(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('@codametrix/ui-common'), require('react-dom'), require('@codametrix/ui-components')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', '@codametrix/ui-common', 'react-dom', '@codametrix/ui-components'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.sharedViews = {}, global.React, global.uiCommon, global.reactDOM, global.uiComponents));
})(this, (function (exports, React, uiCommon, ReactDOM, uiComponents) { 'use strict';

  function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
      Object.keys(e).forEach(function (k) {
        if (k !== 'default') {
          var d = Object.getOwnPropertyDescriptor(e, k);
          Object.defineProperty(n, k, d.get ? d : {
            enumerable: true,
            get: function () { return e[k]; }
          });
        }
      });
    }
    n.default = e;
    return Object.freeze(n);
  }

  var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);
  var ReactDOM__namespace = /*#__PURE__*/_interopNamespaceDefault(ReactDOM);

  function _extends$1() {
    return _extends$1 = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends$1.apply(null, arguments);
  }

  function _objectWithoutPropertiesLoose$2(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
    return t;
  }

  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose$2(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }

  function isHTMLElement$2(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
  }
  function isBrowser$2() {
    return Boolean(globalThis?.document);
  }
  function isHiddenElement(element) {
    if (element.parentElement && isHiddenElement(element.parentElement))
      return true;
    return element.hidden;
  }
  function isContentEditableElement(element) {
    const value = element.getAttribute("contenteditable");
    return value !== "false" && value != null;
  }
  function isDisabledElement(element) {
    return Boolean(element.getAttribute("disabled")) === true || Boolean(element.getAttribute("aria-disabled")) === true;
  }

  function getOwnerWindow(node) {
    return getOwnerDocument$2(node)?.defaultView ?? window;
  }
  function getOwnerDocument$2(node) {
    return isHTMLElement$2(node) ? node.ownerDocument : document;
  }
  function getActiveElement$1(node) {
    return getOwnerDocument$2(node).activeElement;
  }

  function assignAfter(target, ...sources) {
    if (target == null) {
      throw new TypeError("Cannot convert undefined or null to object");
    }
    const result = { ...target };
    for (const nextSource of sources) {
      if (nextSource == null)
        continue;
      for (const nextKey in nextSource) {
        if (!Object.prototype.hasOwnProperty.call(nextSource, nextKey))
          continue;
        if (nextKey in result)
          delete result[nextKey];
        result[nextKey] = nextSource[nextKey];
      }
    }
    return result;
  }

  const dataAttr = (condition) => condition ? "" : void 0;
  const ariaAttr = (condition) => condition ? true : void 0;

  function isArray(value) {
    return Array.isArray(value);
  }
  function isObject$1(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !isArray(value);
  }

  function getLastItem(array) {
    const length = array == null ? 0 : array.length;
    return length ? array[length - 1] : void 0;
  }
  function analyzeCSSValue$2(value) {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return { unitless: !unit, value: num, unit };
  }
  function px$1(value) {
    if (value == null)
      return value;
    const { unitless } = analyzeCSSValue$2(value);
    return unitless || typeof value === "number" ? `${value}px` : value;
  }
  const sortByBreakpointValue = (a, b) => parseInt(a[1], 10) > parseInt(b[1], 10) ? 1 : -1;
  const sortBps = (breakpoints) => Object.fromEntries(Object.entries(breakpoints).sort(sortByBreakpointValue));
  function normalize$1(breakpoints) {
    const sorted = sortBps(breakpoints);
    return Object.assign(Object.values(sorted), sorted);
  }
  function keys(breakpoints) {
    const value = Object.keys(sortBps(breakpoints));
    return new Set(value);
  }
  function subtract$3(value) {
    if (!value)
      return value;
    value = px$1(value) ?? value;
    const OFFSET = -0.02;
    return typeof value === "number" ? `${value + OFFSET}` : value.replace(/(\d+\.?\d*)/u, (m) => `${parseFloat(m) + OFFSET}`);
  }
  function toMediaQueryString(min, max) {
    const query = ["@media screen"];
    if (min)
      query.push("and", `(min-width: ${px$1(min)})`);
    if (max)
      query.push("and", `(max-width: ${px$1(max)})`);
    return query.join(" ");
  }
  function analyzeBreakpoints(breakpoints) {
    if (!breakpoints)
      return null;
    breakpoints.base = breakpoints.base ?? "0px";
    const normalized = normalize$1(breakpoints);
    const queries = Object.entries(breakpoints).sort(sortByBreakpointValue).map(([breakpoint, minW], index, entry) => {
      let [, maxW] = entry[index + 1] ?? [];
      maxW = parseFloat(maxW) > 0 ? subtract$3(maxW) : void 0;
      return {
        _minW: subtract$3(minW),
        breakpoint,
        minW,
        maxW,
        maxWQuery: toMediaQueryString(null, maxW),
        minWQuery: toMediaQueryString(minW),
        minMaxQuery: toMediaQueryString(minW, maxW)
      };
    });
    const _keys = keys(breakpoints);
    const _keysArr = Array.from(_keys.values());
    return {
      keys: _keys,
      normalized,
      isResponsive(test) {
        const keys2 = Object.keys(test);
        return keys2.length > 0 && keys2.every((key) => _keys.has(key));
      },
      asObject: sortBps(breakpoints),
      asArray: normalize$1(breakpoints),
      details: queries,
      get(key) {
        return queries.find((q) => q.breakpoint === key);
      },
      media: [
        null,
        ...normalized.map((minW) => toMediaQueryString(minW)).slice(1)
      ],
      /**
       * Converts the object responsive syntax to array syntax
       *
       * @example
       * toArrayValue({ base: 1, sm: 2, md: 3 }) // => [1, 2, 3]
       */
      toArrayValue(test) {
        if (!isObject$1(test)) {
          throw new Error("toArrayValue: value must be an object");
        }
        const result = _keysArr.map((bp) => test[bp] ?? null);
        while (getLastItem(result) === null) {
          result.pop();
        }
        return result;
      },
      /**
       * Converts the array responsive syntax to object syntax
       *
       * @example
       * toObjectValue([1, 2, 3]) // => { base: 1, sm: 2, md: 3 }
       */
      toObjectValue(test) {
        if (!Array.isArray(test)) {
          throw new Error("toObjectValue: value must be an array");
        }
        return test.reduce(
          (acc, value, index) => {
            const key = _keysArr[index];
            if (key != null && value != null)
              acc[key] = value;
            return acc;
          },
          {}
        );
      }
    };
  }

  function callAll(...fns) {
    return function mergedFn(...args) {
      fns.forEach((fn) => fn?.(...args));
    };
  }
  function callAllHandlers(...fns) {
    return function func(event) {
      fns.some((fn) => {
        fn?.(event);
        return event?.defaultPrevented;
      });
    };
  }

  function getValidChildren(children) {
    return React.Children.toArray(children).filter(
      (child) => React.isValidElement(child)
    );
  }

  function compact(object) {
    const clone = Object.assign({}, object);
    for (let key in clone) {
      if (clone[key] === void 0)
        delete clone[key];
    }
    return clone;
  }

  function getErrorMessage(hook, provider) {
    return `${hook} returned \`undefined\`. Seems you forgot to wrap component within ${provider}`;
  }
  function createContext$1(options = {}) {
    const {
      name,
      strict = true,
      hookName = "useContext",
      providerName = "Provider",
      errorMessage,
      defaultValue
    } = options;
    const Context = React.createContext(defaultValue);
    Context.displayName = name;
    function useContext$1() {
      const context = React.useContext(Context);
      if (!context && strict) {
        const error = new Error(
          errorMessage ?? getErrorMessage(hookName, providerName)
        );
        error.name = "ContextError";
        Error.captureStackTrace?.(error, useContext$1);
        throw error;
      }
      return context;
    }
    return [Context.Provider, useContext$1, Context];
  }

  const cx$1 = (...classNames) => classNames.filter(Boolean).join(" ");

  const hasTabIndex = (element) => element.hasAttribute("tabindex");
  const hasNegativeTabIndex = (element) => hasTabIndex(element) && element.tabIndex === -1;
  function isFocusable(element) {
    if (!isHTMLElement$2(element) || isHiddenElement(element) || isDisabledElement(element)) {
      return false;
    }
    const { localName } = element;
    const focusableTags = ["input", "select", "textarea", "button"];
    if (focusableTags.indexOf(localName) >= 0)
      return true;
    const others = {
      a: () => element.hasAttribute("href"),
      audio: () => element.hasAttribute("controls"),
      video: () => element.hasAttribute("controls")
    };
    if (localName in others) {
      return others[localName]();
    }
    if (isContentEditableElement(element))
      return true;
    return hasTabIndex(element);
  }
  function isTabbable(element) {
    if (!element)
      return false;
    return isHTMLElement$2(element) && isFocusable(element) && !hasNegativeTabIndex(element);
  }

  const focusableElList = [
    "input:not(:disabled):not([disabled])",
    "select:not(:disabled):not([disabled])",
    "textarea:not(:disabled):not([disabled])",
    "embed",
    "iframe",
    "object",
    "a[href]",
    "area[href]",
    "button:not(:disabled):not([disabled])",
    "[tabindex]",
    "audio[controls]",
    "video[controls]",
    "*[tabindex]:not([aria-disabled])",
    "*[contenteditable]"
  ];
  const focusableElSelector = focusableElList.join();
  const isVisible = (el) => el.offsetWidth > 0 && el.offsetHeight > 0;
  function getAllFocusable(container) {
    const focusableEls = Array.from(
      container.querySelectorAll(focusableElSelector)
    );
    focusableEls.unshift(container);
    return focusableEls.filter((el) => isFocusable(el) && isVisible(el));
  }

  function get$3(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [path];
    for (index = 0; index < key.length; index += 1) {
      if (!obj)
        break;
      obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
  }
  const memoize$3 = (fn) => {
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index) => {
      if (typeof obj === "undefined") {
        return fn(obj, path, fallback);
      }
      if (!cache.has(obj)) {
        cache.set(obj, /* @__PURE__ */ new Map());
      }
      const map = cache.get(obj);
      if (map.has(path)) {
        return map.get(path);
      }
      const value = fn(obj, path, fallback, index);
      map.set(path, value);
      return value;
    };
    return memoizedFn;
  };
  const memoizedGet$2 = memoize$3(get$3);

  const interopDefault = (mod) => mod.default || mod;

  function lazyDisclosure(options) {
    const { wasSelected, enabled, isSelected, mode = "unmount" } = options;
    if (!enabled)
      return true;
    if (isSelected)
      return true;
    if (mode === "keepMounted" && wasSelected)
      return true;
    return false;
  }

  function omit(object, keysToOmit = []) {
    const clone = Object.assign({}, object);
    for (const key of keysToOmit) {
      if (key in clone) {
        delete clone[key];
      }
    }
    return clone;
  }

  function pick(object, keysToPick) {
    const result = {};
    for (const key of keysToPick) {
      if (key in object) {
        result[key] = object[key];
      }
    }
    return result;
  }

  function mapResponsive(prop, mapper) {
    if (Array.isArray(prop)) {
      return prop.map((item) => item === null ? null : mapper(item));
    }
    if (isObject$1(prop)) {
      return Object.keys(prop).reduce((result, key) => {
        result[key] = mapper(prop[key]);
        return result;
      }, {});
    }
    if (prop != null) {
      return mapper(prop);
    }
    return null;
  }

  const isFunction$4 = (value) => typeof value === "function";
  function runIfFn$3(valueOrFn, ...args) {
    return isFunction$4(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }

  function isScrollParent$1(el) {
    const win = el.ownerDocument.defaultView || window;
    const { overflow, overflowX, overflowY } = win.getComputedStyle(el);
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }
  function getParent(el) {
    if (el.localName === "html")
      return el;
    return el.assignedSlot || el.parentElement || el.ownerDocument.documentElement;
  }
  function getScrollParent$1(el) {
    if (["html", "body", "#document"].includes(el.localName)) {
      return el.ownerDocument.body;
    }
    if (isHTMLElement$2(el) && isScrollParent$1(el)) {
      return el;
    }
    return getScrollParent$1(getParent(el));
  }

  function split(object, keys) {
    const picked = {};
    const omitted = {};
    for (const [key, value] of Object.entries(object)) {
      if (keys.includes(key))
        picked[key] = value;
      else
        omitted[key] = value;
    }
    return [picked, omitted];
  }

  function splitProps(props, ...keys) {
    const descriptors = Object.getOwnPropertyDescriptors(props);
    const dKeys = Object.keys(descriptors);
    const split = (k) => {
      const clone = {};
      for (let i = 0; i < k.length; i++) {
        const key = k[i];
        if (descriptors[key]) {
          Object.defineProperty(clone, key, descriptors[key]);
          delete descriptors[key];
        }
      }
      return clone;
    };
    const fn = (key) => split(Array.isArray(key) ? key : dKeys.filter(key));
    return keys.map(fn).concat(split(dKeys));
  }

  function walkObject(target, predicate, options = {}) {
    const { stop, getKey } = options;
    function inner(value, path = []) {
      if (isObject$1(value) || Array.isArray(value)) {
        const result = {};
        for (const [prop, child] of Object.entries(value)) {
          const key = getKey?.(prop) ?? prop;
          const childPath = [...path, key];
          if (stop?.(value, childPath)) {
            return predicate(value, path);
          }
          result[key] = inner(child, childPath);
        }
        return result;
      }
      return predicate(value, path);
    }
    return inner(target);
  }

  const warn = (options) => {
    const { condition, message } = options;
  };

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var f = n.default;
  	if (typeof f == "function") {
  		var a = function a () {
  			if (this instanceof a) {
          return Reflect.construct(f, arguments, this.constructor);
  			}
  			return f.apply(this, arguments);
  		};
  		a.prototype = f.prototype;
    } else a = {};
    Object.defineProperty(a, '__esModule', {value: true});
  	Object.keys(n).forEach(function (k) {
  		var d = Object.getOwnPropertyDescriptor(n, k);
  		Object.defineProperty(a, k, d.get ? d : {
  			enumerable: true,
  			get: function () {
  				return n[k];
  			}
  		});
  	});
  	return a;
  }

  var lodash_mergewith = {exports: {}};

  /**
   * Lodash (Custom Build) <https://lodash.com/>
   * Build: `lodash modularize exports="npm" -o ./`
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   */
  lodash_mergewith.exports;

  var hasRequiredLodash_mergewith;

  function requireLodash_mergewith () {
  	if (hasRequiredLodash_mergewith) return lodash_mergewith.exports;
  	hasRequiredLodash_mergewith = 1;
  	(function (module, exports$1) {
  		/** Used as the size to enable large array optimizations. */
  		var LARGE_ARRAY_SIZE = 200;

  		/** Used to stand-in for `undefined` hash values. */
  		var HASH_UNDEFINED = '__lodash_hash_undefined__';

  		/** Used to detect hot functions by number of calls within a span of milliseconds. */
  		var HOT_COUNT = 800,
  		    HOT_SPAN = 16;

  		/** Used as references for various `Number` constants. */
  		var MAX_SAFE_INTEGER = 9007199254740991;

  		/** `Object#toString` result references. */
  		var argsTag = '[object Arguments]',
  		    arrayTag = '[object Array]',
  		    asyncTag = '[object AsyncFunction]',
  		    boolTag = '[object Boolean]',
  		    dateTag = '[object Date]',
  		    errorTag = '[object Error]',
  		    funcTag = '[object Function]',
  		    genTag = '[object GeneratorFunction]',
  		    mapTag = '[object Map]',
  		    numberTag = '[object Number]',
  		    nullTag = '[object Null]',
  		    objectTag = '[object Object]',
  		    proxyTag = '[object Proxy]',
  		    regexpTag = '[object RegExp]',
  		    setTag = '[object Set]',
  		    stringTag = '[object String]',
  		    undefinedTag = '[object Undefined]',
  		    weakMapTag = '[object WeakMap]';

  		var arrayBufferTag = '[object ArrayBuffer]',
  		    dataViewTag = '[object DataView]',
  		    float32Tag = '[object Float32Array]',
  		    float64Tag = '[object Float64Array]',
  		    int8Tag = '[object Int8Array]',
  		    int16Tag = '[object Int16Array]',
  		    int32Tag = '[object Int32Array]',
  		    uint8Tag = '[object Uint8Array]',
  		    uint8ClampedTag = '[object Uint8ClampedArray]',
  		    uint16Tag = '[object Uint16Array]',
  		    uint32Tag = '[object Uint32Array]';

  		/**
  		 * Used to match `RegExp`
  		 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
  		 */
  		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

  		/** Used to detect host constructors (Safari). */
  		var reIsHostCtor = /^\[object .+?Constructor\]$/;

  		/** Used to detect unsigned integer values. */
  		var reIsUint = /^(?:0|[1-9]\d*)$/;

  		/** Used to identify `toStringTag` values of typed arrays. */
  		var typedArrayTags = {};
  		typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  		typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  		typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  		typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  		typedArrayTags[uint32Tag] = true;
  		typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  		typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  		typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  		typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  		typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  		typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  		typedArrayTags[setTag] = typedArrayTags[stringTag] =
  		typedArrayTags[weakMapTag] = false;

  		/** Detect free variable `global` from Node.js. */
  		var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

  		/** Detect free variable `self`. */
  		var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  		/** Used as a reference to the global object. */
  		var root = freeGlobal || freeSelf || Function('return this')();

  		/** Detect free variable `exports`. */
  		var freeExports = exports$1 && !exports$1.nodeType && exports$1;

  		/** Detect free variable `module`. */
  		var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

  		/** Detect the popular CommonJS extension `module.exports`. */
  		var moduleExports = freeModule && freeModule.exports === freeExports;

  		/** Detect free variable `process` from Node.js. */
  		var freeProcess = moduleExports && freeGlobal.process;

  		/** Used to access faster Node.js helpers. */
  		var nodeUtil = (function() {
  		  try {
  		    // Use `util.types` for Node.js 10+.
  		    var types = freeModule && freeModule.require && freeModule.require('util').types;

  		    if (types) {
  		      return types;
  		    }

  		    // Legacy `process.binding('util')` for Node.js < 10.
  		    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  		  } catch (e) {}
  		}());

  		/* Node.js helper references. */
  		var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  		/**
  		 * A faster alternative to `Function#apply`, this function invokes `func`
  		 * with the `this` binding of `thisArg` and the arguments of `args`.
  		 *
  		 * @private
  		 * @param {Function} func The function to invoke.
  		 * @param {*} thisArg The `this` binding of `func`.
  		 * @param {Array} args The arguments to invoke `func` with.
  		 * @returns {*} Returns the result of `func`.
  		 */
  		function apply(func, thisArg, args) {
  		  switch (args.length) {
  		    case 0: return func.call(thisArg);
  		    case 1: return func.call(thisArg, args[0]);
  		    case 2: return func.call(thisArg, args[0], args[1]);
  		    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  		  }
  		  return func.apply(thisArg, args);
  		}

  		/**
  		 * The base implementation of `_.times` without support for iteratee shorthands
  		 * or max array length checks.
  		 *
  		 * @private
  		 * @param {number} n The number of times to invoke `iteratee`.
  		 * @param {Function} iteratee The function invoked per iteration.
  		 * @returns {Array} Returns the array of results.
  		 */
  		function baseTimes(n, iteratee) {
  		  var index = -1,
  		      result = Array(n);

  		  while (++index < n) {
  		    result[index] = iteratee(index);
  		  }
  		  return result;
  		}

  		/**
  		 * The base implementation of `_.unary` without support for storing metadata.
  		 *
  		 * @private
  		 * @param {Function} func The function to cap arguments for.
  		 * @returns {Function} Returns the new capped function.
  		 */
  		function baseUnary(func) {
  		  return function(value) {
  		    return func(value);
  		  };
  		}

  		/**
  		 * Gets the value at `key` of `object`.
  		 *
  		 * @private
  		 * @param {Object} [object] The object to query.
  		 * @param {string} key The key of the property to get.
  		 * @returns {*} Returns the property value.
  		 */
  		function getValue(object, key) {
  		  return object == null ? undefined : object[key];
  		}

  		/**
  		 * Creates a unary function that invokes `func` with its argument transformed.
  		 *
  		 * @private
  		 * @param {Function} func The function to wrap.
  		 * @param {Function} transform The argument transform.
  		 * @returns {Function} Returns the new function.
  		 */
  		function overArg(func, transform) {
  		  return function(arg) {
  		    return func(transform(arg));
  		  };
  		}

  		/** Used for built-in method references. */
  		var arrayProto = Array.prototype,
  		    funcProto = Function.prototype,
  		    objectProto = Object.prototype;

  		/** Used to detect overreaching core-js shims. */
  		var coreJsData = root['__core-js_shared__'];

  		/** Used to resolve the decompiled source of functions. */
  		var funcToString = funcProto.toString;

  		/** Used to check objects for own properties. */
  		var hasOwnProperty = objectProto.hasOwnProperty;

  		/** Used to detect methods masquerading as native. */
  		var maskSrcKey = (function() {
  		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  		  return uid ? ('Symbol(src)_1.' + uid) : '';
  		}());

  		/**
  		 * Used to resolve the
  		 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
  		 * of values.
  		 */
  		var nativeObjectToString = objectProto.toString;

  		/** Used to infer the `Object` constructor. */
  		var objectCtorString = funcToString.call(Object);

  		/** Used to detect if a method is native. */
  		var reIsNative = RegExp('^' +
  		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
  		);

  		/** Built-in value references. */
  		var Buffer = moduleExports ? root.Buffer : undefined,
  		    Symbol = root.Symbol,
  		    Uint8Array = root.Uint8Array;
  		    Buffer ? Buffer.allocUnsafe : undefined;
  		    var getPrototype = overArg(Object.getPrototypeOf, Object),
  		    objectCreate = Object.create,
  		    propertyIsEnumerable = objectProto.propertyIsEnumerable,
  		    splice = arrayProto.splice,
  		    symToStringTag = Symbol ? Symbol.toStringTag : undefined;

  		var defineProperty = (function() {
  		  try {
  		    var func = getNative(Object, 'defineProperty');
  		    func({}, '', {});
  		    return func;
  		  } catch (e) {}
  		}());

  		/* Built-in method references for those with the same name as other `lodash` methods. */
  		var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
  		    nativeMax = Math.max,
  		    nativeNow = Date.now;

  		/* Built-in method references that are verified to be native. */
  		var Map = getNative(root, 'Map'),
  		    nativeCreate = getNative(Object, 'create');

  		/**
  		 * The base implementation of `_.create` without support for assigning
  		 * properties to the created object.
  		 *
  		 * @private
  		 * @param {Object} proto The object to inherit from.
  		 * @returns {Object} Returns the new object.
  		 */
  		var baseCreate = (function() {
  		  function object() {}
  		  return function(proto) {
  		    if (!isObject(proto)) {
  		      return {};
  		    }
  		    if (objectCreate) {
  		      return objectCreate(proto);
  		    }
  		    object.prototype = proto;
  		    var result = new object;
  		    object.prototype = undefined;
  		    return result;
  		  };
  		}());

  		/**
  		 * Creates a hash object.
  		 *
  		 * @private
  		 * @constructor
  		 * @param {Array} [entries] The key-value pairs to cache.
  		 */
  		function Hash(entries) {
  		  var index = -1,
  		      length = entries == null ? 0 : entries.length;

  		  this.clear();
  		  while (++index < length) {
  		    var entry = entries[index];
  		    this.set(entry[0], entry[1]);
  		  }
  		}

  		/**
  		 * Removes all key-value entries from the hash.
  		 *
  		 * @private
  		 * @name clear
  		 * @memberOf Hash
  		 */
  		function hashClear() {
  		  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  		  this.size = 0;
  		}

  		/**
  		 * Removes `key` and its value from the hash.
  		 *
  		 * @private
  		 * @name delete
  		 * @memberOf Hash
  		 * @param {Object} hash The hash to modify.
  		 * @param {string} key The key of the value to remove.
  		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
  		 */
  		function hashDelete(key) {
  		  var result = this.has(key) && delete this.__data__[key];
  		  this.size -= result ? 1 : 0;
  		  return result;
  		}

  		/**
  		 * Gets the hash value for `key`.
  		 *
  		 * @private
  		 * @name get
  		 * @memberOf Hash
  		 * @param {string} key The key of the value to get.
  		 * @returns {*} Returns the entry value.
  		 */
  		function hashGet(key) {
  		  var data = this.__data__;
  		  if (nativeCreate) {
  		    var result = data[key];
  		    return result === HASH_UNDEFINED ? undefined : result;
  		  }
  		  return hasOwnProperty.call(data, key) ? data[key] : undefined;
  		}

  		/**
  		 * Checks if a hash value for `key` exists.
  		 *
  		 * @private
  		 * @name has
  		 * @memberOf Hash
  		 * @param {string} key The key of the entry to check.
  		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
  		 */
  		function hashHas(key) {
  		  var data = this.__data__;
  		  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
  		}

  		/**
  		 * Sets the hash `key` to `value`.
  		 *
  		 * @private
  		 * @name set
  		 * @memberOf Hash
  		 * @param {string} key The key of the value to set.
  		 * @param {*} value The value to set.
  		 * @returns {Object} Returns the hash instance.
  		 */
  		function hashSet(key, value) {
  		  var data = this.__data__;
  		  this.size += this.has(key) ? 0 : 1;
  		  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  		  return this;
  		}

  		// Add methods to `Hash`.
  		Hash.prototype.clear = hashClear;
  		Hash.prototype['delete'] = hashDelete;
  		Hash.prototype.get = hashGet;
  		Hash.prototype.has = hashHas;
  		Hash.prototype.set = hashSet;

  		/**
  		 * Creates an list cache object.
  		 *
  		 * @private
  		 * @constructor
  		 * @param {Array} [entries] The key-value pairs to cache.
  		 */
  		function ListCache(entries) {
  		  var index = -1,
  		      length = entries == null ? 0 : entries.length;

  		  this.clear();
  		  while (++index < length) {
  		    var entry = entries[index];
  		    this.set(entry[0], entry[1]);
  		  }
  		}

  		/**
  		 * Removes all key-value entries from the list cache.
  		 *
  		 * @private
  		 * @name clear
  		 * @memberOf ListCache
  		 */
  		function listCacheClear() {
  		  this.__data__ = [];
  		  this.size = 0;
  		}

  		/**
  		 * Removes `key` and its value from the list cache.
  		 *
  		 * @private
  		 * @name delete
  		 * @memberOf ListCache
  		 * @param {string} key The key of the value to remove.
  		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
  		 */
  		function listCacheDelete(key) {
  		  var data = this.__data__,
  		      index = assocIndexOf(data, key);

  		  if (index < 0) {
  		    return false;
  		  }
  		  var lastIndex = data.length - 1;
  		  if (index == lastIndex) {
  		    data.pop();
  		  } else {
  		    splice.call(data, index, 1);
  		  }
  		  --this.size;
  		  return true;
  		}

  		/**
  		 * Gets the list cache value for `key`.
  		 *
  		 * @private
  		 * @name get
  		 * @memberOf ListCache
  		 * @param {string} key The key of the value to get.
  		 * @returns {*} Returns the entry value.
  		 */
  		function listCacheGet(key) {
  		  var data = this.__data__,
  		      index = assocIndexOf(data, key);

  		  return index < 0 ? undefined : data[index][1];
  		}

  		/**
  		 * Checks if a list cache value for `key` exists.
  		 *
  		 * @private
  		 * @name has
  		 * @memberOf ListCache
  		 * @param {string} key The key of the entry to check.
  		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
  		 */
  		function listCacheHas(key) {
  		  return assocIndexOf(this.__data__, key) > -1;
  		}

  		/**
  		 * Sets the list cache `key` to `value`.
  		 *
  		 * @private
  		 * @name set
  		 * @memberOf ListCache
  		 * @param {string} key The key of the value to set.
  		 * @param {*} value The value to set.
  		 * @returns {Object} Returns the list cache instance.
  		 */
  		function listCacheSet(key, value) {
  		  var data = this.__data__,
  		      index = assocIndexOf(data, key);

  		  if (index < 0) {
  		    ++this.size;
  		    data.push([key, value]);
  		  } else {
  		    data[index][1] = value;
  		  }
  		  return this;
  		}

  		// Add methods to `ListCache`.
  		ListCache.prototype.clear = listCacheClear;
  		ListCache.prototype['delete'] = listCacheDelete;
  		ListCache.prototype.get = listCacheGet;
  		ListCache.prototype.has = listCacheHas;
  		ListCache.prototype.set = listCacheSet;

  		/**
  		 * Creates a map cache object to store key-value pairs.
  		 *
  		 * @private
  		 * @constructor
  		 * @param {Array} [entries] The key-value pairs to cache.
  		 */
  		function MapCache(entries) {
  		  var index = -1,
  		      length = entries == null ? 0 : entries.length;

  		  this.clear();
  		  while (++index < length) {
  		    var entry = entries[index];
  		    this.set(entry[0], entry[1]);
  		  }
  		}

  		/**
  		 * Removes all key-value entries from the map.
  		 *
  		 * @private
  		 * @name clear
  		 * @memberOf MapCache
  		 */
  		function mapCacheClear() {
  		  this.size = 0;
  		  this.__data__ = {
  		    'hash': new Hash,
  		    'map': new (Map || ListCache),
  		    'string': new Hash
  		  };
  		}

  		/**
  		 * Removes `key` and its value from the map.
  		 *
  		 * @private
  		 * @name delete
  		 * @memberOf MapCache
  		 * @param {string} key The key of the value to remove.
  		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
  		 */
  		function mapCacheDelete(key) {
  		  var result = getMapData(this, key)['delete'](key);
  		  this.size -= result ? 1 : 0;
  		  return result;
  		}

  		/**
  		 * Gets the map value for `key`.
  		 *
  		 * @private
  		 * @name get
  		 * @memberOf MapCache
  		 * @param {string} key The key of the value to get.
  		 * @returns {*} Returns the entry value.
  		 */
  		function mapCacheGet(key) {
  		  return getMapData(this, key).get(key);
  		}

  		/**
  		 * Checks if a map value for `key` exists.
  		 *
  		 * @private
  		 * @name has
  		 * @memberOf MapCache
  		 * @param {string} key The key of the entry to check.
  		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
  		 */
  		function mapCacheHas(key) {
  		  return getMapData(this, key).has(key);
  		}

  		/**
  		 * Sets the map `key` to `value`.
  		 *
  		 * @private
  		 * @name set
  		 * @memberOf MapCache
  		 * @param {string} key The key of the value to set.
  		 * @param {*} value The value to set.
  		 * @returns {Object} Returns the map cache instance.
  		 */
  		function mapCacheSet(key, value) {
  		  var data = getMapData(this, key),
  		      size = data.size;

  		  data.set(key, value);
  		  this.size += data.size == size ? 0 : 1;
  		  return this;
  		}

  		// Add methods to `MapCache`.
  		MapCache.prototype.clear = mapCacheClear;
  		MapCache.prototype['delete'] = mapCacheDelete;
  		MapCache.prototype.get = mapCacheGet;
  		MapCache.prototype.has = mapCacheHas;
  		MapCache.prototype.set = mapCacheSet;

  		/**
  		 * Creates a stack cache object to store key-value pairs.
  		 *
  		 * @private
  		 * @constructor
  		 * @param {Array} [entries] The key-value pairs to cache.
  		 */
  		function Stack(entries) {
  		  var data = this.__data__ = new ListCache(entries);
  		  this.size = data.size;
  		}

  		/**
  		 * Removes all key-value entries from the stack.
  		 *
  		 * @private
  		 * @name clear
  		 * @memberOf Stack
  		 */
  		function stackClear() {
  		  this.__data__ = new ListCache;
  		  this.size = 0;
  		}

  		/**
  		 * Removes `key` and its value from the stack.
  		 *
  		 * @private
  		 * @name delete
  		 * @memberOf Stack
  		 * @param {string} key The key of the value to remove.
  		 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
  		 */
  		function stackDelete(key) {
  		  var data = this.__data__,
  		      result = data['delete'](key);

  		  this.size = data.size;
  		  return result;
  		}

  		/**
  		 * Gets the stack value for `key`.
  		 *
  		 * @private
  		 * @name get
  		 * @memberOf Stack
  		 * @param {string} key The key of the value to get.
  		 * @returns {*} Returns the entry value.
  		 */
  		function stackGet(key) {
  		  return this.__data__.get(key);
  		}

  		/**
  		 * Checks if a stack value for `key` exists.
  		 *
  		 * @private
  		 * @name has
  		 * @memberOf Stack
  		 * @param {string} key The key of the entry to check.
  		 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
  		 */
  		function stackHas(key) {
  		  return this.__data__.has(key);
  		}

  		/**
  		 * Sets the stack `key` to `value`.
  		 *
  		 * @private
  		 * @name set
  		 * @memberOf Stack
  		 * @param {string} key The key of the value to set.
  		 * @param {*} value The value to set.
  		 * @returns {Object} Returns the stack cache instance.
  		 */
  		function stackSet(key, value) {
  		  var data = this.__data__;
  		  if (data instanceof ListCache) {
  		    var pairs = data.__data__;
  		    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
  		      pairs.push([key, value]);
  		      this.size = ++data.size;
  		      return this;
  		    }
  		    data = this.__data__ = new MapCache(pairs);
  		  }
  		  data.set(key, value);
  		  this.size = data.size;
  		  return this;
  		}

  		// Add methods to `Stack`.
  		Stack.prototype.clear = stackClear;
  		Stack.prototype['delete'] = stackDelete;
  		Stack.prototype.get = stackGet;
  		Stack.prototype.has = stackHas;
  		Stack.prototype.set = stackSet;

  		/**
  		 * Creates an array of the enumerable property names of the array-like `value`.
  		 *
  		 * @private
  		 * @param {*} value The value to query.
  		 * @param {boolean} inherited Specify returning inherited property names.
  		 * @returns {Array} Returns the array of property names.
  		 */
  		function arrayLikeKeys(value, inherited) {
  		  var isArr = isArray(value),
  		      isArg = !isArr && isArguments(value),
  		      isBuff = !isArr && !isArg && isBuffer(value),
  		      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
  		      skipIndexes = isArr || isArg || isBuff || isType,
  		      result = skipIndexes ? baseTimes(value.length, String) : [],
  		      length = result.length;

  		  for (var key in value) {
  		    if (!(skipIndexes && (
  		           // Safari 9 has enumerable `arguments.length` in strict mode.
  		           key == 'length' ||
  		           // Node.js 0.10 has enumerable non-index properties on buffers.
  		           (isBuff && (key == 'offset' || key == 'parent')) ||
  		           // PhantomJS 2 has enumerable non-index properties on typed arrays.
  		           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
  		           // Skip index properties.
  		           isIndex(key, length)
  		        ))) {
  		      result.push(key);
  		    }
  		  }
  		  return result;
  		}

  		/**
  		 * This function is like `assignValue` except that it doesn't assign
  		 * `undefined` values.
  		 *
  		 * @private
  		 * @param {Object} object The object to modify.
  		 * @param {string} key The key of the property to assign.
  		 * @param {*} value The value to assign.
  		 */
  		function assignMergeValue(object, key, value) {
  		  if ((value !== undefined && !eq(object[key], value)) ||
  		      (value === undefined && !(key in object))) {
  		    baseAssignValue(object, key, value);
  		  }
  		}

  		/**
  		 * Assigns `value` to `key` of `object` if the existing value is not equivalent
  		 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
  		 * for equality comparisons.
  		 *
  		 * @private
  		 * @param {Object} object The object to modify.
  		 * @param {string} key The key of the property to assign.
  		 * @param {*} value The value to assign.
  		 */
  		function assignValue(object, key, value) {
  		  var objValue = object[key];
  		  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
  		      (value === undefined && !(key in object))) {
  		    baseAssignValue(object, key, value);
  		  }
  		}

  		/**
  		 * Gets the index at which the `key` is found in `array` of key-value pairs.
  		 *
  		 * @private
  		 * @param {Array} array The array to inspect.
  		 * @param {*} key The key to search for.
  		 * @returns {number} Returns the index of the matched value, else `-1`.
  		 */
  		function assocIndexOf(array, key) {
  		  var length = array.length;
  		  while (length--) {
  		    if (eq(array[length][0], key)) {
  		      return length;
  		    }
  		  }
  		  return -1;
  		}

  		/**
  		 * The base implementation of `assignValue` and `assignMergeValue` without
  		 * value checks.
  		 *
  		 * @private
  		 * @param {Object} object The object to modify.
  		 * @param {string} key The key of the property to assign.
  		 * @param {*} value The value to assign.
  		 */
  		function baseAssignValue(object, key, value) {
  		  if (key == '__proto__' && defineProperty) {
  		    defineProperty(object, key, {
  		      'configurable': true,
  		      'enumerable': true,
  		      'value': value,
  		      'writable': true
  		    });
  		  } else {
  		    object[key] = value;
  		  }
  		}

  		/**
  		 * The base implementation of `baseForOwn` which iterates over `object`
  		 * properties returned by `keysFunc` and invokes `iteratee` for each property.
  		 * Iteratee functions may exit iteration early by explicitly returning `false`.
  		 *
  		 * @private
  		 * @param {Object} object The object to iterate over.
  		 * @param {Function} iteratee The function invoked per iteration.
  		 * @param {Function} keysFunc The function to get the keys of `object`.
  		 * @returns {Object} Returns `object`.
  		 */
  		var baseFor = createBaseFor();

  		/**
  		 * The base implementation of `getTag` without fallbacks for buggy environments.
  		 *
  		 * @private
  		 * @param {*} value The value to query.
  		 * @returns {string} Returns the `toStringTag`.
  		 */
  		function baseGetTag(value) {
  		  if (value == null) {
  		    return value === undefined ? undefinedTag : nullTag;
  		  }
  		  return (symToStringTag && symToStringTag in Object(value))
  		    ? getRawTag(value)
  		    : objectToString(value);
  		}

  		/**
  		 * The base implementation of `_.isArguments`.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
  		 */
  		function baseIsArguments(value) {
  		  return isObjectLike(value) && baseGetTag(value) == argsTag;
  		}

  		/**
  		 * The base implementation of `_.isNative` without bad shim checks.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a native function,
  		 *  else `false`.
  		 */
  		function baseIsNative(value) {
  		  if (!isObject(value) || isMasked(value)) {
  		    return false;
  		  }
  		  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  		  return pattern.test(toSource(value));
  		}

  		/**
  		 * The base implementation of `_.isTypedArray` without Node.js optimizations.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
  		 */
  		function baseIsTypedArray(value) {
  		  return isObjectLike(value) &&
  		    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
  		}

  		/**
  		 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
  		 *
  		 * @private
  		 * @param {Object} object The object to query.
  		 * @returns {Array} Returns the array of property names.
  		 */
  		function baseKeysIn(object) {
  		  if (!isObject(object)) {
  		    return nativeKeysIn(object);
  		  }
  		  var isProto = isPrototype(object),
  		      result = [];

  		  for (var key in object) {
  		    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
  		      result.push(key);
  		    }
  		  }
  		  return result;
  		}

  		/**
  		 * The base implementation of `_.merge` without support for multiple sources.
  		 *
  		 * @private
  		 * @param {Object} object The destination object.
  		 * @param {Object} source The source object.
  		 * @param {number} srcIndex The index of `source`.
  		 * @param {Function} [customizer] The function to customize merged values.
  		 * @param {Object} [stack] Tracks traversed source values and their merged
  		 *  counterparts.
  		 */
  		function baseMerge(object, source, srcIndex, customizer, stack) {
  		  if (object === source) {
  		    return;
  		  }
  		  baseFor(source, function(srcValue, key) {
  		    stack || (stack = new Stack);
  		    if (isObject(srcValue)) {
  		      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
  		    }
  		    else {
  		      var newValue = customizer
  		        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
  		        : undefined;

  		      if (newValue === undefined) {
  		        newValue = srcValue;
  		      }
  		      assignMergeValue(object, key, newValue);
  		    }
  		  }, keysIn);
  		}

  		/**
  		 * A specialized version of `baseMerge` for arrays and objects which performs
  		 * deep merges and tracks traversed objects enabling objects with circular
  		 * references to be merged.
  		 *
  		 * @private
  		 * @param {Object} object The destination object.
  		 * @param {Object} source The source object.
  		 * @param {string} key The key of the value to merge.
  		 * @param {number} srcIndex The index of `source`.
  		 * @param {Function} mergeFunc The function to merge values.
  		 * @param {Function} [customizer] The function to customize assigned values.
  		 * @param {Object} [stack] Tracks traversed source values and their merged
  		 *  counterparts.
  		 */
  		function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  		  var objValue = safeGet(object, key),
  		      srcValue = safeGet(source, key),
  		      stacked = stack.get(srcValue);

  		  if (stacked) {
  		    assignMergeValue(object, key, stacked);
  		    return;
  		  }
  		  var newValue = customizer
  		    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
  		    : undefined;

  		  var isCommon = newValue === undefined;

  		  if (isCommon) {
  		    var isArr = isArray(srcValue),
  		        isBuff = !isArr && isBuffer(srcValue),
  		        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

  		    newValue = srcValue;
  		    if (isArr || isBuff || isTyped) {
  		      if (isArray(objValue)) {
  		        newValue = objValue;
  		      }
  		      else if (isArrayLikeObject(objValue)) {
  		        newValue = copyArray(objValue);
  		      }
  		      else if (isBuff) {
  		        isCommon = false;
  		        newValue = cloneBuffer(srcValue);
  		      }
  		      else if (isTyped) {
  		        isCommon = false;
  		        newValue = cloneTypedArray(srcValue);
  		      }
  		      else {
  		        newValue = [];
  		      }
  		    }
  		    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
  		      newValue = objValue;
  		      if (isArguments(objValue)) {
  		        newValue = toPlainObject(objValue);
  		      }
  		      else if (!isObject(objValue) || isFunction(objValue)) {
  		        newValue = initCloneObject(srcValue);
  		      }
  		    }
  		    else {
  		      isCommon = false;
  		    }
  		  }
  		  if (isCommon) {
  		    // Recursively merge objects and arrays (susceptible to call stack limits).
  		    stack.set(srcValue, newValue);
  		    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
  		    stack['delete'](srcValue);
  		  }
  		  assignMergeValue(object, key, newValue);
  		}

  		/**
  		 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
  		 *
  		 * @private
  		 * @param {Function} func The function to apply a rest parameter to.
  		 * @param {number} [start=func.length-1] The start position of the rest parameter.
  		 * @returns {Function} Returns the new function.
  		 */
  		function baseRest(func, start) {
  		  return setToString(overRest(func, start, identity), func + '');
  		}

  		/**
  		 * The base implementation of `setToString` without support for hot loop shorting.
  		 *
  		 * @private
  		 * @param {Function} func The function to modify.
  		 * @param {Function} string The `toString` result.
  		 * @returns {Function} Returns `func`.
  		 */
  		var baseSetToString = !defineProperty ? identity : function(func, string) {
  		  return defineProperty(func, 'toString', {
  		    'configurable': true,
  		    'enumerable': false,
  		    'value': constant(string),
  		    'writable': true
  		  });
  		};

  		/**
  		 * Creates a clone of  `buffer`.
  		 *
  		 * @private
  		 * @param {Buffer} buffer The buffer to clone.
  		 * @param {boolean} [isDeep] Specify a deep clone.
  		 * @returns {Buffer} Returns the cloned buffer.
  		 */
  		function cloneBuffer(buffer, isDeep) {
  		  {
  		    return buffer.slice();
  		  }
  		}

  		/**
  		 * Creates a clone of `arrayBuffer`.
  		 *
  		 * @private
  		 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
  		 * @returns {ArrayBuffer} Returns the cloned array buffer.
  		 */
  		function cloneArrayBuffer(arrayBuffer) {
  		  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  		  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  		  return result;
  		}

  		/**
  		 * Creates a clone of `typedArray`.
  		 *
  		 * @private
  		 * @param {Object} typedArray The typed array to clone.
  		 * @param {boolean} [isDeep] Specify a deep clone.
  		 * @returns {Object} Returns the cloned typed array.
  		 */
  		function cloneTypedArray(typedArray, isDeep) {
  		  var buffer = cloneArrayBuffer(typedArray.buffer) ;
  		  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  		}

  		/**
  		 * Copies the values of `source` to `array`.
  		 *
  		 * @private
  		 * @param {Array} source The array to copy values from.
  		 * @param {Array} [array=[]] The array to copy values to.
  		 * @returns {Array} Returns `array`.
  		 */
  		function copyArray(source, array) {
  		  var index = -1,
  		      length = source.length;

  		  array || (array = Array(length));
  		  while (++index < length) {
  		    array[index] = source[index];
  		  }
  		  return array;
  		}

  		/**
  		 * Copies properties of `source` to `object`.
  		 *
  		 * @private
  		 * @param {Object} source The object to copy properties from.
  		 * @param {Array} props The property identifiers to copy.
  		 * @param {Object} [object={}] The object to copy properties to.
  		 * @param {Function} [customizer] The function to customize copied values.
  		 * @returns {Object} Returns `object`.
  		 */
  		function copyObject(source, props, object, customizer) {
  		  var isNew = !object;
  		  object || (object = {});

  		  var index = -1,
  		      length = props.length;

  		  while (++index < length) {
  		    var key = props[index];

  		    var newValue = undefined;

  		    if (newValue === undefined) {
  		      newValue = source[key];
  		    }
  		    if (isNew) {
  		      baseAssignValue(object, key, newValue);
  		    } else {
  		      assignValue(object, key, newValue);
  		    }
  		  }
  		  return object;
  		}

  		/**
  		 * Creates a function like `_.assign`.
  		 *
  		 * @private
  		 * @param {Function} assigner The function to assign values.
  		 * @returns {Function} Returns the new assigner function.
  		 */
  		function createAssigner(assigner) {
  		  return baseRest(function(object, sources) {
  		    var index = -1,
  		        length = sources.length,
  		        customizer = length > 1 ? sources[length - 1] : undefined,
  		        guard = length > 2 ? sources[2] : undefined;

  		    customizer = (assigner.length > 3 && typeof customizer == 'function')
  		      ? (length--, customizer)
  		      : undefined;

  		    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
  		      customizer = length < 3 ? undefined : customizer;
  		      length = 1;
  		    }
  		    object = Object(object);
  		    while (++index < length) {
  		      var source = sources[index];
  		      if (source) {
  		        assigner(object, source, index, customizer);
  		      }
  		    }
  		    return object;
  		  });
  		}

  		/**
  		 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
  		 *
  		 * @private
  		 * @param {boolean} [fromRight] Specify iterating from right to left.
  		 * @returns {Function} Returns the new base function.
  		 */
  		function createBaseFor(fromRight) {
  		  return function(object, iteratee, keysFunc) {
  		    var index = -1,
  		        iterable = Object(object),
  		        props = keysFunc(object),
  		        length = props.length;

  		    while (length--) {
  		      var key = props[++index];
  		      if (iteratee(iterable[key], key, iterable) === false) {
  		        break;
  		      }
  		    }
  		    return object;
  		  };
  		}

  		/**
  		 * Gets the data for `map`.
  		 *
  		 * @private
  		 * @param {Object} map The map to query.
  		 * @param {string} key The reference key.
  		 * @returns {*} Returns the map data.
  		 */
  		function getMapData(map, key) {
  		  var data = map.__data__;
  		  return isKeyable(key)
  		    ? data[typeof key == 'string' ? 'string' : 'hash']
  		    : data.map;
  		}

  		/**
  		 * Gets the native function at `key` of `object`.
  		 *
  		 * @private
  		 * @param {Object} object The object to query.
  		 * @param {string} key The key of the method to get.
  		 * @returns {*} Returns the function if it's native, else `undefined`.
  		 */
  		function getNative(object, key) {
  		  var value = getValue(object, key);
  		  return baseIsNative(value) ? value : undefined;
  		}

  		/**
  		 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
  		 *
  		 * @private
  		 * @param {*} value The value to query.
  		 * @returns {string} Returns the raw `toStringTag`.
  		 */
  		function getRawTag(value) {
  		  var isOwn = hasOwnProperty.call(value, symToStringTag),
  		      tag = value[symToStringTag];

  		  try {
  		    value[symToStringTag] = undefined;
  		    var unmasked = true;
  		  } catch (e) {}

  		  var result = nativeObjectToString.call(value);
  		  if (unmasked) {
  		    if (isOwn) {
  		      value[symToStringTag] = tag;
  		    } else {
  		      delete value[symToStringTag];
  		    }
  		  }
  		  return result;
  		}

  		/**
  		 * Initializes an object clone.
  		 *
  		 * @private
  		 * @param {Object} object The object to clone.
  		 * @returns {Object} Returns the initialized clone.
  		 */
  		function initCloneObject(object) {
  		  return (typeof object.constructor == 'function' && !isPrototype(object))
  		    ? baseCreate(getPrototype(object))
  		    : {};
  		}

  		/**
  		 * Checks if `value` is a valid array-like index.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
  		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
  		 */
  		function isIndex(value, length) {
  		  var type = typeof value;
  		  length = length == null ? MAX_SAFE_INTEGER : length;

  		  return !!length &&
  		    (type == 'number' ||
  		      (type != 'symbol' && reIsUint.test(value))) &&
  		        (value > -1 && value % 1 == 0 && value < length);
  		}

  		/**
  		 * Checks if the given arguments are from an iteratee call.
  		 *
  		 * @private
  		 * @param {*} value The potential iteratee value argument.
  		 * @param {*} index The potential iteratee index or key argument.
  		 * @param {*} object The potential iteratee object argument.
  		 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
  		 *  else `false`.
  		 */
  		function isIterateeCall(value, index, object) {
  		  if (!isObject(object)) {
  		    return false;
  		  }
  		  var type = typeof index;
  		  if (type == 'number'
  		        ? (isArrayLike(object) && isIndex(index, object.length))
  		        : (type == 'string' && index in object)
  		      ) {
  		    return eq(object[index], value);
  		  }
  		  return false;
  		}

  		/**
  		 * Checks if `value` is suitable for use as unique object key.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
  		 */
  		function isKeyable(value) {
  		  var type = typeof value;
  		  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
  		    ? (value !== '__proto__')
  		    : (value === null);
  		}

  		/**
  		 * Checks if `func` has its source masked.
  		 *
  		 * @private
  		 * @param {Function} func The function to check.
  		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
  		 */
  		function isMasked(func) {
  		  return !!maskSrcKey && (maskSrcKey in func);
  		}

  		/**
  		 * Checks if `value` is likely a prototype object.
  		 *
  		 * @private
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
  		 */
  		function isPrototype(value) {
  		  var Ctor = value && value.constructor,
  		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  		  return value === proto;
  		}

  		/**
  		 * This function is like
  		 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
  		 * except that it includes inherited enumerable properties.
  		 *
  		 * @private
  		 * @param {Object} object The object to query.
  		 * @returns {Array} Returns the array of property names.
  		 */
  		function nativeKeysIn(object) {
  		  var result = [];
  		  if (object != null) {
  		    for (var key in Object(object)) {
  		      result.push(key);
  		    }
  		  }
  		  return result;
  		}

  		/**
  		 * Converts `value` to a string using `Object.prototype.toString`.
  		 *
  		 * @private
  		 * @param {*} value The value to convert.
  		 * @returns {string} Returns the converted string.
  		 */
  		function objectToString(value) {
  		  return nativeObjectToString.call(value);
  		}

  		/**
  		 * A specialized version of `baseRest` which transforms the rest array.
  		 *
  		 * @private
  		 * @param {Function} func The function to apply a rest parameter to.
  		 * @param {number} [start=func.length-1] The start position of the rest parameter.
  		 * @param {Function} transform The rest array transform.
  		 * @returns {Function} Returns the new function.
  		 */
  		function overRest(func, start, transform) {
  		  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  		  return function() {
  		    var args = arguments,
  		        index = -1,
  		        length = nativeMax(args.length - start, 0),
  		        array = Array(length);

  		    while (++index < length) {
  		      array[index] = args[start + index];
  		    }
  		    index = -1;
  		    var otherArgs = Array(start + 1);
  		    while (++index < start) {
  		      otherArgs[index] = args[index];
  		    }
  		    otherArgs[start] = transform(array);
  		    return apply(func, this, otherArgs);
  		  };
  		}

  		/**
  		 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
  		 *
  		 * @private
  		 * @param {Object} object The object to query.
  		 * @param {string} key The key of the property to get.
  		 * @returns {*} Returns the property value.
  		 */
  		function safeGet(object, key) {
  		  if (key === 'constructor' && typeof object[key] === 'function') {
  		    return;
  		  }

  		  if (key == '__proto__') {
  		    return;
  		  }

  		  return object[key];
  		}

  		/**
  		 * Sets the `toString` method of `func` to return `string`.
  		 *
  		 * @private
  		 * @param {Function} func The function to modify.
  		 * @param {Function} string The `toString` result.
  		 * @returns {Function} Returns `func`.
  		 */
  		var setToString = shortOut(baseSetToString);

  		/**
  		 * Creates a function that'll short out and invoke `identity` instead
  		 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
  		 * milliseconds.
  		 *
  		 * @private
  		 * @param {Function} func The function to restrict.
  		 * @returns {Function} Returns the new shortable function.
  		 */
  		function shortOut(func) {
  		  var count = 0,
  		      lastCalled = 0;

  		  return function() {
  		    var stamp = nativeNow(),
  		        remaining = HOT_SPAN - (stamp - lastCalled);

  		    lastCalled = stamp;
  		    if (remaining > 0) {
  		      if (++count >= HOT_COUNT) {
  		        return arguments[0];
  		      }
  		    } else {
  		      count = 0;
  		    }
  		    return func.apply(undefined, arguments);
  		  };
  		}

  		/**
  		 * Converts `func` to its source code.
  		 *
  		 * @private
  		 * @param {Function} func The function to convert.
  		 * @returns {string} Returns the source code.
  		 */
  		function toSource(func) {
  		  if (func != null) {
  		    try {
  		      return funcToString.call(func);
  		    } catch (e) {}
  		    try {
  		      return (func + '');
  		    } catch (e) {}
  		  }
  		  return '';
  		}

  		/**
  		 * Performs a
  		 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
  		 * comparison between two values to determine if they are equivalent.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Lang
  		 * @param {*} value The value to compare.
  		 * @param {*} other The other value to compare.
  		 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
  		 * @example
  		 *
  		 * var object = { 'a': 1 };
  		 * var other = { 'a': 1 };
  		 *
  		 * _.eq(object, object);
  		 * // => true
  		 *
  		 * _.eq(object, other);
  		 * // => false
  		 *
  		 * _.eq('a', 'a');
  		 * // => true
  		 *
  		 * _.eq('a', Object('a'));
  		 * // => false
  		 *
  		 * _.eq(NaN, NaN);
  		 * // => true
  		 */
  		function eq(value, other) {
  		  return value === other || (value !== value && other !== other);
  		}

  		/**
  		 * Checks if `value` is likely an `arguments` object.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 0.1.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
  		 *  else `false`.
  		 * @example
  		 *
  		 * _.isArguments(function() { return arguments; }());
  		 * // => true
  		 *
  		 * _.isArguments([1, 2, 3]);
  		 * // => false
  		 */
  		var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  		  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
  		    !propertyIsEnumerable.call(value, 'callee');
  		};

  		/**
  		 * Checks if `value` is classified as an `Array` object.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 0.1.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
  		 * @example
  		 *
  		 * _.isArray([1, 2, 3]);
  		 * // => true
  		 *
  		 * _.isArray(document.body.children);
  		 * // => false
  		 *
  		 * _.isArray('abc');
  		 * // => false
  		 *
  		 * _.isArray(_.noop);
  		 * // => false
  		 */
  		var isArray = Array.isArray;

  		/**
  		 * Checks if `value` is array-like. A value is considered array-like if it's
  		 * not a function and has a `value.length` that's an integer greater than or
  		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
  		 * @example
  		 *
  		 * _.isArrayLike([1, 2, 3]);
  		 * // => true
  		 *
  		 * _.isArrayLike(document.body.children);
  		 * // => true
  		 *
  		 * _.isArrayLike('abc');
  		 * // => true
  		 *
  		 * _.isArrayLike(_.noop);
  		 * // => false
  		 */
  		function isArrayLike(value) {
  		  return value != null && isLength(value.length) && !isFunction(value);
  		}

  		/**
  		 * This method is like `_.isArrayLike` except that it also checks if `value`
  		 * is an object.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is an array-like object,
  		 *  else `false`.
  		 * @example
  		 *
  		 * _.isArrayLikeObject([1, 2, 3]);
  		 * // => true
  		 *
  		 * _.isArrayLikeObject(document.body.children);
  		 * // => true
  		 *
  		 * _.isArrayLikeObject('abc');
  		 * // => false
  		 *
  		 * _.isArrayLikeObject(_.noop);
  		 * // => false
  		 */
  		function isArrayLikeObject(value) {
  		  return isObjectLike(value) && isArrayLike(value);
  		}

  		/**
  		 * Checks if `value` is a buffer.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.3.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
  		 * @example
  		 *
  		 * _.isBuffer(new Buffer(2));
  		 * // => true
  		 *
  		 * _.isBuffer(new Uint8Array(2));
  		 * // => false
  		 */
  		var isBuffer = nativeIsBuffer || stubFalse;

  		/**
  		 * Checks if `value` is classified as a `Function` object.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 0.1.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
  		 * @example
  		 *
  		 * _.isFunction(_);
  		 * // => true
  		 *
  		 * _.isFunction(/abc/);
  		 * // => false
  		 */
  		function isFunction(value) {
  		  if (!isObject(value)) {
  		    return false;
  		  }
  		  // The use of `Object#toString` avoids issues with the `typeof` operator
  		  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  		  var tag = baseGetTag(value);
  		  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
  		}

  		/**
  		 * Checks if `value` is a valid array-like length.
  		 *
  		 * **Note:** This method is loosely based on
  		 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
  		 * @example
  		 *
  		 * _.isLength(3);
  		 * // => true
  		 *
  		 * _.isLength(Number.MIN_VALUE);
  		 * // => false
  		 *
  		 * _.isLength(Infinity);
  		 * // => false
  		 *
  		 * _.isLength('3');
  		 * // => false
  		 */
  		function isLength(value) {
  		  return typeof value == 'number' &&
  		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  		}

  		/**
  		 * Checks if `value` is the
  		 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
  		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 0.1.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
  		 * @example
  		 *
  		 * _.isObject({});
  		 * // => true
  		 *
  		 * _.isObject([1, 2, 3]);
  		 * // => true
  		 *
  		 * _.isObject(_.noop);
  		 * // => true
  		 *
  		 * _.isObject(null);
  		 * // => false
  		 */
  		function isObject(value) {
  		  var type = typeof value;
  		  return value != null && (type == 'object' || type == 'function');
  		}

  		/**
  		 * Checks if `value` is object-like. A value is object-like if it's not `null`
  		 * and has a `typeof` result of "object".
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
  		 * @example
  		 *
  		 * _.isObjectLike({});
  		 * // => true
  		 *
  		 * _.isObjectLike([1, 2, 3]);
  		 * // => true
  		 *
  		 * _.isObjectLike(_.noop);
  		 * // => false
  		 *
  		 * _.isObjectLike(null);
  		 * // => false
  		 */
  		function isObjectLike(value) {
  		  return value != null && typeof value == 'object';
  		}

  		/**
  		 * Checks if `value` is a plain object, that is, an object created by the
  		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 0.8.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
  		 * @example
  		 *
  		 * function Foo() {
  		 *   this.a = 1;
  		 * }
  		 *
  		 * _.isPlainObject(new Foo);
  		 * // => false
  		 *
  		 * _.isPlainObject([1, 2, 3]);
  		 * // => false
  		 *
  		 * _.isPlainObject({ 'x': 0, 'y': 0 });
  		 * // => true
  		 *
  		 * _.isPlainObject(Object.create(null));
  		 * // => true
  		 */
  		function isPlainObject(value) {
  		  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
  		    return false;
  		  }
  		  var proto = getPrototype(value);
  		  if (proto === null) {
  		    return true;
  		  }
  		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  		  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
  		    funcToString.call(Ctor) == objectCtorString;
  		}

  		/**
  		 * Checks if `value` is classified as a typed array.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 3.0.0
  		 * @category Lang
  		 * @param {*} value The value to check.
  		 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
  		 * @example
  		 *
  		 * _.isTypedArray(new Uint8Array);
  		 * // => true
  		 *
  		 * _.isTypedArray([]);
  		 * // => false
  		 */
  		var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

  		/**
  		 * Converts `value` to a plain object flattening inherited enumerable string
  		 * keyed properties of `value` to own properties of the plain object.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 3.0.0
  		 * @category Lang
  		 * @param {*} value The value to convert.
  		 * @returns {Object} Returns the converted plain object.
  		 * @example
  		 *
  		 * function Foo() {
  		 *   this.b = 2;
  		 * }
  		 *
  		 * Foo.prototype.c = 3;
  		 *
  		 * _.assign({ 'a': 1 }, new Foo);
  		 * // => { 'a': 1, 'b': 2 }
  		 *
  		 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
  		 * // => { 'a': 1, 'b': 2, 'c': 3 }
  		 */
  		function toPlainObject(value) {
  		  return copyObject(value, keysIn(value));
  		}

  		/**
  		 * Creates an array of the own and inherited enumerable property names of `object`.
  		 *
  		 * **Note:** Non-object values are coerced to objects.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 3.0.0
  		 * @category Object
  		 * @param {Object} object The object to query.
  		 * @returns {Array} Returns the array of property names.
  		 * @example
  		 *
  		 * function Foo() {
  		 *   this.a = 1;
  		 *   this.b = 2;
  		 * }
  		 *
  		 * Foo.prototype.c = 3;
  		 *
  		 * _.keysIn(new Foo);
  		 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
  		 */
  		function keysIn(object) {
  		  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeysIn(object);
  		}

  		/**
  		 * This method is like `_.merge` except that it accepts `customizer` which
  		 * is invoked to produce the merged values of the destination and source
  		 * properties. If `customizer` returns `undefined`, merging is handled by the
  		 * method instead. The `customizer` is invoked with six arguments:
  		 * (objValue, srcValue, key, object, source, stack).
  		 *
  		 * **Note:** This method mutates `object`.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.0.0
  		 * @category Object
  		 * @param {Object} object The destination object.
  		 * @param {...Object} sources The source objects.
  		 * @param {Function} customizer The function to customize assigned values.
  		 * @returns {Object} Returns `object`.
  		 * @example
  		 *
  		 * function customizer(objValue, srcValue) {
  		 *   if (_.isArray(objValue)) {
  		 *     return objValue.concat(srcValue);
  		 *   }
  		 * }
  		 *
  		 * var object = { 'a': [1], 'b': [2] };
  		 * var other = { 'a': [3], 'b': [4] };
  		 *
  		 * _.mergeWith(object, other, customizer);
  		 * // => { 'a': [1, 3], 'b': [2, 4] }
  		 */
  		var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  		  baseMerge(object, source, srcIndex, customizer);
  		});

  		/**
  		 * Creates a function that returns `value`.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 2.4.0
  		 * @category Util
  		 * @param {*} value The value to return from the new function.
  		 * @returns {Function} Returns the new constant function.
  		 * @example
  		 *
  		 * var objects = _.times(2, _.constant({ 'a': 1 }));
  		 *
  		 * console.log(objects);
  		 * // => [{ 'a': 1 }, { 'a': 1 }]
  		 *
  		 * console.log(objects[0] === objects[1]);
  		 * // => true
  		 */
  		function constant(value) {
  		  return function() {
  		    return value;
  		  };
  		}

  		/**
  		 * This method returns the first argument it receives.
  		 *
  		 * @static
  		 * @since 0.1.0
  		 * @memberOf _
  		 * @category Util
  		 * @param {*} value Any value.
  		 * @returns {*} Returns `value`.
  		 * @example
  		 *
  		 * var object = { 'a': 1 };
  		 *
  		 * console.log(_.identity(object) === object);
  		 * // => true
  		 */
  		function identity(value) {
  		  return value;
  		}

  		/**
  		 * This method returns `false`.
  		 *
  		 * @static
  		 * @memberOf _
  		 * @since 4.13.0
  		 * @category Util
  		 * @returns {boolean} Returns `false`.
  		 * @example
  		 *
  		 * _.times(2, _.stubFalse);
  		 * // => [false, false]
  		 */
  		function stubFalse() {
  		  return false;
  		}

  		module.exports = mergeWith; 
  	} (lodash_mergewith, lodash_mergewith.exports));
  	return lodash_mergewith.exports;
  }

  var lodash_mergewithExports = requireLodash_mergewith();
  var mergeWith = /*@__PURE__*/getDefaultExportFromCjs(lodash_mergewithExports);

  function useCallbackRef$1(callback, deps = []) {
    const callbackRef = React.useRef(callback);
    React.useEffect(() => {
      callbackRef.current = callback;
    });
    return React.useCallback((...args) => callbackRef.current?.(...args), deps);
  }

  function useEventListener(target, event, handler, options) {
    const listener = useCallbackRef$1(handler);
    React.useEffect(() => {
      const node = typeof target === "function" ? target() : target ?? document;
      if (!handler || !node)
        return;
      node.addEventListener(event, listener, options);
      return () => {
        node.removeEventListener(event, listener, options);
      };
    }, [event, target, options, listener, handler]);
    return () => {
      const node = typeof target === "function" ? target() : target ?? document;
      node?.removeEventListener(event, listener, options);
    };
  }

  function useAnimationState(props) {
    const { isOpen, ref } = props;
    const [mounted, setMounted] = React.useState(isOpen);
    const [once, setOnce] = React.useState(false);
    React.useEffect(() => {
      if (!once) {
        setMounted(isOpen);
        setOnce(true);
      }
    }, [isOpen, once, mounted]);
    useEventListener(
      () => ref.current,
      "animationend",
      () => {
        setMounted(isOpen);
      }
    );
    const hidden = isOpen ? false : !mounted;
    return {
      present: !hidden,
      onComplete() {
        const win = getOwnerWindow(ref.current);
        const evt = new win.CustomEvent("animationend", { bubbles: true });
        ref.current?.dispatchEvent(evt);
      }
    };
  }

  function useControllableState(props) {
    const {
      value: valueProp,
      defaultValue,
      onChange,
      shouldUpdate = (prev, next) => prev !== next
    } = props;
    const onChangeProp = useCallbackRef$1(onChange);
    const shouldUpdateProp = useCallbackRef$1(shouldUpdate);
    const [uncontrolledState, setUncontrolledState] = React.useState(defaultValue);
    const controlled = valueProp !== void 0;
    const value = controlled ? valueProp : uncontrolledState;
    const setValue = useCallbackRef$1(
      (next) => {
        const setter = next;
        const nextValue = typeof next === "function" ? setter(value) : next;
        if (!shouldUpdateProp(value, nextValue)) {
          return;
        }
        if (!controlled) {
          setUncontrolledState(nextValue);
        }
        onChangeProp(nextValue);
      },
      [controlled, onChangeProp, value, shouldUpdateProp]
    );
    return [value, setValue];
  }

  function useDisclosure(props = {}) {
    const {
      onClose: onCloseProp,
      onOpen: onOpenProp,
      isOpen: isOpenProp,
      id: idProp
    } = props;
    const handleOpen = useCallbackRef$1(onOpenProp);
    const handleClose = useCallbackRef$1(onCloseProp);
    const [isOpenState, setIsOpen] = React.useState(props.defaultIsOpen || false);
    const isOpen = isOpenProp !== void 0 ? isOpenProp : isOpenState;
    const isControlled = isOpenProp !== void 0;
    const uid = React.useId();
    const id = idProp ?? `disclosure-${uid}`;
    const onClose = React.useCallback(() => {
      if (!isControlled) {
        setIsOpen(false);
      }
      handleClose?.();
    }, [isControlled, handleClose]);
    const onOpen = React.useCallback(() => {
      if (!isControlled) {
        setIsOpen(true);
      }
      handleOpen?.();
    }, [isControlled, handleOpen]);
    const onToggle = React.useCallback(() => {
      if (isOpen) {
        onClose();
      } else {
        onOpen();
      }
    }, [isOpen, onOpen, onClose]);
    function getButtonProps(props2 = {}) {
      return {
        ...props2,
        "aria-expanded": isOpen,
        "aria-controls": id,
        onClick(event) {
          props2.onClick?.(event);
          onToggle();
        }
      };
    }
    function getDisclosureProps(props2 = {}) {
      return {
        ...props2,
        hidden: !isOpen,
        id
      };
    }
    return {
      isOpen,
      onOpen,
      onClose,
      onToggle,
      isControlled,
      getButtonProps,
      getDisclosureProps
    };
  }

  const useSafeLayoutEffect$2 = Boolean(globalThis?.document) ? React.useLayoutEffect : React.useEffect;

  const useUpdateEffect = (effect, deps) => {
    const renderCycleRef = React.useRef(false);
    const effectCycleRef = React.useRef(false);
    React.useEffect(() => {
      const isMounted = renderCycleRef.current;
      const shouldRun = isMounted && effectCycleRef.current;
      if (shouldRun) {
        return effect();
      }
      effectCycleRef.current = true;
    }, deps);
    React.useEffect(() => {
      renderCycleRef.current = true;
      return () => {
        renderCycleRef.current = false;
      };
    }, []);
  };

  function preventReturnFocus(containerRef) {
    const el = containerRef.current;
    if (!el)
      return false;
    const activeElement = getActiveElement$1(el);
    if (!activeElement)
      return false;
    if (el.contains(activeElement))
      return false;
    if (isTabbable(activeElement))
      return true;
    return false;
  }
  function useFocusOnHide(containerRef, options) {
    const { shouldFocus: shouldFocusProp, visible, focusRef } = options;
    const shouldFocus = shouldFocusProp && !visible;
    useUpdateEffect(() => {
      if (!shouldFocus)
        return;
      if (preventReturnFocus(containerRef)) {
        return;
      }
      const el = focusRef?.current || containerRef.current;
      let rafId;
      if (el) {
        rafId = requestAnimationFrame(() => {
          el.focus({ preventScroll: true });
        });
        return () => {
          cancelAnimationFrame(rafId);
        };
      }
    }, [shouldFocus, containerRef, focusRef]);
  }
  const defaultOptions$2 = {
    preventScroll: true,
    shouldFocus: false
  };
  function useFocusOnShow(target, options = defaultOptions$2) {
    const { focusRef, preventScroll, shouldFocus, visible } = options;
    const element = isRefObject$2(target) ? target.current : target;
    const autoFocusValue = shouldFocus && visible;
    const autoFocusRef = React.useRef(autoFocusValue);
    const lastVisibleRef = React.useRef(visible);
    useSafeLayoutEffect$2(() => {
      if (!lastVisibleRef.current && visible) {
        autoFocusRef.current = autoFocusValue;
      }
      lastVisibleRef.current = visible;
    }, [visible, autoFocusValue]);
    const onFocus = React.useCallback(() => {
      if (!visible || !element || !autoFocusRef.current)
        return;
      autoFocusRef.current = false;
      if (element.contains(document.activeElement))
        return;
      if (focusRef?.current) {
        requestAnimationFrame(() => {
          focusRef.current?.focus({ preventScroll });
        });
      } else {
        const tabbableEls = getAllFocusable(element);
        if (tabbableEls.length > 0) {
          requestAnimationFrame(() => {
            tabbableEls[0].focus({ preventScroll });
          });
        }
      }
    }, [visible, preventScroll, element, focusRef]);
    useUpdateEffect(() => {
      onFocus();
    }, [onFocus]);
    useEventListener(element, "transitionend", onFocus);
  }
  function isRefObject$2(val) {
    return "current" in val;
  }

  function isRefObject$1(val) {
    return "current" in val;
  }
  const isDom = () => typeof window !== "undefined";
  function getPlatform() {
    const agent = navigator.userAgentData;
    return agent?.platform ?? navigator.platform;
  }
  const vn = (v) => isDom() && v.test(navigator.vendor);
  const pt = (v) => isDom() && v.test(getPlatform());
  const isApple = () => pt(/mac|iphone|ipad|ipod/i);
  const isSafari$1 = () => isApple() && vn(/apple/i);
  function useFocusOnPointerDown(props) {
    const { ref, elements, enabled } = props;
    const doc = () => ref.current?.ownerDocument ?? document;
    useEventListener(doc, "pointerdown", (event) => {
      if (!isSafari$1() || !enabled)
        return;
      const target = event.composedPath?.()?.[0] ?? event.target;
      const els = elements ?? [ref];
      const isValidTarget = els.some((elementOrRef) => {
        const el = isRefObject$1(elementOrRef) ? elementOrRef.current : elementOrRef;
        return el?.contains(target) || el === target;
      });
      if (doc().activeElement !== target && isValidTarget) {
        event.preventDefault();
        target.focus();
      }
    });
  }

  function useId(idProp, prefix) {
    const id = React.useId();
    return React.useMemo(
      () => idProp || [prefix, id].filter(Boolean).join("-"),
      [idProp, prefix, id]
    );
  }
  function useIds$1(idProp, ...prefixes) {
    const id = useId(idProp);
    return React.useMemo(() => {
      return prefixes.map((prefix) => `${prefix}-${id}`);
    }, [id, prefixes]);
  }

  function assignRef$1(ref, value) {
    if (ref == null)
      return;
    if (typeof ref === "function") {
      ref(value);
      return;
    }
    try {
      ref.current = value;
    } catch (error) {
      throw new Error(`Cannot assign value '${value}' to ref '${ref}'`);
    }
  }
  function mergeRefs(...refs) {
    return (node) => {
      refs.forEach((ref) => {
        assignRef$1(ref, node);
      });
    };
  }
  function useMergeRefs$1(...refs) {
    return React.useMemo(() => mergeRefs(...refs), refs);
  }

  function useOutsideClick(props) {
    const { ref, handler, enabled = true } = props;
    const savedHandler = useCallbackRef$1(handler);
    const stateRef = React.useRef({
      isPointerDown: false,
      ignoreEmulatedMouseEvents: false
    });
    const state = stateRef.current;
    React.useEffect(() => {
      if (!enabled)
        return;
      const onPointerDown = (e) => {
        if (isValidEvent(e, ref)) {
          state.isPointerDown = true;
        }
      };
      const onMouseUp = (event) => {
        if (state.ignoreEmulatedMouseEvents) {
          state.ignoreEmulatedMouseEvents = false;
          return;
        }
        if (state.isPointerDown && handler && isValidEvent(event, ref)) {
          state.isPointerDown = false;
          savedHandler(event);
        }
      };
      const onTouchEnd = (event) => {
        state.ignoreEmulatedMouseEvents = true;
        if (handler && state.isPointerDown && isValidEvent(event, ref)) {
          state.isPointerDown = false;
          savedHandler(event);
        }
      };
      const doc = getOwnerDocument$1(ref.current);
      doc.addEventListener("mousedown", onPointerDown, true);
      doc.addEventListener("mouseup", onMouseUp, true);
      doc.addEventListener("touchstart", onPointerDown, true);
      doc.addEventListener("touchend", onTouchEnd, true);
      return () => {
        doc.removeEventListener("mousedown", onPointerDown, true);
        doc.removeEventListener("mouseup", onMouseUp, true);
        doc.removeEventListener("touchstart", onPointerDown, true);
        doc.removeEventListener("touchend", onTouchEnd, true);
      };
    }, [handler, ref, savedHandler, state, enabled]);
  }
  function isValidEvent(event, ref) {
    const target = event.composedPath?.()[0] ?? event.target;
    if (target) {
      const doc = getOwnerDocument$1(target);
      if (!doc.contains(target))
        return false;
    }
    return !ref.current?.contains(target);
  }
  function getOwnerDocument$1(node) {
    return node?.ownerDocument ?? document;
  }

  function useTimeout(callback, delay) {
    const fn = useCallbackRef$1(callback);
    React.useEffect(() => {
      if (delay == null)
        return void 0;
      let timeoutId = null;
      timeoutId = window.setTimeout(() => {
        fn();
      }, delay);
      return () => {
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
      };
    }, [delay, fn]);
  }

  const state$1 = {
    open: (str, post) => `${str}[data-open], ${str}[open], ${str}[data-state=open] ${post}`,
    closed: (str, post) => `${str}[data-closed], ${str}[data-state=closed] ${post}`,
    hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post) => `${str}:focus-visible ${post}`,
    focusWithin: (str, post) => `${str}:focus-within ${post}`,
    active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
    placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
  };
  const toGroup$1 = (fn) => merge$1((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
  const toPeer$1 = (fn) => merge$1((v) => fn(v, "~ &"), "[data-peer]", ".peer");
  const merge$1 = (fn, ...selectors) => selectors.map(fn).join(", ");
  const pseudoSelectors$1 = {
    /**
     * Styles for CSS selector `&:hover`
     */
    _hover: "&:hover, &[data-hover]",
    /**
     * Styles for CSS Selector `&:active`
     */
    _active: "&:active, &[data-active]",
    /**
     * Styles for CSS selector `&:focus`
     *
     */
    _focus: "&:focus, &[data-focus]",
    /**
     * Styles for the highlighted state.
     */
    _highlighted: "&[data-highlighted]",
    /**
     * Styles to apply when a child of this element has received focus
     * - CSS Selector `&:focus-within`
     */
    _focusWithin: "&:focus-within, &[data-focus-within]",
    /**
     * Styles to apply when this element has received focus via tabbing
     * - CSS Selector `&:focus-visible`
     */
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    /**
     * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
     * - `&[aria-disabled=true]`
     * - `&:disabled`
     * - `&[data-disabled]`
     * - `&[disabled]`
     */
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    /**
     * Styles for CSS Selector `&:readonly`
     */
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    /**
     * Styles for CSS selector `&::before`
     *
     * NOTE:When using this, ensure the `content` is wrapped in a backtick.
     * @example
     * ```jsx
     * <Box _before={{content:`""` }}/>
     * ```
     */
    _before: "&::before",
    /**
     * Styles for CSS selector `&::after`
     *
     * NOTE:When using this, ensure the `content` is wrapped in a backtick.
     * @example
     * ```jsx
     * <Box _after={{content:`""` }}/>
     * ```
     */
    _after: "&::after",
    /**
     * Styles for CSS selector `&:empty`
     */
    _empty: "&:empty, &[data-empty]",
    /**
     * Styles to apply when the ARIA attribute `aria-expanded` is `true`
     * - CSS selector `&[aria-expanded=true]`
     */
    _expanded: "&[aria-expanded=true], &[data-expanded], &[data-state=expanded]",
    /**
     * Styles to apply when the ARIA attribute `aria-checked` is `true`
     * - CSS selector `&[aria-checked=true]`
     */
    _checked: "&[aria-checked=true], &[data-checked], &[data-state=checked]",
    /**
     * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
     * - CSS selector `&[aria-grabbed=true]`
     */
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    /**
     * Styles for CSS Selector `&[aria-pressed=true]`
     * Typically used to style the current "pressed" state of toggle buttons
     */
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    /**
     * Styles to apply when the ARIA attribute `aria-invalid` is `true`
     * - CSS selector `&[aria-invalid=true]`
     */
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    /**
     * Styles for the valid state
     * - CSS selector `&[data-valid], &[data-state=valid]`
     */
    _valid: "&[data-valid], &[data-state=valid]",
    /**
     * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
     * Useful for styling loading states
     */
    _loading: "&[data-loading], &[aria-busy=true]",
    /**
     * Styles to apply when the ARIA attribute `aria-selected` is `true`
     *
     * - CSS selector `&[aria-selected=true]`
     */
    _selected: "&[aria-selected=true], &[data-selected]",
    /**
     * Styles for CSS Selector `[hidden=true]`
     */
    _hidden: "&[hidden], &[data-hidden]",
    /**
     * Styles for CSS Selector `&:-webkit-autofill`
     */
    _autofill: "&:-webkit-autofill",
    /**
     * Styles for CSS Selector `&:nth-child(even)`
     */
    _even: "&:nth-of-type(even)",
    /**
     * Styles for CSS Selector `&:nth-child(odd)`
     */
    _odd: "&:nth-of-type(odd)",
    /**
     * Styles for CSS Selector `&:first-of-type`
     */
    _first: "&:first-of-type",
    /**
     * Styles for CSS selector `&::first-letter`
     *
     * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
     * @example
     * ```jsx
     * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
     * ```
     */
    _firstLetter: "&::first-letter",
    /**
     * Styles for CSS Selector `&:last-of-type`
     */
    _last: "&:last-of-type",
    /**
     * Styles for CSS Selector `&:not(:first-of-type)`
     */
    _notFirst: "&:not(:first-of-type)",
    /**
     * Styles for CSS Selector `&:not(:last-of-type)`
     */
    _notLast: "&:not(:last-of-type)",
    /**
     * Styles for CSS Selector `&:visited`
     */
    _visited: "&:visited",
    /**
     * Used to style the active link in a navigation
     * Styles for CSS Selector `&[aria-current=page]`
     */
    _activeLink: "&[aria-current=page]",
    /**
     * Used to style the current step within a process
     * Styles for CSS Selector `&[aria-current=step]`
     */
    _activeStep: "&[aria-current=step]",
    /**
     * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
     * - CSS selector `&[aria-checked=mixed]`
     */
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate], &[data-state=indeterminate]",
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is open
     */
    _groupOpen: toGroup$1(state$1.open),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is closed
     */
    _groupClosed: toGroup$1(state$1.closed),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
     */
    _groupHover: toGroup$1(state$1.hover),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
     */
    _peerHover: toPeer$1(state$1.hover),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
     */
    _groupFocus: toGroup$1(state$1.focus),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
     */
    _peerFocus: toPeer$1(state$1.focus),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
     */
    _groupFocusVisible: toGroup$1(state$1.focusVisible),
    /**
     * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
     */
    _peerFocusVisible: toPeer$1(state$1.focusVisible),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
     */
    _groupActive: toGroup$1(state$1.active),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is active
     */
    _peerActive: toPeer$1(state$1.active),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
     */
    _groupDisabled: toGroup$1(state$1.disabled),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
     */
    _peerDisabled: toPeer$1(state$1.disabled),
    /**
     *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
     */
    _groupInvalid: toGroup$1(state$1.invalid),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
     */
    _peerInvalid: toPeer$1(state$1.invalid),
    /**
     * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
     */
    _groupChecked: toGroup$1(state$1.checked),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
     */
    _peerChecked: toPeer$1(state$1.checked),
    /**
     *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
     */
    _groupFocusWithin: toGroup$1(state$1.focusWithin),
    /**
     *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
     */
    _peerFocusWithin: toPeer$1(state$1.focusWithin),
    /**
     * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
     */
    _peerPlaceholderShown: toPeer$1(state$1.placeholderShown),
    /**
     * Styles for CSS Selector `&::placeholder`.
     */
    _placeholder: "&::placeholder, &[data-placeholder]",
    /**
     * Styles for CSS Selector `&:placeholder-shown`.
     */
    _placeholderShown: "&:placeholder-shown, &[data-placeholder-shown]",
    /**
     * Styles for CSS Selector `&:fullscreen`.
     */
    _fullScreen: "&:fullscreen, &[data-fullscreen]",
    /**
     * Styles for CSS Selector `&::selection`
     */
    _selection: "&::selection",
    /**
     * Styles for CSS Selector `[dir=rtl] &`
     * It is applied when a parent element or this element has `dir="rtl"`
     */
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    /**
     * Styles for CSS Selector `[dir=ltr] &`
     * It is applied when a parent element or this element has `dir="ltr"`
     */
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    /**
     * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
     * It is used when the user has requested the system use a light or dark color theme.
     */
    _mediaDark: "@media (prefers-color-scheme: dark)",
    /**
     * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
     * It is used when the user has requested the system to reduce the amount of animations.
     */
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    /**
     * Styles for when `data-theme` is applied to any parent of
     * this component or element.
     */
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    /**
     * Styles for when `data-theme` is applied to any parent of
     * this component or element.
     */
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
    /**
     * Styles for the CSS Selector `&[data-orientation=horizontal]`
     */
    _horizontal: "&[data-orientation=horizontal]",
    /**
     * Styles for the CSS Selector `&[data-orientation=vertical]`
     */
    _vertical: "&[data-orientation=vertical]",
    /**
     * Styles for the CSS Selector `&[data-open], &[open], &[data-state=open]`
     */
    _open: "&[data-open], &[open], &[data-state=open]",
    /**
     * Styles for the CSS Selector `&[data-closed], &[data-state=closed]`
     */
    _closed: "&[data-closed], &[data-state=closed]",
    /**
     * Styles for the CSS Selector `&[data-complete]`
     */
    _complete: "&[data-complete]",
    /**
     * Styles for the CSS Selector `&[data-incomplete]`
     */
    _incomplete: "&[data-incomplete]",
    /**
     * Styles for the CSS Selector `&[data-current]`
     */
    _current: "&[data-current]"
  };
  const pseudoPropNames$1 = Object.keys(
    pseudoSelectors$1
  );

  const isImportant$1 = (value) => /!(important)?$/.test(value);
  const withoutImportant$1 = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
  const tokenToCSSVar$1 = (scale, value) => (theme) => {
    const valueStr = String(value);
    const important = isImportant$1(valueStr);
    const valueWithoutImportant = withoutImportant$1(valueStr);
    const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
    let transformed = isObject$1(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    transformed = withoutImportant$1(transformed);
    return important ? `${transformed} !important` : transformed;
  };
  function createTransform$1(options) {
    const { scale, transform, compose } = options;
    const fn = (value, theme) => {
      const _value = tokenToCSSVar$1(scale, value)(theme);
      let result = transform?.(_value, theme) ?? _value;
      if (compose) {
        result = compose(result, theme);
      }
      return result;
    };
    return fn;
  }

  const pipe$3 = (...fns) => (v) => fns.reduce((a, b) => b(a), v);

  function toConfig$1(scale, transform) {
    return (property) => {
      const result = { property, scale };
      result.transform = createTransform$1({
        scale,
        transform
      });
      return result;
    };
  }
  const getRtl$1 = ({ rtl, ltr }) => (theme) => theme.direction === "rtl" ? rtl : ltr;
  function logical$1(options) {
    const { property, scale, transform } = options;
    return {
      scale,
      property: getRtl$1(property),
      transform: scale ? createTransform$1({
        scale,
        compose: transform
      }) : transform
    };
  }

  const transformTemplate$1 = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
  ];
  function getTransformTemplate$1() {
    return [
      "translateX(var(--chakra-translate-x, 0))",
      "translateY(var(--chakra-translate-y, 0))",
      ...transformTemplate$1
    ].join(" ");
  }
  function getTransformGpuTemplate$1() {
    return [
      "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
      ...transformTemplate$1
    ].join(" ");
  }
  const filterTemplate$1 = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
      "var(--chakra-blur)",
      "var(--chakra-brightness)",
      "var(--chakra-contrast)",
      "var(--chakra-grayscale)",
      "var(--chakra-hue-rotate)",
      "var(--chakra-invert)",
      "var(--chakra-saturate)",
      "var(--chakra-sepia)",
      "var(--chakra-drop-shadow)"
    ].join(" ")
  };
  const backdropFilterTemplate$1 = {
    backdropFilter: [
      "var(--chakra-backdrop-blur)",
      "var(--chakra-backdrop-brightness)",
      "var(--chakra-backdrop-contrast)",
      "var(--chakra-backdrop-grayscale)",
      "var(--chakra-backdrop-hue-rotate)",
      "var(--chakra-backdrop-invert)",
      "var(--chakra-backdrop-opacity)",
      "var(--chakra-backdrop-saturate)",
      "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
  };
  function getRingTemplate$1(value) {
    return {
      "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
      "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
      "--chakra-ring-width": value,
      boxShadow: [
        `var(--chakra-ring-offset-shadow)`,
        `var(--chakra-ring-shadow)`,
        `var(--chakra-shadow, 0 0 #0000)`
      ].join(", ")
    };
  }
  const flexDirectionTemplate$1 = {
    "row-reverse": {
      space: "--chakra-space-x-reverse",
      divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
      space: "--chakra-space-y-reverse",
      divide: "--chakra-divide-y-reverse"
    }
  };

  const directionMap$1 = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
  };
  const valueSet$1 = new Set(Object.values(directionMap$1));
  const globalSet$1 = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]);
  const trimSpace$1 = (str) => str.trim();
  function parseGradient$1(value, theme) {
    if (value == null || globalSet$1.has(value))
      return value;
    const prevent = isCSSFunction$1(value) || globalSet$1.has(value);
    if (!prevent)
      return `url('${value}')`;
    const regex = /(^[a-z-A-Z]+)\((.*)\)/g;
    const results = regex.exec(value);
    const type = results?.[1];
    const values = results?.[2];
    if (!type || !values)
      return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map(trimSpace$1).filter(Boolean);
    if (stops?.length === 0)
      return value;
    const direction = maybeDirection in directionMap$1 ? directionMap$1[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop) => {
      if (valueSet$1.has(stop))
        return stop;
      const firstStop = stop.indexOf(" ");
      const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
      const _stopOrFunc = isCSSFunction$1(_stop) ? _stop : _stop && _stop.split(" ");
      const key = `colors.${_color}`;
      const color = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
      return _stopOrFunc ? [
        color,
        ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
      ].join(" ") : color;
    });
    return `${_type}(${_values.join(", ")})`;
  }
  const isCSSFunction$1 = (value) => {
    return typeof value === "string" && value.includes("(") && value.includes(")");
  };
  const gradientTransform$1 = (value, theme) => parseGradient$1(value, theme ?? {});

  function isCssVar$2(value) {
    return /^var\(--.+\)$/.test(value);
  }
  const analyzeCSSValue$1 = (value) => {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return { unitless: !unit, value: num, unit };
  };
  const wrap$1 = (str) => (value) => `${str}(${value})`;
  const transformFunctions$1 = {
    filter(value) {
      return value !== "auto" ? value : filterTemplate$1;
    },
    backdropFilter(value) {
      return value !== "auto" ? value : backdropFilterTemplate$1;
    },
    ring(value) {
      return getRingTemplate$1(transformFunctions$1.px(value));
    },
    bgClip(value) {
      return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
    },
    transform(value) {
      if (value === "auto")
        return getTransformTemplate$1();
      if (value === "auto-gpu")
        return getTransformGpuTemplate$1();
      return value;
    },
    vh(value) {
      return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px(value) {
      if (value == null)
        return value;
      const { unitless } = analyzeCSSValue$1(value);
      return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction(value) {
      return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float(value, theme) {
      const map = { left: "right", right: "left" };
      return theme.direction === "rtl" ? map[value] : value;
    },
    degree(value) {
      if (isCssVar$2(value) || value == null)
        return value;
      const unitless = typeof value === "string" && !value.endsWith("deg");
      return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: gradientTransform$1,
    blur: wrap$1("blur"),
    opacity: wrap$1("opacity"),
    brightness: wrap$1("brightness"),
    contrast: wrap$1("contrast"),
    dropShadow: wrap$1("drop-shadow"),
    grayscale: wrap$1("grayscale"),
    hueRotate: (value) => wrap$1("hue-rotate")(transformFunctions$1.degree(value)),
    invert: wrap$1("invert"),
    saturate: wrap$1("saturate"),
    sepia: wrap$1("sepia"),
    bgImage(value) {
      if (value == null)
        return value;
      const prevent = isCSSFunction$1(value) || globalSet$1.has(value);
      return !prevent ? `url(${value})` : value;
    },
    outline(value) {
      const isNoneOrZero = String(value) === "0" || String(value) === "none";
      return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
    },
    flexDirection(value) {
      const { space, divide } = flexDirectionTemplate$1[value] ?? {};
      const result = { flexDirection: value };
      if (space)
        result[space] = 1;
      if (divide)
        result[divide] = 1;
      return result;
    }
  };

  const t$2 = {
    borderWidths: toConfig$1("borderWidths"),
    borderStyles: toConfig$1("borderStyles"),
    colors: toConfig$1("colors"),
    borders: toConfig$1("borders"),
    gradients: toConfig$1("gradients", transformFunctions$1.gradient),
    radii: toConfig$1("radii", transformFunctions$1.px),
    space: toConfig$1("space", pipe$3(transformFunctions$1.vh, transformFunctions$1.px)),
    spaceT: toConfig$1("space", pipe$3(transformFunctions$1.vh, transformFunctions$1.px)),
    degreeT(property) {
      return { property, transform: transformFunctions$1.degree };
    },
    prop(property, scale, transform) {
      return {
        property,
        scale,
        ...scale && {
          transform: createTransform$1({ scale, transform })
        }
      };
    },
    propT(property, transform) {
      return { property, transform };
    },
    sizes: toConfig$1("sizes", pipe$3(transformFunctions$1.vh, transformFunctions$1.px)),
    sizesT: toConfig$1("sizes", pipe$3(transformFunctions$1.vh, transformFunctions$1.fraction)),
    shadows: toConfig$1("shadows"),
    logical: logical$1,
    blur: toConfig$1("blur", transformFunctions$1.blur)
  };

  const background$1 = {
    background: t$2.colors("background"),
    backgroundColor: t$2.colors("backgroundColor"),
    backgroundImage: t$2.gradients("backgroundImage"),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: { transform: transformFunctions$1.bgClip },
    bgSize: t$2.prop("backgroundSize"),
    bgPosition: t$2.prop("backgroundPosition"),
    bg: t$2.colors("background"),
    bgColor: t$2.colors("backgroundColor"),
    bgPos: t$2.prop("backgroundPosition"),
    bgRepeat: t$2.prop("backgroundRepeat"),
    bgAttachment: t$2.prop("backgroundAttachment"),
    bgGradient: t$2.gradients("backgroundImage"),
    bgClip: { transform: transformFunctions$1.bgClip }
  };
  Object.assign(background$1, {
    bgImage: background$1.backgroundImage,
    bgImg: background$1.backgroundImage
  });

  const border$1 = {
    border: t$2.borders("border"),
    borderWidth: t$2.borderWidths("borderWidth"),
    borderStyle: t$2.borderStyles("borderStyle"),
    borderColor: t$2.colors("borderColor"),
    borderRadius: t$2.radii("borderRadius"),
    borderTop: t$2.borders("borderTop"),
    borderBlockStart: t$2.borders("borderBlockStart"),
    borderTopLeftRadius: t$2.radii("borderTopLeftRadius"),
    borderStartStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderTopLeftRadius",
        rtl: "borderTopRightRadius"
      }
    }),
    borderEndStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomLeftRadius",
        rtl: "borderBottomRightRadius"
      }
    }),
    borderTopRightRadius: t$2.radii("borderTopRightRadius"),
    borderStartEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderTopRightRadius",
        rtl: "borderTopLeftRadius"
      }
    }),
    borderEndEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomRightRadius",
        rtl: "borderBottomLeftRadius"
      }
    }),
    borderRight: t$2.borders("borderRight"),
    borderInlineEnd: t$2.borders("borderInlineEnd"),
    borderBottom: t$2.borders("borderBottom"),
    borderBlockEnd: t$2.borders("borderBlockEnd"),
    borderBottomLeftRadius: t$2.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: t$2.radii("borderBottomRightRadius"),
    borderLeft: t$2.borders("borderLeft"),
    borderInlineStart: {
      property: "borderInlineStart",
      scale: "borders"
    },
    borderInlineStartRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
        rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
      }
    }),
    borderInlineEndRadius: t$2.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
        rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
      }
    }),
    borderX: t$2.borders(["borderLeft", "borderRight"]),
    borderInline: t$2.borders("borderInline"),
    borderY: t$2.borders(["borderTop", "borderBottom"]),
    borderBlock: t$2.borders("borderBlock"),
    borderTopWidth: t$2.borderWidths("borderTopWidth"),
    borderBlockStartWidth: t$2.borderWidths("borderBlockStartWidth"),
    borderTopColor: t$2.colors("borderTopColor"),
    borderBlockStartColor: t$2.colors("borderBlockStartColor"),
    borderTopStyle: t$2.borderStyles("borderTopStyle"),
    borderBlockStartStyle: t$2.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: t$2.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: t$2.borderWidths("borderBlockEndWidth"),
    borderBottomColor: t$2.colors("borderBottomColor"),
    borderBlockEndColor: t$2.colors("borderBlockEndColor"),
    borderBottomStyle: t$2.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: t$2.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: t$2.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: t$2.borderWidths("borderInlineStartWidth"),
    borderLeftColor: t$2.colors("borderLeftColor"),
    borderInlineStartColor: t$2.colors("borderInlineStartColor"),
    borderLeftStyle: t$2.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: t$2.borderStyles("borderInlineStartStyle"),
    borderRightWidth: t$2.borderWidths("borderRightWidth"),
    borderInlineEndWidth: t$2.borderWidths("borderInlineEndWidth"),
    borderRightColor: t$2.colors("borderRightColor"),
    borderInlineEndColor: t$2.colors("borderInlineEndColor"),
    borderRightStyle: t$2.borderStyles("borderRightStyle"),
    borderInlineEndStyle: t$2.borderStyles("borderInlineEndStyle"),
    borderTopRadius: t$2.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
    borderBottomRadius: t$2.radii([
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]),
    borderLeftRadius: t$2.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
    borderRightRadius: t$2.radii([
      "borderTopRightRadius",
      "borderBottomRightRadius"
    ])
  };
  Object.assign(border$1, {
    rounded: border$1.borderRadius,
    roundedTop: border$1.borderTopRadius,
    roundedTopLeft: border$1.borderTopLeftRadius,
    roundedTopRight: border$1.borderTopRightRadius,
    roundedTopStart: border$1.borderStartStartRadius,
    roundedTopEnd: border$1.borderStartEndRadius,
    roundedBottom: border$1.borderBottomRadius,
    roundedBottomLeft: border$1.borderBottomLeftRadius,
    roundedBottomRight: border$1.borderBottomRightRadius,
    roundedBottomStart: border$1.borderEndStartRadius,
    roundedBottomEnd: border$1.borderEndEndRadius,
    roundedLeft: border$1.borderLeftRadius,
    roundedRight: border$1.borderRightRadius,
    roundedStart: border$1.borderInlineStartRadius,
    roundedEnd: border$1.borderInlineEndRadius,
    borderStart: border$1.borderInlineStart,
    borderEnd: border$1.borderInlineEnd,
    borderTopStartRadius: border$1.borderStartStartRadius,
    borderTopEndRadius: border$1.borderStartEndRadius,
    borderBottomStartRadius: border$1.borderEndStartRadius,
    borderBottomEndRadius: border$1.borderEndEndRadius,
    borderStartRadius: border$1.borderInlineStartRadius,
    borderEndRadius: border$1.borderInlineEndRadius,
    borderStartWidth: border$1.borderInlineStartWidth,
    borderEndWidth: border$1.borderInlineEndWidth,
    borderStartColor: border$1.borderInlineStartColor,
    borderEndColor: border$1.borderInlineEndColor,
    borderStartStyle: border$1.borderInlineStartStyle,
    borderEndStyle: border$1.borderInlineEndStyle
  });

  const color$2 = {
    color: t$2.colors("color"),
    textColor: t$2.colors("color"),
    fill: t$2.colors("fill"),
    stroke: t$2.colors("stroke"),
    accentColor: t$2.colors("accentColor"),
    textFillColor: t$2.colors("textFillColor")
  };

  const flexbox$1 = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: { transform: transformFunctions$1.flexDirection },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: t$2.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: t$2.space("gap"),
    rowGap: t$2.space("rowGap"),
    columnGap: t$2.space("columnGap")
  };
  Object.assign(flexbox$1, {
    flexDir: flexbox$1.flexDirection
  });

  const layout$1 = {
    width: t$2.sizesT("width"),
    inlineSize: t$2.sizesT("inlineSize"),
    height: t$2.sizes("height"),
    blockSize: t$2.sizes("blockSize"),
    boxSize: t$2.sizes(["width", "height"]),
    minWidth: t$2.sizes("minWidth"),
    minInlineSize: t$2.sizes("minInlineSize"),
    minHeight: t$2.sizes("minHeight"),
    minBlockSize: t$2.sizes("minBlockSize"),
    maxWidth: t$2.sizes("maxWidth"),
    maxInlineSize: t$2.sizes("maxInlineSize"),
    maxHeight: t$2.sizes("maxHeight"),
    maxBlockSize: t$2.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    aspectRatio: true,
    hideFrom: {
      scale: "breakpoints",
      transform: (value, theme) => {
        const breakpoint = theme.__breakpoints?.get(value)?.minW ?? value;
        const mq = `@media screen and (min-width: ${breakpoint})`;
        return { [mq]: { display: "none" } };
      }
    },
    hideBelow: {
      scale: "breakpoints",
      transform: (value, theme) => {
        const breakpoint = theme.__breakpoints?.get(value)?._minW ?? value;
        const mq = `@media screen and (max-width: ${breakpoint})`;
        return { [mq]: { display: "none" } };
      }
    },
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: t$2.propT("float", transformFunctions$1.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
  };
  Object.assign(layout$1, {
    w: layout$1.width,
    h: layout$1.height,
    minW: layout$1.minWidth,
    maxW: layout$1.maxWidth,
    minH: layout$1.minHeight,
    maxH: layout$1.maxHeight,
    overscroll: layout$1.overscrollBehavior,
    overscrollX: layout$1.overscrollBehaviorX,
    overscrollY: layout$1.overscrollBehaviorY
  });

  const filter$2 = {
    filter: { transform: transformFunctions$1.filter },
    blur: t$2.blur("--chakra-blur"),
    brightness: t$2.propT("--chakra-brightness", transformFunctions$1.brightness),
    contrast: t$2.propT("--chakra-contrast", transformFunctions$1.contrast),
    hueRotate: t$2.propT("--chakra-hue-rotate", transformFunctions$1.hueRotate),
    invert: t$2.propT("--chakra-invert", transformFunctions$1.invert),
    saturate: t$2.propT("--chakra-saturate", transformFunctions$1.saturate),
    dropShadow: t$2.propT("--chakra-drop-shadow", transformFunctions$1.dropShadow),
    backdropFilter: { transform: transformFunctions$1.backdropFilter },
    backdropBlur: t$2.blur("--chakra-backdrop-blur"),
    backdropBrightness: t$2.propT(
      "--chakra-backdrop-brightness",
      transformFunctions$1.brightness
    ),
    backdropContrast: t$2.propT("--chakra-backdrop-contrast", transformFunctions$1.contrast),
    backdropHueRotate: t$2.propT(
      "--chakra-backdrop-hue-rotate",
      transformFunctions$1.hueRotate
    ),
    backdropInvert: t$2.propT("--chakra-backdrop-invert", transformFunctions$1.invert),
    backdropSaturate: t$2.propT("--chakra-backdrop-saturate", transformFunctions$1.saturate)
  };

  const ring$1 = {
    ring: { transform: transformFunctions$1.ring },
    ringColor: t$2.colors("--chakra-ring-color"),
    ringOffset: t$2.prop("--chakra-ring-offset-width"),
    ringOffsetColor: t$2.colors("--chakra-ring-offset-color"),
    ringInset: t$2.prop("--chakra-ring-inset")
  };

  const interactivity$1 = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: { transform: transformFunctions$1.outline },
    outlineOffset: true,
    outlineColor: t$2.colors("outlineColor")
  };

  const grid$1 = {
    gridGap: t$2.space("gridGap"),
    gridColumnGap: t$2.space("gridColumnGap"),
    gridRowGap: t$2.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
  };

  function get$2(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [path];
    for (index = 0; index < key.length; index += 1) {
      if (!obj)
        break;
      obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
  }
  const memoize$2 = (fn) => {
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index) => {
      if (typeof obj === "undefined") {
        return fn(obj, path, fallback);
      }
      if (!cache.has(obj)) {
        cache.set(obj, /* @__PURE__ */ new Map());
      }
      const map = cache.get(obj);
      if (map.has(path)) {
        return map.get(path);
      }
      const value = fn(obj, path, fallback, index);
      map.set(path, value);
      return value;
    };
    return memoizedFn;
  };
  const memoizedGet$1 = memoize$2(get$2);

  const srOnly$1 = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
  };
  const srFocusable$1 = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
  };
  const getWithPriority$1 = (theme, key, styles) => {
    const result = {};
    const obj = memoizedGet$1(theme, key, {});
    for (const prop in obj) {
      const isInStyles = prop in styles && styles[prop] != null;
      if (!isInStyles)
        result[prop] = obj[prop];
    }
    return result;
  };
  const others$1 = {
    srOnly: {
      transform(value) {
        if (value === true)
          return srOnly$1;
        if (value === "focusable")
          return srFocusable$1;
        return {};
      }
    },
    layerStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority$1(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority$1(theme, `textStyles.${value}`, styles)
    },
    apply: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority$1(theme, value, styles)
    }
  };

  const position$2 = {
    position: true,
    pos: t$2.prop("position"),
    zIndex: t$2.prop("zIndex", "zIndices"),
    inset: t$2.spaceT("inset"),
    insetX: t$2.spaceT(["left", "right"]),
    insetInline: t$2.spaceT("insetInline"),
    insetY: t$2.spaceT(["top", "bottom"]),
    insetBlock: t$2.spaceT("insetBlock"),
    top: t$2.spaceT("top"),
    insetBlockStart: t$2.spaceT("insetBlockStart"),
    bottom: t$2.spaceT("bottom"),
    insetBlockEnd: t$2.spaceT("insetBlockEnd"),
    left: t$2.spaceT("left"),
    insetInlineStart: t$2.logical({
      scale: "space",
      property: { ltr: "left", rtl: "right" }
    }),
    right: t$2.spaceT("right"),
    insetInlineEnd: t$2.logical({
      scale: "space",
      property: { ltr: "right", rtl: "left" }
    })
  };
  Object.assign(position$2, {
    insetStart: position$2.insetInlineStart,
    insetEnd: position$2.insetInlineEnd
  });

  const effect$4 = {
    boxShadow: t$2.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: t$2.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: t$2.prop("backgroundBlendMode"),
    opacity: true
  };
  Object.assign(effect$4, {
    shadow: effect$4.boxShadow
  });

  const space$1 = {
    margin: t$2.spaceT("margin"),
    marginTop: t$2.spaceT("marginTop"),
    marginBlockStart: t$2.spaceT("marginBlockStart"),
    marginRight: t$2.spaceT("marginRight"),
    marginInlineEnd: t$2.spaceT("marginInlineEnd"),
    marginBottom: t$2.spaceT("marginBottom"),
    marginBlockEnd: t$2.spaceT("marginBlockEnd"),
    marginLeft: t$2.spaceT("marginLeft"),
    marginInlineStart: t$2.spaceT("marginInlineStart"),
    marginX: t$2.spaceT(["marginInlineStart", "marginInlineEnd"]),
    marginInline: t$2.spaceT("marginInline"),
    marginY: t$2.spaceT(["marginTop", "marginBottom"]),
    marginBlock: t$2.spaceT("marginBlock"),
    padding: t$2.space("padding"),
    paddingTop: t$2.space("paddingTop"),
    paddingBlockStart: t$2.space("paddingBlockStart"),
    paddingRight: t$2.space("paddingRight"),
    paddingBottom: t$2.space("paddingBottom"),
    paddingBlockEnd: t$2.space("paddingBlockEnd"),
    paddingLeft: t$2.space("paddingLeft"),
    paddingInlineStart: t$2.space("paddingInlineStart"),
    paddingInlineEnd: t$2.space("paddingInlineEnd"),
    paddingX: t$2.space(["paddingInlineStart", "paddingInlineEnd"]),
    paddingInline: t$2.space("paddingInline"),
    paddingY: t$2.space(["paddingTop", "paddingBottom"]),
    paddingBlock: t$2.space("paddingBlock")
  };
  Object.assign(space$1, {
    m: space$1.margin,
    mt: space$1.marginTop,
    mr: space$1.marginRight,
    me: space$1.marginInlineEnd,
    marginEnd: space$1.marginInlineEnd,
    mb: space$1.marginBottom,
    ml: space$1.marginLeft,
    ms: space$1.marginInlineStart,
    marginStart: space$1.marginInlineStart,
    mx: space$1.marginX,
    my: space$1.marginY,
    p: space$1.padding,
    pt: space$1.paddingTop,
    py: space$1.paddingY,
    px: space$1.paddingX,
    pb: space$1.paddingBottom,
    pl: space$1.paddingLeft,
    ps: space$1.paddingInlineStart,
    paddingStart: space$1.paddingInlineStart,
    pr: space$1.paddingRight,
    pe: space$1.paddingInlineEnd,
    paddingEnd: space$1.paddingInlineEnd
  });

  const scroll$1 = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    // scroll margin
    scrollMargin: t$2.spaceT("scrollMargin"),
    scrollMarginTop: t$2.spaceT("scrollMarginTop"),
    scrollMarginBottom: t$2.spaceT("scrollMarginBottom"),
    scrollMarginLeft: t$2.spaceT("scrollMarginLeft"),
    scrollMarginRight: t$2.spaceT("scrollMarginRight"),
    scrollMarginX: t$2.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
    scrollMarginY: t$2.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
    // scroll padding
    scrollPadding: t$2.spaceT("scrollPadding"),
    scrollPaddingTop: t$2.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: t$2.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: t$2.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: t$2.spaceT("scrollPaddingRight"),
    scrollPaddingX: t$2.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
    scrollPaddingY: t$2.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
  };

  const typography$2 = {
    fontFamily: t$2.prop("fontFamily", "fonts"),
    fontSize: t$2.prop("fontSize", "fontSizes", transformFunctions$1.px),
    fontWeight: t$2.prop("fontWeight", "fontWeights"),
    lineHeight: t$2.prop("lineHeight", "lineHeights"),
    letterSpacing: t$2.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    textIndent: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    isTruncated: {
      transform(value) {
        if (value === true) {
          return {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          };
        }
      }
    },
    noOfLines: {
      static: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        //@ts-ignore
        WebkitLineClamp: "var(--chakra-line-clamp)"
      },
      property: "--chakra-line-clamp"
    }
  };

  const textDecoration$1 = {
    textDecorationColor: t$2.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: { property: "textDecoration" },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: t$2.shadows("textShadow")
  };

  const transform$1 = {
    clipPath: true,
    transform: t$2.propT("transform", transformFunctions$1.transform),
    transformOrigin: true,
    translateX: t$2.spaceT("--chakra-translate-x"),
    translateY: t$2.spaceT("--chakra-translate-y"),
    skewX: t$2.degreeT("--chakra-skew-x"),
    skewY: t$2.degreeT("--chakra-skew-y"),
    scaleX: t$2.prop("--chakra-scale-x"),
    scaleY: t$2.prop("--chakra-scale-y"),
    scale: t$2.prop(["--chakra-scale-x", "--chakra-scale-y"]),
    rotate: t$2.degreeT("--chakra-rotate")
  };

  const list$1 = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: t$2.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: t$2.prop("listStyleImage")
  };

  const transition$2 = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: t$2.prop("transitionDuration", "transition.duration"),
    transitionProperty: t$2.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: t$2.prop(
      "transitionTimingFunction",
      "transition.easing"
    )
  };

  const systemProps$1 = mergeWith(
    {},
    background$1,
    border$1,
    color$2,
    flexbox$1,
    layout$1,
    filter$2,
    ring$1,
    interactivity$1,
    grid$1,
    others$1,
    position$2,
    effect$4,
    space$1,
    scroll$1,
    typography$2,
    textDecoration$1,
    transform$1,
    list$1,
    transition$2
  );
  const layoutSystem = Object.assign({}, space$1, layout$1, flexbox$1, grid$1, position$2);
  const layoutPropNames = Object.keys(
    layoutSystem
  );
  const propNames$1 = [...Object.keys(systemProps$1), ...pseudoPropNames$1];
  const styleProps$1 = { ...systemProps$1, ...pseudoSelectors$1 };
  const isStyleProp$1 = (prop) => prop in styleProps$1;

  const expandResponsive$1 = (styles) => (theme) => {
    if (!theme.__breakpoints)
      return styles;
    const { isResponsive, toArrayValue, media: medias } = theme.__breakpoints;
    const computedStyles = {};
    for (const key in styles) {
      let value = runIfFn$3(styles[key], theme);
      if (value == null)
        continue;
      value = isObject$1(value) && isResponsive(value) ? toArrayValue(value) : value;
      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }
      const queries = value.slice(0, medias.length).length;
      for (let index = 0; index < queries; index += 1) {
        const media = medias?.[index];
        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }
        computedStyles[media] = computedStyles[media] || {};
        if (value[index] == null) {
          continue;
        }
        computedStyles[media][key] = value[index];
      }
    }
    return computedStyles;
  };

  function splitByComma$1(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char === "(") {
        inParens = true;
        chunk += char;
      } else if (char === ")") {
        inParens = false;
        chunk += char;
      } else if (char === "," && !inParens) {
        chunks.push(chunk);
        chunk = "";
      } else {
        chunk += char;
      }
    }
    chunk = chunk.trim();
    if (chunk) {
      chunks.push(chunk);
    }
    return chunks;
  }

  function isCssVar$1(value) {
    return /^var\(--.+\)$/.test(value);
  }
  const isCSSVariableTokenValue$1 = (key, value) => key.startsWith("--") && typeof value === "string" && !isCssVar$1(value);
  const resolveTokenValue$1 = (theme, value) => {
    if (value == null)
      return value;
    const getVar = (val) => theme.__cssMap?.[val]?.varRef;
    const getValue = (val) => getVar(val) ?? val;
    const [tokenValue, fallbackValue] = splitByComma$1(value);
    value = getVar(tokenValue) ?? getValue(fallbackValue) ?? getValue(value);
    return value;
  };
  function getCss$1(options) {
    const { configs = {}, pseudos = {}, theme } = options;
    const css2 = (stylesOrFn, nested = false) => {
      const _styles = runIfFn$3(stylesOrFn, theme);
      const styles = expandResponsive$1(_styles)(theme);
      let computedStyles = {};
      for (let key in styles) {
        const valueOrFn = styles[key];
        let value = runIfFn$3(valueOrFn, theme);
        if (key in pseudos) {
          key = pseudos[key];
        }
        if (isCSSVariableTokenValue$1(key, value)) {
          value = resolveTokenValue$1(theme, value);
        }
        let config = configs[key];
        if (config === true) {
          config = { property: key };
        }
        if (isObject$1(value)) {
          computedStyles[key] = computedStyles[key] ?? {};
          computedStyles[key] = mergeWith(
            {},
            computedStyles[key],
            css2(value, true)
          );
          continue;
        }
        let rawValue = config?.transform?.(value, theme, _styles) ?? value;
        rawValue = config?.processResult ? css2(rawValue, true) : rawValue;
        const configProperty = runIfFn$3(config?.property, theme);
        if (!nested && config?.static) {
          const staticStyles = runIfFn$3(config.static, theme);
          computedStyles = mergeWith({}, computedStyles, staticStyles);
        }
        if (configProperty && Array.isArray(configProperty)) {
          for (const property of configProperty) {
            computedStyles[property] = rawValue;
          }
          continue;
        }
        if (configProperty) {
          if (configProperty === "&" && isObject$1(rawValue)) {
            computedStyles = mergeWith({}, computedStyles, rawValue);
          } else {
            computedStyles[configProperty] = rawValue;
          }
          continue;
        }
        if (isObject$1(rawValue)) {
          computedStyles = mergeWith({}, computedStyles, rawValue);
          continue;
        }
        computedStyles[key] = rawValue;
      }
      return computedStyles;
    };
    return css2;
  }
  const css$3 = (styles) => (theme) => {
    const cssFn = getCss$1({
      theme,
      pseudos: pseudoSelectors$1,
      configs: systemProps$1
    });
    return cssFn(styles);
  };

  function defineStyle(styles) {
    return styles;
  }
  function defineStyleConfig(config) {
    return config;
  }
  function createMultiStyleConfigHelpers(parts) {
    return {
      definePartsStyle(config) {
        return config;
      },
      defineMultiStyleConfig(config) {
        return { parts, ...config };
      }
    };
  }

  function getCSSVar(theme, scale, value) {
    return theme.__cssMap?.[`${scale}.${value}`]?.varRef ?? value;
  }

  function normalize(value, toArray) {
    if (Array.isArray(value))
      return value;
    if (isObject$1(value))
      return toArray(value);
    if (value != null)
      return [value];
  }
  function getNextIndex$1(values, i) {
    for (let j = i + 1; j < values.length; j++) {
      if (values[j] != null)
        return j;
    }
    return -1;
  }
  function createResolver(theme) {
    const breakpointUtil = theme.__breakpoints;
    return function resolver(config, prop, value, props) {
      if (!breakpointUtil)
        return;
      const result = {};
      const normalized = normalize(value, breakpointUtil.toArrayValue);
      if (!normalized)
        return result;
      const len = normalized.length;
      const isSingle = len === 1;
      const isMultipart = !!config.parts;
      for (let i = 0; i < len; i++) {
        const key = breakpointUtil.details[i];
        const nextKey = breakpointUtil.details[getNextIndex$1(normalized, i)];
        const query = toMediaQueryString(key.minW, nextKey?._minW);
        const styles = runIfFn$3(config[prop]?.[normalized[i]], props);
        if (!styles)
          continue;
        if (isMultipart) {
          config.parts?.forEach((part) => {
            mergeWith(result, {
              [part]: isSingle ? styles[part] : { [query]: styles[part] }
            });
          });
          continue;
        }
        if (!isMultipart) {
          if (isSingle)
            mergeWith(result, styles);
          else
            result[query] = styles;
          continue;
        }
        result[query] = styles;
      }
      return result;
    };
  }
  function resolveStyleConfig(config) {
    return (props) => {
      const { variant, size, theme } = props;
      const recipe = createResolver(theme);
      return mergeWith(
        {},
        runIfFn$3(config.baseStyle ?? {}, props),
        recipe(config, "sizes", size, props),
        recipe(config, "variants", variant, props)
      );
    };
  }

  function omitThemingProps(props) {
    return omit(props, ["styleConfig", "size", "variant", "colorScheme"]);
  }

  function resolveReference$1(operand) {
    if (isObject$1(operand) && operand.reference) {
      return operand.reference;
    }
    return String(operand);
  }
  const toExpression$1 = (operator, ...operands) => operands.map(resolveReference$1).join(` ${operator} `).replace(/calc/g, "");
  const add$2 = (...operands) => `calc(${toExpression$1("+", ...operands)})`;
  const subtract$2 = (...operands) => `calc(${toExpression$1("-", ...operands)})`;
  const multiply$2 = (...operands) => `calc(${toExpression$1("*", ...operands)})`;
  const divide$2 = (...operands) => `calc(${toExpression$1("/", ...operands)})`;
  const negate$2 = (x) => {
    const value = resolveReference$1(x);
    if (value != null && !Number.isNaN(parseFloat(value))) {
      return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    }
    return multiply$2(value, -1);
  };
  const calc$2 = Object.assign(
    (x) => ({
      add: (...operands) => calc$2(add$2(x, ...operands)),
      subtract: (...operands) => calc$2(subtract$2(x, ...operands)),
      multiply: (...operands) => calc$2(multiply$2(x, ...operands)),
      divide: (...operands) => calc$2(divide$2(x, ...operands)),
      negate: () => calc$2(negate$2(x)),
      toString: () => x.toString()
    }),
    {
      add: add$2,
      subtract: subtract$2,
      multiply: multiply$2,
      divide: divide$2,
      negate: negate$2
    }
  );

  function replaceWhiteSpace$1(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
  }
  function escape$1(value) {
    const valueStr = replaceWhiteSpace$1(value.toString());
    return escapeSymbol(escapeDot(valueStr));
  }
  function escapeDot(value) {
    if (value.includes("\\."))
      return value;
    const isDecimal = !Number.isInteger(parseFloat(value.toString()));
    return isDecimal ? value.replace(".", `\\.`) : value;
  }
  function escapeSymbol(value) {
    return value.replace(/[!-,/:-@[-^`{-~]/g, "\\$&");
  }
  function addPrefix$1(value, prefix = "") {
    return [prefix, value].filter(Boolean).join("-");
  }
  function toVarReference(name, fallback) {
    return `var(${name}${fallback ? `, ${fallback}` : ""})`;
  }
  function toVarDefinition(value, prefix = "") {
    return escape$1(`--${addPrefix$1(value, prefix)}`);
  }
  function cssVar$1(name, fallback, cssVarPrefix) {
    const cssVariable = toVarDefinition(name, cssVarPrefix);
    return {
      variable: cssVariable,
      reference: toVarReference(cssVariable, fallback)
    };
  }
  function defineCssVars(scope, keys) {
    const vars = {};
    for (const key of keys) {
      if (Array.isArray(key)) {
        const [name, fallback] = key;
        vars[name] = cssVar$1(`${scope}-${name}`, fallback);
        continue;
      }
      vars[key] = cssVar$1(`${scope}-${key}`);
    }
    return vars;
  }

  const tokens = [
    "colors",
    "borders",
    "borderWidths",
    "borderStyles",
    "fonts",
    "fontSizes",
    "fontWeights",
    "gradients",
    "letterSpacings",
    "lineHeights",
    "radii",
    "space",
    "shadows",
    "sizes",
    "zIndices",
    "transition",
    "blur",
    "breakpoints"
  ];
  function extractTokens(theme) {
    const _tokens = tokens;
    return pick(theme, _tokens);
  }
  function extractSemanticTokens(theme) {
    return theme.semanticTokens;
  }
  function omitVars(rawTheme) {
    const { __cssMap, __cssVars, __breakpoints, ...cleanTheme } = rawTheme;
    return cleanTheme;
  }

  function flattenTokens(theme) {
    const tokens = extractTokens(theme);
    const semanticTokens = extractSemanticTokens(theme);
    const isSemanticCondition = (key) => (
      // @ts-ignore
      pseudoPropNames$1.includes(key) || "default" === key
    );
    const result = {};
    walkObject(tokens, (value, path) => {
      if (value == null)
        return;
      result[path.join(".")] = { isSemantic: false, value };
    });
    walkObject(
      semanticTokens,
      (value, path) => {
        if (value == null)
          return;
        result[path.join(".")] = { isSemantic: true, value };
      },
      {
        stop: (value) => Object.keys(value).every(isSemanticCondition)
      }
    );
    return result;
  }

  function tokenToCssVar(token, prefix) {
    return cssVar$1(String(token).replace(/\./g, "-"), void 0, prefix);
  }
  function createThemeVars(theme) {
    const flatTokens = flattenTokens(theme);
    const cssVarPrefix = theme.config?.cssVarPrefix;
    let cssVars = {};
    const cssMap = {};
    function lookupToken(token, maybeToken) {
      const scale = String(token).split(".")[0];
      const withScale = [scale, maybeToken].join(".");
      const resolvedTokenValue = flatTokens[withScale];
      if (!resolvedTokenValue)
        return maybeToken;
      const { reference } = tokenToCssVar(withScale, cssVarPrefix);
      return reference;
    }
    for (const [token, tokenValue] of Object.entries(flatTokens)) {
      const { isSemantic, value } = tokenValue;
      const { variable, reference } = tokenToCssVar(token, cssVarPrefix);
      if (!isSemantic) {
        if (token.startsWith("space")) {
          const keys = token.split(".");
          const [firstKey, ...referenceKeys] = keys;
          const negativeLookupKey = `${firstKey}.-${referenceKeys.join(".")}`;
          const negativeValue = calc$2.negate(value);
          const negatedReference = calc$2.negate(reference);
          cssMap[negativeLookupKey] = {
            value: negativeValue,
            var: variable,
            varRef: negatedReference
          };
        }
        cssVars[variable] = value;
        cssMap[token] = {
          value,
          var: variable,
          varRef: reference
        };
        continue;
      }
      const normalizedValue = isObject$1(value) ? value : { default: value };
      cssVars = mergeWith(
        cssVars,
        Object.entries(normalizedValue).reduce(
          (acc, [conditionAlias, conditionValue]) => {
            if (!conditionValue)
              return acc;
            const tokenReference = lookupToken(token, `${conditionValue}`);
            if (conditionAlias === "default") {
              acc[variable] = tokenReference;
              return acc;
            }
            const conditionSelector = pseudoSelectors$1?.[conditionAlias] ?? conditionAlias;
            acc[conditionSelector] = { [variable]: tokenReference };
            return acc;
          },
          {}
        )
      );
      cssMap[token] = {
        value: reference,
        var: variable,
        varRef: reference
      };
    }
    return {
      cssVars,
      cssMap
    };
  }

  function toCSSVar(rawTheme) {
    const theme = omitVars(rawTheme);
    const {
      /**
       * This is more like a dictionary of tokens users will type `green.500`,
       * and their equivalent css variable.
       */
      cssMap,
      /**
       * The extracted css variables will be stored here, and used in
       * the emotion's <Global/> component to attach variables to `:root`
       */
      cssVars
    } = createThemeVars(theme);
    const defaultCssVars = {
      "--chakra-ring-inset": "var(--chakra-empty,/*!*/ /*!*/)",
      "--chakra-ring-offset-width": "0px",
      "--chakra-ring-offset-color": "#fff",
      "--chakra-ring-color": "rgba(66, 153, 225, 0.6)",
      "--chakra-ring-offset-shadow": "0 0 #0000",
      "--chakra-ring-shadow": "0 0 #0000",
      "--chakra-space-x-reverse": "0",
      "--chakra-space-y-reverse": "0"
    };
    Object.assign(theme, {
      __cssVars: { ...defaultCssVars, ...cssVars },
      __cssMap: cssMap,
      __breakpoints: analyzeBreakpoints(theme.breakpoints)
    });
    return theme;
  }

  function anatomy(name, map = {}) {
    let called = false;
    function assert() {
      if (!called) {
        called = true;
        return;
      }
      throw new Error(
        "[anatomy] .part(...) should only be called once. Did you mean to use .extend(...) ?"
      );
    }
    function parts(...values) {
      assert();
      for (const part of values) {
        map[part] = toPart(part);
      }
      return anatomy(name, map);
    }
    function extend(...parts2) {
      for (const part of parts2) {
        if (part in map)
          continue;
        map[part] = toPart(part);
      }
      return anatomy(name, map);
    }
    function selectors() {
      const value = Object.fromEntries(
        Object.entries(map).map(([key, part]) => [key, part.selector])
      );
      return value;
    }
    function classnames() {
      const value = Object.fromEntries(
        Object.entries(map).map(([key, part]) => [key, part.className])
      );
      return value;
    }
    function toPart(part) {
      const el = ["container", "root"].includes(part ?? "") ? [name] : [name, part];
      const attr = el.filter(Boolean).join("__");
      const className = `chakra-${attr}`;
      const partObj = {
        className,
        selector: `.${className}`,
        toString: () => part
      };
      return partObj;
    }
    const __type = {};
    return {
      parts,
      toPart,
      extend,
      selectors,
      classnames,
      get keys() {
        return Object.keys(map);
      },
      __type
    };
  }

  const accordionAnatomy = anatomy("accordion").parts(
    "root",
    "container",
    "button",
    "panel",
    "icon"
  );
  const alertAnatomy = anatomy("alert").parts(
    "title",
    "description",
    "container",
    "icon",
    "spinner"
  );
  const avatarAnatomy = anatomy("avatar").parts(
    "label",
    "badge",
    "container",
    "excessLabel",
    "group"
  );
  const breadcrumbAnatomy = anatomy("breadcrumb").parts(
    "link",
    "item",
    "container",
    "separator"
  );
  anatomy("button").parts();
  const checkboxAnatomy = anatomy("checkbox").parts(
    "control",
    "icon",
    "container",
    "label"
  );
  anatomy("progress").parts(
    "track",
    "filledTrack",
    "label"
  );
  const drawerAnatomy = anatomy("drawer").parts(
    "overlay",
    "dialogContainer",
    "dialog",
    "header",
    "closeButton",
    "body",
    "footer"
  );
  const editableAnatomy = anatomy("editable").parts(
    "preview",
    "input",
    "textarea"
  );
  const formAnatomy = anatomy("form").parts(
    "container",
    "requiredIndicator",
    "helperText"
  );
  const formErrorAnatomy = anatomy("formError").parts("text", "icon");
  const inputAnatomy = anatomy("input").parts(
    "addon",
    "field",
    "element",
    "group"
  );
  const listAnatomy = anatomy("list").parts("container", "item", "icon");
  const menuAnatomy = anatomy("menu").parts(
    "button",
    "list",
    "item",
    "groupTitle",
    "icon",
    "command",
    "divider"
  );
  const modalAnatomy = anatomy("modal").parts(
    "overlay",
    "dialogContainer",
    "dialog",
    "header",
    "closeButton",
    "body",
    "footer"
  );
  const numberInputAnatomy = anatomy("numberinput").parts(
    "root",
    "field",
    "stepperGroup",
    "stepper"
  );
  anatomy("pininput").parts("field");
  const popoverAnatomy = anatomy("popover").parts(
    "content",
    "header",
    "body",
    "footer",
    "popper",
    "arrow",
    "closeButton"
  );
  const progressAnatomy = anatomy("progress").parts(
    "label",
    "filledTrack",
    "track"
  );
  const radioAnatomy = anatomy("radio").parts(
    "container",
    "control",
    "label"
  );
  const selectAnatomy = anatomy("select").parts("field", "icon");
  const sliderAnatomy = anatomy("slider").parts(
    "container",
    "track",
    "thumb",
    "filledTrack",
    "mark"
  );
  const statAnatomy = anatomy("stat").parts(
    "container",
    "label",
    "helpText",
    "number",
    "icon"
  );
  const switchAnatomy = anatomy("switch").parts(
    "container",
    "track",
    "thumb",
    "label"
  );
  const tableAnatomy = anatomy("table").parts(
    "table",
    "thead",
    "tbody",
    "tr",
    "th",
    "td",
    "tfoot",
    "caption"
  );
  const tabsAnatomy = anatomy("tabs").parts(
    "root",
    "tab",
    "tablist",
    "tabpanel",
    "tabpanels",
    "indicator"
  );
  const tagAnatomy = anatomy("tag").parts(
    "container",
    "label",
    "closeButton"
  );
  const cardAnatomy = anatomy("card").parts(
    "container",
    "header",
    "body",
    "footer"
  );
  anatomy("stepper").parts(
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
  );

  const { definePartsStyle: definePartsStyle$p, defineMultiStyleConfig: defineMultiStyleConfig$p } = createMultiStyleConfigHelpers(accordionAnatomy.keys);
  const baseStyleContainer$4 = defineStyle({
    borderTopWidth: "1px",
    borderColor: "inherit",
    _last: {
      borderBottomWidth: "1px"
    }
  });
  const baseStyleButton$1 = defineStyle({
    transitionProperty: "common",
    transitionDuration: "normal",
    fontSize: "md",
    _focusVisible: {
      boxShadow: "outline"
    },
    _hover: {
      bg: "blackAlpha.50"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    px: "4",
    py: "2"
  });
  const baseStylePanel = defineStyle({
    pt: "2",
    px: "4",
    pb: "5"
  });
  const baseStyleIcon$6 = defineStyle({
    fontSize: "1.25em"
  });
  const baseStyle$G = definePartsStyle$p({
    container: baseStyleContainer$4,
    button: baseStyleButton$1,
    panel: baseStylePanel,
    icon: baseStyleIcon$6
  });
  const accordionTheme = defineMultiStyleConfig$p({ baseStyle: baseStyle$G });

  /**
   * A simple guard function:
   *
   * ```js
   * Math.min(Math.max(low, value), high)
   * ```
   */
  function guard(low, high, value) {
    return Math.min(Math.max(low, value), high);
  }

  class ColorError extends Error {
    constructor(color) {
      super(`Failed to parse color: "${color}"`);
    }
  }
  var ColorError$1 = ColorError;

  /**
   * Parses a color into red, gree, blue, alpha parts
   *
   * @param color the input color. Can be a RGB, RBGA, HSL, HSLA, or named color
   */
  function parseToRgba(color) {
    if (typeof color !== 'string') throw new ColorError$1(color);
    if (color.trim().toLowerCase() === 'transparent') return [0, 0, 0, 0];
    let normalizedColor = color.trim();
    normalizedColor = namedColorRegex.test(color) ? nameToHex(color) : color;
    const reducedHexMatch = reducedHexRegex.exec(normalizedColor);
    if (reducedHexMatch) {
      const arr = Array.from(reducedHexMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(r$1(x, 2), 16)), parseInt(r$1(arr[3] || 'f', 2), 16) / 255];
    }
    const hexMatch = hexRegex.exec(normalizedColor);
    if (hexMatch) {
      const arr = Array.from(hexMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(x, 16)), parseInt(arr[3] || 'ff', 16) / 255];
    }
    const rgbaMatch = rgbaRegex.exec(normalizedColor);
    if (rgbaMatch) {
      const arr = Array.from(rgbaMatch).slice(1);
      return [...arr.slice(0, 3).map(x => parseInt(x, 10)), parseFloat(arr[3] || '1')];
    }
    const hslaMatch = hslaRegex.exec(normalizedColor);
    if (hslaMatch) {
      const [h, s, l, a] = Array.from(hslaMatch).slice(1).map(parseFloat);
      if (guard(0, 100, s) !== s) throw new ColorError$1(color);
      if (guard(0, 100, l) !== l) throw new ColorError$1(color);
      return [...hslToRgb(h, s, l), Number.isNaN(a) ? 1 : a];
    }
    throw new ColorError$1(color);
  }
  function hash$3(str) {
    let hash = 5381;
    let i = str.length;
    while (i) {
      hash = hash * 33 ^ str.charCodeAt(--i);
    }

    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
     * integers. Since we want the results to be always positive, convert the
     * signed int to an unsigned by doing an unsigned bitshift. */
    return (hash >>> 0) % 2341;
  }
  const colorToInt = x => parseInt(x.replace(/_/g, ''), 36);
  const compressedColorMap = '1q29ehhb 1n09sgk7 1kl1ekf_ _yl4zsno 16z9eiv3 1p29lhp8 _bd9zg04 17u0____ _iw9zhe5 _to73___ _r45e31e _7l6g016 _jh8ouiv _zn3qba8 1jy4zshs 11u87k0u 1ro9yvyo 1aj3xael 1gz9zjz0 _3w8l4xo 1bf1ekf_ _ke3v___ _4rrkb__ 13j776yz _646mbhl _nrjr4__ _le6mbhl 1n37ehkb _m75f91n _qj3bzfz 1939yygw 11i5z6x8 _1k5f8xs 1509441m 15t5lwgf _ae2th1n _tg1ugcv 1lp1ugcv 16e14up_ _h55rw7n _ny9yavn _7a11xb_ 1ih442g9 _pv442g9 1mv16xof 14e6y7tu 1oo9zkds 17d1cisi _4v9y70f _y98m8kc 1019pq0v 12o9zda8 _348j4f4 1et50i2o _8epa8__ _ts6senj 1o350i2o 1mi9eiuo 1259yrp0 1ln80gnw _632xcoy 1cn9zldc _f29edu4 1n490c8q _9f9ziet 1b94vk74 _m49zkct 1kz6s73a 1eu9dtog _q58s1rz 1dy9sjiq __u89jo3 _aj5nkwg _ld89jo3 13h9z6wx _qa9z2ii _l119xgq _bs5arju 1hj4nwk9 1qt4nwk9 1ge6wau6 14j9zlcw 11p1edc_ _ms1zcxe _439shk6 _jt9y70f _754zsow 1la40eju _oq5p___ _x279qkz 1fa5r3rv _yd2d9ip _424tcku _8y1di2_ _zi2uabw _yy7rn9h 12yz980_ __39ljp6 1b59zg0x _n39zfzp 1fy9zest _b33k___ _hp9wq92 1il50hz4 _io472ub _lj9z3eo 19z9ykg0 _8t8iu3a 12b9bl4a 1ak5yw0o _896v4ku _tb8k8lv _s59zi6t _c09ze0p 1lg80oqn 1id9z8wb _238nba5 1kq6wgdi _154zssg _tn3zk49 _da9y6tc 1sg7cv4f _r12jvtt 1gq5fmkz 1cs9rvci _lp9jn1c _xw1tdnb 13f9zje6 16f6973h _vo7ir40 _bt5arjf _rc45e4t _hr4e100 10v4e100 _hc9zke2 _w91egv_ _sj2r1kk 13c87yx8 _vqpds__ _ni8ggk8 _tj9yqfb 1ia2j4r4 _7x9b10u 1fc9ld4j 1eq9zldr _5j9lhpx _ez9zl6o _md61fzm'.split(' ').reduce((acc, next) => {
    const key = colorToInt(next.substring(0, 3));
    const hex = colorToInt(next.substring(3)).toString(16);

    // NOTE: padStart could be used here but it breaks Node 6 compat
    // https://github.com/ricokahler/color2k/issues/351
    let prefix = '';
    for (let i = 0; i < 6 - hex.length; i++) {
      prefix += '0';
    }
    acc[key] = `${prefix}${hex}`;
    return acc;
  }, {});

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   */
  function nameToHex(color) {
    const normalizedColorName = color.toLowerCase().trim();
    const result = compressedColorMap[hash$3(normalizedColorName)];
    if (!result) throw new ColorError$1(color);
    return `#${result}`;
  }
  const r$1 = (str, amount) => Array.from(Array(amount)).map(() => str).join('');
  const reducedHexRegex = new RegExp(`^#${r$1('([a-f0-9])', 3)}([a-f0-9])?$`, 'i');
  const hexRegex = new RegExp(`^#${r$1('([a-f0-9]{2})', 3)}([a-f0-9]{2})?$`, 'i');
  const rgbaRegex = new RegExp(`^rgba?\\(\\s*(\\d+)\\s*${r$1(',\\s*(\\d+)\\s*', 2)}(?:,\\s*([\\d.]+))?\\s*\\)$`, 'i');
  const hslaRegex = /^hsla?\(\s*([\d.]+)\s*,\s*([\d.]+)%\s*,\s*([\d.]+)%(?:\s*,\s*([\d.]+))?\s*\)$/i;
  const namedColorRegex = /^[a-z]+$/i;
  const roundColor = color => {
    return Math.round(color * 255);
  };
  const hslToRgb = (hue, saturation, lightness) => {
    let l = lightness / 100;
    if (saturation === 0) {
      // achromatic
      return [l, l, l].map(roundColor);
    }

    // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
    const huePrime = (hue % 360 + 360) % 360 / 60;
    const chroma = (1 - Math.abs(2 * l - 1)) * (saturation / 100);
    const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
    let red = 0;
    let green = 0;
    let blue = 0;
    if (huePrime >= 0 && huePrime < 1) {
      red = chroma;
      green = secondComponent;
    } else if (huePrime >= 1 && huePrime < 2) {
      red = secondComponent;
      green = chroma;
    } else if (huePrime >= 2 && huePrime < 3) {
      green = chroma;
      blue = secondComponent;
    } else if (huePrime >= 3 && huePrime < 4) {
      green = secondComponent;
      blue = chroma;
    } else if (huePrime >= 4 && huePrime < 5) {
      red = secondComponent;
      blue = chroma;
    } else if (huePrime >= 5 && huePrime < 6) {
      red = chroma;
      blue = secondComponent;
    }
    const lightnessModification = l - chroma / 2;
    const finalRed = red + lightnessModification;
    const finalGreen = green + lightnessModification;
    const finalBlue = blue + lightnessModification;
    return [finalRed, finalGreen, finalBlue].map(roundColor);
  };

  /**
   * Takes in rgba parts and returns an rgba string
   *
   * @param red The amount of red in the red channel, given in a number between 0 and 255 inclusive
   * @param green The amount of green in the red channel, given in a number between 0 and 255 inclusive
   * @param blue The amount of blue in the red channel, given in a number between 0 and 255 inclusive
   * @param alpha Percentage of opacity, given as a decimal between 0 and 1
   */
  function rgba$1(red, green, blue, alpha) {
    return `rgba(${guard(0, 255, red).toFixed()}, ${guard(0, 255, green).toFixed()}, ${guard(0, 255, blue).toFixed()}, ${parseFloat(guard(0, 1, alpha).toFixed(3))})`;
  }

  /**
   * Takes in a color and makes it more transparent by convert to `rgba` and
   * decreasing the amount in the alpha channel.
   *
   * @param amount The amount to increase the transparency by, given as a decimal between 0 and 1
   */
  function transparentize$1(color, amount) {
    const [r, g, b, a] = parseToRgba(color);
    return rgba$1(r, g, b, a - amount);
  }

  /**
   * Takes in any color and returns it as a hex code.
   */
  function toHex(color) {
    const [r, g, b, a] = parseToRgba(color);
    let hex = x => {
      const h = guard(0, 255, x).toString(16);
      // NOTE: padStart could be used here but it breaks Node 6 compat
      // https://github.com/ricokahler/color2k/issues/351
      return h.length === 1 ? `0${h}` : h;
    };
    return `#${hex(r)}${hex(g)}${hex(b)}${a < 1 ? hex(Math.round(a * 255)) : ''}`;
  }

  const isEmptyObject = (obj) => Object.keys(obj).length === 0;
  function get$1(obj, key, def, p, undef) {
    key = key.split ? key.split(".") : key;
    for (p = 0; p < key.length; p++) {
      obj = obj ? obj[key[p]] : undef;
    }
    return obj === undef ? def : obj;
  }
  const getColor = (theme, color, fallback) => {
    const hex = get$1(theme, `colors.${color}`, color);
    try {
      toHex(hex);
      return hex;
    } catch {
      return "#000000";
    }
  };
  const getBrightness = (color) => {
    const [r, g, b] = parseToRgba(color);
    return (r * 299 + g * 587 + b * 114) / 1e3;
  };
  const tone = (color) => (theme) => {
    const hex = getColor(theme, color);
    const brightness = getBrightness(hex);
    const isDark2 = brightness < 128;
    return isDark2 ? "dark" : "light";
  };
  const isDark = (color) => (theme) => tone(color)(theme) === "dark";
  const transparentize = (color, opacity) => (theme) => {
    const raw = getColor(theme, color);
    return transparentize$1(raw, 1 - opacity);
  };
  function generateStripe(size = "1rem", color = "rgba(255, 255, 255, 0.15)") {
    return {
      backgroundImage: `linear-gradient(
    45deg,
    ${color} 25%,
    transparent 25%,
    transparent 50%,
    ${color} 50%,
    ${color} 75%,
    transparent 75%,
    transparent
  )`,
      backgroundSize: `${size} ${size}`
    };
  }
  const randomHex = () => `#${Math.floor(Math.random() * 16777215).toString(16).padEnd(6, "0")}`;
  function randomColor(opts) {
    const fallback = randomHex();
    if (!opts || isEmptyObject(opts)) {
      return fallback;
    }
    if (opts.string && opts.colors) {
      return randomColorFromList(opts.string, opts.colors);
    }
    if (opts.string && !opts.colors) {
      return randomColorFromString(opts.string);
    }
    if (opts.colors && !opts.string) {
      return randomFromList(opts.colors);
    }
    return fallback;
  }
  function randomColorFromString(str) {
    let hash = 0;
    if (str.length === 0)
      return hash.toString();
    for (let i = 0; i < str.length; i += 1) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
      hash = hash & hash;
    }
    let color = "#";
    for (let j = 0; j < 3; j += 1) {
      const value = hash >> j * 8 & 255;
      color += `00${value.toString(16)}`.substr(-2);
    }
    return color;
  }
  function randomColorFromList(str, list) {
    let index = 0;
    if (str.length === 0)
      return list[0];
    for (let i = 0; i < str.length; i += 1) {
      index = str.charCodeAt(i) + ((index << 5) - index);
      index = index & index;
    }
    index = (index % list.length + list.length) % list.length;
    return list[index];
  }
  function randomFromList(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function mode(light, dark) {
    return (props) => props.colorMode === "dark" ? dark : light;
  }
  function orient(options) {
    const { orientation, vertical, horizontal } = options;
    if (!orientation)
      return {};
    return orientation === "vertical" ? vertical : horizontal;
  }

  function toRef(operand) {
    if (isObject$1(operand) && operand.reference) {
      return operand.reference;
    }
    return String(operand);
  }
  const toExpr = (operator, ...operands) => operands.map(toRef).join(` ${operator} `).replace(/calc/g, "");
  const add$1 = (...operands) => `calc(${toExpr("+", ...operands)})`;
  const subtract$1 = (...operands) => `calc(${toExpr("-", ...operands)})`;
  const multiply$1 = (...operands) => `calc(${toExpr("*", ...operands)})`;
  const divide$1 = (...operands) => `calc(${toExpr("/", ...operands)})`;
  const negate$1 = (x) => {
    const value = toRef(x);
    if (value != null && !Number.isNaN(parseFloat(value))) {
      return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    }
    return multiply$1(value, -1);
  };
  const calc$1 = Object.assign(
    (x) => ({
      add: (...operands) => calc$1(add$1(x, ...operands)),
      subtract: (...operands) => calc$1(subtract$1(x, ...operands)),
      multiply: (...operands) => calc$1(multiply$1(x, ...operands)),
      divide: (...operands) => calc$1(divide$1(x, ...operands)),
      negate: () => calc$1(negate$1(x)),
      toString: () => x.toString()
    }),
    {
      add: add$1,
      subtract: subtract$1,
      multiply: multiply$1,
      divide: divide$1,
      negate: negate$1
    }
  );

  function isDecimal(value) {
    return !Number.isInteger(parseFloat(value.toString()));
  }
  function replaceWhiteSpace(value, replaceValue = "-") {
    return value.replace(/\s+/g, replaceValue);
  }
  function escape(value) {
    const valueStr = replaceWhiteSpace(value.toString());
    if (valueStr.includes("\\."))
      return value;
    return isDecimal(value) ? valueStr.replace(".", `\\.`) : value;
  }
  function addPrefix(value, prefix = "") {
    return [prefix, escape(value)].filter(Boolean).join("-");
  }
  function toVarRef(name, fallback) {
    return `var(${escape(name)}${fallback ? `, ${fallback}` : ""})`;
  }
  function toVar$1(value, prefix = "") {
    return `--${addPrefix(value, prefix)}`;
  }
  function cssVar(name, options) {
    const cssVariable = toVar$1(name, options?.prefix);
    return {
      variable: cssVariable,
      reference: toVarRef(cssVariable, getFallback(options?.fallback))
    };
  }
  function getFallback(fallback) {
    return fallback?.reference;
  }

  const { definePartsStyle: definePartsStyle$o, defineMultiStyleConfig: defineMultiStyleConfig$o } = createMultiStyleConfigHelpers(alertAnatomy.keys);
  const $fg$5 = cssVar$1("alert-fg");
  const $bg$f = cssVar$1("alert-bg");
  const baseStyle$F = definePartsStyle$o({
    container: {
      bg: $bg$f.reference,
      px: "4",
      py: "3"
    },
    title: {
      fontWeight: "bold",
      lineHeight: "6",
      marginEnd: "2"
    },
    description: {
      lineHeight: "6"
    },
    icon: {
      color: $fg$5.reference,
      flexShrink: 0,
      marginEnd: "3",
      w: "5",
      h: "6"
    },
    spinner: {
      color: $fg$5.reference,
      flexShrink: 0,
      marginEnd: "3",
      w: "5",
      h: "5"
    }
  });
  function getBg(props) {
    const { theme, colorScheme: c } = props;
    const darkBg = transparentize(`${c}.200`, 0.16)(theme);
    return {
      light: `colors.${c}.100`,
      dark: darkBg
    };
  }
  const variantSubtle$1 = definePartsStyle$o((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg$5.variable]: `colors.${c}.600`,
        [$bg$f.variable]: bg.light,
        _dark: {
          [$fg$5.variable]: `colors.${c}.200`,
          [$bg$f.variable]: bg.dark
        }
      }
    };
  });
  const variantLeftAccent = definePartsStyle$o((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg$5.variable]: `colors.${c}.600`,
        [$bg$f.variable]: bg.light,
        _dark: {
          [$fg$5.variable]: `colors.${c}.200`,
          [$bg$f.variable]: bg.dark
        },
        paddingStart: "3",
        borderStartWidth: "4px",
        borderStartColor: $fg$5.reference
      }
    };
  });
  const variantTopAccent = definePartsStyle$o((props) => {
    const { colorScheme: c } = props;
    const bg = getBg(props);
    return {
      container: {
        [$fg$5.variable]: `colors.${c}.600`,
        [$bg$f.variable]: bg.light,
        _dark: {
          [$fg$5.variable]: `colors.${c}.200`,
          [$bg$f.variable]: bg.dark
        },
        pt: "2",
        borderTopWidth: "4px",
        borderTopColor: $fg$5.reference
      }
    };
  });
  const variantSolid$3 = definePartsStyle$o((props) => {
    const { colorScheme: c } = props;
    return {
      container: {
        [$fg$5.variable]: `colors.white`,
        [$bg$f.variable]: `colors.${c}.600`,
        _dark: {
          [$fg$5.variable]: `colors.gray.900`,
          [$bg$f.variable]: `colors.${c}.200`
        },
        color: $fg$5.reference
      }
    };
  });
  const variants$e = {
    subtle: variantSubtle$1,
    "left-accent": variantLeftAccent,
    "top-accent": variantTopAccent,
    solid: variantSolid$3
  };
  const alertTheme = defineMultiStyleConfig$o({
    baseStyle: baseStyle$F,
    variants: variants$e,
    defaultProps: {
      variant: "subtle",
      colorScheme: "blue"
    }
  });

  const spacing = {
    px: "1px",
    0.5: "0.125rem",
    1: "0.25rem",
    1.5: "0.375rem",
    2: "0.5rem",
    2.5: "0.625rem",
    3: "0.75rem",
    3.5: "0.875rem",
    4: "1rem",
    5: "1.25rem",
    6: "1.5rem",
    7: "1.75rem",
    8: "2rem",
    9: "2.25rem",
    10: "2.5rem",
    12: "3rem",
    14: "3.5rem",
    16: "4rem",
    20: "5rem",
    24: "6rem",
    28: "7rem",
    32: "8rem",
    36: "9rem",
    40: "10rem",
    44: "11rem",
    48: "12rem",
    52: "13rem",
    56: "14rem",
    60: "15rem",
    64: "16rem",
    72: "18rem",
    80: "20rem",
    96: "24rem"
  };

  const largeSizes = {
    max: "max-content",
    min: "min-content",
    full: "100%",
    "3xs": "14rem",
    "2xs": "16rem",
    xs: "20rem",
    sm: "24rem",
    md: "28rem",
    lg: "32rem",
    xl: "36rem",
    "2xl": "42rem",
    "3xl": "48rem",
    "4xl": "56rem",
    "5xl": "64rem",
    "6xl": "72rem",
    "7xl": "80rem",
    "8xl": "90rem",
    prose: "60ch"
  };
  const container = {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px"
  };
  const sizes$m = {
    ...spacing,
    ...largeSizes,
    container
  };

  const isFunction$3 = (value) => typeof value === "function";
  function runIfFn$2(valueOrFn, ...args) {
    return isFunction$3(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }

  const { definePartsStyle: definePartsStyle$n, defineMultiStyleConfig: defineMultiStyleConfig$n } = createMultiStyleConfigHelpers(avatarAnatomy.keys);
  const $border$3 = cssVar$1("avatar-border-color");
  const $bg$e = cssVar$1("avatar-bg");
  const $fs = cssVar$1("avatar-font-size");
  const $size$4 = cssVar$1("avatar-size");
  const baseStyleBadge = defineStyle({
    borderRadius: "full",
    border: "0.2em solid",
    borderColor: $border$3.reference,
    [$border$3.variable]: "white",
    _dark: {
      [$border$3.variable]: "colors.gray.800"
    }
  });
  const baseStyleExcessLabel = defineStyle({
    bg: $bg$e.reference,
    fontSize: $fs.reference,
    width: $size$4.reference,
    height: $size$4.reference,
    lineHeight: "1",
    [$bg$e.variable]: "colors.gray.200",
    _dark: {
      [$bg$e.variable]: "colors.whiteAlpha.400"
    }
  });
  const baseStyleContainer$3 = defineStyle((props) => {
    const { name, theme } = props;
    const bg = name ? randomColor({ string: name }) : "colors.gray.400";
    const isBgDark = isDark(bg)(theme);
    let color = "white";
    if (!isBgDark)
      color = "gray.800";
    return {
      bg: $bg$e.reference,
      fontSize: $fs.reference,
      color,
      borderColor: $border$3.reference,
      verticalAlign: "top",
      width: $size$4.reference,
      height: $size$4.reference,
      "&:not([data-loaded])": {
        [$bg$e.variable]: bg
      },
      [$border$3.variable]: "colors.white",
      _dark: {
        [$border$3.variable]: "colors.gray.800"
      }
    };
  });
  const baseStyleLabel$4 = defineStyle({
    fontSize: $fs.reference,
    lineHeight: "1"
  });
  const baseStyle$E = definePartsStyle$n((props) => ({
    badge: runIfFn$2(baseStyleBadge, props),
    excessLabel: runIfFn$2(baseStyleExcessLabel, props),
    container: runIfFn$2(baseStyleContainer$3, props),
    label: baseStyleLabel$4
  }));
  function getSize$3(size) {
    const themeSize = size !== "100%" ? sizes$m[size] : void 0;
    return definePartsStyle$n({
      container: {
        [$size$4.variable]: themeSize ?? size,
        [$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
      },
      excessLabel: {
        [$size$4.variable]: themeSize ?? size,
        [$fs.variable]: `calc(${themeSize ?? size} / 2.5)`
      }
    });
  }
  const sizes$l = {
    "2xs": getSize$3(4),
    xs: getSize$3(6),
    sm: getSize$3(8),
    md: getSize$3(12),
    lg: getSize$3(16),
    xl: getSize$3(24),
    "2xl": getSize$3(32),
    full: getSize$3("100%")
  };
  const avatarTheme = defineMultiStyleConfig$n({
    baseStyle: baseStyle$E,
    sizes: sizes$l,
    defaultProps: {
      size: "md"
    }
  });

  const vars = defineCssVars("badge", ["bg", "color", "shadow"]);
  const baseStyle$D = defineStyle({
    px: 1,
    textTransform: "uppercase",
    fontSize: "xs",
    borderRadius: "sm",
    fontWeight: "bold",
    bg: vars.bg.reference,
    color: vars.color.reference,
    boxShadow: vars.shadow.reference
  });
  const variantSolid$2 = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const dark = transparentize(`${c}.500`, 0.6)(theme);
    return {
      [vars.bg.variable]: `colors.${c}.500`,
      [vars.color.variable]: `colors.white`,
      _dark: {
        [vars.bg.variable]: dark,
        [vars.color.variable]: `colors.whiteAlpha.800`
      }
    };
  });
  const variantSubtle = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const darkBg = transparentize(`${c}.200`, 0.16)(theme);
    return {
      [vars.bg.variable]: `colors.${c}.100`,
      [vars.color.variable]: `colors.${c}.800`,
      _dark: {
        [vars.bg.variable]: darkBg,
        [vars.color.variable]: `colors.${c}.200`
      }
    };
  });
  const variantOutline$2 = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    const darkColor = transparentize(`${c}.200`, 0.8)(theme);
    return {
      [vars.color.variable]: `colors.${c}.500`,
      _dark: {
        [vars.color.variable]: darkColor
      },
      [vars.shadow.variable]: `inset 0 0 0px 1px ${vars.color.reference}`
    };
  });
  const variants$d = {
    solid: variantSolid$2,
    subtle: variantSubtle,
    outline: variantOutline$2
  };
  const badgeTheme = defineStyleConfig({
    baseStyle: baseStyle$D,
    variants: variants$d,
    defaultProps: {
      variant: "subtle",
      colorScheme: "gray"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$m, definePartsStyle: definePartsStyle$m } = createMultiStyleConfigHelpers(breadcrumbAnatomy.keys);
  const $decor = cssVar$1("breadcrumb-link-decor");
  const baseStyleLink = defineStyle({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    outline: "none",
    color: "inherit",
    textDecoration: $decor.reference,
    [$decor.variable]: "none",
    "&:not([aria-current=page])": {
      cursor: "pointer",
      _hover: {
        [$decor.variable]: "underline"
      },
      _focusVisible: {
        boxShadow: "outline"
      }
    }
  });
  const baseStyle$C = definePartsStyle$m({
    link: baseStyleLink
  });
  const breadcrumbTheme = defineMultiStyleConfig$m({
    baseStyle: baseStyle$C
  });

  const baseStyle$B = defineStyle({
    lineHeight: "1.2",
    borderRadius: "md",
    fontWeight: "semibold",
    transitionProperty: "common",
    transitionDuration: "normal",
    _focusVisible: {
      boxShadow: "outline"
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      _disabled: {
        bg: "initial"
      }
    }
  });
  const variantGhost = defineStyle((props) => {
    const { colorScheme: c, theme } = props;
    if (c === "gray") {
      return {
        color: mode(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
          bg: mode(`gray.100`, `whiteAlpha.200`)(props)
        },
        _active: { bg: mode(`gray.200`, `whiteAlpha.300`)(props) }
      };
    }
    const darkHoverBg = transparentize(`${c}.200`, 0.12)(theme);
    const darkActiveBg = transparentize(`${c}.200`, 0.24)(theme);
    return {
      color: mode(`${c}.600`, `${c}.200`)(props),
      bg: "transparent",
      _hover: {
        bg: mode(`${c}.50`, darkHoverBg)(props)
      },
      _active: {
        bg: mode(`${c}.100`, darkActiveBg)(props)
      }
    };
  });
  const variantOutline$1 = defineStyle((props) => {
    const { colorScheme: c } = props;
    const borderColor = mode(`gray.200`, `whiteAlpha.300`)(props);
    return {
      border: "1px solid",
      borderColor: c === "gray" ? borderColor : "currentColor",
      ".chakra-button__group[data-attached][data-orientation=horizontal] > &:not(:last-of-type)": { marginEnd: "-1px" },
      ".chakra-button__group[data-attached][data-orientation=vertical] > &:not(:last-of-type)": { marginBottom: "-1px" },
      ...runIfFn$2(variantGhost, props)
    };
  });
  const accessibleColorMap = {
    yellow: {
      bg: "yellow.400",
      color: "black",
      hoverBg: "yellow.500",
      activeBg: "yellow.600"
    },
    cyan: {
      bg: "cyan.400",
      color: "black",
      hoverBg: "cyan.500",
      activeBg: "cyan.600"
    }
  };
  const variantSolid$1 = defineStyle((props) => {
    const { colorScheme: c } = props;
    if (c === "gray") {
      const bg2 = mode(`gray.100`, `whiteAlpha.200`)(props);
      return {
        bg: bg2,
        color: mode(`gray.800`, `whiteAlpha.900`)(props),
        _hover: {
          bg: mode(`gray.200`, `whiteAlpha.300`)(props),
          _disabled: {
            bg: bg2
          }
        },
        _active: { bg: mode(`gray.300`, `whiteAlpha.400`)(props) }
      };
    }
    const {
      bg = `${c}.500`,
      color = "white",
      hoverBg = `${c}.600`,
      activeBg = `${c}.700`
    } = accessibleColorMap[c] ?? {};
    const background = mode(bg, `${c}.200`)(props);
    return {
      bg: background,
      color: mode(color, `gray.800`)(props),
      _hover: {
        bg: mode(hoverBg, `${c}.300`)(props),
        _disabled: {
          bg: background
        }
      },
      _active: { bg: mode(activeBg, `${c}.400`)(props) }
    };
  });
  const variantLink = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      padding: 0,
      height: "auto",
      lineHeight: "normal",
      verticalAlign: "baseline",
      color: mode(`${c}.500`, `${c}.200`)(props),
      _hover: {
        textDecoration: "underline",
        _disabled: {
          textDecoration: "none"
        }
      },
      _active: {
        color: mode(`${c}.700`, `${c}.500`)(props)
      }
    };
  });
  const variantUnstyled$2 = defineStyle({
    bg: "none",
    color: "inherit",
    display: "inline",
    lineHeight: "inherit",
    m: "0",
    p: "0"
  });
  const variants$c = {
    ghost: variantGhost,
    outline: variantOutline$1,
    solid: variantSolid$1,
    link: variantLink,
    unstyled: variantUnstyled$2
  };
  const sizes$k = {
    lg: defineStyle({
      h: "12",
      minW: "12",
      fontSize: "lg",
      px: "6"
    }),
    md: defineStyle({
      h: "10",
      minW: "10",
      fontSize: "md",
      px: "4"
    }),
    sm: defineStyle({
      h: "8",
      minW: "8",
      fontSize: "sm",
      px: "3"
    }),
    xs: defineStyle({
      h: "6",
      minW: "6",
      fontSize: "xs",
      px: "2"
    })
  };
  const buttonTheme = defineStyleConfig({
    baseStyle: baseStyle$B,
    variants: variants$c,
    sizes: sizes$k,
    defaultProps: {
      variant: "solid",
      size: "md",
      colorScheme: "gray"
    }
  });

  const { definePartsStyle: definePartsStyle$l, defineMultiStyleConfig: defineMultiStyleConfig$l } = createMultiStyleConfigHelpers(cardAnatomy.keys);
  const $bg$d = cssVar$1("card-bg");
  const $padding$1 = cssVar$1("card-padding");
  const $shadow$3 = cssVar$1("card-shadow");
  const $radius = cssVar$1("card-radius");
  const $border$2 = cssVar$1("card-border-width", "0");
  const $borderColor = cssVar$1("card-border-color");
  const baseStyle$A = definePartsStyle$l({
    container: {
      [$bg$d.variable]: "colors.chakra-body-bg",
      backgroundColor: $bg$d.reference,
      boxShadow: $shadow$3.reference,
      borderRadius: $radius.reference,
      color: "chakra-body-text",
      borderWidth: $border$2.reference,
      borderColor: $borderColor.reference
    },
    body: {
      padding: $padding$1.reference,
      flex: "1 1 0%"
    },
    header: {
      padding: $padding$1.reference
    },
    footer: {
      padding: $padding$1.reference
    }
  });
  const sizes$j = {
    sm: definePartsStyle$l({
      container: {
        [$radius.variable]: "radii.base",
        [$padding$1.variable]: "space.3"
      }
    }),
    md: definePartsStyle$l({
      container: {
        [$radius.variable]: "radii.md",
        [$padding$1.variable]: "space.5"
      }
    }),
    lg: definePartsStyle$l({
      container: {
        [$radius.variable]: "radii.xl",
        [$padding$1.variable]: "space.7"
      }
    })
  };
  const variants$b = {
    elevated: definePartsStyle$l({
      container: {
        [$shadow$3.variable]: "shadows.base",
        _dark: {
          [$bg$d.variable]: "colors.gray.700"
        }
      }
    }),
    outline: definePartsStyle$l({
      container: {
        [$border$2.variable]: "1px",
        [$borderColor.variable]: "colors.chakra-border-color"
      }
    }),
    filled: definePartsStyle$l({
      container: {
        [$bg$d.variable]: "colors.chakra-subtle-bg"
      }
    }),
    unstyled: {
      body: {
        [$padding$1.variable]: 0
      },
      header: {
        [$padding$1.variable]: 0
      },
      footer: {
        [$padding$1.variable]: 0
      }
    }
  };
  const cardTheme = defineMultiStyleConfig$l({
    baseStyle: baseStyle$A,
    variants: variants$b,
    sizes: sizes$j,
    defaultProps: {
      variant: "elevated",
      size: "md"
    }
  });

  const { definePartsStyle: definePartsStyle$k, defineMultiStyleConfig: defineMultiStyleConfig$k } = createMultiStyleConfigHelpers(checkboxAnatomy.keys);
  const $size$3 = cssVar$1("checkbox-size");
  const baseStyleControl$1 = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      w: $size$3.reference,
      h: $size$3.reference,
      transitionProperty: "box-shadow",
      transitionDuration: "normal",
      border: "2px solid",
      borderRadius: "sm",
      borderColor: "inherit",
      color: "white",
      _checked: {
        bg: mode(`${c}.500`, `${c}.200`)(props),
        borderColor: mode(`${c}.500`, `${c}.200`)(props),
        color: mode("white", "gray.900")(props),
        _hover: {
          bg: mode(`${c}.600`, `${c}.300`)(props),
          borderColor: mode(`${c}.600`, `${c}.300`)(props)
        },
        _disabled: {
          borderColor: mode("gray.200", "transparent")(props),
          bg: mode("gray.200", "whiteAlpha.300")(props),
          color: mode("gray.500", "whiteAlpha.500")(props)
        }
      },
      _indeterminate: {
        bg: mode(`${c}.500`, `${c}.200`)(props),
        borderColor: mode(`${c}.500`, `${c}.200`)(props),
        color: mode("white", "gray.900")(props)
      },
      _disabled: {
        bg: mode("gray.100", "whiteAlpha.100")(props),
        borderColor: mode("gray.100", "transparent")(props)
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _invalid: {
        borderColor: mode("red.500", "red.300")(props)
      }
    };
  });
  const baseStyleContainer$2 = defineStyle({
    _disabled: { cursor: "not-allowed" }
  });
  const baseStyleLabel$3 = defineStyle({
    userSelect: "none",
    _disabled: { opacity: 0.4 }
  });
  const baseStyleIcon$5 = defineStyle({
    transitionProperty: "transform",
    transitionDuration: "normal"
  });
  const baseStyle$z = definePartsStyle$k((props) => ({
    icon: baseStyleIcon$5,
    container: baseStyleContainer$2,
    control: runIfFn$2(baseStyleControl$1, props),
    label: baseStyleLabel$3
  }));
  const sizes$i = {
    sm: definePartsStyle$k({
      control: { [$size$3.variable]: "sizes.3" },
      label: { fontSize: "sm" },
      icon: { fontSize: "3xs" }
    }),
    md: definePartsStyle$k({
      control: { [$size$3.variable]: "sizes.4" },
      label: { fontSize: "md" },
      icon: { fontSize: "2xs" }
    }),
    lg: definePartsStyle$k({
      control: { [$size$3.variable]: "sizes.5" },
      label: { fontSize: "lg" },
      icon: { fontSize: "2xs" }
    })
  };
  const checkboxTheme = defineMultiStyleConfig$k({
    baseStyle: baseStyle$z,
    sizes: sizes$i,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const $size$2 = cssVar("close-button-size");
  const $bg$c = cssVar("close-button-bg");
  const baseStyle$y = defineStyle({
    w: [$size$2.reference],
    h: [$size$2.reference],
    borderRadius: "md",
    transitionProperty: "common",
    transitionDuration: "normal",
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed",
      boxShadow: "none"
    },
    _hover: {
      [$bg$c.variable]: "colors.blackAlpha.100",
      _dark: {
        [$bg$c.variable]: "colors.whiteAlpha.100"
      }
    },
    _active: {
      [$bg$c.variable]: "colors.blackAlpha.200",
      _dark: {
        [$bg$c.variable]: "colors.whiteAlpha.200"
      }
    },
    _focusVisible: {
      boxShadow: "outline"
    },
    bg: $bg$c.reference
  });
  const sizes$h = {
    lg: defineStyle({
      [$size$2.variable]: "sizes.10",
      fontSize: "md"
    }),
    md: defineStyle({
      [$size$2.variable]: "sizes.8",
      fontSize: "xs"
    }),
    sm: defineStyle({
      [$size$2.variable]: "sizes.6",
      fontSize: "2xs"
    })
  };
  const closeButtonTheme = defineStyleConfig({
    baseStyle: baseStyle$y,
    sizes: sizes$h,
    defaultProps: {
      size: "md"
    }
  });

  const { variants: variants$a, defaultProps } = badgeTheme;
  const baseStyle$x = defineStyle({
    fontFamily: "mono",
    fontSize: "sm",
    px: "0.2em",
    borderRadius: "sm",
    bg: vars.bg.reference,
    color: vars.color.reference,
    boxShadow: vars.shadow.reference
  });
  const codeTheme = defineStyleConfig({
    baseStyle: baseStyle$x,
    variants: variants$a,
    defaultProps
  });

  const baseStyle$w = defineStyle({
    w: "100%",
    mx: "auto",
    maxW: "prose",
    px: "4"
  });
  const containerTheme = defineStyleConfig({
    baseStyle: baseStyle$w
  });

  const baseStyle$v = defineStyle({
    opacity: 0.6,
    borderColor: "inherit"
  });
  const variantSolid = defineStyle({
    borderStyle: "solid"
  });
  const variantDashed = defineStyle({
    borderStyle: "dashed"
  });
  const variants$9 = {
    solid: variantSolid,
    dashed: variantDashed
  };
  const dividerTheme = defineStyleConfig({
    baseStyle: baseStyle$v,
    variants: variants$9,
    defaultProps: {
      variant: "solid"
    }
  });

  const { definePartsStyle: definePartsStyle$j, defineMultiStyleConfig: defineMultiStyleConfig$j } = createMultiStyleConfigHelpers(drawerAnatomy.keys);
  const $bg$b = cssVar$1("drawer-bg");
  const $bs = cssVar$1("drawer-box-shadow");
  function getSize$2(value) {
    if (value === "full") {
      return definePartsStyle$j({
        dialog: { maxW: "100vw", h: "100vh" }
      });
    }
    return definePartsStyle$j({
      dialog: { maxW: value }
    });
  }
  const baseStyleOverlay$1 = defineStyle({
    bg: "blackAlpha.600",
    zIndex: "modal"
  });
  const baseStyleDialogContainer$1 = defineStyle({
    display: "flex",
    zIndex: "modal",
    justifyContent: "center"
  });
  const baseStyleDialog$1 = defineStyle((props) => {
    const { isFullHeight } = props;
    return {
      ...isFullHeight && { height: "100vh" },
      zIndex: "modal",
      maxH: "100vh",
      color: "inherit",
      [$bg$b.variable]: "colors.white",
      [$bs.variable]: "shadows.lg",
      _dark: {
        [$bg$b.variable]: "colors.gray.700",
        [$bs.variable]: "shadows.dark-lg"
      },
      bg: $bg$b.reference,
      boxShadow: $bs.reference
    };
  });
  const baseStyleHeader$2 = defineStyle({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
  });
  const baseStyleCloseButton$3 = defineStyle({
    position: "absolute",
    top: "2",
    insetEnd: "3"
  });
  const baseStyleBody$2 = defineStyle({
    px: "6",
    py: "2",
    flex: "1",
    overflow: "auto"
  });
  const baseStyleFooter$2 = defineStyle({
    px: "6",
    py: "4"
  });
  const baseStyle$u = definePartsStyle$j((props) => ({
    overlay: baseStyleOverlay$1,
    dialogContainer: baseStyleDialogContainer$1,
    dialog: runIfFn$2(baseStyleDialog$1, props),
    header: baseStyleHeader$2,
    closeButton: baseStyleCloseButton$3,
    body: baseStyleBody$2,
    footer: baseStyleFooter$2
  }));
  const sizes$g = {
    xs: getSize$2("xs"),
    sm: getSize$2("md"),
    md: getSize$2("lg"),
    lg: getSize$2("2xl"),
    xl: getSize$2("4xl"),
    full: getSize$2("full")
  };
  const drawerTheme = defineMultiStyleConfig$j({
    baseStyle: baseStyle$u,
    sizes: sizes$g,
    defaultProps: {
      size: "xs"
    }
  });

  const { definePartsStyle: definePartsStyle$i, defineMultiStyleConfig: defineMultiStyleConfig$i } = createMultiStyleConfigHelpers(editableAnatomy.keys);
  const baseStylePreview = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal"
  });
  const baseStyleInput = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: { boxShadow: "outline" },
    _placeholder: { opacity: 0.6 }
  });
  const baseStyleTextarea = defineStyle({
    borderRadius: "md",
    py: "1",
    transitionProperty: "common",
    transitionDuration: "normal",
    width: "full",
    _focusVisible: { boxShadow: "outline" },
    _placeholder: { opacity: 0.6 }
  });
  const baseStyle$t = definePartsStyle$i({
    preview: baseStylePreview,
    input: baseStyleInput,
    textarea: baseStyleTextarea
  });
  const editableTheme = defineMultiStyleConfig$i({
    baseStyle: baseStyle$t
  });

  const { definePartsStyle: definePartsStyle$h, defineMultiStyleConfig: defineMultiStyleConfig$h } = createMultiStyleConfigHelpers(formAnatomy.keys);
  const $fg$4 = cssVar$1("form-control-color");
  const baseStyleRequiredIndicator = defineStyle({
    marginStart: "1",
    [$fg$4.variable]: "colors.red.500",
    _dark: {
      [$fg$4.variable]: "colors.red.300"
    },
    color: $fg$4.reference
  });
  const baseStyleHelperText = defineStyle({
    mt: "2",
    [$fg$4.variable]: "colors.gray.600",
    _dark: {
      [$fg$4.variable]: "colors.whiteAlpha.600"
    },
    color: $fg$4.reference,
    lineHeight: "normal",
    fontSize: "sm"
  });
  const baseStyle$s = definePartsStyle$h({
    container: {
      width: "100%",
      position: "relative"
    },
    requiredIndicator: baseStyleRequiredIndicator,
    helperText: baseStyleHelperText
  });
  const formTheme = defineMultiStyleConfig$h({
    baseStyle: baseStyle$s
  });

  const { definePartsStyle: definePartsStyle$g, defineMultiStyleConfig: defineMultiStyleConfig$g } = createMultiStyleConfigHelpers(formErrorAnatomy.keys);
  const $fg$3 = cssVar$1("form-error-color");
  const baseStyleText = defineStyle({
    [$fg$3.variable]: `colors.red.500`,
    _dark: {
      [$fg$3.variable]: `colors.red.300`
    },
    color: $fg$3.reference,
    mt: "2",
    fontSize: "sm",
    lineHeight: "normal"
  });
  const baseStyleIcon$4 = defineStyle({
    marginEnd: "0.5em",
    [$fg$3.variable]: `colors.red.500`,
    _dark: {
      [$fg$3.variable]: `colors.red.300`
    },
    color: $fg$3.reference
  });
  const baseStyle$r = definePartsStyle$g({
    text: baseStyleText,
    icon: baseStyleIcon$4
  });
  const formErrorTheme = defineMultiStyleConfig$g({
    baseStyle: baseStyle$r
  });

  const baseStyle$q = defineStyle({
    fontSize: "md",
    marginEnd: "3",
    mb: "2",
    fontWeight: "medium",
    transitionProperty: "common",
    transitionDuration: "normal",
    opacity: 1,
    _disabled: {
      opacity: 0.4
    }
  });
  const formLabelTheme = defineStyleConfig({
    baseStyle: baseStyle$q
  });

  const baseStyle$p = defineStyle({
    fontFamily: "heading",
    fontWeight: "bold"
  });
  const sizes$f = {
    "4xl": defineStyle({
      fontSize: ["6xl", null, "7xl"],
      lineHeight: 1
    }),
    "3xl": defineStyle({
      fontSize: ["5xl", null, "6xl"],
      lineHeight: 1
    }),
    "2xl": defineStyle({
      fontSize: ["4xl", null, "5xl"],
      lineHeight: [1.2, null, 1]
    }),
    xl: defineStyle({
      fontSize: ["3xl", null, "4xl"],
      lineHeight: [1.33, null, 1.2]
    }),
    lg: defineStyle({
      fontSize: ["2xl", null, "3xl"],
      lineHeight: [1.33, null, 1.2]
    }),
    md: defineStyle({
      fontSize: "xl",
      lineHeight: 1.2
    }),
    sm: defineStyle({
      fontSize: "md",
      lineHeight: 1.2
    }),
    xs: defineStyle({
      fontSize: "sm",
      lineHeight: 1.2
    })
  };
  const headingTheme = defineStyleConfig({
    baseStyle: baseStyle$p,
    sizes: sizes$f,
    defaultProps: {
      size: "xl"
    }
  });

  const { definePartsStyle: definePartsStyle$f, defineMultiStyleConfig: defineMultiStyleConfig$f } = createMultiStyleConfigHelpers(inputAnatomy.keys);
  const $height$1 = cssVar$1("input-height");
  const $fontSize$1 = cssVar$1("input-font-size");
  const $padding = cssVar$1("input-padding");
  const $borderRadius = cssVar$1("input-border-radius");
  const baseStyle$o = definePartsStyle$f({
    addon: {
      height: $height$1.reference,
      fontSize: $fontSize$1.reference,
      px: $padding.reference,
      borderRadius: $borderRadius.reference
    },
    field: {
      width: "100%",
      height: $height$1.reference,
      fontSize: $fontSize$1.reference,
      px: $padding.reference,
      borderRadius: $borderRadius.reference,
      minWidth: 0,
      outline: 0,
      position: "relative",
      appearance: "none",
      transitionProperty: "common",
      transitionDuration: "normal",
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      }
    }
  });
  const size = {
    lg: defineStyle({
      [$fontSize$1.variable]: "fontSizes.lg",
      [$padding.variable]: "space.4",
      [$borderRadius.variable]: "radii.md",
      [$height$1.variable]: "sizes.12"
    }),
    md: defineStyle({
      [$fontSize$1.variable]: "fontSizes.md",
      [$padding.variable]: "space.4",
      [$borderRadius.variable]: "radii.md",
      [$height$1.variable]: "sizes.10"
    }),
    sm: defineStyle({
      [$fontSize$1.variable]: "fontSizes.sm",
      [$padding.variable]: "space.3",
      [$borderRadius.variable]: "radii.sm",
      [$height$1.variable]: "sizes.8"
    }),
    xs: defineStyle({
      [$fontSize$1.variable]: "fontSizes.xs",
      [$padding.variable]: "space.2",
      [$borderRadius.variable]: "radii.sm",
      [$height$1.variable]: "sizes.6"
    })
  };
  const sizes$e = {
    lg: definePartsStyle$f({
      field: size.lg,
      group: size.lg
    }),
    md: definePartsStyle$f({
      field: size.md,
      group: size.md
    }),
    sm: definePartsStyle$f({
      field: size.sm,
      group: size.sm
    }),
    xs: definePartsStyle$f({
      field: size.xs,
      group: size.xs
    })
  };
  function getDefaults(props) {
    const { focusBorderColor: fc, errorBorderColor: ec } = props;
    return {
      focusBorderColor: fc || mode("blue.500", "blue.300")(props),
      errorBorderColor: ec || mode("red.500", "red.300")(props)
    };
  }
  const variantOutline = definePartsStyle$f((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        border: "1px solid",
        borderColor: "inherit",
        bg: "inherit",
        _hover: {
          borderColor: mode("gray.300", "whiteAlpha.400")(props)
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec),
          boxShadow: `0 0 0 1px ${getColor(theme, ec)}`
        },
        _focusVisible: {
          zIndex: 1,
          borderColor: getColor(theme, fc),
          boxShadow: `0 0 0 1px ${getColor(theme, fc)}`
        }
      },
      addon: {
        border: "1px solid",
        borderColor: mode("inherit", "whiteAlpha.50")(props),
        bg: mode("gray.100", "whiteAlpha.300")(props)
      }
    };
  });
  const variantFilled = definePartsStyle$f((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        border: "2px solid",
        borderColor: "transparent",
        bg: mode("gray.100", "whiteAlpha.50")(props),
        _hover: {
          bg: mode("gray.200", "whiteAlpha.100")(props)
        },
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec)
        },
        _focusVisible: {
          bg: "transparent",
          borderColor: getColor(theme, fc)
        }
      },
      addon: {
        border: "2px solid",
        borderColor: "transparent",
        bg: mode("gray.100", "whiteAlpha.50")(props)
      }
    };
  });
  const variantFlushed = definePartsStyle$f((props) => {
    const { theme } = props;
    const { focusBorderColor: fc, errorBorderColor: ec } = getDefaults(props);
    return {
      field: {
        borderBottom: "1px solid",
        borderColor: "inherit",
        borderRadius: "0",
        px: "0",
        bg: "transparent",
        _readOnly: {
          boxShadow: "none !important",
          userSelect: "all"
        },
        _invalid: {
          borderColor: getColor(theme, ec),
          boxShadow: `0px 1px 0px 0px ${getColor(theme, ec)}`
        },
        _focusVisible: {
          borderColor: getColor(theme, fc),
          boxShadow: `0px 1px 0px 0px ${getColor(theme, fc)}`
        }
      },
      addon: {
        borderBottom: "2px solid",
        borderColor: "inherit",
        borderRadius: "0",
        px: "0",
        bg: "transparent"
      }
    };
  });
  const variantUnstyled$1 = definePartsStyle$f({
    field: {
      bg: "transparent",
      px: "0",
      height: "auto"
    },
    addon: {
      bg: "transparent",
      px: "0",
      height: "auto"
    }
  });
  const variants$8 = {
    outline: variantOutline,
    filled: variantFilled,
    flushed: variantFlushed,
    unstyled: variantUnstyled$1
  };
  const inputTheme = defineMultiStyleConfig$f({
    baseStyle: baseStyle$o,
    sizes: sizes$e,
    variants: variants$8,
    defaultProps: {
      size: "md",
      variant: "outline"
    }
  });

  const $bg$a = cssVar$1("kbd-bg");
  const baseStyle$n = defineStyle({
    [$bg$a.variable]: "colors.gray.100",
    _dark: {
      [$bg$a.variable]: "colors.whiteAlpha.100"
    },
    bg: $bg$a.reference,
    borderRadius: "md",
    borderWidth: "1px",
    borderBottomWidth: "3px",
    fontSize: "0.8em",
    fontWeight: "bold",
    lineHeight: "normal",
    px: "0.4em",
    whiteSpace: "nowrap"
  });
  const kbdTheme = defineStyleConfig({
    baseStyle: baseStyle$n
  });

  const baseStyle$m = defineStyle({
    transitionProperty: "common",
    transitionDuration: "fast",
    transitionTimingFunction: "ease-out",
    cursor: "pointer",
    textDecoration: "none",
    outline: "none",
    color: "inherit",
    _hover: {
      textDecoration: "underline"
    },
    _focusVisible: {
      boxShadow: "outline"
    }
  });
  const linkTheme = defineStyleConfig({
    baseStyle: baseStyle$m
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$e, definePartsStyle: definePartsStyle$e } = createMultiStyleConfigHelpers(listAnatomy.keys);
  const baseStyleIcon$3 = defineStyle({
    marginEnd: "2",
    display: "inline",
    verticalAlign: "text-bottom"
  });
  const baseStyle$l = definePartsStyle$e({
    icon: baseStyleIcon$3
  });
  const listTheme = defineMultiStyleConfig$e({
    baseStyle: baseStyle$l
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$d, definePartsStyle: definePartsStyle$d } = createMultiStyleConfigHelpers(menuAnatomy.keys);
  const $bg$9 = cssVar$1("menu-bg");
  const $shadow$2 = cssVar$1("menu-shadow");
  const baseStyleList = defineStyle({
    [$bg$9.variable]: "#fff",
    [$shadow$2.variable]: "shadows.sm",
    _dark: {
      [$bg$9.variable]: "colors.gray.700",
      [$shadow$2.variable]: "shadows.dark-lg"
    },
    color: "inherit",
    minW: "3xs",
    py: "2",
    zIndex: "dropdown",
    borderRadius: "md",
    borderWidth: "1px",
    bg: $bg$9.reference,
    boxShadow: $shadow$2.reference
  });
  const baseStyleItem = defineStyle({
    py: "1.5",
    px: "3",
    transitionProperty: "background",
    transitionDuration: "ultra-fast",
    transitionTimingFunction: "ease-in",
    _focus: {
      [$bg$9.variable]: "colors.gray.100",
      _dark: {
        [$bg$9.variable]: "colors.whiteAlpha.100"
      }
    },
    _active: {
      [$bg$9.variable]: "colors.gray.200",
      _dark: {
        [$bg$9.variable]: "colors.whiteAlpha.200"
      }
    },
    _expanded: {
      [$bg$9.variable]: "colors.gray.100",
      _dark: {
        [$bg$9.variable]: "colors.whiteAlpha.100"
      }
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    },
    bg: $bg$9.reference
  });
  const baseStyleGroupTitle = defineStyle({
    mx: 4,
    my: 2,
    fontWeight: "semibold",
    fontSize: "sm"
  });
  const baseStyleIcon$2 = defineStyle({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  });
  const baseStyleCommand = defineStyle({
    opacity: 0.6
  });
  const baseStyleDivider = defineStyle({
    border: 0,
    borderBottom: "1px solid",
    borderColor: "inherit",
    my: "2",
    opacity: 0.6
  });
  const baseStyleButton = defineStyle({
    transitionProperty: "common",
    transitionDuration: "normal"
  });
  const baseStyle$k = definePartsStyle$d({
    button: baseStyleButton,
    list: baseStyleList,
    item: baseStyleItem,
    groupTitle: baseStyleGroupTitle,
    icon: baseStyleIcon$2,
    command: baseStyleCommand,
    divider: baseStyleDivider
  });
  const menuTheme = defineMultiStyleConfig$d({
    baseStyle: baseStyle$k
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$c, definePartsStyle: definePartsStyle$c } = createMultiStyleConfigHelpers(modalAnatomy.keys);
  const $bg$8 = cssVar$1("modal-bg");
  const $shadow$1 = cssVar$1("modal-shadow");
  const baseStyleOverlay = defineStyle({
    bg: "blackAlpha.600",
    zIndex: "modal"
  });
  const baseStyleDialogContainer = defineStyle((props) => {
    const { isCentered, scrollBehavior } = props;
    return {
      display: "flex",
      zIndex: "modal",
      justifyContent: "center",
      alignItems: isCentered ? "center" : "flex-start",
      overflow: scrollBehavior === "inside" ? "hidden" : "auto",
      overscrollBehaviorY: "none"
    };
  });
  const baseStyleDialog = defineStyle((props) => {
    const { isCentered, scrollBehavior } = props;
    return {
      borderRadius: "md",
      color: "inherit",
      my: isCentered ? "auto" : "16",
      mx: isCentered ? "auto" : void 0,
      zIndex: "modal",
      maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : void 0,
      [$bg$8.variable]: "colors.white",
      [$shadow$1.variable]: "shadows.lg",
      _dark: {
        [$bg$8.variable]: "colors.gray.700",
        [$shadow$1.variable]: "shadows.dark-lg"
      },
      bg: $bg$8.reference,
      boxShadow: $shadow$1.reference
    };
  });
  const baseStyleHeader$1 = defineStyle({
    px: "6",
    py: "4",
    fontSize: "xl",
    fontWeight: "semibold"
  });
  const baseStyleCloseButton$2 = defineStyle({
    position: "absolute",
    top: "2",
    insetEnd: "3"
  });
  const baseStyleBody$1 = defineStyle((props) => {
    const { scrollBehavior } = props;
    return {
      px: "6",
      py: "2",
      flex: "1",
      overflow: scrollBehavior === "inside" ? "auto" : void 0
    };
  });
  const baseStyleFooter$1 = defineStyle({
    px: "6",
    py: "4"
  });
  const baseStyle$j = definePartsStyle$c((props) => ({
    overlay: baseStyleOverlay,
    dialogContainer: runIfFn$2(baseStyleDialogContainer, props),
    dialog: runIfFn$2(baseStyleDialog, props),
    header: baseStyleHeader$1,
    closeButton: baseStyleCloseButton$2,
    body: runIfFn$2(baseStyleBody$1, props),
    footer: baseStyleFooter$1
  }));
  function getSize$1(value) {
    if (value === "full") {
      return definePartsStyle$c({
        dialog: {
          maxW: "100vw",
          minH: "$100vh",
          my: "0",
          borderRadius: "0"
        }
      });
    }
    return definePartsStyle$c({
      dialog: { maxW: value }
    });
  }
  const sizes$d = {
    xs: getSize$1("xs"),
    sm: getSize$1("sm"),
    md: getSize$1("md"),
    lg: getSize$1("lg"),
    xl: getSize$1("xl"),
    "2xl": getSize$1("2xl"),
    "3xl": getSize$1("3xl"),
    "4xl": getSize$1("4xl"),
    "5xl": getSize$1("5xl"),
    "6xl": getSize$1("6xl"),
    full: getSize$1("full")
  };
  const modalTheme = defineMultiStyleConfig$c({
    baseStyle: baseStyle$j,
    sizes: sizes$d,
    defaultProps: { size: "md" }
  });

  const typography$1 = {
    letterSpacings: {
      tighter: "-0.05em",
      tight: "-0.025em",
      normal: "0",
      wide: "0.025em",
      wider: "0.05em",
      widest: "0.1em"
    },
    lineHeights: {
      normal: "normal",
      none: 1,
      shorter: 1.25,
      short: 1.375,
      base: 1.5,
      tall: 1.625,
      taller: "2",
      "3": ".75rem",
      "4": "1rem",
      "5": "1.25rem",
      "6": "1.5rem",
      "7": "1.75rem",
      "8": "2rem",
      "9": "2.25rem",
      "10": "2.5rem"
    },
    fontWeights: {
      hairline: 100,
      thin: 200,
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
      extrabold: 800,
      black: 900
    },
    fonts: {
      heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      body: `-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      mono: `SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace`
    },
    fontSizes: {
      "3xs": "0.45rem",
      "2xs": "0.625rem",
      xs: "0.75rem",
      sm: "0.875rem",
      md: "1rem",
      lg: "1.125rem",
      xl: "1.25rem",
      "2xl": "1.5rem",
      "3xl": "1.875rem",
      "4xl": "2.25rem",
      "5xl": "3rem",
      "6xl": "3.75rem",
      "7xl": "4.5rem",
      "8xl": "6rem",
      "9xl": "8rem"
    }
  };

  const { defineMultiStyleConfig: defineMultiStyleConfig$b, definePartsStyle: definePartsStyle$b } = createMultiStyleConfigHelpers(numberInputAnatomy.keys);
  const $stepperWidth = cssVar("number-input-stepper-width");
  const $inputPadding = cssVar("number-input-input-padding");
  const inputPaddingValue = calc$1($stepperWidth).add("0.5rem").toString();
  const $bg$7 = cssVar("number-input-bg");
  const $fg$2 = cssVar("number-input-color");
  const $border$1 = cssVar("number-input-border-color");
  const baseStyleRoot$1 = defineStyle({
    [$stepperWidth.variable]: "sizes.6",
    [$inputPadding.variable]: inputPaddingValue
  });
  const baseStyleField$1 = defineStyle(
    (props) => runIfFn$2(inputTheme.baseStyle, props)?.field ?? {}
  );
  const baseStyleStepperGroup = defineStyle({
    width: $stepperWidth.reference
  });
  const baseStyleStepper = defineStyle({
    borderStart: "1px solid",
    borderStartColor: $border$1.reference,
    color: $fg$2.reference,
    bg: $bg$7.reference,
    [$fg$2.variable]: "colors.chakra-body-text",
    [$border$1.variable]: "colors.chakra-border-color",
    _dark: {
      [$fg$2.variable]: "colors.whiteAlpha.800",
      [$border$1.variable]: "colors.whiteAlpha.300"
    },
    _active: {
      [$bg$7.variable]: "colors.gray.200",
      _dark: {
        [$bg$7.variable]: "colors.whiteAlpha.300"
      }
    },
    _disabled: {
      opacity: 0.4,
      cursor: "not-allowed"
    }
  });
  const baseStyle$i = definePartsStyle$b((props) => ({
    root: baseStyleRoot$1,
    field: runIfFn$2(baseStyleField$1, props) ?? {},
    stepperGroup: baseStyleStepperGroup,
    stepper: baseStyleStepper
  }));
  function getSize(size) {
    const sizeStyle = inputTheme.sizes?.[size];
    const radius = {
      lg: "md",
      md: "md",
      sm: "sm",
      xs: "sm"
    };
    const _fontSize = sizeStyle.field?.fontSize ?? "md";
    const fontSize = typography$1.fontSizes[_fontSize];
    return definePartsStyle$b({
      field: {
        ...sizeStyle.field,
        paddingInlineEnd: $inputPadding.reference,
        verticalAlign: "top"
      },
      stepper: {
        fontSize: calc$1(fontSize).multiply(0.75).toString(),
        _first: {
          borderTopEndRadius: radius[size]
        },
        _last: {
          borderBottomEndRadius: radius[size],
          mt: "-1px",
          borderTopWidth: 1
        }
      }
    });
  }
  const sizes$c = {
    xs: getSize("xs"),
    sm: getSize("sm"),
    md: getSize("md"),
    lg: getSize("lg")
  };
  const numberInputTheme = defineMultiStyleConfig$b({
    baseStyle: baseStyle$i,
    sizes: sizes$c,
    variants: inputTheme.variants,
    defaultProps: inputTheme.defaultProps
  });

  const baseStyle$h = defineStyle({
    ...inputTheme.baseStyle?.field,
    textAlign: "center"
  });
  const sizes$b = {
    lg: defineStyle({
      fontSize: "lg",
      w: 12,
      h: 12,
      borderRadius: "md"
    }),
    md: defineStyle({
      fontSize: "md",
      w: 10,
      h: 10,
      borderRadius: "md"
    }),
    sm: defineStyle({
      fontSize: "sm",
      w: 8,
      h: 8,
      borderRadius: "sm"
    }),
    xs: defineStyle({
      fontSize: "xs",
      w: 6,
      h: 6,
      borderRadius: "sm"
    })
  };
  const variants$7 = {
    outline: defineStyle(
      (props) => runIfFn$2(inputTheme.variants?.outline, props)?.field ?? {}
    ),
    flushed: defineStyle(
      (props) => runIfFn$2(inputTheme.variants?.flushed, props)?.field ?? {}
    ),
    filled: defineStyle(
      (props) => runIfFn$2(inputTheme.variants?.filled, props)?.field ?? {}
    ),
    unstyled: inputTheme.variants?.unstyled.field ?? {}
  };
  const pinInputTheme = defineStyleConfig({
    baseStyle: baseStyle$h,
    sizes: sizes$b,
    variants: variants$7,
    defaultProps: inputTheme.defaultProps
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$a, definePartsStyle: definePartsStyle$a } = createMultiStyleConfigHelpers(popoverAnatomy.keys);
  const $popperBg = cssVar("popper-bg");
  const $arrowBg$1 = cssVar("popper-arrow-bg");
  const $arrowShadowColor = cssVar("popper-arrow-shadow-color");
  const baseStylePopper = defineStyle({
    zIndex: "popover"
  });
  const baseStyleContent = defineStyle({
    [$popperBg.variable]: `colors.white`,
    bg: $popperBg.reference,
    [$arrowBg$1.variable]: $popperBg.reference,
    [$arrowShadowColor.variable]: `colors.gray.200`,
    _dark: {
      [$popperBg.variable]: `colors.gray.700`,
      [$arrowShadowColor.variable]: `colors.whiteAlpha.300`
    },
    width: "xs",
    border: "1px solid",
    borderColor: "inherit",
    borderRadius: "md",
    boxShadow: "sm",
    zIndex: "inherit",
    _focusVisible: {
      outline: 0,
      boxShadow: "outline"
    }
  });
  const baseStyleHeader = defineStyle({
    px: 3,
    py: 2,
    borderBottomWidth: "1px"
  });
  const baseStyleBody = defineStyle({
    px: 3,
    py: 2
  });
  const baseStyleFooter = defineStyle({
    px: 3,
    py: 2,
    borderTopWidth: "1px"
  });
  const baseStyleCloseButton$1 = defineStyle({
    position: "absolute",
    borderRadius: "md",
    top: 1,
    insetEnd: 2,
    padding: 2
  });
  const baseStyle$g = definePartsStyle$a({
    popper: baseStylePopper,
    content: baseStyleContent,
    header: baseStyleHeader,
    body: baseStyleBody,
    footer: baseStyleFooter,
    closeButton: baseStyleCloseButton$1
  });
  const popoverTheme = defineMultiStyleConfig$a({
    baseStyle: baseStyle$g
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$9, definePartsStyle: definePartsStyle$9 } = createMultiStyleConfigHelpers(progressAnatomy.keys);
  const filledStyle = defineStyle((props) => {
    const { colorScheme: c, theme: t, isIndeterminate, hasStripe } = props;
    const stripeStyle = mode(
      generateStripe(),
      generateStripe("1rem", "rgba(0,0,0,0.1)")
    )(props);
    const bgColor = mode(`${c}.500`, `${c}.200`)(props);
    const gradient = `linear-gradient(
    to right,
    transparent 0%,
    ${getColor(t, bgColor)} 50%,
    transparent 100%
  )`;
    const addStripe = !isIndeterminate && hasStripe;
    return {
      ...addStripe && stripeStyle,
      ...isIndeterminate ? { bgImage: gradient } : { bgColor }
    };
  });
  const baseStyleLabel$2 = defineStyle({
    lineHeight: "1",
    fontSize: "0.25em",
    fontWeight: "bold",
    color: "white"
  });
  const baseStyleTrack$2 = defineStyle((props) => {
    return {
      bg: mode("gray.100", "whiteAlpha.300")(props)
    };
  });
  const baseStyleFilledTrack$1 = defineStyle((props) => {
    return {
      transitionProperty: "common",
      transitionDuration: "slow",
      ...filledStyle(props)
    };
  });
  const baseStyle$f = definePartsStyle$9((props) => ({
    label: baseStyleLabel$2,
    filledTrack: baseStyleFilledTrack$1(props),
    track: baseStyleTrack$2(props)
  }));
  const sizes$a = {
    xs: definePartsStyle$9({
      track: { h: "1" }
    }),
    sm: definePartsStyle$9({
      track: { h: "2" }
    }),
    md: definePartsStyle$9({
      track: { h: "3" }
    }),
    lg: definePartsStyle$9({
      track: { h: "4" }
    })
  };
  const progressTheme = defineMultiStyleConfig$9({
    sizes: sizes$a,
    baseStyle: baseStyle$f,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$8, definePartsStyle: definePartsStyle$8 } = createMultiStyleConfigHelpers(radioAnatomy.keys);
  const baseStyleControl = defineStyle((props) => {
    const controlStyle = runIfFn$2(checkboxTheme.baseStyle, props)?.control;
    return {
      ...controlStyle,
      borderRadius: "full",
      _checked: {
        ...controlStyle?.["_checked"],
        _before: {
          content: `""`,
          display: "inline-block",
          pos: "relative",
          w: "50%",
          h: "50%",
          borderRadius: "50%",
          bg: "currentColor"
        }
      }
    };
  });
  const baseStyle$e = definePartsStyle$8((props) => ({
    label: checkboxTheme.baseStyle?.(props).label,
    container: checkboxTheme.baseStyle?.(props).container,
    control: baseStyleControl(props)
  }));
  const sizes$9 = {
    md: definePartsStyle$8({
      control: { w: "4", h: "4" },
      label: { fontSize: "md" }
    }),
    lg: definePartsStyle$8({
      control: { w: "5", h: "5" },
      label: { fontSize: "lg" }
    }),
    sm: definePartsStyle$8({
      control: { width: "3", height: "3" },
      label: { fontSize: "sm" }
    })
  };
  const radioTheme = defineMultiStyleConfig$8({
    baseStyle: baseStyle$e,
    sizes: sizes$9,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$7, definePartsStyle: definePartsStyle$7 } = createMultiStyleConfigHelpers(selectAnatomy.keys);
  const $bg$6 = cssVar$1("select-bg");
  const baseStyleField = defineStyle({
    ...inputTheme.baseStyle?.field,
    appearance: "none",
    paddingBottom: "1px",
    lineHeight: "normal",
    bg: $bg$6.reference,
    [$bg$6.variable]: "colors.white",
    _dark: {
      [$bg$6.variable]: "colors.gray.700"
    },
    "> option, > optgroup": {
      bg: $bg$6.reference
    }
  });
  const baseStyleIcon$1 = defineStyle({
    width: "6",
    height: "100%",
    insetEnd: "2",
    position: "relative",
    color: "currentColor",
    fontSize: "xl",
    _disabled: {
      opacity: 0.5
    }
  });
  const baseStyle$d = definePartsStyle$7({
    field: baseStyleField,
    icon: baseStyleIcon$1
  });
  const iconSpacing = defineStyle({
    paddingInlineEnd: "8"
  });
  const sizes$8 = {
    lg: {
      ...inputTheme.sizes?.lg,
      field: {
        ...inputTheme.sizes?.lg.field,
        ...iconSpacing
      }
    },
    md: {
      ...inputTheme.sizes?.md,
      field: {
        ...inputTheme.sizes?.md.field,
        ...iconSpacing
      }
    },
    sm: {
      ...inputTheme.sizes?.sm,
      field: {
        ...inputTheme.sizes?.sm.field,
        ...iconSpacing
      }
    },
    xs: {
      ...inputTheme.sizes?.xs,
      field: {
        ...inputTheme.sizes?.xs.field,
        ...iconSpacing
      },
      icon: {
        insetEnd: "1"
      }
    }
  };
  const selectTheme = defineMultiStyleConfig$7({
    baseStyle: baseStyle$d,
    sizes: sizes$8,
    variants: inputTheme.variants,
    defaultProps: inputTheme.defaultProps
  });

  const $startColor = cssVar$1("skeleton-start-color");
  const $endColor = cssVar$1("skeleton-end-color");
  const baseStyle$c = defineStyle({
    [$startColor.variable]: "colors.gray.100",
    [$endColor.variable]: "colors.gray.400",
    _dark: {
      [$startColor.variable]: "colors.gray.800",
      [$endColor.variable]: "colors.gray.600"
    },
    background: $startColor.reference,
    borderColor: $endColor.reference,
    opacity: 0.7,
    borderRadius: "sm"
  });
  const skeletonTheme = defineStyleConfig({
    baseStyle: baseStyle$c
  });

  const $bg$5 = cssVar$1("skip-link-bg");
  const baseStyle$b = defineStyle({
    borderRadius: "md",
    fontWeight: "semibold",
    _focusVisible: {
      boxShadow: "outline",
      padding: "4",
      position: "fixed",
      top: "6",
      insetStart: "6",
      [$bg$5.variable]: "colors.white",
      _dark: {
        [$bg$5.variable]: "colors.gray.700"
      },
      bg: $bg$5.reference
    }
  });
  const skipLinkTheme = defineStyleConfig({
    baseStyle: baseStyle$b
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$6, definePartsStyle: definePartsStyle$6 } = createMultiStyleConfigHelpers(sliderAnatomy.keys);
  const $thumbSize = cssVar$1("slider-thumb-size");
  const $trackSize = cssVar$1("slider-track-size");
  const $bg$4 = cssVar$1("slider-bg");
  const baseStyleContainer$1 = defineStyle((props) => {
    const { orientation } = props;
    return {
      display: "inline-block",
      position: "relative",
      cursor: "pointer",
      _disabled: {
        opacity: 0.6,
        cursor: "default",
        pointerEvents: "none"
      },
      ...orient({
        orientation,
        vertical: {
          h: "100%",
          px: calc$2($thumbSize.reference).divide(2).toString()
        },
        horizontal: {
          w: "100%",
          py: calc$2($thumbSize.reference).divide(2).toString()
        }
      })
    };
  });
  const baseStyleTrack$1 = defineStyle((props) => {
    const orientationStyles = orient({
      orientation: props.orientation,
      horizontal: { h: $trackSize.reference },
      vertical: { w: $trackSize.reference }
    });
    return {
      ...orientationStyles,
      overflow: "hidden",
      borderRadius: "sm",
      [$bg$4.variable]: "colors.gray.200",
      _dark: {
        [$bg$4.variable]: "colors.whiteAlpha.200"
      },
      _disabled: {
        [$bg$4.variable]: "colors.gray.300",
        _dark: {
          [$bg$4.variable]: "colors.whiteAlpha.300"
        }
      },
      bg: $bg$4.reference
    };
  });
  const baseStyleThumb$1 = defineStyle((props) => {
    const { orientation } = props;
    const orientationStyle = orient({
      orientation,
      vertical: { left: "50%" },
      horizontal: { top: "50%" }
    });
    return {
      ...orientationStyle,
      w: $thumbSize.reference,
      h: $thumbSize.reference,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "absolute",
      outline: 0,
      zIndex: 1,
      borderRadius: "full",
      bg: "white",
      boxShadow: "base",
      border: "1px solid",
      borderColor: "transparent",
      transitionProperty: "transform",
      transitionDuration: "normal",
      _focusVisible: {
        boxShadow: "outline"
      },
      _active: {
        "--slider-thumb-scale": `1.15`
      },
      _disabled: {
        bg: "gray.300"
      }
    };
  });
  const baseStyleFilledTrack = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      width: "inherit",
      height: "inherit",
      [$bg$4.variable]: `colors.${c}.500`,
      _dark: {
        [$bg$4.variable]: `colors.${c}.200`
      },
      bg: $bg$4.reference
    };
  });
  const baseStyle$a = definePartsStyle$6((props) => ({
    container: baseStyleContainer$1(props),
    track: baseStyleTrack$1(props),
    thumb: baseStyleThumb$1(props),
    filledTrack: baseStyleFilledTrack(props)
  }));
  const sizeLg = definePartsStyle$6({
    container: {
      [$thumbSize.variable]: `sizes.4`,
      [$trackSize.variable]: `sizes.1`
    }
  });
  const sizeMd = definePartsStyle$6({
    container: {
      [$thumbSize.variable]: `sizes.3.5`,
      [$trackSize.variable]: `sizes.1`
    }
  });
  const sizeSm = definePartsStyle$6({
    container: {
      [$thumbSize.variable]: `sizes.2.5`,
      [$trackSize.variable]: `sizes.0.5`
    }
  });
  const sizes$7 = {
    lg: sizeLg,
    md: sizeMd,
    sm: sizeSm
  };
  const sliderTheme = defineMultiStyleConfig$6({
    baseStyle: baseStyle$a,
    sizes: sizes$7,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const $size$1 = cssVar("spinner-size");
  const baseStyle$9 = defineStyle({
    width: [$size$1.reference],
    height: [$size$1.reference]
  });
  const sizes$6 = {
    xs: defineStyle({
      [$size$1.variable]: "sizes.3"
    }),
    sm: defineStyle({
      [$size$1.variable]: "sizes.4"
    }),
    md: defineStyle({
      [$size$1.variable]: "sizes.6"
    }),
    lg: defineStyle({
      [$size$1.variable]: "sizes.8"
    }),
    xl: defineStyle({
      [$size$1.variable]: "sizes.12"
    })
  };
  const spinnerTheme = defineStyleConfig({
    baseStyle: baseStyle$9,
    sizes: sizes$6,
    defaultProps: {
      size: "md"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$5, definePartsStyle: definePartsStyle$5 } = createMultiStyleConfigHelpers(statAnatomy.keys);
  const baseStyleLabel$1 = defineStyle({
    fontWeight: "medium"
  });
  const baseStyleHelpText = defineStyle({
    opacity: 0.8,
    marginBottom: "2"
  });
  const baseStyleNumber = defineStyle({
    verticalAlign: "baseline",
    fontWeight: "semibold"
  });
  const baseStyleIcon = defineStyle({
    marginEnd: 1,
    w: "3.5",
    h: "3.5",
    verticalAlign: "middle"
  });
  const baseStyle$8 = definePartsStyle$5({
    container: {},
    label: baseStyleLabel$1,
    helpText: baseStyleHelpText,
    number: baseStyleNumber,
    icon: baseStyleIcon
  });
  const sizes$5 = {
    md: definePartsStyle$5({
      label: { fontSize: "sm" },
      helpText: { fontSize: "sm" },
      number: { fontSize: "2xl" }
    })
  };
  const statTheme = defineMultiStyleConfig$5({
    baseStyle: baseStyle$8,
    sizes: sizes$5,
    defaultProps: {
      size: "md"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$4, definePartsStyle: definePartsStyle$4 } = createMultiStyleConfigHelpers([
    "stepper",
    "step",
    "title",
    "description",
    "indicator",
    "separator",
    "icon",
    "number"
  ]);
  const $size = cssVar$1("stepper-indicator-size");
  const $iconSize = cssVar$1("stepper-icon-size");
  const $titleFontSize = cssVar$1("stepper-title-font-size");
  const $descFontSize = cssVar$1("stepper-description-font-size");
  const $accentColor = cssVar$1("stepper-accent-color");
  const baseStyle$7 = definePartsStyle$4(({ colorScheme: c }) => ({
    stepper: {
      display: "flex",
      justifyContent: "space-between",
      gap: "4",
      "&[data-orientation=vertical]": {
        flexDirection: "column",
        alignItems: "flex-start"
      },
      "&[data-orientation=horizontal]": {
        flexDirection: "row",
        alignItems: "center"
      },
      [$accentColor.variable]: `colors.${c}.500`,
      _dark: {
        [$accentColor.variable]: `colors.${c}.200`
      }
    },
    title: {
      fontSize: $titleFontSize.reference,
      fontWeight: "medium"
    },
    description: {
      fontSize: $descFontSize.reference,
      color: "chakra-subtle-text"
    },
    number: {
      fontSize: $titleFontSize.reference
    },
    step: {
      flexShrink: 0,
      position: "relative",
      display: "flex",
      gap: "2",
      "&[data-orientation=horizontal]": {
        alignItems: "center"
      },
      flex: "1",
      "&:last-of-type:not([data-stretch])": {
        flex: "initial"
      }
    },
    icon: {
      flexShrink: 0,
      width: $iconSize.reference,
      height: $iconSize.reference
    },
    indicator: {
      flexShrink: 0,
      borderRadius: "full",
      width: $size.reference,
      height: $size.reference,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      "&[data-status=active]": {
        borderWidth: "2px",
        borderColor: $accentColor.reference
      },
      "&[data-status=complete]": {
        bg: $accentColor.reference,
        color: "chakra-inverse-text"
      },
      "&[data-status=incomplete]": {
        borderWidth: "2px"
      }
    },
    separator: {
      bg: "chakra-border-color",
      flex: "1",
      "&[data-status=complete]": {
        bg: $accentColor.reference
      },
      "&[data-orientation=horizontal]": {
        width: "100%",
        height: "2px",
        marginStart: "2"
      },
      "&[data-orientation=vertical]": {
        width: "2px",
        position: "absolute",
        height: "100%",
        maxHeight: `calc(100% - ${$size.reference} - 8px)`,
        top: `calc(${$size.reference} + 4px)`,
        insetStart: `calc(${$size.reference} / 2 - 1px)`
      }
    }
  }));
  const stepperTheme = defineMultiStyleConfig$4({
    baseStyle: baseStyle$7,
    sizes: {
      xs: definePartsStyle$4({
        stepper: {
          [$size.variable]: "sizes.4",
          [$iconSize.variable]: "sizes.3",
          [$titleFontSize.variable]: "fontSizes.xs",
          [$descFontSize.variable]: "fontSizes.xs"
        }
      }),
      sm: definePartsStyle$4({
        stepper: {
          [$size.variable]: "sizes.6",
          [$iconSize.variable]: "sizes.4",
          [$titleFontSize.variable]: "fontSizes.sm",
          [$descFontSize.variable]: "fontSizes.xs"
        }
      }),
      md: definePartsStyle$4({
        stepper: {
          [$size.variable]: "sizes.8",
          [$iconSize.variable]: "sizes.5",
          [$titleFontSize.variable]: "fontSizes.md",
          [$descFontSize.variable]: "fontSizes.sm"
        }
      }),
      lg: definePartsStyle$4({
        stepper: {
          [$size.variable]: "sizes.10",
          [$iconSize.variable]: "sizes.6",
          [$titleFontSize.variable]: "fontSizes.lg",
          [$descFontSize.variable]: "fontSizes.md"
        }
      })
    },
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$3, definePartsStyle: definePartsStyle$3 } = createMultiStyleConfigHelpers(switchAnatomy.keys);
  const $width = cssVar("switch-track-width");
  const $height = cssVar("switch-track-height");
  const $diff = cssVar("switch-track-diff");
  const diffValue = calc$1.subtract($width, $height);
  const $translateX = cssVar("switch-thumb-x");
  const $bg$3 = cssVar("switch-bg");
  const baseStyleTrack = defineStyle((props) => {
    const { colorScheme: c } = props;
    return {
      borderRadius: "full",
      p: "0.5",
      width: [$width.reference],
      height: [$height.reference],
      transitionProperty: "common",
      transitionDuration: "fast",
      [$bg$3.variable]: "colors.gray.300",
      _dark: {
        [$bg$3.variable]: "colors.whiteAlpha.400"
      },
      _focusVisible: {
        boxShadow: "outline"
      },
      _disabled: {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      _checked: {
        [$bg$3.variable]: `colors.${c}.500`,
        _dark: {
          [$bg$3.variable]: `colors.${c}.200`
        }
      },
      bg: $bg$3.reference
    };
  });
  const baseStyleThumb = defineStyle({
    bg: "white",
    transitionProperty: "transform",
    transitionDuration: "normal",
    borderRadius: "inherit",
    width: [$height.reference],
    height: [$height.reference],
    _checked: {
      transform: `translateX(${$translateX.reference})`
    }
  });
  const baseStyle$6 = definePartsStyle$3((props) => ({
    container: {
      [$diff.variable]: diffValue,
      [$translateX.variable]: $diff.reference,
      _rtl: {
        [$translateX.variable]: calc$1($diff).negate().toString()
      }
    },
    track: baseStyleTrack(props),
    thumb: baseStyleThumb
  }));
  const sizes$4 = {
    sm: definePartsStyle$3({
      container: {
        [$width.variable]: "1.375rem",
        [$height.variable]: "sizes.3"
      }
    }),
    md: definePartsStyle$3({
      container: {
        [$width.variable]: "1.875rem",
        [$height.variable]: "sizes.4"
      }
    }),
    lg: definePartsStyle$3({
      container: {
        [$width.variable]: "2.875rem",
        [$height.variable]: "sizes.6"
      }
    })
  };
  const switchTheme = defineMultiStyleConfig$3({
    baseStyle: baseStyle$6,
    sizes: sizes$4,
    defaultProps: {
      size: "md",
      colorScheme: "blue"
    }
  });

  const { defineMultiStyleConfig: defineMultiStyleConfig$2, definePartsStyle: definePartsStyle$2 } = createMultiStyleConfigHelpers(tableAnatomy.keys);
  const baseStyle$5 = definePartsStyle$2({
    table: {
      fontVariantNumeric: "lining-nums tabular-nums",
      borderCollapse: "collapse",
      width: "full"
    },
    th: {
      fontFamily: "heading",
      fontWeight: "bold",
      textTransform: "uppercase",
      letterSpacing: "wider",
      textAlign: "start"
    },
    td: {
      textAlign: "start"
    },
    caption: {
      mt: 4,
      fontFamily: "heading",
      textAlign: "center",
      fontWeight: "medium"
    }
  });
  const numericStyles = defineStyle({
    "&[data-is-numeric=true]": {
      textAlign: "end"
    }
  });
  const variantSimple = definePartsStyle$2((props) => {
    const { colorScheme: c } = props;
    return {
      th: {
        color: mode("gray.600", "gray.400")(props),
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      td: {
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      caption: {
        color: mode("gray.600", "gray.100")(props)
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    };
  });
  const variantStripe = definePartsStyle$2((props) => {
    const { colorScheme: c } = props;
    return {
      th: {
        color: mode("gray.600", "gray.400")(props),
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      td: {
        borderBottom: "1px",
        borderColor: mode(`${c}.100`, `${c}.700`)(props),
        ...numericStyles
      },
      caption: {
        color: mode("gray.600", "gray.100")(props)
      },
      tbody: {
        tr: {
          "&:nth-of-type(odd)": {
            "th, td": {
              borderBottomWidth: "1px",
              borderColor: mode(`${c}.100`, `${c}.700`)(props)
            },
            td: {
              background: mode(`${c}.100`, `${c}.700`)(props)
            }
          }
        }
      },
      tfoot: {
        tr: {
          "&:last-of-type": {
            th: { borderBottomWidth: 0 }
          }
        }
      }
    };
  });
  const variants$6 = {
    simple: variantSimple,
    striped: variantStripe,
    unstyled: defineStyle({})
  };
  const sizes$3 = {
    sm: definePartsStyle$2({
      th: {
        px: "4",
        py: "1",
        lineHeight: "4",
        fontSize: "xs"
      },
      td: {
        px: "4",
        py: "2",
        fontSize: "sm",
        lineHeight: "4"
      },
      caption: {
        px: "4",
        py: "2",
        fontSize: "xs"
      }
    }),
    md: definePartsStyle$2({
      th: {
        px: "6",
        py: "3",
        lineHeight: "4",
        fontSize: "xs"
      },
      td: {
        px: "6",
        py: "4",
        lineHeight: "5"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "sm"
      }
    }),
    lg: definePartsStyle$2({
      th: {
        px: "8",
        py: "4",
        lineHeight: "5",
        fontSize: "sm"
      },
      td: {
        px: "8",
        py: "5",
        lineHeight: "6"
      },
      caption: {
        px: "6",
        py: "2",
        fontSize: "md"
      }
    })
  };
  const tableTheme = defineMultiStyleConfig$2({
    baseStyle: baseStyle$5,
    variants: variants$6,
    sizes: sizes$3,
    defaultProps: {
      variant: "simple",
      size: "md",
      colorScheme: "gray"
    }
  });

  const $fg$1 = cssVar$1("tabs-color");
  const $bg$2 = cssVar$1("tabs-bg");
  const $border = cssVar$1("tabs-border-color");
  const { defineMultiStyleConfig: defineMultiStyleConfig$1, definePartsStyle: definePartsStyle$1 } = createMultiStyleConfigHelpers(tabsAnatomy.keys);
  const baseStyleRoot = defineStyle((props) => {
    const { orientation } = props;
    return {
      display: orientation === "vertical" ? "flex" : "block"
    };
  });
  const baseStyleTab = defineStyle((props) => {
    const { isFitted } = props;
    return {
      flex: isFitted ? 1 : void 0,
      transitionProperty: "common",
      transitionDuration: "normal",
      _focusVisible: {
        zIndex: 1,
        boxShadow: "outline"
      },
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.4
      }
    };
  });
  const baseStyleTablist = defineStyle((props) => {
    const { align = "start", orientation } = props;
    const alignments = {
      end: "flex-end",
      center: "center",
      start: "flex-start"
    };
    return {
      justifyContent: alignments[align],
      flexDirection: orientation === "vertical" ? "column" : "row"
    };
  });
  const baseStyleTabpanel = defineStyle({
    p: 4
  });
  const baseStyle$4 = definePartsStyle$1((props) => ({
    root: baseStyleRoot(props),
    tab: baseStyleTab(props),
    tablist: baseStyleTablist(props),
    tabpanel: baseStyleTabpanel
  }));
  const sizes$2 = {
    sm: definePartsStyle$1({
      tab: {
        py: 1,
        px: 4,
        fontSize: "sm"
      }
    }),
    md: definePartsStyle$1({
      tab: {
        fontSize: "md",
        py: 2,
        px: 4
      }
    }),
    lg: definePartsStyle$1({
      tab: {
        fontSize: "lg",
        py: 3,
        px: 4
      }
    })
  };
  const variantLine = definePartsStyle$1((props) => {
    const { colorScheme: c, orientation } = props;
    const isVertical = orientation === "vertical";
    const borderProp = isVertical ? "borderStart" : "borderBottom";
    const marginProp = isVertical ? "marginStart" : "marginBottom";
    return {
      tablist: {
        [borderProp]: "2px solid",
        borderColor: "inherit"
      },
      tab: {
        [borderProp]: "2px solid",
        borderColor: "transparent",
        [marginProp]: "-2px",
        _selected: {
          [$fg$1.variable]: `colors.${c}.600`,
          _dark: {
            [$fg$1.variable]: `colors.${c}.300`
          },
          borderColor: "currentColor"
        },
        _active: {
          [$bg$2.variable]: "colors.gray.200",
          _dark: {
            [$bg$2.variable]: "colors.whiteAlpha.300"
          }
        },
        _disabled: {
          _active: { bg: "none" }
        },
        color: $fg$1.reference,
        bg: $bg$2.reference
      }
    };
  });
  const variantEnclosed = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        borderTopRadius: "md",
        border: "1px solid",
        borderColor: "transparent",
        mb: "-1px",
        [$border.variable]: "transparent",
        _selected: {
          [$fg$1.variable]: `colors.${c}.600`,
          [$border.variable]: `colors.white`,
          _dark: {
            [$fg$1.variable]: `colors.${c}.300`,
            [$border.variable]: `colors.gray.800`
          },
          borderColor: "inherit",
          borderBottomColor: $border.reference
        },
        color: $fg$1.reference
      },
      tablist: {
        mb: "-1px",
        borderBottom: "1px solid",
        borderColor: "inherit"
      }
    };
  });
  const variantEnclosedColored = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        border: "1px solid",
        borderColor: "inherit",
        [$bg$2.variable]: "colors.gray.50",
        _dark: {
          [$bg$2.variable]: "colors.whiteAlpha.50"
        },
        mb: "-1px",
        _notLast: {
          marginEnd: "-1px"
        },
        _selected: {
          [$bg$2.variable]: "colors.white",
          [$fg$1.variable]: `colors.${c}.600`,
          _dark: {
            [$bg$2.variable]: "colors.gray.800",
            [$fg$1.variable]: `colors.${c}.300`
          },
          borderColor: "inherit",
          borderTopColor: "currentColor",
          borderBottomColor: "transparent"
        },
        color: $fg$1.reference,
        bg: $bg$2.reference
      },
      tablist: {
        mb: "-1px",
        borderBottom: "1px solid",
        borderColor: "inherit"
      }
    };
  });
  const variantSoftRounded = definePartsStyle$1((props) => {
    const { colorScheme: c, theme } = props;
    return {
      tab: {
        borderRadius: "full",
        fontWeight: "semibold",
        color: "gray.600",
        _selected: {
          color: getColor(theme, `${c}.700`),
          bg: getColor(theme, `${c}.100`)
        }
      }
    };
  });
  const variantSolidRounded = definePartsStyle$1((props) => {
    const { colorScheme: c } = props;
    return {
      tab: {
        borderRadius: "full",
        fontWeight: "semibold",
        [$fg$1.variable]: "colors.gray.600",
        _dark: {
          [$fg$1.variable]: "inherit"
        },
        _selected: {
          [$fg$1.variable]: "colors.white",
          [$bg$2.variable]: `colors.${c}.600`,
          _dark: {
            [$fg$1.variable]: "colors.gray.800",
            [$bg$2.variable]: `colors.${c}.300`
          }
        },
        color: $fg$1.reference,
        bg: $bg$2.reference
      }
    };
  });
  const variantUnstyled = definePartsStyle$1({});
  const variants$5 = {
    line: variantLine,
    enclosed: variantEnclosed,
    "enclosed-colored": variantEnclosedColored,
    "soft-rounded": variantSoftRounded,
    "solid-rounded": variantSolidRounded,
    unstyled: variantUnstyled
  };
  const tabsTheme = defineMultiStyleConfig$1({
    baseStyle: baseStyle$4,
    sizes: sizes$2,
    variants: variants$5,
    defaultProps: {
      size: "md",
      variant: "line",
      colorScheme: "blue"
    }
  });

  const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(tagAnatomy.keys);
  const $bg$1 = cssVar$1("tag-bg");
  const $color = cssVar$1("tag-color");
  const $shadow = cssVar$1("tag-shadow");
  const $minH = cssVar$1("tag-min-height");
  const $minW = cssVar$1("tag-min-width");
  const $fontSize = cssVar$1("tag-font-size");
  const $paddingX = cssVar$1("tag-padding-inline");
  const baseStyleContainer = defineStyle({
    fontWeight: "medium",
    lineHeight: 1.2,
    outline: 0,
    [$color.variable]: vars.color.reference,
    [$bg$1.variable]: vars.bg.reference,
    [$shadow.variable]: vars.shadow.reference,
    color: $color.reference,
    bg: $bg$1.reference,
    boxShadow: $shadow.reference,
    borderRadius: "md",
    minH: $minH.reference,
    minW: $minW.reference,
    fontSize: $fontSize.reference,
    px: $paddingX.reference,
    _focusVisible: {
      [$shadow.variable]: "shadows.outline"
    }
  });
  const baseStyleLabel = defineStyle({
    lineHeight: 1.2,
    overflow: "visible"
  });
  const baseStyleCloseButton = defineStyle({
    fontSize: "lg",
    w: "5",
    h: "5",
    transitionProperty: "common",
    transitionDuration: "normal",
    borderRadius: "full",
    marginStart: "1.5",
    marginEnd: "-1",
    opacity: 0.5,
    _disabled: {
      opacity: 0.4
    },
    _focusVisible: {
      boxShadow: "outline",
      bg: "rgba(0, 0, 0, 0.14)"
    },
    _hover: {
      opacity: 0.8
    },
    _active: {
      opacity: 1
    }
  });
  const baseStyle$3 = definePartsStyle({
    container: baseStyleContainer,
    label: baseStyleLabel,
    closeButton: baseStyleCloseButton
  });
  const sizes$1 = {
    sm: definePartsStyle({
      container: {
        [$minH.variable]: "sizes.5",
        [$minW.variable]: "sizes.5",
        [$fontSize.variable]: "fontSizes.xs",
        [$paddingX.variable]: "space.2"
      },
      closeButton: {
        marginEnd: "-2px",
        marginStart: "0.35rem"
      }
    }),
    md: definePartsStyle({
      container: {
        [$minH.variable]: "sizes.6",
        [$minW.variable]: "sizes.6",
        [$fontSize.variable]: "fontSizes.sm",
        [$paddingX.variable]: "space.2"
      }
    }),
    lg: definePartsStyle({
      container: {
        [$minH.variable]: "sizes.8",
        [$minW.variable]: "sizes.8",
        [$fontSize.variable]: "fontSizes.md",
        [$paddingX.variable]: "space.3"
      }
    })
  };
  const variants$4 = {
    subtle: definePartsStyle((props) => ({
      container: badgeTheme.variants?.subtle(props)
    })),
    solid: definePartsStyle((props) => ({
      container: badgeTheme.variants?.solid(props)
    })),
    outline: definePartsStyle((props) => ({
      container: badgeTheme.variants?.outline(props)
    }))
  };
  const tagTheme = defineMultiStyleConfig({
    variants: variants$4,
    baseStyle: baseStyle$3,
    sizes: sizes$1,
    defaultProps: {
      size: "md",
      variant: "subtle",
      colorScheme: "gray"
    }
  });

  const baseStyle$2 = defineStyle({
    ...inputTheme.baseStyle?.field,
    paddingY: "2",
    minHeight: "20",
    lineHeight: "short",
    verticalAlign: "top"
  });
  const variants$3 = {
    outline: defineStyle(
      (props) => inputTheme.variants?.outline(props).field ?? {}
    ),
    flushed: defineStyle(
      (props) => inputTheme.variants?.flushed(props).field ?? {}
    ),
    filled: defineStyle(
      (props) => inputTheme.variants?.filled(props).field ?? {}
    ),
    unstyled: inputTheme.variants?.unstyled.field ?? {}
  };
  const sizes = {
    xs: inputTheme.sizes?.xs.field ?? {},
    sm: inputTheme.sizes?.sm.field ?? {},
    md: inputTheme.sizes?.md.field ?? {},
    lg: inputTheme.sizes?.lg.field ?? {}
  };
  const textareaTheme = defineStyleConfig({
    baseStyle: baseStyle$2,
    sizes,
    variants: variants$3,
    defaultProps: {
      size: "md",
      variant: "outline"
    }
  });

  const $bg = cssVar("tooltip-bg");
  const $fg = cssVar("tooltip-fg");
  const $arrowBg = cssVar("popper-arrow-bg");
  const baseStyle$1 = defineStyle({
    bg: $bg.reference,
    color: $fg.reference,
    [$bg.variable]: "colors.gray.700",
    [$fg.variable]: "colors.whiteAlpha.900",
    _dark: {
      [$bg.variable]: "colors.gray.300",
      [$fg.variable]: "colors.gray.900"
    },
    [$arrowBg.variable]: $bg.reference,
    px: "2",
    py: "0.5",
    borderRadius: "sm",
    fontWeight: "medium",
    fontSize: "sm",
    boxShadow: "md",
    maxW: "xs",
    zIndex: "tooltip"
  });
  const tooltipTheme = defineStyleConfig({
    baseStyle: baseStyle$1
  });

  const components = {
    Accordion: accordionTheme,
    Alert: alertTheme,
    Avatar: avatarTheme,
    Badge: badgeTheme,
    Breadcrumb: breadcrumbTheme,
    Button: buttonTheme,
    Checkbox: checkboxTheme,
    CloseButton: closeButtonTheme,
    Code: codeTheme,
    Container: containerTheme,
    Divider: dividerTheme,
    Drawer: drawerTheme,
    Editable: editableTheme,
    Form: formTheme,
    FormError: formErrorTheme,
    FormLabel: formLabelTheme,
    Heading: headingTheme,
    Input: inputTheme,
    Kbd: kbdTheme,
    Link: linkTheme,
    List: listTheme,
    Menu: menuTheme,
    Modal: modalTheme,
    NumberInput: numberInputTheme,
    PinInput: pinInputTheme,
    Popover: popoverTheme,
    Progress: progressTheme,
    Radio: radioTheme,
    Select: selectTheme,
    Skeleton: skeletonTheme,
    SkipLink: skipLinkTheme,
    Slider: sliderTheme,
    Spinner: spinnerTheme,
    Stat: statTheme,
    Switch: switchTheme,
    Table: tableTheme,
    Tabs: tabsTheme,
    Tag: tagTheme,
    Textarea: textareaTheme,
    Tooltip: tooltipTheme,
    Card: cardTheme,
    Stepper: stepperTheme
  };

  const borders = {
    none: 0,
    "1px": "1px solid",
    "2px": "2px solid",
    "4px": "4px solid",
    "8px": "8px solid"
  };

  const breakpoints = {
    base: "0em",
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em"
  };

  const colors = {
    transparent: "transparent",
    current: "currentColor",
    black: "#000000",
    white: "#FFFFFF",
    whiteAlpha: {
      50: "rgba(255, 255, 255, 0.04)",
      100: "rgba(255, 255, 255, 0.06)",
      200: "rgba(255, 255, 255, 0.08)",
      300: "rgba(255, 255, 255, 0.16)",
      400: "rgba(255, 255, 255, 0.24)",
      500: "rgba(255, 255, 255, 0.36)",
      600: "rgba(255, 255, 255, 0.48)",
      700: "rgba(255, 255, 255, 0.64)",
      800: "rgba(255, 255, 255, 0.80)",
      900: "rgba(255, 255, 255, 0.92)"
    },
    blackAlpha: {
      50: "rgba(0, 0, 0, 0.04)",
      100: "rgba(0, 0, 0, 0.06)",
      200: "rgba(0, 0, 0, 0.08)",
      300: "rgba(0, 0, 0, 0.16)",
      400: "rgba(0, 0, 0, 0.24)",
      500: "rgba(0, 0, 0, 0.36)",
      600: "rgba(0, 0, 0, 0.48)",
      700: "rgba(0, 0, 0, 0.64)",
      800: "rgba(0, 0, 0, 0.80)",
      900: "rgba(0, 0, 0, 0.92)"
    },
    gray: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923"
    },
    red: {
      50: "#FFF5F5",
      100: "#FED7D7",
      200: "#FEB2B2",
      300: "#FC8181",
      400: "#F56565",
      500: "#E53E3E",
      600: "#C53030",
      700: "#9B2C2C",
      800: "#822727",
      900: "#63171B"
    },
    orange: {
      50: "#FFFAF0",
      100: "#FEEBC8",
      200: "#FBD38D",
      300: "#F6AD55",
      400: "#ED8936",
      500: "#DD6B20",
      600: "#C05621",
      700: "#9C4221",
      800: "#7B341E",
      900: "#652B19"
    },
    yellow: {
      50: "#FFFFF0",
      100: "#FEFCBF",
      200: "#FAF089",
      300: "#F6E05E",
      400: "#ECC94B",
      500: "#D69E2E",
      600: "#B7791F",
      700: "#975A16",
      800: "#744210",
      900: "#5F370E"
    },
    green: {
      50: "#F0FFF4",
      100: "#C6F6D5",
      200: "#9AE6B4",
      300: "#68D391",
      400: "#48BB78",
      500: "#38A169",
      600: "#2F855A",
      700: "#276749",
      800: "#22543D",
      900: "#1C4532"
    },
    teal: {
      50: "#E6FFFA",
      100: "#B2F5EA",
      200: "#81E6D9",
      300: "#4FD1C5",
      400: "#38B2AC",
      500: "#319795",
      600: "#2C7A7B",
      700: "#285E61",
      800: "#234E52",
      900: "#1D4044"
    },
    blue: {
      50: "#ebf8ff",
      100: "#bee3f8",
      200: "#90cdf4",
      300: "#63b3ed",
      400: "#4299e1",
      500: "#3182ce",
      600: "#2b6cb0",
      700: "#2c5282",
      800: "#2a4365",
      900: "#1A365D"
    },
    cyan: {
      50: "#EDFDFD",
      100: "#C4F1F9",
      200: "#9DECF9",
      300: "#76E4F7",
      400: "#0BC5EA",
      500: "#00B5D8",
      600: "#00A3C4",
      700: "#0987A0",
      800: "#086F83",
      900: "#065666"
    },
    purple: {
      50: "#FAF5FF",
      100: "#E9D8FD",
      200: "#D6BCFA",
      300: "#B794F4",
      400: "#9F7AEA",
      500: "#805AD5",
      600: "#6B46C1",
      700: "#553C9A",
      800: "#44337A",
      900: "#322659"
    },
    pink: {
      50: "#FFF5F7",
      100: "#FED7E2",
      200: "#FBB6CE",
      300: "#F687B3",
      400: "#ED64A6",
      500: "#D53F8C",
      600: "#B83280",
      700: "#97266D",
      800: "#702459",
      900: "#521B41"
    }
  };

  const radii = {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px"
  };

  const shadows = {
    xs: "0 0 0 1px rgba(0, 0, 0, 0.05)",
    sm: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    base: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    md: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    lg: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    xl: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "2xl": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    outline: "0 0 0 3px rgba(66, 153, 225, 0.6)",
    inner: "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    none: "none",
    "dark-lg": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px"
  };

  const transitionProperty = {
    common: "background-color, border-color, color, fill, stroke, opacity, box-shadow, transform",
    colors: "background-color, border-color, color, fill, stroke",
    dimensions: "width, height",
    position: "left, right, top, bottom",
    background: "background-color, background-image, background-position"
  };
  const transitionTimingFunction = {
    "ease-in": "cubic-bezier(0.4, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.2, 1)",
    "ease-in-out": "cubic-bezier(0.4, 0, 0.2, 1)"
  };
  const transitionDuration = {
    "ultra-fast": "50ms",
    faster: "100ms",
    fast: "150ms",
    normal: "200ms",
    slow: "300ms",
    slower: "400ms",
    "ultra-slow": "500ms"
  };
  const transition$1 = {
    property: transitionProperty,
    easing: transitionTimingFunction,
    duration: transitionDuration
  };

  const zIndices = {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1e3,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800
  };

  const blur = {
    none: 0,
    sm: "4px",
    base: "8px",
    md: "12px",
    lg: "16px",
    xl: "24px",
    "2xl": "40px",
    "3xl": "64px"
  };

  const foundations = {
    breakpoints,
    zIndices,
    radii,
    blur,
    colors,
    ...typography$1,
    sizes: sizes$m,
    shadows,
    space: spacing,
    borders,
    transition: transition$1
  };

  const semanticTokens = {
    colors: {
      "chakra-body-text": { _light: "gray.800", _dark: "whiteAlpha.900" },
      "chakra-body-bg": { _light: "white", _dark: "gray.800" },
      "chakra-border-color": { _light: "gray.200", _dark: "whiteAlpha.300" },
      "chakra-inverse-text": { _light: "white", _dark: "gray.800" },
      "chakra-subtle-bg": { _light: "gray.100", _dark: "gray.700" },
      "chakra-subtle-text": { _light: "gray.600", _dark: "gray.400" },
      "chakra-placeholder-color": { _light: "gray.500", _dark: "whiteAlpha.400" }
    }
  };

  const styles$3 = {
    global: {
      body: {
        fontFamily: "body",
        color: "chakra-body-text",
        bg: "chakra-body-bg",
        transitionProperty: "background-color",
        transitionDuration: "normal",
        lineHeight: "base"
      },
      "*::placeholder": {
        color: "chakra-placeholder-color"
      },
      "*, *::before, &::after": {
        borderColor: "chakra-border-color"
      }
    }
  };

  const requiredChakraThemeKeys = [
    "borders",
    "breakpoints",
    "colors",
    "components",
    "config",
    "direction",
    "fonts",
    "fontSizes",
    "fontWeights",
    "letterSpacings",
    "lineHeights",
    "radii",
    "shadows",
    "sizes",
    "space",
    "styles",
    "transition",
    "zIndices"
  ];
  function isChakraTheme(unit) {
    if (!isObject$1(unit)) {
      return false;
    }
    return requiredChakraThemeKeys.every(
      (propertyName) => Object.prototype.hasOwnProperty.call(unit, propertyName)
    );
  }

  const direction = "ltr";
  const config = {
    useSystemColorMode: false,
    initialColorMode: "light",
    cssVarPrefix: "chakra"
  };
  const theme$1 = {
    semanticTokens,
    direction,
    ...foundations,
    components,
    styles: styles$3,
    config
  };

  var jsxRuntime = {exports: {}};

  var reactJsxRuntime_production_min = {};

  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredReactJsxRuntime_production_min;

  function requireReactJsxRuntime_production_min () {
  	if (hasRequiredReactJsxRuntime_production_min) return reactJsxRuntime_production_min;
  	hasRequiredReactJsxRuntime_production_min = 1;
  var f=React,k=Symbol.for("react.element"),l=Symbol.for("react.fragment"),m=Object.prototype.hasOwnProperty,n=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,p={key:true,ref:true,__self:true,__source:true};
  	function q(c,a,g){var b,d={},e=null,h=null;void 0!==g&&(e=""+g);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(h=a.ref);for(b in a)m.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a) void 0===d[b]&&(d[b]=a[b]);return {$$typeof:k,type:c,key:e,ref:h,props:d,_owner:n.current}}reactJsxRuntime_production_min.Fragment=l;reactJsxRuntime_production_min.jsx=q;reactJsxRuntime_production_min.jsxs=q;
  	return reactJsxRuntime_production_min;
  }

  var hasRequiredJsxRuntime;

  function requireJsxRuntime () {
  	if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  	hasRequiredJsxRuntime = 1;

  	{
  	  jsxRuntime.exports = requireReactJsxRuntime_production_min();
  	}
  	return jsxRuntime.exports;
  }

  var jsxRuntimeExports = requireJsxRuntime();

  /*

  Based off glamor's StyleSheet, thanks Sunil ❤️

  high performance StyleSheet for css-in-js systems

  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance

  // usage

  import { StyleSheet } from '@emotion/sheet'

  let styleSheet = new StyleSheet({ key: '', container: document.head })

  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet

  styleSheet.flush()
  - empties the stylesheet of all its contents

  */

  function sheetForTag(tag) {
    if (tag.sheet) {
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        return document.styleSheets[i];
      }
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here


    return undefined;
  }

  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);

    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }

    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
  }

  var StyleSheet = /*#__PURE__*/function () {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
      var _this = this;

      this._insertTag = function (tag) {
        var before;

        if (_this.tags.length === 0) {
          if (_this.insertionPoint) {
            before = _this.insertionPoint.nextSibling;
          } else if (_this.prepend) {
            before = _this.container.firstChild;
          } else {
            before = _this.before;
          }
        } else {
          before = _this.tags[_this.tags.length - 1].nextSibling;
        }

        _this.container.insertBefore(tag, before);

        _this.tags.push(tag);
      };

      this.isSpeedy = options.speedy === undefined ? true : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.prepend = options.prepend;
      this.insertionPoint = options.insertionPoint;
      this.before = null;
    }

    var _proto = StyleSheet.prototype;

    _proto.hydrate = function hydrate(nodes) {
      nodes.forEach(this._insertTag);
    };

    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        this._insertTag(createStyleElement(this));
      }

      var tag = this.tags[this.tags.length - 1];

      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);

        try {
          // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools
          sheet.insertRule(rule, sheet.cssRules.length);
        } catch (e) {
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }

      this.ctr++;
    };

    _proto.flush = function flush() {
      this.tags.forEach(function (tag) {
        var _tag$parentNode;

        return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;
    };

    return StyleSheet;
  }();

  var MS = '-ms-';
  var MOZ = '-moz-';
  var WEBKIT = '-webkit-';

  var COMMENT = 'comm';
  var RULESET = 'rule';
  var DECLARATION = 'decl';
  var IMPORT = '@import';
  var KEYFRAMES = '@keyframes';
  var LAYER = '@layer';

  /**
   * @param {number}
   * @return {number}
   */
  var abs = Math.abs;

  /**
   * @param {number}
   * @return {string}
   */
  var from = String.fromCharCode;

  /**
   * @param {object}
   * @return {object}
   */
  var assign$1 = Object.assign;

  /**
   * @param {string} value
   * @param {number} length
   * @return {number}
   */
  function hash$2 (value, length) {
  	return charat(value, 0) ^ 45 ? (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3) : 0
  }

  /**
   * @param {string} value
   * @return {string}
   */
  function trim (value) {
  	return value.trim()
  }

  /**
   * @param {string} value
   * @param {RegExp} pattern
   * @return {string?}
   */
  function match$1 (value, pattern) {
  	return (value = pattern.exec(value)) ? value[0] : value
  }

  /**
   * @param {string} value
   * @param {(string|RegExp)} pattern
   * @param {string} replacement
   * @return {string}
   */
  function replace (value, pattern, replacement) {
  	return value.replace(pattern, replacement)
  }

  /**
   * @param {string} value
   * @param {string} search
   * @return {number}
   */
  function indexof (value, search) {
  	return value.indexOf(search)
  }

  /**
   * @param {string} value
   * @param {number} index
   * @return {number}
   */
  function charat (value, index) {
  	return value.charCodeAt(index) | 0
  }

  /**
   * @param {string} value
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function substr (value, begin, end) {
  	return value.slice(begin, end)
  }

  /**
   * @param {string} value
   * @return {number}
   */
  function strlen (value) {
  	return value.length
  }

  /**
   * @param {any[]} value
   * @return {number}
   */
  function sizeof (value) {
  	return value.length
  }

  /**
   * @param {any} value
   * @param {any[]} array
   * @return {any}
   */
  function append (value, array) {
  	return array.push(value), value
  }

  /**
   * @param {string[]} array
   * @param {function} callback
   * @return {string}
   */
  function combine (array, callback) {
  	return array.map(callback).join('')
  }

  var line = 1;
  var column = 1;
  var length = 0;
  var position$1 = 0;
  var character = 0;
  var characters = '';

  /**
   * @param {string} value
   * @param {object | null} root
   * @param {object | null} parent
   * @param {string} type
   * @param {string[] | string} props
   * @param {object[] | string} children
   * @param {number} length
   */
  function node (value, root, parent, type, props, children, length) {
  	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
  }

  /**
   * @param {object} root
   * @param {object} props
   * @return {object}
   */
  function copy (root, props) {
  	return assign$1(node('', null, null, '', null, null, 0), root, {length: -root.length}, props)
  }

  /**
   * @return {number}
   */
  function char () {
  	return character
  }

  /**
   * @return {number}
   */
  function prev () {
  	character = position$1 > 0 ? charat(characters, --position$1) : 0;

  	if (column--, character === 10)
  		column = 1, line--;

  	return character
  }

  /**
   * @return {number}
   */
  function next () {
  	character = position$1 < length ? charat(characters, position$1++) : 0;

  	if (column++, character === 10)
  		column = 1, line++;

  	return character
  }

  /**
   * @return {number}
   */
  function peek () {
  	return charat(characters, position$1)
  }

  /**
   * @return {number}
   */
  function caret () {
  	return position$1
  }

  /**
   * @param {number} begin
   * @param {number} end
   * @return {string}
   */
  function slice (begin, end) {
  	return substr(characters, begin, end)
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function token (type) {
  	switch (type) {
  		// \0 \t \n \r \s whitespace token
  		case 0: case 9: case 10: case 13: case 32:
  			return 5
  		// ! + , / > @ ~ isolate token
  		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
  		// ; { } breakpoint token
  		case 59: case 123: case 125:
  			return 4
  		// : accompanied token
  		case 58:
  			return 3
  		// " ' ( [ opening delimit token
  		case 34: case 39: case 40: case 91:
  			return 2
  		// ) ] closing delimit token
  		case 41: case 93:
  			return 1
  	}

  	return 0
  }

  /**
   * @param {string} value
   * @return {any[]}
   */
  function alloc (value) {
  	return line = column = 1, length = strlen(characters = value), position$1 = 0, []
  }

  /**
   * @param {any} value
   * @return {any}
   */
  function dealloc (value) {
  	return characters = '', value
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function delimit (type) {
  	return trim(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
  }

  /**
   * @param {number} type
   * @return {string}
   */
  function whitespace (type) {
  	while (character = peek())
  		if (character < 33)
  			next();
  		else
  			break

  	return token(type) > 2 || token(character) > 3 ? '' : ' '
  }

  /**
   * @param {number} index
   * @param {number} count
   * @return {string}
   */
  function escaping (index, count) {
  	while (--count && next())
  		// not 0-9 A-F a-f
  		if (character < 48 || character > 102 || (character > 57 && character < 65) || (character > 70 && character < 97))
  			break

  	return slice(index, caret() + (count < 6 && peek() == 32 && next() == 32))
  }

  /**
   * @param {number} type
   * @return {number}
   */
  function delimiter (type) {
  	while (next())
  		switch (character) {
  			// ] ) " '
  			case type:
  				return position$1
  			// " '
  			case 34: case 39:
  				if (type !== 34 && type !== 39)
  					delimiter(character);
  				break
  			// (
  			case 40:
  				if (type === 41)
  					delimiter(type);
  				break
  			// \
  			case 92:
  				next();
  				break
  		}

  	return position$1
  }

  /**
   * @param {number} type
   * @param {number} index
   * @return {number}
   */
  function commenter (type, index) {
  	while (next())
  		// //
  		if (type + character === 47 + 10)
  			break
  		// /*
  		else if (type + character === 42 + 42 && peek() === 47)
  			break

  	return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next())
  }

  /**
   * @param {number} index
   * @return {string}
   */
  function identifier (index) {
  	while (!token(peek()))
  		next();

  	return slice(index, position$1)
  }

  /**
   * @param {string} value
   * @return {object[]}
   */
  function compile (value) {
  	return dealloc(parse$4('', null, null, null, [''], value = alloc(value), 0, [0], value))
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {string[]} rule
   * @param {string[]} rules
   * @param {string[]} rulesets
   * @param {number[]} pseudo
   * @param {number[]} points
   * @param {string[]} declarations
   * @return {object}
   */
  function parse$4 (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
  	var index = 0;
  	var offset = 0;
  	var length = pseudo;
  	var atrule = 0;
  	var property = 0;
  	var previous = 0;
  	var variable = 1;
  	var scanning = 1;
  	var ampersand = 1;
  	var character = 0;
  	var type = '';
  	var props = rules;
  	var children = rulesets;
  	var reference = rule;
  	var characters = type;

  	while (scanning)
  		switch (previous = character, character = next()) {
  			// (
  			case 40:
  				if (previous != 108 && charat(characters, length - 1) == 58) {
  					if (indexof(characters += replace(delimit(character), '&', '&\f'), '&\f') != -1)
  						ampersand = -1;
  					break
  				}
  			// " ' [
  			case 34: case 39: case 91:
  				characters += delimit(character);
  				break
  			// \t \n \r \s
  			case 9: case 10: case 13: case 32:
  				characters += whitespace(previous);
  				break
  			// \
  			case 92:
  				characters += escaping(caret() - 1, 7);
  				continue
  			// /
  			case 47:
  				switch (peek()) {
  					case 42: case 47:
  						append(comment(commenter(next(), caret()), root, parent), declarations);
  						break
  					default:
  						characters += '/';
  				}
  				break
  			// {
  			case 123 * variable:
  				points[index++] = strlen(characters) * ampersand;
  			// } ; \0
  			case 125 * variable: case 59: case 0:
  				switch (character) {
  					// \0 }
  					case 0: case 125: scanning = 0;
  					// ;
  					case 59 + offset: if (ampersand == -1) characters = replace(characters, /\f/g, '');
  						if (property > 0 && (strlen(characters) - length))
  							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
  						break
  					// @ ;
  					case 59: characters += ';';
  					// { rule/at-rule
  					default:
  						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

  						if (character === 123)
  							if (offset === 0)
  								parse$4(characters, root, reference, reference, props, rulesets, length, points, children);
  							else
  								switch (atrule === 99 && charat(characters, 3) === 110 ? 100 : atrule) {
  									// d l m s
  									case 100: case 108: case 109: case 115:
  										parse$4(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
  										break
  									default:
  										parse$4(characters, reference, reference, reference, [''], children, 0, points, children);
  								}
  				}

  				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
  				break
  			// :
  			case 58:
  				length = 1 + strlen(characters), property = previous;
  			default:
  				if (variable < 1)
  					if (character == 123)
  						--variable;
  					else if (character == 125 && variable++ == 0 && prev() == 125)
  						continue

  				switch (characters += from(character), character * variable) {
  					// &
  					case 38:
  						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
  						break
  					// ,
  					case 44:
  						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
  						break
  					// @
  					case 64:
  						// -
  						if (peek() === 45)
  							characters += delimit(next());

  						atrule = peek(), offset = length = strlen(type = characters += identifier(caret())), character++;
  						break
  					// -
  					case 45:
  						if (previous === 45 && strlen(characters) == 2)
  							variable = 0;
  				}
  		}

  	return rulesets
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} index
   * @param {number} offset
   * @param {string[]} rules
   * @param {number[]} points
   * @param {string} type
   * @param {string[]} props
   * @param {string[]} children
   * @param {number} length
   * @return {object}
   */
  function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
  	var post = offset - 1;
  	var rule = offset === 0 ? rules : [''];
  	var size = sizeof(rule);

  	for (var i = 0, j = 0, k = 0; i < index; ++i)
  		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
  			if (z = trim(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
  				props[k++] = z;

  	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
  }

  /**
   * @param {number} value
   * @param {object} root
   * @param {object?} parent
   * @return {object}
   */
  function comment (value, root, parent) {
  	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
  }

  /**
   * @param {string} value
   * @param {object} root
   * @param {object?} parent
   * @param {number} length
   * @return {object}
   */
  function declaration (value, root, parent, length) {
  	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
  }

  /**
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function serialize (children, callback) {
  	var output = '';
  	var length = sizeof(children);

  	for (var i = 0; i < length; i++)
  		output += callback(children[i], i, children, callback) || '';

  	return output
  }

  /**
   * @param {object} element
   * @param {number} index
   * @param {object[]} children
   * @param {function} callback
   * @return {string}
   */
  function stringify (element, index, children, callback) {
  	switch (element.type) {
  		case LAYER: if (element.children.length) break
  		case IMPORT: case DECLARATION: return element.return = element.return || element.value
  		case COMMENT: return ''
  		case KEYFRAMES: return element.return = element.value + '{' + serialize(element.children, callback) + '}'
  		case RULESET: element.value = element.props.join(',');
  	}

  	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
  }

  /**
   * @param {function[]} collection
   * @return {function}
   */
  function middleware (collection) {
  	var length = sizeof(collection);

  	return function (element, index, children, callback) {
  		var output = '';

  		for (var i = 0; i < length; i++)
  			output += collection[i](element, index, children, callback) || '';

  		return output
  	}
  }

  /**
   * @param {function} callback
   * @return {function}
   */
  function rulesheet (callback) {
  	return function (element) {
  		if (!element.root)
  			if (element = element.return)
  				callback(element);
  	}
  }

  var weakMemoize = function weakMemoize(func) {
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  function memoize$1(fn) {
    var cache = Object.create(null);
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;

    while (true) {
      previous = character;
      character = peek(); // &\f

      if (previous === 38 && character === 12) {
        points[index] = 1;
      }

      if (token(character)) {
        break;
      }

      next();
    }

    return slice(begin, position$1);
  };

  var toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;

    do {
      switch (token(character)) {
        case 0:
          // &\f
          if (character === 38 && peek() === 12) {
            // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
          }

          parsed[index] += identifierWithPointTracking(position$1 - 1, points, index);
          break;

        case 2:
          parsed[index] += delimit(character);
          break;

        case 4:
          // comma
          if (character === 44) {
            // colon
            parsed[++index] = peek() === 58 ? '&\f' : '';
            points[index] = parsed[index].length;
            break;
          }

        // fallthrough

        default:
          parsed[index] += from(character);
      }
    } while (character = next());

    return parsed;
  };

  var getRules = function getRules(value, points) {
    return dealloc(toRules(alloc(value), points));
  }; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


  var fixedElements = /* #__PURE__ */new WeakMap();
  var compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) {
      return;
    }

    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;

    while (parent.type !== 'rule') {
      parent = parent.parent;
      if (!parent) return;
    } // short-circuit for the simplest case


    if (element.props.length === 1 && value.charCodeAt(0) !== 58
    /* colon */
    && !fixedElements.get(parent)) {
      return;
    } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


    if (isImplicitRule) {
      return;
    }

    fixedElements.set(element, true);
    var points = [];
    var rules = getRules(value, points);
    var parentRules = parent.props;

    for (var i = 0, k = 0; i < rules.length; i++) {
      for (var j = 0; j < parentRules.length; j++, k++) {
        element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
      }
    }
  };
  var removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
      var value = element.value;

      if ( // charcode for l
      value.charCodeAt(0) === 108 && // charcode for b
      value.charCodeAt(2) === 98) {
        // this ignores label
        element["return"] = '';
        element.value = '';
      }
    }
  };

  /* eslint-disable no-fallthrough */

  function prefix(value, length) {
    switch (hash$2(value, length)) {
      // color-adjust
      case 5103:
        return WEBKIT + 'print-' + value + value;
      // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)

      case 5737:
      case 4201:
      case 3177:
      case 3433:
      case 1641:
      case 4457:
      case 2921: // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break

      case 5572:
      case 6356:
      case 5844:
      case 3191:
      case 6645:
      case 3005: // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,

      case 6391:
      case 5879:
      case 5623:
      case 6135:
      case 4599:
      case 4855: // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)

      case 4215:
      case 6389:
      case 5109:
      case 5365:
      case 5621:
      case 3829:
        return WEBKIT + value + value;
      // appearance, user-select, transform, hyphens, text-size-adjust

      case 5349:
      case 4246:
      case 4810:
      case 6968:
      case 2756:
        return WEBKIT + value + MOZ + value + MS + value + value;
      // flex, flex-direction

      case 6828:
      case 4268:
        return WEBKIT + value + MS + value + value;
      // order

      case 6165:
        return WEBKIT + value + MS + 'flex-' + value + value;
      // align-items

      case 5187:
        return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value;
      // align-self

      case 5443:
        return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value;
      // align-content

      case 4675:
        return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value;
      // flex-shrink

      case 5548:
        return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value;
      // flex-basis

      case 5292:
        return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value;
      // flex-grow

      case 6060:
        return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value;
      // transition

      case 4554:
        return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value;
      // cursor

      case 6187:
        return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value;
      // background, background-image

      case 5495:
      case 3959:
        return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1');
      // justify-content

      case 4968:
        return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value;
      // (margin|padding)-inline-(start|end)

      case 4095:
      case 3583:
      case 4068:
      case 2532:
        return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value;
      // (min|max)?(width|height|inline-size|block-size)

      case 8116:
      case 7059:
      case 5753:
      case 5535:
      case 5445:
      case 5701:
      case 4933:
      case 4677:
      case 5533:
      case 5789:
      case 5021:
      case 4765:
        // stretch, max-content, min-content, fill-available
        if (strlen(value) - 1 - length > 6) switch (charat(value, length + 1)) {
          // (m)ax-content, (m)in-content
          case 109:
            // -
            if (charat(value, length + 4) !== 45) break;
          // (f)ill-available, (f)it-content

          case 102:
            return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (charat(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
          // (s)tretch

          case 115:
            return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value;
        }
        break;
      // position: sticky

      case 4949:
        // (s)ticky?
        if (charat(value, length + 1) !== 115) break;
      // display: (flex|inline-flex)

      case 6444:
        switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
          // stic(k)y
          case 107:
            return replace(value, ':', ':' + WEBKIT) + value;
          // (inline-)?fl(e)x

          case 101:
            return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value;
        }

        break;
      // writing-mode

      case 5936:
        switch (charat(value, length + 11)) {
          // vertical-l(r)
          case 114:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
          // vertical-r(l)

          case 108:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
          // horizontal(-)tb

          case 45:
            return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
        }

        return WEBKIT + value + MS + value + value;
    }

    return value;
  }

  var prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) if (!element["return"]) switch (element.type) {
      case DECLARATION:
        element["return"] = prefix(element.value, element.length);
        break;

      case KEYFRAMES:
        return serialize([copy(element, {
          value: replace(element.value, '@', '@' + WEBKIT)
        })], callback);

      case RULESET:
        if (element.length) return combine(element.props, function (value) {
          switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
            // :read-(only|write)
            case ':read-only':
            case ':read-write':
              return serialize([copy(element, {
                props: [replace(value, /:(read-\w+)/, ':' + MOZ + '$1')]
              })], callback);
            // :placeholder

            case '::placeholder':
              return serialize([copy(element, {
                props: [replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1')]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, ':' + MOZ + '$1')]
              }), copy(element, {
                props: [replace(value, /:(plac\w+)/, MS + 'input-$1')]
              })], callback);
          }

          return '';
        });
    }
  };

  var defaultStylisPlugins = [prefixer];

  var createCache = function createCache(options) {
    var key = options.key;

    if (key === 'css') {
      var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
      // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
      // note this very very intentionally targets all style elements regardless of the key to ensure
      // that creating a cache works inside of render of a React component

      Array.prototype.forEach.call(ssrStyles, function (node) {
        // we want to only move elements which have a space in the data-emotion attribute value
        // because that indicates that it is an Emotion 11 server-side rendered style elements
        // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
        // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
        // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
        // will not result in the Emotion 10 styles being destroyed
        var dataEmotionAttribute = node.getAttribute('data-emotion');

        if (dataEmotionAttribute.indexOf(' ') === -1) {
          return;
        }

        document.head.appendChild(node);
        node.setAttribute('data-s', '');
      });
    }

    var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

    var inserted = {};
    var container;
    var nodesToHydrate = [];

    {
      container = options.container || document.head;
      Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
      // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
      document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
        var attrib = node.getAttribute("data-emotion").split(' ');

        for (var i = 1; i < attrib.length; i++) {
          inserted[attrib[i]] = true;
        }

        nodesToHydrate.push(node);
      });
    }

    var _insert;

    var omnipresentPlugins = [compat, removeLabel];

    {
      var currentSheet;
      var finalizingPlugins = [stringify, rulesheet(function (rule) {
        currentSheet.insert(rule);
      })];
      var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

      var stylis = function stylis(styles) {
        return serialize(compile(styles), serializer);
      };

      _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;

        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

        if (shouldCache) {
          cache.inserted[serialized.name] = true;
        }
      };
    }

    var cache = {
      key: key,
      sheet: new StyleSheet({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy,
        prepend: options.prepend,
        insertionPoint: options.insertionPoint
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
  };

  var reactIs$1 = {exports: {}};

  var reactIs_production_min$1 = {};

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredReactIs_production_min$1;

  function requireReactIs_production_min$1 () {
  	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
  	hasRequiredReactIs_production_min$1 = 1;
  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
  	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
  	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$1.AsyncMode=l;reactIs_production_min$1.ConcurrentMode=m;reactIs_production_min$1.ContextConsumer=k;reactIs_production_min$1.ContextProvider=h;reactIs_production_min$1.Element=c;reactIs_production_min$1.ForwardRef=n;reactIs_production_min$1.Fragment=e;reactIs_production_min$1.Lazy=t;reactIs_production_min$1.Memo=r;reactIs_production_min$1.Portal=d;
  	reactIs_production_min$1.Profiler=g;reactIs_production_min$1.StrictMode=f;reactIs_production_min$1.Suspense=p;reactIs_production_min$1.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$1.isConcurrentMode=A;reactIs_production_min$1.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$1.isContextProvider=function(a){return z(a)===h};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$1.isForwardRef=function(a){return z(a)===n};reactIs_production_min$1.isFragment=function(a){return z(a)===e};reactIs_production_min$1.isLazy=function(a){return z(a)===t};
  	reactIs_production_min$1.isMemo=function(a){return z(a)===r};reactIs_production_min$1.isPortal=function(a){return z(a)===d};reactIs_production_min$1.isProfiler=function(a){return z(a)===g};reactIs_production_min$1.isStrictMode=function(a){return z(a)===f};reactIs_production_min$1.isSuspense=function(a){return z(a)===p};
  	reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$1.typeOf=z;
  	return reactIs_production_min$1;
  }

  var hasRequiredReactIs$1;

  function requireReactIs$1 () {
  	if (hasRequiredReactIs$1) return reactIs$1.exports;
  	hasRequiredReactIs$1 = 1;

  	{
  	  reactIs$1.exports = requireReactIs_production_min$1();
  	}
  	return reactIs$1.exports;
  }

  var hoistNonReactStatics_cjs;
  var hasRequiredHoistNonReactStatics_cjs;

  function requireHoistNonReactStatics_cjs () {
  	if (hasRequiredHoistNonReactStatics_cjs) return hoistNonReactStatics_cjs;
  	hasRequiredHoistNonReactStatics_cjs = 1;

  	var reactIs = requireReactIs$1();

  	/**
  	 * Copyright 2015, Yahoo! Inc.
  	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
  	 */
  	var REACT_STATICS = {
  	  childContextTypes: true,
  	  contextType: true,
  	  contextTypes: true,
  	  defaultProps: true,
  	  displayName: true,
  	  getDefaultProps: true,
  	  getDerivedStateFromError: true,
  	  getDerivedStateFromProps: true,
  	  mixins: true,
  	  propTypes: true,
  	  type: true
  	};
  	var KNOWN_STATICS = {
  	  name: true,
  	  length: true,
  	  prototype: true,
  	  caller: true,
  	  callee: true,
  	  arguments: true,
  	  arity: true
  	};
  	var FORWARD_REF_STATICS = {
  	  '$$typeof': true,
  	  render: true,
  	  defaultProps: true,
  	  displayName: true,
  	  propTypes: true
  	};
  	var MEMO_STATICS = {
  	  '$$typeof': true,
  	  compare: true,
  	  defaultProps: true,
  	  displayName: true,
  	  propTypes: true,
  	  type: true
  	};
  	var TYPE_STATICS = {};
  	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
  	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

  	function getStatics(component) {
  	  // React v16.11 and below
  	  if (reactIs.isMemo(component)) {
  	    return MEMO_STATICS;
  	  } // React v16.12 and above


  	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
  	}

  	var defineProperty = Object.defineProperty;
  	var getOwnPropertyNames = Object.getOwnPropertyNames;
  	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  	var getPrototypeOf = Object.getPrototypeOf;
  	var objectPrototype = Object.prototype;
  	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  	  if (typeof sourceComponent !== 'string') {
  	    // don't hoist over string (html) components
  	    if (objectPrototype) {
  	      var inheritedComponent = getPrototypeOf(sourceComponent);

  	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
  	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
  	      }
  	    }

  	    var keys = getOwnPropertyNames(sourceComponent);

  	    if (getOwnPropertySymbols) {
  	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
  	    }

  	    var targetStatics = getStatics(targetComponent);
  	    var sourceStatics = getStatics(sourceComponent);

  	    for (var i = 0; i < keys.length; ++i) {
  	      var key = keys[i];

  	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
  	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

  	        try {
  	          // Avoid failures from read-only properties
  	          defineProperty(targetComponent, key, descriptor);
  	        } catch (e) {}
  	      }
  	    }
  	  }

  	  return targetComponent;
  	}

  	hoistNonReactStatics_cjs = hoistNonReactStatics;
  	return hoistNonReactStatics_cjs;
  }

  requireHoistNonReactStatics_cjs();

  var isBrowser$1 = true;

  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className] + ";");
      } else if (className) {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }
  var registerStyles = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false ) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }
  };
  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    registerStyles(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;

    if (cache.inserted[serialized.name] === undefined) {
      var current = serialized;

      do {
        cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

        current = current.next;
      } while (current !== undefined);
    }
  };

  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = /* #__PURE__ */memoize$1(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  function handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) {
      return '';
    }

    var componentSelector = interpolation;

    if (componentSelector.__emotion_styles !== undefined) {

      return componentSelector;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          var keyframes = interpolation;

          if (keyframes.anim === 1) {
            cursor = {
              name: keyframes.name,
              styles: keyframes.styles,
              next: cursor
            };
            return keyframes.name;
          }

          var serializedStyles = interpolation;

          if (serializedStyles.styles !== undefined) {
            var next = serializedStyles.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = serializedStyles.styles + ";";
            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result);
          }

          break;
        }
    } // finalize string values (regular strings and functions interpolated into css calls)


    var asString = interpolation;

    if (registered == null) {
      return asString;
    }

    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
      }
    } else {
      for (var key in obj) {
        var value = obj[key];

        if (typeof value !== 'object') {
          var asString = value;

          if (registered != null && registered[asString] !== undefined) {
            string += key + "{" + registered[asString] + "}";
          } else if (isProcessableValue(asString)) {
            string += processStyleName(key) + ":" + processStyleValue(key, asString) + ";";
          }
        } else {

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(key) + ":" + processStyleValue(key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value);

            switch (key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {

                  string += key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list

  var cursor;
  function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings);
    } else {
      var asTemplateStringsArr = strings;

      styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i]);

      if (stringMode) {
        var templateStringsArr = strings;

        styles += templateStringsArr[i];
      }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + match[1];
    }

    var name = murmur2(styles) + identifierName;

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  }

  var syncFallback = function syncFallback(create) {
    return create();
  };

  var useInsertionEffect = React__namespace['useInsertion' + 'Effect'] ? React__namespace['useInsertion' + 'Effect'] : false;
  var useInsertionEffectAlwaysWithSyncFallback = useInsertionEffect || syncFallback;
  var useInsertionEffectWithLayoutFallback = useInsertionEffect || React__namespace.useLayoutEffect;

  var EmotionCacheContext = /* #__PURE__ */React__namespace.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache({
    key: 'css'
  }) : null);

  EmotionCacheContext.Provider;
  var __unsafe_useEmotionCache = function useEmotionCache() {
    return React.useContext(EmotionCacheContext);
  };

  var withEmotionCache = function withEmotionCache(func) {
    return /*#__PURE__*/React.forwardRef(function (props, ref) {
      // the cache will never be null in the browser
      var cache = React.useContext(EmotionCacheContext);
      return func(props, cache, ref);
    });
  };

  var ThemeContext = /* #__PURE__ */React__namespace.createContext({});

  var getTheme$1 = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
      var mergedTheme = theme(outerTheme);

      return mergedTheme;
    }

    return _extends$1({}, outerTheme, theme);
  };

  var createCacheWithTheme = /* #__PURE__ */weakMemoize(function (outerTheme) {
    return weakMemoize(function (theme) {
      return getTheme$1(outerTheme, theme);
    });
  });
  var ThemeProvider$1 = function ThemeProvider(props) {
    var theme = React__namespace.useContext(ThemeContext);

    if (props.theme !== theme) {
      theme = createCacheWithTheme(theme)(props.theme);
    }

    return /*#__PURE__*/React__namespace.createElement(ThemeContext.Provider, {
      value: theme
    }, props.children);
  };

  var hasOwn = {}.hasOwnProperty;

  var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
  var createEmotionProps = function createEmotionProps(type, props) {

    var newProps = {};

    for (var _key in props) {
      if (hasOwn.call(props, _key)) {
        newProps[_key] = props[_key];
      }
    }

    newProps[typePropName] = type; // Runtime labeling is an opt-in feature because:

    return newProps;
  };

  var Insertion$1 = function Insertion(_ref) {
    var cache = _ref.cache,
        serialized = _ref.serialized,
        isStringTag = _ref.isStringTag;
    registerStyles(cache, serialized, isStringTag);
    useInsertionEffectAlwaysWithSyncFallback(function () {
      return insertStyles(cache, serialized, isStringTag);
    });

    return null;
  };

  var Emotion = /* #__PURE__ */withEmotionCache(function (props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible

    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
      cssProp = cache.registered[cssProp];
    }

    var WrappedComponent = props[typePropName];
    var registeredStyles = [cssProp];
    var className = '';

    if (typeof props.className === 'string') {
      className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
    } else if (props.className != null) {
      className = props.className + " ";
    }

    var serialized = serializeStyles(registeredStyles, undefined, React__namespace.useContext(ThemeContext));

    className += cache.key + "-" + serialized.name;
    var newProps = {};

    for (var _key2 in props) {
      if (hasOwn.call(props, _key2) && _key2 !== 'css' && _key2 !== typePropName && (true )) {
        newProps[_key2] = props[_key2];
      }
    }

    newProps.className = className;

    if (ref) {
      newProps.ref = ref;
    }

    return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion$1, {
      cache: cache,
      serialized: serialized,
      isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/React__namespace.createElement(WrappedComponent, newProps));
  });

  var Emotion$1 = Emotion;

  var jsx = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;

    if (props == null || !hasOwn.call(props, 'css')) {
      return React__namespace.createElement.apply(undefined, args);
    }

    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = Emotion$1;
    createElementArgArray[1] = createEmotionProps(type, props);

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    }

    return React__namespace.createElement.apply(null, createElementArgArray);
  };

  (function (_jsx) {
    var JSX;

    (function (_JSX) {})(JSX || (JSX = _jsx.JSX || (_jsx.JSX = {})));
  })(jsx || (jsx = {}));

  // initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
  // initial client-side render from SSR, use place of hydrating tag

  var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {

    var styles = props.styles;
    var serialized = serializeStyles([styles], undefined, React__namespace.useContext(ThemeContext));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything


    var sheetRef = React__namespace.useRef();
    useInsertionEffectWithLayoutFallback(function () {
      var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675

      var sheet = new cache.sheet.constructor({
        key: key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy
      });
      var rehydrating = false;
      var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

      if (cache.sheet.tags.length) {
        sheet.before = cache.sheet.tags[0];
      }

      if (node !== null) {
        rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

        node.setAttribute('data-emotion', key);
        sheet.hydrate([node]);
      }

      sheetRef.current = [sheet, rehydrating];
      return function () {
        sheet.flush();
      };
    }, [cache]);
    useInsertionEffectWithLayoutFallback(function () {
      var sheetRefCurrent = sheetRef.current;
      var sheet = sheetRefCurrent[0],
          rehydrating = sheetRefCurrent[1];

      if (rehydrating) {
        sheetRefCurrent[1] = false;
        return;
      }

      if (serialized.next !== undefined) {
        // insert keyframes
        insertStyles(cache, serialized.next, true);
      }

      if (sheet.tags.length) {
        // if this doesn't exist then it will be null so the style element will be appended
        var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
        sheet.before = element;
        sheet.flush();
      }

      cache.insert("", serialized, sheet, false);
    }, [cache, serialized.name]);
    return null;
  });

  function css$2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return serializeStyles(args);
  }

  function keyframes$2() {
    var insertable = css$2.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  }

  const ColorModeContext$1 = React.createContext({});
  ColorModeContext$1.displayName = "ColorModeContext";
  function useColorMode$1() {
    const context = React.useContext(ColorModeContext$1);
    if (context === void 0) {
      throw new Error("useColorMode must be used within a ColorModeProvider");
    }
    return context;
  }

  const classNames = {
    light: "chakra-ui-light",
    dark: "chakra-ui-dark"
  };
  function getColorModeUtils(options = {}) {
    const { preventTransition = true, nonce } = options;
    const utils = {
      setDataset: (value) => {
        const cleanup = preventTransition ? utils.preventTransition() : void 0;
        document.documentElement.dataset.theme = value;
        document.documentElement.style.colorScheme = value;
        cleanup?.();
      },
      setClassName(dark) {
        document.body.classList.add(dark ? classNames.dark : classNames.light);
        document.body.classList.remove(dark ? classNames.light : classNames.dark);
      },
      query() {
        return window.matchMedia("(prefers-color-scheme: dark)");
      },
      getSystemTheme(fallback) {
        const dark = utils.query().matches ?? fallback === "dark";
        return dark ? "dark" : "light";
      },
      addListener(fn) {
        const mql = utils.query();
        const listener = (e) => {
          fn(e.matches ? "dark" : "light");
        };
        if (typeof mql.addListener === "function")
          mql.addListener(listener);
        else
          mql.addEventListener("change", listener);
        return () => {
          if (typeof mql.removeListener === "function")
            mql.removeListener(listener);
          else
            mql.removeEventListener("change", listener);
        };
      },
      preventTransition() {
        const css = document.createElement("style");
        css.appendChild(
          document.createTextNode(
            `*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}`
          )
        );
        if (nonce !== void 0) {
          css.nonce = nonce;
        }
        document.head.appendChild(css);
        return () => {
          (() => window.getComputedStyle(document.body))();
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              document.head.removeChild(css);
            });
          });
        };
      }
    };
    return utils;
  }

  const STORAGE_KEY = "chakra-ui-color-mode";
  function createLocalStorageManager(key) {
    return {
      ssr: false,
      type: "localStorage",
      get(init) {
        if (!globalThis?.document)
          return init;
        let value;
        try {
          value = localStorage.getItem(key) || init;
        } catch (e) {
        }
        return value || init;
      },
      set(value) {
        try {
          localStorage.setItem(key, value);
        } catch (e) {
        }
      }
    };
  }
  const localStorageManager = createLocalStorageManager(STORAGE_KEY);

  const noop$1 = () => {
  };
  const useSafeLayoutEffect$1 = isBrowser$2() ? React.useLayoutEffect : React.useEffect;
  function getTheme(manager, fallback) {
    return manager.type === "cookie" && manager.ssr ? manager.get(fallback) : fallback;
  }
  const ColorModeProvider = function ColorModeProvider2(props) {
    const {
      value,
      children,
      options: {
        useSystemColorMode,
        initialColorMode,
        disableTransitionOnChange
      } = {},
      colorModeManager = localStorageManager
    } = props;
    const cache = __unsafe_useEmotionCache();
    const defaultColorMode = initialColorMode === "dark" ? "dark" : "light";
    const [colorMode, rawSetColorMode] = React.useState(
      () => getTheme(colorModeManager, defaultColorMode)
    );
    const [resolvedColorMode, setResolvedColorMode] = React.useState(
      () => getTheme(colorModeManager)
    );
    const { getSystemTheme, setClassName, setDataset, addListener } = React.useMemo(
      () => getColorModeUtils({
        preventTransition: disableTransitionOnChange,
        nonce: cache?.nonce
      }),
      [disableTransitionOnChange, cache?.nonce]
    );
    const resolvedValue = initialColorMode === "system" && !colorMode ? resolvedColorMode : colorMode;
    const setColorMode = React.useCallback(
      (value2) => {
        const resolved = value2 === "system" ? getSystemTheme() : value2;
        rawSetColorMode(resolved);
        setClassName(resolved === "dark");
        setDataset(resolved);
        colorModeManager.set(resolved);
      },
      [colorModeManager, getSystemTheme, setClassName, setDataset]
    );
    useSafeLayoutEffect$1(() => {
      if (initialColorMode === "system") {
        setResolvedColorMode(getSystemTheme());
      }
    }, []);
    React.useEffect(() => {
      const managerValue = colorModeManager.get();
      if (managerValue) {
        setColorMode(managerValue);
        return;
      }
      if (initialColorMode === "system") {
        setColorMode("system");
        return;
      }
      setColorMode(defaultColorMode);
    }, [colorModeManager, defaultColorMode, initialColorMode, setColorMode]);
    const toggleColorMode = React.useCallback(() => {
      setColorMode(resolvedValue === "dark" ? "light" : "dark");
    }, [resolvedValue, setColorMode]);
    React.useEffect(() => {
      if (!useSystemColorMode)
        return;
      return addListener(setColorMode);
    }, [useSystemColorMode, addListener, setColorMode]);
    const context = React.useMemo(
      () => ({
        colorMode: value ?? resolvedValue,
        toggleColorMode: value ? noop$1 : toggleColorMode,
        setColorMode: value ? noop$1 : setColorMode,
        forced: value !== void 0
      }),
      [resolvedValue, toggleColorMode, setColorMode, value]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ColorModeContext$1.Provider, { value: context, children });
  };
  ColorModeProvider.displayName = "ColorModeProvider";

  const css$1 = String.raw;
  const vhPolyfill = css$1`
  :root,
  :host {
    --chakra-vh: 100vh;
  }

  @supports (height: -webkit-fill-available) {
    :root,
    :host {
      --chakra-vh: -webkit-fill-available;
    }
  }

  @supports (height: -moz-fill-available) {
    :root,
    :host {
      --chakra-vh: -moz-fill-available;
    }
  }

  @supports (height: 100dvh) {
    :root,
    :host {
      --chakra-vh: 100dvh;
    }
  }
`;
  const CSSPolyfill = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: vhPolyfill });
  const CSSReset = ({ scope = "" }) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    Global,
    {
      styles: css$1`
      html {
        line-height: 1.5;
        -webkit-text-size-adjust: 100%;
        font-family: system-ui, sans-serif;
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        -moz-osx-font-smoothing: grayscale;
        touch-action: manipulation;
      }

      body {
        position: relative;
        min-height: 100%;
        margin: 0;
        font-feature-settings: "kern";
      }

      ${scope} :where(*, *::before, *::after) {
        border-width: 0;
        border-style: solid;
        box-sizing: border-box;
        word-wrap: break-word;
      }

      main {
        display: block;
      }

      ${scope} hr {
        border-top-width: 1px;
        box-sizing: content-box;
        height: 0;
        overflow: visible;
      }

      ${scope} :where(pre, code, kbd,samp) {
        font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
        font-size: 1em;
      }

      ${scope} a {
        background-color: transparent;
        color: inherit;
        text-decoration: inherit;
      }

      ${scope} abbr[title] {
        border-bottom: none;
        text-decoration: underline;
        -webkit-text-decoration: underline dotted;
        text-decoration: underline dotted;
      }

      ${scope} :where(b, strong) {
        font-weight: bold;
      }

      ${scope} small {
        font-size: 80%;
      }

      ${scope} :where(sub,sup) {
        font-size: 75%;
        line-height: 0;
        position: relative;
        vertical-align: baseline;
      }

      ${scope} sub {
        bottom: -0.25em;
      }

      ${scope} sup {
        top: -0.5em;
      }

      ${scope} img {
        border-style: none;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        margin: 0;
      }

      ${scope} :where(button, input) {
        overflow: visible;
      }

      ${scope} :where(button, select) {
        text-transform: none;
      }

      ${scope} :where(
          button::-moz-focus-inner,
          [type="button"]::-moz-focus-inner,
          [type="reset"]::-moz-focus-inner,
          [type="submit"]::-moz-focus-inner
        ) {
        border-style: none;
        padding: 0;
      }

      ${scope} fieldset {
        padding: 0.35em 0.75em 0.625em;
      }

      ${scope} legend {
        box-sizing: border-box;
        color: inherit;
        display: table;
        max-width: 100%;
        padding: 0;
        white-space: normal;
      }

      ${scope} progress {
        vertical-align: baseline;
      }

      ${scope} textarea {
        overflow: auto;
      }

      ${scope} :where([type="checkbox"], [type="radio"]) {
        box-sizing: border-box;
        padding: 0;
      }

      ${scope} input[type="number"]::-webkit-inner-spin-button,
      ${scope} input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
      }

      ${scope} input[type="number"] {
        -moz-appearance: textfield;
      }

      ${scope} input[type="search"] {
        -webkit-appearance: textfield;
        outline-offset: -2px;
      }

      ${scope} input[type="search"]::-webkit-search-decoration {
        -webkit-appearance: none !important;
      }

      ${scope} ::-webkit-file-upload-button {
        -webkit-appearance: button;
        font: inherit;
      }

      ${scope} details {
        display: block;
      }

      ${scope} summary {
        display: list-item;
      }

      template {
        display: none;
      }

      [hidden] {
        display: none !important;
      }

      ${scope} :where(
          blockquote,
          dl,
          dd,
          h1,
          h2,
          h3,
          h4,
          h5,
          h6,
          hr,
          figure,
          p,
          pre
        ) {
        margin: 0;
      }

      ${scope} button {
        background: transparent;
        padding: 0;
      }

      ${scope} fieldset {
        margin: 0;
        padding: 0;
      }

      ${scope} :where(ol, ul) {
        margin: 0;
        padding: 0;
      }

      ${scope} textarea {
        resize: vertical;
      }

      ${scope} :where(button, [role="button"]) {
        cursor: pointer;
      }

      ${scope} button::-moz-focus-inner {
        border: 0 !important;
      }

      ${scope} table {
        border-collapse: collapse;
      }

      ${scope} :where(h1, h2, h3, h4, h5, h6) {
        font-size: inherit;
        font-weight: inherit;
      }

      ${scope} :where(button, input, optgroup, select, textarea) {
        padding: 0;
        line-height: inherit;
        color: inherit;
      }

      ${scope} :where(img, svg, video, canvas, audio, iframe, embed, object) {
        display: block;
      }

      ${scope} :where(img, video) {
        max-width: 100%;
        height: auto;
      }

      [data-js-focus-visible]
        :focus:not([data-focus-visible-added]):not(
          [data-focus-visible-disabled]
        ) {
        outline: none;
        box-shadow: none;
      }

      ${scope} select::-ms-expand {
        display: none;
      }

      ${vhPolyfill}
    `
    }
  );

  function ThemeProvider(props) {
    const { cssVarsRoot, theme, children } = props;
    const computedTheme = React.useMemo(() => toCSSVar(theme), [theme]);
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(ThemeProvider$1, { theme: computedTheme, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(CSSVars, { root: cssVarsRoot }),
      children
    ] });
  }
  function CSSVars({ root = ":host, :root" }) {
    const selector = [root, `[data-theme]`].join(",");
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Global, { styles: (theme) => ({ [selector]: theme.__cssVars }) });
  }
  createContext$1({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  });
  function GlobalStyle() {
    const { colorMode } = useColorMode$1();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Global,
      {
        styles: (theme) => {
          const styleObjectOrFn = memoizedGet$2(theme, "styles.global");
          const globalStyles = runIfFn$3(styleObjectOrFn, { theme, colorMode });
          if (!globalStyles)
            return void 0;
          const styles = css$3(globalStyles)(theme);
          return styles;
        }
      }
    );
  }

  const [PortalManagerContextProvider, usePortalManager] = createContext$1({
    strict: false,
    name: "PortalManagerContext"
  });
  function PortalManager(props) {
    const { children, zIndex } = props;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PortalManagerContextProvider, { value: { zIndex }, children });
  }
  PortalManager.displayName = "PortalManager";

  const EnvironmentContext = React.createContext({
    getDocument() {
      return document;
    },
    getWindow() {
      return window;
    }
  });
  EnvironmentContext.displayName = "EnvironmentContext";
  function EnvironmentProvider(props) {
    const { children, environment: environmentProp, disabled } = props;
    const ref = React.useRef(null);
    const context = React.useMemo(() => {
      if (environmentProp)
        return environmentProp;
      return {
        getDocument: () => ref.current?.ownerDocument ?? document,
        getWindow: () => ref.current?.ownerDocument.defaultView ?? window
      };
    }, [environmentProp]);
    const showSpan = !disabled || !environmentProp;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(EnvironmentContext.Provider, { value: context, children: [
      children,
      showSpan && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { id: "__chakra_env", hidden: true, ref })
    ] });
  }
  EnvironmentProvider.displayName = "EnvironmentProvider";

  const Provider = (props) => {
    const {
      children,
      colorModeManager,
      portalZIndex,
      resetScope,
      resetCSS = true,
      theme = {},
      environment,
      cssVarsRoot,
      disableEnvironment,
      disableGlobalStyle
    } = props;
    const _children = /* @__PURE__ */ jsxRuntimeExports.jsx(
      EnvironmentProvider,
      {
        environment,
        disabled: disableEnvironment,
        children
      }
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ThemeProvider, { theme, cssVarsRoot, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
      ColorModeProvider,
      {
        colorModeManager,
        options: theme.config,
        children: [
          resetCSS ? /* @__PURE__ */ jsxRuntimeExports.jsx(CSSReset, { scope: resetScope }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CSSPolyfill, {}),
          !disableGlobalStyle && /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyle, {}),
          portalZIndex ? /* @__PURE__ */ jsxRuntimeExports.jsx(PortalManager, { zIndex: portalZIndex, children: _children }) : _children
        ]
      }
    ) });
  };

  /******************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */
  /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

  var extendStatics = function(d, b) {
      extendStatics = Object.setPrototypeOf ||
          ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
          function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
      return extendStatics(d, b);
  };

  function __extends(d, b) {
      if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
      extendStatics(d, b);
      function __() { this.constructor = d; }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  }

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
          t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function")
          for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
              if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                  t[p[i]] = s[p[i]];
          }
      return t;
  }

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
              if (!ar) ar = Array.prototype.slice.call(from, 0, i);
              ar[i] = from[i];
          }
      }
      return to.concat(ar || Array.prototype.slice.call(from));
  }

  typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
      var e = new Error(message);
      return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
  };

  var createDefinition = function (propNames) { return ({
      isEnabled: function (props) { return propNames.some(function (name) { return !!props[name]; }); },
  }); };
  var featureDefinitions = {
      measureLayout: createDefinition([
          "layout",
          "layoutId",
          "drag",
          "_layoutResetTransform",
      ]),
      animation: createDefinition([
          "animate",
          "exit",
          "variants",
          "whileHover",
          "whileTap",
          "whileFocus",
          "whileDrag",
      ]),
      exit: createDefinition(["exit"]),
      drag: createDefinition(["drag", "dragControls"]),
      focus: createDefinition(["whileFocus"]),
      hover: createDefinition(["whileHover", "onHoverStart", "onHoverEnd"]),
      tap: createDefinition(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
      pan: createDefinition([
          "onPan",
          "onPanStart",
          "onPanSessionStart",
          "onPanEnd",
      ]),
      layoutAnimation: createDefinition(["layout", "layoutId"]),
  };
  function loadFeatures(features) {
      for (var key in features) {
          var Component = features[key];
          if (Component !== null)
              featureDefinitions[key].Component = Component;
      }
  }

  var invariant = function () { };

  var LazyContext = React.createContext({ strict: false });

  var featureNames = Object.keys(featureDefinitions);
  var numFeatures = featureNames.length;
  /**
   * Load features via renderless components based on the provided MotionProps.
   */
  function useFeatures(props, visualElement, preloadedFeatures) {
      var features = [];
      React.useContext(LazyContext);
      if (!visualElement)
          return null;
      for (var i = 0; i < numFeatures; i++) {
          var name_1 = featureNames[i];
          var _a = featureDefinitions[name_1], isEnabled = _a.isEnabled, Component = _a.Component;
          /**
           * It might be possible in the future to use this moment to
           * dynamically request functionality. In initial tests this
           * was producing a lot of duplication amongst bundles.
           */
          if (isEnabled(props) && Component) {
              features.push(React__namespace.createElement(Component, __assign({ key: name_1 }, props, { visualElement: visualElement })));
          }
      }
      return features;
  }

  /**
   * @public
   */
  var MotionConfigContext = React.createContext({
      transformPagePoint: function (p) { return p; },
      isStatic: false,
  });

  var MotionContext = React.createContext({});
  function useVisualElementContext() {
      return React.useContext(MotionContext).visualElement;
  }

  /**
   * @public
   */
  var PresenceContext = React.createContext(null);

  /**
   * Creates a constant value over the lifecycle of a component.
   *
   * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
   * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
   * you can ensure that initialisers don't execute twice or more.
   */
  function useConstant(init) {
      var ref = React.useRef(null);
      if (ref.current === null) {
          ref.current = init();
      }
      return ref.current;
  }

  /**
   * When a component is the child of `AnimatePresence`, it can use `usePresence`
   * to access information about whether it's still present in the React tree.
   *
   * ```jsx
   * import { usePresence } from "framer-motion"
   *
   * export const Component = () => {
   *   const [isPresent, safeToRemove] = usePresence()
   *
   *   useEffect(() => {
   *     !isPresent && setTimeout(safeToRemove, 1000)
   *   }, [isPresent])
   *
   *   return <div />
   * }
   * ```
   *
   * If `isPresent` is `false`, it means that a component has been removed the tree, but
   * `AnimatePresence` won't really remove it until `safeToRemove` has been called.
   *
   * @public
   */
  function usePresence() {
      var context = React.useContext(PresenceContext);
      if (context === null)
          return [true, null];
      var isPresent = context.isPresent, onExitComplete = context.onExitComplete, register = context.register;
      // It's safe to call the following hooks conditionally (after an early return) because the context will always
      // either be null or non-null for the lifespan of the component.
      // Replace with useOpaqueId when released in React
      var id = useUniqueId();
      React.useEffect(function () { return register(id); }, []);
      var safeToRemove = function () { return onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete(id); };
      return !isPresent && onExitComplete ? [false, safeToRemove] : [true];
  }
  /**
   * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
   * There is no `safeToRemove` function.
   *
   * ```jsx
   * import { useIsPresent } from "framer-motion"
   *
   * export const Component = () => {
   *   const isPresent = useIsPresent()
   *
   *   useEffect(() => {
   *     !isPresent && console.log("I've been removed!")
   *   }, [isPresent])
   *
   *   return <div />
   * }
   * ```
   *
   * @public
   */
  function useIsPresent() {
      return isPresent(React.useContext(PresenceContext));
  }
  function isPresent(context) {
      return context === null ? true : context.isPresent;
  }
  var counter$1 = 0;
  var incrementId = function () { return counter$1++; };
  var useUniqueId = function () { return useConstant(incrementId); };

  /**
   * @internal
   */
  var LayoutGroupContext = React.createContext(null);

  var isBrowser = typeof window !== "undefined";

  var useIsomorphicLayoutEffect$2 = isBrowser ? React.useLayoutEffect : React.useEffect;

  function useLayoutId(_a) {
      var layoutId = _a.layoutId;
      var layoutGroupId = React.useContext(LayoutGroupContext);
      return layoutGroupId && layoutId !== undefined
          ? layoutGroupId + "-" + layoutId
          : layoutId;
  }
  function useVisualElement(Component, visualState, props, createVisualElement) {
      var config = React.useContext(MotionConfigContext);
      var lazyContext = React.useContext(LazyContext);
      var parent = useVisualElementContext();
      var presenceContext = React.useContext(PresenceContext);
      var layoutId = useLayoutId(props);
      var visualElementRef = React.useRef(undefined);
      /**
       * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
       */
      if (!createVisualElement)
          createVisualElement = lazyContext.renderer;
      if (!visualElementRef.current && createVisualElement) {
          visualElementRef.current = createVisualElement(Component, {
              visualState: visualState,
              parent: parent,
              props: __assign(__assign({}, props), { layoutId: layoutId }),
              presenceId: presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id,
              blockInitialAnimation: (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false,
          });
      }
      var visualElement = visualElementRef.current;
      useIsomorphicLayoutEffect$2(function () {
          if (!visualElement)
              return;
          visualElement.setProps(__assign(__assign(__assign({}, config), props), { layoutId: layoutId }));
          visualElement.isPresent = isPresent(presenceContext);
          visualElement.isPresenceRoot =
              !parent || parent.presenceId !== (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.id);
          /**
           * Fire a render to ensure the latest state is reflected on-screen.
           */
          visualElement.syncRender();
      });
      React.useEffect(function () {
          var _a;
          if (!visualElement)
              return;
          /**
           * In a future refactor we can replace the features-as-components and
           * have this loop through them all firing "effect" listeners
           */
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.animateChanges();
      });
      useIsomorphicLayoutEffect$2(function () { return function () { return visualElement === null || visualElement === void 0 ? void 0 : visualElement.notifyUnmount(); }; }, []);
      return visualElement;
  }

  function isRefObject(ref) {
      return (typeof ref === "object" &&
          Object.prototype.hasOwnProperty.call(ref, "current"));
  }

  /**
   * Creates a ref function that, when called, hydrates the provided
   * external ref and VisualElement.
   */
  function useMotionRef(visualState, visualElement, externalRef) {
      return React.useCallback(function (instance) {
          var _a;
          instance && ((_a = visualState.mount) === null || _a === void 0 ? void 0 : _a.call(visualState, instance));
          if (visualElement) {
              instance
                  ? visualElement.mount(instance)
                  : visualElement.unmount();
          }
          if (externalRef) {
              if (typeof externalRef === "function") {
                  externalRef(instance);
              }
              else if (isRefObject(externalRef)) {
                  externalRef.current = instance;
              }
          }
      }, 
      /**
       * Only pass a new ref callback to React if we've received a visual element
       * factory. Otherwise we'll be mounting/remounting every time externalRef
       * or other dependencies change.
       */
      [visualElement]);
  }

  /**
   * Decides if the supplied variable is an array of variant labels
   */
  function isVariantLabels(v) {
      return Array.isArray(v);
  }
  /**
   * Decides if the supplied variable is variant label
   */
  function isVariantLabel(v) {
      return typeof v === "string" || isVariantLabels(v);
  }
  /**
   * Creates an object containing the latest state of every MotionValue on a VisualElement
   */
  function getCurrent(visualElement) {
      var current = {};
      visualElement.forEachValue(function (value, key) { return (current[key] = value.get()); });
      return current;
  }
  /**
   * Creates an object containing the latest velocity of every MotionValue on a VisualElement
   */
  function getVelocity$1(visualElement) {
      var velocity = {};
      visualElement.forEachValue(function (value, key) { return (velocity[key] = value.getVelocity()); });
      return velocity;
  }
  function resolveVariantFromProps(props, definition, custom, currentValues, currentVelocity) {
      var _a;
      if (currentValues === void 0) { currentValues = {}; }
      if (currentVelocity === void 0) { currentVelocity = {}; }
      if (typeof definition === "string") {
          definition = (_a = props.variants) === null || _a === void 0 ? void 0 : _a[definition];
      }
      return typeof definition === "function"
          ? definition(custom !== null && custom !== void 0 ? custom : props.custom, currentValues, currentVelocity)
          : definition;
  }
  function resolveVariant(visualElement, definition, custom) {
      var props = visualElement.getProps();
      return resolveVariantFromProps(props, definition, custom !== null && custom !== void 0 ? custom : props.custom, getCurrent(visualElement), getVelocity$1(visualElement));
  }
  function checkIfControllingVariants(props) {
      var _a;
      return (typeof ((_a = props.animate) === null || _a === void 0 ? void 0 : _a.start) === "function" ||
          isVariantLabel(props.initial) ||
          isVariantLabel(props.animate) ||
          isVariantLabel(props.whileHover) ||
          isVariantLabel(props.whileDrag) ||
          isVariantLabel(props.whileTap) ||
          isVariantLabel(props.whileFocus) ||
          isVariantLabel(props.exit));
  }
  function checkIfVariantNode(props) {
      return Boolean(checkIfControllingVariants(props) || props.variants);
  }

  function getCurrentTreeVariants(props, context) {
      if (checkIfControllingVariants(props)) {
          var initial = props.initial, animate = props.animate;
          return {
              initial: initial === false || isVariantLabel(initial)
                  ? initial
                  : undefined,
              animate: isVariantLabel(animate) ? animate : undefined,
          };
      }
      return props.inherit !== false ? context : {};
  }

  function useCreateMotionContext(props, isStatic) {
      var _a = getCurrentTreeVariants(props, React.useContext(MotionContext)), initial = _a.initial, animate = _a.animate;
      return React.useMemo(function () { return ({ initial: initial, animate: animate }); }, 
      /**
       * Only break memoisation in static mode
       */
      isStatic
          ? [
              variantLabelsAsDependency(initial),
              variantLabelsAsDependency(animate),
          ]
          : []);
  }
  function variantLabelsAsDependency(prop) {
      return Array.isArray(prop) ? prop.join(" ") : prop;
  }

  /**
   * Create a `motion` component.
   *
   * This function accepts a Component argument, which can be either a string (ie "div"
   * for `motion.div`), or an actual React component.
   *
   * Alongside this is a config option which provides a way of rendering the provided
   * component "offline", or outside the React render cycle.
   *
   * @internal
   */
  function createMotionComponent(_a) {
      var preloadedFeatures = _a.preloadedFeatures, createVisualElement = _a.createVisualElement, useRender = _a.useRender, useVisualState = _a.useVisualState, Component = _a.Component;
      preloadedFeatures && loadFeatures(preloadedFeatures);
      function MotionComponent(props, externalRef) {
          /**
           * If we're rendering in a static environment, we only visually update the component
           * as a result of a React-rerender rather than interactions or animations. This
           * means we don't need to load additional memory structures like VisualElement,
           * or any gesture/animation features.
           */
          var isStatic = React.useContext(MotionConfigContext).isStatic;
          var features = null;
          /**
           * Create the tree context. This is memoized and will only trigger renders
           * when the current tree variant changes in static mode.
           */
          var context = useCreateMotionContext(props, isStatic);
          /**
           *
           */
          var visualState = useVisualState(props, isStatic);
          if (!isStatic && isBrowser) {
              /**
               * Create a VisualElement for this component. A VisualElement provides a common
               * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
               * providing a way of rendering to these APIs outside of the React render loop
               * for more performant animations and interactions
               */
              context.visualElement = useVisualElement(Component, visualState, props, createVisualElement);
              /**
               * Load Motion gesture and animation features. These are rendered as renderless
               * components so each feature can optionally make use of React lifecycle methods.
               *
               * TODO: The intention is to move these away from a React-centric to a
               * VisualElement-centric lifecycle scheme.
               */
              features = useFeatures(props, context.visualElement);
          }
          /**
           * The mount order and hierarchy is specific to ensure our element ref
           * is hydrated by the time features fire their effects.
           */
          return (React__namespace.createElement(React__namespace.Fragment, null,
              React__namespace.createElement(MotionContext.Provider, { value: context }, useRender(Component, props, useMotionRef(visualState, context.visualElement, externalRef), visualState, isStatic)),
              features));
      }
      return React.forwardRef(MotionComponent);
  }

  /**
   * Convert any React component into a `motion` component. The provided component
   * **must** use `React.forwardRef` to the underlying DOM component you want to animate.
   *
   * ```jsx
   * const Component = React.forwardRef((props, ref) => {
   *   return <div ref={ref} />
   * })
   *
   * const MotionComponent = motion(Component)
   * ```
   *
   * @public
   */
  function createMotionProxy(createConfig) {
      function custom(Component, customMotionComponentConfig) {
          if (customMotionComponentConfig === void 0) { customMotionComponentConfig = {}; }
          return createMotionComponent(createConfig(Component, customMotionComponentConfig));
      }
      /**
       * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
       * Rather than generating them anew every render.
       */
      var componentCache = new Map();
      return new Proxy(custom, {
          /**
           * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
           * The prop name is passed through as `key` and we can use that to generate a `motion`
           * DOM component with that name.
           */
          get: function (_target, key) {
              /**
               * If this element doesn't exist in the component cache, create it and cache.
               */
              if (!componentCache.has(key)) {
                  componentCache.set(key, custom(key));
              }
              return componentCache.get(key);
          },
      });
  }

  /**
   * We keep these listed seperately as we use the lowercase tag names as part
   * of the runtime bundle to detect SVG components
   */
  var lowercaseSVGElements = [
      "animate",
      "circle",
      "defs",
      "desc",
      "ellipse",
      "g",
      "image",
      "line",
      "filter",
      "marker",
      "mask",
      "metadata",
      "path",
      "pattern",
      "polygon",
      "polyline",
      "rect",
      "stop",
      "svg",
      "switch",
      "symbol",
      "text",
      "tspan",
      "use",
      "view",
  ];

  function isSVGComponent(Component) {
      if (
      /**
       * If it's not a string, it's a custom React component. Currently we only support
       * HTML custom React components.
       */
      typeof Component !== "string" ||
          /**
           * If it contains a dash, the element is a custom HTML webcomponent.
           */
          Component.includes("-")) {
          return false;
      }
      else if (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      lowercaseSVGElements.indexOf(Component) > -1 ||
          /**
           * If it contains a capital letter, it's an SVG component
           */
          /[A-Z]/.test(Component)) {
          return true;
      }
      return false;
  }

  var valueScaleCorrection = {};
  /**
   * @internal
   */
  function addScaleCorrection(correctors) {
      for (var key in correctors) {
          valueScaleCorrection[key] = correctors[key];
      }
  }

  /**
   * A list of all transformable axes. We'll use this list to generated a version
   * of each axes for each transform.
   */
  var transformAxes = ["", "X", "Y", "Z"];
  /**
   * An ordered array of each transformable value. By default, transform values
   * will be sorted to this order.
   */
  var order$1 = ["translate", "scale", "rotate", "skew"];
  /**
   * Generate a list of every possible transform key.
   */
  var transformProps = ["transformPerspective", "x", "y", "z"];
  order$1.forEach(function (operationKey) {
      return transformAxes.forEach(function (axesKey) {
          return transformProps.push(operationKey + axesKey);
      });
  });
  /**
   * A function to use with Array.sort to sort transform keys by their default order.
   */
  function sortTransformProps(a, b) {
      return transformProps.indexOf(a) - transformProps.indexOf(b);
  }
  /**
   * A quick lookup for transform props.
   */
  var transformPropSet = new Set(transformProps);
  function isTransformProp(key) {
      return transformPropSet.has(key);
  }
  /**
   * A quick lookup for transform origin props
   */
  var transformOriginProps = new Set(["originX", "originY", "originZ"]);
  function isTransformOriginProp(key) {
      return transformOriginProps.has(key);
  }

  function isForcedMotionValue(key, _a) {
      var layout = _a.layout, layoutId = _a.layoutId;
      return (isTransformProp(key) ||
          isTransformOriginProp(key) ||
          ((layout || layoutId !== undefined) &&
              (!!valueScaleCorrection[key] || key === "opacity")));
  }

  var isMotionValue = function (value) {
      return value !== null && typeof value === "object" && value.getVelocity;
  };

  var translateAlias = {
      x: "translateX",
      y: "translateY",
      z: "translateZ",
      transformPerspective: "perspective",
  };
  /**
   * Build a CSS transform style from individual x/y/scale etc properties.
   *
   * This outputs with a default order of transforms/scales/rotations, this can be customised by
   * providing a transformTemplate function.
   */
  function buildTransform(_a, _b, transformIsDefault, transformTemplate) {
      var transform = _a.transform, transformKeys = _a.transformKeys;
      var _c = _b.enableHardwareAcceleration, enableHardwareAcceleration = _c === void 0 ? true : _c, _d = _b.allowTransformNone, allowTransformNone = _d === void 0 ? true : _d;
      // The transform string we're going to build into.
      var transformString = "";
      // Transform keys into their default order - this will determine the output order.
      transformKeys.sort(sortTransformProps);
      // Track whether the defined transform has a defined z so we don't add a
      // second to enable hardware acceleration
      var transformHasZ = false;
      // Loop over each transform and build them into transformString
      var numTransformKeys = transformKeys.length;
      for (var i = 0; i < numTransformKeys; i++) {
          var key = transformKeys[i];
          transformString += (translateAlias[key] || key) + "(" + transform[key] + ") ";
          if (key === "z")
              transformHasZ = true;
      }
      if (!transformHasZ && enableHardwareAcceleration) {
          transformString += "translateZ(0)";
      }
      else {
          transformString = transformString.trim();
      }
      // If we have a custom `transform` template, pass our transform values and
      // generated transformString to that before returning
      if (transformTemplate) {
          transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
      }
      else if (allowTransformNone && transformIsDefault) {
          transformString = "none";
      }
      return transformString;
  }
  /**
   * Build a transformOrigin style. Uses the same defaults as the browser for
   * undefined origins.
   */
  function buildTransformOrigin(_a) {
      var _b = _a.originX, originX = _b === void 0 ? "50%" : _b, _c = _a.originY, originY = _c === void 0 ? "50%" : _c, _d = _a.originZ, originZ = _d === void 0 ? 0 : _d;
      return originX + " " + originY + " " + originZ;
  }

  /**
   * Returns true if the provided key is a CSS variable
   */
  function isCSSVariable$1(key) {
      return key.startsWith("--");
  }

  /**
   * Provided a value and a ValueType, returns the value as that value type.
   */
  var getValueAsType = function (value, type) {
      return type && typeof value === "number"
          ? type.transform(value)
          : value;
  };

  var clamp$1 = function (min, max) { return function (v) {
      return Math.max(Math.min(v, max), min);
  }; };
  var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };
  var floatRegex = /(-)?([\d]*\.?[\d])+/g;
  var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi;
  var singleColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
  function isString(v) {
      return typeof v === 'string';
  }

  var number = {
      test: function (v) { return typeof v === 'number'; },
      parse: parseFloat,
      transform: function (v) { return v; },
  };
  var alpha = __assign(__assign({}, number), { transform: clamp$1(0, 1) });
  var scale$1 = __assign(__assign({}, number), { default: 1 });

  var createUnitType = function (unit) { return ({
      test: function (v) {
          return isString(v) && v.endsWith(unit) && v.split(' ').length === 1;
      },
      parse: parseFloat,
      transform: function (v) { return "" + v + unit; },
  }); };
  var degrees = createUnitType('deg');
  var percent = createUnitType('%');
  var px = createUnitType('px');
  var vh = createUnitType('vh');
  var vw = createUnitType('vw');
  var progressPercentage = __assign(__assign({}, percent), { parse: function (v) { return percent.parse(v) / 100; }, transform: function (v) { return percent.transform(v * 100); } });

  var isColorString = function (type, testProp) { return function (v) {
      return Boolean((isString(v) && singleColorRegex.test(v) && v.startsWith(type)) ||
          (testProp && Object.prototype.hasOwnProperty.call(v, testProp)));
  }; };
  var splitColor = function (aName, bName, cName) { return function (v) {
      var _a;
      if (!isString(v))
          return v;
      var _b = v.match(floatRegex), a = _b[0], b = _b[1], c = _b[2], alpha = _b[3];
      return _a = {},
          _a[aName] = parseFloat(a),
          _a[bName] = parseFloat(b),
          _a[cName] = parseFloat(c),
          _a.alpha = alpha !== undefined ? parseFloat(alpha) : 1,
          _a;
  }; };

  var hsla = {
      test: isColorString('hsl', 'hue'),
      parse: splitColor('hue', 'saturation', 'lightness'),
      transform: function (_a) {
          var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
          return ('hsla(' +
              Math.round(hue) +
              ', ' +
              percent.transform(sanitize(saturation)) +
              ', ' +
              percent.transform(sanitize(lightness)) +
              ', ' +
              sanitize(alpha.transform(alpha$1)) +
              ')');
      },
  };

  var clampRgbUnit = clamp$1(0, 255);
  var rgbUnit = __assign(__assign({}, number), { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
  var rgba = {
      test: isColorString('rgb', 'red'),
      parse: splitColor('red', 'green', 'blue'),
      transform: function (_a) {
          var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$1 = _b === void 0 ? 1 : _b;
          return 'rgba(' +
              rgbUnit.transform(red) +
              ', ' +
              rgbUnit.transform(green) +
              ', ' +
              rgbUnit.transform(blue) +
              ', ' +
              sanitize(alpha.transform(alpha$1)) +
              ')';
      },
  };

  function parseHex(v) {
      var r = '';
      var g = '';
      var b = '';
      var a = '';
      if (v.length > 5) {
          r = v.substr(1, 2);
          g = v.substr(3, 2);
          b = v.substr(5, 2);
          a = v.substr(7, 2);
      }
      else {
          r = v.substr(1, 1);
          g = v.substr(2, 1);
          b = v.substr(3, 1);
          a = v.substr(4, 1);
          r += r;
          g += g;
          b += b;
          a += a;
      }
      return {
          red: parseInt(r, 16),
          green: parseInt(g, 16),
          blue: parseInt(b, 16),
          alpha: a ? parseInt(a, 16) / 255 : 1,
      };
  }
  var hex = {
      test: isColorString('#'),
      parse: parseHex,
      transform: rgba.transform,
  };

  var color$1 = {
      test: function (v) { return rgba.test(v) || hex.test(v) || hsla.test(v); },
      parse: function (v) {
          if (rgba.test(v)) {
              return rgba.parse(v);
          }
          else if (hsla.test(v)) {
              return hsla.parse(v);
          }
          else {
              return hex.parse(v);
          }
      },
      transform: function (v) {
          return isString(v)
              ? v
              : v.hasOwnProperty('red')
                  ? rgba.transform(v)
                  : hsla.transform(v);
      },
  };

  var colorToken = '${c}';
  var numberToken = '${n}';
  function test(v) {
      var _a, _b, _c, _d;
      return (isNaN(v) &&
          isString(v) &&
          ((_b = (_a = v.match(floatRegex)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) + ((_d = (_c = v.match(colorRegex)) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0);
  }
  function analyse$1(v) {
      var values = [];
      var numColors = 0;
      var colors = v.match(colorRegex);
      if (colors) {
          numColors = colors.length;
          v = v.replace(colorRegex, colorToken);
          values.push.apply(values, colors.map(color$1.parse));
      }
      var numbers = v.match(floatRegex);
      if (numbers) {
          v = v.replace(floatRegex, numberToken);
          values.push.apply(values, numbers.map(number.parse));
      }
      return { values: values, numColors: numColors, tokenised: v };
  }
  function parse$3(v) {
      return analyse$1(v).values;
  }
  function createTransformer(v) {
      var _a = analyse$1(v), values = _a.values, numColors = _a.numColors, tokenised = _a.tokenised;
      var numValues = values.length;
      return function (v) {
          var output = tokenised;
          for (var i = 0; i < numValues; i++) {
              output = output.replace(i < numColors ? colorToken : numberToken, i < numColors ? color$1.transform(v[i]) : sanitize(v[i]));
          }
          return output;
      };
  }
  var convertNumbersToZero = function (v) {
      return typeof v === 'number' ? 0 : v;
  };
  function getAnimatableNone$1(v) {
      var parsed = parse$3(v);
      var transformer = createTransformer(v);
      return transformer(parsed.map(convertNumbersToZero));
  }
  var complex = { test: test, parse: parse$3, createTransformer: createTransformer, getAnimatableNone: getAnimatableNone$1 };

  var maxDefaults = new Set(['brightness', 'contrast', 'saturate', 'opacity']);
  function applyDefaultFilter(v) {
      var _a = v.slice(0, -1).split('('), name = _a[0], value = _a[1];
      if (name === 'drop-shadow')
          return v;
      var number = (value.match(floatRegex) || [])[0];
      if (!number)
          return v;
      var unit = value.replace(number, '');
      var defaultValue = maxDefaults.has(name) ? 1 : 0;
      if (number !== value)
          defaultValue *= 100;
      return name + '(' + defaultValue + unit + ')';
  }
  var functionRegex = /([a-z-]*)\(.*?\)/g;
  var filter$1 = __assign(__assign({}, complex), { getAnimatableNone: function (v) {
          var functions = v.match(functionRegex);
          return functions ? functions.map(applyDefaultFilter).join(' ') : v;
      } });

  var int = __assign(__assign({}, number), { transform: Math.round });

  var numberValueTypes = {
      // Border props
      borderWidth: px,
      borderTopWidth: px,
      borderRightWidth: px,
      borderBottomWidth: px,
      borderLeftWidth: px,
      borderRadius: px,
      radius: px,
      borderTopLeftRadius: px,
      borderTopRightRadius: px,
      borderBottomRightRadius: px,
      borderBottomLeftRadius: px,
      // Positioning props
      width: px,
      maxWidth: px,
      height: px,
      maxHeight: px,
      size: px,
      top: px,
      right: px,
      bottom: px,
      left: px,
      // Spacing props
      padding: px,
      paddingTop: px,
      paddingRight: px,
      paddingBottom: px,
      paddingLeft: px,
      margin: px,
      marginTop: px,
      marginRight: px,
      marginBottom: px,
      marginLeft: px,
      // Transform props
      rotate: degrees,
      rotateX: degrees,
      rotateY: degrees,
      rotateZ: degrees,
      scale: scale$1,
      scaleX: scale$1,
      scaleY: scale$1,
      scaleZ: scale$1,
      skew: degrees,
      skewX: degrees,
      skewY: degrees,
      distance: px,
      translateX: px,
      translateY: px,
      translateZ: px,
      x: px,
      y: px,
      z: px,
      perspective: px,
      transformPerspective: px,
      opacity: alpha,
      originX: progressPercentage,
      originY: progressPercentage,
      originZ: px,
      // Misc
      zIndex: int,
      // SVG
      fillOpacity: alpha,
      strokeOpacity: alpha,
      numOctaves: int,
  };

  function buildHTMLStyles(state, latestValues, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
      var _a;
      var style = state.style, vars = state.vars, transform = state.transform, transformKeys = state.transformKeys, transformOrigin = state.transformOrigin;
      // Empty the transformKeys array. As we're throwing out refs to its items
      // this might not be as cheap as suspected. Maybe using the array as a buffer
      // with a manual incrementation would be better.
      transformKeys.length = 0;
      // Track whether we encounter any transform or transformOrigin values.
      var hasTransform = false;
      var hasTransformOrigin = false;
      // Does the calculated transform essentially equal "none"?
      var transformIsNone = true;
      /**
       * Loop over all our latest animated values and decide whether to handle them
       * as a style or CSS variable.
       *
       * Transforms and transform origins are kept seperately for further processing.
       */
      for (var key in latestValues) {
          var value = latestValues[key];
          /**
           * If this is a CSS variable we don't do any further processing.
           */
          if (isCSSVariable$1(key)) {
              vars[key] = value;
              continue;
          }
          // Convert the value to its default value type, ie 0 -> "0px"
          var valueType = numberValueTypes[key];
          var valueAsType = getValueAsType(value, valueType);
          if (isTransformProp(key)) {
              // If this is a transform, flag to enable further transform processing
              hasTransform = true;
              transform[key] = valueAsType;
              transformKeys.push(key);
              // If we already know we have a non-default transform, early return
              if (!transformIsNone)
                  continue;
              // Otherwise check to see if this is a default transform
              if (value !== ((_a = valueType.default) !== null && _a !== void 0 ? _a : 0))
                  transformIsNone = false;
          }
          else if (isTransformOriginProp(key)) {
              transformOrigin[key] = valueAsType;
              // If this is a transform origin, flag and enable further transform-origin processing
              hasTransformOrigin = true;
          }
          else {
              /**
               * If layout projection is on, and we need to perform scale correction for this
               * value type, perform it.
               */
              if ((projection === null || projection === void 0 ? void 0 : projection.isHydrated) &&
                  (layoutState === null || layoutState === void 0 ? void 0 : layoutState.isHydrated) &&
                  valueScaleCorrection[key]) {
                  var correctedValue = valueScaleCorrection[key].process(value, layoutState, projection);
                  /**
                   * Scale-correctable values can define a number of other values to break
                   * down into. For instance borderRadius needs applying to borderBottomLeftRadius etc
                   */
                  var applyTo = valueScaleCorrection[key].applyTo;
                  if (applyTo) {
                      var num = applyTo.length;
                      for (var i = 0; i < num; i++) {
                          style[applyTo[i]] = correctedValue;
                      }
                  }
                  else {
                      style[key] = correctedValue;
                  }
              }
              else {
                  style[key] = valueAsType;
              }
          }
      }
      if (layoutState &&
          projection &&
          buildProjectionTransform &&
          buildProjectionTransformOrigin) {
          style.transform = buildProjectionTransform(layoutState.deltaFinal, layoutState.treeScale, hasTransform ? transform : undefined);
          if (transformTemplate) {
              style.transform = transformTemplate(transform, style.transform);
          }
          style.transformOrigin = buildProjectionTransformOrigin(layoutState);
      }
      else {
          if (hasTransform) {
              style.transform = buildTransform(state, options, transformIsNone, transformTemplate);
          }
          if (hasTransformOrigin) {
              style.transformOrigin = buildTransformOrigin(transformOrigin);
          }
      }
  }

  var createHtmlRenderState = function () { return ({
      style: {},
      transform: {},
      transformKeys: [],
      transformOrigin: {},
      vars: {},
  }); };

  function copyRawValuesOnly(target, source, props) {
      for (var key in source) {
          if (!isMotionValue(source[key]) && !isForcedMotionValue(key, props)) {
              target[key] = source[key];
          }
      }
  }
  function useInitialMotionValues(_a, visualState, isStatic) {
      var transformTemplate = _a.transformTemplate;
      return React.useMemo(function () {
          var state = createHtmlRenderState();
          buildHTMLStyles(state, visualState, undefined, undefined, { enableHardwareAcceleration: !isStatic }, transformTemplate);
          var vars = state.vars, style = state.style;
          return __assign(__assign({}, vars), style);
      }, [visualState]);
  }
  function useStyle(props, visualState, isStatic) {
      var styleProp = props.style || {};
      var style = {};
      /**
       * Copy non-Motion Values straight into style
       */
      copyRawValuesOnly(style, styleProp, props);
      Object.assign(style, useInitialMotionValues(props, visualState, isStatic));
      if (props.transformValues) {
          style = props.transformValues(style);
      }
      return style;
  }
  function useHTMLProps(props, visualState, isStatic) {
      // The `any` isn't ideal but it is the type of createElement props argument
      var htmlProps = {};
      var style = useStyle(props, visualState, isStatic);
      if (Boolean(props.drag)) {
          // Disable the ghost element when a user drags
          htmlProps.draggable = false;
          // Disable text selection
          style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout =
              "none";
          // Disable scrolling on the draggable direction
          style.touchAction =
              props.drag === true
                  ? "none"
                  : "pan-" + (props.drag === "x" ? "y" : "x");
      }
      htmlProps.style = style;
      return htmlProps;
  }

  /**
   * A list of all valid MotionProps.
   *
   * @internalremarks
   * This doesn't throw if a `MotionProp` name is missing - it should.
   */
  var validMotionProps = new Set([
      "initial",
      "animate",
      "exit",
      "style",
      "variants",
      "transition",
      "transformTemplate",
      "transformValues",
      "custom",
      "inherit",
      "layout",
      "layoutId",
      "_layoutResetTransform",
      "onLayoutAnimationComplete",
      "onViewportBoxUpdate",
      "onLayoutMeasure",
      "onBeforeLayoutMeasure",
      "onAnimationStart",
      "onAnimationComplete",
      "onUpdate",
      "onDragStart",
      "onDrag",
      "onDragEnd",
      "onMeasureDragConstraints",
      "onDirectionLock",
      "onDragTransitionEnd",
      "drag",
      "dragControls",
      "dragListener",
      "dragConstraints",
      "dragDirectionLock",
      "_dragX",
      "_dragY",
      "dragElastic",
      "dragMomentum",
      "dragPropagation",
      "dragTransition",
      "whileDrag",
      "onPan",
      "onPanStart",
      "onPanEnd",
      "onPanSessionStart",
      "onTap",
      "onTapStart",
      "onTapCancel",
      "onHoverStart",
      "onHoverEnd",
      "whileFocus",
      "whileTap",
      "whileHover",
  ]);
  /**
   * Check whether a prop name is a valid `MotionProp` key.
   *
   * @param key - Name of the property to check
   * @returns `true` is key is a valid `MotionProp`.
   *
   * @public
   */
  function isValidMotionProp(key) {
      return validMotionProps.has(key);
  }

  var shouldForward = function (key) { return !isValidMotionProp(key); };
  /**
   * Emotion and Styled Components both allow users to pass through arbitrary props to their components
   * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
   * of these should be passed to the underlying DOM node.
   *
   * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
   * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
   * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
   * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
   *
   * By making it an optionalDependency we can offer this functionality only in the situations where it's
   * actually required.
   */
  try {
      var emotionIsPropValid_1 = require("@emotion/is-prop-valid").default;
      shouldForward = function (key) {
          // Handle events explicitly as Emotion validates them all as true
          if (key.startsWith("on")) {
              return !isValidMotionProp(key);
          }
          else {
              return emotionIsPropValid_1(key);
          }
      };
  }
  catch (_a) {
      // We don't need to actually do anything here - the fallback is the existing `isPropValid`.
  }
  function filterProps(props, isDom, forwardMotionProps) {
      var filteredProps = {};
      for (var key in props) {
          if (shouldForward(key) ||
              (forwardMotionProps === true && isValidMotionProp(key)) ||
              (!isDom && !isValidMotionProp(key))) {
              filteredProps[key] = props[key];
          }
      }
      return filteredProps;
  }

  function calcOrigin$1(origin, offset, size) {
      return typeof origin === "string"
          ? origin
          : px.transform(offset + size * origin);
  }
  /**
   * The SVG transform origin defaults are different to CSS and is less intuitive,
   * so we use the measured dimensions of the SVG to reconcile these.
   */
  function calcSVGTransformOrigin(dimensions, originX, originY) {
      var pxOriginX = calcOrigin$1(originX, dimensions.x, dimensions.width);
      var pxOriginY = calcOrigin$1(originY, dimensions.y, dimensions.height);
      return pxOriginX + " " + pxOriginY;
  }

  // Convert a progress 0-1 to a pixels value based on the provided length
  var progressToPixels = function (progress, length) {
      return px.transform(progress * length);
  };
  var camelKeys = {
      offset: "strokeDashoffset",
      array: "strokeDasharray",
  };
  /**
   * Build SVG path properties. Uses the path's measured length to convert
   * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
   * and stroke-dasharray attributes.
   *
   * This function is mutative to reduce per-frame GC.
   */
  function buildSVGPath(attrs, totalLength, length, spacing, offset, useDashCase) {
      if (spacing === void 0) { spacing = 1; }
      if (offset === void 0) { offset = 0; }
      // We use dash case when setting attributes directly to the DOM node and camel case
      // when defining props on a React component.
      var keys = camelKeys;
      // Build the dash offset
      attrs[keys.offset] = progressToPixels(-offset, totalLength);
      // Build the dash array
      var pathLength = progressToPixels(length, totalLength);
      var pathSpacing = progressToPixels(spacing, totalLength);
      attrs[keys.array] = pathLength + " " + pathSpacing;
  }

  /**
   * Build SVG visual attrbutes, like cx and style.transform
   */
  function buildSVGAttrs(state, _a, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin) {
      var attrX = _a.attrX, attrY = _a.attrY, originX = _a.originX, originY = _a.originY, pathLength = _a.pathLength, _b = _a.pathSpacing, pathSpacing = _b === void 0 ? 1 : _b, _c = _a.pathOffset, pathOffset = _c === void 0 ? 0 : _c, 
      // This is object creation, which we try to avoid per-frame.
      latest = __rest(_a, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
      buildHTMLStyles(state, latest, projection, layoutState, options, transformTemplate, buildProjectionTransform, buildProjectionTransformOrigin);
      state.attrs = state.style;
      state.style = {};
      var attrs = state.attrs, style = state.style, dimensions = state.dimensions, totalPathLength = state.totalPathLength;
      /**
       * However, we apply transforms as CSS transforms. So if we detect a transform we take it from attrs
       * and copy it into style.
       */
      if (attrs.transform) {
          if (dimensions)
              style.transform = attrs.transform;
          delete attrs.transform;
      }
      // Parse transformOrigin
      if (dimensions &&
          (originX !== undefined || originY !== undefined || style.transform)) {
          style.transformOrigin = calcSVGTransformOrigin(dimensions, originX !== undefined ? originX : 0.5, originY !== undefined ? originY : 0.5);
      }
      // Treat x/y not as shortcuts but as actual attributes
      if (attrX !== undefined)
          attrs.x = attrX;
      if (attrY !== undefined)
          attrs.y = attrY;
      // Build SVG path if one has been measured
      if (totalPathLength !== undefined && pathLength !== undefined) {
          buildSVGPath(attrs, totalPathLength, pathLength, pathSpacing, pathOffset);
      }
  }

  var createSvgRenderState = function () { return (__assign(__assign({}, createHtmlRenderState()), { attrs: {} })); };

  function useSVGProps(props, visualState) {
      var visualProps = React.useMemo(function () {
          var state = createSvgRenderState();
          buildSVGAttrs(state, visualState, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
          return __assign(__assign({}, state.attrs), { style: __assign({}, state.style) });
      }, [visualState]);
      if (props.style) {
          var rawStyles = {};
          copyRawValuesOnly(rawStyles, props.style, props);
          visualProps.style = __assign(__assign({}, rawStyles), visualProps.style);
      }
      return visualProps;
  }

  function createUseRender(forwardMotionProps) {
      if (forwardMotionProps === void 0) { forwardMotionProps = false; }
      var useRender = function (Component, props, ref, _a, isStatic) {
          var latestValues = _a.latestValues;
          var useVisualProps = isSVGComponent(Component)
              ? useSVGProps
              : useHTMLProps;
          var visualProps = useVisualProps(props, latestValues, isStatic);
          var filteredProps = filterProps(props, typeof Component === "string", forwardMotionProps);
          var elementProps = __assign(__assign(__assign({}, filteredProps), visualProps), { ref: ref });
          return React.createElement(Component, elementProps);
      };
      return useRender;
  }

  var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
  var REPLACE_TEMPLATE = "$1-$2";
  /**
   * Convert camelCase to dash-case properties.
   */
  var camelToDash = function (str) {
      return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
  };

  function renderHTML(element, _a) {
      var style = _a.style, vars = _a.vars;
      // Directly assign style into the Element's style prop. In tests Object.assign is the
      // fastest way to assign styles.
      Object.assign(element.style, style);
      // Loop over any CSS variables and assign those.
      for (var key in vars) {
          element.style.setProperty(key, vars[key]);
      }
  }

  /**
   * A set of attribute names that are always read/written as camel case.
   */
  var camelCaseAttributes = new Set([
      "baseFrequency",
      "diffuseConstant",
      "kernelMatrix",
      "kernelUnitLength",
      "keySplines",
      "keyTimes",
      "limitingConeAngle",
      "markerHeight",
      "markerWidth",
      "numOctaves",
      "targetX",
      "targetY",
      "surfaceScale",
      "specularConstant",
      "specularExponent",
      "stdDeviation",
      "tableValues",
      "viewBox",
      "gradientTransform",
  ]);

  function renderSVG(element, renderState) {
      renderHTML(element, renderState);
      for (var key in renderState.attrs) {
          element.setAttribute(!camelCaseAttributes.has(key) ? camelToDash(key) : key, renderState.attrs[key]);
      }
  }

  function scrapeMotionValuesFromProps$1(props) {
      var style = props.style;
      var newValues = {};
      for (var key in style) {
          if (isMotionValue(style[key]) || isForcedMotionValue(key, props)) {
              newValues[key] = style[key];
          }
      }
      return newValues;
  }

  function scrapeMotionValuesFromProps(props) {
      var newValues = scrapeMotionValuesFromProps$1(props);
      for (var key in props) {
          if (isMotionValue(props[key])) {
              var targetKey = key === "x" || key === "y" ? "attr" + key.toUpperCase() : key;
              newValues[targetKey] = props[key];
          }
      }
      return newValues;
  }

  function isAnimationControls(v) {
      return typeof v === "object" && typeof v.start === "function";
  }

  var isKeyframesTarget = function (v) {
      return Array.isArray(v);
  };

  var isCustomValue = function (v) {
      return Boolean(v && typeof v === "object" && v.mix && v.toValue);
  };
  var resolveFinalValueInKeyframes = function (v) {
      // TODO maybe throw if v.length - 1 is placeholder token?
      return isKeyframesTarget(v) ? v[v.length - 1] || 0 : v;
  };

  /**
   * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
   *
   * TODO: Remove and move to library
   *
   * @internal
   */
  function resolveMotionValue(value) {
      var unwrappedValue = isMotionValue(value) ? value.get() : value;
      return isCustomValue(unwrappedValue)
          ? unwrappedValue.toValue()
          : unwrappedValue;
  }

  function makeState(_a, props, context, presenceContext) {
      var scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps, createRenderState = _a.createRenderState, onMount = _a.onMount;
      var state = {
          latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
          renderState: createRenderState(),
      };
      if (onMount) {
          state.mount = function (instance) { return onMount(props, instance, state); };
      }
      return state;
  }
  var makeUseVisualState = function (config) { return function (props, isStatic) {
      var context = React.useContext(MotionContext);
      var presenceContext = React.useContext(PresenceContext);
      return isStatic
          ? makeState(config, props, context, presenceContext)
          : useConstant(function () { return makeState(config, props, context, presenceContext); });
  }; };
  function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
      var values = {};
      var blockInitialAnimation = (presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.initial) === false;
      var motionValues = scrapeMotionValues(props);
      for (var key in motionValues) {
          values[key] = resolveMotionValue(motionValues[key]);
      }
      var initial = props.initial, animate = props.animate;
      var isControllingVariants = checkIfControllingVariants(props);
      var isVariantNode = checkIfVariantNode(props);
      if (context &&
          isVariantNode &&
          !isControllingVariants &&
          props.inherit !== false) {
          initial !== null && initial !== void 0 ? initial : (initial = context.initial);
          animate !== null && animate !== void 0 ? animate : (animate = context.animate);
      }
      var variantToSet = blockInitialAnimation || initial === false ? animate : initial;
      if (variantToSet &&
          typeof variantToSet !== "boolean" &&
          !isAnimationControls(variantToSet)) {
          var list = Array.isArray(variantToSet) ? variantToSet : [variantToSet];
          list.forEach(function (definition) {
              var resolved = resolveVariantFromProps(props, definition);
              if (!resolved)
                  return;
              var transitionEnd = resolved.transitionEnd; resolved.transition; var target = __rest(resolved, ["transitionEnd", "transition"]);
              for (var key in target)
                  values[key] = target[key];
              for (var key in transitionEnd)
                  values[key] = transitionEnd[key];
          });
      }
      return values;
  }

  var svgMotionConfig = {
      useVisualState: makeUseVisualState({
          scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
          createRenderState: createSvgRenderState,
          onMount: function (props, instance, _a) {
              var renderState = _a.renderState, latestValues = _a.latestValues;
              try {
                  renderState.dimensions =
                      typeof instance.getBBox ===
                          "function"
                          ? instance.getBBox()
                          : instance.getBoundingClientRect();
              }
              catch (e) {
                  // Most likely trying to measure an unrendered element under Firefox
                  renderState.dimensions = {
                      x: 0,
                      y: 0,
                      width: 0,
                      height: 0,
                  };
              }
              if (isPath(instance)) {
                  renderState.totalPathLength = instance.getTotalLength();
              }
              buildSVGAttrs(renderState, latestValues, undefined, undefined, { enableHardwareAcceleration: false }, props.transformTemplate);
              // TODO: Replace with direct assignment
              renderSVG(instance, renderState);
          },
      }),
  };
  function isPath(element) {
      return element.tagName === "path";
  }

  var htmlMotionConfig = {
      useVisualState: makeUseVisualState({
          scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
          createRenderState: createHtmlRenderState,
      }),
  };

  function createDomMotionConfig(Component, _a, preloadedFeatures, createVisualElement) {
      var _b = _a.forwardMotionProps, forwardMotionProps = _b === void 0 ? false : _b;
      var baseConfig = isSVGComponent(Component)
          ? svgMotionConfig
          : htmlMotionConfig;
      return __assign(__assign({}, baseConfig), { preloadedFeatures: preloadedFeatures, useRender: createUseRender(forwardMotionProps), createVisualElement: createVisualElement,
          Component: Component });
  }

  var AnimationType;
  (function (AnimationType) {
      AnimationType["Animate"] = "animate";
      AnimationType["Hover"] = "whileHover";
      AnimationType["Tap"] = "whileTap";
      AnimationType["Drag"] = "whileDrag";
      AnimationType["Focus"] = "whileFocus";
      AnimationType["Exit"] = "exit";
  })(AnimationType || (AnimationType = {}));

  function addDomEvent(target, eventName, handler, options) {
      target.addEventListener(eventName, handler, options);
      return function () { return target.removeEventListener(eventName, handler, options); };
  }
  /**
   * Attaches an event listener directly to the provided DOM element.
   *
   * Bypassing React's event system can be desirable, for instance when attaching non-passive
   * event handlers.
   *
   * ```jsx
   * const ref = useRef(null)
   *
   * useDomEvent(ref, 'wheel', onWheel, { passive: false })
   *
   * return <div ref={ref} />
   * ```
   *
   * @param ref - React.RefObject that's been provided to the element you want to bind the listener to.
   * @param eventName - Name of the event you want listen for.
   * @param handler - Function to fire when receiving the event.
   * @param options - Options to pass to `Event.addEventListener`.
   *
   * @public
   */
  function useDomEvent(ref, eventName, handler, options) {
      React.useEffect(function () {
          var element = ref.current;
          if (handler && element) {
              return addDomEvent(element, eventName, handler, options);
          }
      }, [ref, eventName, handler, options]);
  }

  /**
   *
   * @param props
   * @param ref
   * @internal
   */
  function useFocusGesture(_a) {
      var whileFocus = _a.whileFocus, visualElement = _a.visualElement;
      var onFocus = function () {
          var _a;
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, true);
      };
      var onBlur = function () {
          var _a;
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Focus, false);
      };
      useDomEvent(visualElement, "focus", whileFocus ? onFocus : undefined);
      useDomEvent(visualElement, "blur", whileFocus ? onBlur : undefined);
  }

  function isMouseEvent(event) {
      // PointerEvent inherits from MouseEvent so we can't use a straight instanceof check.
      if (typeof PointerEvent !== "undefined" && event instanceof PointerEvent) {
          return !!(event.pointerType === "mouse");
      }
      return event instanceof MouseEvent;
  }
  function isTouchEvent(event) {
      var hasTouches = !!event.touches;
      return hasTouches;
  }

  /**
   * Filters out events not attached to the primary pointer (currently left mouse button)
   * @param eventHandler
   */
  function filterPrimaryPointer(eventHandler) {
      return function (event) {
          var isMouseEvent = event instanceof MouseEvent;
          var isPrimaryPointer = !isMouseEvent ||
              (isMouseEvent && event.button === 0);
          if (isPrimaryPointer) {
              eventHandler(event);
          }
      };
  }
  var defaultPagePoint = { pageX: 0, pageY: 0 };
  function pointFromTouch(e, pointType) {
      if (pointType === void 0) { pointType = "page"; }
      var primaryTouch = e.touches[0] || e.changedTouches[0];
      var point = primaryTouch || defaultPagePoint;
      return {
          x: point[pointType + "X"],
          y: point[pointType + "Y"],
      };
  }
  function pointFromMouse(point, pointType) {
      if (pointType === void 0) { pointType = "page"; }
      return {
          x: point[pointType + "X"],
          y: point[pointType + "Y"],
      };
  }
  function extractEventInfo(event, pointType) {
      if (pointType === void 0) { pointType = "page"; }
      return {
          point: isTouchEvent(event)
              ? pointFromTouch(event, pointType)
              : pointFromMouse(event, pointType),
      };
  }
  function getViewportPointFromEvent(event) {
      return extractEventInfo(event, "client");
  }
  var wrapHandler = function (handler, shouldFilterPrimaryPointer) {
      if (shouldFilterPrimaryPointer === void 0) { shouldFilterPrimaryPointer = false; }
      var listener = function (event) {
          return handler(event, extractEventInfo(event));
      };
      return shouldFilterPrimaryPointer
          ? filterPrimaryPointer(listener)
          : listener;
  };

  // We check for event support via functions in case they've been mocked by a testing suite.
  var supportsPointerEvents = function () {
      return isBrowser && window.onpointerdown === null;
  };
  var supportsTouchEvents = function () {
      return isBrowser && window.ontouchstart === null;
  };
  var supportsMouseEvents = function () {
      return isBrowser && window.onmousedown === null;
  };

  var mouseEventNames = {
      pointerdown: "mousedown",
      pointermove: "mousemove",
      pointerup: "mouseup",
      pointercancel: "mousecancel",
      pointerover: "mouseover",
      pointerout: "mouseout",
      pointerenter: "mouseenter",
      pointerleave: "mouseleave",
  };
  var touchEventNames = {
      pointerdown: "touchstart",
      pointermove: "touchmove",
      pointerup: "touchend",
      pointercancel: "touchcancel",
  };
  function getPointerEventName(name) {
      if (supportsPointerEvents()) {
          return name;
      }
      else if (supportsTouchEvents()) {
          return touchEventNames[name];
      }
      else if (supportsMouseEvents()) {
          return mouseEventNames[name];
      }
      return name;
  }
  function addPointerEvent(target, eventName, handler, options) {
      return addDomEvent(target, getPointerEventName(eventName), wrapHandler(handler, eventName === "pointerdown"), options);
  }
  function usePointerEvent(ref, eventName, handler, options) {
      return useDomEvent(ref, getPointerEventName(eventName), handler && wrapHandler(handler, eventName === "pointerdown"), options);
  }

  function createLock(name) {
      var lock = null;
      return function () {
          var openLock = function () {
              lock = null;
          };
          if (lock === null) {
              lock = name;
              return openLock;
          }
          return false;
      };
  }
  var globalHorizontalLock = createLock("dragHorizontal");
  var globalVerticalLock = createLock("dragVertical");
  function getGlobalLock(drag) {
      var lock = false;
      if (drag === "y") {
          lock = globalVerticalLock();
      }
      else if (drag === "x") {
          lock = globalHorizontalLock();
      }
      else {
          var openHorizontal_1 = globalHorizontalLock();
          var openVertical_1 = globalVerticalLock();
          if (openHorizontal_1 && openVertical_1) {
              lock = function () {
                  openHorizontal_1();
                  openVertical_1();
              };
          }
          else {
              // Release the locks because we don't use them
              if (openHorizontal_1)
                  openHorizontal_1();
              if (openVertical_1)
                  openVertical_1();
          }
      }
      return lock;
  }
  function isDragActive() {
      // Check the gesture lock - if we get it, it means no drag gesture is active
      // and we can safely fire the tap gesture.
      var openGestureLock = getGlobalLock(true);
      if (!openGestureLock)
          return true;
      openGestureLock();
      return false;
  }

  function createHoverEvent(visualElement, isActive, callback) {
      return function (event, info) {
          var _a;
          if (!isMouseEvent(event) || isDragActive())
              return;
          callback === null || callback === void 0 ? void 0 : callback(event, info);
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Hover, isActive);
      };
  }
  function useHoverGesture(_a) {
      var onHoverStart = _a.onHoverStart, onHoverEnd = _a.onHoverEnd, whileHover = _a.whileHover, visualElement = _a.visualElement;
      usePointerEvent(visualElement, "pointerenter", onHoverStart || whileHover
          ? createHoverEvent(visualElement, true, onHoverStart)
          : undefined);
      usePointerEvent(visualElement, "pointerleave", onHoverEnd || whileHover
          ? createHoverEvent(visualElement, false, onHoverEnd)
          : undefined);
  }

  /**
   * Recursively traverse up the tree to check whether the provided child node
   * is the parent or a descendant of it.
   *
   * @param parent - Element to find
   * @param child - Element to test against parent
   */
  var isNodeOrChild = function (parent, child) {
      if (!child) {
          return false;
      }
      else if (parent === child) {
          return true;
      }
      else {
          return isNodeOrChild(parent, child.parentElement);
      }
  };

  function useUnmountEffect(callback) {
      return React.useEffect(function () { return function () { return callback(); }; }, []);
  }

  var clamp = function (min, max, v) {
      return Math.min(Math.max(v, min), max);
  };

  var safeMin = 0.001;
  var minDuration = 0.01;
  var maxDuration = 10.0;
  var minDamping = 0.05;
  var maxDamping = 1;
  function findSpring(_a) {
      var _b = _a.duration, duration = _b === void 0 ? 800 : _b, _c = _a.bounce, bounce = _c === void 0 ? 0.25 : _c, _d = _a.velocity, velocity = _d === void 0 ? 0 : _d, _e = _a.mass, mass = _e === void 0 ? 1 : _e;
      var envelope;
      var derivative;
      var dampingRatio = 1 - bounce;
      dampingRatio = clamp(minDamping, maxDamping, dampingRatio);
      duration = clamp(minDuration, maxDuration, duration / 1000);
      if (dampingRatio < 1) {
          envelope = function (undampedFreq) {
              var exponentialDecay = undampedFreq * dampingRatio;
              var delta = exponentialDecay * duration;
              var a = exponentialDecay - velocity;
              var b = calcAngularFreq(undampedFreq, dampingRatio);
              var c = Math.exp(-delta);
              return safeMin - (a / b) * c;
          };
          derivative = function (undampedFreq) {
              var exponentialDecay = undampedFreq * dampingRatio;
              var delta = exponentialDecay * duration;
              var d = delta * velocity + velocity;
              var e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
              var f = Math.exp(-delta);
              var g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
              var factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
              return (factor * ((d - e) * f)) / g;
          };
      }
      else {
          envelope = function (undampedFreq) {
              var a = Math.exp(-undampedFreq * duration);
              var b = (undampedFreq - velocity) * duration + 1;
              return -safeMin + a * b;
          };
          derivative = function (undampedFreq) {
              var a = Math.exp(-undampedFreq * duration);
              var b = (velocity - undampedFreq) * (duration * duration);
              return a * b;
          };
      }
      var initialGuess = 5 / duration;
      var undampedFreq = approximateRoot(envelope, derivative, initialGuess);
      duration = duration * 1000;
      if (isNaN(undampedFreq)) {
          return {
              stiffness: 100,
              damping: 10,
              duration: duration,
          };
      }
      else {
          var stiffness = Math.pow(undampedFreq, 2) * mass;
          return {
              stiffness: stiffness,
              damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
              duration: duration,
          };
      }
  }
  var rootIterations = 12;
  function approximateRoot(envelope, derivative, initialGuess) {
      var result = initialGuess;
      for (var i = 1; i < rootIterations; i++) {
          result = result - envelope(result) / derivative(result);
      }
      return result;
  }
  function calcAngularFreq(undampedFreq, dampingRatio) {
      return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
  }

  var durationKeys = ["duration", "bounce"];
  var physicsKeys = ["stiffness", "damping", "mass"];
  function isSpringType(options, keys) {
      return keys.some(function (key) { return options[key] !== undefined; });
  }
  function getSpringOptions(options) {
      var springOptions = __assign({ velocity: 0.0, stiffness: 100, damping: 10, mass: 1.0, isResolvedFromDuration: false }, options);
      if (!isSpringType(options, physicsKeys) &&
          isSpringType(options, durationKeys)) {
          var derived = findSpring(options);
          springOptions = __assign(__assign(__assign({}, springOptions), derived), { velocity: 0.0, mass: 1.0 });
          springOptions.isResolvedFromDuration = true;
      }
      return springOptions;
  }
  function spring(_a) {
      var _b = _a.from, from = _b === void 0 ? 0.0 : _b, _c = _a.to, to = _c === void 0 ? 1.0 : _c, _d = _a.restSpeed, restSpeed = _d === void 0 ? 2 : _d, restDelta = _a.restDelta, options = __rest(_a, ["from", "to", "restSpeed", "restDelta"]);
      var state = { done: false, value: from };
      var _e = getSpringOptions(options), stiffness = _e.stiffness, damping = _e.damping, mass = _e.mass, velocity = _e.velocity, duration = _e.duration, isResolvedFromDuration = _e.isResolvedFromDuration;
      var resolveSpring = zero;
      var resolveVelocity = zero;
      function createSpring() {
          var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
          var initialDelta = to - from;
          var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
          var undampedAngularFreq = Math.sqrt(stiffness / mass) / 1000;
          restDelta !== null && restDelta !== void 0 ? restDelta : (restDelta = Math.abs(to - from) <= 1 ? 0.01 : 0.4);
          if (dampingRatio < 1) {
              var angularFreq_1 = calcAngularFreq(undampedAngularFreq, dampingRatio);
              resolveSpring = function (t) {
                  var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                  return (to -
                      envelope *
                          (((initialVelocity +
                              dampingRatio * undampedAngularFreq * initialDelta) /
                              angularFreq_1) *
                              Math.sin(angularFreq_1 * t) +
                              initialDelta * Math.cos(angularFreq_1 * t)));
              };
              resolveVelocity = function (t) {
                  var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                  return (dampingRatio *
                      undampedAngularFreq *
                      envelope *
                      ((Math.sin(angularFreq_1 * t) *
                          (initialVelocity +
                              dampingRatio *
                                  undampedAngularFreq *
                                  initialDelta)) /
                          angularFreq_1 +
                          initialDelta * Math.cos(angularFreq_1 * t)) -
                      envelope *
                          (Math.cos(angularFreq_1 * t) *
                              (initialVelocity +
                                  dampingRatio *
                                      undampedAngularFreq *
                                      initialDelta) -
                              angularFreq_1 *
                                  initialDelta *
                                  Math.sin(angularFreq_1 * t)));
              };
          }
          else if (dampingRatio === 1) {
              resolveSpring = function (t) {
                  return to -
                      Math.exp(-undampedAngularFreq * t) *
                          (initialDelta +
                              (initialVelocity + undampedAngularFreq * initialDelta) *
                                  t);
              };
          }
          else {
              var dampedAngularFreq_1 = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
              resolveSpring = function (t) {
                  var envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                  var freqForT = Math.min(dampedAngularFreq_1 * t, 300);
                  return (to -
                      (envelope *
                          ((initialVelocity +
                              dampingRatio * undampedAngularFreq * initialDelta) *
                              Math.sinh(freqForT) +
                              dampedAngularFreq_1 *
                                  initialDelta *
                                  Math.cosh(freqForT))) /
                          dampedAngularFreq_1);
              };
          }
      }
      createSpring();
      return {
          next: function (t) {
              var current = resolveSpring(t);
              if (!isResolvedFromDuration) {
                  var currentVelocity = resolveVelocity(t) * 1000;
                  var isBelowVelocityThreshold = Math.abs(currentVelocity) <= restSpeed;
                  var isBelowDisplacementThreshold = Math.abs(to - current) <= restDelta;
                  state.done =
                      isBelowVelocityThreshold && isBelowDisplacementThreshold;
              }
              else {
                  state.done = t >= duration;
              }
              state.value = state.done ? to : current;
              return state;
          },
          flipTarget: function () {
              var _a;
              velocity = -velocity;
              _a = [to, from], from = _a[0], to = _a[1];
              createSpring();
          },
      };
  }
  spring.needsInterpolation = function (a, b) {
      return typeof a === "string" || typeof b === "string";
  };
  var zero = function (_t) { return 0; };

  var progress = function (from, to, value) {
      var toFromDifference = to - from;
      return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
  };

  var mix = function (from, to, progress) {
      return -progress * from + progress * to + from;
  };

  var mixLinearColor = function (from, to, v) {
      var fromExpo = from * from;
      var toExpo = to * to;
      return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
  };
  var colorTypes = [hex, rgba, hsla];
  var getColorType = function (v) {
      return colorTypes.find(function (type) { return type.test(v); });
  };
  var mixColor = function (from, to) {
      var fromColorType = getColorType(from);
      var toColorType = getColorType(to);
      invariant(fromColorType.transform === toColorType.transform);
      var fromColor = fromColorType.parse(from);
      var toColor = toColorType.parse(to);
      var blended = __assign({}, fromColor);
      var mixFunc = fromColorType === hsla ? mix : mixLinearColor;
      return function (v) {
          for (var key in blended) {
              if (key !== "alpha") {
                  blended[key] = mixFunc(fromColor[key], toColor[key], v);
              }
          }
          blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
          return fromColorType.transform(blended);
      };
  };

  var isNum = function (v) { return typeof v === 'number'; };

  var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
  var pipe$2 = function () {
      var transformers = [];
      for (var _i = 0; _i < arguments.length; _i++) {
          transformers[_i] = arguments[_i];
      }
      return transformers.reduce(combineFunctions);
  };

  function getMixer(origin, target) {
      if (isNum(origin)) {
          return function (v) { return mix(origin, target, v); };
      }
      else if (color$1.test(origin)) {
          return mixColor(origin, target);
      }
      else {
          return mixComplex(origin, target);
      }
  }
  var mixArray = function (from, to) {
      var output = __spreadArray([], from);
      var numValues = output.length;
      var blendValue = from.map(function (fromThis, i) { return getMixer(fromThis, to[i]); });
      return function (v) {
          for (var i = 0; i < numValues; i++) {
              output[i] = blendValue[i](v);
          }
          return output;
      };
  };
  var mixObject = function (origin, target) {
      var output = __assign(__assign({}, origin), target);
      var blendValue = {};
      for (var key in output) {
          if (origin[key] !== undefined && target[key] !== undefined) {
              blendValue[key] = getMixer(origin[key], target[key]);
          }
      }
      return function (v) {
          for (var key in blendValue) {
              output[key] = blendValue[key](v);
          }
          return output;
      };
  };
  function analyse(value) {
      var parsed = complex.parse(value);
      var numValues = parsed.length;
      var numNumbers = 0;
      var numRGB = 0;
      var numHSL = 0;
      for (var i = 0; i < numValues; i++) {
          if (numNumbers || typeof parsed[i] === "number") {
              numNumbers++;
          }
          else {
              if (parsed[i].hue !== undefined) {
                  numHSL++;
              }
              else {
                  numRGB++;
              }
          }
      }
      return { parsed: parsed, numNumbers: numNumbers, numRGB: numRGB, numHSL: numHSL };
  }
  var mixComplex = function (origin, target) {
      var template = complex.createTransformer(target);
      var originStats = analyse(origin);
      var targetStats = analyse(target);
      return pipe$2(mixArray(originStats.parsed, targetStats.parsed), template);
  };

  var mixNumber = function (from, to) { return function (p) { return mix(from, to, p); }; };
  function detectMixerFactory(v) {
      if (typeof v === 'number') {
          return mixNumber;
      }
      else if (typeof v === 'string') {
          if (color$1.test(v)) {
              return mixColor;
          }
          else {
              return mixComplex;
          }
      }
      else if (Array.isArray(v)) {
          return mixArray;
      }
      else if (typeof v === 'object') {
          return mixObject;
      }
  }
  function createMixers(output, ease, customMixer) {
      var mixers = [];
      var mixerFactory = customMixer || detectMixerFactory(output[0]);
      var numMixers = output.length - 1;
      for (var i = 0; i < numMixers; i++) {
          var mixer = mixerFactory(output[i], output[i + 1]);
          if (ease) {
              var easingFunction = Array.isArray(ease) ? ease[i] : ease;
              mixer = pipe$2(easingFunction, mixer);
          }
          mixers.push(mixer);
      }
      return mixers;
  }
  function fastInterpolate(_a, _b) {
      var from = _a[0], to = _a[1];
      var mixer = _b[0];
      return function (v) { return mixer(progress(from, to, v)); };
  }
  function slowInterpolate(input, mixers) {
      var inputLength = input.length;
      var lastInputIndex = inputLength - 1;
      return function (v) {
          var mixerIndex = 0;
          var foundMixerIndex = false;
          if (v <= input[0]) {
              foundMixerIndex = true;
          }
          else if (v >= input[lastInputIndex]) {
              mixerIndex = lastInputIndex - 1;
              foundMixerIndex = true;
          }
          if (!foundMixerIndex) {
              var i = 1;
              for (; i < inputLength; i++) {
                  if (input[i] > v || i === lastInputIndex) {
                      break;
                  }
              }
              mixerIndex = i - 1;
          }
          var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
          return mixers[mixerIndex](progressInRange);
      };
  }
  function interpolate(input, output, _a) {
      var _b = _a === void 0 ? {} : _a, _c = _b.clamp, isClamp = _c === void 0 ? true : _c, ease = _b.ease, mixer = _b.mixer;
      var inputLength = input.length;
      invariant(inputLength === output.length);
      invariant(!ease || !Array.isArray(ease) || ease.length === inputLength - 1);
      if (input[0] > input[inputLength - 1]) {
          input = [].concat(input);
          output = [].concat(output);
          input.reverse();
          output.reverse();
      }
      var mixers = createMixers(output, ease, mixer);
      var interpolator = inputLength === 2
          ? fastInterpolate(input, mixers)
          : slowInterpolate(input, mixers);
      return isClamp
          ? function (v) { return interpolator(clamp(input[0], input[inputLength - 1], v)); }
          : interpolator;
  }

  var reverseEasing = function (easing) { return function (p) { return 1 - easing(1 - p); }; };
  var mirrorEasing = function (easing) { return function (p) {
      return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
  }; };
  var createExpoIn = function (power) { return function (p) { return Math.pow(p, power); }; };
  var createBackIn = function (power) { return function (p) {
      return p * p * ((power + 1) * p - power);
  }; };
  var createAnticipate = function (power) {
      var backEasing = createBackIn(power);
      return function (p) {
          return (p *= 2) < 1
              ? 0.5 * backEasing(p)
              : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
      };
  };

  var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
  var BOUNCE_FIRST_THRESHOLD = 4.0 / 11.0;
  var BOUNCE_SECOND_THRESHOLD = 8.0 / 11.0;
  var BOUNCE_THIRD_THRESHOLD = 9.0 / 10.0;
  var linear = function (p) { return p; };
  var easeIn = createExpoIn(2);
  var easeOut = reverseEasing(easeIn);
  var easeInOut = mirrorEasing(easeIn);
  var circIn = function (p) { return 1 - Math.sin(Math.acos(p)); };
  var circOut = reverseEasing(circIn);
  var circInOut = mirrorEasing(circOut);
  var backIn = createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
  var backOut = reverseEasing(backIn);
  var backInOut = mirrorEasing(backIn);
  var anticipate = createAnticipate(DEFAULT_OVERSHOOT_STRENGTH);
  var ca = 4356.0 / 361.0;
  var cb = 35442.0 / 1805.0;
  var cc = 16061.0 / 1805.0;
  var bounceOut = function (p) {
      if (p === 1 || p === 0)
          return p;
      var p2 = p * p;
      return p < BOUNCE_FIRST_THRESHOLD
          ? 7.5625 * p2
          : p < BOUNCE_SECOND_THRESHOLD
              ? 9.075 * p2 - 9.9 * p + 3.4
              : p < BOUNCE_THIRD_THRESHOLD
                  ? ca * p2 - cb * p + cc
                  : 10.8 * p * p - 20.52 * p + 10.72;
  };
  var bounceIn = reverseEasing(bounceOut);
  var bounceInOut = function (p) {
      return p < 0.5
          ? 0.5 * (1.0 - bounceOut(1.0 - p * 2.0))
          : 0.5 * bounceOut(p * 2.0 - 1.0) + 0.5;
  };

  function defaultEasing(values, easing) {
      return values.map(function () { return easing || easeInOut; }).splice(0, values.length - 1);
  }
  function defaultOffset(values) {
      var numValues = values.length;
      return values.map(function (_value, i) {
          return i !== 0 ? i / (numValues - 1) : 0;
      });
  }
  function convertOffsetToTimes(offset, duration) {
      return offset.map(function (o) { return o * duration; });
  }
  function keyframes$1(_a) {
      var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.to, to = _c === void 0 ? 1 : _c, ease = _a.ease, offset = _a.offset, _d = _a.duration, duration = _d === void 0 ? 300 : _d;
      var state = { done: false, value: from };
      var values = Array.isArray(to) ? to : [from, to];
      var times = convertOffsetToTimes(offset && offset.length === values.length
          ? offset
          : defaultOffset(values), duration);
      function createInterpolator() {
          return interpolate(times, values, {
              ease: Array.isArray(ease) ? ease : defaultEasing(values, ease),
          });
      }
      var interpolator = createInterpolator();
      return {
          next: function (t) {
              state.value = interpolator(t);
              state.done = t >= duration;
              return state;
          },
          flipTarget: function () {
              values.reverse();
              interpolator = createInterpolator();
          },
      };
  }

  function decay(_a) {
      var _b = _a.velocity, velocity = _b === void 0 ? 0 : _b, _c = _a.from, from = _c === void 0 ? 0 : _c, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 350 : _e, _f = _a.restDelta, restDelta = _f === void 0 ? 0.5 : _f, modifyTarget = _a.modifyTarget;
      var state = { done: false, value: from };
      var amplitude = power * velocity;
      var ideal = from + amplitude;
      var target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
      if (target !== ideal)
          amplitude = target - from;
      return {
          next: function (t) {
              var delta = -amplitude * Math.exp(-t / timeConstant);
              state.done = !(delta > restDelta || delta < -restDelta);
              state.value = state.done ? target : target + delta;
              return state;
          },
          flipTarget: function () { },
      };
  }

  var types = { keyframes: keyframes$1, spring: spring, decay: decay };
  function detectAnimationFromOptions(config) {
      if (Array.isArray(config.to)) {
          return keyframes$1;
      }
      else if (types[config.type]) {
          return types[config.type];
      }
      var keys = new Set(Object.keys(config));
      if (keys.has("ease") ||
          (keys.has("duration") && !keys.has("dampingRatio"))) {
          return keyframes$1;
      }
      else if (keys.has("dampingRatio") ||
          keys.has("stiffness") ||
          keys.has("mass") ||
          keys.has("damping") ||
          keys.has("restSpeed") ||
          keys.has("restDelta")) {
          return spring;
      }
      return keyframes$1;
  }

  var defaultTimestep = (1 / 60) * 1000;
  var getCurrentTime = typeof performance !== "undefined"
      ? function () { return performance.now(); }
      : function () { return Date.now(); };
  var onNextFrame = typeof window !== "undefined"
      ? function (callback) {
          return window.requestAnimationFrame(callback);
      }
      : function (callback) {
          return setTimeout(function () { return callback(getCurrentTime()); }, defaultTimestep);
      };

  function createRenderStep(runNextFrame) {
      var toRun = [];
      var toRunNextFrame = [];
      var numToRun = 0;
      var isProcessing = false;
      var toKeepAlive = new WeakSet();
      var step = {
          schedule: function (callback, keepAlive, immediate) {
              if (keepAlive === void 0) { keepAlive = false; }
              if (immediate === void 0) { immediate = false; }
              var addToCurrentFrame = immediate && isProcessing;
              var buffer = addToCurrentFrame ? toRun : toRunNextFrame;
              if (keepAlive)
                  toKeepAlive.add(callback);
              if (buffer.indexOf(callback) === -1) {
                  buffer.push(callback);
                  if (addToCurrentFrame && isProcessing)
                      numToRun = toRun.length;
              }
              return callback;
          },
          cancel: function (callback) {
              var index = toRunNextFrame.indexOf(callback);
              if (index !== -1)
                  toRunNextFrame.splice(index, 1);
              toKeepAlive.delete(callback);
          },
          process: function (frameData) {
              var _a;
              isProcessing = true;
              _a = [toRunNextFrame, toRun], toRun = _a[0], toRunNextFrame = _a[1];
              toRunNextFrame.length = 0;
              numToRun = toRun.length;
              if (numToRun) {
                  for (var i = 0; i < numToRun; i++) {
                      var callback = toRun[i];
                      callback(frameData);
                      if (toKeepAlive.has(callback)) {
                          step.schedule(callback);
                          runNextFrame();
                      }
                  }
              }
              isProcessing = false;
          },
      };
      return step;
  }

  var maxElapsed = 40;
  var useDefaultElapsed = true;
  var runNextFrame = false;
  var isProcessing = false;
  var frame = {
      delta: 0,
      timestamp: 0
  };
  var stepsOrder = ["read", "update", "preRender", "render", "postRender"];
  var steps = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
      acc[key] = createRenderStep(function () {
          return runNextFrame = true;
      });
      return acc;
  }, {});
  var sync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
      var step = steps[key];
      acc[key] = function (process, keepAlive, immediate) {
          if (keepAlive === void 0) {
              keepAlive = false;
          }
          if (immediate === void 0) {
              immediate = false;
          }
          if (!runNextFrame) startLoop();
          return step.schedule(process, keepAlive, immediate);
      };
      return acc;
  }, {});
  var cancelSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
      acc[key] = steps[key].cancel;
      return acc;
  }, {});
  var flushSync = /*#__PURE__*/stepsOrder.reduce(function (acc, key) {
      acc[key] = function () {
          return steps[key].process(frame);
      };
      return acc;
  }, {});
  var processStep = function (stepId) {
      return steps[stepId].process(frame);
  };
  var processFrame = function (timestamp) {
      runNextFrame = false;
      frame.delta = useDefaultElapsed ? defaultTimestep : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
      frame.timestamp = timestamp;
      isProcessing = true;
      stepsOrder.forEach(processStep);
      isProcessing = false;
      if (runNextFrame) {
          useDefaultElapsed = false;
          onNextFrame(processFrame);
      }
  };
  var startLoop = function () {
      runNextFrame = true;
      useDefaultElapsed = true;
      if (!isProcessing) onNextFrame(processFrame);
  };
  var getFrameData = function () {
      return frame;
  };

  function loopElapsed(elapsed, duration, delay) {
      if (delay === void 0) { delay = 0; }
      return elapsed - duration - delay;
  }
  function reverseElapsed(elapsed, duration, delay, isForwardPlayback) {
      if (delay === void 0) { delay = 0; }
      if (isForwardPlayback === void 0) { isForwardPlayback = true; }
      return isForwardPlayback
          ? loopElapsed(duration + -elapsed, duration, delay)
          : duration - (elapsed - duration) + delay;
  }
  function hasRepeatDelayElapsed(elapsed, duration, delay, isForwardPlayback) {
      return isForwardPlayback ? elapsed >= duration + delay : elapsed <= -delay;
  }

  var framesync = function (update) {
      var passTimestamp = function (_a) {
          var delta = _a.delta;
          return update(delta);
      };
      return {
          start: function () { return sync.update(passTimestamp, true); },
          stop: function () { return cancelSync.update(passTimestamp); },
      };
  };
  function animate(_a) {
      var _b, _c;
      var from = _a.from, _d = _a.autoplay, autoplay = _d === void 0 ? true : _d, _e = _a.driver, driver = _e === void 0 ? framesync : _e, _f = _a.elapsed, elapsed = _f === void 0 ? 0 : _f, _g = _a.repeat, repeatMax = _g === void 0 ? 0 : _g, _h = _a.repeatType, repeatType = _h === void 0 ? "loop" : _h, _j = _a.repeatDelay, repeatDelay = _j === void 0 ? 0 : _j, onPlay = _a.onPlay, onStop = _a.onStop, onComplete = _a.onComplete, onRepeat = _a.onRepeat, onUpdate = _a.onUpdate, options = __rest(_a, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
      var to = options.to;
      var driverControls;
      var repeatCount = 0;
      var computedDuration = options.duration;
      var latest;
      var isComplete = false;
      var isForwardPlayback = true;
      var interpolateFromNumber;
      var animator = detectAnimationFromOptions(options);
      if ((_c = (_b = animator).needsInterpolation) === null || _c === void 0 ? void 0 : _c.call(_b, from, to)) {
          interpolateFromNumber = interpolate([0, 100], [from, to], {
              clamp: false,
          });
          from = 0;
          to = 100;
      }
      var animation = animator(__assign(__assign({}, options), { from: from, to: to }));
      function repeat() {
          repeatCount++;
          if (repeatType === "reverse") {
              isForwardPlayback = repeatCount % 2 === 0;
              elapsed = reverseElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback);
          }
          else {
              elapsed = loopElapsed(elapsed, computedDuration, repeatDelay);
              if (repeatType === "mirror")
                  animation.flipTarget();
          }
          isComplete = false;
          onRepeat && onRepeat();
      }
      function complete() {
          driverControls.stop();
          onComplete && onComplete();
      }
      function update(delta) {
          if (!isForwardPlayback)
              delta = -delta;
          elapsed += delta;
          if (!isComplete) {
              var state = animation.next(Math.max(0, elapsed));
              latest = state.value;
              if (interpolateFromNumber)
                  latest = interpolateFromNumber(latest);
              isComplete = isForwardPlayback ? state.done : elapsed <= 0;
          }
          onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(latest);
          if (isComplete) {
              if (repeatCount === 0)
                  computedDuration !== null && computedDuration !== void 0 ? computedDuration : (computedDuration = elapsed);
              if (repeatCount < repeatMax) {
                  hasRepeatDelayElapsed(elapsed, computedDuration, repeatDelay, isForwardPlayback) && repeat();
              }
              else {
                  complete();
              }
          }
      }
      function play() {
          onPlay === null || onPlay === void 0 ? void 0 : onPlay();
          driverControls = driver(update);
          driverControls.start();
      }
      autoplay && play();
      return {
          stop: function () {
              onStop === null || onStop === void 0 ? void 0 : onStop();
              driverControls.stop();
          },
      };
  }

  function velocityPerSecond(velocity, frameDuration) {
      return frameDuration ? velocity * (1000 / frameDuration) : 0;
  }

  function inertia(_a) {
      var _b = _a.from, from = _b === void 0 ? 0 : _b, _c = _a.velocity, velocity = _c === void 0 ? 0 : _c, min = _a.min, max = _a.max, _d = _a.power, power = _d === void 0 ? 0.8 : _d, _e = _a.timeConstant, timeConstant = _e === void 0 ? 750 : _e, _f = _a.bounceStiffness, bounceStiffness = _f === void 0 ? 500 : _f, _g = _a.bounceDamping, bounceDamping = _g === void 0 ? 10 : _g, _h = _a.restDelta, restDelta = _h === void 0 ? 1 : _h, modifyTarget = _a.modifyTarget, driver = _a.driver, onUpdate = _a.onUpdate, onComplete = _a.onComplete;
      var currentAnimation;
      function isOutOfBounds(v) {
          return (min !== undefined && v < min) || (max !== undefined && v > max);
      }
      function boundaryNearest(v) {
          if (min === undefined)
              return max;
          if (max === undefined)
              return min;
          return Math.abs(min - v) < Math.abs(max - v) ? min : max;
      }
      function startAnimation(options) {
          currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop();
          currentAnimation = animate(__assign(__assign({}, options), { driver: driver, onUpdate: function (v) {
                  var _a;
                  onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(v);
                  (_a = options.onUpdate) === null || _a === void 0 ? void 0 : _a.call(options, v);
              }, onComplete: onComplete }));
      }
      function startSpring(options) {
          startAnimation(__assign({ type: "spring", stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta }, options));
      }
      if (isOutOfBounds(from)) {
          startSpring({ from: from, velocity: velocity, to: boundaryNearest(from) });
      }
      else {
          var target = power * velocity + from;
          if (typeof modifyTarget !== "undefined")
              target = modifyTarget(target);
          var boundary_1 = boundaryNearest(target);
          var heading_1 = boundary_1 === min ? -1 : 1;
          var prev_1;
          var current_1;
          var checkBoundary = function (v) {
              prev_1 = current_1;
              current_1 = v;
              velocity = velocityPerSecond(v - prev_1, getFrameData().delta);
              if ((heading_1 === 1 && v > boundary_1) ||
                  (heading_1 === -1 && v < boundary_1)) {
                  startSpring({ from: v, to: boundary_1, velocity: velocity });
              }
          };
          startAnimation({
              type: "decay",
              from: from,
              velocity: velocity,
              timeConstant: timeConstant,
              power: power,
              restDelta: restDelta,
              modifyTarget: modifyTarget,
              onUpdate: isOutOfBounds(target) ? checkBoundary : undefined,
          });
      }
      return {
          stop: function () { return currentAnimation === null || currentAnimation === void 0 ? void 0 : currentAnimation.stop(); },
      };
  }

  var isPoint = function (point) {
      return point.hasOwnProperty('x') && point.hasOwnProperty('y');
  };

  var isPoint3D = function (point) {
      return isPoint(point) && point.hasOwnProperty('z');
  };

  var distance1D = function (a, b) { return Math.abs(a - b); };
  function distance(a, b) {
      if (isNum(a) && isNum(b)) {
          return distance1D(a, b);
      }
      else if (isPoint(a) && isPoint(b)) {
          var xDelta = distance1D(a.x, b.x);
          var yDelta = distance1D(a.y, b.y);
          var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
          return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
      }
  }

  var a = function (a1, a2) { return 1.0 - 3.0 * a2 + 3.0 * a1; };
  var b = function (a1, a2) { return 3.0 * a2 - 6.0 * a1; };
  var c = function (a1) { return 3.0 * a1; };
  var calcBezier = function (t, a1, a2) {
      return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
  };
  var getSlope = function (t, a1, a2) {
      return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
  };
  var subdivisionPrecision = 0.0000001;
  var subdivisionMaxIterations = 10;
  function binarySubdivide(aX, aA, aB, mX1, mX2) {
      var currentX;
      var currentT;
      var i = 0;
      do {
          currentT = aA + (aB - aA) / 2.0;
          currentX = calcBezier(currentT, mX1, mX2) - aX;
          if (currentX > 0.0) {
              aB = currentT;
          }
          else {
              aA = currentT;
          }
      } while (Math.abs(currentX) > subdivisionPrecision &&
          ++i < subdivisionMaxIterations);
      return currentT;
  }
  var newtonIterations = 8;
  var newtonMinSlope = 0.001;
  function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
      for (var i = 0; i < newtonIterations; ++i) {
          var currentSlope = getSlope(aGuessT, mX1, mX2);
          if (currentSlope === 0.0) {
              return aGuessT;
          }
          var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
          aGuessT -= currentX / currentSlope;
      }
      return aGuessT;
  }
  var kSplineTableSize = 11;
  var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
  function cubicBezier(mX1, mY1, mX2, mY2) {
      if (mX1 === mY1 && mX2 === mY2)
          return linear;
      var sampleValues = new Float32Array(kSplineTableSize);
      for (var i = 0; i < kSplineTableSize; ++i) {
          sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
      }
      function getTForX(aX) {
          var intervalStart = 0.0;
          var currentSample = 1;
          var lastSample = kSplineTableSize - 1;
          for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
              intervalStart += kSampleStepSize;
          }
          --currentSample;
          var dist = (aX - sampleValues[currentSample]) /
              (sampleValues[currentSample + 1] - sampleValues[currentSample]);
          var guessForT = intervalStart + dist * kSampleStepSize;
          var initialSlope = getSlope(guessForT, mX1, mX2);
          if (initialSlope >= newtonMinSlope) {
              return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
          }
          else if (initialSlope === 0.0) {
              return guessForT;
          }
          else {
              return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
          }
      }
      return function (t) {
          return t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
      };
  }

  /**
   * @param handlers -
   * @internal
   */
  function useTapGesture(_a) {
      var onTap = _a.onTap, onTapStart = _a.onTapStart, onTapCancel = _a.onTapCancel, whileTap = _a.whileTap, visualElement = _a.visualElement;
      var hasPressListeners = onTap || onTapStart || onTapCancel || whileTap;
      var isPressing = React.useRef(false);
      var cancelPointerEndListeners = React.useRef(null);
      function removePointerEndListener() {
          var _a;
          (_a = cancelPointerEndListeners.current) === null || _a === void 0 ? void 0 : _a.call(cancelPointerEndListeners);
          cancelPointerEndListeners.current = null;
      }
      function checkPointerEnd() {
          var _a;
          removePointerEndListener();
          isPressing.current = false;
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, false);
          return !isDragActive();
      }
      function onPointerUp(event, info) {
          if (!checkPointerEnd())
              return;
          /**
           * We only count this as a tap gesture if the event.target is the same
           * as, or a child of, this component's element
           */
          !isNodeOrChild(visualElement.getInstance(), event.target)
              ? onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info)
              : onTap === null || onTap === void 0 ? void 0 : onTap(event, info);
      }
      function onPointerCancel(event, info) {
          if (!checkPointerEnd())
              return;
          onTapCancel === null || onTapCancel === void 0 ? void 0 : onTapCancel(event, info);
      }
      function onPointerDown(event, info) {
          var _a;
          removePointerEndListener();
          if (isPressing.current)
              return;
          isPressing.current = true;
          cancelPointerEndListeners.current = pipe$2(addPointerEvent(window, "pointerup", onPointerUp), addPointerEvent(window, "pointercancel", onPointerCancel));
          onTapStart === null || onTapStart === void 0 ? void 0 : onTapStart(event, info);
          (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Tap, true);
      }
      usePointerEvent(visualElement, "pointerdown", hasPressListeners ? onPointerDown : undefined);
      useUnmountEffect(removePointerEndListener);
  }

  var makeRenderlessComponent = function (hook) { return function (props) {
      hook(props);
      return null;
  }; };

  var gestureAnimations = {
      tap: makeRenderlessComponent(useTapGesture),
      focus: makeRenderlessComponent(useFocusGesture),
      hover: makeRenderlessComponent(useHoverGesture),
  };

  function shallowCompare(next, prev) {
      if (!Array.isArray(prev))
          return false;
      var prevLength = prev.length;
      if (prevLength !== next.length)
          return false;
      for (var i = 0; i < prevLength; i++) {
          if (prev[i] !== next[i])
              return false;
      }
      return true;
  }

  /**
   * Converts seconds to milliseconds
   *
   * @param seconds - Time in seconds.
   * @return milliseconds - Converted time in milliseconds.
   */
  var secondsToMilliseconds = function (seconds) { return seconds * 1000; };

  var easingLookup = {
      linear: linear,
      easeIn: easeIn,
      easeInOut: easeInOut,
      easeOut: easeOut,
      circIn: circIn,
      circInOut: circInOut,
      circOut: circOut,
      backIn: backIn,
      backInOut: backInOut,
      backOut: backOut,
      anticipate: anticipate,
      bounceIn: bounceIn,
      bounceInOut: bounceInOut,
      bounceOut: bounceOut,
  };
  var easingDefinitionToFunction = function (definition) {
      if (Array.isArray(definition)) {
          // If cubic bezier definition, create bezier curve
          invariant(definition.length === 4);
          var _a = __read(definition, 4), x1 = _a[0], y1 = _a[1], x2 = _a[2], y2 = _a[3];
          return cubicBezier(x1, y1, x2, y2);
      }
      else if (typeof definition === "string") {
          return easingLookup[definition];
      }
      return definition;
  };
  var isEasingArray = function (ease) {
      return Array.isArray(ease) && typeof ease[0] !== "number";
  };

  /**
   * Check if a value is animatable. Examples:
   *
   * ✅: 100, "100px", "#fff"
   * ❌: "block", "url(2.jpg)"
   * @param value
   *
   * @internal
   */
  var isAnimatable = function (key, value) {
      // If the list of keys tat might be non-animatable grows, replace with Set
      if (key === "zIndex")
          return false;
      // If it's a number or a keyframes array, we can animate it. We might at some point
      // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
      // but for now lets leave it like this for performance reasons
      if (typeof value === "number" || Array.isArray(value))
          return true;
      if (typeof value === "string" && // It's animatable if we have a string
          complex.test(value) && // And it contains numbers and/or colors
          !value.startsWith("url(") // Unless it starts with "url("
      ) {
          return true;
      }
      return false;
  };

  var underDampedSpring = function () { return ({
      type: "spring",
      stiffness: 500,
      damping: 25,
      restDelta: 0.5,
      restSpeed: 10,
  }); };
  var criticallyDampedSpring = function (to) { return ({
      type: "spring",
      stiffness: 550,
      damping: to === 0 ? 2 * Math.sqrt(550) : 30,
      restDelta: 0.01,
      restSpeed: 10,
  }); };
  var linearTween = function () { return ({
      type: "keyframes",
      ease: "linear",
      duration: 0.3,
  }); };
  var keyframes = function (values) { return ({
      type: "keyframes",
      duration: 0.8,
      values: values,
  }); };
  var defaultTransitions$1 = {
      x: underDampedSpring,
      y: underDampedSpring,
      z: underDampedSpring,
      rotate: underDampedSpring,
      rotateX: underDampedSpring,
      rotateY: underDampedSpring,
      rotateZ: underDampedSpring,
      scaleX: criticallyDampedSpring,
      scaleY: criticallyDampedSpring,
      scale: criticallyDampedSpring,
      opacity: linearTween,
      backgroundColor: linearTween,
      color: linearTween,
      default: criticallyDampedSpring,
  };
  var getDefaultTransition = function (valueKey, to) {
      var transitionFactory;
      if (isKeyframesTarget(to)) {
          transitionFactory = keyframes;
      }
      else {
          transitionFactory =
              defaultTransitions$1[valueKey] || defaultTransitions$1.default;
      }
      return __assign({ to: to }, transitionFactory(to));
  };

  /**
   * A map of default value types for common values
   */
  var defaultValueTypes = __assign(__assign({}, numberValueTypes), { 
      // Color props
      color: color$1, backgroundColor: color$1, outlineColor: color$1, fill: color$1, stroke: color$1, 
      // Border props
      borderColor: color$1, borderTopColor: color$1, borderRightColor: color$1, borderBottomColor: color$1, borderLeftColor: color$1, filter: filter$1, WebkitFilter: filter$1 });
  /**
   * Gets the default ValueType for the provided value key
   */
  var getDefaultValueType = function (key) { return defaultValueTypes[key]; };

  function getAnimatableNone(key, value) {
      var _a;
      var defaultValueType = getDefaultValueType(key);
      if (defaultValueType !== filter$1)
          defaultValueType = complex;
      // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
      return (_a = defaultValueType.getAnimatableNone) === null || _a === void 0 ? void 0 : _a.call(defaultValueType, value);
  }

  /**
   * Decide whether a transition is defined on a given Transition.
   * This filters out orchestration options and returns true
   * if any options are left.
   */
  function isTransitionDefined(_a) {
      _a.when; _a.delay; _a.delayChildren; _a.staggerChildren; _a.staggerDirection; _a.repeat; _a.repeatType; _a.repeatDelay; _a.from; var transition = __rest(_a, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
      return !!Object.keys(transition).length;
  }
  /**
   * Convert Framer Motion's Transition type into Popmotion-compatible options.
   */
  function convertTransitionToAnimationOptions(_a) {
      var ease = _a.ease, times = _a.times, yoyo = _a.yoyo, flip = _a.flip, loop = _a.loop, transition = __rest(_a, ["ease", "times", "yoyo", "flip", "loop"]);
      var options = __assign({}, transition);
      if (times)
          options["offset"] = times;
      /**
       * Convert any existing durations from seconds to milliseconds
       */
      if (transition.duration)
          options["duration"] = secondsToMilliseconds(transition.duration);
      if (transition.repeatDelay)
          options.repeatDelay = secondsToMilliseconds(transition.repeatDelay);
      /**
       * Map easing names to Popmotion's easing functions
       */
      if (ease) {
          options["ease"] = isEasingArray(ease)
              ? ease.map(easingDefinitionToFunction)
              : easingDefinitionToFunction(ease);
      }
      /**
       * Support legacy transition API
       */
      if (transition.type === "tween")
          options.type = "keyframes";
      /**
       * TODO: These options are officially removed from the API.
       */
      if (yoyo || loop || flip) {
          if (yoyo) {
              options.repeatType = "reverse";
          }
          else if (loop) {
              options.repeatType = "loop";
          }
          else if (flip) {
              options.repeatType = "mirror";
          }
          options.repeat = loop || yoyo || flip || transition.repeat;
      }
      /**
       * TODO: Popmotion 9 has the ability to automatically detect whether to use
       * a keyframes or spring animation, but does so by detecting velocity and other spring options.
       * It'd be good to introduce a similar thing here.
       */
      if (transition.type !== "spring")
          options.type = "keyframes";
      return options;
  }
  /**
   * Get the delay for a value by checking Transition with decreasing specificity.
   */
  function getDelayFromTransition(transition, key) {
      var _a;
      var valueTransition = getValueTransition(transition, key) || {};
      return (_a = valueTransition.delay) !== null && _a !== void 0 ? _a : 0;
  }
  function hydrateKeyframes(options) {
      if (Array.isArray(options.to) && options.to[0] === null) {
          options.to = __spreadArray([], __read(options.to));
          options.to[0] = options.from;
      }
      return options;
  }
  function getPopmotionAnimationOptions(transition, options, key) {
      var _a;
      if (Array.isArray(options.to)) {
          (_a = transition.duration) !== null && _a !== void 0 ? _a : (transition.duration = 0.8);
      }
      hydrateKeyframes(options);
      /**
       * Get a default transition if none is determined to be defined.
       */
      if (!isTransitionDefined(transition)) {
          transition = __assign(__assign({}, transition), getDefaultTransition(key, options.to));
      }
      return __assign(__assign({}, options), convertTransitionToAnimationOptions(transition));
  }
  /**
   *
   */
  function getAnimation(key, value, target, transition, onComplete) {
      var _a;
      var valueTransition = getValueTransition(transition, key);
      var origin = (_a = valueTransition.from) !== null && _a !== void 0 ? _a : value.get();
      var isTargetAnimatable = isAnimatable(key, target);
      if (origin === "none" && isTargetAnimatable && typeof target === "string") {
          /**
           * If we're trying to animate from "none", try and get an animatable version
           * of the target. This could be improved to work both ways.
           */
          origin = getAnimatableNone(key, target);
      }
      else if (isZero(origin) && typeof target === "string") {
          origin = getZeroUnit(target);
      }
      else if (!Array.isArray(target) &&
          isZero(target) &&
          typeof origin === "string") {
          target = getZeroUnit(origin);
      }
      var isOriginAnimatable = isAnimatable(key, origin);
      function start() {
          var options = {
              from: origin,
              to: target,
              velocity: value.getVelocity(),
              onComplete: onComplete,
              onUpdate: function (v) { return value.set(v); },
          };
          return valueTransition.type === "inertia" ||
              valueTransition.type === "decay"
              ? inertia(__assign(__assign({}, options), valueTransition))
              : animate(__assign(__assign({}, getPopmotionAnimationOptions(valueTransition, options, key)), { onUpdate: function (v) {
                      var _a;
                      options.onUpdate(v);
                      (_a = valueTransition.onUpdate) === null || _a === void 0 ? void 0 : _a.call(valueTransition, v);
                  }, onComplete: function () {
                      var _a;
                      options.onComplete();
                      (_a = valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
                  } }));
      }
      function set() {
          var _a;
          value.set(target);
          onComplete();
          (_a = valueTransition === null || valueTransition === void 0 ? void 0 : valueTransition.onComplete) === null || _a === void 0 ? void 0 : _a.call(valueTransition);
          return { stop: function () { } };
      }
      return !isOriginAnimatable ||
          !isTargetAnimatable ||
          valueTransition.type === false
          ? set
          : start;
  }
  function isZero(value) {
      return (value === 0 ||
          (typeof value === "string" &&
              parseFloat(value) === 0 &&
              value.indexOf(" ") === -1));
  }
  function getZeroUnit(potentialUnitType) {
      return typeof potentialUnitType === "number"
          ? 0
          : getAnimatableNone("", potentialUnitType);
  }
  function getValueTransition(transition, key) {
      return transition[key] || transition["default"] || transition;
  }
  /**
   * Start animation on a MotionValue. This function is an interface between
   * Framer Motion and Popmotion
   *
   * @internal
   */
  function startAnimation(key, value, target, transition) {
      if (transition === void 0) { transition = {}; }
      return value.start(function (onComplete) {
          var delayTimer;
          var controls;
          var animation = getAnimation(key, value, target, transition, onComplete);
          var delay = getDelayFromTransition(transition, key);
          var start = function () { return (controls = animation()); };
          if (delay) {
              delayTimer = setTimeout(start, secondsToMilliseconds(delay));
          }
          else {
              start();
          }
          return function () {
              clearTimeout(delayTimer);
              controls === null || controls === void 0 ? void 0 : controls.stop();
          };
      });
  }

  /**
   * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
   */
  var isNumericalString = function (v) { return /^\-?\d*\.?\d+$/.test(v); };

  function addUniqueItem(arr, item) {
      arr.indexOf(item) === -1 && arr.push(item);
  }
  function removeItem(arr, item) {
      var index = arr.indexOf(item);
      index > -1 && arr.splice(index, 1);
  }

  var SubscriptionManager = /** @class */ (function () {
      function SubscriptionManager() {
          this.subscriptions = [];
      }
      SubscriptionManager.prototype.add = function (handler) {
          var _this = this;
          addUniqueItem(this.subscriptions, handler);
          return function () { return removeItem(_this.subscriptions, handler); };
      };
      SubscriptionManager.prototype.notify = function (a, b, c) {
          var numSubscriptions = this.subscriptions.length;
          if (!numSubscriptions)
              return;
          if (numSubscriptions === 1) {
              /**
               * If there's only a single handler we can just call it without invoking a loop.
               */
              this.subscriptions[0](a, b, c);
          }
          else {
              for (var i = 0; i < numSubscriptions; i++) {
                  /**
                   * Check whether the handler exists before firing as it's possible
                   * the subscriptions were modified during this loop running.
                   */
                  var handler = this.subscriptions[i];
                  handler && handler(a, b, c);
              }
          }
      };
      SubscriptionManager.prototype.getSize = function () {
          return this.subscriptions.length;
      };
      SubscriptionManager.prototype.clear = function () {
          this.subscriptions.length = 0;
      };
      return SubscriptionManager;
  }());

  var isFloat = function (value) {
      return !isNaN(parseFloat(value));
  };
  /**
   * `MotionValue` is used to track the state and velocity of motion values.
   *
   * @public
   */
  var MotionValue = /** @class */ (function () {
      /**
       * @param init - The initiating value
       * @param config - Optional configuration options
       *
       * -  `transformer`: A function to transform incoming values with.
       *
       * @internal
       */
      function MotionValue(init) {
          var _this = this;
          /**
           * Duration, in milliseconds, since last updating frame.
           *
           * @internal
           */
          this.timeDelta = 0;
          /**
           * Timestamp of the last time this `MotionValue` was updated.
           *
           * @internal
           */
          this.lastUpdated = 0;
          /**
           * Functions to notify when the `MotionValue` updates.
           *
           * @internal
           */
          this.updateSubscribers = new SubscriptionManager();
          /**
           * Functions to notify when the velocity updates.
           *
           * @internal
           */
          this.velocityUpdateSubscribers = new SubscriptionManager();
          /**
           * Functions to notify when the `MotionValue` updates and `render` is set to `true`.
           *
           * @internal
           */
          this.renderSubscribers = new SubscriptionManager();
          /**
           * Tracks whether this value can output a velocity. Currently this is only true
           * if the value is numerical, but we might be able to widen the scope here and support
           * other value types.
           *
           * @internal
           */
          this.canTrackVelocity = false;
          this.updateAndNotify = function (v, render) {
              if (render === void 0) { render = true; }
              _this.prev = _this.current;
              _this.current = v;
              // Update timestamp
              var _a = getFrameData(), delta = _a.delta, timestamp = _a.timestamp;
              if (_this.lastUpdated !== timestamp) {
                  _this.timeDelta = delta;
                  _this.lastUpdated = timestamp;
                  sync.postRender(_this.scheduleVelocityCheck);
              }
              // Update update subscribers
              if (_this.prev !== _this.current) {
                  _this.updateSubscribers.notify(_this.current);
              }
              // Update velocity subscribers
              if (_this.velocityUpdateSubscribers.getSize()) {
                  _this.velocityUpdateSubscribers.notify(_this.getVelocity());
              }
              // Update render subscribers
              if (render) {
                  _this.renderSubscribers.notify(_this.current);
              }
          };
          /**
           * Schedule a velocity check for the next frame.
           *
           * This is an instanced and bound function to prevent generating a new
           * function once per frame.
           *
           * @internal
           */
          this.scheduleVelocityCheck = function () { return sync.postRender(_this.velocityCheck); };
          /**
           * Updates `prev` with `current` if the value hasn't been updated this frame.
           * This ensures velocity calculations return `0`.
           *
           * This is an instanced and bound function to prevent generating a new
           * function once per frame.
           *
           * @internal
           */
          this.velocityCheck = function (_a) {
              var timestamp = _a.timestamp;
              if (timestamp !== _this.lastUpdated) {
                  _this.prev = _this.current;
                  _this.velocityUpdateSubscribers.notify(_this.getVelocity());
              }
          };
          this.hasAnimated = false;
          this.prev = this.current = init;
          this.canTrackVelocity = isFloat(this.current);
      }
      /**
       * Adds a function that will be notified when the `MotionValue` is updated.
       *
       * It returns a function that, when called, will cancel the subscription.
       *
       * When calling `onChange` inside a React component, it should be wrapped with the
       * `useEffect` hook. As it returns an unsubscribe function, this should be returned
       * from the `useEffect` function to ensure you don't add duplicate subscribers..
       *
       * @library
       *
       * ```jsx
       * function MyComponent() {
       *   const x = useMotionValue(0)
       *   const y = useMotionValue(0)
       *   const opacity = useMotionValue(1)
       *
       *   useEffect(() => {
       *     function updateOpacity() {
       *       const maxXY = Math.max(x.get(), y.get())
       *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
       *       opacity.set(newOpacity)
       *     }
       *
       *     const unsubscribeX = x.onChange(updateOpacity)
       *     const unsubscribeY = y.onChange(updateOpacity)
       *
       *     return () => {
       *       unsubscribeX()
       *       unsubscribeY()
       *     }
       *   }, [])
       *
       *   return <Frame x={x} />
       * }
       * ```
       *
       * @motion
       *
       * ```jsx
       * export const MyComponent = () => {
       *   const x = useMotionValue(0)
       *   const y = useMotionValue(0)
       *   const opacity = useMotionValue(1)
       *
       *   useEffect(() => {
       *     function updateOpacity() {
       *       const maxXY = Math.max(x.get(), y.get())
       *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
       *       opacity.set(newOpacity)
       *     }
       *
       *     const unsubscribeX = x.onChange(updateOpacity)
       *     const unsubscribeY = y.onChange(updateOpacity)
       *
       *     return () => {
       *       unsubscribeX()
       *       unsubscribeY()
       *     }
       *   }, [])
       *
       *   return <motion.div style={{ x }} />
       * }
       * ```
       *
       * @internalremarks
       *
       * We could look into a `useOnChange` hook if the above lifecycle management proves confusing.
       *
       * ```jsx
       * useOnChange(x, () => {})
       * ```
       *
       * @param subscriber - A function that receives the latest value.
       * @returns A function that, when called, will cancel this subscription.
       *
       * @public
       */
      MotionValue.prototype.onChange = function (subscription) {
          return this.updateSubscribers.add(subscription);
      };
      MotionValue.prototype.clearListeners = function () {
          this.updateSubscribers.clear();
      };
      /**
       * Adds a function that will be notified when the `MotionValue` requests a render.
       *
       * @param subscriber - A function that's provided the latest value.
       * @returns A function that, when called, will cancel this subscription.
       *
       * @internal
       */
      MotionValue.prototype.onRenderRequest = function (subscription) {
          // Render immediately
          subscription(this.get());
          return this.renderSubscribers.add(subscription);
      };
      /**
       * Attaches a passive effect to the `MotionValue`.
       *
       * @internal
       */
      MotionValue.prototype.attach = function (passiveEffect) {
          this.passiveEffect = passiveEffect;
      };
      /**
       * Sets the state of the `MotionValue`.
       *
       * @remarks
       *
       * ```jsx
       * const x = useMotionValue(0)
       * x.set(10)
       * ```
       *
       * @param latest - Latest value to set.
       * @param render - Whether to notify render subscribers. Defaults to `true`
       *
       * @public
       */
      MotionValue.prototype.set = function (v, render) {
          if (render === void 0) { render = true; }
          if (!render || !this.passiveEffect) {
              this.updateAndNotify(v, render);
          }
          else {
              this.passiveEffect(v, this.updateAndNotify);
          }
      };
      /**
       * Returns the latest state of `MotionValue`
       *
       * @returns - The latest state of `MotionValue`
       *
       * @public
       */
      MotionValue.prototype.get = function () {
          return this.current;
      };
      /**
       * @public
       */
      MotionValue.prototype.getPrevious = function () {
          return this.prev;
      };
      /**
       * Returns the latest velocity of `MotionValue`
       *
       * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
       *
       * @public
       */
      MotionValue.prototype.getVelocity = function () {
          // This could be isFloat(this.prev) && isFloat(this.current), but that would be wasteful
          return this.canTrackVelocity
              ? // These casts could be avoided if parseFloat would be typed better
                  velocityPerSecond(parseFloat(this.current) -
                      parseFloat(this.prev), this.timeDelta)
              : 0;
      };
      /**
       * Registers a new animation to control this `MotionValue`. Only one
       * animation can drive a `MotionValue` at one time.
       *
       * ```jsx
       * value.start()
       * ```
       *
       * @param animation - A function that starts the provided animation
       *
       * @internal
       */
      MotionValue.prototype.start = function (animation) {
          var _this = this;
          this.stop();
          return new Promise(function (resolve) {
              _this.hasAnimated = true;
              _this.stopAnimation = animation(resolve);
          }).then(function () { return _this.clearAnimation(); });
      };
      /**
       * Stop the currently active animation.
       *
       * @public
       */
      MotionValue.prototype.stop = function () {
          if (this.stopAnimation)
              this.stopAnimation();
          this.clearAnimation();
      };
      /**
       * Returns `true` if this value is currently animating.
       *
       * @public
       */
      MotionValue.prototype.isAnimating = function () {
          return !!this.stopAnimation;
      };
      MotionValue.prototype.clearAnimation = function () {
          this.stopAnimation = null;
      };
      /**
       * Destroy and clean up subscribers to this `MotionValue`.
       *
       * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
       * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
       * created a `MotionValue` via the `motionValue` function.
       *
       * @public
       */
      MotionValue.prototype.destroy = function () {
          this.updateSubscribers.clear();
          this.renderSubscribers.clear();
          this.stop();
      };
      return MotionValue;
  }());
  /**
   * @internal
   */
  function motionValue(init) {
      return new MotionValue(init);
  }

  /**
   * Tests a provided value against a ValueType
   */
  var testValueType = function (v) { return function (type) { return type.test(v); }; };

  /**
   * ValueType for "auto"
   */
  var auto$1 = {
      test: function (v) { return v === "auto"; },
      parse: function (v) { return v; },
  };

  /**
   * A list of value types commonly used for dimensions
   */
  var dimensionValueTypes = [number, px, percent, degrees, vw, vh, auto$1];
  /**
   * Tests a dimensional value against the list of dimension ValueTypes
   */
  var findDimensionValueType = function (v) {
      return dimensionValueTypes.find(testValueType(v));
  };

  /**
   * A list of all ValueTypes
   */
  var valueTypes = __spreadArray(__spreadArray([], __read(dimensionValueTypes)), [color$1, complex]);
  /**
   * Tests a value against the list of ValueTypes
   */
  var findValueType = function (v) { return valueTypes.find(testValueType(v)); };

  /**
   * Set VisualElement's MotionValue, creating a new MotionValue for it if
   * it doesn't exist.
   */
  function setMotionValue(visualElement, key, value) {
      if (visualElement.hasValue(key)) {
          visualElement.getValue(key).set(value);
      }
      else {
          visualElement.addValue(key, motionValue(value));
      }
  }
  function setTarget(visualElement, definition) {
      var resolved = resolveVariant(visualElement, definition);
      var _a = resolved
          ? visualElement.makeTargetAnimatable(resolved, false)
          : {}, _b = _a.transitionEnd, transitionEnd = _b === void 0 ? {} : _b; _a.transition; var target = __rest(_a, ["transitionEnd", "transition"]);
      target = __assign(__assign({}, target), transitionEnd);
      for (var key in target) {
          var value = resolveFinalValueInKeyframes(target[key]);
          setMotionValue(visualElement, key, value);
      }
  }
  function checkTargetForNewValues(visualElement, target, origin) {
      var _a, _b, _c;
      var _d;
      var newValueKeys = Object.keys(target).filter(function (key) { return !visualElement.hasValue(key); });
      var numNewValues = newValueKeys.length;
      if (!numNewValues)
          return;
      for (var i = 0; i < numNewValues; i++) {
          var key = newValueKeys[i];
          var targetValue = target[key];
          var value = null;
          /**
           * If the target is a series of keyframes, we can use the first value
           * in the array. If this first value is null, we'll still need to read from the DOM.
           */
          if (Array.isArray(targetValue)) {
              value = targetValue[0];
          }
          /**
           * If the target isn't keyframes, or the first keyframe was null, we need to
           * first check if an origin value was explicitly defined in the transition as "from",
           * if not read the value from the DOM. As an absolute fallback, take the defined target value.
           */
          if (value === null) {
              value = (_b = (_a = origin[key]) !== null && _a !== void 0 ? _a : visualElement.readValue(key)) !== null && _b !== void 0 ? _b : target[key];
          }
          /**
           * If value is still undefined or null, ignore it. Preferably this would throw,
           * but this was causing issues in Framer.
           */
          if (value === undefined || value === null)
              continue;
          if (typeof value === "string" && isNumericalString(value)) {
              // If this is a number read as a string, ie "0" or "200", convert it to a number
              value = parseFloat(value);
          }
          else if (!findValueType(value) && complex.test(targetValue)) {
              value = getAnimatableNone(key, targetValue);
          }
          visualElement.addValue(key, motionValue(value));
          (_c = (_d = origin)[key]) !== null && _c !== void 0 ? _c : (_d[key] = value);
          visualElement.setBaseTarget(key, value);
      }
  }
  function getOriginFromTransition(key, transition) {
      if (!transition)
          return;
      var valueTransition = transition[key] || transition["default"] || transition;
      return valueTransition.from;
  }
  function getOrigin(target, transition, visualElement) {
      var _a, _b;
      var origin = {};
      for (var key in target) {
          origin[key] =
              (_a = getOriginFromTransition(key, transition)) !== null && _a !== void 0 ? _a : (_b = visualElement.getValue(key)) === null || _b === void 0 ? void 0 : _b.get();
      }
      return origin;
  }

  /**
   * @internal
   */
  function animateVisualElement(visualElement, definition, options) {
      if (options === void 0) { options = {}; }
      visualElement.notifyAnimationStart();
      var animation;
      if (Array.isArray(definition)) {
          var animations = definition.map(function (variant) {
              return animateVariant(visualElement, variant, options);
          });
          animation = Promise.all(animations);
      }
      else if (typeof definition === "string") {
          animation = animateVariant(visualElement, definition, options);
      }
      else {
          var resolvedDefinition = typeof definition === "function"
              ? resolveVariant(visualElement, definition, options.custom)
              : definition;
          animation = animateTarget(visualElement, resolvedDefinition, options);
      }
      return animation.then(function () {
          return visualElement.notifyAnimationComplete(definition);
      });
  }
  function animateVariant(visualElement, variant, options) {
      var _a;
      if (options === void 0) { options = {}; }
      var resolved = resolveVariant(visualElement, variant, options.custom);
      var _b = (resolved || {}).transition, transition = _b === void 0 ? visualElement.getDefaultTransition() || {} : _b;
      if (options.transitionOverride) {
          transition = options.transitionOverride;
      }
      /**
       * If we have a variant, create a callback that runs it as an animation.
       * Otherwise, we resolve a Promise immediately for a composable no-op.
       */
      var getAnimation = resolved
          ? function () { return animateTarget(visualElement, resolved, options); }
          : function () { return Promise.resolve(); };
      /**
       * If we have children, create a callback that runs all their animations.
       * Otherwise, we resolve a Promise immediately for a composable no-op.
       */
      var getChildAnimations = ((_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.size)
          ? function (forwardDelay) {
              if (forwardDelay === void 0) { forwardDelay = 0; }
              var _a = transition.delayChildren, delayChildren = _a === void 0 ? 0 : _a, staggerChildren = transition.staggerChildren, staggerDirection = transition.staggerDirection;
              return animateChildren(visualElement, variant, delayChildren + forwardDelay, staggerChildren, staggerDirection, options);
          }
          : function () { return Promise.resolve(); };
      /**
       * If the transition explicitly defines a "when" option, we need to resolve either
       * this animation or all children animations before playing the other.
       */
      var when = transition.when;
      if (when) {
          var _c = __read(when === "beforeChildren"
              ? [getAnimation, getChildAnimations]
              : [getChildAnimations, getAnimation], 2), first = _c[0], last = _c[1];
          return first().then(last);
      }
      else {
          return Promise.all([getAnimation(), getChildAnimations(options.delay)]);
      }
  }
  /**
   * @internal
   */
  function animateTarget(visualElement, definition, _a) {
      var _b;
      var _c = _a === void 0 ? {} : _a, _d = _c.delay, delay = _d === void 0 ? 0 : _d, transitionOverride = _c.transitionOverride, type = _c.type;
      var _e = visualElement.makeTargetAnimatable(definition), _f = _e.transition, transition = _f === void 0 ? visualElement.getDefaultTransition() : _f, transitionEnd = _e.transitionEnd, target = __rest(_e, ["transition", "transitionEnd"]);
      if (transitionOverride)
          transition = transitionOverride;
      var animations = [];
      var animationTypeState = type && ((_b = visualElement.animationState) === null || _b === void 0 ? void 0 : _b.getState()[type]);
      for (var key in target) {
          var value = visualElement.getValue(key);
          var valueTarget = target[key];
          if (!value ||
              valueTarget === undefined ||
              (animationTypeState &&
                  shouldBlockAnimation(animationTypeState, key))) {
              continue;
          }
          var animation = startAnimation(key, value, valueTarget, __assign({ delay: delay }, transition));
          animations.push(animation);
      }
      return Promise.all(animations).then(function () {
          transitionEnd && setTarget(visualElement, transitionEnd);
      });
  }
  function animateChildren(visualElement, variant, delayChildren, staggerChildren, staggerDirection, options) {
      if (delayChildren === void 0) { delayChildren = 0; }
      if (staggerChildren === void 0) { staggerChildren = 0; }
      if (staggerDirection === void 0) { staggerDirection = 1; }
      var animations = [];
      var maxStaggerDuration = (visualElement.variantChildren.size - 1) * staggerChildren;
      var generateStaggerDuration = staggerDirection === 1
          ? function (i) {
              if (i === void 0) { i = 0; }
              return i * staggerChildren;
          }
          : function (i) {
              if (i === void 0) { i = 0; }
              return maxStaggerDuration - i * staggerChildren;
          };
      Array.from(visualElement.variantChildren)
          .sort(sortByTreeOrder)
          .forEach(function (child, i) {
          animations.push(animateVariant(child, variant, __assign(__assign({}, options), { delay: delayChildren + generateStaggerDuration(i) })).then(function () { return child.notifyAnimationComplete(variant); }));
      });
      return Promise.all(animations);
  }
  function sortByTreeOrder(a, b) {
      return a.sortNodePosition(b);
  }
  /**
   * Decide whether we should block this animation. Previously, we achieved this
   * just by checking whether the key was listed in protectedKeys, but this
   * posed problems if an animation was triggered by afterChildren and protectedKeys
   * had been set to true in the meantime.
   */
  function shouldBlockAnimation(_a, key) {
      var protectedKeys = _a.protectedKeys, needsAnimating = _a.needsAnimating;
      var shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
      needsAnimating[key] = false;
      return shouldBlock;
  }

  var variantPriorityOrder = [
      AnimationType.Animate,
      AnimationType.Hover,
      AnimationType.Tap,
      AnimationType.Drag,
      AnimationType.Focus,
      AnimationType.Exit,
  ];
  var reversePriorityOrder = __spreadArray([], __read(variantPriorityOrder)).reverse();
  var numAnimationTypes = variantPriorityOrder.length;
  function animateList(visualElement) {
      return function (animations) {
          return Promise.all(animations.map(function (_a) {
              var animation = _a.animation, options = _a.options;
              return animateVisualElement(visualElement, animation, options);
          }));
      };
  }
  function createAnimationState(visualElement) {
      var animate = animateList(visualElement);
      var state = createState();
      var allAnimatedKeys = {};
      var isInitialRender = true;
      /**
       * This function will be used to reduce the animation definitions for
       * each active animation type into an object of resolved values for it.
       */
      var buildResolvedTypeValues = function (acc, definition) {
          var resolved = resolveVariant(visualElement, definition);
          if (resolved) {
              resolved.transition; var transitionEnd = resolved.transitionEnd, target = __rest(resolved, ["transition", "transitionEnd"]);
              acc = __assign(__assign(__assign({}, acc), target), transitionEnd);
          }
          return acc;
      };
      function isAnimated(key) {
          return allAnimatedKeys[key] !== undefined;
      }
      /**
       * This just allows us to inject mocked animation functions
       * @internal
       */
      function setAnimateFunction(makeAnimator) {
          animate = makeAnimator(visualElement);
      }
      /**
       * When we receive new props, we need to:
       * 1. Create a list of protected keys for each type. This is a directory of
       *    value keys that are currently being "handled" by types of a higher priority
       *    so that whenever an animation is played of a given type, these values are
       *    protected from being animated.
       * 2. Determine if an animation type needs animating.
       * 3. Determine if any values have been removed from a type and figure out
       *    what to animate those to.
       */
      function animateChanges(options, changedActiveType) {
          var _a;
          var props = visualElement.getProps();
          var context = visualElement.getVariantContext(true) || {};
          /**
           * A list of animations that we'll build into as we iterate through the animation
           * types. This will get executed at the end of the function.
           */
          var animations = [];
          /**
           * Keep track of which values have been removed. Then, as we hit lower priority
           * animation types, we can check if they contain removed values and animate to that.
           */
          var removedKeys = new Set();
          /**
           * A dictionary of all encountered keys. This is an object to let us build into and
           * copy it without iteration. Each time we hit an animation type we set its protected
           * keys - the keys its not allowed to animate - to the latest version of this object.
           */
          var encounteredKeys = {};
          /**
           * If a variant has been removed at a given index, and this component is controlling
           * variant animations, we want to ensure lower-priority variants are forced to animate.
           */
          var removedVariantIndex = Infinity;
          var _loop_1 = function (i) {
              var type = reversePriorityOrder[i];
              var typeState = state[type];
              var prop = (_a = props[type]) !== null && _a !== void 0 ? _a : context[type];
              var propIsVariant = isVariantLabel(prop);
              /**
               * If this type has *just* changed isActive status, set activeDelta
               * to that status. Otherwise set to null.
               */
              var activeDelta = type === changedActiveType ? typeState.isActive : null;
              if (activeDelta === false)
                  removedVariantIndex = i;
              /**
               * If this prop is an inherited variant, rather than been set directly on the
               * component itself, we want to make sure we allow the parent to trigger animations.
               *
               * TODO: Can probably change this to a !isControllingVariants check
               */
              var isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
              /**
               *
               */
              if (isInherited &&
                  isInitialRender &&
                  visualElement.manuallyAnimateOnMount) {
                  isInherited = false;
              }
              /**
               * Set all encountered keys so far as the protected keys for this type. This will
               * be any key that has been animated or otherwise handled by active, higher-priortiy types.
               */
              typeState.protectedKeys = __assign({}, encounteredKeys);
              // Check if we can skip analysing this prop early
              if (
              // If it isn't active and hasn't *just* been set as inactive
              (!typeState.isActive && activeDelta === null) ||
                  // If we didn't and don't have any defined prop for this animation type
                  (!prop && !typeState.prevProp) ||
                  // Or if the prop doesn't define an animation
                  isAnimationControls(prop) ||
                  typeof prop === "boolean") {
                  return "continue";
              }
              /**
               * As we go look through the values defined on this type, if we detect
               * a changed value or a value that was removed in a higher priority, we set
               * this to true and add this prop to the animation list.
               */
              var shouldAnimateType = variantsHaveChanged(typeState.prevProp, prop) ||
                  // If we're making this variant active, we want to always make it active
                  (type === changedActiveType &&
                      typeState.isActive &&
                      !isInherited &&
                      propIsVariant) ||
                  // If we removed a higher-priority variant (i is in reverse order)
                  (i > removedVariantIndex && propIsVariant);
              /**
               * As animations can be set as variant lists, variants or target objects, we
               * coerce everything to an array if it isn't one already
               */
              var definitionList = Array.isArray(prop) ? prop : [prop];
              /**
               * Build an object of all the resolved values. We'll use this in the subsequent
               * animateChanges calls to determine whether a value has changed.
               */
              var resolvedValues = definitionList.reduce(buildResolvedTypeValues, {});
              if (activeDelta === false)
                  resolvedValues = {};
              /**
               * Now we need to loop through all the keys in the prev prop and this prop,
               * and decide:
               * 1. If the value has changed, and needs animating
               * 2. If it has been removed, and needs adding to the removedKeys set
               * 3. If it has been removed in a higher priority type and needs animating
               * 4. If it hasn't been removed in a higher priority but hasn't changed, and
               *    needs adding to the type's protectedKeys list.
               */
              var _b = typeState.prevResolvedValues, prevResolvedValues = _b === void 0 ? {} : _b;
              var allKeys = __assign(__assign({}, prevResolvedValues), resolvedValues);
              var markToAnimate = function (key) {
                  shouldAnimateType = true;
                  removedKeys.delete(key);
                  typeState.needsAnimating[key] = true;
              };
              for (var key in allKeys) {
                  var next = resolvedValues[key];
                  var prev = prevResolvedValues[key];
                  // If we've already handled this we can just skip ahead
                  if (encounteredKeys.hasOwnProperty(key))
                      continue;
                  /**
                   * If the value has changed, we probably want to animate it.
                   */
                  if (next !== prev) {
                      /**
                       * If both values are keyframes, we need to shallow compare them to
                       * detect whether any value has changed. If it has, we animate it.
                       */
                      if (isKeyframesTarget(next) && isKeyframesTarget(prev)) {
                          if (!shallowCompare(next, prev)) {
                              markToAnimate(key);
                          }
                          else {
                              /**
                               * If it hasn't changed, we want to ensure it doesn't animate by
                               * adding it to the list of protected keys.
                               */
                              typeState.protectedKeys[key] = true;
                          }
                      }
                      else if (next !== undefined) {
                          // If next is defined and doesn't equal prev, it needs animating
                          markToAnimate(key);
                      }
                      else {
                          // If it's undefined, it's been removed.
                          removedKeys.add(key);
                      }
                  }
                  else if (next !== undefined && removedKeys.has(key)) {
                      /**
                       * If next hasn't changed and it isn't undefined, we want to check if it's
                       * been removed by a higher priority
                       */
                      markToAnimate(key);
                  }
                  else {
                      /**
                       * If it hasn't changed, we add it to the list of protected values
                       * to ensure it doesn't get animated.
                       */
                      typeState.protectedKeys[key] = true;
                  }
              }
              /**
               * Update the typeState so next time animateChanges is called we can compare the
               * latest prop and resolvedValues to these.
               */
              typeState.prevProp = prop;
              typeState.prevResolvedValues = resolvedValues;
              /**
               *
               */
              if (typeState.isActive) {
                  encounteredKeys = __assign(__assign({}, encounteredKeys), resolvedValues);
              }
              if (isInitialRender && visualElement.blockInitialAnimation) {
                  shouldAnimateType = false;
              }
              /**
               * If this is an inherited prop we want to hard-block animations
               * TODO: Test as this should probably still handle animations triggered
               * by removed values?
               */
              if (shouldAnimateType && !isInherited) {
                  animations.push.apply(animations, __spreadArray([], __read(definitionList.map(function (animation) { return ({
                      animation: animation,
                      options: __assign({ type: type }, options),
                  }); }))));
              }
          };
          /**
           * Iterate through all animation types in reverse priority order. For each, we want to
           * detect which values it's handling and whether or not they've changed (and therefore
           * need to be animated). If any values have been removed, we want to detect those in
           * lower priority props and flag for animation.
           */
          for (var i = 0; i < numAnimationTypes; i++) {
              _loop_1(i);
          }
          allAnimatedKeys = __assign({}, encounteredKeys);
          /**
           * If there are some removed value that haven't been dealt with,
           * we need to create a new animation that falls back either to the value
           * defined in the style prop, or the last read value.
           */
          if (removedKeys.size) {
              var fallbackAnimation_1 = {};
              removedKeys.forEach(function (key) {
                  var fallbackTarget = visualElement.getBaseTarget(key);
                  if (fallbackTarget !== undefined) {
                      fallbackAnimation_1[key] = fallbackTarget;
                  }
              });
              animations.push({ animation: fallbackAnimation_1 });
          }
          var shouldAnimate = Boolean(animations.length);
          if (isInitialRender &&
              props.initial === false &&
              !visualElement.manuallyAnimateOnMount) {
              shouldAnimate = false;
          }
          isInitialRender = false;
          return shouldAnimate ? animate(animations) : Promise.resolve();
      }
      /**
       * Change whether a certain animation type is active.
       */
      function setActive(type, isActive, options) {
          var _a;
          // If the active state hasn't changed, we can safely do nothing here
          if (state[type].isActive === isActive)
              return Promise.resolve();
          // Propagate active change to children
          (_a = visualElement.variantChildren) === null || _a === void 0 ? void 0 : _a.forEach(function (child) { var _a; return (_a = child.animationState) === null || _a === void 0 ? void 0 : _a.setActive(type, isActive); });
          state[type].isActive = isActive;
          return animateChanges(options, type);
      }
      return {
          isAnimated: isAnimated,
          animateChanges: animateChanges,
          setActive: setActive,
          setAnimateFunction: setAnimateFunction,
          getState: function () { return state; },
      };
  }
  function variantsHaveChanged(prev, next) {
      if (typeof next === "string") {
          return next !== prev;
      }
      else if (isVariantLabels(next)) {
          return !shallowCompare(next, prev);
      }
      return false;
  }
  function createTypeState(isActive) {
      if (isActive === void 0) { isActive = false; }
      return {
          isActive: isActive,
          protectedKeys: {},
          needsAnimating: {},
          prevResolvedValues: {},
      };
  }
  function createState() {
      var _a;
      return _a = {},
          _a[AnimationType.Animate] = createTypeState(true),
          _a[AnimationType.Hover] = createTypeState(),
          _a[AnimationType.Tap] = createTypeState(),
          _a[AnimationType.Drag] = createTypeState(),
          _a[AnimationType.Focus] = createTypeState(),
          _a[AnimationType.Exit] = createTypeState(),
          _a;
  }

  var animations = {
      animation: makeRenderlessComponent(function (_a) {
          var visualElement = _a.visualElement, animate = _a.animate;
          /**
           * We dynamically generate the AnimationState manager as it contains a reference
           * to the underlying animation library. We only want to load that if we load this,
           * so people can optionally code split it out using the `m` component.
           */
          visualElement.animationState || (visualElement.animationState = createAnimationState(visualElement));
          /**
           * Subscribe any provided AnimationControls to the component's VisualElement
           */
          if (isAnimationControls(animate)) {
              React.useEffect(function () { return animate.subscribe(visualElement); }, [animate]);
          }
      }),
      exit: makeRenderlessComponent(function (props) {
          var custom = props.custom, visualElement = props.visualElement;
          var _a = __read(usePresence(), 2), isPresent = _a[0], onExitComplete = _a[1];
          var presenceContext = React.useContext(PresenceContext);
          React.useEffect(function () {
              var _a, _b;
              var animation = (_a = visualElement.animationState) === null || _a === void 0 ? void 0 : _a.setActive(AnimationType.Exit, !isPresent, { custom: (_b = presenceContext === null || presenceContext === void 0 ? void 0 : presenceContext.custom) !== null && _b !== void 0 ? _b : custom });
              !isPresent && (animation === null || animation === void 0 ? void 0 : animation.then(onExitComplete));
          }, [isPresent]);
      }),
  };

  /**
   * @internal
   */
  var PanSession = /** @class */ (function () {
      function PanSession(event, handlers, _a) {
          var _this = this;
          var _b = _a === void 0 ? {} : _a, transformPagePoint = _b.transformPagePoint;
          /**
           * @internal
           */
          this.startEvent = null;
          /**
           * @internal
           */
          this.lastMoveEvent = null;
          /**
           * @internal
           */
          this.lastMoveEventInfo = null;
          /**
           * @internal
           */
          this.handlers = {};
          this.updatePoint = function () {
              if (!(_this.lastMoveEvent && _this.lastMoveEventInfo))
                  return;
              var info = getPanInfo(_this.lastMoveEventInfo, _this.history);
              var isPanStarted = _this.startEvent !== null;
              // Only start panning if the offset is larger than 3 pixels. If we make it
              // any larger than this we'll want to reset the pointer history
              // on the first update to avoid visual snapping to the cursoe.
              var isDistancePastThreshold = distance(info.offset, { x: 0, y: 0 }) >= 3;
              if (!isPanStarted && !isDistancePastThreshold)
                  return;
              var point = info.point;
              var timestamp = getFrameData().timestamp;
              _this.history.push(__assign(__assign({}, point), { timestamp: timestamp }));
              var _a = _this.handlers, onStart = _a.onStart, onMove = _a.onMove;
              if (!isPanStarted) {
                  onStart && onStart(_this.lastMoveEvent, info);
                  _this.startEvent = _this.lastMoveEvent;
              }
              onMove && onMove(_this.lastMoveEvent, info);
          };
          this.handlePointerMove = function (event, info) {
              _this.lastMoveEvent = event;
              _this.lastMoveEventInfo = transformPoint(info, _this.transformPagePoint);
              // Because Safari doesn't trigger mouseup events when it's above a `<select>`
              if (isMouseEvent(event) && event.buttons === 0) {
                  _this.handlePointerUp(event, info);
                  return;
              }
              // Throttle mouse move event to once per frame
              sync.update(_this.updatePoint, true);
          };
          this.handlePointerUp = function (event, info) {
              _this.end();
              var _a = _this.handlers, onEnd = _a.onEnd, onSessionEnd = _a.onSessionEnd;
              var panInfo = getPanInfo(transformPoint(info, _this.transformPagePoint), _this.history);
              if (_this.startEvent && onEnd) {
                  onEnd(event, panInfo);
              }
              onSessionEnd && onSessionEnd(event, panInfo);
          };
          // If we have more than one touch, don't start detecting this gesture
          if (isTouchEvent(event) && event.touches.length > 1)
              return;
          this.handlers = handlers;
          this.transformPagePoint = transformPagePoint;
          var info = extractEventInfo(event);
          var initialInfo = transformPoint(info, this.transformPagePoint);
          var point = initialInfo.point;
          var timestamp = getFrameData().timestamp;
          this.history = [__assign(__assign({}, point), { timestamp: timestamp })];
          var onSessionStart = handlers.onSessionStart;
          onSessionStart &&
              onSessionStart(event, getPanInfo(initialInfo, this.history));
          this.removeListeners = pipe$2(addPointerEvent(window, "pointermove", this.handlePointerMove), addPointerEvent(window, "pointerup", this.handlePointerUp), addPointerEvent(window, "pointercancel", this.handlePointerUp));
      }
      PanSession.prototype.updateHandlers = function (handlers) {
          this.handlers = handlers;
      };
      PanSession.prototype.end = function () {
          this.removeListeners && this.removeListeners();
          cancelSync.update(this.updatePoint);
      };
      return PanSession;
  }());
  function transformPoint(info, transformPagePoint) {
      return transformPagePoint ? { point: transformPagePoint(info.point) } : info;
  }
  function subtractPoint(a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
  }
  function getPanInfo(_a, history) {
      var point = _a.point;
      return {
          point: point,
          delta: subtractPoint(point, lastDevicePoint(history)),
          offset: subtractPoint(point, startDevicePoint(history)),
          velocity: getVelocity(history, 0.1),
      };
  }
  function startDevicePoint(history) {
      return history[0];
  }
  function lastDevicePoint(history) {
      return history[history.length - 1];
  }
  function getVelocity(history, timeDelta) {
      if (history.length < 2) {
          return { x: 0, y: 0 };
      }
      var i = history.length - 1;
      var timestampedPoint = null;
      var lastPoint = lastDevicePoint(history);
      while (i >= 0) {
          timestampedPoint = history[i];
          if (lastPoint.timestamp - timestampedPoint.timestamp >
              secondsToMilliseconds(timeDelta)) {
              break;
          }
          i--;
      }
      if (!timestampedPoint) {
          return { x: 0, y: 0 };
      }
      var time = (lastPoint.timestamp - timestampedPoint.timestamp) / 1000;
      if (time === 0) {
          return { x: 0, y: 0 };
      }
      var currentVelocity = {
          x: (lastPoint.x - timestampedPoint.x) / time,
          y: (lastPoint.y - timestampedPoint.y) / time,
      };
      if (currentVelocity.x === Infinity) {
          currentVelocity.x = 0;
      }
      if (currentVelocity.y === Infinity) {
          currentVelocity.y = 0;
      }
      return currentVelocity;
  }

  function noop(any) {
      return any;
  }

  /**
   * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
   * it's easier to consider each axis individually. This function returns a bounding box
   * as a map of single-axis min/max values.
   */
  function convertBoundingBoxToAxisBox(_a) {
      var top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom;
      return {
          x: { min: left, max: right },
          y: { min: top, max: bottom },
      };
  }
  function convertAxisBoxToBoundingBox(_a) {
      var x = _a.x, y = _a.y;
      return {
          top: y.min,
          bottom: y.max,
          left: x.min,
          right: x.max,
      };
  }
  /**
   * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
   * provided by Framer to allow measured points to be corrected for device scaling. This is used
   * when measuring DOM elements and DOM event points.
   */
  function transformBoundingBox(_a, transformPoint) {
      var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
      if (transformPoint === void 0) { transformPoint = noop; }
      var topLeft = transformPoint({ x: left, y: top });
      var bottomRight = transformPoint({ x: right, y: bottom });
      return {
          top: topLeft.y,
          left: topLeft.x,
          bottom: bottomRight.y,
          right: bottomRight.x,
      };
  }
  /**
   * Create an empty axis box of zero size
   */
  function axisBox() {
      return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
  }
  function copyAxisBox(box) {
      return {
          x: __assign({}, box.x),
          y: __assign({}, box.y),
      };
  }
  /**
   * Create an empty box delta
   */
  var zeroDelta = {
      translate: 0,
      scale: 1,
      origin: 0,
      originPoint: 0,
  };
  function delta() {
      return {
          x: __assign({}, zeroDelta),
          y: __assign({}, zeroDelta),
      };
  }

  // Call a handler once for each axis
  function eachAxis(handler) {
      return [handler("x"), handler("y")];
  }

  /**
   * Apply constraints to a point. These constraints are both physical along an
   * axis, and an elastic factor that determines how much to constrain the point
   * by if it does lie outside the defined parameters.
   */
  function applyConstraints(point, _a, elastic) {
      var min = _a.min, max = _a.max;
      if (min !== undefined && point < min) {
          // If we have a min point defined, and this is outside of that, constrain
          point = elastic ? mix(min, point, elastic.min) : Math.max(point, min);
      }
      else if (max !== undefined && point > max) {
          // If we have a max point defined, and this is outside of that, constrain
          point = elastic ? mix(max, point, elastic.max) : Math.min(point, max);
      }
      return point;
  }
  /**
   * Calculates a min projection point based on a pointer, pointer progress
   * within the drag target, and constraints.
   *
   * For instance if an element was 100px width, we were dragging from 0.25
   * along this axis, the pointer is at 200px, and there were no constraints,
   * we would calculate a min projection point of 175px.
   */
  function calcConstrainedMinPoint(point, length, progress, constraints, elastic) {
      // Calculate a min point for this axis and apply it to the current pointer
      var min = point - length * progress;
      return constraints ? applyConstraints(min, constraints, elastic) : min;
  }
  /**
   * Calculate constraints in terms of the viewport when defined relatively to the
   * measured axis. This is measured from the nearest edge, so a max constraint of 200
   * on an axis with a max value of 300 would return a constraint of 500 - axis length
   */
  function calcRelativeAxisConstraints(axis, min, max) {
      return {
          min: min !== undefined ? axis.min + min : undefined,
          max: max !== undefined
              ? axis.max + max - (axis.max - axis.min)
              : undefined,
      };
  }
  /**
   * Calculate constraints in terms of the viewport when
   * defined relatively to the measured bounding box.
   */
  function calcRelativeConstraints(layoutBox, _a) {
      var top = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
      return {
          x: calcRelativeAxisConstraints(layoutBox.x, left, right),
          y: calcRelativeAxisConstraints(layoutBox.y, top, bottom),
      };
  }
  /**
   * Calculate viewport constraints when defined as another viewport-relative axis
   */
  function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
      var _a;
      var min = constraintsAxis.min - layoutAxis.min;
      var max = constraintsAxis.max - layoutAxis.max;
      // If the constraints axis is actually smaller than the layout axis then we can
      // flip the constraints
      if (constraintsAxis.max - constraintsAxis.min <
          layoutAxis.max - layoutAxis.min) {
          _a = __read([max, min], 2), min = _a[0], max = _a[1];
      }
      return {
          min: layoutAxis.min + min,
          max: layoutAxis.min + max,
      };
  }
  /**
   * Calculate viewport constraints when defined as another viewport-relative box
   */
  function calcViewportConstraints(layoutBox, constraintsBox) {
      return {
          x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
          y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y),
      };
  }
  /**
   * Calculate the an axis position based on two axes and a progress value.
   */
  function calcPositionFromProgress(axis, constraints, progress) {
      var axisLength = axis.max - axis.min;
      var min = mix(constraints.min, constraints.max - axisLength, progress);
      return { min: min, max: min + axisLength };
  }
  /**
   * Rebase the calculated viewport constraints relative to the layout.min point.
   */
  function rebaseAxisConstraints(layout, constraints) {
      var relativeConstraints = {};
      if (constraints.min !== undefined) {
          relativeConstraints.min = constraints.min - layout.min;
      }
      if (constraints.max !== undefined) {
          relativeConstraints.max = constraints.max - layout.min;
      }
      return relativeConstraints;
  }
  var defaultElastic = 0.35;
  /**
   * Accepts a dragElastic prop and returns resolved elastic values for each axis.
   */
  function resolveDragElastic(dragElastic) {
      if (dragElastic === false) {
          dragElastic = 0;
      }
      else if (dragElastic === true) {
          dragElastic = defaultElastic;
      }
      return {
          x: resolveAxisElastic(dragElastic, "left", "right"),
          y: resolveAxisElastic(dragElastic, "top", "bottom"),
      };
  }
  function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
      return {
          min: resolvePointElastic(dragElastic, minLabel),
          max: resolvePointElastic(dragElastic, maxLabel),
      };
  }
  function resolvePointElastic(dragElastic, label) {
      var _a;
      return typeof dragElastic === "number"
          ? dragElastic
          : (_a = dragElastic[label]) !== null && _a !== void 0 ? _a : 0;
  }

  /**
   * Measure and return the element bounding box.
   *
   * We convert the box into an AxisBox2D to make it easier to work with each axis
   * individually and programmatically.
   *
   * This function optionally accepts a transformPagePoint function which allows us to compensate
   * for, for instance, measuring the element within a scaled plane like a Framer devivce preview component.
   */
  function getBoundingBox(element, transformPagePoint) {
      var box = element.getBoundingClientRect();
      return convertBoundingBoxToAxisBox(transformBoundingBox(box, transformPagePoint));
  }

  var clampProgress = function (v) { return clamp(0, 1, v); };
  /**
   * Returns true if the provided value is within maxDistance of the provided target
   */
  function isNear(value, target, maxDistance) {
      if (target === void 0) { target = 0; }
      if (maxDistance === void 0) { maxDistance = 0.01; }
      return distance(value, target) < maxDistance;
  }
  function calcLength(axis) {
      return axis.max - axis.min;
  }
  /**
   * Calculate a transform origin relative to the source axis, between 0-1, that results
   * in an asthetically pleasing scale/transform needed to project from source to target.
   */
  function calcOrigin(source, target) {
      var origin = 0.5;
      var sourceLength = calcLength(source);
      var targetLength = calcLength(target);
      if (targetLength > sourceLength) {
          origin = progress(target.min, target.max - sourceLength, source.min);
      }
      else if (sourceLength > targetLength) {
          origin = progress(source.min, source.max - targetLength, target.min);
      }
      return clampProgress(origin);
  }
  /**
   * Update the AxisDelta with a transform that projects source into target.
   *
   * The transform `origin` is optional. If not provided, it'll be automatically
   * calculated based on the relative positions of the two bounding boxes.
   */
  function updateAxisDelta(delta, source, target, origin) {
      if (origin === void 0) { origin = 0.5; }
      delta.origin = origin;
      delta.originPoint = mix(source.min, source.max, delta.origin);
      delta.scale = calcLength(target) / calcLength(source);
      if (isNear(delta.scale, 1, 0.0001))
          delta.scale = 1;
      delta.translate =
          mix(target.min, target.max, delta.origin) - delta.originPoint;
      if (isNear(delta.translate))
          delta.translate = 0;
  }
  /**
   * Update the BoxDelta with a transform that projects the source into the target.
   *
   * The transform `origin` is optional. If not provided, it'll be automatically
   * calculated based on the relative positions of the two bounding boxes.
   */
  function updateBoxDelta(delta, source, target, origin) {
      updateAxisDelta(delta.x, source.x, target.x, defaultOrigin(origin.originX));
      updateAxisDelta(delta.y, source.y, target.y, defaultOrigin(origin.originY));
  }
  /**
   * Currently this only accepts numerical origins, measured as 0-1, but could
   * accept pixel values by comparing to the target axis.
   */
  function defaultOrigin(origin) {
      return typeof origin === "number" ? origin : 0.5;
  }
  function calcRelativeAxis(target, relative, parent) {
      target.min = parent.min + relative.min;
      target.max = target.min + calcLength(relative);
  }
  function calcRelativeBox(projection, parentProjection) {
      calcRelativeAxis(projection.target.x, projection.relativeTarget.x, parentProjection.target.x);
      calcRelativeAxis(projection.target.y, projection.relativeTarget.y, parentProjection.target.y);
  }

  var compareByDepth = function (a, b) {
      return a.depth - b.depth;
  };

  function isProjecting(visualElement) {
      var isEnabled = visualElement.projection.isEnabled;
      return isEnabled || visualElement.shouldResetTransform();
  }
  function collectProjectingAncestors(visualElement, ancestors) {
      if (ancestors === void 0) { ancestors = []; }
      var parent = visualElement.parent;
      if (parent)
          collectProjectingAncestors(parent, ancestors);
      if (isProjecting(visualElement))
          ancestors.push(visualElement);
      return ancestors;
  }
  function collectProjectingChildren(visualElement) {
      var children = [];
      var addChild = function (child) {
          if (isProjecting(child))
              children.push(child);
          child.children.forEach(addChild);
      };
      visualElement.children.forEach(addChild);
      return children.sort(compareByDepth);
  }
  /**
   * Update the layoutState by measuring the DOM layout. This
   * should be called after resetting any layout-affecting transforms.
   */
  function updateLayoutMeasurement(visualElement) {
      if (visualElement.shouldResetTransform())
          return;
      var layoutState = visualElement.getLayoutState();
      visualElement.notifyBeforeLayoutMeasure(layoutState.layout);
      layoutState.isHydrated = true;
      layoutState.layout = visualElement.measureViewportBox();
      layoutState.layoutCorrected = copyAxisBox(layoutState.layout);
      visualElement.notifyLayoutMeasure(layoutState.layout, visualElement.prevViewportBox || layoutState.layout);
      sync.update(function () { return visualElement.rebaseProjectionTarget(); });
  }
  /**
   * Record the viewport box as it was before an expected mutation/re-render
   */
  function snapshotViewportBox(visualElement) {
      if (visualElement.shouldResetTransform())
          return;
      visualElement.prevViewportBox = visualElement.measureViewportBox(false);
      /**
       * Update targetBox to match the prevViewportBox. This is just to ensure
       * that targetBox is affected by scroll in the same way as the measured box
       */
      visualElement.rebaseProjectionTarget(false, visualElement.prevViewportBox);
  }

  function tweenAxis(target, prev, next, p) {
      target.min = mix(prev.min, next.min, p);
      target.max = mix(prev.max, next.max, p);
  }
  function calcRelativeOffsetAxis(parent, child) {
      return {
          min: child.min - parent.min,
          max: child.max - parent.min,
      };
  }
  function calcRelativeOffset(parent, child) {
      return {
          x: calcRelativeOffsetAxis(parent.x, child.x),
          y: calcRelativeOffsetAxis(parent.y, child.y),
      };
  }
  function checkIfParentHasChanged(prev, next) {
      var prevId = prev.getLayoutId();
      var nextId = next.getLayoutId();
      return prevId !== nextId || (nextId === undefined && prev !== next);
  }

  function isDraggable(visualElement) {
      var _a = visualElement.getProps(), drag = _a.drag, _dragX = _a._dragX;
      return drag && !_dragX;
  }

  /**
   * Reset an axis to the provided origin box.
   *
   * This is a mutative operation.
   */
  function resetAxis(axis, originAxis) {
      axis.min = originAxis.min;
      axis.max = originAxis.max;
  }
  /**
   * Reset a box to the provided origin box.
   *
   * This is a mutative operation.
   */
  function resetBox(box, originBox) {
      resetAxis(box.x, originBox.x);
      resetAxis(box.y, originBox.y);
  }
  /**
   * Scales a point based on a factor and an originPoint
   */
  function scalePoint(point, scale, originPoint) {
      var distanceFromOrigin = point - originPoint;
      var scaled = scale * distanceFromOrigin;
      return originPoint + scaled;
  }
  /**
   * Applies a translate/scale delta to a point
   */
  function applyPointDelta(point, translate, scale, originPoint, boxScale) {
      if (boxScale !== undefined) {
          point = scalePoint(point, boxScale, originPoint);
      }
      return scalePoint(point, scale, originPoint) + translate;
  }
  /**
   * Applies a translate/scale delta to an axis
   */
  function applyAxisDelta(axis, translate, scale, originPoint, boxScale) {
      if (translate === void 0) { translate = 0; }
      if (scale === void 0) { scale = 1; }
      axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
      axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
  }
  /**
   * Applies a translate/scale delta to a box
   */
  function applyBoxDelta(box, _a) {
      var x = _a.x, y = _a.y;
      applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
      applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
  }
  /**
   * Apply a transform to an axis from the latest resolved motion values.
   * This function basically acts as a bridge between a flat motion value map
   * and applyAxisDelta
   */
  function applyAxisTransforms(final, axis, transforms, _a) {
      var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
      // Copy the current axis to the final axis before mutation
      final.min = axis.min;
      final.max = axis.max;
      var axisOrigin = transforms[originKey] !== undefined ? transforms[originKey] : 0.5;
      var originPoint = mix(axis.min, axis.max, axisOrigin);
      // Apply the axis delta to the final axis
      applyAxisDelta(final, transforms[key], transforms[scaleKey], originPoint, transforms.scale);
  }
  /**
   * The names of the motion values we want to apply as translation, scale and origin.
   */
  var xKeys = ["x", "scaleX", "originX"];
  var yKeys = ["y", "scaleY", "originY"];
  /**
   * Apply a transform to a box from the latest resolved motion values.
   */
  function applyBoxTransforms(finalBox, box, transforms) {
      applyAxisTransforms(finalBox.x, box.x, transforms, xKeys);
      applyAxisTransforms(finalBox.y, box.y, transforms, yKeys);
  }
  /**
   * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
   */
  function removePointDelta(point, translate, scale, originPoint, boxScale) {
      point -= translate;
      point = scalePoint(point, 1 / scale, originPoint);
      if (boxScale !== undefined) {
          point = scalePoint(point, 1 / boxScale, originPoint);
      }
      return point;
  }
  /**
   * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
   */
  function removeAxisDelta(axis, translate, scale, origin, boxScale) {
      if (translate === void 0) { translate = 0; }
      if (scale === void 0) { scale = 1; }
      if (origin === void 0) { origin = 0.5; }
      var originPoint = mix(axis.min, axis.max, origin) - translate;
      axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
      axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
  }
  /**
   * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
   * and acts as a bridge between motion values and removeAxisDelta
   */
  function removeAxisTransforms(axis, transforms, _a) {
      var _b = __read(_a, 3), key = _b[0], scaleKey = _b[1], originKey = _b[2];
      removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale);
  }
  /**
   * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
   * and acts as a bridge between motion values and removeAxisDelta
   */
  function removeBoxTransforms(box, transforms) {
      removeAxisTransforms(box.x, transforms, xKeys);
      removeAxisTransforms(box.y, transforms, yKeys);
  }
  /**
   * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
   * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
   *
   * This is the final nested loop within updateLayoutDelta for future refactoring
   */
  function applyTreeDeltas(box, treeScale, treePath) {
      var treeLength = treePath.length;
      if (!treeLength)
          return;
      // Reset the treeScale
      treeScale.x = treeScale.y = 1;
      var node;
      var delta;
      for (var i = 0; i < treeLength; i++) {
          node = treePath[i];
          delta = node.getLayoutState().delta;
          // Incoporate each ancestor's scale into a culmulative treeScale for this component
          treeScale.x *= delta.x.scale;
          treeScale.y *= delta.y.scale;
          // Apply each ancestor's calculated delta into this component's recorded layout box
          applyBoxDelta(box, delta);
          // If this is a draggable ancestor, also incorporate the node's transform to the layout box
          if (isDraggable(node)) {
              applyBoxTransforms(box, box, node.getLatestValues());
          }
      }
  }

  /**
   * Returns a boolean stating whether or not we converted the projection
   * to relative projection.
   */
  function convertToRelativeProjection(visualElement, isLayoutDrag) {
      if (isLayoutDrag === void 0) { isLayoutDrag = true; }
      var projectionParent = visualElement.getProjectionParent();
      if (!projectionParent)
          return false;
      var offset;
      if (isLayoutDrag) {
          offset = calcRelativeOffset(projectionParent.projection.target, visualElement.projection.target);
          removeBoxTransforms(offset, projectionParent.getLatestValues());
      }
      else {
          offset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
      }
      eachAxis(function (axis) {
          return visualElement.setProjectionTargetAxis(axis, offset[axis].min, offset[axis].max, true);
      });
      return true;
  }

  var unresolvedJobs = new Set();
  function pushJob(stack, job, pointer) {
      if (!stack[pointer])
          stack[pointer] = [];
      stack[pointer].push(job);
  }
  function batchLayout(callback) {
      unresolvedJobs.add(callback);
      return function () { return unresolvedJobs.delete(callback); };
  }
  function flushLayout() {
      if (!unresolvedJobs.size)
          return;
      var pointer = 0;
      var reads = [[]];
      var writes = [];
      var setRead = function (job) { return pushJob(reads, job, pointer); };
      var setWrite = function (job) {
          pushJob(writes, job, pointer);
          pointer++;
      };
      /**
       * Resolve jobs into their array stacks
       */
      unresolvedJobs.forEach(function (callback) {
          callback(setRead, setWrite);
          pointer = 0;
      });
      unresolvedJobs.clear();
      /**
       * Execute jobs
       */
      var numStacks = writes.length;
      for (var i = 0; i <= numStacks; i++) {
          reads[i] && reads[i].forEach(executeJob);
          writes[i] && writes[i].forEach(executeJob);
      }
  }
  var executeJob = function (job) { return job(); };

  var elementDragControls = new WeakMap();
  /**
   *
   */
  var lastPointerEvent;
  var VisualElementDragControls = /** @class */ (function () {
      function VisualElementDragControls(_a) {
          var visualElement = _a.visualElement;
          /**
           * Track whether we're currently dragging.
           *
           * @internal
           */
          this.isDragging = false;
          /**
           * The current direction of drag, or `null` if both.
           *
           * @internal
           */
          this.currentDirection = null;
          /**
           * The permitted boundaries of travel, in pixels.
           *
           * @internal
           */
          this.constraints = false;
          /**
           * The per-axis resolved elastic values.
           *
           * @internal
           */
          this.elastic = axisBox();
          /**
           * A reference to the host component's latest props.
           *
           * @internal
           */
          this.props = {};
          /**
           * @internal
           */
          this.hasMutatedConstraints = false;
          /**
           * Track the initial position of the cursor relative to the dragging element
           * when dragging starts as a value of 0-1 on each axis. We then use this to calculate
           * an ideal bounding box for the VisualElement renderer to project into every frame.
           *
           * @internal
           */
          this.cursorProgress = {
              x: 0.5,
              y: 0.5,
          };
          // When updating _dragX, or _dragY instead of the VisualElement,
          // persist their values between drag gestures.
          this.originPoint = {};
          // This is a reference to the global drag gesture lock, ensuring only one component
          // can "capture" the drag of one or both axes.
          // TODO: Look into moving this into pansession?
          this.openGlobalLock = null;
          /**
           * @internal
           */
          this.panSession = null;
          this.visualElement = visualElement;
          this.visualElement.enableLayoutProjection();
          elementDragControls.set(visualElement, this);
      }
      /**
       * Instantiate a PanSession for the drag gesture
       *
       * @public
       */
      VisualElementDragControls.prototype.start = function (originEvent, _a) {
          var _this = this;
          var _b = _a === void 0 ? {} : _a, _c = _b.snapToCursor, snapToCursor = _c === void 0 ? false : _c, cursorProgress = _b.cursorProgress;
          var onSessionStart = function (event) {
              var _a;
              // Stop any animations on both axis values immediately. This allows the user to throw and catch
              // the component.
              _this.stopMotion();
              /**
               * Save the initial point. We'll use this to calculate the pointer's position rather
               * than the one we receive when the gesture actually starts. By then, the pointer will
               * have already moved, and the perception will be of the pointer "slipping" across the element
               */
              var initialPoint = getViewportPointFromEvent(event).point;
              (_a = _this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(_this);
              _this.cancelLayout = batchLayout(function (read, write) {
                  var ancestors = collectProjectingAncestors(_this.visualElement);
                  var children = collectProjectingChildren(_this.visualElement);
                  var tree = __spreadArray(__spreadArray([], __read(ancestors)), __read(children));
                  var hasManuallySetCursorOrigin = false;
                  /**
                   * Apply a simple lock to the projection target. This ensures no animations
                   * can run on the projection box while this lock is active.
                   */
                  _this.isLayoutDrag() && _this.visualElement.lockProjectionTarget();
                  write(function () {
                      tree.forEach(function (element) { return element.resetTransform(); });
                  });
                  read(function () {
                      updateLayoutMeasurement(_this.visualElement);
                      children.forEach(updateLayoutMeasurement);
                  });
                  write(function () {
                      tree.forEach(function (element) { return element.restoreTransform(); });
                      if (snapToCursor) {
                          hasManuallySetCursorOrigin = _this.snapToCursor(initialPoint);
                      }
                  });
                  read(function () {
                      var isRelativeDrag = Boolean(_this.getAxisMotionValue("x") && !_this.isExternalDrag());
                      if (!isRelativeDrag) {
                          _this.visualElement.rebaseProjectionTarget(true, _this.visualElement.measureViewportBox(false));
                      }
                      _this.visualElement.scheduleUpdateLayoutProjection();
                      /**
                       * When dragging starts, we want to find where the cursor is relative to the bounding box
                       * of the element. Every frame, we calculate a new bounding box using this relative position
                       * and let the visualElement renderer figure out how to reproject the element into this bounding
                       * box.
                       *
                       * By doing it this way, rather than applying an x/y transform directly to the element,
                       * we can ensure the component always visually sticks to the cursor as we'd expect, even
                       * if the DOM element itself changes layout as a result of React updates the user might
                       * make based on the drag position.
                       */
                      var projection = _this.visualElement.projection;
                      eachAxis(function (axis) {
                          if (!hasManuallySetCursorOrigin) {
                              var _a = projection.target[axis], min = _a.min, max = _a.max;
                              _this.cursorProgress[axis] = cursorProgress
                                  ? cursorProgress[axis]
                                  : progress(min, max, initialPoint[axis]);
                          }
                          /**
                           * If we have external drag MotionValues, record their origin point. On pointermove
                           * we'll apply the pan gesture offset directly to this value.
                           */
                          var axisValue = _this.getAxisMotionValue(axis);
                          if (axisValue) {
                              _this.originPoint[axis] = axisValue.get();
                          }
                      });
                  });
                  write(function () {
                      flushSync.update();
                      flushSync.preRender();
                      flushSync.render();
                      flushSync.postRender();
                  });
                  read(function () { return _this.resolveDragConstraints(); });
              });
          };
          var onStart = function (event, info) {
              var _a, _b, _c;
              // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
              var _d = _this.props, drag = _d.drag, dragPropagation = _d.dragPropagation;
              if (drag && !dragPropagation) {
                  if (_this.openGlobalLock)
                      _this.openGlobalLock();
                  _this.openGlobalLock = getGlobalLock(drag);
                  // If we don 't have the lock, don't start dragging
                  if (!_this.openGlobalLock)
                      return;
              }
              flushLayout();
              // Set current drag status
              _this.isDragging = true;
              _this.currentDirection = null;
              // Fire onDragStart event
              (_b = (_a = _this.props).onDragStart) === null || _b === void 0 ? void 0 : _b.call(_a, event, info);
              (_c = _this.visualElement.animationState) === null || _c === void 0 ? void 0 : _c.setActive(AnimationType.Drag, true);
          };
          var onMove = function (event, info) {
              var _a, _b, _c, _d;
              var _e = _this.props, dragPropagation = _e.dragPropagation, dragDirectionLock = _e.dragDirectionLock;
              // If we didn't successfully receive the gesture lock, early return.
              if (!dragPropagation && !_this.openGlobalLock)
                  return;
              var offset = info.offset;
              // Attempt to detect drag direction if directionLock is true
              if (dragDirectionLock && _this.currentDirection === null) {
                  _this.currentDirection = getCurrentDirection(offset);
                  // If we've successfully set a direction, notify listener
                  if (_this.currentDirection !== null) {
                      (_b = (_a = _this.props).onDirectionLock) === null || _b === void 0 ? void 0 : _b.call(_a, _this.currentDirection);
                  }
                  return;
              }
              // Update each point with the latest position
              _this.updateAxis("x", info.point, offset);
              _this.updateAxis("y", info.point, offset);
              // Fire onDrag event
              (_d = (_c = _this.props).onDrag) === null || _d === void 0 ? void 0 : _d.call(_c, event, info);
              // Update the last pointer event
              lastPointerEvent = event;
          };
          var onSessionEnd = function (event, info) {
              return _this.stop(event, info);
          };
          var transformPagePoint = this.props.transformPagePoint;
          this.panSession = new PanSession(originEvent, {
              onSessionStart: onSessionStart,
              onStart: onStart,
              onMove: onMove,
              onSessionEnd: onSessionEnd,
          }, { transformPagePoint: transformPagePoint });
      };
      VisualElementDragControls.prototype.resolveDragConstraints = function () {
          var _this = this;
          var _a = this.props, dragConstraints = _a.dragConstraints, dragElastic = _a.dragElastic;
          var layout = this.visualElement.getLayoutState().layoutCorrected;
          if (dragConstraints) {
              this.constraints = isRefObject(dragConstraints)
                  ? this.resolveRefConstraints(layout, dragConstraints)
                  : calcRelativeConstraints(layout, dragConstraints);
          }
          else {
              this.constraints = false;
          }
          this.elastic = resolveDragElastic(dragElastic);
          /**
           * If we're outputting to external MotionValues, we want to rebase the measured constraints
           * from viewport-relative to component-relative.
           */
          if (this.constraints && !this.hasMutatedConstraints) {
              eachAxis(function (axis) {
                  if (_this.getAxisMotionValue(axis)) {
                      _this.constraints[axis] = rebaseAxisConstraints(layout[axis], _this.constraints[axis]);
                  }
              });
          }
      };
      VisualElementDragControls.prototype.resolveRefConstraints = function (layoutBox, constraints) {
          var _a = this.props, onMeasureDragConstraints = _a.onMeasureDragConstraints, transformPagePoint = _a.transformPagePoint;
          var constraintsElement = constraints.current;
          this.constraintsBox = getBoundingBox(constraintsElement, transformPagePoint);
          var measuredConstraints = calcViewportConstraints(layoutBox, this.constraintsBox);
          /**
           * If there's an onMeasureDragConstraints listener we call it and
           * if different constraints are returned, set constraints to that
           */
          if (onMeasureDragConstraints) {
              var userConstraints = onMeasureDragConstraints(convertAxisBoxToBoundingBox(measuredConstraints));
              this.hasMutatedConstraints = !!userConstraints;
              if (userConstraints) {
                  measuredConstraints = convertBoundingBoxToAxisBox(userConstraints);
              }
          }
          return measuredConstraints;
      };
      VisualElementDragControls.prototype.cancelDrag = function () {
          var _a, _b;
          this.visualElement.unlockProjectionTarget();
          (_a = this.cancelLayout) === null || _a === void 0 ? void 0 : _a.call(this);
          this.isDragging = false;
          this.panSession && this.panSession.end();
          this.panSession = null;
          if (!this.props.dragPropagation && this.openGlobalLock) {
              this.openGlobalLock();
              this.openGlobalLock = null;
          }
          (_b = this.visualElement.animationState) === null || _b === void 0 ? void 0 : _b.setActive(AnimationType.Drag, false);
      };
      VisualElementDragControls.prototype.stop = function (event, info) {
          var _a, _b, _c;
          (_a = this.panSession) === null || _a === void 0 ? void 0 : _a.end();
          this.panSession = null;
          var isDragging = this.isDragging;
          this.cancelDrag();
          if (!isDragging)
              return;
          var velocity = info.velocity;
          this.animateDragEnd(velocity);
          (_c = (_b = this.props).onDragEnd) === null || _c === void 0 ? void 0 : _c.call(_b, event, info);
      };
      VisualElementDragControls.prototype.snapToCursor = function (point) {
          var _this = this;
          return eachAxis(function (axis) {
              var drag = _this.props.drag;
              // If we're not dragging this axis, do an early return.
              if (!shouldDrag(axis, drag, _this.currentDirection))
                  return;
              var axisValue = _this.getAxisMotionValue(axis);
              if (axisValue) {
                  var box = _this.visualElement.getLayoutState().layout;
                  var length_1 = box[axis].max - box[axis].min;
                  var center = box[axis].min + length_1 / 2;
                  var offset = point[axis] - center;
                  _this.originPoint[axis] = point[axis];
                  axisValue.set(offset);
              }
              else {
                  _this.cursorProgress[axis] = 0.5;
                  return true;
              }
          }).includes(true);
      };
      /**
       * Update the specified axis with the latest pointer information.
       */
      VisualElementDragControls.prototype.updateAxis = function (axis, point, offset) {
          var drag = this.props.drag;
          // If we're not dragging this axis, do an early return.
          if (!shouldDrag(axis, drag, this.currentDirection))
              return;
          return this.getAxisMotionValue(axis)
              ? this.updateAxisMotionValue(axis, offset)
              : this.updateVisualElementAxis(axis, point);
      };
      VisualElementDragControls.prototype.updateAxisMotionValue = function (axis, offset) {
          var axisValue = this.getAxisMotionValue(axis);
          if (!offset || !axisValue)
              return;
          var nextValue = this.originPoint[axis] + offset[axis];
          var update = this.constraints
              ? applyConstraints(nextValue, this.constraints[axis], this.elastic[axis])
              : nextValue;
          axisValue.set(update);
      };
      VisualElementDragControls.prototype.updateVisualElementAxis = function (axis, point) {
          var _a;
          // Get the actual layout bounding box of the element
          var axisLayout = this.visualElement.getLayoutState().layout[axis];
          // Calculate its current length. In the future we might want to lerp this to animate
          // between lengths if the layout changes as we change the DOM
          var axisLength = axisLayout.max - axisLayout.min;
          // Get the initial progress that the pointer sat on this axis on gesture start.
          var axisProgress = this.cursorProgress[axis];
          // Calculate a new min point based on the latest pointer position, constraints and elastic
          var min = calcConstrainedMinPoint(point[axis], axisLength, axisProgress, (_a = this.constraints) === null || _a === void 0 ? void 0 : _a[axis], this.elastic[axis]);
          // Update the axis viewport target with this new min and the length
          this.visualElement.setProjectionTargetAxis(axis, min, min + axisLength);
      };
      VisualElementDragControls.prototype.setProps = function (_a) {
          var _b = _a.drag, drag = _b === void 0 ? false : _b, _c = _a.dragDirectionLock, dragDirectionLock = _c === void 0 ? false : _c, _d = _a.dragPropagation, dragPropagation = _d === void 0 ? false : _d, _e = _a.dragConstraints, dragConstraints = _e === void 0 ? false : _e, _f = _a.dragElastic, dragElastic = _f === void 0 ? defaultElastic : _f, _g = _a.dragMomentum, dragMomentum = _g === void 0 ? true : _g, remainingProps = __rest(_a, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
          this.props = __assign({ drag: drag,
              dragDirectionLock: dragDirectionLock,
              dragPropagation: dragPropagation,
              dragConstraints: dragConstraints,
              dragElastic: dragElastic,
              dragMomentum: dragMomentum }, remainingProps);
      };
      /**
       * Drag works differently depending on which props are provided.
       *
       * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
       * - If the component will perform layout animations, we output the gesture to the component's
       *      visual bounding box
       * - Otherwise, we apply the delta to the x/y motion values.
       */
      VisualElementDragControls.prototype.getAxisMotionValue = function (axis) {
          var _a = this.props, layout = _a.layout, layoutId = _a.layoutId;
          var dragKey = "_drag" + axis.toUpperCase();
          if (this.props[dragKey]) {
              return this.props[dragKey];
          }
          else if (!layout && layoutId === undefined) {
              return this.visualElement.getValue(axis, 0);
          }
      };
      VisualElementDragControls.prototype.isLayoutDrag = function () {
          return !this.getAxisMotionValue("x");
      };
      VisualElementDragControls.prototype.isExternalDrag = function () {
          var _a = this.props, _dragX = _a._dragX, _dragY = _a._dragY;
          return _dragX || _dragY;
      };
      VisualElementDragControls.prototype.animateDragEnd = function (velocity) {
          var _this = this;
          var _a = this.props, drag = _a.drag, dragMomentum = _a.dragMomentum, dragElastic = _a.dragElastic, dragTransition = _a.dragTransition;
          /**
           * Everything beyond the drag gesture should be performed with
           * relative projection so children stay in sync with their parent element.
           */
          var isRelative = convertToRelativeProjection(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag());
          /**
           * If we had previously resolved constraints relative to the viewport,
           * we need to also convert those to a relative coordinate space for the animation
           */
          var constraints = this.constraints || {};
          if (isRelative &&
              Object.keys(constraints).length &&
              this.isLayoutDrag()) {
              var projectionParent = this.visualElement.getProjectionParent();
              if (projectionParent) {
                  var relativeConstraints_1 = calcRelativeOffset(projectionParent.projection.targetFinal, constraints);
                  eachAxis(function (axis) {
                      var _a = relativeConstraints_1[axis], min = _a.min, max = _a.max;
                      constraints[axis] = {
                          min: isNaN(min) ? undefined : min,
                          max: isNaN(max) ? undefined : max,
                      };
                  });
              }
          }
          var momentumAnimations = eachAxis(function (axis) {
              var _a;
              if (!shouldDrag(axis, drag, _this.currentDirection)) {
                  return;
              }
              var transition = (_a = constraints === null || constraints === void 0 ? void 0 : constraints[axis]) !== null && _a !== void 0 ? _a : {};
              /**
               * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
               * of spring animations so we should look into adding a disable spring option to `inertia`.
               * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
               * using the value of `dragElastic`.
               */
              var bounceStiffness = dragElastic ? 200 : 1000000;
              var bounceDamping = dragElastic ? 40 : 10000000;
              var inertia = __assign(__assign({ type: "inertia", velocity: dragMomentum ? velocity[axis] : 0, bounceStiffness: bounceStiffness,
                  bounceDamping: bounceDamping, timeConstant: 750, restDelta: 1, restSpeed: 10 }, dragTransition), transition);
              // If we're not animating on an externally-provided `MotionValue` we can use the
              // component's animation controls which will handle interactions with whileHover (etc),
              // otherwise we just have to animate the `MotionValue` itself.
              return _this.getAxisMotionValue(axis)
                  ? _this.startAxisValueAnimation(axis, inertia)
                  : _this.visualElement.startLayoutAnimation(axis, inertia, isRelative);
          });
          // Run all animations and then resolve the new drag constraints.
          return Promise.all(momentumAnimations).then(function () {
              var _a, _b;
              (_b = (_a = _this.props).onDragTransitionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
          });
      };
      VisualElementDragControls.prototype.stopMotion = function () {
          var _this = this;
          eachAxis(function (axis) {
              var axisValue = _this.getAxisMotionValue(axis);
              axisValue
                  ? axisValue.stop()
                  : _this.visualElement.stopLayoutAnimation();
          });
      };
      VisualElementDragControls.prototype.startAxisValueAnimation = function (axis, transition) {
          var axisValue = this.getAxisMotionValue(axis);
          if (!axisValue)
              return;
          var currentValue = axisValue.get();
          axisValue.set(currentValue);
          axisValue.set(currentValue); // Set twice to hard-reset velocity
          return startAnimation(axis, axisValue, 0, transition);
      };
      VisualElementDragControls.prototype.scalePoint = function () {
          var _this = this;
          var _a = this.props, drag = _a.drag, dragConstraints = _a.dragConstraints;
          if (!isRefObject(dragConstraints) || !this.constraintsBox)
              return;
          // Stop any current animations as there can be some visual glitching if we resize mid animation
          this.stopMotion();
          // Record the relative progress of the targetBox relative to the constraintsBox
          var boxProgress = { x: 0, y: 0 };
          eachAxis(function (axis) {
              boxProgress[axis] = calcOrigin(_this.visualElement.projection.target[axis], _this.constraintsBox[axis]);
          });
          /**
           * For each axis, calculate the current progress of the layout axis within the constraints.
           * Then, using the latest layout and constraints measurements, reposition the new layout axis
           * proportionally within the constraints.
           */
          this.updateConstraints(function () {
              eachAxis(function (axis) {
                  if (!shouldDrag(axis, drag, null))
                      return;
                  // Calculate the position of the targetBox relative to the constraintsBox using the
                  // previously calculated progress
                  var _a = calcPositionFromProgress(_this.visualElement.projection.target[axis], _this.constraintsBox[axis], boxProgress[axis]), min = _a.min, max = _a.max;
                  _this.visualElement.setProjectionTargetAxis(axis, min, max);
              });
          });
          /**
           * If any other draggable components are queuing the same tasks synchronously
           * this will wait until they've all been scheduled before flushing.
           */
          setTimeout(flushLayout, 1);
      };
      VisualElementDragControls.prototype.updateConstraints = function (onReady) {
          var _this = this;
          this.cancelLayout = batchLayout(function (read, write) {
              var ancestors = collectProjectingAncestors(_this.visualElement);
              write(function () {
                  return ancestors.forEach(function (element) { return element.resetTransform(); });
              });
              read(function () { return updateLayoutMeasurement(_this.visualElement); });
              write(function () {
                  return ancestors.forEach(function (element) { return element.restoreTransform(); });
              });
              read(function () {
                  _this.resolveDragConstraints();
              });
              if (onReady)
                  write(onReady);
          });
      };
      VisualElementDragControls.prototype.mount = function (visualElement) {
          var _this = this;
          var element = visualElement.getInstance();
          /**
           * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
           */
          var stopPointerListener = addPointerEvent(element, "pointerdown", function (event) {
              var _a = _this.props, drag = _a.drag, _b = _a.dragListener, dragListener = _b === void 0 ? true : _b;
              drag && dragListener && _this.start(event);
          });
          /**
           * Attach a window resize listener to scale the draggable target within its defined
           * constraints as the window resizes.
           */
          var stopResizeListener = addDomEvent(window, "resize", function () {
              _this.scalePoint();
          });
          /**
           * Ensure drag constraints are resolved correctly relative to the dragging element
           * whenever its layout changes.
           */
          var stopLayoutUpdateListener = visualElement.onLayoutUpdate(function () {
              if (_this.isDragging) {
                  _this.resolveDragConstraints();
              }
          });
          /**
           * If the previous component with this same layoutId was dragging at the time
           * it was unmounted, we want to continue the same gesture on this component.
           */
          var prevDragCursor = visualElement.prevDragCursor;
          if (prevDragCursor) {
              this.start(lastPointerEvent, { cursorProgress: prevDragCursor });
          }
          /**
           * Return a function that will teardown the drag gesture
           */
          return function () {
              stopPointerListener === null || stopPointerListener === void 0 ? void 0 : stopPointerListener();
              stopResizeListener === null || stopResizeListener === void 0 ? void 0 : stopResizeListener();
              stopLayoutUpdateListener === null || stopLayoutUpdateListener === void 0 ? void 0 : stopLayoutUpdateListener();
              _this.cancelDrag();
          };
      };
      return VisualElementDragControls;
  }());
  function shouldDrag(direction, drag, currentDirection) {
      return ((drag === true || drag === direction) &&
          (currentDirection === null || currentDirection === direction));
  }
  /**
   * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
   * than the provided threshold, return `null`.
   *
   * @param offset - The x/y offset from origin.
   * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
   */
  function getCurrentDirection(offset, lockThreshold) {
      if (lockThreshold === void 0) { lockThreshold = 10; }
      var direction = null;
      if (Math.abs(offset.y) > lockThreshold) {
          direction = "y";
      }
      else if (Math.abs(offset.x) > lockThreshold) {
          direction = "x";
      }
      return direction;
  }

  /**
   * A hook that allows an element to be dragged.
   *
   * @internal
   */
  function useDrag(props) {
      var groupDragControls = props.dragControls, visualElement = props.visualElement;
      var transformPagePoint = React.useContext(MotionConfigContext).transformPagePoint;
      var dragControls = useConstant(function () {
          return new VisualElementDragControls({
              visualElement: visualElement,
          });
      });
      dragControls.setProps(__assign(__assign({}, props), { transformPagePoint: transformPagePoint }));
      // If we've been provided a DragControls for manual control over the drag gesture,
      // subscribe this component to it on mount.
      React.useEffect(function () { return groupDragControls && groupDragControls.subscribe(dragControls); }, [dragControls]);
      // Mount the drag controls with the visualElement
      React.useEffect(function () { return dragControls.mount(visualElement); }, []);
  }

  /**
   *
   * @param handlers -
   * @param ref -
   *
   * @internalremarks
   * Currently this sets new pan gesture functions every render. The memo route has been explored
   * in the past but ultimately we're still creating new functions every render. An optimisation
   * to explore is creating the pan gestures and loading them into a `ref`.
   *
   * @internal
   */
  function usePanGesture(_a) {
      var onPan = _a.onPan, onPanStart = _a.onPanStart, onPanEnd = _a.onPanEnd, onPanSessionStart = _a.onPanSessionStart, visualElement = _a.visualElement;
      var hasPanEvents = onPan || onPanStart || onPanEnd || onPanSessionStart;
      var panSession = React.useRef(null);
      var transformPagePoint = React.useContext(MotionConfigContext).transformPagePoint;
      var handlers = {
          onSessionStart: onPanSessionStart,
          onStart: onPanStart,
          onMove: onPan,
          onEnd: function (event, info) {
              panSession.current = null;
              onPanEnd && onPanEnd(event, info);
          },
      };
      React.useEffect(function () {
          if (panSession.current !== null) {
              panSession.current.updateHandlers(handlers);
          }
      });
      function onPointerDown(event) {
          panSession.current = new PanSession(event, handlers, {
              transformPagePoint: transformPagePoint,
          });
      }
      usePointerEvent(visualElement, "pointerdown", hasPanEvents && onPointerDown);
      useUnmountEffect(function () { return panSession.current && panSession.current.end(); });
  }

  var drag = {
      pan: makeRenderlessComponent(usePanGesture),
      drag: makeRenderlessComponent(useDrag),
  };

  /**
   * @public
   */
  var Presence;
  (function (Presence) {
      Presence[Presence["Entering"] = 0] = "Entering";
      Presence[Presence["Present"] = 1] = "Present";
      Presence[Presence["Exiting"] = 2] = "Exiting";
  })(Presence || (Presence = {}));
  /**
   * @public
   */
  var VisibilityAction;
  (function (VisibilityAction) {
      VisibilityAction[VisibilityAction["Hide"] = 0] = "Hide";
      VisibilityAction[VisibilityAction["Show"] = 1] = "Show";
  })(VisibilityAction || (VisibilityAction = {}));

  function isCSSVariable(value) {
      return typeof value === "string" && value.startsWith("var(--");
  }
  /**
   * Parse Framer's special CSS variable format into a CSS token and a fallback.
   *
   * ```
   * `var(--foo, #fff)` => [`--foo`, '#fff']
   * ```
   *
   * @param current
   */
  var cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
  function parseCSSVariable(current) {
      var match = cssVariableRegex.exec(current);
      if (!match)
          return [,];
      var _a = __read(match, 3), token = _a[1], fallback = _a[2];
      return [token, fallback];
  }
  function getVariableValue(current, element, depth) {
      var _a = __read(parseCSSVariable(current), 2), token = _a[0], fallback = _a[1];
      // No CSS variable detected
      if (!token)
          return;
      // Attempt to read this CSS variable off the element
      var resolved = window.getComputedStyle(element).getPropertyValue(token);
      if (resolved) {
          return resolved.trim();
      }
      else if (isCSSVariable(fallback)) {
          // The fallback might itself be a CSS variable, in which case we attempt to resolve it too.
          return getVariableValue(fallback, element);
      }
      else {
          return fallback;
      }
  }
  /**
   * Resolve CSS variables from
   *
   * @internal
   */
  function resolveCSSVariables(visualElement, _a, transitionEnd) {
      var _b;
      var target = __rest(_a, []);
      var element = visualElement.getInstance();
      if (!(element instanceof HTMLElement))
          return { target: target, transitionEnd: transitionEnd };
      // If `transitionEnd` isn't `undefined`, clone it. We could clone `target` and `transitionEnd`
      // only if they change but I think this reads clearer and this isn't a performance-critical path.
      if (transitionEnd) {
          transitionEnd = __assign({}, transitionEnd);
      }
      // Go through existing `MotionValue`s and ensure any existing CSS variables are resolved
      visualElement.forEachValue(function (value) {
          var current = value.get();
          if (!isCSSVariable(current))
              return;
          var resolved = getVariableValue(current, element);
          if (resolved)
              value.set(resolved);
      });
      // Cycle through every target property and resolve CSS variables. Currently
      // we only read single-var properties like `var(--foo)`, not `calc(var(--foo) + 20px)`
      for (var key in target) {
          var current = target[key];
          if (!isCSSVariable(current))
              continue;
          var resolved = getVariableValue(current, element);
          if (!resolved)
              continue;
          // Clone target if it hasn't already been
          target[key] = resolved;
          // If the user hasn't already set this key on `transitionEnd`, set it to the unresolved
          // CSS variable. This will ensure that after the animation the component will reflect
          // changes in the value of the CSS variable.
          if (transitionEnd)
              (_b = transitionEnd[key]) !== null && _b !== void 0 ? _b : (transitionEnd[key] = current);
      }
      return { target: target, transitionEnd: transitionEnd };
  }

  function pixelsToPercent(pixels, axis) {
      return (pixels / (axis.max - axis.min)) * 100;
  }
  /**
   * We always correct borderRadius as a percentage rather than pixels to reduce paints.
   * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
   * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
   * borderRadius in both states. If we animate between the two in pixels that will trigger
   * a paint each time. If we animate between the two in percentage we'll avoid a paint.
   */
  function correctBorderRadius(latest, _layoutState, _a) {
      var target = _a.target;
      /**
       * If latest is a string, if it's a percentage we can return immediately as it's
       * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
       */
      if (typeof latest === "string") {
          if (px.test(latest)) {
              latest = parseFloat(latest);
          }
          else {
              return latest;
          }
      }
      /**
       * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
       * pixel value as a percentage of each axis
       */
      var x = pixelsToPercent(latest, target.x);
      var y = pixelsToPercent(latest, target.y);
      return x + "% " + y + "%";
  }
  var varToken = "_$css";
  function correctBoxShadow(latest, _a) {
      var delta = _a.delta, treeScale = _a.treeScale;
      var original = latest;
      /**
       * We need to first strip and store CSS variables from the string.
       */
      var containsCSSVariables = latest.includes("var(");
      var cssVariables = [];
      if (containsCSSVariables) {
          latest = latest.replace(cssVariableRegex, function (match) {
              cssVariables.push(match);
              return varToken;
          });
      }
      var shadow = complex.parse(latest);
      // TODO: Doesn't support multiple shadows
      if (shadow.length > 5)
          return original;
      var template = complex.createTransformer(latest);
      var offset = typeof shadow[0] !== "number" ? 1 : 0;
      // Calculate the overall context scale
      var xScale = delta.x.scale * treeScale.x;
      var yScale = delta.y.scale * treeScale.y;
      shadow[0 + offset] /= xScale;
      shadow[1 + offset] /= yScale;
      /**
       * Ideally we'd correct x and y scales individually, but because blur and
       * spread apply to both we have to take a scale average and apply that instead.
       * We could potentially improve the outcome of this by incorporating the ratio between
       * the two scales.
       */
      var averageScale = mix(xScale, yScale, 0.5);
      // Blur
      if (typeof shadow[2 + offset] === "number")
          shadow[2 + offset] /= averageScale;
      // Spread
      if (typeof shadow[3 + offset] === "number")
          shadow[3 + offset] /= averageScale;
      var output = template(shadow);
      if (containsCSSVariables) {
          var i_1 = 0;
          output = output.replace(varToken, function () {
              var cssVariable = cssVariables[i_1];
              i_1++;
              return cssVariable;
          });
      }
      return output;
  }
  var borderCorrectionDefinition = {
      process: correctBorderRadius,
  };
  var defaultScaleCorrectors = {
      borderRadius: __assign(__assign({}, borderCorrectionDefinition), { applyTo: [
              "borderTopLeftRadius",
              "borderTopRightRadius",
              "borderBottomLeftRadius",
              "borderBottomRightRadius",
          ] }),
      borderTopLeftRadius: borderCorrectionDefinition,
      borderTopRightRadius: borderCorrectionDefinition,
      borderBottomLeftRadius: borderCorrectionDefinition,
      borderBottomRightRadius: borderCorrectionDefinition,
      boxShadow: {
          process: correctBoxShadow,
      },
  };

  var progressTarget = 1000;
  var Animate = /** @class */ (function (_super) {
      __extends(Animate, _super);
      function Animate() {
          var _this = _super !== null && _super.apply(this, arguments) || this;
          /**
           * A mutable object that tracks the target viewport box
           * for the current animation frame.
           */
          _this.frameTarget = axisBox();
          /**
           * The current animation target, we use this to check whether to start
           * a new animation or continue the existing one.
           */
          _this.currentAnimationTarget = axisBox();
          /**
           * Track whether we're animating this axis.
           */
          _this.isAnimating = {
              x: false,
              y: false,
          };
          _this.stopAxisAnimation = {
              x: undefined,
              y: undefined,
          };
          _this.isAnimatingTree = false;
          _this.animate = function (target, origin, _a) {
              if (_a === void 0) { _a = {}; }
              var originBox = _a.originBox, targetBox = _a.targetBox, visibilityAction = _a.visibilityAction, shouldStackAnimate = _a.shouldStackAnimate, onComplete = _a.onComplete, prevParent = _a.prevParent, config = __rest(_a, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]);
              var _b = _this.props, visualElement = _b.visualElement, layout = _b.layout;
              /**
               * Early return if we've been instructed not to animate this render.
               */
              if (shouldStackAnimate === false) {
                  _this.isAnimatingTree = false;
                  return _this.safeToRemove();
              }
              /**
               * Prioritise tree animations
               */
              if (_this.isAnimatingTree && shouldStackAnimate !== true) {
                  return;
              }
              else if (shouldStackAnimate) {
                  _this.isAnimatingTree = true;
              }
              /**
               * Allow the measured origin (prev bounding box) and target (actual layout) to be
               * overridden by the provided config.
               */
              origin = originBox || origin;
              target = targetBox || target;
              /**
               * If this element has a projecting parent, there's an opportunity to animate
               * it relatively to that parent rather than relatively to the viewport. This
               * allows us to add orchestrated animations.
               */
              var isRelative = false;
              var projectionParent = visualElement.getProjectionParent();
              if (projectionParent) {
                  var prevParentViewportBox = projectionParent.prevViewportBox;
                  var parentLayout = projectionParent.getLayoutState().layout;
                  /**
                   * If we're being provided a previous parent VisualElement by AnimateSharedLayout
                   */
                  if (prevParent) {
                      /**
                       * If we've been provided an explicit target box it means we're animating back
                       * to this previous parent. So we can make a relative box by comparing to the previous
                       * parent's layout
                       */
                      if (targetBox) {
                          parentLayout = prevParent.getLayoutState().layout;
                      }
                      /**
                       * Likewise if we've been provided an explicit origin box it means we're
                       * animating out from a different element. So we should figure out where that was
                       * on screen relative to the new parent element.
                       */
                      if (originBox &&
                          !checkIfParentHasChanged(prevParent, projectionParent) &&
                          prevParent.prevViewportBox) {
                          prevParentViewportBox = prevParent.prevViewportBox;
                      }
                  }
                  if (prevParentViewportBox &&
                      isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox)) {
                      isRelative = true;
                      origin = calcRelativeOffset(prevParentViewportBox, origin);
                      target = calcRelativeOffset(parentLayout, target);
                  }
              }
              var boxHasMoved = hasMoved(origin, target);
              var animations = eachAxis(function (axis) {
                  var _a, _b;
                  /**
                   * If layout is set to "position", we can resize the origin box based on the target
                   * box and only animate its position.
                   */
                  if (layout === "position") {
                      var targetLength = target[axis].max - target[axis].min;
                      origin[axis].max = origin[axis].min + targetLength;
                  }
                  if (visualElement.projection.isTargetLocked) {
                      return;
                  }
                  else if (visibilityAction !== undefined) {
                      visualElement.setVisibility(visibilityAction === VisibilityAction.Show);
                  }
                  else if (boxHasMoved) {
                      // If the box has moved, animate between it's current visual state and its
                      // final state
                      return _this.animateAxis(axis, target[axis], origin[axis], __assign(__assign({}, config), { isRelative: isRelative }));
                  }
                  else {
                      (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a);
                      // If the box has remained in the same place, immediately set the axis target
                      // to the final desired state
                      return visualElement.setProjectionTargetAxis(axis, target[axis].min, target[axis].max, isRelative);
                  }
              });
              // Force a render to ensure there's no flash of uncorrected bounding box.
              visualElement.syncRender();
              /**
               * If this visualElement isn't present (ie it's been removed from the tree by the user but
               * kept in by the tree by AnimatePresence) then call safeToRemove when all axis animations
               * have successfully finished.
               */
              return Promise.all(animations).then(function () {
                  _this.isAnimatingTree = false;
                  onComplete && onComplete();
                  visualElement.notifyLayoutAnimationComplete();
              });
          };
          return _this;
      }
      Animate.prototype.componentDidMount = function () {
          var _this = this;
          var visualElement = this.props.visualElement;
          visualElement.animateMotionValue = startAnimation;
          visualElement.enableLayoutProjection();
          this.unsubLayoutReady = visualElement.onLayoutUpdate(this.animate);
          visualElement.layoutSafeToRemove = function () { return _this.safeToRemove(); };
          addScaleCorrection(defaultScaleCorrectors);
      };
      Animate.prototype.componentWillUnmount = function () {
          var _this = this;
          this.unsubLayoutReady();
          eachAxis(function (axis) { var _a, _b; return (_b = (_a = _this.stopAxisAnimation)[axis]) === null || _b === void 0 ? void 0 : _b.call(_a); });
      };
      /**
       * TODO: This manually performs animations on the visualElement's layout progress
       * values. It'd be preferable to amend the startLayoutAxisAnimation
       * API to accept more custom animations like this.
       */
      Animate.prototype.animateAxis = function (axis, target, origin, _a) {
          var _this = this;
          var _b, _c;
          var _d = _a === void 0 ? {} : _a, transition = _d.transition, isRelative = _d.isRelative;
          /**
           * If we're not animating to a new target, don't run this animation
           */
          if (this.isAnimating[axis] &&
              axisIsEqual(target, this.currentAnimationTarget[axis])) {
              return;
          }
          (_c = (_b = this.stopAxisAnimation)[axis]) === null || _c === void 0 ? void 0 : _c.call(_b);
          this.isAnimating[axis] = true;
          var visualElement = this.props.visualElement;
          var frameTarget = this.frameTarget[axis];
          var layoutProgress = visualElement.getProjectionAnimationProgress()[axis];
          /**
           * Set layout progress back to 0. We set it twice to hard-reset any velocity that might
           * be re-incoporated into a subsequent spring animation.
           */
          layoutProgress.clearListeners();
          layoutProgress.set(0);
          layoutProgress.set(0);
          /**
           * Create an animation function to run once per frame. This will tween the visual bounding box from
           * origin to target using the latest progress value.
           */
          var frame = function () {
              // Convert the latest layoutProgress, which is a value from 0-1000, into a 0-1 progress
              var p = layoutProgress.get() / progressTarget;
              // Tween the axis and update the visualElement with the latest values
              tweenAxis(frameTarget, origin, target, p);
              visualElement.setProjectionTargetAxis(axis, frameTarget.min, frameTarget.max, isRelative);
          };
          // Synchronously run a frame to ensure there's no flash of the uncorrected bounding box.
          frame();
          // Create a function to stop animation on this specific axis
          var unsubscribeProgress = layoutProgress.onChange(frame);
          this.stopAxisAnimation[axis] = function () {
              _this.isAnimating[axis] = false;
              layoutProgress.stop();
              unsubscribeProgress();
          };
          this.currentAnimationTarget[axis] = target;
          var layoutTransition = transition ||
              visualElement.getDefaultTransition() ||
              defaultLayoutTransition;
          // Start the animation on this axis
          var animation = startAnimation(axis === "x" ? "layoutX" : "layoutY", layoutProgress, progressTarget, layoutTransition && getValueTransition(layoutTransition, "layout")).then(this.stopAxisAnimation[axis]);
          return animation;
      };
      Animate.prototype.safeToRemove = function () {
          var _a, _b;
          (_b = (_a = this.props).safeToRemove) === null || _b === void 0 ? void 0 : _b.call(_a);
      };
      Animate.prototype.render = function () {
          return null;
      };
      return Animate;
  }(React__namespace.Component));
  function AnimateLayoutContextProvider(props) {
      var _a = __read(usePresence(), 2), safeToRemove = _a[1];
      return React__namespace.createElement(Animate, __assign({}, props, { safeToRemove: safeToRemove }));
  }
  function hasMoved(a, b) {
      return (!isZeroBox(a) &&
          !isZeroBox(b) &&
          (!axisIsEqual(a.x, b.x) || !axisIsEqual(a.y, b.y)));
  }
  var zeroAxis = { min: 0, max: 0 };
  function isZeroBox(a) {
      return axisIsEqual(a.x, zeroAxis) && axisIsEqual(a.y, zeroAxis);
  }
  function axisIsEqual(a, b) {
      return a.min === b.min && a.max === b.max;
  }
  var defaultLayoutTransition = {
      duration: 0.45,
      ease: [0.4, 0, 0.1, 1],
  };
  function isProvidedCorrectDataForRelativeSharedLayout(prevParent, originBox, targetBox) {
      return prevParent || (!prevParent && !(originBox || targetBox));
  }

  /**
   * Default handlers for batching VisualElements
   */
  var defaultHandler = {
      layoutReady: function (child) { return child.notifyLayoutReady(); },
  };
  /**
   * Create a batcher to process VisualElements
   */
  function createBatcher() {
      var queue = new Set();
      return {
          add: function (child) { return queue.add(child); },
          flush: function (_a) {
              var _b = _a === void 0 ? defaultHandler : _a, layoutReady = _b.layoutReady, parent = _b.parent;
              batchLayout(function (read, write) {
                  var order = Array.from(queue).sort(compareByDepth);
                  var ancestors = parent
                      ? collectProjectingAncestors(parent)
                      : [];
                  write(function () {
                      var allElements = __spreadArray(__spreadArray([], __read(ancestors)), __read(order));
                      allElements.forEach(function (element) { return element.resetTransform(); });
                  });
                  read(function () {
                      order.forEach(updateLayoutMeasurement);
                  });
                  write(function () {
                      ancestors.forEach(function (element) { return element.restoreTransform(); });
                      order.forEach(layoutReady);
                  });
                  read(function () {
                      /**
                       * After all children have started animating, ensure any Entering components are set to Present.
                       * If we add deferred animations (set up all animations and then start them in two loops) this
                       * could be moved to the start loop. But it needs to happen after all the animations configs
                       * are generated in AnimateSharedLayout as this relies on presence data
                       */
                      order.forEach(function (child) {
                          if (child.isPresent)
                              child.presence = Presence.Present;
                      });
                  });
                  write(function () {
                      /**
                       * Starting these animations will have queued jobs on the frame loop. In some situations,
                       * like when removing an element, these will be processed too late after the DOM is manipulated,
                       * leaving a flash of incorrectly-projected content. By manually flushing these jobs
                       * we ensure there's no flash.
                       */
                      flushSync.preRender();
                      flushSync.render();
                  });
                  read(function () {
                      /**
                       * Schedule a callback at the end of the following frame to assign the latest projection
                       * box to the prevViewportBox snapshot. Once global batching is in place this could be run
                       * synchronously. But for now it ensures that if any nested `AnimateSharedLayout` top-level
                       * child attempts to calculate its previous relative position against a prevViewportBox
                       * it will be against its latest projection box instead, as the snapshot is useless beyond this
                       * render.
                       */
                      sync.postRender(function () {
                          return order.forEach(assignProjectionToSnapshot);
                      });
                      queue.clear();
                  });
              });
              // TODO: Need to find a layout-synchronous way of flushing this
              flushLayout();
          },
      };
  }
  function assignProjectionToSnapshot(child) {
      child.prevViewportBox = child.projection.target;
  }

  var SharedLayoutContext = React.createContext(createBatcher());
  /**
   * @internal
   */
  var FramerTreeLayoutContext = React.createContext(createBatcher());
  function isSharedLayout(context) {
      return !!context.forceUpdate;
  }

  /**
   * This component is responsible for scheduling the measuring of the motion component
   */
  var Measure = /** @class */ (function (_super) {
      __extends(Measure, _super);
      function Measure() {
          return _super !== null && _super.apply(this, arguments) || this;
      }
      /**
       * If this is a child of a SyncContext, register the VisualElement with it on mount.
       */
      Measure.prototype.componentDidMount = function () {
          var _a = this.props, syncLayout = _a.syncLayout, framerSyncLayout = _a.framerSyncLayout, visualElement = _a.visualElement;
          isSharedLayout(syncLayout) && syncLayout.register(visualElement);
          isSharedLayout(framerSyncLayout) &&
              framerSyncLayout.register(visualElement);
          visualElement.onUnmount(function () {
              if (isSharedLayout(syncLayout)) {
                  syncLayout.remove(visualElement);
              }
              if (isSharedLayout(framerSyncLayout)) {
                  framerSyncLayout.remove(visualElement);
              }
          });
      };
      /**
       * If this is a child of a SyncContext, notify it that it needs to re-render. It will then
       * handle the snapshotting.
       *
       * If it is stand-alone component, add it to the batcher.
       */
      Measure.prototype.getSnapshotBeforeUpdate = function () {
          var _a = this.props, syncLayout = _a.syncLayout, visualElement = _a.visualElement;
          if (isSharedLayout(syncLayout)) {
              syncLayout.syncUpdate();
          }
          else {
              snapshotViewportBox(visualElement);
              syncLayout.add(visualElement);
          }
          return null;
      };
      Measure.prototype.componentDidUpdate = function () {
          var syncLayout = this.props.syncLayout;
          if (!isSharedLayout(syncLayout))
              syncLayout.flush();
      };
      Measure.prototype.render = function () {
          return null;
      };
      return Measure;
  }(React.Component));
  function MeasureContextProvider(props) {
      var syncLayout = React.useContext(SharedLayoutContext);
      var framerSyncLayout = React.useContext(FramerTreeLayoutContext);
      return (React.createElement(Measure, __assign({}, props, { syncLayout: syncLayout, framerSyncLayout: framerSyncLayout })));
  }

  var layoutAnimations = {
      measureLayout: MeasureContextProvider,
      layoutAnimation: AnimateLayoutContextProvider,
  };

  var createProjectionState = function () { return ({
      isEnabled: false,
      isHydrated: false,
      isTargetLocked: false,
      target: axisBox(),
      targetFinal: axisBox(),
  }); };
  function createLayoutState() {
      return {
          isHydrated: false,
          layout: axisBox(),
          layoutCorrected: axisBox(),
          treeScale: { x: 1, y: 1 },
          delta: delta(),
          deltaFinal: delta(),
          deltaTransform: "",
      };
  }
  var zeroLayout = createLayoutState();

  /**
   * Build a transform style that takes a calculated delta between the element's current
   * space on screen and projects it into the desired space.
   */
  function buildLayoutProjectionTransform(_a, treeScale, latestTransform) {
      var x = _a.x, y = _a.y;
      /**
       * The translations we use to calculate are always relative to the viewport coordinate space.
       * But when we apply scales, we also scale the coordinate space of an element and its children.
       * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
       * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
       */
      var xTranslate = x.translate / treeScale.x;
      var yTranslate = y.translate / treeScale.y;
      var transform = "translate3d(" + xTranslate + "px, " + yTranslate + "px, 0) ";
      if (latestTransform) {
          var rotate = latestTransform.rotate, rotateX = latestTransform.rotateX, rotateY = latestTransform.rotateY;
          if (rotate)
              transform += "rotate(" + rotate + ") ";
          if (rotateX)
              transform += "rotateX(" + rotateX + ") ";
          if (rotateY)
              transform += "rotateY(" + rotateY + ") ";
      }
      transform += "scale(" + x.scale + ", " + y.scale + ")";
      return !latestTransform && transform === identityProjection ? "" : transform;
  }
  /**
   * Take the calculated delta origin and apply it as a transform string.
   */
  function buildLayoutProjectionTransformOrigin(_a) {
      var deltaFinal = _a.deltaFinal;
      return deltaFinal.x.origin * 100 + "% " + deltaFinal.y.origin * 100 + "% 0";
  }
  var identityProjection = buildLayoutProjectionTransform(zeroLayout.delta, zeroLayout.treeScale, { });

  var names = [
      "LayoutMeasure",
      "BeforeLayoutMeasure",
      "LayoutUpdate",
      "ViewportBoxUpdate",
      "Update",
      "Render",
      "AnimationComplete",
      "LayoutAnimationComplete",
      "AnimationStart",
      "SetAxisTarget",
      "Unmount",
  ];
  function createLifecycles() {
      var managers = names.map(function () { return new SubscriptionManager(); });
      var propSubscriptions = {};
      var lifecycles = {
          clearAllListeners: function () { return managers.forEach(function (manager) { return manager.clear(); }); },
          updatePropListeners: function (props) {
              return names.forEach(function (name) {
                  var _a;
                  (_a = propSubscriptions[name]) === null || _a === void 0 ? void 0 : _a.call(propSubscriptions);
                  var on = "on" + name;
                  var propListener = props[on];
                  if (propListener) {
                      propSubscriptions[name] = lifecycles[on](propListener);
                  }
              });
          },
      };
      managers.forEach(function (manager, i) {
          lifecycles["on" + names[i]] = function (handler) { return manager.add(handler); };
          lifecycles["notify" + names[i]] = function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
              }
              return manager.notify.apply(manager, __spreadArray([], __read(args)));
          };
      });
      return lifecycles;
  }

  function updateMotionValuesFromProps(element, next, prev) {
      var _a;
      for (var key in next) {
          var nextValue = next[key];
          var prevValue = prev[key];
          if (isMotionValue(nextValue)) {
              /**
               * If this is a motion value found in props or style, we want to add it
               * to our visual element's motion value map.
               */
              element.addValue(key, nextValue);
          }
          else if (isMotionValue(prevValue)) {
              /**
               * If we're swapping to a new motion value, create a new motion value
               * from that
               */
              element.addValue(key, motionValue(nextValue));
          }
          else if (prevValue !== nextValue) {
              /**
               * If this is a flat value that has changed, update the motion value
               * or create one if it doesn't exist. We only want to do this if we're
               * not handling the value with our animation state.
               */
              if (element.hasValue(key)) {
                  var existingValue = element.getValue(key);
                  // TODO: Only update values that aren't being animated or even looked at
                  !existingValue.hasAnimated && existingValue.set(nextValue);
              }
              else {
                  element.addValue(key, motionValue((_a = element.getStaticValue(key)) !== null && _a !== void 0 ? _a : nextValue));
              }
          }
      }
      // Handle removed values
      for (var key in prev) {
          if (next[key] === undefined)
              element.removeValue(key);
      }
      return next;
  }

  function updateLayoutDeltas(_a, _b, treePath, transformOrigin) {
      var delta = _a.delta, layout = _a.layout, layoutCorrected = _a.layoutCorrected, treeScale = _a.treeScale;
      var target = _b.target;
      /**
       * Reset the corrected box with the latest values from box, as we're then going
       * to perform mutative operations on it.
       */
      resetBox(layoutCorrected, layout);
      /**
       * Apply all the parent deltas to this box to produce the corrected box. This
       * is the layout box, as it will appear on screen as a result of the transforms of its parents.
       */
      applyTreeDeltas(layoutCorrected, treeScale, treePath);
      /**
       * Update the delta between the corrected box and the target box before user-set transforms were applied.
       * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
       * for our layout reprojection, but still allow them to be scaled correctly by the user.
       * It might be that to simplify this we may want to accept that user-set scale is also corrected
       * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
       * to allow people to choose whether these styles are corrected based on just the
       * layout reprojection or the final bounding box.
       */
      updateBoxDelta(delta, layoutCorrected, target, transformOrigin);
  }

  var FlatTree = /** @class */ (function () {
      function FlatTree() {
          this.children = [];
          this.isDirty = false;
      }
      FlatTree.prototype.add = function (child) {
          addUniqueItem(this.children, child);
          this.isDirty = true;
      };
      FlatTree.prototype.remove = function (child) {
          removeItem(this.children, child);
          this.isDirty = true;
      };
      FlatTree.prototype.forEach = function (callback) {
          this.isDirty && this.children.sort(compareByDepth);
          this.isDirty = false;
          this.children.forEach(callback);
      };
      return FlatTree;
  }());

  function setCurrentViewportBox(visualElement) {
      var projectionParent = visualElement.getProjectionParent();
      if (!projectionParent) {
          visualElement.rebaseProjectionTarget();
          return;
      }
      var relativeOffset = calcRelativeOffset(projectionParent.getLayoutState().layout, visualElement.getLayoutState().layout);
      eachAxis(function (axis) {
          visualElement.setProjectionTargetAxis(axis, relativeOffset[axis].min, relativeOffset[axis].max, true);
      });
  }

  var visualElement = function (_a) {
      var _b = _a.treeType, treeType = _b === void 0 ? "" : _b, build = _a.build, getBaseTarget = _a.getBaseTarget, makeTargetAnimatable = _a.makeTargetAnimatable, measureViewportBox = _a.measureViewportBox, renderInstance = _a.render, readValueFromInstance = _a.readValueFromInstance, resetTransform = _a.resetTransform, restoreTransform = _a.restoreTransform, removeValueFromRenderState = _a.removeValueFromRenderState, sortNodePosition = _a.sortNodePosition, scrapeMotionValuesFromProps = _a.scrapeMotionValuesFromProps;
      return function (_a, options) {
          var parent = _a.parent, props = _a.props, presenceId = _a.presenceId, blockInitialAnimation = _a.blockInitialAnimation, visualState = _a.visualState;
          if (options === void 0) { options = {}; }
          var latestValues = visualState.latestValues, renderState = visualState.renderState;
          /**
           * The instance of the render-specific node that will be hydrated by the
           * exposed React ref. So for example, this visual element can host a
           * HTMLElement, plain object, or Three.js object. The functions provided
           * in VisualElementConfig allow us to interface with this instance.
           */
          var instance;
          /**
           * Manages the subscriptions for a visual element's lifecycle, for instance
           * onRender and onViewportBoxUpdate.
           */
          var lifecycles = createLifecycles();
          /**
           *
           */
          var projection = createProjectionState();
          /**
           * A reference to the nearest projecting parent. This is either
           * undefined if we haven't looked for the nearest projecting parent,
           * false if there is no parent performing layout projection, or a reference
           * to the projecting parent.
           */
          var projectionParent;
          /**
           * This is a reference to the visual state of the "lead" visual element.
           * Usually, this will be this visual element. But if it shares a layoutId
           * with other visual elements, only one of them will be designated lead by
           * AnimateSharedLayout. All the other visual elements will take on the visual
           * appearance of the lead while they crossfade to it.
           */
          var leadProjection = projection;
          var leadLatestValues = latestValues;
          var unsubscribeFromLeadVisualElement;
          /**
           * The latest layout measurements and calculated projections. This
           * is seperate from the target projection data in visualState as
           * many visual elements might point to the same piece of visualState as
           * a target, whereas they might each have different layouts and thus
           * projection calculations needed to project into the same viewport box.
           */
          var layoutState = createLayoutState();
          /**
           *
           */
          var crossfader;
          /**
           * Keep track of whether the viewport box has been updated since the
           * last time the layout projection was re-calculated.
           */
          var hasViewportBoxUpdated = false;
          /**
           * A map of all motion values attached to this visual element. Motion
           * values are source of truth for any given animated value. A motion
           * value might be provided externally by the component via props.
           */
          var values = new Map();
          /**
           * A map of every subscription that binds the provided or generated
           * motion values onChange listeners to this visual element.
           */
          var valueSubscriptions = new Map();
          /**
           * A reference to the previously-provided motion values as returned
           * from scrapeMotionValuesFromProps. We use the keys in here to determine
           * if any motion values need to be removed after props are updated.
           */
          var prevMotionValues = {};
          /**
           * x/y motion values that track the progress of initiated layout
           * animations.
           *
           * TODO: Target for removal
           */
          var projectionTargetProgress;
          /**
           * When values are removed from all animation props we need to search
           * for a fallback value to animate to. These values are tracked in baseTarget.
           */
          var baseTarget = __assign({}, latestValues);
          // Internal methods ========================
          /**
           * On mount, this will be hydrated with a callback to disconnect
           * this visual element from its parent on unmount.
           */
          var removeFromVariantTree;
          /**
           *
           */
          function render() {
              if (!instance)
                  return;
              if (element.isProjectionReady()) {
                  /**
                   * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
                   * This is the final box that we will then project into by calculating a transform delta and
                   * applying it to the corrected box.
                   */
                  applyBoxTransforms(leadProjection.targetFinal, leadProjection.target, leadLatestValues);
                  /**
                   * Update the delta between the corrected box and the final target box, after
                   * user-set transforms are applied to it. This will be used by the renderer to
                   * create a transform style that will reproject the element from its actual layout
                   * into the desired bounding box.
                   */
                  updateBoxDelta(layoutState.deltaFinal, layoutState.layoutCorrected, leadProjection.targetFinal, latestValues);
              }
              triggerBuild();
              renderInstance(instance, renderState);
          }
          function triggerBuild() {
              var valuesToRender = latestValues;
              if (crossfader && crossfader.isActive()) {
                  var crossfadedValues = crossfader.getCrossfadeState(element);
                  if (crossfadedValues)
                      valuesToRender = crossfadedValues;
              }
              build(element, renderState, valuesToRender, leadProjection, layoutState, options, props);
          }
          function update() {
              lifecycles.notifyUpdate(latestValues);
          }
          function updateLayoutProjection() {
              if (!element.isProjectionReady())
                  return;
              var delta = layoutState.delta, treeScale = layoutState.treeScale;
              var prevTreeScaleX = treeScale.x;
              var prevTreeScaleY = treeScale.y;
              var prevDeltaTransform = layoutState.deltaTransform;
              updateLayoutDeltas(layoutState, leadProjection, element.path, latestValues);
              hasViewportBoxUpdated &&
                  element.notifyViewportBoxUpdate(leadProjection.target, delta);
              hasViewportBoxUpdated = false;
              var deltaTransform = buildLayoutProjectionTransform(delta, treeScale);
              if (deltaTransform !== prevDeltaTransform ||
                  // Also compare calculated treeScale, for values that rely on this only for scale correction
                  prevTreeScaleX !== treeScale.x ||
                  prevTreeScaleY !== treeScale.y) {
                  element.scheduleRender();
              }
              layoutState.deltaTransform = deltaTransform;
          }
          function updateTreeLayoutProjection() {
              element.layoutTree.forEach(fireUpdateLayoutProjection);
          }
          /**
           *
           */
          function bindToMotionValue(key, value) {
              var removeOnChange = value.onChange(function (latestValue) {
                  latestValues[key] = latestValue;
                  props.onUpdate && sync.update(update, false, true);
              });
              var removeOnRenderRequest = value.onRenderRequest(element.scheduleRender);
              valueSubscriptions.set(key, function () {
                  removeOnChange();
                  removeOnRenderRequest();
              });
          }
          /**
           * Any motion values that are provided to the element when created
           * aren't yet bound to the element, as this would technically be impure.
           * However, we iterate through the motion values and set them to the
           * initial values for this component.
           *
           * TODO: This is impure and we should look at changing this to run on mount.
           * Doing so will break some tests but this isn't neccessarily a breaking change,
           * more a reflection of the test.
           */
          var initialMotionValues = scrapeMotionValuesFromProps(props);
          for (var key in initialMotionValues) {
              var value = initialMotionValues[key];
              if (latestValues[key] !== undefined && isMotionValue(value)) {
                  value.set(latestValues[key], false);
              }
          }
          /**
           * Determine what role this visual element should take in the variant tree.
           */
          var isControllingVariants = checkIfControllingVariants(props);
          var isVariantNode = checkIfVariantNode(props);
          var element = __assign(__assign({ treeType: treeType, 
              /**
               * This is a mirror of the internal instance prop, which keeps
               * VisualElement type-compatible with React's RefObject.
               */
              current: null, 
              /**
               * The depth of this visual element within the visual element tree.
               */
              depth: parent ? parent.depth + 1 : 0, parent: parent, children: new Set(), 
              /**
               * An ancestor path back to the root visual element. This is used
               * by layout projection to quickly recurse back up the tree.
               */
              path: parent ? __spreadArray(__spreadArray([], __read(parent.path)), [parent]) : [], layoutTree: parent ? parent.layoutTree : new FlatTree(), 
              /**
               *
               */
              presenceId: presenceId,
              projection: projection, 
              /**
               * If this component is part of the variant tree, it should track
               * any children that are also part of the tree. This is essentially
               * a shadow tree to simplify logic around how to stagger over children.
               */
              variantChildren: isVariantNode ? new Set() : undefined, 
              /**
               * Whether this instance is visible. This can be changed imperatively
               * by AnimateSharedLayout, is analogous to CSS's visibility in that
               * hidden elements should take up layout, and needs enacting by the configured
               * render function.
               */
              isVisible: undefined, 
              /**
               * Normally, if a component is controlled by a parent's variants, it can
               * rely on that ancestor to trigger animations further down the tree.
               * However, if a component is created after its parent is mounted, the parent
               * won't trigger that mount animation so the child needs to.
               *
               * TODO: This might be better replaced with a method isParentMounted
               */
              manuallyAnimateOnMount: Boolean(parent === null || parent === void 0 ? void 0 : parent.isMounted()), 
              /**
               * This can be set by AnimatePresence to force components that mount
               * at the same time as it to mount as if they have initial={false} set.
               */
              blockInitialAnimation: blockInitialAnimation, 
              /**
               * Determine whether this component has mounted yet. This is mostly used
               * by variant children to determine whether they need to trigger their
               * own animations on mount.
               */
              isMounted: function () { return Boolean(instance); }, mount: function (newInstance) {
                  instance = element.current = newInstance;
                  element.pointTo(element);
                  if (isVariantNode && parent && !isControllingVariants) {
                      removeFromVariantTree = parent === null || parent === void 0 ? void 0 : parent.addVariantChild(element);
                  }
                  parent === null || parent === void 0 ? void 0 : parent.children.add(element);
              },
              /**
               *
               */
              unmount: function () {
                  cancelSync.update(update);
                  cancelSync.render(render);
                  cancelSync.preRender(element.updateLayoutProjection);
                  valueSubscriptions.forEach(function (remove) { return remove(); });
                  element.stopLayoutAnimation();
                  element.layoutTree.remove(element);
                  removeFromVariantTree === null || removeFromVariantTree === void 0 ? void 0 : removeFromVariantTree();
                  parent === null || parent === void 0 ? void 0 : parent.children.delete(element);
                  unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                  lifecycles.clearAllListeners();
              },
              /**
               * Add a child visual element to our set of children.
               */
              addVariantChild: function (child) {
                  var _a;
                  var closestVariantNode = element.getClosestVariantNode();
                  if (closestVariantNode) {
                      (_a = closestVariantNode.variantChildren) === null || _a === void 0 ? void 0 : _a.add(child);
                      return function () { return closestVariantNode.variantChildren.delete(child); };
                  }
              },
              sortNodePosition: function (other) {
                  /**
                   * If these nodes aren't even of the same type we can't compare their depth.
                   */
                  if (!sortNodePosition || treeType !== other.treeType)
                      return 0;
                  return sortNodePosition(element.getInstance(), other.getInstance());
              }, 
              /**
               * Returns the closest variant node in the tree starting from
               * this visual element.
               */
              getClosestVariantNode: function () {
                  return isVariantNode ? element : parent === null || parent === void 0 ? void 0 : parent.getClosestVariantNode();
              }, 
              /**
               * A method that schedules an update to layout projections throughout
               * the tree. We inherit from the parent so there's only ever one
               * job scheduled on the next frame - that of the root visual element.
               */
              scheduleUpdateLayoutProjection: parent
                  ? parent.scheduleUpdateLayoutProjection
                  : function () {
                      return sync.preRender(element.updateTreeLayoutProjection, false, true);
                  }, 
              /**
               * Expose the latest layoutId prop.
               */
              getLayoutId: function () { return props.layoutId; }, 
              /**
               * Returns the current instance.
               */
              getInstance: function () { return instance; }, 
              /**
               * Get/set the latest static values.
               */
              getStaticValue: function (key) { return latestValues[key]; }, setStaticValue: function (key, value) { return (latestValues[key] = value); }, 
              /**
               * Returns the latest motion value state. Currently only used to take
               * a snapshot of the visual element - perhaps this can return the whole
               * visual state
               */
              getLatestValues: function () { return latestValues; }, 
              /**
               * Set the visiblity of the visual element. If it's changed, schedule
               * a render to reflect these changes.
               */
              setVisibility: function (visibility) {
                  if (element.isVisible === visibility)
                      return;
                  element.isVisible = visibility;
                  element.scheduleRender();
              },
              /**
               * Make a target animatable by Popmotion. For instance, if we're
               * trying to animate width from 100px to 100vw we need to measure 100vw
               * in pixels to determine what we really need to animate to. This is also
               * pluggable to support Framer's custom value types like Color,
               * and CSS variables.
               */
              makeTargetAnimatable: function (target, canMutate) {
                  if (canMutate === void 0) { canMutate = true; }
                  return makeTargetAnimatable(element, target, props, canMutate);
              },
              // Motion values ========================
              /**
               * Add a motion value and bind it to this visual element.
               */
              addValue: function (key, value) {
                  // Remove existing value if it exists
                  if (element.hasValue(key))
                      element.removeValue(key);
                  values.set(key, value);
                  latestValues[key] = value.get();
                  bindToMotionValue(key, value);
              },
              /**
               * Remove a motion value and unbind any active subscriptions.
               */
              removeValue: function (key) {
                  var _a;
                  values.delete(key);
                  (_a = valueSubscriptions.get(key)) === null || _a === void 0 ? void 0 : _a();
                  valueSubscriptions.delete(key);
                  delete latestValues[key];
                  removeValueFromRenderState(key, renderState);
              }, 
              /**
               * Check whether we have a motion value for this key
               */
              hasValue: function (key) { return values.has(key); }, 
              /**
               * Get a motion value for this key. If called with a default
               * value, we'll create one if none exists.
               */
              getValue: function (key, defaultValue) {
                  var value = values.get(key);
                  if (value === undefined && defaultValue !== undefined) {
                      value = motionValue(defaultValue);
                      element.addValue(key, value);
                  }
                  return value;
              }, 
              /**
               * Iterate over our motion values.
               */
              forEachValue: function (callback) { return values.forEach(callback); }, 
              /**
               * If we're trying to animate to a previously unencountered value,
               * we need to check for it in our state and as a last resort read it
               * directly from the instance (which might have performance implications).
               */
              readValue: function (key) { var _a; return (_a = latestValues[key]) !== null && _a !== void 0 ? _a : readValueFromInstance(instance, key, options); }, 
              /**
               * Set the base target to later animate back to. This is currently
               * only hydrated on creation and when we first read a value.
               */
              setBaseTarget: function (key, value) {
                  baseTarget[key] = value;
              },
              /**
               * Find the base target for a value thats been removed from all animation
               * props.
               */
              getBaseTarget: function (key) {
                  if (getBaseTarget) {
                      var target = getBaseTarget(props, key);
                      if (target !== undefined && !isMotionValue(target))
                          return target;
                  }
                  return baseTarget[key];
              } }, lifecycles), { 
              /**
               * Build the renderer state based on the latest visual state.
               */
              build: function () {
                  triggerBuild();
                  return renderState;
              },
              /**
               * Schedule a render on the next animation frame.
               */
              scheduleRender: function () {
                  sync.render(render, false, true);
              }, 
              /**
               * Synchronously fire render. It's prefered that we batch renders but
               * in many circumstances, like layout measurement, we need to run this
               * synchronously. However in those instances other measures should be taken
               * to batch reads/writes.
               */
              syncRender: render, 
              /**
               * Update the provided props. Ensure any newly-added motion values are
               * added to our map, old ones removed, and listeners updated.
               */
              setProps: function (newProps) {
                  props = newProps;
                  lifecycles.updatePropListeners(newProps);
                  prevMotionValues = updateMotionValuesFromProps(element, scrapeMotionValuesFromProps(props), prevMotionValues);
              }, getProps: function () { return props; }, 
              // Variants ==============================
              /**
               * Returns the variant definition with a given name.
               */
              getVariant: function (name) { var _a; return (_a = props.variants) === null || _a === void 0 ? void 0 : _a[name]; }, 
              /**
               * Returns the defined default transition on this component.
               */
              getDefaultTransition: function () { return props.transition; }, 
              /**
               * Used by child variant nodes to get the closest ancestor variant props.
               */
              getVariantContext: function (startAtParent) {
                  if (startAtParent === void 0) { startAtParent = false; }
                  if (startAtParent)
                      return parent === null || parent === void 0 ? void 0 : parent.getVariantContext();
                  if (!isControllingVariants) {
                      var context_1 = (parent === null || parent === void 0 ? void 0 : parent.getVariantContext()) || {};
                      if (props.initial !== undefined) {
                          context_1.initial = props.initial;
                      }
                      return context_1;
                  }
                  var context = {};
                  for (var i = 0; i < numVariantProps; i++) {
                      var name_1 = variantProps[i];
                      var prop = props[name_1];
                      if (isVariantLabel(prop) || prop === false) {
                          context[name_1] = prop;
                      }
                  }
                  return context;
              },
              // Layout projection ==============================
              /**
               * Enable layout projection for this visual element. Won't actually
               * occur until we also have hydrated layout measurements.
               */
              enableLayoutProjection: function () {
                  projection.isEnabled = true;
                  element.layoutTree.add(element);
              },
              /**
               * Lock the projection target, for instance when dragging, so
               * nothing else can try and animate it.
               */
              lockProjectionTarget: function () {
                  projection.isTargetLocked = true;
              },
              unlockProjectionTarget: function () {
                  element.stopLayoutAnimation();
                  projection.isTargetLocked = false;
              }, getLayoutState: function () { return layoutState; }, setCrossfader: function (newCrossfader) {
                  crossfader = newCrossfader;
              }, isProjectionReady: function () {
                  return projection.isEnabled &&
                      projection.isHydrated &&
                      layoutState.isHydrated;
              }, 
              /**
               * Start a layout animation on a given axis.
               */
              startLayoutAnimation: function (axis, transition, isRelative) {
                  if (isRelative === void 0) { isRelative = false; }
                  var progress = element.getProjectionAnimationProgress()[axis];
                  var _a = isRelative
                      ? projection.relativeTarget[axis]
                      : projection.target[axis], min = _a.min, max = _a.max;
                  var length = max - min;
                  progress.clearListeners();
                  progress.set(min);
                  progress.set(min); // Set twice to hard-reset velocity
                  progress.onChange(function (v) {
                      element.setProjectionTargetAxis(axis, v, v + length, isRelative);
                  });
                  return element.animateMotionValue(axis, progress, 0, transition);
              },
              /**
               * Stop layout animations.
               */
              stopLayoutAnimation: function () {
                  eachAxis(function (axis) {
                      return element.getProjectionAnimationProgress()[axis].stop();
                  });
              },
              /**
               * Measure the current viewport box with or without transforms.
               * Only measures axis-aligned boxes, rotate and skew must be manually
               * removed with a re-render to work.
               */
              measureViewportBox: function (withTransform) {
                  if (withTransform === void 0) { withTransform = true; }
                  var viewportBox = measureViewportBox(instance, options);
                  if (!withTransform)
                      removeBoxTransforms(viewportBox, latestValues);
                  return viewportBox;
              },
              /**
               * Get the motion values tracking the layout animations on each
               * axis. Lazy init if not already created.
               */
              getProjectionAnimationProgress: function () {
                  projectionTargetProgress || (projectionTargetProgress = {
                      x: motionValue(0),
                      y: motionValue(0),
                  });
                  return projectionTargetProgress;
              },
              /**
               * Update the projection of a single axis. Schedule an update to
               * the tree layout projection.
               */
              setProjectionTargetAxis: function (axis, min, max, isRelative) {
                  if (isRelative === void 0) { isRelative = false; }
                  var target;
                  if (isRelative) {
                      if (!projection.relativeTarget) {
                          projection.relativeTarget = axisBox();
                      }
                      target = projection.relativeTarget[axis];
                  }
                  else {
                      projection.relativeTarget = undefined;
                      target = projection.target[axis];
                  }
                  projection.isHydrated = true;
                  target.min = min;
                  target.max = max;
                  // Flag that we want to fire the onViewportBoxUpdate event handler
                  hasViewportBoxUpdated = true;
                  lifecycles.notifySetAxisTarget();
              },
              /**
               * Rebase the projection target on top of the provided viewport box
               * or the measured layout. This ensures that non-animating elements
               * don't fall out of sync differences in measurements vs projections
               * after a page scroll or other relayout.
               */
              rebaseProjectionTarget: function (force, box) {
                  if (box === void 0) { box = layoutState.layout; }
                  var _a = element.getProjectionAnimationProgress(), x = _a.x, y = _a.y;
                  var shouldRebase = !projection.relativeTarget &&
                      !projection.isTargetLocked &&
                      !x.isAnimating() &&
                      !y.isAnimating();
                  if (force || shouldRebase) {
                      eachAxis(function (axis) {
                          var _a = box[axis], min = _a.min, max = _a.max;
                          element.setProjectionTargetAxis(axis, min, max);
                      });
                  }
              },
              /**
               * Notify the visual element that its layout is up-to-date.
               * Currently Animate.tsx uses this to check whether a layout animation
               * needs to be performed.
               */
              notifyLayoutReady: function (config) {
                  setCurrentViewportBox(element);
                  element.notifyLayoutUpdate(layoutState.layout, element.prevViewportBox || layoutState.layout, config);
              }, 
              /**
               * Temporarily reset the transform of the instance.
               */
              resetTransform: function () { return resetTransform(element, instance, props); }, restoreTransform: function () { return restoreTransform(instance, renderState); }, updateLayoutProjection: updateLayoutProjection,
              updateTreeLayoutProjection: function () {
                  element.layoutTree.forEach(fireResolveRelativeTargetBox);
                  /**
                   * Schedule the projection updates at the end of the current preRender
                   * step. This will ensure that all layout trees will first resolve
                   * relative projection boxes into viewport boxes, and *then*
                   * update projections.
                   */
                  sync.preRender(updateTreeLayoutProjection, false, true);
                  // sync.postRender(() => element.scheduleUpdateLayoutProjection())
              },
              getProjectionParent: function () {
                  if (projectionParent === undefined) {
                      var foundParent = false;
                      // Search backwards through the tree path
                      for (var i = element.path.length - 1; i >= 0; i--) {
                          var ancestor = element.path[i];
                          if (ancestor.projection.isEnabled) {
                              foundParent = ancestor;
                              break;
                          }
                      }
                      projectionParent = foundParent;
                  }
                  return projectionParent;
              },
              resolveRelativeTargetBox: function () {
                  var relativeParent = element.getProjectionParent();
                  if (!projection.relativeTarget || !relativeParent)
                      return;
                  calcRelativeBox(projection, relativeParent.projection);
                  if (isDraggable(relativeParent)) {
                      var target = projection.target;
                      applyBoxTransforms(target, target, relativeParent.getLatestValues());
                  }
              },
              shouldResetTransform: function () {
                  return Boolean(props._layoutResetTransform);
              },
              /**
               *
               */
              pointTo: function (newLead) {
                  leadProjection = newLead.projection;
                  leadLatestValues = newLead.getLatestValues();
                  /**
                   * Subscribe to lead component's layout animations
                   */
                  unsubscribeFromLeadVisualElement === null || unsubscribeFromLeadVisualElement === void 0 ? void 0 : unsubscribeFromLeadVisualElement();
                  unsubscribeFromLeadVisualElement = pipe$2(newLead.onSetAxisTarget(element.scheduleUpdateLayoutProjection), newLead.onLayoutAnimationComplete(function () {
                      var _a;
                      if (element.isPresent) {
                          element.presence = Presence.Present;
                      }
                      else {
                          (_a = element.layoutSafeToRemove) === null || _a === void 0 ? void 0 : _a.call(element);
                      }
                  }));
              }, 
              // TODO: Clean this up
              isPresent: true, presence: Presence.Entering });
          return element;
      };
  };
  function fireResolveRelativeTargetBox(child) {
      child.resolveRelativeTargetBox();
  }
  function fireUpdateLayoutProjection(child) {
      child.updateLayoutProjection();
  }
  var variantProps = __spreadArray(["initial"], __read(variantPriorityOrder));
  var numVariantProps = variantProps.length;

  var positionalKeys = new Set([
      "width",
      "height",
      "top",
      "left",
      "right",
      "bottom",
      "x",
      "y",
  ]);
  var isPositionalKey = function (key) { return positionalKeys.has(key); };
  var hasPositionalKey = function (target) {
      return Object.keys(target).some(isPositionalKey);
  };
  var setAndResetVelocity = function (value, to) {
      // Looks odd but setting it twice doesn't render, it'll just
      // set both prev and current to the latest value
      value.set(to, false);
      value.set(to);
  };
  var isNumOrPxType = function (v) {
      return v === number || v === px;
  };
  var BoundingBoxDimension;
  (function (BoundingBoxDimension) {
      BoundingBoxDimension["width"] = "width";
      BoundingBoxDimension["height"] = "height";
      BoundingBoxDimension["left"] = "left";
      BoundingBoxDimension["right"] = "right";
      BoundingBoxDimension["top"] = "top";
      BoundingBoxDimension["bottom"] = "bottom";
  })(BoundingBoxDimension || (BoundingBoxDimension = {}));
  var getPosFromMatrix = function (matrix, pos) {
      return parseFloat(matrix.split(", ")[pos]);
  };
  var getTranslateFromMatrix = function (pos2, pos3) { return function (_bbox, _a) {
      var transform = _a.transform;
      if (transform === "none" || !transform)
          return 0;
      var matrix3d = transform.match(/^matrix3d\((.+)\)$/);
      if (matrix3d) {
          return getPosFromMatrix(matrix3d[1], pos3);
      }
      else {
          var matrix = transform.match(/^matrix\((.+)\)$/);
          if (matrix) {
              return getPosFromMatrix(matrix[1], pos2);
          }
          else {
              return 0;
          }
      }
  }; };
  var transformKeys = new Set(["x", "y", "z"]);
  var nonTranslationalTransformKeys = transformProps.filter(function (key) { return !transformKeys.has(key); });
  function removeNonTranslationalTransform(visualElement) {
      var removedTransforms = [];
      nonTranslationalTransformKeys.forEach(function (key) {
          var value = visualElement.getValue(key);
          if (value !== undefined) {
              removedTransforms.push([key, value.get()]);
              value.set(key.startsWith("scale") ? 1 : 0);
          }
      });
      // Apply changes to element before measurement
      if (removedTransforms.length)
          visualElement.syncRender();
      return removedTransforms;
  }
  var positionalValues = {
      // Dimensions
      width: function (_a) {
          var x = _a.x;
          return x.max - x.min;
      },
      height: function (_a) {
          var y = _a.y;
          return y.max - y.min;
      },
      top: function (_bbox, _a) {
          var top = _a.top;
          return parseFloat(top);
      },
      left: function (_bbox, _a) {
          var left = _a.left;
          return parseFloat(left);
      },
      bottom: function (_a, _b) {
          var y = _a.y;
          var top = _b.top;
          return parseFloat(top) + (y.max - y.min);
      },
      right: function (_a, _b) {
          var x = _a.x;
          var left = _b.left;
          return parseFloat(left) + (x.max - x.min);
      },
      // Transform
      x: getTranslateFromMatrix(4, 13),
      y: getTranslateFromMatrix(5, 14),
  };
  var convertChangedValueTypes = function (target, visualElement, changedKeys) {
      var originBbox = visualElement.measureViewportBox();
      var element = visualElement.getInstance();
      var elementComputedStyle = getComputedStyle(element);
      var display = elementComputedStyle.display, top = elementComputedStyle.top, left = elementComputedStyle.left, bottom = elementComputedStyle.bottom, right = elementComputedStyle.right, transform = elementComputedStyle.transform;
      var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform };
      // If the element is currently set to display: "none", make it visible before
      // measuring the target bounding box
      if (display === "none") {
          visualElement.setStaticValue("display", target.display || "block");
      }
      // Apply the latest values (as set in checkAndConvertChangedValueTypes)
      visualElement.syncRender();
      var targetBbox = visualElement.measureViewportBox();
      changedKeys.forEach(function (key) {
          // Restore styles to their **calculated computed style**, not their actual
          // originally set style. This allows us to animate between equivalent pixel units.
          var value = visualElement.getValue(key);
          setAndResetVelocity(value, positionalValues[key](originBbox, originComputedStyle));
          target[key] = positionalValues[key](targetBbox, elementComputedStyle);
      });
      return target;
  };
  var checkAndConvertChangedValueTypes = function (visualElement, target, origin, transitionEnd) {
      if (origin === void 0) { origin = {}; }
      if (transitionEnd === void 0) { transitionEnd = {}; }
      target = __assign({}, target);
      transitionEnd = __assign({}, transitionEnd);
      var targetPositionalKeys = Object.keys(target).filter(isPositionalKey);
      // We want to remove any transform values that could affect the element's bounding box before
      // it's measured. We'll reapply these later.
      var removedTransformValues = [];
      var hasAttemptedToRemoveTransformValues = false;
      var changedValueTypeKeys = [];
      targetPositionalKeys.forEach(function (key) {
          var value = visualElement.getValue(key);
          if (!visualElement.hasValue(key))
              return;
          var from = origin[key];
          var to = target[key];
          var fromType = findDimensionValueType(from);
          var toType;
          // TODO: The current implementation of this basically throws an error
          // if you try and do value conversion via keyframes. There's probably
          // a way of doing this but the performance implications would need greater scrutiny,
          // as it'd be doing multiple resize-remeasure operations.
          if (isKeyframesTarget(to)) {
              var numKeyframes = to.length;
              for (var i = to[0] === null ? 1 : 0; i < numKeyframes; i++) {
                  if (!toType) {
                      toType = findDimensionValueType(to[i]);
                  }
                  else {
                      invariant(findDimensionValueType(to[i]) === toType);
                  }
              }
          }
          else {
              toType = findDimensionValueType(to);
          }
          if (fromType !== toType) {
              // If they're both just number or px, convert them both to numbers rather than
              // relying on resize/remeasure to convert (which is wasteful in this situation)
              if (isNumOrPxType(fromType) && isNumOrPxType(toType)) {
                  var current = value.get();
                  if (typeof current === "string") {
                      value.set(parseFloat(current));
                  }
                  if (typeof to === "string") {
                      target[key] = parseFloat(to);
                  }
                  else if (Array.isArray(to) && toType === px) {
                      target[key] = to.map(parseFloat);
                  }
              }
              else if ((fromType === null || fromType === void 0 ? void 0 : fromType.transform) &&
                  (toType === null || toType === void 0 ? void 0 : toType.transform) &&
                  (from === 0 || to === 0)) {
                  // If one or the other value is 0, it's safe to coerce it to the
                  // type of the other without measurement
                  if (from === 0) {
                      value.set(toType.transform(from));
                  }
                  else {
                      target[key] = fromType.transform(to);
                  }
              }
              else {
                  // If we're going to do value conversion via DOM measurements, we first
                  // need to remove non-positional transform values that could affect the bbox measurements.
                  if (!hasAttemptedToRemoveTransformValues) {
                      removedTransformValues = removeNonTranslationalTransform(visualElement);
                      hasAttemptedToRemoveTransformValues = true;
                  }
                  changedValueTypeKeys.push(key);
                  transitionEnd[key] =
                      transitionEnd[key] !== undefined
                          ? transitionEnd[key]
                          : target[key];
                  setAndResetVelocity(value, to);
              }
          }
      });
      if (changedValueTypeKeys.length) {
          var convertedTarget = convertChangedValueTypes(target, visualElement, changedValueTypeKeys);
          // If we removed transform values, reapply them before the next render
          if (removedTransformValues.length) {
              removedTransformValues.forEach(function (_a) {
                  var _b = __read(_a, 2), key = _b[0], value = _b[1];
                  visualElement.getValue(key).set(value);
              });
          }
          // Reapply original values
          visualElement.syncRender();
          return { target: convertedTarget, transitionEnd: transitionEnd };
      }
      else {
          return { target: target, transitionEnd: transitionEnd };
      }
  };
  /**
   * Convert value types for x/y/width/height/top/left/bottom/right
   *
   * Allows animation between `'auto'` -> `'100%'` or `0` -> `'calc(50% - 10vw)'`
   *
   * @internal
   */
  function unitConversion(visualElement, target, origin, transitionEnd) {
      return hasPositionalKey(target)
          ? checkAndConvertChangedValueTypes(visualElement, target, origin, transitionEnd)
          : { target: target, transitionEnd: transitionEnd };
  }

  /**
   * Parse a DOM variant to make it animatable. This involves resolving CSS variables
   * and ensuring animations like "20%" => "calc(50vw)" are performed in pixels.
   */
  var parseDomVariant = function (visualElement, target, origin, transitionEnd) {
      var resolved = resolveCSSVariables(visualElement, target, transitionEnd);
      target = resolved.target;
      transitionEnd = resolved.transitionEnd;
      return unitConversion(visualElement, target, origin, transitionEnd);
  };

  function getComputedStyle$2(element) {
      return window.getComputedStyle(element);
  }
  var htmlConfig = {
      treeType: "dom",
      readValueFromInstance: function (domElement, key) {
          if (isTransformProp(key)) {
              var defaultType = getDefaultValueType(key);
              return defaultType ? defaultType.default || 0 : 0;
          }
          else {
              var computedStyle = getComputedStyle$2(domElement);
              return ((isCSSVariable$1(key)
                  ? computedStyle.getPropertyValue(key)
                  : computedStyle[key]) || 0);
          }
      },
      sortNodePosition: function (a, b) {
          /**
           * compareDocumentPosition returns a bitmask, by using the bitwise &
           * we're returning true if 2 in that bitmask is set to true. 2 is set
           * to true if b preceeds a.
           */
          return a.compareDocumentPosition(b) & 2 ? 1 : -1;
      },
      getBaseTarget: function (props, key) {
          var _a;
          return (_a = props.style) === null || _a === void 0 ? void 0 : _a[key];
      },
      measureViewportBox: function (element, _a) {
          var transformPagePoint = _a.transformPagePoint;
          return getBoundingBox(element, transformPagePoint);
      },
      /**
       * Reset the transform on the current Element. This is called as part
       * of a batched process across the entire layout tree. To remove this write
       * cycle it'd be interesting to see if it's possible to "undo" all the current
       * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
       * works
       */
      resetTransform: function (element, domElement, props) {
          var transformTemplate = props.transformTemplate;
          domElement.style.transform = transformTemplate
              ? transformTemplate({}, "")
              : "none";
          // Ensure that whatever happens next, we restore our transform on the next frame
          element.scheduleRender();
      },
      restoreTransform: function (instance, mutableState) {
          instance.style.transform = mutableState.style.transform;
      },
      removeValueFromRenderState: function (key, _a) {
          var vars = _a.vars, style = _a.style;
          delete vars[key];
          delete style[key];
      },
      /**
       * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
       * can be animated by Motion.
       */
      makeTargetAnimatable: function (element, _a, _b, isMounted) {
          var transformValues = _b.transformValues;
          if (isMounted === void 0) { isMounted = true; }
          var transition = _a.transition, transitionEnd = _a.transitionEnd, target = __rest(_a, ["transition", "transitionEnd"]);
          var origin = getOrigin(target, transition || {}, element);
          /**
           * If Framer has provided a function to convert `Color` etc value types, convert them
           */
          if (transformValues) {
              if (transitionEnd)
                  transitionEnd = transformValues(transitionEnd);
              if (target)
                  target = transformValues(target);
              if (origin)
                  origin = transformValues(origin);
          }
          if (isMounted) {
              checkTargetForNewValues(element, target, origin);
              var parsed = parseDomVariant(element, target, origin, transitionEnd);
              transitionEnd = parsed.transitionEnd;
              target = parsed.target;
          }
          return __assign({ transition: transition,
              transitionEnd: transitionEnd }, target);
      },
      scrapeMotionValuesFromProps: scrapeMotionValuesFromProps$1,
      build: function (element, renderState, latestValues, projection, layoutState, options, props) {
          if (element.isVisible !== undefined) {
              renderState.style.visibility = element.isVisible
                  ? "visible"
                  : "hidden";
          }
          var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
          buildHTMLStyles(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
              ? buildLayoutProjectionTransformOrigin
              : undefined);
      },
      render: renderHTML,
  };
  var htmlVisualElement = visualElement(htmlConfig);

  var svgVisualElement = visualElement(__assign(__assign({}, htmlConfig), { getBaseTarget: function (props, key) {
          return props[key];
      },
      readValueFromInstance: function (domElement, key) {
          var _a;
          if (isTransformProp(key)) {
              return ((_a = getDefaultValueType(key)) === null || _a === void 0 ? void 0 : _a.default) || 0;
          }
          key = !camelCaseAttributes.has(key) ? camelToDash(key) : key;
          return domElement.getAttribute(key);
      },
      scrapeMotionValuesFromProps: scrapeMotionValuesFromProps,
      build: function (_element, renderState, latestValues, projection, layoutState, options, props) {
          var isProjectionTranform = projection.isEnabled && layoutState.isHydrated;
          buildSVGAttrs(renderState, latestValues, projection, layoutState, options, props.transformTemplate, isProjectionTranform ? buildLayoutProjectionTransform : undefined, isProjectionTranform
              ? buildLayoutProjectionTransformOrigin
              : undefined);
      }, render: renderSVG }));

  var createDomVisualElement = function (Component, options) {
      return isSVGComponent(Component)
          ? svgVisualElement(options, { enableHardwareAcceleration: false })
          : htmlVisualElement(options, { enableHardwareAcceleration: true });
  };

  var featureBundle = __assign(__assign(__assign(__assign({}, animations), gestureAnimations), drag), layoutAnimations);
  /**
   * HTML & SVG components, optimised for use with gestures and animation. These can be used as
   * drop-in replacements for any HTML & SVG component, all CSS & SVG properties are supported.
   *
   * @public
   */
  var motion = /*@__PURE__*/ createMotionProxy(function (Component, config) {
      return createDomMotionConfig(Component, config, featureBundle, createDomVisualElement);
  });

  function useForceUpdate() {
      var unloadingRef = React.useRef(false);
      var _a = __read(React.useState(0), 2), forcedRenderCount = _a[0], setForcedRenderCount = _a[1];
      useUnmountEffect(function () { return (unloadingRef.current = true); });
      return React.useCallback(function () {
          !unloadingRef.current && setForcedRenderCount(forcedRenderCount + 1);
      }, [forcedRenderCount]);
  }

  var presenceId = 0;
  function getPresenceId() {
      var id = presenceId;
      presenceId++;
      return id;
  }
  var PresenceChild = function (_a) {
      var children = _a.children, initial = _a.initial, isPresent = _a.isPresent, onExitComplete = _a.onExitComplete, custom = _a.custom, presenceAffectsLayout = _a.presenceAffectsLayout;
      var presenceChildren = useConstant(newChildrenMap);
      var id = useConstant(getPresenceId);
      var context = React.useMemo(function () { return ({
          id: id,
          initial: initial,
          isPresent: isPresent,
          custom: custom,
          onExitComplete: function (childId) {
              presenceChildren.set(childId, true);
              var allComplete = true;
              presenceChildren.forEach(function (isComplete) {
                  if (!isComplete)
                      allComplete = false;
              });
              allComplete && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
          },
          register: function (childId) {
              presenceChildren.set(childId, false);
              return function () { return presenceChildren.delete(childId); };
          },
      }); }, 
      /**
       * If the presence of a child affects the layout of the components around it,
       * we want to make a new context value to ensure they get re-rendered
       * so they can detect that layout change.
       */
      presenceAffectsLayout ? undefined : [isPresent]);
      React.useMemo(function () {
          presenceChildren.forEach(function (_, key) { return presenceChildren.set(key, false); });
      }, [isPresent]);
      /**
       * If there's no `motion` components to fire exit animations, we want to remove this
       * component immediately.
       */
      React__namespace.useEffect(function () {
          !isPresent && !presenceChildren.size && (onExitComplete === null || onExitComplete === void 0 ? void 0 : onExitComplete());
      }, [isPresent]);
      return (React__namespace.createElement(PresenceContext.Provider, { value: context }, children));
  };
  function newChildrenMap() {
      return new Map();
  }

  function getChildKey(child) {
      return child.key || "";
  }
  function updateChildLookup(children, allChildren) {
      children.forEach(function (child) {
          var key = getChildKey(child);
          allChildren.set(key, child);
      });
  }
  function onlyElements(children) {
      var filtered = [];
      // We use forEach here instead of map as map mutates the component key by preprending `.$`
      React.Children.forEach(children, function (child) {
          if (React.isValidElement(child))
              filtered.push(child);
      });
      return filtered;
  }
  /**
   * `AnimatePresence` enables the animation of components that have been removed from the tree.
   *
   * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
   *
   * @library
   *
   * Any `Frame` components that have an `exit` property defined will animate out when removed from
   * the tree.
   *
   * ```jsx
   * import { Frame, AnimatePresence } from 'framer'
   *
   * // As items are added and removed from `items`
   * export function Items({ items }) {
   *   return (
   *     <AnimatePresence>
   *       {items.map(item => (
   *         <Frame
   *           key={item.id}
   *           initial={{ opacity: 0 }}
   *           animate={{ opacity: 1 }}
   *           exit={{ opacity: 0 }}
   *         />
   *       ))}
   *     </AnimatePresence>
   *   )
   * }
   * ```
   *
   * You can sequence exit animations throughout a tree using variants.
   *
   * @motion
   *
   * Any `motion` components that have an `exit` property defined will animate out when removed from
   * the tree.
   *
   * ```jsx
   * import { motion, AnimatePresence } from 'framer-motion'
   *
   * export const Items = ({ items }) => (
   *   <AnimatePresence>
   *     {items.map(item => (
   *       <motion.div
   *         key={item.id}
   *         initial={{ opacity: 0 }}
   *         animate={{ opacity: 1 }}
   *         exit={{ opacity: 0 }}
   *       />
   *     ))}
   *   </AnimatePresence>
   * )
   * ```
   *
   * You can sequence exit animations throughout a tree using variants.
   *
   * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
   * once all `motion` components have finished animating out. Likewise, any components using
   * `usePresence` all need to call `safeToRemove`.
   *
   * @public
   */
  var AnimatePresence = function (_a) {
      var children = _a.children, custom = _a.custom, _b = _a.initial, initial = _b === void 0 ? true : _b, onExitComplete = _a.onExitComplete, exitBeforeEnter = _a.exitBeforeEnter, _c = _a.presenceAffectsLayout, presenceAffectsLayout = _c === void 0 ? true : _c;
      // We want to force a re-render once all exiting animations have finished. We
      // either use a local forceRender function, or one from a parent context if it exists.
      var forceRender = useForceUpdate();
      var layoutContext = React.useContext(SharedLayoutContext);
      if (isSharedLayout(layoutContext)) {
          forceRender = layoutContext.forceUpdate;
      }
      var isInitialRender = React.useRef(true);
      // Filter out any children that aren't ReactElements. We can only track ReactElements with a props.key
      var filteredChildren = onlyElements(children);
      // Keep a living record of the children we're actually rendering so we
      // can diff to figure out which are entering and exiting
      var presentChildren = React.useRef(filteredChildren);
      // A lookup table to quickly reference components by key
      var allChildren = React.useRef(new Map())
          .current;
      // A living record of all currently exiting components.
      var exiting = React.useRef(new Set()).current;
      updateChildLookup(filteredChildren, allChildren);
      // If this is the initial component render, just deal with logic surrounding whether
      // we play onMount animations or not.
      if (isInitialRender.current) {
          isInitialRender.current = false;
          return (React__namespace.createElement(React__namespace.Fragment, null, filteredChildren.map(function (child) { return (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, initial: initial ? undefined : false, presenceAffectsLayout: presenceAffectsLayout }, child)); })));
      }
      // If this is a subsequent render, deal with entering and exiting children
      var childrenToRender = __spreadArray([], __read(filteredChildren));
      // Diff the keys of the currently-present and target children to update our
      // exiting list.
      var presentKeys = presentChildren.current.map(getChildKey);
      var targetKeys = filteredChildren.map(getChildKey);
      // Diff the present children with our target children and mark those that are exiting
      var numPresent = presentKeys.length;
      for (var i = 0; i < numPresent; i++) {
          var key = presentKeys[i];
          if (targetKeys.indexOf(key) === -1) {
              exiting.add(key);
          }
          else {
              // In case this key has re-entered, remove from the exiting list
              exiting.delete(key);
          }
      }
      // If we currently have exiting children, and we're deferring rendering incoming children
      // until after all current children have exiting, empty the childrenToRender array
      if (exitBeforeEnter && exiting.size) {
          childrenToRender = [];
      }
      // Loop through all currently exiting components and clone them to overwrite `animate`
      // with any `exit` prop they might have defined.
      exiting.forEach(function (key) {
          // If this component is actually entering again, early return
          if (targetKeys.indexOf(key) !== -1)
              return;
          var child = allChildren.get(key);
          if (!child)
              return;
          var insertionIndex = presentKeys.indexOf(key);
          var onExit = function () {
              allChildren.delete(key);
              exiting.delete(key);
              // Remove this child from the present children
              var removeIndex = presentChildren.current.findIndex(function (presentChild) { return presentChild.key === key; });
              presentChildren.current.splice(removeIndex, 1);
              // Defer re-rendering until all exiting children have indeed left
              if (!exiting.size) {
                  presentChildren.current = filteredChildren;
                  forceRender();
                  onExitComplete && onExitComplete();
              }
          };
          childrenToRender.splice(insertionIndex, 0, React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: false, onExitComplete: onExit, custom: custom, presenceAffectsLayout: presenceAffectsLayout }, child));
      });
      // Add `MotionContext` even to children that don't need it to ensure we're rendering
      // the same tree between renders
      childrenToRender = childrenToRender.map(function (child) {
          var key = child.key;
          return exiting.has(key) ? (child) : (React__namespace.createElement(PresenceChild, { key: getChildKey(child), isPresent: true, presenceAffectsLayout: presenceAffectsLayout }, child));
      });
      presentChildren.current = childrenToRender;
      return (React__namespace.createElement(React__namespace.Fragment, null, exiting.size
          ? childrenToRender
          : childrenToRender.map(function (child) { return React.cloneElement(child); })));
  };

  const findById = (arr, id) => arr.find((toast) => toast.id === id);
  function findToast(toasts, id) {
    const position = getToastPosition(toasts, id);
    const index = position ? toasts[position].findIndex((toast) => toast.id === id) : -1;
    return {
      position,
      index
    };
  }
  function getToastPosition(toasts, id) {
    for (const [position, values] of Object.entries(toasts)) {
      if (findById(values, id)) {
        return position;
      }
    }
  }
  function getToastStyle(position) {
    const isRighty = position.includes("right");
    const isLefty = position.includes("left");
    let alignItems = "center";
    if (isRighty)
      alignItems = "flex-end";
    if (isLefty)
      alignItems = "flex-start";
    return {
      display: "flex",
      flexDirection: "column",
      alignItems
    };
  }
  function getToastListStyle(position) {
    const isTopOrBottom = position === "top" || position === "bottom";
    const margin = isTopOrBottom ? "0 auto" : void 0;
    const top = position.includes("top") ? "env(safe-area-inset-top, 0px)" : void 0;
    const bottom = position.includes("bottom") ? "env(safe-area-inset-bottom, 0px)" : void 0;
    const right = !position.includes("left") ? "env(safe-area-inset-right, 0px)" : void 0;
    const left = !position.includes("right") ? "env(safe-area-inset-left, 0px)" : void 0;
    return {
      position: "fixed",
      zIndex: "var(--toast-z-index, 5500)",
      pointerEvents: "none",
      display: "flex",
      flexDirection: "column",
      margin,
      top,
      bottom,
      right,
      left
    };
  }

  // eslint-disable-next-line no-undef
  var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

  var isPropValid = /* #__PURE__ */memoize$1(function (prop) {
    return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
    /* o */
    && prop.charCodeAt(1) === 110
    /* n */
    && prop.charCodeAt(2) < 91;
  }
  /* Z+1 */
  );

  var testOmitPropsOnStringTag = isPropValid;

  var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
  };

  var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
  };
  var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;

    if (options) {
      var optionsShouldForwardProp = options.shouldForwardProp;
      shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
        return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
      } : optionsShouldForwardProp;
    }

    if (typeof shouldForwardProp !== 'function' && isReal) {
      shouldForwardProp = tag.__emotion_forwardProp;
    }

    return shouldForwardProp;
  };

  var Insertion = function Insertion(_ref) {
    var cache = _ref.cache,
        serialized = _ref.serialized,
        isStringTag = _ref.isStringTag;
    registerStyles(cache, serialized, isStringTag);
    useInsertionEffectAlwaysWithSyncFallback(function () {
      return insertStyles(cache, serialized, isStringTag);
    });

    return null;
  };

  var createStyled = function createStyled(tag, options) {

    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;

    if (options !== undefined) {
      identifierName = options.label;
      targetClassName = options.target;
    }

    var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function () {
      // eslint-disable-next-line prefer-rest-params
      var args = arguments;
      var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

      if (identifierName !== undefined) {
        styles.push("label:" + identifierName + ";");
      }

      if (args[0] == null || args[0].raw === undefined) {
        // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
      } else {
        var templateStringsArr = args[0];

        styles.push(templateStringsArr[0]);
        var len = args.length;
        var i = 1;

        for (; i < len; i++) {

          styles.push(args[i], templateStringsArr[i]);
        }
      }

      var Styled = withEmotionCache(function (props, cache, ref) {
        var FinalTag = shouldUseAs && props.as || baseTag;
        var className = '';
        var classInterpolations = [];
        var mergedProps = props;

        if (props.theme == null) {
          mergedProps = {};

          for (var key in props) {
            mergedProps[key] = props[key];
          }

          mergedProps.theme = React__namespace.useContext(ThemeContext);
        }

        if (typeof props.className === 'string') {
          className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }

        var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
        className += cache.key + "-" + serialized.name;

        if (targetClassName !== undefined) {
          className += " " + targetClassName;
        }

        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
        var newProps = {};

        for (var _key in props) {
          if (shouldUseAs && _key === 'as') continue;

          if (finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }

        newProps.className = className;

        if (ref) {
          newProps.ref = ref;
        }

        return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement(Insertion, {
          cache: cache,
          serialized: serialized,
          isStringTag: typeof FinalTag === 'string'
        }), /*#__PURE__*/React__namespace.createElement(FinalTag, newProps));
      });
      Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
      Styled.defaultProps = tag.defaultProps;
      Styled.__emotion_real = Styled;
      Styled.__emotion_base = baseTag;
      Styled.__emotion_styles = styles;
      Styled.__emotion_forwardProp = shouldForwardProp;
      Object.defineProperty(Styled, 'toString', {
        value: function value() {

          return "." + targetClassName;
        }
      });

      Styled.withComponent = function (nextTag, nextOptions) {
        var newStyled = createStyled(nextTag, _extends$1({}, options, nextOptions, {
          shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
        }));
        return newStyled.apply(void 0, styles);
      };

      return Styled;
    };
  };

  var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
  'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

  // bind it to avoid mutating the original function
  var styled$2 = createStyled.bind(null);
  tags.forEach(function (tagName) {
    styled$2[tagName] = styled$2(tagName);
  });

  const allPropNames$1 = /* @__PURE__ */ new Set([
    ...propNames$1,
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
  ]);
  const validHTMLProps$1 = /* @__PURE__ */ new Set([
    "htmlWidth",
    "htmlHeight",
    "htmlSize",
    "htmlTranslate"
  ]);
  function shouldForwardProp$1(prop) {
    return (validHTMLProps$1.has(prop) || !allPropNames$1.has(prop)) && prop[0] !== "_";
  }

  const emotion_styled = interopDefault(styled$2);
  const toCSSObject$1 = ({ baseStyle }) => (props) => {
    const { theme, css: cssProp, __css, sx, ...restProps } = props;
    const [styleProps] = splitProps(restProps, isStyleProp$1);
    const finalBaseStyle = runIfFn$3(baseStyle, props);
    const finalStyles = assignAfter(
      {},
      __css,
      finalBaseStyle,
      compact(styleProps),
      sx
    );
    const computedCSS = css$3(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
  function styled$1(component, options) {
    const { baseStyle, ...styledOptions } = options ?? {};
    if (!styledOptions.shouldForwardProp) {
      styledOptions.shouldForwardProp = shouldForwardProp$1;
    }
    const styleObject = toCSSObject$1({ baseStyle });
    const Component = emotion_styled(
      component,
      styledOptions
    )(styleObject);
    const chakraComponent = React.forwardRef(
      function ChakraComponent2(props, ref) {
        const { children, ...restProps } = props;
        const { colorMode, forced } = useColorMode$1();
        const dataTheme = forced ? colorMode : void 0;
        return React.createElement(
          Component,
          { ref, "data-theme": dataTheme, ...restProps },
          children
        );
      }
    );
    return chakraComponent;
  }

  function factory$1() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy(styled$1, {
      /**
       * @example
       * const Div = chakra("div")
       * const WithChakra = chakra(AnotherComponent)
       */
      apply(target, thisArg, argArray) {
        return styled$1(...argArray);
      },
      /**
       * @example
       * <chakra.div />
       */
      get(_, element) {
        if (!cache.has(element)) {
          cache.set(element, styled$1(element));
        }
        return cache.get(element);
      }
    });
  }
  const chakra$1 = factory$1();

  const toastMotionVariants = {
    initial: (props) => {
      const { position } = props;
      const dir = ["top", "bottom"].includes(position) ? "y" : "x";
      let factor = ["top-right", "bottom-right"].includes(position) ? 1 : -1;
      if (position === "bottom")
        factor = 1;
      return {
        opacity: 0,
        [dir]: factor * 24
      };
    },
    animate: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: [0.4, 0, 0.2, 1]
      }
    },
    exit: {
      opacity: 0,
      scale: 0.85,
      transition: {
        duration: 0.2,
        ease: [0.4, 0, 1, 1]
      }
    }
  };
  const ToastComponent = React.memo((props) => {
    const {
      id,
      message,
      onCloseComplete,
      onRequestRemove,
      requestClose = false,
      position = "bottom",
      duration = 5e3,
      containerStyle,
      motionVariants = toastMotionVariants,
      toastSpacing = "0.5rem"
    } = props;
    const [delay, setDelay] = React.useState(duration);
    const isPresent = useIsPresent();
    useUpdateEffect(() => {
      if (!isPresent) {
        onCloseComplete?.();
      }
    }, [isPresent]);
    useUpdateEffect(() => {
      setDelay(duration);
    }, [duration]);
    const onMouseEnter = () => setDelay(null);
    const onMouseLeave = () => setDelay(duration);
    const close = () => {
      if (isPresent)
        onRequestRemove();
    };
    React.useEffect(() => {
      if (isPresent && requestClose) {
        onRequestRemove();
      }
    }, [isPresent, requestClose, onRequestRemove]);
    useTimeout(close, delay);
    const containerStyles = React.useMemo(
      () => ({
        pointerEvents: "auto",
        maxWidth: 560,
        minWidth: 300,
        margin: toastSpacing,
        ...containerStyle
      }),
      [containerStyle, toastSpacing]
    );
    const toastStyle = React.useMemo(() => getToastStyle(position), [position]);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      motion.div,
      {
        layout: true,
        className: "chakra-toast",
        variants: motionVariants,
        initial: "initial",
        animate: "animate",
        exit: "exit",
        onHoverStart: onMouseEnter,
        onHoverEnd: onMouseLeave,
        custom: { position },
        style: toastStyle,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          chakra$1.div,
          {
            role: "status",
            "aria-atomic": "true",
            className: "chakra-toast__inner",
            __css: containerStyles,
            children: runIfFn$3(message, { id, onClose: close })
          }
        )
      }
    );
  });
  ToastComponent.displayName = "ToastComponent";

  function forwardRef$1(component) {
    return React.forwardRef(component);
  }

  /* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

  var reactFastCompare;
  var hasRequiredReactFastCompare;

  function requireReactFastCompare () {
  	if (hasRequiredReactFastCompare) return reactFastCompare;
  	hasRequiredReactFastCompare = 1;
  	var hasElementType = typeof Element !== 'undefined';
  	var hasMap = typeof Map === 'function';
  	var hasSet = typeof Set === 'function';
  	var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

  	// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

  	function equal(a, b) {
  	  // START: fast-deep-equal es6/index.js 3.1.3
  	  if (a === b) return true;

  	  if (a && b && typeof a == 'object' && typeof b == 'object') {
  	    if (a.constructor !== b.constructor) return false;

  	    var length, i, keys;
  	    if (Array.isArray(a)) {
  	      length = a.length;
  	      if (length != b.length) return false;
  	      for (i = length; i-- !== 0;)
  	        if (!equal(a[i], b[i])) return false;
  	      return true;
  	    }

  	    // START: Modifications:
  	    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
  	    //    to co-exist with es5.
  	    // 2. Replace `for of` with es5 compliant iteration using `for`.
  	    //    Basically, take:
  	    //
  	    //    ```js
  	    //    for (i of a.entries())
  	    //      if (!b.has(i[0])) return false;
  	    //    ```
  	    //
  	    //    ... and convert to:
  	    //
  	    //    ```js
  	    //    it = a.entries();
  	    //    while (!(i = it.next()).done)
  	    //      if (!b.has(i.value[0])) return false;
  	    //    ```
  	    //
  	    //    **Note**: `i` access switches to `i.value`.
  	    var it;
  	    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
  	      if (a.size !== b.size) return false;
  	      it = a.entries();
  	      while (!(i = it.next()).done)
  	        if (!b.has(i.value[0])) return false;
  	      it = a.entries();
  	      while (!(i = it.next()).done)
  	        if (!equal(i.value[1], b.get(i.value[0]))) return false;
  	      return true;
  	    }

  	    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
  	      if (a.size !== b.size) return false;
  	      it = a.entries();
  	      while (!(i = it.next()).done)
  	        if (!b.has(i.value[0])) return false;
  	      return true;
  	    }
  	    // END: Modifications

  	    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
  	      length = a.length;
  	      if (length != b.length) return false;
  	      for (i = length; i-- !== 0;)
  	        if (a[i] !== b[i]) return false;
  	      return true;
  	    }

  	    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
  	    // START: Modifications:
  	    // Apply guards for `Object.create(null)` handling. See:
  	    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
  	    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
  	    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
  	    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
  	    // END: Modifications

  	    keys = Object.keys(a);
  	    length = keys.length;
  	    if (length !== Object.keys(b).length) return false;

  	    for (i = length; i-- !== 0;)
  	      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
  	    // END: fast-deep-equal

  	    // START: react-fast-compare
  	    // custom handling for DOM elements
  	    if (hasElementType && a instanceof Element) return false;

  	    // custom handling for React/Preact
  	    for (i = length; i-- !== 0;) {
  	      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
  	        // React-specific: avoid traversing React elements' _owner
  	        // Preact-specific: avoid traversing Preact elements' __v and __o
  	        //    __v = $_original / $_vnode
  	        //    __o = $_owner
  	        // These properties contain circular references and are not needed when
  	        // comparing the actual elements (and not their owners)
  	        // .$$typeof and ._store on just reasonable markers of elements

  	        continue;
  	      }

  	      // all other properties should be traversed as usual
  	      if (!equal(a[keys[i]], b[keys[i]])) return false;
  	    }
  	    // END: react-fast-compare

  	    // START: fast-deep-equal
  	    return true;
  	  }

  	  return a !== a && b !== b;
  	}
  	// end fast-deep-equal

  	reactFastCompare = function isEqual(a, b) {
  	  try {
  	    return equal(a, b);
  	  } catch (error) {
  	    if (((error.message || '').match(/stack|recursion/i))) {
  	      // warn on circular references, don't crash
  	      // browsers give this different errors name and messages:
  	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
  	      // firefox: "InternalError", too much recursion"
  	      // edge: "Error", "Out of stack space"
  	      console.warn('react-fast-compare cannot handle circular refs');
  	      return false;
  	    }
  	    // some other error. we should definitely know about these
  	    throw error;
  	  }
  	};
  	return reactFastCompare;
  }

  var reactFastCompareExports = requireReactFastCompare();
  var isEqual$4 = /*@__PURE__*/getDefaultExportFromCjs(reactFastCompareExports);

  function useTheme() {
    const theme = React.useContext(
      ThemeContext
    );
    if (!theme) {
      throw Error(
        "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
      );
    }
    return theme;
  }

  function useChakra() {
    const colorModeResult = useColorMode$1();
    const theme = useTheme();
    return { ...colorModeResult, theme };
  }

  function omitReactElements(props) {
    return Object.fromEntries(
      Object.entries(props).filter(([key, value]) => {
        return value !== void 0 && key !== "children" && !React.isValidElement(value);
      })
    );
  }
  function useStyleConfigImpl(themeKey, props = {}) {
    const { styleConfig: styleConfigProp, ...rest } = props;
    const { theme, colorMode } = useChakra();
    const themeStyleConfig = themeKey ? memoizedGet$2(theme, `components.${themeKey}`) : void 0;
    const styleConfig = styleConfigProp || themeStyleConfig;
    const mergedProps = mergeWith(
      { theme, colorMode },
      styleConfig?.defaultProps ?? {},
      omitReactElements(rest),
      (obj, src) => !obj ? src : void 0
    );
    const stylesRef = React.useRef({});
    if (styleConfig) {
      const getStyles = resolveStyleConfig(styleConfig);
      const styles = getStyles(mergedProps);
      const isStyleEqual = isEqual$4(stylesRef.current, styles);
      if (!isStyleEqual) {
        stylesRef.current = styles;
      }
    }
    return stylesRef.current;
  }
  function useStyleConfig(themeKey, props = {}) {
    return useStyleConfigImpl(themeKey, props);
  }
  function useMultiStyleConfig(themeKey, props = {}) {
    return useStyleConfigImpl(themeKey, props);
  }

  const fallbackIcon$1 = {
    path: /* @__PURE__ */ jsxRuntimeExports.jsxs("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          strokeLinecap: "round",
          fill: "none",
          d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx(
        "path",
        {
          fill: "currentColor",
          strokeLinecap: "round",
          d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
        }
      ),
      /* @__PURE__ */ jsxRuntimeExports.jsx("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
    ] }),
    viewBox: "0 0 24 24"
  };
  const Icon$1 = forwardRef$1((props, ref) => {
    const {
      as: element,
      viewBox,
      color = "currentColor",
      focusable = false,
      children,
      className,
      __css,
      ...rest
    } = props;
    const _className = cx$1("chakra-icon", className);
    const customStyles = useStyleConfig("Icon", props);
    const styles = {
      w: "1em",
      h: "1em",
      display: "inline-block",
      lineHeight: "1em",
      flexShrink: 0,
      color,
      ...__css,
      ...customStyles
    };
    const shared = {
      ref,
      focusable,
      className: _className,
      __css: styles
    };
    const _viewBox = viewBox ?? fallbackIcon$1.viewBox;
    if (element && typeof element !== "string") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.svg, { as: element, ...shared, ...rest });
    }
    const _path = children ?? fallbackIcon$1.path;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.svg, { verticalAlign: "middle", viewBox: _viewBox, ...shared, ...rest, children: _path });
  });
  Icon$1.displayName = "Icon";

  function CheckIcon$1(props) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
      }
    ) });
  }
  function InfoIcon(props) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
      }
    ) });
  }
  function WarningIcon(props) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z"
      }
    ) });
  }

  const spin = keyframes$2({
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(360deg)"
    }
  });
  const Spinner = forwardRef$1((props, ref) => {
    const styles = useStyleConfig("Spinner", props);
    const {
      label = "Loading...",
      thickness = "2px",
      speed = "0.45s",
      emptyColor = "transparent",
      className,
      ...rest
    } = omitThemingProps(props);
    const _className = cx$1("chakra-spinner", className);
    const spinnerStyles = {
      display: "inline-block",
      borderColor: "currentColor",
      borderStyle: "solid",
      borderRadius: "99999px",
      borderWidth: thickness,
      borderBottomColor: emptyColor,
      borderLeftColor: emptyColor,
      animation: `${spin} ${speed} linear infinite`,
      ...styles
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        ref,
        __css: spinnerStyles,
        className: _className,
        ...rest,
        children: label && /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.span, { srOnly: true, children: label })
      }
    );
  });
  Spinner.displayName = "Spinner";

  const [AlertProvider, useAlertContext] = createContext$1({
    name: "AlertContext",
    hookName: "useAlertContext",
    providerName: "<Alert />"
  });
  const [AlertStylesProvider, useAlertStyles] = createContext$1({
    name: `AlertStylesContext`,
    hookName: `useAlertStyles`,
    providerName: "<Alert />"
  });
  const STATUSES = {
    info: { icon: InfoIcon, colorScheme: "blue" },
    warning: { icon: WarningIcon, colorScheme: "orange" },
    success: { icon: CheckIcon$1, colorScheme: "green" },
    error: { icon: WarningIcon, colorScheme: "red" },
    loading: { icon: Spinner, colorScheme: "blue" }
  };
  function getStatusColorScheme(status) {
    return STATUSES[status].colorScheme;
  }
  function getStatusIcon$1(status) {
    return STATUSES[status].icon;
  }

  const Alert = forwardRef$1(function Alert2(props, ref) {
    const { status = "info", addRole = true, ...rest } = omitThemingProps(props);
    const colorScheme = props.colorScheme ?? getStatusColorScheme(status);
    const styles = useMultiStyleConfig("Alert", { ...props, colorScheme });
    const alertStyles = defineStyle({
      width: "100%",
      display: "flex",
      alignItems: "center",
      position: "relative",
      overflow: "hidden",
      ...styles.container
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(AlertProvider, { value: { status }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AlertStylesProvider, { value: styles, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        "data-status": status,
        role: addRole ? "alert" : void 0,
        ref,
        ...rest,
        className: cx$1("chakra-alert", props.className),
        __css: alertStyles
      }
    ) }) });
  });
  Alert.displayName = "Alert";

  function AlertIcon$1(props) {
    const { status } = useAlertContext();
    const BaseIcon = getStatusIcon$1(status);
    const styles = useAlertStyles();
    const css = status === "loading" ? styles.spinner : styles.icon;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.span,
      {
        display: "inherit",
        "data-status": status,
        ...props,
        className: cx$1("chakra-alert__icon", props.className),
        __css: css,
        children: props.children || /* @__PURE__ */ jsxRuntimeExports.jsx(BaseIcon, { h: "100%", w: "100%" })
      }
    );
  }
  AlertIcon$1.displayName = "AlertIcon";

  const AlertTitle = forwardRef$1(
    function AlertTitle2(props, ref) {
      const styles = useAlertStyles();
      const { status } = useAlertContext();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ref,
          "data-status": status,
          ...props,
          className: cx$1("chakra-alert__title", props.className),
          __css: styles.title
        }
      );
    }
  );
  AlertTitle.displayName = "AlertTitle";

  const AlertDescription = forwardRef$1(
    function AlertDescription2(props, ref) {
      const { status } = useAlertContext();
      const styles = useAlertStyles();
      const descriptionStyles = defineStyle({
        display: "inline",
        ...styles.description
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ref,
          "data-status": status,
          ...props,
          className: cx$1("chakra-alert__desc", props.className),
          __css: descriptionStyles
        }
      );
    }
  );
  AlertDescription.displayName = "AlertDescription";

  function CloseIcon(props) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Icon$1, { focusable: "false", "aria-hidden": true, ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      "path",
      {
        fill: "currentColor",
        d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
      }
    ) });
  }
  const CloseButton = forwardRef$1(
    function CloseButton2(props, ref) {
      const styles = useStyleConfig("CloseButton", props);
      const { children, isDisabled, __css, ...rest } = omitThemingProps(props);
      const baseStyle = {
        outline: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.button,
        {
          type: "button",
          "aria-label": "Close",
          ref,
          disabled: isDisabled,
          __css: {
            ...baseStyle,
            ...styles,
            ...__css
          },
          ...rest,
          children: children || /* @__PURE__ */ jsxRuntimeExports.jsx(CloseIcon, { width: "1em", height: "1em" })
        }
      );
    }
  );
  CloseButton.displayName = "CloseButton";

  const Toast = (props) => {
    const {
      status,
      variant = "solid",
      id,
      title,
      isClosable,
      onClose,
      description,
      colorScheme,
      icon
    } = props;
    const ids = id ? {
      root: `toast-${id}`,
      title: `toast-${id}-title`,
      description: `toast-${id}-description`
    } : void 0;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      Alert,
      {
        addRole: false,
        status,
        variant,
        id: ids?.root,
        alignItems: "start",
        borderRadius: "md",
        boxShadow: "lg",
        paddingEnd: 8,
        textAlign: "start",
        width: "auto",
        colorScheme,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(AlertIcon$1, { children: icon }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(chakra$1.div, { flex: "1", maxWidth: "100%", children: [
            title && /* @__PURE__ */ jsxRuntimeExports.jsx(AlertTitle, { id: ids?.title, children: title }),
            description && /* @__PURE__ */ jsxRuntimeExports.jsx(AlertDescription, { id: ids?.description, display: "block", children: description })
          ] }),
          isClosable && /* @__PURE__ */ jsxRuntimeExports.jsx(
            CloseButton,
            {
              size: "sm",
              onClick: onClose,
              position: "absolute",
              insetEnd: 1,
              top: 1
            }
          )
        ]
      }
    );
  };
  function createRenderToast(options = {}) {
    const { render, toastComponent: ToastComponent = Toast } = options;
    const renderToast = (props) => {
      if (typeof render === "function") {
        return render({ ...props, ...options });
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ToastComponent, { ...props, ...options });
    };
    return renderToast;
  }

  const initialState = {
    top: [],
    "top-left": [],
    "top-right": [],
    "bottom-left": [],
    bottom: [],
    "bottom-right": []
  };
  const toastStore = createStore(initialState);
  function createStore(initialState2) {
    let state = initialState2;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (setStateFn) => {
      state = setStateFn(state);
      listeners.forEach((l) => l());
    };
    return {
      getState: () => state,
      subscribe: (listener) => {
        listeners.add(listener);
        return () => {
          setState(() => initialState2);
          listeners.delete(listener);
        };
      },
      /**
       * Delete a toast record at its position
       */
      removeToast: (id, position) => {
        setState((prevState) => ({
          ...prevState,
          // id may be string or number
          // eslint-disable-next-line eqeqeq
          [position]: prevState[position].filter((toast) => toast.id != id)
        }));
      },
      notify: (message, options) => {
        const toast = createToast(message, options);
        const { position, id } = toast;
        setState((prevToasts) => {
          const isTop = position.includes("top");
          const toasts = isTop ? [toast, ...prevToasts[position] ?? []] : [...prevToasts[position] ?? [], toast];
          return {
            ...prevToasts,
            [position]: toasts
          };
        });
        return id;
      },
      update: (id, options) => {
        if (!id)
          return;
        setState((prevState) => {
          const nextState = { ...prevState };
          const { position, index } = findToast(nextState, id);
          if (position && index !== -1) {
            nextState[position][index] = {
              ...nextState[position][index],
              ...options,
              message: createRenderToast(options)
            };
          }
          return nextState;
        });
      },
      closeAll: ({ positions } = {}) => {
        setState((prev) => {
          const allPositions = [
            "bottom",
            "bottom-right",
            "bottom-left",
            "top",
            "top-left",
            "top-right"
          ];
          const positionsToClose = positions ?? allPositions;
          return positionsToClose.reduce(
            (acc, position) => {
              acc[position] = prev[position].map((toast) => ({
                ...toast,
                requestClose: true
              }));
              return acc;
            },
            { ...prev }
          );
        });
      },
      close: (id) => {
        setState((prevState) => {
          const position = getToastPosition(prevState, id);
          if (!position)
            return prevState;
          return {
            ...prevState,
            [position]: prevState[position].map((toast) => {
              if (toast.id == id) {
                return {
                  ...toast,
                  requestClose: true
                };
              }
              return toast;
            })
          };
        });
      },
      isActive: (id) => Boolean(findToast(toastStore.getState(), id).position)
    };
  }
  let counter = 0;
  function createToast(message, options = {}) {
    counter += 1;
    const id = options.id ?? counter;
    const position = options.position ?? "bottom";
    return {
      id,
      message,
      position,
      duration: options.duration,
      onCloseComplete: options.onCloseComplete,
      onRequestRemove: () => toastStore.removeToast(String(id), position),
      status: options.status,
      requestClose: false,
      containerStyle: options.containerStyle
    };
  }

  const [PortalContextProvider, usePortalContext] = createContext$1({
    strict: false,
    name: "PortalContext"
  });
  const PORTAL_CLASSNAME = "chakra-portal";
  const PORTAL_SELECTOR = `.chakra-portal`;
  const Container = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    "div",
    {
      className: "chakra-portal-zIndex",
      style: {
        position: "absolute",
        zIndex: props.zIndex,
        top: 0,
        left: 0,
        right: 0
        // NB: Don't add `bottom: 0`, it makes the entire app unusable
        // @see https://github.com/chakra-ui/chakra-ui/issues/3201
      },
      children: props.children
    }
  );
  const DefaultPortal = (props) => {
    const { appendToParentPortal, children } = props;
    const [tempNode, setTempNode] = React.useState(null);
    const portal = React.useRef(null);
    const [, forceUpdate] = React.useState({});
    React.useEffect(() => forceUpdate({}), []);
    const parentPortal = usePortalContext();
    const manager = usePortalManager();
    useSafeLayoutEffect$2(() => {
      if (!tempNode)
        return;
      const doc = tempNode.ownerDocument;
      const host = appendToParentPortal ? parentPortal ?? doc.body : doc.body;
      if (!host)
        return;
      portal.current = doc.createElement("div");
      portal.current.className = PORTAL_CLASSNAME;
      host.appendChild(portal.current);
      forceUpdate({});
      const portalNode = portal.current;
      return () => {
        if (host.contains(portalNode)) {
          host.removeChild(portalNode);
        }
      };
    }, [tempNode]);
    const _children = manager?.zIndex ? /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { zIndex: manager?.zIndex, children }) : children;
    return portal.current ? ReactDOM.createPortal(
      /* @__PURE__ */ jsxRuntimeExports.jsx(PortalContextProvider, { value: portal.current, children: _children }),
      portal.current
    ) : /* @__PURE__ */ jsxRuntimeExports.jsx(
      "span",
      {
        ref: (el) => {
          if (el)
            setTempNode(el);
        }
      }
    );
  };
  const ContainerPortal = (props) => {
    const { children, containerRef, appendToParentPortal } = props;
    const containerEl = containerRef.current;
    const host = containerEl ?? (typeof window !== "undefined" ? document.body : void 0);
    const portal = React.useMemo(() => {
      const node = containerEl?.ownerDocument.createElement("div");
      if (node)
        node.className = PORTAL_CLASSNAME;
      return node;
    }, [containerEl]);
    const [, forceUpdate] = React.useState({});
    useSafeLayoutEffect$2(() => forceUpdate({}), []);
    useSafeLayoutEffect$2(() => {
      if (!portal || !host)
        return;
      host.appendChild(portal);
      return () => {
        host.removeChild(portal);
      };
    }, [portal, host]);
    if (host && portal) {
      return ReactDOM.createPortal(
        /* @__PURE__ */ jsxRuntimeExports.jsx(PortalContextProvider, { value: appendToParentPortal ? portal : null, children }),
        portal
      );
    }
    return null;
  };
  function Portal(props) {
    const portalProps = {
      appendToParentPortal: true,
      ...props
    };
    const { containerRef, ...rest } = portalProps;
    return containerRef ? /* @__PURE__ */ jsxRuntimeExports.jsx(ContainerPortal, { containerRef, ...rest }) : /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultPortal, { ...rest });
  }
  Portal.className = PORTAL_CLASSNAME;
  Portal.selector = PORTAL_SELECTOR;
  Portal.displayName = "Portal";

  const [ToastOptionProvider] = createContext$1({
    name: `ToastOptionsContext`,
    strict: false
  });
  const ToastProvider = (props) => {
    const state = React.useSyncExternalStore(
      toastStore.subscribe,
      toastStore.getState,
      toastStore.getState
    );
    const {
      motionVariants,
      component: Component = ToastComponent,
      portalProps,
      animatePresenceProps
    } = props;
    const stateKeys = Object.keys(state);
    const toastList = stateKeys.map((position) => {
      const toasts = state[position];
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        "div",
        {
          role: "region",
          "aria-live": "polite",
          "aria-label": `Notifications-${position}`,
          id: `chakra-toast-manager-${position}`,
          style: getToastListStyle(position),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { ...animatePresenceProps, initial: false, children: toasts.map((toast) => /* @__PURE__ */ jsxRuntimeExports.jsx(
            Component,
            {
              motionVariants,
              ...toast
            },
            toast.id
          )) })
        },
        position
      );
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { ...portalProps, children: toastList });
  };

  const createProvider = (providerTheme) => {
    return function ChakraProvider({
      children,
      theme = providerTheme,
      toastOptions,
      ...restProps
    }) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(Provider, { theme, ...restProps, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(ToastOptionProvider, { value: toastOptions?.defaultOptions, children }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(ToastProvider, { ...toastOptions })
      ] });
    };
  };

  const ChakraProvider = createProvider(theme$1);

  function sortNodes(nodes) {
    return nodes.sort((a, b) => {
      const compare = a.compareDocumentPosition(b);
      if (compare & Node.DOCUMENT_POSITION_FOLLOWING || compare & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        return -1;
      }
      if (compare & Node.DOCUMENT_POSITION_PRECEDING || compare & Node.DOCUMENT_POSITION_CONTAINS) {
        return 1;
      }
      if (compare & Node.DOCUMENT_POSITION_DISCONNECTED || compare & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC) {
        throw Error("Cannot sort the given nodes.");
      } else {
        return 0;
      }
    });
  }
  const isElement$2 = (el) => typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
  function getNextIndex(current, max, loop) {
    let next = current + 1;
    if (loop && next >= max)
      next = 0;
    return next;
  }
  function getPrevIndex(current, max, loop) {
    let next = current - 1;
    if (loop && next < 0)
      next = max;
    return next;
  }
  const useSafeLayoutEffect = typeof window !== "undefined" ? React.useLayoutEffect : React.useEffect;
  const cast = (value) => value;

  var __defProp$1 = Object.defineProperty;
  var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField$1 = (obj, key, value) => {
    __defNormalProp$1(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
  };
  class DescendantsManager {
    constructor() {
      __publicField$1(this, "descendants", /* @__PURE__ */ new Map());
      __publicField$1(this, "register", (nodeOrOptions) => {
        if (nodeOrOptions == null)
          return;
        if (isElement$2(nodeOrOptions)) {
          return this.registerNode(nodeOrOptions);
        }
        return (node) => {
          this.registerNode(node, nodeOrOptions);
        };
      });
      __publicField$1(this, "unregister", (node) => {
        this.descendants.delete(node);
        const sorted = sortNodes(Array.from(this.descendants.keys()));
        this.assignIndex(sorted);
      });
      __publicField$1(this, "destroy", () => {
        this.descendants.clear();
      });
      __publicField$1(this, "assignIndex", (descendants) => {
        this.descendants.forEach((descendant) => {
          const index = descendants.indexOf(descendant.node);
          descendant.index = index;
          descendant.node.dataset["index"] = descendant.index.toString();
        });
      });
      __publicField$1(this, "count", () => this.descendants.size);
      __publicField$1(this, "enabledCount", () => this.enabledValues().length);
      __publicField$1(this, "values", () => {
        const values = Array.from(this.descendants.values());
        return values.sort((a, b) => a.index - b.index);
      });
      __publicField$1(this, "enabledValues", () => {
        return this.values().filter((descendant) => !descendant.disabled);
      });
      __publicField$1(this, "item", (index) => {
        if (this.count() === 0)
          return void 0;
        return this.values()[index];
      });
      __publicField$1(this, "enabledItem", (index) => {
        if (this.enabledCount() === 0)
          return void 0;
        return this.enabledValues()[index];
      });
      __publicField$1(this, "first", () => this.item(0));
      __publicField$1(this, "firstEnabled", () => this.enabledItem(0));
      __publicField$1(this, "last", () => this.item(this.descendants.size - 1));
      __publicField$1(this, "lastEnabled", () => {
        const lastIndex = this.enabledValues().length - 1;
        return this.enabledItem(lastIndex);
      });
      __publicField$1(this, "indexOf", (node) => {
        if (!node)
          return -1;
        return this.descendants.get(node)?.index ?? -1;
      });
      __publicField$1(this, "enabledIndexOf", (node) => {
        if (node == null)
          return -1;
        return this.enabledValues().findIndex((i) => i.node.isSameNode(node));
      });
      __publicField$1(this, "next", (index, loop = true) => {
        const next = getNextIndex(index, this.count(), loop);
        return this.item(next);
      });
      __publicField$1(this, "nextEnabled", (index, loop = true) => {
        const item = this.item(index);
        if (!item)
          return;
        const enabledIndex = this.enabledIndexOf(item.node);
        const nextEnabledIndex = getNextIndex(
          enabledIndex,
          this.enabledCount(),
          loop
        );
        return this.enabledItem(nextEnabledIndex);
      });
      __publicField$1(this, "prev", (index, loop = true) => {
        const prev = getPrevIndex(index, this.count() - 1, loop);
        return this.item(prev);
      });
      __publicField$1(this, "prevEnabled", (index, loop = true) => {
        const item = this.item(index);
        if (!item)
          return;
        const enabledIndex = this.enabledIndexOf(item.node);
        const prevEnabledIndex = getPrevIndex(
          enabledIndex,
          this.enabledCount() - 1,
          loop
        );
        return this.enabledItem(prevEnabledIndex);
      });
      __publicField$1(this, "registerNode", (node, options) => {
        if (!node || this.descendants.has(node))
          return;
        const keys = Array.from(this.descendants.keys()).concat(node);
        const sorted = sortNodes(keys);
        if (options?.disabled) {
          options.disabled = !!options.disabled;
        }
        const descendant = { node, index: -1, ...options };
        this.descendants.set(node, descendant);
        this.assignIndex(sorted);
      });
    }
  }

  function createDescendantContext() {
    const [DescendantsContextProvider, useDescendantsContext] = createContext$1({
      name: "DescendantsProvider",
      errorMessage: "useDescendantsContext must be used within DescendantsProvider"
    });
    const useDescendant = (options) => {
      const descendants = useDescendantsContext();
      const [index, setIndex] = React.useState(-1);
      const ref = React.useRef(null);
      useSafeLayoutEffect(() => {
        return () => {
          if (!ref.current)
            return;
          descendants.unregister(ref.current);
        };
      }, []);
      useSafeLayoutEffect(() => {
        if (!ref.current)
          return;
        const dataIndex = Number(ref.current.dataset["index"]);
        if (index != dataIndex && !Number.isNaN(dataIndex)) {
          setIndex(dataIndex);
        }
      });
      const refCallback = options ? cast(descendants.register(options)) : cast(descendants.register);
      return {
        descendants,
        index,
        enabledIndex: descendants.enabledIndexOf(ref.current),
        register: mergeRefs(refCallback, ref)
      };
    };
    const useDescendants = () => {
      const descendants = React.useRef(new DescendantsManager());
      useSafeLayoutEffect(() => {
        return () => descendants.current.destroy();
      });
      return descendants.current;
    };
    return [
      // context provider
      DescendantsContextProvider,
      // call this when you need to read from context
      useDescendantsContext,
      // descendants state information, to be called and passed to `ContextProvider`
      useDescendants,
      // descendant index information
      useDescendant
    ];
  }

  const [AccordionStylesProvider, useAccordionStyles] = createContext$1({
    name: "AccordionStylesContext",
    hookName: "useAccordionStyles",
    providerName: "<Accordion />"
  });
  const [AccordionItemProvider, useAccordionItemContext] = createContext$1({
    name: "AccordionItemContext",
    hookName: "useAccordionItemContext",
    providerName: "<AccordionItem />"
  });
  const [
    AccordionDescendantsProvider,
    useAccordionDescendantsContext,
    useAccordionDescendants,
    useAccordionDescendant
  ] = createDescendantContext();

  function useAccordion(props) {
    const {
      onChange,
      defaultIndex,
      index: indexProp,
      allowMultiple,
      allowToggle,
      ...htmlProps
    } = props;
    allowMultipleWarning(props);
    allowMultipleAndAllowToggleWarning(props);
    const descendants = useAccordionDescendants();
    const [focusedIndex, setFocusedIndex] = React.useState(-1);
    React.useEffect(() => {
      return () => {
        setFocusedIndex(-1);
      };
    }, []);
    const [index, setIndex] = useControllableState({
      value: indexProp,
      defaultValue() {
        if (allowMultiple)
          return defaultIndex ?? [];
        return defaultIndex ?? -1;
      },
      onChange
    });
    const getAccordionItemProps = (idx) => {
      let isOpen = false;
      if (idx !== null) {
        isOpen = Array.isArray(index) ? index.includes(idx) : index === idx;
      }
      const onChange2 = (isOpen2) => {
        if (idx === null)
          return;
        if (allowMultiple && Array.isArray(index)) {
          const nextState = isOpen2 ? index.concat(idx) : index.filter((i) => i !== idx);
          setIndex(nextState);
        } else if (isOpen2) {
          setIndex(idx);
        } else if (allowToggle) {
          setIndex(-1);
        }
      };
      return { isOpen, onChange: onChange2 };
    };
    return {
      index,
      setIndex,
      htmlProps,
      getAccordionItemProps,
      focusedIndex,
      setFocusedIndex,
      descendants
    };
  }
  const [AccordionProvider, useAccordionContext] = createContext$1({
    name: "AccordionContext",
    hookName: "useAccordionContext",
    providerName: "Accordion"
  });
  function useAccordionItem(props) {
    const { isDisabled, isFocusable, id, ...htmlProps } = props;
    const { getAccordionItemProps, setFocusedIndex } = useAccordionContext();
    const buttonRef = React.useRef(null);
    const reactId = React.useId();
    const uid = id ?? reactId;
    const buttonId = `accordion-button-${uid}`;
    const panelId = `accordion-panel-${uid}`;
    focusableNotDisabledWarning(props);
    const { register, index, descendants } = useAccordionDescendant({
      disabled: isDisabled && !isFocusable
    });
    const { isOpen, onChange } = getAccordionItemProps(
      index === -1 ? null : index
    );
    warnIfOpenAndDisabled({ isOpen, isDisabled });
    const onOpen = () => {
      onChange?.(true);
    };
    const onClose = () => {
      onChange?.(false);
    };
    const onClick = React.useCallback(() => {
      onChange?.(!isOpen);
      setFocusedIndex(index);
    }, [index, setFocusedIndex, isOpen, onChange]);
    const onKeyDown = React.useCallback(
      (event) => {
        const keyMap = {
          ArrowDown: () => {
            const next = descendants.nextEnabled(index);
            next?.node.focus();
          },
          ArrowUp: () => {
            const prev = descendants.prevEnabled(index);
            prev?.node.focus();
          },
          Home: () => {
            const first = descendants.firstEnabled();
            first?.node.focus();
          },
          End: () => {
            const last = descendants.lastEnabled();
            last?.node.focus();
          }
        };
        const action = keyMap[event.key];
        if (action) {
          event.preventDefault();
          action(event);
        }
      },
      [descendants, index]
    );
    const onFocus = React.useCallback(() => {
      setFocusedIndex(index);
    }, [setFocusedIndex, index]);
    const getButtonProps = React.useCallback(
      function getButtonProps2(props2 = {}, ref = null) {
        return {
          ...props2,
          type: "button",
          ref: mergeRefs(register, buttonRef, ref),
          id: buttonId,
          disabled: !!isDisabled,
          "aria-expanded": !!isOpen,
          "aria-controls": panelId,
          onClick: callAllHandlers(props2.onClick, onClick),
          onFocus: callAllHandlers(props2.onFocus, onFocus),
          onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown)
        };
      },
      [
        buttonId,
        isDisabled,
        isOpen,
        onClick,
        onFocus,
        onKeyDown,
        panelId,
        register
      ]
    );
    const getPanelProps = React.useCallback(
      function getPanelProps2(props2 = {}, ref = null) {
        return {
          ...props2,
          ref,
          role: "region",
          id: panelId,
          "aria-labelledby": buttonId,
          hidden: !isOpen
        };
      },
      [buttonId, isOpen, panelId]
    );
    return {
      isOpen,
      isDisabled,
      isFocusable,
      onOpen,
      onClose,
      getButtonProps,
      getPanelProps,
      htmlProps
    };
  }
  function allowMultipleWarning(props) {
    const index = props.index || props.defaultIndex;
    const condition = index != null && !Array.isArray(index) && props.allowMultiple;
    warn({
      condition: !!condition,
      message: `If 'allowMultiple' is passed, then 'index' or 'defaultIndex' must be an array. You passed: ${typeof index},`
    });
  }
  function allowMultipleAndAllowToggleWarning(props) {
    warn({
      condition: !!(props.allowMultiple && props.allowToggle),
      message: `If 'allowMultiple' is passed, 'allowToggle' will be ignored. Either remove 'allowToggle' or 'allowMultiple' depending on whether you want multiple accordions visible or not`
    });
  }
  function focusableNotDisabledWarning(props) {
    warn({
      condition: !!(props.isFocusable && !props.isDisabled),
      message: `Using only 'isFocusable', this prop is reserved for situations where you pass 'isDisabled' but you still want the element to receive focus (A11y). Either remove it or pass 'isDisabled' as well.
    `
    });
  }
  function warnIfOpenAndDisabled(props) {
    warn({
      condition: props.isOpen && !!props.isDisabled,
      message: "Cannot open a disabled accordion item"
    });
  }

  const Accordion = forwardRef$1(function Accordion2({ children, reduceMotion, ...props }, ref) {
    const styles = useMultiStyleConfig("Accordion", props);
    const ownProps = omitThemingProps(props);
    const { htmlProps, descendants, ...context } = useAccordion(ownProps);
    const ctx = React.useMemo(
      () => ({ ...context, reduceMotion: !!reduceMotion }),
      [context, reduceMotion]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionDescendantsProvider, { value: descendants, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionProvider, { value: ctx, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionStylesProvider, { value: styles, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        ref,
        ...htmlProps,
        className: cx$1("chakra-accordion", props.className),
        __css: styles.root,
        children
      }
    ) }) }) });
  });
  Accordion.displayName = "Accordion";

  const AccordionButton = forwardRef$1(
    function AccordionButton2(props, ref) {
      const { getButtonProps } = useAccordionItemContext();
      const buttonProps = getButtonProps(props, ref);
      const styles = useAccordionStyles();
      const buttonStyles = {
        display: "flex",
        alignItems: "center",
        width: "100%",
        outline: 0,
        ...styles.button
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.button,
        {
          ...buttonProps,
          className: cx$1("chakra-accordion__button", props.className),
          __css: buttonStyles
        }
      );
    }
  );
  AccordionButton.displayName = "AccordionButton";

  function AccordionIcon(props) {
    const { isOpen, isDisabled } = useAccordionItemContext();
    const { reduceMotion } = useAccordionContext();
    const _className = cx$1("chakra-accordion__icon", props.className);
    const styles = useAccordionStyles();
    const iconStyles = {
      opacity: isDisabled ? 0.4 : 1,
      transform: isOpen ? "rotate(-180deg)" : void 0,
      transition: reduceMotion ? void 0 : "transform 0.2s",
      transformOrigin: "center",
      ...styles.icon
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      Icon$1,
      {
        viewBox: "0 0 24 24",
        "aria-hidden": true,
        className: _className,
        __css: iconStyles,
        ...props,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
          }
        )
      }
    );
  }
  AccordionIcon.displayName = "AccordionIcon";

  const AccordionItem = forwardRef$1(
    function AccordionItem2(props, ref) {
      const { children, className } = props;
      const { htmlProps, ...context } = useAccordionItem(props);
      const styles = useAccordionStyles();
      const containerStyles = defineStyle({
        ...styles.container,
        overflowAnchor: "none"
      });
      const ctx = React.useMemo(() => context, [context]);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AccordionItemProvider, { value: ctx, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ref,
          ...htmlProps,
          className: cx$1("chakra-accordion__item", className),
          __css: containerStyles,
          children: typeof children === "function" ? children({
            isExpanded: !!context.isOpen,
            isDisabled: !!context.isDisabled
          }) : children
        }
      ) });
    }
  );
  AccordionItem.displayName = "AccordionItem";

  const TRANSITION_EASINGS = {
    ease: [0.25, 0.1, 0.25, 1],
    easeIn: [0.4, 0, 1, 1],
    easeOut: [0, 0, 0.2, 1],
    easeInOut: [0.4, 0, 0.2, 1]
  };
  const TRANSITION_VARIANTS = {
    slideLeft: {
      position: { left: 0, top: 0, bottom: 0, width: "100%" },
      enter: { x: 0, y: 0 },
      exit: { x: "-100%", y: 0 }
    },
    slideRight: {
      position: { right: 0, top: 0, bottom: 0, width: "100%" },
      enter: { x: 0, y: 0 },
      exit: { x: "100%", y: 0 }
    },
    slideUp: {
      position: { top: 0, left: 0, right: 0, maxWidth: "100vw" },
      enter: { x: 0, y: 0 },
      exit: { x: 0, y: "-100%" }
    },
    slideDown: {
      position: { bottom: 0, left: 0, right: 0, maxWidth: "100vw" },
      enter: { x: 0, y: 0 },
      exit: { x: 0, y: "100%" }
    }
  };
  function getSlideTransition(options) {
    const side = options?.direction ?? "right";
    switch (side) {
      case "right":
        return TRANSITION_VARIANTS.slideRight;
      case "left":
        return TRANSITION_VARIANTS.slideLeft;
      case "bottom":
        return TRANSITION_VARIANTS.slideDown;
      case "top":
        return TRANSITION_VARIANTS.slideUp;
      default:
        return TRANSITION_VARIANTS.slideRight;
    }
  }
  const TRANSITION_DEFAULTS = {
    enter: {
      duration: 0.2,
      ease: TRANSITION_EASINGS.easeOut
    },
    exit: {
      duration: 0.1,
      ease: TRANSITION_EASINGS.easeIn
    }
  };
  const withDelay = {
    enter: (transition, delay) => ({
      ...transition,
      delay: typeof delay === "number" ? delay : delay?.["enter"]
    }),
    exit: (transition, delay) => ({
      ...transition,
      delay: typeof delay === "number" ? delay : delay?.["exit"]
    })
  };

  const isNumeric = (value) => value != null && parseInt(value.toString(), 10) > 0;
  const defaultTransitions = {
    exit: {
      height: { duration: 0.2, ease: TRANSITION_EASINGS.ease },
      opacity: { duration: 0.3, ease: TRANSITION_EASINGS.ease }
    },
    enter: {
      height: { duration: 0.3, ease: TRANSITION_EASINGS.ease },
      opacity: { duration: 0.4, ease: TRANSITION_EASINGS.ease }
    }
  };
  const variants$2 = {
    exit: ({
      animateOpacity,
      startingHeight,
      transition,
      transitionEnd,
      delay
    }) => ({
      ...animateOpacity && { opacity: isNumeric(startingHeight) ? 1 : 0 },
      height: startingHeight,
      transitionEnd: transitionEnd?.exit,
      transition: transition?.exit ?? withDelay.exit(defaultTransitions.exit, delay)
    }),
    enter: ({
      animateOpacity,
      endingHeight,
      transition,
      transitionEnd,
      delay
    }) => ({
      ...animateOpacity && { opacity: 1 },
      height: endingHeight,
      transitionEnd: transitionEnd?.enter,
      transition: transition?.enter ?? withDelay.enter(defaultTransitions.enter, delay)
    })
  };
  const Collapse = React.forwardRef(
    (props, ref) => {
      const {
        in: isOpen,
        unmountOnExit,
        animateOpacity = true,
        startingHeight = 0,
        endingHeight = "auto",
        style,
        className,
        transition,
        transitionEnd,
        animatePresenceProps,
        ...rest
      } = props;
      const [mounted, setMounted] = React.useState(false);
      React.useEffect(() => {
        const timeout = setTimeout(() => {
          setMounted(true);
        });
        return () => clearTimeout(timeout);
      }, []);
      warn({
        condition: Number(startingHeight) > 0 && !!unmountOnExit,
        message: `startingHeight and unmountOnExit are mutually exclusive. You can't use them together`
      });
      const hasStartingHeight = parseFloat(startingHeight.toString()) > 0;
      const custom = {
        startingHeight,
        endingHeight,
        animateOpacity,
        transition: !mounted ? { enter: { duration: 0 } } : transition,
        transitionEnd: {
          enter: transitionEnd?.enter,
          exit: unmountOnExit ? transitionEnd?.exit : {
            ...transitionEnd?.exit,
            display: hasStartingHeight ? "block" : "none"
          }
        }
      };
      const show = unmountOnExit ? isOpen : true;
      const animate = isOpen || unmountOnExit ? "enter" : "exit";
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        AnimatePresence,
        {
          ...animatePresenceProps,
          initial: false,
          custom,
          children: show && /* @__PURE__ */ jsxRuntimeExports.jsx(
            motion.div,
            {
              ref,
              ...rest,
              className: cx$1("chakra-collapse", className),
              style: {
                overflow: "hidden",
                display: "block",
                ...style
              },
              custom,
              variants: variants$2,
              initial: unmountOnExit ? "exit" : false,
              animate,
              exit: "exit"
            }
          )
        }
      );
    }
  );
  Collapse.displayName = "Collapse";

  const AccordionPanel = forwardRef$1(
    function AccordionPanel2(props, ref) {
      const { className, motionProps, ...rest } = props;
      const { reduceMotion } = useAccordionContext();
      const { getPanelProps, isOpen } = useAccordionItemContext();
      const panelProps = getPanelProps(rest, ref);
      const _className = cx$1("chakra-accordion__panel", className);
      const styles = useAccordionStyles();
      if (!reduceMotion) {
        delete panelProps.hidden;
      }
      const child = /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { ...panelProps, __css: styles.panel, className: _className });
      if (!reduceMotion) {
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Collapse, { in: isOpen, ...motionProps, children: child });
      }
      return child;
    }
  );
  AccordionPanel.displayName = "AccordionPanel";

  const [AvatarStylesProvider, useAvatarStyles] = createContext$1({
    name: `AvatarStylesContext`,
    hookName: `useAvatarStyles`,
    providerName: "<Avatar/>"
  });

  function initials(name) {
    const names = name.trim().split(" ");
    const firstName = names[0] ?? "";
    const lastName = names.length > 1 ? names[names.length - 1] : "";
    return firstName && lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
  }
  function AvatarName(props) {
    const { name, getInitials, ...rest } = props;
    const styles = useAvatarStyles();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { role: "img", "aria-label": name, ...rest, __css: styles.label, children: name ? getInitials?.(name) : null });
  }
  AvatarName.displayName = "AvatarName";

  const GenericAvatarIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsxs(
    chakra$1.svg,
    {
      viewBox: "0 0 128 128",
      color: "#fff",
      width: "100%",
      height: "100%",
      className: "chakra-avatar__svg",
      ...props,
      children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
          }
        ),
        /* @__PURE__ */ jsxRuntimeExports.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
          }
        )
      ]
    }
  );

  function useImage(props) {
    const {
      loading,
      src,
      srcSet,
      onLoad,
      onError,
      crossOrigin,
      sizes,
      ignoreFallback
    } = props;
    const [status, setStatus] = React.useState("pending");
    React.useEffect(() => {
      setStatus(src ? "loading" : "pending");
    }, [src]);
    const imageRef = React.useRef(null);
    const load = React.useCallback(() => {
      if (!src)
        return;
      flush();
      const img = new Image();
      img.src = src;
      if (crossOrigin)
        img.crossOrigin = crossOrigin;
      if (srcSet)
        img.srcset = srcSet;
      if (sizes)
        img.sizes = sizes;
      if (loading)
        img.loading = loading;
      img.onload = (event) => {
        flush();
        setStatus("loaded");
        onLoad?.(event);
      };
      img.onerror = (error) => {
        flush();
        setStatus("failed");
        onError?.(error);
      };
      imageRef.current = img;
    }, [src, crossOrigin, srcSet, sizes, onLoad, onError, loading]);
    const flush = () => {
      if (imageRef.current) {
        imageRef.current.onload = null;
        imageRef.current.onerror = null;
        imageRef.current = null;
      }
    };
    useSafeLayoutEffect$2(() => {
      if (ignoreFallback)
        return void 0;
      if (status === "loading") {
        load();
      }
      return () => {
        flush();
      };
    }, [status, load, ignoreFallback]);
    return ignoreFallback ? "loaded" : status;
  }

  function AvatarImage(props) {
    const {
      src,
      srcSet,
      onError,
      onLoad,
      getInitials,
      name,
      borderRadius,
      loading,
      iconLabel,
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(GenericAvatarIcon, {}),
      ignoreFallback,
      referrerPolicy,
      crossOrigin
    } = props;
    const status = useImage({ src, onError, crossOrigin, ignoreFallback });
    const hasLoaded = status === "loaded";
    const showFallback = !src || !hasLoaded;
    if (showFallback) {
      return name ? /* @__PURE__ */ jsxRuntimeExports.jsx(
        AvatarName,
        {
          className: "chakra-avatar__initials",
          getInitials,
          name
        }
      ) : React.cloneElement(icon, {
        role: "img",
        "aria-label": iconLabel
      });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.img,
      {
        src,
        srcSet,
        alt: name ?? iconLabel,
        onLoad,
        referrerPolicy,
        crossOrigin: crossOrigin ?? void 0,
        className: "chakra-avatar__img",
        loading,
        __css: {
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius
        }
      }
    );
  }
  AvatarImage.displayName = "AvatarImage";

  const baseStyle = defineStyle({
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    textTransform: "uppercase",
    fontWeight: "medium",
    position: "relative",
    flexShrink: 0
  });
  const Avatar = forwardRef$1((props, ref) => {
    const styles = useMultiStyleConfig("Avatar", props);
    const [isLoaded, setIsLoaded] = React.useState(false);
    const {
      src,
      srcSet,
      name,
      showBorder,
      borderRadius = "full",
      onError,
      onLoad: onLoadProp,
      getInitials = initials,
      icon = /* @__PURE__ */ jsxRuntimeExports.jsx(GenericAvatarIcon, {}),
      iconLabel = " avatar",
      loading,
      children,
      borderColor,
      ignoreFallback,
      crossOrigin,
      referrerPolicy,
      ...rest
    } = omitThemingProps(props);
    const avatarStyles = {
      borderRadius,
      borderWidth: showBorder ? "2px" : void 0,
      ...baseStyle,
      ...styles.container
    };
    if (borderColor) {
      avatarStyles.borderColor = borderColor;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.span,
      {
        ref,
        ...rest,
        className: cx$1("chakra-avatar", props.className),
        "data-loaded": dataAttr(isLoaded),
        __css: avatarStyles,
        children: /* @__PURE__ */ jsxRuntimeExports.jsxs(AvatarStylesProvider, { value: styles, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            AvatarImage,
            {
              src,
              srcSet,
              loading,
              onLoad: callAllHandlers(onLoadProp, () => {
                setIsLoaded(true);
              }),
              onError,
              getInitials,
              name,
              borderRadius,
              icon,
              iconLabel,
              ignoreFallback,
              crossOrigin,
              referrerPolicy
            }
          ),
          children
        ] })
      }
    );
  });
  Avatar.displayName = "Avatar";

  const Box = chakra$1("div");
  Box.displayName = "Box";

  const [ButtonGroupProvider, useButtonGroup] = createContext$1({
    strict: false,
    name: "ButtonGroupContext"
  });

  function ButtonIcon$1(props) {
    const { children, className, ...rest } = props;
    const _children = React.isValidElement(children) ? React.cloneElement(children, {
      "aria-hidden": true,
      focusable: false
    }) : children;
    const _className = cx$1("chakra-button__icon", className);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.span,
      {
        display: "inline-flex",
        alignSelf: "center",
        flexShrink: 0,
        ...rest,
        className: _className,
        children: _children
      }
    );
  }
  ButtonIcon$1.displayName = "ButtonIcon";

  function ButtonSpinner(props) {
    const {
      label,
      placement,
      spacing = "0.5rem",
      children = /* @__PURE__ */ jsxRuntimeExports.jsx(Spinner, { color: "currentColor", width: "1em", height: "1em" }),
      className,
      __css,
      ...rest
    } = props;
    const _className = cx$1("chakra-button__spinner", className);
    const marginProp = placement === "start" ? "marginEnd" : "marginStart";
    const spinnerStyles = React.useMemo(
      () => defineStyle({
        display: "flex",
        alignItems: "center",
        position: label ? "relative" : "absolute",
        [marginProp]: label ? spacing : 0,
        fontSize: "1em",
        lineHeight: "normal",
        ...__css
      }),
      [__css, label, marginProp, spacing]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { className: _className, ...rest, __css: spinnerStyles, children });
  }
  ButtonSpinner.displayName = "ButtonSpinner";

  function useButtonType(value) {
    const [isButton, setIsButton] = React.useState(!value);
    const refCallback = React.useCallback((node) => {
      if (!node)
        return;
      setIsButton(node.tagName === "BUTTON");
    }, []);
    const type = isButton ? "button" : void 0;
    return { ref: refCallback, type };
  }

  const Button = forwardRef$1((props, ref) => {
    const group = useButtonGroup();
    const styles = useStyleConfig("Button", { ...group, ...props });
    const {
      isDisabled = group?.isDisabled,
      isLoading,
      isActive,
      children,
      leftIcon,
      rightIcon,
      loadingText,
      iconSpacing = "0.5rem",
      type,
      spinner,
      spinnerPlacement = "start",
      className,
      as,
      shouldWrapChildren,
      ...rest
    } = omitThemingProps(props);
    const buttonStyles = React.useMemo(() => {
      const _focus = { ...styles?.["_focus"], zIndex: 1 };
      return {
        display: "inline-flex",
        appearance: "none",
        alignItems: "center",
        justifyContent: "center",
        userSelect: "none",
        position: "relative",
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        outline: "none",
        ...styles,
        ...!!group && { _focus }
      };
    }, [styles, group]);
    const { ref: _ref, type: defaultType } = useButtonType(as);
    const contentProps = {
      rightIcon,
      leftIcon,
      iconSpacing,
      children,
      shouldWrapChildren
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      chakra$1.button,
      {
        disabled: isDisabled || isLoading,
        ref: useMergeRefs$1(ref, _ref),
        as,
        type: type ?? defaultType,
        "data-active": dataAttr(isActive),
        "data-loading": dataAttr(isLoading),
        __css: buttonStyles,
        className: cx$1("chakra-button", className),
        ...rest,
        children: [
          isLoading && spinnerPlacement === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ButtonSpinner,
            {
              className: "chakra-button__spinner--start",
              label: loadingText,
              placement: "start",
              spacing: iconSpacing,
              children: spinner
            }
          ),
          isLoading ? loadingText || /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.span, { opacity: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonContent, { ...contentProps }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonContent, { ...contentProps }),
          isLoading && spinnerPlacement === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(
            ButtonSpinner,
            {
              className: "chakra-button__spinner--end",
              label: loadingText,
              placement: "end",
              spacing: iconSpacing,
              children: spinner
            }
          )
        ]
      }
    );
  });
  Button.displayName = "Button";
  function ButtonContent(props) {
    const { leftIcon, rightIcon, children, iconSpacing, shouldWrapChildren } = props;
    if (!shouldWrapChildren) {
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        leftIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon$1, { marginEnd: iconSpacing, children: leftIcon }),
        children,
        rightIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon$1, { marginStart: iconSpacing, children: rightIcon })
      ] });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { style: { display: "contents" }, children: [
      leftIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon$1, { marginEnd: iconSpacing, children: leftIcon }),
      children,
      rightIcon && /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonIcon$1, { marginStart: iconSpacing, children: rightIcon })
    ] });
  }

  const attachedStyles = {
    horizontal: {
      "> *:first-of-type:not(:last-of-type)": { borderEndRadius: 0 },
      "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
      "> *:not(:first-of-type):last-of-type": { borderStartRadius: 0 }
    },
    vertical: {
      "> *:first-of-type:not(:last-of-type)": { borderBottomRadius: 0 },
      "> *:not(:first-of-type):not(:last-of-type)": { borderRadius: 0 },
      "> *:not(:first-of-type):last-of-type": { borderTopRadius: 0 }
    }
  };
  const gapStyles = {
    horizontal: (spacing) => ({
      "& > *:not(style) ~ *:not(style)": { marginStart: spacing }
    }),
    vertical: (spacing) => ({
      "& > *:not(style) ~ *:not(style)": { marginTop: spacing }
    })
  };
  const ButtonGroup = forwardRef$1(
    function ButtonGroup2(props, ref) {
      const {
        size,
        colorScheme,
        variant,
        className,
        spacing = "0.5rem",
        isAttached,
        isDisabled,
        orientation = "horizontal",
        ...rest
      } = props;
      const _className = cx$1("chakra-button__group", className);
      const context = React.useMemo(
        () => ({ size, colorScheme, variant, isDisabled }),
        [size, colorScheme, variant, isDisabled]
      );
      let groupStyles = {
        display: "inline-flex",
        ...isAttached ? attachedStyles[orientation] : gapStyles[orientation](spacing)
      };
      const isVertical = orientation === "vertical";
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ButtonGroupProvider, { value: context, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ref,
          role: "group",
          __css: groupStyles,
          className: _className,
          "data-attached": isAttached ? "" : void 0,
          "data-orientation": orientation,
          flexDir: isVertical ? "column" : void 0,
          ...rest
        }
      ) });
    }
  );
  ButtonGroup.displayName = "ButtonGroup";

  const IconButton = forwardRef$1(
    (props, ref) => {
      const { icon, children, isRound, "aria-label": ariaLabel, ...rest } = props;
      const element = icon || children;
      const _children = React.isValidElement(element) ? React.cloneElement(element, {
        "aria-hidden": true,
        focusable: false
      }) : null;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Button,
        {
          px: "0",
          py: "0",
          borderRadius: isRound ? "full" : void 0,
          ref,
          "aria-label": ariaLabel,
          ...rest,
          children: _children
        }
      );
    }
  );
  IconButton.displayName = "IconButton";

  const Center = chakra$1("div", {
    baseStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  });
  Center.displayName = "Center";
  const centerStyles = {
    horizontal: {
      insetStart: "50%",
      transform: "translateX(-50%)"
    },
    vertical: {
      top: "50%",
      transform: "translateY(-50%)"
    },
    both: {
      insetStart: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)"
    }
  };
  forwardRef$1(
    function AbsoluteCenter2(props, ref) {
      const { axis = "both", ...rest } = props;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ref,
          __css: centerStyles[axis],
          ...rest,
          position: "absolute"
        }
      );
    }
  );

  const [FormControlStylesProvider, useFormControlStyles] = createContext$1({
    name: `FormControlStylesContext`,
    errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
  });
  const [FormControlProvider, useFormControlContext] = createContext$1({
    strict: false,
    name: "FormControlContext"
  });
  function useFormControlProvider(props) {
    const {
      id: idProp,
      isRequired,
      isInvalid,
      isDisabled,
      isReadOnly,
      ...htmlProps
    } = props;
    const uuid = React.useId();
    const id = idProp || `field-${uuid}`;
    const labelId = `${id}-label`;
    const feedbackId = `${id}-feedback`;
    const helpTextId = `${id}-helptext`;
    const [hasFeedbackText, setHasFeedbackText] = React.useState(false);
    const [hasHelpText, setHasHelpText] = React.useState(false);
    const [isFocused, setFocus] = React.useState(false);
    const getHelpTextProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => ({
        id: helpTextId,
        ...props2,
        /**
         * Notify the field context when the help text is rendered on screen,
         * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
         */
        ref: mergeRefs(forwardedRef, (node) => {
          if (!node)
            return;
          setHasHelpText(true);
        })
      }),
      [helpTextId]
    );
    const getLabelProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => ({
        ...props2,
        ref: forwardedRef,
        "data-focus": dataAttr(isFocused),
        "data-disabled": dataAttr(isDisabled),
        "data-invalid": dataAttr(isInvalid),
        "data-readonly": dataAttr(isReadOnly),
        id: props2.id !== void 0 ? props2.id : labelId,
        htmlFor: props2.htmlFor !== void 0 ? props2.htmlFor : id
      }),
      [id, isDisabled, isFocused, isInvalid, isReadOnly, labelId]
    );
    const getErrorMessageProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => ({
        id: feedbackId,
        ...props2,
        /**
         * Notify the field context when the error message is rendered on screen,
         * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
         */
        ref: mergeRefs(forwardedRef, (node) => {
          if (!node)
            return;
          setHasFeedbackText(true);
        }),
        "aria-live": "polite"
      }),
      [feedbackId]
    );
    const getRootProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => ({
        ...props2,
        ...htmlProps,
        ref: forwardedRef,
        role: "group",
        "data-focus": dataAttr(isFocused),
        "data-disabled": dataAttr(isDisabled),
        "data-invalid": dataAttr(isInvalid),
        "data-readonly": dataAttr(isReadOnly)
      }),
      [htmlProps, isDisabled, isFocused, isInvalid, isReadOnly]
    );
    const getRequiredIndicatorProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => ({
        ...props2,
        ref: forwardedRef,
        role: "presentation",
        "aria-hidden": true,
        children: props2.children || "*"
      }),
      []
    );
    return {
      isRequired: !!isRequired,
      isInvalid: !!isInvalid,
      isReadOnly: !!isReadOnly,
      isDisabled: !!isDisabled,
      isFocused: !!isFocused,
      onFocus: () => setFocus(true),
      onBlur: () => setFocus(false),
      hasFeedbackText,
      setHasFeedbackText,
      hasHelpText,
      setHasHelpText,
      id,
      labelId,
      feedbackId,
      helpTextId,
      htmlProps,
      getHelpTextProps,
      getErrorMessageProps,
      getRootProps,
      getLabelProps,
      getRequiredIndicatorProps
    };
  }
  const FormControl = forwardRef$1(
    function FormControl2(props, ref) {
      const styles = useMultiStyleConfig("Form", props);
      const ownProps = omitThemingProps(props);
      const {
        getRootProps,
        htmlProps: _,
        ...context
      } = useFormControlProvider(ownProps);
      const className = cx$1("chakra-form-control", props.className);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlProvider, { value: context, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FormControlStylesProvider, { value: styles, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...getRootProps({}, ref),
          className,
          __css: styles["container"]
        }
      ) }) });
    }
  );
  FormControl.displayName = "FormControl";
  const FormHelperText = forwardRef$1(
    function FormHelperText2(props, ref) {
      const field = useFormControlContext();
      const styles = useFormControlStyles();
      const className = cx$1("chakra-form__helper-text", props.className);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...field?.getHelpTextProps(props, ref),
          __css: styles.helperText,
          className
        }
      );
    }
  );
  FormHelperText.displayName = "FormHelperText";

  function useFormControl(props) {
    const { isDisabled, isInvalid, isReadOnly, isRequired, ...rest } = useFormControlProps(props);
    return {
      ...rest,
      disabled: isDisabled,
      readOnly: isReadOnly,
      required: isRequired,
      "aria-invalid": ariaAttr(isInvalid),
      "aria-required": ariaAttr(isRequired),
      "aria-readonly": ariaAttr(isReadOnly)
    };
  }
  function useFormControlProps(props) {
    const field = useFormControlContext();
    const {
      id,
      disabled,
      readOnly,
      required,
      isRequired,
      isInvalid,
      isReadOnly,
      isDisabled,
      onFocus,
      onBlur,
      ...rest
    } = props;
    const labelIds = props["aria-describedby"] ? [props["aria-describedby"]] : [];
    if (field?.hasFeedbackText && field?.isInvalid) {
      labelIds.push(field.feedbackId);
    }
    if (field?.hasHelpText) {
      labelIds.push(field.helpTextId);
    }
    return {
      ...rest,
      "aria-describedby": labelIds.join(" ") || void 0,
      id: id ?? field?.id,
      isDisabled: disabled ?? isDisabled ?? field?.isDisabled,
      isReadOnly: readOnly ?? isReadOnly ?? field?.isReadOnly,
      isRequired: required ?? isRequired ?? field?.isRequired,
      isInvalid: isInvalid ?? field?.isInvalid,
      onFocus: callAllHandlers(field?.onFocus, onFocus),
      onBlur: callAllHandlers(field?.onBlur, onBlur)
    };
  }

  const Divider = forwardRef$1(
    function Divider2(props, ref) {
      const {
        borderLeftWidth,
        borderBottomWidth,
        borderTopWidth,
        borderRightWidth,
        borderWidth,
        borderStyle,
        borderColor,
        ...styles
      } = useStyleConfig("Divider", props);
      const {
        className,
        orientation = "horizontal",
        __css,
        ...rest
      } = omitThemingProps(props);
      const dividerStyles = {
        vertical: {
          borderLeftWidth: borderLeftWidth || borderRightWidth || borderWidth || "1px",
          height: "100%"
        },
        horizontal: {
          borderBottomWidth: borderBottomWidth || borderTopWidth || borderWidth || "1px",
          width: "100%"
        }
      };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.hr,
        {
          ref,
          "aria-orientation": orientation,
          ...rest,
          __css: {
            ...styles,
            border: "0",
            borderColor,
            borderStyle,
            ...dividerStyles[orientation],
            ...__css
          },
          className: cx$1("chakra-divider", className)
        }
      );
    }
  );
  Divider.displayName = "Divider";

  function isFunction$2(value) {
    return typeof value === "function";
  }
  function pipe$1(...fns) {
    return (v) => fns.reduce((a, b) => b(a), v);
  }
  const createExtendTheme = (theme2) => {
    return function extendTheme2(...extensions) {
      let overrides = [...extensions];
      let activeTheme = extensions[extensions.length - 1];
      if (isChakraTheme(activeTheme) && // this ensures backward compatibility
      // previously only `extendTheme(override, activeTheme?)` was allowed
      overrides.length > 1) {
        overrides = overrides.slice(0, overrides.length - 1);
      } else {
        activeTheme = theme2;
      }
      return pipe$1(
        ...overrides.map(
          (extension) => (prevTheme) => isFunction$2(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension)
        )
      )(activeTheme);
    };
  };
  const extendTheme = createExtendTheme(theme$1);
  function mergeThemeOverride(...overrides) {
    return mergeWith({}, ...overrides, mergeThemeCustomizer);
  }
  function mergeThemeCustomizer(source, override, key, object) {
    if ((isFunction$2(source) || isFunction$2(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
      return (...args) => {
        const sourceValue = isFunction$2(source) ? source(...args) : source;
        const overrideValue = isFunction$2(override) ? override(...args) : override;
        return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
      };
    }
    if (isObject$1(source) && isArray(override)) {
      return override;
    }
    if (isArray(source) && isObject$1(override)) {
      return override;
    }
    return void 0;
  }

  const Flex = forwardRef$1(function Flex2(props, ref) {
    const { direction, align, justify, wrap, basis, grow, shrink, ...rest } = props;
    const styles = {
      display: "flex",
      flexDirection: direction,
      alignItems: align,
      justifyContent: justify,
      flexWrap: wrap,
      flexBasis: basis,
      flexGrow: grow,
      flexShrink: shrink
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { ref, __css: styles, ...rest });
  });
  Flex.displayName = "Flex";

  var propTypes = {exports: {}};

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret_1;
  var hasRequiredReactPropTypesSecret;

  function requireReactPropTypesSecret () {
  	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
  	hasRequiredReactPropTypesSecret = 1;

  	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  	ReactPropTypesSecret_1 = ReactPropTypesSecret;
  	return ReactPropTypesSecret_1;
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var factoryWithThrowingShims;
  var hasRequiredFactoryWithThrowingShims;

  function requireFactoryWithThrowingShims () {
  	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
  	hasRequiredFactoryWithThrowingShims = 1;

  	var ReactPropTypesSecret = /*@__PURE__*/ requireReactPropTypesSecret();

  	function emptyFunction() {}
  	function emptyFunctionWithReset() {}
  	emptyFunctionWithReset.resetWarningCache = emptyFunction;

  	factoryWithThrowingShims = function() {
  	  function shim(props, propName, componentName, location, propFullName, secret) {
  	    if (secret === ReactPropTypesSecret) {
  	      // It is still safe when called from React.
  	      return;
  	    }
  	    var err = new Error(
  	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
  	      'Use PropTypes.checkPropTypes() to call them. ' +
  	      'Read more at http://fb.me/use-check-prop-types'
  	    );
  	    err.name = 'Invariant Violation';
  	    throw err;
  	  }	  shim.isRequired = shim;
  	  function getShim() {
  	    return shim;
  	  }	  // Important!
  	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  	  var ReactPropTypes = {
  	    array: shim,
  	    bigint: shim,
  	    bool: shim,
  	    func: shim,
  	    number: shim,
  	    object: shim,
  	    string: shim,
  	    symbol: shim,

  	    any: shim,
  	    arrayOf: getShim,
  	    element: shim,
  	    elementType: shim,
  	    instanceOf: getShim,
  	    node: shim,
  	    objectOf: getShim,
  	    oneOf: getShim,
  	    oneOfType: getShim,
  	    shape: getShim,
  	    exact: getShim,

  	    checkPropTypes: emptyFunctionWithReset,
  	    resetWarningCache: emptyFunction
  	  };

  	  ReactPropTypes.PropTypes = ReactPropTypes;

  	  return ReactPropTypes;
  	};
  	return factoryWithThrowingShims;
  }

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredPropTypes;

  function requirePropTypes () {
  	if (hasRequiredPropTypes) return propTypes.exports;
  	hasRequiredPropTypes = 1;
  	{
  	  // By explicitly using `prop-types` you are opting into new production behavior.
  	  // http://fb.me/prop-types-in-prod
  	  propTypes.exports = /*@__PURE__*/ requireFactoryWithThrowingShims()();
  	}
  	return propTypes.exports;
  }

  /**
   * defines a focus group
   */
  var FOCUS_GROUP = 'data-focus-lock';
  /**
   * disables element discovery inside a group marked by key
   */
  var FOCUS_DISABLED = 'data-focus-lock-disabled';
  /**
   * allows uncontrolled focus within the marked area, effectively disabling focus lock for it's content
   */
  var FOCUS_ALLOW = 'data-no-focus-lock';
  /**
   * instructs autofocus engine to pick default autofocus inside a given node
   * can be set on the element or container
   */
  var FOCUS_AUTO = 'data-autofocus-inside';
  /**
   * instructs autofocus to ignore elements within a given node
   * can be set on the element or container
   */
  var FOCUS_NO_AUTOFOCUS = 'data-no-autofocus';

  /**
   * Assigns a value for a given ref, no matter of the ref format
   * @param {RefObject} ref - a callback function or ref object
   * @param value - a new value
   *
   * @see https://github.com/theKashey/use-callback-ref#assignref
   * @example
   * const refObject = useRef();
   * const refFn = (ref) => {....}
   *
   * assignRef(refObject, "refValue");
   * assignRef(refFn, "refValue");
   */
  function assignRef(ref, value) {
      if (typeof ref === 'function') {
          ref(value);
      }
      else if (ref) {
          ref.current = value;
      }
      return ref;
  }

  /**
   * creates a MutableRef with ref change callback
   * @param initialValue - initial ref value
   * @param {Function} callback - a callback to run when value changes
   *
   * @example
   * const ref = useCallbackRef(0, (newValue, oldValue) => console.log(oldValue, '->', newValue);
   * ref.current = 1;
   * // prints 0 -> 1
   *
   * @see https://reactjs.org/docs/hooks-reference.html#useref
   * @see https://github.com/theKashey/use-callback-ref#usecallbackref---to-replace-reactuseref
   * @returns {MutableRefObject}
   */
  function useCallbackRef(initialValue, callback) {
      var ref = React.useState(function () { return ({
          // value
          value: initialValue,
          // last callback
          callback: callback,
          // "memoized" public interface
          facade: {
              get current() {
                  return ref.value;
              },
              set current(value) {
                  var last = ref.value;
                  if (last !== value) {
                      ref.value = value;
                      ref.callback(value, last);
                  }
              },
          },
      }); })[0];
      // update callback
      ref.callback = callback;
      return ref.facade;
  }

  var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
  var currentValues = new WeakMap();
  /**
   * Merges two or more refs together providing a single interface to set their value
   * @param {RefObject|Ref} refs
   * @returns {MutableRefObject} - a new ref, which translates all changes to {refs}
   *
   * @see {@link mergeRefs} a version without buit-in memoization
   * @see https://github.com/theKashey/use-callback-ref#usemergerefs
   * @example
   * const Component = React.forwardRef((props, ref) => {
   *   const ownRef = useRef();
   *   const domRef = useMergeRefs([ref, ownRef]); // 👈 merge together
   *   return <div ref={domRef}>...</div>
   * }
   */
  function useMergeRefs(refs, defaultValue) {
      var callbackRef = useCallbackRef(null, function (newValue) {
          return refs.forEach(function (ref) { return assignRef(ref, newValue); });
      });
      // handle refs changes - added or removed
      useIsomorphicLayoutEffect$1(function () {
          var oldValue = currentValues.get(callbackRef);
          if (oldValue) {
              var prevRefs_1 = new Set(oldValue);
              var nextRefs_1 = new Set(refs);
              var current_1 = callbackRef.current;
              prevRefs_1.forEach(function (ref) {
                  if (!nextRefs_1.has(ref)) {
                      assignRef(ref, null);
                  }
              });
              nextRefs_1.forEach(function (ref) {
                  if (!prevRefs_1.has(ref)) {
                      assignRef(ref, current_1);
                  }
              });
          }
          currentValues.set(callbackRef, refs);
      }, [refs]);
      return callbackRef;
  }

  var hiddenGuard = {
    width: '1px',
    height: '0px',
    padding: 0,
    overflow: 'hidden',
    position: 'fixed',
    top: '1px',
    left: '1px'
  };

  function ItoI(a) {
      return a;
  }
  function innerCreateMedium(defaults, middleware) {
      if (middleware === void 0) { middleware = ItoI; }
      var buffer = [];
      var assigned = false;
      var medium = {
          read: function () {
              if (assigned) {
                  throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
              }
              if (buffer.length) {
                  return buffer[buffer.length - 1];
              }
              return defaults;
          },
          useMedium: function (data) {
              var item = middleware(data, assigned);
              buffer.push(item);
              return function () {
                  buffer = buffer.filter(function (x) { return x !== item; });
              };
          },
          assignSyncMedium: function (cb) {
              assigned = true;
              while (buffer.length) {
                  var cbs = buffer;
                  buffer = [];
                  cbs.forEach(cb);
              }
              buffer = {
                  push: function (x) { return cb(x); },
                  filter: function () { return buffer; },
              };
          },
          assignMedium: function (cb) {
              assigned = true;
              var pendingQueue = [];
              if (buffer.length) {
                  var cbs = buffer;
                  buffer = [];
                  cbs.forEach(cb);
                  pendingQueue = buffer;
              }
              var executeQueue = function () {
                  var cbs = pendingQueue;
                  pendingQueue = [];
                  cbs.forEach(cb);
              };
              var cycle = function () { return Promise.resolve().then(executeQueue); };
              cycle();
              buffer = {
                  push: function (x) {
                      pendingQueue.push(x);
                      cycle();
                  },
                  filter: function (filter) {
                      pendingQueue = pendingQueue.filter(filter);
                      return buffer;
                  },
              };
          },
      };
      return medium;
  }
  function createMedium(defaults, middleware) {
      if (middleware === void 0) { middleware = ItoI; }
      return innerCreateMedium(defaults, middleware);
  }
  // eslint-disable-next-line @typescript-eslint/ban-types
  function createSidecarMedium(options) {
      if (options === void 0) { options = {}; }
      var medium = innerCreateMedium(null);
      medium.options = __assign({ async: true, ssr: false }, options);
      return medium;
  }

  var SideCar$1 = function (_a) {
      var sideCar = _a.sideCar, rest = __rest(_a, ["sideCar"]);
      if (!sideCar) {
          throw new Error('Sidecar: please provide `sideCar` property to import the right car');
      }
      var Target = sideCar.read();
      if (!Target) {
          throw new Error('Sidecar medium not found');
      }
      return React__namespace.createElement(Target, __assign({}, rest));
  };
  SideCar$1.isSideCarExport = true;
  function exportSidecar(medium, exported) {
      medium.useMedium(exported);
      return SideCar$1;
  }

  var mediumFocus = createMedium({}, function (_ref) {
    var target = _ref.target,
      currentTarget = _ref.currentTarget;
    return {
      target: target,
      currentTarget: currentTarget
    };
  });
  var mediumBlur = createMedium();
  var mediumEffect = createMedium();
  var mediumSidecar = createSidecarMedium({
    async: true,
    ssr: typeof document !== 'undefined'
  });

  var focusScope = /*#__PURE__*/React.createContext(undefined);

  var emptyArray = [];
  var FocusLock$1 = /*#__PURE__*/React.forwardRef(function FocusLockUI(props, parentRef) {
    var _extends2;
    var _useState = React.useState(),
      realObserved = _useState[0],
      setObserved = _useState[1];
    var observed = React.useRef();
    var isActive = React.useRef(false);
    var originalFocusedElement = React.useRef(null);
    var _useState2 = React.useState({}),
      update = _useState2[1];
    var children = props.children,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$noFocusGuards = props.noFocusGuards,
      noFocusGuards = _props$noFocusGuards === void 0 ? false : _props$noFocusGuards,
      _props$persistentFocu = props.persistentFocus,
      persistentFocus = _props$persistentFocu === void 0 ? false : _props$persistentFocu,
      _props$crossFrame = props.crossFrame,
      crossFrame = _props$crossFrame === void 0 ? true : _props$crossFrame,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus;
      props.allowTextSelection;
      var group = props.group,
      className = props.className,
      whiteList = props.whiteList,
      hasPositiveIndices = props.hasPositiveIndices,
      _props$shards = props.shards,
      shards = _props$shards === void 0 ? emptyArray : _props$shards,
      _props$as = props.as,
      Container = _props$as === void 0 ? 'div' : _props$as,
      _props$lockProps = props.lockProps,
      containerProps = _props$lockProps === void 0 ? {} : _props$lockProps,
      SideCar = props.sideCar,
      _props$returnFocus = props.returnFocus,
      shouldReturnFocus = _props$returnFocus === void 0 ? false : _props$returnFocus,
      focusOptions = props.focusOptions,
      onActivationCallback = props.onActivation,
      onDeactivationCallback = props.onDeactivation;
    var _useState3 = React.useState({}),
      id = _useState3[0];
    var onActivation = React.useCallback(function (_ref) {
      var captureFocusRestore = _ref.captureFocusRestore;
      if (!originalFocusedElement.current) {
        var _document;
        var activeElement = (_document = document) == null ? void 0 : _document.activeElement;
        originalFocusedElement.current = activeElement;
        if (activeElement !== document.body) {
          originalFocusedElement.current = captureFocusRestore(activeElement);
        }
      }
      if (observed.current && onActivationCallback) {
        onActivationCallback(observed.current);
      }
      isActive.current = true;
      update();
    }, [onActivationCallback]);
    var onDeactivation = React.useCallback(function () {
      isActive.current = false;
      if (onDeactivationCallback) {
        onDeactivationCallback(observed.current);
      }
      update();
    }, [onDeactivationCallback]);
    var returnFocus = React.useCallback(function (allowDefer) {
      var focusRestore = originalFocusedElement.current;
      if (focusRestore) {
        var returnFocusTo = (typeof focusRestore === 'function' ? focusRestore() : focusRestore) || document.body;
        var howToReturnFocus = typeof shouldReturnFocus === 'function' ? shouldReturnFocus(returnFocusTo) : shouldReturnFocus;
        if (howToReturnFocus) {
          var returnFocusOptions = typeof howToReturnFocus === 'object' ? howToReturnFocus : undefined;
          originalFocusedElement.current = null;
          if (allowDefer) {
            Promise.resolve().then(function () {
              return returnFocusTo.focus(returnFocusOptions);
            });
          } else {
            returnFocusTo.focus(returnFocusOptions);
          }
        }
      }
    }, [shouldReturnFocus]);
    var onFocus = React.useCallback(function (event) {
      if (isActive.current) {
        mediumFocus.useMedium(event);
      }
    }, []);
    var onBlur = mediumBlur.useMedium;
    var setObserveNode = React.useCallback(function (newObserved) {
      if (observed.current !== newObserved) {
        observed.current = newObserved;
        setObserved(newObserved);
      }
    }, []);
    var lockProps = _extends$1((_extends2 = {}, _extends2[FOCUS_DISABLED] = disabled && 'disabled', _extends2[FOCUS_GROUP] = group, _extends2), containerProps);
    var hasLeadingGuards = noFocusGuards !== true;
    var hasTailingGuards = hasLeadingGuards && noFocusGuards !== 'tail';
    var mergedRef = useMergeRefs([parentRef, setObserveNode]);
    var focusScopeValue = React.useMemo(function () {
      return {
        observed: observed,
        shards: shards,
        enabled: !disabled,
        get active() {
          return isActive.current;
        }
      };
    }, [disabled, isActive, shards, observed]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, hasLeadingGuards && [
    /*#__PURE__*/
    React.createElement("div", {
      key: "guard-first",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }), hasPositiveIndices ? /*#__PURE__*/React.createElement("div", {
      key: "guard-nearest",
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 1,
      style: hiddenGuard
    }) : null], !disabled && /*#__PURE__*/React.createElement(SideCar, {
      id: id,
      sideCar: mediumSidecar,
      observed: realObserved,
      disabled: disabled,
      persistentFocus: persistentFocus,
      crossFrame: crossFrame,
      autoFocus: autoFocus,
      whiteList: whiteList,
      shards: shards,
      onActivation: onActivation,
      onDeactivation: onDeactivation,
      returnFocus: returnFocus,
      focusOptions: focusOptions,
      noFocusGuards: noFocusGuards
    }), /*#__PURE__*/React.createElement(Container, _extends$1({
      ref: mergedRef
    }, lockProps, {
      className: className,
      onBlur: onBlur,
      onFocus: onFocus
    }), /*#__PURE__*/React.createElement(focusScope.Provider, {
      value: focusScopeValue
    }, children)), hasTailingGuards && /*#__PURE__*/React.createElement("div", {
      "data-focus-guard": true,
      tabIndex: disabled ? -1 : 0,
      style: hiddenGuard
    }));
  });
  FocusLock$1.propTypes = {};

  function _setPrototypeOf$1(t, e) {
    return _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf$1(t, e);
  }

  function _inheritsLoose$1(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf$1(t, o);
  }

  function _typeof$1(o) {
    "@babel/helpers - typeof";

    return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof$1(o);
  }

  function toPrimitive(t, r) {
    if ("object" != _typeof$1(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r);
      if ("object" != _typeof$1(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }

  function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof$1(i) ? i : i + "";
  }

  function _defineProperty(e, r, t) {
    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: true,
      configurable: true,
      writable: true
    }) : e[r] = t, e;
  }

  function withSideEffect(reducePropsToState, handleStateChangeOnClient) {

    function getDisplayName(WrappedComponent) {
      return WrappedComponent.displayName || WrappedComponent.name || 'Component';
    }

    return function wrap(WrappedComponent) {

      var mountedInstances = [];
      var state;

      function emitChange() {
        state = reducePropsToState(mountedInstances.map(function (instance) {
          return instance.props;
        }));
        handleStateChangeOnClient(state);
      }

      var SideEffect = /*#__PURE__*/function (_PureComponent) {
        _inheritsLoose$1(SideEffect, _PureComponent);

        function SideEffect() {
          return _PureComponent.apply(this, arguments) || this;
        }

        // Try to use displayName of wrapped component
        SideEffect.peek = function peek() {
          return state;
        };

        var _proto = SideEffect.prototype;

        _proto.componentDidMount = function componentDidMount() {
          mountedInstances.push(this);
          emitChange();
        };

        _proto.componentDidUpdate = function componentDidUpdate() {
          emitChange();
        };

        _proto.componentWillUnmount = function componentWillUnmount() {
          var index = mountedInstances.indexOf(this);
          mountedInstances.splice(index, 1);
          emitChange();
        };

        _proto.render = function render() {
          return /*#__PURE__*/React.createElement(WrappedComponent, this.props);
        };

        return SideEffect;
      }(React.PureComponent);

      _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

      return SideEffect;
    };
  }

  /*
  IE11 support
   */
  var toArray = function (a) {
      var ret = Array(a.length);
      for (var i = 0; i < a.length; ++i) {
          ret[i] = a[i];
      }
      return ret;
  };
  var asArray = function (a) { return (Array.isArray(a) ? a : [a]); };
  var getFirst = function (a) { return (Array.isArray(a) ? a[0] : a); };

  var isElementHidden = function (node) {
      // we can measure only "elements"
      // consider others as "visible"
      if (node.nodeType !== Node.ELEMENT_NODE) {
          return false;
      }
      var computedStyle = window.getComputedStyle(node, null);
      if (!computedStyle || !computedStyle.getPropertyValue) {
          return false;
      }
      return (computedStyle.getPropertyValue('display') === 'none' || computedStyle.getPropertyValue('visibility') === 'hidden');
  };
  var getParentNode$1 = function (node) {
      // DOCUMENT_FRAGMENT_NODE can also point on ShadowRoot. In this case .host will point on the next node
      return node.parentNode && node.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE
          ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
              node.parentNode.host
          : node.parentNode;
  };
  var isTopNode = function (node) {
      // @ts-ignore
      return node === document || (node && node.nodeType === Node.DOCUMENT_NODE);
  };
  var isInert = function (node) { return node.hasAttribute('inert'); };
  /**
   * @see https://github.com/testing-library/jest-dom/blob/main/src/to-be-visible.js
   */
  var isVisibleUncached = function (node, checkParent) {
      return !node || isTopNode(node) || (!isElementHidden(node) && !isInert(node) && checkParent(getParentNode$1(node)));
  };
  var isVisibleCached = function (visibilityCache, node) {
      var cached = visibilityCache.get(node);
      if (cached !== undefined) {
          return cached;
      }
      var result = isVisibleUncached(node, isVisibleCached.bind(undefined, visibilityCache));
      visibilityCache.set(node, result);
      return result;
  };
  var isAutoFocusAllowedUncached = function (node, checkParent) {
      return node && !isTopNode(node) ? (isAutoFocusAllowed(node) ? checkParent(getParentNode$1(node)) : false) : true;
  };
  var isAutoFocusAllowedCached = function (cache, node) {
      var cached = cache.get(node);
      if (cached !== undefined) {
          return cached;
      }
      var result = isAutoFocusAllowedUncached(node, isAutoFocusAllowedCached.bind(undefined, cache));
      cache.set(node, result);
      return result;
  };
  var getDataset = function (node) {
      // @ts-ignore
      return node.dataset;
  };
  var isHTMLButtonElement = function (node) { return node.tagName === 'BUTTON'; };
  var isHTMLInputElement = function (node) { return node.tagName === 'INPUT'; };
  var isRadioElement = function (node) {
      return isHTMLInputElement(node) && node.type === 'radio';
  };
  var notHiddenInput = function (node) {
      return !((isHTMLInputElement(node) || isHTMLButtonElement(node)) && (node.type === 'hidden' || node.disabled));
  };
  var isAutoFocusAllowed = function (node) {
      var attribute = node.getAttribute(FOCUS_NO_AUTOFOCUS);
      return ![true, 'true', ''].includes(attribute);
  };
  var isGuard = function (node) { var _a; return Boolean(node && ((_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.focusGuard)); };
  var isNotAGuard = function (node) { return !isGuard(node); };
  var isDefined = function (x) { return Boolean(x); };

  var tabSort = function (a, b) {
      var aTab = Math.max(0, a.tabIndex);
      var bTab = Math.max(0, b.tabIndex);
      var tabDiff = aTab - bTab;
      var indexDiff = a.index - b.index;
      if (tabDiff) {
          if (!aTab) {
              return 1;
          }
          if (!bTab) {
              return -1;
          }
      }
      return tabDiff || indexDiff;
  };
  var getTabIndex = function (node) {
      if (node.tabIndex < 0) {
          // all "focusable" elements are already preselected
          // but some might have implicit negative tabIndex
          // return 0 for <audio without tabIndex attribute - it is "tabbable"
          if (!node.hasAttribute('tabindex')) {
              return 0;
          }
      }
      return node.tabIndex;
  };
  var orderByTabIndex = function (nodes, filterNegative, keepGuards) {
      return toArray(nodes)
          .map(function (node, index) {
          var tabIndex = getTabIndex(node);
          return {
              node: node,
              index: index,
              tabIndex: keepGuards && tabIndex === -1 ? ((node.dataset || {}).focusGuard ? 0 : -1) : tabIndex,
          };
      })
          .filter(function (data) { return !filterNegative || data.tabIndex >= 0; })
          .sort(tabSort);
  };

  /**
   * list of the object to be considered as focusable
   */
  var tabbables = [
      'button:enabled',
      'select:enabled',
      'textarea:enabled',
      'input:enabled',
      // elements with explicit roles will also use explicit tabindex
      // '[role="button"]',
      'a[href]',
      'area[href]',
      'summary',
      'iframe',
      'object',
      'embed',
      'audio[controls]',
      'video[controls]',
      '[tabindex]',
      '[contenteditable]',
      '[autofocus]',
  ];

  var queryTabbables = tabbables.join(',');
  var queryGuardTabbables = "".concat(queryTabbables, ", [data-focus-guard]");
  var getFocusablesWithShadowDom = function (parent, withGuards) {
      return toArray((parent.shadowRoot || parent).children).reduce(function (acc, child) {
          return acc.concat(child.matches(withGuards ? queryGuardTabbables : queryTabbables) ? [child] : [], getFocusablesWithShadowDom(child));
      }, []);
  };
  var getFocusablesWithIFrame = function (parent, withGuards) {
      var _a;
      // contentDocument of iframe will be null if current origin cannot access it
      if (parent instanceof HTMLIFrameElement && ((_a = parent.contentDocument) === null || _a === void 0 ? void 0 : _a.body)) {
          return getFocusables([parent.contentDocument.body], withGuards);
      }
      return [parent];
  };
  var getFocusables = function (parents, withGuards) {
      return parents.reduce(function (acc, parent) {
          var _a;
          var focusableWithShadowDom = getFocusablesWithShadowDom(parent, withGuards);
          var focusableWithIframes = (_a = []).concat.apply(_a, focusableWithShadowDom.map(function (node) { return getFocusablesWithIFrame(node, withGuards); }));
          return acc.concat(
          // add all tabbables inside and within shadow DOMs in DOM order
          focusableWithIframes, 
          // add if node is tabbable itself
          parent.parentNode
              ? toArray(parent.parentNode.querySelectorAll(queryTabbables)).filter(function (node) { return node === parent; })
              : []);
      }, []);
  };
  /**
   * return a list of focusable nodes within an area marked as "auto-focusable"
   * @param parent
   */
  var getParentAutofocusables = function (parent) {
      var parentFocus = parent.querySelectorAll("[".concat(FOCUS_AUTO, "]"));
      return toArray(parentFocus)
          .map(function (node) { return getFocusables([node]); })
          .reduce(function (acc, nodes) { return acc.concat(nodes); }, []);
  };

  /**
   * given list of focusable elements keeps the ones user can interact with
   * @param nodes
   * @param visibilityCache
   */
  var filterFocusable = function (nodes, visibilityCache) {
      return toArray(nodes)
          .filter(function (node) { return isVisibleCached(visibilityCache, node); })
          .filter(function (node) { return notHiddenInput(node); });
  };
  var filterAutoFocusable = function (nodes, cache) {
      if (cache === void 0) { cache = new Map(); }
      return toArray(nodes).filter(function (node) { return isAutoFocusAllowedCached(cache, node); });
  };
  /**
   * !__WARNING__! Low level API.
   * @returns all tabbable nodes
   *
   * @see {@link getFocusableNodes} to get any focusable element
   *
   * @param topNodes - array of top level HTMLElements to search inside
   * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
   */
  var getTabbableNodes = function (topNodes, visibilityCache, withGuards) {
      return orderByTabIndex(filterFocusable(getFocusables(topNodes, withGuards), visibilityCache), true, withGuards);
  };
  /**
   * !__WARNING__! Low level API.
   *
   * @returns anything "focusable", not only tabbable. The difference is in `tabIndex=-1`
   * (without guards, as long as they are not expected to be ever focused)
   *
   * @see {@link getTabbableNodes} to get only tabble nodes element
   *
   * @param topNodes - array of top level HTMLElements to search inside
   * @param visibilityCache - an cache to store intermediate measurements. Expected to be a fresh `new Map` on every call
   */
  var getFocusableNodes = function (topNodes, visibilityCache) {
      return orderByTabIndex(filterFocusable(getFocusables(topNodes), visibilityCache), false);
  };
  /**
   * return list of nodes which are expected to be auto-focused
   * @param topNode
   * @param visibilityCache
   */
  var parentAutofocusables = function (topNode, visibilityCache) {
      return filterFocusable(getParentAutofocusables(topNode), visibilityCache);
  };
  /*
   * Determines if element is contained in scope, including nested shadow DOMs
   */
  var contains$2 = function (scope, element) {
      if (scope.shadowRoot) {
          return contains$2(scope.shadowRoot, element);
      }
      else {
          if (Object.getPrototypeOf(scope).contains !== undefined &&
              Object.getPrototypeOf(scope).contains.call(scope, element)) {
              return true;
          }
          return toArray(scope.children).some(function (child) {
              var _a;
              if (child instanceof HTMLIFrameElement) {
                  var iframeBody = (_a = child.contentDocument) === null || _a === void 0 ? void 0 : _a.body;
                  if (iframeBody) {
                      return contains$2(iframeBody, element);
                  }
                  return false;
              }
              return contains$2(child, element);
          });
      }
  };

  /**
   * in case of multiple nodes nested inside each other
   * keeps only top ones
   * this is O(nlogn)
   * @param nodes
   * @returns {*}
   */
  var filterNested = function (nodes) {
      var contained = new Set();
      var l = nodes.length;
      for (var i = 0; i < l; i += 1) {
          for (var j = i + 1; j < l; j += 1) {
              var position = nodes[i].compareDocumentPosition(nodes[j]);
              /* eslint-disable no-bitwise */
              if ((position & Node.DOCUMENT_POSITION_CONTAINED_BY) > 0) {
                  contained.add(j);
              }
              if ((position & Node.DOCUMENT_POSITION_CONTAINS) > 0) {
                  contained.add(i);
              }
              /* eslint-enable */
          }
      }
      return nodes.filter(function (_, index) { return !contained.has(index); });
  };
  /**
   * finds top most parent for a node
   * @param node
   * @returns {*}
   */
  var getTopParent = function (node) {
      return node.parentNode ? getTopParent(node.parentNode) : node;
  };
  /**
   * returns all "focus containers" inside a given node
   * @param node - node or nodes to look inside
   * @returns Element[]
   */
  var getAllAffectedNodes = function (node) {
      var nodes = asArray(node);
      return nodes.filter(Boolean).reduce(function (acc, currentNode) {
          var group = currentNode.getAttribute(FOCUS_GROUP);
          acc.push.apply(acc, (group
              ? filterNested(toArray(getTopParent(currentNode).querySelectorAll("[".concat(FOCUS_GROUP, "=\"").concat(group, "\"]:not([").concat(FOCUS_DISABLED, "=\"disabled\"])"))))
              : [currentNode]));
          return acc;
      }, []);
  };

  var safeProbe = function (cb) {
      try {
          return cb();
      }
      catch (e) {
          return undefined;
      }
  };

  /**
   * returns active element from document or from nested shadowdoms
   */
  /**
   * returns current active element. If the active element is a "container" itself(shadowRoot or iframe) returns active element inside it
   * @param [inDocument]
   */
  var getActiveElement = function (inDocument) {
      if (inDocument === void 0) { inDocument = document; }
      if (!inDocument || !inDocument.activeElement) {
          return undefined;
      }
      var activeElement = inDocument.activeElement;
      return (activeElement.shadowRoot
          ? getActiveElement(activeElement.shadowRoot)
          : activeElement instanceof HTMLIFrameElement && safeProbe(function () { return activeElement.contentWindow.document; })
              ? getActiveElement(activeElement.contentWindow.document)
              : activeElement);
  };

  var focusInFrame = function (frame, activeElement) { return frame === activeElement; };
  var focusInsideIframe = function (topNode, activeElement) {
      return Boolean(toArray(topNode.querySelectorAll('iframe')).some(function (node) { return focusInFrame(node, activeElement); }));
  };
  /**
   * @returns {Boolean} true, if the current focus is inside given node or nodes.
   * Supports nodes hidden inside shadowDom
   */
  var focusInside = function (topNode, activeElement) {
      // const activeElement = document && getActiveElement();
      if (activeElement === void 0) { activeElement = getActiveElement(getFirst(topNode).ownerDocument); }
      if (!activeElement || (activeElement.dataset && activeElement.dataset.focusGuard)) {
          return false;
      }
      return getAllAffectedNodes(topNode).some(function (node) {
          return contains$2(node, activeElement) || focusInsideIframe(node, activeElement);
      });
  };

  /**
   * checks if focus is hidden FROM the focus-lock
   * ie contained inside a node focus-lock shall ignore
   *
   * This is a utility function coupled with {@link FOCUS_ALLOW} constant
   *
   * @returns {boolean} focus is currently is in "allow" area
   */
  var focusIsHidden = function (inDocument) {
      if (inDocument === void 0) { inDocument = document; }
      var activeElement = getActiveElement(inDocument);
      if (!activeElement) {
          return false;
      }
      // this does not support setting FOCUS_ALLOW within shadow dom
      return toArray(inDocument.querySelectorAll("[".concat(FOCUS_ALLOW, "]"))).some(function (node) { return contains$2(node, activeElement); });
  };

  var findSelectedRadio = function (node, nodes) {
      return nodes
          .filter(isRadioElement)
          .filter(function (el) { return el.name === node.name; })
          .filter(function (el) { return el.checked; })[0] || node;
  };
  var correctNode = function (node, nodes) {
      if (isRadioElement(node) && node.name) {
          return findSelectedRadio(node, nodes);
      }
      return node;
  };
  /**
   * giving a set of radio inputs keeps only selected (tabbable) ones
   * @param nodes
   */
  var correctNodes = function (nodes) {
      // IE11 has no Set(array) constructor
      var resultSet = new Set();
      nodes.forEach(function (node) { return resultSet.add(correctNode(node, nodes)); });
      // using filter to support IE11
      return nodes.filter(function (node) { return resultSet.has(node); });
  };

  var pickFirstFocus = function (nodes) {
      if (nodes[0] && nodes.length > 1) {
          return correctNode(nodes[0], nodes);
      }
      return nodes[0];
  };
  var pickFocusable = function (nodes, node) {
      return nodes.indexOf(correctNode(node, nodes));
  };

  var NEW_FOCUS = 'NEW_FOCUS';
  /**
   * Main solver for the "find next focus" question
   * @param innerNodes - used to control "return focus"
   * @param innerTabbables - used to control "autofocus"
   * @param outerNodes
   * @param activeElement
   * @param lastNode
   * @returns {number|string|undefined|*}
   */
  var newFocus = function (innerNodes, innerTabbables, outerNodes, activeElement, lastNode) {
      var cnt = innerNodes.length;
      var firstFocus = innerNodes[0];
      var lastFocus = innerNodes[cnt - 1];
      var isOnGuard = isGuard(activeElement);
      // focus is inside
      if (activeElement && innerNodes.indexOf(activeElement) >= 0) {
          return undefined;
      }
      var activeIndex = activeElement !== undefined ? outerNodes.indexOf(activeElement) : -1;
      var lastIndex = lastNode ? outerNodes.indexOf(lastNode) : activeIndex;
      var lastNodeInside = lastNode ? innerNodes.indexOf(lastNode) : -1;
      // no active focus (or focus is on the body)
      if (activeIndex === -1) {
          // known fallback
          if (lastNodeInside !== -1) {
              return lastNodeInside;
          }
          return NEW_FOCUS;
      }
      // new focus, nothing to calculate
      if (lastNodeInside === -1) {
          return NEW_FOCUS;
      }
      var indexDiff = activeIndex - lastIndex;
      var firstNodeIndex = outerNodes.indexOf(firstFocus);
      var lastNodeIndex = outerNodes.indexOf(lastFocus);
      var correctedNodes = correctNodes(outerNodes);
      var currentFocusableIndex = activeElement !== undefined ? correctedNodes.indexOf(activeElement) : -1;
      var previousFocusableIndex = lastNode ? correctedNodes.indexOf(lastNode) : currentFocusableIndex;
      var tabbableNodes = correctedNodes.filter(function (node) { return node.tabIndex >= 0; });
      var currentTabbableIndex = activeElement !== undefined ? tabbableNodes.indexOf(activeElement) : -1;
      var previousTabbableIndex = lastNode ? tabbableNodes.indexOf(lastNode) : currentTabbableIndex;
      var focusIndexDiff = currentTabbableIndex >= 0 && previousTabbableIndex >= 0
          ? // old/new are tabbables, measure distance in tabbable space
              previousTabbableIndex - currentTabbableIndex
          : // or else measure in focusable space
              previousFocusableIndex - currentFocusableIndex;
      // old focus
      if (!indexDiff && lastNodeInside >= 0) {
          return lastNodeInside;
      }
      // no tabbable elements, autofocus is not possible
      if (innerTabbables.length === 0) {
          // an edge case with no tabbable elements
          // return the last focusable one
          // with some probability this will prevent focus from cycling across the lock, but there is no tabbale elements to cycle to
          return lastNodeInside;
      }
      var returnFirstNode = pickFocusable(innerNodes, innerTabbables[0]);
      var returnLastNode = pickFocusable(innerNodes, innerTabbables[innerTabbables.length - 1]);
      // first element
      if (activeIndex <= firstNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
          return returnLastNode;
      }
      // last element
      if (activeIndex >= lastNodeIndex && isOnGuard && Math.abs(indexDiff) > 1) {
          return returnFirstNode;
      }
      // jump out, but not on the guard
      if (indexDiff && Math.abs(focusIndexDiff) > 1) {
          return lastNodeInside;
      }
      // focus above lock
      if (activeIndex <= firstNodeIndex) {
          return returnLastNode;
      }
      // focus below lock
      if (activeIndex > lastNodeIndex) {
          return returnFirstNode;
      }
      // index is inside tab order, but outside Lock
      if (indexDiff) {
          if (Math.abs(indexDiff) > 1) {
              return lastNodeInside;
          }
          return (cnt + lastNodeInside + indexDiff) % cnt;
      }
      // do nothing
      return undefined;
  };

  var findAutoFocused = function (autoFocusables) {
      return function (node) {
          var _a;
          var autofocus = (_a = getDataset(node)) === null || _a === void 0 ? void 0 : _a.autofocus;
          return (
          // @ts-expect-error
          node.autofocus ||
              //
              (autofocus !== undefined && autofocus !== 'false') ||
              //
              autoFocusables.indexOf(node) >= 0);
      };
  };
  var pickAutofocus = function (nodesIndexes, orderedNodes, groups) {
      var nodes = nodesIndexes.map(function (_a) {
          var node = _a.node;
          return node;
      });
      var autoFocusable = filterAutoFocusable(nodes.filter(findAutoFocused(groups)));
      if (autoFocusable && autoFocusable.length) {
          return pickFirstFocus(autoFocusable);
      }
      return pickFirstFocus(filterAutoFocusable(orderedNodes));
  };

  var getParents = function (node, parents) {
      if (parents === void 0) { parents = []; }
      parents.push(node);
      if (node.parentNode) {
          getParents(node.parentNode.host || node.parentNode, parents);
      }
      return parents;
  };
  /**
   * finds a parent for both nodeA and nodeB
   * @param nodeA
   * @param nodeB
   * @returns {boolean|*}
   */
  var getCommonParent = function (nodeA, nodeB) {
      var parentsA = getParents(nodeA);
      var parentsB = getParents(nodeB);
      // tslint:disable-next-line:prefer-for-of
      for (var i = 0; i < parentsA.length; i += 1) {
          var currentParent = parentsA[i];
          if (parentsB.indexOf(currentParent) >= 0) {
              return currentParent;
          }
      }
      return false;
  };
  var getTopCommonParent = function (baseActiveElement, leftEntry, rightEntries) {
      var activeElements = asArray(baseActiveElement);
      var leftEntries = asArray(leftEntry);
      var activeElement = activeElements[0];
      var topCommon = false;
      leftEntries.filter(Boolean).forEach(function (entry) {
          topCommon = getCommonParent(topCommon || entry, entry) || topCommon;
          rightEntries.filter(Boolean).forEach(function (subEntry) {
              var common = getCommonParent(activeElement, subEntry);
              if (common) {
                  if (!topCommon || contains$2(common, topCommon)) {
                      topCommon = common;
                  }
                  else {
                      topCommon = getCommonParent(common, topCommon);
                  }
              }
          });
      });
      // TODO: add assert here?
      return topCommon;
  };
  /**
   * return list of nodes which are expected to be autofocused inside a given top nodes
   * @param entries
   * @param visibilityCache
   */
  var allParentAutofocusables = function (entries, visibilityCache) {
      return entries.reduce(function (acc, node) { return acc.concat(parentAutofocusables(node, visibilityCache)); }, []);
  };

  var reorderNodes = function (srcNodes, dstNodes) {
      var remap = new Map();
      // no Set(dstNodes) for IE11 :(
      dstNodes.forEach(function (entity) { return remap.set(entity.node, entity); });
      // remap to dstNodes
      return srcNodes.map(function (node) { return remap.get(node); }).filter(isDefined);
  };
  /**
   * contains the main logic of the `focus-lock` package.
   *
   * ! you probably dont need this function !
   *
   * given top node(s) and the last active element returns the element to be focused next
   * @returns element which should be focused to move focus inside
   * @param topNode
   * @param lastNode
   */
  var focusSolver = function (topNode, lastNode) {
      var activeElement = getActiveElement(asArray(topNode).length > 0 ? document : getFirst(topNode).ownerDocument);
      var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
      var commonParent = getTopCommonParent(activeElement || topNode, topNode, entries);
      var visibilityCache = new Map();
      var anyFocusable = getFocusableNodes(entries, visibilityCache);
      var innerElements = anyFocusable.filter(function (_a) {
          var node = _a.node;
          return isNotAGuard(node);
      });
      if (!innerElements[0]) {
          return undefined;
      }
      var outerNodes = getFocusableNodes([commonParent], visibilityCache).map(function (_a) {
          var node = _a.node;
          return node;
      });
      var orderedInnerElements = reorderNodes(outerNodes, innerElements);
      // collect inner focusable and separately tabbables
      var innerFocusables = orderedInnerElements.map(function (_a) {
          var node = _a.node;
          return node;
      });
      var innerTabbable = orderedInnerElements.filter(function (_a) {
          var tabIndex = _a.tabIndex;
          return tabIndex >= 0;
      }).map(function (_a) {
          var node = _a.node;
          return node;
      });
      var newId = newFocus(innerFocusables, innerTabbable, outerNodes, activeElement, lastNode);
      if (newId === NEW_FOCUS) {
          var focusNode = 
          // first try only tabbable, and the fallback to all focusable, as long as at least one element should be picked for focus
          pickAutofocus(anyFocusable, innerTabbable, allParentAutofocusables(entries, visibilityCache)) ||
              pickAutofocus(anyFocusable, innerFocusables, allParentAutofocusables(entries, visibilityCache));
          if (focusNode) {
              return { node: focusNode };
          }
          else {
              console.warn('focus-lock: cannot find any node to move focus into');
              return undefined;
          }
      }
      if (newId === undefined) {
          return newId;
      }
      return orderedInnerElements[newId];
  };

  /**
   * traverses all related nodes (including groups) returning a list of all nodes(outer and internal) with meta information
   * This is low-level API!
   * @returns list of focusable elements inside a given top(!) node.
   * @see {@link getFocusableNodes} providing a simpler API
   */
  var expandFocusableNodes = function (topNode) {
      var entries = getAllAffectedNodes(topNode).filter(isNotAGuard);
      var commonParent = getTopCommonParent(topNode, topNode, entries);
      var outerNodes = orderByTabIndex(getFocusables([commonParent], true), true, true);
      var innerElements = getFocusables(entries, false);
      return outerNodes.map(function (_a) {
          var node = _a.node, index = _a.index;
          return ({
              node: node,
              index: index,
              lockItem: innerElements.indexOf(node) >= 0,
              guard: isGuard(node),
          });
      });
  };

  var focusOn = function (target, focusOptions) {
      if (!target) {
          // not clear how, but is possible https://github.com/theKashey/focus-lock/issues/53
          return;
      }
      if ('focus' in target) {
          target.focus(focusOptions);
      }
      if ('contentWindow' in target && target.contentWindow) {
          target.contentWindow.focus();
      }
  };

  var guardCount = 0;
  var lockDisabled = false;
  /**
   * The main functionality of the focus-lock package
   *
   * Contains focus at a given node.
   * The last focused element will help to determine which element(first or last) should be focused.
   * The found element will be focused.
   *
   * This is one time action (move), not a persistent focus-lock
   *
   * HTML markers (see {@link import('./constants').FOCUS_AUTO} constants) can control autofocus
   * @see {@link focusSolver} for the same functionality without autofocus
   */
  var moveFocusInside = function (topNode, lastNode, options) {
      if (options === void 0) { options = {}; }
      var focusable = focusSolver(topNode, lastNode);
      // global local side effect to countain recursive lock activation and resolve focus-fighting
      if (lockDisabled) {
          return;
      }
      if (focusable) {
          /** +FOCUS-FIGHTING prevention **/
          if (guardCount > 2) {
              // we have recursive entered back the lock activation
              console.error('FocusLock: focus-fighting detected. Only one focus management system could be active. ' +
                  'See https://github.com/theKashey/focus-lock/#focus-fighting');
              lockDisabled = true;
              setTimeout(function () {
                  lockDisabled = false;
              }, 1);
              return;
          }
          guardCount++;
          focusOn(focusable.node, options.focusOptions);
          guardCount--;
      }
  };

  function weakRef(value) {
      if (!value)
          return null;
      // #68 Safari 14.1 dont have it yet
      // FIXME: remove in 2025
      if (typeof WeakRef === 'undefined') {
          return function () { return value || null; };
      }
      var w = value ? new WeakRef(value) : null;
      return function () { return (w === null || w === void 0 ? void 0 : w.deref()) || null; };
  }
  var recordElementLocation = function (element) {
      if (!element) {
          return null;
      }
      var stack = [];
      var currentElement = element;
      while (currentElement && currentElement !== document.body) {
          stack.push({
              current: weakRef(currentElement),
              parent: weakRef(currentElement.parentElement),
              left: weakRef(currentElement.previousElementSibling),
              right: weakRef(currentElement.nextElementSibling),
          });
          currentElement = currentElement.parentElement;
      }
      return {
          element: weakRef(element),
          stack: stack,
          ownerDocument: element.ownerDocument,
      };
  };
  var restoreFocusTo = function (location) {
      var _a, _b, _c, _d, _e;
      if (!location) {
          return undefined;
      }
      var stack = location.stack, ownerDocument = location.ownerDocument;
      var visibilityCache = new Map();
      for (var _i = 0, stack_1 = stack; _i < stack_1.length; _i++) {
          var line = stack_1[_i];
          var parent_1 = (_a = line.parent) === null || _a === void 0 ? void 0 : _a.call(line);
          // is it still here?
          if (parent_1 && ownerDocument.contains(parent_1)) {
              var left = (_b = line.left) === null || _b === void 0 ? void 0 : _b.call(line);
              var savedCurrent = line.current();
              var current = parent_1.contains(savedCurrent) ? savedCurrent : undefined;
              var right = (_c = line.right) === null || _c === void 0 ? void 0 : _c.call(line);
              var focusables = getTabbableNodes([parent_1], visibilityCache);
              var aim = 
              // that is element itself
              (_e = (_d = current !== null && current !== void 0 ? current : 
              // or something in it's place
              left === null || left === void 0 ? void 0 : left.nextElementSibling) !== null && _d !== void 0 ? _d : 
              // or somebody to the right, still close enough
              right) !== null && _e !== void 0 ? _e : 
              // or somebody to the left, something?
              left;
              while (aim) {
                  for (var _f = 0, focusables_1 = focusables; _f < focusables_1.length; _f++) {
                      var focusable = focusables_1[_f];
                      if (aim === null || aim === void 0 ? void 0 : aim.contains(focusable.node)) {
                          return focusable.node;
                      }
                  }
                  aim = aim.nextElementSibling;
              }
              if (focusables.length) {
                  // if parent contains a focusable - move there
                  return focusables[0].node;
              }
          }
      }
      // nothing matched
      return undefined;
  };
  /**
   * Captures the current focused element to restore focus as close as possible in the future
   * Handles situations where the focused element is removed from the DOM or no longer focusable
   * moving focus to the closest focusable element
   * @param targetElement - element where focus should be restored
   * @returns a function returning a new element to focus
   */
  var captureFocusRestore = function (targetElement) {
      var location = recordElementLocation(targetElement);
      return function () {
          return restoreFocusTo(location);
      };
  };

  /**
   * for a given `element` in a given `scope` returns focusable siblings
   * @param element - base element
   * @param scope - common parent. Can be document, but better to narrow it down for performance reasons
   * @returns {prev,next} - references to a focusable element before and after
   * @returns undefined - if operation is not applicable
   */
  var getRelativeFocusable = function (element, scope, useTabbables) {
      if (!element || !scope) {
          console.error('no element or scope given');
          return {};
      }
      var shards = asArray(scope);
      if (shards.every(function (shard) { return !contains$2(shard, element); })) {
          console.error('Active element is not contained in the scope');
          return {};
      }
      var focusables = useTabbables
          ? getTabbableNodes(shards, new Map())
          : getFocusableNodes(shards, new Map());
      var current = focusables.findIndex(function (_a) {
          var node = _a.node;
          return node === element;
      });
      if (current === -1) {
          // an edge case, when anchor element is not found
          return undefined;
      }
      return {
          prev: focusables[current - 1],
          next: focusables[current + 1],
          first: focusables[0],
          last: focusables[focusables.length - 1],
      };
  };
  var getBoundary = function (shards, useTabbables) {
      var set = useTabbables
          ? getTabbableNodes(asArray(shards), new Map())
          : getFocusableNodes(asArray(shards), new Map());
      return {
          first: set[0],
          last: set[set.length - 1],
      };
  };
  var defaultOptions$1 = function (options) {
      return Object.assign({
          scope: document.body,
          cycle: true,
          onlyTabbable: true,
      }, options);
  };
  var moveFocus = function (fromElement, options, cb) {
      if (options === void 0) { options = {}; }
      var newOptions = defaultOptions$1(options);
      var solution = getRelativeFocusable(fromElement, newOptions.scope, newOptions.onlyTabbable);
      if (!solution) {
          return;
      }
      var target = cb(solution, newOptions.cycle);
      if (target) {
          focusOn(target.node, newOptions.focusOptions);
      }
  };
  /**
   * focuses next element in the tab-order
   * @param fromElement - common parent to scope active element search or tab cycle order
   * @param {FocusNextOptions} [options] - focus options
   */
  var focusNextElement = function (fromElement, options) {
      if (options === void 0) { options = {}; }
      moveFocus(fromElement, options, function (_a, cycle) {
          var next = _a.next, first = _a.first;
          return next || (cycle && first);
      });
  };
  /**
   * focuses prev element in the tab order
   * @param fromElement - common parent to scope active element search or tab cycle order
   * @param {FocusNextOptions} [options] - focus options
   */
  var focusPrevElement = function (fromElement, options) {
      if (options === void 0) { options = {}; }
      moveFocus(fromElement, options, function (_a, cycle) {
          var prev = _a.prev, last = _a.last;
          return prev || (cycle && last);
      });
  };
  var pickBoundary = function (scope, options, what) {
      var _a;
      var boundary = getBoundary(scope, (_a = options.onlyTabbable) !== null && _a !== void 0 ? _a : true);
      var node = boundary[what];
      if (node) {
          focusOn(node.node, options.focusOptions);
      }
  };
  /**
   * focuses first element in the tab-order
   * @param {FocusNextOptions} options - focus options
   */
  var focusFirstElement = function (scope, options) {
      if (options === void 0) { options = {}; }
      pickBoundary(scope, options, 'first');
  };
  /**
   * focuses last element in the tab order
   * @param {FocusNextOptions} options - focus options
   */
  var focusLastElement = function (scope, options) {
      if (options === void 0) { options = {}; }
      pickBoundary(scope, options, 'last');
  };

  function deferAction(action) {
    setTimeout(action, 1);
  }
  var extractRef$1 = function extractRef(ref) {
    return ref && 'current' in ref ? ref.current : ref;
  };

  var focusOnBody = function focusOnBody() {
    return document && document.activeElement === document.body;
  };
  var isFreeFocus = function isFreeFocus() {
    return focusOnBody() || focusIsHidden();
  };
  var lastActiveTrap = null;
  var lastActiveFocus = null;
  var tryRestoreFocus = function tryRestoreFocus() {
    return null;
  };
  var lastPortaledElement = null;
  var focusWasOutsideWindow = false;
  var windowFocused = false;
  var defaultWhitelist = function defaultWhitelist() {
    return true;
  };
  var focusWhitelisted = function focusWhitelisted(activeElement) {
    return (lastActiveTrap.whiteList || defaultWhitelist)(activeElement);
  };
  var recordPortal = function recordPortal(observerNode, portaledElement) {
    lastPortaledElement = {
      observerNode: observerNode,
      portaledElement: portaledElement
    };
  };
  var focusIsPortaledPair = function focusIsPortaledPair(element) {
    return lastPortaledElement && lastPortaledElement.portaledElement === element;
  };
  function autoGuard(startIndex, end, step, allNodes) {
    var lastGuard = null;
    var i = startIndex;
    do {
      var item = allNodes[i];
      if (item.guard) {
        if (item.node.dataset.focusAutoGuard) {
          lastGuard = item;
        }
      } else if (item.lockItem) {
        if (i !== startIndex) {
          return;
        }
        lastGuard = null;
      } else {
        break;
      }
    } while ((i += step) !== end);
    if (lastGuard) {
      lastGuard.node.tabIndex = 0;
    }
  }
  var focusWasOutside = function focusWasOutside(crossFrameOption) {
    if (crossFrameOption) {
      return Boolean(focusWasOutsideWindow);
    }
    return focusWasOutsideWindow === 'meanwhile';
  };
  var checkInHost = function checkInHost(check, el, boundary) {
    return el && (el.host === check && (!el.activeElement || boundary.contains(el.activeElement)) || el.parentNode && checkInHost(check, el.parentNode, boundary));
  };
  var withinHost = function withinHost(activeElement, workingArea) {
    return workingArea.some(function (area) {
      return checkInHost(activeElement, area, area);
    });
  };
  var getNodeFocusables = function getNodeFocusables(nodes) {
    return getFocusableNodes(nodes, new Map());
  };
  var isNotFocusable = function isNotFocusable(node) {
    return !getNodeFocusables([node.parentNode]).some(function (el) {
      return el.node === node;
    });
  };
  var activateTrap = function activateTrap() {
    var result = false;
    if (lastActiveTrap) {
      var _lastActiveTrap = lastActiveTrap,
        observed = _lastActiveTrap.observed,
        persistentFocus = _lastActiveTrap.persistentFocus,
        autoFocus = _lastActiveTrap.autoFocus,
        shards = _lastActiveTrap.shards,
        crossFrame = _lastActiveTrap.crossFrame,
        focusOptions = _lastActiveTrap.focusOptions,
        noFocusGuards = _lastActiveTrap.noFocusGuards;
      var workingNode = observed || lastPortaledElement && lastPortaledElement.portaledElement;
      if (focusOnBody() && lastActiveFocus && lastActiveFocus !== document.body) {
        if (!document.body.contains(lastActiveFocus) || isNotFocusable(lastActiveFocus)) {
          var newTarget = tryRestoreFocus();
          if (newTarget) {
            newTarget.focus();
          }
        }
      }
      var activeElement = document && document.activeElement;
      if (workingNode) {
        var workingArea = [workingNode].concat(shards.map(extractRef$1).filter(Boolean));
        var shouldForceRestoreFocus = function shouldForceRestoreFocus() {
          if (!focusWasOutside(crossFrame) || !noFocusGuards || !lastActiveFocus || windowFocused) {
            return false;
          }
          var nodes = getNodeFocusables(workingArea);
          var lastIndex = nodes.findIndex(function (_ref) {
            var node = _ref.node;
            return node === lastActiveFocus;
          });
          return lastIndex === 0 || lastIndex === nodes.length - 1;
        };
        if (!activeElement || focusWhitelisted(activeElement)) {
          if (persistentFocus || shouldForceRestoreFocus() || !isFreeFocus() || !lastActiveFocus && autoFocus) {
            if (workingNode && !(focusInside(workingArea) || activeElement && withinHost(activeElement, workingArea) || focusIsPortaledPair(activeElement))) {
              if (document && !lastActiveFocus && activeElement && !autoFocus) {
                if (activeElement.blur) {
                  activeElement.blur();
                }
                document.body.focus();
              } else {
                result = moveFocusInside(workingArea, lastActiveFocus, {
                  focusOptions: focusOptions
                });
                lastPortaledElement = {};
              }
            }
            lastActiveFocus = document && document.activeElement;
            if (lastActiveFocus !== document.body) {
              tryRestoreFocus = captureFocusRestore(lastActiveFocus);
            }
            focusWasOutsideWindow = false;
          }
        }
        if (document && activeElement !== document.activeElement && document.querySelector('[data-focus-auto-guard]')) {
          var newActiveElement = document && document.activeElement;
          var allNodes = expandFocusableNodes(workingArea);
          var focusedIndex = allNodes.map(function (_ref2) {
            var node = _ref2.node;
            return node;
          }).indexOf(newActiveElement);
          if (focusedIndex > -1) {
            allNodes.filter(function (_ref3) {
              var guard = _ref3.guard,
                node = _ref3.node;
              return guard && node.dataset.focusAutoGuard;
            }).forEach(function (_ref4) {
              var node = _ref4.node;
              return node.removeAttribute('tabIndex');
            });
            autoGuard(focusedIndex, allNodes.length, 1, allNodes);
            autoGuard(focusedIndex, -1, -1, allNodes);
          }
        }
      }
    }
    return result;
  };
  var onTrap = function onTrap(event) {
    if (activateTrap() && event) {
      event.stopPropagation();
      event.preventDefault();
    }
  };
  var onBlur = function onBlur() {
    return deferAction(activateTrap);
  };
  var onFocus = function onFocus(event) {
    var source = event.target;
    var currentNode = event.currentTarget;
    if (!currentNode.contains(source)) {
      recordPortal(currentNode, source);
    }
  };
  var FocusWatcher = function FocusWatcher() {
    return null;
  };
  var onWindowFocus = function onWindowFocus() {
    windowFocused = true;
  };
  var onWindowBlur = function onWindowBlur() {
    windowFocused = false;
    focusWasOutsideWindow = 'just';
    deferAction(function () {
      focusWasOutsideWindow = 'meanwhile';
    });
  };
  var attachHandler = function attachHandler() {
    document.addEventListener('focusin', onTrap);
    document.addEventListener('focusout', onBlur);
    window.addEventListener('focus', onWindowFocus);
    window.addEventListener('blur', onWindowBlur);
  };
  var detachHandler = function detachHandler() {
    document.removeEventListener('focusin', onTrap);
    document.removeEventListener('focusout', onBlur);
    window.removeEventListener('focus', onWindowFocus);
    window.removeEventListener('blur', onWindowBlur);
  };
  function reducePropsToState(propsList) {
    return propsList.filter(function (_ref6) {
      var disabled = _ref6.disabled;
      return !disabled;
    });
  }
  var focusLockAPI = {
    moveFocusInside: moveFocusInside,
    focusInside: focusInside,
    focusNextElement: focusNextElement,
    focusPrevElement: focusPrevElement,
    focusFirstElement: focusFirstElement,
    focusLastElement: focusLastElement,
    captureFocusRestore: captureFocusRestore
  };
  function handleStateChangeOnClient(traps) {
    var trap = traps.slice(-1)[0];
    if (trap && !lastActiveTrap) {
      attachHandler();
    }
    var lastTrap = lastActiveTrap;
    var sameTrap = lastTrap && trap && trap.id === lastTrap.id;
    lastActiveTrap = trap;
    if (lastTrap && !sameTrap) {
      lastTrap.onDeactivation();
      if (!traps.filter(function (_ref7) {
        var id = _ref7.id;
        return id === lastTrap.id;
      }).length) {
        lastTrap.returnFocus(!trap);
      }
    }
    if (trap) {
      lastActiveFocus = null;
      if (!sameTrap || lastTrap.observed !== trap.observed) {
        trap.onActivation(focusLockAPI);
      }
      activateTrap();
      deferAction(activateTrap);
    } else {
      detachHandler();
      lastActiveFocus = null;
    }
  }
  mediumFocus.assignSyncMedium(onFocus);
  mediumBlur.assignMedium(onBlur);
  mediumEffect.assignMedium(function (cb) {
    return cb(focusLockAPI);
  });
  var FocusTrap$1 = withSideEffect(reducePropsToState, handleStateChangeOnClient)(FocusWatcher);

  var FocusLockCombination = /*#__PURE__*/React.forwardRef(function FocusLockUICombination(props, ref) {
    return /*#__PURE__*/React.createElement(FocusLock$1, _extends$1({
      sideCar: FocusTrap$1,
      ref: ref
    }, props));
  });
  var _ref$1 = FocusLock$1.propTypes || {};
    _ref$1.sideCar;
    _objectWithoutPropertiesLoose$2(_ref$1, ["sideCar"]);
  FocusLockCombination.propTypes = {};

  const FocusTrap = FocusLockCombination.default ?? FocusLockCombination;
  const FocusLock = (props) => {
    const {
      initialFocusRef,
      finalFocusRef,
      contentRef,
      restoreFocus,
      children,
      isDisabled,
      autoFocus,
      persistentFocus,
      lockFocusAcrossFrames
    } = props;
    const onActivation = React.useCallback(() => {
      if (initialFocusRef?.current) {
        initialFocusRef.current.focus();
      } else if (contentRef?.current) {
        const focusables = getAllFocusable(contentRef.current);
        if (focusables.length === 0) {
          requestAnimationFrame(() => {
            contentRef.current?.focus();
          });
        }
      }
    }, [initialFocusRef, contentRef]);
    const onDeactivation = React.useCallback(() => {
      finalFocusRef?.current?.focus();
    }, [finalFocusRef]);
    const returnFocus = restoreFocus && !finalFocusRef;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FocusTrap,
      {
        crossFrame: lockFocusAcrossFrames,
        persistentFocus,
        autoFocus,
        disabled: isDisabled,
        onActivation,
        onDeactivation,
        returnFocus,
        children
      }
    );
  };
  FocusLock.displayName = "FocusLock";

  const FormLabel = forwardRef$1(
    function FormLabel2(passedProps, ref) {
      const styles = useStyleConfig("FormLabel", passedProps);
      const props = omitThemingProps(passedProps);
      const {
        className,
        children,
        requiredIndicator = /* @__PURE__ */ jsxRuntimeExports.jsx(RequiredIndicator, {}),
        optionalIndicator = null,
        ...rest
      } = props;
      const field = useFormControlContext();
      const ownProps = field?.getLabelProps(rest, ref) ?? { ref, ...rest };
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        chakra$1.label,
        {
          ...ownProps,
          className: cx$1("chakra-form__label", props.className),
          __css: {
            display: "block",
            textAlign: "start",
            ...styles
          },
          children: [
            children,
            field?.isRequired ? requiredIndicator : optionalIndicator
          ]
        }
      );
    }
  );
  FormLabel.displayName = "FormLabel";
  const RequiredIndicator = forwardRef$1(
    function RequiredIndicator2(props, ref) {
      const field = useFormControlContext();
      const styles = useFormControlStyles();
      if (!field?.isRequired)
        return null;
      const className = cx$1("chakra-form__required-indicator", props.className);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.span,
        {
          ...field?.getRequiredIndicatorProps(props, ref),
          __css: styles.requiredIndicator,
          className
        }
      );
    }
  );
  RequiredIndicator.displayName = "RequiredIndicator";

  const Grid = forwardRef$1(function Grid2(props, ref) {
    const {
      templateAreas,
      gap,
      rowGap,
      columnGap,
      column,
      row,
      autoFlow,
      autoRows,
      templateRows,
      autoColumns,
      templateColumns,
      ...rest
    } = props;
    const styles = {
      display: "grid",
      gridTemplateAreas: templateAreas,
      gridGap: gap,
      gridRowGap: rowGap,
      gridColumnGap: columnGap,
      gridAutoColumns: autoColumns,
      gridColumn: column,
      gridRow: row,
      gridAutoFlow: autoFlow,
      gridAutoRows: autoRows,
      gridTemplateRows: templateRows,
      gridTemplateColumns: templateColumns
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { ref, __css: styles, ...rest });
  });
  Grid.displayName = "Grid";

  function spanFn(span) {
    return mapResponsive(
      span,
      (value) => value === "auto" ? "auto" : `span ${value}/span ${value}`
    );
  }
  const GridItem = forwardRef$1(
    function GridItem2(props, ref) {
      const {
        area,
        colSpan,
        colStart,
        colEnd,
        rowEnd,
        rowSpan,
        rowStart,
        ...rest
      } = props;
      const styles = compact({
        gridArea: area,
        gridColumn: spanFn(colSpan),
        gridRow: spanFn(rowSpan),
        gridColumnStart: colStart,
        gridColumnEnd: colEnd,
        gridRowStart: rowStart,
        gridRowEnd: rowEnd
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { ref, __css: styles, ...rest });
    }
  );
  GridItem.displayName = "GridItem";

  const Input = forwardRef$1(
    function Input2(props, ref) {
      const { htmlSize, ...rest } = props;
      const styles = useMultiStyleConfig("Input", rest);
      const ownProps = omitThemingProps(rest);
      const input = useFormControl(ownProps);
      const _className = cx$1("chakra-input", props.className);
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.input,
        {
          size: htmlSize,
          ...input,
          __css: styles.field,
          ref,
          className: _className
        }
      );
    }
  );
  Input.displayName = "Input";
  Input.id = "Input";

  function getNextItemFromSearch(items, searchString, itemToString, currentItem) {
    if (searchString == null) {
      return currentItem;
    }
    if (!currentItem) {
      const foundItem = items.find(
        (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
      );
      return foundItem;
    }
    const matchingItems = items.filter(
      (item) => itemToString(item).toLowerCase().startsWith(searchString.toLowerCase())
    );
    if (matchingItems.length > 0) {
      let nextIndex;
      if (matchingItems.includes(currentItem)) {
        const currentIndex = matchingItems.indexOf(currentItem);
        nextIndex = currentIndex + 1;
        if (nextIndex === matchingItems.length) {
          nextIndex = 0;
        }
        return matchingItems[nextIndex];
      }
      nextIndex = items.indexOf(matchingItems[0]);
      return items[nextIndex];
    }
    return currentItem;
  }

  function isPrintableCharacter(event) {
    const { key } = event;
    return key.length === 1 || key.length > 1 && /[^a-zA-Z0-9]/.test(key);
  }
  function useShortcut(props = {}) {
    const { timeout = 300, preventDefault = () => true } = props;
    const [keys, setKeys] = React.useState([]);
    const timeoutRef = React.useRef(void 0);
    const flush = () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
    const clearKeysAfterDelay = () => {
      flush();
      timeoutRef.current = setTimeout(() => {
        setKeys([]);
        timeoutRef.current = null;
      }, timeout);
    };
    React.useEffect(() => flush, []);
    function onKeyDown(fn) {
      return (event) => {
        if (event.key === "Backspace") {
          const keysCopy = [...keys];
          keysCopy.pop();
          setKeys(keysCopy);
          return;
        }
        if (isPrintableCharacter(event)) {
          const keysCopy = keys.concat(event.key);
          if (preventDefault(event)) {
            event.preventDefault();
            event.stopPropagation();
          }
          setKeys(keysCopy);
          fn(keysCopy.join(""));
          clearKeysAfterDelay();
        }
      };
    }
    return onKeyDown;
  }

  var top = 'top';
  var bottom = 'bottom';
  var right = 'right';
  var left = 'left';
  var auto = 'auto';
  var basePlacements = [top, bottom, right, left];
  var start = 'start';
  var end = 'end';
  var clippingParents = 'clippingParents';
  var viewport = 'viewport';
  var popper = 'popper';
  var reference = 'reference';
  var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
    return acc.concat([placement + "-" + start, placement + "-" + end]);
  }, []);
  var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
    return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
  }, []); // modifiers that need to read the DOM

  var beforeRead = 'beforeRead';
  var read = 'read';
  var afterRead = 'afterRead'; // pure-logic modifiers

  var beforeMain = 'beforeMain';
  var main$2 = 'main';
  var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

  var beforeWrite = 'beforeWrite';
  var write = 'write';
  var afterWrite = 'afterWrite';
  var modifierPhases = [beforeRead, read, afterRead, beforeMain, main$2, afterMain, beforeWrite, write, afterWrite];

  function getNodeName(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
  }

  function getWindow(node) {
    if (node == null) {
      return window;
    }

    if (node.toString() !== '[object Window]') {
      var ownerDocument = node.ownerDocument;
      return ownerDocument ? ownerDocument.defaultView || window : window;
    }

    return node;
  }

  function isElement$1(node) {
    var OwnElement = getWindow(node).Element;
    return node instanceof OwnElement || node instanceof Element;
  }

  function isHTMLElement$1(node) {
    var OwnElement = getWindow(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
  }

  function isShadowRoot(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') {
      return false;
    }

    var OwnElement = getWindow(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
  }

  // and applies them to the HTMLElements such as popper and arrow

  function applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function (name) {
      var style = state.styles[name] || {};
      var attributes = state.attributes[name] || {};
      var element = state.elements[name]; // arrow is optional + virtual elements

      if (!isHTMLElement$1(element) || !getNodeName(element)) {
        return;
      } // Flow doesn't support to extend this property, but it's the most
      // effective way to apply styles to an HTMLElement
      // $FlowFixMe[cannot-write]


      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (name) {
        var value = attributes[name];

        if (value === false) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, value === true ? '' : value);
        }
      });
    });
  }

  function effect$3(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    }

    return function () {
      Object.keys(state.elements).forEach(function (name) {
        var element = state.elements[name];
        var attributes = state.attributes[name] || {};
        var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

        var style = styleProperties.reduce(function (style, property) {
          style[property] = '';
          return style;
        }, {}); // arrow is optional + virtual elements

        if (!isHTMLElement$1(element) || !getNodeName(element)) {
          return;
        }

        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function (attribute) {
          element.removeAttribute(attribute);
        });
      });
    };
  } // eslint-disable-next-line import/no-unused-modules


  var applyStyles$1 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: applyStyles,
    effect: effect$3,
    requires: ['computeStyles']
  };

  function getBasePlacement(placement) {
    return placement.split('-')[0];
  }

  var max$2 = Math.max;
  var min$2 = Math.min;
  var round = Math.round;

  function getUAString() {
    var uaData = navigator.userAgentData;

    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
      return uaData.brands.map(function (item) {
        return item.brand + "/" + item.version;
      }).join(' ');
    }

    return navigator.userAgent;
  }

  function isLayoutViewport() {
    return !/^((?!chrome|android).)*safari/i.test(getUAString());
  }

  function getBoundingClientRect(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) {
      includeScale = false;
    }

    if (isFixedStrategy === void 0) {
      isFixedStrategy = false;
    }

    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;

    if (includeScale && isHTMLElement$1(element)) {
      scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
      scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
    }

    var _ref = isElement$1(element) ? getWindow(element) : window,
        visualViewport = _ref.visualViewport;

    var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
      width: width,
      height: height,
      top: y,
      right: x + width,
      bottom: y + height,
      left: x,
      x: x,
      y: y
    };
  }

  // means it doesn't take into account transforms.

  function getLayoutRect(element) {
    var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223

    var width = element.offsetWidth;
    var height = element.offsetHeight;

    if (Math.abs(clientRect.width - width) <= 1) {
      width = clientRect.width;
    }

    if (Math.abs(clientRect.height - height) <= 1) {
      height = clientRect.height;
    }

    return {
      x: element.offsetLeft,
      y: element.offsetTop,
      width: width,
      height: height
    };
  }

  function contains$1(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

    if (parent.contains(child)) {
      return true;
    } // then fallback to custom implementation with Shadow DOM support
    else if (rootNode && isShadowRoot(rootNode)) {
        var next = child;

        do {
          if (next && parent.isSameNode(next)) {
            return true;
          } // $FlowFixMe[prop-missing]: need a better way to handle this...


          next = next.parentNode || next.host;
        } while (next);
      } // Give up, the result is false


    return false;
  }

  function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
  }

  function isTableElement(element) {
    return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
  }

  function getDocumentElement(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
    element.document) || window.document).documentElement;
  }

  function getParentNode(element) {
    if (getNodeName(element) === 'html') {
      return element;
    }

    return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
      // $FlowFixMe[incompatible-return]
      // $FlowFixMe[prop-missing]
      element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
      element.parentNode || ( // DOM Element detected
      isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
      // $FlowFixMe[incompatible-call]: HTMLElement is a Node
      getDocumentElement(element) // fallback

    );
  }

  function getTrueOffsetParent(element) {
    if (!isHTMLElement$1(element) || // https://github.com/popperjs/popper-core/issues/837
    getComputedStyle$1(element).position === 'fixed') {
      return null;
    }

    return element.offsetParent;
  } // `.offsetParent` reports `null` for fixed elements, while absolute elements
  // return the containing block


  function getContainingBlock(element) {
    var isFirefox = /firefox/i.test(getUAString());
    var isIE = /Trident/i.test(getUAString());

    if (isIE && isHTMLElement$1(element)) {
      // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
      var elementCss = getComputedStyle$1(element);

      if (elementCss.position === 'fixed') {
        return null;
      }
    }

    var currentNode = getParentNode(element);

    if (isShadowRoot(currentNode)) {
      currentNode = currentNode.host;
    }

    while (isHTMLElement$1(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
      var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
      // create a containing block.
      // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

      if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
        return currentNode;
      } else {
        currentNode = currentNode.parentNode;
      }
    }

    return null;
  } // Gets the closest ancestor positioned element. Handles some edge cases,
  // such as table ancestors and cross browser bugs.


  function getOffsetParent(element) {
    var window = getWindow(element);
    var offsetParent = getTrueOffsetParent(element);

    while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
      offsetParent = getTrueOffsetParent(offsetParent);
    }

    if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
      return window;
    }

    return offsetParent || getContainingBlock(element) || window;
  }

  function getMainAxisFromPlacement(placement) {
    return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
  }

  function within(min, value, max) {
    return max$2(min, min$2(value, max));
  }
  function withinMaxClamp(min, value, max) {
    var v = within(min, value, max);
    return v > max ? max : v;
  }

  function getFreshSideObject() {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    };
  }

  function mergePaddingObject(paddingObject) {
    return Object.assign({}, getFreshSideObject(), paddingObject);
  }

  function expandToHashMap(value, keys) {
    return keys.reduce(function (hashMap, key) {
      hashMap[key] = value;
      return hashMap;
    }, {});
  }

  var toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
      placement: state.placement
    })) : padding;
    return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  };

  function arrow(_ref) {
    var _state$modifiersData$;

    var state = _ref.state,
        name = _ref.name,
        options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = getBasePlacement(state.placement);
    var axis = getMainAxisFromPlacement(basePlacement);
    var isVertical = [left, right].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';

    if (!arrowElement || !popperOffsets) {
      return;
    }

    var paddingObject = toPaddingObject(options.padding, state);
    var arrowRect = getLayoutRect(arrowElement);
    var minProp = axis === 'y' ? top : left;
    var maxProp = axis === 'y' ? bottom : right;
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = getOffsetParent(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds

    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = within(min, center, max); // Prevents breaking syntax highlighting...

    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
  }

  function effect$2(_ref2) {
    var state = _ref2.state,
        options = _ref2.options;
    var _options$element = options.element,
        arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

    if (arrowElement == null) {
      return;
    } // CSS selector


    if (typeof arrowElement === 'string') {
      arrowElement = state.elements.popper.querySelector(arrowElement);

      if (!arrowElement) {
        return;
      }
    }

    if (!contains$1(state.elements.popper, arrowElement)) {
      return;
    }

    state.elements.arrow = arrowElement;
  } // eslint-disable-next-line import/no-unused-modules


  var arrow$1 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: arrow,
    effect: effect$2,
    requires: ['popperOffsets'],
    requiresIfExists: ['preventOverflow']
  };

  function getVariation(placement) {
    return placement.split('-')[1];
  }

  var unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
  }; // Round the offsets to the nearest suitable subpixel based on the DPR.
  // Zooming can change the DPR, but it seems to report a value that will
  // cleanly divide the values into the appropriate subpixels.

  function roundOffsetsByDPR(_ref, win) {
    var x = _ref.x,
        y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
      x: round(x * dpr) / dpr || 0,
      y: round(y * dpr) / dpr || 0
    };
  }

  function mapToStyles(_ref2) {
    var _Object$assign2;

    var popper = _ref2.popper,
        popperRect = _ref2.popperRect,
        placement = _ref2.placement,
        variation = _ref2.variation,
        offsets = _ref2.offsets,
        position = _ref2.position,
        gpuAcceleration = _ref2.gpuAcceleration,
        adaptive = _ref2.adaptive,
        roundOffsets = _ref2.roundOffsets,
        isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x,
        x = _offsets$x === void 0 ? 0 : _offsets$x,
        _offsets$y = offsets.y,
        y = _offsets$y === void 0 ? 0 : _offsets$y;

    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
      x: x,
      y: y
    }) : {
      x: x,
      y: y
    };

    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = left;
    var sideY = top;
    var win = window;

    if (adaptive) {
      var offsetParent = getOffsetParent(popper);
      var heightProp = 'clientHeight';
      var widthProp = 'clientWidth';

      if (offsetParent === getWindow(popper)) {
        offsetParent = getDocumentElement(popper);

        if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
          heightProp = 'scrollHeight';
          widthProp = 'scrollWidth';
        }
      } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


      offsetParent = offsetParent;

      if (placement === top || (placement === left || placement === right) && variation === end) {
        sideY = bottom;
        var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
        offsetParent[heightProp];
        y -= offsetY - popperRect.height;
        y *= gpuAcceleration ? 1 : -1;
      }

      if (placement === left || (placement === top || placement === bottom) && variation === end) {
        sideX = right;
        var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
        offsetParent[widthProp];
        x -= offsetX - popperRect.width;
        x *= gpuAcceleration ? 1 : -1;
      }
    }

    var commonStyles = Object.assign({
      position: position
    }, adaptive && unsetSides);

    var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
      x: x,
      y: y
    }, getWindow(popper)) : {
      x: x,
      y: y
    };

    x = _ref4.x;
    y = _ref4.y;

    if (gpuAcceleration) {
      var _Object$assign;

      return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }

    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
  }

  function computeStyles(_ref5) {
    var state = _ref5.state,
        options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration,
        gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
        _options$adaptive = options.adaptive,
        adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
        _options$roundOffsets = options.roundOffsets,
        roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
      placement: getBasePlacement(state.placement),
      variation: getVariation(state.placement),
      popper: state.elements.popper,
      popperRect: state.rects.popper,
      gpuAcceleration: gpuAcceleration,
      isFixed: state.options.strategy === 'fixed'
    };

    if (state.modifiersData.popperOffsets != null) {
      state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
      })));
    }

    if (state.modifiersData.arrow != null) {
      state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
      })));
    }

    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-placement': state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var computeStyles$1 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: computeStyles,
    data: {}
  };

  var passive = {
    passive: true
  };

  function effect$1(_ref) {
    var state = _ref.state,
        instance = _ref.instance,
        options = _ref.options;
    var _options$scroll = options.scroll,
        scroll = _options$scroll === void 0 ? true : _options$scroll,
        _options$resize = options.resize,
        resize = _options$resize === void 0 ? true : _options$resize;
    var window = getWindow(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.addEventListener('resize', instance.update, passive);
    }

    return function () {
      if (scroll) {
        scrollParents.forEach(function (scrollParent) {
          scrollParent.removeEventListener('scroll', instance.update, passive);
        });
      }

      if (resize) {
        window.removeEventListener('resize', instance.update, passive);
      }
    };
  } // eslint-disable-next-line import/no-unused-modules


  var eventListeners = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: effect$1,
    data: {}
  };

  var hash$1 = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
  };
  function getOppositePlacement(placement) {
    return placement.replace(/left|right|bottom|top/g, function (matched) {
      return hash$1[matched];
    });
  }

  var hash = {
    start: 'end',
    end: 'start'
  };
  function getOppositeVariationPlacement(placement) {
    return placement.replace(/start|end/g, function (matched) {
      return hash[matched];
    });
  }

  function getWindowScroll(node) {
    var win = getWindow(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  function getWindowScrollBarX(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
  }

  function getViewportRect(element, strategy) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;

    if (visualViewport) {
      width = visualViewport.width;
      height = visualViewport.height;
      var layoutViewport = isLayoutViewport();

      if (layoutViewport || !layoutViewport && strategy === 'fixed') {
        x = visualViewport.offsetLeft;
        y = visualViewport.offsetTop;
      }
    }

    return {
      width: width,
      height: height,
      x: x + getWindowScrollBarX(element),
      y: y
    };
  }

  // of the `<html>` and `<body>` rect bounds if horizontally scrollable

  function getDocumentRect(element) {
    var _element$ownerDocumen;

    var html = getDocumentElement(element);
    var winScroll = getWindowScroll(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = max$2(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = max$2(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
    var y = -winScroll.scrollTop;

    if (getComputedStyle$1(body || html).direction === 'rtl') {
      x += max$2(html.clientWidth, body ? body.clientWidth : 0) - width;
    }

    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  }

  function isScrollParent(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = getComputedStyle$1(element),
        overflow = _getComputedStyle.overflow,
        overflowX = _getComputedStyle.overflowX,
        overflowY = _getComputedStyle.overflowY;

    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
  }

  function getScrollParent(node) {
    if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
      // $FlowFixMe[incompatible-return]: assume body is always available
      return node.ownerDocument.body;
    }

    if (isHTMLElement$1(node) && isScrollParent(node)) {
      return node;
    }

    return getScrollParent(getParentNode(node));
  }

  /*
  given a DOM element, return the list of all scroll parents, up the list of ancesors
  until we get to the top window object. This list is what we attach scroll listeners
  to, because if any of these parent elements scroll, we'll need to re-calculate the
  reference element's position.
  */

  function listScrollParents(element, list) {
    var _element$ownerDocumen;

    if (list === void 0) {
      list = [];
    }

    var scrollParent = getScrollParent(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = getWindow(scrollParent);
    var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    updatedList.concat(listScrollParents(getParentNode(target)));
  }

  function rectToClientRect(rect) {
    return Object.assign({}, rect, {
      left: rect.x,
      top: rect.y,
      right: rect.x + rect.width,
      bottom: rect.y + rect.height
    });
  }

  function getInnerBoundingClientRect(element, strategy) {
    var rect = getBoundingClientRect(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
  }

  function getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
  } // A "clipping parent" is an overflowable container with the characteristic of
  // clipping (or hiding) overflowing elements with a position different from
  // `initial`


  function getClippingParents(element) {
    var clippingParents = listScrollParents(getParentNode(element));
    var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
    var clipperElement = canEscapeClipping && isHTMLElement$1(element) ? getOffsetParent(element) : element;

    if (!isElement$1(clipperElement)) {
      return [];
    } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


    return clippingParents.filter(function (clippingParent) {
      return isElement$1(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
    });
  } // Gets the maximum area that the element is visible in due to any number of
  // clipping parents


  function getClippingRect(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
      var rect = getClientRectFromMixedType(element, clippingParent, strategy);
      accRect.top = max$2(rect.top, accRect.top);
      accRect.right = min$2(rect.right, accRect.right);
      accRect.bottom = min$2(rect.bottom, accRect.bottom);
      accRect.left = max$2(rect.left, accRect.left);
      return accRect;
    }, getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
  }

  function computeOffsets(_ref) {
    var reference = _ref.reference,
        element = _ref.element,
        placement = _ref.placement;
    var basePlacement = placement ? getBasePlacement(placement) : null;
    var variation = placement ? getVariation(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;

    switch (basePlacement) {
      case top:
        offsets = {
          x: commonX,
          y: reference.y - element.height
        };
        break;

      case bottom:
        offsets = {
          x: commonX,
          y: reference.y + reference.height
        };
        break;

      case right:
        offsets = {
          x: reference.x + reference.width,
          y: commonY
        };
        break;

      case left:
        offsets = {
          x: reference.x - element.width,
          y: commonY
        };
        break;

      default:
        offsets = {
          x: reference.x,
          y: reference.y
        };
    }

    var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

    if (mainAxis != null) {
      var len = mainAxis === 'y' ? 'height' : 'width';

      switch (variation) {
        case start:
          offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
          break;

        case end:
          offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
          break;
      }
    }

    return offsets;
  }

  function detectOverflow(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        _options$placement = _options.placement,
        placement = _options$placement === void 0 ? state.placement : _options$placement,
        _options$strategy = _options.strategy,
        strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
        _options$boundary = _options.boundary,
        boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
        _options$rootBoundary = _options.rootBoundary,
        rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
        _options$elementConte = _options.elementContext,
        elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
        _options$altBoundary = _options.altBoundary,
        altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
        _options$padding = _options.padding,
        padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
    var altContext = elementContext === popper ? reference : popper;
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = getBoundingClientRect(state.elements.reference);
    var popperOffsets = computeOffsets({
      reference: referenceClientRect,
      element: popperRect,
      placement: placement
    });
    var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect

    var overflowOffsets = {
      top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
      bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
      left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
      right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

    if (elementContext === popper && offsetData) {
      var offset = offsetData[placement];
      Object.keys(overflowOffsets).forEach(function (key) {
        var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
        var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
        overflowOffsets[key] += offset[axis] * multiply;
      });
    }

    return overflowOffsets;
  }

  function computeAutoPlacement(state, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        placement = _options.placement,
        boundary = _options.boundary,
        rootBoundary = _options.rootBoundary,
        padding = _options.padding,
        flipVariations = _options.flipVariations,
        _options$allowedAutoP = _options.allowedAutoPlacements,
        allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
    var variation = getVariation(placement);
    var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
      return getVariation(placement) === variation;
    }) : basePlacements;
    var allowedPlacements = placements$1.filter(function (placement) {
      return allowedAutoPlacements.indexOf(placement) >= 0;
    });

    if (allowedPlacements.length === 0) {
      allowedPlacements = placements$1;
    } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


    var overflows = allowedPlacements.reduce(function (acc, placement) {
      acc[placement] = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding
      })[getBasePlacement(placement)];
      return acc;
    }, {});
    return Object.keys(overflows).sort(function (a, b) {
      return overflows[a] - overflows[b];
    });
  }

  function getExpandedFallbackPlacements(placement) {
    if (getBasePlacement(placement) === auto) {
      return [];
    }

    var oppositePlacement = getOppositePlacement(placement);
    return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
  }

  function flip(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;

    if (state.modifiersData[name]._skip) {
      return;
    }

    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
        specifiedFallbackPlacements = options.fallbackPlacements,
        padding = options.padding,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        _options$flipVariatio = options.flipVariations,
        flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
        allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = getBasePlacement(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
    var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
      return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        flipVariations: flipVariations,
        allowedAutoPlacements: allowedAutoPlacements
      }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];

    for (var i = 0; i < placements.length; i++) {
      var placement = placements[i];

      var _basePlacement = getBasePlacement(placement);

      var isStartVariation = getVariation(placement) === start;
      var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
      var len = isVertical ? 'width' : 'height';
      var overflow = detectOverflow(state, {
        placement: placement,
        boundary: boundary,
        rootBoundary: rootBoundary,
        altBoundary: altBoundary,
        padding: padding
      });
      var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

      if (referenceRect[len] > popperRect[len]) {
        mainVariationSide = getOppositePlacement(mainVariationSide);
      }

      var altVariationSide = getOppositePlacement(mainVariationSide);
      var checks = [];

      if (checkMainAxis) {
        checks.push(overflow[_basePlacement] <= 0);
      }

      if (checkAltAxis) {
        checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
      }

      if (checks.every(function (check) {
        return check;
      })) {
        firstFittingPlacement = placement;
        makeFallbackChecks = false;
        break;
      }

      checksMap.set(placement, checks);
    }

    if (makeFallbackChecks) {
      // `2` may be desired in some cases – research later
      var numberOfChecks = flipVariations ? 3 : 1;

      var _loop = function _loop(_i) {
        var fittingPlacement = placements.find(function (placement) {
          var checks = checksMap.get(placement);

          if (checks) {
            return checks.slice(0, _i).every(function (check) {
              return check;
            });
          }
        });

        if (fittingPlacement) {
          firstFittingPlacement = fittingPlacement;
          return "break";
        }
      };

      for (var _i = numberOfChecks; _i > 0; _i--) {
        var _ret = _loop(_i);

        if (_ret === "break") break;
      }
    }

    if (state.placement !== firstFittingPlacement) {
      state.modifiersData[name]._skip = true;
      state.placement = firstFittingPlacement;
      state.reset = true;
    }
  } // eslint-disable-next-line import/no-unused-modules


  var flip$1 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: flip,
    requiresIfExists: ['offset'],
    data: {
      _skip: false
    }
  };

  function getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) {
      preventedOffsets = {
        x: 0,
        y: 0
      };
    }

    return {
      top: overflow.top - rect.height - preventedOffsets.y,
      right: overflow.right - rect.width + preventedOffsets.x,
      bottom: overflow.bottom - rect.height + preventedOffsets.y,
      left: overflow.left - rect.width - preventedOffsets.x
    };
  }

  function isAnySideFullyClipped(overflow) {
    return [top, right, bottom, left].some(function (side) {
      return overflow[side] >= 0;
    });
  }

  function hide(_ref) {
    var state = _ref.state,
        name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = detectOverflow(state, {
      elementContext: 'reference'
    });
    var popperAltOverflow = detectOverflow(state, {
      altBoundary: true
    });
    var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
      referenceClippingOffsets: referenceClippingOffsets,
      popperEscapeOffsets: popperEscapeOffsets,
      isReferenceHidden: isReferenceHidden,
      hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
      'data-popper-reference-hidden': isReferenceHidden,
      'data-popper-escaped': hasPopperEscaped
    });
  } // eslint-disable-next-line import/no-unused-modules


  var hide$1 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: ['preventOverflow'],
    fn: hide
  };

  function distanceAndSkiddingToXY(placement, rects, offset) {
    var basePlacement = getBasePlacement(placement);
    var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
      placement: placement
    })) : offset,
        skidding = _ref[0],
        distance = _ref[1];

    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [left, right].indexOf(basePlacement) >= 0 ? {
      x: distance,
      y: skidding
    } : {
      x: skidding,
      y: distance
    };
  }

  function offset(_ref2) {
    var state = _ref2.state,
        options = _ref2.options,
        name = _ref2.name;
    var _options$offset = options.offset,
        offset = _options$offset === void 0 ? [0, 0] : _options$offset;
    var data = placements.reduce(function (acc, placement) {
      acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
      return acc;
    }, {});
    var _data$state$placement = data[state.placement],
        x = _data$state$placement.x,
        y = _data$state$placement.y;

    if (state.modifiersData.popperOffsets != null) {
      state.modifiersData.popperOffsets.x += x;
      state.modifiersData.popperOffsets.y += y;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var offset$1 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: ['popperOffsets'],
    fn: offset
  };

  function popperOffsets(_ref) {
    var state = _ref.state,
        name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = computeOffsets({
      reference: state.rects.reference,
      element: state.rects.popper,
      placement: state.placement
    });
  } // eslint-disable-next-line import/no-unused-modules


  var popperOffsets$1 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: popperOffsets,
    data: {}
  };

  function getAltAxis(axis) {
    return axis === 'x' ? 'y' : 'x';
  }

  function preventOverflow(_ref) {
    var state = _ref.state,
        options = _ref.options,
        name = _ref.name;
    var _options$mainAxis = options.mainAxis,
        checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
        _options$altAxis = options.altAxis,
        checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
        boundary = options.boundary,
        rootBoundary = options.rootBoundary,
        altBoundary = options.altBoundary,
        padding = options.padding,
        _options$tether = options.tether,
        tether = _options$tether === void 0 ? true : _options$tether,
        _options$tetherOffset = options.tetherOffset,
        tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = detectOverflow(state, {
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      altBoundary: altBoundary
    });
    var basePlacement = getBasePlacement(state.placement);
    var variation = getVariation(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = getMainAxisFromPlacement(basePlacement);
    var altAxis = getAltAxis(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
      placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
      mainAxis: tetherOffsetValue,
      altAxis: tetherOffsetValue
    } : Object.assign({
      mainAxis: 0,
      altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
      x: 0,
      y: 0
    };

    if (!popperOffsets) {
      return;
    }

    if (checkMainAxis) {
      var _offsetModifierState$;

      var mainSide = mainAxis === 'y' ? top : left;
      var altSide = mainAxis === 'y' ? bottom : right;
      var len = mainAxis === 'y' ? 'height' : 'width';
      var offset = popperOffsets[mainAxis];
      var min = offset + overflow[mainSide];
      var max = offset - overflow[altSide];
      var additive = tether ? -popperRect[len] / 2 : 0;
      var minLen = variation === start ? referenceRect[len] : popperRect[len];
      var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
      // outside the reference bounds

      var arrowElement = state.elements.arrow;
      var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
        width: 0,
        height: 0
      };
      var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
      var arrowPaddingMin = arrowPaddingObject[mainSide];
      var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
      // to include its full size in the calculation. If the reference is small
      // and near the edge of a boundary, the popper can overflow even if the
      // reference is not overflowing as well (e.g. virtual elements with no
      // width or height)

      var arrowLen = within(0, referenceRect[len], arrowRect[len]);
      var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
      var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
      var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
      var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
      var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
      var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
      var tetherMax = offset + maxOffset - offsetModifierValue;
      var preventedOffset = within(tether ? min$2(min, tetherMin) : min, offset, tether ? max$2(max, tetherMax) : max);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _offsetModifierState$2;

      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _len = altAxis === 'y' ? 'height' : 'width';

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

      var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

      var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

      var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

      var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }

    state.modifiersData[name] = data;
  } // eslint-disable-next-line import/no-unused-modules


  var preventOverflow$1 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: preventOverflow,
    requiresIfExists: ['offset']
  };

  function getHTMLElementScroll(element) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }

  function getNodeScroll(node) {
    if (node === getWindow(node) || !isHTMLElement$1(node)) {
      return getWindowScroll(node);
    } else {
      return getHTMLElementScroll(node);
    }
  }

  function isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = round(rect.width) / element.offsetWidth || 1;
    var scaleY = round(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
  } // Returns the composite rect of an element relative to its offsetParent.
  // Composite means it takes into account transforms as well as layout.


  function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) {
      isFixed = false;
    }

    var isOffsetParentAnElement = isHTMLElement$1(offsetParent);
    var offsetParentIsScaled = isHTMLElement$1(offsetParent) && isElementScaled(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
      scrollLeft: 0,
      scrollTop: 0
    };
    var offsets = {
      x: 0,
      y: 0
    };

    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
      if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
      isScrollParent(documentElement)) {
        scroll = getNodeScroll(offsetParent);
      }

      if (isHTMLElement$1(offsetParent)) {
        offsets = getBoundingClientRect(offsetParent, true);
        offsets.x += offsetParent.clientLeft;
        offsets.y += offsetParent.clientTop;
      } else if (documentElement) {
        offsets.x = getWindowScrollBarX(documentElement);
      }
    }

    return {
      x: rect.left + scroll.scrollLeft - offsets.x,
      y: rect.top + scroll.scrollTop - offsets.y,
      width: rect.width,
      height: rect.height
    };
  }

  function order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function (modifier) {
      map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively

    function sort(modifier) {
      visited.add(modifier.name);
      var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
      requires.forEach(function (dep) {
        if (!visited.has(dep)) {
          var depModifier = map.get(dep);

          if (depModifier) {
            sort(depModifier);
          }
        }
      });
      result.push(modifier);
    }

    modifiers.forEach(function (modifier) {
      if (!visited.has(modifier.name)) {
        // check for visited object
        sort(modifier);
      }
    });
    return result;
  }

  function orderModifiers(modifiers) {
    // order based on dependencies
    var orderedModifiers = order(modifiers); // order based on phase

    return modifierPhases.reduce(function (acc, phase) {
      return acc.concat(orderedModifiers.filter(function (modifier) {
        return modifier.phase === phase;
      }));
    }, []);
  }

  function debounce(fn) {
    var pending;
    return function () {
      if (!pending) {
        pending = new Promise(function (resolve) {
          Promise.resolve().then(function () {
            pending = undefined;
            resolve(fn());
          });
        });
      }

      return pending;
    };
  }

  function mergeByName(modifiers) {
    var merged = modifiers.reduce(function (merged, current) {
      var existing = merged[current.name];
      merged[current.name] = existing ? Object.assign({}, existing, current, {
        options: Object.assign({}, existing.options, current.options),
        data: Object.assign({}, existing.data, current.data)
      }) : current;
      return merged;
    }, {}); // IE11 does not support Object.values

    return Object.keys(merged).map(function (key) {
      return merged[key];
    });
  }

  var DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
  };

  function areValidElements() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return !args.some(function (element) {
      return !(element && typeof element.getBoundingClientRect === 'function');
    });
  }

  function popperGenerator(generatorOptions) {
    if (generatorOptions === void 0) {
      generatorOptions = {};
    }

    var _generatorOptions = generatorOptions,
        _generatorOptions$def = _generatorOptions.defaultModifiers,
        defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
        _generatorOptions$def2 = _generatorOptions.defaultOptions,
        defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
      if (options === void 0) {
        options = defaultOptions;
      }

      var state = {
        placement: 'bottom',
        orderedModifiers: [],
        options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
        modifiersData: {},
        elements: {
          reference: reference,
          popper: popper
        },
        attributes: {},
        styles: {}
      };
      var effectCleanupFns = [];
      var isDestroyed = false;
      var instance = {
        state: state,
        setOptions: function setOptions(setOptionsAction) {
          var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
          cleanupModifierEffects();
          state.options = Object.assign({}, defaultOptions, state.options, options);
          state.scrollParents = {
            reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
            popper: listScrollParents(popper)
          }; // Orders the modifiers based on their dependencies and `phase`
          // properties

          var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

          state.orderedModifiers = orderedModifiers.filter(function (m) {
            return m.enabled;
          });
          runModifierEffects();
          return instance.update();
        },
        // Sync update – it will always be executed, even if not necessary. This
        // is useful for low frequency updates where sync behavior simplifies the
        // logic.
        // For high frequency updates (e.g. `resize` and `scroll` events), always
        // prefer the async Popper#update method
        forceUpdate: function forceUpdate() {
          if (isDestroyed) {
            return;
          }

          var _state$elements = state.elements,
              reference = _state$elements.reference,
              popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
          // anymore

          if (!areValidElements(reference, popper)) {
            return;
          } // Store the reference and popper rects to be read by modifiers


          state.rects = {
            reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
            popper: getLayoutRect(popper)
          }; // Modifiers have the ability to reset the current update cycle. The
          // most common use case for this is the `flip` modifier changing the
          // placement, which then needs to re-run all the modifiers, because the
          // logic was previously ran for the previous placement and is therefore
          // stale/incorrect

          state.reset = false;
          state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
          // is filled with the initial data specified by the modifier. This means
          // it doesn't persist and is fresh on each update.
          // To ensure persistent data, use `${name}#persistent`

          state.orderedModifiers.forEach(function (modifier) {
            return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
          });

          for (var index = 0; index < state.orderedModifiers.length; index++) {
            if (state.reset === true) {
              state.reset = false;
              index = -1;
              continue;
            }

            var _state$orderedModifie = state.orderedModifiers[index],
                fn = _state$orderedModifie.fn,
                _state$orderedModifie2 = _state$orderedModifie.options,
                _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
                name = _state$orderedModifie.name;

            if (typeof fn === 'function') {
              state = fn({
                state: state,
                options: _options,
                name: name,
                instance: instance
              }) || state;
            }
          }
        },
        // Async and optimistically optimized update – it will not be executed if
        // not necessary (debounced to run at most once-per-tick)
        update: debounce(function () {
          return new Promise(function (resolve) {
            instance.forceUpdate();
            resolve(state);
          });
        }),
        destroy: function destroy() {
          cleanupModifierEffects();
          isDestroyed = true;
        }
      };

      if (!areValidElements(reference, popper)) {
        return instance;
      }

      instance.setOptions(options).then(function (state) {
        if (!isDestroyed && options.onFirstUpdate) {
          options.onFirstUpdate(state);
        }
      }); // Modifiers have the ability to execute arbitrary code before the first
      // update cycle runs. They will be executed in the same order as the update
      // cycle. This is useful when a modifier adds some persistent data that
      // other modifiers need to use, but the modifier is run after the dependent
      // one.

      function runModifierEffects() {
        state.orderedModifiers.forEach(function (_ref) {
          var name = _ref.name,
              _ref$options = _ref.options,
              options = _ref$options === void 0 ? {} : _ref$options,
              effect = _ref.effect;

          if (typeof effect === 'function') {
            var cleanupFn = effect({
              state: state,
              name: name,
              instance: instance,
              options: options
            });

            var noopFn = function noopFn() {};

            effectCleanupFns.push(cleanupFn || noopFn);
          }
        });
      }

      function cleanupModifierEffects() {
        effectCleanupFns.forEach(function (fn) {
          return fn();
        });
        effectCleanupFns = [];
      }

      return instance;
    };
  }

  var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
  var createPopper = /*#__PURE__*/popperGenerator({
    defaultModifiers: defaultModifiers
  }); // eslint-disable-next-line import/no-unused-modules

  const toVar = (value, fallback) => ({
    var: value,
    varRef: fallback ? `var(${value}, ${fallback})` : `var(${value})`
  });
  const cssVars = {
    arrowShadowColor: toVar("--popper-arrow-shadow-color"),
    arrowSize: toVar("--popper-arrow-size", "8px"),
    arrowSizeHalf: toVar("--popper-arrow-size-half"),
    arrowBg: toVar("--popper-arrow-bg"),
    transformOrigin: toVar("--popper-transform-origin"),
    arrowOffset: toVar("--popper-arrow-offset")
  };
  function getBoxShadow(placement) {
    if (placement.includes("top"))
      return `1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("bottom"))
      return `-1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("right"))
      return `-1px 1px 0px 0 var(--popper-arrow-shadow-color)`;
    if (placement.includes("left"))
      return `1px -1px 0px 0 var(--popper-arrow-shadow-color)`;
  }
  const transforms = {
    top: "bottom center",
    "top-start": "bottom left",
    "top-end": "bottom right",
    bottom: "top center",
    "bottom-start": "top left",
    "bottom-end": "top right",
    left: "right center",
    "left-start": "right top",
    "left-end": "right bottom",
    right: "left center",
    "right-start": "left top",
    "right-end": "left bottom"
  };
  const toTransformOrigin = (placement) => transforms[placement];
  const defaultEventListeners = {
    scroll: true,
    resize: true
  };
  function getEventListenerOptions(value) {
    let eventListeners;
    if (typeof value === "object") {
      eventListeners = {
        enabled: true,
        options: { ...defaultEventListeners, ...value }
      };
    } else {
      eventListeners = {
        enabled: value,
        options: defaultEventListeners
      };
    }
    return eventListeners;
  }

  const matchWidth = {
    name: "matchWidth",
    enabled: true,
    phase: "beforeWrite",
    requires: ["computeStyles"],
    fn: ({ state }) => {
      state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => () => {
      const reference = state.elements.reference;
      state.elements.popper.style.width = `${reference.offsetWidth}px`;
    }
  };
  const transformOrigin = {
    name: "transformOrigin",
    enabled: true,
    phase: "write",
    fn: ({ state }) => {
      setTransformOrigin(state);
    },
    effect: ({ state }) => () => {
      setTransformOrigin(state);
    }
  };
  const setTransformOrigin = (state) => {
    state.elements.popper.style.setProperty(
      cssVars.transformOrigin.var,
      toTransformOrigin(state.placement)
    );
  };
  const positionArrow = {
    name: "positionArrow",
    enabled: true,
    phase: "afterWrite",
    fn: ({ state }) => {
      setArrowStyles(state);
    }
  };
  const setArrowStyles = (state) => {
    if (!state.placement)
      return;
    const overrides = getArrowStyle$1(state.placement);
    if (state.elements?.arrow && overrides) {
      Object.assign(state.elements.arrow.style, {
        [overrides.property]: overrides.value,
        width: cssVars.arrowSize.varRef,
        height: cssVars.arrowSize.varRef,
        zIndex: -1
      });
      const vars = {
        [cssVars.arrowSizeHalf.var]: `calc(${cssVars.arrowSize.varRef} / 2 - 1px)`,
        [cssVars.arrowOffset.var]: `calc(${cssVars.arrowSizeHalf.varRef} * -1)`
      };
      for (const property in vars) {
        state.elements.arrow.style.setProperty(property, vars[property]);
      }
    }
  };
  const getArrowStyle$1 = (placement) => {
    if (placement.startsWith("top")) {
      return { property: "bottom", value: cssVars.arrowOffset.varRef };
    }
    if (placement.startsWith("bottom")) {
      return { property: "top", value: cssVars.arrowOffset.varRef };
    }
    if (placement.startsWith("left")) {
      return { property: "right", value: cssVars.arrowOffset.varRef };
    }
    if (placement.startsWith("right")) {
      return { property: "left", value: cssVars.arrowOffset.varRef };
    }
  };
  const innerArrow = {
    name: "innerArrow",
    enabled: true,
    phase: "main",
    requires: ["arrow"],
    fn: ({ state }) => {
      setInnerArrowStyles(state);
    },
    effect: ({ state }) => () => {
      setInnerArrowStyles(state);
    }
  };
  const setInnerArrowStyles = (state) => {
    if (!state.elements.arrow)
      return;
    const inner = state.elements.arrow.querySelector(
      "[data-popper-arrow-inner]"
    );
    if (!inner)
      return;
    const boxShadow = getBoxShadow(state.placement);
    if (boxShadow) {
      inner.style.setProperty("--popper-arrow-default-shadow", boxShadow);
    }
    Object.assign(inner.style, {
      transform: "rotate(45deg)",
      background: cssVars.arrowBg.varRef,
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      position: "absolute",
      zIndex: "inherit",
      boxShadow: `var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))`
    });
  };

  const logicals = {
    "start-start": { ltr: "left-start", rtl: "right-start" },
    "start-end": { ltr: "left-end", rtl: "right-end" },
    "end-start": { ltr: "right-start", rtl: "left-start" },
    "end-end": { ltr: "right-end", rtl: "left-end" },
    start: { ltr: "left", rtl: "right" },
    end: { ltr: "right", rtl: "left" }
  };
  const opposites = {
    "auto-start": "auto-end",
    "auto-end": "auto-start",
    "top-start": "top-end",
    "top-end": "top-start",
    "bottom-start": "bottom-end",
    "bottom-end": "bottom-start"
  };
  function getPopperPlacement(placement, dir = "ltr") {
    const value = logicals[placement]?.[dir] || placement;
    if (dir === "ltr")
      return value;
    return opposites[placement] ?? value;
  }

  function usePopper$1(props = {}) {
    const {
      enabled = true,
      modifiers,
      placement: placementProp = "bottom",
      strategy = "absolute",
      arrowPadding = 8,
      eventListeners = true,
      offset,
      gutter = 8,
      flip = true,
      boundary = "clippingParents",
      preventOverflow = true,
      matchWidth: matchWidth$1,
      direction = "ltr"
    } = props;
    const reference = React.useRef(null);
    const popper = React.useRef(null);
    const instance = React.useRef(null);
    const placement = getPopperPlacement(placementProp, direction);
    const cleanup = React.useRef(() => {
    });
    const setupPopper = React.useCallback(() => {
      if (!enabled || !reference.current || !popper.current)
        return;
      cleanup.current?.();
      instance.current = createPopper(reference.current, popper.current, {
        placement,
        modifiers: [
          innerArrow,
          positionArrow,
          transformOrigin,
          {
            ...matchWidth,
            enabled: !!matchWidth$1
          },
          {
            name: "eventListeners",
            ...getEventListenerOptions(eventListeners)
          },
          {
            name: "arrow",
            options: { padding: arrowPadding }
          },
          {
            name: "offset",
            options: {
              offset: offset ?? [0, gutter]
            }
          },
          {
            name: "flip",
            enabled: !!flip,
            options: { padding: 8 }
          },
          {
            name: "preventOverflow",
            enabled: !!preventOverflow,
            options: { boundary }
          },
          // allow users override internal modifiers
          ...modifiers ?? []
        ],
        strategy
      });
      instance.current.forceUpdate();
      cleanup.current = instance.current.destroy;
    }, [
      placement,
      enabled,
      modifiers,
      matchWidth$1,
      eventListeners,
      arrowPadding,
      offset,
      gutter,
      flip,
      preventOverflow,
      boundary,
      strategy
    ]);
    React.useEffect(() => {
      return () => {
        if (!reference.current && !popper.current) {
          instance.current?.destroy();
          instance.current = null;
        }
      };
    }, []);
    const referenceRef = React.useCallback(
      (node) => {
        reference.current = node;
        setupPopper();
      },
      [setupPopper]
    );
    const getReferenceProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        ref: mergeRefs(referenceRef, ref)
      }),
      [referenceRef]
    );
    const popperRef = React.useCallback(
      (node) => {
        popper.current = node;
        setupPopper();
      },
      [setupPopper]
    );
    const getPopperProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        ref: mergeRefs(popperRef, ref),
        style: {
          ...props2.style,
          position: strategy,
          minWidth: matchWidth$1 ? void 0 : "max-content",
          inset: "0 auto auto 0"
        }
      }),
      [strategy, popperRef, matchWidth$1]
    );
    const getArrowProps = React.useCallback((props2 = {}, ref = null) => {
      const { size, shadowColor, bg, style, ...rest } = props2;
      return {
        ...rest,
        ref,
        "data-popper-arrow": "",
        style: getArrowStyle(props2)
      };
    }, []);
    const getArrowInnerProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        ref,
        "data-popper-arrow-inner": ""
      }),
      []
    );
    return {
      update() {
        instance.current?.update();
      },
      forceUpdate() {
        instance.current?.forceUpdate();
      },
      transformOrigin: cssVars.transformOrigin.varRef,
      referenceRef,
      popperRef,
      getPopperProps,
      getArrowProps,
      getArrowInnerProps,
      getReferenceProps
    };
  }
  function getArrowStyle(props) {
    const { size, shadowColor, bg, style } = props;
    const computedStyle = { ...style, position: "absolute" };
    if (size) {
      computedStyle["--popper-arrow-size"] = size;
    }
    if (shadowColor) {
      computedStyle["--popper-arrow-shadow-color"] = shadowColor;
    }
    if (bg) {
      computedStyle["--popper-arrow-bg"] = bg;
    }
    return computedStyle;
  }

  function useEventListeners() {
    const listeners = React.useRef(/* @__PURE__ */ new Map());
    const currentListeners = listeners.current;
    const add = React.useCallback((el, type, listener, options) => {
      listeners.current.set(listener, { type, el, options });
      el.addEventListener(type, listener, options);
    }, []);
    const remove = React.useCallback(
      (el, type, listener, options) => {
        el.removeEventListener(type, listener, options);
        listeners.current.delete(listener);
      },
      []
    );
    React.useEffect(
      () => () => {
        currentListeners.forEach((value, key) => {
          remove(value.el, value.type, key, value.options);
        });
      },
      [remove, currentListeners]
    );
    return { add, remove };
  }

  function isValidElement(event) {
    const target = event.composedPath?.()?.[0] ?? event.target;
    const { tagName, isContentEditable } = target;
    return tagName !== "INPUT" && tagName !== "TEXTAREA" && isContentEditable !== true;
  }
  function useClickable(props = {}) {
    const {
      ref: htmlRef,
      isDisabled,
      isFocusable,
      clickOnEnter = true,
      clickOnSpace = true,
      onMouseDown,
      onMouseUp,
      onClick,
      onKeyDown,
      onKeyUp,
      tabIndex: tabIndexProp,
      onMouseOver,
      onMouseLeave,
      ...htmlProps
    } = props;
    const [isButton, setIsButton] = React.useState(true);
    const [isPressed, setIsPressed] = React.useState(false);
    const listeners = useEventListeners();
    const refCallback = (node) => {
      if (!node)
        return;
      if (node.tagName !== "BUTTON") {
        setIsButton(false);
      }
    };
    const tabIndex = isButton ? tabIndexProp : tabIndexProp || 0;
    const trulyDisabled = isDisabled && !isFocusable;
    const handleClick = React.useCallback(
      (event) => {
        if (isDisabled) {
          event.stopPropagation();
          event.preventDefault();
          return;
        }
        const self = event.currentTarget;
        self.focus();
        onClick?.(event);
      },
      [isDisabled, onClick]
    );
    const onDocumentKeyUp = React.useCallback(
      (e) => {
        if (isPressed && isValidElement(e)) {
          e.preventDefault();
          e.stopPropagation();
          setIsPressed(false);
          listeners.remove(document, "keyup", onDocumentKeyUp, false);
        }
      },
      [isPressed, listeners]
    );
    const handleKeyDown = React.useCallback(
      (event) => {
        onKeyDown?.(event);
        if (isDisabled || event.defaultPrevented || event.metaKey) {
          return;
        }
        if (!isValidElement(event.nativeEvent) || isButton)
          return;
        const shouldClickOnEnter = clickOnEnter && event.key === "Enter";
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
          event.preventDefault();
          setIsPressed(true);
        }
        if (shouldClickOnEnter) {
          event.preventDefault();
          const self = event.currentTarget;
          self.click();
        }
        listeners.add(document, "keyup", onDocumentKeyUp, false);
      },
      [
        isDisabled,
        isButton,
        onKeyDown,
        clickOnEnter,
        clickOnSpace,
        listeners,
        onDocumentKeyUp
      ]
    );
    const handleKeyUp = React.useCallback(
      (event) => {
        onKeyUp?.(event);
        if (isDisabled || event.defaultPrevented || event.metaKey)
          return;
        if (!isValidElement(event.nativeEvent) || isButton)
          return;
        const shouldClickOnSpace = clickOnSpace && event.key === " ";
        if (shouldClickOnSpace) {
          event.preventDefault();
          setIsPressed(false);
          const self = event.currentTarget;
          self.click();
        }
      },
      [clickOnSpace, isButton, isDisabled, onKeyUp]
    );
    const onDocumentMouseUp = React.useCallback(
      (event) => {
        if (event.button !== 0)
          return;
        setIsPressed(false);
        listeners.remove(document, "mouseup", onDocumentMouseUp, false);
      },
      [listeners]
    );
    const handleMouseDown = React.useCallback(
      (event) => {
        if (event.button !== 0)
          return;
        if (isDisabled) {
          event.stopPropagation();
          event.preventDefault();
          return;
        }
        if (!isButton) {
          setIsPressed(true);
        }
        const target = event.currentTarget;
        target.focus({ preventScroll: true });
        listeners.add(document, "mouseup", onDocumentMouseUp, false);
        onMouseDown?.(event);
      },
      [isDisabled, isButton, onMouseDown, listeners, onDocumentMouseUp]
    );
    const handleMouseUp = React.useCallback(
      (event) => {
        if (event.button !== 0)
          return;
        if (!isButton) {
          setIsPressed(false);
        }
        onMouseUp?.(event);
      },
      [onMouseUp, isButton]
    );
    const handleMouseOver = React.useCallback(
      (event) => {
        if (isDisabled) {
          event.preventDefault();
          return;
        }
        onMouseOver?.(event);
      },
      [isDisabled, onMouseOver]
    );
    const handleMouseLeave = React.useCallback(
      (event) => {
        if (isPressed) {
          event.preventDefault();
          setIsPressed(false);
        }
        onMouseLeave?.(event);
      },
      [isPressed, onMouseLeave]
    );
    const ref = mergeRefs(htmlRef, refCallback);
    if (isButton) {
      return {
        ...htmlProps,
        ref,
        type: "button",
        "aria-disabled": trulyDisabled ? void 0 : isDisabled,
        disabled: trulyDisabled,
        onClick: handleClick,
        onMouseDown,
        onMouseUp,
        onKeyUp,
        onKeyDown,
        onMouseOver,
        onMouseLeave
      };
    }
    return {
      ...htmlProps,
      ref,
      role: "button",
      "data-active": dataAttr(isPressed),
      "aria-disabled": isDisabled ? "true" : void 0,
      tabIndex: trulyDisabled ? void 0 : tabIndex,
      onClick: handleClick,
      onMouseDown: handleMouseDown,
      onMouseUp: handleMouseUp,
      onKeyUp: handleKeyUp,
      onKeyDown: handleKeyDown,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    };
  }

  const [
    MenuDescendantsProvider,
    useMenuDescendantsContext,
    useMenuDescendants,
    useMenuDescendant
  ] = createDescendantContext();
  const [MenuProvider, useMenuContext] = createContext$1({
    strict: false,
    name: "MenuContext"
  });
  function getOwnerDocument(node) {
    return node?.ownerDocument ?? document;
  }
  function isActiveElement(element) {
    const doc = getOwnerDocument(element);
    return doc.activeElement === element;
  }
  function useMenu(props = {}) {
    const {
      id,
      closeOnSelect = true,
      closeOnBlur = true,
      initialFocusRef,
      autoSelect = true,
      isLazy,
      isOpen: isOpenProp,
      defaultIsOpen,
      onClose: onCloseProp,
      onOpen: onOpenProp,
      placement = "bottom-start",
      lazyBehavior = "unmount",
      direction,
      computePositionOnMount = false,
      ...popperProps
    } = props;
    const menuRef = React.useRef(null);
    const buttonRef = React.useRef(null);
    const scrollIntoViewRef = React.useRef(true);
    const descendants = useMenuDescendants();
    const focusMenu = React.useCallback(() => {
      requestAnimationFrame(() => {
        menuRef.current?.focus({ preventScroll: false });
      });
    }, []);
    const focusFirstItem = React.useCallback(() => {
      const id2 = setTimeout(() => {
        if (initialFocusRef) {
          initialFocusRef.current?.focus();
        } else if (!descendants.count()) {
          menuRef.current?.focus({ preventScroll: false });
        } else {
          const first = descendants.firstEnabled();
          if (first)
            setFocusedIndex(first.index);
        }
      });
      timeoutIds.current.add(id2);
    }, [descendants, initialFocusRef]);
    const focusLastItem = React.useCallback(() => {
      const id2 = setTimeout(() => {
        if (!descendants.count()) {
          menuRef.current?.focus({ preventScroll: false });
        } else {
          const last = descendants.lastEnabled();
          if (last)
            setFocusedIndex(last.index);
        }
      });
      timeoutIds.current.add(id2);
    }, [descendants]);
    const onOpenInternal = React.useCallback(() => {
      onOpenProp?.();
      if (autoSelect) {
        focusFirstItem();
      } else {
        focusMenu();
      }
    }, [autoSelect, focusFirstItem, focusMenu, onOpenProp]);
    const { isOpen, onOpen, onClose, onToggle } = useDisclosure({
      isOpen: isOpenProp,
      defaultIsOpen,
      onClose: onCloseProp,
      onOpen: onOpenInternal
    });
    useOutsideClick({
      enabled: isOpen && closeOnBlur,
      ref: menuRef,
      handler: (event) => {
        const target = event.composedPath?.()?.[0] ?? event.target;
        if (!buttonRef.current?.contains(target)) {
          onClose();
        }
      }
    });
    const popper = usePopper$1({
      ...popperProps,
      enabled: isOpen || computePositionOnMount,
      placement,
      direction
    });
    const [focusedIndex, setFocusedIndex] = React.useState(-1);
    useFocusOnHide(menuRef, {
      focusRef: buttonRef,
      visible: isOpen,
      shouldFocus: true
    });
    const animationState = useAnimationState({ isOpen, ref: menuRef });
    const [buttonId, menuId] = useIds$1(id, `menu-button`, `menu-list`);
    const openAndFocusMenu = React.useCallback(() => {
      onOpen();
      focusMenu();
    }, [onOpen, focusMenu]);
    const timeoutIds = React.useRef(/* @__PURE__ */ new Set([]));
    React.useEffect(() => {
      const ids = timeoutIds.current;
      return () => {
        ids.forEach((id2) => clearTimeout(id2));
        ids.clear();
      };
    }, []);
    useUpdateEffect(() => {
      if (isOpen)
        return;
      setFocusedIndex(-1);
      menuRef.current?.scrollTo(0, 0);
    }, [isOpen]);
    useUpdateEffect(() => {
      if (!isOpen)
        return;
      if (focusedIndex === -1) {
        focusMenu();
      }
    }, [focusedIndex, isOpen]);
    React.useEffect(() => {
      if (!isOpen)
        return;
      const item = descendants.item(focusedIndex);
      item?.node?.focus({ preventScroll: !scrollIntoViewRef.current });
    }, [descendants, focusedIndex, isOpen]);
    const openAndFocusFirstItem = React.useCallback(() => {
      onOpen();
      focusFirstItem();
    }, [focusFirstItem, onOpen]);
    const openAndFocusLastItem = React.useCallback(() => {
      scrollIntoViewRef.current = true;
      onOpen();
      focusLastItem();
    }, [onOpen, focusLastItem]);
    const refocus = React.useCallback(() => {
      const doc = getOwnerDocument(menuRef.current);
      const hasFocusWithin = menuRef.current?.contains(doc.activeElement);
      const shouldRefocus = isOpen && !hasFocusWithin;
      if (!shouldRefocus)
        return;
      const node = descendants.item(focusedIndex)?.node;
      node?.focus({ preventScroll: !scrollIntoViewRef.current });
    }, [isOpen, focusedIndex, descendants]);
    return {
      openAndFocusMenu,
      openAndFocusFirstItem,
      openAndFocusLastItem,
      onTransitionEnd: refocus,
      unstable__animationState: animationState,
      descendants,
      popper,
      buttonId,
      menuId,
      forceUpdate: popper.forceUpdate,
      orientation: "vertical",
      isOpen,
      onToggle,
      onOpen,
      onClose,
      menuRef,
      buttonRef,
      focusedIndex,
      closeOnSelect,
      closeOnBlur,
      autoSelect,
      setFocusedIndex,
      isLazy,
      lazyBehavior,
      initialFocusRef,
      scrollIntoViewRef
    };
  }
  function useMenuButton(props = {}, externalRef = null) {
    const menu = useMenuContext();
    const {
      onToggle,
      popper,
      openAndFocusFirstItem,
      openAndFocusLastItem,
      scrollIntoViewRef
    } = menu;
    const onKeyDown = React.useCallback(
      (event) => {
        const eventKey = event.key;
        const keyMap = {
          Enter: openAndFocusFirstItem,
          ArrowDown: openAndFocusFirstItem,
          ArrowUp: openAndFocusLastItem
        };
        const action = keyMap[eventKey];
        if (action) {
          scrollIntoViewRef.current = true;
          event.preventDefault();
          event.stopPropagation();
          action(event);
        }
      },
      [openAndFocusFirstItem, openAndFocusLastItem, scrollIntoViewRef]
    );
    return {
      ...props,
      ref: mergeRefs(menu.buttonRef, externalRef, popper.referenceRef),
      id: menu.buttonId,
      "data-active": dataAttr(menu.isOpen),
      "aria-expanded": menu.isOpen,
      "aria-haspopup": "menu",
      "aria-controls": menu.menuId,
      onClick: callAllHandlers(props.onClick, onToggle),
      onKeyDown: callAllHandlers(props.onKeyDown, onKeyDown)
    };
  }
  function isTargetMenuItem(target) {
    return isHTMLElement(target) && !!target?.getAttribute("role")?.startsWith("menuitem");
  }
  function useMenuList(props = {}, ref = null) {
    const menu = useMenuContext();
    if (!menu) {
      throw new Error(
        `useMenuContext: context is undefined. Seems you forgot to wrap component within <Menu>`
      );
    }
    const {
      focusedIndex,
      setFocusedIndex,
      menuRef,
      isOpen,
      onClose,
      menuId,
      isLazy,
      lazyBehavior,
      scrollIntoViewRef,
      unstable__animationState: animated
    } = menu;
    const descendants = useMenuDescendantsContext();
    const createTypeaheadHandler = useShortcut({
      preventDefault: (event) => event.key !== " " && isTargetMenuItem(event.target)
    });
    const onKeyDown = React.useCallback(
      (event) => {
        if (!event.currentTarget.contains(event.target))
          return;
        const eventKey = event.key;
        const keyMap = {
          Tab: (event2) => event2.preventDefault(),
          Escape: (event2) => {
            event2.stopPropagation();
            onClose();
          },
          ArrowDown: () => {
            scrollIntoViewRef.current = true;
            const next = descendants.nextEnabled(focusedIndex) ?? descendants.firstEnabled();
            if (next)
              setFocusedIndex(next.index);
          },
          ArrowUp: () => {
            scrollIntoViewRef.current = true;
            const prev = descendants.prevEnabled(focusedIndex) ?? descendants.firstEnabled();
            if (prev)
              setFocusedIndex(prev.index);
          }
        };
        const fn = keyMap[eventKey];
        if (fn) {
          event.preventDefault();
          fn(event);
          return;
        }
        const onTypeahead = createTypeaheadHandler((character) => {
          const nextItem = getNextItemFromSearch(
            descendants.values(),
            character,
            (item) => item?.node?.textContent ?? "",
            descendants.item(focusedIndex)
          );
          if (nextItem) {
            const index = descendants.indexOf(nextItem.node);
            setFocusedIndex(index);
          }
        });
        if (isTargetMenuItem(event.target)) {
          onTypeahead(event);
        }
      },
      [
        descendants,
        focusedIndex,
        createTypeaheadHandler,
        onClose,
        setFocusedIndex,
        scrollIntoViewRef
      ]
    );
    const hasBeenOpened = React.useRef(false);
    if (isOpen) {
      hasBeenOpened.current = true;
    }
    const shouldRenderChildren = lazyDisclosure({
      wasSelected: hasBeenOpened.current,
      enabled: isLazy,
      mode: lazyBehavior,
      isSelected: animated.present
    });
    return {
      ...props,
      ref: mergeRefs(menuRef, ref),
      children: shouldRenderChildren ? props.children : null,
      tabIndex: -1,
      role: "menu",
      id: menuId,
      style: {
        ...props.style,
        transformOrigin: "var(--popper-transform-origin)"
      },
      "aria-orientation": "vertical",
      onKeyDown: callAllHandlers(props.onKeyDown, onKeyDown)
    };
  }
  function useMenuPositioner(props = {}) {
    const { popper, isOpen } = useMenuContext();
    return popper.getPopperProps({
      ...props,
      style: {
        visibility: isOpen ? "visible" : "hidden",
        ...props.style
      }
    });
  }
  function useMenuItem(props = {}, externalRef = null) {
    const {
      onMouseEnter: onMouseEnterProp,
      onMouseMove: onMouseMoveProp,
      onMouseLeave: onMouseLeaveProp,
      onClick: onClickProp,
      onFocus: onFocusProp,
      isDisabled,
      isFocusable,
      closeOnSelect,
      type: typeProp,
      ...htmlProps
    } = props;
    const menu = useMenuContext();
    const {
      setFocusedIndex,
      focusedIndex,
      closeOnSelect: menuCloseOnSelect,
      onClose,
      menuId,
      scrollIntoViewRef
    } = menu;
    const ref = React.useRef(null);
    const id = `${menuId}-menuitem-${React.useId()}`;
    const { index, register } = useMenuDescendant({
      disabled: isDisabled && !isFocusable
    });
    const onMouseEnter = React.useCallback(
      (event) => {
        onMouseEnterProp?.(event);
        if (isDisabled)
          return;
        scrollIntoViewRef.current = false;
        setFocusedIndex(index);
      },
      [setFocusedIndex, index, isDisabled, onMouseEnterProp, scrollIntoViewRef]
    );
    const onMouseMove = React.useCallback(
      (event) => {
        onMouseMoveProp?.(event);
        if (ref.current && !isActiveElement(ref.current)) {
          onMouseEnter(event);
        }
      },
      [onMouseEnter, onMouseMoveProp]
    );
    const onMouseLeave = React.useCallback(
      (event) => {
        onMouseLeaveProp?.(event);
        if (isDisabled)
          return;
        setFocusedIndex(-1);
      },
      [setFocusedIndex, isDisabled, onMouseLeaveProp]
    );
    const onClick = React.useCallback(
      (event) => {
        onClickProp?.(event);
        if (!isTargetMenuItem(event.currentTarget))
          return;
        if (closeOnSelect ?? menuCloseOnSelect) {
          onClose();
        }
      },
      [onClose, onClickProp, menuCloseOnSelect, closeOnSelect]
    );
    const onFocus = React.useCallback(
      (event) => {
        onFocusProp?.(event);
        setFocusedIndex(index);
      },
      [setFocusedIndex, onFocusProp, index]
    );
    const isFocused = index === focusedIndex;
    const clickableProps = useClickable({
      onClick,
      onFocus,
      onMouseEnter,
      onMouseMove,
      onMouseLeave,
      ref: mergeRefs(register, ref, externalRef),
      isDisabled,
      isFocusable
    });
    return {
      ...htmlProps,
      ...clickableProps,
      type: typeProp ?? clickableProps.type,
      id,
      role: "menuitem",
      tabIndex: isFocused ? 0 : -1
    };
  }
  function useMenuOption(props = {}, ref = null) {
    const { type = "radio", isChecked, ...rest } = props;
    const ownProps = useMenuItem(rest, ref);
    return {
      ...ownProps,
      role: `menuitem${type}`,
      "aria-checked": isChecked
    };
  }
  function useMenuOptionGroup(props = {}) {
    const {
      children,
      type = "radio",
      value: valueProp,
      defaultValue,
      onChange: onChangeProp,
      ...htmlProps
    } = props;
    const isRadio = type === "radio";
    const fallback = isRadio ? "" : [];
    const [value, setValue] = useControllableState({
      defaultValue: defaultValue ?? fallback,
      value: valueProp,
      onChange: onChangeProp
    });
    const onChange = React.useCallback(
      (selectedValue) => {
        if (type === "radio" && typeof value === "string") {
          setValue(selectedValue);
        }
        if (type === "checkbox" && Array.isArray(value)) {
          const nextValue = value.includes(selectedValue) ? value.filter((item) => item !== selectedValue) : value.concat(selectedValue);
          setValue(nextValue);
        }
      },
      [value, setValue, type]
    );
    const validChildren = getValidChildren(children);
    const clones = validChildren.map((child) => {
      if (child.type.id !== "MenuItemOption")
        return child;
      const onClick = (event) => {
        onChange(child.props.value);
        child.props.onClick?.(event);
      };
      const isChecked = type === "radio" ? child.props.value === value : value.includes(child.props.value);
      return React.cloneElement(child, {
        type,
        onClick,
        isChecked
      });
    });
    return {
      ...htmlProps,
      children: clones
    };
  }
  function isHTMLElement(el) {
    if (!isElement(el))
      return false;
    const win = el.ownerDocument.defaultView ?? window;
    return el instanceof win.HTMLElement;
  }
  function isElement(el) {
    return el != null && typeof el == "object" && "nodeType" in el && el.nodeType === Node.ELEMENT_NODE;
  }

  const [MenuStylesProvider, useMenuStyles] = createContext$1({
    name: `MenuStylesContext`,
    errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
  });
  const Menu = (props) => {
    const { children } = props;
    const styles = useMultiStyleConfig("Menu", props);
    const ownProps = omitThemingProps(props);
    const { direction } = useTheme();
    const { descendants, ...ctx } = useMenu({ ...ownProps, direction });
    const context = React.useMemo(() => ctx, [ctx]);
    const { isOpen, onClose, forceUpdate } = context;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(MenuDescendantsProvider, { value: descendants, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuProvider, { value: context, children: /* @__PURE__ */ jsxRuntimeExports.jsx(MenuStylesProvider, { value: styles, children: runIfFn$3(children, { isOpen, onClose, forceUpdate }) }) }) });
  };
  Menu.displayName = "Menu";

  const StyledMenuButton = forwardRef$1((props, ref) => {
    const styles = useMenuStyles();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.button,
      {
        ref,
        ...props,
        __css: {
          display: "inline-flex",
          appearance: "none",
          alignItems: "center",
          outline: 0,
          ...styles.button
        }
      }
    );
  });
  const MenuButton$1 = forwardRef$1(
    (props, ref) => {
      const { children, as: As, ...rest } = props;
      const buttonProps = useMenuButton(rest, ref);
      const Element = As || StyledMenuButton;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        Element,
        {
          ...buttonProps,
          className: cx$1("chakra-menu__menu-button", props.className),
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            chakra$1.span,
            {
              __css: { pointerEvents: "none", flex: "1 1 auto", minW: 0 },
              children: props.children
            }
          )
        }
      );
    }
  );
  MenuButton$1.displayName = "MenuButton";

  const MenuCommand = forwardRef$1(
    (props, ref) => {
      const styles = useMenuStyles();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.span,
        {
          ref,
          ...props,
          __css: styles.command,
          className: "chakra-menu__command"
        }
      );
    }
  );
  MenuCommand.displayName = "MenuCommand";

  const MenuGroup = forwardRef$1((props, ref) => {
    const { title, children, className, ...rest } = props;
    const _className = cx$1("chakra-menu__group__title", className);
    const styles = useMenuStyles();
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { ref, className: "chakra-menu__group", role: "group", children: [
      title && /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.p, { className: _className, ...rest, __css: styles.groupTitle, children: title }),
      children
    ] });
  });
  MenuGroup.displayName = "MenuGroup";

  const MenuIcon = (props) => {
    const { className, children, ...rest } = props;
    const styles = useMenuStyles();
    const child = React.Children.only(children);
    const clone = React.isValidElement(child) ? React.cloneElement(child, {
      focusable: "false",
      "aria-hidden": true,
      className: cx$1("chakra-menu__icon", child.props.className)
    }) : null;
    const _className = cx$1("chakra-menu__icon-wrapper", className);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.span, { className: _className, ...rest, __css: styles.icon, children: clone });
  };
  MenuIcon.displayName = "MenuIcon";

  const StyledMenuItem = forwardRef$1(
    (props, ref) => {
      const { type, ...rest } = props;
      const styles = useMenuStyles();
      const btnType = rest.as || type ? type ?? void 0 : "button";
      const buttonStyles = React.useMemo(
        () => ({
          textDecoration: "none",
          color: "inherit",
          userSelect: "none",
          display: "flex",
          width: "100%",
          alignItems: "center",
          textAlign: "start",
          flex: "0 0 auto",
          outline: 0,
          ...styles.item
        }),
        [styles.item]
      );
      return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.button, { ref, type: btnType, ...rest, __css: buttonStyles });
    }
  );

  const MenuItem$1 = forwardRef$1((props, ref) => {
    const {
      icon,
      iconSpacing = "0.75rem",
      command,
      commandSpacing = "0.75rem",
      children,
      ...rest
    } = props;
    const menuitemProps = useMenuItem(rest, ref);
    const shouldWrap = icon || command;
    const _children = shouldWrap ? /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { pointerEvents: "none", flex: 1 }, children }) : children;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      StyledMenuItem,
      {
        ...menuitemProps,
        className: cx$1("chakra-menu__menuitem", menuitemProps.className),
        children: [
          icon && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuIcon, { fontSize: "0.8em", marginEnd: iconSpacing, children: icon }),
          _children,
          command && /* @__PURE__ */ jsxRuntimeExports.jsx(MenuCommand, { marginStart: commandSpacing, children: command })
        ]
      }
    );
  });
  MenuItem$1.displayName = "MenuItem";

  const CheckIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "polygon",
    {
      fill: "currentColor",
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }
  ) });
  const MenuItemOption = forwardRef$1(
    (props, ref) => {
      const {
        icon,
        iconSpacing = "0.75rem",
        iconPlacement = "start",
        ...rest
      } = props;
      const optionProps = useMenuOption(rest, ref);
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        StyledMenuItem,
        {
          ...optionProps,
          className: cx$1("chakra-menu__menuitem-option", rest.className),
          children: [
            icon !== null && iconPlacement === "start" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              MenuIcon,
              {
                fontSize: "0.8em",
                marginEnd: iconSpacing,
                opacity: props.isChecked ? 1 : 0,
                children: icon || /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, {})
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: { flex: 1 }, children: optionProps.children }),
            icon !== null && iconPlacement === "end" && /* @__PURE__ */ jsxRuntimeExports.jsx(
              MenuIcon,
              {
                fontSize: "0.8em",
                marginStart: iconSpacing,
                opacity: props.isChecked ? 1 : 0,
                children: icon || /* @__PURE__ */ jsxRuntimeExports.jsx(CheckIcon, {})
              }
            )
          ]
        }
      );
    }
  );
  MenuItemOption.id = "MenuItemOption";
  MenuItemOption.displayName = "MenuItemOption";

  const motionVariants = {
    enter: {
      visibility: "visible",
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.2,
        ease: [0.4, 0, 0.2, 1]
      }
    },
    exit: {
      transitionEnd: {
        visibility: "hidden"
      },
      opacity: 0,
      scale: 0.8,
      transition: {
        duration: 0.1,
        easings: "easeOut"
      }
    }
  };
  const MenuTransition = chakra$1(motion.div);
  const MenuList$1 = forwardRef$1(
    function MenuList2(props, ref) {
      const { rootProps, motionProps, ...rest } = props;
      const {
        isOpen,
        onTransitionEnd,
        unstable__animationState: animated
      } = useMenuContext();
      const listProps = useMenuList(rest, ref);
      const positionerProps = useMenuPositioner(rootProps);
      const styles = useMenuStyles();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...positionerProps,
          __css: { zIndex: props.zIndex ?? styles.list?.zIndex },
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            MenuTransition,
            {
              variants: motionVariants,
              initial: false,
              animate: isOpen ? "enter" : "exit",
              __css: { outline: 0, ...styles.list },
              ...motionProps,
              ...listProps,
              className: cx$1("chakra-menu__menu-list", listProps.className),
              onUpdate: onTransitionEnd,
              onAnimationComplete: callAll(
                animated.onComplete,
                listProps.onAnimationComplete
              )
            }
          )
        }
      );
    }
  );
  MenuList$1.displayName = "MenuList";

  const MenuOptionGroup = (props) => {
    const { className, title, ...rest } = props;
    const ownProps = useMenuOptionGroup(rest);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      MenuGroup,
      {
        title,
        className: cx$1("chakra-menu__option-group", className),
        ...ownProps
      }
    );
  };
  MenuOptionGroup.displayName = "MenuOptionGroup";

  var getDefaultParent = function (originalTarget) {
      if (typeof document === 'undefined') {
          return null;
      }
      var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
      return sampleTarget.ownerDocument.body;
  };
  var counterMap = new WeakMap();
  var uncontrolledNodes = new WeakMap();
  var markerMap = {};
  var lockCount = 0;
  var unwrapHost = function (node) {
      return node && (node.host || unwrapHost(node.parentNode));
  };
  var correctTargets = function (parent, targets) {
      return targets
          .map(function (target) {
          if (parent.contains(target)) {
              return target;
          }
          var correctedTarget = unwrapHost(target);
          if (correctedTarget && parent.contains(correctedTarget)) {
              return correctedTarget;
          }
          console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
          return null;
      })
          .filter(function (x) { return Boolean(x); });
  };
  /**
   * Marks everything except given node(or nodes) as aria-hidden
   * @param {Element | Element[]} originalTarget - elements to keep on the page
   * @param [parentNode] - top element, defaults to document.body
   * @param {String} [markerName] - a special attribute to mark every node
   * @param {String} [controlAttribute] - html Attribute to control
   * @return {Undo} undo command
   */
  var applyAttributeToOthers = function (originalTarget, parentNode, markerName, controlAttribute) {
      var targets = correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
      if (!markerMap[markerName]) {
          markerMap[markerName] = new WeakMap();
      }
      var markerCounter = markerMap[markerName];
      var hiddenNodes = [];
      var elementsToKeep = new Set();
      var elementsToStop = new Set(targets);
      var keep = function (el) {
          if (!el || elementsToKeep.has(el)) {
              return;
          }
          elementsToKeep.add(el);
          keep(el.parentNode);
      };
      targets.forEach(keep);
      var deep = function (parent) {
          if (!parent || elementsToStop.has(parent)) {
              return;
          }
          Array.prototype.forEach.call(parent.children, function (node) {
              if (elementsToKeep.has(node)) {
                  deep(node);
              }
              else {
                  try {
                      var attr = node.getAttribute(controlAttribute);
                      var alreadyHidden = attr !== null && attr !== 'false';
                      var counterValue = (counterMap.get(node) || 0) + 1;
                      var markerValue = (markerCounter.get(node) || 0) + 1;
                      counterMap.set(node, counterValue);
                      markerCounter.set(node, markerValue);
                      hiddenNodes.push(node);
                      if (counterValue === 1 && alreadyHidden) {
                          uncontrolledNodes.set(node, true);
                      }
                      if (markerValue === 1) {
                          node.setAttribute(markerName, 'true');
                      }
                      if (!alreadyHidden) {
                          node.setAttribute(controlAttribute, 'true');
                      }
                  }
                  catch (e) {
                      console.error('aria-hidden: cannot operate on ', node, e);
                  }
              }
          });
      };
      deep(parentNode);
      elementsToKeep.clear();
      lockCount++;
      return function () {
          hiddenNodes.forEach(function (node) {
              var counterValue = counterMap.get(node) - 1;
              var markerValue = markerCounter.get(node) - 1;
              counterMap.set(node, counterValue);
              markerCounter.set(node, markerValue);
              if (!counterValue) {
                  if (!uncontrolledNodes.has(node)) {
                      node.removeAttribute(controlAttribute);
                  }
                  uncontrolledNodes.delete(node);
              }
              if (!markerValue) {
                  node.removeAttribute(markerName);
              }
          });
          lockCount--;
          if (!lockCount) {
              // clear
              counterMap = new WeakMap();
              counterMap = new WeakMap();
              uncontrolledNodes = new WeakMap();
              markerMap = {};
          }
      };
  };
  /**
   * Marks everything except given node(or nodes) as aria-hidden
   * @param {Element | Element[]} originalTarget - elements to keep on the page
   * @param [parentNode] - top element, defaults to document.body
   * @param {String} [markerName] - a special attribute to mark every node
   * @return {Undo} undo command
   */
  var hideOthers = function (originalTarget, parentNode, markerName) {
      if (markerName === void 0) { markerName = 'data-aria-hidden'; }
      var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [originalTarget]);
      var activeParentNode = getDefaultParent(originalTarget);
      if (!activeParentNode) {
          return function () { return null; };
      }
      // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
      // and script elements, as they have no impact on accessibility.
      targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
      return applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
  };

  var __defProp = Object.defineProperty;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
  var __publicField = (obj, key, value) => {
    __defNormalProp(obj, key + "" , value);
    return value;
  };
  class ModalManager {
    constructor() {
      __publicField(this, "modals");
      this.modals = /* @__PURE__ */ new Set();
    }
    add(modal) {
      this.modals.add(modal);
      return this.modals.size;
    }
    remove(modal) {
      this.modals.delete(modal);
    }
    isTopModal(modal) {
      if (!modal)
        return false;
      const topModal = Array.from(this.modals)[this.modals.size - 1];
      return modal === topModal;
    }
  }
  const modalManager = new ModalManager();
  function useModalManager(ref, isOpen) {
    const [index, setIndex] = React.useState(0);
    React.useEffect(() => {
      const node = ref.current;
      if (!node)
        return;
      if (isOpen) {
        const index2 = modalManager.add(node);
        setIndex(index2);
      }
      return () => {
        modalManager.remove(node);
        setIndex(0);
      };
    }, [isOpen, ref]);
    return index;
  }

  function useModal(props) {
    const {
      isOpen,
      onClose,
      id,
      closeOnOverlayClick = true,
      closeOnEsc = true,
      useInert = true,
      onOverlayClick: onOverlayClickProp,
      onEsc
    } = props;
    const dialogRef = React.useRef(null);
    const overlayRef = React.useRef(null);
    const [dialogId, headerId, bodyId] = useIds(
      id,
      `chakra-modal`,
      `chakra-modal--header`,
      `chakra-modal--body`
    );
    useAriaHidden(dialogRef, isOpen && useInert);
    const index = useModalManager(dialogRef, isOpen);
    const mouseDownTarget = React.useRef(null);
    const onMouseDown = React.useCallback((event) => {
      mouseDownTarget.current = event.target;
    }, []);
    const onKeyDown = React.useCallback(
      (event) => {
        if (event.key === "Escape") {
          event.stopPropagation();
          if (closeOnEsc) {
            onClose?.();
          }
          onEsc?.();
        }
      },
      [closeOnEsc, onClose, onEsc]
    );
    const [headerMounted, setHeaderMounted] = React.useState(false);
    const [bodyMounted, setBodyMounted] = React.useState(false);
    const getDialogProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        role: "dialog",
        ...props2,
        ref: mergeRefs(ref, dialogRef),
        id: dialogId,
        tabIndex: -1,
        "aria-modal": true,
        "aria-labelledby": headerMounted ? headerId : void 0,
        "aria-describedby": bodyMounted ? bodyId : void 0,
        onClick: callAllHandlers(
          props2.onClick,
          (event) => event.stopPropagation()
        )
      }),
      [bodyId, bodyMounted, dialogId, headerId, headerMounted]
    );
    const onOverlayClick = React.useCallback(
      (event) => {
        event.stopPropagation();
        if (mouseDownTarget.current !== event.target)
          return;
        if (!modalManager.isTopModal(dialogRef.current))
          return;
        if (closeOnOverlayClick) {
          onClose?.();
        }
        onOverlayClickProp?.();
      },
      [onClose, closeOnOverlayClick, onOverlayClickProp]
    );
    const getDialogContainerProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        ref: mergeRefs(ref, overlayRef),
        onClick: callAllHandlers(props2.onClick, onOverlayClick),
        onKeyDown: callAllHandlers(props2.onKeyDown, onKeyDown),
        onMouseDown: callAllHandlers(props2.onMouseDown, onMouseDown)
      }),
      [onKeyDown, onMouseDown, onOverlayClick]
    );
    return {
      isOpen,
      onClose,
      headerId,
      bodyId,
      setBodyMounted,
      setHeaderMounted,
      dialogRef,
      overlayRef,
      getDialogProps,
      getDialogContainerProps,
      index
    };
  }
  function useAriaHidden(ref, shouldHide) {
    const currentElement = ref.current;
    React.useEffect(() => {
      if (!ref.current || !shouldHide)
        return void 0;
      return hideOthers(ref.current);
    }, [shouldHide, ref, currentElement]);
  }
  function useIds(idProp, ...prefixes) {
    const reactId = React.useId();
    const id = idProp || reactId;
    return React.useMemo(() => {
      return prefixes.map((prefix) => `${prefix}-${id}`);
    }, [id, prefixes]);
  }

  const [ModalStylesProvider, useModalStyles] = createContext$1({
    name: `ModalStylesContext`,
    errorMessage: `useModalStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Modal />" `
  });
  const [ModalContextProvider, useModalContext] = createContext$1({
    strict: true,
    name: "ModalContext",
    errorMessage: "useModalContext: `context` is undefined. Seems you forgot to wrap modal components in `<Modal />`"
  });
  const Modal = (props) => {
    const modalProps = {
      scrollBehavior: "outside",
      autoFocus: true,
      trapFocus: true,
      returnFocusOnClose: true,
      blockScrollOnMount: true,
      allowPinchZoom: false,
      preserveScrollBarGap: true,
      motionPreset: "scale",
      ...props,
      lockFocusAcrossFrames: props.lockFocusAcrossFrames ?? true
    };
    const {
      portalProps,
      children,
      autoFocus,
      trapFocus,
      initialFocusRef,
      finalFocusRef,
      returnFocusOnClose,
      blockScrollOnMount,
      allowPinchZoom,
      preserveScrollBarGap,
      motionPreset,
      lockFocusAcrossFrames,
      animatePresenceProps,
      onCloseComplete
    } = modalProps;
    const styles = useMultiStyleConfig("Modal", modalProps);
    const modal = useModal(modalProps);
    const context = {
      ...modal,
      autoFocus,
      trapFocus,
      initialFocusRef,
      finalFocusRef,
      returnFocusOnClose,
      blockScrollOnMount,
      allowPinchZoom,
      preserveScrollBarGap,
      motionPreset,
      lockFocusAcrossFrames
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalContextProvider, { value: context, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ModalStylesProvider, { value: styles, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      AnimatePresence,
      {
        ...animatePresenceProps,
        onExitComplete: onCloseComplete,
        children: context.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { ...portalProps, children })
      }
    ) }) });
  };
  Modal.displayName = "Modal";

  var zeroRightClassName = 'right-scroll-bar-position';
  var fullWidthClassName = 'width-before-scroll-bar';
  var noScrollbarsClassName = 'with-scroll-bars-hidden';
  /**
   * Name of a CSS variable containing the amount of "hidden" scrollbar
   * ! might be undefined ! use will fallback!
   */
  var removedBarSizeVariable = '--removed-body-scroll-bar-size';

  var effectCar = createSidecarMedium();

  var nothing = function () {
      return;
  };
  /**
   * Removes scrollbar from the page and contain the scroll within the Lock
   */
  var RemoveScroll = React__namespace.forwardRef(function (props, parentRef) {
      var ref = React__namespace.useRef(null);
      var _a = React__namespace.useState({
          onScrollCapture: nothing,
          onWheelCapture: nothing,
          onTouchMoveCapture: nothing,
      }), callbacks = _a[0], setCallbacks = _a[1];
      var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = __rest(props, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]);
      var SideCar = sideCar;
      var containerRef = useMergeRefs([ref, parentRef]);
      var containerProps = __assign(__assign({}, rest), callbacks);
      return (React__namespace.createElement(React__namespace.Fragment, null,
          enabled && (React__namespace.createElement(SideCar, { sideCar: effectCar, removeScrollBar: removeScrollBar, shards: shards, noRelative: noRelative, noIsolation: noIsolation, inert: inert, setCallbacks: setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref, gapMode: gapMode })),
          forwardProps ? (React__namespace.cloneElement(React__namespace.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef }))) : (React__namespace.createElement(Container, __assign({}, containerProps, { className: className, ref: containerRef }), children))));
  });
  RemoveScroll.defaultProps = {
      enabled: true,
      removeScrollBar: true,
      inert: false,
  };
  RemoveScroll.classNames = {
      fullWidth: fullWidthClassName,
      zeroRight: zeroRightClassName,
  };

  var getNonce = function () {
      if (typeof __webpack_nonce__ !== 'undefined') {
          return __webpack_nonce__;
      }
      return undefined;
  };

  function makeStyleTag() {
      if (!document)
          return null;
      var tag = document.createElement('style');
      tag.type = 'text/css';
      var nonce = getNonce();
      if (nonce) {
          tag.setAttribute('nonce', nonce);
      }
      return tag;
  }
  function injectStyles(tag, css) {
      // @ts-ignore
      if (tag.styleSheet) {
          // @ts-ignore
          tag.styleSheet.cssText = css;
      }
      else {
          tag.appendChild(document.createTextNode(css));
      }
  }
  function insertStyleTag(tag) {
      var head = document.head || document.getElementsByTagName('head')[0];
      head.appendChild(tag);
  }
  var stylesheetSingleton = function () {
      var counter = 0;
      var stylesheet = null;
      return {
          add: function (style) {
              if (counter == 0) {
                  if ((stylesheet = makeStyleTag())) {
                      injectStyles(stylesheet, style);
                      insertStyleTag(stylesheet);
                  }
              }
              counter++;
          },
          remove: function () {
              counter--;
              if (!counter && stylesheet) {
                  stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                  stylesheet = null;
              }
          },
      };
  };

  /**
   * creates a hook to control style singleton
   * @see {@link styleSingleton} for a safer component version
   * @example
   * ```tsx
   * const useStyle = styleHookSingleton();
   * ///
   * useStyle('body { overflow: hidden}');
   */
  var styleHookSingleton = function () {
      var sheet = stylesheetSingleton();
      return function (styles, isDynamic) {
          React__namespace.useEffect(function () {
              sheet.add(styles);
              return function () {
                  sheet.remove();
              };
          }, [styles && isDynamic]);
      };
  };

  /**
   * create a Component to add styles on demand
   * - styles are added when first instance is mounted
   * - styles are removed when the last instance is unmounted
   * - changing styles in runtime does nothing unless dynamic is set. But with multiple components that can lead to the undefined behavior
   */
  var styleSingleton = function () {
      var useStyle = styleHookSingleton();
      var Sheet = function (_a) {
          var styles = _a.styles, dynamic = _a.dynamic;
          useStyle(styles, dynamic);
          return null;
      };
      return Sheet;
  };

  var zeroGap = {
      left: 0,
      top: 0,
      right: 0,
      gap: 0,
  };
  var parse$2 = function (x) { return parseInt(x || '', 10) || 0; };
  var getOffset = function (gapMode) {
      var cs = window.getComputedStyle(document.body);
      var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
      var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
      var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
      return [parse$2(left), parse$2(top), parse$2(right)];
  };
  var getGapWidth = function (gapMode) {
      if (gapMode === void 0) { gapMode = 'margin'; }
      if (typeof window === 'undefined') {
          return zeroGap;
      }
      var offsets = getOffset(gapMode);
      var documentWidth = document.documentElement.clientWidth;
      var windowWidth = window.innerWidth;
      return {
          left: offsets[0],
          top: offsets[1],
          right: offsets[2],
          gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0]),
      };
  };

  var Style = styleSingleton();
  var lockAttribute = 'data-scroll-locked';
  // important tip - once we measure scrollBar width and remove them
  // we could not repeat this operation
  // thus we are using style-singleton - only the first "yet correct" style will be applied.
  var getStyles = function (_a, allowRelative, gapMode, important) {
      var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
      if (gapMode === void 0) { gapMode = 'margin'; }
      return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat(lockAttribute, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
          allowRelative && "position: relative ".concat(important, ";"),
          gapMode === 'margin' &&
              "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
          gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";"),
      ]
          .filter(Boolean)
          .join(''), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat(lockAttribute, "] {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
  };
  var getCurrentUseCounter = function () {
      var counter = parseInt(document.body.getAttribute(lockAttribute) || '0', 10);
      return isFinite(counter) ? counter : 0;
  };
  var useLockAttribute = function () {
      React__namespace.useEffect(function () {
          document.body.setAttribute(lockAttribute, (getCurrentUseCounter() + 1).toString());
          return function () {
              var newCounter = getCurrentUseCounter() - 1;
              if (newCounter <= 0) {
                  document.body.removeAttribute(lockAttribute);
              }
              else {
                  document.body.setAttribute(lockAttribute, newCounter.toString());
              }
          };
      }, []);
  };
  /**
   * Removes page scrollbar and blocks page scroll when mounted
   */
  var RemoveScrollBar = function (_a) {
      var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
      useLockAttribute();
      /*
       gap will be measured on every component mount
       however it will be used only by the "first" invocation
       due to singleton nature of <Style
       */
      var gap = React__namespace.useMemo(function () { return getGapWidth(gapMode); }, [gapMode]);
      return React__namespace.createElement(Style, { styles: getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '') });
  };

  var passiveSupported = false;
  if (typeof window !== 'undefined') {
      try {
          var options = Object.defineProperty({}, 'passive', {
              get: function () {
                  passiveSupported = true;
                  return true;
              },
          });
          // @ts-ignore
          window.addEventListener('test', options, options);
          // @ts-ignore
          window.removeEventListener('test', options, options);
      }
      catch (err) {
          passiveSupported = false;
      }
  }
  var nonPassive = passiveSupported ? { passive: false } : false;

  var alwaysContainsScroll = function (node) {
      // textarea will always _contain_ scroll inside self. It only can be hidden
      return node.tagName === 'TEXTAREA';
  };
  var elementCanBeScrolled = function (node, overflow) {
      if (!(node instanceof Element)) {
          return false;
      }
      var styles = window.getComputedStyle(node);
      return (
      // not-not-scrollable
      styles[overflow] !== 'hidden' &&
          // contains scroll inside self
          !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible'));
  };
  var elementCouldBeVScrolled = function (node) { return elementCanBeScrolled(node, 'overflowY'); };
  var elementCouldBeHScrolled = function (node) { return elementCanBeScrolled(node, 'overflowX'); };
  var locationCouldBeScrolled = function (axis, node) {
      var ownerDocument = node.ownerDocument;
      var current = node;
      do {
          // Skip over shadow root
          if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) {
              current = current.host;
          }
          var isScrollable = elementCouldBeScrolled(axis, current);
          if (isScrollable) {
              var _a = getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
              if (scrollHeight > clientHeight) {
                  return true;
              }
          }
          current = current.parentNode;
      } while (current && current !== ownerDocument.body);
      return false;
  };
  var getVScrollVariables = function (_a) {
      var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
      return [
          scrollTop,
          scrollHeight,
          clientHeight,
      ];
  };
  var getHScrollVariables = function (_a) {
      var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
      return [
          scrollLeft,
          scrollWidth,
          clientWidth,
      ];
  };
  var elementCouldBeScrolled = function (axis, node) {
      return axis === 'v' ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
  };
  var getScrollVariables = function (axis, node) {
      return axis === 'v' ? getVScrollVariables(node) : getHScrollVariables(node);
  };
  var getDirectionFactor = function (axis, direction) {
      /**
       * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
       * and then increasingly negative as you scroll towards the end of the content.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
       */
      return axis === 'h' && direction === 'rtl' ? -1 : 1;
  };
  var handleScroll = function (axis, endTarget, event, sourceDelta, noOverscroll) {
      var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
      var delta = directionFactor * sourceDelta;
      // find scrollable target
      var target = event.target;
      var targetInLock = endTarget.contains(target);
      var shouldCancelScroll = false;
      var isDeltaPositive = delta > 0;
      var availableScroll = 0;
      var availableScrollTop = 0;
      do {
          if (!target) {
              break;
          }
          var _a = getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
          var elementScroll = scroll_1 - capacity - directionFactor * position;
          if (position || elementScroll) {
              if (elementCouldBeScrolled(axis, target)) {
                  availableScroll += elementScroll;
                  availableScrollTop += position;
              }
          }
          var parent_1 = target.parentNode;
          // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
          // this is the same logic used in focus-lock
          target = (parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1);
      } while (
      // portaled content
      (!targetInLock && target !== document.body) ||
          // self content
          (targetInLock && (endTarget.contains(target) || endTarget === target)));
      // handle epsilon around 0 (non standard zoom levels)
      if (isDeltaPositive &&
          ((Math.abs(availableScroll) < 1) || (false))) {
          shouldCancelScroll = true;
      }
      else if (!isDeltaPositive &&
          ((Math.abs(availableScrollTop) < 1) || (false))) {
          shouldCancelScroll = true;
      }
      return shouldCancelScroll;
  };

  var getTouchXY = function (event) {
      return 'changedTouches' in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
  };
  var getDeltaXY = function (event) { return [event.deltaX, event.deltaY]; };
  var extractRef = function (ref) {
      return ref && 'current' in ref ? ref.current : ref;
  };
  var deltaCompare = function (x, y) { return x[0] === y[0] && x[1] === y[1]; };
  var generateStyle = function (id) { return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n"); };
  var idCounter = 0;
  var lockStack = [];
  function RemoveScrollSideCar(props) {
      var shouldPreventQueue = React__namespace.useRef([]);
      var touchStartRef = React__namespace.useRef([0, 0]);
      var activeAxis = React__namespace.useRef();
      var id = React__namespace.useState(idCounter++)[0];
      var Style = React__namespace.useState(styleSingleton)[0];
      var lastProps = React__namespace.useRef(props);
      React__namespace.useEffect(function () {
          lastProps.current = props;
      }, [props]);
      React__namespace.useEffect(function () {
          if (props.inert) {
              document.body.classList.add("block-interactivity-".concat(id));
              var allow_1 = __spreadArray([props.lockRef.current], (props.shards || []).map(extractRef), true).filter(Boolean);
              allow_1.forEach(function (el) { return el.classList.add("allow-interactivity-".concat(id)); });
              return function () {
                  document.body.classList.remove("block-interactivity-".concat(id));
                  allow_1.forEach(function (el) { return el.classList.remove("allow-interactivity-".concat(id)); });
              };
          }
          return;
      }, [props.inert, props.lockRef.current, props.shards]);
      var shouldCancelEvent = React__namespace.useCallback(function (event, parent) {
          if (('touches' in event && event.touches.length === 2) || (event.type === 'wheel' && event.ctrlKey)) {
              return !lastProps.current.allowPinchZoom;
          }
          var touch = getTouchXY(event);
          var touchStart = touchStartRef.current;
          var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
          var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
          var currentAxis;
          var target = event.target;
          var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
          // allow horizontal touch move on Range inputs. They will not cause any scroll
          if ('touches' in event && moveDirection === 'h' && target.type === 'range') {
              return false;
          }
          // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
          var selection = window.getSelection();
          var anchorNode = selection && selection.anchorNode;
          var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
          if (isTouchingSelection) {
              return false;
          }
          var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
          if (!canBeScrolledInMainDirection) {
              return true;
          }
          if (canBeScrolledInMainDirection) {
              currentAxis = moveDirection;
          }
          else {
              currentAxis = moveDirection === 'v' ? 'h' : 'v';
              canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
              // other axis might be not scrollable
          }
          if (!canBeScrolledInMainDirection) {
              return false;
          }
          if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) {
              activeAxis.current = currentAxis;
          }
          if (!currentAxis) {
              return true;
          }
          var cancelingAxis = activeAxis.current || currentAxis;
          return handleScroll(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY);
      }, []);
      var shouldPrevent = React__namespace.useCallback(function (_event) {
          var event = _event;
          if (!lockStack.length || lockStack[lockStack.length - 1] !== Style) {
              // not the last active
              return;
          }
          var delta = 'deltaY' in event ? getDeltaXY(event) : getTouchXY(event);
          var sourceEvent = shouldPreventQueue.current.filter(function (e) { return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && deltaCompare(e.delta, delta); })[0];
          // self event, and should be canceled
          if (sourceEvent && sourceEvent.should) {
              if (event.cancelable) {
                  event.preventDefault();
              }
              return;
          }
          // outside or shard event
          if (!sourceEvent) {
              var shardNodes = (lastProps.current.shards || [])
                  .map(extractRef)
                  .filter(Boolean)
                  .filter(function (node) { return node.contains(event.target); });
              var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
              if (shouldStop) {
                  if (event.cancelable) {
                      event.preventDefault();
                  }
              }
          }
      }, []);
      var shouldCancel = React__namespace.useCallback(function (name, delta, target, should) {
          var event = { name: name, delta: delta, target: target, should: should, shadowParent: getOutermostShadowParent(target) };
          shouldPreventQueue.current.push(event);
          setTimeout(function () {
              shouldPreventQueue.current = shouldPreventQueue.current.filter(function (e) { return e !== event; });
          }, 1);
      }, []);
      var scrollTouchStart = React__namespace.useCallback(function (event) {
          touchStartRef.current = getTouchXY(event);
          activeAxis.current = undefined;
      }, []);
      var scrollWheel = React__namespace.useCallback(function (event) {
          shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
      }, []);
      var scrollTouchMove = React__namespace.useCallback(function (event) {
          shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props.lockRef.current));
      }, []);
      React__namespace.useEffect(function () {
          lockStack.push(Style);
          props.setCallbacks({
              onScrollCapture: scrollWheel,
              onWheelCapture: scrollWheel,
              onTouchMoveCapture: scrollTouchMove,
          });
          document.addEventListener('wheel', shouldPrevent, nonPassive);
          document.addEventListener('touchmove', shouldPrevent, nonPassive);
          document.addEventListener('touchstart', scrollTouchStart, nonPassive);
          return function () {
              lockStack = lockStack.filter(function (inst) { return inst !== Style; });
              document.removeEventListener('wheel', shouldPrevent, nonPassive);
              document.removeEventListener('touchmove', shouldPrevent, nonPassive);
              document.removeEventListener('touchstart', scrollTouchStart, nonPassive);
          };
      }, []);
      var removeScrollBar = props.removeScrollBar, inert = props.inert;
      return (React__namespace.createElement(React__namespace.Fragment, null,
          inert ? React__namespace.createElement(Style, { styles: generateStyle(id) }) : null,
          removeScrollBar ? React__namespace.createElement(RemoveScrollBar, { noRelative: props.noRelative, gapMode: props.gapMode }) : null));
  }
  function getOutermostShadowParent(node) {
      var shadowParent = null;
      while (node !== null) {
          if (node instanceof ShadowRoot) {
              shadowParent = node.host;
              node = node.host;
          }
          node = node.parentNode;
      }
      return shadowParent;
  }

  var SideCar = exportSidecar(effectCar, RemoveScrollSideCar);

  var ReactRemoveScroll = React__namespace.forwardRef(function (props, ref) { return (React__namespace.createElement(RemoveScroll, __assign({}, props, { ref: ref, sideCar: SideCar }))); });
  ReactRemoveScroll.classNames = RemoveScroll.classNames;

  function ModalFocusScope(props) {
    const {
      autoFocus,
      trapFocus,
      dialogRef,
      initialFocusRef,
      blockScrollOnMount,
      allowPinchZoom,
      finalFocusRef,
      returnFocusOnClose,
      preserveScrollBarGap,
      lockFocusAcrossFrames,
      isOpen
    } = useModalContext();
    const [isPresent, safeToRemove] = usePresence();
    React.useEffect(() => {
      if (!isPresent && safeToRemove) {
        setTimeout(safeToRemove);
      }
    }, [isPresent, safeToRemove]);
    const index = useModalManager(dialogRef, isOpen);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      FocusLock,
      {
        autoFocus,
        isDisabled: !trapFocus,
        initialFocusRef,
        finalFocusRef,
        restoreFocus: returnFocusOnClose,
        contentRef: dialogRef,
        lockFocusAcrossFrames,
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          ReactRemoveScroll,
          {
            removeScrollBar: !preserveScrollBarGap,
            allowPinchZoom,
            enabled: index === 1 && blockScrollOnMount,
            forwardProps: true,
            children: props.children
          }
        )
      }
    );
  }

  const ModalBody = forwardRef$1((props, ref) => {
    const { className, ...rest } = props;
    const { bodyId, setBodyMounted } = useModalContext();
    React.useEffect(() => {
      setBodyMounted(true);
      return () => setBodyMounted(false);
    }, [setBodyMounted]);
    const _className = cx$1("chakra-modal__body", className);
    const styles = useModalStyles();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        ref,
        className: _className,
        id: bodyId,
        ...rest,
        __css: styles.body
      }
    );
  });
  ModalBody.displayName = "ModalBody";

  const ModalCloseButton = forwardRef$1(
    (props, ref) => {
      const { onClick, className, ...rest } = props;
      const { onClose } = useModalContext();
      const _className = cx$1("chakra-modal__close-btn", className);
      const styles = useModalStyles();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        CloseButton,
        {
          ref,
          __css: styles.closeButton,
          className: _className,
          onClick: callAllHandlers(onClick, (event) => {
            event.stopPropagation();
            onClose();
          }),
          ...rest
        }
      );
    }
  );
  ModalCloseButton.displayName = "ModalCloseButton";

  const ModalHeader = forwardRef$1(
    (props, ref) => {
      const { className, ...rest } = props;
      const { headerId, setHeaderMounted } = useModalContext();
      React.useEffect(() => {
        setHeaderMounted(true);
        return () => setHeaderMounted(false);
      }, [setHeaderMounted]);
      const _className = cx$1("chakra-modal__header", className);
      const styles = useModalStyles();
      const headerStyles = defineStyle({
        flex: 0,
        ...styles.header
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.header,
        {
          ref,
          className: _className,
          id: headerId,
          ...rest,
          __css: headerStyles
        }
      );
    }
  );
  ModalHeader.displayName = "ModalHeader";

  const variants$1 = {
    enter: ({ transition, transitionEnd, delay } = {}) => ({
      opacity: 1,
      transition: transition?.enter ?? withDelay.enter(TRANSITION_DEFAULTS.enter, delay),
      transitionEnd: transitionEnd?.enter
    }),
    exit: ({ transition, transitionEnd, delay } = {}) => ({
      opacity: 0,
      transition: transition?.exit ?? withDelay.exit(TRANSITION_DEFAULTS.exit, delay),
      transitionEnd: transitionEnd?.exit
    })
  };
  const fadeConfig = {
    initial: "exit",
    animate: "enter",
    exit: "exit",
    variants: variants$1
  };
  const Fade = React.forwardRef(
    function Fade2(props, ref) {
      const {
        unmountOnExit,
        in: isOpen,
        className,
        transition,
        transitionEnd,
        delay,
        animatePresenceProps,
        ...rest
      } = props;
      const animate = isOpen || unmountOnExit ? "enter" : "exit";
      const show = unmountOnExit ? isOpen && unmountOnExit : true;
      const custom = { transition, transitionEnd, delay };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { ...animatePresenceProps, custom, children: show && /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          ref,
          className: cx$1("chakra-fade", className),
          custom,
          ...fadeConfig,
          animate,
          ...rest
        }
      ) });
    }
  );
  Fade.displayName = "Fade";

  const MotionDiv$2 = chakra$1(motion.div);
  const ModalOverlay = forwardRef$1(
    (props, ref) => {
      const { className, transition, motionProps: _motionProps, ...rest } = props;
      const _className = cx$1("chakra-modal__overlay", className);
      const styles = useModalStyles();
      const overlayStyle = {
        pos: "fixed",
        left: "0",
        top: "0",
        w: "100vw",
        h: "100vh",
        ...styles.overlay
      };
      const { motionPreset } = useModalContext();
      const defaultMotionProps = motionPreset === "none" ? {} : fadeConfig;
      const motionProps = _motionProps || defaultMotionProps;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        MotionDiv$2,
        {
          ...motionProps,
          __css: overlayStyle,
          ref,
          className: _className,
          ...rest
        }
      );
    }
  );
  ModalOverlay.displayName = "ModalOverlay";

  const [DrawerContextProvider, useDrawerContext] = createContext$1();
  const placementMap = {
    start: { ltr: "left", rtl: "right" },
    end: { ltr: "right", rtl: "left" }
  };
  function getDrawerPlacement(placement, dir) {
    if (!placement)
      return;
    return placementMap[placement]?.[dir] ?? placement;
  }
  function Drawer(props) {
    const {
      isOpen,
      onClose,
      placement: placementProp = "right",
      children,
      ...rest
    } = props;
    const theme = useTheme();
    const drawerStyleConfig = theme.components?.Drawer;
    const placement = getDrawerPlacement(placementProp, theme.direction);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerContextProvider, { value: { placement }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      Modal,
      {
        isOpen,
        onClose,
        styleConfig: drawerStyleConfig,
        ...rest,
        children
      }
    ) });
  }

  const defaultTransition = {
    exit: {
      duration: 0.15,
      ease: TRANSITION_EASINGS.easeInOut
    },
    enter: {
      type: "spring",
      damping: 25,
      stiffness: 180
    }
  };
  const variants = {
    exit: ({ direction, transition, transitionEnd, delay }) => {
      const { exit: exitStyles } = getSlideTransition({ direction });
      return {
        ...exitStyles,
        transition: transition?.exit ?? withDelay.exit(defaultTransition.exit, delay),
        transitionEnd: transitionEnd?.exit
      };
    },
    enter: ({ direction, transitionEnd, transition, delay }) => {
      const { enter: enterStyles } = getSlideTransition({ direction });
      return {
        ...enterStyles,
        transition: transition?.enter ?? withDelay.enter(defaultTransition.enter, delay),
        transitionEnd: transitionEnd?.enter
      };
    }
  };
  const Slide = React.forwardRef(
    function Slide2(props, ref) {
      const {
        direction = "right",
        style,
        unmountOnExit,
        in: isOpen,
        className,
        transition,
        transitionEnd,
        delay,
        motionProps,
        animatePresenceProps,
        ...rest
      } = props;
      const transitionStyles = getSlideTransition({ direction });
      const computedStyle = Object.assign(
        { position: "fixed" },
        transitionStyles.position,
        style
      );
      const show = unmountOnExit ? isOpen && unmountOnExit : true;
      const animate = isOpen || unmountOnExit ? "enter" : "exit";
      const custom = { transitionEnd, transition, direction, delay };
      return /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { ...animatePresenceProps, custom, children: show && /* @__PURE__ */ jsxRuntimeExports.jsx(
        motion.div,
        {
          ...rest,
          ref,
          initial: "exit",
          className: cx$1("chakra-slide", className),
          animate,
          exit: "exit",
          custom,
          variants,
          style: computedStyle,
          ...motionProps
        }
      ) });
    }
  );
  Slide.displayName = "Slide";

  const MotionDiv$1 = chakra$1(Slide);
  const DrawerContent = forwardRef$1(
    (props, ref) => {
      const {
        className,
        children,
        motionProps,
        containerProps: rootProps,
        ...rest
      } = props;
      const { getDialogProps, getDialogContainerProps, isOpen } = useModalContext();
      const dialogProps = getDialogProps(rest, ref);
      const containerProps = getDialogContainerProps(rootProps);
      const _className = cx$1("chakra-modal__content", className);
      const styles = useModalStyles();
      const dialogStyles = {
        display: "flex",
        flexDirection: "column",
        position: "relative",
        width: "100%",
        outline: 0,
        ...styles.dialog
      };
      const dialogContainerStyles = {
        display: "flex",
        width: "100vw",
        height: "$100vh",
        position: "fixed",
        left: 0,
        top: 0,
        ...styles.dialogContainer
      };
      const { placement } = useDrawerContext();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(ModalFocusScope, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...containerProps,
          className: "chakra-modal__content-container",
          __css: dialogContainerStyles,
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            MotionDiv$1,
            {
              motionProps,
              direction: placement,
              in: isOpen,
              className: _className,
              ...dialogProps,
              __css: dialogStyles,
              children
            }
          )
        }
      ) });
    }
  );
  DrawerContent.displayName = "DrawerContent";

  const [PopoverProvider, usePopoverContext] = createContext$1({
    name: "PopoverContext",
    errorMessage: "usePopoverContext: `context` is undefined. Seems you forgot to wrap all popover components within `<Popover />`"
  });
  const [PopoverStylesProvider, usePopoverStyles] = createContext$1({
    name: `PopoverStylesContext`,
    errorMessage: `usePopoverStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Popover />" `
  });

  const TRIGGER = {
    click: "click",
    hover: "hover"
  };
  function usePopover(props = {}) {
    const {
      closeOnBlur = true,
      closeOnEsc = true,
      initialFocusRef,
      id,
      returnFocusOnClose = true,
      autoFocus = true,
      arrowSize,
      arrowShadowColor,
      trigger = TRIGGER.click,
      openDelay = 200,
      closeDelay = 200,
      isLazy,
      lazyBehavior = "unmount",
      computePositionOnMount,
      ...popperProps
    } = props;
    const { isOpen, onClose, onOpen, onToggle } = useDisclosure(props);
    const [restoreFocus, setRestoreFocus] = React.useState(returnFocusOnClose);
    React.useEffect(() => setRestoreFocus(returnFocusOnClose), [returnFocusOnClose]);
    const anchorRef = React.useRef(null);
    const triggerRef = React.useRef(null);
    const popoverRef = React.useRef(null);
    const isHoveringRef = React.useRef(false);
    const hasBeenOpened = React.useRef(false);
    if (isOpen) {
      hasBeenOpened.current = true;
    }
    const [hasHeader, setHasHeader] = React.useState(false);
    const [hasBody, setHasBody] = React.useState(false);
    const uuid = React.useId();
    const uid = id ?? uuid;
    const [triggerId, popoverId, headerId, bodyId] = [
      "popover-trigger",
      "popover-content",
      "popover-header",
      "popover-body"
    ].map((id2) => `${id2}-${uid}`);
    const {
      referenceRef,
      getArrowProps,
      getPopperProps,
      getArrowInnerProps,
      forceUpdate
    } = usePopper$1({
      ...popperProps,
      enabled: isOpen || !!computePositionOnMount
    });
    const animated = useAnimationState({ isOpen, ref: popoverRef });
    useFocusOnPointerDown({
      enabled: isOpen,
      ref: triggerRef
    });
    useFocusOnHide(popoverRef, {
      focusRef: triggerRef,
      visible: isOpen,
      shouldFocus: restoreFocus && trigger === TRIGGER.click
    });
    useFocusOnShow(popoverRef, {
      focusRef: initialFocusRef,
      visible: isOpen,
      shouldFocus: autoFocus && trigger === TRIGGER.click
    });
    useOutsideClick({
      enabled: isOpen && closeOnBlur,
      ref: popoverRef,
      handler(event) {
        const relatedTarget = event.composedPath?.()[0] ?? [
          event.target
        ];
        if (contains(triggerRef.current, relatedTarget))
          return;
        if (relatedTarget) {
          setRestoreFocus(!isFocusable(relatedTarget));
        }
        onClose();
      }
    });
    const shouldRenderChildren = lazyDisclosure({
      wasSelected: hasBeenOpened.current,
      enabled: isLazy,
      mode: lazyBehavior,
      isSelected: animated.present
    });
    const getPopoverProps = React.useCallback(
      (props2 = {}, _ref = null) => {
        const popoverProps = {
          ...props2,
          style: {
            ...props2.style,
            transformOrigin: cssVars.transformOrigin.varRef,
            [cssVars.arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
            [cssVars.arrowShadowColor.var]: arrowShadowColor
          },
          ref: mergeRefs(popoverRef, _ref),
          children: shouldRenderChildren ? props2.children : null,
          id: popoverId,
          tabIndex: -1,
          role: "dialog",
          onKeyDown: callAllHandlers(props2.onKeyDown, (event) => {
            if (event.nativeEvent.isComposing)
              return;
            if (closeOnEsc && event.key === "Escape") {
              event.preventDefault();
              event.stopPropagation();
              onClose();
            }
          }),
          onBlur: callAllHandlers(props2.onBlur, (event) => {
            const relatedTarget = getRelatedTarget(event);
            const targetIsPopover = contains(popoverRef.current, relatedTarget);
            const targetIsTrigger = contains(triggerRef.current, relatedTarget);
            const isValidBlur = !targetIsPopover && !targetIsTrigger;
            if (relatedTarget) {
              setRestoreFocus(!isFocusable(relatedTarget));
            }
            if (isOpen && closeOnBlur && isValidBlur) {
              onClose();
            }
          }),
          "aria-labelledby": hasHeader ? headerId : void 0,
          "aria-describedby": hasBody ? bodyId : void 0
        };
        if (trigger === TRIGGER.hover) {
          popoverProps.role = "tooltip";
          popoverProps.onMouseEnter = callAllHandlers(props2.onMouseEnter, () => {
            isHoveringRef.current = true;
          });
          popoverProps.onMouseLeave = callAllHandlers(
            props2.onMouseLeave,
            (event) => {
              if (event.nativeEvent.relatedTarget === null) {
                return;
              }
              isHoveringRef.current = false;
              setTimeout(() => onClose(), closeDelay);
            }
          );
        }
        return popoverProps;
      },
      [
        shouldRenderChildren,
        popoverId,
        hasHeader,
        headerId,
        hasBody,
        bodyId,
        trigger,
        closeOnEsc,
        onClose,
        isOpen,
        closeOnBlur,
        closeDelay,
        arrowShadowColor,
        arrowSize
      ]
    );
    const getPopoverPositionerProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => getPopperProps(
        {
          ...props2,
          style: {
            visibility: isOpen ? "visible" : "hidden",
            ...props2.style
          }
        },
        forwardedRef
      ),
      [isOpen, getPopperProps]
    );
    const getAnchorProps = React.useCallback(
      (props2, _ref = null) => {
        return {
          ...props2,
          // If anchor is rendered, it is used as reference.
          ref: mergeRefs(_ref, anchorRef, referenceRef)
        };
      },
      [anchorRef, referenceRef]
    );
    const openTimeout = React.useRef(void 0);
    const closeTimeout = React.useRef(void 0);
    const maybeReferenceRef = React.useCallback(
      (node) => {
        if (anchorRef.current == null) {
          referenceRef(node);
        }
      },
      [referenceRef]
    );
    const getTriggerProps = React.useCallback(
      (props2 = {}, _ref = null) => {
        const triggerProps = {
          ...props2,
          ref: mergeRefs(triggerRef, _ref, maybeReferenceRef),
          id: triggerId,
          "aria-haspopup": "dialog",
          "aria-expanded": isOpen,
          "aria-controls": popoverId
        };
        if (trigger === TRIGGER.click) {
          triggerProps.onClick = callAllHandlers(props2.onClick, onToggle);
        }
        if (trigger === TRIGGER.hover) {
          triggerProps.onFocus = callAllHandlers(props2.onFocus, () => {
            if (openTimeout.current === void 0) {
              onOpen();
            }
          });
          triggerProps.onBlur = callAllHandlers(props2.onBlur, (event) => {
            const relatedTarget = getRelatedTarget(event);
            const isValidBlur = !contains(popoverRef.current, relatedTarget);
            if (isOpen && closeOnBlur && isValidBlur) {
              onClose();
            }
          });
          triggerProps.onKeyDown = callAllHandlers(props2.onKeyDown, (event) => {
            if (event.key === "Escape") {
              onClose();
            }
          });
          triggerProps.onMouseEnter = callAllHandlers(props2.onMouseEnter, () => {
            isHoveringRef.current = true;
            openTimeout.current = window.setTimeout(() => onOpen(), openDelay);
          });
          triggerProps.onMouseLeave = callAllHandlers(props2.onMouseLeave, () => {
            isHoveringRef.current = false;
            if (openTimeout.current) {
              clearTimeout(openTimeout.current);
              openTimeout.current = void 0;
            }
            closeTimeout.current = window.setTimeout(() => {
              if (isHoveringRef.current === false) {
                onClose();
              }
            }, closeDelay);
          });
        }
        return triggerProps;
      },
      [
        triggerId,
        isOpen,
        popoverId,
        trigger,
        maybeReferenceRef,
        onToggle,
        onOpen,
        closeOnBlur,
        onClose,
        openDelay,
        closeDelay
      ]
    );
    React.useEffect(() => {
      return () => {
        if (openTimeout.current) {
          clearTimeout(openTimeout.current);
        }
        if (closeTimeout.current) {
          clearTimeout(closeTimeout.current);
        }
      };
    }, []);
    const getHeaderProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        id: headerId,
        ref: mergeRefs(ref, (node) => {
          setHasHeader(!!node);
        })
      }),
      [headerId]
    );
    const getBodyProps = React.useCallback(
      (props2 = {}, ref = null) => ({
        ...props2,
        id: bodyId,
        ref: mergeRefs(ref, (node) => {
          setHasBody(!!node);
        })
      }),
      [bodyId]
    );
    return {
      forceUpdate,
      isOpen,
      onAnimationComplete: animated.onComplete,
      onClose,
      getAnchorProps,
      getArrowProps,
      getArrowInnerProps,
      getPopoverPositionerProps,
      getPopoverProps,
      getTriggerProps,
      getHeaderProps,
      getBodyProps
    };
  }
  function contains(parent, child) {
    return parent === child || parent?.contains(child);
  }
  function getRelatedTarget(event) {
    const activeEl = event.currentTarget.ownerDocument.activeElement;
    return event.relatedTarget ?? activeEl;
  }

  function Popover(props) {
    const styles = useMultiStyleConfig("Popover", props);
    const { children, ...rest } = omitThemingProps(props);
    const theme = useTheme();
    const context = usePopover({ ...rest, direction: theme.direction });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverProvider, { value: context, children: /* @__PURE__ */ jsxRuntimeExports.jsx(PopoverStylesProvider, { value: styles, children: runIfFn$3(children, {
      isOpen: context.isOpen,
      onClose: context.onClose,
      forceUpdate: context.forceUpdate
    }) }) });
  }
  Popover.displayName = "Popover";

  function getElementRef(el) {
    const version = React__namespace.version;
    if (typeof version !== "string")
      return el?.ref;
    if (version.startsWith("18."))
      return el?.ref;
    return el?.props?.ref;
  }

  const resolveVar = (scale, value) => value ? `${scale}.${value}, ${value}` : void 0;
  function PopoverArrow(props) {
    const {
      bg,
      bgColor,
      backgroundColor,
      shadow,
      boxShadow,
      shadowColor,
      ...rest
    } = props;
    const { getArrowProps, getArrowInnerProps } = usePopoverContext();
    const styles = usePopoverStyles();
    const arrowBg = bg ?? bgColor ?? backgroundColor;
    const arrowShadow = shadow ?? boxShadow;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        ...getArrowProps(),
        className: "chakra-popover__arrow-positioner",
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          chakra$1.div,
          {
            className: cx$1("chakra-popover__arrow", props.className),
            ...getArrowInnerProps(rest),
            __css: {
              "--popper-arrow-shadow-color": resolveVar("colors", shadowColor),
              "--popper-arrow-bg": resolveVar("colors", arrowBg),
              "--popper-arrow-shadow": resolveVar("shadows", arrowShadow),
              ...styles.arrow
            }
          }
        )
      }
    );
  }
  PopoverArrow.displayName = "PopoverArrow";

  const PopoverBody = forwardRef$1(
    function PopoverBody2(props, ref) {
      const { getBodyProps } = usePopoverContext();
      const styles = usePopoverStyles();
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...getBodyProps(props, ref),
          className: cx$1("chakra-popover__body", props.className),
          __css: styles.body
        }
      );
    }
  );
  PopoverBody.displayName = "PopoverBody";

  function mergeVariants(variants) {
    if (!variants)
      return;
    return {
      enter: {
        ...variants.enter,
        visibility: "visible"
      },
      exit: {
        ...variants.exit,
        transitionEnd: {
          visibility: "hidden"
        }
      }
    };
  }
  const scaleFade = {
    exit: {
      opacity: 0,
      scale: 0.95,
      transition: {
        duration: 0.1,
        ease: [0.4, 0, 1, 1]
      }
    },
    enter: {
      scale: 1,
      opacity: 1,
      transition: {
        duration: 0.15,
        ease: [0, 0, 0.2, 1]
      }
    }
  };
  const MotionSection = chakra$1(motion.section);
  const PopoverTransition = forwardRef$1(function PopoverTransition2(props, ref) {
    const { variants = scaleFade, ...rest } = props;
    const { isOpen } = usePopoverContext();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      MotionSection,
      {
        ref,
        variants: mergeVariants(variants),
        initial: false,
        animate: isOpen ? "enter" : "exit",
        ...rest
      }
    );
  });
  PopoverTransition.displayName = "PopoverTransition";

  const PopoverContent = forwardRef$1(
    function PopoverContent2(props, ref) {
      const { rootProps, motionProps, ...contentProps } = props;
      const { getPopoverProps, getPopoverPositionerProps, onAnimationComplete } = usePopoverContext();
      const styles = usePopoverStyles();
      const contentStyles = defineStyle({
        position: "relative",
        display: "flex",
        flexDirection: "column",
        ...styles.content
      });
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...getPopoverPositionerProps(rootProps),
          __css: styles.popper,
          className: "chakra-popover__popper",
          children: /* @__PURE__ */ jsxRuntimeExports.jsx(
            PopoverTransition,
            {
              ...motionProps,
              ...getPopoverProps(contentProps, ref),
              onAnimationComplete: callAll(
                onAnimationComplete,
                contentProps.onAnimationComplete
              ),
              className: cx$1("chakra-popover__content", props.className),
              __css: contentStyles
            }
          )
        }
      );
    }
  );
  PopoverContent.displayName = "PopoverContent";

  function PopoverFooter(props) {
    const styles = usePopoverStyles();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.footer,
      {
        ...props,
        className: cx$1("chakra-popover__footer", props.className),
        __css: styles.footer
      }
    );
  }
  PopoverFooter.displayName = "PopoverFooter";

  function PopoverTrigger(props) {
    const child = React.Children.only(props.children);
    const { getTriggerProps } = usePopoverContext();
    return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: React.cloneElement(child, getTriggerProps(child.props, getElementRef(child))) });
  }
  PopoverTrigger.displayName = "PopoverTrigger";

  const SelectField = forwardRef$1(
    function SelectField2(props, ref) {
      const { children, placeholder, className, ...rest } = props;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(
        chakra$1.select,
        {
          ...rest,
          ref,
          className: cx$1("chakra-select", className),
          children: [
            placeholder && /* @__PURE__ */ jsxRuntimeExports.jsx("option", { value: "", children: placeholder }),
            children
          ]
        }
      );
    }
  );
  SelectField.displayName = "SelectField";

  const Select = forwardRef$1((props, ref) => {
    const styles = useMultiStyleConfig("Select", props);
    const {
      rootProps,
      placeholder,
      icon,
      color,
      height,
      h,
      minH,
      minHeight,
      iconColor,
      iconSize,
      ...rest
    } = omitThemingProps(props);
    const [layoutProps, otherProps] = split(rest, layoutPropNames);
    const ownProps = useFormControl(otherProps);
    const rootStyles = {
      width: "100%",
      height: "fit-content",
      position: "relative",
      color
    };
    const fieldStyles = {
      paddingEnd: "2rem",
      ...styles.field,
      _focus: {
        zIndex: "unset",
        ...styles.field?.["_focus"]
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(
      chakra$1.div,
      {
        className: "chakra-select__wrapper",
        __css: rootStyles,
        ...layoutProps,
        ...rootProps,
        children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            SelectField,
            {
              ref,
              height: h ?? height,
              minH: minH ?? minHeight,
              placeholder,
              ...ownProps,
              __css: fieldStyles,
              children: props.children
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports.jsx(
            SelectIcon,
            {
              "data-disabled": dataAttr(ownProps.disabled),
              ...(iconColor || color) && { color: iconColor || color },
              __css: styles.icon,
              ...iconSize && { fontSize: iconSize },
              children: icon
            }
          )
        ]
      }
    );
  });
  Select.displayName = "Select";
  const DefaultIcon = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx("svg", { viewBox: "0 0 24 24", ...props, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
    "path",
    {
      fill: "currentColor",
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  ) });
  const IconWrapper = chakra$1("div", {
    baseStyle: {
      position: "absolute",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      pointerEvents: "none",
      top: "50%",
      transform: "translateY(-50%)"
    }
  });
  const SelectIcon = (props) => {
    const { children = /* @__PURE__ */ jsxRuntimeExports.jsx(DefaultIcon, {}), ...rest } = props;
    const clone = React.cloneElement(children, {
      role: "presentation",
      className: "chakra-select__icon",
      focusable: false,
      "aria-hidden": true,
      // force icon to adhere to `IconWrapper` styles
      style: {
        width: "1em",
        height: "1em",
        color: "currentColor"
      }
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(IconWrapper, { ...rest, className: "chakra-select__icon-wrapper", children: React.isValidElement(children) ? clone : null });
  };
  SelectIcon.displayName = "SelectIcon";

  const StackItem = (props) => /* @__PURE__ */ jsxRuntimeExports.jsx(
    chakra$1.div,
    {
      className: "chakra-stack__item",
      ...props,
      __css: {
        display: "inline-block",
        flex: "0 0 auto",
        minWidth: 0,
        ...props["__css"]
      }
    }
  );
  StackItem.displayName = "StackItem";

  function getDividerStyles(options) {
    const { spacing, direction } = options;
    const dividerStyles = {
      column: {
        my: spacing,
        mx: 0,
        borderLeftWidth: 0,
        borderBottomWidth: "1px"
      },
      "column-reverse": {
        my: spacing,
        mx: 0,
        borderLeftWidth: 0,
        borderBottomWidth: "1px"
      },
      row: {
        mx: spacing,
        my: 0,
        borderLeftWidth: "1px",
        borderBottomWidth: 0
      },
      "row-reverse": {
        mx: spacing,
        my: 0,
        borderLeftWidth: "1px",
        borderBottomWidth: 0
      }
    };
    return {
      "&": mapResponsive(
        direction,
        (value) => dividerStyles[value]
      )
    };
  }

  const Stack = forwardRef$1((props, ref) => {
    const {
      isInline,
      direction: directionProp,
      align,
      justify,
      spacing = "0.5rem",
      wrap,
      children,
      divider,
      className,
      shouldWrapChildren,
      ...rest
    } = props;
    const direction = isInline ? "row" : directionProp ?? "column";
    const dividerStyle = React.useMemo(
      () => getDividerStyles({ spacing, direction }),
      [spacing, direction]
    );
    const hasDivider = !!divider;
    const shouldUseChildren = !shouldWrapChildren && !hasDivider;
    const clones = React.useMemo(() => {
      const validChildren = getValidChildren(children);
      return shouldUseChildren ? validChildren : validChildren.map((child, index) => {
        const key = typeof child.key !== "undefined" ? child.key : index;
        const isLast = index + 1 === validChildren.length;
        const wrappedChild = /* @__PURE__ */ jsxRuntimeExports.jsx(StackItem, { children: child }, key);
        const _child = shouldWrapChildren ? wrappedChild : child;
        if (!hasDivider)
          return _child;
        const clonedDivider = React.cloneElement(
          divider,
          {
            __css: dividerStyle
          }
        );
        const _divider = isLast ? null : clonedDivider;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(React.Fragment, { children: [
          _child,
          _divider
        ] }, key);
      });
    }, [
      divider,
      dividerStyle,
      hasDivider,
      shouldUseChildren,
      shouldWrapChildren,
      children
    ]);
    const _className = cx$1("chakra-stack", className);
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.div,
      {
        ref,
        display: "flex",
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction,
        flexWrap: wrap,
        gap: hasDivider ? void 0 : spacing,
        className: _className,
        ...rest,
        children: clones
      }
    );
  });
  Stack.displayName = "Stack";

  const HStack = forwardRef$1((props, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { align: "center", ...props, direction: "row", ref }));
  HStack.displayName = "HStack";

  const VStack = forwardRef$1((props, ref) => /* @__PURE__ */ jsxRuntimeExports.jsx(Stack, { align: "center", ...props, direction: "column", ref }));
  VStack.displayName = "VStack";

  const omitted = ["h", "minH", "height", "minHeight"];
  const Textarea$1 = forwardRef$1((props, ref) => {
    const styles = useStyleConfig("Textarea", props);
    const { className, rows, ...rest } = omitThemingProps(props);
    const textareaProps = useFormControl(rest);
    const textareaStyles = rows ? omit(styles, omitted) : styles;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.textarea,
      {
        ref,
        rows,
        ...textareaProps,
        className: cx$1("chakra-textarea", className),
        __css: textareaStyles
      }
    );
  });
  Textarea$1.displayName = "Textarea";

  const scale = {
    exit: {
      scale: 0.85,
      opacity: 0,
      transition: {
        opacity: { duration: 0.15, easings: "easeInOut" },
        scale: { duration: 0.2, easings: "easeInOut" }
      }
    },
    enter: {
      scale: 1,
      opacity: 1,
      transition: {
        opacity: { easings: "easeOut", duration: 0.2 },
        scale: { duration: 0.2, ease: [0.175, 0.885, 0.4, 1.1] }
      }
    }
  };

  const getDoc = (ref) => ref.current?.ownerDocument || document;
  const getWin = (ref) => ref.current?.ownerDocument?.defaultView || window;
  function useTooltip(props = {}) {
    const {
      openDelay = 0,
      closeDelay = 0,
      closeOnClick = true,
      closeOnMouseDown,
      closeOnScroll,
      closeOnPointerDown = closeOnMouseDown,
      closeOnEsc = true,
      onOpen: onOpenProp,
      onClose: onCloseProp,
      placement,
      id,
      isOpen: isOpenProp,
      defaultIsOpen,
      arrowSize = 10,
      arrowShadowColor,
      arrowPadding,
      modifiers,
      isDisabled,
      gutter,
      offset,
      direction,
      ...htmlProps
    } = props;
    const { isOpen, onOpen, onClose } = useDisclosure({
      isOpen: isOpenProp,
      defaultIsOpen,
      onOpen: onOpenProp,
      onClose: onCloseProp
    });
    const { referenceRef, getPopperProps, getArrowInnerProps, getArrowProps } = usePopper$1({
      enabled: isOpen,
      placement,
      arrowPadding,
      modifiers,
      gutter,
      offset,
      direction
    });
    const uuid = React.useId();
    const uid = id ?? uuid;
    const tooltipId = `tooltip-${uid}`;
    const ref = React.useRef(null);
    const enterTimeout = React.useRef(void 0);
    const clearEnterTimeout = React.useCallback(() => {
      if (enterTimeout.current) {
        clearTimeout(enterTimeout.current);
        enterTimeout.current = void 0;
      }
    }, []);
    const exitTimeout = React.useRef(void 0);
    const clearExitTimeout = React.useCallback(() => {
      if (exitTimeout.current) {
        clearTimeout(exitTimeout.current);
        exitTimeout.current = void 0;
      }
    }, []);
    const closeNow = React.useCallback(() => {
      clearExitTimeout();
      onClose();
    }, [onClose, clearExitTimeout]);
    const dispatchCloseEvent = useCloseEvent(ref, closeNow);
    const openWithDelay = React.useCallback(() => {
      if (!isDisabled && !enterTimeout.current) {
        if (isOpen)
          dispatchCloseEvent();
        const win = getWin(ref);
        enterTimeout.current = win.setTimeout(onOpen, openDelay);
      }
    }, [dispatchCloseEvent, isDisabled, isOpen, onOpen, openDelay]);
    const closeWithDelay = React.useCallback(() => {
      clearEnterTimeout();
      const win = getWin(ref);
      exitTimeout.current = win.setTimeout(closeNow, closeDelay);
    }, [closeDelay, closeNow, clearEnterTimeout]);
    const onClick = React.useCallback(() => {
      if (isOpen && closeOnClick) {
        closeWithDelay();
      }
    }, [closeOnClick, closeWithDelay, isOpen]);
    const onPointerDown = React.useCallback(() => {
      if (isOpen && closeOnPointerDown) {
        closeWithDelay();
      }
    }, [closeOnPointerDown, closeWithDelay, isOpen]);
    const onKeyDown = React.useCallback(
      (event) => {
        if (isOpen && event.key === "Escape") {
          closeWithDelay();
        }
      },
      [isOpen, closeWithDelay]
    );
    useEventListener(
      () => getDoc(ref),
      "keydown",
      closeOnEsc ? onKeyDown : void 0
    );
    useEventListener(
      () => {
        if (!closeOnScroll)
          return null;
        const node = ref.current;
        if (!node)
          return null;
        const scrollParent = getScrollParent$1(node);
        return scrollParent.localName === "body" ? getWin(ref) : scrollParent;
      },
      "scroll",
      () => {
        if (isOpen && closeOnScroll) {
          closeNow();
        }
      },
      { passive: true, capture: true }
    );
    React.useEffect(() => {
      if (!isDisabled)
        return;
      clearEnterTimeout();
      if (isOpen)
        onClose();
    }, [isDisabled, isOpen, onClose, clearEnterTimeout]);
    React.useEffect(() => {
      return () => {
        clearEnterTimeout();
        clearExitTimeout();
      };
    }, [clearEnterTimeout, clearExitTimeout]);
    useEventListener(() => ref.current, "pointerleave", closeWithDelay);
    const getTriggerProps = React.useCallback(
      (props2 = {}, _ref = null) => {
        const triggerProps = {
          ...props2,
          ref: mergeRefs(ref, _ref, referenceRef),
          onPointerEnter: callAllHandlers(props2.onPointerEnter, (e) => {
            if (e.pointerType === "touch")
              return;
            openWithDelay();
          }),
          onClick: callAllHandlers(props2.onClick, onClick),
          onPointerDown: callAllHandlers(props2.onPointerDown, onPointerDown),
          onFocus: callAllHandlers(props2.onFocus, openWithDelay),
          onBlur: callAllHandlers(props2.onBlur, closeWithDelay),
          "aria-describedby": isOpen ? tooltipId : void 0
        };
        return triggerProps;
      },
      [
        openWithDelay,
        closeWithDelay,
        onPointerDown,
        isOpen,
        tooltipId,
        onClick,
        referenceRef
      ]
    );
    const getTooltipPositionerProps = React.useCallback(
      (props2 = {}, forwardedRef = null) => getPopperProps(
        {
          ...props2,
          style: {
            ...props2.style,
            [cssVars.arrowSize.var]: arrowSize ? `${arrowSize}px` : void 0,
            [cssVars.arrowShadowColor.var]: arrowShadowColor
          }
        },
        forwardedRef
      ),
      [getPopperProps, arrowSize, arrowShadowColor]
    );
    const getTooltipProps = React.useCallback(
      (props2 = {}, ref2 = null) => {
        const styles = {
          ...props2.style,
          position: "relative",
          transformOrigin: cssVars.transformOrigin.varRef
        };
        return {
          ref: ref2,
          ...htmlProps,
          ...props2,
          id: tooltipId,
          role: "tooltip",
          style: styles
        };
      },
      [htmlProps, tooltipId]
    );
    return {
      isOpen,
      show: openWithDelay,
      hide: closeWithDelay,
      getTriggerProps,
      getTooltipProps,
      getTooltipPositionerProps,
      getArrowProps,
      getArrowInnerProps
    };
  }
  const closeEventName = "chakra-ui:close-tooltip";
  function useCloseEvent(ref, close) {
    React.useEffect(() => {
      const doc = getDoc(ref);
      doc.addEventListener(closeEventName, close);
      return () => doc.removeEventListener(closeEventName, close);
    }, [close, ref]);
    return () => {
      const doc = getDoc(ref);
      const win = getWin(ref);
      doc.dispatchEvent(new win.CustomEvent(closeEventName));
    };
  }

  const MotionDiv = chakra$1(motion.div);
  const Tooltip = forwardRef$1((props, ref) => {
    const styles = useStyleConfig("Tooltip", props);
    const ownProps = omitThemingProps(props);
    const theme = useTheme();
    const {
      children,
      label,
      shouldWrapChildren,
      "aria-label": ariaLabel,
      hasArrow,
      bg,
      portalProps,
      background,
      backgroundColor,
      bgColor,
      motionProps,
      animatePresenceProps,
      ...rest
    } = ownProps;
    const userDefinedBg = background ?? backgroundColor ?? bg ?? bgColor;
    if (userDefinedBg) {
      styles.bg = userDefinedBg;
      const bgVar = getCSSVar(theme, "colors", userDefinedBg);
      styles[cssVars.arrowBg.var] = bgVar;
    }
    const tooltip = useTooltip({ ...rest, direction: theme.direction });
    const shouldWrap = !React.isValidElement(children) || shouldWrapChildren;
    let trigger;
    if (shouldWrap) {
      trigger = /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.span,
        {
          display: "inline-block",
          tabIndex: 0,
          ...tooltip.getTriggerProps(),
          children
        }
      );
    } else {
      const child = React.Children.only(children);
      trigger = React.cloneElement(
        child,
        tooltip.getTriggerProps(child.props, getElementRef(child))
      );
    }
    const hasAriaLabel = !!ariaLabel;
    const _tooltipProps = tooltip.getTooltipProps({}, ref);
    const tooltipProps = hasAriaLabel ? omit(_tooltipProps, ["role", "id"]) : _tooltipProps;
    const srOnlyProps = pick(_tooltipProps, ["role", "id"]);
    if (!label) {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      trigger,
      /* @__PURE__ */ jsxRuntimeExports.jsx(AnimatePresence, { ...animatePresenceProps, children: tooltip.isOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(Portal, { ...portalProps, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.div,
        {
          ...tooltip.getTooltipPositionerProps(),
          __css: {
            zIndex: styles.zIndex,
            pointerEvents: "none"
          },
          children: /* @__PURE__ */ jsxRuntimeExports.jsxs(
            MotionDiv,
            {
              variants: scale,
              initial: "exit",
              animate: "enter",
              exit: "exit",
              ...motionProps,
              ...tooltipProps,
              __css: styles,
              children: [
                label,
                hasAriaLabel && /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.span, { srOnly: true, ...srOnlyProps, children: ariaLabel }),
                hasArrow && /* @__PURE__ */ jsxRuntimeExports.jsx(
                  chakra$1.div,
                  {
                    "data-popper-arrow": true,
                    className: "chakra-tooltip__arrow-wrapper",
                    children: /* @__PURE__ */ jsxRuntimeExports.jsx(
                      chakra$1.div,
                      {
                        "data-popper-arrow-inner": true,
                        className: "chakra-tooltip__arrow",
                        __css: { bg: styles.bg }
                      }
                    )
                  }
                )
              ]
            }
          )
        }
      ) }) })
    ] });
  });
  Tooltip.displayName = "Tooltip";

  const Text = forwardRef$1(function Text2(props, ref) {
    const styles = useStyleConfig("Text", props);
    const { className, align, decoration, casing, ...rest } = omitThemingProps(props);
    const aliasedProps = compact({
      textAlign: props.align,
      textDecoration: props.decoration,
      textTransform: props.casing
    });
    return /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.p,
      {
        ref,
        className: cx$1("chakra-text", props.className),
        ...aliasedProps,
        ...rest,
        __css: styles
      }
    );
  });
  Text.displayName = "Text";

  const Wrap = forwardRef$1(function Wrap2(props, ref) {
    const {
      spacing = "0.5rem",
      spacingX,
      spacingY,
      children,
      justify,
      direction,
      align,
      className,
      shouldWrapChildren,
      ...rest
    } = props;
    const _children = React.useMemo(
      () => shouldWrapChildren ? React.Children.map(children, (child, index) => /* @__PURE__ */ jsxRuntimeExports.jsx(WrapItem, { children: child }, index)) : children,
      [children, shouldWrapChildren]
    );
    return /* @__PURE__ */ jsxRuntimeExports.jsx(chakra$1.div, { ref, className: cx$1("chakra-wrap", className), ...rest, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
      chakra$1.ul,
      {
        className: "chakra-wrap__list",
        __css: {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: justify,
          alignItems: align,
          flexDirection: direction,
          listStyleType: "none",
          gap: spacing,
          columnGap: spacingX,
          rowGap: spacingY,
          padding: "0"
        },
        children: _children
      }
    ) });
  });
  Wrap.displayName = "Wrap";
  const WrapItem = forwardRef$1(
    function WrapItem2(props, ref) {
      const { className, ...rest } = props;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(
        chakra$1.li,
        {
          ref,
          __css: { display: "flex", alignItems: "flex-start" },
          className: cx$1("chakra-wrap__listitem", className),
          ...rest
        }
      );
    }
  );
  WrapItem.displayName = "WrapItem";

  var e;
  !function (C) {
    C[C.Activity_History = 0] = "Activity_History", C[C.Add_Window = 1] = "Add_Window", C[C.Admin = 2] = "Admin", C[C.Alert = 3] = "Alert", C[C.Arrow_Left = 4] = "Arrow_Left", C[C.Arrow_Right = 5] = "Arrow_Right", C[C.Automation = 6] = "Automation", C[C.Badge = 7] = "Badge", C[C.Briefcase = 8] = "Briefcase", C[C.Calendar = 9] = "Calendar", C[C.Cancel = 10] = "Cancel", C[C.Cancel_Circle = 11] = "Cancel_Circle", C[C.Chat = 12] = "Chat", C[C.Check = 13] = "Check", C[C.Check_Circle = 14] = "Check_Circle", C[C.Checkbox = 15] = "Checkbox", C[C.Checkbox_Filled = 16] = "Checkbox_Filled", C[C.Chevron_Down = 17] = "Chevron_Down", C[C.Chevron_Left = 18] = "Chevron_Left", C[C.Chevron_Right = 19] = "Chevron_Right", C[C.Chevron_Up = 20] = "Chevron_Up", C[C.Clipboard = 21] = "Clipboard", C[C.Clock = 22] = "Clock", C[C.Coding = 23] = "Coding", C[C.Comments = 24] = "Comments", C[C.Download = 25] = "Download", C[C.Edit = 26] = "Edit", C[C.Edit_Note = 27] = "Edit_Note", C[C.Encounter = 28] = "Encounter", C[C.Error = 29] = "Error", C[C.Export = 30] = "Export", C[C.Filter = 31] = "Filter", C[C.First = 32] = "First", C[C.Flag = 33] = "Flag", C[C.Footprints = 34] = "Footprints", C[C.Global = 35] = "Global", C[C.Grid = 36] = "Grid", C[C.Gripper = 37] = "Gripper", C[C.Help = 38] = "Help", C[C.History = 39] = "History", C[C.Increase_Priority = 40] = "Increase_Priority", C[C.Info = 41] = "Info", C[C.Labels = 42] = "Labels", C[C.Last = 43] = "Last", C[C.Launch = 44] = "Launch", C[C.Location = 45] = "Location", C[C.Lock = 46] = "Lock", C[C.Logout = 47] = "Logout", C[C.Magic = 48] = "Magic", C[C.Merge = 49] = "Merge", C[C.Minus = 50] = "Minus", C[C.New_Window = 51] = "New_Window", C[C.Notes_Stacked = 52] = "Notes_Stacked", C[C.Off_Hold = 53] = "Off_Hold", C[C.Pending = 54] = "Pending", C[C.Plus = 55] = "Plus", C[C.Plus_Circle = 56] = "Plus_Circle", C[C.Profile_Preference = 57] = "Profile_Preference", C[C.Radio = 58] = "Radio", C[C.Radio_Empty = 59] = "Radio_Empty", C[C.Radio_Filled = 60] = "Radio_Filled", C[C.Reduce_Priority = 61] = "Reduce_Priority", C[C.Refresh = 62] = "Refresh", C[C.Related = 63] = "Related", C[C.Reports = 64] = "Reports", C[C.Reset = 65] = "Reset", C[C.Reset_View = 66] = "Reset_View", C[C.Search = 67] = "Search", C[C.Settings = 68] = "Settings", C[C.Snooze = 69] = "Snooze", C[C.Sort_A_to_Z = 70] = "Sort_A_to_Z", C[C.Sort_Z_to_A = 71] = "Sort_Z_to_A", C[C.Source = 72] = "Source", C[C.Square = 73] = "Square", C[C.Square_Filled = 74] = "Square_Filled", C[C.Star = 75] = "Star", C[C.Stop_Circle = 76] = "Stop_Circle", C[C.Surgery = 77] = "Surgery", C[C.Table = 78] = "Table", C[C.Timeline_ADT = 79] = "Timeline_ADT", C[C.Timeline_DFT = 80] = "Timeline_DFT", C[C.Timeline_MDM = 81] = "Timeline_MDM", C[C.Timeline_ORM = 82] = "Timeline_ORM", C[C.Timeline_RDS = 83] = "Timeline_RDS", C[C.Timeline_SIU = 84] = "Timeline_SIU", C[C.Trash = 85] = "Trash", C[C.Unlock = 86] = "Unlock", C[C.User = 87] = "User", C[C.User_Plus = 88] = "User_Plus", C[C.Vertical_Menu = 89] = "Vertical_Menu", C[C.Visiblity_Off = 90] = "Visiblity_Off", C[C.Visiblity_On = 91] = "Visiblity_On", C[C.Warning = 92] = "Warning", C[C.Worklist_Settings = 93] = "Worklist_Settings", C[C.Wrong_Code = 94] = "Wrong_Code", C[C.Zap = 95] = "Zap";
  }(e || (e = {}));
  var t$1,
    l = new Map([[e.Activity_History, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.513 16.7276C8.75451 16.7276 7.25371 16.14 6.01065 14.9647C4.7676 13.7895 4.07717 12.3424 3.93936 10.6234C3.92226 10.4717 3.9666 10.3472 4.07236 10.25C4.17812 10.1528 4.30723 10.1069 4.45969 10.1122C4.60317 10.1175 4.72859 10.1651 4.83596 10.2548C4.94333 10.3446 5.00288 10.4626 5.01463 10.609C5.15139 12.0214 5.74114 13.2137 6.78388 14.1859C7.8266 15.1581 9.06966 15.6443 10.513 15.6443C12.0269 15.6443 13.3221 15.1061 14.3985 14.0297C15.4749 12.9533 16.013 11.6581 16.013 10.1443C16.013 8.63036 15.4749 7.33522 14.3985 6.25884C13.3221 5.18245 12.0269 4.64425 10.513 4.64425C9.70002 4.64425 8.94729 4.802 8.25486 5.11748C7.56244 5.43297 6.96421 5.8671 6.46017 6.41988H8.03551C8.18896 6.41988 8.3176 6.47139 8.42142 6.57442C8.52524 6.67745 8.57715 6.80511 8.57715 6.95742C8.57715 7.10973 8.52524 7.23876 8.42142 7.34452C8.3176 7.4503 8.18896 7.50319 8.03551 7.50319H5.0163C4.82651 7.50319 4.66742 7.43899 4.53903 7.31059C4.41064 7.1822 4.34644 7.02311 4.34644 6.83332V3.81413C4.34644 3.66066 4.39796 3.53201 4.50098 3.42819C4.60401 3.32437 4.73168 3.27246 4.88398 3.27246C5.03629 3.27246 5.16533 3.32437 5.27109 3.42819C5.37685 3.53201 5.42973 3.66066 5.42973 3.81413V5.99684C6.03657 5.25432 6.77695 4.66271 7.65088 4.222C8.52481 3.78129 9.47887 3.56094 10.513 3.56094C11.4269 3.56094 12.2829 3.73365 13.081 4.07907C13.8791 4.42447 14.5752 4.89416 15.1692 5.48813C15.7631 6.08211 16.2328 6.77811 16.5782 7.57613C16.9236 8.37414 17.0963 9.23003 17.0963 10.1438C17.0963 11.0576 16.9236 11.9136 16.5782 12.7119C16.2328 13.5102 15.7631 14.2064 15.1692 14.8004C14.5752 15.3944 13.8791 15.864 13.081 16.2094C12.2829 16.5549 11.4269 16.7276 10.513 16.7276ZM11.0787 9.59938L13.1621 11.6827C13.2775 11.7981 13.333 11.9223 13.3287 12.0553C13.3245 12.1883 13.262 12.3152 13.1413 12.4359C13.0205 12.5566 12.8915 12.617 12.7542 12.617C12.617 12.617 12.488 12.5566 12.3672 12.4359L10.2066 10.2753C10.1385 10.2071 10.0862 10.1327 10.0499 10.052C10.0136 9.97132 9.99542 9.88791 9.99542 9.80182V6.67915C9.99542 6.52759 10.0484 6.40056 10.1544 6.29804C10.2603 6.19552 10.388 6.14425 10.5374 6.14425C10.6867 6.14425 10.8143 6.19616 10.9201 6.29998C11.0259 6.4038 11.0787 6.53244 11.0787 6.6859V9.59938Z",
        fill: "currentColor"
      }));
    }], [e.Add_Window, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.75646 16.5833C4.38132 16.5833 4.06423 16.4538 3.80521 16.1948C3.54618 15.9358 3.41666 15.6187 3.41666 15.2435V4.75646C3.41666 4.38132 3.54618 4.06424 3.80521 3.80521C4.06423 3.54618 4.38132 3.41667 4.75646 3.41667H8.79812C8.95159 3.41667 9.08021 3.4682 9.18396 3.57125C9.28784 3.67431 9.33979 3.80195 9.33979 3.95417C9.33979 4.10653 9.28784 4.23556 9.18396 4.34125C9.08021 4.44708 8.95159 4.5 8.79812 4.5H4.75646C4.69229 4.5 4.63354 4.52674 4.58021 4.58021C4.52673 4.63354 4.5 4.69229 4.5 4.75646V15.2435C4.5 15.3077 4.52673 15.3665 4.58021 15.4198C4.63354 15.4733 4.69229 15.5 4.75646 15.5H15.2435C15.3077 15.5 15.3665 15.4733 15.4198 15.4198C15.4733 15.3665 15.5 15.3077 15.5 15.2435V11.2019C15.5 11.0484 15.5515 10.9198 15.6546 10.816C15.7576 10.7122 15.8853 10.6602 16.0375 10.6602C16.1899 10.6602 16.3189 10.7122 16.4246 10.816C16.5304 10.9198 16.5833 11.0484 16.5833 11.2019V15.2435C16.5833 15.6187 16.4538 15.9358 16.1948 16.1948C15.9358 16.4538 15.6187 16.5833 15.2435 16.5833H4.75646ZM13.25 6.74479H11.5417C11.3882 6.74479 11.2595 6.69271 11.1556 6.58854C11.0519 6.48424 11 6.35577 11 6.20313C11 6.05049 11.0519 5.92264 11.1556 5.81959C11.2595 5.71653 11.3882 5.665 11.5417 5.665H13.25V3.96313C13.25 3.81063 13.3015 3.68146 13.4046 3.57563C13.5076 3.46965 13.6353 3.41667 13.7875 3.41667C13.9399 3.41667 14.0681 3.46861 14.1721 3.5725C14.2761 3.67625 14.3281 3.80486 14.3281 3.95833V5.66667H16.04C16.1939 5.66667 16.3229 5.71861 16.4271 5.8225C16.5312 5.92639 16.5833 6.05507 16.5833 6.20854C16.5833 6.36215 16.5312 6.49077 16.4271 6.59438C16.3229 6.69813 16.1939 6.75 16.04 6.75H14.3281V8.45833C14.3281 8.61181 14.276 8.74049 14.1717 8.84438C14.0675 8.94813 13.9408 9 13.7915 9C13.6378 9 13.5092 8.94792 13.4056 8.84375C13.3019 8.73958 13.25 8.61056 13.25 8.45667V6.74479Z",
        fill: "currentColor"
      }));
    }], [e.Admin, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M13.8216 14.0796C14.1607 14.0796 14.454 13.9562 14.7015 13.7093C14.9483 13.4618 15.0718 13.1685 15.0718 12.8294C15.0718 12.4903 14.9483 12.197 14.7015 11.9495C14.454 11.7027 14.1607 11.5792 13.8216 11.5792C13.4825 11.5792 13.1895 11.7027 12.9427 11.9495C12.6952 12.197 12.5714 12.4903 12.5714 12.8294C12.5714 13.1685 12.6952 13.4618 12.9427 13.7093C13.1895 13.9562 13.4825 14.0796 13.8216 14.0796ZM13.8216 16.6013C14.2739 16.6013 14.6767 16.5026 15.03 16.3053C15.3834 16.1073 15.6801 15.8458 15.9201 15.521C15.5953 15.323 15.2562 15.1745 14.9029 15.0755C14.5496 14.9771 14.1891 14.928 13.8216 14.928C13.4547 14.928 13.0946 14.9771 12.7413 15.0755C12.388 15.1745 12.0489 15.323 11.7241 15.521C11.9641 15.8458 12.2608 16.1073 12.6141 16.3053C12.9674 16.5026 13.3699 16.6013 13.8216 16.6013ZM13.8216 18C12.7338 18 11.8122 17.6185 11.0567 16.8556C10.3006 16.0927 9.92254 15.1745 9.92254 14.101C9.92254 13.0132 10.304 12.0913 11.0669 11.3351C11.8298 10.5797 12.7481 10.2019 13.8216 10.2019C14.91 10.2019 15.832 10.5834 16.5874 11.3463C17.3436 12.1092 17.7216 13.0274 17.7216 14.101C17.7216 15.1887 17.3402 16.1107 16.5773 16.8668C15.8143 17.6223 14.8958 18 13.8216 18ZM9.51971 17.8942C9.44919 17.88 9.39968 17.8695 9.3712 17.8627C9.3434 17.8552 9.30101 17.8376 9.24405 17.8098C7.54866 17.2449 6.13607 16.1568 5.00627 14.5455C3.87579 12.9356 3.31055 11.1415 3.31055 9.16333V5.37008C3.31055 5.031 3.40583 4.72346 3.59639 4.44745C3.78695 4.17212 4.04499 3.97105 4.3705 3.84424L9.13825 2.08443C9.32203 2.02814 9.50581 2 9.68959 2C9.87337 2 10.0568 2.02814 10.2399 2.08443L14.966 3.84424C15.2915 3.97105 15.5495 4.17212 15.7401 4.44745C15.9306 4.72346 16.0259 5.031 16.0259 5.37008V8.8663C15.8421 8.78153 15.6268 8.70727 15.38 8.64352C15.1324 8.58046 14.8958 8.52756 14.6699 8.48484V5.34872C14.6699 5.29243 14.6557 5.24293 14.6272 5.2002C14.5987 5.15748 14.5564 5.12934 14.5001 5.11577L9.77402 3.37733C9.74554 3.36309 9.7174 3.35597 9.68959 3.35597C9.66111 3.35597 9.63297 3.36309 9.60516 3.37733L4.83639 5.11577C4.7801 5.12934 4.73772 5.15748 4.70924 5.2002C4.68075 5.24293 4.66651 5.29243 4.66651 5.34872V9.16333C4.66651 9.94049 4.76891 10.6753 4.97372 11.3677C5.1792 12.0594 5.46199 12.6985 5.82209 13.2851C6.18219 13.8717 6.59552 14.3837 7.06209 14.8212C7.52798 15.2592 8.02235 15.6197 8.54521 15.9025L8.56657 15.8811C8.6371 16.2202 8.77103 16.5664 8.96838 16.9197C9.1664 17.273 9.39968 17.5907 9.66823 17.8728C9.63975 17.8728 9.615 17.8766 9.59397 17.884C9.57295 17.8908 9.5482 17.8942 9.51971 17.8942Z",
        fill: "currentColor"
      }));
    }], [e.Alert, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 10.863C10.6987 10.863 10.8566 10.7963 10.99 10.6629C11.1234 10.5295 11.1901 10.3719 11.1901 10.19V6.52596C11.1901 6.35754 11.1234 6.20698 10.99 6.07427C10.8566 5.94089 10.6987 5.87419 10.5161 5.87419C10.3336 5.87419 10.1756 5.94089 10.0422 6.07427C9.90881 6.20698 9.84212 6.36462 9.84212 6.54718V10.2102C9.84212 10.3786 9.90881 10.5295 10.0422 10.6629C10.1756 10.7963 10.3336 10.863 10.5161 10.863ZM10.5161 13.9995C10.7128 13.9995 10.8812 13.9365 11.0214 13.8105C11.1615 13.6839 11.2315 13.5084 11.2315 13.2841C11.2315 13.0874 11.1615 12.919 11.0214 12.7788C10.8812 12.6387 10.7128 12.5686 10.5161 12.5686C10.3194 12.5686 10.151 12.6387 10.0109 12.7788C9.87075 12.919 9.80069 13.0874 9.80069 13.2841C9.80069 13.5084 9.87075 13.6839 10.0109 13.8105C10.151 13.9365 10.3194 13.9995 10.5161 13.9995ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Arrow_Left, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.72231 17.7539L2.8659 10.761C2.74027 10.6522 2.65035 10.5338 2.59614 10.4057C2.54279 10.2776 2.51611 10.1495 2.51611 10.0214C2.51611 9.89325 2.54279 9.76515 2.59614 9.63704C2.65035 9.50893 2.74027 9.39047 2.8659 9.28167L9.72231 2.26121C9.90215 2.09712 10.1039 2.01026 10.3277 2.0006C10.5514 1.99183 10.7532 2.0787 10.933 2.26121C11.0939 2.44372 11.1744 2.65386 11.1744 2.89165C11.1744 3.12944 11.0939 3.33959 10.933 3.5221L5.39317 9.14347H17.6552C17.8703 9.14347 18.0674 9.23034 18.2463 9.40408C18.4262 9.57781 18.5161 9.78357 18.5161 10.0214C18.5161 10.2591 18.4262 10.4649 18.2463 10.6386C18.0674 10.8124 17.8703 10.8992 17.6552 10.8992H5.39317L10.933 16.5469C11.0939 16.7119 11.1791 16.9041 11.1886 17.1234C11.1972 17.3428 11.112 17.5529 10.933 17.7539C10.7532 17.918 10.5471 18 10.3148 18C10.0816 18 9.88408 17.918 9.72231 17.7539Z",
        fill: "currentColor"
      }));
    }], [e.Arrow_Right, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.1263 17.7274C9.9284 17.5273 9.82944 17.3224 9.82944 17.1127C9.82944 16.9039 9.91936 16.699 10.0992 16.498L15.6649 10.8742H3.37575C3.16062 10.8742 2.96357 10.7877 2.78459 10.6147C2.6056 10.4417 2.51611 10.2368 2.51611 10C2.51611 9.76322 2.6056 9.55832 2.78459 9.38532C2.96357 9.21232 3.16062 9.12582 3.37575 9.12582H15.6649L10.0992 3.52818C9.91936 3.32809 9.82944 3.11883 9.82944 2.90039C9.82944 2.68196 9.9284 2.4727 10.1263 2.27261C10.3234 2.09087 10.5204 2 10.7175 2C10.9145 2 11.1116 2.09087 11.3086 2.27261L18.1663 9.26343C18.292 9.37178 18.3814 9.48973 18.4348 9.6173C18.489 9.74487 18.5161 9.87243 18.5161 10C18.5161 10.1276 18.489 10.2551 18.4348 10.3827C18.3814 10.5103 18.292 10.6282 18.1663 10.7366L11.3086 17.7274C11.1116 17.9091 10.9145 18 10.7175 18C10.5204 18 10.3234 17.9091 10.1263 17.7274Z",
        fill: "currentColor"
      }));
    }], [e.Automation, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.49998 2.69553C6.85896 2.69553 7.14998 2.98654 7.14998 3.34553V4.68051H9.34998V3.34553C9.34998 2.98654 9.64099 2.69553 9.99998 2.69553C10.359 2.69553 10.65 2.98654 10.65 3.34553V4.68051H12.85V3.34553C12.85 2.98654 13.141 2.69553 13.5 2.69553C13.859 2.69553 14.15 2.98654 14.15 3.34553V4.8959C14.9729 5.21699 15.6285 5.87256 15.9496 6.69553H17.5C17.859 6.69553 18.15 6.98654 18.15 7.34553C18.15 7.70451 17.859 7.99553 17.5 7.99553H16.165V10.1955H17.5C17.859 10.1955 18.15 10.4865 18.15 10.8455C18.15 11.2045 17.859 11.4955 17.5 11.4955H16.165V13.6955H17.5C17.859 13.6955 18.15 13.9865 18.15 14.3455C18.15 14.7045 17.859 14.9955 17.5 14.9955H15.9496C15.6285 15.8185 14.9729 16.474 14.15 16.7951V18.3455C14.15 18.7045 13.859 18.9955 13.5 18.9955C13.141 18.9955 12.85 18.7045 12.85 18.3455V17.0105H10.65V18.3455C10.65 18.7045 10.359 18.9955 9.99998 18.9955C9.64099 18.9955 9.34998 18.7045 9.34998 18.3455V17.0105H7.14998V18.3455C7.14998 18.7045 6.85896 18.9955 6.49998 18.9955C6.14099 18.9955 5.84998 18.7045 5.84998 18.3455V16.7951C5.02706 16.474 4.37152 15.8184 4.05043 14.9955H2.49998C2.14099 14.9955 1.84998 14.7045 1.84998 14.3455C1.84998 13.9865 2.14099 13.6955 2.49998 13.6955H3.83502V11.4955H2.49998C2.14099 11.4955 1.84998 11.2045 1.84998 10.8455C1.84998 10.4865 2.14099 10.1955 2.49998 10.1955H3.83502V7.99553H2.49998C2.14099 7.99553 1.84998 7.70451 1.84998 7.34553C1.84998 6.98654 2.14099 6.69553 2.49998 6.69553H4.05042C4.3715 5.87259 5.02705 5.21703 5.84998 4.89594V3.34553C5.84998 2.98654 6.14099 2.69553 6.49998 2.69553ZM7.00002 6.01051C5.98658 6.01051 5.16502 6.83207 5.16502 7.84551V13.8455C5.16502 14.859 5.98658 15.6805 7.00002 15.6805H13C14.0135 15.6805 14.835 14.859 14.835 13.8455V7.84551C14.835 6.83207 14.0135 6.01051 13 6.01051H7.00002Z",
        fill: "currentColor"
      }));
    }], [e.Badge, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.12821 14.7596H9.87179V14.4086C9.87179 14.1873 9.81287 13.9823 9.69502 13.7935C9.57717 13.6048 9.4128 13.4583 9.20192 13.3542C8.92939 13.2484 8.65346 13.1656 8.37412 13.1058C8.09479 13.0459 7.80342 13.016 7.5 13.016C7.19658 13.016 6.90521 13.0459 6.62587 13.1058C6.34654 13.1656 6.07061 13.2517 5.79808 13.364C5.58719 13.4575 5.42283 13.5992 5.30498 13.7893C5.18713 13.9794 5.12821 14.1858 5.12821 14.4086V14.7596ZM12.6218 13.7436H14.3782C14.5495 13.7436 14.696 13.6828 14.8176 13.5613C14.9392 13.4397 15 13.2933 15 13.1222C15 12.951 14.9392 12.8045 14.8176 12.6827C14.696 12.5609 14.5495 12.5 14.3782 12.5H12.6218C12.4505 12.5 12.304 12.5608 12.1824 12.6823C12.0608 12.8039 12 12.9502 12 13.1214C12 13.2926 12.0608 13.4391 12.1824 13.5609C12.304 13.6827 12.4505 13.7436 12.6218 13.7436ZM7.4981 12.5C7.80919 12.5 8.07424 12.3911 8.29327 12.1734C8.51228 11.9556 8.62179 11.6912 8.62179 11.3801C8.62179 11.069 8.51291 10.804 8.29515 10.585C8.07738 10.3659 7.81296 10.2564 7.5019 10.2564C7.19081 10.2564 6.92576 10.3653 6.70673 10.5831C6.48771 10.8008 6.37821 11.0653 6.37821 11.3763C6.37821 11.6874 6.48709 11.9525 6.70485 12.1715C6.92262 12.3905 7.18703 12.5 7.4981 12.5ZM12.6218 11.5H14.3782C14.5495 11.5 14.696 11.4392 14.8176 11.3177C14.9392 11.1961 15 11.0498 15 10.8786C15 10.7074 14.9392 10.5609 14.8176 10.4391C14.696 10.3173 14.5495 10.2564 14.3782 10.2564H12.6218C12.4505 10.2564 12.304 10.3172 12.1824 10.4388C12.0608 10.5603 12 10.7067 12 10.8778C12 11.049 12.0608 11.1955 12.1824 11.3173C12.304 11.4391 12.4505 11.5 12.6218 11.5ZM3.75644 17.5833C3.38133 17.5833 3.06426 17.4538 2.80523 17.1948C2.5462 16.9357 2.41669 16.6187 2.41669 16.2436V7.75644C2.41669 7.38133 2.5462 7.06426 2.80523 6.80523C3.06426 6.5462 3.38133 6.41669 3.75644 6.41669H8.41669V3.5C8.41669 3.2021 8.52276 2.94707 8.73492 2.73492C8.94707 2.52276 9.2021 2.41669 9.5 2.41669H10.5C10.7979 2.41669 11.0529 2.52276 11.2651 2.73492C11.4772 2.94707 11.5833 3.2021 11.5833 3.5V6.41669H16.2436C16.6187 6.41669 16.9357 6.5462 17.1948 6.80523C17.4538 7.06426 17.5833 7.38133 17.5833 7.75644V16.2436C17.5833 16.6187 17.4538 16.9357 17.1948 17.1948C16.9357 17.4538 16.6187 17.5833 16.2436 17.5833H3.75644ZM3.75644 16.5H16.2436C16.3184 16.5 16.3798 16.476 16.4279 16.4279C16.476 16.3798 16.5 16.3184 16.5 16.2436V7.75644C16.5 7.68165 16.476 7.62021 16.4279 7.57212C16.3798 7.52404 16.3184 7.5 16.2436 7.5H11.5833V7.82054C11.5833 8.11968 11.4765 8.37501 11.2629 8.58654C11.0493 8.79807 10.795 8.90383 10.5 8.90383H9.5C9.20503 8.90383 8.95074 8.79703 8.73712 8.58342C8.5235 8.36981 8.41669 8.11551 8.41669 7.82054V7.5H3.75644C3.68165 7.5 3.62021 7.52404 3.57212 7.57212C3.52404 7.62021 3.5 7.68165 3.5 7.75644V16.2436C3.5 16.3184 3.52404 16.3798 3.57212 16.4279C3.62021 16.476 3.68165 16.5 3.75644 16.5ZM9.5 7.82054H10.5V3.5H9.5V7.82054Z",
        fill: "black"
      }));
    }], [e.Briefcase, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.44222 5.62109V4.23168C7.44222 3.78302 7.59683 3.40409 7.90603 3.09488C8.21457 2.78635 8.5935 2.63208 9.04283 2.63208H11.9894C12.4387 2.63208 12.8177 2.78635 13.1262 3.09488C13.4354 3.40409 13.59 3.78302 13.59 4.23168V5.62109H16.9155C17.3648 5.62109 17.7438 5.7757 18.0523 6.0849C18.3615 6.39344 18.5161 6.77237 18.5161 7.2217V15.7684C18.5161 16.2177 18.3615 16.5966 18.0523 16.9052C17.7438 17.2137 17.3648 17.368 16.9155 17.368H4.11672C3.66739 17.368 3.28846 17.2137 2.97993 16.9052C2.67072 16.5966 2.51611 16.2177 2.51611 15.7684V7.2217C2.51611 6.77237 2.67072 6.39344 2.97993 6.0849C3.28846 5.7757 3.66739 5.62109 4.11672 5.62109H7.44222ZM8.79021 5.62109H12.242V4.23168C12.242 4.17576 12.2141 4.11985 12.1581 4.06394C12.1022 4.00735 12.046 3.97906 11.9894 3.97906H9.04283C8.98624 3.97906 8.92999 4.00735 8.87408 4.06394C8.81816 4.11985 8.79021 4.17576 8.79021 4.23168V5.62109ZM17.1681 12.5894H12.7058V13.3048C12.7058 13.5157 12.625 13.7019 12.4633 13.8636C12.3023 14.0246 12.1093 14.1051 11.8843 14.1051H9.14792C8.92292 14.1051 8.72991 14.0246 8.56891 13.8636C8.40723 13.7019 8.32639 13.5157 8.32639 13.3048V12.5894H3.8641V15.7684C3.8641 15.8243 3.89206 15.8805 3.94797 15.9371C4.00388 15.993 4.06013 16.021 4.11672 16.021H16.9155C16.9721 16.021 17.0283 15.993 17.0843 15.9371C17.1402 15.8805 17.1681 15.8243 17.1681 15.7684V12.5894ZM9.67438 12.7581H11.3578V11.0737H9.67438V12.7581ZM3.8641 11.2424H8.32639V10.526C8.32639 10.3158 8.40723 10.1299 8.56891 9.96819C8.72991 9.80719 8.92292 9.72669 9.14792 9.72669H11.8843C12.1093 9.72669 12.3023 9.80719 12.4633 9.96819C12.625 10.1299 12.7058 10.3158 12.7058 10.526V11.2424H17.1681V7.2217C17.1681 7.16511 17.1402 7.10886 17.0843 7.05295C17.0283 6.99703 16.9721 6.96908 16.9155 6.96908H4.11672C4.06013 6.96908 4.00388 6.99703 3.94797 7.05295C3.89206 7.10886 3.8641 7.16511 3.8641 7.2217V11.2424Z",
        fill: "currentColor"
      }));
    }], [e.Calendar, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 11.8301C10.3073 11.8301 10.1259 11.7498 9.97196 11.5892C9.8187 11.4292 9.74207 11.2515 9.74207 11.0561C9.74207 10.8473 9.8187 10.6626 9.97196 10.5019C10.1259 10.3413 10.3073 10.261 10.5161 10.261C10.7249 10.261 10.9062 10.3413 11.0602 10.5019C11.2134 10.6626 11.2901 10.8473 11.2901 11.0561C11.2901 11.2515 11.2134 11.4292 11.0602 11.5892C10.9062 11.7498 10.7249 11.8301 10.5161 11.8301ZM7.1701 11.8301C6.96063 11.8301 6.77926 11.7498 6.626 11.5892C6.47274 11.4292 6.39611 11.2515 6.39611 11.0561C6.39611 10.8473 6.47274 10.6626 6.626 10.5019C6.77926 10.3413 6.96063 10.261 7.1701 10.261C7.37891 10.261 7.55995 10.3413 7.71321 10.5019C7.86714 10.6626 7.9441 10.8473 7.9441 11.0561C7.9441 11.2515 7.86714 11.4292 7.71321 11.5892C7.55995 11.7498 7.37891 11.8301 7.1701 11.8301ZM13.862 11.8301C13.6532 11.8301 13.4722 11.7498 13.3189 11.5892C13.165 11.4292 13.088 11.2515 13.088 11.0561C13.088 10.8473 13.165 10.6626 13.3189 10.5019C13.4722 10.3413 13.6532 10.261 13.862 10.261C14.0715 10.261 14.2529 10.3413 14.4061 10.5019C14.5594 10.6626 14.636 10.8473 14.636 11.0561C14.636 11.2515 14.5594 11.4292 14.4061 11.5892C14.2529 11.7498 14.0715 11.8301 13.862 11.8301ZM10.5161 15.1138C10.3073 15.1138 10.1259 15.0335 9.97196 14.8729C9.8187 14.7123 9.74207 14.5346 9.74207 14.3398C9.74207 14.1303 9.8187 13.9456 9.97196 13.7857C10.1259 13.625 10.3073 13.5447 10.5161 13.5447C10.7249 13.5447 10.9062 13.625 11.0602 13.7857C11.2134 13.9456 11.2901 14.1303 11.2901 14.3398C11.2901 14.5346 11.2134 14.7123 11.0602 14.8729C10.9062 15.0335 10.7249 15.1138 10.5161 15.1138ZM7.1701 15.1138C6.96063 15.1138 6.77926 15.0335 6.626 14.8729C6.47274 14.7123 6.39611 14.5346 6.39611 14.3398C6.39611 14.1303 6.47274 13.9456 6.626 13.7857C6.77926 13.625 6.96063 13.5447 7.1701 13.5447C7.37891 13.5447 7.55995 13.625 7.71321 13.7857C7.86714 13.9456 7.9441 14.1303 7.9441 14.3398C7.9441 14.5346 7.86714 14.7123 7.71321 14.8729C7.55995 15.0335 7.37891 15.1138 7.1701 15.1138ZM13.862 15.1138C13.6532 15.1138 13.4722 15.0335 13.3189 14.8729C13.165 14.7123 13.088 14.5346 13.088 14.3398C13.088 14.1303 13.165 13.9456 13.3189 13.7857C13.4722 13.625 13.6532 13.5447 13.862 13.5447C14.0715 13.5447 14.2529 13.625 14.4061 13.7857C14.5594 13.9456 14.636 14.1303 14.636 14.3398C14.636 14.5346 14.5594 14.7123 14.4061 14.8729C14.2529 15.0335 14.0715 15.1138 13.862 15.1138ZM4.99468 18C4.54828 18 4.17182 17.8464 3.8653 17.5392C3.55878 17.2327 3.40552 16.8562 3.40552 16.4098V5.45137C3.40552 5.00498 3.55878 4.62852 3.8653 4.322C4.17182 4.01481 4.54828 3.86121 4.99468 3.86121H5.99857V2.69068C5.99857 2.50931 6.06482 2.34902 6.19734 2.20981C6.32985 2.06994 6.48679 2 6.66816 2C6.86291 2 7.02655 2.06994 7.15906 2.20981C7.29158 2.34902 7.35783 2.50931 7.35783 2.69068V3.86121H13.6954V2.66959C13.6954 2.50228 13.765 2.34902 13.9042 2.20981C14.0434 2.06994 14.1967 2 14.364 2C14.5454 2 14.7023 2.06994 14.8348 2.20981C14.9673 2.34902 15.0336 2.50228 15.0336 2.66959V3.86121H16.0375C16.4839 3.86121 16.8603 4.01481 17.1668 4.322C17.4734 4.62852 17.6266 5.00498 17.6266 5.45137V16.4098C17.6266 16.8562 17.4734 17.2327 17.1668 17.5392C16.8603 17.8464 16.4839 18 16.0375 18H4.99468ZM4.99468 16.6608H16.0375C16.1071 16.6608 16.1663 16.6364 16.2152 16.5875C16.264 16.5393 16.2884 16.4801 16.2884 16.4098V8.67185H4.7437V16.4098C4.7437 16.4801 4.76813 16.5393 4.81699 16.5875C4.86584 16.6364 4.92507 16.6608 4.99468 16.6608ZM4.7437 7.33367H16.2884V5.45137C16.2884 5.3811 16.264 5.32187 16.2152 5.27369C16.1663 5.22483 16.1071 5.2004 16.0375 5.2004H4.99468C4.92507 5.2004 4.86584 5.22483 4.81699 5.27369C4.76813 5.32187 4.7437 5.3811 4.7437 5.45137V7.33367Z",
        fill: "currentColor"
      }));
    }], [e.Cancel, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5048 11.0728L5.78922 15.7873C5.64814 15.9291 5.47915 16 5.28224 16C5.08609 16 4.90955 15.9212 4.75263 15.7635C4.59495 15.6066 4.51611 15.43 4.51611 15.2339C4.51611 15.037 4.59495 14.8601 4.75263 14.7031L9.44331 10.0113L4.72886 5.29574C4.58703 5.15466 4.51611 4.98189 4.51611 4.77744C4.51611 4.57299 4.59495 4.3923 4.75263 4.23538C4.90955 4.07846 5.08609 4 5.28224 4C5.47915 4 5.65606 4.07846 5.81298 4.23538L10.5048 8.94983L15.2204 4.23538C15.3615 4.09355 15.5342 4.01886 15.7387 4.01132C15.9431 4.00377 16.1238 4.07846 16.2807 4.23538C16.4377 4.3923 16.5161 4.56922 16.5161 4.76613C16.5161 4.96228 16.4377 5.13882 16.2807 5.29574L11.5663 10.0113L16.2807 14.7269C16.4226 14.868 16.4973 15.037 16.5048 15.2339C16.5123 15.43 16.4377 15.6066 16.2807 15.7635C16.1238 15.9212 15.9469 16 15.75 16C15.5538 16 15.3773 15.9212 15.2204 15.7635L10.5048 11.0728Z",
        fill: "currentColor"
      }));
    }], [e.Cancel_Circle, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.04207 13.474C7.18286 13.6142 7.33747 13.6842 7.50588 13.6842C7.6743 13.6842 7.82856 13.6142 7.96868 13.474L10.5161 10.9266L13.0635 13.474C13.1895 13.6 13.3475 13.663 13.5375 13.663C13.7268 13.663 13.8844 13.6 14.0104 13.474C14.1512 13.3332 14.2179 13.1786 14.2104 13.0102C14.2037 12.8418 14.1303 12.6805 13.9902 12.5262L11.4639 10L14.0104 7.45257C14.137 7.3266 14.2003 7.16862 14.2003 6.97865C14.2003 6.78936 14.137 6.63172 14.0104 6.50575C13.8702 6.36495 13.7126 6.29456 13.5375 6.29456C13.3616 6.29456 13.2037 6.36495 13.0635 6.50575L10.5161 9.05217L7.94746 6.48453C7.82149 6.35788 7.67059 6.29826 7.49477 6.30567C7.31962 6.31241 7.16872 6.3791 7.04207 6.50575C6.90195 6.64587 6.83189 6.80013 6.83189 6.96855C6.83189 7.13696 6.90195 7.29123 7.04207 7.43135L9.5895 10L7.02186 12.5686C6.89521 12.6946 6.83559 12.8455 6.843 13.0213C6.84974 13.1965 6.9161 13.3474 7.04207 13.474ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Chat, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.34787 12.2334H11.3791C11.5475 12.2334 11.6984 12.1704 11.8318 12.0445C11.9651 11.9178 12.0318 11.7565 12.0318 11.5604C12.0318 11.3779 11.9651 11.2199 11.8318 11.0865C11.6984 10.9531 11.5404 10.8864 11.3578 10.8864H6.32665C6.15823 10.8864 6.00733 10.9494 5.87395 11.0754C5.74057 11.2021 5.67388 11.3637 5.67388 11.5604C5.67388 11.7423 5.74057 11.9 5.87395 12.0333C6.00733 12.1667 6.16531 12.2334 6.34787 12.2334ZM6.34787 9.74965H14.7056C14.874 9.74965 15.0249 9.68633 15.1583 9.55968C15.2917 9.4337 15.3584 9.27236 15.3584 9.07566C15.3584 8.8931 15.2917 8.73546 15.1583 8.60275C15.0249 8.46937 14.8669 8.40267 14.6844 8.40267H6.32665C6.15823 8.40267 6.00733 8.46566 5.87395 8.59163C5.74057 8.71828 5.67388 8.87962 5.67388 9.07566C5.67388 9.25822 5.74057 9.41619 5.87395 9.54957C6.00733 9.68296 6.16531 9.74965 6.34787 9.74965ZM6.34787 7.26588H14.7056C14.874 7.26588 15.0249 7.20256 15.1583 7.07591C15.2917 6.94993 15.3584 6.78859 15.3584 6.59189C15.3584 6.40933 15.2917 6.25135 15.1583 6.11797C15.0249 5.98459 14.8669 5.91789 14.6844 5.91789H6.32665C6.15823 5.91789 6.00733 5.98122 5.87395 6.10786C5.74057 6.23384 5.67388 6.39518 5.67388 6.59189C5.67388 6.77445 5.74057 6.93242 5.87395 7.0658C6.00733 7.19919 6.16531 7.26588 6.34787 7.26588ZM2.51611 16.4441V4.36074C2.51611 3.91141 2.67072 3.53248 2.97993 3.22394C3.28846 2.91474 3.66739 2.76013 4.11672 2.76013H16.9155C17.3648 2.76013 17.7438 2.91474 18.0523 3.22394C18.3615 3.53248 18.5161 3.91141 18.5161 4.36074V13.7916C18.5161 14.2409 18.3615 14.6198 18.0523 14.9284C17.7438 15.2369 17.3648 15.3912 16.9155 15.3912H5.50613L3.88532 16.9918C3.63202 17.2444 3.34067 17.304 3.01125 17.1706C2.68116 17.0373 2.51611 16.7951 2.51611 16.4441ZM3.8641 15.1173L4.93723 14.0442H16.9155C16.9862 14.0442 17.0459 14.0196 17.0944 13.9704C17.1435 13.9213 17.1681 13.8616 17.1681 13.7916V4.36074C17.1681 4.29 17.1435 4.23039 17.0944 4.18188C17.0459 4.13271 16.9862 4.10812 16.9155 4.10812H4.11672C4.04599 4.10812 3.98637 4.13271 3.93786 4.18188C3.88869 4.23039 3.8641 4.29 3.8641 4.36074V15.1173ZM3.8641 4.36074V4.10812V15.1173V4.36074Z",
        fill: "currentColor"
      }));
    }], [e.Check, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.91228 15.7056C7.78655 15.7056 7.66125 15.6785 7.53638 15.6242C7.41065 15.5708 7.29397 15.4903 7.18632 15.3827L2.77247 10.9688C2.59335 10.7897 2.50809 10.5791 2.51671 10.3372C2.52532 10.0943 2.61057 9.88333 2.77247 9.70421C2.95159 9.52509 3.16257 9.43553 3.40542 9.43553C3.6474 9.43553 3.84891 9.52509 4.00995 9.70421L7.96653 13.6595L17.0616 4.56441C17.2235 4.38442 17.4212 4.29443 17.6545 4.29443C17.8879 4.29443 18.0851 4.38442 18.2461 4.56441C18.4261 4.74353 18.5161 4.94547 18.5161 5.17023C18.5161 5.39413 18.4261 5.59564 18.2461 5.77476L8.63952 15.3827C8.53188 15.4903 8.41519 15.5708 8.28946 15.6242C8.16373 15.6785 8.038 15.7056 7.91228 15.7056Z",
        fill: "currentColor"
      }));
    }], [e.Check_Circle, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.3581 11.6633L7.44222 9.74738C7.31625 9.62073 7.15861 9.55741 6.96931 9.55741C6.77934 9.55741 6.62137 9.62073 6.4954 9.74738C6.34113 9.90165 6.264 10.0667 6.264 10.2425C6.264 10.4177 6.34113 10.5753 6.4954 10.7154L8.76899 12.989C8.92325 13.1574 9.10918 13.2416 9.32677 13.2416C9.54436 13.2416 9.74444 13.1574 9.927 12.989L14.5368 8.35796C14.6635 8.23199 14.7268 8.07772 14.7268 7.89516C14.7268 7.7126 14.6635 7.558 14.5368 7.43135C14.3967 7.29123 14.2387 7.22117 14.0629 7.22117C13.8878 7.22117 13.7301 7.29123 13.59 7.43135L9.3581 11.6633ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Checkbox, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.30406 18C3.80182 18 3.37827 17.8276 3.03341 17.4827C2.68854 17.1378 2.51611 16.7143 2.51611 16.2121V3.78794C2.51611 3.28571 2.68854 2.86216 3.03341 2.51729C3.37827 2.17243 3.80182 2 4.30406 2H16.7282C17.2304 2 17.654 2.17243 17.9988 2.51729C18.3437 2.86216 18.5161 3.28571 18.5161 3.78794V16.2121C18.5161 16.7143 18.3437 17.1378 17.9988 17.4827C17.654 17.8276 17.2304 18 16.7282 18H4.30406ZM4.30406 16.4944H16.7282C16.8065 16.4944 16.8731 16.4669 16.9281 16.412C16.9831 16.357 17.0105 16.2904 17.0105 16.2121V3.78794C17.0105 3.70963 16.9831 3.64299 16.9281 3.58803C16.8731 3.53306 16.8065 3.50558 16.7282 3.50558H4.30406C4.22575 3.50558 4.15911 3.53306 4.10414 3.58803C4.04917 3.64299 4.02169 3.70963 4.02169 3.78794V16.2121C4.02169 16.2904 4.04917 16.357 4.10414 16.412C4.15911 16.4669 4.22575 16.4944 4.30406 16.4944ZM9.24547 13.3184C9.3554 13.3184 9.46533 13.2984 9.57527 13.2585C9.68445 13.2194 9.78648 13.1452 9.88135 13.036L15.034 7.88225C15.1755 7.74145 15.2501 7.56901 15.2576 7.36496C15.2651 7.1609 15.1906 6.98056 15.034 6.82394C14.8774 6.66657 14.697 6.58789 14.493 6.58789C14.2889 6.58789 14.1161 6.66657 13.9745 6.82394L9.24547 11.553L7.104 9.41155C6.96319 9.27074 6.79453 9.1962 6.598 9.18791C6.40223 9.18038 6.22565 9.25493 6.06828 9.41155C5.91166 9.56892 5.83335 9.74549 5.83335 9.94127C5.83335 10.137 5.91166 10.3136 6.06828 10.471L8.60958 13.036C8.70445 13.1452 8.80648 13.2194 8.91566 13.2585C9.0256 13.2984 9.13553 13.3184 9.24547 13.3184Z",
        fill: "currentColor"
      }));
    }], [e.Checkbox_Filled, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.30406 18C3.80182 18 3.37827 17.8276 3.03341 17.4827C2.68854 17.1378 2.51611 16.7143 2.51611 16.2121V3.78794C2.51611 3.28571 2.68854 2.86216 3.03341 2.51729C3.37827 2.17243 3.80182 2 4.30406 2H16.7282C17.2304 2 17.654 2.17243 17.9988 2.51729C18.3437 2.86216 18.5161 3.28571 18.5161 3.78794V16.2121C18.5161 16.7143 18.3437 17.1378 17.9988 17.4827C17.654 17.8276 17.2304 18 16.7282 18H4.30406ZM9.24547 13.3184C9.3554 13.3184 9.46533 13.2946 9.57527 13.2472C9.68445 13.1998 9.78648 13.1294 9.88135 13.036L15.034 7.88225C15.1755 7.74145 15.2463 7.56901 15.2463 7.36496C15.2463 7.1609 15.1755 6.98056 15.034 6.82394C14.8615 6.66657 14.6771 6.58789 14.4805 6.58789C14.2848 6.58789 14.1161 6.66657 13.9745 6.82394L9.24547 11.553L7.104 9.41155C6.96319 9.27074 6.79076 9.20034 6.5867 9.20034C6.38265 9.20034 6.20984 9.27074 6.06828 9.41155C5.89585 9.58398 5.80963 9.76432 5.80963 9.95256C5.80963 10.1408 5.89585 10.3136 6.06828 10.471L8.60958 13.036C8.70445 13.1294 8.80648 13.1998 8.91566 13.2472C9.0256 13.2946 9.13553 13.3184 9.24547 13.3184Z",
        fill: "currentColor"
      }));
    }], [e.Chevron_Down, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5108 12.5752C10.412 12.5752 10.3132 12.5576 10.2144 12.5224C10.1156 12.4872 10.0242 12.4202 9.94032 12.3214L6.19641 8.59981C6.06918 8.45836 6.00929 8.29255 6.01673 8.10238C6.0235 7.91221 6.0905 7.7535 6.21773 7.62627C6.37271 7.4855 6.5348 7.4185 6.70399 7.42527C6.87319 7.43271 7.02817 7.49972 7.16894 7.62627L10.5108 10.9895L13.873 7.64759C14.0003 7.50682 14.1485 7.43644 14.3177 7.43644C14.4869 7.43644 14.649 7.50682 14.8039 7.64759C14.9454 7.78836 15.0161 7.95045 15.0161 8.13385C15.0161 8.31726 14.9454 8.47258 14.8039 8.59981L11.0814 12.3214C10.9974 12.4202 10.9061 12.4872 10.8073 12.5224C10.7085 12.5576 10.6096 12.5752 10.5108 12.5752Z",
        fill: "currentColor"
      }));
    }], [e.Chevron_Left, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M11.8938 14.2688L8.1923 10.5673C8.10818 10.4838 8.04492 10.393 8.00253 10.2948C7.9608 10.1965 7.93994 10.0983 7.93994 10C7.93994 9.90175 7.9608 9.8035 8.00253 9.70525C8.04492 9.607 8.10818 9.51615 8.1923 9.43271L11.8938 5.73116C12.0479 5.57705 12.2091 5.5 12.3774 5.5C12.5456 5.5 12.7068 5.57705 12.8609 5.73116C13.015 5.88526 13.092 6.04643 13.092 6.21467C13.092 6.38291 13.015 6.54408 12.8609 6.69818L9.55905 10L12.8609 13.3018C13.015 13.4559 13.092 13.6171 13.092 13.7853C13.092 13.9536 13.015 14.1147 12.8609 14.2688C12.7068 14.4229 12.5456 14.5 12.3774 14.5C12.2091 14.5 12.0479 14.4229 11.8938 14.2688Z",
        fill: "currentColor"
      }));
    }], [e.Chevron_Right, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M8.1711 14.2688C8.01699 14.1147 7.93994 13.9536 7.93994 13.7853C7.93994 13.6171 8.01699 13.4559 8.1711 13.3018L11.4729 10L8.1711 6.69818C8.01699 6.54408 7.93994 6.38291 7.93994 6.21467C7.93994 6.04643 8.01699 5.88526 8.1711 5.73116C8.3252 5.57705 8.48637 5.5 8.65461 5.5C8.82285 5.5 8.98402 5.57705 9.13812 5.73116L12.8397 9.43271C12.9238 9.51615 12.987 9.607 13.0294 9.70525C13.0712 9.8035 13.092 9.90175 13.092 10C13.092 10.0983 13.0712 10.1965 13.0294 10.2948C12.987 10.393 12.9238 10.4838 12.8397 10.5673L9.13812 14.2688C8.98402 14.4229 8.82285 14.5 8.65461 14.5C8.48637 14.5 8.3252 14.4229 8.1711 14.2688Z",
        fill: "currentColor"
      }));
    }], [e.Chevron_Up, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.22778 12.342C6.08667 12.2151 6.01611 12.0602 6.01611 11.8772C6.01611 11.6942 6.08667 11.5325 6.22778 11.3921L9.94164 7.69948C10.0254 7.6009 10.1165 7.53068 10.2151 7.48882C10.3137 7.44696 10.4122 7.42603 10.5108 7.42603C10.6094 7.42603 10.708 7.44696 10.8065 7.48882C10.9051 7.53068 10.9963 7.6009 11.08 7.69948L14.8151 11.4133C14.9421 11.5538 15.0089 11.7084 15.0156 11.8772C15.0224 12.046 14.9556 12.2009 14.8151 12.342C14.6747 12.4825 14.5164 12.5527 14.3401 12.5527C14.1646 12.5527 14.0062 12.4825 13.8651 12.342L10.5108 9.02925L7.1565 12.3623C7.02957 12.5034 6.87832 12.574 6.70278 12.574C6.52655 12.574 6.36822 12.4967 6.22778 12.342Z",
        fill: "currentColor"
      }));
    }], [e.Clipboard, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5132 4.92169C10.5132 5.24217 10.2534 5.50197 9.93292 5.50197C9.61244 5.50197 9.35264 5.24217 9.35264 4.92169C9.35264 4.60121 9.61244 4.34141 9.93292 4.34141C10.2534 4.34141 10.5132 4.60121 10.5132 4.92169ZM11.7187 5.60138C11.4448 6.32082 10.7485 6.83197 9.93292 6.83197C8.8779 6.83197 8.02264 5.97671 8.02264 4.92169C8.02264 3.86667 8.8779 3.01141 9.93292 3.01141C10.7653 3.01141 11.4733 3.54374 11.7351 4.28651C11.7386 4.28645 11.7421 4.28642 11.7456 4.28642H14.0096C15.1084 4.28642 15.9821 5.18152 15.9821 6.26295V17.019C15.9821 18.1016 15.1081 18.9955 14.0096 18.9955H5.99044C4.89191 18.9955 4.01794 18.1016 4.01794 17.019V6.26295C4.01794 5.19797 4.86526 4.31368 5.94048 4.28704C6.13258 4.13118 6.37729 4.03751 6.64499 4.03751C7.26843 4.03751 7.76715 4.54553 7.76715 5.16397C7.76715 5.78241 7.26843 6.29043 6.64499 6.29043C6.21568 6.29043 5.8455 6.04953 5.6566 5.69755C5.47191 5.81187 5.34458 6.0187 5.34458 6.26295V17.019C5.34458 17.3941 5.64364 17.68 5.99044 17.68H14.0096C14.3564 17.68 14.6555 17.3941 14.6555 17.019V6.26295C14.6555 5.88844 14.3561 5.60191 14.0096 5.60191H11.7456C11.7366 5.60191 11.7277 5.60173 11.7187 5.60138ZM6.68408 8.67806C6.68408 8.31079 6.98181 8.01306 7.34908 8.01306H12.6813C13.0486 8.01306 13.3463 8.31079 13.3463 8.67806C13.3463 9.04533 13.0486 9.34306 12.6813 9.34306H7.34908C6.98181 9.34306 6.68408 9.04533 6.68408 8.67806ZM6.68408 11.7892C6.68408 11.4219 6.98181 11.1242 7.34908 11.1242H12.6813C13.0486 11.1242 13.3463 11.4219 13.3463 11.7892C13.3463 12.1564 13.0486 12.4542 12.6813 12.4542H7.34908C6.98181 12.4542 6.68408 12.1564 6.68408 11.7892ZM6.68408 14.9003C6.68408 14.533 6.98181 14.2353 7.34908 14.2353H12.6813C13.0486 14.2353 13.3463 14.533 13.3463 14.9003C13.3463 15.2676 13.0486 15.5653 12.6813 15.5653H7.34908C6.98181 15.5653 6.68408 15.2676 6.68408 14.9003Z",
        fill: "currentColor"
      }));
    }], [e.Clock, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M12.8948 13.3467C13.0214 13.4734 13.1757 13.5367 13.3576 13.5367C13.5402 13.5367 13.7018 13.4666 13.8426 13.3265C13.9969 13.1716 14.074 13.0065 14.074 12.8314C14.074 12.6562 13.9969 12.4983 13.8426 12.3575L11.1901 9.70494V6.48453C11.1901 6.31611 11.1268 6.16521 11.0001 6.03183C10.8742 5.89845 10.7128 5.83175 10.5161 5.83175C10.3336 5.83175 10.1756 5.89845 10.0422 6.03183C9.90881 6.16521 9.84212 6.32319 9.84212 6.50575V9.95756C9.84212 10.0418 9.85964 10.1297 9.89467 10.2213C9.93037 10.3122 9.98999 10.3998 10.0735 10.484L12.8948 13.3467ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Coding, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.0976 4.73606L8.52847 13.5557L5.12378 9.27352L6.14134 8.46447L8.67572 11.652L17.2165 3.78015L18.0976 4.73606Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M13.572 5.3714C12.448 4.44273 11.0065 3.88477 9.43457 3.88477C5.84472 3.88477 2.93457 6.79491 2.93457 10.3848C2.93457 13.9746 5.84472 16.8848 9.43457 16.8848C13.0244 16.8848 15.9346 13.9746 15.9346 10.3848C15.9346 9.80236 15.858 9.23785 15.7143 8.70075L14.5941 9.73318C14.6208 9.94662 14.6346 10.1641 14.6346 10.3848C14.6346 13.2566 12.3065 15.5848 9.43457 15.5848C6.56269 15.5848 4.23457 13.2566 4.23457 10.3848C4.23457 7.51289 6.56269 5.18477 9.43457 5.18477C10.6279 5.18477 11.7274 5.58676 12.605 6.26272L13.572 5.3714Z",
        fill: "currentColor"
      }));
    }], [e.Comments, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.38798 12.1886H14.6445C14.8197 12.1886 14.974 12.1218 15.1076 11.9883C15.2411 11.8547 15.3079 11.6993 15.3079 11.522C15.3079 11.3446 15.2411 11.1892 15.1076 11.0556C14.974 10.9221 14.8197 10.8553 14.6445 10.8553H6.38798C6.21282 10.8553 6.05846 10.9221 5.92492 11.0556C5.79138 11.1892 5.72461 11.3446 5.72461 11.522C5.72461 11.6993 5.79138 11.8547 5.92492 11.9883C6.05846 12.1218 6.21282 12.1886 6.38798 12.1886ZM6.38798 9.73026H14.6445C14.8197 9.73026 14.974 9.66349 15.1076 9.52995C15.2411 9.39641 15.3079 9.24097 15.3079 9.06362C15.3079 8.88627 15.2411 8.73083 15.1076 8.59729C14.974 8.46374 14.8197 8.39697 14.6445 8.39697H6.38798C6.21282 8.39697 6.05846 8.46374 5.92492 8.59729C5.79138 8.73083 5.72461 8.88627 5.72461 9.06362C5.72461 9.24097 5.79138 9.39641 5.92492 9.52995C6.05846 9.66349 6.21282 9.73026 6.38798 9.73026ZM6.38798 7.27193H14.6445C14.8197 7.27193 14.974 7.20516 15.1076 7.07162C15.2411 6.93808 15.3079 6.78263 15.3079 6.60529C15.3079 6.42794 15.2411 6.27249 15.1076 6.13895C14.974 6.00541 14.8197 5.93864 14.6445 5.93864H6.38798C6.21282 5.93864 6.05846 6.00541 5.92492 6.13895C5.79138 6.27249 5.72461 6.42794 5.72461 6.60529C5.72461 6.78263 5.79138 6.93808 5.92492 7.07162C6.05846 7.20516 6.21282 7.27193 6.38798 7.27193ZM17.0691 16.9193L15.4842 15.3344H4.18936C3.7455 15.3344 3.36957 15.1804 3.06159 14.8725C2.7536 14.5645 2.59961 14.1885 2.59961 13.7447V4.42422C2.59961 3.98036 2.7536 3.60444 3.06159 3.29645C3.36957 2.98847 3.7455 2.83447 4.18936 2.83447H16.8432C17.287 2.83447 17.6629 2.98847 17.9709 3.29645C18.2789 3.60444 18.4329 3.98036 18.4329 4.42422V16.3793C18.4329 16.7247 18.2684 16.9638 17.9393 17.0967C17.6102 17.2295 17.3202 17.1704 17.0691 16.9193ZM3.93292 4.42422V14.0011H16.0451L17.0996 15.0556V4.42422C17.0996 4.34943 17.0755 4.28799 17.0275 4.23991C16.9794 4.19183 16.9179 4.16779 16.8432 4.16779H4.18936C4.11457 4.16779 4.05313 4.19183 4.00505 4.23991C3.95696 4.28799 3.93292 4.34943 3.93292 4.42422ZM3.93292 4.42422V15.0556V4.16779V4.42422Z",
        fill: "currentColor"
      }));
    }], [e.Download, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.99585 12.5512C9.90655 12.5512 9.82349 12.5352 9.74669 12.5031C9.66988 12.4712 9.5994 12.4231 9.53523 12.359L6.98565 9.80937C6.87565 9.70062 6.82141 9.57326 6.82294 9.42729C6.8246 9.28132 6.88245 9.15062 6.99648 9.03521C7.11856 8.91993 7.24953 8.86361 7.3894 8.86625C7.5294 8.86889 7.6571 8.92791 7.77252 9.04333L9.45835 10.75V3.95833C9.45835 3.80458 9.50981 3.6759 9.61273 3.57229C9.71551 3.46854 9.84315 3.41666 9.99565 3.41666C10.1481 3.41666 10.2772 3.46854 10.3829 3.57229C10.4888 3.6759 10.5417 3.80458 10.5417 3.95833V10.75L12.2484 9.04333C12.3538 8.93333 12.479 8.8791 12.624 8.88062C12.7688 8.88229 12.9023 8.94076 13.0244 9.05604C13.1384 9.17146 13.1941 9.30048 13.1915 9.44312C13.1888 9.58576 13.1298 9.71479 13.0144 9.83021L10.4648 12.359C10.3951 12.4231 10.3218 12.4712 10.245 12.5031C10.1682 12.5352 10.0852 12.5512 9.99585 12.5512ZM5.75065 15.5833C5.37523 15.5833 5.05905 15.4538 4.8021 15.1948C4.54516 14.9358 4.41669 14.6187 4.41669 14.2435V13.5256C4.41669 13.3719 4.46815 13.2432 4.57106 13.1396C4.67384 13.0358 4.80148 12.984 4.95398 12.984C5.10648 12.984 5.23558 13.0358 5.34127 13.1396C5.4471 13.2432 5.50002 13.3719 5.50002 13.5256V14.2435C5.50002 14.3077 5.52676 14.3665 5.58023 14.4198C5.63356 14.4733 5.69231 14.5 5.75648 14.5H14.2436C14.3077 14.5 14.3665 14.4733 14.4198 14.4198C14.4733 14.3665 14.5 14.3077 14.5 14.2435V13.5256C14.5 13.3719 14.5514 13.2432 14.6542 13.1396C14.7571 13.0358 14.8848 12.984 15.0373 12.984C15.1898 12.984 15.3189 13.0358 15.4246 13.1396C15.5304 13.2432 15.5834 13.3719 15.5834 13.5256V14.2435C15.5834 14.6187 15.4538 14.9358 15.1946 15.1948C14.9354 15.4538 14.6181 15.5833 14.2427 15.5833H5.75065Z",
        fill: "currentColor"
      }));
    }], [e.Edit, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.24994 16.4944H5.47911L12.4791 9.49444L11.2499 8.26528L4.24994 15.2653V16.4944ZM16.1874 8.28611L12.4583 4.55694L13.4791 3.53611C13.8263 3.18889 14.2395 3.01528 14.7187 3.01528C15.1979 3.01528 15.6111 3.18889 15.9583 3.53611L17.2083 4.78611C17.5416 5.11944 17.7083 5.53264 17.7083 6.02569C17.7083 6.51875 17.5416 6.93194 17.2083 7.26528L16.1874 8.28611ZM3.37494 18.2444C3.13883 18.2444 2.93397 18.1576 2.76036 17.984C2.58674 17.8104 2.49994 17.6056 2.49994 17.3694V14.8694C2.49994 14.7583 2.52077 14.6507 2.56244 14.5465C2.60411 14.4424 2.66661 14.3486 2.74994 14.2653L11.2291 5.78611L14.9583 9.51528L6.47911 17.9944C6.39577 18.0778 6.30202 18.1403 6.19786 18.1819C6.09369 18.2236 5.98605 18.2444 5.87494 18.2444H3.37494ZM11.8749 8.89028L11.2499 8.26528L12.4791 9.49444L11.8749 8.89028Z",
        fill: "currentColor"
      }));
    }], [e.Edit_Note, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M16.7917 13.2653L14.9792 11.4528L15.5625 10.8694C15.7292 10.7028 15.9306 10.6194 16.1667 10.6194C16.4028 10.6194 16.6042 10.7028 16.7708 10.8694L17.375 11.4736C17.5417 11.6403 17.625 11.8417 17.625 12.0778C17.625 12.3139 17.5417 12.5153 17.375 12.6819L16.7917 13.2653ZM10 18.2444V16.4319L14.3958 12.0361L16.2083 13.8486L11.8125 18.2444H10ZM2.5 14.4944V12.7444H9.02083V14.4944H2.5ZM2.5 10.9944V9.24445H11.9375V10.9944H2.5ZM2.5 7.49445V5.74445H11.9375V7.49445H2.5Z",
        fill: "currentColor"
      }));
    }], [e.Encounter, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5848 2.40945H2.00009V2.97682C2.00009 5.23735 2.52636 7.16673 3.4204 8.55004C4.20067 9.75734 5.28381 10.5738 6.53906 10.7641V13.5073C6.53906 15.024 7.76853 16.2534 9.28516 16.2534C10.8018 16.2534 12.0313 15.024 12.0313 13.5073V12.9626C12.0313 11.9724 12.834 11.1697 13.8242 11.1697C14.8144 11.1697 15.6171 11.9724 15.6171 12.9626V14.8687C14.8923 15.1069 14.3689 15.7893 14.3689 16.5938C14.3689 17.5966 15.1818 18.4094 16.1845 18.4094C17.1873 18.4094 18.0001 17.5966 18.0001 16.5938C18.0001 15.7892 17.4767 15.1068 16.7518 14.8686V12.9626C16.7518 11.3457 15.4411 10.035 13.8242 10.035C12.2073 10.035 10.8965 11.3457 10.8965 12.9626V13.5073C10.8965 14.3972 10.1751 15.1187 9.28516 15.1187C8.39523 15.1187 7.67381 14.3972 7.67381 13.5073V10.76C8.94789 10.5488 10.0286 9.63821 10.7974 8.40627C11.6832 6.9868 12.2129 5.06366 12.2129 2.97682V2.40945H9.62815C9.31479 2.40945 9.06077 2.66347 9.06077 2.97682C9.06077 3.29018 9.31479 3.5442 9.62815 3.5442H11.0637C10.9779 5.22181 10.5158 6.714 9.83469 7.80553C9.07236 9.02719 8.09258 9.67186 7.10647 9.67186C6.09553 9.67186 5.12063 9.09022 4.37343 7.9341C3.6934 6.88192 3.22696 5.38162 3.14705 3.5442H4.5848C4.89816 3.5442 5.15218 3.29018 5.15218 2.97682C5.15218 2.66347 4.89816 2.40945 4.5848 2.40945ZM16.1845 17.2747C16.5606 17.2747 16.8654 16.9698 16.8654 16.5938C16.8654 16.2178 16.5606 15.913 16.1845 15.913C15.8085 15.913 15.5037 16.2178 15.5037 16.5938C15.5037 16.9698 15.8085 17.2747 16.1845 17.2747Z",
        fill: "currentColor"
      }));
    }], [e.Error, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.516 5.90176L5.26793 14.9918H15.7642L10.516 5.90176ZM11.3821 4.80176C10.9972 4.13509 10.0349 4.13509 9.65002 4.80176L3.88229 14.7918C3.49739 15.4584 3.97852 16.2918 4.74832 16.2918H16.2838C17.0536 16.2918 17.5347 15.4584 17.1498 14.7918L11.3821 4.80176Z",
        fill: "currentColor"
      }));
    }], [e.Export, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.45833 8.96197L7.75167 10.6686C7.64153 10.7786 7.51521 10.8363 7.37271 10.8418C7.23007 10.847 7.09771 10.792 6.97562 10.6768C6.8616 10.5613 6.8059 10.4323 6.80854 10.2897C6.81118 10.147 6.87021 10.018 6.98562 9.90259L9.53521 7.35301C9.60493 7.28884 9.67819 7.24078 9.755 7.20884C9.83181 7.17676 9.91486 7.16071 10.0042 7.16071C10.0935 7.16071 10.1765 7.17676 10.2533 7.20884C10.3301 7.24078 10.4006 7.28884 10.4648 7.35301L13.0144 9.90259C13.1244 10.0127 13.1821 10.137 13.1875 10.2753C13.1928 10.4136 13.1384 10.5405 13.0244 10.6559C12.9023 10.7712 12.7713 10.8275 12.6315 10.8249C12.4915 10.8222 12.3637 10.7632 12.2483 10.6478L10.5417 8.96197V15.7536C10.5417 15.9074 10.4902 16.0361 10.3873 16.1397C10.2845 16.2434 10.1569 16.2953 10.0044 16.2953C9.85187 16.2953 9.72278 16.2434 9.61708 16.1397C9.51125 16.0361 9.45833 15.9074 9.45833 15.7536V8.96197ZM4.41667 6.18634V5.46842C4.41667 5.09328 4.54625 4.7762 4.80542 4.51717C5.06458 4.25815 5.38187 4.12863 5.75729 4.12863H14.2494C14.6248 4.12863 14.941 4.25815 15.1979 4.51717C15.4549 4.7762 15.5833 5.09328 15.5833 5.46842V6.18634C15.5833 6.34009 15.5319 6.46877 15.429 6.57238C15.3262 6.67613 15.1985 6.72801 15.046 6.72801C14.8935 6.72801 14.7644 6.67613 14.6588 6.57238C14.5529 6.46877 14.5 6.34009 14.5 6.18634V5.46842C14.5 5.40426 14.4733 5.34551 14.4198 5.29217C14.3665 5.2387 14.3077 5.21196 14.2435 5.21196H5.75646C5.69229 5.21196 5.63354 5.2387 5.58021 5.29217C5.52674 5.34551 5.5 5.40426 5.5 5.46842V6.18634C5.5 6.34009 5.44861 6.46877 5.34583 6.57238C5.24292 6.67613 5.11521 6.72801 4.96271 6.72801C4.81021 6.72801 4.68111 6.67613 4.57542 6.57238C4.46958 6.46877 4.41667 6.34009 4.41667 6.18634Z",
        fill: "currentColor"
      }));
    }], [e.Filter, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.2768 18C10.0982 18 9.95392 17.9455 9.84406 17.8366C9.73516 17.7268 9.68071 17.5926 9.68071 17.434V10.8956L2.90443 2.71646C2.80412 2.55693 2.78884 2.3974 2.85857 2.23787C2.92831 2.07929 3.05297 2 3.23256 2H17.7996C17.9792 2 18.1039 2.07929 18.1736 2.23787C18.2434 2.3974 18.2281 2.55693 18.1278 2.71646L11.3515 10.8956V17.434C11.3515 17.5926 11.297 17.7268 11.1881 17.8366C11.0783 17.9455 10.9441 18 10.7855 18H10.2768ZM10.5161 9.46265L15.3522 3.55185H5.6499L10.5161 9.46265Z",
        fill: "currentColor"
      }));
    }], [e.First, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.29683 15.6444C5.10001 15.6444 4.93325 15.5774 4.79657 15.4432C4.65989 15.309 4.59155 15.1428 4.59155 14.9445V6.54442C4.59155 6.34609 4.65812 6.17985 4.79127 6.0457C4.92441 5.91153 5.0894 5.84444 5.28623 5.84444C5.48305 5.84444 5.64981 5.91153 5.78649 6.0457C5.92317 6.17985 5.99151 6.34609 5.99151 6.54442V14.9445C5.99151 15.1428 5.92493 15.309 5.79179 15.4432C5.65865 15.5774 5.49366 15.6444 5.29683 15.6444ZM11.8649 10.7444L15.1744 14.054C15.3235 14.2031 15.3998 14.368 15.4032 14.5489C15.4067 14.7298 15.3304 14.8982 15.1744 15.0542C15.0184 15.2102 14.8517 15.2883 14.6743 15.2883C14.4969 15.2883 14.3302 15.2102 14.1741 15.0542L10.465 11.345C10.3821 11.255 10.32 11.1599 10.2786 11.0597C10.2371 10.9595 10.2164 10.8522 10.2164 10.7377C10.2164 10.6232 10.2371 10.5163 10.2786 10.417C10.32 10.3178 10.3821 10.2267 10.465 10.1439L14.1741 6.43468C14.3232 6.28556 14.4882 6.20928 14.6691 6.20584C14.85 6.20237 15.0184 6.27865 15.1744 6.43468C15.3304 6.59069 15.4084 6.7574 15.4084 6.93481C15.4084 7.11221 15.3304 7.27892 15.1744 7.43493L11.8649 10.7444Z",
        fill: "currentColor"
      }));
    }], [e.Flag, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.41185 18C4.19839 18 4.01368 17.922 3.85772 17.7661C3.70176 17.6101 3.62378 17.4254 3.62378 17.2119V2.93576C3.62378 2.68921 3.7183 2.47182 3.90734 2.28356C4.0956 2.09452 4.31299 2 4.55953 2H10.9101C11.1236 2 11.3205 2.06971 11.5009 2.20913C11.6813 2.34855 11.788 2.52498 11.8211 2.73844L12.0917 3.94476H16.4727C16.7192 3.94476 16.9366 4.03889 17.1249 4.22715C17.3139 4.41619 17.4084 4.63398 17.4084 4.88052V12.018C17.4084 12.2646 17.3139 12.482 17.1249 12.6702C16.9366 12.8593 16.7192 12.9538 16.4727 12.9538H12.0668C11.8534 12.9538 11.6565 12.8841 11.4761 12.7446C11.2957 12.6052 11.189 12.4288 11.1559 12.2153L10.9101 10.9842H5.19991V17.2119C5.19991 17.4254 5.12193 17.6101 4.96597 17.7661C4.81001 17.922 4.62531 18 4.41185 18ZM12.5843 11.3788H15.8335V5.51972H10.7625L10.3926 3.57495H5.19991V9.40925H12.2145L12.5843 11.3788Z",
        fill: "currentColor"
      }));
    }], [e.Footprints, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.50001 3.21197C4.90487 3.21197 4.42278 3.53871 4.05376 4.19218C3.68459 4.84565 3.50001 5.59017 3.50001 6.42572C3.50001 7.23197 3.61862 8.01246 3.85584 8.76718C4.09292 9.52204 4.35507 10.1046 4.6423 10.5149L6.61209 10.0645C6.78945 9.62003 6.98181 9.06128 7.18917 8.38822C7.39639 7.71517 7.50001 7.05815 7.50001 6.41718C7.50001 5.58385 7.31542 4.84128 6.94626 4.18947C6.57723 3.53781 6.09514 3.21197 5.50001 3.21197ZM6.59751 13.712C6.85139 13.712 7.06528 13.6157 7.23917 13.4232C7.41306 13.2309 7.50001 12.9729 7.50001 12.6495C7.50001 12.4223 7.44042 12.175 7.32126 11.9078C7.20223 11.6404 7.06042 11.3775 6.89584 11.1191L5.00001 11.5518C5.02778 12.165 5.17681 12.6783 5.44709 13.0918C5.71737 13.5052 6.10084 13.712 6.59751 13.712ZM14.5 7.69114C13.9049 7.69114 13.4228 8.01697 13.0538 8.66864C12.6846 9.32044 12.5 10.063 12.5 10.8963C12.5 11.5373 12.605 12.1978 12.815 12.8778C13.0249 13.5578 13.2158 14.12 13.3879 14.5645L15.3365 15.0838C15.6891 14.5454 15.9712 13.9281 16.1827 13.232C16.3942 12.536 16.5 11.7654 16.5 10.9203C16.5 10.081 16.3154 9.33295 15.9463 8.67614C15.5772 8.01947 15.0951 7.69114 14.5 7.69114ZM13.3933 18.212C13.8854 18.212 14.2692 18.0079 14.5448 17.5999C14.8205 17.1917 14.9722 16.6943 15 16.1078L13.1123 15.6109C12.9851 15.8375 12.8513 16.0857 12.7108 16.3557C12.5703 16.6259 12.5 16.8898 12.5 17.1474C12.5 17.4179 12.5854 17.663 12.7563 17.8826C12.9269 18.1022 13.1393 18.212 13.3933 18.212ZM6.60417 14.7953C5.76987 14.7953 5.12514 14.485 4.67001 13.8643C4.21487 13.2434 3.96376 12.5377 3.91667 11.7472L3.58167 10.8547C3.21209 10.267 2.92556 9.56725 2.72209 8.75531C2.51848 7.94322 2.41667 7.16489 2.41667 6.42031C2.41667 5.37114 2.68695 4.39357 3.22751 3.4876C3.7682 2.58162 4.5257 2.12864 5.50001 2.12864C6.43626 2.12864 7.18417 2.56628 7.74376 3.44156C8.30348 4.31683 8.58334 5.30975 8.58334 6.42031C8.58334 7.16072 8.47438 7.88399 8.25646 8.5901C8.03841 9.29635 7.84237 9.87114 7.66834 10.3145L7.91834 10.7409C8.05306 10.962 8.19758 11.2502 8.35188 11.6053C8.50619 11.9604 8.58334 12.3093 8.58334 12.6518C8.58334 13.2827 8.3966 13.7977 8.02313 14.1968C7.64966 14.5958 7.17667 14.7953 6.60417 14.7953ZM13.3958 19.2953C12.8233 19.2953 12.3504 19.0958 11.9769 18.6968C11.6034 18.2977 11.4167 17.7832 11.4167 17.153C11.4167 16.8109 11.4938 16.4593 11.6481 16.098C11.8024 15.7368 11.9469 15.4441 12.0817 15.2201L12.3317 14.8145C12.1629 14.3764 11.9683 13.803 11.7477 13.0943C11.527 12.3854 11.4167 11.6607 11.4167 10.9203C11.4167 9.80975 11.6965 8.81683 12.2563 7.94156C12.8158 7.06628 13.5638 6.62864 14.5 6.62864C15.4743 6.62864 16.2318 7.08163 16.7725 7.9876C17.3131 8.89357 17.5833 9.87114 17.5833 10.9203C17.5833 11.6649 17.4829 12.4418 17.2821 13.2511C17.0813 14.0604 16.7933 14.7643 16.4183 15.3626L16.1042 15.8834C16.0293 16.6911 15.8074 17.4616 15.4383 18.1951C15.0692 18.9286 14.3883 19.2953 13.3958 19.2953Z",
        fill: "currentColor"
      }));
    }], [e.Global, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.0071 18.3278C8.96392 18.3278 7.98142 18.1304 7.05965 17.7357C6.13785 17.341 5.33103 16.7978 4.63919 16.1063C3.94733 15.4148 3.40394 14.6086 3.00904 13.6878C2.61414 12.767 2.41669 11.7832 2.41669 10.7363C2.41669 9.68938 2.61405 8.70851 3.00877 7.79367C3.40349 6.87883 3.94662 6.07548 4.63815 5.38363C5.32969 4.69177 6.13585 4.14839 7.05662 3.75349C7.9774 3.35859 8.96124 3.16113 10.0081 3.16113C11.0551 3.16113 12.0359 3.35849 12.9508 3.75322C13.8656 4.14794 14.669 4.69106 15.3608 5.38259C16.0527 6.07413 16.5961 6.87867 16.991 7.7962C17.3859 8.71372 17.5833 9.69409 17.5833 10.7373C17.5833 11.7805 17.386 12.763 16.9912 13.6848C16.5965 14.6066 16.0534 15.4134 15.3619 16.1053C14.6703 16.7971 13.8658 17.3405 12.9482 17.7354C12.0307 18.1303 11.0504 18.3278 10.0071 18.3278ZM9 17.1611V15.7444C8.72222 15.7444 8.48611 15.6465 8.29167 15.4507C8.09722 15.2549 8 15.0194 8 14.7444V13.7444L3.64583 9.39028C3.59028 9.65417 3.55208 9.89722 3.53125 10.1194C3.51042 10.3417 3.5 10.55 3.5 10.7444C3.5 12.3417 4.01736 13.7514 5.05208 14.9736C6.08681 16.1958 7.40278 16.925 9 17.1611ZM15 14.8903C15.25 14.5986 15.4688 14.2931 15.6563 13.9736C15.8438 13.6542 15.999 13.317 16.1221 12.9621C16.2451 12.6072 16.3389 12.2426 16.4033 11.8683C16.4678 11.4941 16.5 11.1194 16.5 10.7444C16.5 9.42642 16.1402 8.22272 15.4207 7.13334C14.7011 6.04395 13.7276 5.24231 12.5 4.72843V5.24445C12.5 5.65695 12.3531 6.01007 12.0594 6.30382C11.7656 6.59757 11.4125 6.74445 11 6.74445H9V7.74445C9 8.02778 8.90417 8.26528 8.7125 8.45695C8.52083 8.64861 8.28333 8.74445 8 8.74445H7V10.7444H12C12.2833 10.7444 12.5208 10.8403 12.7125 11.0319C12.9042 11.2236 13 11.4611 13 11.7444V13.7444H13.8542C14.1736 13.7444 14.4444 13.8556 14.6667 14.0778C14.8889 14.3 15 14.5708 15 14.8903Z",
        fill: "currentColor"
      }));
    }], [e.Grid, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.02169 9.01172C3.61358 9.01172 3.26043 8.86263 2.96225 8.56445C2.66483 8.26627 2.51611 7.9135 2.51611 7.50614V3.50558C2.51611 3.09746 2.66483 2.74469 2.96225 2.44727C3.26043 2.14909 3.61358 2 4.02169 2H8.02225C8.42961 2 8.78238 2.14909 9.08056 2.44727C9.37874 2.74469 9.52783 3.09746 9.52783 3.50558V7.50614C9.52783 7.9135 9.37874 8.26627 9.08056 8.56445C8.78238 8.86263 8.42961 9.01172 8.02225 9.01172H4.02169ZM4.02169 18C3.61358 18 3.26043 17.8513 2.96225 17.5539C2.66483 17.2557 2.51611 16.9025 2.51611 16.4944V12.4939C2.51611 12.0865 2.66483 11.7337 2.96225 11.4355C3.26043 11.1374 3.61358 10.9883 4.02169 10.9883H8.02225C8.42961 10.9883 8.78238 11.1374 9.08056 11.4355C9.37874 11.7337 9.52783 12.0865 9.52783 12.4939V16.4944C9.52783 16.9025 9.37874 17.2557 9.08056 17.5539C8.78238 17.8513 8.42961 18 8.02225 18H4.02169ZM13.01 9.01172C12.6026 9.01172 12.2498 8.86263 11.9517 8.56445C11.6535 8.26627 11.5044 7.9135 11.5044 7.50614V3.50558C11.5044 3.09746 11.6535 2.74469 11.9517 2.44727C12.2498 2.14909 12.6026 2 13.01 2H17.0105C17.4186 2 17.7718 2.14909 18.07 2.44727C18.3674 2.74469 18.5161 3.09746 18.5161 3.50558V7.50614C18.5161 7.9135 18.3674 8.26627 18.07 8.56445C17.7718 8.86263 17.4186 9.01172 17.0105 9.01172H13.01ZM13.01 18C12.6026 18 12.2498 17.8513 11.9517 17.5539C11.6535 17.2557 11.5044 16.9025 11.5044 16.4944V12.4939C11.5044 12.0865 11.6535 11.7337 11.9517 11.4355C12.2498 11.1374 12.6026 10.9883 13.01 10.9883H17.0105C17.4186 10.9883 17.7718 11.1374 18.07 11.4355C18.3674 11.7337 18.5161 12.0865 18.5161 12.4939V16.4944C18.5161 16.9025 18.3674 17.2557 18.07 17.5539C17.7718 17.8513 17.4186 18 17.0105 18H13.01ZM4.02169 7.50614H8.02225V3.50558H4.02169V7.50614ZM13.01 7.50614H17.0105V3.50558H13.01V7.50614ZM13.01 16.4944H17.0105V12.4939H13.01V16.4944ZM4.02169 16.4944H8.02225V12.4939H4.02169V16.4944Z",
        fill: "currentColor"
      }));
    }], [e.Gripper, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M8.31847 15C8.02546 15 7.77816 14.896 7.57656 14.6879C7.37497 14.4805 7.27417 14.2364 7.27417 13.9557C7.27417 13.6627 7.37819 13.4154 7.58623 13.2138C7.79368 13.0122 8.03777 12.9114 8.31847 12.9114C8.61149 12.9114 8.85879 13.0154 9.06039 13.2235C9.26198 13.4309 9.36278 13.675 9.36278 13.9557C9.36278 14.2487 9.25876 14.496 9.05072 14.6976C8.84326 14.8992 8.59918 15 8.31847 15ZM12.7137 15C12.4207 15 12.1734 14.896 11.9718 14.6879C11.7702 14.4805 11.6694 14.2364 11.6694 13.9557C11.6694 13.6627 11.7734 13.4154 11.9814 13.2138C12.1889 13.0122 12.433 12.9114 12.7137 12.9114C13.0067 12.9114 13.254 13.0154 13.4556 13.2235C13.6572 13.4309 13.758 13.675 13.758 13.9557C13.758 14.2487 13.654 14.496 13.4459 14.6976C13.2385 14.8992 12.9944 15 12.7137 15ZM8.31847 11.0443C8.02546 11.0443 7.77816 10.9403 7.57656 10.7322C7.37497 10.5248 7.27417 10.2807 7.27417 10C7.27417 9.70699 7.37819 9.45968 7.58623 9.25809C7.79368 9.05649 8.03777 8.9557 8.31847 8.9557C8.61149 8.9557 8.85879 9.05972 9.06039 9.26776C9.26198 9.47521 9.36278 9.71929 9.36278 10C9.36278 10.293 9.25876 10.5403 9.05072 10.7419C8.84326 10.9435 8.59918 11.0443 8.31847 11.0443ZM12.7137 11.0443C12.4207 11.0443 12.1734 10.9403 11.9718 10.7322C11.7702 10.5248 11.6694 10.2807 11.6694 10C11.6694 9.70699 11.7734 9.45968 11.9814 9.25809C12.1889 9.05649 12.433 8.9557 12.7137 8.9557C13.0067 8.9557 13.254 9.05972 13.4556 9.26776C13.6572 9.47521 13.758 9.71929 13.758 10C13.758 10.293 13.654 10.5403 13.4459 10.7419C13.2385 10.9435 12.9944 11.0443 12.7137 11.0443ZM8.31847 7.08861C8.02546 7.08861 7.77816 6.98459 7.57656 6.77655C7.37497 6.56909 7.27417 6.32501 7.27417 6.0443C7.27417 5.75129 7.37819 5.50399 7.58623 5.30239C7.79368 5.1008 8.03777 5 8.31847 5C8.61149 5 8.85879 5.10402 9.06039 5.31206C9.26198 5.51951 9.36278 5.7636 9.36278 6.0443C9.36278 6.33732 9.25876 6.58462 9.05072 6.78622C8.84326 6.98781 8.59918 7.08861 8.31847 7.08861ZM12.7137 7.08861C12.4207 7.08861 12.1734 6.98459 11.9718 6.77655C11.7702 6.56909 11.6694 6.32501 11.6694 6.0443C11.6694 5.75129 11.7734 5.50399 11.9814 5.30239C12.1889 5.1008 12.433 5 12.7137 5C13.0067 5 13.254 5.10402 13.4556 5.31206C13.6572 5.51951 13.758 5.7636 13.758 6.0443C13.758 6.33732 13.654 6.58462 13.4459 6.78622C13.2385 6.98781 12.9944 7.08861 12.7137 7.08861Z",
        fill: "currentColor"
      }));
    }], [e.Help, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 14.7574C10.7687 14.7574 10.9793 14.6698 11.1477 14.4946C11.3161 14.3195 11.4003 14.1053 11.4003 13.852C11.4003 13.6 11.3127 13.3861 11.1376 13.2103C10.9617 13.0352 10.7475 12.9476 10.4949 12.9476C10.2423 12.9476 10.0318 13.0352 9.86334 13.2103C9.69493 13.3861 9.61072 13.6 9.61072 13.852C9.61072 14.1053 9.69863 14.3195 9.87446 14.4946C10.0496 14.6698 10.2635 14.7574 10.5161 14.7574ZM10.5586 6.44209C10.9937 6.44209 11.3444 6.55459 11.6105 6.77959C11.8772 7.00392 12.0106 7.29864 12.0106 7.66376C12.0106 7.90224 11.9406 8.14778 11.8004 8.4004C11.6596 8.65302 11.4491 8.89857 11.1689 9.13705C10.7337 9.51564 10.4215 9.85954 10.2322 10.1688C10.0429 10.4773 9.94115 10.7929 9.927 11.1156C9.91285 11.2698 9.95833 11.4032 10.0634 11.5157C10.1685 11.6282 10.3123 11.6845 10.4949 11.6845C10.6633 11.6845 10.8108 11.6316 10.9375 11.5258C11.0635 11.4207 11.1406 11.2769 11.1689 11.0944C11.2107 10.87 11.3019 10.6561 11.4427 10.4527C11.5828 10.2493 11.8072 9.99326 12.1157 9.68473C12.565 9.26302 12.8668 8.8979 13.0211 8.58936C13.1754 8.28083 13.2525 7.93693 13.2525 7.55766C13.2525 6.86986 13.0107 6.31578 12.527 5.89542C12.0426 5.47371 11.4074 5.26285 10.6212 5.26285C10.1018 5.26285 9.6316 5.37535 9.21057 5.60035C8.78953 5.82468 8.41768 6.15444 8.09499 6.58962C8.01079 6.70212 7.9899 6.82843 8.03234 6.96855C8.07411 7.10867 8.15832 7.22791 8.28496 7.32626C8.41094 7.43876 8.56857 7.4775 8.75787 7.44247C8.94784 7.40744 9.10581 7.30571 9.23179 7.1373C9.4002 6.92644 9.58613 6.75803 9.78958 6.63206C9.99302 6.50541 10.2493 6.44209 10.5586 6.44209ZM10.5161 18C9.40728 18 8.36883 17.7895 7.40079 17.3684C6.43207 16.9474 5.5863 16.3788 4.86347 15.6628C4.14063 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.14063 5.05267 4.86347 4.33725C5.5863 3.62115 6.43207 3.05259 7.40079 2.63155C8.36883 2.21052 9.40728 2 10.5161 2C11.6391 2 12.6846 2.21052 13.6527 2.63155C14.6214 3.05259 15.4671 3.62115 16.19 4.33725C16.9128 5.05267 17.481 5.89811 17.8947 6.87356C18.309 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.309 12.151 17.8947 13.1264C17.481 14.1019 16.9128 14.9473 16.19 15.6628C15.4671 16.3788 14.6214 16.9474 13.6527 17.3684C12.6846 17.7895 11.6391 18 10.5161 18ZM10.5161 16.652C12.3828 16.652 13.9582 16.0029 15.2421 14.7048C16.5261 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5261 6.59332 15.2421 5.29519C13.9582 3.99705 12.3828 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.History, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.513 16.7276C8.75451 16.7276 7.25371 16.14 6.01065 14.9647C4.7676 13.7895 4.07717 12.3424 3.93936 10.6234C3.92226 10.4717 3.9666 10.3472 4.07236 10.25C4.17812 10.1528 4.30723 10.1069 4.45969 10.1122C4.60317 10.1175 4.72859 10.1651 4.83596 10.2548C4.94333 10.3446 5.00288 10.4626 5.01463 10.609C5.15139 12.0214 5.74114 13.2137 6.78388 14.1859C7.8266 15.1581 9.06966 15.6443 10.513 15.6443C12.0269 15.6443 13.3221 15.1061 14.3985 14.0297C15.4749 12.9533 16.013 11.6581 16.013 10.1443C16.013 8.63036 15.4749 7.33522 14.3985 6.25884C13.3221 5.18245 12.0269 4.64425 10.513 4.64425C9.70002 4.64425 8.94729 4.802 8.25486 5.11748C7.56244 5.43297 6.96421 5.8671 6.46017 6.41988H8.03551C8.18896 6.41988 8.3176 6.47139 8.42142 6.57442C8.52524 6.67745 8.57715 6.80511 8.57715 6.95742C8.57715 7.10973 8.52524 7.23876 8.42142 7.34452C8.3176 7.4503 8.18896 7.50319 8.03551 7.50319H5.0163C4.82651 7.50319 4.66742 7.43899 4.53903 7.31059C4.41064 7.1822 4.34644 7.02311 4.34644 6.83332V3.81413C4.34644 3.66066 4.39796 3.53201 4.50098 3.42819C4.60401 3.32437 4.73168 3.27246 4.88398 3.27246C5.03629 3.27246 5.16533 3.32437 5.27109 3.42819C5.37685 3.53201 5.42973 3.66066 5.42973 3.81413V5.99684C6.03657 5.25432 6.77695 4.66271 7.65088 4.222C8.52481 3.78129 9.47887 3.56094 10.513 3.56094C11.4269 3.56094 12.2829 3.73365 13.081 4.07907C13.8791 4.42447 14.5752 4.89416 15.1692 5.48813C15.7631 6.08211 16.2328 6.77811 16.5782 7.57613C16.9236 8.37414 17.0963 9.23003 17.0963 10.1438C17.0963 11.0576 16.9236 11.9136 16.5782 12.7119C16.2328 13.5102 15.7631 14.2064 15.1692 14.8004C14.5752 15.3944 13.8791 15.864 13.081 16.2094C12.2829 16.5549 11.4269 16.7276 10.513 16.7276ZM11.0787 9.59938L13.1621 11.6827C13.2775 11.7981 13.333 11.9223 13.3287 12.0553C13.3245 12.1883 13.262 12.3152 13.1413 12.4359C13.0205 12.5566 12.8915 12.617 12.7542 12.617C12.617 12.617 12.488 12.5566 12.3672 12.4359L10.2066 10.2753C10.1385 10.2071 10.0862 10.1327 10.0499 10.052C10.0136 9.97132 9.99542 9.88791 9.99542 9.80182V6.67915C9.99542 6.52759 10.0484 6.40056 10.1544 6.29804C10.2603 6.19552 10.388 6.14425 10.5374 6.14425C10.6867 6.14425 10.8143 6.19616 10.9201 6.29998C11.0259 6.4038 11.0787 6.53244 11.0787 6.6859V9.59938Z",
        fill: "currentColor"
      }));
    }], [e.Increase_Priority, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M3.5 10.4322C3.5 9.37001 3.87069 8.46314 4.61208 7.71161C5.35361 6.96022 6.2484 6.58668 7.29646 6.59099H7.76937L7.02417 7.36494C6.90875 7.48036 6.85319 7.6046 6.8575 7.73765C6.86167 7.87071 6.92417 7.99758 7.045 8.11828C7.16569 8.23897 7.29118 8.29932 7.42146 8.29932C7.55188 8.29932 7.67743 8.23897 7.79812 8.11828L9.40146 6.50765C9.5366 6.3771 9.60285 6.22397 9.60021 6.04828C9.59743 5.87272 9.53035 5.71654 9.39896 5.57974L7.79812 3.96286C7.68451 3.84217 7.56076 3.78529 7.42687 3.79224C7.29299 3.79918 7.16569 3.863 7.045 3.98369C6.92958 4.09731 6.87188 4.22453 6.87188 4.36536C6.87188 4.50619 6.92958 4.63696 7.045 4.75765L7.795 5.52369H7.32208C5.96639 5.51939 4.80986 5.99612 3.8525 6.9539C2.89528 7.91182 2.41667 9.07397 2.41667 10.4404C2.41667 11.8079 2.89451 12.9727 3.85021 13.9347C4.8059 14.8968 5.96465 15.3779 7.32646 15.3779H9.33021C9.48368 15.3779 9.61229 15.3263 9.71604 15.2233C9.81993 15.1202 9.87188 14.9926 9.87188 14.8404C9.87188 14.688 9.81993 14.559 9.71604 14.4533C9.61229 14.3474 9.48368 14.2945 9.33021 14.2945H7.33021C6.26618 14.2945 5.36181 13.9206 4.61708 13.1727C3.87236 12.4246 3.5 11.5111 3.5 10.4322ZM12.5729 6.58619H17.0358C17.189 6.58619 17.3185 6.53467 17.4244 6.43161C17.5303 6.32855 17.5833 6.20092 17.5833 6.04869C17.5833 5.89633 17.5315 5.76731 17.4279 5.66161C17.3242 5.55578 17.1957 5.50286 17.0425 5.50286H12.5796C12.4264 5.50286 12.2968 5.55439 12.1908 5.65744C12.085 5.7605 12.0321 5.88814 12.0321 6.04036C12.0321 6.19272 12.0839 6.32175 12.1875 6.42744C12.2911 6.53328 12.4196 6.58619 12.5729 6.58619ZM12.5729 10.982H17.0358C17.189 10.982 17.3185 10.9305 17.4244 10.8274C17.5303 10.7244 17.5833 10.5968 17.5833 10.4445C17.5833 10.2922 17.5315 10.1631 17.4279 10.0574C17.3242 9.95161 17.1957 9.89869 17.0425 9.89869H12.5796C12.4264 9.89869 12.2968 9.95022 12.1908 10.0533C12.085 10.1563 12.0321 10.284 12.0321 10.4362C12.0321 10.5886 12.0839 10.7176 12.1875 10.8233C12.2911 10.9291 12.4196 10.982 12.5729 10.982ZM12.5729 15.3779H17.0358C17.189 15.3779 17.3185 15.3263 17.4244 15.2233C17.5303 15.1202 17.5833 14.9926 17.5833 14.8404C17.5833 14.688 17.5315 14.559 17.4279 14.4533C17.3242 14.3474 17.1957 14.2945 17.0425 14.2945H12.5796C12.4264 14.2945 12.2968 14.3461 12.1908 14.4491C12.085 14.5522 12.0321 14.6798 12.0321 14.832C12.0321 14.9844 12.0839 15.1134 12.1875 15.2191C12.2911 15.3249 12.4196 15.3779 12.5729 15.3779Z",
        fill: "currentColor"
      }));
    }], [e.Info, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 13.9995C10.6987 13.9995 10.8566 13.9328 10.99 13.7994C11.1234 13.666 11.1901 13.5084 11.1901 13.3265V9.81003C11.1901 9.64161 11.1234 9.49105 10.99 9.35834C10.8566 9.22496 10.6987 9.15827 10.5161 9.15827C10.3336 9.15827 10.1756 9.22496 10.0422 9.35834C9.90881 9.49105 9.84212 9.64869 9.84212 9.83125V13.3467C9.84212 13.5151 9.90881 13.666 10.0422 13.7994C10.1756 13.9328 10.3336 13.9995 10.5161 13.9995ZM10.5161 7.70519C10.7128 7.70519 10.8812 7.63143 11.0214 7.4839C11.1615 7.33704 11.2315 7.16526 11.2315 6.96855C11.2315 6.78599 11.1615 6.62094 11.0214 6.47341C10.8812 6.32655 10.7128 6.25313 10.5161 6.25313C10.3194 6.25313 10.151 6.32655 10.0109 6.47341C9.87075 6.62094 9.80069 6.78599 9.80069 6.96855C9.80069 7.16526 9.87075 7.33704 10.0109 7.4839C10.151 7.63143 10.3194 7.70519 10.5161 7.70519ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Labels, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M11.9338 17.2701C11.7218 17.4816 11.4664 17.5873 11.1675 17.5873C10.8686 17.5873 10.6134 17.4816 10.4018 17.2701L3.25598 10.1242C3.15435 10.0184 3.07473 9.89706 3.0171 9.7602C2.95948 9.62334 2.93066 9.48667 2.93066 9.3502V3.49603C2.93066 3.20106 3.03748 2.94677 3.2511 2.73316C3.46471 2.51953 3.719 2.41272 4.01398 2.41272H9.86814C10.005 2.41272 10.1366 2.43587 10.2631 2.48218C10.3896 2.52847 10.5087 2.60632 10.6205 2.71572L17.772 9.85985C17.9889 10.0767 18.0986 10.3339 18.1013 10.6314C18.104 10.929 17.9995 11.1835 17.788 11.3951L11.9338 17.2701ZM11.1642 16.496L17.022 10.6419L9.87173 3.49603H4.01398V9.3502L11.1642 16.496ZM6.01304 6.53768C6.30212 6.53768 6.54816 6.4365 6.75114 6.23414C6.95413 6.03177 7.05562 5.78605 7.05562 5.49697C7.05562 5.20789 6.95444 4.96185 6.75208 4.75887C6.54972 4.55588 6.304 4.45439 6.01491 4.45439C5.72583 4.45439 5.4798 4.55557 5.27681 4.75793C5.07382 4.96029 4.97233 5.20601 4.97233 5.49509C4.97233 5.78418 5.07351 6.03021 5.27587 6.2332C5.47823 6.43619 5.72396 6.53768 6.01304 6.53768Z",
        fill: "currentColor"
      }));
    }], [e.Last, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M8.13253 10.7444L4.82305 7.43493C4.67393 7.28583 4.59764 7.12085 4.5942 6.93998C4.59073 6.75913 4.66702 6.59069 4.82305 6.43468C4.97906 6.27865 5.14577 6.20064 5.32317 6.20064C5.50058 6.20064 5.66729 6.27865 5.8233 6.43468L9.53248 10.1439C9.61533 10.2339 9.67746 10.329 9.71887 10.4292C9.7603 10.5294 9.78101 10.6367 9.78101 10.7512C9.78101 10.8657 9.7603 10.9726 9.71887 11.0719C9.67746 11.1711 9.61533 11.2622 9.53248 11.345L5.8233 15.0542C5.6742 15.2033 5.5137 15.2751 5.3418 15.2696C5.16992 15.2641 5.00598 15.1833 4.84997 15.0273C4.69394 14.8713 4.61592 14.7046 4.61592 14.5272C4.61592 14.3498 4.69394 14.183 4.84997 14.027L8.13253 10.7444ZM14.7006 5.84444C14.8974 5.84444 15.0642 5.91153 15.2009 6.0457C15.3376 6.17985 15.4059 6.34609 15.4059 6.54442V14.9445C15.4059 15.1428 15.3393 15.309 15.2062 15.4432C15.073 15.5774 14.908 15.6444 14.7112 15.6444C14.5144 15.6444 14.3476 15.5774 14.211 15.4432C14.0743 15.309 14.0059 15.1428 14.0059 14.9445V6.54442C14.0059 6.34609 14.0725 6.17985 14.2057 6.0457C14.3388 5.91153 14.5038 5.84444 14.7006 5.84444Z",
        fill: "currentColor"
      }));
    }], [e.Launch, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.81409 10.2745C7.04062 9.82155 7.29249 9.38162 7.56971 8.95468C7.84694 8.52787 8.13992 8.10989 8.44867 7.70072L7.2468 7.53885C7.20402 7.52815 7.16263 7.52947 7.12263 7.5428C7.08249 7.55628 7.04638 7.57898 7.0143 7.61093L5.04471 9.58051C5.02874 9.59662 5.0234 9.61537 5.02867 9.63676C5.03409 9.65801 5.04749 9.67398 5.06888 9.68468L6.81409 10.2745ZM16.0447 4.40114C14.7926 4.461 13.7194 4.7444 12.8251 5.25135C11.931 5.75829 11.1057 6.3969 10.3493 7.16718C9.80541 7.71093 9.32513 8.28142 8.90846 8.87864C8.4918 9.47586 8.09812 10.1265 7.72742 10.8305L9.84451 12.9555C10.5485 12.5848 11.2005 12.1911 11.8003 11.7745C12.4002 11.3578 12.9721 10.8776 13.516 10.3338C14.2862 9.56357 14.9353 8.71044 15.463 7.77447C15.9908 6.83864 16.2708 5.79322 16.3028 4.63822C16.3028 4.60725 16.2964 4.5776 16.2835 4.54926C16.2707 4.52093 16.2531 4.49558 16.2308 4.47322C16.2083 4.43683 16.1828 4.41572 16.1545 4.40989C16.1262 4.40405 16.0896 4.40114 16.0447 4.40114ZM11.4214 9.29051C11.1671 9.03621 11.0399 8.73148 11.0399 8.37635C11.0399 8.02107 11.1671 7.71628 11.4214 7.46197C11.6757 7.20766 11.9791 7.08051 12.3316 7.08051C12.6842 7.08051 12.9876 7.20766 13.2418 7.46197C13.4961 7.71628 13.6233 8.02107 13.6233 8.37635C13.6233 8.73148 13.4961 9.03621 13.2418 9.29051C12.9876 9.54482 12.6842 9.67197 12.3316 9.67197C11.9791 9.67197 11.6757 9.54482 11.4214 9.29051ZM10.4214 13.8978L11.0112 15.6351C11.0219 15.6565 11.0378 15.6685 11.0591 15.6711C11.0805 15.6738 11.0992 15.6671 11.1153 15.6511L13.0849 13.6895C13.1169 13.6574 13.1396 13.6213 13.153 13.5813C13.1664 13.5412 13.1677 13.4998 13.157 13.4572L12.9951 12.2553C12.586 12.5641 12.168 12.8584 11.7412 13.1382C11.3142 13.4181 10.8743 13.6713 10.4214 13.8978ZM17.3685 4.00697C17.4903 5.38197 17.2649 6.65273 16.6922 7.81926C16.1196 8.98593 15.3845 10.018 14.487 10.9155C14.3909 11.0116 14.3065 11.0947 14.2339 11.1647C14.1612 11.2347 14.0838 11.3177 14.0016 11.4138L14.2195 13.3497C14.2419 13.5591 14.2189 13.7616 14.1505 13.9572C14.0822 14.1526 13.9727 14.3187 13.822 14.4555L11.2035 17.0741C11.0304 17.2332 10.8357 17.2899 10.6193 17.2441C10.4029 17.1981 10.2653 17.0704 10.2066 16.8609L9.28034 13.9443L6.77242 11.4074L3.83492 10.4395C3.62548 10.3807 3.50395 10.2432 3.47034 10.027C3.43673 9.81058 3.49951 9.6228 3.65867 9.46364L6.25638 6.8451C6.40708 6.6944 6.57534 6.58621 6.76117 6.52051C6.94701 6.45482 7.14465 6.43315 7.35409 6.45551L9.28992 6.69447C9.38617 6.59822 9.47485 6.51162 9.55596 6.43468C9.63721 6.35787 9.7259 6.27135 9.82201 6.1751C10.7195 5.29162 11.7446 4.55871 12.8974 3.97635C14.0502 3.39412 15.3071 3.17086 16.6683 3.30655C16.7687 3.31516 16.8573 3.34322 16.9341 3.39072C17.011 3.43822 17.0816 3.49405 17.1458 3.55822C17.2098 3.62225 17.2608 3.68794 17.2987 3.7553C17.3366 3.82253 17.3599 3.90641 17.3685 4.00697ZM4.20513 13.8963C4.55555 13.532 4.97756 13.3629 5.47117 13.3891C5.96464 13.4153 6.39353 13.6106 6.75784 13.9749C7.10826 14.3253 7.29527 14.7403 7.31888 15.2199C7.34235 15.6996 7.17888 16.1077 6.82846 16.4443C6.30499 16.9955 5.67305 17.3636 4.93263 17.5484C4.19221 17.7333 3.44701 17.8861 2.69701 18.0068C2.81784 17.2654 2.96853 16.5258 3.14909 15.788C3.32965 15.0504 3.68166 14.4198 4.20513 13.8963ZM4.84617 14.8032C4.60464 15.0447 4.44089 15.3252 4.35492 15.6447C4.26895 15.9641 4.18694 16.2862 4.10888 16.6109C4.43374 16.533 4.74895 16.4484 5.05451 16.357C5.36006 16.2656 5.63353 16.0992 5.87492 15.8578C6.05548 15.705 6.15353 15.5154 6.16909 15.2888C6.18451 15.0623 6.11583 14.8727 5.96305 14.7199C5.81027 14.5671 5.62409 14.5011 5.40451 14.522C5.18506 14.5428 4.99895 14.6366 4.84617 14.8032Z",
        fill: "currentColor"
      }));
    }], [e.Location, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.516 9.97894C10.9338 9.97894 11.2887 9.83289 11.5808 9.54079C11.8736 9.24803 12.02 8.89276 12.02 8.475C12.02 8.05723 11.8736 7.7023 11.5808 7.4102C11.2887 7.11743 10.9338 6.97105 10.516 6.97105C10.0982 6.97105 9.74332 7.11743 9.45122 7.4102C9.15845 7.7023 9.01206 8.05723 9.01206 8.475C9.01206 8.89276 9.15845 9.24803 9.45122 9.54079C9.74332 9.83289 10.0982 9.97894 10.516 9.97894ZM10.516 16.5382C12.2285 15.0202 13.5132 13.5754 14.3701 12.2038C15.2264 10.8322 15.6545 9.64507 15.6545 8.64244C15.6545 7.05494 15.1602 5.77391 14.1716 4.79935C13.183 3.82412 11.9645 3.33651 10.516 3.33651C9.06754 3.33651 7.84901 3.82412 6.86042 4.79935C5.87182 5.77391 5.37752 7.05494 5.37752 8.64244C5.37752 9.64507 5.80565 10.8322 6.6619 12.2038C7.51881 13.5754 8.80352 15.0202 10.516 16.5382ZM10.516 18C10.4044 18 10.3001 17.9863 10.2032 17.9589C10.1056 17.9308 10.008 17.882 9.91042 17.8125C7.93323 16.0024 6.4607 14.3417 5.49283 12.8304C4.52495 11.3198 4.04102 9.9238 4.04102 8.64244C4.04102 6.6091 4.68838 4.99386 5.98311 3.79672C7.27851 2.59891 8.78948 2 10.516 2C12.2425 2 13.7535 2.59891 15.0489 3.79672C16.3436 4.99386 16.991 6.6091 16.991 8.64244C16.991 9.9238 16.5071 11.3198 15.5392 12.8304C14.5713 14.3417 13.0988 16.0024 11.1216 17.8125C11.038 17.882 10.9441 17.9308 10.8399 17.9589C10.7356 17.9863 10.6276 18 10.516 18Z",
        fill: "currentColor"
      }));
    }], [e.Lock, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.75052 18.3278C5.38053 18.3278 5.06574 18.1969 4.80612 17.9352C4.5465 17.6735 4.41669 17.3578 4.41669 16.988V9.50089C4.41669 9.13112 4.54754 8.81539 4.80925 8.5537C5.07094 8.29199 5.38667 8.16113 5.75644 8.16113H6.41669V6.16113C6.41669 5.16666 6.76575 4.32083 7.46387 3.62363C8.16199 2.92644 9.00893 2.57784 10.0047 2.57784C11.0005 2.57784 11.8459 2.92644 12.5409 3.62363C13.2358 4.32083 13.5833 5.16666 13.5833 6.16113V8.16113H14.2436C14.6133 8.16113 14.9291 8.29199 15.1908 8.5537C15.4525 8.81539 15.5833 9.13112 15.5833 9.50089V16.988C15.5833 17.3578 15.4524 17.6735 15.1905 17.9352C14.9286 18.1969 14.6127 18.3278 14.2427 18.3278H5.75052ZM5.75644 17.2444H14.2436C14.3184 17.2444 14.3798 17.2204 14.4279 17.1723C14.476 17.1242 14.5 17.0628 14.5 16.988V9.50089C14.5 9.42609 14.476 9.36466 14.4279 9.31657C14.3798 9.26849 14.3184 9.24445 14.2436 9.24445H5.75644C5.68165 9.24445 5.62021 9.26849 5.57212 9.31657C5.52404 9.36466 5.5 9.42609 5.5 9.50089V16.988C5.5 17.0628 5.52404 17.1242 5.57212 17.1723C5.62021 17.2204 5.68165 17.2444 5.75644 17.2444ZM10.0044 14.5361C10.3647 14.5361 10.6693 14.4102 10.9182 14.1583C11.1672 13.9064 11.2916 13.6003 11.2916 13.24C11.2916 12.8797 11.1657 12.5751 10.9138 12.3262C10.662 12.0773 10.3559 11.9528 9.99558 11.9528C9.63528 11.9528 9.33067 12.0787 9.08175 12.3306C8.83282 12.5825 8.70835 12.8886 8.70835 13.2489C8.70835 13.6092 8.83429 13.9138 9.08617 14.1627C9.33804 14.4116 9.64412 14.5361 10.0044 14.5361ZM7.5 8.16113H12.5V6.16113C12.5 5.46669 12.2569 4.87641 11.7708 4.3903C11.2847 3.90419 10.6944 3.66113 10 3.66113C9.30556 3.66113 8.71528 3.90419 8.22917 4.3903C7.74306 4.87641 7.5 5.46669 7.5 6.16113V8.16113Z",
        fill: "currentColor"
      }));
    }], [e.Logout, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M13.8416 13.5203C13.6895 13.3828 13.6134 13.2149 13.6134 13.0167C13.6134 12.8192 13.6895 12.644 13.8416 12.4911L15.6015 10.7313H8.81329C8.61507 10.7313 8.44355 10.6588 8.29872 10.514C8.15389 10.3692 8.08148 10.1977 8.08148 9.99945C8.08148 9.80196 8.15389 9.6308 8.29872 9.48598C8.44355 9.34115 8.61507 9.26874 8.81329 9.26874H15.5334L13.8186 7.50888C13.6972 7.37137 13.6364 7.20752 13.6364 7.01735C13.6364 6.82644 13.7048 6.6626 13.8416 6.52582C13.9784 6.38831 14.1499 6.31955 14.3562 6.31955C14.5617 6.31955 14.7329 6.38831 14.8697 6.52582L17.7508 9.40588C17.8569 9.49731 17.9289 9.59643 17.967 9.70322C18.0057 9.80928 18.0251 9.9157 18.0251 10.0225C18.0251 10.1293 18.0057 10.2361 17.967 10.3429C17.9289 10.4497 17.8569 10.5488 17.7508 10.6402L14.8477 13.5433C14.7256 13.6801 14.5694 13.7521 14.3792 13.7594C14.1883 13.7675 14.0091 13.6878 13.8416 13.5203ZM4.7439 18C4.25675 18 3.84532 17.8325 3.50958 17.4975C3.17458 17.1618 3.00708 16.7503 3.00708 16.2632V3.73682C3.00708 3.24894 3.17458 2.8375 3.50958 2.5025C3.84532 2.1675 4.25675 2 4.7439 2H10.0476C10.2305 2 10.398 2.07241 10.5501 2.21724C10.7023 2.36133 10.7783 2.53249 10.7783 2.73071C10.7783 2.92894 10.7023 3.10046 10.5501 3.24529C10.398 3.39011 10.2305 3.46252 10.0476 3.46252H4.7439C4.68319 3.46252 4.62248 3.49288 4.56177 3.55359C4.50033 3.61503 4.46961 3.67611 4.46961 3.73682V16.2632C4.46961 16.3239 4.50033 16.3846 4.56177 16.4453C4.62248 16.5068 4.68319 16.5375 4.7439 16.5375H10.0476C10.2305 16.5375 10.398 16.6099 10.5501 16.7547C10.7023 16.8988 10.7783 17.07 10.7783 17.2682C10.7783 17.4664 10.7023 17.6379 10.5501 17.7828C10.398 17.9276 10.2305 18 10.0476 18H4.7439Z",
        fill: "currentColor"
      }));
    }], [e.Magic, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M15.0833 8.06244L14.1394 6.00317L12.0802 5.08011L14.1394 4.13621L15.0833 2.07694L16.0064 4.13621L18.0657 5.08011L16.0064 6.00317L15.0833 8.06244ZM15.0833 18.7419L14.1603 16.6618L12.0802 15.7387L14.1603 14.8157L15.0833 12.7356L16.0064 14.8157L18.0865 15.7387L16.0064 16.6618L15.0833 18.7419ZM7.40387 15.8893L5.70357 12.0993L1.91357 10.399L5.70357 8.69871L7.40387 4.90869L9.10418 8.69871L12.8942 10.399L9.10418 12.0993L7.40387 15.8893ZM7.40387 13.274L8.2997 11.2948L10.2789 10.399L8.2997 9.50317L7.40387 7.52401L6.50803 9.50317L4.52887 10.399L6.50803 11.2948L7.40387 13.274Z",
        fill: "currentColor"
      }));
    }], [e.Merge, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M2.72331 4.35966C2.86144 4.22153 3.02259 4.15247 3.20676 4.15247C3.39093 4.15247 3.55209 4.22153 3.69022 4.35966L7.71899 8.38844C8.08734 8.75678 8.42499 9.00235 8.73194 9.12513C9.03889 9.24791 9.49165 9.3093 10.0902 9.3093L16.1909 9.3093L14.6024 7.72081C14.4643 7.58268 14.3952 7.42153 14.3952 7.23736C14.3952 7.05318 14.4643 6.89203 14.6024 6.7539C14.7406 6.61578 14.9017 6.54671 15.0859 6.54671C15.2701 6.54671 15.4312 6.61578 15.5694 6.7539L18.3319 9.51649C18.4087 9.59323 18.4586 9.66997 18.4816 9.74671C18.5046 9.82345 18.5161 9.90786 18.5161 9.99995C18.5161 10.092 18.5046 10.1764 18.4816 10.2532C18.4586 10.3299 18.4087 10.4067 18.3319 10.4834L15.5694 13.246C15.4312 13.3841 15.2701 13.4532 15.0859 13.4532C14.9017 13.4532 14.7406 13.3841 14.6024 13.246C14.4643 13.1079 14.3952 12.9467 14.3952 12.7625C14.3952 12.5784 14.4643 12.4172 14.6024 12.2791L16.1909 10.6906L10.0902 10.6906C9.49165 10.6906 9.03889 10.752 8.73194 10.8748C8.42499 10.9975 8.08734 11.2431 7.71899 11.6115L3.69021 15.6402C3.55209 15.7784 3.39093 15.8474 3.20676 15.8474C3.02259 15.8474 2.86144 15.7784 2.72331 15.6402C2.58518 15.5021 2.51611 15.341 2.51611 15.1568C2.51611 14.9726 2.58518 14.8115 2.72331 14.6733L7.39669 9.99995L2.72331 5.32657C2.58518 5.18844 2.51611 5.02729 2.51611 4.84311C2.51611 4.65894 2.58518 4.49779 2.72331 4.35966Z",
        fill: "currentColor"
      }));
    }], [e.Minus, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.55811 10.625C5.37745 10.625 5.22111 10.559 5.08911 10.427C4.95711 10.295 4.89111 10.1387 4.89111 9.95799C4.89111 9.77799 4.95711 9.62199 5.08911 9.48999C5.22111 9.35799 5.37745 9.29199 5.55811 9.29199H15.4741C15.6548 9.29199 15.8111 9.35799 15.9431 9.48999C16.0751 9.62199 16.1411 9.77799 16.1411 9.95799C16.1411 10.1387 16.0751 10.295 15.9431 10.427C15.8111 10.559 15.6548 10.625 15.4741 10.625H5.55811Z",
        fill: "currentColor"
      }));
    }], [e.New_Window, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.75646 16.5833C4.38132 16.5833 4.06424 16.4538 3.80521 16.1948C3.54619 15.9358 3.41667 15.6187 3.41667 15.2435V4.75646C3.41667 4.38132 3.54619 4.06424 3.80521 3.80521C4.06424 3.54618 4.38132 3.41667 4.75646 3.41667H9.13771C9.29146 3.41667 9.42021 3.46812 9.52396 3.57104C9.62757 3.67382 9.67938 3.80146 9.67938 3.95396C9.67938 4.10646 9.62757 4.23556 9.52396 4.34125C9.42021 4.44708 9.29146 4.5 9.13771 4.5H4.75646C4.6923 4.5 4.63355 4.52674 4.58021 4.58021C4.52674 4.63354 4.50001 4.69229 4.50001 4.75646V15.2435C4.50001 15.3077 4.52674 15.3665 4.58021 15.4198C4.63355 15.4733 4.6923 15.5 4.75646 15.5H15.2435C15.3077 15.5 15.3665 15.4733 15.4198 15.4198C15.4733 15.3665 15.5 15.3077 15.5 15.2435V10.8623C15.5 10.7085 15.5514 10.5798 15.6542 10.476C15.7571 10.3724 15.8848 10.3206 16.0373 10.3206C16.1898 10.3206 16.3189 10.3724 16.4246 10.476C16.5304 10.5798 16.5833 10.7085 16.5833 10.8623V15.2435C16.5833 15.6187 16.4538 15.9358 16.1948 16.1948C15.9358 16.4538 15.6187 16.5833 15.2435 16.5833H4.75646ZM15.5 5.27396L8.45521 12.319C8.3398 12.4342 8.21556 12.4898 8.08251 12.4856C7.94959 12.4813 7.82271 12.4188 7.70188 12.2981C7.58119 12.1773 7.52084 12.0483 7.52084 11.911C7.52084 11.7738 7.58119 11.6448 7.70188 11.524L14.726 4.5H12.5417C12.3879 4.5 12.2592 4.44861 12.1556 4.34583C12.0519 4.24292 12 4.11521 12 3.96271C12 3.81021 12.0519 3.68111 12.1556 3.57542C12.2592 3.46958 12.3879 3.41667 12.5417 3.41667H15.9133C16.1046 3.41667 16.264 3.48056 16.3917 3.60833C16.5194 3.73597 16.5833 3.89542 16.5833 4.08667V7.45833C16.5833 7.61208 16.5319 7.74076 16.429 7.84438C16.3262 7.94813 16.1985 8 16.046 8C15.8935 8 15.7644 7.94813 15.6588 7.84438C15.5529 7.74076 15.5 7.61208 15.5 7.45833V5.27396Z",
        fill: "currentColor"
      }));
    }], [e.Notes_Stacked, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.75 7.88509V16.3722C7.75 16.447 7.77403 16.5085 7.82208 16.5565C7.87014 16.6046 7.9316 16.6286 8.00646 16.6286H13.25V13.7984C13.25 13.6073 13.3139 13.4479 13.4417 13.3203C13.5693 13.1925 13.7287 13.1286 13.9198 13.1286H16.75V7.88509C16.75 7.81023 16.726 7.74877 16.6779 7.70071C16.6299 7.65266 16.5684 7.62863 16.4935 7.62863H8.00646C7.9316 7.62863 7.87014 7.65266 7.82208 7.70071C7.77403 7.74877 7.75 7.81023 7.75 7.88509ZM6.66667 16.3722V7.893C6.66667 7.518 6.79514 7.19967 7.05208 6.938C7.30903 6.6762 7.62444 6.5453 7.99833 6.5453H16.4935C16.8633 6.5453 17.179 6.67613 17.4408 6.9378C17.7025 7.1996 17.8333 7.51537 17.8333 7.88509V13.3913C17.8333 13.5676 17.8012 13.7372 17.7371 13.9001C17.6731 14.0631 17.5744 14.2113 17.441 14.3445L14.4658 17.3197C14.3326 17.453 14.1845 17.5517 14.0215 17.6157C13.8585 17.6799 13.689 17.712 13.5127 17.712H8.00646C7.63673 17.712 7.32097 17.5811 7.05917 17.3195C6.7975 17.0577 6.66667 16.7419 6.66667 16.3722ZM2.70833 5.62696C2.6443 5.26696 2.7218 4.93071 2.94083 4.61821C3.15972 4.30571 3.44924 4.11745 3.80937 4.05342L12.1506 2.56613C12.516 2.5021 12.8528 2.57821 13.161 2.79446C13.4692 3.01085 13.6501 3.30175 13.7035 3.66717L13.75 4.06613C13.7703 4.2328 13.7379 4.37113 13.6529 4.48113C13.5681 4.59127 13.4551 4.65752 13.3142 4.67988C13.1731 4.70238 13.0432 4.68182 12.9246 4.61821C12.8061 4.5546 12.734 4.43946 12.7083 4.2728L12.625 3.80488C12.6143 3.74613 12.5822 3.69939 12.5287 3.66467C12.4754 3.62995 12.4167 3.61794 12.3525 3.62863L3.98729 5.118C3.91243 5.1287 3.85632 5.16342 3.81896 5.22217C3.7816 5.28092 3.76819 5.34773 3.77875 5.42259L5.165 13.2072C5.18208 13.3376 5.15111 13.4634 5.07208 13.5847C4.99305 13.7059 4.88493 13.7847 4.74771 13.8209C4.60507 13.8573 4.4666 13.8315 4.33229 13.7436C4.19798 13.6557 4.11611 13.5362 4.08667 13.3851L2.70833 5.62696Z",
        fill: "currentColor"
      }));
    }], [e.Off_Hold, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.9833 18.0353C9.00411 18.0353 8.08664 17.8494 7.23091 17.4775C6.37517 17.1058 5.62439 16.5969 4.97855 15.9511C4.33272 15.3053 3.82391 14.554 3.45211 13.6972C3.08032 12.8405 2.89443 11.9219 2.89443 10.9415C2.89443 9.96115 3.08032 9.04258 3.45211 8.18582C3.82391 7.32905 4.33272 6.57775 4.97855 5.93192C5.62439 5.2861 6.37517 4.78077 7.23091 4.41592C8.08664 4.05106 9.00411 3.86863 9.9833 3.86863C10.9625 3.86863 11.8816 4.05106 12.7405 4.41592C13.5995 4.78077 14.3484 5.2861 14.9873 5.93192C15.6262 6.57775 16.1316 7.32905 16.5033 8.18582C16.8751 9.04258 17.061 9.96115 17.061 10.9415C17.061 11.9219 16.8751 12.8405 16.5033 13.6972C16.1316 14.554 15.6262 15.304 14.9873 15.9473C14.3484 16.5905 13.5995 17.0993 12.7405 17.4737C11.8816 17.8481 10.9625 18.0353 9.9833 18.0353ZM2.95209 6.26925C2.80893 6.38463 2.65215 6.44579 2.48176 6.45273C2.31136 6.45968 2.16152 6.39852 2.03224 6.26925C1.89763 6.13464 1.83032 5.98133 1.83032 5.80932C1.83032 5.63732 1.89763 5.47707 2.03224 5.32857L4.35436 3.00644C4.48363 2.87718 4.64041 2.81255 4.8247 2.81255C5.00899 2.81255 5.16577 2.87718 5.29503 3.00644C5.42964 3.14107 5.49348 3.29438 5.48653 3.46638C5.47959 3.63838 5.40881 3.79863 5.2742 3.94713L2.95209 6.26925ZM17.0034 6.26925L14.6813 3.94713C14.552 3.81787 14.4873 3.66109 14.4873 3.4768C14.4873 3.2925 14.552 3.13572 14.6813 3.00644C14.8298 2.85794 14.9935 2.78369 15.1724 2.78369C15.3514 2.78369 15.5082 2.85794 15.6428 3.00644L17.9649 5.32857C18.1081 5.45089 18.1762 5.60246 18.1692 5.78327C18.1623 5.96409 18.0942 6.11914 17.9649 6.24842C17.8164 6.39692 17.6527 6.47464 17.4737 6.48159C17.2948 6.48853 17.138 6.41775 17.0034 6.26925ZM9.97291 16.7019C11.568 16.7019 12.9259 16.1418 14.0466 15.0214C15.1674 13.901 15.7277 12.5413 15.7277 10.9421C15.7277 9.34289 15.169 7.9864 14.0515 6.87261C12.934 5.75883 11.5777 5.20194 9.98255 5.20194C8.38745 5.20194 7.02955 5.75883 5.90882 6.87261C4.7881 7.9864 4.22774 9.34289 4.22774 10.9421C4.22774 12.5413 4.78649 13.901 5.90399 15.0214C7.0215 16.1418 8.37781 16.7019 9.97291 16.7019Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4832 7.24961C10.3871 7.02869 10.1681 6.88669 9.92719 6.88903C9.68627 6.89137 9.47012 7.0376 9.3783 7.26035L6.9707 13.1011C6.84442 13.4075 6.9904 13.7582 7.29676 13.8845C7.60313 14.0108 7.95386 13.8648 8.08014 13.5584L8.8271 11.7464H11.1312L11.9243 13.5692C12.0565 13.873 12.41 14.0122 12.7139 13.88C13.0177 13.7477 13.1569 13.3942 13.0247 13.0904L10.4832 7.24961ZM10.609 10.5464L9.94796 9.02715L9.32174 10.5464H10.609Z",
        fill: "currentColor"
      }));
    }], [e.Pending, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.31588 16.652H13.7163V14.1682C13.7163 13.2278 13.4108 12.4137 12.7998 11.7259C12.1894 11.0388 11.4282 10.6952 10.5161 10.6952C9.60395 10.6952 8.84272 11.0388 8.23238 11.7259C7.62138 12.4137 7.31588 13.2278 7.31588 14.1682V16.652ZM10.5161 9.30479C11.4282 9.30479 12.1894 8.96122 12.7998 8.27409C13.4108 7.58629 13.7163 6.77925 13.7163 5.85297V3.34799H7.31588V5.85297C7.31588 6.7934 7.62138 7.60381 8.23238 8.2842C8.84272 8.96459 9.60395 9.30479 10.5161 9.30479ZM16.0737 18H4.95842C4.77586 18 4.61788 17.9333 4.4845 17.7999C4.35112 17.6665 4.28442 17.5086 4.28442 17.326C4.28442 17.1434 4.35112 16.9855 4.4845 16.8521C4.61788 16.7187 4.77586 16.652 4.95842 16.652H5.9689V14.1682C5.9689 13.2703 6.18986 12.4457 6.63178 11.6946C7.0737 10.9435 7.68066 10.3786 8.45267 10C7.68066 9.62141 7.0737 9.05654 6.63178 8.30542C6.18986 7.55429 5.9689 6.73681 5.9689 5.85297V3.34799H4.95842C4.77586 3.34799 4.61788 3.28129 4.4845 3.14791C4.35112 3.01453 4.28442 2.85655 4.28442 2.67399C4.28442 2.49143 4.35112 2.33346 4.4845 2.20008C4.61788 2.06669 4.77586 2 4.95842 2H16.0737C16.2563 2 16.4143 2.06669 16.5477 2.20008C16.681 2.33346 16.7477 2.49143 16.7477 2.67399C16.7477 2.85655 16.681 3.01453 16.5477 3.14791C16.4143 3.28129 16.2563 3.34799 16.0737 3.34799H15.0633V5.85297C15.0633 6.73681 14.8423 7.55429 14.4004 8.30542C13.9585 9.05654 13.3515 9.62141 12.5795 10C13.3515 10.3786 13.9585 10.9435 14.4004 11.6946C14.8423 12.4457 15.0633 13.2703 15.0633 14.1682V16.652H16.0737C16.2563 16.652 16.4143 16.7187 16.5477 16.8521C16.681 16.9855 16.7477 17.1434 16.7477 17.326C16.7477 17.5086 16.681 17.6665 16.5477 17.7999C16.4143 17.9333 16.2563 18 16.0737 18Z",
        fill: "currentColor"
      }));
    }], [e.Plus, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 16C10.3234 16 10.1566 15.9296 10.0158 15.7888C9.87505 15.648 9.80465 15.4812 9.80465 15.2885V10.7115H5.22758C5.03487 10.7115 4.86811 10.6411 4.72731 10.5003C4.58651 10.3595 4.51611 10.1927 4.51611 10C4.51611 9.80729 4.58651 9.64053 4.72731 9.49973C4.86811 9.35893 5.03487 9.28853 5.22758 9.28853H9.80465V4.71147C9.80465 4.51876 9.87505 4.352 10.0158 4.2112C10.1566 4.0704 10.3234 4 10.5161 4C10.7088 4 10.8756 4.0704 11.0164 4.2112C11.1572 4.352 11.2276 4.51876 11.2276 4.71147V9.28853H15.8046C15.9974 9.28853 16.1641 9.35893 16.3049 9.49973C16.4457 9.64053 16.5161 9.80729 16.5161 10C16.5161 10.1927 16.4457 10.3595 16.3049 10.5003C16.1641 10.6411 15.9974 10.7115 15.8046 10.7115H11.2276V15.2885C11.2276 15.4812 11.1572 15.648 11.0164 15.7888C10.8756 15.9296 10.7088 16 10.5161 16Z",
        fill: "currentColor"
      }));
    }], [e.Plus_Circle, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 13.9995C10.6987 13.9995 10.8566 13.9328 10.99 13.7994C11.1234 13.666 11.1901 13.5084 11.1901 13.3265V10.674H13.8628C14.0312 10.674 14.1821 10.6107 14.3155 10.484C14.4489 10.358 14.5156 10.1967 14.5156 10C14.5156 9.81744 14.4489 9.65947 14.3155 9.52608C14.1821 9.3927 14.0245 9.32601 13.8426 9.32601H11.1901V6.65328C11.1901 6.48486 11.1268 6.33396 11.0001 6.20058C10.8742 6.0672 10.7128 6.00051 10.5161 6.00051C10.3336 6.00051 10.1756 6.0672 10.0422 6.20058C9.90881 6.33396 9.84212 6.4916 9.84212 6.67349V9.32601H7.16939C7.00098 9.32601 6.85008 9.38933 6.71669 9.51598C6.58331 9.64195 6.51662 9.80329 6.51662 10C6.51662 10.1826 6.58331 10.3405 6.71669 10.4739C6.85008 10.6073 7.00771 10.674 7.1896 10.674H9.84212V13.3467C9.84212 13.5151 9.90544 13.666 10.0321 13.7994C10.1581 13.9328 10.3194 13.9995 10.5161 13.9995ZM10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Profile_Preference, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M8.98997 9.51943C8.16012 9.51943 7.46655 9.24079 6.90926 8.68351C6.35197 8.12622 6.07332 7.43265 6.07332 6.6028C6.07332 5.77294 6.35197 5.07937 6.90926 4.52209C7.46655 3.9648 8.16012 3.68616 8.98997 3.68616C9.81982 3.68616 10.5134 3.9648 11.0707 4.52209C11.628 5.07937 11.9066 5.77294 11.9066 6.6028C11.9066 7.43265 11.628 8.12622 11.0707 8.68351C10.5134 9.24079 9.81982 9.51943 8.98997 9.51943ZM3.47741 15.8864C3.25931 15.8864 3.07147 15.8073 2.91389 15.649C2.75629 15.4908 2.67749 15.3036 2.67749 15.0876V13.9714C2.67749 13.5227 2.78487 13.138 2.99962 12.8175C3.21435 12.497 3.52097 12.2433 3.91947 12.0563C4.69512 11.6835 5.49507 11.3953 6.3193 11.1917C7.14355 10.9882 8.03206 10.8865 8.98482 10.8865H9.23355C9.31475 10.8865 9.3874 10.8881 9.45151 10.8913C9.36126 11.101 9.28662 11.315 9.22757 11.5333C9.16853 11.7517 9.11391 11.9805 9.0637 12.2198H8.98997C8.15557 12.2198 7.37913 12.3092 6.66066 12.4882C5.94217 12.6671 5.22662 12.9227 4.51401 13.255C4.31103 13.3565 4.17641 13.4682 4.11016 13.5899C4.04392 13.7118 4.0108 13.8389 4.0108 13.9714V14.5531H9.1983C9.27415 14.7924 9.36496 15.021 9.47074 15.239C9.5765 15.4569 9.69562 15.6727 9.82809 15.8864H3.47741ZM8.98997 8.18614C9.4483 8.18614 9.82678 8.03683 10.1254 7.73822C10.424 7.43961 10.5733 7.06114 10.5733 6.6028C10.5733 6.14447 10.424 5.766 10.1254 5.46739C9.82678 5.16878 9.4483 5.01947 8.98997 5.01947C8.53164 5.01947 8.15316 5.16878 7.85455 5.46739C7.55594 5.766 7.40664 6.14447 7.40664 6.6028C7.40664 7.06114 7.55594 7.43961 7.85455 7.73822C8.15316 8.03683 8.53164 8.18614 8.98997 8.18614ZM14.5804 14.4329C15.0169 14.4329 15.3903 14.2775 15.7007 13.9666C16.0111 13.6558 16.1662 13.2821 16.1662 12.8456C16.1662 12.4092 16.0108 12.0357 15.7 11.7254C15.3892 11.415 15.0155 11.2598 14.579 11.2598C14.1425 11.2598 13.7691 11.4152 13.4587 11.7261C13.1484 12.0369 12.9932 12.4106 12.9932 12.8471C12.9932 13.2836 13.1486 13.657 13.4594 13.9673C13.7703 14.2777 14.1439 14.4329 14.5804 14.4329ZM13.7672 15.4184C13.5824 15.3875 13.4058 15.3279 13.2376 15.2398C13.0693 15.1516 12.913 15.036 12.7688 14.8928L11.99 15.1925C11.8937 15.2202 11.8042 15.2181 11.7217 15.1861C11.6391 15.154 11.5747 15.0947 11.5284 15.0082L11.2208 14.4746C11.162 14.3947 11.1404 14.307 11.1559 14.2112C11.1714 14.1154 11.2117 14.0418 11.2769 13.9904L11.8986 13.4842C11.8527 13.31 11.8297 13.0974 11.8297 12.8464C11.8297 12.5953 11.8527 12.3827 11.8986 12.2085L11.2849 11.6862C11.2197 11.6349 11.1794 11.5613 11.1639 11.4655C11.1484 11.3697 11.17 11.2793 11.2288 11.1941L11.5364 10.6605C11.5827 10.5811 11.6471 10.5262 11.7297 10.4959C11.8122 10.4657 11.9017 10.4644 11.998 10.4922L12.7688 10.7919C12.9077 10.6487 13.0626 10.5344 13.2336 10.4489C13.4045 10.3635 13.5824 10.3052 13.7672 10.2743L13.8858 9.50824C13.9135 9.41523 13.9619 9.33882 14.0311 9.27903C14.1002 9.21924 14.1832 9.18934 14.28 9.18934H14.8954C14.9948 9.18934 15.0799 9.21916 15.1509 9.27878C15.2219 9.33841 15.2681 9.41489 15.2896 9.50824L15.4002 10.2743C15.585 10.3052 15.7618 10.3631 15.9306 10.4479C16.0994 10.5327 16.2554 10.642 16.3986 10.7759L17.1774 10.4922C17.2725 10.4698 17.3615 10.4733 17.4444 10.5026C17.5274 10.532 17.5922 10.59 17.639 10.6765L17.9467 11.1941C18.0054 11.2753 18.0244 11.3621 18.0035 11.4545C17.9827 11.5469 17.9407 11.6188 17.8776 11.6702L17.2688 12.1925C17.3147 12.3512 17.3377 12.5669 17.3377 12.8396C17.3377 13.1123 17.3147 13.3271 17.2688 13.4842L17.8906 13.9904C17.9611 14.0418 18.0014 14.1167 18.0116 14.2152C18.0217 14.3136 17.9974 14.4054 17.9386 14.4906L17.631 15.0242C17.5856 15.1036 17.5224 15.1585 17.4412 15.1887C17.3601 15.219 17.2721 15.2202 17.1774 15.1925L16.3986 14.8928C16.2544 15.036 16.0981 15.1516 15.9298 15.2398C15.7616 15.3279 15.585 15.3875 15.4002 15.4184L15.2896 16.1845C15.2681 16.2778 15.2219 16.3543 15.1509 16.4139C15.0799 16.4736 14.9948 16.5034 14.8954 16.5034H14.28C14.1832 16.5034 14.1002 16.4735 14.0311 16.4137C13.9619 16.3539 13.9135 16.2775 13.8858 16.1845L13.7672 15.4184Z",
        fill: "currentColor"
      }));
    }], [e.Radio, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 13.78C11.5711 13.78 12.465 13.4101 13.1979 12.6702C13.9301 11.9303 14.2961 11.0402 14.2961 10C14.2961 8.94501 13.9262 8.05108 13.1863 7.31821C12.4464 6.58605 11.5563 6.21997 10.5161 6.21997C9.46112 6.21997 8.56719 6.58992 7.83433 7.32982C7.10216 8.06972 6.73608 8.95978 6.73608 10C6.73608 11.055 7.10603 11.9489 7.84593 12.6818C8.58583 13.414 9.47589 13.78 10.5161 13.78ZM10.5161 18C9.41752 18 8.38081 17.7915 7.406 17.3744C6.43189 16.9566 5.58192 16.3852 4.85608 15.66C4.13095 14.9342 3.5595 14.0842 3.14172 13.1101C2.72465 12.1353 2.51611 11.0986 2.51611 10C2.51611 8.88663 2.72465 7.84641 3.14172 6.87934C3.5595 5.91226 4.13095 5.06581 4.85608 4.33997C5.58192 3.61484 6.43189 3.04339 7.406 2.62561C8.38081 2.20854 9.41752 2 10.5161 2C11.6295 2 12.6697 2.20854 13.6368 2.62561C14.6039 3.04339 15.4503 3.61484 16.1761 4.33997C16.9013 5.06581 17.4727 5.91578 17.8905 6.88989C18.3076 7.8647 18.5161 8.9014 18.5161 10C18.5161 11.0986 18.3076 12.1353 17.8905 13.1101C17.4727 14.0842 16.9013 14.9342 16.1761 15.66C15.4503 16.3852 14.6003 16.9566 13.6262 17.3744C12.6514 17.7915 11.6147 18 10.5161 18ZM10.5161 16.8574C12.4207 16.8574 14.0398 16.1907 15.3733 14.8572C16.7068 13.5237 17.3736 11.9046 17.3736 10C17.3736 8.09539 16.7068 6.47633 15.3733 5.14282C14.0398 3.80931 12.4207 3.14256 10.5161 3.14256C8.6115 3.14256 6.99244 3.80931 5.65893 5.14282C4.32542 6.47633 3.65867 8.09539 3.65867 10C3.65867 11.9046 4.32542 13.5237 5.65893 14.8572C6.99244 16.1907 8.6115 16.8574 10.5161 16.8574Z",
        fill: "currentColor"
      }));
    }], [e.Radio_Empty, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 18C9.41752 18 8.38081 17.7915 7.406 17.3744C6.43189 16.9566 5.58192 16.3852 4.85608 15.66C4.13095 14.9342 3.5595 14.0842 3.14172 13.1101C2.72465 12.1353 2.51611 11.0986 2.51611 10C2.51611 8.88663 2.72465 7.84641 3.14172 6.87934C3.5595 5.91226 4.13095 5.06581 4.85608 4.33997C5.58192 3.61484 6.43189 3.04339 7.406 2.62561C8.38081 2.20854 9.41752 2 10.5161 2C11.6295 2 12.6697 2.20854 13.6368 2.62561C14.6039 3.04339 15.4503 3.61484 16.1761 4.33997C16.9013 5.06581 17.4727 5.91578 17.8905 6.88989C18.3076 7.8647 18.5161 8.9014 18.5161 10C18.5161 11.0986 18.3076 12.1353 17.8905 13.1101C17.4727 14.0842 16.9013 14.9342 16.1761 15.66C15.4503 16.3852 14.6003 16.9566 13.6262 17.3744C12.6514 17.7915 11.6147 18 10.5161 18ZM10.5161 16.8574C12.4207 16.8574 14.0398 16.1907 15.3733 14.8572C16.7068 13.5237 17.3736 11.9046 17.3736 10C17.3736 8.09539 16.7068 6.47633 15.3733 5.14282C14.0398 3.80931 12.4207 3.14256 10.5161 3.14256C8.6115 3.14256 6.99244 3.80931 5.65893 5.14282C4.32542 6.47633 3.65867 8.09539 3.65867 10C3.65867 11.9046 4.32542 13.5237 5.65893 14.8572C6.99244 16.1907 8.6115 16.8574 10.5161 16.8574Z",
        fill: "currentColor"
      }));
    }], [e.Radio_Filled, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10 18.4094C8.9014 18.4094 7.8647 18.2009 6.88989 17.7838C5.91578 17.366 5.06581 16.7946 4.33997 16.0695C3.61484 15.3436 3.04339 14.4936 2.62561 13.5195C2.20854 12.5447 2 11.508 2 10.4094C2 9.29606 2.20854 8.25584 2.62561 7.28876C3.04339 6.32168 3.61484 5.47523 4.33997 4.7494C5.06581 4.02426 5.91578 3.45281 6.88989 3.03503C7.8647 2.61796 8.9014 2.40942 10 2.40942C11.1134 2.40942 12.1536 2.61796 13.1207 3.03503C14.0877 3.45281 14.9342 4.02426 15.66 4.7494C16.3852 5.47523 16.9566 6.3252 17.3744 7.29931C17.7915 8.27412 18 9.31083 18 10.4094C18 11.508 17.7915 12.5447 17.3744 13.5195C16.9566 14.4936 16.3852 15.3436 15.66 16.0695C14.9342 16.7946 14.0842 17.366 13.1101 17.7838C12.1353 18.2009 11.0986 18.4094 10 18.4094Z",
        fill: "currentColor"
      }));
    }], [e.Reduce_Priority, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M3.5 8.73729C3.5 9.79952 3.8707 10.7064 4.61208 11.4579C5.35361 12.2093 6.2484 12.5828 7.29646 12.5785H7.76938L7.02417 11.8046C6.90875 11.6892 6.8532 11.5649 6.8575 11.4319C6.86167 11.2988 6.92417 11.1719 7.045 11.0513C7.1657 10.9306 7.29118 10.8702 7.42146 10.8702C7.55188 10.8702 7.67743 10.9306 7.79813 11.0513L9.40146 12.6619C9.5366 12.7924 9.60285 12.9456 9.60021 13.1213C9.59743 13.2968 9.53035 13.453 9.39896 13.5898L7.79813 15.2067C7.68452 15.3274 7.56077 15.3842 7.42688 15.3773C7.29299 15.3703 7.1657 15.3065 7.045 15.1858C6.92958 15.0722 6.87188 14.945 6.87188 14.8042C6.87188 14.6633 6.92958 14.5326 7.045 14.4119L7.795 13.6458H7.32208C5.96639 13.6501 4.80986 13.1734 3.8525 12.2156C2.89528 11.2577 2.41667 10.0956 2.41667 8.72917C2.41667 7.36167 2.89452 6.19688 3.85021 5.23479C4.8059 4.27271 5.96465 3.79167 7.32646 3.79167H9.33021C9.48368 3.79167 9.61229 3.8432 9.71604 3.94625C9.81993 4.04931 9.87188 4.17695 9.87188 4.32917C9.87188 4.48153 9.81993 4.61056 9.71604 4.71625C9.61229 4.82208 9.48368 4.875 9.33021 4.875H7.33021C6.26618 4.875 5.36181 5.24896 4.61708 5.99688C3.87236 6.74493 3.5 7.6584 3.5 8.73729ZM12.5729 12.5833H17.0358C17.189 12.5833 17.3185 12.6349 17.4244 12.7379C17.5303 12.841 17.5833 12.9686 17.5833 13.1208C17.5833 13.2732 17.5315 13.4022 17.4279 13.5079C17.3242 13.6138 17.1957 13.6667 17.0425 13.6667H12.5796C12.4264 13.6667 12.2968 13.6151 12.1908 13.5121C12.085 13.409 12.0321 13.2814 12.0321 13.1292C12.0321 12.9768 12.0839 12.8478 12.1875 12.7421C12.2911 12.6363 12.4196 12.5833 12.5729 12.5833ZM12.5729 8.1875H17.0358C17.189 8.1875 17.3185 8.23903 17.4244 8.34208C17.5303 8.44514 17.5833 8.57278 17.5833 8.725C17.5833 8.87736 17.5315 9.00639 17.4279 9.11208C17.3242 9.21792 17.1957 9.27083 17.0425 9.27083H12.5796C12.4264 9.27083 12.2968 9.21931 12.1908 9.11625C12.085 9.0132 12.0321 8.88556 12.0321 8.73334C12.0321 8.58097 12.0839 8.45195 12.1875 8.34625C12.2911 8.24042 12.4196 8.1875 12.5729 8.1875ZM12.5729 3.79167H17.0358C17.189 3.79167 17.3185 3.8432 17.4244 3.94625C17.5303 4.04931 17.5833 4.17695 17.5833 4.32917C17.5833 4.48153 17.5315 4.61056 17.4279 4.71625C17.3242 4.82208 17.1957 4.875 17.0425 4.875H12.5796C12.4264 4.875 12.2968 4.82347 12.1908 4.72042C12.085 4.61736 12.0321 4.48972 12.0321 4.3375C12.0321 4.18514 12.0839 4.05611 12.1875 3.95042C12.2911 3.84458 12.4196 3.79167 12.5729 3.79167Z",
        fill: "currentColor"
      }));
    }], [e.Refresh, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.032 15.5833C8.4817 15.5833 7.16356 15.0405 6.07763 13.9548C4.9917 12.8691 4.44873 11.5513 4.44873 10.0013C4.44873 8.45129 4.9917 7.13303 6.07763 6.0465C7.16356 4.95996 8.4817 4.41669 10.032 4.41669C10.9508 4.41669 11.793 4.62289 12.5585 5.03529C13.324 5.44768 13.9604 5.99309 14.4679 6.67152V4.95835C14.4679 4.80488 14.5194 4.67624 14.6225 4.57242C14.7255 4.4686 14.8532 4.41669 15.0055 4.41669C15.1578 4.41669 15.2868 4.4686 15.3926 4.57242C15.4983 4.67624 15.5512 4.80488 15.5512 4.95835V8.0096C15.5512 8.1994 15.487 8.35849 15.3586 8.48688C15.2303 8.61526 15.0712 8.67946 14.8814 8.67946H11.8301C11.6766 8.67946 11.548 8.62794 11.4442 8.52492C11.3404 8.42189 11.2885 8.29422 11.2885 8.14192C11.2885 7.98961 11.3404 7.86058 11.4442 7.75481C11.548 7.64905 11.6766 7.59617 11.8301 7.59617H13.8093C13.4118 6.95835 12.8827 6.44953 12.2219 6.06971C11.5611 5.6899 10.8312 5.5 10.032 5.5C8.78204 5.5 7.71954 5.9375 6.84454 6.8125C5.96954 7.6875 5.53204 8.75 5.53204 10C5.53204 11.25 5.96954 12.3125 6.84454 13.1875C7.71954 14.0625 8.78204 14.5 10.032 14.5C11.0978 14.5 12.0365 14.1693 12.8482 13.508C13.6599 12.8467 14.1827 12.0155 14.4166 11.0144C14.4402 10.8627 14.5147 10.7393 14.6402 10.6442C14.7657 10.5491 14.9014 10.5075 15.0472 10.5192C15.2027 10.531 15.3282 10.59 15.4238 10.6963C15.5195 10.8026 15.5625 10.9316 15.5528 11.0833C15.2868 12.3846 14.6431 13.4599 13.6217 14.3093C12.6003 15.1586 11.4038 15.5833 10.032 15.5833Z",
        fill: "currentColor"
      }));
    }], [e.Related, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.76611 6C3.76611 5.12858 4.32343 4.38733 5.10107 4.11323V2H6.43107V4.1132C7.20876 4.38728 7.76611 5.12855 7.76611 6C7.76611 6.87145 7.20876 7.61272 6.43107 7.8868V12.1132C7.20876 12.3873 7.76611 13.1286 7.76611 14C7.76611 14.8714 7.20876 15.6127 6.43107 15.8868V18H5.10107V15.8868C4.32343 15.6127 3.76611 14.8714 3.76611 14C3.76611 13.1286 4.32343 12.3873 5.10107 12.1132V7.88677C4.32343 7.61267 3.76611 6.87142 3.76611 6Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.59611 4.33V7.67H15.9361V4.33H9.59611ZM9.26611 3C8.71383 3 8.26611 3.44772 8.26611 4V8C8.26611 8.55228 8.71383 9 9.26611 9H16.2661C16.8184 9 17.2661 8.55228 17.2661 8V4C17.2661 3.44772 16.8184 3 16.2661 3H9.26611Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.59611 12.33V15.67H15.9361V12.33H9.59611ZM9.26611 11C8.71383 11 8.26611 11.4477 8.26611 12V16C8.26611 16.5523 8.71383 17 9.26611 17H16.2661C16.8184 17 17.2661 16.5523 17.2661 16V12C17.2661 11.4477 16.8184 11 16.2661 11H9.26611Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4311 5.33496C11.0638 5.33496 10.7661 5.63269 10.7661 5.99996C10.7661 6.36723 11.0638 6.66496 11.4311 6.66496H14.1011C14.4684 6.66496 14.7661 6.36723 14.7661 5.99996C14.7661 5.63269 14.4684 5.33496 14.1011 5.33496H11.4311Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4311 13.335C11.0638 13.335 10.7661 13.6327 10.7661 14C10.7661 14.3672 11.0638 14.665 11.4311 14.665H14.1011C14.4684 14.665 14.7661 14.3672 14.7661 14C14.7661 13.6327 14.4684 13.335 14.1011 13.335H11.4311Z",
        fill: "currentColor"
      }));
    }], [e.Reports, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.79791 7.17634C7.0336 7.17634 7.24142 7.08598 7.42138 6.90527C7.60209 6.7253 7.69245 6.51748 7.69245 6.2818C7.69245 6.04687 7.60209 5.83905 7.42138 5.65834C7.24142 5.47838 7.0336 5.38839 6.79791 5.38839C6.56299 5.38839 6.35516 5.47838 6.17445 5.65834C5.99449 5.83905 5.90451 6.04687 5.90451 6.2818C5.90451 6.51748 5.99449 6.7253 6.17445 6.90527C6.35516 7.08598 6.56299 7.17634 6.79791 7.17634ZM6.79791 10.8945C7.0336 10.8945 7.24142 10.8042 7.42138 10.6235C7.60209 10.4428 7.69245 10.2349 7.69245 10C7.69245 9.76507 7.60209 9.55725 7.42138 9.37654C7.24142 9.19582 7.0336 9.10546 6.79791 9.10546C6.56299 9.10546 6.35516 9.19582 6.17445 9.37654C5.99449 9.55725 5.90451 9.76507 5.90451 10C5.90451 10.2349 5.99449 10.4428 6.17445 10.6235C6.35516 10.8042 6.56299 10.8945 6.79791 10.8945ZM6.79791 14.6116C7.0336 14.6116 7.24142 14.5216 7.42138 14.3417C7.60209 14.1609 7.69245 13.9531 7.69245 13.7182C7.69245 13.4825 7.60209 13.2747 7.42138 13.0947C7.24142 12.914 7.0336 12.8237 6.79791 12.8237C6.56299 12.8237 6.35516 12.914 6.17445 13.0947C5.99449 13.2747 5.90451 13.4825 5.90451 13.7182C5.90451 13.9531 5.99449 14.1609 6.17445 14.3417C6.35516 14.5216 6.56299 14.6116 6.79791 14.6116ZM4.30406 18C3.80182 18 3.37827 17.8276 3.03341 17.4827C2.68854 17.1378 2.51611 16.7143 2.51611 16.2121V3.78794C2.51611 3.28571 2.68854 2.86216 3.03341 2.51729C3.37827 2.17243 3.80182 2 4.30406 2H14.0931L18.5161 6.42298V16.2121C18.5161 16.7143 18.3437 17.1378 17.9988 17.4827C17.654 17.8276 17.2304 18 16.7282 18H4.30406ZM4.30406 16.4944H16.7282C16.8065 16.4944 16.8731 16.4669 16.9281 16.412C16.9831 16.357 17.0105 16.2904 17.0105 16.2121V7.20006H14.2106C13.9749 7.20006 13.7671 7.1097 13.5871 6.92899C13.4064 6.74902 13.3161 6.5412 13.3161 6.30552V3.50558H4.30406C4.22575 3.50558 4.15911 3.53306 4.10414 3.58803C4.04917 3.64299 4.02169 3.70963 4.02169 3.78794V16.2121C4.02169 16.2904 4.04917 16.357 4.10414 16.412C4.15911 16.4669 4.22575 16.4944 4.30406 16.4944ZM4.02169 7.20006V16.4944V3.50558V7.20006Z",
        fill: "currentColor"
      }));
    }], [e.Reset, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.70993 16.3278C6.56036 16.3278 6.43269 16.2749 6.32693 16.1691C6.22117 16.0633 6.16828 15.9357 6.16828 15.7861C6.16828 15.6365 6.22117 15.5089 6.32693 15.4031C6.43269 15.2973 6.56036 15.2444 6.70993 15.2444H12.2324C12.9215 15.2444 13.4997 14.992 13.9672 14.4872C14.4346 13.9824 14.6683 13.3774 14.6683 12.6723C14.6683 11.9672 14.4346 11.3636 13.9672 10.8614C13.4997 10.3593 12.9215 10.1082 12.2324 10.1082H6.50637L8.1987 11.8214C8.31942 11.9421 8.37978 12.0711 8.37978 12.2084C8.37978 12.3457 8.31942 12.4747 8.1987 12.5954C8.07798 12.7161 7.95111 12.7752 7.8181 12.7725C7.6851 12.7698 7.5609 12.7108 7.44551 12.5954L4.88143 10.0313C4.81733 9.9672 4.76926 9.89536 4.7372 9.81576C4.70515 9.73617 4.68912 9.65311 4.68912 9.56657C4.68912 9.48003 4.70515 9.39696 4.7372 9.31736C4.76926 9.23778 4.81733 9.16593 4.88143 9.10182L7.42468 6.55857C7.54542 6.43785 7.67442 6.37749 7.8117 6.37749C7.94898 6.37749 8.07798 6.43785 8.1987 6.55857C8.31942 6.67929 8.38192 6.80616 8.3862 6.93917C8.39048 7.07217 8.33492 7.19637 8.21953 7.31176L6.50637 9.02493H12.2324C13.2153 9.02493 14.0475 9.38309 14.7292 10.0994C15.4108 10.8158 15.7516 11.6734 15.7516 12.6723C15.7516 13.6713 15.4108 14.5302 14.7292 15.2492C14.0475 15.9683 13.2153 16.3278 12.2324 16.3278H6.70993Z",
        fill: "currentColor"
      }));
    }], [e.Reset_View, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.54737 8.49368H4.43841C4.22355 8.49368 4.04431 8.4218 3.9007 8.27805C3.75695 8.1343 3.68507 7.95507 3.68507 7.74035V4.63139C3.68507 4.45403 3.74493 4.30555 3.86466 4.18597C3.98424 4.06625 4.13271 4.00639 4.31007 4.00639C4.48743 4.00639 4.63591 4.06625 4.75549 4.18597C4.87521 4.30555 4.93507 4.45403 4.93507 4.63139V6.75014C5.56007 5.79278 6.38139 5.02674 7.39903 4.45201C8.41667 3.87715 9.5398 3.58972 10.7684 3.58972C12.1541 3.58972 13.4006 3.94847 14.508 4.66597C15.6154 5.38333 16.4597 6.31576 17.0409 7.46326C17.1199 7.60951 17.1378 7.76437 17.0944 7.92785C17.0513 8.09132 16.9565 8.21257 16.8101 8.2916C16.6637 8.37076 16.5053 8.38868 16.3349 8.34535C16.1644 8.30215 16.0397 8.20736 15.9607 8.06097C15.4896 7.10153 14.7938 6.32479 13.8734 5.73076C12.953 5.13674 11.918 4.83972 10.7684 4.83972C9.81119 4.83972 8.93244 5.05771 8.13216 5.49368C7.33188 5.92951 6.68389 6.51285 6.1882 7.24368H7.54737C7.72459 7.24368 7.87306 7.30347 7.99278 7.42306C8.11237 7.54278 8.17216 7.69132 8.17216 7.86868C8.17216 8.04604 8.11237 8.19451 7.99278 8.3141C7.87306 8.43382 7.72459 8.49368 7.54737 8.49368Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.32564 11.1187C3.32564 10.7735 3.60546 10.4937 3.95064 10.4937H8.77627C9.12145 10.4937 9.40127 10.7735 9.40127 11.1187C9.40127 11.4638 9.12145 11.7437 8.77627 11.7437H3.95064C3.60546 11.7437 3.32564 11.4638 3.32564 11.1187Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4013 11.1187C11.4013 10.7735 11.6811 10.4937 12.0263 10.4937H16.8519C17.1971 10.4937 17.4769 10.7735 17.4769 11.1187C17.4769 11.4638 17.1971 11.7437 16.8519 11.7437H12.0263C11.6811 11.7437 11.4013 11.4638 11.4013 11.1187Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.32564 14.3687C3.32564 14.0235 3.60546 13.7437 3.95064 13.7437H8.77627C9.12145 13.7437 9.40127 14.0235 9.40127 14.3687C9.40127 14.7138 9.12145 14.9937 8.77627 14.9937H3.95064C3.60546 14.9937 3.32564 14.7138 3.32564 14.3687Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4013 14.3687C11.4013 14.0235 11.6811 13.7437 12.0263 13.7437H16.8519C17.1971 13.7437 17.4769 14.0235 17.4769 14.3687C17.4769 14.7138 17.1971 14.9937 16.8519 14.9937H12.0263C11.6811 14.9937 11.4013 14.7138 11.4013 14.3687Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.32564 17.6187C3.32564 17.2735 3.60546 16.9937 3.95064 16.9937H8.77627C9.12145 16.9937 9.40127 17.2735 9.40127 17.6187C9.40127 17.9638 9.12145 18.2437 8.77627 18.2437H3.95064C3.60546 18.2437 3.32564 17.9638 3.32564 17.6187Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4013 17.6187C11.4013 17.2735 11.6811 16.9937 12.0263 16.9937H16.8519C17.1971 16.9937 17.4769 17.2735 17.4769 17.6187C17.4769 17.9638 17.1971 18.2437 16.8519 18.2437H12.0263C11.6811 18.2437 11.4013 17.9638 11.4013 17.6187Z",
        fill: "currentColor"
      }));
    }], [e.Search, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M17.2439 17.7637L11.8943 12.4379C11.374 12.8484 10.8101 13.1521 10.2027 13.349C9.59534 13.546 8.98377 13.6444 8.36804 13.6444C6.74274 13.6444 5.36208 13.0844 4.22603 11.9642C3.08999 10.8441 2.52197 9.47136 2.52197 7.84607C2.52197 6.23668 3.08999 4.86017 4.22603 3.71656C5.36208 2.57219 6.74274 2 8.36804 2C9.97743 2 11.3422 2.56802 12.4623 3.70406C13.5825 4.8401 14.1425 6.22077 14.1425 7.84607C14.1425 8.49285 14.0479 9.12033 13.8585 9.72849C13.6692 10.3359 13.3696 10.8838 12.9599 11.3723L18.3084 16.7458C18.4508 16.8874 18.5178 17.0571 18.5095 17.2548C18.5019 17.4517 18.4269 17.6213 18.2845 17.7637C18.127 17.9212 17.9498 18 17.7529 18C17.5552 18 17.3856 17.9212 17.2439 17.7637ZM8.36804 12.1301C9.55179 12.1301 10.5576 11.712 11.3854 10.8759C12.2139 10.0398 12.6282 9.02982 12.6282 7.84607C12.6282 6.64716 12.2181 5.62549 11.3979 4.78103C10.5769 3.93733 9.56694 3.51548 8.36804 3.51548C7.15323 3.51548 6.12777 3.93733 5.29164 4.78103C4.45551 5.62549 4.03745 6.64716 4.03745 7.84607C4.03745 9.04573 4.45551 10.0595 5.29164 10.8872C6.12777 11.7158 7.15323 12.1301 8.36804 12.1301Z",
        fill: "currentColor"
      }));
    }], [e.Settings, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M11.7875 18H9.19763C9.0016 18 8.82981 17.9333 8.68228 17.7999C8.53475 17.6665 8.44718 17.4944 8.41956 17.2836L8.18715 15.4738C8.00526 15.3896 7.79474 15.2771 7.55559 15.1363C7.31712 14.9962 7.1066 14.8631 6.92404 14.7371L5.26078 15.4738C5.06475 15.558 4.87208 15.5651 4.68279 15.495C4.49282 15.4243 4.34192 15.2976 4.23009 15.1151L2.94577 12.8627C2.84741 12.6801 2.82282 12.4942 2.872 12.3049C2.92118 12.1156 3.01583 11.9576 3.15595 11.831L4.5878 10.7366C4.57366 10.6241 4.56321 10.5015 4.55648 10.3688C4.54907 10.2354 4.54536 10.1125 4.54536 10C4.54536 9.90165 4.54907 9.78578 4.55648 9.65239C4.56321 9.51901 4.57366 9.38933 4.5878 9.26336L3.15595 8.169C3.01583 8.04236 2.92118 7.88438 2.872 7.69509C2.82282 7.50579 2.84741 7.31986 2.94577 7.1373L4.23009 4.90514C4.34192 4.73673 4.49282 4.61412 4.68279 4.53732C4.87208 4.45985 5.05801 4.46322 5.24057 4.54743L6.92404 5.26285C7.1066 5.13688 7.31375 5.0072 7.54549 4.87382C7.77723 4.74043 7.99111 4.62456 8.18715 4.52621L8.41956 2.71643C8.44718 2.50558 8.53475 2.33346 8.68228 2.20008C8.82981 2.06669 9.0016 2 9.19763 2H11.7875C11.9977 2 12.1765 2.06669 12.3241 2.20008C12.4716 2.33346 12.5592 2.50558 12.5868 2.71643L12.8192 4.52621C13.0294 4.63871 13.2399 4.75458 13.4508 4.87382C13.6609 4.99305 13.8644 5.12273 14.0611 5.26285L15.7658 4.54743C15.9483 4.46322 16.1343 4.45615 16.3236 4.52621C16.5135 4.59694 16.6644 4.72325 16.7763 4.90514L18.0818 7.1373C18.1802 7.31986 18.2081 7.50579 18.1657 7.69509C18.1239 7.88438 18.0259 8.04236 17.8716 8.169L16.4185 9.28458C16.4327 9.41055 16.4398 9.53316 16.4398 9.65239V10C16.4398 10.0984 16.4364 10.2105 16.4297 10.3365C16.4223 10.4631 16.4185 10.5965 16.4185 10.7366L17.8504 11.831C18.0188 11.9576 18.1239 12.1156 18.1657 12.3049C18.2081 12.4942 18.1731 12.6801 18.0606 12.8627L16.756 15.1151C16.6577 15.2976 16.5135 15.4206 16.3236 15.4839C16.1343 15.5472 15.9416 15.5368 15.7456 15.4526L14.0611 14.7371C13.8644 14.8773 13.6572 15.0103 13.4396 15.1363C13.222 15.2629 13.0152 15.3754 12.8192 15.4738L12.5868 17.2836C12.5592 17.4944 12.4716 17.6665 12.3241 17.7999C12.1765 17.9333 11.9977 18 11.7875 18ZM10.4607 12.5889C11.1768 12.5889 11.7875 12.3362 12.2927 11.831C12.798 11.3258 13.0506 10.7154 13.0506 10C13.0506 9.28458 12.798 8.67424 12.2927 8.169C11.7875 7.66376 11.1768 7.41114 10.4607 7.41114C9.75946 7.41114 9.15249 7.66376 8.63984 8.169C8.12786 8.67424 7.87187 9.28458 7.87187 10C7.87187 10.7154 8.12786 11.3258 8.63984 11.831C9.15249 12.3362 9.75946 12.5889 10.4607 12.5889ZM10.4607 11.2419C10.1239 11.2419 9.83289 11.1193 9.58768 10.8741C9.34179 10.6282 9.21885 10.3368 9.21885 10C9.21885 9.66317 9.34179 9.37182 9.58768 9.12593C9.83289 8.88072 10.1239 8.75811 10.4607 8.75811C10.7976 8.75811 11.0889 8.88072 11.3348 9.12593C11.5807 9.37182 11.7036 9.66317 11.7036 10C11.7036 10.3368 11.5807 10.6282 11.3348 10.8741C11.0889 11.1193 10.7976 11.2419 10.4607 11.2419ZM9.66144 16.652H11.3449L11.5975 14.4421C12.0051 14.3296 12.3877 14.1645 12.7454 13.9469C13.1031 13.7294 13.4504 13.4592 13.7872 13.1365L15.8294 14.0207L16.6924 12.6313L14.8816 11.2631C14.9523 11.0388 14.9981 10.8249 15.019 10.6214C15.0399 10.4173 15.0504 10.2102 15.0504 10C15.0504 9.80329 15.0399 9.61029 15.019 9.42099C14.9981 9.2317 14.9594 9.01781 14.9028 8.77934L16.7136 7.3687L15.8709 5.97928L13.7872 6.86346C13.4922 6.5684 13.1483 6.30533 12.7555 6.07427C12.3628 5.84253 11.9839 5.67749 11.6187 5.57913L11.3449 3.34799H9.66144L9.3876 5.57913C8.99419 5.67749 8.61525 5.83175 8.25081 6.04193C7.88568 6.25279 7.53471 6.51956 7.19788 6.84224L5.15569 5.97928L4.31396 7.3687L6.08231 8.73689C6.02639 8.96122 5.98429 9.17881 5.956 9.38967C5.9277 9.59985 5.91356 9.80329 5.91356 10C5.91356 10.1967 5.9277 10.3968 5.956 10.6002C5.98429 10.8037 6.02639 11.0176 6.08231 11.2419L4.31396 12.6313L5.15569 14.0207L7.19788 13.1578C7.52056 13.4663 7.86446 13.726 8.22959 13.9368C8.59471 14.147 8.98071 14.3084 9.3876 14.4209L9.66144 16.652Z",
        fill: "currentColor"
      }));
    }], [e.Snooze, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.20605 12.6257H11.9186C12.0544 12.6257 12.1699 12.5781 12.2652 12.4828C12.3605 12.3882 12.4081 12.2658 12.4081 12.1157C12.4081 11.9799 12.3637 11.8644 12.275 11.7692C12.1869 11.6739 12.0681 11.6262 11.9186 11.6262H10.0626L12.2241 9.15935C12.2919 9.09083 12.3396 9.01251 12.367 8.92441C12.3944 8.83566 12.4081 8.74396 12.4081 8.64933C12.4081 8.47248 12.3468 8.31944 12.2241 8.19022C12.1014 8.061 11.9451 7.99639 11.7552 7.99639H9.08368C8.94729 7.99639 8.83178 8.04404 8.73715 8.13932C8.64187 8.2346 8.59422 8.35696 8.59422 8.50641C8.59422 8.64216 8.63828 8.75767 8.72638 8.85295C8.81448 8.94823 8.92673 8.99587 9.06313 8.99587H11.0004L8.77728 11.5244C8.70941 11.5792 8.66177 11.6507 8.63436 11.7388C8.6076 11.8269 8.59422 11.9186 8.59422 12.0139C8.59422 12.1907 8.65198 12.3369 8.76749 12.4524C8.88301 12.5679 9.02919 12.6257 9.20605 12.6257ZM10.5109 17.4596C9.54573 17.4596 8.64513 17.2759 7.80913 16.9085C6.97248 16.5417 6.23829 16.0421 5.60656 15.4098C4.97418 14.7774 4.47428 14.0432 4.10686 13.2072C3.74009 12.3712 3.5567 11.4771 3.5567 10.5249C3.5567 9.55973 3.74009 8.65912 4.10686 7.82313C4.47428 6.98713 4.97418 6.25294 5.60656 5.62056C6.23829 4.98817 6.97248 4.49186 7.80913 4.13162C8.64513 3.77138 9.54573 3.59126 10.5109 3.59126C11.4625 3.59126 12.3598 3.77138 13.203 4.13162C14.0462 4.49186 14.7803 4.98817 15.4055 5.62056C16.0308 6.25294 16.5235 6.98713 16.8837 7.82313C17.244 8.65912 17.4241 9.55288 17.4241 10.5044C17.4241 11.4703 17.244 12.3712 16.8837 13.2072C16.5235 14.0432 16.0308 14.7774 15.4055 15.4098C14.7803 16.0421 14.0462 16.5417 13.203 16.9085C12.3598 17.2759 11.4625 17.4596 10.5109 17.4596ZM3.6174 5.93675C3.49536 6.05879 3.34591 6.11981 3.16905 6.11981C2.99219 6.11981 2.84275 6.05879 2.72071 5.93675C2.58431 5.81406 2.51611 5.66787 2.51611 5.49819C2.51611 5.32851 2.58431 5.16862 2.72071 5.01852L4.98397 2.75526C5.11971 2.61952 5.27601 2.55164 5.45287 2.55164C5.62973 2.55164 5.78603 2.61952 5.92177 2.75526C6.04447 2.8773 6.10255 3.02348 6.09602 3.19382C6.08884 3.36349 6.02423 3.52306 5.9022 3.67251L3.6174 5.93675ZM17.3839 5.93675L15.1001 3.67251C14.9774 3.53676 14.9128 3.38405 14.9063 3.21437C14.8991 3.04404 14.9637 2.891 15.1001 2.75526C15.2359 2.61952 15.3954 2.54805 15.5788 2.54088C15.7622 2.53435 15.9152 2.60581 16.0379 2.75526L18.3217 5.01852C18.4444 5.12751 18.509 5.27043 18.5156 5.44729C18.5228 5.62415 18.4581 5.78045 18.3217 5.91619C18.186 6.05193 18.0264 6.12666 17.8431 6.14036C17.659 6.15407 17.506 6.0862 17.3839 5.93675ZM10.4904 16.1537C12.0541 16.1537 13.3831 15.6065 14.4775 14.5121C15.572 13.4177 16.1192 12.0886 16.1192 10.5249C16.1192 8.94823 15.5752 7.61592 14.4873 6.52802C13.4001 5.44011 12.0746 4.89616 10.5109 4.89616C8.93358 4.89616 7.59769 5.44011 6.50325 6.52802C5.40882 7.61592 4.8616 8.94823 4.8616 10.5249C4.8616 12.0886 5.40882 13.4177 6.50325 14.5121C7.59769 15.6065 8.92673 16.1537 10.4904 16.1537Z",
        fill: "currentColor"
      }));
    }], [e.Sort_A_to_Z, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.1837 13.7956C10.3135 13.6658 10.4715 13.601 10.6578 13.601C10.8448 13.601 11.0104 13.6658 11.1546 13.7956L13.0519 15.6928L13.0519 3.16445C13.0519 2.97744 13.1202 2.81563 13.2568 2.679C13.3935 2.54237 13.5553 2.47406 13.7423 2.47406C13.9286 2.47406 14.0901 2.54237 14.2267 2.679C14.3633 2.81563 14.4316 2.97744 14.4316 3.16445L14.4316 15.6928L16.3506 13.7738C16.4949 13.6441 16.6532 13.5792 16.8257 13.5792C16.9982 13.5792 17.1563 13.6514 17.2998 13.7956C17.444 13.9391 17.5161 14.1006 17.5161 14.28C17.5161 14.4601 17.444 14.6219 17.2998 14.7654L14.324 17.7412C14.2377 17.8275 14.1442 17.8924 14.0435 17.9358C13.9434 17.9786 13.843 18 13.7423 18C13.6415 18 13.5408 17.9786 13.44 17.9358C13.3393 17.8924 13.2458 17.8275 13.1595 17.7412L10.162 14.7437C10.033 14.6147 9.96464 14.4639 9.95705 14.2914C9.95015 14.1189 10.0257 13.9536 10.1837 13.7956ZM3.36991 5.25631L6.34572 2.25877C6.43197 2.17251 6.52547 2.10765 6.62622 2.06417C6.72628 2.02139 6.82668 2 6.92742 2C7.02817 2 7.12891 2.02139 7.22966 2.06417C7.33041 2.10765 7.42391 2.17251 7.51016 2.25877L10.5077 5.25631C10.6512 5.39984 10.7195 5.56131 10.7126 5.74072C10.7051 5.92082 10.6295 6.07539 10.486 6.20443C10.3424 6.34864 10.1772 6.42075 9.99017 6.42075C9.80317 6.42075 9.63791 6.34864 9.49438 6.20442L7.61781 4.32889L7.61781 16.8356C7.61781 17.0226 7.54949 17.1844 7.41287 17.321C7.27624 17.4576 7.11442 17.5259 6.92742 17.5259C6.74111 17.5259 6.57964 17.4576 6.44301 17.321C6.30638 17.1844 6.23807 17.0226 6.23807 16.8356L6.23807 4.32889L4.31906 6.22616C4.17485 6.3414 4.01648 6.40247 3.84397 6.40937C3.67146 6.41696 3.51344 6.35589 3.36991 6.22616C3.24018 6.08263 3.17532 5.91737 3.17532 5.73037C3.17532 5.54336 3.24018 5.38534 3.36991 5.25631Z",
        fill: "currentColor"
      }));
    }], [e.Sort_Z_to_A, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.8485 13.7956C10.7188 13.6658 10.5607 13.601 10.3744 13.601C10.1874 13.601 10.0218 13.6658 9.87761 13.7956L7.98034 15.6928L7.98034 3.16445C7.98034 2.97744 7.91202 2.81563 7.7754 2.679C7.63877 2.54237 7.47695 2.47406 7.28995 2.47406C7.10364 2.47406 6.94217 2.54237 6.80554 2.679C6.66891 2.81563 6.6006 2.97744 6.6006 3.16445L6.6006 15.6928L4.68159 13.7738C4.53738 13.6441 4.37901 13.5792 4.2065 13.5792C4.03399 13.5792 3.87597 13.6514 3.73244 13.7956C3.58822 13.9391 3.51611 14.1006 3.51611 14.28C3.51611 14.4601 3.58822 14.6219 3.73244 14.7654L6.70825 17.7412C6.7945 17.8275 6.888 17.8924 6.98875 17.9358C7.08881 17.9786 7.18921 18 7.28995 18C7.3907 18 7.49144 17.9786 7.59219 17.9358C7.69294 17.8924 7.78644 17.8275 7.87269 17.7412L10.8702 14.7437C10.9993 14.6147 11.0676 14.4639 11.0752 14.2914C11.0821 14.1189 11.0065 13.9536 10.8485 13.7956ZM17.6623 5.25631L14.6865 2.25877C14.6003 2.17251 14.5068 2.10765 14.406 2.06417C14.306 2.02139 14.2056 2 14.1048 2C14.0041 2 13.9033 2.02139 13.8026 2.06417C13.7018 2.10765 13.6083 2.17251 13.5221 2.25877L10.5245 5.25631C10.381 5.39984 10.3127 5.56131 10.3196 5.74072C10.3272 5.92082 10.4027 6.07539 10.5463 6.20443C10.6898 6.34864 10.8551 6.42075 11.0421 6.42075C11.2291 6.42075 11.3943 6.34864 11.5378 6.20442L13.4144 4.32889L13.4144 16.8356C13.4144 17.0226 13.4827 17.1844 13.6194 17.321C13.756 17.4576 13.9178 17.5259 14.1048 17.5259C14.2911 17.5259 14.4526 17.4576 14.5892 17.321C14.7258 17.1844 14.7942 17.0226 14.7942 16.8356L14.7942 4.32889L16.7132 6.22616C16.8574 6.3414 17.0157 6.40247 17.1883 6.40937C17.3608 6.41696 17.5188 6.35589 17.6623 6.22616C17.792 6.08263 17.8569 5.91737 17.8569 5.73037C17.8569 5.54336 17.792 5.38534 17.6623 5.25631Z",
        fill: "currentColor"
      }));
    }], [e.Source, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M12.766 15.8953C12.6123 15.8953 12.4836 15.8439 12.38 15.7409C12.2762 15.6382 12.2244 15.5105 12.2244 15.358C12.2244 15.2055 12.2762 15.0764 12.38 14.9707C12.4836 14.8649 12.6123 14.812 12.766 14.812H13.5335C13.7995 14.812 14.0271 14.7214 14.2162 14.5403C14.4054 14.3591 14.5 14.1355 14.5 13.8697V12.3216C14.5 11.7842 14.6856 11.3293 15.0569 10.957C15.4281 10.5846 15.8851 10.3771 16.4279 10.3345V10.3312C15.8851 10.2468 15.4281 10.022 15.0569 9.65657C14.6856 9.29115 14.5 8.83976 14.5 8.3024V6.75428C14.5 6.48844 14.4054 6.2649 14.2162 6.08365C14.0271 5.90254 13.7995 5.81199 13.5335 5.81199H12.766C12.6123 5.81199 12.4836 5.7606 12.38 5.65782C12.2762 5.5549 12.2244 5.4272 12.2244 5.2747C12.2244 5.1222 12.2762 4.9931 12.38 4.8874C12.4836 4.78157 12.6123 4.72865 12.766 4.72865H13.5335C14.0998 4.72865 14.583 4.92601 14.9831 5.32074C15.3833 5.7156 15.5833 6.19344 15.5833 6.75428V8.3024C15.5833 8.59726 15.7081 8.83074 15.9575 9.00282C16.2069 9.17476 16.4992 9.26074 16.8342 9.26074C17.0408 9.26074 17.2174 9.3422 17.3637 9.50511C17.5101 9.66803 17.5833 9.85365 17.5833 10.062V10.562C17.5833 10.7703 17.5115 10.9559 17.3679 11.1189C17.2243 11.2818 17.0429 11.3632 16.8237 11.3632C16.4957 11.3632 16.2069 11.4492 15.9575 11.6212C15.7081 11.7932 15.5833 12.0267 15.5833 12.3216V13.8697C15.5833 14.4305 15.3833 14.9084 14.9831 15.3032C14.583 15.698 14.0998 15.8953 13.5335 15.8953H12.766ZM6.46646 15.8953C5.90021 15.8953 5.41701 15.698 5.01687 15.3032C4.61673 14.9084 4.41666 14.4305 4.41666 13.8697V12.3216C4.41666 12.0267 4.29194 11.7932 4.0425 11.6212C3.79305 11.4492 3.50083 11.3632 3.16583 11.3632C2.96444 11.3632 2.78923 11.2901 2.64021 11.1439C2.49118 10.9976 2.41666 10.8175 2.41666 10.6037V10.0203C2.41666 9.80643 2.48979 9.62636 2.63604 9.48011C2.78229 9.33386 2.96236 9.26074 3.17625 9.26074C3.5043 9.26074 3.79305 9.17476 4.0425 9.00282C4.29194 8.83074 4.41666 8.59726 4.41666 8.3024V6.75428C4.41666 6.19344 4.61673 5.7156 5.01687 5.32074C5.41701 4.92601 5.90021 4.72865 6.46646 4.72865H7.24208C7.39569 4.72865 7.52437 4.78011 7.62812 4.88303C7.73173 4.98581 7.78354 5.11344 7.78354 5.26594C7.78354 5.41844 7.73173 5.54754 7.62812 5.65324C7.52437 5.75907 7.39569 5.81199 7.24208 5.81199H6.46646C6.20048 5.81199 5.97291 5.90254 5.78375 6.08365C5.59458 6.2649 5.5 6.48844 5.5 6.75428V8.3024C5.5 8.85365 5.31437 9.31546 4.94312 9.68782C4.57187 10.0602 4.11486 10.2677 3.57208 10.3103V10.3166C4.12875 10.3434 4.58923 10.5464 4.95354 10.9257C5.31784 11.305 5.5 11.7703 5.5 12.3216V13.8697C5.5 14.1355 5.59458 14.3591 5.78375 14.5403C5.97291 14.7214 6.20048 14.812 6.46646 14.812H7.24208C7.39569 14.812 7.52437 14.8634 7.62812 14.9662C7.73173 15.0691 7.78354 15.1968 7.78354 15.3493C7.78354 15.5018 7.73173 15.6309 7.62812 15.7366C7.52437 15.8424 7.39569 15.8953 7.24208 15.8953H6.46646Z",
        fill: "currentColor"
      }));
    }], [e.Square, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M4.13604 18C3.68073 18 3.29671 17.844 2.98399 17.5321C2.67207 17.2194 2.51611 16.8354 2.51611 16.3801V3.61993C2.51611 3.16462 2.67207 2.7806 2.98399 2.46787C3.29671 2.15596 3.68073 2 4.13604 2H16.8962C17.3515 2 17.7355 2.15596 18.0482 2.46787C18.3602 2.7806 18.5161 3.16462 18.5161 3.61993V16.3801C18.5161 16.8354 18.3602 17.2194 18.0482 17.5321C17.7355 17.844 17.3515 18 16.8962 18H4.13604ZM4.13604 16.6839H16.8962C16.9634 16.6839 17.0311 16.6503 17.0991 16.583C17.1664 16.515 17.2 16.4473 17.2 16.3801V3.61993C17.2 3.55269 17.1664 3.48504 17.0991 3.41698C17.0311 3.34974 16.9634 3.31612 16.8962 3.31612H4.13604C4.0688 3.31612 4.00115 3.34974 3.9331 3.41698C3.86585 3.48504 3.83223 3.55269 3.83223 3.61993V16.3801C3.83223 16.4473 3.86585 16.515 3.9331 16.583C4.00115 16.6503 4.0688 16.6839 4.13604 16.6839Z",
        fill: "currentColor"
      }));
    }], [e.Square_Filled, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M2.46796 17.9416C2.78069 18.2535 3.16471 18.4094 3.62002 18.4094H16.3802C16.8355 18.4094 17.2195 18.2535 17.5322 17.9416C17.8441 17.6288 18.0001 17.2448 18.0001 16.7895V4.02937C18.0001 3.57406 17.8441 3.19004 17.5322 2.87732C17.2195 2.5654 16.8355 2.40944 16.3802 2.40944H3.62002C3.16471 2.40944 2.78069 2.5654 2.46796 2.87732C2.15605 3.19004 2.00009 3.57406 2.00009 4.02937V16.7895C2.00009 17.2448 2.15605 17.6288 2.46796 17.9416Z",
        fill: "currentColor"
      }));
    }], [e.Star, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M7.05904 15.4101L10.518 13.3557L14.0041 15.4101L13.0846 11.5193L16.0844 8.95268L12.1119 8.60121L10.518 4.89977L8.92403 8.60121L4.95154 8.95268L7.97857 11.5193L7.05904 15.4101ZM10.518 15.0041L6.35741 17.4631C6.21301 17.5349 6.07338 17.5664 5.9385 17.5578C5.80275 17.5492 5.68127 17.5085 5.57406 17.4359C5.46512 17.3641 5.38384 17.2517 5.33024 17.0987C5.27663 16.9456 5.27663 16.7969 5.33024 16.6525L6.41058 12.0588L2.76362 8.95268C2.63738 8.8446 2.56086 8.71836 2.53406 8.57397C2.50639 8.42958 2.51072 8.29427 2.54703 8.16803C2.58334 8.04266 2.65986 7.93459 2.77659 7.8438C2.89417 7.75388 3.02473 7.70892 3.16826 7.70892L7.95133 7.27704L9.86949 2.87267C9.94125 2.72828 10.0312 2.6202 10.1393 2.54844C10.2473 2.47668 10.3736 2.4408 10.518 2.4408C10.6623 2.4408 10.7886 2.47668 10.8967 2.54844C11.0047 2.6202 11.0947 2.72828 11.1664 2.87267L13.0846 7.30428L17.8676 7.70892C18.0112 7.70892 18.1417 7.75864 18.2593 7.85807C18.376 7.9575 18.4526 8.0699 18.4889 8.19527C18.5252 8.3215 18.5252 8.45206 18.4889 8.58694C18.4526 8.72269 18.3713 8.8446 18.2451 8.95268L14.6253 12.0588L15.7057 16.6525C15.7593 16.7969 15.7593 16.9456 15.7057 17.0987C15.6521 17.2517 15.5708 17.3641 15.4618 17.4359C15.3546 17.5085 15.2332 17.5492 15.0974 17.5578C14.9625 17.5664 14.8229 17.5349 14.6785 17.4631L10.518 15.0041Z",
        fill: "currentColor"
      }));
    }], [e.Stop_Circle, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 18C9.40728 18 8.36513 17.7895 7.38968 17.3684C6.41422 16.9474 5.56878 16.3788 4.85336 15.6628C4.13727 14.9473 3.5687 14.1019 3.14767 13.1264C2.72663 12.151 2.51611 11.1088 2.51611 10C2.51611 8.89116 2.72663 7.84902 3.14767 6.87356C3.5687 5.89811 4.13727 5.05267 4.85336 4.33725C5.56878 3.62115 6.41422 3.05259 7.38968 2.63155C8.36513 2.21052 9.40728 2 10.5161 2C11.625 2 12.6671 2.21052 13.6425 2.63155C14.618 3.05259 15.4634 3.62115 16.1789 4.33725C16.895 5.05267 17.4635 5.89811 17.8846 6.87356C18.3056 7.84902 18.5161 8.89116 18.5161 10C18.5161 11.1088 18.3056 12.151 17.8846 13.1264C17.4635 14.1019 16.895 14.9473 16.1789 15.6628C15.4634 16.3788 14.618 16.9474 13.6425 17.3684C12.6671 17.7895 11.625 18 10.5161 18ZM10.5161 16.652C12.3545 16.652 13.9228 16.0029 15.2209 14.7048C16.5191 13.4067 17.1681 11.8384 17.1681 10C17.1681 8.16159 16.5191 6.59332 15.2209 5.29519C13.9228 3.99705 12.3545 3.34799 10.5161 3.34799C8.67771 3.34799 7.10944 3.99705 5.8113 5.29519C4.51317 6.59332 3.8641 8.16159 3.8641 10C3.8641 11.8384 4.51317 13.4067 5.8113 14.7048C7.10944 16.0029 8.67771 16.652 10.5161 16.652ZM8.07377 13.2416H12.9585C13.1686 13.2416 13.3546 13.1611 13.5162 13.0001C13.6772 12.8384 13.7577 12.6525 13.7577 12.4423V7.55766C13.7577 7.34748 13.6772 7.16155 13.5162 6.99987C13.3546 6.83887 13.1686 6.75837 12.9585 6.75837H8.07377C7.86359 6.75837 7.67766 6.83887 7.51599 6.99987C7.35498 7.16155 7.27448 7.34748 7.27448 7.55766V12.4423C7.27448 12.6525 7.35498 12.8384 7.51599 13.0001C7.67766 13.1611 7.86359 13.2416 8.07377 13.2416Z",
        fill: "currentColor"
      }));
    }], [e.Surgery, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6471 2.59445C13.0061 2.59445 13.2971 2.88546 13.2971 3.24445V3.72508L13.7342 3.94365C13.8103 3.92684 13.8894 3.91798 13.9706 3.91798H16.1765C16.7791 3.91798 17.2677 4.40651 17.2677 5.00915V10.4233C17.7995 10.7768 18.15 11.3815 18.15 12.068C18.15 13.0874 17.3771 13.9263 16.3853 14.0306V14.9474H17.5C17.859 14.9474 18.15 15.2384 18.15 15.5974C18.15 15.9564 17.859 16.2474 17.5 16.2474H17.0228C17.1783 16.5092 17.2677 16.8149 17.2677 17.1415C17.2677 18.1096 16.4828 18.8944 15.5147 18.8944C14.5466 18.8944 13.7618 18.1096 13.7618 17.1415C13.7618 16.8149 13.8511 16.5092 14.0066 16.2474H5.99338C6.14892 16.5092 6.23824 16.8149 6.23824 17.1415C6.23824 18.1096 5.45342 18.8944 4.4853 18.8944C3.51718 18.8944 2.73236 18.1096 2.73236 17.1415C2.73236 16.8149 2.82168 16.5092 2.97722 16.2474H2.50001C2.14102 16.2474 1.85001 15.9564 1.85001 15.5974C1.85001 15.2384 2.14102 14.9474 2.50001 14.9474H3.17354V10.5219L2.86922 10.2176C2.0985 9.44687 2.0985 8.1973 2.86922 7.42658C3.33262 6.96318 3.96914 6.77841 4.5706 6.87226L5.07066 6.3722C5.60017 5.84269 6.45867 5.84269 6.98817 6.3722L8.48557 7.8696C9.01508 8.3991 9.01508 9.2576 8.48557 9.78711L8.25315 10.0195L8.32807 10.0944H15.9677V5.21798H14.1794V5.32975H14.2353C14.6917 5.32975 15.0618 5.69977 15.0618 6.15622V8.45033C15.0618 8.90678 14.6917 9.2768 14.2353 9.2768H12.8235C12.3671 9.2768 11.9971 8.90678 11.9971 8.45033V6.15622C11.9971 5.69977 12.3671 5.32975 12.8235 5.32975H12.8794V5.00915C12.8794 4.99606 12.8796 4.98302 12.8801 4.97004L12.6003 4.83011C12.2306 4.64528 11.9971 4.26744 11.9971 3.85414V3.24445C11.9971 2.88546 12.2881 2.59445 12.6471 2.59445ZM13.2971 6.62975V7.9768H13.7618V6.62975H13.2971ZM7.33391 9.10029L7.56634 8.86787C7.58816 8.84604 7.58816 8.81066 7.56634 8.78884L6.06893 7.29143C6.04711 7.26961 6.01173 7.26961 5.9899 7.29143L5.75748 7.52386L7.33391 9.10029ZM8.49217 10.2585C8.49202 10.2584 8.49232 10.2587 8.49217 10.2585V10.2585ZM4.47354 11.8219V14.9474H15.0853V14.0415H7.35295C7.19828 14.0415 7.04688 14.0236 6.90106 13.9894C6.62239 13.9241 6.41741 13.7658 6.28201 13.6304L4.47354 11.8219ZM16.1765 12.7415C16.5485 12.7415 16.85 12.44 16.85 12.068C16.85 11.696 16.5485 11.3944 16.1765 11.3944H8.09538C7.89958 11.3944 7.71181 11.3167 7.57337 11.1782C7.57337 11.1782 7.57337 11.1782 7.57337 11.1782L4.74097 8.34582C4.47794 8.08279 4.05148 8.08279 3.78845 8.34582C3.52543 8.60885 3.52543 9.03531 3.78845 9.29834L7.20125 12.7111C7.20901 12.7189 7.21539 12.7246 7.22028 12.7286C7.26265 12.737 7.30695 12.7415 7.35295 12.7415H16.1765ZM4.4853 16.6886C4.23515 16.6886 4.03236 16.8914 4.03236 17.1415C4.03236 17.3917 4.23515 17.5944 4.4853 17.5944C4.73545 17.5944 4.93824 17.3917 4.93824 17.1415C4.93824 16.8914 4.73545 16.6886 4.4853 16.6886ZM15.5147 16.6886C15.2646 16.6886 15.0618 16.8914 15.0618 17.1415C15.0618 17.3917 15.2646 17.5944 15.5147 17.5944C15.7649 17.5944 15.9677 17.3917 15.9677 17.1415C15.9677 16.8914 15.7649 16.6886 15.5147 16.6886Z",
        fill: "currentColor"
      }));
    }], [e.Table, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M17.0105 17.4352H4.02169C3.61358 17.4352 3.26043 17.2865 2.96225 16.9891C2.66483 16.6909 2.51611 16.3378 2.51611 15.9297V4.07027C2.51611 3.6471 2.66483 3.29019 2.96225 2.99954C3.26043 2.70965 3.61358 2.5647 4.02169 2.5647H17.0105C17.4186 2.5647 17.7718 2.70965 18.07 2.99954C18.3674 3.29019 18.5161 3.6471 18.5161 4.07027V15.9297C18.5161 16.3378 18.3674 16.6909 18.07 16.9891C17.7718 17.2865 17.4186 17.4352 17.0105 17.4352ZM3.73932 6.56413H17.2929V4.07027C17.2929 4.00778 17.2617 3.9449 17.1992 3.88165C17.1359 3.81916 17.073 3.78791 17.0105 3.78791H4.02169C3.95919 3.78791 3.89632 3.81916 3.83307 3.88165C3.77057 3.9449 3.73932 4.00778 3.73932 4.07027V6.56413ZM6.37437 7.78847H3.73932V15.9297C3.73932 15.9922 3.77057 16.055 3.83307 16.1183C3.89632 16.1808 3.95919 16.212 4.02169 16.212H6.37437V7.78847ZM14.6579 7.78847V16.212H17.0105C17.073 16.212 17.1359 16.1808 17.1992 16.1183C17.2617 16.055 17.2929 15.9922 17.2929 15.9297V7.78847H14.6579ZM13.4335 7.78847H7.59871V16.212H13.4335V7.78847Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_ADT, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Registration Events"), /*#__PURE__*/React.createElement("path", {
        d: "M12.0983 15.423H5.82017C5.51413 15.423 5.25534 15.3162 5.04381 15.1026C4.83227 14.8889 4.7265 14.6293 4.7265 14.3237V13.9871C4.7265 13.7318 4.80263 13.4719 4.95488 13.2075C5.10711 12.9431 5.31998 12.7243 5.59348 12.5512C6.31998 12.1335 7.08361 11.8133 7.88436 11.5905C8.68512 11.3678 9.4925 11.2564 10.3065 11.2564C10.6207 11.2564 10.9199 11.2728 11.2041 11.3057C11.4882 11.3385 11.7863 11.3858 12.0983 11.4476V12.5496C11.7863 12.4727 11.4917 12.4185 11.2145 12.3869C10.9372 12.3554 10.6375 12.3397 10.3153 12.3397C9.56578 12.3397 8.83876 12.4342 8.13423 12.6233C7.4297 12.8124 6.77402 13.0907 6.16719 13.4583C6.05501 13.5352 5.9674 13.6212 5.90438 13.7163C5.84133 13.8114 5.80981 13.9016 5.80981 13.9871V14.3397H12.0983V15.423ZM10.3098 9.74351C9.59108 9.74351 8.98084 9.49265 8.47911 8.99093C7.97737 8.48919 7.7265 7.87895 7.7265 7.16022C7.7265 6.44147 7.97737 5.83123 8.47911 5.32951C8.98084 4.82777 9.59108 4.5769 10.3098 4.5769C11.0286 4.5769 11.6388 4.82777 12.1405 5.32951C12.6423 5.83123 12.8931 6.44147 12.8931 7.16022C12.8931 7.87895 12.6423 8.48919 12.1405 8.99093C11.6388 9.49265 11.0286 9.74351 10.3098 9.74351ZM10.3142 8.66022C10.728 8.66022 11.0806 8.5129 11.3723 8.21828C11.664 7.92367 11.8098 7.5695 11.8098 7.15578C11.8098 6.74207 11.6625 6.38938 11.3679 6.09772C11.0733 5.80605 10.7191 5.66022 10.3054 5.66022C9.89167 5.66022 9.53898 5.80752 9.24731 6.10213C8.95565 6.39676 8.80981 6.75093 8.80981 7.16463C8.80981 7.57836 8.95712 7.93105 9.25173 8.22272C9.54636 8.51438 9.90052 8.66022 10.3142 8.66022ZM15.0182 14.7115H14.4328C14.2443 14.7115 14.0847 14.6475 13.9543 14.5196C13.8238 14.3917 13.7586 14.2332 13.7586 14.0442V10.8751C13.7586 10.686 13.8228 10.5276 13.9511 10.3999C14.0795 10.2722 14.2386 10.2083 14.4284 10.2083H17.2153C17.3863 10.2083 17.5247 10.2836 17.6304 10.4343C17.7361 10.5849 17.7526 10.7468 17.68 10.9198L16.5454 13.548H17.0566C17.2505 13.548 17.3959 13.6311 17.4929 13.7972C17.5898 13.9634 17.5881 14.133 17.4877 14.306L15.3323 17.713C15.2879 17.7857 15.2245 17.8108 15.1419 17.7884C15.0594 17.7659 15.0182 17.7114 15.0182 17.6249V14.7115Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_DFT, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Charges"), /*#__PURE__*/React.createElement("path", {
        d: "M5.30981 17.5833C4.78312 17.5833 4.38756 17.4546 4.12313 17.1971C3.85871 16.9396 3.7265 16.5406 3.7265 16V14.0866C3.7265 13.8996 3.79141 13.7412 3.92123 13.6114C4.05104 13.4816 4.20942 13.4167 4.39638 13.4167H5.7265V2.94716C5.7265 2.87452 5.75455 2.82004 5.81065 2.7837C5.86673 2.74738 5.92683 2.75593 5.99094 2.80935L6.62394 3.33818C6.6827 3.38627 6.75429 3.41031 6.83869 3.41031C6.92309 3.41031 6.99467 3.38627 7.05342 3.33818L7.73131 2.76768C7.79008 2.7196 7.86165 2.69556 7.94604 2.69556C8.03045 2.69556 8.10203 2.7196 8.16079 2.76768L8.8595 3.33818C8.91827 3.38627 8.98985 3.41031 9.07425 3.41031C9.15865 3.41031 9.23023 3.38627 9.28898 3.33818L9.96688 2.76768C10.0256 2.7196 10.0972 2.69556 10.1816 2.69556C10.266 2.69556 10.3376 2.7196 10.3964 2.76768L11.0951 3.33818C11.1538 3.38627 11.2254 3.41031 11.3098 3.41031C11.3942 3.41031 11.4658 3.38627 11.5245 3.33818L12.2233 2.76768C12.282 2.7196 12.3536 2.69556 12.438 2.69556C12.5224 2.69556 12.594 2.7196 12.6528 2.76768L13.3306 3.33818C13.3894 3.38627 13.461 3.41031 13.5454 3.41031C13.6298 3.41031 13.7014 3.38627 13.7601 3.33818L14.4588 2.76768C14.5176 2.7196 14.5892 2.69556 14.6736 2.69556C14.758 2.69556 14.8295 2.7196 14.8883 2.76768L15.5662 3.33818C15.625 3.38627 15.6965 3.41031 15.7809 3.41031C15.8653 3.41031 15.9369 3.38627 15.9957 3.33818L16.6287 2.80935C16.6928 2.75593 16.7529 2.74738 16.809 2.7837C16.8651 2.82004 16.8931 2.87452 16.8931 2.94716V15.75C16.8931 16.2906 16.7193 16.7313 16.3715 17.0721C16.0237 17.4129 15.5865 17.5833 15.0598 17.5833H5.30981ZM15.0598 16.5C15.282 16.5 15.4626 16.434 15.6015 16.3021C15.7404 16.1702 15.8098 15.9861 15.8098 15.75V4.50002H6.80981V13.4167H13.6399C13.8269 13.4167 13.9853 13.4816 14.1151 13.6114C14.2449 13.7412 14.3098 13.8996 14.3098 14.0866V15.75C14.3098 15.9861 14.3793 16.1702 14.5181 16.3021C14.657 16.434 14.8376 16.5 15.0598 16.5ZM8.51173 6.20837H11.656C11.8056 6.20837 11.9332 6.26125 12.039 6.36702C12.1447 6.47278 12.1976 6.60045 12.1976 6.75002C12.1976 6.89958 12.1447 7.02725 12.039 7.13301C11.9332 7.23878 11.8056 7.29166 11.656 7.29166H8.51173C8.36216 7.29166 8.23449 7.23878 8.12873 7.13301C8.02297 7.02725 7.97008 6.89958 7.97008 6.75002C7.97008 6.60045 8.02297 6.47278 8.12873 6.36702C8.23449 6.26125 8.36216 6.20837 8.51173 6.20837ZM8.51173 8.70837H11.656C11.8056 8.70837 11.9332 8.76125 12.039 8.86702C12.1447 8.97278 12.1976 9.10045 12.1976 9.25002C12.1976 9.39958 12.1447 9.52725 12.039 9.63302C11.9332 9.73878 11.8056 9.79166 11.656 9.79166H8.51173C8.36216 9.79166 8.23449 9.73878 8.12873 9.63302C8.02297 9.52725 7.97008 9.39958 7.97008 9.25002C7.97008 9.10045 8.02297 8.97278 8.12873 8.86702C8.23449 8.76125 8.36216 8.70837 8.51173 8.70837ZM14.0117 7.40385C13.8493 7.40385 13.6998 7.33895 13.563 7.20914C13.4263 7.07934 13.3579 6.92629 13.3579 6.75002C13.3579 6.57374 13.4263 6.4207 13.563 6.29089C13.6998 6.16108 13.8493 6.09618 14.0117 6.09618C14.188 6.09618 14.3411 6.16108 14.4709 6.29089C14.6007 6.4207 14.6656 6.57374 14.6656 6.75002C14.6656 6.92629 14.6007 7.07934 14.4709 7.20914C14.3411 7.33895 14.188 7.40385 14.0117 7.40385ZM14.0117 9.90385C13.8493 9.90385 13.6998 9.83895 13.563 9.70914C13.4263 9.57933 13.3579 9.42629 13.3579 9.25002C13.3579 9.07374 13.4263 8.9207 13.563 8.79089C13.6998 8.66108 13.8493 8.59618 14.0117 8.59618C14.188 8.59618 14.3411 8.66108 14.4709 8.79089C14.6007 8.9207 14.6656 9.07374 14.6656 9.25002C14.6656 9.42629 14.6007 9.57933 14.4709 9.70914C14.3411 9.83895 14.188 9.90385 14.0117 9.90385ZM5.30981 16.5H13.2265V14.5H4.80981V16C4.80981 16.2361 4.83412 16.3785 4.88273 16.4271C4.93134 16.4757 5.0737 16.5 5.30981 16.5Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_MDM, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Notes"), /*#__PURE__*/React.createElement("path", {
        d: "M8.05898 14.7916H12.5539C12.7074 14.7916 12.837 14.7402 12.9428 14.6373C13.0486 14.5345 13.1015 14.4068 13.1015 14.2543C13.1015 14.1018 13.0497 13.9727 12.9462 13.8669C12.8427 13.7612 12.7141 13.7083 12.5606 13.7083H8.06571C7.91221 13.7083 7.78258 13.7597 7.67681 13.8625C7.57105 13.9654 7.51817 14.0931 7.51817 14.2455C7.51817 14.398 7.56993 14.5272 7.67344 14.6329C7.77697 14.7387 7.90548 14.7916 8.05898 14.7916ZM8.05898 11.7916H12.5539C12.7074 11.7916 12.837 11.7402 12.9428 11.6373C13.0486 11.5345 13.1015 11.4068 13.1015 11.2543C13.1015 11.1018 13.0497 10.9727 12.9462 10.8669C12.8427 10.7612 12.7141 10.7083 12.5606 10.7083H8.06571C7.91221 10.7083 7.78258 10.7597 7.67681 10.8625C7.57105 10.9654 7.51817 11.0931 7.51817 11.2455C7.51817 11.398 7.56993 11.5272 7.67344 11.6329C7.77697 11.7387 7.90548 11.7916 8.05898 11.7916ZM6.06033 17.5833C5.685 17.5833 5.36886 17.4537 5.11192 17.1947C4.85497 16.9357 4.7265 16.6186 4.7265 16.2435V3.75638C4.7265 3.38127 4.85602 3.0642 5.11504 2.80517C5.37407 2.54614 5.69114 2.41663 6.06625 2.41663H11.9573C12.1334 2.41663 12.303 2.44868 12.466 2.51279C12.629 2.57689 12.7788 2.67731 12.9156 2.81406L15.4957 5.39415C15.6324 5.53091 15.7329 5.68079 15.797 5.84377C15.8611 6.00675 15.8931 6.17631 15.8931 6.35248V16.2435C15.8931 16.6186 15.7635 16.9357 15.5043 17.1947C15.2451 17.4537 14.9279 17.5833 14.5525 17.5833H6.06033ZM11.7265 5.91338V3.49994H6.06625C6.00214 3.49994 5.94337 3.52665 5.88994 3.58006C5.83652 3.63349 5.80981 3.69227 5.80981 3.75638V16.2435C5.80981 16.3076 5.83652 16.3664 5.88994 16.4198C5.94337 16.4732 6.00214 16.4999 6.06625 16.4999H14.5534C14.6175 16.4999 14.6763 16.4732 14.7297 16.4198C14.7831 16.3664 14.8098 16.3076 14.8098 16.2435V6.58325H12.3964C12.2053 6.58325 12.0458 6.51938 11.9181 6.39165C11.7904 6.26393 11.7265 6.1045 11.7265 5.91338Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_ORM, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Orders"), /*#__PURE__*/React.createElement("path", {
        d: "M5.26817 11.7501C5.1147 11.7501 4.98605 11.6985 4.88223 11.5955C4.77841 11.4925 4.7265 11.3648 4.7265 11.2125C4.7265 11.0602 4.77841 10.9312 4.88223 10.8254C4.98605 10.7196 5.1147 10.6667 5.26817 10.6667H10.1849C10.3383 10.6667 10.467 10.7183 10.5708 10.8213C10.6746 10.9243 10.7265 11.052 10.7265 11.2043C10.7265 11.3566 10.6746 11.4857 10.5708 11.5914C10.467 11.6972 10.3383 11.7501 10.1849 11.7501H5.26817ZM5.26817 8.62506C5.1147 8.62506 4.98605 8.57355 4.88223 8.47052C4.77841 8.36749 4.7265 8.23983 4.7265 8.08752C4.7265 7.93521 4.77841 7.80618 4.88223 7.70042C4.98605 7.59464 5.1147 7.54175 5.26817 7.54175H13.1849C13.3383 7.54175 13.467 7.59327 13.5708 7.69631C13.6746 7.79934 13.7265 7.92701 13.7265 8.07931C13.7265 8.23162 13.6746 8.36065 13.5708 8.46642C13.467 8.57218 13.3383 8.62506 13.1849 8.62506H5.26817ZM5.26817 5.50006C5.1147 5.50006 4.98605 5.44855 4.88223 5.34552C4.77841 5.24249 4.7265 5.11482 4.7265 4.96252C4.7265 4.81021 4.77841 4.68118 4.88223 4.57542C4.98605 4.46964 5.1147 4.41675 5.26817 4.41675H13.1849C13.3383 4.41675 13.467 4.46827 13.5708 4.57131C13.6746 4.67434 13.7265 4.80201 13.7265 4.95431C13.7265 5.10662 13.6746 5.23565 13.5708 5.34142C13.467 5.44718 13.3383 5.50006 13.1849 5.50006H5.26817ZM11.406 14.9135V13.8532C11.406 13.7611 11.4241 13.676 11.4605 13.598C11.4968 13.5199 11.547 13.4488 11.6111 13.3847L15.7008 9.31577C15.7803 9.2342 15.8653 9.17721 15.9558 9.14481C16.0464 9.11242 16.1362 9.09623 16.2252 9.09623C16.3223 9.09623 16.4165 9.11385 16.5078 9.1491C16.5992 9.18437 16.6822 9.23725 16.7569 9.30775L17.6736 10.2533C17.7437 10.3327 17.7978 10.418 17.8359 10.5092C17.8741 10.6003 17.8931 10.6907 17.8931 10.7803C17.8931 10.8699 17.8756 10.9609 17.8405 11.0534C17.8055 11.1459 17.7498 11.2312 17.6736 11.3093L13.6047 15.3782C13.5406 15.4423 13.4695 15.4926 13.3914 15.5289C13.3133 15.5652 13.2282 15.5834 13.1361 15.5834H12.0758C11.886 15.5834 11.727 15.5192 11.5986 15.3908C11.4702 15.2624 11.406 15.1033 11.406 14.9135ZM12.1495 14.8398H13.087L15.6672 12.2677L15.2008 11.7885L14.7505 11.3141L12.1495 13.9023V14.8398ZM15.2008 11.7885L14.7505 11.3141L15.6672 12.2677L15.2008 11.7885Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_RDS, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Medication"), /*#__PURE__*/React.createElement("path", {
        d: "M9.67844 11.5833V12.9519C9.67844 13.1273 9.73991 13.2763 9.86286 13.3991C9.98581 13.5219 10.1351 13.5833 10.3108 13.5833C10.4864 13.5833 10.6354 13.5219 10.7577 13.3991C10.88 13.2763 10.9412 13.1273 10.9412 12.9519V11.5833H12.3098C12.4852 11.5833 12.6343 11.5218 12.757 11.3988C12.8798 11.2759 12.9412 11.1266 12.9412 10.9509C12.9412 10.7753 12.8798 10.6263 12.757 10.504C12.6343 10.3817 12.4852 10.3205 12.3098 10.3205H10.9412V8.95187C10.9412 8.77648 10.8797 8.6274 10.7568 8.50464C10.6338 8.38187 10.4845 8.32049 10.3089 8.32049C10.1332 8.32049 9.98424 8.38187 9.86192 8.50464C9.7396 8.6274 9.67844 8.77648 9.67844 8.95187V10.3205H8.30981C8.13442 10.3205 7.98535 10.382 7.86258 10.5049C7.73982 10.6279 7.67844 10.7772 7.67844 10.9528C7.67844 11.1285 7.73982 11.2774 7.86258 11.3998C7.98535 11.5221 8.13442 11.5833 8.30981 11.5833H9.67844ZM6.56625 16.5352C6.19782 16.5352 5.88242 16.404 5.62006 16.1416C5.35769 15.8793 5.2265 15.5639 5.2265 15.1954V7.2083C5.2265 6.83987 5.35769 6.52448 5.62006 6.26212C5.88242 5.99976 6.19782 5.86857 6.56625 5.86857H14.0534C14.4218 5.86857 14.7372 5.99976 14.9996 6.26212C15.2619 6.52448 15.3931 6.83987 15.3931 7.2083V15.1954C15.3931 15.5639 15.2619 15.8793 14.9996 16.1416C14.7372 16.404 14.4218 16.5352 14.0534 16.5352H6.56625ZM6.56625 15.4519H14.0534C14.1175 15.4519 14.1763 15.4252 14.2297 15.3717C14.2831 15.3183 14.3098 15.2595 14.3098 15.1954V7.2083C14.3098 7.14419 14.2831 7.08543 14.2297 7.03201C14.1763 6.97858 14.1175 6.95187 14.0534 6.95187H6.56625C6.50214 6.95187 6.44337 6.97858 6.38994 7.03201C6.33652 7.08543 6.30981 7.14419 6.30981 7.2083V15.1954C6.30981 15.2595 6.33652 15.3183 6.38994 15.3717C6.44337 15.4252 6.50214 15.4519 6.56625 15.4519ZM6.54981 4.54803C6.39649 4.54803 6.26688 4.49652 6.16098 4.39349C6.05508 4.29046 6.00213 4.1628 6.00213 4.01049C6.00213 3.85819 6.05399 3.72915 6.15771 3.62337C6.26142 3.5176 6.38993 3.46472 6.54323 3.46472H14.0698C14.2231 3.46472 14.3527 3.51623 14.4586 3.61926C14.5645 3.7223 14.6175 3.84998 14.6175 4.00228C14.6175 4.15459 14.5656 4.28362 14.4619 4.38939C14.3582 4.49515 14.2297 4.54803 14.0764 4.54803H6.54981Z",
        fill: "currentColor"
      }));
    }], [e.Timeline_SIU, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("title", null, "Surgeries"), /*#__PURE__*/React.createElement("path", {
        d: "M10.5791 16.2547L11.6624 15.1714H17.8243C17.9777 15.1714 18.1064 15.223 18.2102 15.326C18.314 15.429 18.3659 15.5567 18.3659 15.709C18.3659 15.8613 18.314 15.9903 18.2102 16.0961C18.1064 16.2019 17.9777 16.2547 17.8243 16.2547H10.5791ZM10.4973 12.0961L8.17363 9.77244L14.0386 3.92755C14.1756 3.78998 14.333 3.72119 14.5109 3.72119C14.6888 3.72119 14.8481 3.79224 14.9887 3.93434L16.3375 5.29969C16.4782 5.44072 16.5485 5.60133 16.5485 5.78152C16.5485 5.96172 16.4801 6.11788 16.3434 6.25L10.4973 12.0961ZM10.4973 10.5641L15.289 5.77244L14.4973 4.98078L9.70563 9.77244L10.4973 10.5641ZM5.07425 16.2628C4.60417 16.2628 4.15197 16.1817 3.71765 16.0195C3.28333 15.8573 2.891 15.6265 2.54065 15.3269L7.07425 10.8061L9.11109 12.8429C9.22896 12.9436 9.31265 13.0631 9.36215 13.2014C9.41165 13.3398 9.4364 13.4791 9.4364 13.6193C9.4364 13.7595 9.41236 13.8945 9.3643 14.0243C9.31623 14.1541 9.2345 14.2763 9.11911 14.391L8.59827 14.9406C8.16346 15.3808 7.66368 15.7112 7.09894 15.9318C6.53422 16.1524 5.9496 16.2628 5.34509 16.2628H5.07425ZM5.07425 15.1794H5.32425C5.79648 15.1794 6.24786 15.0926 6.67842 14.919C7.10898 14.7454 7.49092 14.4919 7.82425 14.1586L8.34509 13.6169L8.34109 13.6129L8.32907 13.6009L7.07425 12.3253L4.3403 15.0593C4.44927 15.0924 4.56718 15.1207 4.69402 15.1442C4.82087 15.1677 4.94761 15.1794 5.07425 15.1794Z",
        fill: "currentColor"
      }));
    }], [e.Trash, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.14246 18C5.63651 18 5.20983 17.8263 4.86241 17.4789C4.51424 17.1315 4.34016 16.7048 4.34016 16.1988V4.39397H4.10349C3.89792 4.39397 3.72005 4.31887 3.56985 4.16868C3.42042 4.01849 3.3457 3.84061 3.3457 3.63505C3.3457 3.43024 3.42042 3.25274 3.56985 3.10255C3.72005 2.95235 3.89792 2.87726 4.10349 2.87726H7.70696C7.70696 2.63983 7.79761 2.43427 7.9789 2.26056C8.16095 2.08685 8.37031 2 8.60698 2H12.4244C12.661 2 12.8704 2.08685 13.0524 2.26056C13.2337 2.43427 13.3244 2.63983 13.3244 2.87726H16.9278C17.1334 2.87726 17.3113 2.95235 17.4615 3.10255C17.6117 3.25274 17.6868 3.43024 17.6868 3.63505C17.6868 3.84061 17.6117 4.01849 17.4615 4.16868C17.3113 4.31887 17.1334 4.39397 16.9278 4.39397H16.6912V16.1988C16.6912 16.7048 16.5171 17.1315 16.1689 17.4789C15.8215 17.8263 15.3948 18 14.8889 18H6.14246ZM5.85801 4.39397V16.1988C5.85801 16.2777 5.88569 16.3449 5.94107 16.4002C5.99644 16.4556 6.06357 16.4833 6.14246 16.4833H14.8889C14.9685 16.4833 15.0356 16.4556 15.0903 16.4002C15.1456 16.3449 15.1733 16.2777 15.1733 16.1988V4.39397H5.85801ZM8.01531 13.7332C8.01531 13.9387 8.09041 14.1166 8.2406 14.2668C8.39079 14.417 8.56829 14.4921 8.7731 14.4921C8.97866 14.4921 9.15654 14.417 9.30673 14.2668C9.45693 14.1166 9.53202 13.9387 9.53202 13.7332V7.14408C9.53202 6.93851 9.45693 6.76063 9.30673 6.61044C9.15654 6.46025 8.97866 6.38515 8.7731 6.38515C8.56829 6.38515 8.39079 6.46025 8.2406 6.61044C8.09041 6.76063 8.01531 6.93851 8.01531 7.14408V13.7332ZM11.4993 13.7332C11.4993 13.9387 11.5744 14.1166 11.7246 14.2668C11.8748 14.417 12.0527 14.4921 12.2582 14.4921C12.4638 14.4921 12.6417 14.417 12.7919 14.2668C12.9421 14.1166 13.0172 13.9387 13.0172 13.7332V7.14408C13.0172 6.93851 12.9421 6.76063 12.7919 6.61044C12.6417 6.46025 12.4638 6.38515 12.2582 6.38515C12.0527 6.38515 11.8748 6.46025 11.7246 6.61044C11.5744 6.76063 11.4993 6.93851 11.4993 7.14408V13.7332ZM5.85801 4.39397V16.1988C5.85801 16.2777 5.88569 16.3449 5.94107 16.4002C5.99644 16.4556 6.06357 16.4833 6.14246 16.4833H5.85801V4.39397Z",
        fill: "currentColor"
      }));
    }], [e.Unlock, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M5.75052 17.5833C5.38053 17.5833 5.06574 17.4525 4.80612 17.1908C4.5465 16.9291 4.41669 16.6133 4.41669 16.2436V8.75644C4.41669 8.38667 4.54754 8.07094 4.80925 7.80925C5.07094 7.54754 5.38667 7.41669 5.75644 7.41669H12.5V5.41669C12.5 4.72224 12.2569 4.13196 11.7708 3.64585C11.2847 3.15974 10.6944 2.91669 10 2.91669C9.39529 2.91669 8.86404 3.1106 8.40625 3.49844C7.94844 3.88626 7.66612 4.36969 7.55929 4.94875C7.53365 5.10046 7.46324 5.21637 7.34806 5.2965C7.23288 5.37662 7.10298 5.41669 6.95835 5.41669C6.81052 5.41669 6.68676 5.35419 6.58706 5.22921C6.48737 5.10421 6.45208 4.96685 6.48119 4.81712C6.6188 3.97136 7.01764 3.26263 7.67771 2.69094C8.33778 2.11924 9.11187 1.8334 10 1.8334C10.9945 1.8334 11.8403 2.18199 12.5375 2.87919C13.2347 3.57638 13.5833 4.42221 13.5833 5.41669V7.41669H14.2436C14.6133 7.41669 14.9291 7.54754 15.1908 7.80925C15.4525 8.07094 15.5833 8.38667 15.5833 8.75644V16.2436C15.5833 16.6133 15.4524 16.9291 15.1905 17.1908C14.9286 17.4525 14.6127 17.5833 14.2427 17.5833H5.75052ZM5.75644 16.5H14.2436C14.3184 16.5 14.3798 16.476 14.4279 16.4279C14.476 16.3798 14.5 16.3184 14.5 16.2436V8.75644C14.5 8.68165 14.476 8.62021 14.4279 8.57212C14.3798 8.52404 14.3184 8.5 14.2436 8.5H5.75644C5.68165 8.5 5.62021 8.52404 5.57212 8.57212C5.52404 8.62021 5.5 8.68165 5.5 8.75644V16.2436C5.5 16.3184 5.52404 16.3798 5.57212 16.4279C5.62021 16.476 5.68165 16.5 5.75644 16.5ZM10.0044 13.7916C10.3647 13.7916 10.6693 13.6657 10.9182 13.4138C11.1672 13.162 11.2916 12.8559 11.2916 12.4956C11.2916 12.1353 11.1657 11.8307 10.9138 11.5818C10.662 11.3328 10.3559 11.2084 9.99558 11.2084C9.63528 11.2084 9.33067 11.3343 9.08175 11.5862C8.83282 11.838 8.70835 12.1441 8.70835 12.5044C8.70835 12.8647 8.83429 13.1693 9.08617 13.4182C9.33804 13.6672 9.64412 13.7916 10.0044 13.7916Z",
        fill: "currentColor"
      }));
    }], [e.User, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.5161 9.78287C9.82134 9.78287 9.24249 9.54833 8.77952 9.07925C8.316 8.61072 8.08423 8.03465 8.08423 7.35104C8.08423 6.65631 8.316 6.07746 8.77952 5.6145C9.24249 5.15153 9.82134 4.92004 10.5161 4.92004C11.2108 4.92004 11.7896 5.15153 12.2526 5.6145C12.7161 6.07746 12.9479 6.65631 12.9479 7.35104C12.9479 8.03465 12.7161 8.61072 12.2526 9.07925C11.7896 9.54833 11.2108 9.78287 10.5161 9.78287ZM14.6494 15.08H6.3827C6.0698 15.08 5.8033 14.9703 5.58321 14.7507C5.36367 14.5307 5.25391 14.27 5.25391 13.9688V13.4827C5.25391 13.1354 5.34922 12.8197 5.53986 12.5357C5.73105 12.2522 5.97726 12.0352 6.27849 11.8846C6.96155 11.5722 7.66212 11.3318 8.38019 11.1634C9.09771 10.9956 9.80966 10.9117 10.5161 10.9117C11.2225 10.9117 11.9375 10.9956 12.6611 11.1634C13.3847 11.3318 14.0764 11.5722 14.7361 11.8846C15.049 12.0352 15.3011 12.2522 15.4923 12.5357C15.6829 12.8197 15.7782 13.1354 15.7782 13.4827V13.9688C15.7782 14.27 15.6685 14.5307 15.4489 14.7507C15.2288 14.9703 14.9623 15.08 14.6494 15.08ZM6.3652 13.9688H14.6669V13.4827C14.6669 13.3438 14.6294 13.2221 14.5544 13.1176C14.4788 13.0136 14.3774 12.9383 14.2501 12.8916C13.6715 12.6254 13.0607 12.4142 12.4177 12.2581C11.7752 12.1019 11.1413 12.0238 10.5161 12.0238C9.89081 12.0238 9.25694 12.1047 8.61445 12.2664C7.97141 12.4287 7.3606 12.6371 6.78203 12.8916C6.65476 12.9494 6.55333 13.0278 6.47774 13.1267C6.40271 13.2251 6.3652 13.3438 6.3652 13.4827V13.9688ZM10.5161 8.67158C10.8984 8.67158 11.2139 8.54709 11.4623 8.2981C11.7113 8.0491 11.8358 7.73342 11.8358 7.35104C11.8358 6.96922 11.7113 6.65381 11.4623 6.40482C11.2139 6.15583 10.8984 6.03133 10.5161 6.03133C10.1337 6.03133 9.81828 6.15583 9.56984 6.40482C9.32085 6.65381 9.19636 6.96922 9.19636 7.35104C9.19636 7.73342 9.32085 8.0491 9.56984 8.2981C9.81828 8.54709 10.1337 8.67158 10.5161 8.67158Z",
        fill: "currentColor"
      }));
    }], [e.User_Plus, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M15.2902 11.2238C15.1396 11.2238 15.0094 11.1688 14.8994 11.0588C14.7894 10.9488 14.7344 10.8188 14.7344 10.6688V9.17545H13.2419C13.0913 9.17545 12.961 9.12045 12.851 9.01045C12.741 8.90045 12.686 8.77017 12.686 8.61962C12.686 8.46906 12.741 8.33906 12.851 8.22962C12.961 8.11962 13.0913 8.06462 13.2419 8.06462H14.7344V6.57129C14.7344 6.42073 14.7894 6.29045 14.8994 6.18045C15.0094 6.07045 15.1396 6.01545 15.2902 6.01545C15.4408 6.01545 15.571 6.07045 15.681 6.18045C15.791 6.29045 15.846 6.42073 15.846 6.57129V8.06462H17.3394C17.4894 8.06462 17.6194 8.11962 17.7294 8.22962C17.8394 8.33906 17.8944 8.46906 17.8944 8.61962C17.8944 8.77017 17.8394 8.90045 17.7294 9.01045C17.6194 9.12045 17.4894 9.17545 17.3394 9.17545H15.846V10.6688C15.846 10.8188 15.791 10.9488 15.681 11.0588C15.571 11.1688 15.4408 11.2238 15.2902 11.2238ZM8.38103 9.78295C7.68658 9.78295 7.1077 9.54851 6.64436 9.07962C6.18158 8.61129 5.9502 8.03545 5.9502 7.35212C5.9502 6.65767 6.18158 6.07906 6.64436 5.61629C7.1077 5.15351 7.68658 4.92212 8.38103 4.92212C9.07547 4.92212 9.65408 5.15351 10.1169 5.61629C10.5796 6.07906 10.811 6.65767 10.811 7.35212C10.811 8.03545 10.5796 8.61129 10.1169 9.07962C9.65408 9.54851 9.07547 9.78295 8.38103 9.78295ZM3.7977 15.078C3.62381 15.078 3.4702 15.0143 3.33686 14.8871C3.20408 14.7599 3.1377 14.6038 3.1377 14.4188V13.4813C3.1377 13.1341 3.23325 12.8185 3.42436 12.5346C3.61492 12.2513 3.86658 12.0343 4.17936 11.8838C4.86214 11.5599 5.55936 11.3168 6.27103 11.1546C6.98325 10.9924 7.69214 10.9113 8.3977 10.9113C9.10381 10.9113 9.8127 10.9952 10.5244 11.163C11.2366 11.3313 11.9341 11.5716 12.6169 11.8838C12.9291 12.0343 13.178 12.2513 13.3635 12.5346C13.5485 12.8185 13.641 13.1341 13.641 13.4813V14.4188C13.641 14.6038 13.5744 14.7599 13.441 14.8871C13.3083 15.0143 13.1549 15.078 12.981 15.078H3.7977ZM4.24853 13.9671H12.5302V13.4813C12.5302 13.3424 12.4924 13.2207 12.4169 13.1163C12.3419 13.0124 12.2408 12.9371 12.1135 12.8905C11.523 12.6243 10.9152 12.4132 10.2902 12.2571C9.6652 12.101 9.03436 12.023 8.3977 12.023C7.76103 12.023 7.13047 12.101 6.50603 12.2571C5.88047 12.4132 5.2727 12.6243 4.6827 12.8905C4.54381 12.9482 4.43686 13.0266 4.36186 13.1255C4.28631 13.2238 4.24853 13.3424 4.24853 13.4813V13.9671ZM8.38103 8.67212C8.7627 8.67212 9.07797 8.54767 9.32686 8.29879C9.57575 8.0499 9.7002 7.73434 9.7002 7.35212C9.7002 6.97045 9.57575 6.65517 9.32686 6.40629C9.07797 6.1574 8.7627 6.03295 8.38103 6.03295C7.99881 6.03295 7.68325 6.1574 7.43436 6.40629C7.18547 6.65517 7.06103 6.97045 7.06103 7.35212C7.06103 7.73434 7.18547 8.0499 7.43436 8.29879C7.68325 8.54767 7.99881 8.67212 8.38103 8.67212Z",
        fill: "currentColor"
      }));
    }], [e.Vertical_Menu, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.7203 16C10.3808 16 10.0951 15.8803 9.86304 15.6408C9.63175 15.4014 9.51611 15.1193 9.51611 14.7947C9.51611 14.4552 9.63583 14.1698 9.87527 13.9385C10.114 13.7064 10.3957 13.5904 10.7203 13.5904C11.0598 13.5904 11.3456 13.7064 11.5776 13.9385C11.8089 14.1698 11.9246 14.4552 11.9246 14.7947C11.9246 15.1349 11.8048 15.4207 11.5654 15.652C11.3267 15.884 11.045 16 10.7203 16ZM10.7203 11.2042C10.3808 11.2042 10.0951 11.0845 9.86304 10.8451C9.63175 10.6064 9.51611 10.3247 9.51611 10C9.51611 9.66049 9.63583 9.37472 9.87527 9.1427C10.114 8.91142 10.3957 8.79577 10.7203 8.79577C11.0598 8.79577 11.3456 8.91549 11.5776 9.15493C11.8089 9.39362 11.9246 9.67532 11.9246 10C11.9246 10.3395 11.8048 10.6253 11.5654 10.8573C11.3267 11.0886 11.045 11.2042 10.7203 11.2042ZM10.7203 6.40956C10.3808 6.40956 10.0951 6.29355 9.86304 6.06153C9.63175 5.83024 9.51611 5.54485 9.51611 5.20534C9.51611 4.86509 9.63583 4.57932 9.87527 4.34804C10.114 4.11601 10.3957 4 10.7203 4C11.0598 4 11.3456 4.11972 11.5776 4.35915C11.8089 4.59859 11.9246 4.88065 11.9246 5.20534C11.9246 5.54485 11.8048 5.83024 11.5654 6.06153C11.3267 6.29355 11.045 6.40956 10.7203 6.40956Z",
        fill: "currentColor"
      }));
    }], [e.Visiblity_Off, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M12.9984 11.6153L11.9792 10.596C12.0347 10.0309 11.8656 9.56666 11.472 9.20342C11.0782 8.84017 10.6362 8.68633 10.1458 8.74188L9.12662 7.72267C9.25909 7.67994 9.39985 7.64789 9.54889 7.62653C9.69792 7.60515 9.84829 7.59447 10 7.59447C10.8761 7.59447 11.6196 7.90002 12.2307 8.51113C12.8419 9.12224 13.1474 9.86583 13.1474 10.7419C13.1474 10.8936 13.1367 11.0466 13.1154 11.201C13.094 11.3554 13.055 11.4935 12.9984 11.6153ZM15.7532 14.354L14.9583 13.5752C15.4583 13.1863 15.9132 12.7592 16.3229 12.294C16.7326 11.8287 17.0764 11.3113 17.3542 10.7419C16.6736 9.3391 15.6701 8.23841 14.3437 7.4398C13.0174 6.64119 11.5694 6.24188 10 6.24188C9.63888 6.24188 9.28472 6.26272 8.9375 6.30438C8.59027 6.34605 8.25 6.41549 7.91666 6.51272L7.02887 5.62492C7.51391 5.4433 8.0067 5.32017 8.50722 5.25553C9.00775 5.19089 9.50534 5.15857 10 5.15857C11.8419 5.15857 13.551 5.65536 15.1274 6.64894C16.7038 7.64254 17.8451 9.00685 18.5512 10.7419C18.2564 11.4588 17.8715 12.1121 17.3966 12.7018C16.9217 13.2915 16.3739 13.8423 15.7532 14.354ZM15.9679 18.2579L13.3878 15.6617C12.9188 15.8615 12.3966 16.022 11.8213 16.1433C11.246 16.2646 10.6389 16.3252 10 16.3252C8.15279 16.3252 6.44366 15.8284 4.87262 14.8348C3.30158 13.8412 2.16029 12.4769 1.44875 10.7419C1.77033 9.95022 2.20249 9.22532 2.74522 8.56719C3.28796 7.90908 3.90068 7.33217 4.58337 6.83644L2.48402 4.75311L3.25804 3.97909L16.742 17.4838L15.9679 18.2579ZM5.35739 7.63128C4.83389 8.00949 4.32241 8.46195 3.82293 8.98867C3.32346 9.51538 2.93109 10.0998 2.64583 10.7419C3.32638 12.1447 4.32986 13.2454 5.65625 14.044C6.98263 14.8426 8.43055 15.2419 10 15.2419C10.4626 15.2419 10.9236 15.2029 11.383 15.1249C11.8424 15.0469 12.2377 14.9529 12.5689 14.8428L11.3269 13.6169C11.1432 13.7023 10.93 13.7691 10.6875 13.8172C10.445 13.8653 10.2158 13.8893 10 13.8893C9.12394 13.8893 8.38036 13.5837 7.76925 12.9726C7.15813 12.3615 6.85258 11.6179 6.85258 10.7419C6.85258 10.5314 6.88356 10.3063 6.94554 10.0664C7.00751 9.82654 7.06734 9.60939 7.12502 9.41494L5.35739 7.63128Z",
        fill: "currentColor"
      }));
    }], [e.Visiblity_On, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M10.002 13.8488C10.8768 13.8488 11.6197 13.5427 12.2308 12.9303C12.8419 12.3179 13.1475 11.5743 13.1475 10.6995C13.1475 9.82473 12.8413 9.08178 12.2289 8.47067C11.6166 7.85956 10.873 7.554 9.99817 7.554C9.12338 7.554 8.38043 7.86018 7.76931 8.47254C7.1582 9.08492 6.85265 9.82851 6.85265 10.7033C6.85265 11.5781 7.15883 12.3211 7.77119 12.9322C8.38356 13.5433 9.12715 13.8488 10.002 13.8488ZM10.0001 12.7014C9.44451 12.7014 8.97229 12.507 8.5834 12.1181C8.19451 11.7292 8.00006 11.257 8.00006 10.7014C8.00006 10.1459 8.19451 9.67364 8.5834 9.28475C8.97229 8.89586 9.44451 8.70142 10.0001 8.70142C10.5556 8.70142 11.0278 8.89586 11.4167 9.28475C11.8056 9.67364 12.0001 10.1459 12.0001 10.7014C12.0001 11.257 11.8056 11.7292 11.4167 12.1181C11.0278 12.507 10.5556 12.7014 10.0001 12.7014ZM10.0012 16.2847C8.13214 16.2847 6.42911 15.777 4.89213 14.7615C3.35513 13.746 2.20736 12.3927 1.44881 10.7014C2.20736 9.01018 3.35474 7.65682 4.89098 6.64133C6.4272 5.62585 8.12985 5.1181 9.99892 5.1181C11.868 5.1181 13.571 5.62585 15.108 6.64133C16.645 7.65682 17.7928 9.01018 18.5513 10.7014C17.7928 12.3927 16.6454 13.746 15.1091 14.7615C13.5729 15.777 11.8703 16.2847 10.0012 16.2847ZM10.0001 15.2014C11.5556 15.2014 12.9931 14.7986 14.3126 13.9931C15.632 13.1875 16.6459 12.0903 17.3542 10.7014C16.6459 9.31253 15.632 8.21531 14.3126 7.40975C12.9931 6.60419 11.5556 6.20142 10.0001 6.20142C8.44451 6.20142 7.00701 6.60419 5.68756 7.40975C4.36812 8.21531 3.35423 9.31253 2.6459 10.7014C3.35423 12.0903 4.36812 13.1875 5.68756 13.9931C7.00701 14.7986 8.44451 15.2014 10.0001 15.2014Z",
        fill: "currentColor"
      }));
    }], [e.Warning, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5488 14.9867C13.1446 14.9867 15.2488 12.8825 15.2488 10.2867C15.2488 7.691 13.1446 5.58674 10.5488 5.58674C7.95309 5.58674 5.84883 7.691 5.84883 10.2867C5.84883 12.8825 7.95309 14.9867 10.5488 14.9867ZM10.5488 16.2867C13.8625 16.2867 16.5488 13.6005 16.5488 10.2867C16.5488 6.97303 13.8625 4.28674 10.5488 4.28674C7.23512 4.28674 4.54883 6.97303 4.54883 10.2867C4.54883 13.6005 7.23512 16.2867 10.5488 16.2867Z",
        fill: "currentColor"
      }));
    }], [e.Worklist_Settings, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M3.24787 16.1711C3.04967 16.1711 2.87815 16.0987 2.73334 15.9539C2.58852 15.8091 2.51611 15.6376 2.51611 15.4394C2.51611 15.2419 2.58852 15.0708 2.73334 14.9259C2.87815 14.7811 3.04967 14.7087 3.24787 14.7087H6.99664C7.19412 14.7087 7.36526 14.7811 7.51008 14.9259C7.6549 15.0708 7.7273 15.2419 7.7273 15.4394C7.7273 15.6376 7.6549 15.8091 7.51008 15.9539C7.36526 16.0987 7.19412 16.1711 6.99664 16.1711H3.24787ZM3.24787 5.29128C3.04967 5.29128 2.87815 5.21887 2.73334 5.07405C2.58852 4.92924 2.51611 4.75809 2.51611 4.56061C2.51611 4.36241 2.58852 4.19089 2.73334 4.04608C2.87815 3.90126 3.04967 3.82885 3.24787 3.82885H10.402C10.6002 3.82885 10.7717 3.90126 10.9166 4.04608C11.0606 4.19089 11.1327 4.36241 11.1327 4.56061C11.1327 4.75809 11.0606 4.92924 10.9166 5.07405C10.7717 5.21887 10.6002 5.29128 10.402 5.29128H3.24787ZM10.6072 18C10.409 18 10.2378 17.9276 10.0937 17.7828C9.94892 17.638 9.87651 17.4664 9.87651 17.2682V13.6336C9.87651 13.4361 9.94892 13.2649 10.0937 13.1201C10.2378 12.9753 10.409 12.9029 10.6072 12.9029C10.8054 12.9029 10.9769 12.9753 11.1217 13.1201C11.2665 13.2649 11.3389 13.4361 11.3389 13.6336V14.7087H17.7844C17.9826 14.7087 18.1541 14.7811 18.2989 14.9259C18.4437 15.0708 18.5161 15.2419 18.5161 15.4394C18.5161 15.6376 18.4437 15.8091 18.2989 15.9539C18.1541 16.0987 17.9826 16.1711 17.7844 16.1711H11.3389V17.2682C11.3389 17.4664 11.2665 17.638 11.1217 17.7828C10.9769 17.9276 10.8054 18 10.6072 18ZM6.99664 12.5595C6.79843 12.5595 6.62692 12.4871 6.4821 12.3423C6.33729 12.1982 6.26488 12.0271 6.26488 11.8289V10.7318H3.24787C3.04967 10.7318 2.87815 10.6594 2.73334 10.5145C2.58852 10.3697 2.51611 10.1982 2.51611 10C2.51611 9.80179 2.58852 9.63028 2.73334 9.48546C2.87815 9.34065 3.04967 9.26824 3.24787 9.26824H6.26488V8.19419C6.26488 7.99598 6.33729 7.82447 6.4821 7.67965C6.62692 7.53556 6.79843 7.46352 6.99664 7.46352C7.19412 7.46352 7.36526 7.53556 7.51008 7.67965C7.6549 7.82447 7.7273 7.99598 7.7273 8.19419V11.8289C7.7273 12.0271 7.6549 12.1982 7.51008 12.3423C7.36526 12.4871 7.19412 12.5595 6.99664 12.5595ZM10.6072 10.7318C10.409 10.7318 10.2378 10.6594 10.0937 10.5145C9.94892 10.3697 9.87651 10.1982 9.87651 10C9.87651 9.80179 9.94892 9.63028 10.0937 9.48546C10.2378 9.34065 10.409 9.26824 10.6072 9.26824H17.7844C17.9826 9.26824 18.1541 9.34065 18.2989 9.48546C18.4437 9.63028 18.5161 9.80179 18.5161 10C18.5161 10.1982 18.4437 10.3697 18.2989 10.5145C18.1541 10.6594 17.9826 10.7318 17.7844 10.7318H10.6072ZM14.0356 7.09709C13.8381 7.09709 13.667 7.02468 13.5221 6.87987C13.3773 6.73505 13.3049 6.56391 13.3049 6.36643V2.73176C13.3049 2.53355 13.3773 2.36204 13.5221 2.21722C13.667 2.07241 13.8381 2 14.0356 2C14.2338 2 14.4053 2.07241 14.5501 2.21722C14.6949 2.36204 14.7673 2.53355 14.7673 2.73176V3.82885H17.7844C17.9826 3.82885 18.1541 3.90126 18.2989 4.04608C18.4437 4.19089 18.5161 4.36241 18.5161 4.56061C18.5161 4.75809 18.4437 4.92924 18.2989 5.07405C18.1541 5.21887 17.9826 5.29128 17.7844 5.29128H14.7673V6.36643C14.7673 6.56391 14.6949 6.73505 14.5501 6.87987C14.4053 7.02468 14.2338 7.09709 14.0356 7.09709Z",
        fill: "currentColor"
      }));
    }], [e.Wrong_Code, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.62404 15.4803L17.595 3.48034L18.376 4.51966L2.40495 16.5197L1.62404 15.4803Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7842 4.71758C12.7176 3.95126 11.4094 3.5 9.99577 3.5C6.40592 3.5 3.49577 6.41015 3.49577 10C3.49577 10.7607 3.62645 11.4909 3.86658 12.1693L4.97011 11.3402C4.85638 10.9126 4.79577 10.4634 4.79577 10C4.79577 7.12812 7.12389 4.8 9.99577 4.8C10.9785 4.8 11.8975 5.07258 12.6813 5.54626L13.7842 4.71758ZM7.31491 14.4566C8.09774 14.9285 9.01505 15.2 9.99577 15.2C12.8677 15.2 15.1958 12.8719 15.1958 10C15.1958 9.53853 15.1357 9.09111 15.0228 8.66512L16.1267 7.83569C16.3657 8.51271 16.4958 9.24117 16.4958 10C16.4958 13.5899 13.5856 16.5 9.99577 16.5C8.58407 16.5 7.27748 16.05 6.21164 15.2855L7.31491 14.4566Z",
        fill: "currentColor"
      }));
    }], [e.Zap, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M9.61787 15.4791L14.0054 9.94203H10.4326L11.0562 4.64427L6.90916 11.0927H10.4095L9.61787 15.4791ZM8.8987 12.3389H5.92648C5.65492 12.3389 5.45508 12.2192 5.32697 11.9799C5.19886 11.7398 5.20692 11.5081 5.35114 11.2849L10.9607 2.39123C11.0566 2.19945 11.1962 2.0794 11.3796 2.03107C11.5637 1.98274 11.7516 1.99079 11.9434 2.05523C12.1191 2.1189 12.2629 2.2309 12.3749 2.39123C12.4869 2.55079 12.5268 2.73452 12.4946 2.94241L11.8237 8.69583H15.1078C15.3955 8.69583 15.5991 8.82356 15.7188 9.07901C15.8385 9.33446 15.8185 9.58224 15.659 9.82235L9.4982 17.685C9.37009 17.8292 9.2182 17.9251 9.04253 17.9727C8.86686 18.021 8.69119 18.0053 8.51552 17.9255C8.33985 17.8288 8.2079 17.7007 8.11968 17.5411C8.03223 17.3816 8.01229 17.2059 8.05985 17.0141L8.8987 12.3389Z",
        fill: "currentColor"
      }));
    }]]),
    r = function r(e) {
      var t = e.iconClass,
        r = e.iconName,
        n = e.titleText,
        a = e.iconSize,
        o = void 0 === a ? "20" : a,
        i = e.viewBox,
        c = void 0 === i ? "20" : i;
      return /*#__PURE__*/React.createElement("svg", {
        role: "graphics-symbol",
        xmlns: "http://www.w3.org/2000/svg",
        width: o,
        height: o,
        viewBox: "0 0 " + c + " " + c,
        className: t
      }, /*#__PURE__*/React.createElement("title", null, n), function (C) {
        return l.get(C)();
      }(r));
    };
  r.displayName = "BiomeIcon", function (C) {
    C[C.Admin = 0] = "Admin", C[C.Briefcase = 1] = "Briefcase", C[C.CaseList = 2] = "CaseList", C[C.Classfication = 3] = "Classfication", C[C.CodingQuality = 4] = "CodingQuality", C[C.Documents = 5] = "Documents", C[C.Filters = 6] = "Filters", C[C.Insights = 7] = "Insights", C[C.Providers = 8] = "Providers", C[C.Search = 9] = "Search", C[C.Tables = 10] = "Tables", C[C.AddUsers = 11] = "AddUsers", C[C.Worklist = 12] = "Worklist", C[C.WorklistConfig = 13] = "WorklistConfig";
  }(t$1 || (t$1 = {}));
  new Map([[t$1.Admin, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M19.7781 30H16.8781C16.6557 30 16.4501 29.9221 16.2613 29.7664C16.0725 29.6112 15.9557 29.4112 15.9109 29.1664L15.5109 26.1664C15.0443 26.0331 14.5333 25.8109 13.9781 25.5C13.4224 25.1891 12.9557 24.8557 12.5781 24.5L9.84453 25.7336C9.60027 25.8221 9.36133 25.8277 9.12773 25.7504C8.89467 25.6725 8.7224 25.5224 8.61093 25.3L7.11093 22.7336C7 22.5112 6.97227 22.2832 7.02773 22.0496C7.0832 21.8165 7.21093 21.6221 7.41093 21.4664L9.84453 19.6664C9.80027 19.3997 9.76133 19.1221 9.72773 18.8336C9.69467 18.5445 9.67813 18.2779 9.67813 18.0336C9.67813 17.7888 9.69467 17.5275 9.72773 17.2496C9.76133 16.9723 9.80027 16.6669 9.84453 16.3336L7.41093 14.5336C7.21093 14.3779 7.0832 14.1835 7.02773 13.9504C6.97227 13.7168 7 13.4888 7.11093 13.2664L8.61093 10.7336C8.74427 10.5336 8.92213 10.3891 9.14453 10.3C9.36693 10.2109 9.58907 10.2221 9.81093 10.3336L12.5445 11.5336C12.9888 11.1555 13.472 10.8165 13.9941 10.5168C14.5168 10.2165 15.0115 9.99973 15.4781 9.8664L15.9109 6.8336C15.9557 6.5888 16.0725 6.3888 16.2613 6.2336C16.4501 6.07787 16.6557 6 16.8781 6H19.7781C20.0224 6 20.2389 6.07787 20.4277 6.2336C20.6165 6.3888 20.7333 6.5888 20.7781 6.8336L21.1781 9.8664C21.7115 10.0664 22.2115 10.2944 22.6781 10.5504C23.1448 10.8059 23.6003 11.1336 24.0445 11.5336L26.8781 10.3336C27.1 10.2221 27.3277 10.2053 27.5613 10.2832C27.7944 10.3611 27.9667 10.5112 28.0781 10.7336L29.5781 13.2664C29.6891 13.4888 29.7224 13.7168 29.6781 13.9504C29.6333 14.1835 29.5 14.3779 29.2781 14.5336L26.7445 16.4C26.8336 16.6891 26.8837 16.9669 26.8949 17.2336C26.9056 17.5003 26.9109 17.7557 26.9109 18C26.9109 18.2224 26.9 18.4669 26.8781 18.7336C26.8557 19.0003 26.8112 19.3003 26.7445 19.6336L29.2445 21.4664C29.4445 21.5997 29.5723 21.7888 29.6277 22.0336C29.6832 22.2779 29.6443 22.5112 29.5109 22.7336L28.0445 25.3C27.9112 25.5224 27.728 25.6725 27.4949 25.7504C27.2613 25.8277 27.0333 25.8109 26.8109 25.7L24.0445 24.4664C23.6003 24.8445 23.1392 25.1835 22.6613 25.4832C22.1835 25.7835 21.6891 26.0003 21.1781 26.1336L20.7781 29.1664C20.7333 29.4112 20.6165 29.6112 20.4277 29.7664C20.2389 29.9221 20.0224 30 19.7781 30ZM18.2781 21.2336C19.1891 21.2336 19.9557 20.9224 20.5781 20.3C21.2 19.6776 21.5109 18.9109 21.5109 18C21.5109 17.0891 21.2 16.3224 20.5781 15.7C19.9557 15.0776 19.1891 14.7664 18.2781 14.7664C17.3891 14.7664 16.6277 15.0776 15.9941 15.7C15.3611 16.3224 15.0445 17.0891 15.0445 18C15.0445 18.9109 15.3611 19.6776 15.9941 20.3C16.6277 20.9224 17.3891 21.2336 18.2781 21.2336ZM18.2781 20.1C17.7 20.1 17.2053 19.8944 16.7941 19.4832C16.3835 19.072 16.1781 18.5776 16.1781 18C16.1781 17.4224 16.3835 16.928 16.7941 16.5168C17.2053 16.1056 17.7 15.9 18.2781 15.9C18.8781 15.9 19.3781 16.1056 19.7781 16.5168C20.1781 16.928 20.3781 17.4224 20.3781 18C20.3781 18.5776 20.1781 19.072 19.7781 19.4832C19.3781 19.8944 18.8781 20.1 18.2781 20.1ZM16.9781 28.8664H19.6781L20.1781 25.2C20.8448 25.0224 21.4613 24.7723 22.0277 24.4496C22.5947 24.1275 23.1669 23.6888 23.7445 23.1336L27.1109 24.6L28.4445 22.3L25.4781 20.0664C25.5667 19.6664 25.6333 19.3053 25.6781 18.9832C25.7224 18.6611 25.7445 18.3333 25.7445 18C25.7445 17.6443 25.7224 17.3109 25.6781 17C25.6333 16.6891 25.5667 16.3445 25.4781 15.9664L28.5109 13.7L27.1781 11.4L23.7109 12.8664C23.2891 12.3997 22.7448 11.9611 22.0781 11.5504C21.4115 11.1392 20.7669 10.8891 20.1445 10.8L19.7109 7.1336H16.9781L16.5445 10.7664C15.8555 10.9221 15.2221 11.1611 14.6445 11.4832C14.0669 11.8053 13.4891 12.2555 12.9109 12.8336L9.51093 11.4L8.17813 13.7L11.1781 15.9C11.0667 16.2109 10.9888 16.5443 10.9445 16.9C10.9003 17.2557 10.8781 17.6336 10.8781 18.0336C10.8781 18.3888 10.9003 18.7331 10.9445 19.0664C10.9888 19.3997 11.0555 19.7331 11.1445 20.0664L8.17813 22.3L9.51093 24.6L12.9109 23.1664C13.4224 23.7221 13.9725 24.1611 14.5613 24.4832C15.1501 24.8053 15.8112 25.0555 16.5445 25.2336L16.9781 28.8664Z",
        fill: "currentColor"
      }));
    }], [t$1.Briefcase, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M14.1 10.9V8.9328C14.1 8.39947 14.2888 7.944 14.6664 7.5664C15.0445 7.1888 15.5112 7 16.0664 7H19.9336C20.4888 7 20.9555 7.1888 21.3336 7.5664C21.7112 7.944 21.9 8.39947 21.9 8.9328V10.9H28.0664C28.5997 10.9 29.0555 11.0944 29.4336 11.4832C29.8112 11.872 30 12.3331 30 12.8664V26.4C30 26.9333 29.8112 27.3888 29.4336 27.7664C29.0555 28.144 28.5997 28.3328 28.0664 28.3328H7.9336C7.40027 28.3328 6.94453 28.144 6.5664 27.7664C6.1888 27.3888 6 26.9333 6 26.4V12.8664C6 12.3331 6.1888 11.872 6.5664 11.4832C6.94453 11.0944 7.40027 10.9 7.9336 10.9H14.1ZM15.2336 10.9H20.7664V8.9328C20.7664 8.7328 20.6832 8.5496 20.5168 8.3832C20.3499 8.21627 20.1555 8.1328 19.9336 8.1328H16.0664C15.8445 8.1328 15.6501 8.21627 15.4832 8.3832C15.3168 8.5496 15.2336 8.7328 15.2336 8.9328V10.9ZM28.8664 20.9H20.3664V21.7328C20.3664 21.9995 20.272 22.2275 20.0832 22.4168C19.8944 22.6056 19.6667 22.7 19.4 22.7H16.6C16.3333 22.7 16.1056 22.6 15.9168 22.4C15.728 22.2 15.6336 21.9667 15.6336 21.7V20.9H7.1336V26.4C7.1336 26.6 7.2168 26.7832 7.3832 26.9496C7.55013 27.1165 7.7336 27.2 7.9336 27.2H28.0664C28.2664 27.2 28.4499 27.1165 28.6168 26.9496C28.7832 26.7832 28.8664 26.6 28.8664 26.4V20.9ZM16.7664 21.5664H19.2336V19.1H16.7664V21.5664ZM7.1336 19.7664H15.6336V18.9328C15.6336 18.6661 15.7336 18.4384 15.9336 18.2496C16.1336 18.0608 16.3669 17.9664 16.6336 17.9664H19.4C19.6667 17.9664 19.8944 18.0608 20.0832 18.2496C20.272 18.4384 20.3664 18.6661 20.3664 18.9328V19.7664H28.8664V12.8664C28.8664 12.644 28.7832 12.4496 28.6168 12.2832C28.4499 12.1163 28.2664 12.0328 28.0664 12.0328H7.9336C7.7336 12.0328 7.55013 12.1163 7.3832 12.2832C7.2168 12.4496 7.1336 12.644 7.1336 12.8664V19.7664Z",
        fill: "currentColor"
      }));
    }], [t$1.CaseList, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9268 13.2582C10.9268 12.8992 11.2178 12.6082 11.5768 12.6082H24.459C24.818 12.6082 25.109 12.8992 25.109 13.2582C25.109 13.6171 24.818 13.9082 24.459 13.9082H11.5768C11.2178 13.9082 10.9268 13.6171 10.9268 13.2582Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9268 18.5711C10.9268 18.2122 11.2178 17.9211 11.5768 17.9211H24.459C24.818 17.9211 25.109 18.2122 25.109 18.5711C25.109 18.9301 24.818 19.2211 24.459 19.2211H11.5768C11.2178 19.2211 10.9268 18.9301 10.9268 18.5711Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.9268 23.884C10.9268 23.525 11.2178 23.234 11.5768 23.234H21.3243C21.6833 23.234 21.9743 23.525 21.9743 23.884C21.9743 24.243 21.6833 24.534 21.3243 24.534H11.5768C11.2178 24.534 10.9268 24.243 10.9268 23.884Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.0028 9.24666C18.3744 9.24666 18.6756 8.94543 18.6756 8.57385C18.6756 8.20227 18.3744 7.90104 18.0028 7.90104C17.6312 7.90104 17.33 8.20227 17.33 8.57385C17.33 8.94543 17.6312 9.24666 18.0028 9.24666ZM19.5288 9.87104C19.5281 9.8719 19.5274 9.87275 19.5266 9.87359H16.479C16.4783 9.87275 16.4775 9.8719 16.4768 9.87104H10C9.6134 9.87104 9.3 10.1844 9.3 10.571V26.571C9.3 26.9576 9.6134 27.271 10 27.271H26C26.3866 27.271 26.7 26.9576 26.7 26.571V10.571C26.7 10.1844 26.3866 9.87104 26 9.87104H19.5288ZM20.0056 8.57104H26C27.1046 8.57104 28 9.46648 28 10.571V26.571C28 27.6756 27.1046 28.571 26 28.571H10C8.89543 28.571 8 27.6756 8 26.571V10.571C8 9.46648 8.89543 8.57104 10 8.57104H16C16.0015 7.46622 16.8976 6.57104 18.0028 6.57104C19.108 6.57104 20.0041 7.46622 20.0056 8.57104Z",
        fill: "currentColor"
      }));
    }], [t$1.Classfication, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.7 5.60942V10.4994H21.3V5.60942H10.7ZM10.5 4.40942C9.94772 4.40942 9.5 4.85714 9.5 5.40942V10.6994C9.5 11.2516 9.94772 11.6994 10.5 11.6994H21.5C22.0523 11.6994 22.5 11.2516 22.5 10.6994V5.40942C22.5 4.85714 22.0523 4.40942 21.5 4.40942H10.5Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 27.2094C16.8283 27.2094 17.4997 26.538 17.4997 25.7098C17.4997 24.8815 16.8283 24.2101 16 24.2101C15.1718 24.2101 14.5003 24.8815 14.5003 25.7098C14.5003 26.538 15.1718 27.2094 16 27.2094ZM16 28.4094C17.491 28.4094 18.6997 27.2007 18.6997 25.7098C18.6997 24.2188 17.491 23.0101 16 23.0101C14.509 23.0101 13.3003 24.2188 13.3003 25.7098C13.3003 27.2007 14.509 28.4094 16 28.4094Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.3003 25.2094C24.1286 25.2094 24.8 24.538 24.8 23.7098C24.8 22.8815 24.1286 22.2101 23.3003 22.2101C22.4721 22.2101 21.8006 22.8815 21.8006 23.7098C21.8006 24.538 22.4721 25.2094 23.3003 25.2094ZM23.3003 26.4094C24.7913 26.4094 26 25.2007 26 23.7098C26 22.2188 24.7913 21.0101 23.3003 21.0101C21.8093 21.0101 20.6006 22.2188 20.6006 23.7098C20.6006 25.2007 21.8093 26.4094 23.3003 26.4094Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.69968 25.2094C9.52793 25.2094 10.1994 24.538 10.1994 23.7098C10.1994 22.8815 9.52793 22.2101 8.69968 22.2101C7.87143 22.2101 7.2 22.8815 7.2 23.7098C7.2 24.538 7.87143 25.2094 8.69968 25.2094ZM8.69968 26.4094C10.1907 26.4094 11.3994 25.2007 11.3994 23.7098C11.3994 22.2188 10.1907 21.0101 8.69968 21.0101C7.20869 21.0101 6 22.2188 6 23.7098C6 25.2007 7.20869 26.4094 8.69968 26.4094Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 12.5361C16.3314 12.5361 16.6 12.8047 16.6 13.1361V21.5329C16.6 21.8643 16.3314 22.1329 16 22.1329C15.6686 22.1329 15.4 21.8643 15.4 21.5329V13.1361C15.4 12.8047 15.6686 12.5361 16 12.5361Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.63946 16.3402C9.41855 16.3402 9.23946 16.5192 9.23946 16.7402V19.3009C9.23946 19.6322 8.97083 19.9009 8.63946 19.9009C8.30809 19.9009 8.03946 19.6322 8.03946 19.3009V16.7402C8.03946 15.8565 8.7558 15.1402 9.63946 15.1402H22.3605C23.2442 15.1402 23.9605 15.8565 23.9605 16.7402V19.3009C23.9605 19.6322 23.6919 19.9009 23.3605 19.9009C23.0292 19.9009 22.7605 19.6322 22.7605 19.3009V16.7402C22.7605 16.5192 22.5814 16.3402 22.3605 16.3402H9.63946Z",
        fill: "currentColor"
      }));
    }], [t$1.CodingQuality, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75635 26.6428L9.75637 26.6428C10.0223 26.4679 10.3336 26.3747 10.6519 26.3747H28C28.37 26.3747 28.67 26.0747 28.67 25.7047V11.7047C28.67 11.3347 28.37 11.0347 28 11.0347H8C7.62997 11.0347 7.33 11.3347 7.33 11.7047V28.2383L9.75635 26.6428ZM8 9.70471H28C29.1046 9.70471 30 10.6001 30 11.7047V25.7047C30 26.8093 29.1046 27.7047 28 27.7047H10.6519C10.5934 27.7047 10.5361 27.7219 10.4871 27.7541L7.54944 29.6858C6.88449 30.1231 6 29.6461 6 28.8503V11.7047C6 10.6001 6.89543 9.70471 8 9.70471Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 14.0347C18.7215 14.0347 19.4048 14.1983 20.0147 14.4905L20.8079 13.4009C19.9701 12.9565 19.0144 12.7047 18 12.7047C14.6863 12.7047 12 15.391 12 18.7047C12 22.0184 14.6863 24.7047 18 24.7047C21.3137 24.7047 24 22.0184 24 18.7047C24 17.8943 23.8393 17.1214 23.5481 16.4162L22.5734 17.7552C22.6367 18.0618 22.67 18.3794 22.67 18.7047C22.67 21.2839 20.5792 23.3747 18 23.3747C15.4208 23.3747 13.33 21.2839 13.33 18.7047C13.33 16.1255 15.4208 14.0347 18 14.0347ZM21.121 15.2307C21.121 15.2307 21.121 15.2307 21.121 15.2307L21.907 14.1509C21.907 14.1509 21.907 14.1509 21.907 14.1509L22.71 13.0478C22.9261 12.7509 23.3421 12.6854 23.639 12.9015C23.9359 13.1177 24.0014 13.5336 23.7853 13.8305L18.4184 21.2033C18.1116 21.6247 17.4825 21.6226 17.1785 21.1992L15.0403 18.221C14.8261 17.9227 14.8943 17.5072 15.1926 17.293C15.491 17.0788 15.9065 17.147 16.1207 17.4453L17.8031 19.7887L21.121 15.2307Z",
        fill: "currentColor"
      }));
    }], [t$1.Documents, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M11.8871 12.9752C12.1625 12.9752 12.4127 12.8627 12.6377 12.6377C12.8627 12.4127 12.9752 12.1625 12.9752 11.8871C12.9752 11.5871 12.8627 11.3309 12.6377 11.1185C12.4127 10.9061 12.1625 10.7999 11.8871 10.7999C11.5871 10.7999 11.3309 10.9061 11.1185 11.1185C10.9061 11.3309 10.7999 11.5871 10.7999 11.8871C10.7999 12.1625 10.9061 12.4127 11.1185 12.6377C11.3309 12.8627 11.5871 12.9752 11.8871 12.9752ZM11.8871 19.0871C12.1625 19.0871 12.4127 18.9809 12.6377 18.7685C12.8627 18.5561 12.9752 18.2999 12.9752 17.9999C12.9752 17.6999 12.8627 17.4437 12.6377 17.2313C12.4127 17.0189 12.1625 16.9127 11.8871 16.9127C11.5871 16.9127 11.3309 17.0189 11.1185 17.2313C10.9061 17.4437 10.7999 17.6999 10.7999 17.9999C10.7999 18.2999 10.9061 18.5561 11.1185 18.7685C11.3309 18.9809 11.5871 19.0871 11.8871 19.0871ZM11.8871 25.1999C12.1625 25.1999 12.4127 25.0937 12.6377 24.8813C12.8627 24.6689 12.9752 24.4127 12.9752 24.1127C12.9752 23.8373 12.8627 23.5871 12.6377 23.3621C12.4127 23.1371 12.1625 23.0246 11.8871 23.0246C11.5871 23.0246 11.3309 23.1371 11.1185 23.3621C10.9061 23.5871 10.7999 23.8373 10.7999 24.1127C10.7999 24.4127 10.9061 24.6689 11.1185 24.8813C11.3309 25.0937 11.5871 25.1999 11.8871 25.1999ZM8.17464 29.9996C7.57464 29.9996 7.06224 29.7872 6.63744 29.3624C6.21264 28.9376 6.00024 28.4252 6.00024 27.8252V8.17464C6.00024 7.57464 6.21264 7.06224 6.63744 6.63744C7.06224 6.21264 7.57464 6.00024 8.17464 6.00024H23.3999L29.9996 12.5999V27.8252C29.9996 28.4252 29.7872 28.9376 29.3624 29.3624C28.9376 29.7872 28.4252 29.9996 27.8252 29.9996H8.17464ZM8.17464 28.7252H27.8252C28.0748 28.7252 28.2872 28.6376 28.4624 28.4624C28.6376 28.2872 28.7252 28.0748 28.7252 27.8252V13.3874H23.6996C23.3996 13.3874 23.1434 13.2812 22.931 13.0688C22.7186 12.8564 22.6124 12.6002 22.6124 12.3002V7.27464H8.17464C7.92504 7.27464 7.71264 7.36224 7.53744 7.53744C7.36224 7.71264 7.27464 7.92504 7.27464 8.17464V27.8252C7.27464 28.0748 7.36224 28.2872 7.53744 28.4624C7.71264 28.6376 7.92504 28.7252 8.17464 28.7252ZM7.27464 13.3874V28.7252V7.27464V13.3874Z",
        fill: "currentColor"
      }));
    }], [t$1.Filters, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M6.60055 27.1412C6.43566 27.1412 6.29449 27.0822 6.17703 26.9642C6.05901 26.8468 6 26.7056 6 26.5407C6 26.3764 6.05901 26.2352 6.17703 26.1172C6.29449 25.9997 6.43566 25.941 6.60055 25.941H12.5298C12.6941 25.941 12.8353 25.9997 12.9533 26.1172C13.0708 26.2352 13.1295 26.3764 13.1295 26.5407C13.1295 26.7293 13.0708 26.8764 12.9533 26.982C12.8353 27.0882 12.6941 27.1412 12.5298 27.1412H6.60055ZM6.60055 10.059C6.43566 10.059 6.29449 10.0003 6.17703 9.88283C6.05901 9.76481 6 9.62363 6 9.45931C6 9.2707 6.05901 9.1236 6.17703 9.018C6.29449 8.91184 6.43566 8.85876 6.60055 8.85876H18.2473C18.4117 8.85876 18.5528 8.91777 18.6709 9.03579C18.7883 9.15324 18.847 9.29442 18.847 9.45931C18.847 9.62363 18.7883 9.76481 18.6709 9.88283C18.5528 10.0003 18.4117 10.059 18.2473 10.059H6.60055ZM17.7527 30C17.5646 30 17.4178 29.941 17.3122 29.823C17.206 29.7055 17.153 29.5643 17.153 29.3995V23.6819C17.153 23.5408 17.2117 23.4055 17.3291 23.2762C17.4472 23.1469 17.5883 23.0822 17.7527 23.0822C17.9176 23.0822 18.0587 23.1469 18.1762 23.2762C18.2942 23.4055 18.3532 23.5408 18.3532 23.6819V25.941H29.3995C29.5643 25.941 29.7055 25.9997 29.823 26.1172C29.941 26.2352 30 26.3764 30 26.5407C30 26.7293 29.941 26.8764 29.823 26.982C29.7055 27.0882 29.5643 27.1412 29.3995 27.1412H18.3532V29.3995C18.3532 29.5643 18.2942 29.7055 18.1762 29.823C18.0587 29.941 17.9176 30 17.7527 30ZM12.5298 21.4585C12.3649 21.4585 12.2238 21.3997 12.1063 21.2823C11.9883 21.1648 11.9293 21.0236 11.9293 20.8588V18.5997H6.60055C6.43566 18.5997 6.29449 18.541 6.17703 18.4235C6.05901 18.3061 6 18.1649 6 18C6 17.8351 6.05901 17.6939 6.17703 17.5765C6.29449 17.459 6.43566 17.4003 6.60055 17.4003H11.9293V15.1412C11.9293 14.9764 11.9883 14.8352 12.1063 14.7177C12.2238 14.6003 12.3649 14.5415 12.5298 14.5415C12.7179 14.5415 12.8647 14.6003 12.9703 14.7177C13.0764 14.8352 13.1295 14.9764 13.1295 15.1412V20.8588C13.1295 21.0236 13.0708 21.1648 12.9533 21.2823C12.8353 21.3997 12.6941 21.4585 12.5298 21.4585ZM17.7527 18.5997C17.5883 18.5997 17.4472 18.541 17.3291 18.4235C17.2117 18.3061 17.153 18.1649 17.153 18C17.153 17.8351 17.2117 17.6939 17.3291 17.5765C17.4472 17.459 17.5883 17.4003 17.7527 17.4003H29.3995C29.5643 17.4003 29.7055 17.459 29.823 17.5765C29.941 17.6939 30 17.8351 30 18C30 18.1649 29.941 18.3061 29.823 18.4235C29.7055 18.541 29.5643 18.5997 29.3995 18.5997H17.7527ZM23.4702 12.8822C23.2821 12.8822 23.1353 12.8235 23.0297 12.706C22.9236 12.5886 22.8705 12.4474 22.8705 12.2825V6.60055C22.8705 6.43566 22.9292 6.29449 23.0467 6.17703C23.1647 6.05901 23.3059 6 23.4702 6C23.6351 6 23.7762 6.05901 23.8937 6.17703C24.0117 6.29449 24.0707 6.43566 24.0707 6.60055V8.85876H29.3995C29.5643 8.85876 29.7055 8.91777 29.823 9.03579C29.941 9.15324 30 9.29442 30 9.45931C30 9.62363 29.941 9.76481 29.823 9.88283C29.7055 10.0003 29.5643 10.059 29.3995 10.059H24.0707V12.2825C24.0707 12.4474 24.0117 12.5886 23.8937 12.706C23.7762 12.8235 23.6351 12.8822 23.4702 12.8822Z",
        fill: "currentColor"
      }));
    }], [t$1.Insights, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.67588 23.2029C7.03486 23.2029 7.32588 23.4939 7.32588 23.8529L7.32588 29.895C7.32588 30.254 7.03486 30.545 6.67588 30.545C6.31689 30.545 6.02588 30.254 6.02588 29.895L6.02588 23.8529C6.02588 23.4939 6.31689 23.2029 6.67588 23.2029Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.338 18.1691C12.697 18.1691 12.988 18.4601 12.988 18.8191L12.988 29.895C12.988 30.254 12.697 30.545 12.338 30.545C11.979 30.545 11.688 30.254 11.688 29.895L11.688 18.8191C11.688 18.4601 11.979 18.1691 12.338 18.1691Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.0001 19.9805C18.3591 19.9805 18.6501 20.2715 18.6501 20.6305L18.6501 29.895C18.6501 30.254 18.3591 30.545 18.0001 30.545C17.6411 30.545 17.3501 30.254 17.3501 29.895L17.3501 20.6305C17.3501 20.2715 17.6411 19.9805 18.0001 19.9805Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.6625 18.3486C24.0214 18.3486 24.3125 18.6396 24.3125 18.9986L24.3125 29.8949C24.3125 30.2539 24.0214 30.5449 23.6625 30.5449C23.3035 30.5449 23.0125 30.2539 23.0125 29.8949L23.0125 18.9986C23.0125 18.6396 23.3035 18.3486 23.6625 18.3486Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.3246 13.4729C29.6835 13.4729 29.9746 13.7639 29.9746 14.1229L29.9746 29.895C29.9746 30.254 29.6835 30.545 29.3246 30.545C28.9656 30.545 28.6746 30.254 28.6746 29.895L28.6746 14.1229C28.6746 13.7639 28.9656 13.4729 29.3246 13.4729Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M29.7823 6.83188C30.0372 7.08465 30.0389 7.4962 29.7862 7.75111L20.4278 17.1886C20.1766 17.442 19.7681 17.4454 19.5126 17.1964L13.9622 11.787L7.14155 18.7908C6.89109 19.048 6.47957 19.0534 6.22239 18.803C5.96521 18.5525 5.95976 18.141 6.21021 17.8838L13.4845 10.4141C13.6048 10.2906 13.7693 10.2199 13.9417 10.2177C14.1141 10.2154 14.2804 10.2818 14.4039 10.4021L19.9585 15.8157L28.8631 6.83575C29.1158 6.58085 29.5274 6.57911 29.7823 6.83188Z",
        fill: "currentColor"
      }));
    }], [t$1.Providers, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23.865 7.97847H8.52979C8.14319 7.97847 7.82979 8.29187 7.82979 8.67847V24.0137C7.82979 24.4003 8.14319 24.7137 8.52979 24.7137H11.797C11.598 25.1282 11.4635 25.5636 11.3952 26.0137H8.52979C7.42522 26.0137 6.52979 25.1183 6.52979 24.0137V8.67847C6.52979 7.5739 7.42522 6.67847 8.52979 6.67847H23.865C24.9696 6.67847 25.865 7.5739 25.865 8.67847V11.687C25.4604 11.3548 25.0257 11.083 24.565 10.8726V8.67847C24.565 8.29187 24.2516 7.97847 23.865 7.97847ZM20.357 10.5597H9.98765C9.62866 10.5597 9.33765 10.8507 9.33765 11.2097C9.33765 11.5687 9.62866 11.8597 9.98765 11.8597H17.9962C18.6943 11.236 19.4886 10.8006 20.357 10.5597ZM15.9922 15.6961H9.98766C9.62868 15.6961 9.33766 15.9871 9.33766 16.3461C9.33766 16.7051 9.62868 16.9961 9.98766 16.9961H15.9783C15.9615 16.8054 15.9531 16.612 15.9531 16.416C15.9531 16.1719 15.9661 15.9318 15.9922 15.6961ZM17.8445 20.8324H9.98766C9.62868 20.8324 9.33766 21.1234 9.33766 21.4824C9.33766 21.8414 9.62868 22.1324 9.98766 22.1324H14.7973C15.1514 21.9617 15.491 21.8139 15.8145 21.692C16.4851 21.4393 17.2672 21.2437 18.1308 21.0893C18.0336 21.0072 17.9381 20.9216 17.8445 20.8324Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.0366 19.1944C23.5711 19.1944 24.815 17.9505 24.815 16.416C24.815 14.8816 23.5711 13.6376 22.0366 13.6376C20.5022 13.6376 19.2583 14.8816 19.2583 16.416C19.2583 17.9505 20.5022 19.1944 22.0366 19.1944ZM22.0366 20.4944C24.289 20.4944 26.115 18.6684 26.115 16.416C26.115 14.1636 24.289 12.3376 22.0366 12.3376C19.7842 12.3376 17.9583 14.1636 17.9583 16.416C17.9583 18.6684 19.7842 20.4944 22.0366 20.4944Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.0436 28.0697L19.1365 24.4052L19.1199 24.3823C19.0961 24.3494 19.078 24.3266 19.0651 24.3113C19.0142 24.3056 18.9037 24.3016 18.7044 24.3291C18.3242 24.3816 17.613 24.5534 16.8661 24.8253C16.0988 25.1047 15.4575 25.4315 15.1117 25.7283C14.6755 26.1027 14.6672 26.6001 14.6672 26.7503V29.3794C14.6689 29.3794 14.6706 29.3794 14.6723 29.3794C14.9907 29.3794 15.8156 29.3802 16.8364 29.3811C17.1559 29.3814 17.4946 29.3817 17.843 29.382C19.3053 29.3833 20.9389 29.3845 22.0436 29.3845C23.1484 29.3845 24.782 29.3833 26.2442 29.382C26.5926 29.3817 26.9313 29.3814 27.2509 29.3811C28.2717 29.3802 29.0965 29.3794 29.4149 29.3794C29.4167 29.3794 29.4184 29.3794 29.42 29.3794V26.7503C29.42 26.6001 29.4117 26.1027 28.9755 25.7283C28.6297 25.4315 27.9884 25.1047 27.2211 24.8253C26.4742 24.5534 25.763 24.3816 25.3829 24.3291C25.1835 24.3016 25.073 24.3056 25.0221 24.3113C25.0092 24.3266 24.9912 24.3494 24.9674 24.3823L24.9508 24.4052L22.0436 28.0697ZM24.9868 24.3172C24.9868 24.3172 24.9875 24.317 24.9889 24.3166ZM19.1005 24.3172C19.1004 24.3172 19.0997 24.317 19.0983 24.3166ZM20.1725 23.6194C19.8621 23.1911 19.5112 22.9054 18.5265 23.0414C17.5419 23.1773 15.3179 23.8383 14.2651 24.7418C13.3672 25.5124 13.3672 26.5345 13.3672 26.7503V29.5503C13.3672 29.8495 13.6642 30.6794 14.6723 30.6794C14.99 30.6794 15.8133 30.6802 16.8332 30.6811C18.4933 30.6826 20.6742 30.6845 22.0436 30.6845C23.413 30.6845 25.594 30.6826 27.254 30.6811C28.274 30.6802 29.0973 30.6794 29.4149 30.6794C30.423 30.6794 30.72 29.8495 30.72 29.5503V26.7503C30.72 26.5345 30.72 25.5124 29.8221 24.7418C28.7693 23.8383 26.5454 23.1773 25.5607 23.0414C24.5761 22.9054 24.2252 23.1911 23.9148 23.6194L22.0436 25.978L20.1725 23.6194Z",
        fill: "currentColor"
      }));
    }], [t$1.Search, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22.3257 15.4073C22.3257 19.5482 18.9688 22.9051 14.8278 22.9051C10.6869 22.9051 7.33 19.5482 7.33 15.4073C7.33 11.2664 10.6869 7.90947 14.8278 7.90947C18.9688 7.90947 22.3257 11.2664 22.3257 15.4073ZM20.5331 22.1441C18.9944 23.4485 17.003 24.2351 14.8278 24.2351C9.95236 24.2351 6 20.2828 6 15.4073C6 10.5318 9.95236 6.57947 14.8278 6.57947C19.7033 6.57947 23.6557 10.5318 23.6557 15.4073C23.6557 17.6397 22.8271 19.6785 21.4606 21.233L29.8056 29.4495C30.0614 29.7013 30.0646 30.1129 29.8127 30.3687C29.5608 30.6245 29.1493 30.6277 28.8935 30.3758L20.5331 22.1441Z",
        fill: "currentColor"
      }));
    }], [t$1.Tables, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M27.9526 29.5879H8.04652C7.48181 29.5879 6.99954 29.388 6.59972 28.9882C6.19991 28.5884 6 28.0943 6 27.5058V9.04652C6 8.48181 6.19991 7.99954 6.59972 7.59972C6.99954 7.19991 7.48181 7 8.04652 7H27.9526C28.5173 7 28.9999 7.19991 29.4003 7.59972C29.8001 7.99954 30 8.48181 30 9.04652V27.5058C30 28.0943 29.8001 28.5884 29.4003 28.9882C28.9999 29.388 28.5173 29.5879 27.9526 29.5879ZM7.19945 13.353H28.7997V9.04652C28.7997 8.83475 28.7116 8.64077 28.5354 8.46458C28.3587 8.28783 28.1644 8.19945 27.9526 8.19945H8.04652C7.83475 8.19945 7.64077 8.28783 7.46458 8.46458C7.28783 8.64077 7.19945 8.83475 7.19945 9.04652V13.353ZM12.2819 14.5525H7.19945V27.5058C7.19945 27.7413 7.28783 27.9472 7.46458 28.1234C7.64077 28.3001 7.83475 28.3885 8.04652 28.3885H12.2819V14.5525ZM23.7173 14.5525V28.3885H27.9526C28.1644 28.3885 28.3587 28.3001 28.5354 28.1234C28.7116 27.9472 28.7997 27.7413 28.7997 27.5058V14.5525H23.7173ZM22.5178 14.5525H13.4822V28.3885H22.5178V14.5525Z",
        fill: "currentColor"
      }));
    }], [t$1.AddUsers, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M25.9026 19.337C25.7658 19.337 25.6488 19.2883 25.5514 19.1909C25.454 19.093 25.4053 18.9759 25.4053 18.8397V15.7369H22.3025C22.1658 15.7369 22.0487 15.6882 21.9513 15.5908C21.8539 15.4929 21.8052 15.3759 21.8052 15.2396C21.8052 15.1029 21.8539 14.9858 21.9513 14.8884C22.0487 14.7905 22.1658 14.7416 22.3025 14.7416H25.4053V11.6395C25.4053 11.5028 25.454 11.3857 25.5514 11.2883C25.6488 11.1904 25.7658 11.1415 25.9026 11.1415C26.0393 11.1415 26.1564 11.1904 26.2538 11.2883C26.3512 11.3857 26.3999 11.5028 26.3999 11.6395V14.7416H29.5027C29.6394 14.7416 29.7565 14.7905 29.8539 14.8884C29.9513 14.9858 30 15.1029 30 15.2396C30 15.3759 29.9513 15.4929 29.8539 15.5908C29.7565 15.6882 29.6394 15.7369 29.5027 15.7369H26.3999V18.8397C26.3999 18.9759 26.3512 19.093 26.2538 19.1909C26.1564 19.2883 26.0393 19.337 25.9026 19.337ZM14.1948 16.8489C13.2193 16.8489 12.4047 16.522 11.751 15.8683C11.0972 15.215 10.7704 14.4004 10.7704 13.4245C10.7704 12.449 11.0972 11.6344 11.751 10.9806C12.4047 10.3269 13.2193 10 14.1948 10C15.1708 10 15.9854 10.3269 16.6386 10.9806C17.2924 11.6344 17.6193 12.449 17.6193 13.4245C17.6193 14.4004 17.2924 15.215 16.6386 15.8683C15.9854 16.522 15.1708 16.8489 14.1948 16.8489ZM6.84856 25.3374C6.61441 25.3374 6.41445 25.2545 6.24867 25.0887C6.08289 24.9224 6 24.7126 6 24.4593V23.5517C6 23.0637 6.14143 22.61 6.42428 22.1904C6.70714 21.7712 7.09255 21.4446 7.58052 21.2104C8.77047 20.6836 9.90212 20.2933 10.9755 20.0395C12.0488 19.7856 13.1219 19.6587 14.1948 19.6587C15.2682 19.6587 16.3415 19.7856 17.4149 20.0395C18.4877 20.2933 19.6096 20.6836 20.7803 21.2104C21.2879 21.4638 21.6832 21.7954 21.966 22.2051C22.2489 22.6149 22.3903 23.0637 22.3903 23.5517V24.4593C22.3903 24.7126 22.3074 24.9224 22.1417 25.0887C21.9759 25.2545 21.7759 25.3374 21.5418 25.3374H6.84856ZM6.99467 24.342H21.395V23.5517C21.395 23.2787 21.3071 23.0104 21.1315 22.7467C20.9559 22.4835 20.6925 22.2641 20.3413 22.0885C19.2876 21.5809 18.2632 21.2149 17.268 20.9906C16.2729 20.7663 15.2485 20.6541 14.1948 20.6541C13.1411 20.6541 12.1167 20.7663 11.1216 20.9906C10.1264 21.2149 9.10203 21.5809 8.04835 22.0885C7.69713 22.2641 7.43371 22.4835 7.25809 22.7467C7.08248 23.0104 6.99467 23.2787 6.99467 23.5517V24.342ZM14.1948 15.8542C14.8781 15.8542 15.4538 15.6201 15.9221 15.1518C16.3904 14.6835 16.6246 14.1077 16.6246 13.4245C16.6246 12.7417 16.3904 12.1661 15.9221 11.6978C15.4538 11.2295 14.8781 10.9954 14.1948 10.9954C13.512 10.9954 12.9365 11.2295 12.4682 11.6978C11.9999 12.1661 11.7657 12.7417 11.7657 13.4245C11.7657 14.1077 11.9999 14.6835 12.4682 15.1518C12.9365 15.6201 13.512 15.8542 14.1948 15.8542Z",
        fill: "currentColor"
      }));
    }], [t$1.Worklist, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M28 9.87104H8C7.6134 9.87104 7.3 10.1844 7.3 10.571V26.571C7.3 26.9576 7.6134 27.271 8 27.271H28C28.3866 27.271 28.7 26.9576 28.7 26.571V10.571C28.7 10.1844 28.3866 9.87104 28 9.87104ZM8 8.57104C6.89543 8.57104 6 9.46648 6 10.571V26.571C6 27.6756 6.89543 28.571 8 28.571H28C29.1046 28.571 30 27.6756 30 26.571V10.571C30 9.46648 29.1046 8.57104 28 8.57104H8Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.04297 18.571C9.04297 18.212 9.33398 17.921 9.69297 17.921H15.693C16.052 17.921 16.343 18.212 16.343 18.571C16.343 18.93 16.052 19.221 15.693 19.221H9.69297C9.33398 19.221 9.04297 18.93 9.04297 18.571Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.04297 23.7694C9.04297 23.4104 9.33398 23.1194 9.69297 23.1194H15.693C16.052 23.1194 16.343 23.4104 16.343 23.7694C16.343 24.1284 16.052 24.4194 15.693 24.4194H9.69297C9.33398 24.4194 9.04297 24.1284 9.04297 23.7694Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.04297 13.3727C9.04297 13.0137 9.33398 12.7227 9.69297 12.7227H15.693C16.052 12.7227 16.343 13.0137 16.343 13.3727C16.343 13.7316 16.052 14.0227 15.693 14.0227H9.69297C9.33398 14.0227 9.04297 13.7316 9.04297 13.3727Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.798 16.0369C27.0445 16.2979 27.0327 16.7093 26.7717 16.9558L22.3507 21.1313C22.0949 21.3728 21.6935 21.3671 21.4447 21.1183L19.4184 19.092C19.1646 18.8382 19.1646 18.4266 19.4184 18.1728C19.6722 17.9189 20.0838 17.9189 20.3376 18.1728L21.9173 19.7524L25.8791 16.0107C26.1401 15.7642 26.5515 15.776 26.798 16.0369Z",
        fill: "currentColor"
      }));
    }], [t$1.WorklistConfig, function () {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
        d: "M26.2442 27.5785C26.3689 27.4358 26.4517 27.2673 26.4927 27.0729C26.5336 26.8785 26.5541 26.6768 26.5541 26.4679V24.7013C26.5541 24.0076 26.3847 23.3011 26.0458 22.582C25.7069 21.8628 25.1902 21.2527 24.4957 20.7518C25.3236 20.8694 26.0821 21.0515 26.7713 21.2981C27.4604 21.5446 28.1371 21.8361 28.8015 22.1723C29.428 22.4965 29.8578 22.8836 30.0907 23.3334C30.3237 23.7833 30.4402 24.3274 30.4402 24.9659V26.4565C30.4402 26.7578 30.3285 27.0201 30.1052 27.2434C29.8818 27.4668 29.6195 27.5785 29.3183 27.5785H26.2442ZM25.5067 14.4747C25.5067 15.646 25.1134 16.625 24.3268 17.4116C23.5402 18.1982 22.564 18.5915 21.3983 18.5915C21.26 18.5915 21.0638 18.5715 20.8097 18.5316C20.5556 18.4916 20.3622 18.4535 20.2295 18.4173C20.6738 17.8597 21.0205 17.2452 21.2696 16.5739C21.5187 15.9027 21.6432 15.2056 21.6432 14.4828C21.6432 13.7599 21.5162 13.0656 21.2621 12.4C21.008 11.7343 20.6638 11.1215 20.2295 10.5614C20.418 10.501 20.6163 10.452 20.8244 10.4143C21.0325 10.3766 21.2244 10.3578 21.4002 10.3578C22.5646 10.3578 23.5402 10.7511 24.3268 11.5377C25.1134 12.3243 25.5067 13.3033 25.5067 14.4747Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3502 17.2915C16.9059 17.2915 18.1671 16.0303 18.1671 14.4746C18.1671 12.9189 16.9059 11.6578 15.3502 11.6578C13.7945 11.6578 12.5334 12.9189 12.5334 14.4746C12.5334 16.0303 13.7945 17.2915 15.3502 17.2915ZM15.3502 18.5915C17.6239 18.5915 19.4671 16.7483 19.4671 14.4746C19.4671 12.201 17.6239 10.3578 15.3502 10.3578C13.0766 10.3578 11.2334 12.201 11.2334 14.4746C11.2334 16.7483 13.0766 18.5915 15.3502 18.5915Z",
        fill: "currentColor"
      }), /*#__PURE__*/React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.298 21.8226L15.2717 21.8221C13.4354 21.7849 10.8562 22.2484 8.43679 23.5263C8.0747 23.7175 7.74019 24.2133 7.74019 24.8304V26.3003C7.76152 26.302 7.78666 26.3032 7.81597 26.3032H22.8885C22.9178 26.3032 22.943 26.302 22.9643 26.3003V24.8304C22.9643 24.2133 22.6298 23.7175 22.2677 23.5263C19.8552 22.2521 17.1703 21.7847 15.3243 21.8221L15.298 21.8226ZM7.82964 22.3768C10.4542 20.9905 13.2531 20.4809 15.298 20.5223C17.3442 20.4809 20.2502 20.9905 22.8749 22.3768C23.7068 22.8162 24.2643 23.7828 24.2643 24.8304V26.4238C24.2643 26.9386 23.9274 27.6032 22.8885 27.6032H7.81597C6.77712 27.6032 6.44019 26.9386 6.44019 26.4238V24.8304C6.44019 23.7828 6.99769 22.8162 7.82964 22.3768Z",
        fill: "currentColor"
      }));
    }]]);

  var classnames$1 = {exports: {}};

  /*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  */

  var hasRequiredClassnames;

  function requireClassnames () {
  	if (hasRequiredClassnames) return classnames$1.exports;
  	hasRequiredClassnames = 1;
  	(function (module) {
  		/* global define */

  		(function () {

  			var hasOwn = {}.hasOwnProperty;

  			function classNames () {
  				var classes = '';

  				for (var i = 0; i < arguments.length; i++) {
  					var arg = arguments[i];
  					if (arg) {
  						classes = appendClass(classes, parseValue(arg));
  					}
  				}

  				return classes;
  			}

  			function parseValue (arg) {
  				if (typeof arg === 'string' || typeof arg === 'number') {
  					return arg;
  				}

  				if (typeof arg !== 'object') {
  					return '';
  				}

  				if (Array.isArray(arg)) {
  					return classNames.apply(null, arg);
  				}

  				if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
  					return arg.toString();
  				}

  				var classes = '';

  				for (var key in arg) {
  					if (hasOwn.call(arg, key) && arg[key]) {
  						classes = appendClass(classes, key);
  					}
  				}

  				return classes;
  			}

  			function appendClass (value, newClass) {
  				if (!newClass) {
  					return value;
  				}
  			
  				if (value) {
  					return value + ' ' + newClass;
  				}
  			
  				return value + newClass;
  			}

  			if (module.exports) {
  				classNames.default = classNames;
  				module.exports = classNames;
  			} else {
  				window.classNames = classNames;
  			}
  		}()); 
  	} (classnames$1));
  	return classnames$1.exports;
  }

  var classnamesExports = requireClassnames();
  var classnames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

  var _excluded$l = ["isAttached", "label", "iconName", "className", "actionsState"];
  var DEFAULT_BUTTON_ACTION_STATE = {
    visible: true,
    enabled: true
  };
  var ButtonIcon = function ButtonIcon(props) {
    var isAttached = props.isAttached,
      label = props.label,
      iconName = props.iconName,
      className = props.className,
      _props$actionsState = props.actionsState,
      actionsState = _props$actionsState === void 0 ? DEFAULT_BUTTON_ACTION_STATE : _props$actionsState,
      spreadable = _objectWithoutProperties(props, _excluded$l);
    if (!actionsState.visible) {
      // return an empty span - easier for ts to handle than
      // a false atm.
      return /*#__PURE__*/React.createElement("span", {
        key: label
      });
    }
    var classes = classnames(className, 'icon-button', {
      'icon-disabled': !actionsState.enabled,
      'icon-enabled': actionsState.enabled,
      'icon-visible': actionsState.visible
    });
    var title = actionsState.enabled ? "".concat(props.label) : "Unable to ".concat(props.label);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends$1({}, spreadable, {
      //as="a"
      mr: isAttached ? '-px' : undefined,
      isDisabled: !actionsState.enabled,
      className: classes,
      "aria-label": title,
      title: title
    }), /*#__PURE__*/React.createElement(r, {
      iconName: iconName
    })));
  };
  ButtonIcon.displayName = 'ButtonIcon';

  var _excluded$k = ["caseRun", "secondaryPrefix", "isPreGoLive", "groupedCases", "secondaryIndicatorVisibility", "includeBox"],
    _excluded2 = ["caseRun", "timeStamp", "isPreGoLive", "groupedCases", "secondaryPrefix", "billingGroupLoadState", "includeBox"];
  function ownKeys$M(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$M(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$M(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$M(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DefaultGroupedCases = {
    groupType: 'none',
    caseRuns: []
  };
  var DEFAULT_PROPS$9 = {
    groupedCases: _objectSpread$M({}, DefaultGroupedCases),
    secondaryPrefix: '',
    isPreGoLive: false,
    secondaryIndicatorVisibility: true
  };
  var getMiniStatus = function getMiniStatus(caseRun) {
    var _caseRun$case_uid, _caseRun$case_uid2;
    var statusDisplay = uiCommon.caseUtils.deriveStatus(caseRun);
    // TODO: CDS does not currently support exam_description
    // const description = caseRun.exam_description ?? '';
    var clinicalId = "".concat(caseRun.primary_clinical_identifier.number, " (").concat(caseRun.primary_clinical_identifier.issuer, ")");
    caseRun.case_type ? "- ".concat(caseRun.case_type) : '';
    var styleClasses = ['related-group-item', 'qa-related-group-item', statusDisplay.styleClass];
    return /*#__PURE__*/React.createElement("li", {
      className: classnames(styleClasses),
      key: caseRun.process_instance_id
    }, /*#__PURE__*/React.createElement("a", {
      className: "qa-related-group-item-link",
      href: "/cmx/cases/".concat(((_caseRun$case_uid = caseRun.case_uid) === null || _caseRun$case_uid === void 0 ? void 0 : _caseRun$case_uid.length) > 0 ? caseRun.case_uid : caseRun.case_id),
      "data-case-id": "".concat(((_caseRun$case_uid2 = caseRun.case_uid) === null || _caseRun$case_uid2 === void 0 ? void 0 : _caseRun$case_uid2.length) > 0 ? caseRun.case_uid : caseRun.case_id),
      title: "".concat(caseRun.exam_description)
    }, /*#__PURE__*/React.createElement("div", {
      className: "info-display"
    }, /*#__PURE__*/React.createElement("div", {
      className: "circle"
    }), statusDisplay.signifier), /*#__PURE__*/React.createElement("div", {
      className: "descriptive-text ellipsify"
    }, "".concat(caseRun.exam_description)), /*#__PURE__*/React.createElement("div", {
      className: "clinical-id sensitive-data"
    }, "#", clinicalId)));
  };
  var getBillingGroup$1 = function getBillingGroup(groupedCases) {
    var caseRuns = groupedCases.caseRuns;
    if (!caseRuns || !caseRuns.length) {
      return false;
    }
    var relatedStatuses = caseRuns.map(getMiniStatus);
    return /*#__PURE__*/React.createElement("div", {
      className: "relation-grouping"
    }, /*#__PURE__*/React.createElement("span", {
      className: "relation-grouping-reason"
    }, "Billed with:"), /*#__PURE__*/React.createElement("ul", {
      className: "related-group"
    }, relatedStatuses));
  };
  var StatusDescription = function StatusDescription(props) {
    var computed = _objectSpread$M(_objectSpread$M({}, DEFAULT_PROPS$9), props);
    var caseDetail = computed.caseRun;
      computed.secondaryPrefix;
      var passedPreGoLive = computed.isPreGoLive;
      computed.groupedCases;
      var secondaryIndicatorVisibility = computed.secondaryIndicatorVisibility,
      includeBox = computed.includeBox,
      rest = _objectWithoutProperties(computed, _excluded$k);
    var isPreGoLive = passedPreGoLive || uiCommon.caseUtils.isPreGoLive(caseDetail);
    var statusDisplay = uiCommon.caseUtils.deriveStatus(caseDetail);
    var statusSignifier = statusDisplay.signifier;
    var secondaryIndicatorText = uiCommon.caseUtils.getStatusReason(caseDetail);
    var classes = [props.className, 'standalone-status', 'description', statusDisplay.styleClass];
    return /*#__PURE__*/React.createElement("div", {
      className: includeBox && secondaryIndicatorText ? 'status-description' : ''
    }, /*#__PURE__*/React.createElement("span", _extends$1({}, rest, {
      className: classnames(classes)
    }), /*#__PURE__*/React.createElement("span", {
      className: "status-signifier"
    }, statusSignifier), isPreGoLive && includeBox !== true && /*#__PURE__*/React.createElement("span", {
      className: "status-modifier"
    }, "Pre Go-Live"), secondaryIndicatorVisibility && secondaryIndicatorText && /*#__PURE__*/React.createElement("span", {
      className: "secondary-indicator-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "secondary-indicator"
    }, secondaryIndicatorText))));
  };
  StatusDescription.displayName = 'StatusDescription';
  var CaseStatus = function CaseStatus(props) {
    var computed = _objectSpread$M(_objectSpread$M({}, DEFAULT_PROPS$9), props);
    var caseDetail = computed.caseRun,
      timeStamp = computed.timeStamp,
      isPreGoLive = computed.isPreGoLive,
      groupedCases = computed.groupedCases;
      computed.secondaryPrefix;
      var billingGroupLoadState = computed.billingGroupLoadState;
      computed.includeBox;
      var rest = _objectWithoutProperties(computed, _excluded2);
    var statusDisplay = uiCommon.caseUtils.deriveStatus(caseDetail);
    var showLoading = billingGroupLoadState !== null && (billingGroupLoadState === null || billingGroupLoadState === void 0 ? void 0 : billingGroupLoadState.initial);
    var readout = /*#__PURE__*/React.createElement("div", {
      className: "large-info-display"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-code"
    }, /*#__PURE__*/React.createElement("span", {
      className: "large-circle"
    })), /*#__PURE__*/React.createElement("div", {
      className: "description-container"
    }, /*#__PURE__*/React.createElement(StatusDescription, {
      caseRun: caseDetail,
      isPreGoLive: isPreGoLive,
      includeBox: true
    }), /*#__PURE__*/React.createElement("span", {
      className: "description-timestamp"
    }, "Updated ", timeStamp, " "), showLoading && /*#__PURE__*/React.createElement("div", {
      className: "billing-group-loading-message relation-grouping"
    }, "Checking for other billed exams..."), getBillingGroup$1(groupedCases)));
    var classes = [props.className, 'case-status', statusDisplay.styleClass];
    return /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
      className: classnames(classes)
    }), readout);
  };
  CaseStatus.displayName = 'CaseStatus';

  var FieldNames$1 = {
    reason_for_visit: 'reason for visit',
    work_queue_name: 'work queue',
    procedure_type: 'procedure type',
    procedure_category: 'procedure category',
    exam_type: 'exam type',
    exam_description: 'exam description',
    body_region: 'body part',
    raw_body: 'documentation'
  };

  var CaseArtifactTypes$1 = uiCommon.commonEnums.CaseArtifactTypes;
  var externalSource = new Set([CaseArtifactTypes$1.CLINICAL, CaseArtifactTypes$1.CODED, CaseArtifactTypes$1.CLAIM].map(function (code) {
    return code.toLowerCase();
  }));
  var displayNoEvidenceAvailable = function displayNoEvidenceAvailable(artifact) {
    var _artifact$meta;
    var text = '';
    if (((_artifact$meta = artifact.meta) === null || _artifact$meta === void 0 ? void 0 : _artifact$meta.imported) === true) {
      text = 'This code was billed on a different case';
    } else {
      text = externalSource.has(artifact.type.toLowerCase()) ? "This code originated in your health system." : "There is no displayable evidence at this time.";
    }
    return /*#__PURE__*/React.createElement("ul", {
      className: "case-evidence-list"
    }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
      className: "qa-empty-message"
    }, text)));
  };
  var buildClickHandler = function buildClickHandler(onSelection, evidence) {
    return function (ev) {
      ev.preventDefault();
      var target = ev.target || document.createElement('span');
      var valuable = target.classList.contains('field-value');
      var linkable = target.closest('.case-evidence-item.case-evidence-linked');
      if (!valuable || !linkable) return;
      var item = target.attributes.getNamedItem('data-index');
      if (!item) return;
      var currentIndex = parseInt(item.value);
      var feature = evidence[currentIndex];
      var display = !linkable.classList.contains('case-evidence-active');
      onSelection({
        evidence: feature,
        display: display
      });
    };
  };

  var _excluded$j = ["medicalCode", "artifact", "onSelection", "evidenceManager", "codeType"];
  var isNgram$1 = uiCommon.cmxTypeguards.isNgram,
    isCategorical$1 = uiCommon.cmxTypeguards.isCategorical,
    isUnknownEvidence = uiCommon.cmxTypeguards.isUnknownEvidence;
  var CaseArtifactTypes = uiCommon.commonEnums.CaseArtifactTypes;
  var getCode = function getCode(code) {
    if ('procedure_code' in code) {
      return code.procedure_code;
    } else if ('diagnosis_code' in code) {
      return code.diagnosis_code;
    } else if ('modifier_code' in code) {
      return code.modifier_code;
    }
  };
  var CaseEvidenceTable = function CaseEvidenceTable(props) {
    var _medicalCode$evidence, _artifact$meta;
    var medicalCode = props.medicalCode,
      artifact = props.artifact,
      onSelection = props.onSelection,
      evidenceManager = props.evidenceManager,
      codeType = props.codeType,
      rest = _objectWithoutProperties(props, _excluded$j);
    var evidenceForCode = (_medicalCode$evidence = medicalCode.evidence) !== null && _medicalCode$evidence !== void 0 ? _medicalCode$evidence : [];
    var fromSource = artifact.type === CaseArtifactTypes.CLINICAL;
    var classes = [rest.className, 'case-evidence-table', 'col-artifacts', "case-evidence-".concat(codeType.toLowerCase()), {
      'case-evidence-soure': fromSource,
      'case-has-no-evidence': !evidenceForCode.length
    }];
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement("div", _extends$1({}, rest, {
        className: classnames(classes),
        key: "".concat(artifact.identifier, "-").concat(medicalCode.uuid, "-case-evidence-table")
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-code"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-description"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "evidence-table-descriptor"
      }, "Why we selected ", getCode(medicalCode)), !evidenceForCode.length || ((_artifact$meta = artifact.meta) === null || _artifact$meta === void 0 ? void 0 : _artifact$meta.imported) === true ? displayNoEvidenceAvailable(artifact) : displayEvidenceList(evidenceForCode, evidenceManager, artifact, medicalCode, onSelection)))
    );
  };
  var displayEvidenceList = function displayEvidenceList(evidence, evidenceManager, artifact, medicalCode, onSelection) {
    var handleClick = buildClickHandler(onSelection, evidence);
    var listItems = evidence.map(function (singleEvidence, index) {
      var feature = uiCommon.cmxArtifacts.getFeature(singleEvidence);
      var fieldProp;
      if (isNgram$1(feature)) {
        fieldProp = "".concat(feature.field);
      } else if (isCategorical$1(feature)) {
        fieldProp = "".concat(feature.field);
      } else {
        // this is bogus, but really
        // we shouldn't be in here.
        fieldProp = 'undefined';
      }
      var key = "".concat(fieldProp, "-").concat(index, "-").concat(singleEvidence.type);
      var linkable = uiCommon.cmxArtifacts.isLinkable(fieldProp);
      var featureSelection = {
        evidence: singleEvidence,
        artifactId: artifact.artifact_id,
        code: medicalCode,
        codeType: 'something',
        display: true
      };
      var isActive = evidenceManager.hasSelectedFeature(featureSelection);
      var fieldName = FieldNames$1[fieldProp] || fieldProp || 'Unknown field';
      var styleClasses = ["case-evidence-item", {
        'case-evidence-linked': linkable
      }, {
        'case-evidence-active': isActive
      }, {
        'sentence-highlight': isNgram$1(feature)
      }, {
        'categorical-highlight': isCategorical$1(feature)
      }];
      var valueClasses = ["field-value", 'highlighted-text', 'sensitive-data'];

      // we're currently displaying two types of features 'ngrams' and 'categorical' data.
      if (uiCommon.cmxArtifacts.isSubhighlight(feature)) {
        var descriptions = feature.spans;
        return descriptions.map(function (span) {
          var _span$content, _span$uuid;
          return /*#__PURE__*/React.createElement("li", {
            className: classnames(styleClasses),
            key: "".concat(key, "-").concat(span.uuid)
          }, "The ", /*#__PURE__*/React.createElement("span", {
            className: "field-name"
          }, fieldName), " contains", ' ', /*#__PURE__*/React.createElement("span", {
            className: classnames(valueClasses),
            "data-index": index
          }, (_span$content = span.content) === null || _span$content === void 0 ? void 0 : _span$content.trim()), /*#__PURE__*/React.createElement("span", {
            className: "highlighter-diagnostics"
          }, (_span$uuid = span.uuid) === null || _span$uuid === void 0 ? void 0 : _span$uuid.slice(-7), " ", "".concat(span.start, "-").concat(span.end)));
        });
      } else if (uiCommon.cmxArtifacts.isBlockHighlight(feature)) {
        var description = uiCommon.cmxArtifacts.getDescription(feature);
        return /*#__PURE__*/React.createElement("li", {
          className: classnames(styleClasses),
          key: key
        }, "The ", /*#__PURE__*/React.createElement("span", {
          className: "field-name"
        }, fieldName), " is", ' ', /*#__PURE__*/React.createElement("span", {
          className: classnames(valueClasses),
          "data-index": index
        }, description));
      }
      return false;
    });

    // test for unknown evidence
    var hasUnknown = evidence.some(isUnknownEvidence);
    if (hasUnknown) {
      listItems.unshift(/*#__PURE__*/React.createElement("li", {
        className: 'case-evidence-item',
        key: 'unknown-evidence-item'
      }, /*#__PURE__*/React.createElement("span", {
        className: "unknown-evidence"
      }, "Some information was found that is not displayable.")));
    }
    return /*#__PURE__*/React.createElement("ol", {
      className: "case-evidence-list",
      onClick: handleClick,
      key: "".concat(medicalCode.uuid, "-case-evidence-list")
    }, listItems.flat());
  };
  CaseEvidenceTable.displayName = 'CaseEvidenceTable';

  function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
      var i = n[a](c),
        u = i.value;
    } catch (n) {
      return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
  }
  function _asyncToGenerator(n) {
    return function () {
      var t = this,
        e = arguments;
      return new Promise(function (r, o) {
        var a = n.apply(t, e);
        function _next(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
        }
        function _throw(n) {
          asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
        }
        _next(void 0);
      });
    };
  }

  var regeneratorRuntime$1 = {exports: {}};

  var OverloadYield = {exports: {}};

  var hasRequiredOverloadYield;
  function requireOverloadYield() {
    if (hasRequiredOverloadYield) return OverloadYield.exports;
    hasRequiredOverloadYield = 1;
    (function (module) {
      function _OverloadYield(e, d) {
        this.v = e, this.k = d;
      }
      module.exports = _OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(OverloadYield);
    return OverloadYield.exports;
  }

  var regenerator$1 = {exports: {}};

  var regeneratorDefine = {exports: {}};

  var hasRequiredRegeneratorDefine;
  function requireRegeneratorDefine() {
    if (hasRequiredRegeneratorDefine) return regeneratorDefine.exports;
    hasRequiredRegeneratorDefine = 1;
    (function (module) {
      function _regeneratorDefine(e, r, n, t) {
        var i = Object.defineProperty;
        try {
          i({}, "", {});
        } catch (e) {
          i = 0;
        }
        module.exports = _regeneratorDefine = function regeneratorDefine(e, r, n, t) {
          function o(r, n) {
            _regeneratorDefine(e, r, function (e) {
              return this._invoke(r, n, e);
            });
          }
          r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
          }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _regeneratorDefine(e, r, n, t);
      }
      module.exports = _regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorDefine);
    return regeneratorDefine.exports;
  }

  var hasRequiredRegenerator$1;
  function requireRegenerator$1() {
    if (hasRequiredRegenerator$1) return regenerator$1.exports;
    hasRequiredRegenerator$1 = 1;
    (function (module) {
      var regeneratorDefine = requireRegeneratorDefine();
      function _regenerator() {
        /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
        var e,
          t,
          r = "function" == typeof Symbol ? Symbol : {},
          n = r.iterator || "@@iterator",
          o = r.toStringTag || "@@toStringTag";
        function i(r, n, o, i) {
          var c = n && n.prototype instanceof Generator ? n : Generator,
            u = Object.create(c.prototype);
          return regeneratorDefine(u, "_invoke", function (r, n, o) {
            var i,
              c,
              u,
              f = 0,
              p = o || [],
              y = false,
              G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                  return i = t, c = 0, u = e, G.n = r, a;
                }
              };
            function d(r, n) {
              for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
                var o,
                  i = p[t],
                  d = G.p,
                  l = i[2];
                r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
              }
              if (o || r > 1) return a;
              throw y = true, n;
            }
            return function (o, p, l) {
              if (f > 1) throw TypeError("Generator is already running");
              for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
                i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                try {
                  if (f = 2, i) {
                    if (c || (o = "next"), t = i[o]) {
                      if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                      if (!t.done) return t;
                      u = t.value, c < 2 && (c = 0);
                    } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                    i = e;
                  } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                } catch (t) {
                  i = e, c = 1, u = t;
                } finally {
                  f = 1;
                }
              }
              return {
                value: t,
                done: y
              };
            };
          }(r, o, i), true), u;
        }
        var a = {};
        function Generator() {}
        function GeneratorFunction() {}
        function GeneratorFunctionPrototype() {}
        t = Object.getPrototypeOf;
        var c = [][n] ? t(t([][n]())) : (regeneratorDefine(t = {}, n, function () {
            return this;
          }), t),
          u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
        function f(e) {
          return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, regeneratorDefine(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
        }
        return GeneratorFunction.prototype = GeneratorFunctionPrototype, regeneratorDefine(u, "constructor", GeneratorFunctionPrototype), regeneratorDefine(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", regeneratorDefine(GeneratorFunctionPrototype, o, "GeneratorFunction"), regeneratorDefine(u), regeneratorDefine(u, o, "Generator"), regeneratorDefine(u, n, function () {
          return this;
        }), regeneratorDefine(u, "toString", function () {
          return "[object Generator]";
        }), (module.exports = _regenerator = function _regenerator() {
          return {
            w: i,
            m: f
          };
        }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
      }
      module.exports = _regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regenerator$1);
    return regenerator$1.exports;
  }

  var regeneratorAsync = {exports: {}};

  var regeneratorAsyncGen = {exports: {}};

  var regeneratorAsyncIterator = {exports: {}};

  var hasRequiredRegeneratorAsyncIterator;
  function requireRegeneratorAsyncIterator() {
    if (hasRequiredRegeneratorAsyncIterator) return regeneratorAsyncIterator.exports;
    hasRequiredRegeneratorAsyncIterator = 1;
    (function (module) {
      var OverloadYield = requireOverloadYield();
      var regeneratorDefine = requireRegeneratorDefine();
      function AsyncIterator(t, e) {
        function n(r, o, i, f) {
          try {
            var c = t[r](o),
              u = c.value;
            return u instanceof OverloadYield ? e.resolve(u.v).then(function (t) {
              n("next", t, i, f);
            }, function (t) {
              n("throw", t, i, f);
            }) : e.resolve(u).then(function (t) {
              c.value = t, i(c);
            }, function (t) {
              return n("throw", t, i, f);
            });
          } catch (t) {
            f(t);
          }
        }
        var r;
        this.next || (regeneratorDefine(AsyncIterator.prototype), regeneratorDefine(AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () {
          return this;
        })), regeneratorDefine(this, "_invoke", function (t, o, i) {
          function f() {
            return new e(function (e, r) {
              n(t, i, e, r);
            });
          }
          return r = r ? r.then(f, f) : f();
        }, true);
      }
      module.exports = AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorAsyncIterator);
    return regeneratorAsyncIterator.exports;
  }

  var hasRequiredRegeneratorAsyncGen;
  function requireRegeneratorAsyncGen() {
    if (hasRequiredRegeneratorAsyncGen) return regeneratorAsyncGen.exports;
    hasRequiredRegeneratorAsyncGen = 1;
    (function (module) {
      var regenerator = requireRegenerator$1();
      var regeneratorAsyncIterator = requireRegeneratorAsyncIterator();
      function _regeneratorAsyncGen(r, e, t, o, n) {
        return new regeneratorAsyncIterator(regenerator().w(r, e, t, o), n || Promise);
      }
      module.exports = _regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorAsyncGen);
    return regeneratorAsyncGen.exports;
  }

  var hasRequiredRegeneratorAsync;
  function requireRegeneratorAsync() {
    if (hasRequiredRegeneratorAsync) return regeneratorAsync.exports;
    hasRequiredRegeneratorAsync = 1;
    (function (module) {
      var regeneratorAsyncGen = requireRegeneratorAsyncGen();
      function _regeneratorAsync(n, e, r, t, o) {
        var a = regeneratorAsyncGen(n, e, r, t, o);
        return a.next().then(function (n) {
          return n.done ? n.value : a.next();
        });
      }
      module.exports = _regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorAsync);
    return regeneratorAsync.exports;
  }

  var regeneratorKeys = {exports: {}};

  var hasRequiredRegeneratorKeys;
  function requireRegeneratorKeys() {
    if (hasRequiredRegeneratorKeys) return regeneratorKeys.exports;
    hasRequiredRegeneratorKeys = 1;
    (function (module) {
      function _regeneratorKeys(e) {
        var n = Object(e),
          r = [];
        for (var t in n) r.unshift(t);
        return function e() {
          for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = false, e;
          return e.done = true, e;
        };
      }
      module.exports = _regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorKeys);
    return regeneratorKeys.exports;
  }

  var regeneratorValues = {exports: {}};

  var _typeof = {exports: {}};

  var hasRequired_typeof;
  function require_typeof() {
    if (hasRequired_typeof) return _typeof.exports;
    hasRequired_typeof = 1;
    (function (module) {
      function _typeof(o) {
        "@babel/helpers - typeof";

        return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
          return typeof o;
        } : function (o) {
          return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
      }
      module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(_typeof);
    return _typeof.exports;
  }

  var hasRequiredRegeneratorValues;
  function requireRegeneratorValues() {
    if (hasRequiredRegeneratorValues) return regeneratorValues.exports;
    hasRequiredRegeneratorValues = 1;
    (function (module) {
      var _typeof = require_typeof()["default"];
      function _regeneratorValues(e) {
        if (null != e) {
          var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
            r = 0;
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) return {
            next: function next() {
              return e && r >= e.length && (e = void 0), {
                value: e && e[r++],
                done: !e
              };
            }
          };
        }
        throw new TypeError(_typeof(e) + " is not iterable");
      }
      module.exports = _regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorValues);
    return regeneratorValues.exports;
  }

  var hasRequiredRegeneratorRuntime;
  function requireRegeneratorRuntime() {
    if (hasRequiredRegeneratorRuntime) return regeneratorRuntime$1.exports;
    hasRequiredRegeneratorRuntime = 1;
    (function (module) {
      var OverloadYield = requireOverloadYield();
      var regenerator = requireRegenerator$1();
      var regeneratorAsync = requireRegeneratorAsync();
      var regeneratorAsyncGen = requireRegeneratorAsyncGen();
      var regeneratorAsyncIterator = requireRegeneratorAsyncIterator();
      var regeneratorKeys = requireRegeneratorKeys();
      var regeneratorValues = requireRegeneratorValues();
      function _regeneratorRuntime() {

        var r = regenerator(),
          e = r.m(_regeneratorRuntime),
          t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
        function n(r) {
          var e = "function" == typeof r && r.constructor;
          return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
        }
        var o = {
          "throw": 1,
          "return": 2,
          "break": 3,
          "continue": 3
        };
        function a(r) {
          var e, t;
          return function (n) {
            e || (e = {
              stop: function stop() {
                return t(n.a, 2);
              },
              "catch": function _catch() {
                return n.v;
              },
              abrupt: function abrupt(r, e) {
                return t(n.a, o[r], e);
              },
              delegateYield: function delegateYield(r, o, a) {
                return e.resultName = o, t(n.d, regeneratorValues(r), a);
              },
              finish: function finish(r) {
                return t(n.f, r);
              }
            }, t = function t(r, _t, o) {
              n.p = e.prev, n.n = e.next;
              try {
                return r(_t, o);
              } finally {
                e.next = n.n;
              }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
              return r.call(this, e);
            } finally {
              n.p = e.prev, n.n = e.next;
            }
          };
        }
        return (module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
          return {
            wrap: function wrap(e, t, n, o) {
              return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
              return new OverloadYield(r, e);
            },
            AsyncIterator: regeneratorAsyncIterator,
            async: function async(r, e, t, o, u) {
              return (n(e) ? regeneratorAsyncGen : regeneratorAsync)(a(r), e, t, o, u);
            },
            keys: regeneratorKeys,
            values: regeneratorValues
          };
        }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
      }
      module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;
    })(regeneratorRuntime$1);
    return regeneratorRuntime$1.exports;
  }

  var regenerator;
  var hasRequiredRegenerator;
  function requireRegenerator() {
    if (hasRequiredRegenerator) return regenerator;
    hasRequiredRegenerator = 1;
    // TODO(Babel 8): Remove this file.

    var runtime = requireRegeneratorRuntime()();
    regenerator = runtime;

    // Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
    try {
      regeneratorRuntime = runtime;
    } catch (accidentalStrictMode) {
      if ((typeof globalThis === "undefined" ? "undefined" : _typeof$1(globalThis)) === "object") {
        globalThis.regeneratorRuntime = runtime;
      } else {
        Function("r", "regeneratorRuntime = r")(runtime);
      }
    }
    return regenerator;
  }

  var regeneratorExports = requireRegenerator();
  var _regeneratorRuntime = /*@__PURE__*/getDefaultExportFromCjs(regeneratorExports);

  function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
  }

  function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
      var e,
        n,
        i,
        u,
        a = [],
        f = true,
        o = false;
      try {
        if (i = (t = t.call(r)).next, 0 === l) {
          if (Object(t) !== t) return;
          f = !1;
        } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
      } catch (r) {
        o = true, n = r;
      } finally {
        try {
          if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
        } finally {
          if (o) throw n;
        }
      }
      return a;
    }
  }

  function _arrayLikeToArray$4(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }

  function _unsupportedIterableToArray$3(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray$4(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$4(r, a) : void 0;
    }
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$3(r, e) || _nonIterableRest();
  }

  var reactDatepicker_min$1 = {exports: {}};

  function requiredArgs(required, args) {
    if (args.length < required) {
      throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
    }
  }

  /**
   * @name isDate
   * @category Common Helpers
   * @summary Is the given value a date?
   *
   * @description
   * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
   *
   * @param {*} value - the value to check
   * @returns {boolean} true if the given value is a date
   * @throws {TypeError} 1 arguments required
   *
   * @example
   * // For a valid date:
   * const result = isDate(new Date())
   * //=> true
   *
   * @example
   * // For an invalid date:
   * const result = isDate(new Date(NaN))
   * //=> true
   *
   * @example
   * // For some value:
   * const result = isDate('2014-02-31')
   * //=> false
   *
   * @example
   * // For an object:
   * const result = isDate({})
   * //=> false
   */
  function isDate(value) {
    requiredArgs(1, arguments);
    return value instanceof Date || _typeof$1(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
  }

  var isDate$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isDate
  });

  var require$$3 = /*@__PURE__*/getAugmentedNamespace(isDate$1);

  /**
   * @name toDate
   * @category Common Helpers
   * @summary Convert the given argument to an instance of Date.
   *
   * @description
   * Convert the given argument to an instance of Date.
   *
   * If the argument is an instance of Date, the function returns its clone.
   *
   * If the argument is a number, it is treated as a timestamp.
   *
   * If the argument is none of the above, the function returns Invalid Date.
   *
   * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
   *
   * @param {Date|Number} argument - the value to convert
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Clone the date:
   * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert the timestamp to date:
   * const result = toDate(1392098430000)
   * //=> Tue Feb 11 2014 11:30:30
   */
  function toDate(argument) {
    requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument);

    // Clone the date
    if (argument instanceof Date || _typeof$1(argument) === 'object' && argStr === '[object Date]') {
      // Prevent the date to lose the milliseconds when passed to new Date() in IE10
      return new Date(argument.getTime());
    } else if (typeof argument === 'number' || argStr === '[object Number]') {
      return new Date(argument);
    } else {
      if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
        // eslint-disable-next-line no-console
        console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
        // eslint-disable-next-line no-console
        console.warn(new Error().stack);
      }
      return new Date(NaN);
    }
  }

  var toDate$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: toDate
  });

  /**
   * @name isValid
   * @category Common Helpers
   * @summary Is the given date valid?
   *
   * @description
   * Returns false if argument is Invalid Date and true otherwise.
   * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
   * Invalid Date is a Date, whose time value is NaN.
   *
   * Time value of Date: http://es5.github.io/#x15.9.1.1
   *
   * @param {*} date - the date to check
   * @returns {Boolean} the date is valid
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // For the valid date:
   * const result = isValid(new Date(2014, 1, 31))
   * //=> true
   *
   * @example
   * // For the value, convertable into a date:
   * const result = isValid(1393804800000)
   * //=> true
   *
   * @example
   * // For the invalid date:
   * const result = isValid(new Date(''))
   * //=> false
   */
  function isValid(dirtyDate) {
    requiredArgs(1, arguments);
    if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
      return false;
    }
    var date = toDate(dirtyDate);
    return !isNaN(Number(date));
  }

  var isValid$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isValid
  });

  var require$$4 = /*@__PURE__*/getAugmentedNamespace(isValid$1);

  function toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
      return NaN;
    }
    var number = Number(dirtyNumber);
    if (isNaN(number)) {
      return number;
    }
    return number < 0 ? Math.ceil(number) : Math.floor(number);
  }

  /**
   * @name addMilliseconds
   * @category Millisecond Helpers
   * @summary Add the specified number of milliseconds to the given date.
   *
   * @description
   * Add the specified number of milliseconds to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the milliseconds added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
   * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:30.750
   */
  function addMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var timestamp = toDate(dirtyDate).getTime();
    var amount = toInteger(dirtyAmount);
    return new Date(timestamp + amount);
  }

  /**
   * @name subMilliseconds
   * @category Millisecond Helpers
   * @summary Subtract the specified number of milliseconds from the given date.
   *
   * @description
   * Subtract the specified number of milliseconds from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the milliseconds subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
   * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
   * //=> Thu Jul 10 2014 12:45:29.250
   */
  function subMilliseconds(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, -amount);
  }

  var MILLISECONDS_IN_DAY$1 = 86400000;
  function getUTCDayOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
  }

  function startOfUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  function getUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }

  function startOfUTCISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCISOWeek(fourthOfJanuary);
    return date;
  }

  var MILLISECONDS_IN_WEEK$2 = 604800000;
  function getUTCISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
  }

  var defaultOptions = {};
  function getDefaultOptions() {
    return defaultOptions;
  }

  function startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var date = toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
  }

  function getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = getDefaultOptions();
    var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }

  function startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = getUTCWeekYear(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = startOfUTCWeek(firstWeek, options);
    return date;
  }

  var MILLISECONDS_IN_WEEK$1 = 604800000;
  function getUTCWeek(dirtyDate, options) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
  }

  function addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while (output.length < targetLength) {
      output = '0' + output;
    }
    return sign + output;
  }

  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* |                                |
   * |  d  | Day of month                   |  D  |                                |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  m  | Minute                         |  M  | Month                          |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  y  | Year (abs)                     |  Y  |                                |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   */
  var formatters$1 = {
    // Year
    y: function y(date, token) {
      // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
      // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
      // |----------|-------|----|-------|-------|-------|
      // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
      // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
      // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
      // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
      // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
      var month = date.getUTCMonth();
      return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
      return addLeadingZeros(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
      var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
      switch (token) {
        case 'a':
        case 'aa':
          return dayPeriodEnumValue.toUpperCase();
        case 'aaa':
          return dayPeriodEnumValue;
        case 'aaaaa':
          return dayPeriodEnumValue[0];
        case 'aaaa':
        default:
          return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
      }
    },
    // Hour [1-12]
    h: function h(date, token) {
      return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
      return addLeadingZeros(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
      return addLeadingZeros(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
      return addLeadingZeros(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
      var numberOfDigits = token.length;
      var milliseconds = date.getUTCMilliseconds();
      var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
      return addLeadingZeros(fractionalSeconds, token.length);
    }
  };

  var dayPeriodEnum = {
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  };
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

  var formatters = {
    // Era
    G: function G(date, token, localize) {
      var era = date.getUTCFullYear() > 0 ? 1 : 0;
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return localize.era(era, {
            width: 'abbreviated'
          });
        // A, B
        case 'GGGGG':
          return localize.era(era, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return localize.era(era, {
            width: 'wide'
          });
      }
    },
    // Year
    y: function y(date, token, localize) {
      // Ordinal number
      if (token === 'yo') {
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return localize.ordinalNumber(year, {
          unit: 'year'
        });
      }
      return formatters$1.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
      var signedWeekYear = getUTCWeekYear(date, options);
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

      // Two digit year
      if (token === 'YY') {
        var twoDigitYear = weekYear % 100;
        return addLeadingZeros(twoDigitYear, 2);
      }

      // Ordinal number
      if (token === 'Yo') {
        return localize.ordinalNumber(weekYear, {
          unit: 'year'
        });
      }

      // Padding
      return addLeadingZeros(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
      var isoWeekYear = getUTCISOWeekYear(date);

      // Padding
      return addLeadingZeros(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
      var year = date.getUTCFullYear();
      return addLeadingZeros(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
          return String(quarter);
        // 01, 02, 03, 04
        case 'QQ':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
      var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
          return String(quarter);
        // 01, 02, 03, 04
        case 'qq':
          return addLeadingZeros(quarter, 2);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return localize.ordinalNumber(quarter, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return localize.quarter(quarter, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return localize.quarter(quarter, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return localize.quarter(quarter, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Month
    M: function M(date, token, localize) {
      var month = date.getUTCMonth();
      switch (token) {
        case 'M':
        case 'MM':
          return formatters$1.M(date, token);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec
        case 'MMM':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return localize.month(month, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
      var month = date.getUTCMonth();
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return String(month + 1);
        // 01, 02, ..., 12
        case 'LL':
          return addLeadingZeros(month + 1, 2);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return localize.ordinalNumber(month + 1, {
            unit: 'month'
          });
        // Jan, Feb, ..., Dec
        case 'LLL':
          return localize.month(month, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return localize.month(month, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return localize.month(month, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
      var week = getUTCWeek(date, options);
      if (token === 'wo') {
        return localize.ordinalNumber(week, {
          unit: 'week'
        });
      }
      return addLeadingZeros(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
      var isoWeek = getUTCISOWeek(date);
      if (token === 'Io') {
        return localize.ordinalNumber(isoWeek, {
          unit: 'week'
        });
      }
      return addLeadingZeros(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
      if (token === 'do') {
        return localize.ordinalNumber(date.getUTCDate(), {
          unit: 'date'
        });
      }
      return formatters$1.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
      var dayOfYear = getUTCDayOfYear(date);
      if (token === 'Do') {
        return localize.ordinalNumber(dayOfYear, {
          unit: 'dayOfYear'
        });
      }
      return addLeadingZeros(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
      var dayOfWeek = date.getUTCDay();
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
      switch (token) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case 'e':
          return String(localDayOfWeek);
        // Padded numerical value
        case 'ee':
          return addLeadingZeros(localDayOfWeek, 2);
        // 1st, 2nd, ..., 7th
        case 'eo':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });
        case 'eee':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
      var dayOfWeek = date.getUTCDay();
      var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
      switch (token) {
        // Numerical value (same as in `e`)
        case 'c':
          return String(localDayOfWeek);
        // Padded numerical value
        case 'cc':
          return addLeadingZeros(localDayOfWeek, token.length);
        // 1st, 2nd, ..., 7th
        case 'co':
          return localize.ordinalNumber(localDayOfWeek, {
            unit: 'day'
          });
        case 'ccc':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'standalone'
          });
      }
    },
    // ISO day of week
    i: function i(date, token, localize) {
      var dayOfWeek = date.getUTCDay();
      var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
      switch (token) {
        // 2
        case 'i':
          return String(isoDayOfWeek);
        // 02
        case 'ii':
          return addLeadingZeros(isoDayOfWeek, token.length);
        // 2nd
        case 'io':
          return localize.ordinalNumber(isoDayOfWeek, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return localize.day(dayOfWeek, {
            width: 'abbreviated',
            context: 'formatting'
          });
        // T
        case 'iiiii':
          return localize.day(dayOfWeek, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'iiiiii':
          return localize.day(dayOfWeek, {
            width: 'short',
            context: 'formatting'
          });
        // Tuesday
        case 'iiii':
        default:
          return localize.day(dayOfWeek, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM or PM
    a: function a(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
      switch (token) {
        case 'a':
        case 'aa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });
        case 'aaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          }).toLowerCase();
        case 'aaaaa':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;
      if (hours === 12) {
        dayPeriodEnumValue = dayPeriodEnum.noon;
      } else if (hours === 0) {
        dayPeriodEnumValue = dayPeriodEnum.midnight;
      } else {
        dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
      }
      switch (token) {
        case 'b':
        case 'bb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });
        case 'bbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          }).toLowerCase();
        case 'bbbbb':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
      var hours = date.getUTCHours();
      var dayPeriodEnumValue;
      if (hours >= 17) {
        dayPeriodEnumValue = dayPeriodEnum.evening;
      } else if (hours >= 12) {
        dayPeriodEnumValue = dayPeriodEnum.afternoon;
      } else if (hours >= 4) {
        dayPeriodEnumValue = dayPeriodEnum.morning;
      } else {
        dayPeriodEnumValue = dayPeriodEnum.night;
      }
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'abbreviated',
            context: 'formatting'
          });
        case 'BBBBB':
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return localize.dayPeriod(dayPeriodEnumValue, {
            width: 'wide',
            context: 'formatting'
          });
      }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
      if (token === 'ho') {
        var hours = date.getUTCHours() % 12;
        if (hours === 0) hours = 12;
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }
      return formatters$1.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
      if (token === 'Ho') {
        return localize.ordinalNumber(date.getUTCHours(), {
          unit: 'hour'
        });
      }
      return formatters$1.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
      var hours = date.getUTCHours() % 12;
      if (token === 'Ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }
      return addLeadingZeros(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
      var hours = date.getUTCHours();
      if (hours === 0) hours = 24;
      if (token === 'ko') {
        return localize.ordinalNumber(hours, {
          unit: 'hour'
        });
      }
      return addLeadingZeros(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
      if (token === 'mo') {
        return localize.ordinalNumber(date.getUTCMinutes(), {
          unit: 'minute'
        });
      }
      return formatters$1.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
      if (token === 'so') {
        return localize.ordinalNumber(date.getUTCSeconds(), {
          unit: 'second'
        });
      }
      return formatters$1.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
      return formatters$1.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();
      if (timezoneOffset === 0) {
        return 'Z';
      }
      switch (token) {
        // Hours and optional minutes
        case 'X':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);

        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`
        case 'XXXX':
        case 'XX':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);

        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`
        case 'XXXXX':
        case 'XXX': // Hours and minutes with `:` delimiter
        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        // Hours and optional minutes
        case 'x':
          return formatTimezoneWithOptionalMinutes(timezoneOffset);

        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`
        case 'xxxx':
        case 'xx':
          // Hours and minutes without `:` delimiter
          return formatTimezone(timezoneOffset);

        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`
        case 'xxxxx':
        case 'xxx': // Hours and minutes with `:` delimiter
        default:
          return formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        // Short
        case 'O':
        case 'OO':
        case 'OOO':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long
        case 'OOOO':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timezoneOffset = originalDate.getTimezoneOffset();
      switch (token) {
        // Short
        case 'z':
        case 'zz':
        case 'zzz':
          return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
        // Long
        case 'zzzz':
        default:
          return 'GMT' + formatTimezone(timezoneOffset, ':');
      }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = Math.floor(originalDate.getTime() / 1000);
      return addLeadingZeros(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
      var originalDate = options._originalDate || date;
      var timestamp = originalDate.getTime();
      return addLeadingZeros(timestamp, token.length);
    }
  };
  function formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) {
      return sign + String(hours);
    }
    var delimiter = dirtyDelimiter;
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
  }
  function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
      var sign = offset > 0 ? '-' : '+';
      return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, dirtyDelimiter);
  }
  function formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
  }

  var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'P':
        return formatLong.date({
          width: 'short'
        });
      case 'PP':
        return formatLong.date({
          width: 'medium'
        });
      case 'PPP':
        return formatLong.date({
          width: 'long'
        });
      case 'PPPP':
      default:
        return formatLong.date({
          width: 'full'
        });
    }
  };
  var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch (pattern) {
      case 'p':
        return formatLong.time({
          width: 'short'
        });
      case 'pp':
        return formatLong.time({
          width: 'medium'
        });
      case 'ppp':
        return formatLong.time({
          width: 'long'
        });
      case 'pppp':
      default:
        return formatLong.time({
          width: 'full'
        });
    }
  };
  var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) {
      return dateLongFormatter(pattern, formatLong);
    }
    var dateTimeFormat;
    switch (datePattern) {
      case 'P':
        dateTimeFormat = formatLong.dateTime({
          width: 'short'
        });
        break;
      case 'PP':
        dateTimeFormat = formatLong.dateTime({
          width: 'medium'
        });
        break;
      case 'PPP':
        dateTimeFormat = formatLong.dateTime({
          width: 'long'
        });
        break;
      case 'PPPP':
      default:
        dateTimeFormat = formatLong.dateTime({
          width: 'full'
        });
        break;
    }
    return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
  };
  var longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
  };

  /**
   * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
   * They usually appear for dates that denote time before the timezones were introduced
   * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
   * and GMT+01:00:00 after that date)
   *
   * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
   * which would lead to incorrect calculations.
   *
   * This function returns the timezone offset in milliseconds that takes seconds in account.
   */
  function getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
  }

  var protectedDayOfYearTokens = ['D', 'DD'];
  var protectedWeekYearTokens = ['YY', 'YYYY'];
  function isProtectedDayOfYearToken(token) {
    return protectedDayOfYearTokens.indexOf(token) !== -1;
  }
  function isProtectedWeekYearToken(token) {
    return protectedWeekYearTokens.indexOf(token) !== -1;
  }
  function throwProtectedError(token, format, input) {
    if (token === 'YYYY') {
      throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === 'YY') {
      throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === 'D') {
      throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    } else if (token === 'DD') {
      throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    }
  }

  var formatDistanceLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },
    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },
    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },
    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },
    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },
    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },
    aboutXWeeks: {
      one: 'about 1 week',
      other: 'about {{count}} weeks'
    },
    xWeeks: {
      one: '1 week',
      other: '{{count}} weeks'
    },
    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },
    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },
    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },
    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },
    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },
    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  };
  var formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === 'string') {
      result = tokenValue;
    } else if (count === 1) {
      result = tokenValue.one;
    } else {
      result = tokenValue.other.replace('{{count}}', count.toString());
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        return 'in ' + result;
      } else {
        return result + ' ago';
      }
    }
    return result;
  };

  function buildFormatLongFn(args) {
    return function () {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // TODO: Remove String()
      var width = options.width ? String(options.width) : args.defaultWidth;
      var format = args.formats[width] || args.formats[args.defaultWidth];
      return format;
    };
  }

  var dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
  };
  var timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
  };
  var dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
  };
  var formatLong = {
    date: buildFormatLongFn({
      formats: dateFormats,
      defaultWidth: 'full'
    }),
    time: buildFormatLongFn({
      formats: timeFormats,
      defaultWidth: 'full'
    }),
    dateTime: buildFormatLongFn({
      formats: dateTimeFormats,
      defaultWidth: 'full'
    })
  };

  var formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
  };
  var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return formatRelativeLocale[token];
  };

  function buildLocalizeFn(args) {
    return function (dirtyIndex, options) {
      var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
      var valuesArray;
      if (context === 'formatting' && args.formattingValues) {
        var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
        var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
        valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
      } else {
        var _defaultWidth = args.defaultWidth;
        var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
        valuesArray = args.values[_width] || args.values[_defaultWidth];
      }
      var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
      // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
      return valuesArray[index];
    };
  }

  var eraValues = {
    narrow: ['B', 'A'],
    abbreviated: ['BC', 'AD'],
    wide: ['Before Christ', 'Anno Domini']
  };
  var quarterValues = {
    narrow: ['1', '2', '3', '4'],
    abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
    wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
  };

  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var monthValues = {
    narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
    abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  };
  var dayValues = {
    narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
    short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  };
  var dayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'morning',
      afternoon: 'afternoon',
      evening: 'evening',
      night: 'night'
    }
  };
  var formattingDayPeriodValues = {
    narrow: {
      am: 'a',
      pm: 'p',
      midnight: 'mi',
      noon: 'n',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    abbreviated: {
      am: 'AM',
      pm: 'PM',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    },
    wide: {
      am: 'a.m.',
      pm: 'p.m.',
      midnight: 'midnight',
      noon: 'noon',
      morning: 'in the morning',
      afternoon: 'in the afternoon',
      evening: 'in the evening',
      night: 'at night'
    }
  };
  var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);

    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.

    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) {
      switch (rem100 % 10) {
        case 1:
          return number + 'st';
        case 2:
          return number + 'nd';
        case 3:
          return number + 'rd';
      }
    }
    return number + 'th';
  };
  var localize = {
    ordinalNumber: ordinalNumber,
    era: buildLocalizeFn({
      values: eraValues,
      defaultWidth: 'wide'
    }),
    quarter: buildLocalizeFn({
      values: quarterValues,
      defaultWidth: 'wide',
      argumentCallback: function argumentCallback(quarter) {
        return quarter - 1;
      }
    }),
    month: buildLocalizeFn({
      values: monthValues,
      defaultWidth: 'wide'
    }),
    day: buildLocalizeFn({
      values: dayValues,
      defaultWidth: 'wide'
    }),
    dayPeriod: buildLocalizeFn({
      values: dayPeriodValues,
      defaultWidth: 'wide',
      formattingValues: formattingDayPeriodValues,
      defaultFormattingWidth: 'wide'
    })
  };

  function buildMatchFn(args) {
    return function (string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var width = options.width;
      var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
      var matchResult = string.match(matchPattern);
      if (!matchResult) {
        return null;
      }
      var matchedString = matchResult[0];
      var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
      var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      }) : findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
      var value;
      value = args.valueCallback ? args.valueCallback(key) : key;
      value = options.valueCallback ? options.valueCallback(value) : value;
      var rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }
  function findKey(object, predicate) {
    for (var key in object) {
      if (object.hasOwnProperty(key) && predicate(object[key])) {
        return key;
      }
    }
    return undefined;
  }
  function findIndex(array, predicate) {
    for (var key = 0; key < array.length; key++) {
      if (predicate(array[key])) {
        return key;
      }
    }
    return undefined;
  }

  function buildMatchPatternFn(args) {
    return function (string) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var matchResult = string.match(args.matchPattern);
      if (!matchResult) return null;
      var matchedString = matchResult[0];
      var parseResult = string.match(args.parsePattern);
      if (!parseResult) return null;
      var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
      value = options.valueCallback ? options.valueCallback(value) : value;
      var rest = string.slice(matchedString.length);
      return {
        value: value,
        rest: rest
      };
    };
  }

  var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
  var parseOrdinalNumberPattern = /\d+/i;
  var matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  };
  var parseEraPatterns = {
    any: [/^b/i, /^(a|c)/i]
  };
  var matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  };
  var parseQuarterPatterns = {
    any: [/1/i, /2/i, /3/i, /4/i]
  };
  var matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  };
  var parseMonthPatterns = {
    narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
    any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
  };
  var matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  };
  var parseDayPatterns = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  };
  var matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  };
  var parseDayPeriodPatterns = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  };
  var match = {
    ordinalNumber: buildMatchPatternFn({
      matchPattern: matchOrdinalNumberPattern,
      parsePattern: parseOrdinalNumberPattern,
      valueCallback: function valueCallback(value) {
        return parseInt(value, 10);
      }
    }),
    era: buildMatchFn({
      matchPatterns: matchEraPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseEraPatterns,
      defaultParseWidth: 'any'
    }),
    quarter: buildMatchFn({
      matchPatterns: matchQuarterPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseQuarterPatterns,
      defaultParseWidth: 'any',
      valueCallback: function valueCallback(index) {
        return index + 1;
      }
    }),
    month: buildMatchFn({
      matchPatterns: matchMonthPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseMonthPatterns,
      defaultParseWidth: 'any'
    }),
    day: buildMatchFn({
      matchPatterns: matchDayPatterns,
      defaultMatchWidth: 'wide',
      parsePatterns: parseDayPatterns,
      defaultParseWidth: 'any'
    }),
    dayPeriod: buildMatchFn({
      matchPatterns: matchDayPeriodPatterns,
      defaultMatchWidth: 'any',
      parsePatterns: parseDayPeriodPatterns,
      defaultParseWidth: 'any'
    })
  };

  /**
   * @type {Locale}
   * @category Locales
   * @summary English locale (United States).
   * @language English
   * @iso-639-2 eng
   * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
   * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
   */
  var locale = {
    code: 'en-US',
    formatDistance: formatDistance,
    formatLong: formatLong,
    formatRelative: formatRelative,
    localize: localize,
    match: match,
    options: {
      weekStartsOn: 0 /* Sunday */,
      firstWeekContainsDate: 1
    }
  };

  // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
  //   (one of the certain letters followed by `o`)
  // - (\w)\1* matches any sequences of the same letter
  // - '' matches two quote characters in a row
  // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
  //   except a single quote symbol, which ends the sequence.
  //   Two quote characters do not end the sequence.
  //   If there is no matching single quote
  //   then the sequence will continue until the end of the string.
  // - . matches any single character unmatched by previous parts of the RegExps
  var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

  // This RegExp catches symbols escaped by quotes, and also
  // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
  var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp$1 = /^'([^]*?)'?$/;
  var doubleQuoteRegExp$1 = /''/g;
  var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

  /**
   * @name format
   * @category Common Helpers
   * @summary Format the date.
   *
   * @description
   * Return the formatted date string in the given format. The result may vary by locale.
   *
   * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
   * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * The characters wrapped between two single quotes characters (') are escaped.
   * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   * (see the last example)
   *
   * Format of the string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   * with a few additions (see note 7 below the table).
   *
   * Accepted patterns:
   * | Unit                            | Pattern | Result examples                   | Notes |
   * |---------------------------------|---------|-----------------------------------|-------|
   * | Era                             | G..GGG  | AD, BC                            |       |
   * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
   * |                                 | GGGGG   | A, B                              |       |
   * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
   * |                                 | yy      | 44, 01, 00, 17                    | 5     |
   * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
   * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
   * |                                 | yyyyy   | ...                               | 3,5   |
   * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
   * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
   * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
   * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
   * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
   * |                                 | YYYYY   | ...                               | 3,5   |
   * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
   * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
   * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
   * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
   * |                                 | RRRRR   | ...                               | 3,5,7 |
   * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
   * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
   * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
   * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
   * |                                 | uuuuu   | ...                               | 3,5   |
   * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
   * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | QQ      | 01, 02, 03, 04                    |       |
   * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
   * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
   * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
   * |                                 | qq      | 01, 02, 03, 04                    |       |
   * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
   * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
   * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
   * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | MM      | 01, 02, ..., 12                   |       |
   * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
   * |                                 | MMMM    | January, February, ..., December  | 2     |
   * |                                 | MMMMM   | J, F, ..., D                      |       |
   * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
   * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
   * |                                 | LL      | 01, 02, ..., 12                   |       |
   * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
   * |                                 | LLLL    | January, February, ..., December  | 2     |
   * |                                 | LLLLL   | J, F, ..., D                      |       |
   * | Local week of year              | w       | 1, 2, ..., 53                     |       |
   * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | ww      | 01, 02, ..., 53                   |       |
   * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
   * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
   * |                                 | II      | 01, 02, ..., 53                   | 7     |
   * | Day of month                    | d       | 1, 2, ..., 31                     |       |
   * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
   * |                                 | dd      | 01, 02, ..., 31                   |       |
   * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
   * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
   * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
   * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
   * |                                 | DDDD    | ...                               | 3     |
   * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
   * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
   * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
   * |                                 | ii      | 01, 02, ..., 07                   | 7     |
   * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
   * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
   * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
   * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
   * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
   * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | ee      | 02, 03, ..., 01                   |       |
   * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
   * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
   * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
   * |                                 | cc      | 02, 03, ..., 01                   |       |
   * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
   * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | AM, PM                          | a..aa   | AM, PM                            |       |
   * |                                 | aaa     | am, pm                            |       |
   * |                                 | aaaa    | a.m., p.m.                        | 2     |
   * |                                 | aaaaa   | a, p                              |       |
   * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
   * |                                 | bbb     | am, pm, noon, midnight            |       |
   * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
   * |                                 | bbbbb   | a, p, n, mi                       |       |
   * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
   * |                                 | BBBB    | at night, in the morning, ...     | 2     |
   * |                                 | BBBBB   | at night, in the morning, ...     |       |
   * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
   * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
   * |                                 | hh      | 01, 02, ..., 11, 12               |       |
   * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
   * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
   * |                                 | HH      | 00, 01, 02, ..., 23               |       |
   * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
   * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
   * |                                 | KK      | 01, 02, ..., 11, 00               |       |
   * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
   * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
   * |                                 | kk      | 24, 01, 02, ..., 23               |       |
   * | Minute                          | m       | 0, 1, ..., 59                     |       |
   * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | mm      | 00, 01, ..., 59                   |       |
   * | Second                          | s       | 0, 1, ..., 59                     |       |
   * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
   * |                                 | ss      | 00, 01, ..., 59                   |       |
   * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
   * |                                 | SS      | 00, 01, ..., 99                   |       |
   * |                                 | SSS     | 000, 001, ..., 999                |       |
   * |                                 | SSSS    | ...                               | 3     |
   * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
   * |                                 | XX      | -0800, +0530, Z                   |       |
   * |                                 | XXX     | -08:00, +05:30, Z                 |       |
   * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
   * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
   * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
   * |                                 | xx      | -0800, +0530, +0000               |       |
   * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
   * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
   * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
   * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
   * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
   * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
   * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
   * | Seconds timestamp               | t       | 512969520                         | 7     |
   * |                                 | tt      | ...                               | 3,7   |
   * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
   * |                                 | TT      | ...                               | 3,7   |
   * | Long localized date             | P       | 04/29/1453                        | 7     |
   * |                                 | PP      | Apr 29, 1453                      | 7     |
   * |                                 | PPP     | April 29th, 1453                  | 7     |
   * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
   * | Long localized time             | p       | 12:00 AM                          | 7     |
   * |                                 | pp      | 12:00:00 AM                       | 7     |
   * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
   * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
   * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
   * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
   * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
   * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
   * Notes:
   * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
   *    are the same as "stand-alone" units, but are different in some languages.
   *    "Formatting" units are declined according to the rules of the language
   *    in the context of a date. "Stand-alone" units are always nominative singular:
   *
   *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
   *
   *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
   *
   * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
   *    the single quote characters (see below).
   *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
   *    the output will be the same as default pattern for this unit, usually
   *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
   *    are marked with "2" in the last column of the table.
   *
   *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
   *
   *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
   *
   * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
   *    The output will be padded with zeros to match the length of the pattern.
   *
   *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
   *
   * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
   *    These tokens represent the shortest form of the quarter.
   *
   * 5. The main difference between `y` and `u` patterns are B.C. years:
   *
   *    | Year | `y` | `u` |
   *    |------|-----|-----|
   *    | AC 1 |   1 |   1 |
   *    | BC 1 |   1 |   0 |
   *    | BC 2 |   2 |  -1 |
   *
   *    Also `yy` always returns the last two digits of a year,
   *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
   *
   *    | Year | `yy` | `uu` |
   *    |------|------|------|
   *    | 1    |   01 |   01 |
   *    | 14   |   14 |   14 |
   *    | 376  |   76 |  376 |
   *    | 1453 |   53 | 1453 |
   *
   *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
   *    except local week-numbering years are dependent on `options.weekStartsOn`
   *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
   *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
   *
   * 6. Specific non-location timezones are currently unavailable in `date-fns`,
   *    so right now these tokens fall back to GMT timezones.
   *
   * 7. These patterns are not in the Unicode Technical Standard #35:
   *    - `i`: ISO day of week
   *    - `I`: ISO week of year
   *    - `R`: ISO week-numbering year
   *    - `t`: seconds timestamp
   *    - `T`: milliseconds timestamp
   *    - `o`: ordinal number modifier
   *    - `P`: long localized date
   *    - `p`: long localized time
   *
   * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
   *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
   *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * @param {Date|Number} date - the original date
   * @param {String} format - the string of tokens
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
   * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
   *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
   *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @returns {String} the formatted date string
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} `date` must not be Invalid Date
   * @throws {RangeError} `options.locale` must contain `localize` property
   * @throws {RangeError} `options.locale` must contain `formatLong` property
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
   * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} format string contains an unescaped latin alphabet character
   *
   * @example
   * // Represent 11 February 2014 in middle-endian format:
   * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
   * //=> '02/11/2014'
   *
   * @example
   * // Represent 2 July 2014 in Esperanto:
   * import { eoLocale } from 'date-fns/locale/eo'
   * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
   *   locale: eoLocale
   * })
   * //=> '2-a de julio 2014'
   *
   * @example
   * // Escape string by single quote characters:
   * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
   * //=> "3 o'clock"
   */

  function format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = getDefaultOptions();
    var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
    var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }
    var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    if (!locale$1.localize) {
      throw new RangeError('locale must contain localize property');
    }
    if (!locale$1.formatLong) {
      throw new RangeError('locale must contain formatLong property');
    }
    var originalDate = toDate(dirtyDate);
    if (!isValid(originalDate)) {
      throw new RangeError('Invalid time value');
    }

    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
      firstWeekContainsDate: firstWeekContainsDate,
      weekStartsOn: weekStartsOn,
      locale: locale$1,
      _originalDate: originalDate
    };
    var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
      var firstCharacter = substring[0];
      if (firstCharacter === 'p' || firstCharacter === 'P') {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale$1.formatLong);
      }
      return substring;
    }).join('').match(formattingTokensRegExp$1).map(function (substring) {
      // Replace two single quote characters with one single quote character
      if (substring === "''") {
        return "'";
      }
      var firstCharacter = substring[0];
      if (firstCharacter === "'") {
        return cleanEscapedString$1(substring);
      }
      var formatter = formatters[firstCharacter];
      if (formatter) {
        if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
          throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
        }
        if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
          throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
        }
        return formatter(utcDate, substring, locale$1.localize, formatterOptions);
      }
      if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      }
      return substring;
    }).join('');
    return result;
  }
  function cleanEscapedString$1(input) {
    var matched = input.match(escapedStringRegExp$1);
    if (!matched) {
      return input;
    }
    return matched[1].replace(doubleQuoteRegExp$1, "'");
  }

  var format$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: format
  });

  var require$$5 = /*@__PURE__*/getAugmentedNamespace(format$1);

  var MILLISECONDS_IN_MINUTE = 60000;

  /**
   * @name addMinutes
   * @category Minute Helpers
   * @summary Add the specified number of minutes to the given date.
   *
   * @description
   * Add the specified number of minutes to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the minutes added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 30 minutes to 10 July 2014 12:00:00:
   * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
   * //=> Thu Jul 10 2014 12:30:00
   */
  function addMinutes(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
  }

  var addMinutes$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addMinutes
  });

  var require$$6 = /*@__PURE__*/getAugmentedNamespace(addMinutes$1);

  var MILLISECONDS_IN_HOUR = 3600000;

  /**
   * @name addHours
   * @category Hour Helpers
   * @summary Add the specified number of hours to the given date.
   *
   * @description
   * Add the specified number of hours to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the hours added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 2 hours to 10 July 2014 23:00:00:
   * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
   * //=> Fri Jul 11 2014 01:00:00
   */
  function addHours(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
  }

  var addHours$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addHours
  });

  var require$$7 = /*@__PURE__*/getAugmentedNamespace(addHours$1);

  /**
   * @name addDays
   * @category Day Helpers
   * @summary Add the specified number of days to the given date.
   *
   * @description
   * Add the specified number of days to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} - the new date with the days added
   * @throws {TypeError} - 2 arguments required
   *
   * @example
   * // Add 10 days to 1 September 2014:
   * const result = addDays(new Date(2014, 8, 1), 10)
   * //=> Thu Sep 11 2014 00:00:00
   */
  function addDays(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);
    if (isNaN(amount)) {
      return new Date(NaN);
    }
    if (!amount) {
      // If 0 days, no-op to avoid changing times in the hour before end of DST
      return date;
    }
    date.setDate(date.getDate() + amount);
    return date;
  }

  var addDays$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addDays
  });

  var require$$8 = /*@__PURE__*/getAugmentedNamespace(addDays$1);

  /**
   * @name addWeeks
   * @category Week Helpers
   * @summary Add the specified number of weeks to the given date.
   *
   * @description
   * Add the specified number of week to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the weeks added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 4 weeks to 1 September 2014:
   * const result = addWeeks(new Date(2014, 8, 1), 4)
   * //=> Mon Sep 29 2014 00:00:00
   */
  function addWeeks(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    var days = amount * 7;
    return addDays(dirtyDate, days);
  }

  var addWeeks$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addWeeks
  });

  var require$$9 = /*@__PURE__*/getAugmentedNamespace(addWeeks$1);

  /**
   * @name addMonths
   * @category Month Helpers
   * @summary Add the specified number of months to the given date.
   *
   * @description
   * Add the specified number of months to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the months added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 5 months to 1 September 2014:
   * const result = addMonths(new Date(2014, 8, 1), 5)
   * //=> Sun Feb 01 2015 00:00:00
   */
  function addMonths(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var amount = toInteger(dirtyAmount);
    if (isNaN(amount)) {
      return new Date(NaN);
    }
    if (!amount) {
      // If 0 months, no-op to avoid changing times in the hour before end of DST
      return date;
    }
    var dayOfMonth = date.getDate();

    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) {
      // If we're already at the end of the month, then this is the correct date
      // and we're done.
      return endOfDesiredMonth;
    } else {
      // Otherwise, we now know that setting the original day-of-month value won't
      // cause an overflow, so set the desired day-of-month. Note that we can't
      // just set the date of `endOfDesiredMonth` because that object may have had
      // its time changed in the unusual case where where a DST transition was on
      // the last day of the month and its local time was in the hour skipped or
      // repeated next to a DST transition.  So we use `date` instead which is
      // guaranteed to still have the original time.
      date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
      return date;
    }
  }

  var addMonths$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addMonths
  });

  var require$$10 = /*@__PURE__*/getAugmentedNamespace(addMonths$1);

  /**
   * @name addQuarters
   * @category Quarter Helpers
   * @summary Add the specified number of year quarters to the given date.
   *
   * @description
   * Add the specified number of year quarters to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the quarters added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 1 quarter to 1 September 2014:
   * const result = addQuarters(new Date(2014, 8, 1), 1)
   * //=> Mon Dec 01 2014 00:00:00
   */
  function addQuarters(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    var months = amount * 3;
    return addMonths(dirtyDate, months);
  }

  var addQuarters$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addQuarters
  });

  var require$$11 = /*@__PURE__*/getAugmentedNamespace(addQuarters$1);

  /**
   * @name addYears
   * @category Year Helpers
   * @summary Add the specified number of years to the given date.
   *
   * @description
   * Add the specified number of years to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the years added
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Add 5 years to 1 September 2014:
   * const result = addYears(new Date(2014, 8, 1), 5)
   * //=> Sun Sep 01 2019 00:00:00
   */
  function addYears(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMonths(dirtyDate, amount * 12);
  }

  var addYears$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: addYears
  });

  var require$$12 = /*@__PURE__*/getAugmentedNamespace(addYears$1);

  /**
   * @name subDays
   * @category Day Helpers
   * @summary Subtract the specified number of days from the given date.
   *
   * @description
   * Subtract the specified number of days from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the days subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 10 days from 1 September 2014:
   * const result = subDays(new Date(2014, 8, 1), 10)
   * //=> Fri Aug 22 2014 00:00:00
   */
  function subDays(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addDays(dirtyDate, -amount);
  }

  var subDays$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: subDays
  });

  var require$$13 = /*@__PURE__*/getAugmentedNamespace(subDays$1);

  /**
   * @name subWeeks
   * @category Week Helpers
   * @summary Subtract the specified number of weeks from the given date.
   *
   * @description
   * Subtract the specified number of weeks from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the weeks subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 4 weeks from 1 September 2014:
   * const result = subWeeks(new Date(2014, 8, 1), 4)
   * //=> Mon Aug 04 2014 00:00:00
   */
  function subWeeks(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addWeeks(dirtyDate, -amount);
  }

  var subWeeks$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: subWeeks
  });

  var require$$14 = /*@__PURE__*/getAugmentedNamespace(subWeeks$1);

  /**
   * @name subMonths
   * @category Month Helpers
   * @summary Subtract the specified number of months from the given date.
   *
   * @description
   * Subtract the specified number of months from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the months subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 5 months from 1 February 2015:
   * const result = subMonths(new Date(2015, 1, 1), 5)
   * //=> Mon Sep 01 2014 00:00:00
   */
  function subMonths(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addMonths(dirtyDate, -amount);
  }

  var subMonths$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: subMonths
  });

  var require$$15 = /*@__PURE__*/getAugmentedNamespace(subMonths$1);

  /**
   * @name subQuarters
   * @category Quarter Helpers
   * @summary Subtract the specified number of year quarters from the given date.
   *
   * @description
   * Subtract the specified number of year quarters from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the quarters subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 3 quarters from 1 September 2014:
   * const result = subQuarters(new Date(2014, 8, 1), 3)
   * //=> Sun Dec 01 2013 00:00:00
   */
  function subQuarters(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addQuarters(dirtyDate, -amount);
  }

  var subQuarters$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: subQuarters
  });

  var require$$16 = /*@__PURE__*/getAugmentedNamespace(subQuarters$1);

  /**
   * @name subYears
   * @category Year Helpers
   * @summary Subtract the specified number of years from the given date.
   *
   * @description
   * Subtract the specified number of years from the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
   * @returns {Date} the new date with the years subtracted
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Subtract 5 years from 1 September 2014:
   * const result = subYears(new Date(2014, 8, 1), 5)
   * //=> Tue Sep 01 2009 00:00:00
   */
  function subYears(dirtyDate, dirtyAmount) {
    requiredArgs(2, arguments);
    var amount = toInteger(dirtyAmount);
    return addYears(dirtyDate, -amount);
  }

  var subYears$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: subYears
  });

  var require$$17 = /*@__PURE__*/getAugmentedNamespace(subYears$1);

  /**
   * @name getSeconds
   * @category Second Helpers
   * @summary Get the seconds of the given date.
   *
   * @description
   * Get the seconds of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the seconds
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the seconds of 29 February 2012 11:45:05.123:
   * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
   * //=> 5
   */
  function getSeconds(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
  }

  var getSeconds$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getSeconds
  });

  var require$$18 = /*@__PURE__*/getAugmentedNamespace(getSeconds$1);

  /**
   * @name getMinutes
   * @category Minute Helpers
   * @summary Get the minutes of the given date.
   *
   * @description
   * Get the minutes of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the minutes
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the minutes of 29 February 2012 11:45:05:
   * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
   * //=> 45
   */
  function getMinutes(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
  }

  var getMinutes$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getMinutes
  });

  var require$$19 = /*@__PURE__*/getAugmentedNamespace(getMinutes$1);

  /**
   * @name getHours
   * @category Hour Helpers
   * @summary Get the hours of the given date.
   *
   * @description
   * Get the hours of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the hours
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the hours of 29 February 2012 11:45:00:
   * const result = getHours(new Date(2012, 1, 29, 11, 45))
   * //=> 11
   */
  function getHours(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var hours = date.getHours();
    return hours;
  }

  var getHours$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getHours
  });

  var require$$20 = /*@__PURE__*/getAugmentedNamespace(getHours$1);

  /**
   * @name getDay
   * @category Weekday Helpers
   * @summary Get the day of the week of the given date.
   *
   * @description
   * Get the day of the week of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which day of the week is 29 February 2012?
   * const result = getDay(new Date(2012, 1, 29))
   * //=> 3
   */
  function getDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var day = date.getDay();
    return day;
  }

  var getDay$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getDay
  });

  var require$$21 = /*@__PURE__*/getAugmentedNamespace(getDay$1);

  /**
   * @name getDate
   * @category Day Helpers
   * @summary Get the day of the month of the given date.
   *
   * @description
   * Get the day of the month of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the day of month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which day of the month is 29 February 2012?
   * const result = getDate(new Date(2012, 1, 29))
   * //=> 29
   */
  function getDate(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
  }

  var getDate$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getDate
  });

  var require$$22 = /*@__PURE__*/getAugmentedNamespace(getDate$1);

  /**
   * @name startOfWeek
   * @category Week Helpers
   * @summary Return the start of a week for the given date.
   *
   * @description
   * Return the start of a week for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @returns {Date} the start of a week
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   *
   * @example
   * // The start of a week for 2 September 2014 11:55:00:
   * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Sun Aug 31 2014 00:00:00
   *
   * @example
   * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
   * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
   * //=> Mon Sep 01 2014 00:00:00
   */
  function startOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var startOfWeek$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: startOfWeek
  });

  /**
   * @name startOfISOWeek
   * @category ISO Week Helpers
   * @summary Return the start of an ISO week for the given date.
   *
   * @description
   * Return the start of an ISO week for the given date.
   * The result will be in the local timezone.
   *
   * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of an ISO week
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of an ISO week for 2 September 2014 11:55:00:
   * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Mon Sep 01 2014 00:00:00
   */
  function startOfISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    return startOfWeek(dirtyDate, {
      weekStartsOn: 1
    });
  }

  /**
   * @name getISOWeekYear
   * @category ISO Week-Numbering Year Helpers
   * @summary Get the ISO week-numbering year of the given date.
   *
   * @description
   * Get the ISO week-numbering year of the given date,
   * which always starts 3 days before the year's first Thursday.
   *
   * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the ISO week-numbering year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which ISO-week numbering year is 2 January 2005?
   * const result = getISOWeekYear(new Date(2005, 0, 2))
   * //=> 2004
   */
  function getISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) {
      return year + 1;
    } else if (date.getTime() >= startOfThisYear.getTime()) {
      return year;
    } else {
      return year - 1;
    }
  }

  /**
   * @name startOfISOWeekYear
   * @category ISO Week-Numbering Year Helpers
   * @summary Return the start of an ISO week-numbering year for the given date.
   *
   * @description
   * Return the start of an ISO week-numbering year,
   * which always starts 3 days before the year's first Thursday.
   * The result will be in the local timezone.
   *
   * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of an ISO week-numbering year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of an ISO week-numbering year for 2 July 2005:
   * const result = startOfISOWeekYear(new Date(2005, 6, 2))
   * //=> Mon Jan 03 2005 00:00:00
   */
  function startOfISOWeekYear(dirtyDate) {
    requiredArgs(1, arguments);
    var year = getISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = startOfISOWeek(fourthOfJanuary);
    return date;
  }

  var MILLISECONDS_IN_WEEK = 604800000;

  /**
   * @name getISOWeek
   * @category ISO Week Helpers
   * @summary Get the ISO week of the given date.
   *
   * @description
   * Get the ISO week of the given date.
   *
   * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the ISO week
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which week of the ISO-week numbering year is 2 January 2005?
   * const result = getISOWeek(new Date(2005, 0, 2))
   * //=> 53
   */
  function getISOWeek(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
  }

  var getISOWeek$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getISOWeek
  });

  var require$$23 = /*@__PURE__*/getAugmentedNamespace(getISOWeek$1);

  /**
   * @name getMonth
   * @category Month Helpers
   * @summary Get the month of the given date.
   *
   * @description
   * Get the month of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which month is 29 February 2012?
   * const result = getMonth(new Date(2012, 1, 29))
   * //=> 1
   */
  function getMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var month = date.getMonth();
    return month;
  }

  var getMonth$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getMonth
  });

  var require$$24 = /*@__PURE__*/getAugmentedNamespace(getMonth$1);

  /**
   * @name getQuarter
   * @category Quarter Helpers
   * @summary Get the year quarter of the given date.
   *
   * @description
   * Get the year quarter of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the quarter
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which quarter is 2 July 2014?
   * const result = getQuarter(new Date(2014, 6, 2))
   * //=> 3
   */
  function getQuarter(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
  }

  var getQuarter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getQuarter
  });

  var require$$25 = /*@__PURE__*/getAugmentedNamespace(getQuarter$1);

  /**
   * @name getYear
   * @category Year Helpers
   * @summary Get the year of the given date.
   *
   * @description
   * Get the year of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which year is 2 July 2014?
   * const result = getYear(new Date(2014, 6, 2))
   * //=> 2014
   */
  function getYear(dirtyDate) {
    requiredArgs(1, arguments);
    return toDate(dirtyDate).getFullYear();
  }

  var getYear$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getYear
  });

  var require$$26 = /*@__PURE__*/getAugmentedNamespace(getYear$1);

  /**
   * @name getTime
   * @category Timestamp Helpers
   * @summary Get the milliseconds timestamp of the given date.
   *
   * @description
   * Get the milliseconds timestamp of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the timestamp
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Get the timestamp of 29 February 2012 11:45:05.123:
   * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
   * //=> 1330515905123
   */
  function getTime(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
  }

  var getTime$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: getTime
  });

  var require$$27 = /*@__PURE__*/getAugmentedNamespace(getTime$1);

  /**
   * @name setSeconds
   * @category Second Helpers
   * @summary Set the seconds to the given date.
   *
   * @description
   * Set the seconds to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} seconds - the seconds of the new date
   * @returns {Date} the new date with the seconds set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 45 seconds to 1 September 2014 11:30:40:
   * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
   * //=> Mon Sep 01 2014 11:30:45
   */
  function setSeconds(dirtyDate, dirtySeconds) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var seconds = toInteger(dirtySeconds);
    date.setSeconds(seconds);
    return date;
  }

  var setSeconds$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setSeconds
  });

  var require$$28 = /*@__PURE__*/getAugmentedNamespace(setSeconds$1);

  /**
   * @name setMinutes
   * @category Minute Helpers
   * @summary Set the minutes to the given date.
   *
   * @description
   * Set the minutes to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} minutes - the minutes of the new date
   * @returns {Date} the new date with the minutes set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 45 minutes to 1 September 2014 11:30:40:
   * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
   * //=> Mon Sep 01 2014 11:45:40
   */
  function setMinutes(dirtyDate, dirtyMinutes) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var minutes = toInteger(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
  }

  var setMinutes$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setMinutes
  });

  var require$$29 = /*@__PURE__*/getAugmentedNamespace(setMinutes$1);

  /**
   * @name setHours
   * @category Hour Helpers
   * @summary Set the hours to the given date.
   *
   * @description
   * Set the hours to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} hours - the hours of the new date
   * @returns {Date} the new date with the hours set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set 4 hours to 1 September 2014 11:30:00:
   * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
   * //=> Mon Sep 01 2014 04:30:00
   */
  function setHours(dirtyDate, dirtyHours) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var hours = toInteger(dirtyHours);
    date.setHours(hours);
    return date;
  }

  var setHours$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setHours
  });

  var require$$30 = /*@__PURE__*/getAugmentedNamespace(setHours$1);

  /**
   * @name getDaysInMonth
   * @category Month Helpers
   * @summary Get the number of days in a month of the given date.
   *
   * @description
   * Get the number of days in a month of the given date.
   *
   * @param {Date|Number} date - the given date
   * @returns {Number} the number of days in a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // How many days are in February 2000?
   * const result = getDaysInMonth(new Date(2000, 1))
   * //=> 29
   */
  function getDaysInMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
  }

  /**
   * @name setMonth
   * @category Month Helpers
   * @summary Set the month to the given date.
   *
   * @description
   * Set the month to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} month - the month of the new date
   * @returns {Date} the new date with the month set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set February to 1 September 2014:
   * const result = setMonth(new Date(2014, 8, 1), 1)
   * //=> Sat Feb 01 2014 00:00:00
   */
  function setMonth(dirtyDate, dirtyMonth) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var month = toInteger(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
  }

  var setMonth$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setMonth
  });

  var require$$31 = /*@__PURE__*/getAugmentedNamespace(setMonth$1);

  /**
   * @name setQuarter
   * @category Quarter Helpers
   * @summary Set the year quarter to the given date.
   *
   * @description
   * Set the year quarter to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} quarter - the quarter of the new date
   * @returns {Date} the new date with the quarter set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set the 2nd quarter to 2 July 2014:
   * const result = setQuarter(new Date(2014, 6, 2), 2)
   * //=> Wed Apr 02 2014 00:00:00
   */
  function setQuarter(dirtyDate, dirtyQuarter) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var quarter = toInteger(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return setMonth(date, date.getMonth() + diff * 3);
  }

  var setQuarter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setQuarter
  });

  var require$$32 = /*@__PURE__*/getAugmentedNamespace(setQuarter$1);

  /**
   * @name setYear
   * @category Year Helpers
   * @summary Set the year to the given date.
   *
   * @description
   * Set the year to the given date.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Number} year - the year of the new date
   * @returns {Date} the new date with the year set
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Set year 2013 to 1 September 2014:
   * const result = setYear(new Date(2014, 8, 1), 2013)
   * //=> Sun Sep 01 2013 00:00:00
   */
  function setYear(dirtyDate, dirtyYear) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var year = toInteger(dirtyYear);

    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) {
      return new Date(NaN);
    }
    date.setFullYear(year);
    return date;
  }

  var setYear$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: setYear
  });

  var require$$33 = /*@__PURE__*/getAugmentedNamespace(setYear$1);

  /**
   * @name min
   * @category Common Helpers
   * @summary Returns the earliest of the given dates.
   *
   * @description
   * Returns the earliest of the given dates.
   *
   * @param {Date[]|Number[]} datesArray - the dates to compare
   * @returns {Date} - the earliest of the dates
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which of these dates is the earliest?
   * const result = min([
   *   new Date(1989, 6, 10),
   *   new Date(1987, 1, 11),
   *   new Date(1995, 6, 2),
   *   new Date(1990, 0, 1)
   * ])
   * //=> Wed Feb 11 1987 00:00:00
   */
  function min(dirtyDatesArray) {
    requiredArgs(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
      datesArray = dirtyDatesArray;
      // If `dirtyDatesArray` is Array-like Object, convert to Array.
    } else if (_typeof$1(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
      datesArray = Array.prototype.slice.call(dirtyDatesArray);
    } else {
      // `dirtyDatesArray` is non-iterable, return Invalid Date
      return new Date(NaN);
    }
    var result;
    datesArray.forEach(function (dirtyDate) {
      var currentDate = toDate(dirtyDate);
      if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
        result = currentDate;
      }
    });
    return result || new Date(NaN);
  }

  var min$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: min
  });

  var require$$34 = /*@__PURE__*/getAugmentedNamespace(min$1);

  /**
   * @name max
   * @category Common Helpers
   * @summary Return the latest of the given dates.
   *
   * @description
   * Return the latest of the given dates.
   *
   * @param {Date[]|Number[]} datesArray - the dates to compare
   * @returns {Date} the latest of the dates
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // Which of these dates is the latest?
   * const result = max([
   *   new Date(1989, 6, 10),
   *   new Date(1987, 1, 11),
   *   new Date(1995, 6, 2),
   *   new Date(1990, 0, 1)
   * ])
   * //=> Sun Jul 02 1995 00:00:00
   */
  function max(dirtyDatesArray) {
    requiredArgs(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
      datesArray = dirtyDatesArray;

      // If `dirtyDatesArray` is Array-like Object, convert to Array.
    } else if (_typeof$1(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
      datesArray = Array.prototype.slice.call(dirtyDatesArray);
    } else {
      // `dirtyDatesArray` is non-iterable, return Invalid Date
      return new Date(NaN);
    }
    var result;
    datesArray.forEach(function (dirtyDate) {
      var currentDate = toDate(dirtyDate);
      if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
        result = currentDate;
      }
    });
    return result || new Date(NaN);
  }

  var max$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: max
  });

  var require$$35 = /*@__PURE__*/getAugmentedNamespace(max$1);

  /**
   * @name startOfDay
   * @category Day Helpers
   * @summary Return the start of a day for the given date.
   *
   * @description
   * Return the start of a day for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a day
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a day for 2 September 2014 11:55:00:
   * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 02 2014 00:00:00
   */
  function startOfDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var startOfDay$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: startOfDay
  });

  var MILLISECONDS_IN_DAY = 86400000;

  /**
   * @name differenceInCalendarDays
   * @category Day Helpers
   * @summary Get the number of calendar days between the given dates.
   *
   * @description
   * Get the number of calendar days between the given dates. This means that the times are removed
   * from the dates and then the difference in days is calculated.
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar days
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar days are between
   * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
   * const result = differenceInCalendarDays(
   *   new Date(2012, 6, 2, 0, 0),
   *   new Date(2011, 6, 2, 23, 0)
   * )
   * //=> 366
   * // How many calendar days are between
   * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
   * const result = differenceInCalendarDays(
   *   new Date(2011, 6, 3, 0, 1),
   *   new Date(2011, 6, 2, 23, 59)
   * )
   * //=> 1
   */
  function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var startOfDayLeft = startOfDay(dirtyDateLeft);
    var startOfDayRight = startOfDay(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
  }

  var differenceInCalendarDays$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: differenceInCalendarDays
  });

  var require$$36 = /*@__PURE__*/getAugmentedNamespace(differenceInCalendarDays$1);

  /**
   * @name differenceInCalendarMonths
   * @category Month Helpers
   * @summary Get the number of calendar months between the given dates.
   *
   * @description
   * Get the number of calendar months between the given dates.
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar months
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar months are between 31 January 2014 and 1 September 2014?
   * const result = differenceInCalendarMonths(
   *   new Date(2014, 8, 1),
   *   new Date(2014, 0, 31)
   * )
   * //=> 8
   */
  function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
  }

  var differenceInCalendarMonths$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: differenceInCalendarMonths
  });

  var require$$37 = /*@__PURE__*/getAugmentedNamespace(differenceInCalendarMonths$1);

  /**
   * @name differenceInCalendarYears
   * @category Year Helpers
   * @summary Get the number of calendar years between the given dates.
   *
   * @description
   * Get the number of calendar years between the given dates.
   *
   * @param {Date|Number} dateLeft - the later date
   * @param {Date|Number} dateRight - the earlier date
   * @returns {Number} the number of calendar years
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // How many calendar years are between 31 December 2013 and 11 February 2015?
   * const result = differenceInCalendarYears(
   *   new Date(2015, 1, 11),
   *   new Date(2013, 11, 31)
   * )
   * //=> 2
   */
  function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
  }

  var differenceInCalendarYears$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: differenceInCalendarYears
  });

  var require$$38 = /*@__PURE__*/getAugmentedNamespace(differenceInCalendarYears$1);

  var require$$39 = /*@__PURE__*/getAugmentedNamespace(startOfDay$1);

  var require$$40 = /*@__PURE__*/getAugmentedNamespace(startOfWeek$1);

  /**
   * @name startOfMonth
   * @category Month Helpers
   * @summary Return the start of a month for the given date.
   *
   * @description
   * Return the start of a month for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a month for 2 September 2014 11:55:00:
   * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Mon Sep 01 2014 00:00:00
   */
  function startOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var startOfMonth$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: startOfMonth
  });

  var require$$41 = /*@__PURE__*/getAugmentedNamespace(startOfMonth$1);

  /**
   * @name startOfQuarter
   * @category Quarter Helpers
   * @summary Return the start of a year quarter for the given date.
   *
   * @description
   * Return the start of a year quarter for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a quarter
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a quarter for 2 September 2014 11:55:00:
   * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Jul 01 2014 00:00:00
   */
  function startOfQuarter(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var startOfQuarter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: startOfQuarter
  });

  var require$$42 = /*@__PURE__*/getAugmentedNamespace(startOfQuarter$1);

  /**
   * @name startOfYear
   * @category Year Helpers
   * @summary Return the start of a year for the given date.
   *
   * @description
   * Return the start of a year for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the start of a year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The start of a year for 2 September 2014 11:55:00:
   * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
   * //=> Wed Jan 01 2014 00:00:00
   */
  function startOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var cleanDate = toDate(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
  }

  var startOfYear$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: startOfYear
  });

  var require$$43 = /*@__PURE__*/getAugmentedNamespace(startOfYear$1);

  /**
   * @name endOfDay
   * @category Day Helpers
   * @summary Return the end of a day for the given date.
   *
   * @description
   * Return the end of a day for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a day
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a day for 2 September 2014 11:55:00:
   * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 02 2014 23:59:59.999
   */
  function endOfDay(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
  }

  var endOfDay$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: endOfDay
  });

  var require$$44 = /*@__PURE__*/getAugmentedNamespace(endOfDay$1);

  /**
   * @name endOfWeek
   * @category Week Helpers
   * @summary Return the end of a week for the given date.
   *
   * @description
   * Return the end of a week for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @returns {Date} the end of a week
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   *
   * @example
   * // The end of a week for 2 September 2014 11:55:00:
   * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Sat Sep 06 2014 23:59:59.999
   *
   * @example
   * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
   * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
   * //=> Sun Sep 07 2014 23:59:59.999
   */
  function endOfWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(1, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var date = toDate(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
  }

  var endOfWeek$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: endOfWeek
  });

  var require$$45 = /*@__PURE__*/getAugmentedNamespace(endOfWeek$1);

  /**
   * @name endOfMonth
   * @category Month Helpers
   * @summary Return the end of a month for the given date.
   *
   * @description
   * Return the end of a month for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a month
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a month for 2 September 2014 11:55:00:
   * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
   * //=> Tue Sep 30 2014 23:59:59.999
   */
  function endOfMonth(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }

  var endOfMonth$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: endOfMonth
  });

  var require$$46 = /*@__PURE__*/getAugmentedNamespace(endOfMonth$1);

  /**
   * @name endOfYear
   * @category Year Helpers
   * @summary Return the end of a year for the given date.
   *
   * @description
   * Return the end of a year for the given date.
   * The result will be in the local timezone.
   *
   * @param {Date|Number} date - the original date
   * @returns {Date} the end of a year
   * @throws {TypeError} 1 argument required
   *
   * @example
   * // The end of a year for 2 September 2014 11:55:00:
   * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
   * //=> Wed Dec 31 2014 23:59:59.999
   */
  function endOfYear(dirtyDate) {
    requiredArgs(1, arguments);
    var date = toDate(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
  }

  var endOfYear$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: endOfYear
  });

  var require$$47 = /*@__PURE__*/getAugmentedNamespace(endOfYear$1);

  /**
   * @name isEqual
   * @category Common Helpers
   * @summary Are the given dates equal?
   *
   * @description
   * Are the given dates equal?
   *
   * @param {Date|Number} dateLeft - the first date to compare
   * @param {Date|Number} dateRight - the second date to compare
   * @returns {Boolean} the dates are equal
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
   * const result = isEqual(
   *   new Date(2014, 6, 2, 6, 30, 45, 0),
   *   new Date(2014, 6, 2, 6, 30, 45, 500)
   * )
   * //=> false
   */
  function isEqual$2(dirtyLeftDate, dirtyRightDate) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyLeftDate);
    var dateRight = toDate(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
  }

  var isEqual$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isEqual$2
  });

  var require$$48 = /*@__PURE__*/getAugmentedNamespace(isEqual$3);

  /**
   * @name isSameDay
   * @category Day Helpers
   * @summary Are the given dates in the same day (and year and month)?
   *
   * @description
   * Are the given dates in the same day (and year and month)?
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same day (and year and month)
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
   * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
   * //=> true
   *
   * @example
   * // Are 4 September and 4 October in the same day?
   * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
   * //=> false
   *
   * @example
   * // Are 4 September, 2014 and 4 September, 2015 in the same day?
   * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
   * //=> false
   */
  function isSameDay(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
    var dateRightStartOfDay = startOfDay(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
  }

  var isSameDay$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isSameDay
  });

  var require$$49 = /*@__PURE__*/getAugmentedNamespace(isSameDay$1);

  /**
   * @name isSameMonth
   * @category Month Helpers
   * @summary Are the given dates in the same month (and year)?
   *
   * @description
   * Are the given dates in the same month (and year)?
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same month (and year)
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 September 2014 and 25 September 2014 in the same month?
   * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
   * //=> true
   *
   * @example
   * // Are 2 September 2014 and 25 September 2015 in the same month?
   * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
   * //=> false
   */
  function isSameMonth(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
  }

  var isSameMonth$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isSameMonth
  });

  var require$$50 = /*@__PURE__*/getAugmentedNamespace(isSameMonth$1);

  /**
   * @name isSameYear
   * @category Year Helpers
   * @summary Are the given dates in the same year?
   *
   * @description
   * Are the given dates in the same year?
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same year
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 2 September 2014 and 25 September 2014 in the same year?
   * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
   * //=> true
   */
  function isSameYear(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeft = toDate(dirtyDateLeft);
    var dateRight = toDate(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
  }

  var isSameYear$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isSameYear
  });

  var require$$51 = /*@__PURE__*/getAugmentedNamespace(isSameYear$1);

  /**
   * @name isSameQuarter
   * @category Quarter Helpers
   * @summary Are the given dates in the same quarter (and year)?
   *
   * @description
   * Are the given dates in the same quarter (and year)?
   *
   * @param {Date|Number} dateLeft - the first date to check
   * @param {Date|Number} dateRight - the second date to check
   * @returns {Boolean} the dates are in the same quarter (and year)
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Are 1 January 2014 and 8 March 2014 in the same quarter?
   * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
   * //=> true
   *
   * @example
   * // Are 1 January 2014 and 1 January 2015 in the same quarter?
   * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
   * //=> false
   */
  function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
    requiredArgs(2, arguments);
    var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
    var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
  }

  var isSameQuarter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isSameQuarter
  });

  var require$$52 = /*@__PURE__*/getAugmentedNamespace(isSameQuarter$1);

  /**
   * @name isAfter
   * @category Common Helpers
   * @summary Is the first date after the second one?
   *
   * @description
   * Is the first date after the second one?
   *
   * @param {Date|Number} date - the date that should be after the other one to return true
   * @param {Date|Number} dateToCompare - the date to compare with
   * @returns {Boolean} the first date is after the second date
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Is 10 July 1989 after 11 February 1987?
   * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
   * //=> true
   */
  function isAfter(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
  }

  var isAfter$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isAfter
  });

  var require$$53 = /*@__PURE__*/getAugmentedNamespace(isAfter$1);

  /**
   * @name isBefore
   * @category Common Helpers
   * @summary Is the first date before the second one?
   *
   * @description
   * Is the first date before the second one?
   *
   * @param {Date|Number} date - the date that should be before the other one to return true
   * @param {Date|Number} dateToCompare - the date to compare with
   * @returns {Boolean} the first date is before the second date
   * @throws {TypeError} 2 arguments required
   *
   * @example
   * // Is 10 July 1989 before 11 February 1987?
   * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
   * //=> false
   */
  function isBefore(dirtyDate, dirtyDateToCompare) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var dateToCompare = toDate(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
  }

  var isBefore$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isBefore
  });

  var require$$54 = /*@__PURE__*/getAugmentedNamespace(isBefore$1);

  /**
   * @name isWithinInterval
   * @category Interval Helpers
   * @summary Is the given date within the interval?
   *
   * @description
   * Is the given date within the interval? (Including start and end.)
   *
   * @param {Date|Number} date - the date to check
   * @param {Interval} interval - the interval to check
   * @returns {Boolean} the date is within the interval
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} The start of an interval cannot be after its end
   * @throws {RangeError} Date in interval cannot be `Invalid Date`
   *
   * @example
   * // For the date within the interval:
   * isWithinInterval(new Date(2014, 0, 3), {
   *   start: new Date(2014, 0, 1),
   *   end: new Date(2014, 0, 7)
   * })
   * //=> true
   *
   * @example
   * // For the date outside of the interval:
   * isWithinInterval(new Date(2014, 0, 10), {
   *   start: new Date(2014, 0, 1),
   *   end: new Date(2014, 0, 7)
   * })
   * //=> false
   *
   * @example
   * // For date equal to interval start:
   * isWithinInterval(date, { start, end: date }) // => true
   *
   * @example
   * // For date equal to interval end:
   * isWithinInterval(date, { start: date, end }) // => true
   */
  function isWithinInterval(dirtyDate, interval) {
    requiredArgs(2, arguments);
    var time = toDate(dirtyDate).getTime();
    var startTime = toDate(interval.start).getTime();
    var endTime = toDate(interval.end).getTime();

    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) {
      throw new RangeError('Invalid interval');
    }
    return time >= startTime && time <= endTime;
  }

  var isWithinInterval$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: isWithinInterval
  });

  var require$$55 = /*@__PURE__*/getAugmentedNamespace(isWithinInterval$1);

  var require$$56 = /*@__PURE__*/getAugmentedNamespace(toDate$1);

  function _createForOfIteratorHelper$3(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
      if (Array.isArray(r) || (t = _unsupportedIterableToArray$3(r)) || e) {
        t && (r = t);
        var _n = 0,
          F = function F() {};
        return {
          s: F,
          n: function n() {
            return _n >= r.length ? {
              done: true
            } : {
              done: false,
              value: r[_n++]
            };
          },
          e: function e(r) {
            throw r;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = true,
      u = false;
    return {
      s: function s() {
        t = t.call(r);
      },
      n: function n() {
        var r = t.next();
        return a = r.done, r;
      },
      e: function e(r) {
        u = true, o = r;
      },
      f: function f() {
        try {
          a || null == t["return"] || t["return"]();
        } finally {
          if (u) throw o;
        }
      }
    };
  }

  function assign(target, object) {
    if (target == null) {
      throw new TypeError('assign requires that input parameter not be null or undefined');
    }
    for (var property in object) {
      if (Object.prototype.hasOwnProperty.call(object, property)) {
        target[property] = object[property];
      }
    }
    return target;
  }

  function _assertThisInitialized$1(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: true,
        configurable: true
      }
    }), Object.defineProperty(t, "prototype", {
      writable: false
    }), e && _setPrototypeOf$1(t, e);
  }

  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }

  function _isNativeReflectConstruct$z() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct$z = function _isNativeReflectConstruct() {
      return !!t;
    })();
  }

  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof$1(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized$1(t);
  }

  function _createSuper(t) {
    var r = _isNativeReflectConstruct$z();
    return function () {
      var e,
        o = _getPrototypeOf(t);
      if (r) {
        var s = _getPrototypeOf(this).constructor;
        e = Reflect.construct(o, arguments, s);
      } else e = o.apply(this, arguments);
      return _possibleConstructorReturn(this, e);
    };
  }

  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }

  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), Object.defineProperty(e, "prototype", {
      writable: false
    }), e;
  }

  var TIMEZONE_UNIT_PRIORITY = 10;
  var Setter = /*#__PURE__*/function () {
    function Setter() {
      _classCallCheck(this, Setter);
      _defineProperty(this, "priority", void 0);
      _defineProperty(this, "subPriority", 0);
    }
    _createClass(Setter, [{
      key: "validate",
      value: function validate(_utcDate, _options) {
        return true;
      }
    }]);
    return Setter;
  }();
  var ValueSetter = /*#__PURE__*/function (_Setter) {
    _inherits(ValueSetter, _Setter);
    var _super = _createSuper(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
      var _this;
      _classCallCheck(this, ValueSetter);
      _this = _super.call(this);
      _this.value = value;
      _this.validateValue = validateValue;
      _this.setValue = setValue;
      _this.priority = priority;
      if (subPriority) {
        _this.subPriority = subPriority;
      }
      return _this;
    }
    _createClass(ValueSetter, [{
      key: "validate",
      value: function validate(utcDate, options) {
        return this.validateValue(utcDate, this.value, options);
      }
    }, {
      key: "set",
      value: function set(utcDate, flags, options) {
        return this.setValue(utcDate, flags, this.value, options);
      }
    }]);
    return ValueSetter;
  }(Setter);
  var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
    _inherits(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = _createSuper(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
      var _this2;
      _classCallCheck(this, DateToSystemTimezoneSetter);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this2 = _super2.call.apply(_super2, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
      _defineProperty(_assertThisInitialized$1(_this2), "subPriority", -1);
      return _this2;
    }
    _createClass(DateToSystemTimezoneSetter, [{
      key: "set",
      value: function set(date, flags) {
        if (flags.timestampIsSet) {
          return date;
        }
        var convertedDate = new Date(0);
        convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
        return convertedDate;
      }
    }]);
    return DateToSystemTimezoneSetter;
  }(Setter);

  var Parser = /*#__PURE__*/function () {
    function Parser() {
      _classCallCheck(this, Parser);
      _defineProperty(this, "incompatibleTokens", void 0);
      _defineProperty(this, "priority", void 0);
      _defineProperty(this, "subPriority", void 0);
    }
    _createClass(Parser, [{
      key: "run",
      value: function run(dateString, token, match, options) {
        var result = this.parse(dateString, token, match, options);
        if (!result) {
          return null;
        }
        return {
          setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
          rest: result.rest
        };
      }
    }, {
      key: "validate",
      value: function validate(_utcDate, _value, _options) {
        return true;
      }
    }]);
    return Parser;
  }();

  var EraParser = /*#__PURE__*/function (_Parser) {
    _inherits(EraParser, _Parser);
    var _super = _createSuper(EraParser);
    function EraParser() {
      var _this;
      _classCallCheck(this, EraParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 140);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
      return _this;
    }
    _createClass(EraParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          // AD, BC
          case 'G':
          case 'GG':
          case 'GGG':
            return match.era(dateString, {
              width: 'abbreviated'
            }) || match.era(dateString, {
              width: 'narrow'
            });
          // A, B
          case 'GGGGG':
            return match.era(dateString, {
              width: 'narrow'
            });
          // Anno Domini, Before Christ
          case 'GGGG':
          default:
            return match.era(dateString, {
              width: 'wide'
            }) || match.era(dateString, {
              width: 'abbreviated'
            }) || match.era(dateString, {
              width: 'narrow'
            });
        }
      }
    }, {
      key: "set",
      value: function set(date, flags, value) {
        flags.era = value;
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return EraParser;
  }(Parser);

  /**
   * Days in 1 week.
   *
   * @name daysInWeek
   * @constant
   * @type {number}
   * @default
   */

  /**
   * Milliseconds in 1 minute
   *
   * @name millisecondsInMinute
   * @constant
   * @type {number}
   * @default
   */
  var millisecondsInMinute = 60000;

  /**
   * Milliseconds in 1 hour
   *
   * @name millisecondsInHour
   * @constant
   * @type {number}
   * @default
   */
  var millisecondsInHour = 3600000;

  /**
   * Milliseconds in 1 second
   *
   * @name millisecondsInSecond
   * @constant
   * @type {number}
   * @default
   */
  var millisecondsInSecond = 1000;

  var numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59

    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999

    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
  };

  var timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };

  function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) {
      return parseFnResult;
    }
    return {
      value: mapFn(parseFnResult.value),
      rest: parseFnResult.rest
    };
  }
  function parseNumericPattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) {
      return null;
    }
    return {
      value: parseInt(matchResult[0], 10),
      rest: dateString.slice(matchResult[0].length)
    };
  }
  function parseTimezonePattern(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) {
      return null;
    }

    // Input is 'Z'
    if (matchResult[0] === 'Z') {
      return {
        value: 0,
        rest: dateString.slice(1)
      };
    }
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
      value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
      rest: dateString.slice(matchResult[0].length)
    };
  }
  function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
  }
  function parseNDigits(n, dateString) {
    switch (n) {
      case 1:
        return parseNumericPattern(numericPatterns.singleDigit, dateString);
      case 2:
        return parseNumericPattern(numericPatterns.twoDigits, dateString);
      case 3:
        return parseNumericPattern(numericPatterns.threeDigits, dateString);
      case 4:
        return parseNumericPattern(numericPatterns.fourDigits, dateString);
      default:
        return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
  }
  function parseNDigitsSigned(n, dateString) {
    switch (n) {
      case 1:
        return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
      case 2:
        return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
      case 3:
        return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
      case 4:
        return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
      default:
        return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
  }
  function dayPeriodEnumToHours(dayPeriod) {
    switch (dayPeriod) {
      case 'morning':
        return 4;
      case 'evening':
        return 17;
      case 'pm':
      case 'noon':
      case 'afternoon':
        return 12;
      case 'am':
      case 'midnight':
      case 'night':
      default:
        return 0;
    }
  }
  function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) {
      result = twoDigitYear || 100;
    } else {
      var rangeEnd = absCurrentYear + 50;
      var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
      var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
      result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
  }
  function isLeapYearIndex$1(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
  }

  // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
  // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
  // |----------|-------|----|-------|-------|-------|
  // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
  // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
  // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
  // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
  // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
  var YearParser = /*#__PURE__*/function (_Parser) {
    _inherits(YearParser, _Parser);
    var _super = _createSuper(YearParser);
    function YearParser() {
      var _this;
      _classCallCheck(this, YearParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(YearParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'yy'
          };
        };
        switch (token) {
          case 'y':
            return mapValue(parseNDigits(4, dateString), valueCallback);
          case 'yo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'year'
            }), valueCallback);
          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      }
    }, {
      key: "set",
      value: function set(date, flags, value) {
        var currentYear = date.getUTCFullYear();
        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
          date.setUTCHours(0, 0, 0, 0);
          return date;
        }
        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return YearParser;
  }(Parser);

  // Local week-numbering year
  var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
    _inherits(LocalWeekYearParser, _Parser);
    var _super = _createSuper(LocalWeekYearParser);
    function LocalWeekYearParser() {
      var _this;
      _classCallCheck(this, LocalWeekYearParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
      return _this;
    }
    _createClass(LocalWeekYearParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(year) {
          return {
            year: year,
            isTwoDigitYear: token === 'YY'
          };
        };
        switch (token) {
          case 'Y':
            return mapValue(parseNDigits(4, dateString), valueCallback);
          case 'Yo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'year'
            }), valueCallback);
          default:
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
      }
    }, {
      key: "set",
      value: function set(date, flags, value, options) {
        var currentYear = getUTCWeekYear(date, options);
        if (value.isTwoDigitYear) {
          var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
          date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
          date.setUTCHours(0, 0, 0, 0);
          return startOfUTCWeek(date, options);
        }
        var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
    }]);
    return LocalWeekYearParser;
  }(Parser);

  var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
    _inherits(ISOWeekYearParser, _Parser);
    var _super = _createSuper(ISOWeekYearParser);
    function ISOWeekYearParser() {
      var _this;
      _classCallCheck(this, ISOWeekYearParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(ISOWeekYearParser, [{
      key: "parse",
      value: function parse(dateString, token) {
        if (token === 'R') {
          return parseNDigitsSigned(4, dateString);
        }
        return parseNDigitsSigned(token.length, dateString);
      }
    }, {
      key: "set",
      value: function set(_date, _flags, value) {
        var firstWeekOfYear = new Date(0);
        firstWeekOfYear.setUTCFullYear(value, 0, 4);
        firstWeekOfYear.setUTCHours(0, 0, 0, 0);
        return startOfUTCISOWeek(firstWeekOfYear);
      }
    }]);
    return ISOWeekYearParser;
  }(Parser);

  var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
    _inherits(ExtendedYearParser, _Parser);
    var _super = _createSuper(ExtendedYearParser);
    function ExtendedYearParser() {
      var _this;
      _classCallCheck(this, ExtendedYearParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 130);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(ExtendedYearParser, [{
      key: "parse",
      value: function parse(dateString, token) {
        if (token === 'u') {
          return parseNDigitsSigned(4, dateString);
        }
        return parseNDigitsSigned(token.length, dateString);
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCFullYear(value, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return ExtendedYearParser;
  }(Parser);

  var QuarterParser = /*#__PURE__*/function (_Parser) {
    _inherits(QuarterParser, _Parser);
    var _super = _createSuper(QuarterParser);
    function QuarterParser() {
      var _this;
      _classCallCheck(this, QuarterParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(QuarterParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'Q':
          case 'QQ':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th
          case 'Qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4
          case 'QQQ':
            return match.quarter(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case 'QQQQQ':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // 1st quarter, 2nd quarter, ...
          case 'QQQQ':
          default:
            return match.quarter(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.quarter(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.quarter(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 4;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return QuarterParser;
  }(Parser);

  var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
    _inherits(StandAloneQuarterParser, _Parser);
    var _super = _createSuper(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
      var _this;
      _classCallCheck(this, StandAloneQuarterParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 120);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(StandAloneQuarterParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          // 1, 2, 3, 4
          case 'q':
          case 'qq':
            // 01, 02, 03, 04
            return parseNDigits(token.length, dateString);
          // 1st, 2nd, 3rd, 4th
          case 'qo':
            return match.ordinalNumber(dateString, {
              unit: 'quarter'
            });
          // Q1, Q2, Q3, Q4
          case 'qqq':
            return match.quarter(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // 1, 2, 3, 4 (narrow quarter; could be not numerical)
          case 'qqqqq':
            return match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // 1st quarter, 2nd quarter, ...
          case 'qqqq':
          default:
            return match.quarter(dateString, {
              width: 'wide',
              context: 'standalone'
            }) || match.quarter(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.quarter(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 4;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMonth((value - 1) * 3, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return StandAloneQuarterParser;
  }(Parser);

  var MonthParser = /*#__PURE__*/function (_Parser) {
    _inherits(MonthParser, _Parser);
    var _super = _createSuper(MonthParser);
    function MonthParser() {
      var _this;
      _classCallCheck(this, MonthParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
      _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
      return _this;
    }
    _createClass(MonthParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };
        switch (token) {
          // 1, 2, ..., 12
          case 'M':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12
          case 'MM':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th
          case 'Mo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'month'
            }), valueCallback);
          // Jan, Feb, ..., Dec
          case 'MMM':
            return match.month(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.month(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // J, F, ..., D
          case 'MMMMM':
            return match.month(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // January, February, ..., December
          case 'MMMM':
          default:
            return match.month(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.month(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.month(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return MonthParser;
  }(Parser);

  var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
    _inherits(StandAloneMonthParser, _Parser);
    var _super = _createSuper(StandAloneMonthParser);
    function StandAloneMonthParser() {
      var _this;
      _classCallCheck(this, StandAloneMonthParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 110);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(StandAloneMonthParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          return value - 1;
        };
        switch (token) {
          // 1, 2, ..., 12
          case 'L':
            return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
          // 01, 02, ..., 12
          case 'LL':
            return mapValue(parseNDigits(2, dateString), valueCallback);
          // 1st, 2nd, ..., 12th
          case 'Lo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'month'
            }), valueCallback);
          // Jan, Feb, ..., Dec
          case 'LLL':
            return match.month(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.month(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // J, F, ..., D
          case 'LLLLL':
            return match.month(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // January, February, ..., December
          case 'LLLL':
          default:
            return match.month(dateString, {
              width: 'wide',
              context: 'standalone'
            }) || match.month(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.month(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMonth(value, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return StandAloneMonthParser;
  }(Parser);

  function setUTCWeek(dirtyDate, dirtyWeek, options) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var week = toInteger(dirtyWeek);
    var diff = getUTCWeek(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
  }

  var LocalWeekParser = /*#__PURE__*/function (_Parser) {
    _inherits(LocalWeekParser, _Parser);
    var _super = _createSuper(LocalWeekParser);
    function LocalWeekParser() {
      var _this;
      _classCallCheck(this, LocalWeekParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
      return _this;
    }
    _createClass(LocalWeekParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'w':
            return parseNumericPattern(numericPatterns.week, dateString);
          case 'wo':
            return match.ordinalNumber(dateString, {
              unit: 'week'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 53;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value, options) {
        return startOfUTCWeek(setUTCWeek(date, value, options), options);
      }
    }]);
    return LocalWeekParser;
  }(Parser);

  function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    requiredArgs(2, arguments);
    var date = toDate(dirtyDate);
    var isoWeek = toInteger(dirtyISOWeek);
    var diff = getUTCISOWeek(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
  }

  var ISOWeekParser = /*#__PURE__*/function (_Parser) {
    _inherits(ISOWeekParser, _Parser);
    var _super = _createSuper(ISOWeekParser);
    function ISOWeekParser() {
      var _this;
      _classCallCheck(this, ISOWeekParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 100);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(ISOWeekParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'I':
            return parseNumericPattern(numericPatterns.week, dateString);
          case 'Io':
            return match.ordinalNumber(dateString, {
              unit: 'week'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 53;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        return startOfUTCISOWeek(setUTCISOWeek(date, value));
      }
    }]);
    return ISOWeekParser;
  }(Parser);

  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  // Day of the month
  var DateParser = /*#__PURE__*/function (_Parser) {
    _inherits(DateParser, _Parser);
    var _super = _createSuper(DateParser);
    function DateParser() {
      var _this;
      _classCallCheck(this, DateParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "subPriority", 1);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(DateParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'd':
            return parseNumericPattern(numericPatterns.date, dateString);
          case 'do':
            return match.ordinalNumber(dateString, {
              unit: 'date'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);
        var month = date.getUTCMonth();
        if (isLeapYear) {
          return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        } else {
          return value >= 1 && value <= DAYS_IN_MONTH[month];
        }
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCDate(value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return DateParser;
  }(Parser);

  var DayOfYearParser = /*#__PURE__*/function (_Parser) {
    _inherits(DayOfYearParser, _Parser);
    var _super = _createSuper(DayOfYearParser);
    function DayOfYearParser() {
      var _this;
      _classCallCheck(this, DayOfYearParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "subpriority", 1);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(DayOfYearParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'D':
          case 'DD':
            return parseNumericPattern(numericPatterns.dayOfYear, dateString);
          case 'Do':
            return match.ordinalNumber(dateString, {
              unit: 'date'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(date, value) {
        var year = date.getUTCFullYear();
        var isLeapYear = isLeapYearIndex$1(year);
        if (isLeapYear) {
          return value >= 1 && value <= 366;
        } else {
          return value >= 1 && value <= 365;
        }
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMonth(0, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return DayOfYearParser;
  }(Parser);

  function setUTCDay(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    requiredArgs(2, arguments);
    var defaultOptions = getDefaultOptions();
    var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    var date = toDate(dirtyDate);
    var day = toInteger(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  }

  var DayParser = /*#__PURE__*/function (_Parser) {
    _inherits(DayParser, _Parser);
    var _super = _createSuper(DayParser);
    function DayParser() {
      var _this;
      _classCallCheck(this, DayParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(DayParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          // Tue
          case 'E':
          case 'EE':
          case 'EEE':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // T
          case 'EEEEE':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu
          case 'EEEEEE':
            return match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tuesday
          case 'EEEE':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return DayParser;
  }(Parser);

  var LocalDayParser = /*#__PURE__*/function (_Parser) {
    _inherits(LocalDayParser, _Parser);
    var _super = _createSuper(LocalDayParser);
    function LocalDayParser() {
      var _this;
      _classCallCheck(this, LocalDayParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
      return _this;
    }
    _createClass(LocalDayParser, [{
      key: "parse",
      value: function parse(dateString, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch (token) {
          // 3
          case 'e':
          case 'ee':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd
          case 'eo':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'day'
            }), valueCallback);
          // Tue
          case 'eee':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // T
          case 'eeeee':
            return match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tu
          case 'eeeeee':
            return match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          // Tuesday
          case 'eeee':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return LocalDayParser;
  }(Parser);

  var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
    _inherits(StandAloneLocalDayParser, _Parser);
    var _super = _createSuper(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
      var _this;
      _classCallCheck(this, StandAloneLocalDayParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
      return _this;
    }
    _createClass(StandAloneLocalDayParser, [{
      key: "parse",
      value: function parse(dateString, token, match, options) {
        var valueCallback = function valueCallback(value) {
          var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
          return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch (token) {
          // 3
          case 'c':
          case 'cc':
            // 03
            return mapValue(parseNDigits(token.length, dateString), valueCallback);
          // 3rd
          case 'co':
            return mapValue(match.ordinalNumber(dateString, {
              unit: 'day'
            }), valueCallback);
          // Tue
          case 'ccc':
            return match.day(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'short',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // T
          case 'ccccc':
            return match.day(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // Tu
          case 'cccccc':
            return match.day(dateString, {
              width: 'short',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
          // Tuesday
          case 'cccc':
          default:
            return match.day(dateString, {
              width: 'wide',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'abbreviated',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'short',
              context: 'standalone'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'standalone'
            });
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 6;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value, options) {
        date = setUTCDay(date, value, options);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return StandAloneLocalDayParser;
  }(Parser);

  function setUTCISODay(dirtyDate, dirtyDay) {
    requiredArgs(2, arguments);
    var day = toInteger(dirtyDay);
    if (day % 7 === 0) {
      day = day - 7;
    }
    var weekStartsOn = 1;
    var date = toDate(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  }

  var ISODayParser = /*#__PURE__*/function (_Parser) {
    _inherits(ISODayParser, _Parser);
    var _super = _createSuper(ISODayParser);
    function ISODayParser() {
      var _this;
      _classCallCheck(this, ISODayParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 90);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
      return _this;
    }
    _createClass(ISODayParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        var valueCallback = function valueCallback(value) {
          if (value === 0) {
            return 7;
          }
          return value;
        };
        switch (token) {
          // 2
          case 'i':
          case 'ii':
            // 02
            return parseNDigits(token.length, dateString);
          // 2nd
          case 'io':
            return match.ordinalNumber(dateString, {
              unit: 'day'
            });
          // Tue
          case 'iii':
            return mapValue(match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            }), valueCallback);
          // T
          case 'iiiii':
            return mapValue(match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            }), valueCallback);
          // Tu
          case 'iiiiii':
            return mapValue(match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            }), valueCallback);
          // Tuesday
          case 'iiii':
          default:
            return mapValue(match.day(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'short',
              context: 'formatting'
            }) || match.day(dateString, {
              width: 'narrow',
              context: 'formatting'
            }), valueCallback);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 7;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date = setUTCISODay(date, value);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
    }]);
    return ISODayParser;
  }(Parser);

  var AMPMParser = /*#__PURE__*/function (_Parser) {
    _inherits(AMPMParser, _Parser);
    var _super = _createSuper(AMPMParser);
    function AMPMParser() {
      var _this;
      _classCallCheck(this, AMPMParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
      return _this;
    }
    _createClass(AMPMParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'a':
          case 'aa':
          case 'aaa':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'aaaaa':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'aaaa':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }
    }]);
    return AMPMParser;
  }(Parser);

  var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
    _inherits(AMPMMidnightParser, _Parser);
    var _super = _createSuper(AMPMMidnightParser);
    function AMPMMidnightParser() {
      var _this;
      _classCallCheck(this, AMPMMidnightParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
      return _this;
    }
    _createClass(AMPMMidnightParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'b':
          case 'bb':
          case 'bbb':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'bbbbb':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'bbbb':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }
    }]);
    return AMPMMidnightParser;
  }(Parser);

  var DayPeriodParser = /*#__PURE__*/function (_Parser) {
    _inherits(DayPeriodParser, _Parser);
    var _super = _createSuper(DayPeriodParser);
    function DayPeriodParser() {
      var _this;
      _classCallCheck(this, DayPeriodParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 80);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
      return _this;
    }
    _createClass(DayPeriodParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'B':
          case 'BB':
          case 'BBB':
            return match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'BBBBB':
            return match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
          case 'BBBB':
          default:
            return match.dayPeriod(dateString, {
              width: 'wide',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'abbreviated',
              context: 'formatting'
            }) || match.dayPeriod(dateString, {
              width: 'narrow',
              context: 'formatting'
            });
        }
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
        return date;
      }
    }]);
    return DayPeriodParser;
  }(Parser);

  var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
    _inherits(Hour1to12Parser, _Parser);
    var _super = _createSuper(Hour1to12Parser);
    function Hour1to12Parser() {
      var _this;
      _classCallCheck(this, Hour1to12Parser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
      return _this;
    }
    _createClass(Hour1to12Parser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'h':
            return parseNumericPattern(numericPatterns.hour12h, dateString);
          case 'ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 12;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;
        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else if (!isPM && value === 12) {
          date.setUTCHours(0, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }
        return date;
      }
    }]);
    return Hour1to12Parser;
  }(Parser);

  var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
    _inherits(Hour0to23Parser, _Parser);
    var _super = _createSuper(Hour0to23Parser);
    function Hour0to23Parser() {
      var _this;
      _classCallCheck(this, Hour0to23Parser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
      return _this;
    }
    _createClass(Hour0to23Parser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'H':
            return parseNumericPattern(numericPatterns.hour23h, dateString);
          case 'Ho':
            return match.ordinalNumber(dateString, {
              unit: 'hour'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 23;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCHours(value, 0, 0, 0);
        return date;
      }
    }]);
    return Hour0to23Parser;
  }(Parser);

  var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
    _inherits(Hour0To11Parser, _Parser);
    var _super = _createSuper(Hour0To11Parser);
    function Hour0To11Parser() {
      var _this;
      _classCallCheck(this, Hour0To11Parser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
      return _this;
    }
    _createClass(Hour0To11Parser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'K':
            return parseNumericPattern(numericPatterns.hour11h, dateString);
          case 'Ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 11;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        var isPM = date.getUTCHours() >= 12;
        if (isPM && value < 12) {
          date.setUTCHours(value + 12, 0, 0, 0);
        } else {
          date.setUTCHours(value, 0, 0, 0);
        }
        return date;
      }
    }]);
    return Hour0To11Parser;
  }(Parser);

  var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
    _inherits(Hour1To24Parser, _Parser);
    var _super = _createSuper(Hour1To24Parser);
    function Hour1To24Parser() {
      var _this;
      _classCallCheck(this, Hour1To24Parser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 70);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
      return _this;
    }
    _createClass(Hour1To24Parser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'k':
            return parseNumericPattern(numericPatterns.hour24h, dateString);
          case 'ko':
            return match.ordinalNumber(dateString, {
              unit: 'hour'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 1 && value <= 24;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        var hours = value <= 24 ? value % 24 : value;
        date.setUTCHours(hours, 0, 0, 0);
        return date;
      }
    }]);
    return Hour1To24Parser;
  }(Parser);

  var MinuteParser = /*#__PURE__*/function (_Parser) {
    _inherits(MinuteParser, _Parser);
    var _super = _createSuper(MinuteParser);
    function MinuteParser() {
      var _this;
      _classCallCheck(this, MinuteParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 60);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
      return _this;
    }
    _createClass(MinuteParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 'm':
            return parseNumericPattern(numericPatterns.minute, dateString);
          case 'mo':
            return match.ordinalNumber(dateString, {
              unit: 'minute'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 59;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMinutes(value, 0, 0);
        return date;
      }
    }]);
    return MinuteParser;
  }(Parser);

  var SecondParser = /*#__PURE__*/function (_Parser) {
    _inherits(SecondParser, _Parser);
    var _super = _createSuper(SecondParser);
    function SecondParser() {
      var _this;
      _classCallCheck(this, SecondParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 50);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
      return _this;
    }
    _createClass(SecondParser, [{
      key: "parse",
      value: function parse(dateString, token, match) {
        switch (token) {
          case 's':
            return parseNumericPattern(numericPatterns.second, dateString);
          case 'so':
            return match.ordinalNumber(dateString, {
              unit: 'second'
            });
          default:
            return parseNDigits(token.length, dateString);
        }
      }
    }, {
      key: "validate",
      value: function validate(_date, value) {
        return value >= 0 && value <= 59;
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCSeconds(value, 0);
        return date;
      }
    }]);
    return SecondParser;
  }(Parser);

  var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
    _inherits(FractionOfSecondParser, _Parser);
    var _super = _createSuper(FractionOfSecondParser);
    function FractionOfSecondParser() {
      var _this;
      _classCallCheck(this, FractionOfSecondParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 30);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T']);
      return _this;
    }
    _createClass(FractionOfSecondParser, [{
      key: "parse",
      value: function parse(dateString, token) {
        var valueCallback = function valueCallback(value) {
          return Math.floor(value * Math.pow(10, -token.length + 3));
        };
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }, {
      key: "set",
      value: function set(date, _flags, value) {
        date.setUTCMilliseconds(value);
        return date;
      }
    }]);
    return FractionOfSecondParser;
  }(Parser);

  var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
    _inherits(ISOTimezoneWithZParser, _Parser);
    var _super = _createSuper(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
      var _this;
      _classCallCheck(this, ISOTimezoneWithZParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'x']);
      return _this;
    }
    _createClass(ISOTimezoneWithZParser, [{
      key: "parse",
      value: function parse(dateString, token) {
        switch (token) {
          case 'X':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
          case 'XX':
            return parseTimezonePattern(timezonePatterns.basic, dateString);
          case 'XXXX':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
          case 'XXXXX':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
          case 'XXX':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);
        }
      }
    }, {
      key: "set",
      value: function set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }
        return new Date(date.getTime() - value);
      }
    }]);
    return ISOTimezoneWithZParser;
  }(Parser);

  var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
    _inherits(ISOTimezoneParser, _Parser);
    var _super = _createSuper(ISOTimezoneParser);
    function ISOTimezoneParser() {
      var _this;
      _classCallCheck(this, ISOTimezoneParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 10);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", ['t', 'T', 'X']);
      return _this;
    }
    _createClass(ISOTimezoneParser, [{
      key: "parse",
      value: function parse(dateString, token) {
        switch (token) {
          case 'x':
            return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
          case 'xx':
            return parseTimezonePattern(timezonePatterns.basic, dateString);
          case 'xxxx':
            return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
          case 'xxxxx':
            return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
          case 'xxx':
          default:
            return parseTimezonePattern(timezonePatterns.extended, dateString);
        }
      }
    }, {
      key: "set",
      value: function set(date, flags, value) {
        if (flags.timestampIsSet) {
          return date;
        }
        return new Date(date.getTime() - value);
      }
    }]);
    return ISOTimezoneParser;
  }(Parser);

  var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
    _inherits(TimestampSecondsParser, _Parser);
    var _super = _createSuper(TimestampSecondsParser);
    function TimestampSecondsParser() {
      var _this;
      _classCallCheck(this, TimestampSecondsParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 40);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
      return _this;
    }
    _createClass(TimestampSecondsParser, [{
      key: "parse",
      value: function parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      }
    }, {
      key: "set",
      value: function set(_date, _flags, value) {
        return [new Date(value * 1000), {
          timestampIsSet: true
        }];
      }
    }]);
    return TimestampSecondsParser;
  }(Parser);

  var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
    _inherits(TimestampMillisecondsParser, _Parser);
    var _super = _createSuper(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
      var _this;
      _classCallCheck(this, TimestampMillisecondsParser);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized$1(_this), "priority", 20);
      _defineProperty(_assertThisInitialized$1(_this), "incompatibleTokens", '*');
      return _this;
    }
    _createClass(TimestampMillisecondsParser, [{
      key: "parse",
      value: function parse(dateString) {
        return parseAnyDigitsSigned(dateString);
      }
    }, {
      key: "set",
      value: function set(_date, _flags, value) {
        return [new Date(value), {
          timestampIsSet: true
        }];
      }
    }]);
    return TimestampMillisecondsParser;
  }(Parser);

  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
   * |  p  |                                |  P  |                                |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   */
  var parsers = {
    G: new EraParser(),
    y: new YearParser(),
    Y: new LocalWeekYearParser(),
    R: new ISOWeekYearParser(),
    u: new ExtendedYearParser(),
    Q: new QuarterParser(),
    q: new StandAloneQuarterParser(),
    M: new MonthParser(),
    L: new StandAloneMonthParser(),
    w: new LocalWeekParser(),
    I: new ISOWeekParser(),
    d: new DateParser(),
    D: new DayOfYearParser(),
    E: new DayParser(),
    e: new LocalDayParser(),
    c: new StandAloneLocalDayParser(),
    i: new ISODayParser(),
    a: new AMPMParser(),
    b: new AMPMMidnightParser(),
    B: new DayPeriodParser(),
    h: new Hour1to12Parser(),
    H: new Hour0to23Parser(),
    K: new Hour0To11Parser(),
    k: new Hour1To24Parser(),
    m: new MinuteParser(),
    s: new SecondParser(),
    S: new FractionOfSecondParser(),
    X: new ISOTimezoneWithZParser(),
    x: new ISOTimezoneParser(),
    t: new TimestampSecondsParser(),
    T: new TimestampMillisecondsParser()
  };

  // - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
  //   (one of the certain letters followed by `o`)
  // - (\w)\1* matches any sequences of the same letter
  // - '' matches two quote characters in a row
  // - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
  //   except a single quote symbol, which ends the sequence.
  //   Two quote characters do not end the sequence.
  //   If there is no matching single quote
  //   then the sequence will continue until the end of the string.
  // - . matches any single character unmatched by previous parts of the RegExps
  var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

  // This RegExp catches symbols escaped by quotes, and also
  // sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
  var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
  var escapedStringRegExp = /^'([^]*?)'?$/;
  var doubleQuoteRegExp = /''/g;
  var notWhitespaceRegExp = /\S/;
  var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

  /**
   * @name parse
   * @category Common Helpers
   * @summary Parse the date.
   *
   * @description
   * Return the date parsed from string using the given format string.
   *
   * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
   * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * The characters in the format string wrapped between two single quotes characters (') are escaped.
   * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
   *
   * Format of the format string is based on Unicode Technical Standard #35:
   * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
   * with a few additions (see note 5 below the table).
   *
   * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
   * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
   *
   * ```javascript
   * parse('23 AM', 'HH a', new Date())
   * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
   * ```
   *
   * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
   *
   * Accepted format string patterns:
   * | Unit                            |Prior| Pattern | Result examples                   | Notes |
   * |---------------------------------|-----|---------|-----------------------------------|-------|
   * | Era                             | 140 | G..GGG  | AD, BC                            |       |
   * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
   * |                                 |     | GGGGG   | A, B                              |       |
   * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
   * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
   * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
   * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
   * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
   * |                                 |     | yyyyy   | ...                               | 2,4   |
   * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
   * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
   * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
   * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
   * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
   * |                                 |     | YYYYY   | ...                               | 2,4   |
   * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
   * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
   * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
   * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
   * |                                 |     | RRRRR   | ...                               | 2,4,5 |
   * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
   * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
   * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
   * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
   * |                                 |     | uuuuu   | ...                               | 2,4   |
   * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
   * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
   * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
   * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
   * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
   * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
   * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
   * |                                 |     | qq      | 01, 02, 03, 04                    |       |
   * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
   * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
   * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
   * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
   * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
   * |                                 |     | MM      | 01, 02, ..., 12                   |       |
   * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
   * |                                 |     | MMMM    | January, February, ..., December  | 2     |
   * |                                 |     | MMMMM   | J, F, ..., D                      |       |
   * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
   * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
   * |                                 |     | LL      | 01, 02, ..., 12                   |       |
   * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
   * |                                 |     | LLLL    | January, February, ..., December  | 2     |
   * |                                 |     | LLLLL   | J, F, ..., D                      |       |
   * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
   * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
   * |                                 |     | ww      | 01, 02, ..., 53                   |       |
   * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
   * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
   * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
   * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
   * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
   * |                                 |     | dd      | 01, 02, ..., 31                   |       |
   * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
   * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
   * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
   * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
   * |                                 |     | DDDD    | ...                               | 2     |
   * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
   * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
   * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
   * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
   * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
   * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
   * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
   * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
   * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
   * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
   * |                                 |     | ee      | 02, 03, ..., 01                   |       |
   * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
   * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
   * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
   * |                                 |     | cc      | 02, 03, ..., 01                   |       |
   * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
   * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
   * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
   * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
   * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
   * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
   * |                                 |     | aaaaa   | a, p                              |       |
   * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
   * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
   * |                                 |     | bbbbb   | a, p, n, mi                       |       |
   * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
   * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
   * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
   * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
   * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
   * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
   * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
   * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
   * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
   * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
   * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
   * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
   * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
   * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
   * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
   * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
   * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
   * |                                 |     | mm      | 00, 01, ..., 59                   |       |
   * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
   * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
   * |                                 |     | ss      | 00, 01, ..., 59                   |       |
   * | Seconds timestamp               |  40 | t       | 512969520                         |       |
   * |                                 |     | tt      | ...                               | 2     |
   * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
   * |                                 |     | SS      | 00, 01, ..., 99                   |       |
   * |                                 |     | SSS     | 000, 001, ..., 999                |       |
   * |                                 |     | SSSS    | ...                               | 2     |
   * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
   * |                                 |     | TT      | ...                               | 2     |
   * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
   * |                                 |     | XX      | -0800, +0530, Z                   |       |
   * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
   * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
   * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
   * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
   * |                                 |     | xx      | -0800, +0530, +0000               |       |
   * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
   * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
   * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
   * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
   * |                                 |     | PP      | May 29, 1453                      |       |
   * |                                 |     | PPP     | May 29th, 1453                    |       |
   * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
   * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
   * |                                 |     | pp      | 12:00:00 AM                       |       |
   * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
   * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
   * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
   * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
   * Notes:
   * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
   *    are the same as "stand-alone" units, but are different in some languages.
   *    "Formatting" units are declined according to the rules of the language
   *    in the context of a date. "Stand-alone" units are always nominative singular.
   *    In `format` function, they will produce different result:
   *
   *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
   *
   *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
   *
   *    `parse` will try to match both formatting and stand-alone units interchangably.
   *
   * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
   *    the single quote characters (see below).
   *    If the sequence is longer than listed in table:
   *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
   *      as wide as the sequence
   *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
   *      These variations are marked with "2" in the last column of the table.
   *
   * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
   *    These tokens represent the shortest form of the quarter.
   *
   * 4. The main difference between `y` and `u` patterns are B.C. years:
   *
   *    | Year | `y` | `u` |
   *    |------|-----|-----|
   *    | AC 1 |   1 |   1 |
   *    | BC 1 |   1 |   0 |
   *    | BC 2 |   2 |  -1 |
   *
   *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
   *
   *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
   *
   *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
   *
   *    while `uu` will just assign the year as is:
   *
   *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
   *
   *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
   *
   *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
   *    except local week-numbering years are dependent on `options.weekStartsOn`
   *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
   *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
   *
   * 5. These patterns are not in the Unicode Technical Standard #35:
   *    - `i`: ISO day of week
   *    - `I`: ISO week of year
   *    - `R`: ISO week-numbering year
   *    - `o`: ordinal number modifier
   *    - `P`: long localized date
   *    - `p`: long localized time
   *
   * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
   *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
   *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   *
   * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
   *    on the given locale.
   *
   *    using `en-US` locale: `P` => `MM/dd/yyyy`
   *    using `en-US` locale: `p` => `hh:mm a`
   *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
   *    using `pt-BR` locale: `p` => `HH:mm`
   *
   * Values will be assigned to the date in the descending order of its unit's priority.
   * Units of an equal priority overwrite each other in the order of appearance.
   *
   * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
   * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
   *
   * `referenceDate` must be passed for correct work of the function.
   * If you're not sure which `referenceDate` to supply, create a new instance of Date:
   * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
   * In this case parsing will be done in the context of the current date.
   * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
   * then `Invalid Date` will be returned.
   *
   * The result may vary by locale.
   *
   * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
   *
   * If parsing failed, `Invalid Date` will be returned.
   * Invalid Date is a Date, whose time value is NaN.
   * Time value of Date: http://es5.github.io/#x15.9.1.1
   *
   * @param {String} dateString - the string to parse
   * @param {String} formatString - the string of tokens
   * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
   * @param {Object} [options] - an object with options.
   * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
   * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
   * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
   * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
   *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
   *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @returns {Date} the parsed date
   * @throws {TypeError} 3 arguments required
   * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
   * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
   * @throws {RangeError} `options.locale` must contain `match` property
   * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
   * @throws {RangeError} format string contains an unescaped latin alphabet character
   *
   * @example
   * // Parse 11 February 2014 from middle-endian format:
   * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
   * //=> Tue Feb 11 2014 00:00:00
   *
   * @example
   * // Parse 28th of February in Esperanto locale in the context of 2010 year:
   * import eo from 'date-fns/locale/eo'
   * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
   *   locale: eo
   * })
   * //=> Sun Feb 28 2010 00:00:00
   */
  function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    requiredArgs(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = getDefaultOptions();
    var locale$1 = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : locale;
    if (!locale$1.match) {
      throw new RangeError('locale must contain match property');
    }
    var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
      throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    }
    var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
      throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    }
    if (formatString === '') {
      if (dateString === '') {
        return toDate(dirtyReferenceDate);
      } else {
        return new Date(NaN);
      }
    }
    var subFnOptions = {
      firstWeekContainsDate: firstWeekContainsDate,
      weekStartsOn: weekStartsOn,
      locale: locale$1
    };

    // If timezone isn't specified, it will be set to the system timezone
    var setters = [new DateToSystemTimezoneSetter()];
    var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
      var firstCharacter = substring[0];
      if (firstCharacter in longFormatters) {
        var longFormatter = longFormatters[firstCharacter];
        return longFormatter(substring, locale$1.formatLong);
      }
      return substring;
    }).join('').match(formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = _createForOfIteratorHelper$3(tokens),
      _step;
    try {
      var _loop = function _loop() {
        var token = _step.value;
        if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
          throwProtectedError(token, formatString, dirtyDateString);
        }
        if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
          throwProtectedError(token, formatString, dirtyDateString);
        }
        var firstCharacter = token[0];
        var parser = parsers[firstCharacter];
        if (parser) {
          var incompatibleTokens = parser.incompatibleTokens;
          if (Array.isArray(incompatibleTokens)) {
            var incompatibleToken = usedTokens.find(function (usedToken) {
              return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
            });
            if (incompatibleToken) {
              throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            }
          } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
            throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
          }
          usedTokens.push({
            token: firstCharacter,
            fullToken: token
          });
          var parseResult = parser.run(dateString, token, locale$1.match, subFnOptions);
          if (!parseResult) {
            return {
              v: new Date(NaN)
            };
          }
          setters.push(parseResult.setter);
          dateString = parseResult.rest;
        } else {
          if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
            throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
          }

          // Replace two single quote characters with one single quote character
          if (token === "''") {
            token = "'";
          } else if (firstCharacter === "'") {
            token = cleanEscapedString(token);
          }

          // Cut token from string, or, if string doesn't match the token, return Invalid Date
          if (dateString.indexOf(token) === 0) {
            dateString = dateString.slice(token.length);
          } else {
            return {
              v: new Date(NaN)
            };
          }
        }
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();
        if (_typeof$1(_ret) === "object") return _ret.v;
      }

      // Check if the remaining input contains something other than whitespace
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
      return new Date(NaN);
    }
    var uniquePrioritySetters = setters.map(function (setter) {
      return setter.priority;
    }).sort(function (a, b) {
      return b - a;
    }).filter(function (priority, index, array) {
      return array.indexOf(priority) === index;
    }).map(function (priority) {
      return setters.filter(function (setter) {
        return setter.priority === priority;
      }).sort(function (a, b) {
        return b.subPriority - a.subPriority;
      });
    }).map(function (setterArray) {
      return setterArray[0];
    });
    var date = toDate(dirtyReferenceDate);
    if (isNaN(date.getTime())) {
      return new Date(NaN);
    }

    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
    var flags = {};
    var _iterator2 = _createForOfIteratorHelper$3(uniquePrioritySetters),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var setter = _step2.value;
        if (!setter.validate(utcDate, subFnOptions)) {
          return new Date(NaN);
        }
        var result = setter.set(utcDate, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
          utcDate = result[0];
          assign(flags, result[1]);
          // Result is date
        } else {
          utcDate = result;
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return utcDate;
  }
  function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
  }

  var parse$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: parse
  });

  var require$$57 = /*@__PURE__*/getAugmentedNamespace(parse$1);

  /**
   * @name parseISO
   * @category Common Helpers
   * @summary Parse ISO string
   *
   * @description
   * Parse the given string in ISO 8601 format and return an instance of Date.
   *
   * Function accepts complete ISO 8601 formats as well as partial implementations.
   * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
   *
   * If the argument isn't a string, the function cannot parse the string or
   * the values are invalid, it returns Invalid Date.
   *
   * @param {String} argument - the value to convert
   * @param {Object} [options] - an object with options.
   * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
   * @returns {Date} the parsed date in the local time zone
   * @throws {TypeError} 1 argument required
   * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
   *
   * @example
   * // Convert string '2014-02-11T11:30:30' to date:
   * const result = parseISO('2014-02-11T11:30:30')
   * //=> Tue Feb 11 2014 11:30:30
   *
   * @example
   * // Convert string '+02014101' to date,
   * // if the additional number of digits in the extended year format is 1:
   * const result = parseISO('+02014101', { additionalDigits: 1 })
   * //=> Fri Apr 11 2014 00:00:00
   */
  function parseISO(argument, options) {
    var _options$additionalDi;
    requiredArgs(1, arguments);
    var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
      throw new RangeError('additionalDigits must be 0, 1 or 2');
    }
    if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
      return new Date(NaN);
    }
    var dateStrings = splitDateString(argument);
    var date;
    if (dateStrings.date) {
      var parseYearResult = parseYear(dateStrings.date, additionalDigits);
      date = parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) {
      return new Date(NaN);
    }
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
      time = parseTime(dateStrings.time);
      if (isNaN(time)) {
        return new Date(NaN);
      }
    }
    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone);
      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      var dirtyDate = new Date(timestamp + time);
      // js parsed string assuming it's in UTC timezone
      // but we need it to be parsed in our timezone
      // so we use utc values to build date in our timezone.
      // Year values from 0 to 99 map to the years 1900 to 1999
      // so set year explicitly with setFullYear.
      var result = new Date(0);
      result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
      result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
      return result;
    }
    return new Date(timestamp + time + offset);
  }
  var patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
  };
  var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
  var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
  var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
  function splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split(patterns.dateTimeDelimiter);
    var timeString;

    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) {
      return dateStrings;
    }
    if (/:/.test(array[0])) {
      timeString = array[0];
    } else {
      dateStrings.date = array[0];
      timeString = array[1];
      if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
        dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
        timeString = dateString.substr(dateStrings.date.length, dateString.length);
      }
    }
    if (timeString) {
      var token = patterns.timezone.exec(timeString);
      if (token) {
        dateStrings.time = timeString.replace(token[1], '');
        dateStrings.timezone = token[1];
      } else {
        dateStrings.time = timeString;
      }
    }
    return dateStrings;
  }
  function parseYear(dateString, additionalDigits) {
    var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
      year: NaN,
      restDateString: ''
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;

    // either year or century is null, not both
    return {
      year: century === null ? year : century * 100,
      restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
  }
  function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match(dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = parseDateUnit(captures[1]);
    var month = parseDateUnit(captures[2]) - 1;
    var day = parseDateUnit(captures[3]);
    var week = parseDateUnit(captures[4]);
    var dayOfWeek = parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
      if (!validateWeekDate(year, week, dayOfWeek)) {
        return new Date(NaN);
      }
      return dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
      var date = new Date(0);
      if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
        return new Date(NaN);
      }
      date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
      return date;
    }
  }
  function parseDateUnit(value) {
    return value ? parseInt(value) : 1;
  }
  function parseTime(timeString) {
    var captures = timeString.match(timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time

    var hours = parseTimeUnit(captures[1]);
    var minutes = parseTimeUnit(captures[2]);
    var seconds = parseTimeUnit(captures[3]);
    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }
    return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
  }
  function parseTimeUnit(value) {
    return value && parseFloat(value.replace(',', '.')) || 0;
  }
  function parseTimezone(timezoneString) {
    if (timezoneString === 'Z') return 0;
    var captures = timezoneString.match(timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === '+' ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }
    return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
  }
  function dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
  }

  // Validation functions

  // February is null to handle the leap year (using ||)
  var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
  }
  function validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
  }
  function validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
  }
  function validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
  }
  function validateTime(hours, minutes, seconds) {
    if (hours === 24) {
      return minutes === 0 && seconds === 0;
    }
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
  }
  function validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
  }

  var parseISO$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: parseISO
  });

  var require$$58 = /*@__PURE__*/getAugmentedNamespace(parseISO$1);

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose$1(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }/**
   * Check whether some DOM node is our Component's node.
   */
  function isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    } // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


    if (current.correspondingElement) {
      return current.correspondingElement.classList.contains(ignoreClass);
    }

    return current.classList.contains(ignoreClass);
  }
  /**
   * Try to find our node in a hierarchy of nodes, returning the document
   * node as highest node if our node is not found in the path up.
   */

  function findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) {
      return true;
    } // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host


    while (current.parentNode || current.host) {
      // Only check normal node without shadowRoot
      if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
        return true;
      }

      current = current.parentNode || current.host;
    }

    return current;
  }
  /**
   * Check if the browser scrollbar was clicked
   */

  function clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
  }// ideally will get replaced with external dep
  // when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
  var testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
      return;
    }

    var passive = false;
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passive = true;
      }
    });

    var noop = function noop() {};

    window.addEventListener('testPassiveEventSupport', noop, options);
    window.removeEventListener('testPassiveEventSupport', noop, options);
    return passive;
  };function autoInc(seed) {
    if (seed === void 0) {
      seed = 0;
    }

    return function () {
      return ++seed;
    };
  }

  var uid = autoInc();var passiveEventSupport;
  var handlersMap = {};
  var enabledInstances = {};
  var touchEvents = ['touchstart', 'touchmove'];
  var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
  /**
   * Options for addEventHandler and removeEventHandler
   */

  function getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

    if (isTouchEvent && passiveEventSupport) {
      handlerOptions.passive = !instance.props.preventDefault;
    }

    return handlerOptions;
  }
  /**
   * This function generates the HOC function that you'll use
   * in order to impart onOutsideClick listening to an
   * arbitrary component. It gets called at the end of the
   * bootstrapping code to yield an instance of the
   * onClickOutsideHOC function defined inside setupHOC().
   */


  function onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;

    var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    return _temp = _class = /*#__PURE__*/function (_Component) {
      _inheritsLoose(onClickOutside, _Component);

      function onClickOutside(props) {
        var _this;

        _this = _Component.call(this, props) || this;

        _this.__outsideClickHandler = function (event) {
          if (typeof _this.__clickOutsideHandlerProp === 'function') {
            _this.__clickOutsideHandlerProp(event);

            return;
          }

          var instance = _this.getInstance();

          if (typeof instance.props.handleClickOutside === 'function') {
            instance.props.handleClickOutside(event);
            return;
          }

          if (typeof instance.handleClickOutside === 'function') {
            instance.handleClickOutside(event);
            return;
          }

          throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
        };

        _this.__getComponentNode = function () {
          var instance = _this.getInstance();

          if (config && typeof config.setClickOutsideRef === 'function') {
            return config.setClickOutsideRef()(instance);
          }

          if (typeof instance.setClickOutsideRef === 'function') {
            return instance.setClickOutsideRef();
          }

          return ReactDOM.findDOMNode(instance);
        };

        _this.enableOnClickOutside = function () {
          if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
            return;
          }

          if (typeof passiveEventSupport === 'undefined') {
            passiveEventSupport = testPassiveEventSupport();
          }

          enabledInstances[_this._uid] = true;
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          handlersMap[_this._uid] = function (event) {
            if (_this.componentNode === null) return;
            if (_this.initTimeStamp > event.timeStamp) return;

            if (_this.props.preventDefault) {
              event.preventDefault();
            }

            if (_this.props.stopPropagation) {
              event.stopPropagation();
            }

            if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
            var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

            if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
              return;
            }

            _this.__outsideClickHandler(event);
          };

          events.forEach(function (eventName) {
            document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
        };

        _this.disableOnClickOutside = function () {
          delete enabledInstances[_this._uid];
          var fn = handlersMap[_this._uid];

          if (fn && typeof document !== 'undefined') {
            var events = _this.props.eventTypes;

            if (!events.forEach) {
              events = [events];
            }

            events.forEach(function (eventName) {
              return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
            });
            delete handlersMap[_this._uid];
          }
        };

        _this.getRef = function (ref) {
          return _this.instanceRef = ref;
        };

        _this._uid = uid();
        _this.initTimeStamp = performance.now();
        return _this;
      }
      /**
       * Access the WrappedComponent's instance.
       */


      var _proto = onClickOutside.prototype;

      _proto.getInstance = function getInstance() {
        if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
          return this;
        }

        var ref = this.instanceRef;
        return ref.getInstance ? ref.getInstance() : ref;
      };

      /**
       * Add click listeners to the current document,
       * linked to this component's state.
       */
      _proto.componentDidMount = function componentDidMount() {
        // If we are in an environment without a DOM such
        // as shallow rendering or snapshots then we exit
        // early to prevent any unhandled errors being thrown.
        if (typeof document === 'undefined' || !document.createElement) {
          return;
        }

        var instance = this.getInstance();

        if (config && typeof config.handleClickOutside === 'function') {
          this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

          if (typeof this.__clickOutsideHandlerProp !== 'function') {
            throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
          }
        }

        this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

        if (this.props.disableOnClickOutside) return;
        this.enableOnClickOutside();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        this.componentNode = this.__getComponentNode();
      }
      /**
       * Remove all document's event listeners for this component
       */
      ;

      _proto.componentWillUnmount = function componentWillUnmount() {
        this.disableOnClickOutside();
      }
      /**
       * Can be called to explicitly enable event listening
       * for clicks and touches outside of this element.
       */
      ;

      /**
       * Pass-through render
       */
      _proto.render = function render() {
        // eslint-disable-next-line no-unused-vars
        var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = _objectWithoutPropertiesLoose$1(_this$props, ["excludeScrollbar"]);

        if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
          props.ref = this.getRef;
        } else {
          props.wrappedRef = this.getRef;
        }

        props.disableOnClickOutside = this.disableOnClickOutside;
        props.enableOnClickOutside = this.enableOnClickOutside;
        return React.createElement(WrappedComponent, props);
      };

      return onClickOutside;
    }(React.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
      eventTypes: ['mousedown', 'touchstart'],
      excludeScrollbar: config && config.excludeScrollbar || false,
      outsideClickIgnoreClass: IGNORE_CLASS_NAME,
      preventDefault: false,
      stopPropagation: false
    }, _class.getClass = function () {
      return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
  }

  var reactOnclickoutside_es = /*#__PURE__*/Object.freeze({
    __proto__: null,
    IGNORE_CLASS_NAME: IGNORE_CLASS_NAME,
    default: onClickOutsideHOC
  });

  var require$$59 = /*@__PURE__*/getAugmentedNamespace(reactOnclickoutside_es);

  var ManagerReferenceNodeContext = React__namespace.createContext();
  var ManagerReferenceNodeSetterContext = React__namespace.createContext();
  function Manager(_ref) {
    var children = _ref.children;

    var _React$useState = React__namespace.useState(null),
        referenceNode = _React$useState[0],
        setReferenceNode = _React$useState[1];

    var hasUnmounted = React__namespace.useRef(false);
    React__namespace.useEffect(function () {
      return function () {
        hasUnmounted.current = true;
      };
    }, []);
    var handleSetReferenceNode = React__namespace.useCallback(function (node) {
      if (!hasUnmounted.current) {
        setReferenceNode(node);
      }
    }, []);
    return /*#__PURE__*/React__namespace.createElement(ManagerReferenceNodeContext.Provider, {
      value: referenceNode
    }, /*#__PURE__*/React__namespace.createElement(ManagerReferenceNodeSetterContext.Provider, {
      value: handleSetReferenceNode
    }, children));
  }

  /**
   * Takes an argument and if it's an array, returns the first item in the array,
   * otherwise returns the argument. Used for Preact compatibility.
   */
  var unwrapArray = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
  };
  /**
   * Takes a maybe-undefined function and arbitrary args and invokes the function
   * only if it is defined.
   */

  var safeInvoke = function safeInvoke(fn) {
    if (typeof fn === 'function') {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return fn.apply(void 0, args);
    }
  };
  /**
   * Sets a ref using either a ref callback or a ref object
   */

  var setRef = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') {
      return safeInvoke(ref, node);
    } // otherwise we should treat it as a ref object
    else if (ref != null) {
        ref.current = node;
      }
  };
  /**
   * Simple ponyfill for Object.fromEntries
   */

  var fromEntries = function fromEntries(entries) {
    return entries.reduce(function (acc, _ref) {
      var key = _ref[0],
          value = _ref[1];
      acc[key] = value;
      return acc;
    }, {});
  };
  /**
   * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
   */

  var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React__namespace.useLayoutEffect : React__namespace.useEffect;

  var EMPTY_MODIFIERS$1 = [];
  var usePopper = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) {
      options = {};
    }

    var prevOptions = React__namespace.useRef(null);
    var optionsWithDefaults = {
      onFirstUpdate: options.onFirstUpdate,
      placement: options.placement || 'bottom',
      strategy: options.strategy || 'absolute',
      modifiers: options.modifiers || EMPTY_MODIFIERS$1
    };

    var _React$useState = React__namespace.useState({
      styles: {
        popper: {
          position: optionsWithDefaults.strategy,
          left: '0',
          top: '0'
        },
        arrow: {
          position: 'absolute'
        }
      },
      attributes: {}
    }),
        state = _React$useState[0],
        setState = _React$useState[1];

    var updateStateModifier = React__namespace.useMemo(function () {
      return {
        name: 'updateState',
        enabled: true,
        phase: 'write',
        fn: function fn(_ref) {
          var state = _ref.state;
          var elements = Object.keys(state.elements);
          ReactDOM__namespace.flushSync(function () {
            setState({
              styles: fromEntries(elements.map(function (element) {
                return [element, state.styles[element] || {}];
              })),
              attributes: fromEntries(elements.map(function (element) {
                return [element, state.attributes[element]];
              }))
            });
          });
        },
        requires: ['computeStyles']
      };
    }, []);
    var popperOptions = React__namespace.useMemo(function () {
      var newOptions = {
        onFirstUpdate: optionsWithDefaults.onFirstUpdate,
        placement: optionsWithDefaults.placement,
        strategy: optionsWithDefaults.strategy,
        modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
          name: 'applyStyles',
          enabled: false
        }])
      };

      if (isEqual$4(prevOptions.current, newOptions)) {
        return prevOptions.current || newOptions;
      } else {
        prevOptions.current = newOptions;
        return newOptions;
      }
    }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
    var popperInstanceRef = React__namespace.useRef();
    useIsomorphicLayoutEffect(function () {
      if (popperInstanceRef.current) {
        popperInstanceRef.current.setOptions(popperOptions);
      }
    }, [popperOptions]);
    useIsomorphicLayoutEffect(function () {
      if (referenceElement == null || popperElement == null) {
        return;
      }

      var createPopper$1 = options.createPopper || createPopper;
      var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
      popperInstanceRef.current = popperInstance;
      return function () {
        popperInstance.destroy();
        popperInstanceRef.current = null;
      };
    }, [referenceElement, popperElement, options.createPopper]);
    return {
      state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
      styles: state.styles,
      attributes: state.attributes,
      update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
      forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
  };

  var NOOP = function NOOP() {
    return void 0;
  };

  var NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
  };

  var EMPTY_MODIFIERS = [];
  function Popper(_ref) {
    var _ref$placement = _ref.placement,
        placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
        _ref$strategy = _ref.strategy,
        strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
        _ref$modifiers = _ref.modifiers,
        modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
        referenceElement = _ref.referenceElement,
        onFirstUpdate = _ref.onFirstUpdate,
        innerRef = _ref.innerRef,
        children = _ref.children;
    var referenceNode = React__namespace.useContext(ManagerReferenceNodeContext);

    var _React$useState = React__namespace.useState(null),
        popperElement = _React$useState[0],
        setPopperElement = _React$useState[1];

    var _React$useState2 = React__namespace.useState(null),
        arrowElement = _React$useState2[0],
        setArrowElement = _React$useState2[1];

    React__namespace.useEffect(function () {
      setRef(innerRef, popperElement);
    }, [innerRef, popperElement]);
    var options = React__namespace.useMemo(function () {
      return {
        placement: placement,
        strategy: strategy,
        onFirstUpdate: onFirstUpdate,
        modifiers: [].concat(modifiers, [{
          name: 'arrow',
          enabled: arrowElement != null,
          options: {
            element: arrowElement
          }
        }])
      };
    }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

    var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
        state = _usePopper.state,
        styles = _usePopper.styles,
        forceUpdate = _usePopper.forceUpdate,
        update = _usePopper.update;

    var childrenProps = React__namespace.useMemo(function () {
      return {
        ref: setPopperElement,
        style: styles.popper,
        placement: state ? state.placement : placement,
        hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
        isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
        arrowProps: {
          style: styles.arrow,
          ref: setArrowElement
        },
        forceUpdate: forceUpdate || NOOP,
        update: update || NOOP_PROMISE
      };
    }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
    return unwrapArray(children)(childrenProps);
  }

  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var warning_1;
  var hasRequiredWarning;

  function requireWarning () {
  	if (hasRequiredWarning) return warning_1;
  	hasRequiredWarning = 1;

  	var warning = function() {};

  	warning_1 = warning;
  	return warning_1;
  }

  var warningExports = requireWarning();
  var warning = /*@__PURE__*/getDefaultExportFromCjs(warningExports);

  function Reference(_ref) {
    var children = _ref.children,
        innerRef = _ref.innerRef;
    var setReferenceNode = React__namespace.useContext(ManagerReferenceNodeSetterContext);
    var refHandler = React__namespace.useCallback(function (node) {
      setRef(innerRef, node);
      safeInvoke(setReferenceNode, node);
    }, [innerRef, setReferenceNode]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps

    React__namespace.useEffect(function () {
      return function () {
        return setRef(innerRef, null);
      };
    }, []);
    React__namespace.useEffect(function () {
      warning(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [setReferenceNode]);
    return unwrapArray(children)({
      ref: refHandler
    });
  }

  // Public components
   // Public types

  var esm = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Manager: Manager,
    Popper: Popper,
    Reference: Reference,
    usePopper: usePopper
  });

  var require$$61 = /*@__PURE__*/getAugmentedNamespace(esm);

  /**
   * @name set
   * @category Common Helpers
   * @summary Set date values to a given date.
   *
   * @description
   * Set date values to a given date.
   *
   * Sets time values to date from object `values`.
   * A value is not set if it is undefined or null or doesn't exist in `values`.
   *
   * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
   * to use native `Date#setX` methods. If you use this function, you may not want to include the
   * other `setX` functions that date-fns provides if you are concerned about the bundle size.
   *
   * @param {Date|Number} date - the date to be changed
   * @param {Object} values - an object with options
   * @param {Number} [values.year] - the number of years to be set
   * @param {Number} [values.month] - the number of months to be set
   * @param {Number} [values.date] - the number of days to be set
   * @param {Number} [values.hours] - the number of hours to be set
   * @param {Number} [values.minutes] - the number of minutes to be set
   * @param {Number} [values.seconds] - the number of seconds to be set
   * @param {Number} [values.milliseconds] - the number of milliseconds to be set
   * @returns {Date} the new date with options set
   * @throws {TypeError} 2 arguments required
   * @throws {RangeError} `values` must be an object
   *
   * @example
   * // Transform 1 September 2014 into 20 October 2015 in a single line:
   * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
   * //=> Tue Oct 20 2015 00:00:00
   *
   * @example
   * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
   * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
   * //=> Mon Sep 01 2014 12:23:45
   */
  function set(dirtyDate, values) {
    requiredArgs(2, arguments);
    if (_typeof$1(values) !== 'object' || values === null) {
      throw new RangeError('values parameter must be an object');
    }
    var date = toDate(dirtyDate);

    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) {
      return new Date(NaN);
    }
    if (values.year != null) {
      date.setFullYear(values.year);
    }
    if (values.month != null) {
      date = setMonth(date, values.month);
    }
    if (values.date != null) {
      date.setDate(toInteger(values.date));
    }
    if (values.hours != null) {
      date.setHours(toInteger(values.hours));
    }
    if (values.minutes != null) {
      date.setMinutes(toInteger(values.minutes));
    }
    if (values.seconds != null) {
      date.setSeconds(toInteger(values.seconds));
    }
    if (values.milliseconds != null) {
      date.setMilliseconds(toInteger(values.milliseconds));
    }
    return date;
  }

  var set$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    default: set
  });

  var require$$62 = /*@__PURE__*/getAugmentedNamespace(set$1);

  var reactDatepicker_min = reactDatepicker_min$1.exports;

  var hasRequiredReactDatepicker_min;

  function requireReactDatepicker_min () {
  	if (hasRequiredReactDatepicker_min) return reactDatepicker_min$1.exports;
  	hasRequiredReactDatepicker_min = 1;
  	(function (module, exports$1) {
  		!function(e,t){t(exports$1,React,/*@__PURE__*/ requirePropTypes(),requireClassnames(),require$$3,require$$4,require$$5,require$$6,require$$7,require$$8,require$$9,require$$10,require$$11,require$$12,require$$13,require$$14,require$$15,require$$16,require$$17,require$$18,require$$19,require$$20,require$$21,require$$22,require$$23,require$$24,require$$25,require$$26,require$$27,require$$28,require$$29,require$$30,require$$31,require$$32,require$$33,require$$34,require$$35,require$$36,require$$37,require$$38,require$$39,require$$40,require$$41,require$$42,require$$43,require$$44,require$$45,require$$46,require$$47,require$$48,require$$49,require$$50,require$$51,require$$52,require$$53,require$$54,require$$55,require$$56,require$$57,require$$58,require$$59,ReactDOM,require$$61,require$$62);}(reactDatepicker_min,(function(e,t,r,a,n,o,s,i,p,l,c,d,u,f,h,m,y,v,D,g,k,w,b,S,C,_,M,P,E,N,x,Y,O,I,T,R,L,F,A,W,q,K,B,Q,H,j,V,U,z,$,G,J,X,Z,ee,te,re,ae,ne,oe,se,ie,pe,le){function ce(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var de=ce(t),ue=ce(a),fe=ce(n),he=ce(o),me=ce(s),ye=ce(i),ve=ce(p),De=ce(l),ge=ce(c),ke=ce(d),we=ce(u),be=ce(f),Se=ce(h),Ce=ce(m),_e=ce(y),Me=ce(v),Pe=ce(D),Ee=ce(g),Ne=ce(k),xe=ce(w),Ye=ce(b),Oe=ce(S),Ie=ce(C),Te=ce(_),Re=ce(M),Le=ce(P),Fe=ce(E),Ae=ce(N),We=ce(x),qe=ce(Y),Ke=ce(O),Be=ce(I),Qe=ce(T),He=ce(R),je=ce(L),Ve=ce(F),Ue=ce(A),ze=ce(W),$e=ce(q),Ge=ce(K),Je=ce(B),Xe=ce(Q),Ze=ce(H),et=ce(j),tt=ce(U),rt=ce(z),at=ce($),nt=ce(G),ot=ce(J),st=ce(X),it=ce(Z),pt=ce(ee),lt=ce(te),ct=ce(re),dt=ce(ae),ut=ce(ne),ft=ce(oe),ht=ce(se),mt=ce(ie),yt=ce(le);function vt(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,a);}return r}function Dt(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?vt(Object(r),true).forEach((function(t){St(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):vt(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function gt(e){return gt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},gt(e)}function kt(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function wt(e,t){for(var r=0;r<t.length;r++){var a=t[r];a.enumerable=a.enumerable||false,a.configurable=true,"value"in a&&(a.writable=true),Object.defineProperty(e,Ot(a.key),a);}}function bt(e,t,r){return t&&wt(e.prototype,t),r&&wt(e,r),Object.defineProperty(e,"prototype",{writable:false}),e}function St(e,t,r){return (t=Ot(t))in e?Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true}):e[t]=r,e}function Ct(){return Ct=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var a in r)Object.prototype.hasOwnProperty.call(r,a)&&(e[a]=r[a]);}return e},Ct.apply(this,arguments)}function _t(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}}),Object.defineProperty(e,"prototype",{writable:false}),t&&Pt(e,t);}function Mt(e){return Mt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},Mt(e)}function Pt(e,t){return Pt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},Pt(e,t)}function Et(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function Nt(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return  false;if(Reflect.construct.sham)return  false;if("function"==typeof Proxy)return  true;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return  false}}();return function(){var r,a=Mt(e);if(t){var n=Mt(this).constructor;r=Reflect.construct(a,arguments,n);}else r=a.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return Et(e)}(this,r)}}function xt(e){return function(e){if(Array.isArray(e))return Yt(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Yt(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Yt(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Yt(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,a=new Array(t);r<t;r++)a[r]=e[r];return a}function Ot(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var a=r.call(e,t);if("object"!=typeof a)return a;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}var It=function(e,t){switch(e){case "P":return t.date({width:"short"});case "PP":return t.date({width:"medium"});case "PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Tt=function(e,t){switch(e){case "p":return t.time({width:"short"});case "pp":return t.time({width:"medium"});case "ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Rt={p:Tt,P:function(e,t){var r,a=e.match(/(P+)(p+)?/)||[],n=a[1],o=a[2];if(!o)return It(e,t);switch(n){case "P":r=t.dateTime({width:"short"});break;case "PP":r=t.dateTime({width:"medium"});break;case "PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",It(n,t)).replace("{{time}}",Tt(o,t))}},Lt=12,Ft=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function At(e){var t=e?"string"==typeof e||e instanceof String?ft.default(e):dt.default(e):new Date;return Wt(t)?t:null}function Wt(e,t){return t=t||new Date("1/1/1000"),he.default(e)&&!lt.default(e,t)}function qt(e,t,r){if("en"===r)return me.default(e,t,{awareOfUnicodeTokens:true});var a=tr(r);return r&&!a&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!a&&er()&&tr(er())&&(a=tr(er())),me.default(e,t,{locale:a||null,awareOfUnicodeTokens:true})}function Kt(e,t){var r=t.dateFormat,a=t.locale;return e&&qt(e,Array.isArray(r)?r[0]:r,a)||""}function Bt(e,t){var r=t.hour,a=void 0===r?0:r,n=t.minute,o=void 0===n?0:n,s=t.second,i=void 0===s?0:s;return qe.default(We.default(Ae.default(e,i),o),a)}function Qt(e,t,r){var a=tr(t||er());return Ge.default(e,{locale:a,weekStartsOn:r})}function Ht(e){return Je.default(e)}function jt(e){return Ze.default(e)}function Vt(e){return Xe.default(e)}function Ut(){return $e.default(At())}function zt(e,t){return e&&t?st.default(e,t):!e&&!t}function $t(e,t){return e&&t?ot.default(e,t):!e&&!t}function Gt(e,t){return e&&t?it.default(e,t):!e&&!t}function Jt(e,t){return e&&t?nt.default(e,t):!e&&!t}function Xt(e,t){return e&&t?at.default(e,t):!e&&!t}function Zt(e,t,r){var a,n=$e.default(t),o=et.default(r);try{a=ct.default(e,{start:n,end:o});}catch(e){a=false;}return a}function er(){return ("undefined"!=typeof window?window:globalThis).__localeId__}function tr(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function rr(e,t){return qt(Ke.default(At(),e),"LLLL",t)}function ar(e,t){return qt(Ke.default(At(),e),"LLL",t)}function nr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Jt(e,t)}))||o&&o.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||s&&!s.some((function(t){return Jt(e,t)}))||i&&!i.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})}))||p&&!p(At(e))||false}function or(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,a=t.excludeDateIntervals;return a&&a.length>0?a.some((function(t){var r=t.start,a=t.end;return ct.default(e,{start:r,end:a})})):r&&r.some((function(t){return Jt(e,t)}))||false}function sr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:Je.default(r),maxDate:tt.default(a)})||n&&n.some((function(t){return $t(e,t)}))||o&&!o.some((function(t){return $t(e,t)}))||s&&!s(At(e))||false}function ir(e,t,r,a){var n=Le.default(e),o=Te.default(e),s=Le.default(t),i=Te.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function pr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate;return ur(e,{minDate:r,maxDate:a})||n&&n.some((function(t){return Gt(e,t)}))||o&&!o.some((function(t){return Gt(e,t)}))||s&&!s(At(e))||false}function lr(e,t,r){if(!he.default(t)||!he.default(r))return  false;var a=Le.default(t),n=Le.default(r);return a<=e&&n>=e}function cr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate,n=t.excludeDates,o=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return ur(i,{minDate:Ze.default(r),maxDate:rt.default(a)})||n&&n.some((function(e){return zt(i,e)}))||o&&!o.some((function(e){return zt(i,e)}))||s&&!s(At(i))||false}function dr(e,t,r,a){var n=Le.default(e),o=Re.default(e),s=Le.default(t),i=Re.default(t),p=Le.default(a);return n===s&&n===p?o<=r&&r<=i:n<s?p===n&&o<=r||p===s&&i>=r||p<s&&p>n:void 0}function ur(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.maxDate;return r&&Ve.default(e,r)<0||a&&Ve.default(e,a)>0}function fr(e,t){return t.some((function(t){return xe.default(t)===xe.default(e)&&Ne.default(t)===Ne.default(e)}))}function hr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,a=t.includeTimes,n=t.filterTime;return r&&fr(e,r)||a&&!fr(e,a)||n&&!n(e)||false}function mr(e,t){var r=t.minTime,a=t.maxTime;if(!r||!a)throw new Error("Both minTime and maxTime props required");var n,o=At(),s=qe.default(We.default(o,Ne.default(e)),xe.default(e)),i=qe.default(We.default(o,Ne.default(r)),xe.default(r)),p=qe.default(We.default(o,Ne.default(a)),xe.default(a));try{n=!ct.default(s,{start:i,end:p});}catch(e){n=false;}return n}function yr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=_e.default(e,1);return r&&Ue.default(r,n)>0||a&&a.every((function(e){return Ue.default(e,n)>0}))||false}function vr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=ke.default(e,1);return r&&Ue.default(n,r)>0||a&&a.every((function(e){return Ue.default(n,e)>0}))||false}function Dr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.includeDates,n=Pe.default(e,1);return r&&ze.default(r,n)>0||a&&a.every((function(e){return ze.default(e,n)>0}))||false}function gr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.includeDates,n=be.default(e,1);return r&&ze.default(n,r)>0||a&&a.every((function(e){return ze.default(n,e)>0}))||false}function kr(e){var t=e.minDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)>=0}));return He.default(a)}return r?He.default(r):t}function wr(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var a=r.filter((function(e){return Ve.default(e,t)<=0}));return je.default(a)}return r?je.default(r):t}function br(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,a=0,n=e.length;a<n;a++){var o=e[a];if(fe.default(o)){var s=qt(o,"MM.dd.yyyy"),i=r.get(s)||[];i.includes(t)||(i.push(t),r.set(s,i));}else if("object"===gt(o)){var p=Object.keys(o),l=p[0],c=o[p[0]];if("string"==typeof l&&c.constructor===Array)for(var d=0,u=c.length;d<u;d++){var f=qt(c[d],"MM.dd.yyyy"),h=r.get(f)||[];h.includes(l)||(h.push(l),r.set(f,h));}}}return r}function Sr(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var a=e.date,n=e.holidayName;if(fe.default(a)){var o=qt(a,"MM.dd.yyyy"),s=r.get(o)||{};if(!("className"in s)||s.className!==t||(i=s.holidayNames,p=[n],i.length!==p.length||!i.every((function(e,t){return e===p[t]})))){var i,p;s.className=t;var l=s.holidayNames;s.holidayNames=l?[].concat(xt(l),[n]):[n],r.set(o,s);}}})),r}function Cr(e,t,r,a,n){for(var o=n.length,s=[],i=0;i<o;i++){var p=ye.default(ve.default(e,xe.default(n[i])),Ne.default(n[i])),l=ye.default(e,(r+1)*a);pt.default(p,t)&&lt.default(p,l)&&s.push(n[i]);}return s}function _r(e){return e<10?"0".concat(e):"".concat(e)}function Mr(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Lt,r=Math.ceil(Le.default(e)/t)*t;return {startPeriod:r-(t-1),endPeriod:r}}function Pr(e){var t=e.getSeconds(),r=e.getMilliseconds();return dt.default(e.getTime()-1e3*t-r)}function Er(e,t,r,a){for(var n=[],o=0;o<2*t+1;o++){var s=e+t-o,i=true;r&&(i=Le.default(r)<=s),a&&i&&(i=Le.default(a)>=s),i&&n.push(s);}return n}var Nr=function(e){_t(a,e);var r=Nt(a);function a(e){var n;kt(this,a),St(Et(n=r.call(this,e)),"renderOptions",(function(){var e=n.props.year,t=n.state.yearsList.map((function(t){return de.default.createElement("div",{className:e===t?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:t,onClick:n.onChange.bind(Et(n),t),"aria-selected":e===t?"true":void 0},e===t?de.default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",t)})),r=n.props.minDate?Le.default(n.props.minDate):null,a=n.props.maxDate?Le.default(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||t.unshift(de.default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),r&&n.state.yearsList.find((function(e){return e===r}))||t.push(de.default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},de.default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),t})),St(Et(n),"onChange",(function(e){n.props.onChange(e);})),St(Et(n),"handleClickOutside",(function(){n.props.onCancel();})),St(Et(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t});})),St(Et(n),"incrementYears",(function(){return n.shiftYears(1)})),St(Et(n),"decrementYears",(function(){return n.shiftYears(-1)}));var o=e.yearDropdownItemNumber,s=e.scrollableYearDropdown,i=o||(s?10:5);return n.state={yearsList:Er(n.props.year,i,n.props.minDate,n.props.maxDate)},n.dropdownRef=t.createRef(),n}return bt(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2;}}},{key:"render",value:function(){var e=ue.default({"react-datepicker__year-dropdown":true,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return de.default.createElement("div",{className:e,ref:this.dropdownRef},this.renderOptions())}}]),a}(de.default.Component),xr=ht.default(Nr),Yr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:false}),St(Et(e),"renderSelectOptions",(function(){for(var t=e.props.minDate?Le.default(e.props.minDate):1900,r=e.props.maxDate?Le.default(e.props.maxDate):2100,a=[],n=t;n<=r;n++)a.push(de.default.createElement("option",{key:n,value:n},n));return a})),St(Et(e),"onSelectChange",(function(t){e.onChange(t.target.value);})),St(Et(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:e.props.year,className:"react-datepicker__year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Et(e),"renderReadView",(function(t){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},e.props.year))})),St(Et(e),"renderDropdown",(function(){return de.default.createElement(xr,{key:"dropdown",year:e.props.year,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableYearDropdown:e.props.scrollableYearDropdown,yearDropdownItemNumber:e.props.yearDropdownItemNumber})})),St(Et(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Et(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.year&&e.props.onChange(t);})),St(Et(e),"toggleDropdown",(function(t){e.setState({dropdownVisible:!e.state.dropdownVisible},(function(){e.props.adjustDateOnChange&&e.handleYearChange(e.props.date,t);}));})),St(Et(e),"handleYearChange",(function(t,r){e.onSelect(t,r),e.setOpen();})),St(Et(e),"onSelect",(function(t,r){e.props.onSelect&&e.props.onSelect(t,r);})),St(Et(e),"setOpen",(function(){e.props.setOpen&&e.props.setOpen(true);})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case "scroll":e=this.renderScrollMode();break;case "select":e=this.renderSelectMode();}return de.default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Or=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"isSelectedMonth",(function(t){return e.props.month===t})),St(Et(e),"renderOptions",(function(){return e.props.monthNames.map((function(t,r){return de.default.createElement("div",{className:e.isSelectedMonth(r)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:t,onClick:e.onChange.bind(Et(e),r),"aria-selected":e.isSelectedMonth(r)?"true":void 0},e.isSelectedMonth(r)?de.default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",t)}))})),St(Et(e),"onChange",(function(t){return e.props.onChange(t)})),St(Et(e),"handleClickOutside",(function(){return e.props.onCancel()})),e}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}(de.default.Component),Ir=ht.default(Or),Tr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:false}),St(Et(e),"renderSelectOptions",(function(e){return e.map((function(e,t){return de.default.createElement("option",{key:t,value:t},e)}))})),St(Et(e),"renderSelectMode",(function(t){return de.default.createElement("select",{value:e.props.month,className:"react-datepicker__month-select",onChange:function(t){return e.onChange(t.target.value)}},e.renderSelectOptions(t))})),St(Et(e),"renderReadView",(function(t,r){return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:e.toggleDropdown},de.default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[e.props.month]))})),St(Et(e),"renderDropdown",(function(t){return de.default.createElement(Ir,{key:"dropdown",month:e.props.month,monthNames:t,onChange:e.onChange,onCancel:e.toggleDropdown})})),St(Et(e),"renderScrollMode",(function(t){var r=e.state.dropdownVisible,a=[e.renderReadView(!r,t)];return r&&a.unshift(e.renderDropdown(t)),a})),St(Et(e),"onChange",(function(t){e.toggleDropdown(),t!==e.props.month&&e.props.onChange(t);})),St(Et(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e,t=this,r=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return ar(e,t.props.locale)}:function(e){return rr(e,t.props.locale)});switch(this.props.dropdownMode){case "scroll":e=this.renderScrollMode(r);break;case "select":e=this.renderSelectMode(r);}return de.default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component);function Rr(e,t){for(var r=[],a=Ht(e),n=Ht(t);!pt.default(a,n);)r.push(At(a)),a=ke.default(a,1);return r}var Lr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"renderOptions",(function(){return a.state.monthYearsList.map((function(e){var t=Fe.default(e),r=zt(a.props.date,e)&&$t(a.props.date,e);return de.default.createElement("div",{className:r?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:t,onClick:a.onChange.bind(Et(a),t),"aria-selected":r?"true":void 0},r?de.default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",qt(e,a.props.dateFormat,a.props.locale))}))})),St(Et(a),"onChange",(function(e){return a.props.onChange(e)})),St(Et(a),"handleClickOutside",(function(){a.props.onCancel();})),a.state={monthYearsList:Rr(a.props.minDate,a.props.maxDate)},a}return bt(r,[{key:"render",value:function(){var e=ue.default({"react-datepicker__month-year-dropdown":true,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return de.default.createElement("div",{className:e},this.renderOptions())}}]),r}(de.default.Component),Fr=ht.default(Lr),Ar=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{dropdownVisible:false}),St(Et(e),"renderSelectOptions",(function(){for(var t=Ht(e.props.minDate),r=Ht(e.props.maxDate),a=[];!pt.default(t,r);){var n=Fe.default(t);a.push(de.default.createElement("option",{key:n,value:n},qt(t,e.props.dateFormat,e.props.locale))),t=ke.default(t,1);}return a})),St(Et(e),"onSelectChange",(function(t){e.onChange(t.target.value);})),St(Et(e),"renderSelectMode",(function(){return de.default.createElement("select",{value:Fe.default(Ht(e.props.date)),className:"react-datepicker__month-year-select",onChange:e.onSelectChange},e.renderSelectOptions())})),St(Et(e),"renderReadView",(function(t){var r=qt(e.props.date,e.props.dateFormat,e.props.locale);return de.default.createElement("div",{key:"read",style:{visibility:t?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(t){return e.toggleDropdown(t)}},de.default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),de.default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))})),St(Et(e),"renderDropdown",(function(){return de.default.createElement(Fr,{key:"dropdown",date:e.props.date,dateFormat:e.props.dateFormat,onChange:e.onChange,onCancel:e.toggleDropdown,minDate:e.props.minDate,maxDate:e.props.maxDate,scrollableMonthYearDropdown:e.props.scrollableMonthYearDropdown,locale:e.props.locale})})),St(Et(e),"renderScrollMode",(function(){var t=e.state.dropdownVisible,r=[e.renderReadView(!t)];return t&&r.unshift(e.renderDropdown()),r})),St(Et(e),"onChange",(function(t){e.toggleDropdown();var r=At(parseInt(t));zt(e.props.date,r)&&$t(e.props.date,r)||e.props.onChange(r);})),St(Et(e),"toggleDropdown",(function(){return e.setState({dropdownVisible:!e.state.dropdownVisible})})),e}return bt(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case "scroll":e=this.renderScrollMode();break;case "select":e=this.renderSelectMode();}return de.default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(de.default.Component),Wr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"dayEl",de.default.createRef()),St(Et(e),"handleClick",(function(t){!e.isDisabled()&&e.props.onClick&&e.props.onClick(t);})),St(Et(e),"handleMouseEnter",(function(t){!e.isDisabled()&&e.props.onMouseEnter&&e.props.onMouseEnter(t);})),St(Et(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t);})),St(Et(e),"isSameDay",(function(t){return Jt(e.props.day,t)})),St(Et(e),"isKeyboardSelected",(function(){return !e.props.disabledKeyboardNavigation&&!(e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected))&&(e.isSameDay(e.props.preSelection)||e.isSameWeek(e.props.preSelection))})),St(Et(e),"isDisabled",(function(){return nr(e.props.day,e.props)})),St(Et(e),"isExcluded",(function(){return or(e.props.day,e.props)})),St(Et(e),"isStartOfWeek",(function(){return Jt(e.props.day,Qt(e.props.day,e.props.locale,e.props.calendarStartDay))})),St(Et(e),"isSameWeek",(function(t){return e.props.showWeekPicker&&Jt(t,Qt(e.props.day,e.props.locale,e.props.calendarStartDay))})),St(Et(e),"getHighLightedClass",(function(){var t=e.props,r=t.day,a=t.highlightDates;if(!a)return  false;var n=qt(r,"MM.dd.yyyy");return a.get(n)})),St(Et(e),"getHolidaysClass",(function(){var t=e.props,r=t.day,a=t.holidays;if(!a)return  false;var n=qt(r,"MM.dd.yyyy");return a.has(n)?[a.get(n).className]:void 0})),St(Et(e),"isInRange",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return !(!a||!n)&&Zt(r,a,n)})),St(Et(e),"isInSelectingRange",(function(){var t,r=e.props,a=r.day,n=r.selectsStart,o=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,l=r.endDate,c=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return !(!(n||o||s)||!c||!i&&e.isDisabled())&&(n&&l&&(lt.default(c,l)||Xt(c,l))?Zt(a,c,l):(o&&p&&(pt.default(c,p)||Xt(c,p))||!(!s||!p||l||!pt.default(c,p)&&!Xt(c,p)))&&Zt(a,p,c))})),St(Et(e),"isSelectingRangeStart",(function(){var t;if(!e.isInSelectingRange())return  false;var r=e.props,a=r.day,n=r.startDate,o=r.selectsStart,s=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o?s:n)})),St(Et(e),"isSelectingRangeEnd",(function(){var t;if(!e.isInSelectingRange())return  false;var r=e.props,a=r.day,n=r.endDate,o=r.selectsEnd,s=r.selectsRange,i=null!==(t=e.props.selectingDate)&&void 0!==t?t:e.props.preSelection;return Jt(a,o||s?i:n)})),St(Et(e),"isRangeStart",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return !(!a||!n)&&Jt(a,r)})),St(Et(e),"isRangeEnd",(function(){var t=e.props,r=t.day,a=t.startDate,n=t.endDate;return !(!a||!n)&&Jt(n,r)})),St(Et(e),"isWeekend",(function(){var t=Ye.default(e.props.day);return 0===t||6===t})),St(Et(e),"isAfterMonth",(function(){return void 0!==e.props.month&&(e.props.month+1)%12===Te.default(e.props.day)})),St(Et(e),"isBeforeMonth",(function(){return void 0!==e.props.month&&(Te.default(e.props.day)+1)%12===e.props.month})),St(Et(e),"isCurrentDay",(function(){return e.isSameDay(At())})),St(Et(e),"isSelected",(function(){return e.isSameDay(e.props.selected)||e.isSameWeek(e.props.selected)})),St(Et(e),"getClassNames",(function(t){var r,a=e.props.dayClassName?e.props.dayClassName(t):void 0;return ue.default("react-datepicker__day",a,"react-datepicker__day--"+qt(e.props.day,"ddd",r),{"react-datepicker__day--disabled":e.isDisabled(),"react-datepicker__day--excluded":e.isExcluded(),"react-datepicker__day--selected":e.isSelected(),"react-datepicker__day--keyboard-selected":e.isKeyboardSelected(),"react-datepicker__day--range-start":e.isRangeStart(),"react-datepicker__day--range-end":e.isRangeEnd(),"react-datepicker__day--in-range":e.isInRange(),"react-datepicker__day--in-selecting-range":e.isInSelectingRange(),"react-datepicker__day--selecting-range-start":e.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":e.isSelectingRangeEnd(),"react-datepicker__day--today":e.isCurrentDay(),"react-datepicker__day--weekend":e.isWeekend(),"react-datepicker__day--outside-month":e.isAfterMonth()||e.isBeforeMonth()},e.getHighLightedClass("react-datepicker__day--highlighted"),e.getHolidaysClass())})),St(Et(e),"getAriaLabel",(function(){var t=e.props,r=t.day,a=t.ariaLabelPrefixWhenEnabled,n=void 0===a?"Choose":a,o=t.ariaLabelPrefixWhenDisabled,s=void 0===o?"Not available":o,i=e.isDisabled()||e.isExcluded()?s:n;return "".concat(i," ").concat(qt(r,"PPPP",e.props.locale))})),St(Et(e),"getTitle",(function(){var t=e.props,r=t.day,a=t.holidays,n=void 0===a?new Map:a,o=qt(r,"MM.dd.yyyy");return n.has(o)&&n.get(o).holidayNames.length>0?n.get(o).holidayNames.join(", "):""})),St(Et(e),"getTabIndex",(function(t,r){var a=t||e.props.selected,n=r||e.props.preSelection;return (!e.props.showWeekPicker||!e.props.showWeekNumber&&e.isStartOfWeek())&&(e.isKeyboardSelected()||e.isSameDay(a)&&Jt(n,a))?0:-1})),St(Et(e),"handleFocusDay",(function(){var t,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},a=false;0===e.getTabIndex()&&!r.isInputFocused&&e.isSameDay(e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(a=true),e.props.inline&&!e.props.shouldFocusDayInline&&(a=false),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(a=true),e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()&&(a=false),e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()&&(a=false)),a&&(null===(t=e.dayEl.current)||void 0===t||t.focus({preventScroll:true}));})),St(Et(e),"renderDayContents",(function(){return e.props.monthShowsDuplicateDaysEnd&&e.isAfterMonth()||e.props.monthShowsDuplicateDaysStart&&e.isBeforeMonth()?null:e.props.renderDayContents?e.props.renderDayContents(Oe.default(e.props.day),e.props.day):Oe.default(e.props.day)})),St(Et(e),"render",(function(){return de.default.createElement("div",{ref:e.dayEl,className:e.getClassNames(e.props.day),onKeyDown:e.handleOnKeyDown,onClick:e.handleClick,onMouseEnter:e.handleMouseEnter,tabIndex:e.getTabIndex(),"aria-label":e.getAriaLabel(),role:"option",title:e.getTitle(),"aria-disabled":e.isDisabled(),"aria-current":e.isCurrentDay()?"date":void 0,"aria-selected":e.isSelected()||e.isInRange()},e.renderDayContents(),""!==e.getTitle()&&de.default.createElement("span",{className:"holiday-overlay"},e.getTitle()))})),e}return bt(r,[{key:"componentDidMount",value:function(){this.handleFocusDay();}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e);}}]),r}(de.default.Component),qr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"weekNumberEl",de.default.createRef()),St(Et(e),"handleClick",(function(t){e.props.onClick&&e.props.onClick(t);})),St(Et(e),"handleOnKeyDown",(function(t){" "===t.key&&(t.preventDefault(),t.key="Enter"),e.props.handleOnKeyDown(t);})),St(Et(e),"isKeyboardSelected",(function(){return !e.props.disabledKeyboardNavigation&&!Jt(e.props.date,e.props.selected)&&Jt(e.props.date,e.props.preSelection)})),St(Et(e),"getTabIndex",(function(){return e.props.showWeekPicker&&e.props.showWeekNumber&&(e.isKeyboardSelected()||Jt(e.props.date,e.props.selected)&&Jt(e.props.preSelection,e.props.selected))?0:-1})),St(Et(e),"handleFocusWeekNumber",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=false;0===e.getTabIndex()&&!t.isInputFocused&&Jt(e.props.date,e.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=true),e.props.inline&&!e.props.shouldFocusDayInline&&(r=false),e.props.containerRef&&e.props.containerRef.current&&e.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=true)),r&&e.weekNumberEl.current&&e.weekNumberEl.current.focus({preventScroll:true});})),e}return bt(r,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber();}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e);}},{key:"render",value:function(){var e=this.props,t=e.weekNumber,r=e.ariaLabelPrefix,a=void 0===r?"week ":r,n={"react-datepicker__week-number":true,"react-datepicker__week-number--clickable":!!e.onClick,"react-datepicker__week-number--selected":Jt(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{ref:this.weekNumberEl,className:ue.default(n),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},t)}}],[{key:"defaultProps",get:function(){return {ariaLabelPrefix:"week "}}}]),r}(de.default.Component),Kr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r);})),St(Et(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t);})),St(Et(e),"handleWeekClick",(function(t,r,a){if("function"==typeof e.props.onWeekSelect&&e.props.onWeekSelect(t,r,a),e.props.showWeekPicker){var n=Qt(t,e.props.locale,e.props.calendarStartDay);e.handleDayClick(n,a);}e.props.shouldCloseOnSelect&&e.props.setOpen(false);})),St(Et(e),"formatWeekNumber",(function(t){return e.props.formatWeekNumber?e.props.formatWeekNumber(t):function(e,t){var r=er()&&tr(er());return Ie.default(e,r?{locale:r}:null)}(t)})),St(Et(e),"renderDays",(function(){var t=Qt(e.props.day,e.props.locale,e.props.calendarStartDay),r=[],a=e.formatWeekNumber(t);if(e.props.showWeekNumber){var n=e.props.onWeekSelect||e.props.showWeekPicker?e.handleWeekClick.bind(Et(e),t,a):void 0;r.push(de.default.createElement(qr,{key:"W",weekNumber:a,date:t,onClick:n,selected:e.props.selected,preSelection:e.props.preSelection,ariaLabelPrefix:e.props.ariaLabelPrefix,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef}));}return r.concat([0,1,2,3,4,5,6].map((function(r){var a=De.default(t,r);return de.default.createElement(Wr,{ariaLabelPrefixWhenEnabled:e.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:e.props.disabledDayAriaLabelPrefix,key:a.valueOf(),day:a,month:e.props.month,onClick:e.handleDayClick.bind(Et(e),a),onMouseEnter:e.handleDayMouseEnter.bind(Et(e),a),minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,showWeekPicker:e.props.showWeekPicker,showWeekNumber:e.props.showWeekNumber,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,renderDayContents:e.props.renderDayContents,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart,locale:e.props.locale})})))})),St(Et(e),"startOfWeek",(function(){return Qt(e.props.day,e.props.locale,e.props.calendarStartDay)})),St(Et(e),"isKeyboardSelected",(function(){return !e.props.disabledKeyboardNavigation&&!Jt(e.startOfWeek(),e.props.selected)&&Jt(e.startOfWeek(),e.props.preSelection)})),e}return bt(r,[{key:"render",value:function(){var e={"react-datepicker__week":true,"react-datepicker__week--selected":Jt(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return de.default.createElement("div",{className:ue.default(e)},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:true}}}]),r}(de.default.Component),Br="two_columns",Qr="three_columns",Hr="four_columns",jr=St(St(St({},Br,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),Qr,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Hr,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function Vr(e,t){return e?Hr:t?Br:Qr}var Ur=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"MONTH_REFS",xt(Array(12)).map((function(){return de.default.createRef()}))),St(Et(e),"QUARTER_REFS",xt(Array(4)).map((function(){return de.default.createRef()}))),St(Et(e),"isDisabled",(function(t){return nr(t,e.props)})),St(Et(e),"isExcluded",(function(t){return or(t,e.props)})),St(Et(e),"handleDayClick",(function(t,r){e.props.onDayClick&&e.props.onDayClick(t,r,e.props.orderInDisplay);})),St(Et(e),"handleDayMouseEnter",(function(t){e.props.onDayMouseEnter&&e.props.onDayMouseEnter(t);})),St(Et(e),"handleMouseLeave",(function(){e.props.onMouseLeave&&e.props.onMouseLeave();})),St(Et(e),"isRangeStartMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return !(!n||!o)&&$t(Ke.default(a,t),n)})),St(Et(e),"isRangeStartQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return !(!n||!o)&&Gt(Be.default(a,t),n)})),St(Et(e),"isRangeEndMonth",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return !(!n||!o)&&$t(Ke.default(a,t),o)})),St(Et(e),"isRangeEndQuarter",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate;return !(!n||!o)&&Gt(Be.default(a,t),o)})),St(Et(e),"isInSelectingRangeMonth",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return !(!(o||s||i)||!c)&&(o&&l?ir(c,l,t,n):(s&&p||!(!i||!p||l))&&ir(p,c,t,n))})),St(Et(e),"isSelectingMonthRangeStart",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return  false;var a=e.props,n=a.day,o=a.startDate,s=a.selectsStart,i=Ke.default(n,t),p=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(i,s?p:o)})),St(Et(e),"isSelectingMonthRangeEnd",(function(t){var r;if(!e.isInSelectingRangeMonth(t))return  false;var a=e.props,n=a.day,o=a.endDate,s=a.selectsEnd,i=a.selectsRange,p=Ke.default(n,t),l=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return $t(p,s||i?l:o)})),St(Et(e),"isInSelectingRangeQuarter",(function(t){var r,a=e.props,n=a.day,o=a.selectsStart,s=a.selectsEnd,i=a.selectsRange,p=a.startDate,l=a.endDate,c=null!==(r=e.props.selectingDate)&&void 0!==r?r:e.props.preSelection;return !(!(o||s||i)||!c)&&(o&&l?dr(c,l,t,n):(s&&p||!(!i||!p||l))&&dr(p,c,t,n))})),St(Et(e),"isWeekInMonth",(function(t){var r=e.props.day,a=De.default(t,6);return $t(t,r)||$t(a,r)})),St(Et(e),"isCurrentMonth",(function(e,t){return Le.default(e)===Le.default(At())&&t===Te.default(At())})),St(Et(e),"isCurrentQuarter",(function(e,t){return Le.default(e)===Le.default(At())&&t===Re.default(At())})),St(Et(e),"isSelectedMonth",(function(e,t,r){return Te.default(r)===t&&Le.default(e)===Le.default(r)})),St(Et(e),"isSelectedQuarter",(function(e,t,r){return Re.default(e)===t&&Le.default(e)===Le.default(r)})),St(Et(e),"renderWeeks",(function(){for(var t=[],r=e.props.fixedHeight,a=0,n=false,o=Qt(Ht(e.props.day),e.props.locale,e.props.calendarStartDay);t.push(de.default.createElement(Kr,{ariaLabelPrefix:e.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:e.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:e.props.disabledDayAriaLabelPrefix,key:a,day:o,month:Te.default(e.props.day),onDayClick:e.handleDayClick,onDayMouseEnter:e.handleDayMouseEnter,onWeekSelect:e.props.onWeekSelect,formatWeekNumber:e.props.formatWeekNumber,locale:e.props.locale,minDate:e.props.minDate,maxDate:e.props.maxDate,excludeDates:e.props.excludeDates,excludeDateIntervals:e.props.excludeDateIntervals,includeDates:e.props.includeDates,includeDateIntervals:e.props.includeDateIntervals,inline:e.props.inline,shouldFocusDayInline:e.props.shouldFocusDayInline,highlightDates:e.props.highlightDates,holidays:e.props.holidays,selectingDate:e.props.selectingDate,filterDate:e.props.filterDate,preSelection:e.props.preSelection,selected:e.props.selected,selectsStart:e.props.selectsStart,selectsEnd:e.props.selectsEnd,selectsRange:e.props.selectsRange,selectsDisabledDaysInRange:e.props.selectsDisabledDaysInRange,showWeekNumber:e.props.showWeekNumbers,showWeekPicker:e.props.showWeekPicker,startDate:e.props.startDate,endDate:e.props.endDate,dayClassName:e.props.dayClassName,setOpen:e.props.setOpen,shouldCloseOnSelect:e.props.shouldCloseOnSelect,disabledKeyboardNavigation:e.props.disabledKeyboardNavigation,renderDayContents:e.props.renderDayContents,handleOnKeyDown:e.props.handleOnKeyDown,isInputFocused:e.props.isInputFocused,containerRef:e.props.containerRef,calendarStartDay:e.props.calendarStartDay,monthShowsDuplicateDaysEnd:e.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:e.props.monthShowsDuplicateDaysStart})),!n;){a++,o=ge.default(o,1);var s=r&&a>=6,i=!r&&!e.isWeekInMonth(o);if(s||i){if(!e.props.peekNextMonth)break;n=true;}}return t})),St(Et(e),"onMonthClick",(function(t,r){e.handleDayClick(Ht(Ke.default(e.props.day,r)),t);})),St(Et(e),"onMonthMouseEnter",(function(t){e.handleDayMouseEnter(Ht(Ke.default(e.props.day,t)));})),St(Et(e),"handleMonthNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.MONTH_REFS[t].current&&e.MONTH_REFS[t].current.focus());})),St(Et(e),"onMonthKeyDown",(function(t,r){var a=e.props,n=a.selected,o=a.preSelection,s=a.disabledKeyboardNavigation,i=a.showTwoColumnMonthYearPicker,p=a.showFourColumnMonthYearPicker,l=a.setPreSelection,c=t.key;if("Tab"!==c&&t.preventDefault(),!s){var d=Vr(p,i),u=jr[d].verticalNavigationOffset,f=jr[d].grid;switch(c){case "Enter":e.onMonthClick(t,r),l(n);break;case "ArrowRight":e.handleMonthNavigation(11===r?0:r+1,ke.default(o,1));break;case "ArrowLeft":e.handleMonthNavigation(0===r?11:r-1,_e.default(o,1));break;case "ArrowUp":e.handleMonthNavigation(f[0].includes(r)?r+12-u:r-u,_e.default(o,u));break;case "ArrowDown":e.handleMonthNavigation(f[f.length-1].includes(r)?r-12+u:r+u,ke.default(o,u));}}})),St(Et(e),"onQuarterClick",(function(t,r){e.handleDayClick(Vt(Be.default(e.props.day,r)),t);})),St(Et(e),"onQuarterMouseEnter",(function(t){e.handleDayMouseEnter(Vt(Be.default(e.props.day,t)));})),St(Et(e),"handleQuarterNavigation",(function(t,r){e.isDisabled(r)||e.isExcluded(r)||(e.props.setPreSelection(r),e.QUARTER_REFS[t-1].current&&e.QUARTER_REFS[t-1].current.focus());})),St(Et(e),"onQuarterKeyDown",(function(t,r){var a=t.key;if(!e.props.disabledKeyboardNavigation)switch(a){case "Enter":e.onQuarterClick(t,r),e.props.setPreSelection(e.props.selected);break;case "ArrowRight":e.handleQuarterNavigation(4===r?1:r+1,we.default(e.props.preSelection,1));break;case "ArrowLeft":e.handleQuarterNavigation(1===r?4:r-1,Me.default(e.props.preSelection,1));}})),St(Et(e),"getMonthClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,c=r.monthClassName,d=r.excludeDates,u=r.includeDates,f=c?c(Ke.default(a,t)):void 0,h=Ke.default(a,t);return ue.default("react-datepicker__month-text","react-datepicker__month-".concat(t),f,{"react-datepicker__month-text--disabled":(i||p||d||u)&&sr(h,e.props),"react-datepicker__month-text--selected":e.isSelectedMonth(a,t,s),"react-datepicker__month-text--keyboard-selected":!e.props.disabledKeyboardNavigation&&Te.default(l)===t,"react-datepicker__month-text--in-selecting-range":e.isInSelectingRangeMonth(t),"react-datepicker__month-text--in-range":ir(n,o,t,a),"react-datepicker__month-text--range-start":e.isRangeStartMonth(t),"react-datepicker__month-text--range-end":e.isRangeEndMonth(t),"react-datepicker__month-text--selecting-range-start":e.isSelectingMonthRangeStart(t),"react-datepicker__month-text--selecting-range-end":e.isSelectingMonthRangeEnd(t),"react-datepicker__month-text--today":e.isCurrentMonth(a,t)})})),St(Et(e),"getTabIndex",(function(t){var r=Te.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Et(e),"getQuarterTabIndex",(function(t){var r=Re.default(e.props.preSelection);return e.props.disabledKeyboardNavigation||t!==r?"-1":"0"})),St(Et(e),"getAriaLabel",(function(t){var r=e.props,a=r.chooseDayAriaLabelPrefix,n=void 0===a?"Choose":a,o=r.disabledDayAriaLabelPrefix,s=void 0===o?"Not available":o,i=r.day,p=Ke.default(i,t),l=e.isDisabled(p)||e.isExcluded(p)?s:n;return "".concat(l," ").concat(qt(p,"MMMM yyyy"))})),St(Et(e),"getQuarterClassNames",(function(t){var r=e.props,a=r.day,n=r.startDate,o=r.endDate,s=r.selected,i=r.minDate,p=r.maxDate,l=r.preSelection,c=r.disabledKeyboardNavigation;return ue.default("react-datepicker__quarter-text","react-datepicker__quarter-".concat(t),{"react-datepicker__quarter-text--disabled":(i||p)&&pr(Be.default(a,t),e.props),"react-datepicker__quarter-text--selected":e.isSelectedQuarter(a,t,s),"react-datepicker__quarter-text--keyboard-selected":!c&&Re.default(l)===t,"react-datepicker__quarter-text--in-selecting-range":e.isInSelectingRangeQuarter(t),"react-datepicker__quarter-text--in-range":dr(n,o,t,a),"react-datepicker__quarter-text--range-start":e.isRangeStartQuarter(t),"react-datepicker__quarter-text--range-end":e.isRangeEndQuarter(t)})})),St(Et(e),"getMonthContent",(function(t){var r=e.props,a=r.showFullMonthYearPicker,n=r.renderMonthContent,o=r.locale,s=ar(t,o),i=rr(t,o);return n?n(t,s,i):a?i:s})),St(Et(e),"getQuarterContent",(function(t){var r=e.props,a=r.renderQuarterContent,n=function(e,t){return qt(Be.default(At(),e),"QQQ",t)}(t,r.locale);return a?a(t,n):n})),St(Et(e),"renderMonths",(function(){var t=e.props,r=t.showTwoColumnMonthYearPicker,a=t.showFourColumnMonthYearPicker,n=t.day,o=t.selected;return jr[Vr(a,r)].grid.map((function(t,r){return de.default.createElement("div",{className:"react-datepicker__month-wrapper",key:r},t.map((function(t,r){return de.default.createElement("div",{ref:e.MONTH_REFS[t],key:r,onClick:function(r){e.onMonthClick(r,t);},onKeyDown:function(r){e.onMonthKeyDown(r,t);},onMouseEnter:function(){return e.onMonthMouseEnter(t)},tabIndex:e.getTabIndex(t),className:e.getMonthClassNames(t),role:"option","aria-label":e.getAriaLabel(t),"aria-current":e.isCurrentMonth(n,t)?"date":void 0,"aria-selected":e.isSelectedMonth(n,t,o)},e.getMonthContent(t))})))}))})),St(Et(e),"renderQuarters",(function(){var t=e.props,r=t.day,a=t.selected;return de.default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(t,n){return de.default.createElement("div",{key:n,ref:e.QUARTER_REFS[n],role:"option",onClick:function(r){e.onQuarterClick(r,t);},onKeyDown:function(r){e.onQuarterKeyDown(r,t);},onMouseEnter:function(){return e.onQuarterMouseEnter(t)},className:e.getQuarterClassNames(t),"aria-selected":e.isSelectedQuarter(r,t,a),tabIndex:e.getQuarterTabIndex(t),"aria-current":e.isCurrentQuarter(r,t)?"date":void 0},e.getQuarterContent(t))})))})),St(Et(e),"getClassNames",(function(){var t=e.props,r=t.selectingDate,a=t.selectsStart,n=t.selectsEnd,o=t.showMonthYearPicker,s=t.showQuarterYearPicker,i=t.showWeekPicker;return ue.default("react-datepicker__month",{"react-datepicker__month--selecting-range":r&&(a||n)},{"react-datepicker__monthPicker":o},{"react-datepicker__quarterPicker":s},{"react-datepicker__weekPicker":i})})),e}return bt(r,[{key:"render",value:function(){var e=this.props,t=e.showMonthYearPicker,r=e.showQuarterYearPicker,a=e.day,n=e.ariaLabelPrefix,o=void 0===n?"month ":n;return de.default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(o," ").concat(qt(a,"yyyy-MM")),role:"listbox"},t?this.renderMonths():r?this.renderQuarters():this.renderWeeks())}}]),r}(de.default.Component),zr=function(e){_t(r,e);var t=Nt(r);function r(){var e;kt(this,r);for(var a=arguments.length,n=new Array(a),o=0;o<a;o++)n[o]=arguments[o];return St(Et(e=t.call.apply(t,[this].concat(n))),"state",{height:null}),St(Et(e),"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){e.list&&(e.list.scrollTop=e.centerLi&&r.calcCenterPosition(e.props.monthRef?e.props.monthRef.clientHeight-e.header.clientHeight:e.list.clientHeight,e.centerLi));}));})),St(Et(e),"handleClick",(function(t){(e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props)||e.props.onChange(t);})),St(Et(e),"isSelectedTime",(function(t){return e.props.selected&&(r=e.props.selected,a=t,Pr(r).getTime()===Pr(a).getTime());var r,a;})),St(Et(e),"isDisabledTime",(function(t){return (e.props.minTime||e.props.maxTime)&&mr(t,e.props)||(e.props.excludeTimes||e.props.includeTimes||e.props.filterTime)&&hr(t,e.props)})),St(Et(e),"liClasses",(function(t){var r=["react-datepicker__time-list-item",e.props.timeClassName?e.props.timeClassName(t):void 0];return e.isSelectedTime(t)&&r.push("react-datepicker__time-list-item--selected"),e.isDisabledTime(t)&&r.push("react-datepicker__time-list-item--disabled"),e.props.injectTimes&&(60*xe.default(t)+Ne.default(t))%e.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),St(Et(e),"handleOnKeyDown",(function(t,r){" "===t.key&&(t.preventDefault(),t.key="Enter"),"ArrowUp"!==t.key&&"ArrowLeft"!==t.key||!t.target.previousSibling||(t.preventDefault(),t.target.previousSibling.focus()),"ArrowDown"!==t.key&&"ArrowRight"!==t.key||!t.target.nextSibling||(t.preventDefault(),t.target.nextSibling.focus()),"Enter"===t.key&&e.handleClick(r),e.props.handleOnKeyDown(t);})),St(Et(e),"renderTimes",(function(){for(var t,r=[],a=e.props.format?e.props.format:"p",n=e.props.intervals,o=e.props.selected||e.props.openToDate||At(),s=(t=o,$e.default(t)),i=e.props.injectTimes&&e.props.injectTimes.sort((function(e,t){return e-t})),p=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(o),l=p/n,c=0;c<l;c++){var d=ye.default(s,c*n);if(r.push(d),i){var u=Cr(s,d,c,n,i);r=r.concat(u);}}var f=r.reduce((function(e,t){return t.getTime()<=o.getTime()?t:e}),r[0]);return r.map((function(t,r){return de.default.createElement("li",{key:r,onClick:e.handleClick.bind(Et(e),t),className:e.liClasses(t),ref:function(r){t===f&&(e.centerLi=r);},onKeyDown:function(r){e.handleOnKeyDown(r,t);},tabIndex:t===f?0:-1,role:"option","aria-selected":e.isSelectedTime(t)?"true":void 0,"aria-disabled":e.isDisabledTime(t)?"true":void 0},qt(t,a,e.props.locale))}))})),e}return bt(r,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var e=this,t=this.state.height;return de.default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(t){e.header=t;}},de.default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),de.default.createElement("div",{className:"react-datepicker__time"},de.default.createElement("div",{className:"react-datepicker__time-box"},de.default.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t;},style:t?{height:t}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}(de.default.Component);St(zr,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var $r=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"YEAR_REFS",xt(Array(a.props.yearItemNumber)).map((function(){return de.default.createRef()}))),St(Et(a),"isDisabled",(function(e){return nr(e,a.props)})),St(Et(a),"isExcluded",(function(e){return or(e,a.props)})),St(Et(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),St(Et(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus();}.bind(Et(a));window.requestAnimationFrame(t);})),St(Et(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t);})),St(Et(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=Mr(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus());})),St(Et(a),"isSameDay",(function(e,t){return Jt(e,t)})),St(Et(a),"isCurrentYear",(function(e){return e===Le.default(At())})),St(Et(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&zt(Qe.default(At(),e),a.props.startDate)})),St(Et(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&zt(Qe.default(At(),e),a.props.endDate)})),St(Et(a),"isInRange",(function(e){return lr(e,a.props.startDate,a.props.endDate)})),St(Et(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return !(!(r||n||o)||!a.selectingDate())&&(r&&i?lr(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&lr(e,s,a.selectingDate()))})),St(Et(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return  false;var t=a.props,r=t.startDate,n=t.selectsStart,o=Qe.default(At(),e);return zt(o,n?a.selectingDate():r)})),St(Et(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return  false;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=Qe.default(At(),e);return zt(s,n||o?a.selectingDate():r)})),St(Et(a),"isKeyboardSelected",(function(e){var t=jt(Qe.default(a.props.date,e));return !a.props.disabledKeyboardNavigation&&!a.props.inline&&!Jt(t,jt(a.props.selected))&&Jt(t,jt(a.props.preSelection))})),St(Et(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(jt(Qe.default(r,t)),e);})),St(Et(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case "Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case "ArrowRight":a.handleYearNavigation(t+1,be.default(a.props.preSelection,1));break;case "ArrowLeft":a.handleYearNavigation(t-1,Pe.default(a.props.preSelection,1));}})),St(Et(a),"getYearClassNames",(function(e){var t=a.props,r=t.minDate,n=t.maxDate,o=t.selected,s=t.excludeDates,i=t.includeDates,p=t.filterDate;return ue.default("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===Le.default(o),"react-datepicker__year-text--disabled":(r||n||s||i||p)&&cr(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),St(Et(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===Le.default(a.props.preSelection)?"0":"-1"})),St(Et(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,n=e.selectsEnd,o=e.selectsRange;return ue.default("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(r||n||o)})})),St(Et(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return bt(r,[{key:"render",value:function(){for(var e=this,t=[],r=this.props,a=r.date,n=r.yearItemNumber,o=r.onYearMouseEnter,s=r.onYearMouseLeave,i=Mr(a,n),p=i.startPeriod,l=i.endPeriod,c=function(r){t.push(de.default.createElement("div",{ref:e.YEAR_REFS[r-p],onClick:function(t){e.onYearClick(t,r);},onKeyDown:function(t){e.onYearKeyDown(t,r);},tabIndex:e.getYearTabIndex(r),className:e.getYearClassNames(r),onMouseEnter:function(e){return o(e,r)},onMouseLeave:function(e){return s(e,r)},key:r,"aria-current":e.isCurrentYear(r)?"date":void 0},e.getYearContent(r)));},d=p;d<=l;d++)c(d);return de.default.createElement("div",{className:this.getYearContainerClassNames()},de.default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},t))}}]),r}(de.default.Component),Gr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"onTimeChange",(function(e){a.setState({time:e});var t=a.props.date,r=t instanceof Date&&!isNaN(t)?t:new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),a.props.onChange(r);})),St(Et(a),"renderTimeInput",(function(){var e=a.state.time,t=a.props,r=t.date,n=t.timeString,o=t.customTimeInput;return o?de.default.cloneElement(o,{date:r,value:e,onChange:a.onTimeChange}):de.default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:true,value:e,onChange:function(e){a.onTimeChange(e.target.value||n);}})})),a.state={time:a.props.timeString},a}return bt(r,[{key:"render",value:function(){return de.default.createElement("div",{className:"react-datepicker__input-time-container"},de.default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),de.default.createElement("div",{className:"react-datepicker-time__input-container"},de.default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),r}(de.default.Component);function Jr(e){var t=e.className,r=e.children,a=e.showPopperArrow,n=e.arrowProps,o=void 0===n?{}:n;return de.default.createElement("div",{className:t},a&&de.default.createElement("div",Ct({className:"react-datepicker__triangle"},o)),r)}var Xr=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Zr=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"handleClickOutside",(function(e){a.props.onClickOutside(e);})),St(Et(a),"setClickOutsideRef",(function(){return a.containerRef.current})),St(Et(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return Xr.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus();})),St(Et(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=kr(a.props),s=wr(a.props),i=At(),p=n||r||t;return p||(o&&lt.default(i,o)?o:s&&pt.default(i,s)?s:i)})),St(Et(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:ke.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),St(Et(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:_e.default(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),St(Et(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e);})),St(Et(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e);})),St(Et(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave();})),St(Et(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:Qe.default(At(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t);})),St(Et(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t);})),St(Et(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:true})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(true)),a.props.setPreSelection&&a.props.setPreSelection(e);})),St(Et(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(true)),a.props.setPreSelection&&a.props.setPreSelection(e);})),St(Et(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:true}));})),St(Et(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e);})),St(Et(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return {date:Qe.default(r,e)}}),(function(){return a.handleYearChange(a.state.date)}));})),St(Et(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return {date:Ke.default(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}));})),St(Et(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return {date:Qe.default(Ke.default(r,Te.default(e)),Le.default(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}));})),St(Et(a),"header",(function(){var e=Qt(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),t=[];return a.props.showWeekNumbers&&t.push(de.default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),t.concat([0,1,2,3,4,5,6].map((function(t){var r=De.default(e,t),n=a.formatWeekday(r,a.props.locale),o=a.props.weekDayClassName?a.props.weekDayClassName(r):void 0;return de.default.createElement("div",{key:t,className:ue.default("react-datepicker__day-name",o)},n)})))})),St(Et(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(qt(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return qt(e,"EEE",t)}(e,t):function(e,t){return qt(e,"EEEEEE",t)}(e,t)})),St(Et(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return {date:Pe.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),St(Et(a),"clearSelectingDate",(function(){a.setState({selectingDate:null});})),St(Et(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var e;switch(true){case a.props.showMonthYearPicker:e=Dr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=Mr(jt(Pe.default(e,n)),n).endPeriod,s=r&&Le.default(r);return s&&s>o||false}(a.state.date,a.props);break;default:e=yr(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--previous"],r=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.decreaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--previous--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.previousMonthButtonLabel,i=o.previousYearButtonLabel,p=a.props,l=p.previousMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Previous Month":l,d=p.previousYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Previous Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},n?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),St(Et(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return {date:be.default(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),St(Et(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var e;switch(true){case a.props.showMonthYearPicker:e=gr(a.state.date,a.props);break;case a.props.showYearPicker:e=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,a=t.yearItemNumber,n=void 0===a?Lt:a,o=Mr(be.default(e,n),n).startPeriod,s=r&&Le.default(r);return s&&s<o||false}(a.state.date,a.props);break;default:e=vr(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!e)&&!a.props.showTimeSelectOnly){var t=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&t.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&t.push("react-datepicker__navigation--next--with-today-button");var r=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(r=a.increaseYear),e&&a.props.showDisabledMonthNavigation&&(t.push("react-datepicker__navigation--next--disabled"),r=null);var n=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,o=a.props,s=o.nextMonthButtonLabel,i=o.nextYearButtonLabel,p=a.props,l=p.nextMonthAriaLabel,c=void 0===l?"string"==typeof s?s:"Next Month":l,d=p.nextYearAriaLabel,u=void 0===d?"string"==typeof i?i:"Next Year":d;return de.default.createElement("button",{type:"button",className:t.join(" "),onClick:r,onKeyDown:a.props.handleOnKeyDown,"aria-label":n?u:c},de.default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},n?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),St(Et(a),"renderCurrentMonth",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,t=["react-datepicker__current-month"];return a.props.showYearDropdown&&t.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&t.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&t.push("react-datepicker__current-month--hasMonthYearDropdown"),de.default.createElement("div",{className:t.join(" ")},qt(e,a.props.dateFormat,a.props.locale))})),St(Et(a),"renderYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!e)return de.default.createElement(Yr,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:Le.default(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),St(Et(a),"renderMonthDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!e)return de.default.createElement(Tr,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:Te.default(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),St(Et(a),"renderMonthYearDropdown",(function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!e)return de.default.createElement(Ar,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),St(Et(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Ut(),e),a.props.setPreSelection&&a.props.setPreSelection(Ut());})),St(Et(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return de.default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),St(Et(a),"renderDefaultHeader",(function(e){var t=e.monthDate,r=e.i;return de.default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(t),de.default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==r),a.renderMonthYearDropdown(0!==r),a.renderYearDropdown(0!==r)),de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Et(a),"renderCustomHeader",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.monthDate,r=e.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var n=yr(a.state.date,a.props),o=vr(a.state.date,a.props),s=Dr(a.state.date,a.props),i=gr(a.state.date,a.props),p=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(Dt(Dt({},a.state),{},{customHeaderCount:r,monthDate:t,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:n,nextMonthButtonDisabled:o,prevYearButtonDisabled:s,nextYearButtonDisabled:i})),p&&de.default.createElement("div",{className:"react-datepicker__day-names"},a.header(t)))})),St(Et(a),"renderYearHeader",(function(){var e=a.state.date,t=a.props,r=t.showYearPicker,n=Mr(e,t.yearItemNumber),o=n.startPeriod,s=n.endPeriod;return de.default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},r?"".concat(o," - ").concat(s):Le.default(e))})),St(Et(a),"renderHeader",(function(e){switch(true){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),St(Et(a),"renderMonths",(function(){var e;if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var t=[],r=a.props.showPreviousMonths?a.props.monthsShown-1:0,n=_e.default(a.state.date,r),o=null!==(e=a.props.monthSelectedIn)&&void 0!==e?e:r,s=0;s<a.props.monthsShown;++s){var i=s-o+r,p=ke.default(n,i),l="month-".concat(s),c=s<a.props.monthsShown-1,d=s>0;t.push(de.default.createElement("div",{key:l,ref:function(e){a.monthContainer=e;},className:"react-datepicker__month-container"},a.renderHeader({monthDate:p,i:s}),de.default.createElement(Ur,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:p,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:s,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,holidays:a.props.holidays,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:c,monthShowsDuplicateDaysStart:d})));}return t}})),St(Et(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?de.default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),de.default.createElement($r,Ct({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),St(Et(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return de.default.createElement(zr,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),St(Et(a),"renderInputTimeSection",(function(){var e=new Date(a.props.selected),t=Wt(e)&&Boolean(a.props.selected)?"".concat(_r(e.getHours()),":").concat(_r(e.getMinutes())):"";if(a.props.showTimeInput)return de.default.createElement(Gr,{date:e,timeString:t,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),St(Et(a),"renderAriaLiveRegion",(function(){var e,t=Mr(a.state.date,a.props.yearItemNumber),r=t.startPeriod,n=t.endPeriod;return e=a.props.showYearPicker?"".concat(r," - ").concat(n):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?Le.default(a.state.date):"".concat(rr(Te.default(a.state.date),a.props.locale)," ").concat(Le.default(a.state.date)),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&e)})),St(Et(a),"renderChildren",(function(){if(a.props.children)return de.default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=de.default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:false},a}return bt(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||Jt(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!Jt(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else {var r=!$t(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}));}}},{key:"render",value:function(){var e=this.props.container||Jr;return de.default.createElement("div",{style:{display:"contents"},ref:this.containerRef},de.default.createElement(e,{className:ue.default("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:false,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Lt}}}]),r}(de.default.Component),ea=function(e){var t=e.icon,r=e.className,a=void 0===r?"":r,n="react-datepicker__calendar-icon";return de.default.isValidElement(t)?de.default.cloneElement(t,{className:"".concat(t.props.className||""," ").concat(n," ").concat(a)}):"string"==typeof t?de.default.createElement("i",{className:"".concat(n," ").concat(t," ").concat(a),"aria-hidden":"true"}):de.default.createElement("svg",{className:"".concat(n," ").concat(a),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512"},de.default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},ta=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),(a=t.call(this,e)).el=document.createElement("div"),a}return bt(r,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el);}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el);}},{key:"render",value:function(){return mt.default.createPortal(this.props.children,this.el)}}]),r}(de.default.Component),ra=function(e){return !e.disabled&&-1!==e.tabIndex},aa=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"getTabChildren",(function(){return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(ra)})),St(Et(a),"handleFocusStart",(function(){var e=a.getTabChildren();e&&e.length>1&&e[e.length-1].focus();})),St(Et(a),"handleFocusEnd",(function(){var e=a.getTabChildren();e&&e.length>1&&e[0].focus();})),a.tabLoopRef=de.default.createRef(),a}return bt(r,[{key:"render",value:function(){return this.props.enableTabLoop?de.default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},de.default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,de.default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return {enableTabLoop:true}}}]),r}(de.default.Component),na=function(e){_t(r,e);var t=Nt(r);function r(){return kt(this,r),t.apply(this,arguments)}return bt(r,[{key:"render",value:function(){var e,t=this.props,r=t.className,a=t.wrapperClassName,n=t.hidePopper,o=t.popperComponent,s=t.popperModifiers,i=t.popperPlacement,p=t.popperProps,l=t.targetComponent,c=t.enableTabLoop,d=t.popperOnKeyDown,u=t.portalId,f=t.portalHost;if(!n){var h=ue.default("react-datepicker-popper",r);e=de.default.createElement(pe.Popper,Ct({modifiers:s,placement:i},p),(function(e){var t=e.ref,r=e.style,a=e.placement,n=e.arrowProps;return de.default.createElement(aa,{enableTabLoop:c},de.default.createElement("div",{ref:t,style:r,className:h,"data-placement":a,onKeyDown:d},de.default.cloneElement(o,{arrowProps:n})))}));}this.props.popperContainer&&(e=de.default.createElement(this.props.popperContainer,{},e)),u&&!n&&(e=de.default.createElement(ta,{portalId:u,portalHost:f},e));var m=ue.default("react-datepicker-wrapper",a);return de.default.createElement(pe.Manager,{className:"react-datepicker-manager"},de.default.createElement(pe.Reference,null,(function(e){var t=e.ref;return de.default.createElement("div",{ref:t,className:m},l)})),e)}}],[{key:"defaultProps",get:function(){return {hidePopper:true,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),r}(de.default.Component),oa="react-datepicker-ignore-onclickoutside",sa=ht.default(Zr);var ia="Date input not valid.",pa=function(e){_t(r,e);var t=Nt(r);function r(e){var a;return kt(this,r),St(Et(a=t.call(this,e)),"getPreSelection",(function(){return a.props.openToDate?a.props.openToDate:a.props.selectsEnd&&a.props.startDate?a.props.startDate:a.props.selectsStart&&a.props.endDate?a.props.endDate:At()})),St(Et(a),"modifyHolidays",(function(){var e;return null===(e=a.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return he.default(r)?[].concat(xt(e),[Dt(Dt({},t),{},{date:r})]):e}),[])})),St(Et(a),"calcInitialState",(function(){var e,t=a.getPreSelection(),r=kr(a.props),n=wr(a.props),o=r&&lt.default(t,$e.default(r))?r:n&&pt.default(t,et.default(n))?n:t;return {open:a.props.startOpen||false,preventFocus:false,preSelection:null!==(e=a.props.selectsRange?a.props.startDate:a.props.selected)&&void 0!==e?e:o,highlightDates:br(a.props.highlightDates),focused:false,shouldFocusDayInline:false,isRenderAriaLiveMessage:false}})),St(Et(a),"clearPreventFocusTimeout",(function(){a.preventFocusTimeout&&clearTimeout(a.preventFocusTimeout);})),St(Et(a),"setFocus",(function(){a.input&&a.input.focus&&a.input.focus({preventScroll:true});})),St(Et(a),"setBlur",(function(){a.input&&a.input.blur&&a.input.blur(),a.cancelFocusInput();})),St(Et(a),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];a.setState({open:e,preSelection:e&&a.state.open?a.state.preSelection:a.calcInitialState().preSelection,lastPreSelectChange:ca},(function(){e||a.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&a.setBlur(),a.setState({inputValue:null});}));}));})),St(Et(a),"inputOk",(function(){return fe.default(a.state.preSelection)})),St(Et(a),"isCalendarOpen",(function(){return void 0===a.props.open?a.state.open&&!a.props.disabled&&!a.props.readOnly:a.props.open})),St(Et(a),"handleFocus",(function(e){a.state.preventFocus||(a.props.onFocus(e),a.props.preventOpenOnFocus||a.props.readOnly||a.setOpen(true)),a.setState({focused:true});})),St(Et(a),"sendFocusBackToInput",(function(){a.preventFocusTimeout&&a.clearPreventFocusTimeout(),a.setState({preventFocus:true},(function(){a.preventFocusTimeout=setTimeout((function(){a.setFocus(),a.setState({preventFocus:false});}));}));})),St(Et(a),"cancelFocusInput",(function(){clearTimeout(a.inputFocusTimeout),a.inputFocusTimeout=null;})),St(Et(a),"deferFocusInput",(function(){a.cancelFocusInput(),a.inputFocusTimeout=setTimeout((function(){return a.setFocus()}),1);})),St(Et(a),"handleDropdownFocus",(function(){a.cancelFocusInput();})),St(Et(a),"handleBlur",(function(e){(!a.state.open||a.props.withPortal||a.props.showTimeInput)&&a.props.onBlur(e),a.setState({focused:false});})),St(Et(a),"handleCalendarClickOutside",(function(e){a.props.inline||a.setOpen(false),a.props.onClickOutside(e),a.props.withPortal&&e.preventDefault();})),St(Et(a),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!a.props.onChangeRaw||(a.props.onChangeRaw.apply(Et(a),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){a.setState({inputValue:n.target.value,lastPreSelectChange:la});var o,s,i,p,l,c,d,u,f=(o=n.target.value,s=a.props.dateFormat,i=a.props.locale,p=a.props.strictParsing,l=a.props.minDate,c=null,d=tr(i)||tr(er()),u=true,Array.isArray(s)?(s.forEach((function(e){var t=ut.default(o,e,new Date,{locale:d});p&&(u=Wt(t,l)&&o===qt(t,e,i)),Wt(t,l)&&u&&(c=t);})),c):(c=ut.default(o,s,new Date,{locale:d}),p?u=Wt(c)&&o===qt(c,s,i):Wt(c)||(s=s.match(Ft).map((function(e){var t=e[0];return "p"===t||"P"===t?d?(0, Rt[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(c=ut.default(o,s.slice(0,o.length),new Date)),Wt(c)||(c=new Date(o))),Wt(c)&&u?c:null));a.props.showTimeSelectOnly&&a.props.selected&&f&&!Jt(f,a.props.selected)&&(f=yt.default(a.props.selected,{hours:xe.default(f),minutes:Ne.default(f),seconds:Ee.default(f)})),!f&&n.target.value||(a.props.showWeekPicker&&(f=Qt(f,a.props.locale,a.props.calendarStartDay)),a.setSelected(f,n,true));}})),St(Et(a),"handleSelect",(function(e,t,r){if(a.props.shouldCloseOnSelect&&!a.props.showTimeSelect&&a.sendFocusBackToInput(),a.props.onChangeRaw&&a.props.onChangeRaw(t),a.props.showWeekPicker&&(e=Qt(e,a.props.locale,a.props.calendarStartDay)),a.setSelected(e,t,false,r),a.props.showDateSelect&&a.setState({isRenderAriaLiveMessage:true}),!a.props.shouldCloseOnSelect||a.props.showTimeSelect)a.setPreSelection(e);else if(!a.props.inline){a.props.selectsRange||a.setOpen(false);var n=a.props,o=n.startDate,s=n.endDate;!o||s||lt.default(e,o)||a.setOpen(false);}})),St(Et(a),"setSelected",(function(e,t,r,n){var o=e;if(a.props.showYearPicker){if(null!==o&&cr(Le.default(o),a.props))return}else if(a.props.showMonthYearPicker){if(null!==o&&sr(o,a.props))return}else if(null!==o&&nr(o,a.props))return;var s=a.props,i=s.onChange,p=s.selectsRange,l=s.startDate,c=s.endDate;if(!Xt(a.props.selected,o)||a.props.allowSameDay||p)if(null!==o&&(!a.props.selected||r&&(a.props.showTimeSelect||a.props.showTimeSelectOnly||a.props.showTimeInput)||(o=Bt(o,{hour:xe.default(a.props.selected),minute:Ne.default(a.props.selected),second:Ee.default(a.props.selected)})),a.props.inline||a.setState({preSelection:o}),a.props.focusSelectedMonth||a.setState({monthSelectedIn:n})),p){var d=l&&!c,u=l&&c;!l&&!c?i([o,null],t):d&&(lt.default(o,l)?i([o,null],t):i([l,o],t)),u&&i([o,null],t);}else i(o,t);r||(a.props.onSelect(o,t),a.setState({inputValue:null}));})),St(Et(a),"setPreSelection",(function(e){var t=void 0!==a.props.minDate,r=void 0!==a.props.maxDate,n=true;if(e){a.props.showWeekPicker&&(e=Qt(e,a.props.locale,a.props.calendarStartDay));var o=$e.default(e);if(t&&r)n=Zt(e,a.props.minDate,a.props.maxDate);else if(t){var s=$e.default(a.props.minDate);n=pt.default(e,s)||Xt(o,s);}else if(r){var i=et.default(a.props.maxDate);n=lt.default(e,i)||Xt(o,i);}}n&&a.setState({preSelection:e});})),St(Et(a),"handleTimeChange",(function(e){var t=a.props.selected?a.props.selected:a.getPreSelection(),r=a.props.selected?e:Bt(t,{hour:xe.default(e),minute:Ne.default(e)});a.setState({preSelection:r}),a.props.onChange(r),a.props.shouldCloseOnSelect&&(a.sendFocusBackToInput(),a.setOpen(false)),a.props.showTimeInput&&a.setOpen(true),(a.props.showTimeSelectOnly||a.props.showTimeSelect)&&a.setState({isRenderAriaLiveMessage:true}),a.setState({inputValue:null});})),St(Et(a),"onInputClick",(function(){a.props.disabled||a.props.readOnly||a.setOpen(true),a.props.onInputClick();})),St(Et(a),"onInputKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key;if(a.state.open||a.props.inline||a.props.preventOpenOnFocus){if(a.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=a.props.showWeekPicker&&a.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',n=a.calendar.componentNode&&a.calendar.componentNode.querySelector(r);return void(n&&n.focus({preventScroll:true}))}var o=At(a.state.preSelection);"Enter"===t?(e.preventDefault(),a.inputOk()&&a.state.lastPreSelectChange===ca?(a.handleSelect(o,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(o)):a.setOpen(false)):"Escape"===t?(e.preventDefault(),a.sendFocusBackToInput(),a.setOpen(false)):"Tab"===t&&a.setOpen(false),a.inputOk()||a.props.onInputError({code:1,msg:ia});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||a.onInputClick();})),St(Et(a),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.setState({preventFocus:true},(function(){a.setOpen(false),setTimeout((function(){a.setFocus(),a.setState({preventFocus:false});}));})));})),St(Et(a),"onDayKeyDown",(function(e){a.props.onKeyDown(e);var t=e.key,r=At(a.state.preSelection);if("Enter"===t)e.preventDefault(),a.handleSelect(r,e),!a.props.shouldCloseOnSelect&&a.setPreSelection(r);else if("Escape"===t)e.preventDefault(),a.setOpen(false),a.inputOk()||a.props.onInputError({code:1,msg:ia});else if(!a.props.disabledKeyboardNavigation){var n;switch(t){case "ArrowLeft":n=a.props.showWeekPicker?Ce.default(r,1):Se.default(r,1);break;case "ArrowRight":n=a.props.showWeekPicker?ge.default(r,1):De.default(r,1);break;case "ArrowUp":n=Ce.default(r,1);break;case "ArrowDown":n=ge.default(r,1);break;case "PageUp":n=_e.default(r,1);break;case "PageDown":n=ke.default(r,1);break;case "Home":n=Pe.default(r,1);break;case "End":n=be.default(r,1);break;default:n=null;}if(!n)return void(a.props.onInputError&&a.props.onInputError({code:1,msg:ia}));if(e.preventDefault(),a.setState({lastPreSelectChange:ca}),a.props.adjustDateOnChange&&a.setSelected(n),a.setPreSelection(n),a.props.inline){var o=Te.default(r),s=Te.default(n),i=Le.default(r),p=Le.default(n);o!==s||i!==p?a.setState({shouldFocusDayInline:true}):a.setState({shouldFocusDayInline:false});}}})),St(Et(a),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),a.sendFocusBackToInput());})),St(Et(a),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),a.sendFocusBackToInput(),a.props.selectsRange?a.props.onChange([null,null],e):a.props.onChange(null,e),a.setState({inputValue:null});})),St(Et(a),"clear",(function(){a.onClearClick();})),St(Et(a),"onScroll",(function(e){"boolean"==typeof a.props.closeOnScroll&&a.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||a.setOpen(false):"function"==typeof a.props.closeOnScroll&&a.props.closeOnScroll(e)&&a.setOpen(false);})),St(Et(a),"renderCalendar",(function(){return a.props.inline||a.isCalendarOpen()?de.default.createElement(sa,{ref:function(e){a.calendar=e;},locale:a.props.locale,calendarStartDay:a.props.calendarStartDay,chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,monthAriaLabelPrefix:a.props.monthAriaLabelPrefix,adjustDateOnChange:a.props.adjustDateOnChange,setOpen:a.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,dateFormat:a.props.dateFormatCalendar,useWeekdaysShort:a.props.useWeekdaysShort,formatWeekDay:a.props.formatWeekDay,dropdownMode:a.props.dropdownMode,selected:a.props.selected,preSelection:a.state.preSelection,onSelect:a.handleSelect,onWeekSelect:a.props.onWeekSelect,openToDate:a.props.openToDate,minDate:a.props.minDate,maxDate:a.props.maxDate,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,startDate:a.props.startDate,endDate:a.props.endDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,filterDate:a.props.filterDate,onClickOutside:a.handleCalendarClickOutside,formatWeekNumber:a.props.formatWeekNumber,highlightDates:a.state.highlightDates,holidays:Sr(a.modifyHolidays()),includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,includeTimes:a.props.includeTimes,injectTimes:a.props.injectTimes,inline:a.props.inline,shouldFocusDayInline:a.state.shouldFocusDayInline,peekNextMonth:a.props.peekNextMonth,showMonthDropdown:a.props.showMonthDropdown,showPreviousMonths:a.props.showPreviousMonths,useShortMonthInDropdown:a.props.useShortMonthInDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showWeekNumbers:a.props.showWeekNumbers,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,forceShowMonthNavigation:a.props.forceShowMonthNavigation,showDisabledMonthNavigation:a.props.showDisabledMonthNavigation,scrollableYearDropdown:a.props.scrollableYearDropdown,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown,todayButton:a.props.todayButton,weekLabel:a.props.weekLabel,outsideClickIgnoreClass:oa,fixedHeight:a.props.fixedHeight,monthsShown:a.props.monthsShown,monthSelectedIn:a.state.monthSelectedIn,onDropdownFocus:a.handleDropdownFocus,onMonthChange:a.props.onMonthChange,onYearChange:a.props.onYearChange,dayClassName:a.props.dayClassName,weekDayClassName:a.props.weekDayClassName,monthClassName:a.props.monthClassName,timeClassName:a.props.timeClassName,showDateSelect:a.props.showDateSelect,showTimeSelect:a.props.showTimeSelect,showTimeSelectOnly:a.props.showTimeSelectOnly,onTimeChange:a.handleTimeChange,timeFormat:a.props.timeFormat,timeIntervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,className:a.props.calendarClassName,container:a.props.calendarContainer,yearItemNumber:a.props.yearItemNumber,yearDropdownItemNumber:a.props.yearDropdownItemNumber,previousMonthAriaLabel:a.props.previousMonthAriaLabel,previousMonthButtonLabel:a.props.previousMonthButtonLabel,nextMonthAriaLabel:a.props.nextMonthAriaLabel,nextMonthButtonLabel:a.props.nextMonthButtonLabel,previousYearAriaLabel:a.props.previousYearAriaLabel,previousYearButtonLabel:a.props.previousYearButtonLabel,nextYearAriaLabel:a.props.nextYearAriaLabel,nextYearButtonLabel:a.props.nextYearButtonLabel,timeInputLabel:a.props.timeInputLabel,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderCustomHeader:a.props.renderCustomHeader,popperProps:a.props.popperProps,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,onDayMouseEnter:a.props.onDayMouseEnter,onMonthMouseLeave:a.props.onMonthMouseLeave,onYearMouseEnter:a.props.onYearMouseEnter,onYearMouseLeave:a.props.onYearMouseLeave,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showTimeInput:a.props.showTimeInput,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,showPopperArrow:a.props.showPopperArrow,excludeScrollbar:a.props.excludeScrollbar,handleOnKeyDown:a.props.onKeyDown,handleOnDayKeyDown:a.onDayKeyDown,isInputFocused:a.state.focused,customTimeInput:a.props.customTimeInput,setPreSelection:a.setPreSelection},a.props.children):null})),St(Et(a),"renderAriaLiveRegion",(function(){var e,t=a.props,r=t.dateFormat,n=t.locale,o=a.props.showTimeInput||a.props.showTimeSelect?"PPPPp":"PPPP";return e=a.props.selectsRange?"Selected start date: ".concat(Kt(a.props.startDate,{dateFormat:o,locale:n}),". ").concat(a.props.endDate?"End date: "+Kt(a.props.endDate,{dateFormat:o,locale:n}):""):a.props.showTimeSelectOnly?"Selected time: ".concat(Kt(a.props.selected,{dateFormat:r,locale:n})):a.props.showYearPicker?"Selected year: ".concat(Kt(a.props.selected,{dateFormat:"yyyy",locale:n})):a.props.showMonthYearPicker?"Selected month: ".concat(Kt(a.props.selected,{dateFormat:"MMMM yyyy",locale:n})):a.props.showQuarterYearPicker?"Selected quarter: ".concat(Kt(a.props.selected,{dateFormat:"yyyy, QQQ",locale:n})):"Selected date: ".concat(Kt(a.props.selected,{dateFormat:o,locale:n})),de.default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},e)})),St(Et(a),"renderDateInput",(function(){var e,t=ue.default(a.props.className,St({},oa,a.state.open)),r=a.props.customInput||de.default.createElement("input",{type:"text"}),n=a.props.customInputRef||"ref",o="string"==typeof a.props.value?a.props.value:"string"==typeof a.state.inputValue?a.state.inputValue:a.props.selectsRange?function(e,t,r){if(!e)return "";var a=Kt(e,r),n=t?Kt(t,r):"";return "".concat(a," - ").concat(n)}(a.props.startDate,a.props.endDate,a.props):Kt(a.props.selected,a.props);return de.default.cloneElement(r,(St(St(St(St(St(St(St(St(St(St(e={},n,(function(e){a.input=e;})),"value",o),"onBlur",a.handleBlur),"onChange",a.handleChange),"onClick",a.onInputClick),"onFocus",a.handleFocus),"onKeyDown",a.onInputKeyDown),"id",a.props.id),"name",a.props.name),"form",a.props.form),St(St(St(St(St(St(St(St(St(St(e,"autoFocus",a.props.autoFocus),"placeholder",a.props.placeholderText),"disabled",a.props.disabled),"autoComplete",a.props.autoComplete),"className",ue.default(r.props.className,t)),"title",a.props.title),"readOnly",a.props.readOnly),"required",a.props.required),"tabIndex",a.props.tabIndex),"aria-describedby",a.props.ariaDescribedBy),St(St(St(e,"aria-invalid",a.props.ariaInvalid),"aria-labelledby",a.props.ariaLabelledBy),"aria-required",a.props.ariaRequired)))})),St(Et(a),"renderClearButton",(function(){var e=a.props,t=e.isClearable,r=e.disabled,n=e.selected,o=e.startDate,s=e.endDate,i=e.clearButtonTitle,p=e.clearButtonClassName,l=void 0===p?"":p,c=e.ariaLabelClose,d=void 0===c?"Close":c;return !t||null==n&&null==o&&null==s?null:de.default.createElement("button",{type:"button",className:ue.default("react-datepicker__close-icon",l,{"react-datepicker__close-icon--disabled":r}),disabled:r,"aria-label":d,onClick:a.onClearClick,title:i,tabIndex:-1})})),a.state=a.calcInitialState(),a.preventFocusTimeout=null,a}return bt(r,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,true);}},{key:"componentDidUpdate",value:function(e,t){var r,a;e.inline&&(r=e.selected,a=this.props.selected,r&&a?Te.default(r)!==Te.default(a)||Le.default(r)!==Le.default(a):r!==a)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:br(this.props.highlightDates)}),t.focused||Xt(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(false===t.open&&true===this.state.open&&this.props.onCalendarOpen(),true===t.open&&false===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,true);}},{key:"renderInputContainer",value:function(){var e=this.props,t=e.showIcon,r=e.icon,a=e.calendarIconClassname;return de.default.createElement("div",{className:"react-datepicker__input-container".concat(t?" react-datepicker__view-calendar-icon":"")},t&&de.default.createElement(ea,{icon:r,className:a}),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var e=this.renderCalendar();if(this.props.inline)return e;if(this.props.withPortal){var t=this.state.open?de.default.createElement(aa,{enableTabLoop:this.props.enableTabLoop},de.default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},e)):null;return this.state.open&&this.props.portalId&&(t=de.default.createElement(ta,{portalId:this.props.portalId,portalHost:this.props.portalHost},t)),de.default.createElement("div",null,this.renderInputContainer(),t)}return de.default.createElement(na,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return {allowSameDay:false,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:false,disabledKeyboardNavigation:false,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:false,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:false,withPortal:false,selectsDisabledDaysInRange:false,shouldCloseOnSelect:true,showTimeSelect:false,showTimeInput:false,showPreviousMonths:false,showMonthYearPicker:false,showFullMonthYearPicker:false,showTwoColumnMonthYearPicker:false,showFourColumnMonthYearPicker:false,showYearPicker:false,showQuarterYearPicker:false,showWeekPicker:false,strictParsing:false,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:true,yearItemNumber:Lt,focusSelectedMonth:false,showPopperArrow:true,excludeScrollbar:true,customTimeInput:null,calendarStartDay:void 0}}}]),r}(de.default.Component),la="input",ca="navigate";e.CalendarContainer=Jr,e.default=pa,e.getDefaultLocale=er,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t;},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:globalThis).__localeId__=e;},Object.defineProperty(e,"__esModule",{value:true});})); 
  	} (reactDatepicker_min$1, reactDatepicker_min$1.exports));
  	return reactDatepicker_min$1.exports;
  }

  var reactDatepicker_minExports = /*@__PURE__*/ requireReactDatepicker_min();
  var DatePicker = /*@__PURE__*/getDefaultExportFromCjs(reactDatepicker_minExports);

  function ownKeys$L(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$L(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$L(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$L(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var styles$2 = {
    button: _objectSpread$L(_objectSpread$L({
      width: '100%',
      'text-align': 'left',
      color: uiCommon.theme.colors.text['highEmphasis'],
      'font-family': 'Roboto'
    }, uiCommon.theme.textStyles['Body 1']), {}, {
      border: "1px solid ".concat(uiCommon.theme.colors.stroke[200]),
      bgColor: uiCommon.theme.colors.structural[0],
      px: uiCommon.theme.space[8],
      borderRadius: uiCommon.theme.radii[3],
      'max-width': uiCommon.theme.space[300],
      overflow: 'hidden',
      'min-width': uiCommon.theme.space[120]
    }),
    buttonSelected: _objectSpread$L(_objectSpread$L({
      width: '100%',
      'text-align': 'left',
      color: uiCommon.theme.colors.text['highEmphasis'],
      'font-family': 'Roboto'
    }, uiCommon.theme.textStyles['Body 1']), {}, {
      border: "".concat(uiCommon.theme.borders['1px'], " ").concat(uiCommon.theme.colors.stroke[200]),
      bgColor: uiCommon.theme.colors.structural[0],
      paddingLeft: uiCommon.theme.space[16],
      borderRadius: uiCommon.theme.radii[3],
      'max-width': uiCommon.theme.space[300],
      overflow: 'hidden',
      'min-width': uiCommon.theme.space[120]
    }),
    list: {
      padding: '10px',
      'max-height': '40vh',
      'over-flow': 'auto'
    },
    item: {
      'margin-left': '0px',
      color: uiCommon.theme.colors.text['mediumEmphasis']
    },
    itemSelected: {
      'margin-left': '0px',
      color: uiCommon.theme.colors.accent[200],
      backgroundColor: uiCommon.theme.colors.accent[50]
    },
    icon: {
      color: uiCommon.theme.colors.foundation[300]}};

  var _excluded$i = ["cellKey", "label", "value", "fieldType", "onChange", "onSubmit", "fieldEditorInfo", "className"];
  var isEmpty$4 = uiCommon.objectUtils.isEmpty;
  /**
   * Fetches the initial label for a field based on the cell key, case edits, and value.
   * For 'billing_location' fields, attempts to find a matching label from mapped values.
   * This is not the ideal way to do this, adding support for CDMX-1832
   * Component itself should be able to manage label - value combination in the dropdown
   *
   * @param {string} cellKey - The key identifying the cell/field
   * @param {CMxCommonApp.CaseEditsState} caseEdits - The current case edits state
   * @param {string} value - The current value of the field
   * @returns {string} The label to display, or the original value if no mapping is found
   */
  var fetchInitialLabel$1 = function fetchInitialLabel(cellKey, caseEdits, value) {
    if (cellKey === 'billing_location' && !isEmpty$4(caseEdits) && Object.keys(caseEdits).includes(cellKey)) {
      var _mappedValues$find;
      var _caseEdits$cellKey = caseEdits === null || caseEdits === void 0 ? void 0 : caseEdits[cellKey],
        mappedValues = _caseEdits$cellKey.mappedValues;
      var label = mappedValues === null || mappedValues === void 0 || (_mappedValues$find = mappedValues.find(function (map) {
        return (map === null || map === void 0 ? void 0 : map.value) === value;
      })) === null || _mappedValues$find === void 0 ? void 0 : _mappedValues$find.label;
      return label || value;
    }
    return value;
  };
  var FieldEditorv2 = function FieldEditorv2(props) {
    var defaultClassname = 'col-4 col-md-12';
    var cellKey = props.cellKey;
      props.label;
      var value = props.value,
      fieldType = props.fieldType,
      _onChange = props.onChange;
      props.onSubmit;
      var fieldEditorInfo = props.fieldEditorInfo,
      _props$className = props.className,
      className = _props$className === void 0 ? defaultClassname : _props$className,
      spreadable = _objectWithoutProperties(props, _excluded$i);
    var classes = classnames("".concat(cellKey, "-editor"), 'field-editorv2', 'encounter-info', className);
    var caseEdits = fieldEditorInfo.caseEdits;
    var updatedValue = value;
    var _useState = React.useState(fetchInitialLabel$1(cellKey, caseEdits, value.toString())),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];
    var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isMenuOpen = _useState4[0],
      setIsMenuOpen = _useState4[1];
    if (caseEdits && Object.keys(caseEdits).includes(cellKey)) {
      var _caseEdits$cellKey2 = caseEdits[cellKey],
        newValue = _caseEdits$cellKey2.newValue,
        initialValue = _caseEdits$cellKey2.initialValue;
      updatedValue = (newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0 ? newValue : initialValue !== null && initialValue !== void 0 ? initialValue : 'N/A';
      // setSelected(updatedValue.toString());
    }
    if (fieldType === 'date' && updatedValue !== 'N/A') {
      updatedValue = uiCommon.cmxDateTime.format(updatedValue.toString(), uiCommon.cmxDateTime.FORMATS.DATE);
    }
    React.useEffect(function () {
      setSelected(fetchInitialLabel$1(cellKey, caseEdits, value.toString()));
    }, [value]);
    var handleSelect = React.useCallback(function (option) {
      setSelected(option);
      _onChange(option);
      setIsMenuOpen(false);
    }, [_onChange]);

    // Render menu items only when the menu is open
    var renderMenuItems = React.useMemo(function () {
      if (fieldType === 'dictionary' && caseEdits && caseEdits[cellKey] && isMenuOpen) {
        var options = caseEdits[cellKey].options;
        return options.map(function (option, index) {
          return /*#__PURE__*/React.createElement(MenuItem$1, {
            sx: option === selected ? styles$2.itemSelected : styles$2.item,
            key: "".concat(cellKey, "-").concat(option, "-").concat(index),
            onSelect: function onSelect() {
              return handleSelect(option);
            },
            onClick: function onClick() {
              return handleSelect(option);
            },
            value: option
          }, option);
        });
      }
      return null;
    }, [fieldType, caseEdits, selected, handleSelect, cellKey, isMenuOpen]);
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement("div", _extends$1({}, spreadable, {
        className: classes,
        "data-testid": "field-editor"
      }), fieldType === 'date' && /*#__PURE__*/React.createElement("div", {
        className: "datepicker-qa date-field-editor",
        "data-testid": "field-editor-datepicker"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        key: updatedValue.toString(),
        selected: selected !== 'N/A' || null || undefined ? new Date("".concat(selected, " 00:00")) : null,
        placeholderText: 'No Date Selected',
        onChange: function onChange(e) {
          var newTime = e.toISOString().split('T')[0];
          setSelected(newTime);
          _onChange(newTime);
        }
      })), fieldType === 'dictionary' && /*#__PURE__*/React.createElement("div", {
        className: "dictionary-menu-button",
        "data-tooltip": selected,
        "data-testid": "field-editor-dictionary"
      }, /*#__PURE__*/React.createElement(ChakraProvider, null, /*#__PURE__*/React.createElement(Menu, {
        onOpen: function onOpen() {
          return setIsMenuOpen(true);
        },
        onClose: function onClose() {
          return setIsMenuOpen(false);
        }
      }, /*#__PURE__*/React.createElement(Tooltip, {
        label: selected,
        placement: "top"
      }, /*#__PURE__*/React.createElement(MenuButton$1, {
        as: Button,
        sx: styles$2.button
        //key={updatedValue.toString()}
        ,
        rightIcon: /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeChevronDownSVG20",
          svgIconSize: "20",
          svgIconClass: "select-checvron"
        }),
        _focus: {
          boxShadow: 'none'
        },
        _expanded: {
          bg: uiCommon.theme.colors.text['light'],
          border: "".concat(uiCommon.theme.borders['1px'], " ").concat(uiCommon.theme.colors.foundation[500])
        },
        _hover: {
          border: "".concat(uiCommon.theme.borders['1px'], " ").concat(uiCommon.theme.colors.foundation[400]),
          bg: uiCommon.theme.colors.text['light']
        }
      }, selected !== 'N/A' ? "".concat(selected) : 'No Selection')), /*#__PURE__*/React.createElement(MenuList$1, {
        sx: styles$2.list,
        style: {
          overflow: 'auto'
        },
        width: "200px"
      }, isMenuOpen && renderMenuItems)))))
    );
  };
  FieldEditorv2.displayName = 'FieldEditorv2';

  function _callSuper$y(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$y() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$y() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$y = function _isNativeReflectConstruct() { return !!t; })(); }

  /**
   * Props for the Menu Button component
   */

  /**
   * State for the Menu Button component
   */
  /**
   * A menu button that displays a dropdown menu when clicked
   */
  var MenuButton = /*#__PURE__*/function (_React$Component) {
    /**
     * Constructor function for the component
     * @param props - The props passed to the component
     */
    function MenuButton(props) {
      var _this;
      _classCallCheck(this, MenuButton);
      _this = _callSuper$y(this, MenuButton, [props]);
      _defineProperty(_this, "menuButtonRef", void 0);
      _defineProperty(_this, "menuRef", void 0);
      /**
       * Toggles the visibility of the menu on click
       */
      _defineProperty(_this, "handleMenuButtonClick", function (event) {
        event.stopPropagation();
        if (_this.props.disabled !== true) {
          _this.setState({
            showMenu: !_this.state.showMenu
          });
        }
      });
      /**
       * Handles clicks outside the menu, hiding the menu if necessary
       * @param event - the mouse event that occurred
       */
      _defineProperty(_this, "handleClickOutside", function (event) {
        var target = event.target;
        if (!target.closest('.menu-button-section') || Array.from(target.classList).includes('chakra-select-button')) {
          _this.setState({
            showMenu: false
          });
        }
      });
      _defineProperty(_this, "handleFocus", function () {
        // Open menu when MenuButton is focused
        _this.setState({
          showMenu: true
        });
      });
      _defineProperty(_this, "handleKeyDown", function (event) {
        if (event.key === 'Tab') {
          var _this$menuRef$current;
          var menuItems = (_this$menuRef$current = _this.menuRef.current) === null || _this$menuRef$current === void 0 ? void 0 : _this$menuRef$current.querySelectorAll("button, a, [tabindex='0']");
          if (menuItems) {
            var lastItem = menuItems[menuItems.length - 1];
            if (!event.shiftKey && document.activeElement === lastItem) {
              _this.setState({
                showMenu: false
              }); // Close menu when tabbing out from last item
            }
          }
        }
      });
      _defineProperty(_this, "handleBlur", function (event) {
        setTimeout(function () {
          var _this$menuRef$current2;
          var focusedElement = document.activeElement;

          // Close the menu only if the new focused element is NOT inside the menu or the menu button
          if (!((_this$menuRef$current2 = _this.menuRef.current) !== null && _this$menuRef$current2 !== void 0 && _this$menuRef$current2.contains(focusedElement)) && focusedElement !== _this.menuButtonRef.current) {
            _this.setState({
              showMenu: false
            });
          }
        }, 0); // Timeout allows new focus to be determined before closing the menu
      });
      /**
       * Handles clicks on the menu, hiding the menu if item selected
       * @param event - the mouse event that occurred
       */
      _defineProperty(_this, "handleMenuClick", function (event) {
        var target = event.target;

        // Check if click is on a menu item
        if (target.closest('.chakra-select-button')) {
          // Close the menu
          _this.setState({
            showMenu: false
          });
        }
      });
      _this.state = {
        showMenu: false
      };
      _this.menuButtonRef = /*#__PURE__*/React.createRef();
      _this.menuRef = /*#__PURE__*/React.createRef();
      return _this;
    }
    _inherits(MenuButton, _React$Component);
    return _createClass(MenuButton, [{
      key: "componentDidMount",
      value:
      /**
       * Adds an event listener for clicks outside the component, and removes it when the component unmounts
       */
      function componentDidMount() {
        window.addEventListener('click', this.handleClickOutside);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('click', this.handleClickOutside);
      }
    }, {
      key: "render",
      value:
      /**
       * Renders the component
       * @returns The rendered component
       */
      function render() {
        var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          prefixTitle = _this$props.prefixTitle,
          label = _this$props.label,
          icon = _this$props.icon,
          disabled = _this$props.disabled,
          defaultLabel = _this$props.defaultLabel,
          secondaryLabel = _this$props.secondaryLabel;
        var showMenu = this.state.showMenu;
        // Check if label prop is present, if not, use default label
        var renderedLabel = label ? label : defaultLabel;

        // Determine the class name for the label span
        var labelClassName = classnames({
          'chakra-button-label': label,
          // Apply chakra-button-label style if label is present
          'default-button-label': !label && defaultLabel // Apply default-button-label style if label is not present and defaultLabel is present
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "menu-button-section"
        }, /*#__PURE__*/React.createElement("button", {
          style: style,
          ref: this.menuButtonRef,
          onMouseDown: this.handleMenuButtonClick,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: classnames('chakra-secondary-button', className !== null && className !== void 0 ? className : '', 'menu-main-button', {
            'menu-main-button-active': showMenu
          })
        }, /*#__PURE__*/React.createElement("span", {
          className: labelClassName,
          onMouseDown: this.handleMenuButtonClick
        }, prefixTitle, renderedLabel), icon && /*#__PURE__*/React.createElement("span", {
          className: "menu-section-icon"
        }, icon), disabled !== true && !icon &&
        /*#__PURE__*/
        // Only render Chevron if not disabled and icon is not present
        // Removed onClick from Chevron to prevent duplicate triggers of handleMenuButtonClick.
        // The button already handles onMouseDown, and click on Chevron was bubbling up and causing double execution.
        React.createElement(uiComponents.Chevron, {
          className: "menu-section-icon"
        }), secondaryLabel && /*#__PURE__*/React.createElement("span", {
          className: "secondary-label"
        }, secondaryLabel)), /*#__PURE__*/React.createElement("div", {
          className: classnames('chakra-menu-section', {
            'chakra-active-menu': this.state.showMenu
          }),
          "data-testid": "menu-button-menu",
          ref: this.menuRef,
          onKeyDown: this.handleKeyDown,
          onClick: this.handleMenuClick
        }, this.props.children));
      }
    }]);
  }(React.Component);

  // React imports

  // Props type for menu button

  /**
   * Menu Button component for display multiple options
   * @param props
   */
  var MenuItem = function MenuItem(props) {
    var classnames$1 = classnames('chakra-select-button chakra-item-button', props.className);
    return /*#__PURE__*/React.createElement("button", {
      type: "button",
      role: "menuitem",
      onClick: props.onSelect,
      disabled: props.disabled,
      className: classnames$1
    }, props.children);
  };

  var _excluded$h = ["cellKey", "label", "value", "fieldType", "onChange", "onSubmit", "fieldEditorInfo", "className"];
  var isEmpty$3 = uiCommon.objectUtils.isEmpty;
  /**
   * Fetches the initial label for a field based on the cell key, case edits, and value.
   * For billing_location fields, it attempts to find a mapped label from the case edits.
   *
   * @param cellKey - The key identifier for the cell
   * @param caseEdits - The current state of case edits
   * @param value - The current value of the field
   * @returns The label to display, or the original value if no mapping is found
   */
  var fetchInitialLabel = function fetchInitialLabel(cellKey, caseEdits, value) {
    if (cellKey === 'billing_location' && !isEmpty$3(caseEdits) && Object.keys(caseEdits).includes(cellKey)) {
      var _mappedValues$find;
      var _caseEdits$cellKey = caseEdits === null || caseEdits === void 0 ? void 0 : caseEdits[cellKey],
        mappedValues = _caseEdits$cellKey.mappedValues;
      var label = mappedValues === null || mappedValues === void 0 || (_mappedValues$find = mappedValues.find(function (map) {
        return (map === null || map === void 0 ? void 0 : map.value) === value;
      })) === null || _mappedValues$find === void 0 ? void 0 : _mappedValues$find.label;
      return label || value;
    }
    return value;
  };
  var FieldEditor = function FieldEditor(props) {
    var defaultClassname = 'col-4 col-md-12';
    var cellKey = props.cellKey;
      props.label;
      var value = props.value,
      fieldType = props.fieldType,
      _onChange = props.onChange;
      props.onSubmit;
      var fieldEditorInfo = props.fieldEditorInfo,
      _props$className = props.className,
      className = _props$className === void 0 ? defaultClassname : _props$className,
      spreadable = _objectWithoutProperties(props, _excluded$h);
    var classes = classnames("".concat(cellKey, "-editor"), 'field-editor', 'encounter-info', className);
    var caseEdits = fieldEditorInfo.caseEdits;
    var updatedValue = value;
    var menuSelect;
    if (caseEdits && Object.keys(caseEdits).includes(cellKey)) {
      var _caseEdits$cellKey2 = caseEdits[cellKey],
        newValue = _caseEdits$cellKey2.newValue,
        initialValue = _caseEdits$cellKey2.initialValue;
      updatedValue = (newValue === null || newValue === void 0 ? void 0 : newValue.length) > 0 ? newValue : initialValue !== null && initialValue !== void 0 ? initialValue : 'N/A';
      // setSelected(updatedValue.toString());

      if (fieldType === 'dictionary') {
        var options = caseEdits[cellKey].options;
        menuSelect = options.map(function (option, index) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: "".concat(cellKey, "-").concat(option, "-").concat(index),
            onSelect: function onSelect(e) {
              setSelected(e.currentTarget.innerText);
              _onChange(e.currentTarget.innerText);
            }
          }, /*#__PURE__*/React.createElement("div", null, option));
        });
      }
    }
    if (fieldType === 'date' && updatedValue !== 'N/A') {
      updatedValue = uiCommon.cmxDateTime.format(updatedValue.toString(), uiCommon.cmxDateTime.FORMATS.DATE);
    }
    var _useState = React.useState(fetchInitialLabel(cellKey, caseEdits, value.toString())),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];
    React.useEffect(function () {
      setSelected(fetchInitialLabel(cellKey, caseEdits, value.toString()));
    }, [value]);
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement("div", _extends$1({}, spreadable, {
        className: classes,
        "data-testid": "field-editor"
      }), fieldType === 'date' && /*#__PURE__*/React.createElement("div", {
        className: "datepicker-qa date-field-editor",
        "data-testid": "field-editor-datepicker"
      }, /*#__PURE__*/React.createElement(DatePicker, {
        key: updatedValue.toString(),
        selected: selected !== 'N/A' || null || undefined ? new Date("".concat(selected, " 00:00")) : null,
        placeholderText: 'No Date Selected',
        onChange: function onChange(e) {
          var newTime = e.toISOString().split('T')[0];
          setSelected(newTime);
          _onChange(newTime);
        }
      })), fieldType === 'dictionary' && /*#__PURE__*/React.createElement("div", {
        className: "dictionary-menu-button tooltip",
        "data-tooltip": selected,
        "data-testid": "field-editor-dictionary"
      }, /*#__PURE__*/React.createElement(MenuButton, {
        key: updatedValue.toString(),
        label: selected !== 'N/A' ? "".concat(selected) : 'No Selection'
      }, menuSelect)))
    );
  };
  FieldEditor.displayName = 'FieldEditor';

  var _excluded$g = ["additionalInfo", "capability", "cellKey", "fieldType", "hasLink", "label", "showProviderInfo", "value", "className", "fieldEditorInfo"];
  function ownKeys$K(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$K(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$K(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$K(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  uiCommon.AmplifyCore.conditionalUtils;
  var caseEdit$1 = uiCommon.AmplifyCore.state.capabilities.capabilities.caseEdit;
  var BASE_FIELD$1 = {
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    showProviderInfo: function showProviderInfo(providerInfo) {},
    updateValue: function updateValue(value) {},
    updateCase: function updateCase(idAndUpdates) {},
    loadPatientDetailOptions: function loadPatientDetailOptions(dictionaryInfo) {}
  };
  var UNEDITABLE_FIELD$1 = _objectSpread$K(_objectSpread$K({}, BASE_FIELD$1), {}, {
    editEnabled: false
  });
  var EDITABLE_FIELD = _objectSpread$K(_objectSpread$K({}, BASE_FIELD$1), {}, {
    editEnabled: true
  });
  var InfoCell$1 = function InfoCell(_ref) {
    var _caseEdit$on$value;
    var additionalInfo = _ref.additionalInfo,
      capability = _ref.capability,
      cellKey = _ref.cellKey,
      fieldType = _ref.fieldType,
      hasLink = _ref.hasLink,
      label = _ref.label,
      showProviderInfo = _ref.showProviderInfo,
      value = _ref.value,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? 'col-4 col-md-12' : _ref$className,
      _ref$fieldEditorInfo = _ref.fieldEditorInfo,
      fieldEditorInfo = _ref$fieldEditorInfo === void 0 ? _objectSpread$K({}, UNEDITABLE_FIELD$1) : _ref$fieldEditorInfo,
      spreadable = _objectWithoutProperties(_ref, _excluded$g);
    var props = _objectSpread$K({
      cellKey: cellKey,
      label: label,
      value: value,
      fieldType: fieldType,
      fieldEditorInfo: fieldEditorInfo,
      className: className,
      capability: capability,
      hasLink: hasLink,
      additionalInfo: additionalInfo,
      showProviderInfo: showProviderInfo
    }, spreadable);
    var classes = classnames("".concat(cellKey, "-cell"), 'info-cell', 'encounter-info', className);
    var additionalInfoHasNA = (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName) === 'N/A' || (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber) === 'N/A' || (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode) === 'N/A';
    var showLink = hasLink ? value !== 'N/A' && !additionalInfoHasNA : false;
    var updateValue = fieldEditorInfo.updateValue,
      updateCase = fieldEditorInfo.updateCase;
    var isValidDate = function isValidDate(date) {
      if (fieldType === 'date') {
        var _cmxDateTime$parse;
        return fieldType === 'date' && date && (date === 'N/A' || ((_cmxDateTime$parse = uiCommon.cmxDateTime.parse(date)) === null || _cmxDateTime$parse === void 0 ? void 0 : _cmxDateTime$parse.successfullyParsed));
      } else {
        return false;
      }
    };
    var handleProviderClick = function handleProviderClick(ev) {
      ev.preventDefault();
      if (showLink) {
        showProviderInfo({
          providerName: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName,
          providerNumber: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber,
          tenantCode: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode
        });
      }
    };
    var _handleChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
        var caseUpdate;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (fieldType === 'dictionary' || isValidDate(val === null || val === void 0 ? void 0 : val.toString())) {
                updateValue({
                  fieldKey: cellKey,
                  newValue: val
                });
                caseUpdate = {};
                caseUpdate[cellKey] = val;
                updateCase(caseUpdate);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function _handleChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var showFieldEditor = (fieldType === 'dictionary' || isValidDate(value === null || value === void 0 ? void 0 : value.toString())) && cellKey !== 'date_of_service' && (
    //@ts-ignore
    capability ? capability.on : (_caseEdit$on$value = caseEdit$1.on.value) !== null && _caseEdit$on$value !== void 0 ? _caseEdit$on$value : caseEdit$1.on);
    var hasAmplifyCaseRunV2Access = uiCommon.Utils.doesPathEndWithV2() || /cmx.*quality-assessment.*case.*case-run/.test(window.location.pathname);
    classnames('flex-container', className);
    var displayValue = typeof value === 'string' || /*#__PURE__*/React.isValidElement(value) ? value : JSON.stringify(value);
    var infoCellContent =
    /*#__PURE__*/
    //@ts-ignore
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends$1({}, spreadable, {
      className: classes,
      key: "".concat(cellKey, "-info-cell")
    }), /*#__PURE__*/React.createElement("span", {
      className: "encounter-field field-label"
    }, label), showFieldEditor ? hasAmplifyCaseRunV2Access ? /*#__PURE__*/React.createElement(FieldEditorv2, _extends$1({
      className: "field-data"
    }, props, {
      value: value,
      onChange: _handleChange,
      onSubmit: function onSubmit() {},
      fieldEditorInfo: fieldEditorInfo
    })) : /*#__PURE__*/React.createElement(FieldEditor, _extends$1({
      className: "field-data"
    }, props, {
      value: value,
      onChange: _handleChange,
      onSubmit: function onSubmit() {},
      fieldEditorInfo: fieldEditorInfo
    })) : /*#__PURE__*/React.createElement("span", {
      className: classnames('encounter-detail field-data sensitive-data', "".concat(cellKey, "-field"), {
        'cmx-link': showLink
      }),
      onClick: function onClick(ev) {
        return handleProviderClick(ev);
      }
    }, displayValue)));
    return infoCellContent;
  };
  InfoCell$1.displayName = 'InfoCell';

  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray$4(r);
  }

  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$3(r) || _nonIterableSpread();
  }

  // ---------------------------------------
  // types
  // ---------------------------------------

  // counter function to generate unique keys.  there are currently no
  // unique keys on segments or spans.  It's not clear to me that we'd use
  // them as keys anyways, as we're creating "synthetic" spans in places.
  // So, the proposal for now is just to use a counter to generate an
  // increasing number.

  var counterGenerator = function counterGenerator(id) {
    var idx = 0;
    return function () {
      return "{id}-".concat(idx++);
    };
  };

  /**
   * Returns a portion of text designed to be displayed without highlighting.
   * If no text was selected, the return's advanced property will be 0.
   * @param span
   * @param segment
   * @param currentIndex
   */
  var getUnhighlightedText = function getUnhighlightedText(span, segment, currentIndex, counter) {
    var firstSpanStarts = span.span.start;
    var sliceLength = firstSpanStarts - segment.start - currentIndex;
    if (sliceLength) {
      var slice = segment.text.slice(currentIndex, currentIndex + sliceLength);
      return {
        segment: unhighlightedText(slice, counter),
        advanced: sliceLength
      };
    }
    return {
      advanced: 0
    };
  };

  // ---------------------------------------
  // React based code
  // ---------------------------------------
  var unhighlightedText = function unhighlightedText(text, counter) {
    if (uiCommon.objectUtils.isString(text) && text.trim().length === 0) {
      return emptySegment({
        key: "span-".concat(counter())
      });
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "unhighlighted qa-unhighlighted",
      key: "span-".concat(counter())
    }, text);
  };
  var highlightText = function highlightText(text, span, counter) {
    var _span$code$provenance, _span$code;
    var hasContent = uiCommon.objectUtils.isString(text) && text.trim().length > 0;
    var content = uiCommon.objectUtils.isString(text) && !hasContent ? /*#__PURE__*/React.createElement("br", null) : text;
    //@ts-ignore
    var provenance = ((_span$code$provenance = (_span$code = span.code) === null || _span$code === void 0 ? void 0 : _span$code.provenance) !== null && _span$code$provenance !== void 0 ? _span$code$provenance : '').toLowerCase();
    var classNames = [{
      'highlighted-segment': hasContent,
      'empty-block': !hasContent
    }, "qa-highlighted", "highlighted-".concat(span.codeType.toLowerCase()), "highlighted-".concat(provenance), span.span.uuid ? "span-".concat(span.span.uuid) : false,
    // hashes are not currently
    span.span.hash ? "span-".concat(span.span.hash) : false, {
      'highlighted-active': span.active,
      'qa-highlighted-active': span.active
    }];
    return /*#__PURE__*/React.createElement("span", {
      id: span.span.uuid,
      className: classnames(classNames),
      key: "span-".concat(counter())
    }, content);
  };
  /**
   * Given a segment, apply all the evidence to it.
   * @param segment
   * @param spans
   */
  var _highlightSegment = function highlightSegment(segment, spans, counter) {
    var segments = [];
    var currentIndex = 0;
    var seen = new Set();
    spans.forEach(function (span, idx) {
      if (!seen.has(span)) {
        // if the span starts later than the segment, let's peel off first chunk of text
        var unhighlighted = getUnhighlightedText(span, segment, currentIndex, counter);
        if (unhighlighted.segment) {
          segments.push(unhighlighted.segment);
          // advance along the string length n units
          currentIndex += unhighlighted.advanced;
        }

        // determine if there's any nesting.
        var subsections = spans.slice(idx);
        var nest = uiCommon.highlighterUtils.buildNest(subsections, segment);
        var text = segment.text.slice(nest.start, nest.end);
        // Note: spans operate on a relative basis.
        // span.start = 53 may mean that the span is only
        // starting 3 characters in if the span starts at character
        // 50; as would be the case with a segment that starts at 50.
        // text slicing on the other hand, operates on absolute basis.
        if (!nest.hasChildren) {
          segments.push(highlightText(text, span, counter));
        } else {
          // 1. create psuedo segment
          var start = segment.start + currentIndex;
          var end = start + text.length;
          var psuedoSegment = {
            text: text,
            start: start,
            end: end
          };
          // 2. recurse through data structure
          var highlightedSubsegments = _highlightSegment(psuedoSegment, nest.children, counter);
          nest.children.forEach(function (child) {
            seen.add(child);
          });
          // 3. wrap the output in another span
          segments.push(highlightText(highlightedSubsegments, nest.parent, counter));
        }
        currentIndex += text.length;
      }
    });
    // if there are any leftovers, append the raw string.s
    var leftoverText = segment.text.slice(currentIndex);
    if (leftoverText.length) {
      segments.push(unhighlightedText(leftoverText, counter));
    }
    if (!segments.length) {
      var emptyKey = counter();
      segments.push(emptySegment({
        className: "span-no-segments-".concat(emptyKey),
        key: emptyKey
      }));
    }
    return segments;
  };
  var emptySegment = function emptySegment(props) {
    var classes = [props.className, 'empty-segment'];
    return /*#__PURE__*/React.createElement("div", _extends$1({}, props, {
      className: classnames(classes)
    }), /*#__PURE__*/React.createElement("br", null));
  };
  var highlightSegments = function highlightSegments(segments, spans, counter) {
    var tempSpans = _toConsumableArray(spans);
    var texts = [];
    var currentSegment = 0;
    var totalSegments = segments.length;
    while (currentSegment < totalSegments) {
      var activeSegment = segments[currentSegment];
      var activeSpans = uiCommon.highlighterUtils.getActiveSpans(tempSpans, activeSegment);
      var textContents = _highlightSegment(activeSegment, activeSpans, counter);
      texts.push(/*#__PURE__*/React.createElement("div", {
        className: "content-segment",
        key: "content-segment-".concat(counter())
      }, /*#__PURE__*/React.createElement("span", {
        className: "highlighter-diagnostics"
      }, activeSegment.start, " - ", activeSegment.end), textContents));
      currentSegment++;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "highlighted-content"
    }, texts);
  };
  var HighlightedContent = function HighlightedContent(props) {
    var spans = props.spans,
      segments = props.segments;
      props.id;
    var counter = counterGenerator();
    var texts = highlightSegments(segments, spans, counter);
    return /*#__PURE__*/React.createElement("div", {
      className: "highlighted-content"
    }, texts);
  };

  function _callSuper$x(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$x() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$x() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$x = function _isNativeReflectConstruct() { return !!t; })(); }
  var NoteFrame = /*#__PURE__*/function (_React$Component) {
    function NoteFrame(props) {
      var _this;
      _classCallCheck(this, NoteFrame);
      _this = _callSuper$x(this, NoteFrame, [props]);
      _defineProperty(_this, "_iframeRef", void 0);
      _this._iframeRef = /*#__PURE__*/React.createRef();
      return _this;
    }
    _inherits(NoteFrame, _React$Component);
    return _createClass(NoteFrame, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.updateIframeContent();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.iframeNote.id !== prevProps.iframeNote.id) {
          this.updateIframeContent();
        }
      }
    }, {
      key: "updateIframeContent",
      value: function updateIframeContent() {
        var iframeNote = this.props.iframeNote;
        var iframe = this._iframeRef.current;
        if (!iframe) return;
        var iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(iframeNote.content);
        iframeDocument.close();

        // Prevent inner scrollbars
        iframeDocument.body.style.overflowY = 'hidden';
        iframeDocument.body.style.margin = '0'; // Ensure no margin offset

        // --- Dynamic Resizing Logic ---
        // We use requestAnimationFrame to ensure the browser has 
        // rendered the written content before we measure it.
        requestAnimationFrame(function () {
          var height = iframeDocument.documentElement.scrollHeight;
          iframe.style.height = "".concat(height, "px");
        });
        // ------------------------------

        var inputEls = iframeDocument.getElementsByTagName('input');
        for (var i = 0; i < inputEls.length; i++) {
          if (inputEls[i].type === 'checkbox') {
            inputEls[i].addEventListener('click', function (e) {
              return e.preventDefault();
            });
          }
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement("iframe", {
          className: "note-iframe autosize-iframe-content",
          sandbox: "allow-same-origin",
          ref: this._iframeRef
        });
      }
    }]);
  }(React.Component);

  function _callSuper$w(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$w() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$w() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$w = function _isNativeReflectConstruct() { return !!t; })(); }
  var base64toBlob = function base64toBlob(data) {
    var bytes = window.atob(data);
    var length = bytes.length;
    var out = new Uint8Array(length);
    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], {
      type: 'application/pdf'
    });
  };
  var PDFFrame = /*#__PURE__*/function (_React$Component) {
    function PDFFrame(props) {
      var _this;
      _classCallCheck(this, PDFFrame);
      _this = _callSuper$w(this, PDFFrame, [props]);
      _defineProperty(_this, "_iframeRef", void 0);
      _this._iframeRef = /*#__PURE__*/React.createRef();
      return _this;
    }
    _inherits(PDFFrame, _React$Component);
    return _createClass(PDFFrame, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.updateIframeContent();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.props.pdfContent.id !== prevProps.pdfContent.id) {
          this.updateIframeContent();
        }
      }
    }, {
      key: "updateIframeContent",
      value: function updateIframeContent() {
        var _this2 = this;
        var iframeNote = this.props.pdfContent;
        // some delay is necessary atm.
        setTimeout(function () {
          if (iframeNote.content && _this2._iframeRef.current) {
            var blob = base64toBlob(iframeNote.content);
            var pdfContent = URL.createObjectURL(blob);
            var iframeWindow = _this2._iframeRef.current.contentWindow;
            iframeWindow.postMessage({
              pdfContent: pdfContent
            }, window.location.origin);
          }
        }, 1000);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement("iframe", {
          className: "note-iframe",
          src: "/pages/pdf-viewer/index.html",
          height: "800px",
          "min-width": "450px",
          ref: this._iframeRef
        });
      }
    }]);
  }(React.Component);

  function ownKeys$J(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$J(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$J(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$J(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$v(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$v() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$v() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$v = function _isNativeReflectConstruct() { return !!t; })(); }
  var CaseAlertType$2 = uiCommon.commonEnums.CaseAlertType;
  var DEFAULT_PROPS$8 = {
    alertSize: 'md'
  };
  var alertIcon = _defineProperty(_defineProperty(_defineProperty({}, CaseAlertType$2.WARNING, 'BiomeWarning'), CaseAlertType$2.ERROR, 'BiomeWarning'), CaseAlertType$2.INFO, 'BiomeInfo');
  var CaseAlert = /*#__PURE__*/function (_React$Component) {
    /**
     * Constructor method for class CaseAlert
     * @param {Accelerate.CaseAlertProps} props - Props object passed to CaseAlert component
     */
    function CaseAlert(props) {
      _classCallCheck(this, CaseAlert);
      return _callSuper$v(this, CaseAlert, [props]);
    }
    _inherits(CaseAlert, _React$Component);
    return _createClass(CaseAlert, [{
      key: "render",
      value: function render() {
        var props = _objectSpread$J(_objectSpread$J({}, DEFAULT_PROPS$8), this.props);
        var caseAlertClass = ['case-alert', 'case-alert-' + props.alertSize, {
          'case-alert-warning': this.props.alertType === CaseAlertType$2.WARNING,
          'case-alert-error': this.props.alertType === CaseAlertType$2.ERROR,
          'case-alert-info': this.props.alertType === CaseAlertType$2.INFO
        }];
        var caseAlertSidebar = ['case-alert-sidebar', {
          'case-alert-bg-warning': this.props.alertType === CaseAlertType$2.WARNING,
          'case-alert-bg-error': this.props.alertType === CaseAlertType$2.ERROR,
          'case-alert-bg-info': this.props.alertType === CaseAlertType$2.INFO
        }];
        var alertIconClass = [{
          'case-alert-icon-warning': this.props.alertType === CaseAlertType$2.WARNING,
          'case-alert-icon-error': this.props.alertType === CaseAlertType$2.ERROR,
          'case-alert-icon-info': this.props.alertType === CaseAlertType$2.INFO
        }];
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(caseAlertClass),
          "data-testid": "case-alert"
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames(caseAlertSidebar)
        }, /*#__PURE__*/React.createElement(uiComponents.Icon, {
          svgIconName: alertIcon[this.props.alertType],
          svgIconClass: classnames(alertIconClass),
          svgIconSize: "20"
        })), /*#__PURE__*/React.createElement("div", null, this.props.children));
      }
    }]);
  }(React.Component);

  var shim = {exports: {}};

  var useSyncExternalStoreShim_production = {};

  /**
   * @license React
   * use-sync-external-store-shim.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredUseSyncExternalStoreShim_production;

  function requireUseSyncExternalStoreShim_production () {
  	if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  	hasRequiredUseSyncExternalStoreShim_production = 1;
  	var React$1 = React;
  	function is(x, y) {
  	  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
  	}
  	var objectIs = "function" === typeof Object.is ? Object.is : is,
  	  useState = React$1.useState,
  	  useEffect = React$1.useEffect,
  	  useLayoutEffect = React$1.useLayoutEffect,
  	  useDebugValue = React$1.useDebugValue;
  	function useSyncExternalStore$2(subscribe, getSnapshot) {
  	  var value = getSnapshot(),
  	    _useState = useState({ inst: { value: value, getSnapshot: getSnapshot } }),
  	    inst = _useState[0].inst,
  	    forceUpdate = _useState[1];
  	  useLayoutEffect(
  	    function () {
  	      inst.value = value;
  	      inst.getSnapshot = getSnapshot;
  	      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
  	    },
  	    [subscribe, value, getSnapshot]
  	  );
  	  useEffect(
  	    function () {
  	      checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
  	      return subscribe(function () {
  	        checkIfSnapshotChanged(inst) && forceUpdate({ inst: inst });
  	      });
  	    },
  	    [subscribe]
  	  );
  	  useDebugValue(value);
  	  return value;
  	}
  	function checkIfSnapshotChanged(inst) {
  	  var latestGetSnapshot = inst.getSnapshot;
  	  inst = inst.value;
  	  try {
  	    var nextValue = latestGetSnapshot();
  	    return !objectIs(inst, nextValue);
  	  } catch (error) {
  	    return true;
  	  }
  	}
  	function useSyncExternalStore$1(subscribe, getSnapshot) {
  	  return getSnapshot();
  	}
  	var shim =
  	  "undefined" === typeof window ||
  	  "undefined" === typeof window.document ||
  	  "undefined" === typeof window.document.createElement
  	    ? useSyncExternalStore$1
  	    : useSyncExternalStore$2;
  	useSyncExternalStoreShim_production.useSyncExternalStore =
  	  void 0 !== React$1.useSyncExternalStore ? React$1.useSyncExternalStore : shim;
  	return useSyncExternalStoreShim_production;
  }

  var hasRequiredShim;

  function requireShim () {
  	if (hasRequiredShim) return shim.exports;
  	hasRequiredShim = 1;

  	{
  	  shim.exports = requireUseSyncExternalStoreShim_production();
  	}
  	return shim.exports;
  }

  requireShim();

  var withSelector = {exports: {}};

  var withSelector_production = {};

  /**
   * @license React
   * use-sync-external-store-shim/with-selector.production.js
   *
   * Copyright (c) Meta Platforms, Inc. and affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredWithSelector_production;

  function requireWithSelector_production () {
  	if (hasRequiredWithSelector_production) return withSelector_production;
  	hasRequiredWithSelector_production = 1;
  	var React$1 = React,
  	  shim = requireShim();
  	function is(x, y) {
  	  return (x === y && (0 !== x || 1 / x === 1 / y)) || (x !== x && y !== y);
  	}
  	var objectIs = "function" === typeof Object.is ? Object.is : is,
  	  useSyncExternalStore = shim.useSyncExternalStore,
  	  useRef = React$1.useRef,
  	  useEffect = React$1.useEffect,
  	  useMemo = React$1.useMemo,
  	  useDebugValue = React$1.useDebugValue;
  	withSelector_production.useSyncExternalStoreWithSelector = function (
  	  subscribe,
  	  getSnapshot,
  	  getServerSnapshot,
  	  selector,
  	  isEqual
  	) {
  	  var instRef = useRef(null);
  	  if (null === instRef.current) {
  	    var inst = { hasValue: false, value: null };
  	    instRef.current = inst;
  	  } else inst = instRef.current;
  	  instRef = useMemo(
  	    function () {
  	      function memoizedSelector(nextSnapshot) {
  	        if (!hasMemo) {
  	          hasMemo = true;
  	          memoizedSnapshot = nextSnapshot;
  	          nextSnapshot = selector(nextSnapshot);
  	          if (void 0 !== isEqual && inst.hasValue) {
  	            var currentSelection = inst.value;
  	            if (isEqual(currentSelection, nextSnapshot))
  	              return (memoizedSelection = currentSelection);
  	          }
  	          return (memoizedSelection = nextSnapshot);
  	        }
  	        currentSelection = memoizedSelection;
  	        if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
  	        var nextSelection = selector(nextSnapshot);
  	        if (void 0 !== isEqual && isEqual(currentSelection, nextSelection))
  	          return (memoizedSnapshot = nextSnapshot), currentSelection;
  	        memoizedSnapshot = nextSnapshot;
  	        return (memoizedSelection = nextSelection);
  	      }
  	      var hasMemo = false,
  	        memoizedSnapshot,
  	        memoizedSelection,
  	        maybeGetServerSnapshot =
  	          void 0 === getServerSnapshot ? null : getServerSnapshot;
  	      return [
  	        function () {
  	          return memoizedSelector(getSnapshot());
  	        },
  	        null === maybeGetServerSnapshot
  	          ? void 0
  	          : function () {
  	              return memoizedSelector(maybeGetServerSnapshot());
  	            }
  	      ];
  	    },
  	    [getSnapshot, getServerSnapshot, selector, isEqual]
  	  );
  	  var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
  	  useEffect(
  	    function () {
  	      inst.hasValue = true;
  	      inst.value = value;
  	    },
  	    [value]
  	  );
  	  useDebugValue(value);
  	  return value;
  	};
  	return withSelector_production;
  }

  var hasRequiredWithSelector;

  function requireWithSelector () {
  	if (hasRequiredWithSelector) return withSelector.exports;
  	hasRequiredWithSelector = 1;

  	{
  	  withSelector.exports = requireWithSelector_production();
  	}
  	return withSelector.exports;
  }

  var withSelectorExports = requireWithSelector();

  const ContextKey = Symbol.for(`react-redux-context`);
  const gT = typeof globalThis !== "undefined" ? globalThis :
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {};

  function getContext() {
    var _gT$ContextKey;

    if (!React__namespace.createContext) return {};
    const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
    let realContext = contextMap.get(React__namespace.createContext);

    if (!realContext) {
      realContext = React__namespace.createContext(null);

      contextMap.set(React__namespace.createContext, realContext);
    }

    return realContext;
  }

  const ReactReduxContext = /*#__PURE__*/getContext();

  /**
   * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
   * hook that you should usually not need to call directly.
   *
   * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
   * @returns {Function} A `useReduxContext` hook bound to the specified context.
   */
  function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext() {
      const contextValue = React.useContext(context);

      return contextValue;
    };
  }
  /**
   * A hook to access the value of the `ReactReduxContext`. This is a low-level
   * hook that you should usually not need to call directly.
   *
   * @returns {any} the value of the `ReactReduxContext`
   *
   * @example
   *
   * import React from 'react'
   * import { useReduxContext } from 'react-redux'
   *
   * export const CounterComponent = () => {
   *   const { store } = useReduxContext()
   *   return <div>{store.getState()}</div>
   * }
   */

  const useReduxContext = /*#__PURE__*/createReduxContextHook();

  const notInitialized = () => {
    throw new Error('uSES not initialized!');
  };

  let useSyncExternalStoreWithSelector = notInitialized;
  const initializeUseSelector = fn => {
    useSyncExternalStoreWithSelector = fn;
  };

  const refEquality = (a, b) => a === b;
  /**
   * Hook factory, which creates a `useSelector` hook bound to a given context.
   *
   * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
   * @returns {Function} A `useSelector` hook bound to the specified context.
   */


  function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext$1 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
      const {
        equalityFn = refEquality,
        stabilityCheck = undefined,
        noopCheck = undefined
      } = typeof equalityFnOrOptions === 'function' ? {
        equalityFn: equalityFnOrOptions
      } : equalityFnOrOptions;

      const {
        store,
        subscription,
        getServerState,
        stabilityCheck: globalStabilityCheck,
        noopCheck: globalNoopCheck
      } = useReduxContext$1();
      React.useRef(true);
      const wrappedSelector = React.useCallback({
        [selector.name](state) {
          const selected = selector(state);

          return selected;
        }

      }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
      const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
      React.useDebugValue(selectedState);
      return selectedState;
    };
  }
  /**
   * A hook to access the redux store's state. This hook takes a selector function
   * as an argument. The selector is called with the store state.
   *
   * This hook takes an optional equality comparison function as the second parameter
   * that allows you to customize the way the selected state is compared to determine
   * whether the component needs to be re-rendered.
   *
   * @param {Function} selector the selector function
   * @param {Function=} equalityFn the function that will be used to determine equality
   *
   * @returns {any} the selected state
   *
   * @example
   *
   * import React from 'react'
   * import { useSelector } from 'react-redux'
   *
   * export const CounterComponent = () => {
   *   const counter = useSelector(state => state.counter)
   *   return <div>{counter}</div>
   * }
   */

  const useSelector = /*#__PURE__*/createSelectorHook();

  var reactIs = {exports: {}};

  var reactIs_production_min = {};

  /**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var hasRequiredReactIs_production_min;

  function requireReactIs_production_min () {
  	if (hasRequiredReactIs_production_min) return reactIs_production_min;
  	hasRequiredReactIs_production_min = 1;
  var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
  	function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=g;reactIs_production_min.Element=b;reactIs_production_min.ForwardRef=l;reactIs_production_min.Fragment=d;reactIs_production_min.Lazy=q;reactIs_production_min.Memo=p;reactIs_production_min.Portal=c;reactIs_production_min.Profiler=f;reactIs_production_min.StrictMode=e;reactIs_production_min.Suspense=m;
  	reactIs_production_min.SuspenseList=n;reactIs_production_min.isAsyncMode=function(){return  false};reactIs_production_min.isConcurrentMode=function(){return  false};reactIs_production_min.isContextConsumer=function(a){return v(a)===h};reactIs_production_min.isContextProvider=function(a){return v(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return v(a)===l};reactIs_production_min.isFragment=function(a){return v(a)===d};reactIs_production_min.isLazy=function(a){return v(a)===q};reactIs_production_min.isMemo=function(a){return v(a)===p};
  	reactIs_production_min.isPortal=function(a){return v(a)===c};reactIs_production_min.isProfiler=function(a){return v(a)===f};reactIs_production_min.isStrictMode=function(a){return v(a)===e};reactIs_production_min.isSuspense=function(a){return v(a)===m};reactIs_production_min.isSuspenseList=function(a){return v(a)===n};
  	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?true:false};reactIs_production_min.typeOf=v;
  	return reactIs_production_min;
  }

  var hasRequiredReactIs;

  function requireReactIs () {
  	if (hasRequiredReactIs) return reactIs.exports;
  	hasRequiredReactIs = 1;

  	{
  	  reactIs.exports = requireReactIs_production_min();
  	}
  	return reactIs.exports;
  }

  requireReactIs();

  /**
   * Hook factory, which creates a `useStore` hook bound to a given context.
   *
   * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
   * @returns {Function} A `useStore` hook bound to the specified context.
   */

  function createStoreHook(context = ReactReduxContext) {
    const useReduxContext$1 = // @ts-ignore
    context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    return function useStore() {
      const {
        store
      } = useReduxContext$1(); // @ts-ignore

      return store;
    };
  }
  /**
   * A hook to access the redux store.
   *
   * @returns {any} the redux store
   *
   * @example
   *
   * import React from 'react'
   * import { useStore } from 'react-redux'
   *
   * export const ExampleComponent = () => {
   *   const store = useStore()
   *   return <div>{store.getState()}</div>
   * }
   */

  const useStore = /*#__PURE__*/createStoreHook();

  /**
   * Hook factory, which creates a `useDispatch` hook bound to a given context.
   *
   * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
   * @returns {Function} A `useDispatch` hook bound to the specified context.
   */

  function createDispatchHook(context = ReactReduxContext) {
    const useStore$1 = // @ts-ignore
    context === ReactReduxContext ? useStore : createStoreHook(context);
    return function useDispatch() {
      const store = useStore$1(); // @ts-ignore

      return store.dispatch;
    };
  }
  /**
   * A hook to access the redux `dispatch` function.
   *
   * @returns {any|function} redux store's `dispatch` function
   *
   * @example
   *
   * import React, { useCallback } from 'react'
   * import { useDispatch } from 'react-redux'
   *
   * export const CounterComponent = ({ value }) => {
   *   const dispatch = useDispatch()
   *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
   *   return (
   *     <div>
   *       <span>{value}</span>
   *       <button onClick={increaseCounter}>Increase counter</button>
   *     </div>
   *   )
   * }
   */

  const useDispatch = /*#__PURE__*/createDispatchHook();

  // The primary entry point assumes we're working with standard ReactDOM/RN, but
  // older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
  // Because of that, the useSyncExternalStore compat shim is needed.
  initializeUseSelector(withSelectorExports.useSyncExternalStoreWithSelector);

  function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }

  // ../../../react-shim.js
  var ColorModeContext = React.createContext({});
  ColorModeContext.displayName = "ColorModeContext";
  function useColorMode() {
    const context = React.useContext(ColorModeContext);
    if (context === void 0) {
      throw new Error("useColorMode must be used within a ColorModeProvider");
    }
    return context;
  }

  // ../../utilities/shared-utils/src/index.ts
  function isObject(value) {
    const type = typeof value;
    return value != null && (type === "object" || type === "function") && !Array.isArray(value);
  }
  function runIfFn$1(valueOrFn, ...args) {
    return isFunction$1(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }
  var isFunction$1 = (value) => typeof value === "function";

  // src/utils/create-transform.ts
  var isImportant = (value) => /!(important)?$/.test(value);
  var withoutImportant = (value) => typeof value === "string" ? value.replace(/!(important)?$/, "").trim() : value;
  var tokenToCSSVar = (scale, value) => (theme) => {
    const valueStr = String(value);
    const important = isImportant(valueStr);
    const valueWithoutImportant = withoutImportant(valueStr);
    const key = scale ? `${scale}.${valueWithoutImportant}` : valueWithoutImportant;
    let transformed = isObject(theme.__cssMap) && key in theme.__cssMap ? theme.__cssMap[key].varRef : value;
    transformed = withoutImportant(transformed);
    return important ? `${transformed} !important` : transformed;
  };
  function createTransform(options) {
    const { scale, transform: transform2, compose } = options;
    const fn = (value, theme) => {
      const _value = tokenToCSSVar(scale, value)(theme);
      let result = (transform2 == null ? void 0 : transform2(_value, theme)) ?? _value;
      if (compose) {
        result = compose(result, theme);
      }
      return result;
    };
    return fn;
  }

  // src/utils/pipe.ts
  var pipe = (...fns) => (v) => fns.reduce((a, b) => b(a), v);

  // src/utils/prop-config.ts
  function toConfig(scale, transform2) {
    return (property) => {
      const result = { property, scale };
      result.transform = createTransform({
        scale,
        transform: transform2
      });
      return result;
    };
  }
  var getRtl = ({ rtl, ltr }) => (theme) => theme.direction === "rtl" ? rtl : ltr;
  function logical(options) {
    const { property, scale, transform: transform2 } = options;
    return {
      scale,
      property: getRtl(property),
      transform: scale ? createTransform({
        scale,
        compose: transform2
      }) : transform2
    };
  }

  // src/utils/templates.ts
  var transformTemplate = [
    "rotate(var(--chakra-rotate, 0))",
    "scaleX(var(--chakra-scale-x, 1))",
    "scaleY(var(--chakra-scale-y, 1))",
    "skewX(var(--chakra-skew-x, 0))",
    "skewY(var(--chakra-skew-y, 0))"
  ];
  function getTransformTemplate() {
    return [
      "translateX(var(--chakra-translate-x, 0))",
      "translateY(var(--chakra-translate-y, 0))",
      ...transformTemplate
    ].join(" ");
  }
  function getTransformGpuTemplate() {
    return [
      "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
      ...transformTemplate
    ].join(" ");
  }
  var filterTemplate = {
    "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
    filter: [
      "var(--chakra-blur)",
      "var(--chakra-brightness)",
      "var(--chakra-contrast)",
      "var(--chakra-grayscale)",
      "var(--chakra-hue-rotate)",
      "var(--chakra-invert)",
      "var(--chakra-saturate)",
      "var(--chakra-sepia)",
      "var(--chakra-drop-shadow)"
    ].join(" ")
  };
  var backdropFilterTemplate = {
    backdropFilter: [
      "var(--chakra-backdrop-blur)",
      "var(--chakra-backdrop-brightness)",
      "var(--chakra-backdrop-contrast)",
      "var(--chakra-backdrop-grayscale)",
      "var(--chakra-backdrop-hue-rotate)",
      "var(--chakra-backdrop-invert)",
      "var(--chakra-backdrop-opacity)",
      "var(--chakra-backdrop-saturate)",
      "var(--chakra-backdrop-sepia)"
    ].join(" "),
    "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
    "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
  };
  function getRingTemplate(value) {
    return {
      "--chakra-ring-offset-shadow": `var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)`,
      "--chakra-ring-shadow": `var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)`,
      "--chakra-ring-width": value,
      boxShadow: [
        `var(--chakra-ring-offset-shadow)`,
        `var(--chakra-ring-shadow)`,
        `var(--chakra-shadow, 0 0 #0000)`
      ].join(", ")
    };
  }
  var flexDirectionTemplate = {
    "row-reverse": {
      space: "--chakra-space-x-reverse",
      divide: "--chakra-divide-x-reverse"
    },
    "column-reverse": {
      space: "--chakra-space-y-reverse",
      divide: "--chakra-divide-y-reverse"
    }
  };
  var owlSelector = "& > :not(style) ~ :not(style)";
  var spaceXTemplate = {
    [owlSelector]: {
      marginInlineStart: "calc(var(--chakra-space-x) * calc(1 - var(--chakra-space-x-reverse)))",
      marginInlineEnd: "calc(var(--chakra-space-x) * var(--chakra-space-x-reverse))"
    }
  };
  var spaceYTemplate = {
    [owlSelector]: {
      marginTop: "calc(var(--chakra-space-y) * calc(1 - var(--chakra-space-y-reverse)))",
      marginBottom: "calc(var(--chakra-space-y) * var(--chakra-space-y-reverse))"
    }
  };

  // src/utils/parse-gradient.ts
  var directionMap = {
    "to-t": "to top",
    "to-tr": "to top right",
    "to-r": "to right",
    "to-br": "to bottom right",
    "to-b": "to bottom",
    "to-bl": "to bottom left",
    "to-l": "to left",
    "to-tl": "to top left"
  };
  var valueSet = new Set(Object.values(directionMap));
  var globalSet = /* @__PURE__ */ new Set([
    "none",
    "-moz-initial",
    "inherit",
    "initial",
    "revert",
    "unset"
  ]);
  var trimSpace = (str) => str.trim();
  function parseGradient(value, theme) {
    var _a;
    if (value == null || globalSet.has(value))
      return value;
    const regex = /(?<type>^[a-z-A-Z]+)\((?<values>(.*))\)/g;
    const { type, values } = ((_a = regex.exec(value)) == null ? void 0 : _a.groups) ?? {};
    if (!type || !values)
      return value;
    const _type = type.includes("-gradient") ? type : `${type}-gradient`;
    const [maybeDirection, ...stops] = values.split(",").map(trimSpace).filter(Boolean);
    if ((stops == null ? void 0 : stops.length) === 0)
      return value;
    const direction = maybeDirection in directionMap ? directionMap[maybeDirection] : maybeDirection;
    stops.unshift(direction);
    const _values = stops.map((stop) => {
      if (valueSet.has(stop))
        return stop;
      const firstStop = stop.indexOf(" ");
      const [_color, _stop] = firstStop !== -1 ? [stop.substr(0, firstStop), stop.substr(firstStop + 1)] : [stop];
      const _stopOrFunc = isCSSFunction(_stop) ? _stop : _stop && _stop.split(" ");
      const key = `colors.${_color}`;
      const color2 = key in theme.__cssMap ? theme.__cssMap[key].varRef : _color;
      return _stopOrFunc ? [
        color2,
        ...Array.isArray(_stopOrFunc) ? _stopOrFunc : [_stopOrFunc]
      ].join(" ") : color2;
    });
    return `${_type}(${_values.join(", ")})`;
  }
  var isCSSFunction = (value) => {
    return typeof value === "string" && value.includes("(") && value.includes(")");
  };
  var gradientTransform = (value, theme) => parseGradient(value, theme ?? {});

  // src/utils/transform-functions.ts
  function isCssVar(value) {
    return /^var\(--.+\)$/.test(value);
  }
  var analyzeCSSValue = (value) => {
    const num = parseFloat(value.toString());
    const unit = value.toString().replace(String(num), "");
    return { unitless: !unit, value: num, unit };
  };
  var wrap = (str) => (value) => `${str}(${value})`;
  var transformFunctions = {
    filter(value) {
      return value !== "auto" ? value : filterTemplate;
    },
    backdropFilter(value) {
      return value !== "auto" ? value : backdropFilterTemplate;
    },
    ring(value) {
      return getRingTemplate(transformFunctions.px(value));
    },
    bgClip(value) {
      return value === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: value };
    },
    transform(value) {
      if (value === "auto")
        return getTransformTemplate();
      if (value === "auto-gpu")
        return getTransformGpuTemplate();
      return value;
    },
    vh(value) {
      return value === "$100vh" ? "var(--chakra-vh)" : value;
    },
    px(value) {
      if (value == null)
        return value;
      const { unitless } = analyzeCSSValue(value);
      return unitless || typeof value === "number" ? `${value}px` : value;
    },
    fraction(value) {
      return !(typeof value === "number") || value > 1 ? value : `${value * 100}%`;
    },
    float(value, theme) {
      const map = { left: "right", right: "left" };
      return theme.direction === "rtl" ? map[value] : value;
    },
    degree(value) {
      if (isCssVar(value) || value == null)
        return value;
      const unitless = typeof value === "string" && !value.endsWith("deg");
      return typeof value === "number" || unitless ? `${value}deg` : value;
    },
    gradient: gradientTransform,
    blur: wrap("blur"),
    opacity: wrap("opacity"),
    brightness: wrap("brightness"),
    contrast: wrap("contrast"),
    dropShadow: wrap("drop-shadow"),
    grayscale: wrap("grayscale"),
    hueRotate: wrap("hue-rotate"),
    invert: wrap("invert"),
    saturate: wrap("saturate"),
    sepia: wrap("sepia"),
    bgImage(value) {
      if (value == null)
        return value;
      const prevent = isCSSFunction(value) || globalSet.has(value);
      return !prevent ? `url(${value})` : value;
    },
    outline(value) {
      const isNoneOrZero = String(value) === "0" || String(value) === "none";
      return value !== null && isNoneOrZero ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: value };
    },
    flexDirection(value) {
      const { space: space2, divide: divide2 } = flexDirectionTemplate[value] ?? {};
      const result = { flexDirection: value };
      if (space2)
        result[space2] = 1;
      if (divide2)
        result[divide2] = 1;
      return result;
    }
  };

  // src/utils/index.ts
  var t = {
    borderWidths: toConfig("borderWidths"),
    borderStyles: toConfig("borderStyles"),
    colors: toConfig("colors"),
    borders: toConfig("borders"),
    radii: toConfig("radii", transformFunctions.px),
    space: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
    spaceT: toConfig("space", pipe(transformFunctions.vh, transformFunctions.px)),
    degreeT(property) {
      return { property, transform: transformFunctions.degree };
    },
    prop(property, scale, transform2) {
      return {
        property,
        scale,
        ...scale && {
          transform: createTransform({ scale, transform: transform2 })
        }
      };
    },
    propT(property, transform2) {
      return { property, transform: transform2 };
    },
    sizes: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.px)),
    sizesT: toConfig("sizes", pipe(transformFunctions.vh, transformFunctions.fraction)),
    shadows: toConfig("shadows"),
    logical,
    blur: toConfig("blur", transformFunctions.blur)
  };

  // src/config/background.ts
  var background = {
    background: t.colors("background"),
    backgroundColor: t.colors("backgroundColor"),
    backgroundImage: t.propT("backgroundImage", transformFunctions.bgImage),
    backgroundSize: true,
    backgroundPosition: true,
    backgroundRepeat: true,
    backgroundAttachment: true,
    backgroundClip: { transform: transformFunctions.bgClip },
    bgSize: t.prop("backgroundSize"),
    bgPosition: t.prop("backgroundPosition"),
    bg: t.colors("background"),
    bgColor: t.colors("backgroundColor"),
    bgPos: t.prop("backgroundPosition"),
    bgRepeat: t.prop("backgroundRepeat"),
    bgAttachment: t.prop("backgroundAttachment"),
    bgGradient: t.propT("backgroundImage", transformFunctions.gradient),
    bgClip: { transform: transformFunctions.bgClip }
  };
  Object.assign(background, {
    bgImage: background.backgroundImage,
    bgImg: background.backgroundImage
  });

  // src/config/border.ts
  var border = {
    border: t.borders("border"),
    borderWidth: t.borderWidths("borderWidth"),
    borderStyle: t.borderStyles("borderStyle"),
    borderColor: t.colors("borderColor"),
    borderRadius: t.radii("borderRadius"),
    borderTop: t.borders("borderTop"),
    borderBlockStart: t.borders("borderBlockStart"),
    borderTopLeftRadius: t.radii("borderTopLeftRadius"),
    borderStartStartRadius: t.logical({
      scale: "radii",
      property: {
        ltr: "borderTopLeftRadius",
        rtl: "borderTopRightRadius"
      }
    }),
    borderEndStartRadius: t.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomLeftRadius",
        rtl: "borderBottomRightRadius"
      }
    }),
    borderTopRightRadius: t.radii("borderTopRightRadius"),
    borderStartEndRadius: t.logical({
      scale: "radii",
      property: {
        ltr: "borderTopRightRadius",
        rtl: "borderTopLeftRadius"
      }
    }),
    borderEndEndRadius: t.logical({
      scale: "radii",
      property: {
        ltr: "borderBottomRightRadius",
        rtl: "borderBottomLeftRadius"
      }
    }),
    borderRight: t.borders("borderRight"),
    borderInlineEnd: t.borders("borderInlineEnd"),
    borderBottom: t.borders("borderBottom"),
    borderBlockEnd: t.borders("borderBlockEnd"),
    borderBottomLeftRadius: t.radii("borderBottomLeftRadius"),
    borderBottomRightRadius: t.radii("borderBottomRightRadius"),
    borderLeft: t.borders("borderLeft"),
    borderInlineStart: {
      property: "borderInlineStart",
      scale: "borders"
    },
    borderInlineStartRadius: t.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
        rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
      }
    }),
    borderInlineEndRadius: t.logical({
      scale: "radii",
      property: {
        ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
        rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
      }
    }),
    borderX: t.borders(["borderLeft", "borderRight"]),
    borderInline: t.borders("borderInline"),
    borderY: t.borders(["borderTop", "borderBottom"]),
    borderBlock: t.borders("borderBlock"),
    borderTopWidth: t.borderWidths("borderTopWidth"),
    borderBlockStartWidth: t.borderWidths("borderBlockStartWidth"),
    borderTopColor: t.colors("borderTopColor"),
    borderBlockStartColor: t.colors("borderBlockStartColor"),
    borderTopStyle: t.borderStyles("borderTopStyle"),
    borderBlockStartStyle: t.borderStyles("borderBlockStartStyle"),
    borderBottomWidth: t.borderWidths("borderBottomWidth"),
    borderBlockEndWidth: t.borderWidths("borderBlockEndWidth"),
    borderBottomColor: t.colors("borderBottomColor"),
    borderBlockEndColor: t.colors("borderBlockEndColor"),
    borderBottomStyle: t.borderStyles("borderBottomStyle"),
    borderBlockEndStyle: t.borderStyles("borderBlockEndStyle"),
    borderLeftWidth: t.borderWidths("borderLeftWidth"),
    borderInlineStartWidth: t.borderWidths("borderInlineStartWidth"),
    borderLeftColor: t.colors("borderLeftColor"),
    borderInlineStartColor: t.colors("borderInlineStartColor"),
    borderLeftStyle: t.borderStyles("borderLeftStyle"),
    borderInlineStartStyle: t.borderStyles("borderInlineStartStyle"),
    borderRightWidth: t.borderWidths("borderRightWidth"),
    borderInlineEndWidth: t.borderWidths("borderInlineEndWidth"),
    borderRightColor: t.colors("borderRightColor"),
    borderInlineEndColor: t.colors("borderInlineEndColor"),
    borderRightStyle: t.borderStyles("borderRightStyle"),
    borderInlineEndStyle: t.borderStyles("borderInlineEndStyle"),
    borderTopRadius: t.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
    borderBottomRadius: t.radii([
      "borderBottomLeftRadius",
      "borderBottomRightRadius"
    ]),
    borderLeftRadius: t.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
    borderRightRadius: t.radii([
      "borderTopRightRadius",
      "borderBottomRightRadius"
    ])
  };
  Object.assign(border, {
    rounded: border.borderRadius,
    roundedTop: border.borderTopRadius,
    roundedTopLeft: border.borderTopLeftRadius,
    roundedTopRight: border.borderTopRightRadius,
    roundedTopStart: border.borderStartStartRadius,
    roundedTopEnd: border.borderStartEndRadius,
    roundedBottom: border.borderBottomRadius,
    roundedBottomLeft: border.borderBottomLeftRadius,
    roundedBottomRight: border.borderBottomRightRadius,
    roundedBottomStart: border.borderEndStartRadius,
    roundedBottomEnd: border.borderEndEndRadius,
    roundedLeft: border.borderLeftRadius,
    roundedRight: border.borderRightRadius,
    roundedStart: border.borderInlineStartRadius,
    roundedEnd: border.borderInlineEndRadius,
    borderStart: border.borderInlineStart,
    borderEnd: border.borderInlineEnd,
    borderTopStartRadius: border.borderStartStartRadius,
    borderTopEndRadius: border.borderStartEndRadius,
    borderBottomStartRadius: border.borderEndStartRadius,
    borderBottomEndRadius: border.borderEndEndRadius,
    borderStartRadius: border.borderInlineStartRadius,
    borderEndRadius: border.borderInlineEndRadius,
    borderStartWidth: border.borderInlineStartWidth,
    borderEndWidth: border.borderInlineEndWidth,
    borderStartColor: border.borderInlineStartColor,
    borderEndColor: border.borderInlineEndColor,
    borderStartStyle: border.borderInlineStartStyle,
    borderEndStyle: border.borderInlineEndStyle
  });

  // src/config/color.ts
  var color = {
    color: t.colors("color"),
    textColor: t.colors("color"),
    fill: t.colors("fill"),
    stroke: t.colors("stroke")
  };

  // src/config/effect.ts
  var effect = {
    boxShadow: t.shadows("boxShadow"),
    mixBlendMode: true,
    blendMode: t.prop("mixBlendMode"),
    backgroundBlendMode: true,
    bgBlendMode: t.prop("backgroundBlendMode"),
    opacity: true
  };
  Object.assign(effect, {
    shadow: effect.boxShadow
  });

  // src/config/filter.ts
  var filter = {
    filter: { transform: transformFunctions.filter },
    blur: t.blur("--chakra-blur"),
    brightness: t.propT("--chakra-brightness", transformFunctions.brightness),
    contrast: t.propT("--chakra-contrast", transformFunctions.contrast),
    hueRotate: t.degreeT("--chakra-hue-rotate"),
    invert: t.propT("--chakra-invert", transformFunctions.invert),
    saturate: t.propT("--chakra-saturate", transformFunctions.saturate),
    dropShadow: t.propT("--chakra-drop-shadow", transformFunctions.dropShadow),
    backdropFilter: { transform: transformFunctions.backdropFilter },
    backdropBlur: t.blur("--chakra-backdrop-blur"),
    backdropBrightness: t.propT("--chakra-backdrop-brightness", transformFunctions.brightness),
    backdropContrast: t.propT("--chakra-backdrop-contrast", transformFunctions.contrast),
    backdropHueRotate: t.degreeT("--chakra-backdrop-hue-rotate"),
    backdropInvert: t.propT("--chakra-backdrop-invert", transformFunctions.invert),
    backdropSaturate: t.propT("--chakra-backdrop-saturate", transformFunctions.saturate)
  };

  // src/config/flexbox.ts
  var flexbox = {
    alignItems: true,
    alignContent: true,
    justifyItems: true,
    justifyContent: true,
    flexWrap: true,
    flexDirection: { transform: transformFunctions.flexDirection },
    experimental_spaceX: {
      static: spaceXTemplate,
      transform: createTransform({
        scale: "space",
        transform: (value) => value !== null ? { "--chakra-space-x": value } : null
      })
    },
    experimental_spaceY: {
      static: spaceYTemplate,
      transform: createTransform({
        scale: "space",
        transform: (value) => value != null ? { "--chakra-space-y": value } : null
      })
    },
    flex: true,
    flexFlow: true,
    flexGrow: true,
    flexShrink: true,
    flexBasis: t.sizes("flexBasis"),
    justifySelf: true,
    alignSelf: true,
    order: true,
    placeItems: true,
    placeContent: true,
    placeSelf: true,
    gap: t.space("gap"),
    rowGap: t.space("rowGap"),
    columnGap: t.space("columnGap")
  };
  Object.assign(flexbox, {
    flexDir: flexbox.flexDirection
  });

  // src/config/grid.ts
  var grid = {
    gridGap: t.space("gridGap"),
    gridColumnGap: t.space("gridColumnGap"),
    gridRowGap: t.space("gridRowGap"),
    gridColumn: true,
    gridRow: true,
    gridAutoFlow: true,
    gridAutoColumns: true,
    gridColumnStart: true,
    gridColumnEnd: true,
    gridRowStart: true,
    gridRowEnd: true,
    gridAutoRows: true,
    gridTemplate: true,
    gridTemplateColumns: true,
    gridTemplateRows: true,
    gridTemplateAreas: true,
    gridArea: true
  };

  // src/config/interactivity.ts
  var interactivity = {
    appearance: true,
    cursor: true,
    resize: true,
    userSelect: true,
    pointerEvents: true,
    outline: { transform: transformFunctions.outline },
    outlineOffset: true,
    outlineColor: t.colors("outlineColor")
  };

  // src/config/layout.ts
  var layout = {
    width: t.sizesT("width"),
    inlineSize: t.sizesT("inlineSize"),
    height: t.sizes("height"),
    blockSize: t.sizes("blockSize"),
    boxSize: t.sizes(["width", "height"]),
    minWidth: t.sizes("minWidth"),
    minInlineSize: t.sizes("minInlineSize"),
    minHeight: t.sizes("minHeight"),
    minBlockSize: t.sizes("minBlockSize"),
    maxWidth: t.sizes("maxWidth"),
    maxInlineSize: t.sizes("maxInlineSize"),
    maxHeight: t.sizes("maxHeight"),
    maxBlockSize: t.sizes("maxBlockSize"),
    overflow: true,
    overflowX: true,
    overflowY: true,
    overscrollBehavior: true,
    overscrollBehaviorX: true,
    overscrollBehaviorY: true,
    display: true,
    verticalAlign: true,
    boxSizing: true,
    boxDecorationBreak: true,
    float: t.propT("float", transformFunctions.float),
    objectFit: true,
    objectPosition: true,
    visibility: true,
    isolation: true
  };
  Object.assign(layout, {
    w: layout.width,
    h: layout.height,
    minW: layout.minWidth,
    maxW: layout.maxWidth,
    minH: layout.minHeight,
    maxH: layout.maxHeight,
    overscroll: layout.overscrollBehavior,
    overscrollX: layout.overscrollBehaviorX,
    overscrollY: layout.overscrollBehaviorY
  });

  // src/config/list.ts
  var list = {
    listStyleType: true,
    listStylePosition: true,
    listStylePos: t.prop("listStylePosition"),
    listStyleImage: true,
    listStyleImg: t.prop("listStyleImage")
  };

  // src/get.ts
  function get(obj, path, fallback, index) {
    const key = typeof path === "string" ? path.split(".") : [path];
    for (index = 0; index < key.length; index += 1) {
      if (!obj)
        break;
      obj = obj[key[index]];
    }
    return obj === void 0 ? fallback : obj;
  }
  var memoize = (fn) => {
    const cache = /* @__PURE__ */ new WeakMap();
    const memoizedFn = (obj, path, fallback, index) => {
      if (typeof obj === "undefined") {
        return fn(obj, path, fallback);
      }
      if (!cache.has(obj)) {
        cache.set(obj, /* @__PURE__ */ new Map());
      }
      const map = cache.get(obj);
      if (map.has(path)) {
        return map.get(path);
      }
      const value = fn(obj, path, fallback, index);
      map.set(path, value);
      return value;
    };
    return memoizedFn;
  };
  var memoizedGet = memoize(get);

  // src/config/others.ts
  var srOnly = {
    border: "0px",
    clip: "rect(0, 0, 0, 0)",
    width: "1px",
    height: "1px",
    margin: "-1px",
    padding: "0px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    position: "absolute"
  };
  var srFocusable = {
    position: "static",
    width: "auto",
    height: "auto",
    clip: "auto",
    padding: "0",
    margin: "0",
    overflow: "visible",
    whiteSpace: "normal"
  };
  var getWithPriority = (theme, key, styles) => {
    const result = {};
    const obj = memoizedGet(theme, key, {});
    for (const prop in obj) {
      const isInStyles = prop in styles && styles[prop] != null;
      if (!isInStyles)
        result[prop] = obj[prop];
    }
    return result;
  };
  var others = {
    srOnly: {
      transform(value) {
        if (value === true)
          return srOnly;
        if (value === "focusable")
          return srFocusable;
        return {};
      }
    },
    layerStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, `layerStyles.${value}`, styles)
    },
    textStyle: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, `textStyles.${value}`, styles)
    },
    apply: {
      processResult: true,
      transform: (value, theme, styles) => getWithPriority(theme, value, styles)
    }
  };

  // src/config/position.ts
  var position = {
    position: true,
    pos: t.prop("position"),
    zIndex: t.prop("zIndex", "zIndices"),
    inset: t.spaceT("inset"),
    insetX: t.spaceT(["left", "right"]),
    insetInline: t.spaceT("insetInline"),
    insetY: t.spaceT(["top", "bottom"]),
    insetBlock: t.spaceT("insetBlock"),
    top: t.spaceT("top"),
    insetBlockStart: t.spaceT("insetBlockStart"),
    bottom: t.spaceT("bottom"),
    insetBlockEnd: t.spaceT("insetBlockEnd"),
    left: t.spaceT("left"),
    insetInlineStart: t.logical({
      scale: "space",
      property: { ltr: "left", rtl: "right" }
    }),
    right: t.spaceT("right"),
    insetInlineEnd: t.logical({
      scale: "space",
      property: { ltr: "right", rtl: "left" }
    })
  };
  Object.assign(position, {
    insetStart: position.insetInlineStart,
    insetEnd: position.insetInlineEnd
  });

  // src/config/ring.ts
  var ring = {
    ring: { transform: transformFunctions.ring },
    ringColor: t.colors("--chakra-ring-color"),
    ringOffset: t.prop("--chakra-ring-offset-width"),
    ringOffsetColor: t.colors("--chakra-ring-offset-color"),
    ringInset: t.prop("--chakra-ring-inset")
  };

  // src/config/space.ts
  var space = {
    margin: t.spaceT("margin"),
    marginTop: t.spaceT("marginTop"),
    marginBlockStart: t.spaceT("marginBlockStart"),
    marginRight: t.spaceT("marginRight"),
    marginInlineEnd: t.spaceT("marginInlineEnd"),
    marginBottom: t.spaceT("marginBottom"),
    marginBlockEnd: t.spaceT("marginBlockEnd"),
    marginLeft: t.spaceT("marginLeft"),
    marginInlineStart: t.spaceT("marginInlineStart"),
    marginX: t.spaceT(["marginInlineStart", "marginInlineEnd"]),
    marginInline: t.spaceT("marginInline"),
    marginY: t.spaceT(["marginTop", "marginBottom"]),
    marginBlock: t.spaceT("marginBlock"),
    padding: t.space("padding"),
    paddingTop: t.space("paddingTop"),
    paddingBlockStart: t.space("paddingBlockStart"),
    paddingRight: t.space("paddingRight"),
    paddingBottom: t.space("paddingBottom"),
    paddingBlockEnd: t.space("paddingBlockEnd"),
    paddingLeft: t.space("paddingLeft"),
    paddingInlineStart: t.space("paddingInlineStart"),
    paddingInlineEnd: t.space("paddingInlineEnd"),
    paddingX: t.space(["paddingInlineStart", "paddingInlineEnd"]),
    paddingInline: t.space("paddingInline"),
    paddingY: t.space(["paddingTop", "paddingBottom"]),
    paddingBlock: t.space("paddingBlock")
  };
  Object.assign(space, {
    m: space.margin,
    mt: space.marginTop,
    mr: space.marginRight,
    me: space.marginInlineEnd,
    marginEnd: space.marginInlineEnd,
    mb: space.marginBottom,
    ml: space.marginLeft,
    ms: space.marginInlineStart,
    marginStart: space.marginInlineStart,
    mx: space.marginX,
    my: space.marginY,
    p: space.padding,
    pt: space.paddingTop,
    py: space.paddingY,
    px: space.paddingX,
    pb: space.paddingBottom,
    pl: space.paddingLeft,
    ps: space.paddingInlineStart,
    paddingStart: space.paddingInlineStart,
    pr: space.paddingRight,
    pe: space.paddingInlineEnd,
    paddingEnd: space.paddingInlineEnd
  });

  // src/config/text-decoration.ts
  var textDecoration = {
    textDecorationColor: t.colors("textDecorationColor"),
    textDecoration: true,
    textDecor: { property: "textDecoration" },
    textDecorationLine: true,
    textDecorationStyle: true,
    textDecorationThickness: true,
    textUnderlineOffset: true,
    textShadow: t.shadows("textShadow")
  };

  // src/config/transform.ts
  var transform = {
    clipPath: true,
    transform: t.propT("transform", transformFunctions.transform),
    transformOrigin: true,
    translateX: t.spaceT("--chakra-translate-x"),
    translateY: t.spaceT("--chakra-translate-y"),
    skewX: t.degreeT("--chakra-skew-x"),
    skewY: t.degreeT("--chakra-skew-y"),
    scaleX: t.prop("--chakra-scale-x"),
    scaleY: t.prop("--chakra-scale-y"),
    scale: t.prop(["--chakra-scale-x", "--chakra-scale-y"]),
    rotate: t.degreeT("--chakra-rotate")
  };

  // src/config/transition.ts
  var transition = {
    transition: true,
    transitionDelay: true,
    animation: true,
    willChange: true,
    transitionDuration: t.prop("transitionDuration", "transition.duration"),
    transitionProperty: t.prop("transitionProperty", "transition.property"),
    transitionTimingFunction: t.prop("transitionTimingFunction", "transition.easing")
  };

  // src/config/typography.ts
  var typography = {
    fontFamily: t.prop("fontFamily", "fonts"),
    fontSize: t.prop("fontSize", "fontSizes", transformFunctions.px),
    fontWeight: t.prop("fontWeight", "fontWeights"),
    lineHeight: t.prop("lineHeight", "lineHeights"),
    letterSpacing: t.prop("letterSpacing", "letterSpacings"),
    textAlign: true,
    fontStyle: true,
    wordBreak: true,
    overflowWrap: true,
    textOverflow: true,
    textTransform: true,
    whiteSpace: true,
    noOfLines: {
      static: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "var(--chakra-line-clamp)"
      },
      property: "--chakra-line-clamp"
    }
  };

  // src/config/scroll.ts
  var scroll = {
    scrollBehavior: true,
    scrollSnapAlign: true,
    scrollSnapStop: true,
    scrollSnapType: true,
    scrollMargin: t.spaceT("scrollMargin"),
    scrollMarginTop: t.spaceT("scrollMarginTop"),
    scrollMarginBottom: t.spaceT("scrollMarginBottom"),
    scrollMarginLeft: t.spaceT("scrollMarginLeft"),
    scrollMarginRight: t.spaceT("scrollMarginRight"),
    scrollMarginX: t.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
    scrollMarginY: t.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
    scrollPadding: t.spaceT("scrollPadding"),
    scrollPaddingTop: t.spaceT("scrollPaddingTop"),
    scrollPaddingBottom: t.spaceT("scrollPaddingBottom"),
    scrollPaddingLeft: t.spaceT("scrollPaddingLeft"),
    scrollPaddingRight: t.spaceT("scrollPaddingRight"),
    scrollPaddingX: t.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
    scrollPaddingY: t.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
  };

  // src/create-theme-vars/calc.ts
  function resolveReference(operand) {
    if (isObject(operand) && operand.reference) {
      return operand.reference;
    }
    return String(operand);
  }
  var toExpression = (operator, ...operands) => operands.map(resolveReference).join(` ${operator} `).replace(/calc/g, "");
  var add = (...operands) => `calc(${toExpression("+", ...operands)})`;
  var subtract = (...operands) => `calc(${toExpression("-", ...operands)})`;
  var multiply = (...operands) => `calc(${toExpression("*", ...operands)})`;
  var divide = (...operands) => `calc(${toExpression("/", ...operands)})`;
  var negate = (x) => {
    const value = resolveReference(x);
    if (value != null && !Number.isNaN(parseFloat(value))) {
      return String(value).startsWith("-") ? String(value).slice(1) : `-${value}`;
    }
    return multiply(value, -1);
  };
  var calc = Object.assign((x) => ({
    add: (...operands) => calc(add(x, ...operands)),
    subtract: (...operands) => calc(subtract(x, ...operands)),
    multiply: (...operands) => calc(multiply(x, ...operands)),
    divide: (...operands) => calc(divide(x, ...operands)),
    negate: () => calc(negate(x)),
    toString: () => x.toString()
  }), {
    add,
    subtract,
    multiply,
    divide,
    negate
  });

  // src/pseudos.ts
  var state = {
    hover: (str, post) => `${str}:hover ${post}, ${str}[data-hover] ${post}`,
    focus: (str, post) => `${str}:focus ${post}, ${str}[data-focus] ${post}`,
    focusVisible: (str, post) => `${str}:focus-visible ${post}`,
    focusWithin: (str, post) => `${str}:focus-within ${post}`,
    active: (str, post) => `${str}:active ${post}, ${str}[data-active] ${post}`,
    disabled: (str, post) => `${str}:disabled ${post}, ${str}[data-disabled] ${post}`,
    invalid: (str, post) => `${str}:invalid ${post}, ${str}[data-invalid] ${post}`,
    checked: (str, post) => `${str}:checked ${post}, ${str}[data-checked] ${post}`,
    placeholderShown: (str, post) => `${str}:placeholder-shown ${post}`
  };
  var toGroup = (fn) => merge((v) => fn(v, "&"), "[role=group]", "[data-group]", ".group");
  var toPeer = (fn) => merge((v) => fn(v, "~ &"), "[data-peer]", ".peer");
  var merge = (fn, ...selectors) => selectors.map(fn).join(", ");
  var pseudoSelectors = {
    _hover: "&:hover, &[data-hover]",
    _active: "&:active, &[data-active]",
    _focus: "&:focus, &[data-focus]",
    _highlighted: "&[data-highlighted]",
    _focusWithin: "&:focus-within",
    _focusVisible: "&:focus-visible, &[data-focus-visible]",
    _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
    _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
    _before: "&::before",
    _after: "&::after",
    _empty: "&:empty",
    _expanded: "&[aria-expanded=true], &[data-expanded]",
    _checked: "&[aria-checked=true], &[data-checked]",
    _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
    _pressed: "&[aria-pressed=true], &[data-pressed]",
    _invalid: "&[aria-invalid=true], &[data-invalid]",
    _valid: "&[data-valid], &[data-state=valid]",
    _loading: "&[data-loading], &[aria-busy=true]",
    _selected: "&[aria-selected=true], &[data-selected]",
    _hidden: "&[hidden], &[data-hidden]",
    _autofill: "&:-webkit-autofill",
    _even: "&:nth-of-type(even)",
    _odd: "&:nth-of-type(odd)",
    _first: "&:first-of-type",
    _last: "&:last-of-type",
    _notFirst: "&:not(:first-of-type)",
    _notLast: "&:not(:last-of-type)",
    _visited: "&:visited",
    _activeLink: "&[aria-current=page]",
    _activeStep: "&[aria-current=step]",
    _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
    _groupHover: toGroup(state.hover),
    _peerHover: toPeer(state.hover),
    _groupFocus: toGroup(state.focus),
    _peerFocus: toPeer(state.focus),
    _groupFocusVisible: toGroup(state.focusVisible),
    _peerFocusVisible: toPeer(state.focusVisible),
    _groupActive: toGroup(state.active),
    _peerActive: toPeer(state.active),
    _groupDisabled: toGroup(state.disabled),
    _peerDisabled: toPeer(state.disabled),
    _groupInvalid: toGroup(state.invalid),
    _peerInvalid: toPeer(state.invalid),
    _groupChecked: toGroup(state.checked),
    _peerChecked: toPeer(state.checked),
    _groupFocusWithin: toGroup(state.focusWithin),
    _peerFocusWithin: toPeer(state.focusWithin),
    _peerPlaceholderShown: toPeer(state.placeholderShown),
    _placeholder: "&::placeholder",
    _placeholderShown: "&:placeholder-shown",
    _fullScreen: "&:fullscreen",
    _selection: "&::selection",
    _rtl: "[dir=rtl] &, &[dir=rtl]",
    _ltr: "[dir=ltr] &, &[dir=ltr]",
    _mediaDark: "@media (prefers-color-scheme: dark)",
    _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
    _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
    _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]"
  };
  var pseudoPropNames = Object.keys(pseudoSelectors);
  var systemProps = mergeWith({}, background, border, color, flexbox, layout, filter, ring, interactivity, grid, others, position, effect, space, scroll, typography, textDecoration, transform, list, transition);
  Object.assign({}, space, layout, flexbox, grid, position);
  var propNames = [...Object.keys(systemProps), ...pseudoPropNames];
  var styleProps = { ...systemProps, ...pseudoSelectors };
  var isStyleProp = (prop) => prop in styleProps;

  // src/utils/expand-responsive.ts
  var expandResponsive = (styles) => (theme) => {
    if (!theme.__breakpoints)
      return styles;
    const { isResponsive, toArrayValue, media: medias } = theme.__breakpoints;
    const computedStyles = {};
    for (const key in styles) {
      let value = runIfFn$1(styles[key], theme);
      if (value == null)
        continue;
      value = isObject(value) && isResponsive(value) ? toArrayValue(value) : value;
      if (!Array.isArray(value)) {
        computedStyles[key] = value;
        continue;
      }
      const queries = value.slice(0, medias.length).length;
      for (let index = 0; index < queries; index += 1) {
        const media = medias == null ? void 0 : medias[index];
        if (!media) {
          computedStyles[key] = value[index];
          continue;
        }
        computedStyles[media] = computedStyles[media] || {};
        if (value[index] == null) {
          continue;
        }
        computedStyles[media][key] = value[index];
      }
    }
    return computedStyles;
  };

  // src/utils/split-by-comma.ts
  function splitByComma(value) {
    const chunks = [];
    let chunk = "";
    let inParens = false;
    for (let i = 0; i < value.length; i++) {
      const char = value[i];
      if (char === "(") {
        inParens = true;
        chunk += char;
      } else if (char === ")") {
        inParens = false;
        chunk += char;
      } else if (char === "," && !inParens) {
        chunks.push(chunk);
        chunk = "";
      } else {
        chunk += char;
      }
    }
    chunk = chunk.trim();
    if (chunk) {
      chunks.push(chunk);
    }
    return chunks;
  }

  // src/css.ts
  function isCssVar2(value) {
    return /^var\(--.+\)$/.test(value);
  }
  var isCSSVariableTokenValue = (key, value) => key.startsWith("--") && typeof value === "string" && !isCssVar2(value);
  var resolveTokenValue = (theme, value) => {
    if (value == null)
      return value;
    const getVar = (val) => {
      var _a, _b;
      return (_b = (_a = theme.__cssMap) == null ? void 0 : _a[val]) == null ? void 0 : _b.varRef;
    };
    const getValue = (val) => getVar(val) ?? val;
    const [tokenValue, fallbackValue] = splitByComma(value);
    value = getVar(tokenValue) ?? getValue(fallbackValue) ?? getValue(value);
    return value;
  };
  function getCss(options) {
    const { configs = {}, pseudos = {}, theme } = options;
    const css2 = (stylesOrFn, nested = false) => {
      var _a;
      const _styles = runIfFn$1(stylesOrFn, theme);
      const styles = expandResponsive(_styles)(theme);
      let computedStyles = {};
      for (let key in styles) {
        const valueOrFn = styles[key];
        let value = runIfFn$1(valueOrFn, theme);
        if (key in pseudos) {
          key = pseudos[key];
        }
        if (isCSSVariableTokenValue(key, value)) {
          value = resolveTokenValue(theme, value);
        }
        let config = configs[key];
        if (config === true) {
          config = { property: key };
        }
        if (isObject(value)) {
          computedStyles[key] = computedStyles[key] ?? {};
          computedStyles[key] = mergeWith({}, computedStyles[key], css2(value, true));
          continue;
        }
        let rawValue = ((_a = config == null ? void 0 : config.transform) == null ? void 0 : _a.call(config, value, theme, _styles)) ?? value;
        rawValue = (config == null ? void 0 : config.processResult) ? css2(rawValue, true) : rawValue;
        const configProperty = runIfFn$1(config == null ? void 0 : config.property, theme);
        if (!nested && (config == null ? void 0 : config.static)) {
          const staticStyles = runIfFn$1(config.static, theme);
          computedStyles = mergeWith({}, computedStyles, staticStyles);
        }
        if (configProperty && Array.isArray(configProperty)) {
          for (const property of configProperty) {
            computedStyles[property] = rawValue;
          }
          continue;
        }
        if (configProperty) {
          if (configProperty === "&" && isObject(rawValue)) {
            computedStyles = mergeWith({}, computedStyles, rawValue);
          } else {
            computedStyles[configProperty] = rawValue;
          }
          continue;
        }
        if (isObject(rawValue)) {
          computedStyles = mergeWith({}, computedStyles, rawValue);
          continue;
        }
        computedStyles[key] = rawValue;
      }
      return computedStyles;
    };
    return css2;
  }
  var css = (styles) => (theme) => {
    const cssFn = getCss({
      theme,
      pseudos: pseudoSelectors,
      configs: systemProps
    });
    return cssFn(styles);
  };

  // src/index.ts
  function isFunction(value) {
    return typeof value === "function";
  }
  function objectFilter(object, fn) {
    const result = {};
    Object.keys(object).forEach((key) => {
      const value = object[key];
      const shouldPass = fn(value, key, object);
      if (shouldPass) {
        result[key] = value;
      }
    });
    return result;
  }
  var filterUndefined = (object) => objectFilter(object, (val) => val !== null && val !== void 0);

  // src/function.ts
  function runIfFn(valueOrFn, ...args) {
    return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
  }

  // src/refs.ts
  function createContext(options = {}) {
    const {
      strict = true,
      errorMessage = "useContext: `context` is undefined. Seems you forgot to wrap component within the Provider",
      name
    } = options;
    const Context = React.createContext(void 0);
    Context.displayName = name;
    function useContext() {
      var _a;
      const context = React.useContext(Context);
      if (!context && strict) {
        const error = new Error(errorMessage);
        error.name = "ContextError";
        (_a = Error.captureStackTrace) == null ? void 0 : _a.call(Error, error, useContext);
        throw error;
      }
      return context;
    }
    return [
      Context.Provider,
      useContext,
      Context
    ];
  }

  // ../../../react-shim.js
  createContext({
    name: "StylesContext",
    errorMessage: "useStyles: `styles` is undefined. Seems you forgot to wrap the components in `<StylesProvider />` "
  });
  var allPropNames = /* @__PURE__ */ new Set([
    ...propNames,
    "textStyle",
    "layerStyle",
    "apply",
    "noOfLines",
    "focusBorderColor",
    "errorBorderColor",
    "as",
    "__css",
    "css",
    "sx"
  ]);
  var validHTMLProps = /* @__PURE__ */ new Set(["htmlWidth", "htmlHeight", "htmlSize"]);
  function shouldForwardProp(prop) {
    return validHTMLProps.has(prop) || !allPropNames.has(prop);
  }

  // src/system.ts
  var toCSSObject = ({ baseStyle }) => (props) => {
    const { theme, css: cssProp, __css, sx, ...rest } = props;
    const styleProps = objectFilter(rest, (_, prop) => isStyleProp(prop));
    const finalBaseStyle = runIfFn(baseStyle, props);
    const finalStyles = Object.assign({}, __css, finalBaseStyle, filterUndefined(styleProps), sx);
    const computedCSS = css(finalStyles)(props.theme);
    return cssProp ? [computedCSS, cssProp] : computedCSS;
  };
  function styled(component, options) {
    const { baseStyle, ...styledOptions } = options ?? {};
    if (!styledOptions.shouldForwardProp) {
      styledOptions.shouldForwardProp = shouldForwardProp;
    }
    const styleObject = toCSSObject({ baseStyle });
    const Component = styled$2(component, styledOptions)(styleObject);
    const chakraComponent = React.forwardRef(function ChakraComponent(props, ref) {
      const { colorMode, forced } = useColorMode();
      return React.createElement(Component, {
        ref,
        "data-theme": forced ? colorMode : void 0,
        ...props
      });
    });
    return chakraComponent;
  }
  function forwardRef(component) {
    return React.forwardRef(component);
  }

  // src/factory.ts
  function factory() {
    const cache = /* @__PURE__ */ new Map();
    return new Proxy(styled, {
      apply(target, thisArg, argArray) {
        return styled(...argArray);
      },
      get(_, element) {
        if (!cache.has(element)) {
          cache.set(element, styled(element));
        }
        return cache.get(element);
      }
    });
  }
  var chakra = factory();

  var cx = function cx() {
    for (var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++) {
      classNames[_key] = arguments[_key];
    }

    return classNames.filter(Boolean).join(" ");
  };

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  var _excluded$f = ["as", "viewBox", "color", "focusable", "children", "className", "__css"];
  var fallbackIcon = {
    path: /*#__PURE__*/React__namespace.createElement("g", {
      stroke: "currentColor",
      strokeWidth: "1.5"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      strokeLinecap: "round",
      fill: "none",
      d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      fill: "currentColor",
      strokeLinecap: "round",
      d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
    }), /*#__PURE__*/React__namespace.createElement("circle", {
      fill: "none",
      strokeMiterlimit: "10",
      cx: "12",
      cy: "12",
      r: "11.25"
    })),
    viewBox: "0 0 24 24"
  };
  var Icon = /*#__PURE__*/forwardRef(function (props, ref) {
    var element = props.as,
        viewBox = props.viewBox,
        _props$color = props.color,
        color = _props$color === void 0 ? "currentColor" : _props$color,
        _props$focusable = props.focusable,
        focusable = _props$focusable === void 0 ? false : _props$focusable,
        children = props.children,
        className = props.className,
        __css = props.__css,
        rest = _objectWithoutPropertiesLoose(props, _excluded$f);

    var _className = cx("chakra-icon", className);

    var styles = _extends({
      w: "1em",
      h: "1em",
      display: "inline-block",
      lineHeight: "1em",
      flexShrink: 0,
      color: color
    }, __css);

    var shared = {
      ref: ref,
      focusable: focusable,
      className: _className,
      __css: styles
    };

    var _viewBox = viewBox != null ? viewBox : fallbackIcon.viewBox;
    /**
     * If you're using an icon library like `react-icons`.
     * Note: anyone passing the `as` prop, should manage the `viewBox` from the external component
     */


    if (element && typeof element !== "string") {
      return /*#__PURE__*/React__namespace.createElement(chakra.svg, _extends({
        as: element
      }, shared, rest));
    }

    var _path = children != null ? children : fallbackIcon.path;

    return /*#__PURE__*/React__namespace.createElement(chakra.svg, _extends({
      verticalAlign: "middle",
      viewBox: _viewBox
    }, shared, rest), _path);
  });

  function createIcon(options) {
    var _options$viewBox = options.viewBox,
        viewBox = _options$viewBox === void 0 ? "0 0 24 24" : _options$viewBox,
        pathDefinition = options.d;
        options.displayName;
        var _options$defaultProps = options.defaultProps,
        defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps;
    var path = React__namespace.Children.toArray(options.path);
    var Comp = /*#__PURE__*/forwardRef(function (props, ref) {
      return /*#__PURE__*/React__namespace.createElement(Icon, _extends({
        ref: ref,
        viewBox: viewBox
      }, defaultProps, props), path.length ? path : /*#__PURE__*/React__namespace.createElement("path", {
        fill: "currentColor",
        d: pathDefinition
      }));
    });

    return Comp;
  }

  createIcon({
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z",
    displayName: "CopyIcon"
  });

  createIcon({
    d: "M23.384,21.619,16.855,15.09a9.284,9.284,0,1,0-1.768,1.768l6.529,6.529a1.266,1.266,0,0,0,1.768,0A1.251,1.251,0,0,0,23.384,21.619ZM2.75,9.5a6.75,6.75,0,1,1,6.75,6.75A6.758,6.758,0,0,1,2.75,9.5Z",
    displayName: "SearchIcon"
  });

  createIcon({
    d: "M23.414,20.591l-4.645-4.645a10.256,10.256,0,1,0-2.828,2.829l4.645,4.644a2.025,2.025,0,0,0,2.828,0A2,2,0,0,0,23.414,20.591ZM10.25,3.005A7.25,7.25,0,1,1,3,10.255,7.258,7.258,0,0,1,10.25,3.005Z",
    displayName: "Search2Icon"
  });

  createIcon({
    d: "M21.4,13.7C20.6,13.9,19.8,14,19,14c-5,0-9-4-9-9c0-0.8,0.1-1.6,0.3-2.4c0.1-0.3,0-0.7-0.3-1 c-0.3-0.3-0.6-0.4-1-0.3C4.3,2.7,1,7.1,1,12c0,6.1,4.9,11,11,11c4.9,0,9.3-3.3,10.6-8.1c0.1-0.3,0-0.7-0.3-1 C22.1,13.7,21.7,13.6,21.4,13.7z",
    displayName: "MoonIcon"
  });

  createIcon({
    displayName: "SunIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: "2",
      fill: "none",
      stroke: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "5"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 1v2"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 21v2"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.22 4.22l1.42 1.42"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.36 18.36l1.42 1.42"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M1 12h2"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M21 12h2"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M4.22 19.78l1.42-1.42"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.36 5.64l1.42-1.42"
    }))
  });

  createIcon({
    d: "M0,12a1.5,1.5,0,0,0,1.5,1.5h8.75a.25.25,0,0,1,.25.25V22.5a1.5,1.5,0,0,0,3,0V13.75a.25.25,0,0,1,.25-.25H22.5a1.5,1.5,0,0,0,0-3H13.75a.25.25,0,0,1-.25-.25V1.5a1.5,1.5,0,0,0-3,0v8.75a.25.25,0,0,1-.25.25H1.5A1.5,1.5,0,0,0,0,12Z",
    displayName: "AddIcon"
  });

  createIcon({
    displayName: "SmallAddIcon",
    viewBox: "0 0 20 20",
    path: /*#__PURE__*/React__namespace.createElement("path", {
      fill: "currentColor",
      d: "M14 9h-3V6c0-.55-.45-1-1-1s-1 .45-1 1v3H6c-.55 0-1 .45-1 1s.45 1 1 1h3v3c0 .55.45 1 1 1s1-.45 1-1v-3h3c.55 0 1-.45 1-1s-.45-1-1-1z",
      fillRule: "evenodd"
    })
  });

  createIcon({
    viewBox: "0 0 14 14",
    d: "M14,7.77 L14,6.17 L12.06,5.53 L11.61,4.44 L12.49,2.6 L11.36,1.47 L9.55,2.38 L8.46,1.93 L7.77,0.01 L6.17,0.01 L5.54,1.95 L4.43,2.4 L2.59,1.52 L1.46,2.65 L2.37,4.46 L1.92,5.55 L0,6.23 L0,7.82 L1.94,8.46 L2.39,9.55 L1.51,11.39 L2.64,12.52 L4.45,11.61 L5.54,12.06 L6.23,13.98 L7.82,13.98 L8.45,12.04 L9.56,11.59 L11.4,12.47 L12.53,11.34 L11.61,9.53 L12.08,8.44 L14,7.75 L14,7.77 Z M7,10 C5.34,10 4,8.66 4,7 C4,5.34 5.34,4 7,4 C8.66,4 10,5.34 10,7 C10,8.66 8.66,10 7,10 Z",
    displayName: "SettingsIcon"
  });

  createIcon({
    displayName: "CheckCircleIcon",
    d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
  });

  createIcon({
    d: "M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z",
    displayName: "LockIcon"
  });

  createIcon({
    d: "M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z",
    displayName: "UnlockIcon"
  });

  createIcon({
    displayName: "ViewIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.432,10.524C20.787,7.614,16.4,4.538,12,4.6,7.6,4.537,3.213,7.615.568,10.524a2.211,2.211,0,0,0,0,2.948C3.182,16.351,7.507,19.4,11.839,19.4h.308c4.347,0,8.671-3.049,11.288-5.929A2.21,2.21,0,0,0,23.432,10.524ZM7.4,12A4.6,4.6,0,1,1,12,16.6,4.6,4.6,0,0,1,7.4,12Z"
    }), /*#__PURE__*/React__namespace.createElement("circle", {
      cx: "12",
      cy: "12",
      r: "2"
    }))
  });

  createIcon({
    displayName: "ViewOffIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.2,10.549a20.954,20.954,0,0,0-4.3-3.6l4-3.995a1,1,0,1,0-1.414-1.414l-.018.018a.737.737,0,0,1-.173.291l-19.5,19.5c-.008.007-.018.009-.026.017a1,1,0,0,0,1.631,1.088l4.146-4.146a11.26,11.26,0,0,0,4.31.939h.3c4.256,0,8.489-2.984,11.051-5.8A2.171,2.171,0,0,0,23.2,10.549ZM16.313,13.27a4.581,4.581,0,0,1-3,3.028,4.3,4.3,0,0,1-3.1-.19.253.253,0,0,1-.068-.407l5.56-5.559a.252.252,0,0,1,.407.067A4.3,4.3,0,0,1,16.313,13.27Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M7.615,13.4a.244.244,0,0,0,.061-.24A4.315,4.315,0,0,1,7.5,12,4.5,4.5,0,0,1,12,7.5a4.276,4.276,0,0,1,1.16.173.244.244,0,0,0,.24-.062l1.941-1.942a.254.254,0,0,0-.1-.421A10.413,10.413,0,0,0,12,4.75C7.7,4.692,3.4,7.7.813,10.549a2.15,2.15,0,0,0-.007,2.9,21.209,21.209,0,0,0,3.438,3.03.256.256,0,0,0,.326-.029Z"
    }))
  });

  createIcon({
    d: "M11.2857,6.05714 L10.08571,4.85714 L7.85714,7.14786 L7.85714,1 L6.14286,1 L6.14286,7.14786 L3.91429,4.85714 L2.71429,6.05714 L7,10.42857 L11.2857,6.05714 Z M1,11.2857 L1,13 L13,13 L13,11.2857 L1,11.2857 Z",
    displayName: "DownloadIcon",
    viewBox: "0 0 14 14"
  });

  createIcon({
    displayName: "DeleteIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M19.452 7.5H4.547a.5.5 0 00-.5.545l1.287 14.136A2 2 0 007.326 24h9.347a2 2 0 001.992-1.819L19.95 8.045a.5.5 0 00-.129-.382.5.5 0 00-.369-.163zm-9.2 13a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zm5 0a.75.75 0 01-1.5 0v-9a.75.75 0 011.5 0zM22 4h-4.75a.25.25 0 01-.25-.25V2.5A2.5 2.5 0 0014.5 0h-5A2.5 2.5 0 007 2.5v1.25a.25.25 0 01-.25.25H2a1 1 0 000 2h20a1 1 0 000-2zM9 3.75V2.5a.5.5 0 01.5-.5h5a.5.5 0 01.5.5v1.25a.25.25 0 01-.25.25h-5.5A.25.25 0 019 3.75z"
    }))
  });

  createIcon({
    displayName: "RepeatIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.319,4.936a7.239,7.239,0,0,1,7.1,2.252,1.25,1.25,0,1,0,1.872-1.657A9.737,9.737,0,0,0,9.743,2.5,10.269,10.269,0,0,0,2.378,9.61a.249.249,0,0,1-.271.178l-1.033-.13A.491.491,0,0,0,.6,9.877a.5.5,0,0,0-.019.526l2.476,4.342a.5.5,0,0,0,.373.248.43.43,0,0,0,.062,0,.5.5,0,0,0,.359-.152l3.477-3.593a.5.5,0,0,0-.3-.844L5.15,10.172a.25.25,0,0,1-.2-.333A7.7,7.7,0,0,1,10.319,4.936Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.406,14.1a.5.5,0,0,0,.015-.526l-2.5-4.329A.5.5,0,0,0,20.546,9a.489.489,0,0,0-.421.151l-3.456,3.614a.5.5,0,0,0,.3.842l1.848.221a.249.249,0,0,1,.183.117.253.253,0,0,1,.023.216,7.688,7.688,0,0,1-5.369,4.9,7.243,7.243,0,0,1-7.1-2.253,1.25,1.25,0,1,0-1.872,1.656,9.74,9.74,0,0,0,9.549,3.03,10.261,10.261,0,0,0,7.369-7.12.251.251,0,0,1,.27-.179l1.058.127a.422.422,0,0,0,.06,0A.5.5,0,0,0,23.406,14.1Z"
    }))
  });

  createIcon({
    displayName: "RepeatClockIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.965,6a1,1,0,0,0-1,1v5.5a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2h-3.75a.25.25,0,0,1-.25-.25V7A1,1,0,0,0,12.965,6Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12.567,1.258A10.822,10.822,0,0,0,2.818,8.4a.25.25,0,0,1-.271.163L.858,8.309a.514.514,0,0,0-.485.213.5.5,0,0,0-.021.53l2.679,4.7a.5.5,0,0,0,.786.107l3.77-3.746a.5.5,0,0,0-.279-.85L5.593,9.007a.25.25,0,0,1-.192-.35,8.259,8.259,0,1,1,7.866,11.59,1.25,1.25,0,0,0,.045,2.5h.047a10.751,10.751,0,1,0-.792-21.487Z"
    }))
  });

  createIcon({
    displayName: "EditIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: "2"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"
    }))
  });

  createIcon({
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z",
    displayName: "ChevronLeftIcon"
  });

  createIcon({
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z",
    displayName: "ChevronRightIcon"
  });

  var ChevronDownIcon = createIcon({
    displayName: "ChevronDownIcon",
    d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
  });

  createIcon({
    d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z",
    displayName: "ChevronUpIcon"
  });

  createIcon({
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z",
    displayName: "ArrowBackIcon"
  });

  createIcon({
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z",
    displayName: "ArrowForwardIcon"
  });

  createIcon({
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z",
    displayName: "ArrowUpIcon"
  });

  createIcon({
    viewBox: "0 0 16 16",
    d: "M11.891 9.992a1 1 0 1 1 1.416 1.415l-4.3 4.3a1 1 0 0 1-1.414 0l-4.3-4.3A1 1 0 0 1 4.71 9.992l3.59 3.591 3.591-3.591zm0-3.984L8.3 2.417 4.709 6.008a1 1 0 0 1-1.416-1.415l4.3-4.3a1 1 0 0 1 1.414 0l4.3 4.3a1 1 0 1 1-1.416 1.415z",
    displayName: "ArrowUpDownIcon"
  });

  createIcon({
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
    displayName: "ArrowDownIcon"
  });

  createIcon({
    displayName: "ExternalLinkIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: "2"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M15 3h6v6"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10 14L21 3"
    }))
  });

  createIcon({
    displayName: "LinkIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.458,18.374,7.721,21.11a2.853,2.853,0,0,1-3.942,0l-.892-.891a2.787,2.787,0,0,1,0-3.941l5.8-5.8a2.789,2.789,0,0,1,3.942,0l.893.892A1,1,0,0,0,14.94,9.952l-.893-.892a4.791,4.791,0,0,0-6.771,0l-5.8,5.8a4.787,4.787,0,0,0,0,6.77l.892.891a4.785,4.785,0,0,0,6.771,0l2.736-2.735a1,1,0,1,0-1.414-1.415Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M22.526,2.363l-.892-.892a4.8,4.8,0,0,0-6.77,0l-2.905,2.9a1,1,0,0,0,1.414,1.414l2.9-2.9a2.79,2.79,0,0,1,3.941,0l.893.893a2.786,2.786,0,0,1,0,3.942l-5.8,5.8a2.769,2.769,0,0,1-1.971.817h0a2.766,2.766,0,0,1-1.969-.816,1,1,0,1,0-1.415,1.412,4.751,4.751,0,0,0,3.384,1.4h0a4.752,4.752,0,0,0,3.385-1.4l5.8-5.8a4.786,4.786,0,0,0,0-6.771Z"
    }))
  });

  createIcon({
    displayName: "PlusSquareIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeWidth: "2"
    }, /*#__PURE__*/React__namespace.createElement("rect", {
      height: "18",
      width: "18",
      rx: "2",
      ry: "2",
      x: "3",
      y: "3"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12 8v8"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M8 12h8"
    }))
  });

  createIcon({
    displayName: "CalendarIcon",
    viewBox: "0 0 14 14",
    d: "M10.8889,5.5 L3.11111,5.5 L3.11111,7.05556 L10.8889,7.05556 L10.8889,5.5 Z M12.4444,1.05556 L11.6667,1.05556 L11.6667,0 L10.1111,0 L10.1111,1.05556 L3.88889,1.05556 L3.88889,0 L2.33333,0 L2.33333,1.05556 L1.55556,1.05556 C0.692222,1.05556 0.00777777,1.75556 0.00777777,2.61111 L0,12.5 C0,13.3556 0.692222,14 1.55556,14 L12.4444,14 C13.3,14 14,13.3556 14,12.5 L14,2.61111 C14,1.75556 13.3,1.05556 12.4444,1.05556 Z M12.4444,12.5 L1.55556,12.5 L1.55556,3.94444 L12.4444,3.94444 L12.4444,12.5 Z M8.55556,8.61111 L3.11111,8.61111 L3.11111,10.1667 L8.55556,10.1667 L8.55556,8.61111 Z"
  });

  createIcon({
    d: "M0.913134,0.920639 C1.49851,0.331726 2.29348,0 3.12342,0 L10.8766,0 C11.7065,0 12.5015,0.331725 13.0869,0.920639 C13.6721,1.50939 14,2.30689 14,3.13746 L14,8.12943 C13.9962,8.51443 13.9059,8.97125 13.7629,9.32852 C13.6128,9.683 13.3552,10.0709 13.0869,10.3462 C12.813,10.6163 12.4265,10.8761 12.0734,11.0274 C11.7172,11.1716 11.2607,11.263 10.8766,11.2669 L10.1234,11.2669 L10.1234,12.5676 L10.1209,12.5676 C10.1204,12.793 10.0633,13.0791 9.97807,13.262 C9.8627,13.466 9.61158,13.7198 9.40818,13.8382 L9.40824,13.8383 C9.4077,13.8386 9.40716,13.8388 9.40661,13.8391 C9.40621,13.8393 9.4058,13.8396 9.40539,13.8398 L9.40535,13.8397 C9.22958,13.9254 8.94505,13.9951 8.75059,14 L8.74789,14 C8.35724,13.9963 7.98473,13.8383 7.71035,13.5617 L5.39553,11.2669 L3.12342,11.2669 C2.29348,11.2669 1.49851,10.9352 0.913134,10.3462 C0.644826,10.0709 0.387187,9.683 0.23711,9.32852 C0.0941235,8.97125 0.00379528,8.51443 0,8.12943 L0,3.13746 C0,2.30689 0.327915,1.50939 0.913134,0.920639 Z M3.12342,1.59494 C2.71959,1.59494 2.33133,1.75628 2.04431,2.04503 C1.75713,2.33395 1.59494,2.72681 1.59494,3.13746 L1.59494,8.12943 C1.59114,8.35901 1.62114,8.51076 1.71193,8.72129 C1.79563,8.9346 1.88065,9.06264 2.04431,9.22185 C2.33133,9.5106 2.71959,9.67195 3.12342,9.67195 L5.72383,9.67195 C5.93413,9.67195 6.13592,9.75502 6.28527,9.90308 L8.52848,12.1269 L8.52848,10.4694 C8.52848,10.029 8.88552,9.67195 9.32595,9.67195 L10.8766,9.67195 C11.1034,9.67583 11.2517,9.64614 11.4599,9.55518 C11.6712,9.47132 11.7976,9.38635 11.9557,9.22185 C12.1193,9.06264 12.2044,8.9346 12.2881,8.72129 C12.3789,8.51076 12.4089,8.35901 12.4051,8.12943 L12.4051,3.13746 C12.4051,2.72681 12.2429,2.33394 11.9557,2.04503 C11.6687,1.75628 11.2804,1.59494 10.8766,1.59494 L3.12342,1.59494 Z",
    displayName: "ChatIcon",
    viewBox: "0 0 14 14"
  });

  createIcon({
    displayName: "TimeIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M17.134,15.81,12.5,11.561V6.5a1,1,0,0,0-2,0V12a1,1,0,0,0,.324.738l4.959,4.545a1.01,1.01,0,0,0,1.413-.061A1,1,0,0,0,17.134,15.81Z"
    }))
  });

  createIcon({
    displayName: "ArrowRightIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M13.584,12a2.643,2.643,0,0,1-.775,1.875L3.268,23.416a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L.768,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,13.584,12Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.75,12a2.643,2.643,0,0,1-.775,1.875l-9.541,9.541a1.768,1.768,0,0,1-2.5-2.5l8.739-8.739a.25.25,0,0,0,0-.354L10.934,3.084a1.768,1.768,0,0,1,2.5-2.5l9.541,9.541A2.643,2.643,0,0,1,23.75,12Z"
    }))
  });

  createIcon({
    displayName: "ArrowLeftIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10.416,12a2.643,2.643,0,0,1,.775-1.875L20.732.584a1.768,1.768,0,0,1,2.5,2.5l-8.739,8.739a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5l-9.541-9.541A2.643,2.643,0,0,1,10.416,12Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M.25,12a2.643,2.643,0,0,1,.775-1.875L10.566.584a1.768,1.768,0,0,1,2.5,2.5L4.327,11.823a.25.25,0,0,0,0,.354l8.739,8.739a1.768,1.768,0,0,1-2.5,2.5L1.025,13.875A2.643,2.643,0,0,1,.25,12Z"
    }))
  });

  createIcon({
    displayName: "AtSignIcon",
    d: "M12,.5A11.634,11.634,0,0,0,.262,12,11.634,11.634,0,0,0,12,23.5a11.836,11.836,0,0,0,6.624-2,1.25,1.25,0,1,0-1.393-2.076A9.34,9.34,0,0,1,12,21a9.132,9.132,0,0,1-9.238-9A9.132,9.132,0,0,1,12,3a9.132,9.132,0,0,1,9.238,9v.891a1.943,1.943,0,0,1-3.884,0V12A5.355,5.355,0,1,0,12,17.261a5.376,5.376,0,0,0,3.861-1.634,4.438,4.438,0,0,0,7.877-2.736V12A11.634,11.634,0,0,0,12,.5Zm0,14.261A2.763,2.763,0,1,1,14.854,12,2.812,2.812,0,0,1,12,14.761Z"
  });

  createIcon({
    displayName: "AttachmentIcon",
    d: "M21.843,3.455a6.961,6.961,0,0,0-9.846,0L1.619,13.832a5.128,5.128,0,0,0,7.252,7.252L17.3,12.653A3.293,3.293,0,1,0,12.646,8L7.457,13.184A1,1,0,1,0,8.871,14.6L14.06,9.409a1.294,1.294,0,0,1,1.829,1.83L7.457,19.67a3.128,3.128,0,0,1-4.424-4.424L13.411,4.869a4.962,4.962,0,1,1,7.018,7.018L12.646,19.67a1,1,0,1,0,1.414,1.414L21.843,13.3a6.96,6.96,0,0,0,0-9.846Z"
  });

  createIcon({
    displayName: "UpDownIcon",
    viewBox: "-1 -1 9 11",
    d: "M 3.5 0L 3.98809 -0.569442L 3.5 -0.987808L 3.01191 -0.569442L 3.5 0ZM 3.5 9L 3.01191 9.56944L 3.5 9.98781L 3.98809 9.56944L 3.5 9ZM 0.488094 3.56944L 3.98809 0.569442L 3.01191 -0.569442L -0.488094 2.43056L 0.488094 3.56944ZM 3.01191 0.569442L 6.51191 3.56944L 7.48809 2.43056L 3.98809 -0.569442L 3.01191 0.569442ZM -0.488094 6.56944L 3.01191 9.56944L 3.98809 8.43056L 0.488094 5.43056L -0.488094 6.56944ZM 3.98809 9.56944L 7.48809 6.56944L 6.51191 5.43056L 3.01191 8.43056L 3.98809 9.56944Z"
  });

  createIcon({
    d: "M23.555,8.729a1.505,1.505,0,0,0-1.406-.98H16.062a.5.5,0,0,1-.472-.334L13.405,1.222a1.5,1.5,0,0,0-2.81,0l-.005.016L8.41,7.415a.5.5,0,0,1-.471.334H1.85A1.5,1.5,0,0,0,.887,10.4l5.184,4.3a.5.5,0,0,1,.155.543L4.048,21.774a1.5,1.5,0,0,0,2.31,1.684l5.346-3.92a.5.5,0,0,1,.591,0l5.344,3.919a1.5,1.5,0,0,0,2.312-1.683l-2.178-6.535a.5.5,0,0,1,.155-.543l5.194-4.306A1.5,1.5,0,0,0,23.555,8.729Z",
    displayName: "StarIcon"
  });

  createIcon({
    displayName: "EmailIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      d: "M11.114,14.556a1.252,1.252,0,0,0,1.768,0L22.568,4.87a.5.5,0,0,0-.281-.849A1.966,1.966,0,0,0,22,4H2a1.966,1.966,0,0,0-.289.021.5.5,0,0,0-.281.849Z"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M23.888,5.832a.182.182,0,0,0-.2.039l-6.2,6.2a.251.251,0,0,0,0,.354l5.043,5.043a.75.75,0,1,1-1.06,1.061l-5.043-5.043a.25.25,0,0,0-.354,0l-2.129,2.129a2.75,2.75,0,0,1-3.888,0L7.926,13.488a.251.251,0,0,0-.354,0L2.529,18.531a.75.75,0,0,1-1.06-1.061l5.043-5.043a.251.251,0,0,0,0-.354l-6.2-6.2a.18.18,0,0,0-.2-.039A.182.182,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.181.181,0,0,0,23.888,5.832Z"
    }))
  });

  createIcon({
    d: "M2.20731,0.0127209 C2.1105,-0.0066419 1.99432,-0.00664663 1.91687,0.032079 C0.871279,0.438698 0.212942,1.92964 0.0580392,2.95587 C-0.426031,6.28627 2.20731,9.17133 4.62766,11.0689 C6.77694,12.7534 10.9012,15.5223 13.3409,12.8503 C13.6507,12.5211 14.0186,12.037 13.9993,11.553 C13.9412,10.7397 13.186,10.1588 12.6051,9.71349 C12.1598,9.38432 11.2304,8.47427 10.6495,8.49363 C10.1267,8.51299 9.79754,9.05515 9.46837,9.38432 L8.88748,9.96521 C8.79067,10.062 7.55145,9.24878 7.41591,9.15197 C6.91248,8.8228 6.4284,8.45491 6.00242,8.04829 C5.57644,7.64167 5.18919,7.19632 4.86002,6.73161 C4.7632,6.59607 3.96933,5.41495 4.04678,5.31813 C4.04678,5.31813 4.72448,4.58234 4.91811,4.2919 C5.32473,3.67229 5.63453,3.18822 5.16982,2.45243 C4.99556,2.18135 4.78257,1.96836 4.55021,1.73601 C4.14359,1.34875 3.73698,0.942131 3.27227,0.612963 C3.02055,0.419335 2.59457,0.0708094 2.20731,0.0127209 Z",
    displayName: "PhoneIcon",
    viewBox: "0 0 14 14"
  });

  createIcon({
    viewBox: "0 0 10 10",
    d: "M3,2 C2.44771525,2 2,1.55228475 2,1 C2,0.44771525 2.44771525,0 3,0 C3.55228475,0 4,0.44771525 4,1 C4,1.55228475 3.55228475,2 3,2 Z M3,6 C2.44771525,6 2,5.55228475 2,5 C2,4.44771525 2.44771525,4 3,4 C3.55228475,4 4,4.44771525 4,5 C4,5.55228475 3.55228475,6 3,6 Z M3,10 C2.44771525,10 2,9.55228475 2,9 C2,8.44771525 2.44771525,8 3,8 C3.55228475,8 4,8.44771525 4,9 C4,9.55228475 3.55228475,10 3,10 Z M7,2 C6.44771525,2 6,1.55228475 6,1 C6,0.44771525 6.44771525,0 7,0 C7.55228475,0 8,0.44771525 8,1 C8,1.55228475 7.55228475,2 7,2 Z M7,6 C6.44771525,6 6,5.55228475 6,5 C6,4.44771525 6.44771525,4 7,4 C7.55228475,4 8,4.44771525 8,5 C8,5.55228475 7.55228475,6 7,6 Z M7,10 C6.44771525,10 6,9.55228475 6,9 C6,8.44771525 6.44771525,8 7,8 C7.55228475,8 8,8.44771525 8,9 C8,9.55228475 7.55228475,10 7,10 Z",
    displayName: "DragHandleIcon"
  });

  createIcon({
    displayName: "SpinnerIcon",
    path: /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("linearGradient", {
      x1: "28.154%",
      y1: "63.74%",
      x2: "74.629%",
      y2: "17.783%",
      id: "a"
    }, /*#__PURE__*/React__namespace.createElement("stop", {
      stopColor: "currentColor",
      offset: "0%"
    }), /*#__PURE__*/React__namespace.createElement("stop", {
      stopColor: "#fff",
      stopOpacity: "0",
      offset: "100%"
    }))), /*#__PURE__*/React__namespace.createElement("g", {
      transform: "translate(2)",
      fill: "none"
    }, /*#__PURE__*/React__namespace.createElement("circle", {
      stroke: "url(#a)",
      strokeWidth: "4",
      cx: "10",
      cy: "12",
      r: "10"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      d: "M10 2C4.477 2 0 6.477 0 12",
      stroke: "currentColor",
      strokeWidth: "4"
    }), /*#__PURE__*/React__namespace.createElement("rect", {
      fill: "currentColor",
      x: "8",
      width: "4",
      height: "4",
      rx: "8"
    })))
  });

  createIcon({
    displayName: "CloseIcon",
    d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z"
  });

  createIcon({
    displayName: "SmallCloseIcon",
    viewBox: "0 0 16 16",
    path: /*#__PURE__*/React__namespace.createElement("path", {
      d: "M9.41 8l2.29-2.29c.19-.18.3-.43.3-.71a1.003 1.003 0 0 0-1.71-.71L8 6.59l-2.29-2.3a1.003 1.003 0 0 0-1.42 1.42L6.59 8 4.3 10.29c-.19.18-.3.43-.3.71a1.003 1.003 0 0 0 1.71.71L8 9.41l2.29 2.29c.18.19.43.3.71.3a1.003 1.003 0 0 0 .71-1.71L9.41 8z",
      fillRule: "evenodd",
      fill: "currentColor"
    })
  });

  createIcon({
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z",
    displayName: "NotAllowedIcon"
  });

  createIcon({
    d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
    displayName: "TriangleDownIcon"
  });

  createIcon({
    d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
    displayName: "TriangleUpIcon"
  });

  createIcon({
    displayName: "InfoOutlineIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinecap: "square",
      strokeWidth: "2"
    }, /*#__PURE__*/React__namespace.createElement("circle", {
      cx: "12",
      cy: "12",
      fill: "none",
      r: "11",
      stroke: "currentColor"
    }), /*#__PURE__*/React__namespace.createElement("line", {
      fill: "none",
      x1: "11.959",
      x2: "11.959",
      y1: "11",
      y2: "17"
    }), /*#__PURE__*/React__namespace.createElement("circle", {
      cx: "11.959",
      cy: "7",
      r: "1",
      stroke: "none"
    }))
  });

  createIcon({
    displayName: "BellIcon",
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
  });

  createIcon({
    d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
  });

  createIcon({
    d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,19a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,19Zm1.6-6.08a1,1,0,0,0-.6.917,1,1,0,1,1-2,0,3,3,0,0,1,1.8-2.75A2,2,0,1,0,10,9.255a1,1,0,1,1-2,0,4,4,0,1,1,5.6,3.666Z",
    displayName: "QuestionIcon"
  });

  createIcon({
    displayName: "QuestionOutlineIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      stroke: "currentColor",
      strokeWidth: "1.5"
    }, /*#__PURE__*/React__namespace.createElement("path", {
      strokeLinecap: "round",
      fill: "none",
      d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
    }), /*#__PURE__*/React__namespace.createElement("path", {
      fill: "none",
      strokeLinecap: "round",
      d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
    }), /*#__PURE__*/React__namespace.createElement("circle", {
      fill: "none",
      strokeMiterlimit: "10",
      cx: "12",
      cy: "12",
      r: "11.25"
    }))
  });

  createIcon({
    d: "M11.983,0a12.206,12.206,0,0,0-8.51,3.653A11.8,11.8,0,0,0,0,12.207,11.779,11.779,0,0,0,11.8,24h.214A12.111,12.111,0,0,0,24,11.791h0A11.766,11.766,0,0,0,11.983,0ZM10.5,16.542a1.476,1.476,0,0,1,1.449-1.53h.027a1.527,1.527,0,0,1,1.523,1.47,1.475,1.475,0,0,1-1.449,1.53h-.027A1.529,1.529,0,0,1,10.5,16.542ZM11,12.5v-6a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Z",
    displayName: "WarningIcon"
  });

  createIcon({
    displayName: "WarningTwoIcon",
    d: "M23.119,20,13.772,2.15h0a2,2,0,0,0-3.543,0L.881,20a2,2,0,0,0,1.772,2.928H21.347A2,2,0,0,0,23.119,20ZM11,8.423a1,1,0,0,1,2,0v6a1,1,0,1,1-2,0Zm1.05,11.51h-.028a1.528,1.528,0,0,1-1.522-1.47,1.476,1.476,0,0,1,1.448-1.53h.028A1.527,1.527,0,0,1,13.5,18.4,1.475,1.475,0,0,1,12.05,19.933Z"
  });

  createIcon({
    viewBox: "0 0 14 14",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("polygon", {
      points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039"
    }))
  });

  createIcon({
    displayName: "MinusIcon",
    path: /*#__PURE__*/React__namespace.createElement("g", {
      fill: "currentColor"
    }, /*#__PURE__*/React__namespace.createElement("rect", {
      height: "4",
      width: "20",
      x: "2",
      y: "10"
    }))
  });

  createIcon({
    displayName: "HamburgerIcon",
    viewBox: "0 0 24 24",
    d: "M 3 5 A 1.0001 1.0001 0 1 0 3 7 L 21 7 A 1.0001 1.0001 0 1 0 21 5 L 3 5 z M 3 11 A 1.0001 1.0001 0 1 0 3 13 L 21 13 A 1.0001 1.0001 0 1 0 21 11 L 3 11 z M 3 17 A 1.0001 1.0001 0 1 0 3 19 L 21 19 A 1.0001 1.0001 0 1 0 21 17 L 3 17 z"
  });

  var _templateObject;
  var bounce = keyframes$2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0%, 80%, 100% { opacity: 0.3; transform: scale(0.6); }\n  40% { opacity: 1; transform: scale(1); }\n"])));
  var ThreeDotLoader = function ThreeDotLoader() {
    return /*#__PURE__*/React.createElement(Flex, {
      align: "center",
      gap: "3px",
      ml: 2,
      "aria-label": "Evaluating"
    }, [0, 1, 2].map(function (i) {
      return /*#__PURE__*/React.createElement(Box, {
        key: i,
        w: "5px",
        h: "5px",
        borderRadius: "50%",
        bg: "gray.400",
        sx: {
          animation: "".concat(bounce, " 1.2s ease-in-out ").concat(i * 0.16, "s infinite")
        }
      });
    }));
  };
  var formatSpanOption = function formatSpanOption(span, allSpans) {
    var maxLen = 80;
    var text = span.coveredText || '(empty span)';
    var truncated = text.length > maxLen ? text.substring(0, maxLen) + '...' : text;

    // Check if another span has the same truncated text — disambiguate with offset
    var hasDuplicate = allSpans.some(function (s) {
      return s.id !== span.id && (s.coveredText || '(empty span)').substring(0, maxLen) === text.substring(0, maxLen);
    });
    if (hasDuplicate) {
      return "".concat(truncated, " (").concat(span.beginOffset, "-").concat(span.endOffset, ")");
    }
    return truncated;
  };
  /**
   * Renders a single rubric question with its answer options.
   * Currently supports MULTIPLE_CHOICE questions rendered as dropdowns.
   */
  var RubricQuestionField = function RubricQuestionField(_ref) {
    var workflowQuestion = _ref.workflowQuestion,
      currentAnswer = _ref.currentAnswer,
      onAnswerChange = _ref.onAnswerChange,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isAutofilled = _ref.isAutofilled,
      isAutofilled = _ref$isAutofilled === void 0 ? false : _ref$isAutofilled,
      filteredAnswerIds = _ref.filteredAnswerIds,
      _ref$isEvaluating = _ref.isEvaluating,
      isEvaluating = _ref$isEvaluating === void 0 ? false : _ref$isEvaluating,
      spans = _ref.spans;
    var effectiveDisabled = isDisabled || isAutofilled;
    var question = workflowQuestion.question;
    var labelText = "".concat(question.questionText || question.name).concat(isAutofilled ? ' (Autofilled)' : '');

    // Compute visible answers - filter by filteredAnswerIds if provided (SET_ANSWERS trigger)
    var visibleAnswers = React.useMemo(function () {
      var answers = question.answers || [];
      var activeAnswers = answers.filter(function (a) {
        return a.active !== false;
      });
      if (filteredAnswerIds && filteredAnswerIds.length > 0) {
        return activeAnswers.filter(function (a) {
          return filteredAnswerIds.includes(a.id);
        });
      }
      return activeAnswers;
    }, [question.answers, filteredAnswerIds]);
    var handleChange = React.useCallback(function (e) {
      var value = parseInt(e.target.value, 10);
      if (!isNaN(value)) {
        onAnswerChange(value);
      }
    }, [onAnswerChange]);

    // Get current value - use explicit null check for clarity
    var currentValue = (currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answerValueId) != null ? currentAnswer.answerValueId.toString() : '';

    // Render based on question type
    // Both MULTIPLE_CHOICE and SYSTEM question types render as dropdowns
    if (question.questionType === 'MULTIPLE_CHOICE' || question.questionType === 'SYSTEM') {
      return /*#__PURE__*/React.createElement(Tooltip, {
        label: "Question autofilled by previous answers",
        isDisabled: !isAutofilled,
        placement: "top",
        hasArrow: true
      }, /*#__PURE__*/React.createElement(FormControl, {
        size: "sm",
        isRequired: question.required,
        isDisabled: effectiveDisabled
      }, /*#__PURE__*/React.createElement(FormLabel, {
        fontSize: uiCommon.pxToRem(12),
        mb: 1,
        color: "gray.600"
      }, labelText), /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-select",
        value: currentValue,
        onChange: handleChange,
        disabled: effectiveDisabled,
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true
      }, "Select an option"), visibleAnswers.map(function (answer) {
        return /*#__PURE__*/React.createElement("option", {
          key: answer.id,
          value: answer.id
        }, answer.displayText || answer.name);
      })), isEvaluating && /*#__PURE__*/React.createElement(ThreeDotLoader, null))));
    }

    // FREE_TEXT: use DelayedInputBox (debounced save, blur save, Enter submit, Shift+Enter new line)
    if (question.questionType === 'FREE_TEXT') {
      var _currentAnswer$answer;
      return /*#__PURE__*/React.createElement(Tooltip, {
        label: "Question autofilled by previous answers",
        isDisabled: !isAutofilled,
        placement: "top",
        hasArrow: true
      }, /*#__PURE__*/React.createElement(Flex, {
        align: "flex-end"
      }, /*#__PURE__*/React.createElement(Box, {
        flex: 1
      }, /*#__PURE__*/React.createElement(uiComponents.DelayedInputBox, {
        label: labelText,
        value: (_currentAnswer$answer = currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.answerDisplayText) !== null && _currentAnswer$answer !== void 0 ? _currentAnswer$answer : '',
        onSave: function onSave(trimmed) {
          return onAnswerChange(trimmed);
        },
        isRequired: question.required,
        isDisabled: effectiveDisabled
      })), isEvaluating && /*#__PURE__*/React.createElement(ThreeDotLoader, null)));
    }

    // SPAN: render a single-select dropdown of span annotations
    if (question.questionType === 'SPAN') {
      var _currentAnswer$spanAn;
      var selectedId = currentAnswer === null || currentAnswer === void 0 || (_currentAnswer$spanAn = currentAnswer.spanAnnotationIds) === null || _currentAnswer$spanAn === void 0 ? void 0 : _currentAnswer$spanAn[0];
      var spanList = spans || [];
      return /*#__PURE__*/React.createElement(FormControl, {
        size: "sm",
        isRequired: question.required,
        isDisabled: isDisabled
      }, /*#__PURE__*/React.createElement(FormLabel, {
        fontSize: uiCommon.pxToRem(12),
        mb: 1,
        color: "gray.600"
      }, question.questionText || question.name), /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement("select", {
        className: "form-select",
        value: selectedId != null ? selectedId.toString() : '',
        onChange: function onChange(e) {
          var val = parseInt(e.target.value, 10);
          if (!isNaN(val)) {
            onAnswerChange([val]);
          }
        },
        disabled: isDisabled || spanList.length === 0,
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("option", {
        value: "",
        disabled: true
      }, spanList.length === 0 ? 'No spans available' : 'Select a span'), spanList.map(function (span) {
        return /*#__PURE__*/React.createElement("option", {
          key: span.id,
          value: span.id.toString()
        }, formatSpanOption(span, spanList));
      })), isEvaluating && /*#__PURE__*/React.createElement(ThreeDotLoader, null)));
    }

    // SPANS: render a multi-select dropdown of span annotations
    if (question.questionType === 'SPANS') {
      var _currentAnswer$spanAn2;
      var selectedIds = (_currentAnswer$spanAn2 = currentAnswer === null || currentAnswer === void 0 ? void 0 : currentAnswer.spanAnnotationIds) !== null && _currentAnswer$spanAn2 !== void 0 ? _currentAnswer$spanAn2 : [];
      var _spanList = spans || [];
      var selectedStrings = selectedIds.map(function (id) {
        return id.toString();
      });

      // Build display label for the button
      var selectedCount = selectedIds.length;
      var buttonLabel = _spanList.length === 0 ? 'No spans available' : selectedCount === 0 ? 'Select spans' : "".concat(selectedCount, " span").concat(selectedCount > 1 ? 's' : '', " selected");
      return /*#__PURE__*/React.createElement(FormControl, {
        size: "sm",
        isRequired: question.required,
        isDisabled: isDisabled
      }, /*#__PURE__*/React.createElement(FormLabel, {
        fontSize: uiCommon.pxToRem(12),
        mb: 1,
        color: "gray.600"
      }, question.questionText || question.name), /*#__PURE__*/React.createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React.createElement(Menu, {
        closeOnSelect: false
      }, /*#__PURE__*/React.createElement(MenuButton$1, {
        as: Button,
        rightIcon: /*#__PURE__*/React.createElement(ChevronDownIcon, null),
        size: "sm",
        variant: "outline",
        flex: 1,
        textAlign: "left",
        fontWeight: "normal",
        isDisabled: isDisabled || _spanList.length === 0
      }, buttonLabel), /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(MenuList$1, {
        maxH: "250px",
        overflowY: "auto",
        zIndex: 1400
      }, /*#__PURE__*/React.createElement(MenuOptionGroup, {
        type: "checkbox",
        value: selectedStrings,
        onChange: function onChange(values) {
          var ids = values.map(function (v) {
            return parseInt(v, 10);
          });
          onAnswerChange(ids);
        }
      }, _spanList.map(function (span) {
        return /*#__PURE__*/React.createElement(MenuItemOption, {
          key: span.id,
          value: span.id.toString()
        }, formatSpanOption(span, _spanList));
      }))))), isEvaluating && /*#__PURE__*/React.createElement(ThreeDotLoader, null)));
    }

    // Fallback for unsupported question types
    return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(12),
      color: "gray.500"
    }, "Unsupported question type: ", question.questionType));
  };

  function ownKeys$I(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$I(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$I(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$I(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  /**
   * Utility functions for rubric workflow question processing
   */

  /**
   * Gets the workflow for a specific code type from the rubric version
   *
   * @param rubricVersion - Full rubric version with all workflows
   * @param codeType - Type of code ('procedure', 'diagnosis', 'modifier')
   * @returns The code workflow or undefined if not found
   */
  var getWorkflowForCodeType = function getWorkflowForCodeType(rubricVersion, codeType) {
    if (!(rubricVersion !== null && rubricVersion !== void 0 && rubricVersion.workflows)) {
      return undefined;
    }

    // Map code type to workflow type
    var workflowTypeMap = {
      'procedure': 'PROCEDURE',
      'diagnosis': 'DIAGNOSIS',
      'modifier': 'MODIFIER',
      'case': 'CASE',
      'span': 'SPAN'
    };
    var workflowType = workflowTypeMap[codeType.toLowerCase()];
    if (!workflowType) {
      return undefined;
    }
    var workflowEntry = rubricVersion.workflows.find(function (w) {
      return w.workflow.codeType === workflowType;
    });
    if (!workflowEntry) {
      return undefined;
    }

    // Return workflow object with questions attached
    // (questions are a sibling to workflow in the API response structure)
    return _objectSpread$I(_objectSpread$I({}, workflowEntry.workflow), {}, {
      questions: workflowEntry.questions
    });
  };

  /**
   * Finds an attribute for a specific question from the code's attributes
   *
   * @param attributes - Array of attributes
   * @param questionId - The question ID to find
   * @returns The matching attribute or undefined
   */
  var findAnswerForQuestion = function findAnswerForQuestion(attributes, questionId) {
    if (!attributes) {
      return undefined;
    }
    return attributes.find(function (a) {
      return a.questionId === questionId;
    });
  };

  /**
   * Maps a code type string to the corresponding attribute entity type for API calls.
   * This is a centralized mapping used across all rubric question components.
   *
   * @param codeType - The code type ('procedure', 'diagnosis', 'modifier', 'case')
   * @returns The corresponding attribute entity type
   */
  /**
   * Gets question IDs that should be cleared when a question's answer changes.
   * Uses the backend-provided visible questions to determine downstream questions
   * and also finds stale attributes from previously visited workflow branches.
   *
   * @param visibleQuestions - Currently visible workflow questions (from backend evaluation)
   * @param attributes - Current saved attributes on the entity
   * @param changedQuestionId - The question whose answer is changing
   * @returns Array of question IDs whose attributes should be deleted
   */
  var getQuestionIdsToClear = function getQuestionIdsToClear(visibleQuestions, attributes, changedQuestionId) {
    // Find downstream: all visible questions after the changed question
    var changedIndex = visibleQuestions.findIndex(function (wq) {
      return wq.question.id === changedQuestionId;
    });
    var downstream = changedIndex >= 0 ? visibleQuestions.slice(changedIndex + 1).map(function (wq) {
      return wq.question.id;
    }) : [];

    // Find stale: attributes for questions not currently visible (from old branches)
    var visibleIds = new Set(visibleQuestions.map(function (wq) {
      return wq.question.id;
    }));
    visibleIds.add(changedQuestionId);
    var staleIds = attributes.filter(function (a) {
      return !visibleIds.has(a.questionId);
    }).map(function (a) {
      return a.questionId;
    });

    // Combine and deduplicate
    return _toConsumableArray(new Set([].concat(_toConsumableArray(downstream), _toConsumableArray(staleIds))));
  };
  var codeTypeToEntityType$1 = function codeTypeToEntityType(codeType) {
    switch (codeType.toLowerCase()) {
      case 'procedure':
        return 'code_procedure';
      case 'diagnosis':
        return 'code_diagnosis';
      case 'modifier':
        return 'code_modifier';
      case 'case':
        return 'case';
      case 'span':
        return 'span';
      default:
        return 'code_procedure';
      // fallback
    }
  };

  /**
   * Hook that manages autofill logic for rubric questions.
   *
   * Handles the complex timing of:
   * 1. Preventing autofill when state is stale (race condition with API)
   * 2. Applying autofill when triggers fire
   * 3. Tracking which questions have been autofilled to prevent loops
   * 4. Resetting tracking when the entity changes
   * 5. Clearing downstream tracking when upstream answers change
   *
   * @example
   * const { trackAnswerChange, clearDownstreamTracking } = useRubricAutofill({
   *   entityId: code.id,
   *   entityKey: `${code.id}`,
   *   attributes: code.attributes || [],
   *   autofilledAnswers,
   *   onAutofill: handleAnswerChange
   * });
   *
   * // In your handleAnswerChange:
   * trackAnswerChange(questionId, answerValueId);
   * clearDownstreamTracking(downstreamIds);
   * await handleAnswerChangeWithCleanup({...});
   */
  function useRubricAutofill(_ref) {
    var entityId = _ref.entityId,
      entityKey = _ref.entityKey,
      attributes = _ref.attributes,
      autofilledAnswers = _ref.autofilledAnswers,
      onAutofill = _ref.onAutofill;
    // Track which questions have had autofill applied to prevent loops
    var appliedAutofillsRef = React.useRef(new Set());

    // Track pending answer change to verify state is fresh before autofilling
    var pendingAnswerRef = React.useRef(null);

    // When downstream answers are cleared, block autofills until fresh evaluation data arrives.
    // Without this, stale autofilledAnswers can re-apply a cleared autofill before the new
    // evaluation (which no longer includes the autofill) has returned.
    var awaitingFreshEvalRef = React.useRef(false);

    // Reset the flag when evaluation data refreshes (autofilledAnswers reference changes).
    // This effect MUST be defined before the autofill effect so it runs first in the same
    // render cycle, allowing the autofill effect to proceed with fresh data.
    React.useEffect(function () {
      awaitingFreshEvalRef.current = false;
    }, [autofilledAnswers]);

    // Apply auto-filled answers when triggers fire
    React.useEffect(function () {
      // Skip autofills while waiting for fresh evaluation data after a downstream clear.
      // The stale autofilledAnswers map may still reference cleared questions.
      if (awaitingFreshEvalRef.current) return;

      // If there's a pending answer change, check if it's reflected in state
      if (pendingAnswerRef.current) {
        var _pendingAnswerRef$cur = pendingAnswerRef.current,
          questionId = _pendingAnswerRef$cur.questionId,
          answerValueId = _pendingAnswerRef$cur.answerValueId;
        var currentAnswer = findAnswerForQuestion(attributes, questionId);
        // If the pending answer is NOT yet in state, skip (data is stale)
        if (!currentAnswer || currentAnswer.answerValueId !== answerValueId) {
          return;
        }
        // Answer IS reflected in state, clear pending and proceed
        pendingAnswerRef.current = null;
      }
      if (autofilledAnswers.size === 0) return;
      autofilledAnswers.forEach(function (answerValueIds, questionId) {
        var autofillKey = "".concat(entityKey, "-").concat(questionId);
        // Skip if we've already applied autofill for this question
        if (appliedAutofillsRef.current.has(autofillKey)) return;

        // Only apply if the question doesn't already have an answer
        var existingAnswer = findAnswerForQuestion(attributes, questionId);
        if (!existingAnswer && answerValueIds.length > 0) {
          appliedAutofillsRef.current.add(autofillKey);
          // Apply the first answer value (for single-select questions)
          onAutofill(questionId, answerValueIds[0]);
        }
      });
    }, [autofilledAnswers, attributes, entityKey, onAutofill]);

    // Reset autofill tracking when the entity changes
    React.useEffect(function () {
      appliedAutofillsRef.current.clear();
    }, [entityId]);

    // Track an answer change to verify state is fresh before autofilling
    var trackAnswerChange = React.useCallback(function (questionId, answerValueId) {
      pendingAnswerRef.current = {
        questionId: questionId,
        answerValueId: answerValueId
      };
    }, []);

    // Clear tracking for downstream questions being cleared.
    // Also sets the awaitingFreshEval flag to block stale autofill re-application
    // until the next evaluation completes with fresh autofilledAnswers data.
    var clearDownstreamTracking = React.useCallback(function (downstreamQuestionIds) {
      downstreamQuestionIds.forEach(function (id) {
        appliedAutofillsRef.current.delete("".concat(entityKey, "-").concat(id));
      });
      if (downstreamQuestionIds.length > 0) {
        awaitingFreshEvalRef.current = true;
      }
    }, [entityKey]);
    return {
      trackAnswerChange: trackAnswerChange,
      clearDownstreamTracking: clearDownstreamTracking
    };
  }

  function ownKeys$H(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$H(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$H(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$H(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  /**
   * Calls the backend workflow evaluation API and returns pre-mapped results
   * ready for rendering. Shows loading state during backend evaluation.
   */
  function useWorkflowEvaluation(_ref) {
    var workflowId = _ref.workflowId,
      attributes = _ref.attributes,
      workflowQuestions = _ref.workflowQuestions,
      codeContext = _ref.codeContext,
      workItemId = _ref.workItemId,
      evaluateFn = _ref.evaluateFn,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled;
    var dispatch = useDispatch();
    var sdCaseId = useSelector(function (state) {
      var _state$gradeBenchPane;
      return (_state$gradeBenchPane = state.gradeBenchPanel) === null || _state$gradeBenchPane === void 0 || (_state$gradeBenchPane = _state$gradeBenchPane.invoices) === null || _state$gradeBenchPane === void 0 || (_state$gradeBenchPane = _state$gradeBenchPane[0]) === null || _state$gradeBenchPane === void 0 ? void 0 : _state$gradeBenchPane.sdCaseId;
    });
    var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      evaluation = _useState2[0],
      setEvaluation = _useState2[1];
    var _useState3 = React.useState(enabled && !!workflowId),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];
    var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

    // Stabilize evaluateFn so callers don't need to memoize it
    var evaluateFnRef = React.useRef(evaluateFn);
    evaluateFnRef.current = evaluateFn;

    // Serialize attributes to a stable string so the effect only re-fires on value changes
    var attributesKey = React.useMemo(function () {
      return JSON.stringify(attributes.map(function (a) {
        var _ref2, _a$answerValueId, _a$spanAnnotationIds;
        return "".concat(a.questionId, ":").concat((_ref2 = (_a$answerValueId = a.answerValueId) !== null && _a$answerValueId !== void 0 ? _a$answerValueId : (_a$spanAnnotationIds = a.spanAnnotationIds) === null || _a$spanAnnotationIds === void 0 ? void 0 : _a$spanAnnotationIds.join(',')) !== null && _ref2 !== void 0 ? _ref2 : a.answerDisplayText);
      }));
    }, [attributes]);

    // Serialize context objects for stable dependency comparison
    var codeContextKey = React.useMemo(function () {
      return codeContext ? JSON.stringify(codeContext) : '';
    }, [codeContext]);
    React.useEffect(function () {
      if (!enabled || !workflowId) {
        setIsLoading(false);
        return;
      }

      // Use a local variable instead of a shared ref for cancellation.
      // Each effect invocation gets its own `cancelled` flag so that when
      // a newer invocation's cleanup marks a previous one as cancelled,
      // it doesn't get reset by the newer invocation (which was the bug
      // with the shared cancelledRef — the new effect would set
      // cancelledRef.current = false, un-cancelling the stale in-flight request).
      var cancelled = false;
      setIsLoading(true);
      setError(null);

      // Debounce evaluation to avoid rapid-fire API calls when attributes change quickly
      // (e.g., multiple downstream clears followed by the new answer save).
      var timerId = setTimeout(function () {
        var request = {
          workflowId: workflowId,
          attributes: attributes.filter(function (a) {
            return a.answerValueId != null || a.spanAnnotationIds != null && a.spanAnnotationIds.length > 0;
          }).map(function (a) {
            return _objectSpread$H(_objectSpread$H({
              questionId: a.questionId
            }, a.answerValueId != null ? {
              answerValueId: a.answerValueId
            } : {}), a.spanAnnotationIds != null && a.spanAnnotationIds.length > 0 ? {
              spanAnnotationIds: a.spanAnnotationIds
            } : {});
          }),
          codeContext: codeContext,
          workItemId: workItemId,
          sdCaseId: sdCaseId
        };
        evaluateFnRef.current(request).then(function (result) {
          if (!cancelled) {
            setEvaluation(result);
            if (result.validation) {
              dispatch(uiCommon.gradeBenchPanelActions.setValidationResult(result.validation));
            }
          }
        }).catch(function (e) {
          if (!cancelled) {
            setError(e instanceof Error ? e : new Error(String(e)));
          }
        }).finally(function () {
          if (!cancelled) {
            setIsLoading(false);
          }
        });
      }, 100);
      return function () {
        cancelled = true;
        clearTimeout(timerId);
      };
      // Deps use serialized keys (attributesKey, etc.) for stable identity instead of object refs
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workflowId, attributesKey, codeContextKey, workItemId, enabled]);

    // Build question lookup map
    var questionMap = React.useMemo(function () {
      var map = new Map();
      workflowQuestions === null || workflowQuestions === void 0 || workflowQuestions.forEach(function (wq) {
        return map.set(wq.question.id, wq);
      });
      return map;
    }, [workflowQuestions]);

    // Map visible questions from API response to workflow question objects
    var visibleQuestions = React.useMemo(function () {
      var _evaluation$visibleQu;
      if (!(evaluation !== null && evaluation !== void 0 && (_evaluation$visibleQu = evaluation.visibleQuestions) !== null && _evaluation$visibleQu !== void 0 && _evaluation$visibleQu.length)) return [];
      return _toConsumableArray(evaluation.visibleQuestions).sort(function (a, b) {
        return a.sequenceOrder - b.sequenceOrder;
      }).map(function (vq) {
        return questionMap.get(vq.questionId);
      }).filter(function (wq) {
        return wq != null && wq.question.questionType !== 'SYSTEM';
      });
    }, [evaluation === null || evaluation === void 0 ? void 0 : evaluation.visibleQuestions, questionMap]);

    // Convert filteredAnswers Record to Map
    var filteredAnswersMap = React.useMemo(function () {
      if (!(evaluation !== null && evaluation !== void 0 && evaluation.filteredAnswers)) return new Map();
      return new Map(Object.entries(evaluation.filteredAnswers).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          k = _ref4[0],
          v = _ref4[1];
        return [Number(k), v];
      }));
    }, [evaluation === null || evaluation === void 0 ? void 0 : evaluation.filteredAnswers]);

    // Convert autofilledAnswers Record to Map
    var autofilledAnswersMap = React.useMemo(function () {
      if (!(evaluation !== null && evaluation !== void 0 && evaluation.autofilledAnswers)) return new Map();
      return new Map(Object.entries(evaluation.autofilledAnswers).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          k = _ref6[0],
          v = _ref6[1];
        return [Number(k), v];
      }));
    }, [evaluation === null || evaluation === void 0 ? void 0 : evaluation.autofilledAnswers]);
    return {
      evaluation: evaluation,
      visibleQuestions: visibleQuestions,
      filteredAnswersMap: filteredAnswersMap,
      autofilledAnswersMap: autofilledAnswersMap,
      isLoading: isLoading,
      error: error
    };
  }

  function ownKeys$G(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$G(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$G(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$G(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var HighlightDrawerCodeContainer = function HighlightDrawerCodeContainer(_ref) {
    var code = _ref.code,
      onDelete = _ref.onDelete,
      onAssessmentChange = _ref.onAssessmentChange,
      onRoleChange = _ref.onRoleChange;
      _ref.riskCategories;
      _ref.cqaCodeAssessmentRiskDictionaries;
      var projectConfiguration = _ref.projectConfiguration,
      cptFields = _ref.cptFields,
      icdFields = _ref.icdFields,
      modifierFields = _ref.modifierFields,
      rubricWorkflow = _ref.rubricWorkflow,
      hasRubricVersion = _ref.hasRubricVersion,
      onAnswerChange = _ref.onAnswerChange,
      onDeleteAnswer = _ref.onDeleteAnswer,
      onClearDownstream = _ref.onClearDownstream,
      evaluateFn = _ref.evaluateFn,
      workItemId = _ref.workItemId,
      spans = _ref.spans,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? true : _ref$editable;
    var allFields = React.useMemo(function () {
      if (code.codeType === 'procedure') return cptFields || [];
      if (code.codeType === 'diagnosis') return icdFields || [];
      if (code.codeType === 'modifier') return modifierFields || [];
      return [];
    }, [code.codeType, cptFields, icdFields, modifierFields]);
    var assessmentField = React.useMemo(function () {
      var _code$original, _field$rerenderFields;
      var fieldFromArray = allFields.find(function (f) {
        return f.key === 'assessment';
      });
      var field = fieldFromArray || (code.codeType === 'modifier' ? _objectSpread$G(_objectSpread$G({}, uiCommon.AssesmentSelect), {}, {
        optionsTreePath: uiCommon.modifierAssessmentOptionsTreePath
      }) : uiCommon.AssesmentSelect);
      var codeValue = _objectSpread$G(_objectSpread$G({}, code), {}, {
        original: (_code$original = code.original) !== null && _code$original !== void 0 ? _code$original : false,
        codeAssessment: code.codeAssessment || null
      });
      var options = uiCommon.getOptionsFromTree(codeValue, field.optionsTree, field.optionsTreePath) || [];
      var currentValue = uiCommon.getValueAtPath(code, field.path) || '';
      var rerenderKey = ((_field$rerenderFields = field.rerenderFields) === null || _field$rerenderFields === void 0 ? void 0 : _field$rerenderFields.map(function (f) {
        return uiCommon.getValueAtPath(code, [f]);
      }).join('-')) || '';
      return {
        field: field,
        options: options,
        currentValue: currentValue,
        rerenderKey: rerenderKey,
        valueInOptions: options.includes(currentValue)
      };
    }, [allFields, code]);
    var roleField = React.useMemo(function () {
      var _code$original2, _field$rerenderFields2;
      var fieldFromArray = allFields.find(function (f) {
        return f.key === 'role';
      });
      var field = fieldFromArray || (code.codeType === 'modifier' ? _objectSpread$G(_objectSpread$G({}, uiCommon.RoleSelect), {}, {
        optionsTreePath: uiCommon.modifierRoleOptionsTreePath
      }) : uiCommon.RoleSelect);
      var codeValue = _objectSpread$G(_objectSpread$G({}, code), {}, {
        original: (_code$original2 = code.original) !== null && _code$original2 !== void 0 ? _code$original2 : false,
        codeAssessment: code.codeAssessment || null
      });
      var options = uiCommon.getOptionsFromTree(codeValue, field.optionsTree, field.optionsTreePath) || [];
      var currentValue = uiCommon.getValueAtPath(code, field.path) || '';
      var rerenderKey = ((_field$rerenderFields2 = field.rerenderFields) === null || _field$rerenderFields2 === void 0 ? void 0 : _field$rerenderFields2.map(function (f) {
        return uiCommon.getValueAtPath(code, [f]);
      }).join('-')) || '';
      return {
        field: field,
        options: options,
        currentValue: currentValue,
        rerenderKey: rerenderKey,
        valueInOptions: options.includes(currentValue)
      };
    }, [allFields, code]);
    var handleDelete = function handleDelete() {
      if (onDelete) {
        onDelete(code);
      }
    };
    var codeContext = React.useMemo(function () {
      var _code$original3, _code$sequenceNumber;
      return {
        original: (_code$original3 = code.original) !== null && _code$original3 !== void 0 ? _code$original3 : null,
        code: code.value,
        sequenceNumber: (_code$sequenceNumber = code.sequenceNumber) !== null && _code$sequenceNumber !== void 0 ? _code$sequenceNumber : 0,
        codeType: code.codeType
      };
    }, [code.original, code.value, code.sequenceNumber, code.codeType]);
    var _useWorkflowEvaluatio = useWorkflowEvaluation({
        workflowId: rubricWorkflow === null || rubricWorkflow === void 0 ? void 0 : rubricWorkflow.id,
        attributes: code.attributes || [],
        workflowQuestions: rubricWorkflow === null || rubricWorkflow === void 0 ? void 0 : rubricWorkflow.questions,
        codeContext: codeContext,
        workItemId: workItemId,
        evaluateFn: evaluateFn,
        enabled: !!evaluateFn && !!rubricWorkflow
      }),
      evaluation = _useWorkflowEvaluatio.evaluation,
      visibleQuestions = _useWorkflowEvaluatio.visibleQuestions,
      filteredAnswersMap = _useWorkflowEvaluatio.filteredAnswersMap,
      autofilledAnswersMap = _useWorkflowEvaluatio.autofilledAnswersMap,
      isLoading = _useWorkflowEvaluatio.isLoading,
      error = _useWorkflowEvaluatio.error;
    var handleAnswerChangeWithCleanup = uiCommon.useHandleRubricAnswerChange(onAnswerChange || function () {}, onDeleteAnswer || /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), onClearDownstream);

    // Use a ref to break the circular dependency between hook and handler
    var handleRubricAnswerChangeRef = React.useRef(function () {});

    // Use the autofill hook to handle autofill logic (only for multiple-choice; FREE_TEXT has no autofill)
    var _useRubricAutofill = useRubricAutofill({
        entityId: code.codeId.toString(),
        entityKey: "".concat(code.codeId),
        attributes: code.attributes || [],
        autofilledAnswers: autofilledAnswersMap,
        onAutofill: function onAutofill(questionId, answerValueId) {
          handleRubricAnswerChangeRef.current(questionId, answerValueId);
        }
      }),
      trackAnswerChange = _useRubricAutofill.trackAnswerChange,
      clearDownstreamTracking = _useRubricAutofill.clearDownstreamTracking;
    var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastChangedCodeQuestionId = _useState2[0],
      setLastChangedCodeQuestionId = _useState2[1];

    // Handle rubric answer change - wraps the shared hook with code-specific params
    // value: number = answerValueId (MULTIPLE_CHOICE/SYSTEM), number[] = spanAnnotationIds (SPAN/SPANS), string = answerDisplayText (FREE_TEXT)
    var handleRubricAnswerChange = React.useCallback(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(questionId, value) {
        var _visibleQuestions$fin;
        var downstreamIds, isFreeText, question, isSpan, isSpans, answerParams;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (onAnswerChange) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              setLastChangedCodeQuestionId(questionId);
              downstreamIds = getQuestionIdsToClear(visibleQuestions, code.attributes || [], questionId);
              isFreeText = typeof value === 'string';
              if (!isFreeText && typeof value === 'number') {
                trackAnswerChange(questionId, value);
              }
              clearDownstreamTracking(downstreamIds);

              // Use real attributes for the save operation (not virtual system question answers)
              // Determine which answer field to use based on question type
              question = (_visibleQuestions$fin = visibleQuestions.find(function (wq) {
                return wq.question.id === questionId;
              })) === null || _visibleQuestions$fin === void 0 ? void 0 : _visibleQuestions$fin.question;
              isSpan = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPAN';
              isSpans = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPANS';
              if (isFreeText) {
                answerParams = {
                  answerDisplayText: value
                };
              } else if (isSpan || isSpans) {
                answerParams = {
                  spanAnnotationIds: value
                };
              } else {
                answerParams = {
                  answerValueId: value
                };
              }
              _context2.next = 2;
              return handleAnswerChangeWithCleanup(_objectSpread$G(_objectSpread$G({
                entityId: code.codeId.toString(),
                entityType: codeTypeToEntityType$1(code.codeType),
                attributes: code.attributes || [],
                questionId: questionId
              }, answerParams), {}, {
                downstreamQuestionIds: downstreamIds
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x, _x2) {
        return _ref3.apply(this, arguments);
      };
    }(), [handleAnswerChangeWithCleanup, onAnswerChange, code.codeId, code.codeType, code.attributes, visibleQuestions, rubricWorkflow, trackAnswerChange, clearDownstreamTracking]);
    handleRubricAnswerChangeRef.current = handleRubricAnswerChange;
    var hasRubricWorkflow = rubricWorkflow && rubricWorkflow.questions && rubricWorkflow.questions.length > 0;
    var shouldHideAssessmentRole = Boolean(hasRubricVersion);
    var handleAssessmentChange = function handleAssessmentChange(e) {
      if (onAssessmentChange && assessmentField) {
        onAssessmentChange(code, assessmentField.field, allFields, e.target.value);
      }
    };
    var handleRoleChange = function handleRoleChange(e) {
      if (onRoleChange && roleField) {
        onRoleChange(code, roleField.field, allFields, e.target.value);
      }
    };
    var showAssessment = (projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.assessment) !== false;
    var showRole = (projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.role) !== false;
    var showLegacyAssessment = !shouldHideAssessmentRole && showAssessment;
    var showLegacyRole = !shouldHideAssessmentRole && showRole;
    var classNames = classnames('code-container', code.codeType);
    return /*#__PURE__*/React.createElement(Box, {
      className: classNames
    }, /*#__PURE__*/React.createElement(VStack, {
      spacing: 3,
      align: "stretch"
    }, /*#__PURE__*/React.createElement(HStack, {
      spacing: 3,
      align: "center",
      width: "100%"
    }, /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
      code: code.value,
      codeType: code.codeType,
      description: code.description,
      editable: false
    }), /*#__PURE__*/React.createElement(Text, {
      flex: 1
    }, code.description), onDelete && /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Delete code",
      icon: /*#__PURE__*/React.createElement(uiComponents.Icon, {
        svgIconName: "BiomeDelete",
        svgIconSize: "16"
      }),
      size: "sm",
      variant: "ghost",
      onClick: handleDelete
    })), hasRubricWorkflow && error ? /*#__PURE__*/React.createElement(Alert, {
      status: "error",
      variant: "left-accent",
      borderRadius: "md"
    }, /*#__PURE__*/React.createElement(AlertIcon$1, null), /*#__PURE__*/React.createElement(AlertDescription, {
      fontSize: "sm"
    }, "Unable to load questions. Please try refreshing the page.")) : hasRubricWorkflow && isLoading && !evaluation ? /*#__PURE__*/React.createElement(Center, {
      py: 4
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "sm"
    })) : hasRubricWorkflow && visibleQuestions.length > 0 ? /*#__PURE__*/React.createElement(VStack, {
      spacing: 3,
      align: "stretch"
    }, visibleQuestions.map(function (wq) {
      return /*#__PURE__*/React.createElement(RubricQuestionField, {
        key: wq.question.id,
        workflowQuestion: wq,
        currentAnswer: findAnswerForQuestion(code.attributes, wq.question.id),
        onAnswerChange: function onAnswerChange(value) {
          return handleRubricAnswerChange(wq.question.id, value);
        },
        filteredAnswerIds: filteredAnswersMap.get(wq.question.id),
        isAutofilled: autofilledAnswersMap.has(wq.question.id),
        isDisabled: !editable || isLoading,
        isEvaluating: isLoading && lastChangedCodeQuestionId === wq.question.id,
        spans: spans
      });
    })) : !hasRubricWorkflow ? /*#__PURE__*/React.createElement(React.Fragment, null, showLegacyAssessment && assessmentField && /*#__PURE__*/React.createElement(Select, {
      key: assessmentField.rerenderKey,
      placeholder: assessmentField.field.placeholder,
      value: assessmentField.currentValue,
      onChange: handleAssessmentChange,
      size: "sm"
    }, !assessmentField.valueInOptions && assessmentField.currentValue && /*#__PURE__*/React.createElement("option", {
      value: assessmentField.currentValue,
      disabled: true
    }, assessmentField.currentValue), assessmentField.options.map(function (option) {
      return /*#__PURE__*/React.createElement("option", {
        key: option,
        value: option
      }, option);
    })), showLegacyRole && roleField && /*#__PURE__*/React.createElement(Select, {
      key: roleField.rerenderKey,
      placeholder: roleField.field.placeholder,
      value: roleField.currentValue,
      onChange: handleRoleChange,
      size: "sm"
    }, !roleField.valueInOptions && roleField.currentValue && /*#__PURE__*/React.createElement("option", {
      value: roleField.currentValue,
      disabled: true
    }, roleField.currentValue), roleField.options.map(function (option) {
      return /*#__PURE__*/React.createElement("option", {
        key: option,
        value: option
      }, option);
    }))) : null));
  };

  var ChargeSessionCodeProvenance$2 = uiCommon.commonEnums.ChargeSessionCodeProvenance;
  var matchRequirements = function matchRequirements(codeQuery) {
    var _codeQuery$text = codeQuery.text,
      text = _codeQuery$text === void 0 ? '' : _codeQuery$text,
      _codeQuery$searchType = codeQuery.searchType,
      searchType = _codeQuery$searchType === void 0 ? '' : _codeQuery$searchType;
    return text.length > 2 || text.length === 2 && searchType === ChargeSessionCodeProvenance$2.MODIFIER;
  };

  function isElementVisible(activeElement, ancestorElement) {
    // this function takes two elements and determines if the activeElement
    // is *fully* visible in the field of view for the ancestorElement.

    // activeElement dimensions
    var offsetTop = activeElement.offsetTop,
      offsetHeight = activeElement.offsetHeight;
    var elementBottom = offsetHeight + offsetTop;

    // boundaries for the ancestorElement
    var containerTop = ancestorElement.scrollTop;
    var containerBottom = ancestorElement.scrollTop + ancestorElement.offsetHeight;
    var above = offsetTop < containerTop;
    var below = elementBottom > containerBottom;
    var topIsWithin = offsetTop >= containerTop && offsetTop < containerBottom;
    var bottomIsWithin = elementBottom <= containerBottom && elementBottom > containerTop;
    var visibility = {
      contained: !above && !below,
      above: above,
      below: below,
      topIsWithin: topIsWithin,
      bottomIsWithin: bottomIsWithin
    };
    return visibility;
  }

  var InvoiceTypes$1 = uiCommon.commonEnums.InvoiceTypes;
  var artifactTypeToDisplayName = function artifactTypeToDisplayName(artifactType) {
    switch (artifactType) {
      case InvoiceTypes$1.CLINICAL.toString():
        return 'Provider';
      case InvoiceTypes$1.MAPPED.toString():
        return 'Rule';
      case InvoiceTypes$1.PREDICTION.toString():
        return 'Prediction';
      case InvoiceTypes$1.ASSEMBLED.toString():
        return 'Assembled';
      case InvoiceTypes$1.CODED.toString():
        return 'Coded';
      default:
        return uiCommon.toCapitalCase(artifactType);
    }
  };
  var CodeProvenanceChip = function CodeProvenanceChip(props) {
    var codeProvenance = props.codeProvenance,
      _props$count = props.count,
      count = _props$count === void 0 ? 1 : _props$count;
    var artifactTypeDisplayName = artifactTypeToDisplayName(codeProvenance.artifact_type);
    var qaClass = "qa-code-provenance-chip-".concat(codeProvenance.artifact_type);
    return /*#__PURE__*/React.createElement("div", {
      className: "code-provenance-chip ".concat(qaClass)
    }, count > 1 && /*#__PURE__*/React.createElement("span", {
      className: "chip-count"
    }, count), artifactTypeDisplayName);
  };
  var CodeProvenanceChipRow = function CodeProvenanceChipRow(props) {
    var codeProvenances = props.codeProvenances,
      className = props.className;

    // Group provenances by artifact type using array
    var groupedProvenances = (codeProvenances || []).filter(function (provenance) {
      return provenance;
    }).reduce(function (acc, provenance) {
      var existingGroup = acc.find(function (group) {
        return group.provenance.artifact_type === provenance.artifact_type;
      });
      if (existingGroup) {
        existingGroup.count++;
      } else {
        acc.push({
          provenance: provenance,
          count: 1
        });
      }
      return acc;
    }, []);
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('code-provenance-chip-row', className)
    }, groupedProvenances.map(function (_ref) {
      var provenance = _ref.provenance,
        count = _ref.count;
      return /*#__PURE__*/React.createElement(CodeProvenanceChip, {
        key: "".concat(provenance.artifact_type, "-").concat(count),
        codeProvenance: provenance,
        count: count
      });
    }));
  };

  uiCommon.commonEnums.SugggestedCodeType;
  var isSuggestedLinkedProcedure = function isSuggestedLinkedProcedure(codeInfo) {
    return 'units' in codeInfo && 'modifiers' in codeInfo;
  };
  var ResultRow = function ResultRow(props) {
    var _codeData$transaction, _codeData$transaction2, _codeInfo$codeType;
    var activeIdx = props.activeIdx,
      activeSelection = props.activeSelection,
      codeInfo = props.codeInfo,
      idx = props.idx;
      props.idxOffset;
      var _props$allowCodeRemov = props.allowCodeRemove,
      allowCodeRemove = _props$allowCodeRemov === void 0 ? false : _props$allowCodeRemov,
      _props$transactionGui = props.transactionGuid,
      transactionGuid = _props$transactionGui === void 0 ? '' : _props$transactionGui,
      _props$isSuggestedRow = props.isSuggestedRow,
      isSuggestedRow = _props$isSuggestedRow === void 0 ? false : _props$isSuggestedRow;
    var codeData = codeInfo;
    //const index = idxOffset + idx;
    var index = idx;
    var isFromSuggestedResult = activeSelection === ResultType.SUGGESTED_RESULTS;
    var isInCurrentTnx = (_codeData$transaction = codeData === null || codeData === void 0 || (_codeData$transaction2 = codeData.transaction_guids) === null || _codeData$transaction2 === void 0 ? void 0 : _codeData$transaction2.includes(transactionGuid)) !== null && _codeData$transaction !== void 0 ? _codeData$transaction : false;
    var _useState = React.useState(isInCurrentTnx),
      _useState2 = _slicedToArray(_useState, 2),
      isChecked = _useState2[0],
      setIsChecked = _useState2[1];
    React.useEffect(function () {
      if (isInCurrentTnx !== isChecked) setIsChecked(isInCurrentTnx);
    }, [codeInfo]);
    var activeIndex = isSuggestedRow && activeSelection === ResultType.SUGGESTED_RESULTS || !isSuggestedRow && activeSelection === ResultType.SEARCH_RESULTS ? activeIdx : -1;
    var styleClasses = ['search-result', "".concat(codeInfo === null || codeInfo === void 0 || (_codeInfo$codeType = codeInfo.codeType) === null || _codeInfo$codeType === void 0 ? void 0 : _codeInfo$codeType.toLowerCase(), "-code"), {
      'search-result-submittable': activeIndex === index
    }];
    var handleClick = function handleClick(event) {
      var checked = !isChecked;
      setIsChecked(checked); // Toggle the state
      var opType = checked ? 'add' : 'delete';
      props.handleClick(event, codeInfo, opType);
    };
    var isLinkedProcedure = isSuggestedLinkedProcedure(codeInfo);
    var modifierList = isLinkedProcedure ? codeInfo.modifiers.map(function (mod) {
      return /*#__PURE__*/React.createElement("span", {
        className: "chip",
        key: mod.code
      }, mod.code);
    }) : '';
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(isFromSuggestedResult ? 'suggested' : 'search', "-result-").concat(index),
      "data-idx": index,
      className: classnames(styleClasses),
      "data-dd-action-name": "~Select code (".concat(codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType.toLowerCase(), "-code)"),
      onClick: function onClick(ev) {
        return handleClick(ev);
      }
    }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [isSuggestedRow, allowCodeRemove]
    }, /*#__PURE__*/React.createElement(Checkbox, {
      value: isChecked,
      disabled: true,
      onChange: function onChange() {}
    })), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [isLinkedProcedure]
    }, /*#__PURE__*/React.createElement("span", {
      className: "col-units units-chip"
    }, codeInfo.units)), /*#__PURE__*/React.createElement("div", {
      className: "col-label search-label"
    }, /*#__PURE__*/React.createElement("span", {
      className: "code-chip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "chip"
    }, codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [isLinkedProcedure]
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-modifiers modifier-code"
    }, modifierList)), /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.description), /*#__PURE__*/React.createElement(CodeProvenanceChipRow, {
      codeProvenances: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances,
      className: "col-code-provenance"
    }));
  };
  var ResultHeaderRow = function ResultHeaderRow(props) {
    var label = props.label,
      _props$isSuggestedRow2 = props.isSuggestedRow,
      isSuggestedRow = _props$isSuggestedRow2 === void 0 ? false : _props$isSuggestedRow2,
      _props$allowCodeRemov2 = props.allowCodeRemove,
      allowCodeRemove = _props$allowCodeRemov2 === void 0 ? false : _props$allowCodeRemov2,
      opType = props.opType,
      handleSelectAll = props.handleSelectAll,
      handleUnselectAll = props.handleUnselectAll,
      activeIndex = props.activeIndex,
      sectionStartIndex = props.sectionStartIndex,
      activeSelection = props.activeSelection,
      fieldDefinitions = props.fieldDefinitions;
    var styleClasses = classnames('result-header', {
      'suggested-result-header': isSuggestedRow
    });
    var codeType = fieldDefinitions && (fieldDefinitions === null || fieldDefinitions === void 0 ? void 0 : fieldDefinitions.length) > 0 ? fieldDefinitions[0].key : null;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styleClasses)
    }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [isSuggestedRow, allowCodeRemove, codeType != 'CPT']
    }, /*#__PURE__*/React.createElement("div", {
      className: "action-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('select-all', {
        highlighted: activeSelection === ResultType.SUGGESTED_RESULTS && sectionStartIndex === activeIndex
      }),
      onClick: function onClick(ev) {
        return handleSelectAll(ev, opType);
      }
    }, "add all"), /*#__PURE__*/React.createElement("div", {
      className: classnames('unselect-all', {
        highlighted: activeSelection === ResultType.SUGGESTED_RESULTS && sectionStartIndex + 1 === activeIndex
      }),
      onClick: function onClick(ev) {
        return handleUnselectAll(ev, opType);
      }
    }, "remove all"))));
  };
  ResultHeaderRow.displayName = 'ResultHeaderRow';
  var Checkbox = function Checkbox(_ref) {
    var _ref$value = _ref.value,
      value = _ref$value === void 0 ? false : _ref$value,
      label = _ref.label,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange;
    var _useState3 = React.useState(value),
      _useState4 = _slicedToArray(_useState3, 2),
      checked = _useState4[0],
      setChecked = _useState4[1];

    // Sync state with the `value` prop if it changes
    React.useEffect(function () {
      if (value !== checked) {
        setChecked(value);
      }
    }, [value]);
    var handleClick = function handleClick(event) {
      if (disabled) return;
      var newChecked = !checked;
      setChecked(newChecked);
      onChange(newChecked);
    };
    var containerClasses = classnames('cmx-custom-checkbox', {
      checked: checked
    });
    var checkboxClasses = classnames('custom-checkbox', {
      checked: checked,
      'checkbox-disabled': disabled
    });
    return /*#__PURE__*/React.createElement("div", {
      className: containerClasses,
      onClick: handleClick
    }, /*#__PURE__*/React.createElement("div", {
      className: checkboxClasses
    }, checked && /*#__PURE__*/React.createElement(uiComponents.Icon, {
      svgIconName: "BiomeCheckSVG20",
      svgIconSize: "12",
      svgIconClass: "check-mark"
    })), label && /*#__PURE__*/React.createElement("span", {
      className: "checkbox-label"
    }, label));
  };

  var _excluded$e = ["onSearch", "searchResults", "onSearchSelection", "autoFocus", "autoBlur", "shouldShowResults", "FieldDefinitions", "placeholderText", "actionPrefix", "autoSearch", "getSelectionData", "debounceTimeout", "showSearchButton", "actionNameForDD", "suggestedCodes"];
  function ownKeys$F(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$F(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$F(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$F(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$u(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$u() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$u() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$u = function _isNativeReflectConstruct() { return !!t; })(); }
  uiCommon.commonEnums.CodeType;
    var SugggestedCodeType = uiCommon.commonEnums.SugggestedCodeType;
  var SUGGESTED_LIST_HEADER_BUTTONS_COUNT = 2;
  var HEADER_LABEL_MAP = _defineProperty(_defineProperty(_defineProperty({}, SugggestedCodeType.CURRENT_CASE, 'In this case'), SugggestedCodeType.RELATED_CASE, 'In this encounter'), SugggestedCodeType.FROM_SOURCES, 'From sources');
  var SELECT_ALL_NAME_MAP = _defineProperty(_defineProperty(_defineProperty({}, SugggestedCodeType.CURRENT_CASE, 'caseList'), SugggestedCodeType.RELATED_CASE, 'encounterList'), SugggestedCodeType.FROM_SOURCES, 'codeSourceList');
  var ResultType = /*#__PURE__*/function (ResultType) {
    ResultType["SEARCH_RESULTS"] = "searchResults";
    ResultType["SUGGESTED_RESULTS"] = "suggestedSearchResults";
    return ResultType;
  }({});

  // Adding additional metadata to a suggested code so handlers can easily identify the type of code and suggestion list

  var defaultSearchContext = function defaultSearchContext() {
    return {
      codeType: null
    };
  };
  var getSelectionData$2 = function getSelectionData(codeInfo) {
    var _codeInfo$customCpt;
    var searchSelection = {
      code: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code,
      description: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.description,
      codeType: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType,
      effectiveDate: '',
      shortDescription: '',
      tenantDefined: false,
      modifierType: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.modifierType) || null,
      customCpt: (_codeInfo$customCpt = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.customCpt) !== null && _codeInfo$customCpt !== void 0 ? _codeInfo$customCpt : false,
      codeProvenances: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeProvenances,
      codeId: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeId
    };
    return searchSelection;
  };
  var getSelectionDataForLinkedProcedure = function getSelectionDataForLinkedProcedure(suggestedLinkedProcedure) {
    var procedureCodeInfo = {
      code: suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.code,
      description: suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.description,
      codeType: suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.codeType,
      units: suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.units,
      effectiveDate: '',
      shortDescription: '',
      tenantDefined: false,
      modifierType: null,
      customCpt: false,
      codeProvenances: suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.codeProvenances
    };
    var modifierCodeInfos = suggestedLinkedProcedure === null || suggestedLinkedProcedure === void 0 ? void 0 : suggestedLinkedProcedure.modifiers.map(function (modifier) {
      return {
        code: modifier.code,
        description: modifier.description,
        codeType: modifier.codeType,
        effectiveDate: '',
        shortDescription: '',
        tenantDefined: false,
        modifierType: null,
        customCpt: false,
        codeProvenances: modifier.codeProvenances
      };
    });
    return {
      procedureCodeInfo: procedureCodeInfo,
      modifierCodeInfos: modifierCodeInfos
    };
  };
  var placeholderResult = function placeholderResult(text, FieldDefinitions) {
    var styleClasses = ['search-result', 'not-selectable'];
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styleClasses)
    }, (FieldDefinitions === null || FieldDefinitions === void 0 ? void 0 : FieldDefinitions.length) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "col-label search-label"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, text));
  };
  var suppressEnterKey = function suppressEnterKey(ev) {
    // in the case of this component being wrapped by a from, for submit,
    // the form looks for the keydown event in order to submit.  For the lookup
    // form we don't want it to trigger a submit at all.
    if (ev.key === 'Enter') {
      ev.preventDefault();
    }
  };
  var SuggestedLookup = /*#__PURE__*/function (_React$Component) {
    function SuggestedLookup(props) {
      var _this$props$searchRes, _props$searchResults;
      var _this;
      _classCallCheck(this, SuggestedLookup);
      _this = _callSuper$u(this, SuggestedLookup, [props]);
      _defineProperty(_this, "wrapperRef", void 0);
      _defineProperty(_this, "resultRef", void 0);
      _defineProperty(_this, "searchRef", void 0);
      _defineProperty(_this, "searchResultsRef", void 0);
      _defineProperty(_this, "suggestedResultsRef", void 0);
      _defineProperty(_this, "updatePopupPosition", function () {
        if (!_this.searchRef.current) {
          return;
        } else {
          var rect = _this.searchRef.current.getBoundingClientRect();
          var _this$state = _this.state,
            resultHeight = _this$state.resultHeight,
            resultWidth = _this$state.resultWidth; // Dynamic popup height

          // Check if search-cols is visible in the viewport
          var isVisible = rect.top >= 0 && rect.left >= 0 && rect.bottom <= window.innerHeight && rect.right <= window.innerWidth;
          if (!isVisible) {
            // If search-cols is not visible, hide the popup
            _this.setState({
              popupPosition: null // Hide popup
            });
            return;
          }

          // Calculate available space above and below
          var spaceBelow = window.innerHeight - rect.bottom; // Space below search-cols
          var spaceAbove = rect.top; // Space above search-cols
          var spaceRight = window.innerWidth - rect.left; // Space to the right of the element
          var spaceLeft = window.innerWidth - rect.right; // Space to the left of the element

          // Determine where to show the popup: below or above
          var showBelow = spaceBelow >= resultHeight || spaceBelow >= spaceAbove;

          // Decide horizontal positioning (left or right)
          var showLeft = spaceRight >= resultWidth || spaceLeft >= spaceRight;

          // Calculate top and left positions based on the chosen direction
          var top = showBelow ? rect.bottom // Position below the element
          : Math.max(0, rect.top - resultHeight); // Position above the element

          var left = showLeft ? rect.left // Position to the left of the element
          : Math.max(0, rect.right - resultWidth); // Position to the right of the element
          // Detect if we're inside a transformed parent (like Drawer)
          // by checking if the wrapper has an offsetParent that's not body/html
          var containingBlock = _this.getContainingBlock();
          if (containingBlock) {
            var containingRect = containingBlock.getBoundingClientRect();
            // Subtract the containing block's offset to convert from viewport to container coords
            top = top - containingRect.top;
            left = left - containingRect.left;
          }
          // Update the popup's position
          _this.setState({
            popupPosition: {
              top: top,
              left: left
            }
          });
        }
      });
      // Function to find the containing block
      _defineProperty(_this, "getContainingBlock", function () {
        if (!_this.wrapperRef.current) return null;
        var element = _this.wrapperRef.current.parentElement;

        // Traverse up the DOM to find an element that creates a containing block
        while (element && element !== document.body) {
          var style = window.getComputedStyle(element);

          // These CSS properties create a containing block for position:fixed
          if (style.transform !== 'none' || style.perspective !== 'none' || style.filter !== 'none' || style.willChange === 'transform' || style.willChange === 'filter' || style.contain === 'paint') {
            return element;
          }
          element = element.parentElement;
        }
        return null;
      });
      _defineProperty(_this, "handleKeyPress", function (event) {
        switch (event.key) {
          case 'ArrowDown':
            {
              // Move focus down in the results
              event.preventDefault();
              _this.moveFocus(1); // Pass +1 for downward movement
              break;
            }
          case 'ArrowUp':
            {
              // Move focus up in the results
              event.preventDefault();
              _this.moveFocus(-1); // Pass -1 for upward movement
              break;
            }
          case 'Tab':
            {
              var _this$props, _suggestedResults$enc, _suggestedResults$cas;
              var hasSearchResults = ((_this$props = _this.props) === null || _this$props === void 0 || (_this$props = _this$props.searchResults) === null || _this$props === void 0 ? void 0 : _this$props.length) > 0;
              var suggestedResults = _this.getCurrentSuggestedCodeList();
              var hasSuggestedResults = (suggestedResults === null || suggestedResults === void 0 || (_suggestedResults$enc = suggestedResults.encounterList) === null || _suggestedResults$enc === void 0 ? void 0 : _suggestedResults$enc.length) > 0 || (suggestedResults === null || suggestedResults === void 0 || (_suggestedResults$cas = suggestedResults.caseList) === null || _suggestedResults$cas === void 0 ? void 0 : _suggestedResults$cas.length) > 0;

              // Only handle custom tab logic if both results exist
              if (hasSearchResults && hasSuggestedResults) {
                event.preventDefault();
                _this.toggleSearchAndSuggested();
              } else {
                _this.handleFocusExit();
              }
              break;
            }
          case 'ArrowLeft':
            {
              // Optionally toggle back to search if suggested results are shown
              event.preventDefault();
              _this.toggleSearchAndSuggested(false); // Pass false to toggle back
              break;
            }
          case 'ArrowRight':
            {
              // Optionally toggle back to search if suggested results are shown
              event.preventDefault();
              _this.toggleSearchAndSuggested(true); // Pass false to toggle back
              break;
            }
          case 'Enter':
            {
              event.preventDefault();
              var _this$state2 = _this.state,
                activeSelection = _this$state2.activeSelection,
                activeIndex = _this$state2.activeIndex;
              var _suggestedResults = _this.getCurrentSuggestedCodeList();
              var allowHeaderButtons = _this.props.allowCodeRemove;
              if (activeSelection === ResultType.SUGGESTED_RESULTS) {
                var caseList = (_suggestedResults === null || _suggestedResults === void 0 ? void 0 : _suggestedResults.caseList) || [];
                var relatedList = (_suggestedResults === null || _suggestedResults === void 0 ? void 0 : _suggestedResults.encounterList) || [];
                var codeSourceList = (_suggestedResults === null || _suggestedResults === void 0 ? void 0 : _suggestedResults.codeSourceList) || [];
                var currentOffset = 0;

                /** Attempts to handle user selection within a given section of suggested codes.
                  * section can be a case list or a related case list.
                
                  * It handles 3 types of interactions based on the current activeIndex:
                  * 1. Header buttons: "Add All" or "Remove All" (if enabled)
                  * 2. Individual item selection
                  * 3. If nothing matches, it does nothing
                
                  * Returns true if an action was taken for this section, otherwise false. 
                */
                var handleSuggestedCodeSection = function handleSuggestedCodeSection(list, type) {
                  if (!list.length) return false;

                  // If header buttons like "Add All" / "Remove All" are shown
                  if (allowHeaderButtons) {
                    // "Add All" clicked
                    if (activeIndex === currentOffset) {
                      _this.handleAddAllCodes(event, type);
                      return true;
                    }
                    // "Remove All" clicked
                    if (activeIndex === currentOffset + 1) {
                      _this.handleRemoveAllCodes(event, type);
                      return true;
                    }
                    // Move offset past the header buttons
                    currentOffset += SUGGESTED_LIST_HEADER_BUTTONS_COUNT;
                  }

                  // Check if the activeIndex points to a specific item in this section
                  var itemIndex = activeIndex - currentOffset;
                  if (itemIndex >= 0 && itemIndex < list.length) {
                    // Apply the selected code (individual item)
                    _this.applySelectedCode(event);
                    return true;
                  }
                  // Move offset past the items in this section
                  currentOffset += list.length;
                  return false;
                };
                if (handleSuggestedCodeSection(caseList.map(function (item) {
                  return item.codeInfo;
                }), SugggestedCodeType.CURRENT_CASE)) break;
                if (handleSuggestedCodeSection(relatedList.map(function (item) {
                  return item.codeInfo;
                }), SugggestedCodeType.RELATED_CASE)) break;
                if (handleSuggestedCodeSection(codeSourceList.map(function (item) {
                  return item.codeInfo;
                }), SugggestedCodeType.FROM_SOURCES)) break;
              }
              _this.applySelectedCode(event);
              break;
            }
          case 'Escape':
            {
              _this.handleFocusExit();
              break;
            }
        }
      });
      /**
       * Handles moving the keyboard focus up or down through a list of results.
       * It determines the active list (search or suggested), calculates the number
       * of focusable rows (including header buttons, if applicable), and updates
       * the active index accordingly. It ensures the new active item is scrolled into view.
       *
       * @param direction - A number indicating the movement direction: -1 for up, +1 for down
       */
      _defineProperty(_this, "moveFocus", function (direction) {
        var _suggestedResults$cas2, _suggestedResults$enc2;
        var _this$state3 = _this.state,
          activeIndex = _this$state3.activeIndex,
          activeSelection = _this$state3.activeSelection;
        var searchResults = _this.props.searchResults;
        var suggestedResults = _this.getCurrentSuggestedCodeList();
        var hasSearchResults = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0;
        var hasCaseResults = (suggestedResults === null || suggestedResults === void 0 || (_suggestedResults$cas2 = suggestedResults.caseList) === null || _suggestedResults$cas2 === void 0 ? void 0 : _suggestedResults$cas2.length) > 0;
        var hasEncounterResults = (suggestedResults === null || suggestedResults === void 0 || (_suggestedResults$enc2 = suggestedResults.encounterList) === null || _suggestedResults$enc2 === void 0 ? void 0 : _suggestedResults$enc2.length) > 0;
        // If no active selection is set, initialize it based on available results
        if (activeSelection === undefined || activeSelection === null) {
          if (hasSearchResults) {
            _this.updateSelection(ResultType.SEARCH_RESULTS);
            return;
          } else if (hasCaseResults || hasEncounterResults) {
            _this.updateSelection(ResultType.SUGGESTED_RESULTS);
            return;
          }
        }

        // Total number of items that can receive focus
        var totalRows = 0;
        // Calculate total rows based on the active result type
        if (activeSelection === ResultType.SEARCH_RESULTS) {
          var _searchResults$length;
          // Only search result items are focusable (no headers here)
          totalRows = (_searchResults$length = searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) !== null && _searchResults$length !== void 0 ? _searchResults$length : 0;
        } else if (activeSelection === ResultType.SUGGESTED_RESULTS) {
          var _suggestedResults$cas3, _suggestedResults$cas4, _suggestedResults$enc3, _suggestedResults$enc4;
          // Suggested results can include "Add All" / "Remove All" buttons as well
          var totalCaseRows = hasCaseResults ? (_suggestedResults$cas3 = (_suggestedResults$cas4 = suggestedResults.caseList) === null || _suggestedResults$cas4 === void 0 ? void 0 : _suggestedResults$cas4.length) !== null && _suggestedResults$cas3 !== void 0 ? _suggestedResults$cas3 : 0 : 0;
          var totalEncounterRows = hasEncounterResults ? (_suggestedResults$enc3 = (_suggestedResults$enc4 = suggestedResults.encounterList) === null || _suggestedResults$enc4 === void 0 ? void 0 : _suggestedResults$enc4.length) !== null && _suggestedResults$enc3 !== void 0 ? _suggestedResults$enc3 : 0 : 0;
          // Include header buttons if allowed
          var caseHeaderButtons = hasCaseResults && _this.props.allowCodeRemove ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT : 0;
          var encounterHeaderButtons = hasEncounterResults && _this.props.allowCodeRemove ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT : 0;
          // Final total includes items + headers
          totalRows = totalCaseRows + caseHeaderButtons + totalEncounterRows + encounterHeaderButtons;
        }
        if (totalRows === 0) return;
        // Calculate the new active index, wrapping around if needed
        var newIndex = (activeIndex + direction + totalRows) % totalRows;
        // Update the active index, and once the state update is complete,
        // scroll the newly active item into view. The callback ensures scrolling
        // happens *after* React has re-rendered the DOM based on the new index.
        _this.setState({
          activeIndex: newIndex
        }, function () {
          _this.scrollActiveItemIntoView();
        });
      });
      /**
       * Scrolls the currently active item into view within its container
       * (either search results or suggested results), taking into account
       * a fixed header height that may otherwise cover the item.
       */
      _defineProperty(_this, "scrollActiveItemIntoView", function () {
        // Get the currently active item (the one with a highlight or focus)
        var activeItem = document.querySelector('.search-result-submittable');
        // Height of header or spacing to preserve
        var headerOffset = 60;
        var activeSelection = _this.state.activeSelection;

        // Determine which container to scroll based on which list is currently active
        var container = activeSelection === ResultType.SEARCH_RESULTS ? _this.searchResultsRef.current : activeSelection === ResultType.SUGGESTED_RESULTS ? _this.suggestedResultsRef.current : null;
        if (!activeItem || !container) return;
        // Calculate position of the active item within the container
        var itemTop = activeItem.offsetTop;
        var itemBottom = itemTop + activeItem.offsetHeight;
        var containerTop = container.scrollTop;
        var containerHeight = container.clientHeight;
        var containerBottom = containerTop + containerHeight;
        // Active item is above the visible area (considering header offset)
        if (itemTop - headerOffset < containerTop) {
          container.scrollTo({
            top: itemTop - headerOffset,
            behavior: 'smooth'
          });
        }
        // Active item is below the visible area
        else if (itemBottom > containerBottom) {
          container.scrollTo({
            top: itemBottom - containerHeight + headerOffset,
            behavior: 'smooth'
          });
        }
      });
      _defineProperty(_this, "toggleSearchAndSuggested", function (toSuggested) {
        var _suggestedResults$cas5, _suggestedResults$enc5;
        var searchResults = _this.props.searchResults;
        var activeSelection = _this.state.activeSelection;
        var suggestedResults = _this.getCurrentSuggestedCodeList();
        var hasSearchResults = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0;
        var hasSuggestedResults = ((_suggestedResults$cas5 = suggestedResults.caseList) === null || _suggestedResults$cas5 === void 0 ? void 0 : _suggestedResults$cas5.length) > 0 || (suggestedResults === null || suggestedResults === void 0 || (_suggestedResults$enc5 = suggestedResults.encounterList) === null || _suggestedResults$enc5 === void 0 ? void 0 : _suggestedResults$enc5.length) > 0;
        var hasActiveSelection = !!activeSelection; // Compact check for truthy value.

        if (toSuggested !== undefined) {
          if (toSuggested && hasSuggestedResults) _this.updateSelection(ResultType.SUGGESTED_RESULTS);else if (!toSuggested && hasSearchResults) _this.updateSelection(ResultType.SEARCH_RESULTS);
          return;
        } else {
          if (hasActiveSelection) {
            if (activeSelection === ResultType.SEARCH_RESULTS && hasSuggestedResults) _this.updateSelection(ResultType.SUGGESTED_RESULTS);else if (activeSelection === ResultType.SUGGESTED_RESULTS && hasSearchResults) _this.updateSelection(ResultType.SEARCH_RESULTS);
          } else {
            if (hasSearchResults) _this.updateSelection(ResultType.SEARCH_RESULTS);else if (hasSuggestedResults) _this.updateSelection(ResultType.SUGGESTED_RESULTS);
          }
        }
      });
      /**
       * Handles selection of the currently active item (when user presses Enter).
       *
       * Depending on the current active section (`SEARCH_RESULTS` or `SUGGESTED_RESULTS`),
       * it either triggers a search result selection or handles a suggested code selection.
       *
       * - For search results: directly calls `onSearchSelection`.
       * - For suggested results:
       *    - Calculates correct item position accounting for optional header buttons.
       *    - Finds and selects the correct code item.
       *    - If the code is already part of the current transaction and removal is allowed,
       *      triggers `onRemoveAllCodes`.
       *    - Otherwise, adds the selected code via `onSearchSelection`.
       *
       * After handling the selection, it resets the active state.
       */
      _defineProperty(_this, "applySelectedCode", function (event) {
        var _this$state4 = _this.state,
          activeIndex = _this$state4.activeIndex,
          activeSelection = _this$state4.activeSelection;
        var results = _this.props.searchResults;
        var suggestedResults = _this.getCurrentSuggestedCodeList();
        var allowHeaderButtons = _this.props.allowCodeRemove;
        var caseList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.caseList) || [];
        var encounterList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) || [];
        var codeSourceList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.codeSourceList) || [];
        var currentOffset = 0;
        if (activeIndex !== -1) {
          // Selection is from search results
          if (activeSelection === ResultType.SEARCH_RESULTS) {
            _this.props.onSearchSelection({
              codeInfo: results === null || results === void 0 ? void 0 : results[activeIndex],
              context: {}
            });
          }
          // Selection is from suggested results
          else if (activeSelection === ResultType.SUGGESTED_RESULTS) {
            var activeItem = null;

            /**
             * Finds the item in the given list based on the current activeIndex,
             * adjusting for header buttons and previous list lengths.
             */
            var findItem = function findItem(list) {
              if (!list.length) return false;
              // If header buttons are rendered for this section, move the offset
              if (allowHeaderButtons) currentOffset += SUGGESTED_LIST_HEADER_BUTTONS_COUNT;
              var indexInSection = activeIndex - currentOffset;
              if (indexInSection >= 0 && indexInSection < list.length) {
                activeItem = list[indexInSection];
                return true;
              }
              // Move the offset past this section
              currentOffset += list.length;
              return false;
            };
            // Try to find the selected item in either section
            findItem(caseList) || findItem(encounterList) || findItem(codeSourceList);
            if (activeItem) {
              var _activeItem$codeInfo$, _activeItem;
              var transactionGuids = (_activeItem$codeInfo$ = (_activeItem = activeItem) === null || _activeItem === void 0 || (_activeItem = _activeItem.codeInfo) === null || _activeItem === void 0 ? void 0 : _activeItem.transaction_guids) !== null && _activeItem$codeInfo$ !== void 0 ? _activeItem$codeInfo$ : [];
              // Check if the selected code is already part of the current transaction
              var isInCurrentTnx = transactionGuids.includes(_this.props.transactionGuid);
              if (isInCurrentTnx && allowHeaderButtons) {
                // If it's already selected and removal is allowed, remove it
                _this.props.onRemoveAllCodes([activeItem.codeInfo]);
              } else {
                // Check if the code is a SuggestedLinkedProcedure
                if ('units' in activeItem.codeInfo && 'modifiers' in activeItem.codeInfo) {
                  // Handle SuggestedLinkedProcedure differently
                  var linkedProcedure = activeItem.codeInfo;
                  var _getSelectionDataForL = getSelectionDataForLinkedProcedure(linkedProcedure),
                    procedureCodeInfo = _getSelectionDataForL.procedureCodeInfo,
                    modifierCodeInfos = _getSelectionDataForL.modifierCodeInfos;
                  var optAdditionalCodes = modifierCodeInfos.length > 0 ? [modifierCodeInfos] : undefined;
                  _this.props.onSearchSelection({
                    codeInfo: procedureCodeInfo,
                    additionalCodes: optAdditionalCodes,
                    context: {
                      source: activeSelection
                    }
                  });
                } else {
                  // Handle regular SuggestedCode
                  _this.props.onSearchSelection({
                    codeInfo: getSelectionData$2(activeItem.codeInfo),
                    context: {
                      source: activeSelection
                    }
                  });
                }
              }
            }
          }
        }
        _this.reset();
      });
      _this.handleSearchSelection = _this.handleSearchSelection.bind(_this);
      _this.getCurrentSuggestedCodeList = _this.getCurrentSuggestedCodeList.bind(_this);
      _this.getSuggestedRows = _this.getSuggestedRows.bind(_this);
      _this.moveFocus = _this.moveFocus.bind(_this);
      _this.applySelectedCode = _this.applySelectedCode.bind(_this);
      _this.updatePopupPosition = _this.updatePopupPosition.bind(_this);
      _this.updateSelection = _this.updateSelection.bind(_this);
      _this.toggleSearchAndSuggested = _this.toggleSearchAndSuggested.bind(_this);
      _this.handleSearchBarFocus = _this.handleSearchBarFocus.bind(_this);
      _this.handleSearchChange = _this.handleSearchChange.bind(_this);
      _this.onSubmit = _this.onSubmit.bind(_this);
      _this.handleKeyPress = _this.handleKeyPress.bind(_this);
      _this._detectClickOutside = _this._detectClickOutside.bind(_this);
      _this.handleFocusExit = _this.handleFocusExit.bind(_this);
      _this.handleOnInputFocus = _this.handleOnInputFocus.bind(_this);
      _this.handleAddAllCodes = _this.handleAddAllCodes.bind(_this);
      _this.handleRemoveAllCodes = _this.handleRemoveAllCodes.bind(_this);
      _this.getBulkOpCodes = _this.getBulkOpCodes.bind(_this);
      _this.handleSuggestedClick = _this.handleSuggestedClick.bind(_this);
      var WithResults = ((_this$props$searchRes = _this.props.searchResults) === null || _this$props$searchRes === void 0 ? void 0 : _this$props$searchRes.length) > 0;
      _this.state = {
        active: WithResults,
        autocompleteEntry: (_props$searchResults = props.searchResults) !== null && _props$searchResults !== void 0 && _props$searchResults.length ? 0 : -1,
        resultsActive: WithResults,
        showResults: WithResults,
        selecting: false,
        searching: false,
        codeQuery: {},
        searchResultPosition: 'bottom',
        resultHeight: 0,
        resultWidth: 0,
        searchBarContext: defaultSearchContext(),
        popupPosition: {
          top: 0,
          left: 0
        },
        searchType: null,
        activeIndex: -1,
        activeSelection: null
      };
      _this.wrapperRef = /*#__PURE__*/React.createRef();
      _this.resultRef = /*#__PURE__*/React.createRef();
      _this.searchRef = /*#__PURE__*/React.createRef();
      _this.searchResultsRef = /*#__PURE__*/React.createRef();
      _this.suggestedResultsRef = /*#__PURE__*/React.createRef();
      if (_this.props.autoBlur) {
        document.addEventListener('click', _this._detectClickOutside, true);
      }
      if (_this.props.debounceTimeout > 0) {
        var origSearch = _this.handleSearch.bind(_this);
        _this.handleSearch = uiCommon.objectUtils.debounce(origSearch, _this.props.debounceTimeout);
      }
      return _this;
    }
    _inherits(SuggestedLookup, _React$Component);
    return _createClass(SuggestedLookup, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        window.addEventListener('scroll', this.updatePopupPosition, true);
        window.addEventListener('resize', this.updatePopupPosition);
        // Initial position update
        this.updatePopupPosition();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('scroll', this.updatePopupPosition, true);
        window.removeEventListener('resize', this.updatePopupPosition);
      }
    }, {
      key: "handleSearch",
      value:
      /**
       * Calls onSearch.
       * @param codeQuery
       */
      function handleSearch(codeQuery) {
        var _codeQuery$text;
        codeQuery.context = _objectSpread$F(_objectSpread$F({}, codeQuery.context), {}, {
          meetsMinimum: (codeQuery === null || codeQuery === void 0 || (_codeQuery$text = codeQuery.text) === null || _codeQuery$text === void 0 ? void 0 : _codeQuery$text.length) > this.props.minLength
        });
        if (codeQuery.context.meetsMinimum) {
          var _this$props$searchRes2;
          this._setState({
            codeQuery: codeQuery,
            searching: true,
            showResults: ((_this$props$searchRes2 = this.props.searchResults) === null || _this$props$searchRes2 === void 0 ? void 0 : _this$props$searchRes2.length) > 0
          });
        }
        this.props.onSearch(codeQuery);
      }
    }, {
      key: "scrollResultIfNeeded",
      value: function scrollResultIfNeeded() {
        var _this$resultRef$curre;
        var activeResult = (_this$resultRef$curre = this.resultRef.current) === null || _this$resultRef$curre === void 0 ? void 0 : _this$resultRef$curre.querySelector('.search-result-submittable');
        if (activeResult) {
          var visibility = isElementVisible(activeResult, this.resultRef.current);
          if (!visibility.contained) {
            if (visibility.below) {
              // only partial support for IE
              // https://caniuse.com/scrollintoview
              activeResult.scrollIntoView({
                block: 'end',
                behavior: 'smooth',
                inline: 'nearest'
              });
            } else {
              activeResult.scrollIntoView({
                block: 'start',
                behavior: 'smooth',
                inline: 'nearest'
              });
            }
          }
        }
      }
    }, {
      key: "handleOnInputFocus",
      value: function handleOnInputFocus(searchType) {
        this.setState({
          searchType: searchType
        });
        this.updatePopupPosition();
      }
    }, {
      key: "updateSelection",
      value: function updateSelection(selection) {
        this.setState({
          activeSelection: selection,
          activeIndex: 0
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        if (this.searchRef) {
          this.searchRef.current.reset();
        }
        this.setState({
          resultsActive: false,
          showResults: false,
          selecting: false,
          searching: false,
          codeQuery: {},
          activeIndex: -1,
          activeSelection: null,
          searchType: null
        });
      }
    }, {
      key: "focus",
      value: function focus() {
        if (this.searchRef.current) {
          this.searchRef.current.focus();
        }
      }
    }, {
      key: "_detectClickOutside",
      value: function _detectClickOutside(ev) {
        if (this.props.autoBlur) {
          var target = ev === null || ev === void 0 ? void 0 : ev.target;
          //Changed HTMLElement to Element because clicking on an SVG icon (e.g., the delete icon for codes) was not closing the current menu.
          if (target instanceof Element && this.wrapperRef.current !== null) {
            var outOfScope = !this.wrapperRef.current.contains(target);
            if (outOfScope) {
              this._setState({
                searching: false,
                showResults: false,
                active: false,
                searchType: null,
                popupPosition: null
              });
            }
          }
        }
      }
    }, {
      key: "handleFocusExit",
      value: function handleFocusExit() {
        if (this.props.autoBlur) {
          this._setState({
            searching: false,
            showResults: false,
            active: false,
            searchType: null,
            popupPosition: null
          });
        }
      }
    }, {
      key: "handleSearchChange",
      value: function handleSearchChange(event) {
        var _this$state5;
        if (((_this$state5 = this.state) === null || _this$state5 === void 0 ? void 0 : _this$state5.searchType) === null || this.state.searchType === undefined) {
          var _event$detail;
          this.setState({
            searchType: event === null || event === void 0 || (_event$detail = event.detail) === null || _event$detail === void 0 || (_event$detail = _event$detail.value) === null || _event$detail === void 0 ? void 0 : _event$detail.key
          });
        }
        if (this.props.autoSearch) {
          var _event$detail$value, _event$detail2;
          var evValues = (_event$detail$value = event.detail.value) !== null && _event$detail$value !== void 0 ? _event$detail$value : {
            value: '',
            key: ''
          };
          var codeQuery = {
            text: evValues.value,
            searchType: evValues.key,
            searchResultsLookupKey: this.props.searchResultsLookupKey
          };
          if ((event === null || event === void 0 || (_event$detail2 = event.detail) === null || _event$detail2 === void 0 || (_event$detail2 = _event$detail2.value) === null || _event$detail2 === void 0 ? void 0 : _event$detail2.eventSource) === 'dropdown') {
            codeQuery.text = '';
            this.state.codeQuery.text = '';
            this.searchRef.current.reset();
          }
          var showResults = matchRequirements(codeQuery);
          if (!showResults) {
            var _event$detail3;
            this._setState({
              searching: false,
              showResults: false,
              active: true,
              codeQuery: codeQuery,
              searchBarContext: _objectSpread$F(_objectSpread$F({}, this.state.searchBarContext), {}, {
                codeType: event === null || event === void 0 || (_event$detail3 = event.detail) === null || _event$detail3 === void 0 || (_event$detail3 = _event$detail3.value) === null || _event$detail3 === void 0 ? void 0 : _event$detail3.key
              })
            });
          } else if (showResults && !this.state.searching) {
            var _event$detail4;
            this._setState({
              searching: true,
              showResults: true,
              active: true,
              codeQuery: codeQuery,
              searchBarContext: _objectSpread$F(_objectSpread$F({}, this.state.searchBarContext), {}, {
                codeType: event === null || event === void 0 || (_event$detail4 = event.detail) === null || _event$detail4 === void 0 || (_event$detail4 = _event$detail4.value) === null || _event$detail4 === void 0 ? void 0 : _event$detail4.key
              })
            });
          } else {
            var _event$detail5;
            this._setState({
              searching: true,
              showResults: true,
              active: true,
              codeQuery: codeQuery,
              searchBarContext: _objectSpread$F(_objectSpread$F({}, this.state.searchBarContext), {}, {
                codeType: event === null || event === void 0 || (_event$detail5 = event.detail) === null || _event$detail5 === void 0 || (_event$detail5 = _event$detail5.value) === null || _event$detail5 === void 0 ? void 0 : _event$detail5.key
              })
            });
          }
          this.handleSearch(codeQuery);
        }
      }
    }, {
      key: "onSubmit",
      value: function onSubmit(event) {
        var _event$detail$value2;
        var evValues = (_event$detail$value2 = event.detail.value) !== null && _event$detail$value2 !== void 0 ? _event$detail$value2 : {
          value: '',
          key: ''
        };
        var codeQuery = {
          text: evValues.value,
          searchType: evValues.key
        };
        this.handleSearch(codeQuery);
        if (!this.props.autoSearch) {
          this._setState({
            searching: true,
            showResults: true,
            active: true,
            codeQuery: codeQuery
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _this$props2 = this.props,
          searchResults = _this$props2.searchResults,
          suggestedCodes = _this$props2.suggestedCodes;
        var previousSearchResults = prevProps.searchResults,
          prevSuggestedCodes = prevProps.suggestedCodes;
        var _this$state6 = this.state,
          codeQuery = _this$state6.codeQuery,
          searchType = _this$state6.searchType;
        var prevSearchType = prevState.searchType;
        if (prevState.resultHeight !== this.state.resultHeight || prevState.resultWidth !== this.state.resultWidth) {
          this.updatePopupPosition();
        }
        if (searchResults !== previousSearchResults || suggestedCodes !== prevSuggestedCodes || searchType !== prevSearchType) {
          var _this$resultRef$curre2, _this$resultRef$curre3, _ref;
          // if a new result comes in we want to reset the scroll position
          // of the results so that it comes back to the top.
          var height = (_this$resultRef$curre2 = this.resultRef.current) === null || _this$resultRef$curre2 === void 0 || (_this$resultRef$curre2 = _this$resultRef$curre2.getBoundingClientRect()) === null || _this$resultRef$curre2 === void 0 ? void 0 : _this$resultRef$curre2.height;
          var width = (_this$resultRef$curre3 = this.resultRef.current) === null || _this$resultRef$curre3 === void 0 || (_this$resultRef$curre3 = _this$resultRef$curre3.getBoundingClientRect()) === null || _this$resultRef$curre3 === void 0 ? void 0 : _this$resultRef$curre3.width;
          this._setState({
            resultHeight: height,
            resultWidth: width
          });
          if (this.state.showResults && this.resultRef.current) {
            this.resultRef.current.scrollTop = 0;
          }
          if (this.state.searching && ((_ref = "".concat(codeQuery.text)) === null || _ref === void 0 ? void 0 : _ref.length) > 1) {
            this._setState({
              searching: false,
              showResults: true,
              resultsActive: true
            });
          }
        }
      }
    }, {
      key: "_setState",
      value: function _setState(s) {
        this.setState(function (state) {
          return _objectSpread$F(_objectSpread$F({}, state), s);
        });
      }
    }, {
      key: "handleSearchBarFocus",
      value: function handleSearchBarFocus(ev) {
        var _this2 = this;
        if (!this.state.active) {
          // The focus event fires after the SearchBar change event, but
          // in the same thread afaict.
          // What this means in practice is that calls to get and set
          // state can have unwanted effects.  Since React's setState queues
          // changes, the desired changes can be overridden if they happen
          // in succession.  By running the call in the next `tick`, then
          // the changes that we're looking for, do not get clobbered.
          setTimeout(function () {
            var showResults = Array.isArray(_this2.props.searchResults);
            _this2._setState({
              showResults: showResults,
              active: true
            });
          }, 0);
        }
      }
    }, {
      key: "handleSearchSelection",
      value: function handleSearchSelection(ev, codeInfo, opType, isSuggestedRow) {
        ev.preventDefault();
        if (!!codeInfo) {
          var searchSelection = this.props.getSelectionData(codeInfo);
          if (opType === 'delete') {
            this.props.onRemoveAllCodes([searchSelection]);
          } else {
            if ('units' in codeInfo && 'modifiers' in codeInfo) {
              // Handle SuggestedLinkedProcedure differently
              var _getSelectionDataForL2 = getSelectionDataForLinkedProcedure(codeInfo),
                procedureCodeInfo = _getSelectionDataForL2.procedureCodeInfo,
                modifierCodeInfos = _getSelectionDataForL2.modifierCodeInfos;
              var optAdditionalCodes = modifierCodeInfos.length > 0 ? [modifierCodeInfos] : undefined;
              this.props.onSearchSelection({
                codeInfo: procedureCodeInfo,
                additionalCodes: optAdditionalCodes,
                context: {
                  source: isSuggestedRow ? ResultType.SUGGESTED_RESULTS : ResultType.SEARCH_RESULTS
                }
              });
            } else {
              // Handle regular SuggestedCode
              this.props.onSearchSelection({
                codeInfo: searchSelection,
                context: {
                  source: isSuggestedRow ? ResultType.SUGGESTED_RESULTS : ResultType.SEARCH_RESULTS
                }
              });
            }
          }
          this.reset();
        }
      }
    }, {
      key: "getCurrentSuggestedCodeList",
      value: function getCurrentSuggestedCodeList() {
        var _ref2, _suggestedList$encoun, _suggestedList$caseLi, _suggestedList$codeSo;
        var searchType = this.state.searchType;
        var suggestedCodes = this.props.suggestedCodes;

        // Safely handle null searchType by using a default empty object
        var suggestedList = (_ref2 = searchType ? suggestedCodes[searchType.toLowerCase()] : null) !== null && _ref2 !== void 0 ? _ref2 : {
          encounterList: [],
          caseList: [],
          codeSourceList: []
        };
        var mapList = function mapList(codelist, suggestedCodeType) {
          return Array.isArray(codelist) ? codelist === null || codelist === void 0 ? void 0 : codelist.map(function (codeInfo) {
            return {
              codeInfo: codeInfo,
              searchType: searchType,
              suggestedCodeType: suggestedCodeType
            };
          }) : [];
        };
        return {
          encounterList: mapList((_suggestedList$encoun = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.encounterList) !== null && _suggestedList$encoun !== void 0 ? _suggestedList$encoun : [], SugggestedCodeType.RELATED_CASE),
          caseList: mapList((_suggestedList$caseLi = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.caseList) !== null && _suggestedList$caseLi !== void 0 ? _suggestedList$caseLi : [], SugggestedCodeType.CURRENT_CASE),
          codeSourceList: mapList((_suggestedList$codeSo = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.codeSourceList) !== null && _suggestedList$codeSo !== void 0 ? _suggestedList$codeSo : [], SugggestedCodeType.FROM_SOURCES)
        };
      }
    }, {
      key: "getBulkOpCodes",
      value: function getBulkOpCodes(opType) {
        var _suggestedMap$SELECT_, _suggestedList$map;
        var suggestedMap = this.getCurrentSuggestedCodeList();
        var suggestedList = (_suggestedMap$SELECT_ = suggestedMap[SELECT_ALL_NAME_MAP[opType]]) !== null && _suggestedMap$SELECT_ !== void 0 ? _suggestedMap$SELECT_ : [];
        var codeList = (_suggestedList$map = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.map(function (item) {
          return item.codeInfo;
        })) !== null && _suggestedList$map !== void 0 ? _suggestedList$map : [];
        return codeList;
      }
    }, {
      key: "handleAddAllCodes",
      value: function handleAddAllCodes(event, opType) {
        event.preventDefault();
        var codeList = this.getBulkOpCodes(opType);
        console.log(codeList);
        this.props.onAddAllCodes(codeList);
      }
    }, {
      key: "handleRemoveAllCodes",
      value: function handleRemoveAllCodes(event, opType) {
        event.preventDefault();
        var codeList = this.getBulkOpCodes(opType);
        console.log(codeList);
        this.props.onRemoveAllCodes(codeList);
      }
    }, {
      key: "handleSuggestedClick",
      value: function handleSuggestedClick(ev, codeInfo, opType) {
        this.handleSearchSelection(ev, codeInfo, opType, true);
      }
    }, {
      key: "getSuggestedRows",
      value: function getSuggestedRows(suggestedList, suggestedListType, indexOffset) {
        var _this3 = this;
        var allowCodeRemove = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var suggestedResults;
        var headerLabel = HEADER_LABEL_MAP[suggestedListType];
        var sectionStartIndex = indexOffset;
        var selectAllName = SELECT_ALL_NAME_MAP[suggestedListType];
        suggestedResults = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.map(function (result, idx) {
          var _result$codeInfo, _this3$state, _this3$state2, _this3$props;
          return /*#__PURE__*/React.createElement(ResultRow, {
            key: idx + (result === null || result === void 0 || (_result$codeInfo = result.codeInfo) === null || _result$codeInfo === void 0 ? void 0 : _result$codeInfo.code),
            activeIdx: (_this3$state = _this3.state) === null || _this3$state === void 0 ? void 0 : _this3$state.activeIndex,
            activeSelection: (_this3$state2 = _this3.state) === null || _this3$state2 === void 0 ? void 0 : _this3$state2.activeSelection,
            codeInfo: result === null || result === void 0 ? void 0 : result.codeInfo,
            idx: idx + sectionStartIndex + (_this3.props.allowCodeRemove ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT : 0),
            allowCodeRemove: allowCodeRemove,
            transactionGuid: (_this3$props = _this3.props) === null || _this3$props === void 0 ? void 0 : _this3$props.transactionGuid,
            isSuggestedRow: true,
            handleClick: _this3.handleSuggestedClick
          });
        });
        if (!uiCommon.objectUtils.isEmpty(suggestedResults)) {
          var _this$props3, _this$props4;
          suggestedResults.unshift(/*#__PURE__*/React.createElement(ResultHeaderRow, {
            fieldDefinitions: (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : _this$props3.FieldDefinitions,
            label: headerLabel,
            isSuggestedRow: true,
            allowCodeRemove: allowCodeRemove,
            name: "selectall_".concat(selectAllName, "_").concat((_this$props4 = this.props) === null || _this$props4 === void 0 ? void 0 : _this$props4.transactionGuid),
            opType: suggestedListType,
            handleSelectAll: this.handleAddAllCodes,
            handleUnselectAll: this.handleRemoveAllCodes,
            activeIndex: this.state.activeIndex,
            sectionStartIndex: sectionStartIndex,
            activeSelection: this.state.activeSelection
          }));
        }
        return suggestedResults;
      }
    }, {
      key: "render",
      value: function render() {
        var _this4 = this,
          _this$props6,
          _suggestedCodeList$ca,
          _this$props7,
          _suggestedCodeList$ca2,
          _suggestedCodeList$en;
        var _this$props5 = this.props;
          _this$props5.onSearch;
          var searchResults = _this$props5.searchResults;
          _this$props5.onSearchSelection;
          var autoFocus = _this$props5.autoFocus;
          _this$props5.autoBlur;
          var shouldShowResults = _this$props5.shouldShowResults,
          FieldDefinitions = _this$props5.FieldDefinitions;
          _this$props5.placeholderText;
          _this$props5.actionPrefix;
          _this$props5.autoSearch;
          _this$props5.getSelectionData;
          _this$props5.debounceTimeout;
          _this$props5.showSearchButton;
          _this$props5.actionNameForDD;
          _this$props5.suggestedCodes;
          var rest = _objectWithoutProperties(_this$props5, _excluded$e);
        var state = this.state;
        var showResults = shouldShowResults(state);
        var styleClasses = ['suggested-lookupV2', {
          'is-active': this.state.active,
          'is-searching': this.state.searching,
          'is-selecting': this.state.selecting,
          'show-results': showResults,
          'has-search-results': showResults && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0
        }];
        var results;
        if (showResults && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0) {
          var _this$state$codeQuery;
          results = searchResults.map(function (result, idx) {
            var _this4$state, _this4$state2;
            return /*#__PURE__*/React.createElement(ResultRow, {
              activeIdx: (_this4$state = _this4.state) === null || _this4$state === void 0 ? void 0 : _this4$state.activeIndex,
              activeSelection: (_this4$state2 = _this4.state) === null || _this4$state2 === void 0 ? void 0 : _this4$state2.activeSelection,
              codeInfo: result,
              idx: idx,
              handleClick: _this4.handleSearchSelection
            });
          });
          if (!uiCommon.objectUtils.isEmpty((_this$state$codeQuery = this.state.codeQuery) === null || _this$state$codeQuery === void 0 ? void 0 : _this$state$codeQuery.text)) {
            var _this$state$codeQuery2;
            results.unshift(/*#__PURE__*/React.createElement(ResultHeaderRow, {
              label: "Result for \u201C".concat((_this$state$codeQuery2 = this.state.codeQuery) === null || _this$state$codeQuery2 === void 0 ? void 0 : _this$state$codeQuery2.text, "\u201D"),
              name: "searchResult_".concat(this.props.transactionGuid),
              activeIndex: this.state.activeIndex,
              activeSelection: this.state.activeSelection
            }));
          }
        } else if (state.searching) {
          results = placeholderResult('Searching...', FieldDefinitions);
        } else if (showResults) {
          var _this$state$codeQuery3, _this$state$codeQuery4;
          results = placeholderResult("No results found for '".concat((_this$state$codeQuery3 = (_this$state$codeQuery4 = this.state.codeQuery) === null || _this$state$codeQuery4 === void 0 ? void 0 : _this$state$codeQuery4.text) !== null && _this$state$codeQuery3 !== void 0 ? _this$state$codeQuery3 : '', "'"), FieldDefinitions);
        }
        var suggestedCodeList = this.getCurrentSuggestedCodeList();
        var caseRows = this.getSuggestedRows(suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.caseList, SugggestedCodeType.CURRENT_CASE, 0, ((_this$props6 = this.props) === null || _this$props6 === void 0 ? void 0 : _this$props6.allowCodeRemove) || true);
        var encounterRows = this.getSuggestedRows(suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.encounterList, SugggestedCodeType.RELATED_CASE, suggestedCodeList !== null && suggestedCodeList !== void 0 && (_suggestedCodeList$ca = suggestedCodeList.caseList) !== null && _suggestedCodeList$ca !== void 0 && _suggestedCodeList$ca.length ? suggestedCodeList.caseList.length + SUGGESTED_LIST_HEADER_BUTTONS_COUNT : 0, ((_this$props7 = this.props) === null || _this$props7 === void 0 ? void 0 : _this$props7.allowCodeRemove) || true);
        var indexOffset = ((suggestedCodeList === null || suggestedCodeList === void 0 || (_suggestedCodeList$ca2 = suggestedCodeList.caseList) === null || _suggestedCodeList$ca2 === void 0 ? void 0 : _suggestedCodeList$ca2.length) || 0) + SUGGESTED_LIST_HEADER_BUTTONS_COUNT + ((suggestedCodeList === null || suggestedCodeList === void 0 || (_suggestedCodeList$en = suggestedCodeList.encounterList) === null || _suggestedCodeList$en === void 0 ? void 0 : _suggestedCodeList$en.length) || 0) + SUGGESTED_LIST_HEADER_BUTTONS_COUNT;
        var codeSourceRows = this.getSuggestedRows(suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.codeSourceList, SugggestedCodeType.FROM_SOURCES, indexOffset, false);
        return /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
          onKeyDown: suppressEnterKey,
          onFocus: this.handleSearchBarFocus,
          ref: this.wrapperRef,
          className: classnames(styleClasses)
        }), /*#__PURE__*/React.createElement("div", {
          className: "search-cols"
        }, /*#__PURE__*/React.createElement(uiComponents.SearchBar, {
          ref: this.searchRef,
          flex: true,
          disabled: this.props.disabled,
          actionPrefix: this.props.actionPrefix,
          autoFocus: autoFocus,
          onKeyPress: this.handleKeyPress,
          onChange: this.handleSearchChange,
          onFocus: this.handleOnInputFocus,
          onSubmit: this.onSubmit,
          FieldDefinitions: FieldDefinitions,
          placeholder: this.props.placeholderText,
          showSearchButton: this.props.showSearchButton,
          actionNameForDD: this.props.actionNameForDD,
          searchBarViewVersion: this.props.SearchBarViewVersion
        })), this.state.popupPosition && /*#__PURE__*/React.createElement("div", {
          className: "result-container",
          ref: this.resultRef,
          style: {
            top: "".concat(this.state.popupPosition.top, "px"),
            // Dynamic position
            left: "".concat(this.state.popupPosition.left, "px") // Dynamic position
          }
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: !uiCommon.objectUtils.isEmpty(results),
          style: {
            minWidth: '50%'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "search-results",
          ref: this.searchResultsRef
        }, results)), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          some: [!uiCommon.objectUtils.isEmpty(caseRows), !uiCommon.objectUtils.isEmpty(encounterRows), !uiCommon.objectUtils.isEmpty(codeSourceRows)],
          style: {
            minWidth: '50%'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "suggested-results search-results",
          ref: this.suggestedResultsRef
        }, caseRows, encounterRows, codeSourceRows))));
      }
    }]);
  }(React.Component);
  _defineProperty(SuggestedLookup, "displayName", 'SuggestedLookup');
  _defineProperty(SuggestedLookup, "defaultProps", {
    autoFocus: false,
    autoBlur: true,
    autoSearch: true,
    actionPrefix: 'Add',
    debounceTimeout: 0,
    placeholderText: 'Search for code',
    minLength: 2,
    FieldDefinitions: [],
    showSearchButton: true,
    actionNameForDD: '~Focus code search',
    searchBarViewVersion: 'SearchBarView1',
    allowCodeRemove: false,
    transactionGuid: '',
    getSelectionData: getSelectionData$2,
    shouldShowResults: function shouldShowResults(codeQuery) {
      return true;
    },
    onSearchSelection: function onSearchSelection(searchSelection) {},
    onSearch: function onSearch(codeQuery) {},
    searchBarContext: defaultSearchContext,
    onAddAllCodes: function onAddAllCodes(codes) {},
    onRemoveAllCodes: function onRemoveAllCodes(codes) {}
  });

  function _createForOfIteratorHelper$2(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray$2(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$3(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$3(r, a) : void 0; } }
  function _arrayLikeToArray$3(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  function ownKeys$E(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$E(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$E(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$E(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var CODE_TYPE_MAP = {
    'CPT': 'procedure',
    'ICD': 'diagnosis',
    'MODIFIER': 'modifier',
    'procedure': 'procedure',
    'diagnosis': 'diagnosis',
    'modifier': 'modifier'
  };

  /**
   * Props that drive the assessment and role selections for codes in the highlight drawer
   */

  var HighlightDrawer = function HighlightDrawer(_ref) {
    var _projectConfiguration, _projectConfiguration2, _projectConfiguration3, _projectConfiguration4, _projectConfiguration5, _projectConfiguration6, _projectConfiguration7, _projectConfiguration8, _projectConfiguration9, _projectConfiguration0, _projectConfiguration1, _projectConfiguration10, _codeSearch$searchRes, _codeSearch$searchRes2, _attachedCodes$proced, _attachedCodes$modifi, _attachedCodes$diagno;
    var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "sm" : _ref$size,
      attachedCodes = _ref.attachedCodes,
      availableCodes = _ref.availableCodes,
      codeSearch = _ref.codeSearch,
      selectedSpan = _ref.selectedSpan,
      caseId = _ref.caseId,
      onAttachCode = _ref.onAttachCode,
      onDetachCode = _ref.onDetachCode,
      onDelete = _ref.onDelete,
      riskCategories = _ref.riskCategories,
      codeAssessmentProps = _ref.codeAssessmentProps,
      suggestedCodes = _ref.suggestedCodes,
      rubricVersion = _ref.rubricVersion,
      onAttributeChange = _ref.onAttributeChange,
      onDeleteAttribute = _ref.onDeleteAttribute,
      _ref$editable = _ref.editable,
      editable = _ref$editable === void 0 ? true : _ref$editable,
      onClearDownstream = _ref.onClearDownstream,
      evaluateFn = _ref.evaluateFn,
      workItemId = _ref.workItemId;
    var _ref2 = codeAssessmentProps || {},
      cptFields = _ref2.cptFields,
      icdFields = _ref2.icdFields,
      modifierFields = _ref2.modifierFields,
      cqaCodeAssessmentRiskDictionaries = _ref2.cqaCodeAssessmentRiskDictionaries,
      projectConfiguration = _ref2.projectConfiguration,
      onCodeAssessmentUpdate = _ref2.onCodeAssessmentUpdate;
    var procedureAllowNewCodes = (_projectConfiguration = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.procedure) !== null && _projectConfiguration !== void 0 ? _projectConfiguration : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration2 = projectConfiguration.tasks) === null || _projectConfiguration2 === void 0 || (_projectConfiguration2 = _projectConfiguration2.procedure) === null || _projectConfiguration2 === void 0 ? void 0 : _projectConfiguration2.allow_new_codes;
    var diagnosisAllowNewCodes = (_projectConfiguration3 = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.diagnosis) !== null && _projectConfiguration3 !== void 0 ? _projectConfiguration3 : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration4 = projectConfiguration.tasks) === null || _projectConfiguration4 === void 0 || (_projectConfiguration4 = _projectConfiguration4.diagnosis) === null || _projectConfiguration4 === void 0 ? void 0 : _projectConfiguration4.allow_new_codes;
    var modifierAllowNewCodes = (_projectConfiguration5 = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.modifier) !== null && _projectConfiguration5 !== void 0 ? _projectConfiguration5 : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration6 = projectConfiguration.tasks) === null || _projectConfiguration6 === void 0 || (_projectConfiguration6 = _projectConfiguration6.modifier) === null || _projectConfiguration6 === void 0 ? void 0 : _projectConfiguration6.allow_new_codes;
    var procedureVisible = (_projectConfiguration7 = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.procedure) !== null && _projectConfiguration7 !== void 0 ? _projectConfiguration7 : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration8 = projectConfiguration.tasks) === null || _projectConfiguration8 === void 0 || (_projectConfiguration8 = _projectConfiguration8.procedure) === null || _projectConfiguration8 === void 0 ? void 0 : _projectConfiguration8.visible;
    var diagnosisVisible = (_projectConfiguration9 = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.diagnosis) !== null && _projectConfiguration9 !== void 0 ? _projectConfiguration9 : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration0 = projectConfiguration.tasks) === null || _projectConfiguration0 === void 0 || (_projectConfiguration0 = _projectConfiguration0.diagnosis) === null || _projectConfiguration0 === void 0 ? void 0 : _projectConfiguration0.visible;
    var modifierVisible = (_projectConfiguration1 = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.modifier) !== null && _projectConfiguration1 !== void 0 ? _projectConfiguration1 : projectConfiguration === null || projectConfiguration === void 0 || (_projectConfiguration10 = projectConfiguration.tasks) === null || _projectConfiguration10 === void 0 || (_projectConfiguration10 = _projectConfiguration10.modifier) === null || _projectConfiguration10 === void 0 ? void 0 : _projectConfiguration10.visible;

    // Respect project code type collection: only show sections for enabled types (default true when config missing)
    var showProcedure = procedureVisible !== false;
    var showModifier = modifierVisible !== false;
    var showDiagnosis = diagnosisVisible !== false;

    // Filter available codes to only those for enabled code types
    var filteredAvailableCodes = React.useMemo(function () {
      if (!(availableCodes !== null && availableCodes !== void 0 && availableCodes.length)) return availableCodes !== null && availableCodes !== void 0 ? availableCodes : [];
      return availableCodes.filter(function (code) {
        var type = code.codeType;
        if (type === 'procedure') return showProcedure;
        if (type === 'modifier') return showModifier;
        if (type === 'diagnosis') return showDiagnosis;
        return true;
      });
    }, [availableCodes, showProcedure, showModifier, showDiagnosis]);
    var lookupRef = React.useRef(null);
    var modifierLookupRef = React.useRef(null);
    var diagnosisLookupRef = React.useRef(null);
    var hasRubricVersion = Boolean(rubricVersion || (projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.rubricVersionId));

    // Get workflows for each code type
    var procedureWorkflow = React.useMemo(function () {
      return getWorkflowForCodeType(rubricVersion, 'procedure');
    }, [rubricVersion]);
    var modifierWorkflow = React.useMemo(function () {
      return getWorkflowForCodeType(rubricVersion, 'modifier');
    }, [rubricVersion]);
    var diagnosisWorkflow = React.useMemo(function () {
      return getWorkflowForCodeType(rubricVersion, 'diagnosis');
    }, [rubricVersion]);
    var spanWorkflow = React.useMemo(function () {
      return getWorkflowForCodeType(rubricVersion, 'span');
    }, [rubricVersion]);
    var allSpans = useSelector(function (state) {
      return uiCommon.spanSelectors.selectSpanAnnotations(state.gradeBenchPanel);
    });

    // Use backend-driven workflow evaluation for span questions
    var _useWorkflowEvaluatio = useWorkflowEvaluation({
        workflowId: spanWorkflow === null || spanWorkflow === void 0 ? void 0 : spanWorkflow.id,
        attributes: (selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.rubricAttributes) || [],
        workflowQuestions: spanWorkflow === null || spanWorkflow === void 0 ? void 0 : spanWorkflow.questions,
        workItemId: workItemId,
        evaluateFn: evaluateFn,
        enabled: !!evaluateFn && !!spanWorkflow
      }),
      spanEvaluation = _useWorkflowEvaluatio.evaluation,
      visibleSpanQuestions = _useWorkflowEvaluatio.visibleQuestions,
      spanFilteredAnswersMap = _useWorkflowEvaluatio.filteredAnswersMap,
      spanAutofilledAnswersMap = _useWorkflowEvaluatio.autofilledAnswersMap,
      isSpanLoading = _useWorkflowEvaluatio.isLoading,
      spanError = _useWorkflowEvaluatio.error;
    var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastChangedSpanQuestionId = _useState2[0],
      setLastChangedSpanQuestionId = _useState2[1];

    // Handle attaching a code
    var handleAttachCode = React.useCallback(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(code) {
        var updatedAnnotation;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!onAttachCode || !selectedSpan || !editable)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              // Build updated annotation with the new code
              updatedAnnotation = {
                id: selectedSpan.id,
                beginOffset: selectedSpan.beginOffset,
                endOffset: selectedSpan.endOffset,
                coveredText: selectedSpan.coveredText,
                attributes: _toConsumableArray(selectedSpan.attributes || [])
              }; // Make API call
              _context.next = 2;
              return onAttachCode(code, updatedAnnotation);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }(), [onAttachCode, selectedSpan, editable]);

    // Get search results for this highlight drawer context
    // Use selectedSpan id as the lookup key
    var searchResultsKey = (selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id) || 'highlight-drawer';
    var allSearchResults = (_codeSearch$searchRes = codeSearch === null || codeSearch === void 0 || (_codeSearch$searchRes2 = codeSearch.searchResults) === null || _codeSearch$searchRes2 === void 0 ? void 0 : _codeSearch$searchRes2[searchResultsKey]) !== null && _codeSearch$searchRes !== void 0 ? _codeSearch$searchRes : [];

    // Filter search results by code type
    var procedureSearchResults = allSearchResults.filter(function (result) {
      return result.codeType === 'CPT' || result.codeType === 'procedure';
    });
    var modifierSearchResults = allSearchResults.filter(function (result) {
      return result.codeType === 'MODIFIER' || result.codeType === 'modifier';
    });
    var diagnosisSearchResults = allSearchResults.filter(function (result) {
      return result.codeType === 'ICD' || result.codeType === 'diagnosis';
    });

    // Handle code search
    var onSearch = React.useCallback(function (codeQuery) {
      if (!(codeSearch !== null && codeSearch !== void 0 && codeSearch.onCodeSearch) || !editable) return;
      codeSearch.onCodeSearch(_objectSpread$E(_objectSpread$E({}, codeQuery), {}, {
        context: _objectSpread$E(_objectSpread$E({}, codeQuery.context), {}, {
          selectedSpan: selectedSpan ? _objectSpread$E({}, selectedSpan) : undefined
        })
      }));
    }, [codeSearch, selectedSpan, editable]);

    // Handle code selection from search
    var onCodeSelect = React.useCallback(function (codeAction) {
      if (!(codeSearch !== null && codeSearch !== void 0 && codeSearch.onCodeSearchSelection) || !selectedSpan || !editable) return;

      // Call the code search selection handler - this will handle the actual attachment
      // with proper context including documentId, caseId, and spans
      var payload = {
        codeInfo: codeAction.codeInfo,
        context: codeAction.context,
        documentId: selectedSpan.documentId,
        caseId: caseId,
        spans: selectedSpan ? [selectedSpan] : undefined
      };
      codeSearch.onCodeSearchSelection(payload);
    }, [codeSearch, selectedSpan, caseId, editable]);
    var handleCodeSelection = function handleCodeSelection(selection) {
      if (!editable) return;
      var context = selection.context,
        codeInfo = selection.codeInfo;
      codeInfo.codeType;
      if ((context === null || context === void 0 ? void 0 : context.source) === ResultType.SUGGESTED_RESULTS) {
        // Attach to existing code
        handleAttachCode(_objectSpread$E(_objectSpread$E({}, codeInfo), {}, {
          spanId: selectedSpan.id,
          codeId: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeId,
          codeType: CODE_TYPE_MAP[codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType],
          compositeId: '',
          value: '',
          invoiceId: 0,
          transactionId: 0
        }));
      } else {
        // Add new code/charge
        onCodeSelect(selection);
      }
    };

    // Handle detaching a code from the span
    var handleDetachCode = React.useCallback(/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(code) {
        var updatedAnnotation;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!onDetachCode || !selectedSpan || !editable)) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              // Build updated annotation without the detached code
              updatedAnnotation = {
                id: selectedSpan.id,
                beginOffset: selectedSpan.beginOffset,
                endOffset: selectedSpan.endOffset,
                coveredText: selectedSpan.coveredText,
                attributes: _toConsumableArray(selectedSpan.attributes || [])
              }; // Make API call to detach the code
              _context2.next = 2;
              return onDetachCode(code, updatedAnnotation);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref4.apply(this, arguments);
      };
    }(), [onDetachCode, selectedSpan, editable]);

    // Handle deleting the span
    var handleDeleteSpan = React.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      return _regeneratorRuntime.wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            if (!(onDelete && editable)) {
              _context3.next = 2;
              break;
            }
            _context3.next = 1;
            return onDelete();
          case 1:
            onClose();
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), [onDelete, onClose, editable]);

    // Handle assessment change
    var handleAssessmentChange = React.useCallback(function (code, field, fields, value) {
      if (onCodeAssessmentUpdate && editable) {
        onCodeAssessmentUpdate(code, field, fields, value);
      }
    }, [onCodeAssessmentUpdate, editable]);

    // Handle role change
    var handleRoleChange = React.useCallback(function (code, field, fields, value) {
      if (onCodeAssessmentUpdate && editable) {
        onCodeAssessmentUpdate(code, field, fields, value);
      }
    }, [onCodeAssessmentUpdate, editable]);

    // Set up the shared hook for handling span answer changes with downstream cleanup
    var handleSpanAnswerChangeWithCleanup = uiCommon.useHandleRubricAnswerChange(onAttributeChange || function () {}, onDeleteAttribute || /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function (_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), onClearDownstream);

    // Use a ref to break the circular dependency between hook and handler
    var handleSpanAttributeChangeRef = React.useRef(function () {});

    // Use the autofill hook for span questions
    var _useRubricAutofill = useRubricAutofill({
        entityId: String((selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id) || ''),
        entityKey: "span-".concat(selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id),
        attributes: (selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.rubricAttributes) || [],
        autofilledAnswers: spanAutofilledAnswersMap,
        onAutofill: function onAutofill(questionId, answerValueId) {
          handleSpanAttributeChangeRef.current(questionId, answerValueId);
        }
      }),
      trackSpanAnswerChange = _useRubricAutofill.trackAnswerChange,
      clearSpanDownstreamTracking = _useRubricAutofill.clearDownstreamTracking;

    // Handle span attribute changes (value: number = answerValueId for categorical, number[] = spanAnnotationIds for SPAN/SPANS, string = answerDisplayText for FREE_TEXT)
    var handleSpanAttributeChange = React.useCallback(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(questionId, value) {
        var _visibleSpanQuestions;
        var spanAttributes, downstreamQuestionIds, isFreeText, isArray, question, isSpan, isSpans, answerFields;
        return _regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!onAttributeChange || !selectedSpan)) {
                _context5.next = 1;
                break;
              }
              return _context5.abrupt("return");
            case 1:
              setLastChangedSpanQuestionId(questionId);
              spanAttributes = selectedSpan.rubricAttributes || [];
              downstreamQuestionIds = getQuestionIdsToClear(visibleSpanQuestions, spanAttributes, questionId);
              isFreeText = typeof value === 'string';
              isArray = Array.isArray(value);
              if (!isFreeText && !isArray) {
                trackSpanAnswerChange(questionId, value);
              }
              clearSpanDownstreamTracking(downstreamQuestionIds);

              // Determine which answer field to use based on question type
              question = visibleSpanQuestions === null || visibleSpanQuestions === void 0 || (_visibleSpanQuestions = visibleSpanQuestions.find(function (wq) {
                return wq.question.id === questionId;
              })) === null || _visibleSpanQuestions === void 0 ? void 0 : _visibleSpanQuestions.question;
              isSpan = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPAN';
              isSpans = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPANS';
              if (isFreeText) {
                answerFields = {
                  answerDisplayText: value
                };
              } else if (isSpan || isSpans) {
                answerFields = {
                  spanAnnotationIds: value
                };
              } else {
                answerFields = {
                  answerValueId: value
                };
              }
              _context5.next = 2;
              return handleSpanAnswerChangeWithCleanup(_objectSpread$E(_objectSpread$E({
                entityId: String(selectedSpan.id),
                entityType: 'span',
                attributes: spanAttributes,
                questionId: questionId
              }, answerFields), {}, {
                downstreamQuestionIds: downstreamQuestionIds
              }));
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function (_x3, _x4) {
        return _ref7.apply(this, arguments);
      };
    }(), [onAttributeChange, selectedSpan, visibleSpanQuestions, handleSpanAnswerChangeWithCleanup, trackSpanAnswerChange, clearSpanDownstreamTracking]);
    handleSpanAttributeChangeRef.current = handleSpanAttributeChange;
    var createRemoveCodesHandler = React.useCallback(function (codeType) {
      return /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(codes) {
          var codeListMap, codeList, _iterator, _step, _loop, _t;
          return _regeneratorRuntime.wrap(function (_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (editable) {
                  _context7.next = 1;
                  break;
                }
                return _context7.abrupt("return");
              case 1:
                codeListMap = {
                  procedure: attachedCodes === null || attachedCodes === void 0 ? void 0 : attachedCodes.procedures,
                  modifier: attachedCodes === null || attachedCodes === void 0 ? void 0 : attachedCodes.modifiers,
                  diagnosis: attachedCodes === null || attachedCodes === void 0 ? void 0 : attachedCodes.diagnoses
                };
                codeList = codeListMap[codeType];
                _iterator = _createForOfIteratorHelper$2(codes);
                _context7.prev = 2;
                _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                  var code, extractedCode;
                  return _regeneratorRuntime.wrap(function (_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        code = _step.value;
                        extractedCode = codeList === null || codeList === void 0 ? void 0 : codeList.find(function (c) {
                          return c.codeId === code.codeId;
                        });
                        if (!extractedCode) {
                          _context6.next = 1;
                          break;
                        }
                        _context6.next = 1;
                        return handleDetachCode(extractedCode);
                      case 1:
                      case "end":
                        return _context6.stop();
                    }
                  }, _loop);
                });
                _iterator.s();
              case 3:
                if ((_step = _iterator.n()).done) {
                  _context7.next = 5;
                  break;
                }
                return _context7.delegateYield(_loop(), "t0", 4);
              case 4:
                _context7.next = 3;
                break;
              case 5:
                _context7.next = 7;
                break;
              case 6:
                _context7.prev = 6;
                _t = _context7["catch"](2);
                _iterator.e(_t);
              case 7:
                _context7.prev = 7;
                _iterator.f();
                return _context7.finish(7);
              case 8:
              case "end":
                return _context7.stop();
            }
          }, _callee6, null, [[2, 6, 7, 8]]);
        }));
        return function (_x5) {
          return _ref8.apply(this, arguments);
        };
      }();
    }, [handleDetachCode, attachedCodes, editable]);
    var procedureCodeContainers = attachedCodes === null || attachedCodes === void 0 || (_attachedCodes$proced = attachedCodes.procedures) === null || _attachedCodes$proced === void 0 ? void 0 : _attachedCodes$proced.map(function (procedure) {
      return /*#__PURE__*/React.createElement(HighlightDrawerCodeContainer, {
        key: procedure.compositeId,
        code: procedure,
        onDelete: handleDetachCode,
        onAssessmentChange: handleAssessmentChange,
        onRoleChange: handleRoleChange,
        riskCategories: riskCategories,
        cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
        projectConfiguration: projectConfiguration,
        cptFields: cptFields,
        icdFields: icdFields,
        modifierFields: modifierFields,
        rubricWorkflow: procedureWorkflow,
        hasRubricVersion: hasRubricVersion,
        onAnswerChange: onAttributeChange,
        onDeleteAnswer: onDeleteAttribute,
        onClearDownstream: onClearDownstream,
        evaluateFn: evaluateFn,
        workItemId: workItemId,
        spans: allSpans,
        editable: editable
      });
    });
    var modifierCodeContainers = attachedCodes === null || attachedCodes === void 0 || (_attachedCodes$modifi = attachedCodes.modifiers) === null || _attachedCodes$modifi === void 0 ? void 0 : _attachedCodes$modifi.map(function (modifier) {
      return /*#__PURE__*/React.createElement(HighlightDrawerCodeContainer, {
        key: modifier.compositeId,
        code: modifier,
        onDelete: handleDetachCode,
        onAssessmentChange: handleAssessmentChange,
        onRoleChange: handleRoleChange,
        riskCategories: riskCategories,
        cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
        projectConfiguration: projectConfiguration,
        cptFields: cptFields,
        icdFields: icdFields,
        modifierFields: modifierFields,
        rubricWorkflow: modifierWorkflow,
        hasRubricVersion: hasRubricVersion,
        onAnswerChange: onAttributeChange,
        onDeleteAnswer: onDeleteAttribute,
        onClearDownstream: onClearDownstream,
        evaluateFn: evaluateFn,
        workItemId: workItemId,
        spans: allSpans,
        editable: editable
      });
    });
    var diagnosisCodeContainers = attachedCodes === null || attachedCodes === void 0 || (_attachedCodes$diagno = attachedCodes.diagnoses) === null || _attachedCodes$diagno === void 0 ? void 0 : _attachedCodes$diagno.map(function (diagnosis) {
      return /*#__PURE__*/React.createElement(HighlightDrawerCodeContainer, {
        key: diagnosis.compositeId,
        code: diagnosis,
        onDelete: handleDetachCode,
        onAssessmentChange: handleAssessmentChange,
        onRoleChange: handleRoleChange,
        riskCategories: riskCategories,
        cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
        projectConfiguration: projectConfiguration,
        cptFields: cptFields,
        icdFields: icdFields,
        modifierFields: modifierFields,
        rubricWorkflow: diagnosisWorkflow,
        hasRubricVersion: hasRubricVersion,
        onAnswerChange: onAttributeChange,
        onDeleteAnswer: onDeleteAttribute,
        onClearDownstream: onClearDownstream,
        evaluateFn: evaluateFn,
        workItemId: workItemId,
        spans: allSpans,
        editable: editable
      });
    });
    return /*#__PURE__*/React.createElement(Drawer, {
      isOpen: isOpen,
      placement: "right",
      size: size,
      onClose: onClose,
      blockScrollOnMount: false
    }, /*#__PURE__*/React.createElement(ModalOverlay, null), /*#__PURE__*/React.createElement(DrawerContent, {
      className: "highlight-drawer ".concat(!editable ? 'highlight-drawer-uneditable' : '')
    }, /*#__PURE__*/React.createElement(ModalHeader, {
      px: 6,
      py: 4
    }, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(18),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis
    }, "Highlight"), /*#__PURE__*/React.createElement(ModalCloseButton, null)), /*#__PURE__*/React.createElement(ModalBody, {
      px: 6,
      py: 4
    }, /*#__PURE__*/React.createElement(VStack, {
      align: "stretch"
    }, /*#__PURE__*/React.createElement(Box, {
      className: "code-chip-container"
    }, /*#__PURE__*/React.createElement(Alert, {
      status: "info",
      variant: "left-accent",
      flexDirection: "column",
      alignItems: "flex-start"
    }, /*#__PURE__*/React.createElement(AlertTitle, {
      fontSize: uiCommon.pxToRem(14)
    }, "Codes that still need supporting documentation"), /*#__PURE__*/React.createElement(AlertDescription, {
      fontSize: uiCommon.pxToRem(12)
    }, editable ? (filteredAvailableCodes === null || filteredAvailableCodes === void 0 ? void 0 : filteredAvailableCodes.length) > 0 ? 'Click one to apply to this text selection.' : 'There are no codes available to be attached.' : 'View only mode - editing disabled.')), (filteredAvailableCodes === null || filteredAvailableCodes === void 0 ? void 0 : filteredAvailableCodes.length) > 0 && /*#__PURE__*/React.createElement(Wrap, {
      spacing: 3,
      mt: 3
    }, filteredAvailableCodes.map(function (code) {
      return /*#__PURE__*/React.createElement(WrapItem, {
        key: code.compositeId,
        onClick: editable ? function () {
          return handleAttachCode(code);
        } : undefined,
        cursor: editable ? "pointer" : "default",
        _hover: editable ? {
          transform: 'scale(1.05)',
          boxShadow: 'md'
        } : {}
      }, /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
        code: code.value,
        codeType: code.codeType,
        description: code.description,
        editable: false
      }));
    }))), /*#__PURE__*/React.createElement(Alert, {
      status: "info",
      className: "selected-span-text"
    }, /*#__PURE__*/React.createElement(HStack, {
      width: "100%",
      justify: "space-between",
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      flex: 1
    }, "\"", selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.coveredText, "\""), onDelete && editable && /*#__PURE__*/React.createElement(IconButton, {
      "aria-label": "Delete span",
      icon: /*#__PURE__*/React.createElement(uiComponents.Icon, {
        svgIconName: "BiomeDelete",
        svgIconSize: "16"
      }),
      size: "sm",
      variant: "ghost",
      onClick: handleDeleteSpan
    }))), spanWorkflow && (spanError ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis,
      mb: 2
    }, "Highlight Questions"), /*#__PURE__*/React.createElement(Alert, {
      status: "error",
      variant: "left-accent",
      borderRadius: "md"
    }, /*#__PURE__*/React.createElement(AlertIcon$1, null), /*#__PURE__*/React.createElement(AlertDescription, {
      fontSize: "sm"
    }, "Unable to load highlight questions. Please try refreshing the page.")), /*#__PURE__*/React.createElement(Divider, {
      my: 4
    })) : isSpanLoading && !spanEvaluation ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis,
      mb: 2
    }, "Highlight Questions"), /*#__PURE__*/React.createElement(Center, {
      py: 4
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "md"
    })), /*#__PURE__*/React.createElement(Divider, {
      my: 4
    })) : visibleSpanQuestions.length > 0 ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis,
      mb: 2
    }, "Highlight Questions"), /*#__PURE__*/React.createElement(VStack, {
      spacing: 3,
      align: "stretch"
    }, visibleSpanQuestions.map(function (wq) {
      return /*#__PURE__*/React.createElement(RubricQuestionField, {
        key: wq.question.id,
        workflowQuestion: wq,
        currentAnswer: findAnswerForQuestion(selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.rubricAttributes, wq.question.id),
        onAnswerChange: function onAnswerChange(answerValueId) {
          return handleSpanAttributeChange(wq.question.id, answerValueId);
        },
        isDisabled: !editable || isSpanLoading,
        isAutofilled: spanAutofilledAnswersMap.has(wq.question.id),
        filteredAnswerIds: spanFilteredAnswersMap.get(wq.question.id),
        spans: allSpans,
        isEvaluating: isSpanLoading && lastChangedSpanQuestionId === wq.question.id
      });
    })), /*#__PURE__*/React.createElement(Divider, {
      my: 4
    })) : null), showProcedure && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis
    }, "Procedures"), procedureCodeContainers, codeSearch && procedureAllowNewCodes && /*#__PURE__*/React.createElement(SuggestedLookup, {
      ref: lookupRef,
      actionPrefix: "",
      placeholderText: 'Select procedure',
      debounceTimeout: 30,
      FieldDefinitions: uiComponents.FieldDefinitions.filter(function (def) {
        return def.label.toLowerCase() === 'procedure';
      }),
      shouldShowResults: uiComponents.shouldShowResults,
      autoFocus: false,
      onSearch: onSearch,
      onSearchSelection: handleCodeSelection,
      searchResults: procedureSearchResults,
      SearchBarViewVersion: 'SearchBarView2',
      suggestedCodes: suggestedCodes,
      allowCodeRemove: false,
      transactionGuid: "".concat(selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id),
      onRemoveAllCodes: createRemoveCodesHandler('procedure'),
      disabled: !editable
    })), showModifier && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis
    }, "Modifiers"), modifierCodeContainers, codeSearch && modifierAllowNewCodes && /*#__PURE__*/React.createElement(SuggestedLookup, {
      ref: modifierLookupRef,
      actionPrefix: "",
      placeholderText: 'Select modifier',
      debounceTimeout: 30,
      FieldDefinitions: [{
        label: 'Modifier',
        value: 'modifier',
        key: 'MODIFIER'
      }],
      shouldShowResults: uiComponents.shouldShowResults,
      autoFocus: false,
      onSearch: onSearch,
      onSearchSelection: handleCodeSelection,
      searchResults: modifierSearchResults,
      SearchBarViewVersion: 'SearchBarView2',
      suggestedCodes: suggestedCodes,
      transactionGuid: "".concat(selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id),
      onRemoveAllCodes: createRemoveCodesHandler('modifier'),
      disabled: !editable
    })), showDiagnosis && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(16),
      fontWeight: "semibold",
      color: uiCommon.colorTheme.text.highEmphasis
    }, "Diagnoses"), diagnosisCodeContainers, codeSearch && diagnosisAllowNewCodes && /*#__PURE__*/React.createElement(SuggestedLookup, {
      ref: diagnosisLookupRef,
      actionPrefix: "",
      placeholderText: 'Select diagnosis',
      debounceTimeout: 30,
      FieldDefinitions: [{
        label: 'Diagnosis',
        value: 'icd',
        key: 'ICD'
      }],
      shouldShowResults: uiComponents.shouldShowResults,
      autoFocus: false,
      onSearch: onSearch,
      onSearchSelection: handleCodeSelection,
      searchResults: diagnosisSearchResults,
      SearchBarViewVersion: 'SearchBarView2',
      suggestedCodes: suggestedCodes,
      allowCodeRemove: false,
      transactionGuid: "".concat(selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id),
      onRemoveAllCodes: createRemoveCodesHandler('diagnosis'),
      disabled: !editable
    }))))));
  };

  function commonjsRequire(path) {
  	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
  }

  var pluralize$2 = {exports: {}};

  /* global define */
  var pluralize$1 = pluralize$2.exports;

  var hasRequiredPluralize;

  function requirePluralize () {
  	if (hasRequiredPluralize) return pluralize$2.exports;
  	hasRequiredPluralize = 1;
  	(function (module, exports$1) {
  		(function (root, pluralize) {
  		  /* istanbul ignore else */
  		  if (typeof commonjsRequire === 'function' && 'object' === 'object' && 'object' === 'object') {
  		    // Node.
  		    module.exports = pluralize();
  		  } else {
  		    // Browser global.
  		    root.pluralize = pluralize();
  		  }
  		})(pluralize$1, function () {
  		  // Rule storage - pluralize and singularize need to be run sequentially,
  		  // while other rules can be optimized using an object for instant lookups.
  		  var pluralRules = [];
  		  var singularRules = [];
  		  var uncountables = {};
  		  var irregularPlurals = {};
  		  var irregularSingles = {};

  		  /**
  		   * Sanitize a pluralization rule to a usable regular expression.
  		   *
  		   * @param  {(RegExp|string)} rule
  		   * @return {RegExp}
  		   */
  		  function sanitizeRule (rule) {
  		    if (typeof rule === 'string') {
  		      return new RegExp('^' + rule + '$', 'i');
  		    }

  		    return rule;
  		  }

  		  /**
  		   * Pass in a word token to produce a function that can replicate the case on
  		   * another word.
  		   *
  		   * @param  {string}   word
  		   * @param  {string}   token
  		   * @return {Function}
  		   */
  		  function restoreCase (word, token) {
  		    // Tokens are an exact match.
  		    if (word === token) return token;

  		    // Lower cased words. E.g. "hello".
  		    if (word === word.toLowerCase()) return token.toLowerCase();

  		    // Upper cased words. E.g. "WHISKY".
  		    if (word === word.toUpperCase()) return token.toUpperCase();

  		    // Title cased words. E.g. "Title".
  		    if (word[0] === word[0].toUpperCase()) {
  		      return token.charAt(0).toUpperCase() + token.substr(1).toLowerCase();
  		    }

  		    // Lower cased words. E.g. "test".
  		    return token.toLowerCase();
  		  }

  		  /**
  		   * Interpolate a regexp string.
  		   *
  		   * @param  {string} str
  		   * @param  {Array}  args
  		   * @return {string}
  		   */
  		  function interpolate (str, args) {
  		    return str.replace(/\$(\d{1,2})/g, function (match, index) {
  		      return args[index] || '';
  		    });
  		  }

  		  /**
  		   * Replace a word using a rule.
  		   *
  		   * @param  {string} word
  		   * @param  {Array}  rule
  		   * @return {string}
  		   */
  		  function replace (word, rule) {
  		    return word.replace(rule[0], function (match, index) {
  		      var result = interpolate(rule[1], arguments);

  		      if (match === '') {
  		        return restoreCase(word[index - 1], result);
  		      }

  		      return restoreCase(match, result);
  		    });
  		  }

  		  /**
  		   * Sanitize a word by passing in the word and sanitization rules.
  		   *
  		   * @param  {string}   token
  		   * @param  {string}   word
  		   * @param  {Array}    rules
  		   * @return {string}
  		   */
  		  function sanitizeWord (token, word, rules) {
  		    // Empty string or doesn't need fixing.
  		    if (!token.length || uncountables.hasOwnProperty(token)) {
  		      return word;
  		    }

  		    var len = rules.length;

  		    // Iterate over the sanitization rules and use the first one to match.
  		    while (len--) {
  		      var rule = rules[len];

  		      if (rule[0].test(word)) return replace(word, rule);
  		    }

  		    return word;
  		  }

  		  /**
  		   * Replace a word with the updated word.
  		   *
  		   * @param  {Object}   replaceMap
  		   * @param  {Object}   keepMap
  		   * @param  {Array}    rules
  		   * @return {Function}
  		   */
  		  function replaceWord (replaceMap, keepMap, rules) {
  		    return function (word) {
  		      // Get the correct token and case restoration functions.
  		      var token = word.toLowerCase();

  		      // Check against the keep object map.
  		      if (keepMap.hasOwnProperty(token)) {
  		        return restoreCase(word, token);
  		      }

  		      // Check against the replacement map for a direct word replacement.
  		      if (replaceMap.hasOwnProperty(token)) {
  		        return restoreCase(word, replaceMap[token]);
  		      }

  		      // Run all the rules against the word.
  		      return sanitizeWord(token, word, rules);
  		    };
  		  }

  		  /**
  		   * Check if a word is part of the map.
  		   */
  		  function checkWord (replaceMap, keepMap, rules, bool) {
  		    return function (word) {
  		      var token = word.toLowerCase();

  		      if (keepMap.hasOwnProperty(token)) return true;
  		      if (replaceMap.hasOwnProperty(token)) return false;

  		      return sanitizeWord(token, token, rules) === token;
  		    };
  		  }

  		  /**
  		   * Pluralize or singularize a word based on the passed in count.
  		   *
  		   * @param  {string}  word      The word to pluralize
  		   * @param  {number}  count     How many of the word exist
  		   * @param  {boolean} inclusive Whether to prefix with the number (e.g. 3 ducks)
  		   * @return {string}
  		   */
  		  function pluralize (word, count, inclusive) {
  		    var pluralized = count === 1
  		      ? pluralize.singular(word) : pluralize.plural(word);

  		    return (inclusive ? count + ' ' : '') + pluralized;
  		  }

  		  /**
  		   * Pluralize a word.
  		   *
  		   * @type {Function}
  		   */
  		  pluralize.plural = replaceWord(
  		    irregularSingles, irregularPlurals, pluralRules
  		  );

  		  /**
  		   * Check if a word is plural.
  		   *
  		   * @type {Function}
  		   */
  		  pluralize.isPlural = checkWord(
  		    irregularSingles, irregularPlurals, pluralRules
  		  );

  		  /**
  		   * Singularize a word.
  		   *
  		   * @type {Function}
  		   */
  		  pluralize.singular = replaceWord(
  		    irregularPlurals, irregularSingles, singularRules
  		  );

  		  /**
  		   * Check if a word is singular.
  		   *
  		   * @type {Function}
  		   */
  		  pluralize.isSingular = checkWord(
  		    irregularPlurals, irregularSingles, singularRules
  		  );

  		  /**
  		   * Add a pluralization rule to the collection.
  		   *
  		   * @param {(string|RegExp)} rule
  		   * @param {string}          replacement
  		   */
  		  pluralize.addPluralRule = function (rule, replacement) {
  		    pluralRules.push([sanitizeRule(rule), replacement]);
  		  };

  		  /**
  		   * Add a singularization rule to the collection.
  		   *
  		   * @param {(string|RegExp)} rule
  		   * @param {string}          replacement
  		   */
  		  pluralize.addSingularRule = function (rule, replacement) {
  		    singularRules.push([sanitizeRule(rule), replacement]);
  		  };

  		  /**
  		   * Add an uncountable word rule.
  		   *
  		   * @param {(string|RegExp)} word
  		   */
  		  pluralize.addUncountableRule = function (word) {
  		    if (typeof word === 'string') {
  		      uncountables[word.toLowerCase()] = true;
  		      return;
  		    }

  		    // Set singular and plural references for the word.
  		    pluralize.addPluralRule(word, '$0');
  		    pluralize.addSingularRule(word, '$0');
  		  };

  		  /**
  		   * Add an irregular word definition.
  		   *
  		   * @param {string} single
  		   * @param {string} plural
  		   */
  		  pluralize.addIrregularRule = function (single, plural) {
  		    plural = plural.toLowerCase();
  		    single = single.toLowerCase();

  		    irregularSingles[single] = plural;
  		    irregularPlurals[plural] = single;
  		  };

  		  /**
  		   * Irregular rules.
  		   */
  		  [
  		    // Pronouns.
  		    ['I', 'we'],
  		    ['me', 'us'],
  		    ['he', 'they'],
  		    ['she', 'they'],
  		    ['them', 'them'],
  		    ['myself', 'ourselves'],
  		    ['yourself', 'yourselves'],
  		    ['itself', 'themselves'],
  		    ['herself', 'themselves'],
  		    ['himself', 'themselves'],
  		    ['themself', 'themselves'],
  		    ['is', 'are'],
  		    ['was', 'were'],
  		    ['has', 'have'],
  		    ['this', 'these'],
  		    ['that', 'those'],
  		    // Words ending in with a consonant and `o`.
  		    ['echo', 'echoes'],
  		    ['dingo', 'dingoes'],
  		    ['volcano', 'volcanoes'],
  		    ['tornado', 'tornadoes'],
  		    ['torpedo', 'torpedoes'],
  		    // Ends with `us`.
  		    ['genus', 'genera'],
  		    ['viscus', 'viscera'],
  		    // Ends with `ma`.
  		    ['stigma', 'stigmata'],
  		    ['stoma', 'stomata'],
  		    ['dogma', 'dogmata'],
  		    ['lemma', 'lemmata'],
  		    ['schema', 'schemata'],
  		    ['anathema', 'anathemata'],
  		    // Other irregular rules.
  		    ['ox', 'oxen'],
  		    ['axe', 'axes'],
  		    ['die', 'dice'],
  		    ['yes', 'yeses'],
  		    ['foot', 'feet'],
  		    ['eave', 'eaves'],
  		    ['goose', 'geese'],
  		    ['tooth', 'teeth'],
  		    ['quiz', 'quizzes'],
  		    ['human', 'humans'],
  		    ['proof', 'proofs'],
  		    ['carve', 'carves'],
  		    ['valve', 'valves'],
  		    ['looey', 'looies'],
  		    ['thief', 'thieves'],
  		    ['groove', 'grooves'],
  		    ['pickaxe', 'pickaxes'],
  		    ['passerby', 'passersby']
  		  ].forEach(function (rule) {
  		    return pluralize.addIrregularRule(rule[0], rule[1]);
  		  });

  		  /**
  		   * Pluralization rules.
  		   */
  		  [
  		    [/s?$/i, 's'],
  		    [/[^\u0000-\u007F]$/i, '$0'],
  		    [/([^aeiou]ese)$/i, '$1'],
  		    [/(ax|test)is$/i, '$1es'],
  		    [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, '$1es'],
  		    [/(e[mn]u)s?$/i, '$1s'],
  		    [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, '$1'],
  		    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1i'],
  		    [/(alumn|alg|vertebr)(?:a|ae)$/i, '$1ae'],
  		    [/(seraph|cherub)(?:im)?$/i, '$1im'],
  		    [/(her|at|gr)o$/i, '$1oes'],
  		    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, '$1a'],
  		    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, '$1a'],
  		    [/sis$/i, 'ses'],
  		    [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, '$1$2ves'],
  		    [/([^aeiouy]|qu)y$/i, '$1ies'],
  		    [/([^ch][ieo][ln])ey$/i, '$1ies'],
  		    [/(x|ch|ss|sh|zz)$/i, '$1es'],
  		    [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, '$1ices'],
  		    [/\b((?:tit)?m|l)(?:ice|ouse)$/i, '$1ice'],
  		    [/(pe)(?:rson|ople)$/i, '$1ople'],
  		    [/(child)(?:ren)?$/i, '$1ren'],
  		    [/eaux$/i, '$0'],
  		    [/m[ae]n$/i, 'men'],
  		    ['thou', 'you']
  		  ].forEach(function (rule) {
  		    return pluralize.addPluralRule(rule[0], rule[1]);
  		  });

  		  /**
  		   * Singularization rules.
  		   */
  		  [
  		    [/s$/i, ''],
  		    [/(ss)$/i, '$1'],
  		    [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, '$1fe'],
  		    [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, '$1f'],
  		    [/ies$/i, 'y'],
  		    [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, '$1ie'],
  		    [/\b(mon|smil)ies$/i, '$1ey'],
  		    [/\b((?:tit)?m|l)ice$/i, '$1ouse'],
  		    [/(seraph|cherub)im$/i, '$1'],
  		    [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, '$1'],
  		    [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, '$1sis'],
  		    [/(movie|twelve|abuse|e[mn]u)s$/i, '$1'],
  		    [/(test)(?:is|es)$/i, '$1is'],
  		    [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, '$1us'],
  		    [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, '$1um'],
  		    [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, '$1on'],
  		    [/(alumn|alg|vertebr)ae$/i, '$1a'],
  		    [/(cod|mur|sil|vert|ind)ices$/i, '$1ex'],
  		    [/(matr|append)ices$/i, '$1ix'],
  		    [/(pe)(rson|ople)$/i, '$1rson'],
  		    [/(child)ren$/i, '$1'],
  		    [/(eau)x?$/i, '$1'],
  		    [/men$/i, 'man']
  		  ].forEach(function (rule) {
  		    return pluralize.addSingularRule(rule[0], rule[1]);
  		  });

  		  /**
  		   * Uncountable rules.
  		   */
  		  [
  		    // Singular words with no plurals.
  		    'adulthood',
  		    'advice',
  		    'agenda',
  		    'aid',
  		    'aircraft',
  		    'alcohol',
  		    'ammo',
  		    'analytics',
  		    'anime',
  		    'athletics',
  		    'audio',
  		    'bison',
  		    'blood',
  		    'bream',
  		    'buffalo',
  		    'butter',
  		    'carp',
  		    'cash',
  		    'chassis',
  		    'chess',
  		    'clothing',
  		    'cod',
  		    'commerce',
  		    'cooperation',
  		    'corps',
  		    'debris',
  		    'diabetes',
  		    'digestion',
  		    'elk',
  		    'energy',
  		    'equipment',
  		    'excretion',
  		    'expertise',
  		    'firmware',
  		    'flounder',
  		    'fun',
  		    'gallows',
  		    'garbage',
  		    'graffiti',
  		    'hardware',
  		    'headquarters',
  		    'health',
  		    'herpes',
  		    'highjinks',
  		    'homework',
  		    'housework',
  		    'information',
  		    'jeans',
  		    'justice',
  		    'kudos',
  		    'labour',
  		    'literature',
  		    'machinery',
  		    'mackerel',
  		    'mail',
  		    'media',
  		    'mews',
  		    'moose',
  		    'music',
  		    'mud',
  		    'manga',
  		    'news',
  		    'only',
  		    'personnel',
  		    'pike',
  		    'plankton',
  		    'pliers',
  		    'police',
  		    'pollution',
  		    'premises',
  		    'rain',
  		    'research',
  		    'rice',
  		    'salmon',
  		    'scissors',
  		    'series',
  		    'sewage',
  		    'shambles',
  		    'shrimp',
  		    'software',
  		    'species',
  		    'staff',
  		    'swine',
  		    'tennis',
  		    'traffic',
  		    'transportation',
  		    'trout',
  		    'tuna',
  		    'wealth',
  		    'welfare',
  		    'whiting',
  		    'wildebeest',
  		    'wildlife',
  		    'you',
  		    /pok[eé]mon$/i,
  		    // Regexes.
  		    /[^aeiou]ese$/i, // "chinese", "japanese"
  		    /deer$/i, // "deer", "reindeer"
  		    /fish$/i, // "fish", "blowfish", "angelfish"
  		    /measles$/i,
  		    /o[iu]s$/i, // "carnivorous"
  		    /pox$/i, // "chickpox", "smallpox"
  		    /sheep$/i
  		  ].forEach(pluralize.addUncountableRule);

  		  return pluralize;
  		}); 
  	} (pluralize$2));
  	return pluralize$2.exports;
  }

  var pluralizeExports = requirePluralize();
  var pluralize = /*@__PURE__*/getDefaultExportFromCjs(pluralizeExports);

  var EditorIssueProvenance = uiCommon.commonEnums.EditorIssueProvenance;
    uiCommon.commonEnums.EditorIssueLevel;
  var formatMessage = function formatMessage(messageType, idx) {
    return function (edit) {
      return /*#__PURE__*/React.createElement("li", {
        key: "".concat(edit.message, "-").concat(idx)
      }, /*#__PURE__*/React.createElement("span", null, edit.message));
    };
  };
  var formatEditGroup = function formatEditGroup(rawEdits, idx) {
    // Messages are grouped by two properties.
    // 1. the source of the messages : CCI or Claims
    // 2. the status level : Warning or Error
    // We first sort the messages by source, and then by level.
    var sourceGroups = uiCommon.objectUtils.groupBy(rawEdits, 'source');
    return Object.values(sourceGroups).map(function (edits, subIdx) {
      var levelGroups = uiCommon.objectUtils.groupBy(edits, 'level');
      return Object.values(levelGroups).map(function (levelGroup, sectionIdx) {
        var _edit$level;
        var _levelGroup = _slicedToArray(levelGroup, 1),
          edit = _levelGroup[0];
        var editLevel = ((_edit$level = edit === null || edit === void 0 ? void 0 : edit.level) !== null && _edit$level !== void 0 ? _edit$level : 'unknown').toLowerCase();
        var heading = getMessageHeading(levelGroup);
        var formatEdit = formatMessage(editLevel, subIdx);
        var editMessages = levelGroup.map(formatEdit);
        var styleClasses = classnames("".concat(editLevel, "-msg"));
        return /*#__PURE__*/React.createElement("div", {
          className: "messages",
          key: "".concat(idx, "-").concat(subIdx, "-").concat(sectionIdx)
        }, heading, /*#__PURE__*/React.createElement("ul", {
          className: styleClasses
        }, editMessages));
      });
    });
  };
  var getMessageHeading = function getMessageHeading(edits) {
    var _edits = _slicedToArray(edits, 1),
      edit = _edits[0];
    var errorType = uiCommon.objectUtils.capitalize("".concat(edit.level));
    var source = edit.source !== EditorIssueProvenance.CCI ? uiCommon.objectUtils.capitalize("".concat(edit.source)) : edit.source;
    return /*#__PURE__*/React.createElement("h5", {
      className: "message-type-heading qa-scrubber-message-heading"
    }, source, " ", pluralize(errorType, edits.length));
  };

  var _ref = (uiCommon.workBench === null || uiCommon.workBench === void 0 ? void 0 : uiCommon.workBench.pathUtils) || {},
    getValueAtPath$2 = _ref.getValueAtPath;
  var CodeFieldComponent = function CodeFieldComponent(_ref2) {
    var _computedChipProps$co, _field$classNames, _computedChipProps$ev;
    var chipProps = _ref2.chipProps,
      field = _ref2.field,
      value = _ref2.value,
      _ref2$classNamesMedic = _ref2.classNamesMedicalCodeChip,
      classNamesMedicalCodeChip = _ref2$classNamesMedic === void 0 ? [] : _ref2$classNamesMedic;
    // controlling this manually so that the popover content will unmount properly when closed
    // otherwise it creates space in the DOM when not visible
    var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];
    var getDefaultChipProps = function getDefaultChipProps() {
      var _value$description, _value$codeProvenance;
      if (!field || !value) return undefined;
      return {
        code: getValueAtPath$2(value, field.path),
        codeType: field.codeType,
        editable: !value['original'],
        sequence: 0,
        isDraggable: false,
        onDrop: function onDrop() {},
        handleCodeDelete: function handleCodeDelete() {
          var _field$onCodeDelete;
          return field === null || field === void 0 || (_field$onCodeDelete = field.onCodeDelete) === null || _field$onCodeDelete === void 0 ? void 0 : _field$onCodeDelete.call(field, value);
        },
        description: (_value$description = value['description']) !== null && _value$description !== void 0 ? _value$description : undefined,
        codeProvenance: (_value$codeProvenance = value['codeProvenance']) !== null && _value$codeProvenance !== void 0 ? _value$codeProvenance : []
      };
    };
    var computedChipProps = chipProps || getDefaultChipProps();
    if (!computedChipProps) return null; // Render nothing if props are invalid

    var description = computedChipProps.description || 'No code description available';
    var popoverModifiers = {
      name: 'offset',
      options: {
        offset: [0, 20] // Adjust horizontal and vertical offset
      }
    };
    var errorMessages = computedChipProps !== null && computedChipProps !== void 0 && (_computedChipProps$co = computedChipProps.codeEdits) !== null && _computedChipProps$co !== void 0 && _computedChipProps$co[computedChipProps.code] ? formatEditGroup(computedChipProps === null || computedChipProps === void 0 ? void 0 : computedChipProps.codeEdits[computedChipProps.code], 0) : false;
    var handleMouseEnter = function handleMouseEnter() {
      return setIsHovered(true);
    };
    var handleMouseLeave = function handleMouseLeave() {
      return setIsHovered(false);
    };
    return /*#__PURE__*/React.createElement(Popover, {
      trigger: "hover",
      placement: "right",
      flip: true,
      modifiers: [popoverModifiers],
      isOpen: isHovered,
      onOpen: handleMouseEnter,
      onClose: handleMouseLeave
    }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement("div", {
      className: classnames((_field$classNames = field === null || field === void 0 ? void 0 : field.classNames) !== null && _field$classNames !== void 0 ? _field$classNames : ''),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave
    }, /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, _extends$1({}, computedChipProps, {
      classNames: classNamesMedicalCodeChip
    })))), /*#__PURE__*/React.createElement(Portal, null, isHovered &&
    /*#__PURE__*/
    //only take up space if it's showing
    React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement(PopoverArrow, null), /*#__PURE__*/React.createElement(PopoverBody, null, /*#__PURE__*/React.createElement("div", {
      className: "code-popover-body"
    }, /*#__PURE__*/React.createElement("b", null, uiCommon.objectUtils.capitalize(computedChipProps.codeType)), /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, _extends$1({}, computedChipProps, {
      editable: false
    })), /*#__PURE__*/React.createElement("div", {
      className: "code-description"
    }, description), /*#__PURE__*/React.createElement(CodeProvenanceChipRow, {
      codeProvenances: computedChipProps.codeProvenance
    }), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: ((_computedChipProps$ev = computedChipProps.evidence) === null || _computedChipProps$ev === void 0 ? void 0 : _computedChipProps$ev.length) > 0
    }, /*#__PURE__*/React.createElement("div", {
      className: "indicator"
    }, "cmx")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: !!errorMessages
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-artifacts message-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-artifacts col-messages"
    }, errorMessages))))))));
  };

  function _toArray(r) {
    return _arrayWithHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$3(r) || _nonIterableRest();
  }

  function _createForOfIteratorHelper$1(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray$1(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray$1(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray$2(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0; } }
  function _arrayLikeToArray$2(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  /**
   * Evaluates a single rule against the provided data.
   * @param {Object} rule - The rule to evaluate, containing a path and optional conditions.
   * @param {string[]} rule.path - An array of strings representing the path to the value in the data object.
   * @param {any} [rule.is] - An optional condition that specifies the value must be equal to this for the rule to pass.
   * @param {any} [rule.isNot] - An optional condition that specifies the value must not be equal to this for the rule to pass.
   * @param {Record<string, any>} data - The data object to evaluate the rule against.
   * @returns {boolean} - Returns true if the rule is satisfied, otherwise false.
   */
  var evaluateRule = function evaluateRule(rule, data) {
    var value = rule.path.reduce(function (obj, key) {
      return obj ? obj[key] : undefined;
    }, data);

    // Check `is` and `isNot` conditions
    return (rule.is === undefined || value === rule.is) && (rule.isNot === undefined || value !== rule.isNot);
  };

  /**
   * Evaluates whether the input should be enabled based on the given rule.
   * @param rule - Array of PathAssertion objects that must all evaluate to true for the input to be enabled.
   * @param data - The data object to evaluate the rule against.
   * @param logicType - Select logical operation. If "AND", all rules must be true for the input to be enabled. If "OR", at least one rule must be true for the input to be enabled.
   * @returns {boolean} - True if all assertions are met, otherwise false.
   */
  function evaluateEnablerRules(rules, data) {
    var logicType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'OR';
    // Iterate through the rules with short-circuiting
    var _iterator = _createForOfIteratorHelper$1(rules),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var rule = _step.value;
        var rulePasses = evaluateRule(rule, data);
        if (logicType === 'OR' && rulePasses) {
          return true; // Short-circuit for "OR"
        }
        if (logicType === 'AND' && !rulePasses) {
          return false; // Short-circuit for "AND"
        }
      }

      // Return the appropriate default based on the logic type
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return logicType === 'AND'; // All rules passed for "AND", or none passed for "OR"
  }

  function _arrayLikeToArray$1(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  uiCommon.workBench.pathUtils.getValueAtPath;
  var TextInputComponent = function TextInputComponent(_ref) {
    var field = _ref.field,
      value = _ref.value;
    var _field$classNames = _toArray(field.classNames),
      firstClass = _field$classNames[0],
      rest = _arrayLikeToArray$1(_field$classNames).slice(1);
    var handleChange = function handleChange(event) {
      var userInputValue = event.target.value;
      if (userInputValue !== '' && field.validateInputString) {
        var regex = new RegExp(field.validateInputString);
        if (!regex.test(userInputValue)) {
          return;
        }
      }
      field.onKeyPress(Number(userInputValue), value, field);
    };
    var isEnabled = true;
    if (field.inputEnableRules && field.inputEnableRules.length > 0) {
      isEnabled = evaluateEnablerRules(field.inputEnableRules, value, 'OR');
    }
    var textInputComponent = /*#__PURE__*/React.createElement("input", {
      onBlur: function onBlur() {},
      type: "text",
      disabled: !isEnabled,
      value: value['units'],
      className: classnames(firstClass),
      onChange: handleChange,
      "data-testid": "input-field-units"
    });
    return /*#__PURE__*/React.createElement(AppliedClassNames, {
      value: textInputComponent,
      classNames: rest
    });
  };

  function ownKeys$D(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$D(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$D(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$D(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  /**
   * CodeQuestionsSection renders rubric questions for a specific code.
   * It uses the workflow for the code's type (PROCEDURE, MODIFIER, DIAGNOSIS)
   * and displays questions with trigger-based sequencing.
   */
  var CodeQuestionsSection = function CodeQuestionsSection(_ref) {
    var _code$original, _code$sequenceNumber;
    var code = _ref.code,
      rubricWorkflow = _ref.rubricWorkflow,
      onAnswerChange = _ref.onAnswerChange,
      onDeleteAnswer = _ref.onDeleteAnswer,
      onClearDownstream = _ref.onClearDownstream,
      evaluateFn = _ref.evaluateFn,
      workItemId = _ref.workItemId,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    var attributes = code.attributes || [];
    var allSpans = useSelector(function (state) {
      return uiCommon.spanSelectors.selectSpanAnnotations(state.gradeBenchPanel);
    });
    var _useWorkflowEvaluatio = useWorkflowEvaluation({
        workflowId: rubricWorkflow === null || rubricWorkflow === void 0 ? void 0 : rubricWorkflow.id,
        attributes: attributes,
        workflowQuestions: rubricWorkflow === null || rubricWorkflow === void 0 ? void 0 : rubricWorkflow.questions,
        codeContext: {
          original: (_code$original = code.original) !== null && _code$original !== void 0 ? _code$original : null,
          code: code.code || '',
          sequenceNumber: (_code$sequenceNumber = code.sequenceNumber) !== null && _code$sequenceNumber !== void 0 ? _code$sequenceNumber : 0,
          codeType: code.codeType || ''
        },
        workItemId: workItemId,
        evaluateFn: evaluateFn,
        enabled: !!evaluateFn && !!(rubricWorkflow !== null && rubricWorkflow !== void 0 && rubricWorkflow.id)
      }),
      evaluation = _useWorkflowEvaluatio.evaluation,
      visibleQuestions = _useWorkflowEvaluatio.visibleQuestions,
      filteredAnswersMap = _useWorkflowEvaluatio.filteredAnswersMap,
      autofilledAnswersMap = _useWorkflowEvaluatio.autofilledAnswersMap,
      isLoading = _useWorkflowEvaluatio.isLoading,
      error = _useWorkflowEvaluatio.error;
    var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastChangedQuestionId = _useState2[0],
      setLastChangedQuestionId = _useState2[1];

    // Use the shared hook for handling rubric answer changes with downstream cleanup
    var handleAnswerChangeWithCleanup = uiCommon.useHandleRubricAnswerChange(onAnswerChange, onDeleteAnswer, onClearDownstream);

    // Use a ref to break the circular dependency between hook and handler
    var handleAnswerChangeRef = React.useRef(function () {});

    // Use the autofill hook to handle autofill logic (only for multiple-choice; FREE_TEXT has no autofill)
    var _useRubricAutofill = useRubricAutofill({
        entityId: code.id.toString(),
        entityKey: "".concat(code.id),
        attributes: attributes,
        autofilledAnswers: autofilledAnswersMap,
        onAutofill: function onAutofill(questionId, answerValueId) {
          handleAnswerChangeRef.current(questionId, answerValueId);
        }
      }),
      trackAnswerChange = _useRubricAutofill.trackAnswerChange,
      clearDownstreamTracking = _useRubricAutofill.clearDownstreamTracking;

    // Handle answer change for a question. value: number = answerValueId (MULTIPLE_CHOICE/SYSTEM), number[] = spanAnnotationIds (SPAN/SPANS), string = answerDisplayText (FREE_TEXT)
    var handleAnswerChange = React.useCallback(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(questionId, value) {
        var _visibleQuestions$fin;
        var downstreamQuestionIds, isFreeText, question, isSpan, isSpans, answerFields;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (rubricWorkflow !== null && rubricWorkflow !== void 0 && rubricWorkflow.questions) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              setLastChangedQuestionId(questionId);
              downstreamQuestionIds = getQuestionIdsToClear(visibleQuestions, attributes, questionId);
              isFreeText = typeof value === 'string';
              if (!isFreeText && typeof value === 'number') {
                trackAnswerChange(questionId, value);
              }
              clearDownstreamTracking(downstreamQuestionIds);

              // Determine which answer field to use based on question type
              question = (_visibleQuestions$fin = visibleQuestions.find(function (wq) {
                return wq.question.id === questionId;
              })) === null || _visibleQuestions$fin === void 0 ? void 0 : _visibleQuestions$fin.question;
              isSpan = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPAN';
              isSpans = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPANS';
              if (isFreeText) {
                answerFields = {
                  answerDisplayText: value
                };
              } else if (isSpan || isSpans) {
                answerFields = {
                  spanAnnotationIds: value
                };
              } else {
                answerFields = {
                  answerValueId: value
                };
              }
              _context.next = 2;
              return handleAnswerChangeWithCleanup(_objectSpread$D(_objectSpread$D({
                entityId: code.id.toString(),
                entityType: codeTypeToEntityType$1(code.codeType || 'procedure'),
                attributes: attributes,
                questionId: questionId
              }, answerFields), {}, {
                downstreamQuestionIds: downstreamQuestionIds
              }));
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }(), [rubricWorkflow, attributes, visibleQuestions, code.id, code.codeType, handleAnswerChangeWithCleanup, trackAnswerChange, clearDownstreamTracking]);

    // Update the ref so the hook can call the handler
    handleAnswerChangeRef.current = handleAnswerChange;
    if (error) {
      return /*#__PURE__*/React.createElement(Box, {
        pl: 8,
        pr: 4,
        py: 3
      }, /*#__PURE__*/React.createElement(Alert, {
        status: "error",
        variant: "left-accent",
        borderRadius: "md"
      }, /*#__PURE__*/React.createElement(AlertIcon$1, null), /*#__PURE__*/React.createElement(AlertDescription, {
        fontSize: "sm"
      }, "Unable to load questions. Please try refreshing the page.")));
    }
    if (isLoading && !evaluation) {
      return /*#__PURE__*/React.createElement(Box, {
        pl: 8,
        pr: 4,
        py: 3,
        bg: "gray.50",
        borderTop: "1px solid",
        borderColor: "gray.200"
      }, /*#__PURE__*/React.createElement(Center, {
        py: 4
      }, /*#__PURE__*/React.createElement(Spinner, {
        size: "md"
      })));
    }
    if (visibleQuestions.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Box, {
      className: "code-questions-section",
      pl: 8,
      pr: 4,
      py: 3,
      bg: "gray.50",
      borderTop: "1px solid",
      borderColor: "gray.200"
    }, /*#__PURE__*/React.createElement(VStack, {
      spacing: 3,
      align: "stretch"
    }, visibleQuestions.map(function (workflowQuestion) {
      var currentAnswer = findAnswerForQuestion(attributes, workflowQuestion.question.id);
      return /*#__PURE__*/React.createElement(RubricQuestionField, {
        key: workflowQuestion.question.id,
        workflowQuestion: workflowQuestion,
        currentAnswer: currentAnswer,
        onAnswerChange: function onAnswerChange(value) {
          return handleAnswerChange(workflowQuestion.question.id, value);
        },
        isDisabled: isDisabled || isLoading,
        isAutofilled: autofilledAnswersMap.has(workflowQuestion.question.id),
        filteredAnswerIds: filteredAnswersMap.get(workflowQuestion.question.id),
        isEvaluating: isLoading && lastChangedQuestionId === workflowQuestion.question.id,
        spans: allSpans
      });
    })));
  };

  function ownKeys$C(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$C(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$C(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$C(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var FieldType$2 = uiCommon.commonEnums.FieldType,
    CodeAssessmentRiskCategory = uiCommon.commonEnums.CodeAssessmentRiskCategory;
  var _workBench$pathUtils = uiCommon.workBench.pathUtils,
    getValueAtPath$1 = _workBench$pathUtils.getValueAtPath,
    getOptionsFromTree = _workBench$pathUtils.getOptionsFromTree;

  // TODO : Move AppliedClassNames to new file (all of this should be in UI-Components)
  // Recursivley Applies Classnames
  var AppliedClassNames = function AppliedClassNames(_ref) {
    var value = _ref.value,
      classNames = _ref.classNames;
    if (classNames.length == 0) {
      return /*#__PURE__*/React.createElement("span", null, value);
    }
    // Recursively applies classNames to nested spans
    var _innerSpan = function innerSpan(index) {
      if (index == classNames.length - 1) {
        return /*#__PURE__*/React.createElement("span", {
          className: classnames(classNames[index])
        }, value);
      }
      return /*#__PURE__*/React.createElement("span", {
        className: classnames(classNames[index])
      }, ' ', _innerSpan(index + 1));
    };
    return _innerSpan(0);
  };
  var IconComponent = function IconComponent(_ref2) {
    var field = _ref2.field;
    var IconComponent = field.svgIconName ? /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: field.svgIconName,
      svgIconClass: field.svgIconClass,
      svgIconSize: field.svgIconSize,
      svgViewBox: field.svgIconSize,
      svgTitleText: field.svgIconName
    }) : /*#__PURE__*/React.createElement(React.Fragment, null);
    field.classNames;
    var handleClick = function handleClick(e) {
      e.preventDefault();
      if (field.onSelect) {
        field.onSelect(field.key);
      }
    };
    return /*#__PURE__*/React.createElement(Box, {
      onClick: handleClick,
      cursor: field.onSelect ? 'pointer' : 'default'
    }, /*#__PURE__*/React.createElement(AppliedClassNames, {
      classNames: field.classNames,
      value: IconComponent
    }));
  };
  var SelectListFieldComponent = function SelectListFieldComponent(_ref3) {
    var field = _ref3.field,
      value = _ref3.value;
    var handleSelect = function handleSelect(e) {
      field.onSelect(field.path, e.target.value, value);
    };
    var options = field['options'] ? field['options'] : field['defaultOptions'];
    if (field.optionsTree) {
      var optionsAtTree = getOptionsFromTree(value, field.optionsTree, field.optionsTreePath);
      if (optionsAtTree) {
        options = optionsAtTree;
      }
    }
    var key = field.rerenderFields ? field.rerenderFields.map(function (field) {
      return value[field];
    }).join('-') : '';
    var valueAtPath = getValueAtPath$1(value, field.path);
    var optionsIncludeValue = options.includes(valueAtPath);
    return /*#__PURE__*/React.createElement("select", {
      className: "form-select",
      key: key,
      disabled: field.readonly,
      value: valueAtPath,
      onChange: handleSelect
    }, /*#__PURE__*/React.createElement("option", {
      value: "",
      disabled: true,
      selected: true
    }, field.placeholder), !optionsIncludeValue && valueAtPath && /*#__PURE__*/React.createElement("option", {
      value: valueAtPath,
      disabled: true
    }, valueAtPath, " (no longer available)"), options.map(function (option) {
      return /*#__PURE__*/React.createElement("option", {
        key: option,
        value: option
      }, option);
    }));
  };

  // Placeholder component for ButtonField
  var ButtonFieldComponent = function ButtonFieldComponent(_ref4) {
    var field = _ref4.field;
    return /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return console.log(field.action);
      }
    }, field.icon && /*#__PURE__*/React.createElement("span", null, field.icon));
  };
  //Sets widths of fields using chakra grid
  //React to screen size?
  //Recommend 4 or less fields
  //Todo : Padding fr if fr total < 10 or does muy grid automatically align center
  function generateTemplateColumns(draggable, expandable, fieldFractions) {
    var calculateFractions = fieldFractions.reduce(function (acc, fraction) {
      return acc + "".concat(fraction, " ");
    }, '');
    return calculateFractions;
  }
  function mapCategorytoSvgName(category) {
    if (!category) {
      return '';
    }
    switch (category) {
      case CodeAssessmentRiskCategory.CORRECT:
        return 'CheckCircle1';
      case CodeAssessmentRiskCategory.INCORRECT:
        return 'WrongCode1';
      case CodeAssessmentRiskCategory.MISSED:
        return 'PlusCircle1';
      default:
        return '';
    }
  }
  function findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries) {
    if (!code || !code.codeAssessment || !code.codeType || !cqaCodeAssessmentRiskDictionaries) {
      return null;
    }
    var assessment = code.codeAssessment.assessment;
    var role = code.codeAssessment.role;
    var codeType = code.codeType;
    return cqaCodeAssessmentRiskDictionaries[codeType].rows.find(function (row) {
      return row.assessment == assessment && row.role == role;
    });
  }
  function updateCodeAssessmentIcon(field, code, cqaCodeAssessmentRiskDictionaries) {
    if (field.key !== 'baseCQACodeAssessmentIcon') {
      return field;
    }
    var row = findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries);
    if (!row) {
      return field;
    }
    return _objectSpread$C(_objectSpread$C({}, field), {}, {
      svgIconName: mapCategorytoSvgName(row.category)
    });
  }
  function componentForField(field, code, cqaCodeAssessmentRiskDictionaries) {
    if (field.hidden) {
      return null;
    }
    switch (field.fieldType) {
      case FieldType$2.SelectList:
        return /*#__PURE__*/React.createElement(SelectListFieldComponent, {
          field: field,
          value: code
        });
      case FieldType$2.Button:
        return /*#__PURE__*/React.createElement(ButtonFieldComponent, {
          field: field
        });
      case FieldType$2.Text:
        return /*#__PURE__*/React.createElement(AppliedClassNames, {
          classNames: field.classNames,
          value: getValueAtPath$1(code, field.key)
        });
      case FieldType$2.Icon:
        if (field.key === 'baseCQACodeAssessmentIcon') {
          var updatedField = updateCodeAssessmentIcon(field, code, cqaCodeAssessmentRiskDictionaries);
          return /*#__PURE__*/React.createElement(IconComponent, {
            field: updatedField
          });
        }
        return /*#__PURE__*/React.createElement(IconComponent, {
          field: field
        });
      case FieldType$2.Code:
        var classNamesMedicalCodeChip = [];
        var row = findCodeAssessmentRiskEntry(code, cqaCodeAssessmentRiskDictionaries);
        if (row && row.category == CodeAssessmentRiskCategory.INCORRECT) {
          classNamesMedicalCodeChip.push('incorrect-medical-code');
        }
        return /*#__PURE__*/React.createElement(CodeFieldComponent, {
          field: field,
          value: code,
          classNamesMedicalCodeChip: classNamesMedicalCodeChip
        });
      case FieldType$2.TextInput:
        return /*#__PURE__*/React.createElement(TextInputComponent, {
          field: field,
          value: code
        });
      default:
        return null;
      // Handle unknown field types gracefully
    }
  }
  function createGridItems(expandable, fieldsComponents) {
    var components = [];
    var fieldGridItems = fieldsComponents.map(function (component) {
      return (
        /*#__PURE__*/
        // @ts-ignore - TypeScript cannot handle complex Chakra UI GridItem union types
        React.createElement(GridItem, {
          w: "100%"
        }, component)
      );
    });
    components = [].concat(_toConsumableArray(components), _toConsumableArray(fieldGridItems));
    return components;
  }

  // Could also be called "Row", it is based off of fields, nothing code specific
  var GenericCodeLayer = function GenericCodeLayer(props) {
    var _rubricWorkflow$quest;
    var fields = props.fields,
      expandableOptions = props.expandableOptions,
      values = props.values,
      classNames = props.classNames,
      cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries,
      workItemId = props.workItemId;
    var _itemRef = React.useRef(null);
    var dispatch = useDispatch();

    // Get rubricVersion from Redux (same pattern as CaseQuestionsForm)
    var rubricVersion = useSelector(function (state) {
      var _state$gradeBenchPane;
      return (_state$gradeBenchPane = state.gradeBenchPanel) === null || _state$gradeBenchPane === void 0 ? void 0 : _state$gradeBenchPane.rubricVersion;
    });
    var rubricVersionId = useSelector(function (state) {
      var _state$gradeBenchPane2;
      return (_state$gradeBenchPane2 = state.gradeBenchPanel) === null || _state$gradeBenchPane2 === void 0 || (_state$gradeBenchPane2 = _state$gradeBenchPane2.qaRule) === null || _state$gradeBenchPane2 === void 0 || (_state$gradeBenchPane2 = _state$gradeBenchPane2.data) === null || _state$gradeBenchPane2 === void 0 || (_state$gradeBenchPane2 = _state$gradeBenchPane2.project_configuration) === null || _state$gradeBenchPane2 === void 0 ? void 0 : _state$gradeBenchPane2.rubricVersionId;
    });

    // Expand/collapse state for questions section (expanded by default)
    var _useDisclosure = useDisclosure({
        defaultIsOpen: true
      }),
      isOpen = _useDisclosure.isOpen,
      onToggle = _useDisclosure.onToggle;

    // Get the code object from values (it includes id, codeType, attributes)
    var code = values;
    var rubricWorkflow = React.useMemo(function () {
      if (!rubricVersion || !code.codeType) return undefined;
      return getWorkflowForCodeType(rubricVersion, code.codeType);
    }, [rubricVersion, code.codeType]);

    // Check if rubric workflow has questions
    var hasRubricWorkflow = (rubricWorkflow === null || rubricWorkflow === void 0 || (_rubricWorkflow$quest = rubricWorkflow.questions) === null || _rubricWorkflow$quest === void 0 ? void 0 : _rubricWorkflow$quest.length) > 0;
    var hasRubricVersion = Boolean(rubricVersion || rubricVersionId);

    // Create handlers for attribute changes (same pattern as CaseQuestionsForm)
    var handleAnswerChange = React.useCallback(function (params) {
      dispatch(uiCommon.gradeBenchPanelActions.updateAttribute(params));
    }, [dispatch]);
    var handleDeleteAnswer = React.useCallback(/*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return dispatch(uiCommon.gradeBenchPanelActions.deleteAttribute(params));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref5.apply(this, arguments);
      };
    }(), [dispatch]);
    var handleClearDownstream = React.useCallback(function (params) {
      dispatch(uiCommon.gradeBenchPanelActions.clearDownstreamAttributes(params));
    }, [dispatch]);

    // Fields to hide when rubric workflow exists (Assessment/Role dropdowns and icon)
    var ASSESSMENT_ROLE_FIELD_KEYS = ['assessment', 'role', 'baseCQACodeAssessmentIcon'];
    var visibleFields = React.useMemo(function () {
      if (hasRubricVersion) {
        return fields.filter(function (field) {
          return !ASSESSMENT_ROLE_FIELD_KEYS.includes(field.key);
        });
      }
      return fields;
    }, [fields, hasRubricVersion]);
    var columns = visibleFields.reduce(function (acc, field) {
      var temp = acc;
      if (!field.hidden) {
        temp.push(field.width);
      }
      return temp;
    }, []);
    var columnsWithButton = hasRubricWorkflow ? [].concat(_toConsumableArray(columns), ['1fr']) : columns;
    var templateColumns = generateTemplateColumns(true, false, columnsWithButton);

    //Get the components for each field
    var mapped = visibleFields.map(function (field) {
      return componentForField(field, values, cqaCodeAssessmentRiskDictionaries);
    }).filter(function (item) {
      return item !== null;
    });

    //Wrap component for each field
    var gridItems = createGridItems(false, mapped);
    if (hasRubricWorkflow) {
      gridItems.push(
      /*#__PURE__*/
      // @ts-ignore - TypeScript cannot handle complex Chakra UI GridItem union types
      React.createElement(GridItem, {
        w: "100%",
        display: "flex",
        justifyContent: "flex-end",
        key: "collapse-btn"
      }, /*#__PURE__*/React.createElement(IconButton, {
        "aria-label": isOpen ? 'Collapse questions' : 'Expand questions',
        icon: /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: isOpen ? 'BiomeChevronDownSVG20' : 'BiomeChevronRight',
          svgIconSize: "16"
        }),
        onClick: onToggle,
        variant: "ghost",
        size: "sm"
      })));
    }

    //If expandable, add expandable component
    var displayExpandable = expandableOptions ? expandableOptions.shouldDisplay(fields) : false;
    var Component = expandableOptions === null || expandableOptions === void 0 ? void 0 : expandableOptions.component;
    var ExpandComponent = Component ? /*#__PURE__*/React.createElement(Component, null) : /*#__PURE__*/React.createElement("div", null, "No expandable Options");
    var classes = classnames(classNames);
    return /*#__PURE__*/React.createElement(Box, {
      ref: _itemRef
    }, /*#__PURE__*/React.createElement(Grid, {
      templateColumns: templateColumns,
      gap: 0,
      alignItems: 'center',
      className: classes
    }, gridItems), /*#__PURE__*/React.createElement(Box, {
      display: displayExpandable ? 'block' : 'none',
      className: classes
    }, ExpandComponent), hasRubricWorkflow && /*#__PURE__*/React.createElement(Collapse, {
      in: isOpen,
      animateOpacity: true
    }, /*#__PURE__*/React.createElement(CodeQuestionsSection, {
      code: code,
      rubricWorkflow: rubricWorkflow,
      onAnswerChange: handleAnswerChange,
      onDeleteAnswer: handleDeleteAnswer,
      onClearDownstream: handleClearDownstream,
      evaluateFn: uiCommon.gradeBenchPanelActions.evaluateWorkflow,
      workItemId: workItemId
    })));
  };

  // Define types for the props

  // Component to render action menu
  var MenuList = function MenuList(_ref) {
    var options = _ref.options;
    var icon = /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeVerticalMenu",
      svgIconClass: "menu-list-icon",
      svgIconSize: "16"
    });
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement(Grid, {
        className: "menu-list"
      }, /*#__PURE__*/React.createElement(MenuButton, {
        icon: icon
      }, options.map(function (option, idx) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: idx,
          onSelect: option.onClick
        }, option.label);
      })))
    );
  };

  var InvoiceActionMenu = function InvoiceActionMenu(_ref) {
    var onEdit = _ref.onEdit,
      onDelete = _ref.onDelete;
    var menuOptions = [{
      label: 'Edit',
      onClick: onEdit
    }, {
      label: 'Delete',
      onClick: onDelete
    }];
    return /*#__PURE__*/React.createElement(MenuList, {
      options: menuOptions
    });
  };

  function ownKeys$B(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$B(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$B(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$B(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var noOpHandler = function noOpHandler(actionItem) {};
  var DEFAULT_PROPS$7 = {
    display: true,
    onConfirm: noOpHandler,
    onDismiss: noOpHandler,
    actionItem: {
      action: 'STANDARD_ACTION'
    },
    strings: {
      proceed: 'Accept',
      dismiss: 'Cancel'
    }
  };
  var Confirm = function Confirm(passed) {
    var props = _objectSpread$B(_objectSpread$B({}, DEFAULT_PROPS$7), passed);
    var title = props.title,
      strings = props.strings;
    var helpText = props.helpText ? /*#__PURE__*/React.createElement("p", null, props.helpText) : /*#__PURE__*/React.createElement("span", null);
    var handleConfirm = function handleConfirm(event) {
      event.preventDefault();
      props.onConfirm(props.actionItem);
    };
    var handleDismiss = function handleDismiss(event) {
      event.preventDefault();
      props.onDismiss(props.actionItem);
    };
    var footerChildren = /*#__PURE__*/React.createElement("div", {
      className: 'confirm-text'
    }, /*#__PURE__*/React.createElement(uiComponents.RoundedButton, {
      className: 'btn btn-primary btn-sm qa-submit-button auto-focus-btn',
      autoFocus: true,
      onClick: handleConfirm
    }, ' ', strings.proceed), /*#__PURE__*/React.createElement("span", {
      className: 'column col-1'
    }, "or"), /*#__PURE__*/React.createElement("a", {
      href: "#/dismiss-confirm",
      tabIndex: 0,
      className: 'qa-cancel-button ',
      onClick: handleDismiss
    }, strings.dismiss));
    return props.display ? /*#__PURE__*/React.createElement("div", {
      className: "confirm"
    }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
      footerChildren: footerChildren,
      closable: false,
      title: title
    }, helpText)) : null;
  };
  Confirm.displayName = 'Confirm';

  function _callSuper$t(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$t() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$t() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$t = function _isNativeReflectConstruct() { return !!t; })(); }
  var getValueAtPath = uiCommon.workBench.pathUtils.getValueAtPath;

  // Define a type for the props
  // Define the component
  var InvoiceMetadatav2 = /*#__PURE__*/function (_Component) {
    function InvoiceMetadatav2(props) {
      var _this;
      _classCallCheck(this, InvoiceMetadatav2);
      _this = _callSuper$t(this, InvoiceMetadatav2, [props]);
      _this.state = {
        showRemoveConfirm: false
      };
      return _this;
    }
    _inherits(InvoiceMetadatav2, _Component);
    return _createClass(InvoiceMetadatav2, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          editable = _this$props.editable,
          invoice = _this$props.invoice,
          onInvoiceMetaEdit = _this$props.onInvoiceMetaEdit,
          onInvoiceRemove = _this$props.onInvoiceRemove,
          fields = _this$props.fields,
          _this$props$idField = _this$props.idField,
          idField = _this$props$idField === void 0 ? 'guid' : _this$props$idField;
        var handleInvoiceRemove = function handleInvoiceRemove(ev) {
          ev.preventDefault();
          var proceedToRemove = uiCommon.objectUtils.isEmpty(invoice === null || invoice === void 0 ? void 0 : invoice.transactions) || invoice.transactions.every(function (transaction) {
            return uiCommon.objectUtils.isEmpty(transaction === null || transaction === void 0 ? void 0 : transaction.codes);
          });
          if (proceedToRemove) {
            if (invoice[idField]) {
              onInvoiceRemove(invoice[idField]);
            }
          } else {
            _this2.setState({
              showRemoveConfirm: true
            });
          }
        };
        var handleConfirmRemove = function handleConfirmRemove() {
          if (invoice[idField]) {
            onInvoiceRemove(invoice[idField]);
          }
        };
        var metadataRows = fields.map(function (field, index) {
          var mainValue = getValueAtPath(invoice, field.path);
          var appendValue = field.appendValuePath ? getValueAtPath(invoice, field.appendValuePath) : null;
          var value = appendValue ? "".concat(mainValue, " (").concat(appendValue, ")") : mainValue;
          if (value === undefined || value === null) {
            return null; // Skip empty values
          } else if (field.datetimeFormat && value) {
            value = uiCommon.cmxDateTime.format(value, field.datetimeFormat);
          }
          return /*#__PURE__*/React.createElement("p", {
            key: index,
            className: field.classNames.length > 0 ? field.classNames[0].join(' ') : ''
          }, field.displayName && /*#__PURE__*/React.createElement("span", {
            className: "invoice-meta-label"
          }, field.displayName, ":"), field.displayName && ' ', value);
        }).filter(function (item) {
          return item !== null;
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-cell-providers"
        }, metadataRows), /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-cell-actions"
        }, /*#__PURE__*/React.createElement(Confirm, {
          onConfirm: handleConfirmRemove,
          onDismiss: function onDismiss(e) {
            return _this2.setState({
              showRemoveConfirm: false
            });
          },
          display: this.state.showRemoveConfirm,
          title: "Are you sure you want to remove this invoice?",
          strings: {
            proceed: 'Yes, Remove',
            dismiss: 'No, Cancel'
          }
        }), editable && /*#__PURE__*/React.createElement(InvoiceActionMenu, {
          onEdit: function onEdit(e) {
            e.preventDefault();
            if (onInvoiceMetaEdit) {
              onInvoiceMetaEdit(invoice);
            }
          },
          onDelete: function onDelete(e) {
            e.preventDefault();
            if (onInvoiceRemove) {
              handleInvoiceRemove(e);
            }
          }
        })));
      }
    }]);
  }(React.Component);

  //Move to ui-components package as needed
  var InvoiceCard = function InvoiceCard(props) {
    var children = props.children,
      additionalClasses = props.additionalClasses,
      key = props.key;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('invoice-card', additionalClasses),
      key: key
    }, children);
  };

  function sortAndMap(_ref) {
    var array = _ref.array,
      sortKey = _ref.sortKey,
      mapCallback = _ref.mapCallback;
    return array.sort(function (a, b) {
      return a[sortKey] > b[sortKey] ? 1 : -1;
    }).map(mapCallback);
  }

  function ownKeys$A(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$A(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$A(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$A(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  /**
   * CaseQuestionsForm displays case-level questions from the rubric's CASE workflow.
   * It uses the same RubricQuestionField component as the highlight drawer for consistent styling.
   * Questions are displayed with trigger-based sequencing (GO_TO, STOP actions).
   *
   * Attributes are fetched centrally via fetchAllAttributes when the case loads.
   * This component reads caseAttributes from Redux state.
   */
  var CaseQuestionsForm = function CaseQuestionsForm(_ref) {
    var sdWorkitemId = _ref.sdWorkitemId,
      evaluateFn = _ref.evaluateFn,
      workItemId = _ref.workItemId,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled;
    var dispatch = useDispatch();
    var rubricVersion = useSelector(function (state) {
      var _state$gradeBenchPane;
      return (_state$gradeBenchPane = state.gradeBenchPanel) === null || _state$gradeBenchPane === void 0 ? void 0 : _state$gradeBenchPane.rubricVersion;
    });
    var caseAttributes = useSelector(function (state) {
      var _state$gradeBenchPane2;
      return (_state$gradeBenchPane2 = state.gradeBenchPanel) === null || _state$gradeBenchPane2 === void 0 ? void 0 : _state$gradeBenchPane2.caseAttributes;
    });
    var attributesFetched = useSelector(function (state) {
      var _state$gradeBenchPane3;
      return (_state$gradeBenchPane3 = state.gradeBenchPanel) === null || _state$gradeBenchPane3 === void 0 ? void 0 : _state$gradeBenchPane3.attributesFetched;
    });
    var attributes = caseAttributes || [];
    var allSpans = useSelector(function (state) {
      return uiCommon.spanSelectors.selectSpanAnnotations(state.gradeBenchPanel);
    });
    var isAttributesLoading = !attributesFetched;
    var caseWorkflow = React.useMemo(function () {
      return getWorkflowForCodeType(rubricVersion, 'case');
    }, [rubricVersion]);
    var _useWorkflowEvaluatio = useWorkflowEvaluation({
        workflowId: caseWorkflow === null || caseWorkflow === void 0 ? void 0 : caseWorkflow.id,
        attributes: attributes,
        workflowQuestions: caseWorkflow === null || caseWorkflow === void 0 ? void 0 : caseWorkflow.questions,
        workItemId: workItemId,
        evaluateFn: evaluateFn,
        enabled: !!evaluateFn && !!(caseWorkflow !== null && caseWorkflow !== void 0 && caseWorkflow.id)
      }),
      evaluation = _useWorkflowEvaluatio.evaluation,
      visibleQuestions = _useWorkflowEvaluatio.visibleQuestions,
      filteredAnswersMap = _useWorkflowEvaluatio.filteredAnswersMap,
      autofilledAnswersMap = _useWorkflowEvaluatio.autofilledAnswersMap,
      isEvaluationLoading = _useWorkflowEvaluatio.isLoading,
      error = _useWorkflowEvaluatio.error;
    var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      lastChangedQuestionId = _useState2[0],
      setLastChangedQuestionId = _useState2[1];
    var handleAttributeChange = React.useCallback(function (params) {
      dispatch(uiCommon.gradeBenchPanelActions.updateAttribute(params));
    }, [dispatch]);
    var handleDeleteAttribute = React.useCallback(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return dispatch(uiCommon.gradeBenchPanelActions.deleteAttribute(params));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), [dispatch]);
    var handleClearDownstream = React.useCallback(function (params) {
      dispatch(uiCommon.gradeBenchPanelActions.clearDownstreamAttributes(params));
    }, [dispatch]);
    var handleAnswerChangeWithCleanup = uiCommon.useHandleRubricAnswerChange(handleAttributeChange, handleDeleteAttribute, handleClearDownstream);

    // Use a ref to break the circular dependency between hook and handler
    var handleAnswerChangeRef = React.useRef(function () {});

    // Use the autofill hook to handle autofill logic (only for multiple-choice; FREE_TEXT has no autofill)
    var _useRubricAutofill = useRubricAutofill({
        entityId: sdWorkitemId,
        entityKey: "case-".concat(sdWorkitemId),
        attributes: attributes,
        autofilledAnswers: autofilledAnswersMap,
        onAutofill: function onAutofill(questionId, answerValueId) {
          handleAnswerChangeRef.current(questionId, answerValueId);
        }
      }),
      trackAnswerChange = _useRubricAutofill.trackAnswerChange,
      clearDownstreamTracking = _useRubricAutofill.clearDownstreamTracking;

    // Handle answer change for a question. value: number = answerValueId (MULTIPLE_CHOICE/SYSTEM), number[] = spanAnnotationIds (SPAN/SPANS), string = answerDisplayText (FREE_TEXT)
    var handleAnswerChange = React.useCallback(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(questionId, value) {
        var _visibleQuestions$fin;
        var downstreamQuestionIds, isFreeText, question, isSpan, isSpans, answerFields;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (caseWorkflow !== null && caseWorkflow !== void 0 && caseWorkflow.questions) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return");
            case 1:
              setLastChangedQuestionId(questionId);
              downstreamQuestionIds = getQuestionIdsToClear(visibleQuestions, attributes, questionId);
              isFreeText = typeof value === 'string';
              if (!isFreeText && typeof value === 'number') {
                trackAnswerChange(questionId, value);
              }
              clearDownstreamTracking(downstreamQuestionIds);

              // Determine which answer field to use based on question type
              question = (_visibleQuestions$fin = visibleQuestions.find(function (wq) {
                return wq.question.id === questionId;
              })) === null || _visibleQuestions$fin === void 0 ? void 0 : _visibleQuestions$fin.question;
              isSpan = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPAN';
              isSpans = (question === null || question === void 0 ? void 0 : question.questionType) === 'SPANS';
              if (isFreeText) {
                answerFields = {
                  answerDisplayText: value
                };
              } else if (isSpan || isSpans) {
                answerFields = {
                  spanAnnotationIds: value
                };
              } else {
                answerFields = {
                  answerValueId: value
                };
              }
              _context2.next = 2;
              return handleAnswerChangeWithCleanup(_objectSpread$A(_objectSpread$A({
                entityId: sdWorkitemId,
                entityType: codeTypeToEntityType$1('case'),
                attributes: attributes,
                questionId: questionId
              }, answerFields), {}, {
                downstreamQuestionIds: downstreamQuestionIds
              }));
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2, _x3) {
        return _ref3.apply(this, arguments);
      };
    }(), [caseWorkflow, attributes, visibleQuestions, sdWorkitemId, handleAnswerChangeWithCleanup, trackAnswerChange, clearDownstreamTracking]);
    handleAnswerChangeRef.current = handleAnswerChange;
    if (!rubricVersion) {
      return null;
    }
    if (!caseWorkflow || !caseWorkflow.questions || caseWorkflow.questions.length === 0) {
      return null;
    }
    var hasValidQuestions = caseWorkflow.questions.some(function (wq) {
      return wq.question.answers && wq.question.answers.length > 0 || wq.question.questionType === 'SPAN' || wq.question.questionType === 'SPANS';
    });
    if (!hasValidQuestions) {
      return null;
    }
    var boxProps = {
      className: "case-questions-form",
      p: 5,
      bg: "#FEEEEA",
      borderRadius: "md",
      border: "1px solid",
      borderColor: "#c37c6a"
    };
    if (isAttributesLoading) {
      return /*#__PURE__*/React.createElement(Box, boxProps, /*#__PURE__*/React.createElement(Text, {
        fontSize: uiCommon.pxToRem(14),
        fontWeight: "semibold",
        color: "gray.700",
        mb: 1
      }, "Case Questions"), /*#__PURE__*/React.createElement(Divider, {
        mb: 3
      }), /*#__PURE__*/React.createElement(Center, {
        py: 4
      }, /*#__PURE__*/React.createElement(Spinner, {
        size: "md",
        color: "#c37c6a"
      })));
    }
    return /*#__PURE__*/React.createElement(Box, boxProps, /*#__PURE__*/React.createElement(Text, {
      fontSize: uiCommon.pxToRem(14),
      fontWeight: "semibold",
      color: "gray.700",
      mb: 3
    }, "Case Questions"), /*#__PURE__*/React.createElement(Divider, {
      mb: 3
    }), error ? /*#__PURE__*/React.createElement(Alert, {
      status: "error",
      variant: "left-accent",
      borderRadius: "md"
    }, /*#__PURE__*/React.createElement(AlertIcon$1, null), /*#__PURE__*/React.createElement(AlertDescription, {
      fontSize: "sm"
    }, "Unable to load case questions. Please try refreshing the page.")) : isEvaluationLoading && !evaluation ? /*#__PURE__*/React.createElement(Center, {
      py: 4
    }, /*#__PURE__*/React.createElement(Spinner, {
      size: "md",
      color: "#c37c6a"
    })) : /*#__PURE__*/React.createElement(VStack, {
      spacing: 3,
      align: "stretch"
    }, visibleQuestions.map(function (workflowQuestion) {
      var currentAnswer = findAnswerForQuestion(attributes, workflowQuestion.question.id);
      return /*#__PURE__*/React.createElement(RubricQuestionField, {
        key: workflowQuestion.question.id,
        workflowQuestion: workflowQuestion,
        currentAnswer: currentAnswer,
        onAnswerChange: function onAnswerChange(value) {
          return handleAnswerChange(workflowQuestion.question.id, value);
        },
        isDisabled: isDisabled || isEvaluationLoading,
        isAutofilled: autofilledAnswersMap.has(workflowQuestion.question.id),
        filteredAnswerIds: filteredAnswersMap.get(workflowQuestion.question.id),
        isEvaluating: isEvaluationLoading && lastChangedQuestionId === workflowQuestion.question.id,
        spans: allSpans
      });
    })));
  };

  var ERROR = 'ERROR';
  var WARNING = 'WARNING';
  function isError(dto) {
    var _dto$severity;
    var s = ((_dto$severity = dto.severity) !== null && _dto$severity !== void 0 ? _dto$severity : ERROR).toUpperCase();
    return s === ERROR;
  }
  function isWarning(dto) {
    var _dto$severity2;
    var s = ((_dto$severity2 = dto.severity) !== null && _dto$severity2 !== void 0 ? _dto$severity2 : '').toUpperCase();
    return s === WARNING;
  }

  /**
   * Modal for resolver validation errors, same format and styling as the Vitalware
   * modal (code-bench.vw-modal) but without comment or override controls.
   */
  var GradeBenchResolverModal = function GradeBenchResolverModal(_ref) {
    var validationErrors = _ref.validationErrors,
      onClose = _ref.onClose;
    var errors = validationErrors.filter(isError);
    var warnings = validationErrors.filter(isWarning);
    return /*#__PURE__*/React.createElement("div", {
      className: "top-level-modal vw-modal"
    }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
      closable: true,
      maximize: false,
      onClose: onClose,
      title: "Can you check these items before submission?"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "vw-title"
    }, "Validation issues"), /*#__PURE__*/React.createElement("p", {
      className: "vw-subtitle"
    }, "Please fix the following validation issues before submitting."), /*#__PURE__*/React.createElement("div", {
      className: "vw-issues-box"
    }, errors.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "vw-issues-section vw-error-issues"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "vw-issues-title vw-issues-error"
    }, "ERRORS"), errors.map(function (dto, idx) {
      var _dto$message, _dto$message2;
      return /*#__PURE__*/React.createElement("li", {
        className: "vw-issues-text",
        key: "error-".concat(idx, "-").concat((_dto$message = dto.message) !== null && _dto$message !== void 0 ? _dto$message : idx)
      }, (_dto$message2 = dto.message) !== null && _dto$message2 !== void 0 ? _dto$message2 : '');
    })), warnings.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "vw-issues-section vw-warning-issues"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "vw-issues-title vw-issues-warning"
    }, "WARNINGS"), warnings.map(function (dto, idx) {
      var _dto$message3, _dto$message4;
      return /*#__PURE__*/React.createElement("li", {
        className: "vw-issues-text",
        key: "warning-".concat(idx, "-").concat((_dto$message3 = dto.message) !== null && _dto$message3 !== void 0 ? _dto$message3 : idx)
      }, (_dto$message4 = dto.message) !== null && _dto$message4 !== void 0 ? _dto$message4 : '');
    }))), /*#__PURE__*/React.createElement("div", {
      className: "vw-buttons-group"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: onClose,
      className: "chakra-secondary-button override-close-button"
    }, "I'll make changes"))));
  };

  function ownKeys$z(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$z(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$z(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$z(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  uiCommon.workBench.pathUtils.changeValueAtPath;
  var _AmplifyCore$transact = uiCommon.AmplifyCore.transactionUpdateDTOFactory.codePredicates,
    isSelectionCPT = _AmplifyCore$transact.isSelectionCPT,
    isSelectionICD = _AmplifyCore$transact.isSelectionICD,
    isSelectionModifier = _AmplifyCore$transact.isSelectionModifier;
  var draggedCodesManager$3 = uiCommon.dragManager.load('codes');
  var vanillaProcedure = {
    id: 2,
    // Unique identifier for the procedure
    code: '99213',
    // CPT code for an outpatient office visit (Level 3)
    original: true,
    codeAssessment: {
      assessment: 'IDEAL CPT',
      role: 'CODABLE',
      id: 1
    },
    sequenceNumber: 1,
    units: 1,
    codeType: 'procedure',
    description: 'someDescription'
  };
  var FieldType$1 = uiCommon.commonEnums.FieldType;
  uiCommon.commonEnums.ChargeSessionCodeType;
  var isCodeUniqueInCQATransaction = function isCodeUniqueInCQATransaction(codeInfo, transaction) {
    if (isSelectionCPT(codeInfo)) {
      return !transaction.procedures.some(function (code) {
        return code.code === codeInfo.code;
      });
    }
    if (isSelectionICD(codeInfo)) {
      return !transaction.diagnoses.some(function (code) {
        return code.code === codeInfo.code;
      });
    }
    if (isSelectionModifier(codeInfo)) {
      return !transaction.modifiers.some(function (code) {
        return code.code === codeInfo.code;
      });
    }
    return true;
  };
  function attachHandlersToFields(fields, transaction, invoice, codeType, onChange, onCodeEvent, deleteCQACode) {
    return fields.map(function (field) {
      if (field.fieldType == FieldType$1.SelectList) {
        var handleUpdate = function handleUpdate(key, value, values) {
          var update = {
            selection: value,
            context: {
              value: values,
              field: field,
              fields: fields,
              transaction: transaction
            }
          };
          onChange(update);
        };
        return _objectSpread$z(_objectSpread$z({}, field), {}, {
          onSelect: handleUpdate
        });
      }
      if (field.fieldType == FieldType$1.Code) {
        var handleDelete = function handleDelete(values) {
          var update = {
            code: _objectSpread$z({}, values),
            codeType: codeType,
            context: {
              transaction: transaction,
              invoice: invoice
            }
          };
          deleteCQACode(update);
        };
        return _objectSpread$z(_objectSpread$z({}, field), {}, {
          onCodeDelete: handleDelete
        });
      }
      if (field.fieldType == FieldType$1.TextInput) {
        var handleTextChange = function handleTextChange(units, value, field) {
          var update = {
            //parseInt(ev.key)
            code: _objectSpread$z(_objectSpread$z(_objectSpread$z({}, vanillaProcedure), value), {}, {
              units: units
            }),
            context: {
              value: value,
              field: field,
              fields: fields,
              transaction: transaction
            }
          };
          onCodeEvent(update);
        };
        return _objectSpread$z(_objectSpread$z({}, field), {}, {
          onKeyPress: handleTextChange
        });
      }
      return field;
    });
  }
  var Transaction$1 = function Transaction(props) {
    var _tasks$procedure, _tasks$diagnosis, _tasks$modifier, _tasks$procedure2, _tasks$diagnosis2, _tasks$modifier2, _codeSearch$searchRes, _codeSearch$searchRes2;
    var invoice = props.invoice,
      transaction = props.transaction,
      codeSearch = props.codeSearch,
      cptFields = props.cptFields,
      icdFields = props.icdFields,
      modifierFields = props.modifierFields,
      onCodeEvent = props.onCodeEvent,
      onChange = props.onChange,
      onCodeRemove = props.onCodeRemove,
      onDeleteCQATransaction = props.onDeleteCQATransaction,
      projectConfiguration = props.projectConfiguration,
      cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries,
      _props$editable = props.editable,
      editable = _props$editable === void 0 ? true : _props$editable,
      workItemId = props.workItemId;
    var procedure = projectConfiguration.procedure,
      diagnosis = projectConfiguration.diagnosis,
      modifier = projectConfiguration.modifier,
      tasks = projectConfiguration.tasks;
    var procedureAllowNewCodes = procedure !== null && procedure !== void 0 ? procedure : tasks === null || tasks === void 0 || (_tasks$procedure = tasks.procedure) === null || _tasks$procedure === void 0 ? void 0 : _tasks$procedure.allow_new_codes;
    var diagnosisAllowNewCodes = diagnosis !== null && diagnosis !== void 0 ? diagnosis : tasks === null || tasks === void 0 || (_tasks$diagnosis = tasks.diagnosis) === null || _tasks$diagnosis === void 0 ? void 0 : _tasks$diagnosis.allow_new_codes;
    var modifierAllowNewCodes = modifier !== null && modifier !== void 0 ? modifier : tasks === null || tasks === void 0 || (_tasks$modifier = tasks.modifier) === null || _tasks$modifier === void 0 ? void 0 : _tasks$modifier.allow_new_codes;
    var procedureVisible = procedure !== null && procedure !== void 0 ? procedure : tasks === null || tasks === void 0 || (_tasks$procedure2 = tasks.procedure) === null || _tasks$procedure2 === void 0 ? void 0 : _tasks$procedure2.visible;
    var diagnosisVisible = diagnosis !== null && diagnosis !== void 0 ? diagnosis : tasks === null || tasks === void 0 || (_tasks$diagnosis2 = tasks.diagnosis) === null || _tasks$diagnosis2 === void 0 ? void 0 : _tasks$diagnosis2.visible;
    var modifierVisible = modifier !== null && modifier !== void 0 ? modifier : tasks === null || tasks === void 0 || (_tasks$modifier2 = tasks.modifier) === null || _tasks$modifier2 === void 0 ? void 0 : _tasks$modifier2.visible;
    var cptFieldsWithHandlers = attachHandlersToFields(cptFields, transaction, invoice, 'procedure', onChange, onCodeEvent, onCodeRemove);
    var icdFieldsWithHandlers = attachHandlersToFields(icdFields, transaction, invoice, 'diagnosis', onChange, onCodeEvent, onCodeRemove);
    var modifierFieldsWithHandlers = attachHandlersToFields(modifierFields, transaction, invoice, 'modifier', onChange, onCodeEvent, onCodeRemove);
    var codeLayerClassNames = ['standard-code-layer', 'code-row'];
    var cptItems = sortAndMap({
      array: transaction.procedures,
      sortKey: 'sequenceNumber',
      mapCallback: function mapCallback(cpt, index) {
        return {
          key: "cpt-".concat(index),
          fields: cptFieldsWithHandlers,
          values: _objectSpread$z(_objectSpread$z({}, cpt), {}, {
            codeType: 'procedure'
          }),
          classNames: [].concat(codeLayerClassNames, [cpt.codeAssessment ? 'selected-code-assessment' : 'select-code-assessment']),
          draggable: procedureAllowNewCodes && editable,
          transactionId: transaction.id,
          cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
          editable: editable,
          workItemId: workItemId
        };
      }
    });
    var icdItems = sortAndMap({
      array: transaction.diagnoses,
      sortKey: 'sequenceNumber',
      mapCallback: function mapCallback(icd, index) {
        return {
          key: "icd-".concat(index),
          fields: icdFieldsWithHandlers,
          values: _objectSpread$z(_objectSpread$z({}, icd), {}, {
            codeType: 'diagnosis'
          }),
          classNames: [].concat(codeLayerClassNames, [icd.codeAssessment ? 'selected-code-assessment' : 'select-code-assessment']),
          draggable: diagnosisAllowNewCodes && editable,
          transactionId: transaction.id,
          cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
          editable: editable,
          workItemId: workItemId
        };
      }
    });
    var modifierItems = sortAndMap({
      array: transaction.modifiers,
      sortKey: 'sequenceNumber',
      mapCallback: function mapCallback(modifier, index) {
        return {
          key: "modifier-".concat(index),
          fields: modifierFieldsWithHandlers,
          values: _objectSpread$z(_objectSpread$z({}, modifier), {}, {
            codeType: 'modifier'
          }),
          classNames: [].concat(codeLayerClassNames, [modifier.codeAssessment ? 'selected-code-assessment' : 'select-code-assessment']),
          draggable: modifierAllowNewCodes && editable,
          transactionId: transaction.id,
          cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
          editable: editable,
          workItemId: workItemId
        };
      }
    });
    var lookupRef = React.useRef(null);
    var searchResults = (_codeSearch$searchRes = codeSearch === null || codeSearch === void 0 || (_codeSearch$searchRes2 = codeSearch.searchResults) === null || _codeSearch$searchRes2 === void 0 ? void 0 : _codeSearch$searchRes2[transaction.id]) !== null && _codeSearch$searchRes !== void 0 ? _codeSearch$searchRes : [];
    var onSearch = function onSearch(codeQuery) {
      if (!editable) return;
      props.codeSearch.onCodeSearch(_objectSpread$z(_objectSpread$z({}, codeQuery), {}, {
        context: {
          transaction: _objectSpread$z({}, transaction)
        }
      }));
    };
    var onCodeSelect = function onCodeSelect(codeInfo) {
      if (!editable) return;
      var isUnique = isCodeUniqueInCQATransaction(codeInfo.codeInfo, transaction);
      if (!isUnique) {
        return;
      }
      props.codeSearch.onCodeSearchSelection({
        codeInfo: codeInfo.codeInfo,
        context: _objectSpread$z(_objectSpread$z({}, codeInfo.context), {}, {
          transaction: _objectSpread$z({}, transaction)
        })
      });
    };
    var handleCodeResequence = function handleCodeResequence(action) {
      if (!action.dropCandidate || !action.dropTarget || !editable) {
        return;
      }
      onCodeEvent({
        code: _objectSpread$z(_objectSpread$z({}, action.dropCandidate), {}, {
          sequenceNumber: action.dropTarget.sequenceNumber
        }),
        context: {
          transaction: _objectSpread$z({}, transaction)
        }
      });
    };
    var canDropInto = function canDropInto(item1, item2, position, allItems) {
      if (!editable) return false;
      if (item1.codeType == item2.codeType && item1.transactionId == item2.transactionId) {
        return true;
      } else {
        return false;
      }
    };
    var onRemoveTransactionClick = function onRemoveTransactionClick(invoiceId, transactionId, original) {
      if (!editable) return;
      onDeleteCQATransaction({
        invoiceId: invoiceId,
        transactionId: transactionId,
        original: original
      });
    };
    var hasProcedureCodes = transaction.procedures.length > 0;

    //Display Procedure Lookup if procedure are active for the project and there is not a procedure code yet
    var incorrectCPTCount = transaction.procedures.filter(function (code) {
      var _cqaCodeAssessmentRis;
      return ((_cqaCodeAssessmentRis = cqaCodeAssessmentRiskDictionaries.procedure.rows.find(function (row) {
        var _code$codeAssessment;
        return row.assessment == (code === null || code === void 0 || (_code$codeAssessment = code.codeAssessment) === null || _code$codeAssessment === void 0 ? void 0 : _code$codeAssessment.assessment);
      })) === null || _cqaCodeAssessmentRis === void 0 ? void 0 : _cqaCodeAssessmentRis.category) == 'INCORRECT';
    }).length;
    var correctOrNeutralCPTCount = transaction.procedures.filter(function (code) {
      var _cqaCodeAssessmentRis2;
      return ((_cqaCodeAssessmentRis2 = cqaCodeAssessmentRiskDictionaries.procedure.rows.find(function (row) {
        var _code$codeAssessment2;
        return row.assessment == (code === null || code === void 0 || (_code$codeAssessment2 = code.codeAssessment) === null || _code$codeAssessment2 === void 0 ? void 0 : _code$codeAssessment2.assessment);
      })) === null || _cqaCodeAssessmentRis2 === void 0 ? void 0 : _cqaCodeAssessmentRis2.category) !== 'INCORRECT' || (code === null || code === void 0 ? void 0 : code.codeAssessment) == null;
    }).length;

    // caseEvaluationLevel is driven by an option on the CQA collection/rule.
    // ML models need support for case level and charge level grading. In case
    // level grading a grader can link several procedures on the same transaction/charge,
    // so in this case cpt search is always made availble. If case caseEvaluationLevel
    // is set to false then the default functionality is understood as charge level grading.
    var displayCPTLookup = procedureAllowNewCodes && (transaction.procedures.length == 0 || incorrectCPTCount > correctOrNeutralCPTCount || projectConfiguration.caseEvaluationLevel);
    //Display ICD Lookup if diagnosis are active for the project and the transaction has a CPT Code
    var displayICDLookup = diagnosisAllowNewCodes && (hasProcedureCodes || !procedure);
    //Display MOD Lookup if modifier are active for the project and the transaction has a Modifier Code
    var displayMODLookup = modifierAllowNewCodes && (hasProcedureCodes || !procedure);
    return (
      /*#__PURE__*/
      //Grade-bench-panel shares the invoice card with code-bench-panel-v2
      React.createElement(InvoiceCard, {
        additionalClasses: ['codable-invoice', 'qa-codable-invoice', 'transaction-card', 'gradeable-transaction', !editable && 'transaction-uneditable'].filter(Boolean),
        key: "transaction-".concat(transaction.sequenceNumber)
      }, /*#__PURE__*/React.createElement(Box, {
        className: "code-row charge-text"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-header-row"
      }, "Charge ", transaction.sequenceNumber), !transaction.original && editable && /*#__PURE__*/React.createElement("div", {
        className: "charge-remove"
      }, /*#__PURE__*/React.createElement("button", {
        className: "charge-remove-btn",
        onClick: function onClick() {
          return onRemoveTransactionClick(invoice.id, transaction.id, transaction.original);
        }
      }, "remove"))), procedureVisible && /*#__PURE__*/React.createElement(uiComponents.DraggableList, {
        items: cptItems,
        itemComponent: GenericCodeLayer,
        onDropHandler: handleCodeResequence,
        canDropOnto: canDropInto,
        droppable: editable,
        dragManager: draggedCodesManager$3,
        dataKey: 'values'
      }), displayCPTLookup && codeSearch && editable && /*#__PURE__*/React.createElement(uiComponents.Lookup, {
        ref: lookupRef,
        actionPrefix: "",
        placeholderText: 'Select procedure',
        debounceTimeout: 30,
        FieldDefinitions: [{
          label: 'Procedure',
          value: 'cpt',
          key: 'CPT'
        }],
        shouldShowResults: uiComponents.shouldShowResults,
        autoFocus: transaction.sequenceNumber == 1,
        onSearch: onSearch,
        onSearchSelection: onCodeSelect,
        searchResults: searchResults,
        SearchBarViewVersion: 'SearchBarView2'
      }), modifierVisible && /*#__PURE__*/React.createElement(uiComponents.DraggableList, {
        items: modifierItems,
        itemComponent: GenericCodeLayer,
        onDropHandler: handleCodeResequence,
        canDropOnto: canDropInto,
        droppable: editable,
        dragManager: draggedCodesManager$3,
        dataKey: 'values'
      }), displayMODLookup && codeSearch && editable && /*#__PURE__*/React.createElement(uiComponents.Lookup, {
        ref: lookupRef,
        actionPrefix: "",
        placeholderText: 'Select modifier',
        debounceTimeout: 30,
        FieldDefinitions: [{
          label: 'Modifier',
          value: 'modifier',
          key: 'MODIFIER'
        }],
        shouldShowResults: uiComponents.shouldShowResults,
        autoFocus: false,
        onSearch: onSearch,
        onSearchSelection: onCodeSelect,
        searchResults: searchResults,
        SearchBarViewVersion: 'SearchBarView2'
      }), diagnosisVisible && /*#__PURE__*/React.createElement(uiComponents.DraggableList, {
        items: icdItems,
        itemComponent: GenericCodeLayer,
        onDropHandler: handleCodeResequence,
        canDropOnto: canDropInto,
        droppable: editable,
        dragManager: draggedCodesManager$3,
        dataKey: 'values'
      }), displayICDLookup && codeSearch && editable && /*#__PURE__*/React.createElement(uiComponents.Lookup, {
        ref: lookupRef,
        actionPrefix: "",
        placeholderText: 'Select diagnosis',
        debounceTimeout: 30,
        FieldDefinitions: [{
          label: 'Diagnosis',
          value: 'icd',
          key: 'ICD'
        }],
        shouldShowResults: uiComponents.shouldShowResults,
        autoFocus: false,
        onSearch: onSearch,
        onSearchSelection: onCodeSelect,
        searchResults: searchResults,
        SearchBarViewVersion: 'SearchBarView2'
      }))
    );
  };
  var GradeBenchPanelGeneralized = function GradeBenchPanelGeneralized(props) {
    var _gradeableInvoices$, _gradeableInvoices$2, _resolverValidationEr;
    // Return grade-benchgroup

    var gradeableInvoices = props.gradeableInvoices,
      codeSearch = props.codeSearch,
      invoiceMetadataFields = props.invoiceMetadataFields,
      cptFields = props.cptFields,
      icdFields = props.icdFields,
      modifierFields = props.modifierFields,
      onCodeUpdate = props.onCodeUpdate,
      onCodeRemove = props.onCodeRemove,
      onCodeEvent = props.onCodeEvent,
      riskCategories = props.riskCategories,
      cqaCodeAssessmentRiskDictionaries = props.cqaCodeAssessmentRiskDictionaries,
      _props$projectConfigu = props.projectConfiguration,
      projectConfiguration = _props$projectConfigu === void 0 ? uiCommon.AmplifyState.defaultQARule.data.project_configuration : _props$projectConfigu,
      onCreateCQATransaction = props.onCreateCQATransaction,
      onDeleteCQATransaction = props.onDeleteCQATransaction,
      gradingErrors = props.gradingErrors,
      resolverValidationErrors = props.resolverValidationErrors,
      editable = props.editable;

    // Get workitemId from the first invoice (set during loadCQAItemFromURL)
    var sdCaseId = (_gradeableInvoices$ = gradeableInvoices[0]) === null || _gradeableInvoices$ === void 0 ? void 0 : _gradeableInvoices$.sdCaseId;
    var workitemId = (_gradeableInvoices$2 = gradeableInvoices[0]) === null || _gradeableInvoices$2 === void 0 ? void 0 : _gradeableInvoices$2.workitemId;
    var invoiceItems = gradeableInvoices.map(function (invoice, invoiceIndex) {
      var _invoice$dateOfServic, _invoice$billingProvi;
      var attachInvoiceToUpdate = function attachInvoiceToUpdate(update) {
        update.context['invoice'] = invoice;
        update.context.riskCategories = riskCategories;
        onCodeUpdate(_objectSpread$z({}, update));
      };
      var codeSearchWithInvoice = _objectSpread$z(_objectSpread$z({}, codeSearch), {}, {
        onCodeSearchSelection: function onCodeSearchSelection(codeAction) {
          codeAction.context.invoice = invoice;
          codeSearch.onCodeSearchSelection(codeAction);
        }
      });
      var onCodeEventWithInvoice = function onCodeEventWithInvoice(codeUpdate) {
        codeUpdate.context.invoice = invoice;
        onCodeEvent(codeUpdate);
      };
      var onAddTransactionClick = function onAddTransactionClick(invoice) {
        onCreateCQATransaction({
          invoiceId: invoice.id
        });
      };
      var txs = invoice.transactions.map(function (transaction, index) {
        return /*#__PURE__*/React.createElement(Transaction$1, {
          key: "transaction-".concat(index + 1, "-group"),
          invoice: invoice,
          transaction: transaction,
          codeSearch: codeSearchWithInvoice,
          cptFields: cptFields,
          icdFields: icdFields,
          modifierFields: modifierFields,
          onChange: attachInvoiceToUpdate,
          onCodeRemove: onCodeRemove,
          projectConfiguration: projectConfiguration,
          onCodeEvent: onCodeEventWithInvoice,
          onDeleteCQATransaction: onDeleteCQATransaction,
          cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
          editable: editable,
          workItemId: workitemId
        });
      });
      invoice.transactions.sort(function (t1, t2) {
        return t1.sequenceNumber - t2.sequenceNumber;
      });
      return {
        headerText: (_invoice$dateOfServic = invoice['dateOfService']) !== null && _invoice$dateOfServic !== void 0 ? _invoice$dateOfServic : '',
        subheaderText: (_invoice$billingProvi = invoice['billingProviderName']) !== null && _invoice$billingProvi !== void 0 ? _invoice$billingProvi : '',
        body: /*#__PURE__*/React.createElement("div", {
          key: invoiceIndex,
          className: "invoice-meta"
        }, /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-line invoice-meta-provider"
        }, /*#__PURE__*/React.createElement(InvoiceMetadatav2, {
          fields: invoiceMetadataFields,
          invoice: invoice,
          editable: false
        }), txs), !projectConfiguration.caseEvaluationLevel && editable && /*#__PURE__*/React.createElement("div", {
          key: "add-transaction-".concat(invoiceIndex),
          className: "add-transaction",
          onClick: function onClick() {
            return onAddTransactionClick(invoice);
          }
        }, /*#__PURE__*/React.createElement("button", {
          className: "add-transaction-btn"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: 'PlusSign1',
          svgIconClass: '',
          svgIconSize: '16',
          svgViewBox: '16'
        }), /*#__PURE__*/React.createElement("span", null, "\xA0 Add transaction")), gradingErrors.addTransaction && /*#__PURE__*/React.createElement("small", {
          className: "add-transaction-error"
        }, "error adding transaction")))
      };
    });
    var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showResolverErrorsModal = _useState2[0],
      setShowResolverErrorsModal = _useState2[1];
    var hasResolverErrors = ((_resolverValidationEr = resolverValidationErrors === null || resolverValidationErrors === void 0 ? void 0 : resolverValidationErrors.length) !== null && _resolverValidationEr !== void 0 ? _resolverValidationEr : 0) > 0;
    React.useEffect(function () {
      if (hasResolverErrors) {
        setShowResolverErrorsModal(true);
      }
      if (!(resolverValidationErrors !== null && resolverValidationErrors !== void 0 && resolverValidationErrors.length)) {
        setShowResolverErrorsModal(false);
      }
    }, [hasResolverErrors, resolverValidationErrors === null || resolverValidationErrors === void 0 ? void 0 : resolverValidationErrors.length]);
    return /*#__PURE__*/React.createElement(Box, {
      className: "code-bench-panelv2 grade-bench-panel"
    }, sdCaseId && /*#__PURE__*/React.createElement(CaseQuestionsForm, {
      sdWorkitemId: sdCaseId,
      evaluateFn: uiCommon.gradeBenchPanelActions.evaluateWorkflow,
      workItemId: workitemId
    }), showResolverErrorsModal && resolverValidationErrors && resolverValidationErrors.length > 0 && /*#__PURE__*/React.createElement(GradeBenchResolverModal, {
      validationErrors: resolverValidationErrors,
      onClose: function onClose() {
        return setShowResolverErrorsModal(false);
      }
    }), /*#__PURE__*/React.createElement(uiComponents.HorizontalTabContainer, {
      items: invoiceItems
    }));
  };

  function ownKeys$y(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$y(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$y(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$y(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: true } : { done: false, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = true, u = false; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = true, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var codePredicates = uiCommon.AmplifyCore.transactionUpdateDTOFactory.codePredicates;
  var CodeTypeMap = {
    procedure: 'PROCEDURE',
    modifier: 'MODIFIER',
    diagnosis: 'DIAGNOSIS'
  };

  // Maps code type to attribute entity type for API calls
  var codeTypeToEntityType = function codeTypeToEntityType(codeType) {
    switch (codeType) {
      case 'procedure':
        return 'code_procedure';
      case 'diagnosis':
        return 'code_diagnosis';
      case 'modifier':
        return 'code_modifier';
      default:
        return 'code_procedure';
      // fallback
    }
  };
  var AnnotatableDocumentWithDrawerWrapper = function AnnotatableDocumentWithDrawerWrapper(_ref) {
    var _qaRule$data, _projectConfiguration, _invoices$, _invoices$2;
    var text = _ref.text,
      noteId = _ref.noteId,
      spans = _ref.spans;
    var dispatch = useDispatch();
    var gradeBenchPanelState = useSelector(function (state) {
      return state.gradeBenchPanel;
    });
    var invoices = gradeBenchPanelState.invoices,
      codeDescriptions = gradeBenchPanelState.codeDescriptions,
      qaRule = gradeBenchPanelState.qaRule,
      fieldDefinitions = gradeBenchPanelState.fieldDefinitions,
      cqaCodeAssessmentRiskDictionaries = gradeBenchPanelState.cqaCodeAssessmentRiskDictionaries,
      rubricVersion = gradeBenchPanelState.rubricVersion;

    // Get project configuration
    var projectConfiguration = qaRule === null || qaRule === void 0 || (_qaRule$data = qaRule.data) === null || _qaRule$data === void 0 ? void 0 : _qaRule$data.project_configuration;
    var caseEvaluationLevel = (_projectConfiguration = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.caseEvaluationLevel) !== null && _projectConfiguration !== void 0 ? _projectConfiguration : false;
    var rubricVersionId = projectConfiguration === null || projectConfiguration === void 0 ? void 0 : projectConfiguration.rubricVersionId;

    // Fetch rubric version when rubricVersionId is available, clear it when it is not available
    React.useEffect(function () {
      if (rubricVersionId) {
        dispatch(uiCommon.gradeBenchPanelActions.fetchRubricVersion({
          versionId: rubricVersionId
        }));
      } else {
        dispatch(uiCommon.gradeBenchPanelActions.clearRubricVersion());
      }
    }, [rubricVersionId, dispatch]);
    var caseId = ((_invoices$ = invoices[0]) === null || _invoices$ === void 0 ? void 0 : _invoices$.sdCaseId) || '';
    var workItemId = (_invoices$2 = invoices[0]) === null || _invoices$2 === void 0 ? void 0 : _invoices$2.workitemId;

    // Get codeBench state for code search hook
    var _useSelector = useSelector(function (state) {
        var _codeBench$capabiliti, _codeBench$capabiliti2, _codeBench$benchEdita;
        var codeBench = state.codeBench;
        return {
          activeItem: (codeBench === null || codeBench === void 0 ? void 0 : codeBench.activeItem) || (codeBench === null || codeBench === void 0 || (_codeBench$capabiliti = codeBench.capabilities) === null || _codeBench$capabiliti === void 0 ? void 0 : _codeBench$capabiliti.activeItem) || {},
          userContext: state.ui.context.activeContext || (codeBench === null || codeBench === void 0 || (_codeBench$capabiliti2 = codeBench.capabilities) === null || _codeBench$capabiliti2 === void 0 ? void 0 : _codeBench$capabiliti2.userContext) || (codeBench === null || codeBench === void 0 ? void 0 : codeBench.userContext) || {},
          processInstance: codeBench === null || codeBench === void 0 ? void 0 : codeBench.processInstance,
          searchResultsMap: {
            v2: (codeBench === null || codeBench === void 0 ? void 0 : codeBench.codeSearchResultsV2) || {},
            v1: (codeBench === null || codeBench === void 0 ? void 0 : codeBench.searchResults) || {}
          },
          editable: codeBench === null || codeBench === void 0 || (_codeBench$benchEdita = codeBench.benchEditable) === null || _codeBench$benchEdita === void 0 ? void 0 : _codeBench$benchEdita.editable
        };
      }),
      activeItem = _useSelector.activeItem,
      userContext = _useSelector.userContext,
      processInstance = _useSelector.processInstance,
      searchResultsMap = _useSelector.searchResultsMap,
      editable = _useSelector.editable;

    // State for drawer and hover
    var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      drawerOpen = _useState2[0],
      setDrawerOpen = _useState2[1];
    var _useState3 = React.useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedSpanId = _useState4[0],
      setSelectedSpanId = _useState4[1];
    var _useState5 = React.useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      hoveredSpan = _useState6[0],
      setHoveredSpan = _useState6[1];

    // Track which codes we've already fetched attributes for to prevent duplicate fetches
    var fetchedAttributesRef = React.useRef(new Set());

    // Derive selectedSpan from Redux state so rubricAttributes stay in sync
    var selectedSpan = React.useMemo(function () {
      var _gradeBenchPanelState;
      if (!selectedSpanId) return null;
      // Check loose spans first
      var looseSpan = (_gradeBenchPanelState = gradeBenchPanelState.looseSpans) === null || _gradeBenchPanelState === void 0 ? void 0 : _gradeBenchPanelState.find(function (s) {
        return s.id === selectedSpanId;
      });
      if (looseSpan) return looseSpan;
      // Check spans attached to codes in invoices
      var _iterator = _createForOfIteratorHelper(invoices || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var invoice = _step.value;
          var _iterator2 = _createForOfIteratorHelper(invoice.transactions || []),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var transaction = _step2.value;
              for (var _i = 0, _arr = [transaction.procedures, transaction.diagnoses, transaction.modifiers]; _i < _arr.length; _i++) {
                var codes = _arr[_i];
                var _iterator3 = _createForOfIteratorHelper(codes || []),
                  _step3;
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    var _code$spans;
                    var code = _step3.value;
                    var found = (_code$spans = code.spans) === null || _code$spans === void 0 ? void 0 : _code$spans.find(function (s) {
                      return s.id === selectedSpanId;
                    });
                    if (found) return found;
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return null;
    }, [selectedSpanId, gradeBenchPanelState.looseSpans, invoices]);

    // Wrapper to match existing setSelectedSpan call sites
    var setSelectedSpan = React.useCallback(function (spanOrNull) {
      var _spanOrNull$id;
      setSelectedSpanId((_spanOrNull$id = spanOrNull === null || spanOrNull === void 0 ? void 0 : spanOrNull.id) !== null && _spanOrNull$id !== void 0 ? _spanOrNull$id : null);
    }, []);

    // Extract codes and calculate available
    var allInvoiceCodes = React.useMemo(function () {
      return uiCommon.extractCodesFromInvoices(invoices || [], codeDescriptions || {});
    }, [invoices, codeDescriptions]);

    // Filter available codes: exclude codes attached to any span
    var availableCodes = React.useMemo(function () {
      return allInvoiceCodes.filter(function (code) {
        var _code$spans2;
        return ((_code$spans2 = code.spans) === null || _code$spans2 === void 0 ? void 0 : _code$spans2.length) === 0;
      });
    }, [allInvoiceCodes, selectedSpan]);
    var suggestedCodes = React.useMemo(function () {
      // Get codes that ARE attached to spans
      var codesWithSpans = allInvoiceCodes.filter(function (code) {
        var _code$spans3;
        return ((_code$spans3 = code.spans) === null || _code$spans3 === void 0 ? void 0 : _code$spans3.length) > 0;
      });
      var procedures = codesWithSpans.filter(function (code) {
        return code.codeType === 'procedure';
      }).map(uiCommon.mapExtractedCodetoSuggestedCode);
      var diagnoses = codesWithSpans.filter(function (code) {
        return code.codeType === 'diagnosis';
      }).map(uiCommon.mapExtractedCodetoSuggestedCode);
      var modifiers = codesWithSpans.filter(function (code) {
        return code.codeType === 'modifier';
      }).map(uiCommon.mapExtractedCodetoSuggestedCode);
      return {
        cpt: {
          encounterList: [],
          caseList: procedures,
          codeSourceList: []
        },
        icd: {
          caseList: diagnoses,
          encounterList: [],
          codeSourceList: []
        },
        modifier: {
          caseList: modifiers,
          encounterList: [],
          codeSourceList: []
        }
      };
    }, [allInvoiceCodes]);

    // Use code search hook - pass Redux state values as parameters
    var codeSearch = uiCommon.useCodeSearch({
      dispatch: dispatch,
      caseId: caseId,
      lookupKey: selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id,
      activeItem: activeItem,
      userContext: userContext,
      processInstance: processInstance,
      searchResultsMap: searchResultsMap
    });

    // Use transaction creation and code addition hook
    var _useCreateTransaction = uiCommon.useCreateTransactionAndAddCode(dispatch),
      createTransactionAndAddCode = _useCreateTransaction.createTransactionAndAddCode;

    // Use code assessment update hook
    var _useCodeAssessmentUpd = uiCommon.useCodeAssessmentUpdate(dispatch),
      updateCodeAssessment = _useCodeAssessmentUpd.updateCodeAssessment;

    // Save rubric answers - Redux reducer handles updating span/code/case attributes in state
    var saveAttribute = React.useCallback(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return dispatch(uiCommon.gradeBenchPanelActions.updateAttribute(params));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), [dispatch]);

    // Delete rubric answers - Redux reducer handles removing span/code/case attributes in state
    var deleteAttribute = React.useCallback(/*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return dispatch(uiCommon.gradeBenchPanelActions.deleteAttribute(params));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    }(), [dispatch]);
    var clearDownstream = React.useCallback(function (params) {
      dispatch(uiCommon.gradeBenchPanelActions.clearDownstreamAttributes(params));
    }, [dispatch]);
    var revalidate = React.useCallback(function () {
      dispatch(uiCommon.gradeBenchPanelActions.revalidateWorkItem());
    }, [dispatch]);

    // Convert existing codes for selected span to AttachedCodes format
    var attachedCodes = React.useMemo(function () {
      if (!selectedSpan) {
        return {
          procedures: [],
          modifiers: [],
          diagnoses: []
        };
      }

      // Filter codes that have the selected span in their spans array
      var spanCodes = allInvoiceCodes.filter(function (code) {
        var _code$spans4;
        return (_code$spans4 = code.spans) === null || _code$spans4 === void 0 ? void 0 : _code$spans4.some(function (span) {
          return span.id === selectedSpan.id;
        });
      });
      return {
        procedures: spanCodes.filter(function (code) {
          return code.codeType === 'procedure';
        }),
        modifiers: spanCodes.filter(function (code) {
          return code.codeType === 'modifier';
        }),
        diagnoses: spanCodes.filter(function (code) {
          return code.codeType === 'diagnosis';
        })
      };
    }, [selectedSpan, allInvoiceCodes]);

    // Fetch code answers when drawer opens with attached codes
    React.useEffect(function () {
      if (drawerOpen && selectedSpan) {
        // Get all codes attached to the selected span
        var spanCodes = allInvoiceCodes.filter(function (code) {
          var _code$spans5;
          return (_code$spans5 = code.spans) === null || _code$spans5 === void 0 ? void 0 : _code$spans5.some(function (span) {
            return span.id === selectedSpan.id;
          });
        });

        // Fetch answers for each code that we haven't already fetched
        spanCodes.forEach(function (code) {
          var codeKey = "".concat(code.codeType, "-").concat(code.codeId);
          if (!fetchedAttributesRef.current.has(codeKey)) {
            fetchedAttributesRef.current.add(codeKey);
            dispatch(uiCommon.gradeBenchPanelActions.fetchAttributes({
              entityId: code.codeId.toString(),
              entityType: codeTypeToEntityType(code.codeType)
            }));
          }
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen, selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id, dispatch]);

    // Fetch span attributes when drawer opens - Redux reducer stores them on the span
    React.useEffect(function () {
      if (!drawerOpen || !selectedSpan) return;
      var spanKey = "span-".concat(selectedSpan.id);
      if (fetchedAttributesRef.current.has(spanKey)) return;
      fetchedAttributesRef.current.add(spanKey);
      dispatch(uiCommon.gradeBenchPanelActions.fetchAttributes({
        entityId: String(selectedSpan.id),
        entityType: 'span'
      }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [drawerOpen, selectedSpan === null || selectedSpan === void 0 ? void 0 : selectedSpan.id, dispatch]);

    // Handler for adding a code to an annotation (atomic save)
    var handleAttachCode = React.useCallback(/*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(code, annotation) {
        var _invoices$3, originalCode, codeKey, _t;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!noteId || !annotation.id)) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              _context3.prev = 1;
              originalCode = allInvoiceCodes.find(function (c) {
                return c.codeId === code.codeId && c.codeType === code.codeType;
              });
              if (originalCode) {
                _context3.next = 2;
                break;
              }
              throw new Error('Code not found in available codes');
            case 2:
              _context3.next = 3;
              return uiCommon.enrichingAnnotationHooks.attachCode(dispatch, {
                spanId: annotation.id,
                codeId: originalCode.codeId,
                codeType: CodeTypeMap[code.codeType],
                caseId: ((_invoices$3 = invoices[0]) === null || _invoices$3 === void 0 ? void 0 : _invoices$3.sdCaseId) || '',
                documentId: noteId
              });
            case 3:
              // Fetch attributes for this code if not already fetched
              // This handles the case where a code with existing attributes is attached while drawer is open
              codeKey = "".concat(code.codeType, "-").concat(code.codeId);
              if (!fetchedAttributesRef.current.has(codeKey)) {
                fetchedAttributesRef.current.add(codeKey);
                dispatch(uiCommon.gradeBenchPanelActions.fetchAttributes({
                  entityId: code.codeId.toString(),
                  entityType: codeTypeToEntityType(code.codeType)
                }));
              }
              revalidate();
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t = _context3["catch"](1);
              console.error('Failed to add code:', _t);
              throw _t;
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 4]]);
      }));
      return function (_x3, _x4) {
        return _ref4.apply(this, arguments);
      };
    }(), [noteId, dispatch, invoices, allInvoiceCodes, revalidate]);

    // Handler for removing a code from an annotation (atomic save)
    var handleRemoveCode = React.useCallback(/*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(code, annotation) {
        var originalCode, codeKey, _t2;
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(!noteId || !annotation.id)) {
                _context4.next = 1;
                break;
              }
              throw new Error('No note ID or annotation ID');
            case 1:
              _context4.prev = 1;
              originalCode = allInvoiceCodes.find(function (c) {
                return c.codeId === code.codeId && c.codeType === code.codeType;
              });
              if (originalCode) {
                _context4.next = 2;
                break;
              }
              throw new Error('Code not found in available codes');
            case 2:
              _context4.next = 3;
              return uiCommon.enrichingAnnotationHooks.detachCode(dispatch, {
                spanId: annotation.id,
                codeId: originalCode.codeId,
                codeType: CodeTypeMap[code.codeType]
              });
            case 3:
              // Clear the cache entry so attributes are re-fetched if code is re-attached
              codeKey = "".concat(code.codeType, "-").concat(code.codeId);
              fetchedAttributesRef.current.delete(codeKey);
              revalidate();
              _context4.next = 5;
              break;
            case 4:
              _context4.prev = 4;
              _t2 = _context4["catch"](1);
              console.error('Failed to remove code:', _t2);
              throw _t2;
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[1, 4]]);
      }));
      return function (_x5, _x6) {
        return _ref5.apply(this, arguments);
      };
    }(), [noteId, dispatch, allInvoiceCodes, revalidate]);

    // Handler for deleting entire annotation
    var handleDeleteAnnotation = React.useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var _t3;
      return _regeneratorRuntime.wrap(function (_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            if (selectedSpan) {
              _context5.next = 1;
              break;
            }
            return _context5.abrupt("return");
          case 1:
            _context5.prev = 1;
            _context5.next = 2;
            return uiCommon.enrichingAnnotationHooks.deleteSpan(dispatch, {
              spanId: selectedSpan.id
            });
          case 2:
            setDrawerOpen(false);
            setSelectedSpan(null);
            revalidate();
            _context5.next = 4;
            break;
          case 3:
            _context5.prev = 3;
            _t3 = _context5["catch"](1);
            console.error('Failed to delete annotation:', _t3);
          case 4:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[1, 3]]);
    })), [selectedSpan, dispatch, revalidate]);

    // Handler for text selection to create new annotation
    var handleTextSelection = React.useCallback(/*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(selectedText, startIndex, endIndex) {
        var _invoices$4, tempSpan, spanData, createdSpan, _t4;
        return _regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              tempSpan = {
                id: Date.now(),
                beginOffset: startIndex,
                endOffset: endIndex,
                coveredText: selectedText,
                attributes: [],
                documentId: noteId
              };
              spanData = {
                documentId: noteId.toString(),
                caseId: ((_invoices$4 = invoices[0]) === null || _invoices$4 === void 0 ? void 0 : _invoices$4.sdCaseId) || '',
                spans: [tempSpan]
              };
              _context6.next = 1;
              return uiCommon.enrichingAnnotationHooks.addEmptySpan(dispatch, spanData);
            case 1:
              createdSpan = _context6.sent;
              if (createdSpan) {
                setSelectedSpan(createdSpan);
                setDrawerOpen(true);
                revalidate();
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t4 = _context6["catch"](0);
              console.error('Failed to create empty span:', _t4);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 2]]);
      }));
      return function (_x7, _x8, _x9) {
        return _ref7.apply(this, arguments);
      };
    }(), [noteId, dispatch, invoices, revalidate]);

    // Handler for span click - opens drawer. Span rubricAttributes are stored in Redux.
    var handleSpanClick = React.useCallback(function (span, index, event) {
      setSelectedSpan(span);
      setDrawerOpen(true);
      setHoveredSpan(null);
    }, []);

    // Handler for span hover - shows preview
    var handleSpanHover = React.useCallback(function (span, index, event) {
      setHoveredSpan(span);
    }, []);

    // Handler for closing drawer
    var handleCloseDrawer = React.useCallback(function () {
      setDrawerOpen(false);
      setSelectedSpan(null);
    }, []);

    // Handler for closing annotation preview
    var handleCloseAnnotation = React.useCallback(function () {
      setHoveredSpan(null);
    }, []);

    // Build code search props for HighlightDrawer
    var codeSearchProps = React.useMemo(function () {
      if (!selectedSpan) {
        return {
          searchResults: {},
          onCodeSearch: function onCodeSearch() {},
          onCodeSearchSelection: function onCodeSearchSelection() {}
        };
      }
      var searchResultsKey = selectedSpan.id.toString();
      var searchResults = codeSearch.getSearchResults(selectedSpan.id);
      return {
        searchResults: _defineProperty({}, searchResultsKey, searchResults),
        onCodeSearch: function onCodeSearch(codeQuery) {
          codeSearch.onCodeSearch(codeQuery, {
            selectedSpan: selectedSpan,
            documentId: noteId,
            caseId: caseId,
            spans: [selectedSpan]
          }, searchResultsKey);
        },
        onCodeSearchSelection: function onCodeSearchSelection(codeAction) {
          var lastInvoice = invoices === null || invoices === void 0 ? void 0 : invoices.at(-1);
          if (!lastInvoice) {
            console.warn('No invoice found for code search selection');
            return;
          }

          // Check if caseEvaluationLevel is false and code is CPT
          var isCPTCode = codePredicates.isSelectionCPT(codeAction.codeInfo);
          var shouldCreateTransaction = !caseEvaluationLevel && isCPTCode;
          if (shouldCreateTransaction) {
            var _codeAction$context, _codeAction$context2;
            // Create transaction and add code in one operation
            var payload = {
              codeInfo: codeAction.codeInfo,
              context: _objectSpread$y(_objectSpread$y({}, codeAction.context), {}, {
                invoice: lastInvoice,
                processInstance: processInstance || ((_codeAction$context = codeAction.context) === null || _codeAction$context === void 0 ? void 0 : _codeAction$context.processInstance),
                activeItem: activeItem || ((_codeAction$context2 = codeAction.context) === null || _codeAction$context2 === void 0 ? void 0 : _codeAction$context2.activeItem)
              }),
              documentId: noteId,
              caseId: caseId,
              spans: [selectedSpan]
            };
            createTransactionAndAddCode(payload);
          } else {
            var _lastInvoice$transact;
            // Use last invoice's last transaction
            var transactionToUse = (_lastInvoice$transact = lastInvoice.transactions) === null || _lastInvoice$transact === void 0 ? void 0 : _lastInvoice$transact.at(-1);
            if (!transactionToUse) {
              return;
            }

            // Check for duplicate codes in the transaction
            var isUnique = isCodeUniqueInCQATransaction(codeAction.codeInfo, transactionToUse);
            if (!isUnique) {
              // Duplicate code detected, prevent adding
              return;
            }
            codeSearch.onCodeSearchSelection(codeAction, {
              transaction: transactionToUse,
              invoice: lastInvoice,
              documentId: noteId,
              caseId: caseId,
              spans: [selectedSpan]
            });
          }
        }
      };
    }, [selectedSpan, codeSearch, noteId, caseId, invoices, caseEvaluationLevel, createTransactionAndAddCode, activeItem, processInstance]);

    // Handler for code assessment/role updates
    var handleCodeAssessmentUpdate = React.useCallback(/*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(code, field, fields, value) {
        var _invoiceToUse$transac;
        var invoiceToUse, transactionToUse, codeTypeValue, codeValue, changeEvent;
        return _regeneratorRuntime.wrap(function (_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              // Find the invoice and transaction using the code's IDs
              invoiceToUse = invoices === null || invoices === void 0 ? void 0 : invoices.find(function (inv) {
                return inv.id === code.invoiceId;
              });
              transactionToUse = invoiceToUse === null || invoiceToUse === void 0 || (_invoiceToUse$transac = invoiceToUse.transactions) === null || _invoiceToUse$transac === void 0 ? void 0 : _invoiceToUse$transac.find(function (tx) {
                return tx.id === code.transactionId;
              });
              if (!(!invoiceToUse || !transactionToUse)) {
                _context7.next = 1;
                break;
              }
              console.warn("Invoice or transaction not found for code ".concat(code.compositeId));
              return _context7.abrupt("return");
            case 1:
              if (code.codeType === 'procedure') {
                codeTypeValue = 'procedure';
              } else if (code.codeType === 'diagnosis') {
                codeTypeValue = 'diagnosis';
              } else {
                codeTypeValue = 'modifier';
              }
              codeValue = {
                id: code.codeId,
                codeType: codeTypeValue,
                code: code.value,
                codeAssessment: code.codeAssessment || null
              }; // Create the GradeBenchSelectEvent
              changeEvent = {
                selection: value,
                context: {
                  value: codeValue,
                  field: field,
                  fields: fields,
                  transaction: transactionToUse,
                  invoice: invoiceToUse
                }
              }; // Dispatch the action using the hook
              _context7.next = 2;
              return updateCodeAssessment(changeEvent);
            case 2:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      return function (_x0, _x1, _x10, _x11) {
        return _ref8.apply(this, arguments);
      };
    }(), [updateCodeAssessment, invoices]);
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.AnnotatableDocument, {
      text: text,
      spans: spans,
      isAnnotationRenderPinnable: false,
      renderAnnotation: function renderAnnotation(span, onCloseCallback) {
        // Show AnnotationRender preview on hover (single-span path)
        if ((hoveredSpan === null || hoveredSpan === void 0 ? void 0 : hoveredSpan.id) === span.id && !drawerOpen) {
          return /*#__PURE__*/React.createElement(uiComponents.AnnotationRender, {
            key: span.id,
            mode: "read",
            span: span,
            availableCodes: availableCodes,
            existingCodes: allInvoiceCodes === null || allInvoiceCodes === void 0 ? void 0 : allInvoiceCodes.filter(function (code) {
              var _code$spans6;
              return (_code$spans6 = code.spans) === null || _code$spans6 === void 0 ? void 0 : _code$spans6.some(function (s) {
                return s.id === span.id;
              });
            }),
            onClose: handleCloseAnnotation,
            onAttachCode: handleAttachCode,
            onDetachCode: handleRemoveCode,
            onDelete: handleDeleteAnnotation
          });
        }
        return null;
      },
      renderPreviewContent: function renderPreviewContent(span) {
        return /*#__PURE__*/React.createElement(uiComponents.AnnotationRender, {
          key: span.id,
          mode: "read",
          span: span,
          availableCodes: availableCodes,
          existingCodes: allInvoiceCodes === null || allInvoiceCodes === void 0 ? void 0 : allInvoiceCodes.filter(function (code) {
            var _code$spans7;
            return (_code$spans7 = code.spans) === null || _code$spans7 === void 0 ? void 0 : _code$spans7.some(function (s) {
              return s.id === span.id;
            });
          }),
          onClose: handleCloseAnnotation,
          onAttachCode: handleAttachCode,
          onDetachCode: handleRemoveCode,
          onDelete: handleDeleteAnnotation
        });
      },
      enableHover: true,
      enableClick: true,
      closeOnBlur: false,
      onSpanClick: handleSpanClick,
      onSpanHover: handleSpanHover,
      enableTextSelection: true,
      onTextSelection: handleTextSelection,
      onAnnotationClose: handleCloseAnnotation
    }), /*#__PURE__*/React.createElement(HighlightDrawer, {
      isOpen: drawerOpen,
      onClose: handleCloseDrawer,
      size: "lg",
      selectedSpan: selectedSpan || undefined,
      attachedCodes: attachedCodes,
      availableCodes: availableCodes,
      codeSearch: codeSearchProps,
      caseId: caseId,
      onAttachCode: handleAttachCode,
      onDetachCode: handleRemoveCode,
      onDelete: handleDeleteAnnotation,
      codeAssessmentProps: {
        cptFields: fieldDefinitions === null || fieldDefinitions === void 0 ? void 0 : fieldDefinitions.cptFields,
        icdFields: fieldDefinitions === null || fieldDefinitions === void 0 ? void 0 : fieldDefinitions.icdFields,
        modifierFields: fieldDefinitions === null || fieldDefinitions === void 0 ? void 0 : fieldDefinitions.modifierFields,
        cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
        projectConfiguration: projectConfiguration,
        onCodeAssessmentUpdate: handleCodeAssessmentUpdate
      },
      suggestedCodes: suggestedCodes,
      rubricVersion: rubricVersion,
      onAttributeChange: saveAttribute,
      onDeleteAttribute: deleteAttribute,
      editable: editable,
      onClearDownstream: clearDownstream,
      evaluateFn: uiCommon.gradeBenchPanelActions.evaluateWorkflow,
      workItemId: workItemId
    }));
  };

  function _callSuper$s(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$s() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$s() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$s = function _isNativeReflectConstruct() { return !!t; })(); }
  var selectSpanAnnotations = uiCommon.spanSelectors.selectSpanAnnotations;
  var Note = /*#__PURE__*/function (_Component) {
    function Note() {
      _classCallCheck(this, Note);
      return _callSuper$s(this, Note, arguments);
    }
    _inherits(Note, _Component);
    return _createClass(Note, [{
      key: "render",
      value: function render() {
        var note = this.props.note;
        var _note$segments = note.segments,
          segments = _note$segments === void 0 ? [] : _note$segments,
          _note$spans = note.spans,
          spans = _note$spans === void 0 ? [] : _note$spans,
          document_id = note.document_id;
          note.filetype;
        var content = /*#__PURE__*/React.createElement(HighlightedContent, {
          segments: segments,
          spans: spans,
          id: document_id
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "report case-note qa-report sensitive-data",
          "data-testid": "case-note"
        }, content, /*#__PURE__*/React.createElement("div", {
          className: "divider-space"
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(Note, "displayName", 'Note');
  function NotePlainText(_ref) {
    var note = _ref.note;
    return /*#__PURE__*/React.createElement("div", {
      className: "report case-note qa-report sensitive-data",
      "data-testid": "case-note",
      style: {
        whiteSpace: 'pre-line'
      }
    }, note.content);
  }
  var EmptyNote = function EmptyNote() {
    return /*#__PURE__*/React.createElement("div", {
      className: "content-vacant qa-empty-note"
    }, /*#__PURE__*/React.createElement("h4", null, "No document available"), /*#__PURE__*/React.createElement("h4", null, "Please contact CodaMetrix if you expect to see a document for this case"), /*#__PURE__*/React.createElement("p", null, " support@codametrix.com "));
  };
  EmptyNote.displayName = 'EmptyNote';
  var sortNotes = function sortNotes(a, b) {
    if (a.primary === true) return -1;
    if (b.primary === true) return 1;
    return b.id - a.id;
  };
  var Notes = function Notes(props) {
    var _gradeBenchPanelState2;
    var _props$notes = props.notes,
      notes = _props$notes === void 0 ? [] : _props$notes,
      noteRefs = props.noteRefs;
    notes.sort(sortNotes);
    var gradeBenchPanelState = useSelector(function (state) {
      return state.gradeBenchPanel;
    });

    // Extract spanAnnotationEnabled from project_configuration, default to false
    var spanAnnotationEnabled = React.useMemo(function () {
      var _spanAnnotationEnable, _gradeBenchPanelState;
      return (_spanAnnotationEnable = gradeBenchPanelState === null || gradeBenchPanelState === void 0 || (_gradeBenchPanelState = gradeBenchPanelState.qaRule) === null || _gradeBenchPanelState === void 0 || (_gradeBenchPanelState = _gradeBenchPanelState.data) === null || _gradeBenchPanelState === void 0 || (_gradeBenchPanelState = _gradeBenchPanelState.project_configuration) === null || _gradeBenchPanelState === void 0 ? void 0 : _gradeBenchPanelState.spanAnnotationEnabled) !== null && _spanAnnotationEnable !== void 0 ? _spanAnnotationEnable : false;
    }, [gradeBenchPanelState === null || gradeBenchPanelState === void 0 || (_gradeBenchPanelState2 = gradeBenchPanelState.qaRule) === null || _gradeBenchPanelState2 === void 0 || (_gradeBenchPanelState2 = _gradeBenchPanelState2.data) === null || _gradeBenchPanelState2 === void 0 ? void 0 : _gradeBenchPanelState2.project_configuration]);
    var spanAnnotations = React.useMemo(function () {
      return gradeBenchPanelState ? selectSpanAnnotations(gradeBenchPanelState) : [];
    }, [gradeBenchPanelState === null || gradeBenchPanelState === void 0 ? void 0 : gradeBenchPanelState.invoices, gradeBenchPanelState === null || gradeBenchPanelState === void 0 ? void 0 : gradeBenchPanelState.looseSpans]);
    var noteContent = notes.map(function (note) {
      var _note$documentNotices;
      var synthKey = "".concat(note === null || note === void 0 ? void 0 : note.id);
      // {
      //   !note.filename && !note.description;
      // }
      var content;
      var notices = false;
      if (note.filetype === 'text/html') {
        content = /*#__PURE__*/React.createElement(NoteFrame, {
          key: synthKey,
          iframeNote: note
        });
      } else if (note.filetype === 'application/pdf') {
        content = /*#__PURE__*/React.createElement(PDFFrame, {
          key: synthKey,
          pdfContent: note
        });
      }
      // CQA conditionals will maintain backwards compatability for existing Note displays
      else if (note.filetype === 'text/plain' && note.benchmode === uiCommon.commonEnums.BenchMode.GRADE && !spanAnnotationEnabled) {
        content = /*#__PURE__*/React.createElement(NotePlainText, {
          key: synthKey,
          note: note
        });
      } else if (note.filetype === 'text/plain' && note.benchmode === uiCommon.commonEnums.BenchMode.GRADE) {
        // Use Redux annotations state filtered by document ID
        var noteAnnotations = spanAnnotations.filter(function (span) {
          return span.documentId === note.document_id;
        });
        content = /*#__PURE__*/React.createElement(AnnotatableDocumentWithDrawerWrapper, {
          text: note.content,
          noteId: note.document_id,
          spans: noteAnnotations
        });
      } else {
        content = /*#__PURE__*/React.createElement(Note, {
          key: synthKey,
          note: note
        });
      }
      var documentNotices = (_note$documentNotices = note === null || note === void 0 ? void 0 : note.documentNotices) !== null && _note$documentNotices !== void 0 ? _note$documentNotices : [];
      if (documentNotices.length) {
        notices = documentNotices.map(function (notice, idx) {
          return /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: notice.level,
            alertSize: "sm",
            key: "document-notice-".concat(idx)
          }, notice.message);
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        key: note.document_id,
        ref: noteRefs ? noteRefs[note.document_id] : undefined,
        className: "notes-inner ".concat(note.document_id)
      }, notices, content, !note.filename && !note.description ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement("div", {
        className: "notes-heading"
      }, /*#__PURE__*/React.createElement("p", {
        className: "note-text"
      }, /*#__PURE__*/React.createElement("span", {
        className: "note-name"
      }, " End of ", note.filename), /*#__PURE__*/React.createElement("span", {
        className: "note-description"
      }, !note.description ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(React.Fragment, null, ' — ', note.description))), /*#__PURE__*/React.createElement("hr", {
        className: "notes-divider"
      })));
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, noteContent !== null && noteContent !== void 0 && noteContent.length ? noteContent : /*#__PURE__*/React.createElement(EmptyNote, null));
  };
  Notes.displayName = 'Notes';

  var mapping = {};
  mapping['exam_description'] = 'exam_description';
  mapping['procedure_type'] = 'procedure_type';
  mapping['reason_for_visit'] = 'reason_for_visit';
  mapping['notes'] = 'body';

  var getFeatureForSelection$2 = uiCommon.cmxArtifacts.getFeatureForSelection,
    isSingleSelection$2 = uiCommon.cmxArtifacts.isSingleSelection,
    isLinkable = uiCommon.cmxArtifacts.isLinkable;
  var isCategorical = uiCommon.cmxTypeguards.isCategorical,
    isNgram = uiCommon.cmxTypeguards.isNgram;
  var NA$1 = 'N/A';
  var onlyType = function onlyType(items) {
    return items.filter(function (item) {
      var _ref;
      var feature = getFeatureForSelection$2(item);
      return (_ref = isSingleSelection$2(item) && (isCategorical(feature) || isNgram(feature))) !== null && _ref !== void 0 ? _ref : false;
    });
  };
  var propAccessor = function propAccessor(detail, evidenceManager) {
    return function (propPath) {
      var altValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NA$1;
      var prop = uiCommon.objectUtils.get(detail, propPath, altValue);
      var evidenceKey = mapping[propPath];
      // no evidence may be sought, if so, just return the value
      if (evidenceKey === undefined) {
        return prop !== null ? prop : altValue;
      }
      var notLinked = !isLinkable(evidenceKey);
      // check to see if we have any highlights
      var isHighlighted = evidenceManager.isHighlighted(evidenceKey);
      if (notLinked || !isHighlighted) {
        return prop !== null ? prop : altValue;
      }
      var isSelected = evidenceManager.isSelected(evidenceKey);
      var highlights = evidenceManager.getHighlights(evidenceKey);
      if (highlights === undefined) {
        return prop;
      }
      // deal with categorical evidence only at this time
      var categoricals = onlyType(highlights);
      if (!categoricals.length) {
        return prop;
      }

      // wrap the value in spans for particular codes
      var highlighted = prop;
      categoricals.forEach(function (categorical) {
        if (isSingleSelection$2(categorical) && !categorical.evidence) {
          return;
        }
        var styleClasses = ["evidence", 'highlighted-text', {
          'evidence-categorical': true,
          'qa-evidence-categorical': true,
          'evidence-active': isSelected,
          'qa-evidence-active': isSelected
        }, "evidence-".concat(categorical.codeType.toLowerCase())];
        highlighted = /*#__PURE__*/React.createElement("span", {
          className: classnames(styleClasses)
        }, highlighted);
      });
      return highlighted;
    };
  };

  var ProcessSelection = function ProcessSelection(props) {
    var caseRuns = props.caseRuns,
      activeId = props.activeId,
      onClick = props.onClick;
    var multipleRunTypes = Object.keys(caseRuns).filter(function (key) {
      return caseRuns[key].length > 0;
    }).length > 1;
    return /*#__PURE__*/React.createElement("div", {
      className: "btn-group btn-group-block process-selection"
    }, Object.keys(caseRuns).map(function (runType) {
      var display = runType === 'prediction' ? 'Final' : runType;
      if (caseRuns[runType].length > 0) {
        var runs = caseRuns[runType].sort(function (a, b) {
          return a.process_instance_id - b.process_instance_id;
        });
        var activeIndex = runs.findIndex(function (run) {
          return run.process_instance_id === activeId;
        });
        var classes = classnames([runType, {
          'multiple-run-types': multipleRunTypes
        }]);
        return /*#__PURE__*/React.createElement("div", {
          className: classes,
          key: "".concat(runType)
        }, runs.length === 1 ? /*#__PURE__*/React.createElement("a", {
          className: "qa-".concat(runType, "-button"),
          href: "#/new-process",
          "data-process-id": runs[0].process_instance_id,
          onClick: onClick
        }, /*#__PURE__*/React.createElement("button", {
          className: classnames(["btn", "btn-sm", {
            active: activeIndex !== -1
          }])
        }, display)) : null, runs.length > 1 ? /*#__PURE__*/React.createElement("div", {
          className: "dropdown",
          key: "".concat(runType, "-dropdown")
        }, /*#__PURE__*/React.createElement("button", {
          className: classnames(["qa-".concat(runType, "-dropdown dropdown-toggle btn btn-sm"), {
            active: activeIndex !== -1
          }])
        }, display, " ", activeIndex !== -1 ? activeIndex + 1 : null, ' ', /*#__PURE__*/React.createElement("i", {
          className: "icon icon-caret"
        })), /*#__PURE__*/React.createElement("ul", {
          className: "menu"
        }, runs.map(function (run, idx) {
          return /*#__PURE__*/React.createElement("li", {
            className: "menu-item",
            key: "".concat(runType, "-").concat(idx)
          }, /*#__PURE__*/React.createElement("a", {
            "data-testid": "".concat(runType, "-").concat(idx, "-button"),
            className: classnames(["qa-".concat(runType, "-").concat(idx, "-button dropdown-item"), {
              active: run.process_instance_id === activeId
            }]),
            href: "#/new-process",
            "data-process-id": run.process_instance_id,
            onClick: onClick
          }, "".concat(display, " ").concat(idx + 1)));
        }))) : null);
      } else {
        return null;
      }
    }));
  };
  ProcessSelection.displayName = 'ProcessSelection';

  var main$1 = {exports: {}};

  var main = main$1.exports;

  var hasRequiredMain;

  function requireMain () {
  	if (hasRequiredMain) return main$1.exports;
  	hasRequiredMain = 1;
  	(function (module, exports$1) {
  		!function(e,t){module.exports=t(React);}(main,(function(e){return function(e){var t={};function n(a){if(t[a])return t[a].exports;var r=t[a]={i:a,l:false,exports:{}};return e[a].call(r.exports,r,r.exports,n),r.l=true,r.exports}return n.m=e,n.c=t,n.d=function(e,t,a){n.o(e,t)||Object.defineProperty(e,t,{enumerable:true,get:a});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:true});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var a=Object.create(null);if(n.r(a),Object.defineProperty(a,"default",{enumerable:true,value:e}),2&t&&"string"!=typeof e)for(var r in e)n.d(a,r,function(t){return e[t]}.bind(null,r));return a},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=48)}([function(t,n){t.exports=e;},function(e,t){var n=e.exports={version:"2.6.12"};"number"==typeof __e&&(__e=n);},function(e,t,n){var a=n(26)("wks"),r=n(17),o=n(3).Symbol,i="function"==typeof o;(e.exports=function(e){return a[e]||(a[e]=i&&o[e]||(i?o:r)("Symbol."+e))}).store=a;},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n);},function(e,t,n){e.exports=!n(8)((function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a}));},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)};},function(e,t,n){var a=n(7),r=n(16);e.exports=n(4)?function(e,t,n){return a.f(e,t,r(1,n))}:function(e,t,n){return e[t]=n,e};},function(e,t,n){var a=n(10),r=n(35),o=n(23),i=Object.defineProperty;t.f=n(4)?Object.defineProperty:function(e,t,n){if(a(e),t=o(t,true),a(n),r)try{return i(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return "value"in n&&(e[t]=n.value),e};},function(e,t){e.exports=function(e){try{return !!e()}catch(e){return  true}};},function(e,t,n){var a=n(40),r=n(22);e.exports=function(e){return a(r(e))};},function(e,t,n){var a=n(11);e.exports=function(e){if(!a(e))throw TypeError(e+" is not an object!");return e};},function(e,t){e.exports=function(e){return "object"==typeof e?null!==e:"function"==typeof e};},function(e,t){e.exports={};},function(e,t,n){var a=n(39),r=n(27);e.exports=Object.keys||function(e){return a(e,r)};},function(e,t){e.exports=true;},function(e,t,n){var a=n(3),r=n(1),o=n(53),i=n(6),s=n(5),c=function(e,t,n){var l,u,f,p=e&c.F,d=e&c.G,b=e&c.S,h=e&c.P,v=e&c.B,m=e&c.W,y=d?r:r[t]||(r[t]={}),g=y.prototype,E=d?a:b?a[t]:(a[t]||{}).prototype;for(l in d&&(n=t),n)(u=!p&&E&&void 0!==E[l])&&s(y,l)||(f=u?E[l]:n[l],y[l]=d&&"function"!=typeof E[l]?n[l]:v&&u?o(f,a):m&&E[l]==f?function(e){var t=function(t,n,a){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,a)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(f):h&&"function"==typeof f?o(Function.call,f):f,h&&((y.virtual||(y.virtual={}))[l]=f,e&c.R&&g&&!g[l]&&i(g,l,f)));};c.F=1,c.G=2,c.S=4,c.P=8,c.B=16,c.W=32,c.U=64,c.R=128,e.exports=c;},function(e,t){e.exports=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}};},function(e,t){var n=0,a=Math.random();e.exports=function(e){return "Symbol(".concat(void 0===e?"":e,")_",(++n+a).toString(36))};},function(e,t,n){var a=n(22);e.exports=function(e){return Object(a(e))};},function(e,t){t.f={}.propertyIsEnumerable;},function(e,t,n){var a=n(52)(true);n(34)(String,"String",(function(e){this._t=String(e),this._i=0;}),(function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:true}:(e=a(t,n),this._i+=e.length,{value:e,done:false})}));},function(e,t){var n=Math.ceil,a=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?a:n)(e)};},function(e,t){e.exports=function(e){if(null==e)throw TypeError("Can't call method on  "+e);return e};},function(e,t,n){var a=n(11);e.exports=function(e,t){if(!a(e))return e;var n,r;if(t&&"function"==typeof(n=e.toString)&&!a(r=n.call(e)))return r;if("function"==typeof(n=e.valueOf)&&!a(r=n.call(e)))return r;if(!t&&"function"==typeof(n=e.toString)&&!a(r=n.call(e)))return r;throw TypeError("Can't convert object to primitive value")};},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)};},function(e,t,n){var a=n(26)("keys"),r=n(17);e.exports=function(e){return a[e]||(a[e]=r(e))};},function(e,t,n){var a=n(1),r=n(3),o=r["__core-js_shared__"]||(r["__core-js_shared__"]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:a.version,mode:n(14)?"pure":"global",copyright:"© 2020 Denis Pushkarev (zloirock.ru)"});},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");},function(e,t,n){var a=n(7).f,r=n(5),o=n(2)("toStringTag");e.exports=function(e,t,n){e&&!r(e=n?e:e.prototype,o)&&a(e,o,{configurable:true,value:t});};},function(e,t,n){n(62);for(var a=n(3),r=n(6),o=n(12),i=n(2)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),c=0;c<s.length;c++){var l=s[c],u=a[l],f=u&&u.prototype;f&&!f[i]&&r(f,i,l),o[l]=o.Array;}},function(e,t,n){t.f=n(2);},function(e,t,n){var a=n(3),r=n(1),o=n(14),i=n(30),s=n(7).f;e.exports=function(e){var t=r.Symbol||(r.Symbol=o?{}:a.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:i.f(e)});};},function(e,t){t.f=Object.getOwnPropertySymbols;},function(e,t){e.exports=function(e,t,n){return Math.min(Math.max(e,t),n)};},function(e,t,n){var a=n(14),r=n(15),o=n(37),i=n(6),s=n(12),c=n(55),l=n(28),u=n(61),f=n(2)("iterator"),p=!([].keys&&"next"in[].keys()),d=function(){return this};e.exports=function(e,t,n,b,h,v,m){c(n,t,b);var y,g,E,j=function(e){if(!p&&e in O)return O[e];switch(e){case "keys":case "values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},x=t+" Iterator",_="values"==h,k=false,O=e.prototype,C=O[f]||O["@@iterator"]||h&&O[h],S=C||j(h),w=h?_?j("entries"):S:void 0,A="Array"==t&&O.entries||C;if(A&&(E=u(A.call(new e)))!==Object.prototype&&E.next&&(l(E,x,true),a||"function"==typeof E[f]||i(E,f,d)),_&&C&&"values"!==C.name&&(k=true,S=function(){return C.call(this)}),a&&!m||!p&&!k&&O[f]||i(O,f,S),s[t]=S,s[x]=d,h)if(y={values:_?S:j("values"),keys:v?S:j("keys"),entries:w},m)for(g in y)g in O||o(O,g,y[g]);else r(r.P+r.F*(p||k),t,y);return y};},function(e,t,n){e.exports=!n(4)&&!n(8)((function(){return 7!=Object.defineProperty(n(36)("div"),"a",{get:function(){return 7}}).a}));},function(e,t,n){var a=n(11),r=n(3).document,o=a(r)&&a(r.createElement);e.exports=function(e){return o?r.createElement(e):{}};},function(e,t,n){e.exports=n(6);},function(e,t,n){var a=n(10),r=n(56),o=n(27),i=n(25)("IE_PROTO"),s=function(){},c=function(){var e,t=n(36)("iframe"),a=o.length;for(t.style.display="none",n(60).appendChild(t),t.src="javascript:",(e=t.contentWindow.document).open(),e.write("<script>document.F=Object<\/script>"),e.close(),c=e.F;a--;)delete c.prototype[o[a]];return c()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=a(e),n=new s,s.prototype=null,n[i]=e):n=c(),void 0===t?n:r(n,t)};},function(e,t,n){var a=n(5),r=n(9),o=n(57)(false),i=n(25)("IE_PROTO");e.exports=function(e,t){var n,s=r(e),c=0,l=[];for(n in s)n!=i&&a(s,n)&&l.push(n);for(;t.length>c;)a(s,n=t[c++])&&(~o(l,n)||l.push(n));return l};},function(e,t,n){var a=n(24);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return "String"==a(e)?e.split(""):Object(e)};},function(e,t,n){var a=n(39),r=n(27).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return a(e,r)};},function(e,t,n){var a=n(24),r=n(2)("toStringTag"),o="Arguments"==a(function(){return arguments}());e.exports=function(e){var t,n,i;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=function(e,t){try{return e[t]}catch(e){}}(t=Object(e),r))?n:o?a(t):"Object"==(i=a(t))&&"function"==typeof t.callee?"Arguments":i};},function(e,t){var n;n=function(){return this}();try{n=n||new Function("return this")();}catch(e){"object"==typeof window&&(n=window);}e.exports=n;},function(e,t){var n=/-?\d+(\.\d+)?%?/g;e.exports=function(e){return e.match(n)};},function(e,t,n){Object.defineProperty(t,"__esModule",{value:true}),t.getBase16Theme=t.createStyling=t.invertTheme=void 0;var a=d(n(49)),r=d(n(76)),o=d(n(81)),i=d(n(89)),s=d(n(93)),c=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}(n(94)),l=d(n(132)),u=d(n(133)),f=d(n(138)),p=n(139);function d(e){return e&&e.__esModule?e:{default:e}}var b=c.default,h=(0, i.default)(b),v=(0, f.default)(u.default,p.rgb2yuv,(function(e){var t,n=(0, o.default)(e,3),a=n[0],r=n[1],i=n[2];return [(t=a,t<.25?1:t<.5?.9-t:1.1-t),r,i]}),p.yuv2rgb,l.default),m=function(e){return function(t){return {className:[t.className,e.className].filter(Boolean).join(" "),style:(0, r.default)({},t.style||{},e.style||{})}}},y=function(e,t){var n=(0, i.default)(t);for(var o in e) -1===n.indexOf(o)&&n.push(o);return n.reduce((function(n,o){return n[o]=function(e,t){if(void 0===e)return t;if(void 0===t)return e;var n=void 0===e?"undefined":(0, a.default)(e),o=void 0===t?"undefined":(0, a.default)(t);switch(n){case "string":switch(o){case "string":return [t,e].filter(Boolean).join(" ");case "object":return m({className:e,style:t});case "function":return function(n){for(var a=arguments.length,r=Array(a>1?a-1:0),o=1;o<a;o++)r[o-1]=arguments[o];return m({className:e})(t.apply(void 0,[n].concat(r)))}}case "object":switch(o){case "string":return m({className:t,style:e});case "object":return (0, r.default)({},t,e);case "function":return function(n){for(var a=arguments.length,r=Array(a>1?a-1:0),o=1;o<a;o++)r[o-1]=arguments[o];return m({style:e})(t.apply(void 0,[n].concat(r)))}}case "function":switch(o){case "string":return function(n){for(var a=arguments.length,r=Array(a>1?a-1:0),o=1;o<a;o++)r[o-1]=arguments[o];return e.apply(void 0,[m(n)({className:t})].concat(r))};case "object":return function(n){for(var a=arguments.length,r=Array(a>1?a-1:0),o=1;o<a;o++)r[o-1]=arguments[o];return e.apply(void 0,[m(n)({style:t})].concat(r))};case "function":return function(n){for(var a=arguments.length,r=Array(a>1?a-1:0),o=1;o<a;o++)r[o-1]=arguments[o];return e.apply(void 0,[t.apply(void 0,[n].concat(r))].concat(r))}}}}(e[o],t[o]),n}),{})},g=function(e,t){for(var n=arguments.length,o=Array(n>2?n-2:0),s=2;s<n;s++)o[s-2]=arguments[s];if(null===t)return e;Array.isArray(t)||(t=[t]);var c=t.map((function(t){return e[t]})).filter(Boolean),l=c.reduce((function(e,t){return "string"==typeof t?e.className=[e.className,t].filter(Boolean).join(" "):"object"===(void 0===t?"undefined":(0, a.default)(t))?e.style=(0, r.default)({},e.style,t):"function"==typeof t&&(e=(0, r.default)({},e,t.apply(void 0,[e].concat(o)))),e}),{className:"",style:{}});return l.className||delete l.className,0===(0, i.default)(l.style).length&&delete l.style,l},E=t.invertTheme=function(e){return (0, i.default)(e).reduce((function(t,n){return t[n]=/^base/.test(n)?v(e[n]):"scheme"===n?e[n]+":inverted":e[n],t}),{})},j=(t.createStyling=(0, s.default)((function(e){for(var t=arguments.length,n=Array(t>3?t-3:0),a=3;a<t;a++)n[a-3]=arguments[a];var o=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},c=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{},l=o.defaultBase16,u=void 0===l?b:l,f=o.base16Themes,p=void 0===f?null:f,d=j(c,p);d&&(c=(0, r.default)({},d,c));var v=h.reduce((function(e,t){return e[t]=c[t]||u[t],e}),{}),m=(0, i.default)(c).reduce((function(e,t){return  -1===h.indexOf(t)?(e[t]=c[t],e):e}),{}),E=e(v),x=y(m,E);return (0, s.default)(g,2).apply(void 0,[x].concat(n))}),3),t.getBase16Theme=function(e,t){if(e&&e.extend&&(e=e.extend),"string"==typeof e){var n=e.split(":"),a=(0, o.default)(n,2),r=a[0],i=a[1];e=(t||{})[r]||c[r],"inverted"===i&&(e=E(e));}return e&&e.hasOwnProperty("base00")?e:void 0});},function(e,t,n){var a,r="object"==typeof Reflect?Reflect:null,o=r&&"function"==typeof r.apply?r.apply:function(e,t,n){return Function.prototype.apply.call(e,t,n)};a=r&&"function"==typeof r.ownKeys?r.ownKeys:Object.getOwnPropertySymbols?function(e){return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e))}:function(e){return Object.getOwnPropertyNames(e)};var i=Number.isNaN||function(e){return e!=e};function s(){s.init.call(this);}e.exports=s,e.exports.once=function(e,t){return new Promise((function(n,a){function r(){ void 0!==o&&e.removeListener("error",o),n([].slice.call(arguments));}var o;"error"!==t&&(o=function(n){e.removeListener(t,r),a(n);},e.once("error",o)),e.once(t,r);}))},s.EventEmitter=s,s.prototype._events=void 0,s.prototype._eventsCount=0,s.prototype._maxListeners=void 0;var c=10;function l(e){if("function"!=typeof e)throw new TypeError('The "listener" argument must be of type Function. Received type '+typeof e)}function u(e){return void 0===e._maxListeners?s.defaultMaxListeners:e._maxListeners}function f(e,t,n,a){var r,o,i,s;if(l(n),void 0===(o=e._events)?(o=e._events=Object.create(null),e._eventsCount=0):(void 0!==o.newListener&&(e.emit("newListener",t,n.listener?n.listener:n),o=e._events),i=o[t]),void 0===i)i=o[t]=n,++e._eventsCount;else if("function"==typeof i?i=o[t]=a?[n,i]:[i,n]:a?i.unshift(n):i.push(n),(r=u(e))>0&&i.length>r&&!i.warned){i.warned=true;var c=new Error("Possible EventEmitter memory leak detected. "+i.length+" "+String(t)+" listeners added. Use emitter.setMaxListeners() to increase limit");c.name="MaxListenersExceededWarning",c.emitter=e,c.type=t,c.count=i.length,s=c,console&&console.warn&&console.warn(s);}return e}function p(){if(!this.fired)return this.target.removeListener(this.type,this.wrapFn),this.fired=true,0===arguments.length?this.listener.call(this.target):this.listener.apply(this.target,arguments)}function d(e,t,n){var a={fired:false,wrapFn:void 0,target:e,type:t,listener:n},r=p.bind(a);return r.listener=n,a.wrapFn=r,r}function b(e,t,n){var a=e._events;if(void 0===a)return [];var r=a[t];return void 0===r?[]:"function"==typeof r?n?[r.listener||r]:[r]:n?function(e){for(var t=new Array(e.length),n=0;n<t.length;++n)t[n]=e[n].listener||e[n];return t}(r):v(r,r.length)}function h(e){var t=this._events;if(void 0!==t){var n=t[e];if("function"==typeof n)return 1;if(void 0!==n)return n.length}return 0}function v(e,t){for(var n=new Array(t),a=0;a<t;++a)n[a]=e[a];return n}Object.defineProperty(s,"defaultMaxListeners",{enumerable:true,get:function(){return c},set:function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received '+e+".");c=e;}}),s.init=function(){ void 0!==this._events&&this._events!==Object.getPrototypeOf(this)._events||(this._events=Object.create(null),this._eventsCount=0),this._maxListeners=this._maxListeners||void 0;},s.prototype.setMaxListeners=function(e){if("number"!=typeof e||e<0||i(e))throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received '+e+".");return this._maxListeners=e,this},s.prototype.getMaxListeners=function(){return u(this)},s.prototype.emit=function(e){for(var t=[],n=1;n<arguments.length;n++)t.push(arguments[n]);var a="error"===e,r=this._events;if(void 0!==r)a=a&&void 0===r.error;else if(!a)return  false;if(a){var i;if(t.length>0&&(i=t[0]),i instanceof Error)throw i;var s=new Error("Unhandled error."+(i?" ("+i.message+")":""));throw s.context=i,s}var c=r[e];if(void 0===c)return  false;if("function"==typeof c)o(c,this,t);else {var l=c.length,u=v(c,l);for(n=0;n<l;++n)o(u[n],this,t);}return  true},s.prototype.addListener=function(e,t){return f(this,e,t,false)},s.prototype.on=s.prototype.addListener,s.prototype.prependListener=function(e,t){return f(this,e,t,true)},s.prototype.once=function(e,t){return l(t),this.on(e,d(this,e,t)),this},s.prototype.prependOnceListener=function(e,t){return l(t),this.prependListener(e,d(this,e,t)),this},s.prototype.removeListener=function(e,t){var n,a,r,o,i;if(l(t),void 0===(a=this._events))return this;if(void 0===(n=a[e]))return this;if(n===t||n.listener===t)0==--this._eventsCount?this._events=Object.create(null):(delete a[e],a.removeListener&&this.emit("removeListener",e,n.listener||t));else if("function"!=typeof n){for(r=-1,o=n.length-1;o>=0;o--)if(n[o]===t||n[o].listener===t){i=n[o].listener,r=o;break}if(r<0)return this;0===r?n.shift():function(e,t){for(;t+1<e.length;t++)e[t]=e[t+1];e.pop();}(n,r),1===n.length&&(a[e]=n[0]),void 0!==a.removeListener&&this.emit("removeListener",e,i||t);}return this},s.prototype.off=s.prototype.removeListener,s.prototype.removeAllListeners=function(e){var t,n,a;if(void 0===(n=this._events))return this;if(void 0===n.removeListener)return 0===arguments.length?(this._events=Object.create(null),this._eventsCount=0):void 0!==n[e]&&(0==--this._eventsCount?this._events=Object.create(null):delete n[e]),this;if(0===arguments.length){var r,o=Object.keys(n);for(a=0;a<o.length;++a)"removeListener"!==(r=o[a])&&this.removeAllListeners(r);return this.removeAllListeners("removeListener"),this._events=Object.create(null),this._eventsCount=0,this}if("function"==typeof(t=n[e]))this.removeListener(e,t);else if(void 0!==t)for(a=t.length-1;a>=0;a--)this.removeListener(e,t[a]);return this},s.prototype.listeners=function(e){return b(this,e,true)},s.prototype.rawListeners=function(e){return b(this,e,false)},s.listenerCount=function(e,t){return "function"==typeof e.listenerCount?e.listenerCount(t):h.call(e,t)},s.prototype.listenerCount=h,s.prototype.eventNames=function(){return this._eventsCount>0?a(this._events):[]};},function(e,t,n){e.exports.Dispatcher=n(140);},function(e,t,n){e.exports=n(142);},function(e,t,n){t.__esModule=true;var a=i(n(50)),r=i(n(65)),o="function"==typeof r.default&&"symbol"==typeof a.default?function(e){return typeof e}:function(e){return e&&"function"==typeof r.default&&e.constructor===r.default&&e!==r.default.prototype?"symbol":typeof e};function i(e){return e&&e.__esModule?e:{default:e}}t.default="function"==typeof r.default&&"symbol"===o(a.default)?function(e){return void 0===e?"undefined":o(e)}:function(e){return e&&"function"==typeof r.default&&e.constructor===r.default&&e!==r.default.prototype?"symbol":void 0===e?"undefined":o(e)};},function(e,t,n){e.exports={default:n(51),__esModule:true};},function(e,t,n){n(20),n(29),e.exports=n(30).f("iterator");},function(e,t,n){var a=n(21),r=n(22);e.exports=function(e){return function(t,n){var o,i,s=String(r(t)),c=a(n),l=s.length;return c<0||c>=l?e?"":void 0:(o=s.charCodeAt(c))<55296||o>56319||c+1===l||(i=s.charCodeAt(c+1))<56320||i>57343?e?s.charAt(c):o:e?s.slice(c,c+2):i-56320+(o-55296<<10)+65536}};},function(e,t,n){var a=n(54);e.exports=function(e,t,n){if(a(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,a){return e.call(t,n,a)};case 3:return function(n,a,r){return e.call(t,n,a,r)}}return function(){return e.apply(t,arguments)}};},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e};},function(e,t,n){var a=n(38),r=n(16),o=n(28),i={};n(6)(i,n(2)("iterator"),(function(){return this})),e.exports=function(e,t,n){e.prototype=a(i,{next:r(1,n)}),o(e,t+" Iterator");};},function(e,t,n){var a=n(7),r=n(10),o=n(13);e.exports=n(4)?Object.defineProperties:function(e,t){r(e);for(var n,i=o(t),s=i.length,c=0;s>c;)a.f(e,n=i[c++],t[n]);return e};},function(e,t,n){var a=n(9),r=n(58),o=n(59);e.exports=function(e){return function(t,n,i){var s,c=a(t),l=r(c.length),u=o(i,l);if(e&&n!=n){for(;l>u;)if((s=c[u++])!=s)return  true}else for(;l>u;u++)if((e||u in c)&&c[u]===n)return e||u||0;return !e&&-1}};},function(e,t,n){var a=n(21),r=Math.min;e.exports=function(e){return e>0?r(a(e),9007199254740991):0};},function(e,t,n){var a=n(21),r=Math.max,o=Math.min;e.exports=function(e,t){return (e=a(e))<0?r(e+t,0):o(e,t)};},function(e,t,n){var a=n(3).document;e.exports=a&&a.documentElement;},function(e,t,n){var a=n(5),r=n(18),o=n(25)("IE_PROTO"),i=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=r(e),a(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?i:null};},function(e,t,n){var a=n(63),r=n(64),o=n(12),i=n(9);e.exports=n(34)(Array,"Array",(function(e,t){this._t=i(e),this._i=0,this._k=t;}),(function(){var e=this._t,t=this._k,n=this._i++;return !e||n>=e.length?(this._t=void 0,r(1)):r(0,"keys"==t?n:"values"==t?e[n]:[n,e[n]])}),"values"),o.Arguments=o.Array,a("keys"),a("values"),a("entries");},function(e,t){e.exports=function(){};},function(e,t){e.exports=function(e,t){return {value:t,done:!!e}};},function(e,t,n){e.exports={default:n(66),__esModule:true};},function(e,t,n){n(67),n(73),n(74),n(75),e.exports=n(1).Symbol;},function(e,t,n){var a=n(3),r=n(5),o=n(4),i=n(15),s=n(37),c=n(68).KEY,l=n(8),u=n(26),f=n(28),p=n(17),d=n(2),b=n(30),h=n(31),v=n(69),m=n(70),y=n(10),g=n(11),E=n(18),j=n(9),x=n(23),_=n(16),k=n(38),O=n(71),C=n(72),S=n(32),w=n(7),A=n(13),M=C.f,P=w.f,F=O.f,D=a.Symbol,I=a.JSON,R=I&&I.stringify,L=d("_hidden"),B=d("toPrimitive"),N={}.propertyIsEnumerable,z=u("symbol-registry"),T=u("symbols"),q=u("op-symbols"),V=Object.prototype,K="function"==typeof D&&!!S.f,W=a.QObject,H=!W||!W.prototype||!W.prototype.findChild,U=o&&l((function(){return 7!=k(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a}))?function(e,t,n){var a=M(V,t);a&&delete V[t],P(e,t,n),a&&e!==V&&P(V,t,a);}:P,G=function(e){var t=T[e]=k(D.prototype);return t._k=e,t},J=K&&"symbol"==typeof D.iterator?function(e){return "symbol"==typeof e}:function(e){return e instanceof D},Y=function(e,t,n){return e===V&&Y(q,t,n),y(e),t=x(t,true),y(n),r(T,t)?(n.enumerable?(r(e,L)&&e[L][t]&&(e[L][t]=false),n=k(n,{enumerable:_(0,false)})):(r(e,L)||P(e,L,_(1,{})),e[L][t]=true),U(e,t,n)):P(e,t,n)},$=function(e,t){y(e);for(var n,a=v(t=j(t)),r=0,o=a.length;o>r;)Y(e,n=a[r++],t[n]);return e},Q=function(e){var t=N.call(this,e=x(e,true));return !(this===V&&r(T,e)&&!r(q,e))&&(!(t||!r(this,e)||!r(T,e)||r(this,L)&&this[L][e])||t)},Z=function(e,t){if(e=j(e),t=x(t,true),e!==V||!r(T,t)||r(q,t)){var n=M(e,t);return !n||!r(T,t)||r(e,L)&&e[L][t]||(n.enumerable=true),n}},X=function(e){for(var t,n=F(j(e)),a=[],o=0;n.length>o;)r(T,t=n[o++])||t==L||t==c||a.push(t);return a},ee=function(e){for(var t,n=e===V,a=F(n?q:j(e)),o=[],i=0;a.length>i;)!r(T,t=a[i++])||n&&!r(V,t)||o.push(T[t]);return o};K||(s((D=function(){if(this instanceof D)throw TypeError("Symbol is not a constructor!");var e=p(arguments.length>0?arguments[0]:void 0),t=function(n){this===V&&t.call(q,n),r(this,L)&&r(this[L],e)&&(this[L][e]=false),U(this,e,_(1,n));};return o&&H&&U(V,e,{configurable:true,set:t}),G(e)}).prototype,"toString",(function(){return this._k})),C.f=Z,w.f=Y,n(41).f=O.f=X,n(19).f=Q,S.f=ee,o&&!n(14)&&s(V,"propertyIsEnumerable",Q,true),b.f=function(e){return G(d(e))}),i(i.G+i.W+i.F*!K,{Symbol:D});for(var te="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),ne=0;te.length>ne;)d(te[ne++]);for(var ae=A(d.store),re=0;ae.length>re;)h(ae[re++]);i(i.S+i.F*!K,"Symbol",{for:function(e){return r(z,e+="")?z[e]:z[e]=D(e)},keyFor:function(e){if(!J(e))throw TypeError(e+" is not a symbol!");for(var t in z)if(z[t]===e)return t},useSetter:function(){H=true;},useSimple:function(){H=false;}}),i(i.S+i.F*!K,"Object",{create:function(e,t){return void 0===t?k(e):$(k(e),t)},defineProperty:Y,defineProperties:$,getOwnPropertyDescriptor:Z,getOwnPropertyNames:X,getOwnPropertySymbols:ee});var oe=l((function(){S.f(1);}));i(i.S+i.F*oe,"Object",{getOwnPropertySymbols:function(e){return S.f(E(e))}}),I&&i(i.S+i.F*(!K||l((function(){var e=D();return "[null]"!=R([e])||"{}"!=R({a:e})||"{}"!=R(Object(e))}))),"JSON",{stringify:function(e){for(var t,n,a=[e],r=1;arguments.length>r;)a.push(arguments[r++]);if(n=t=a[1],(g(t)||void 0!==e)&&!J(e))return m(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!J(t))return t}),a[1]=t,R.apply(I,a)}}),D.prototype[B]||n(6)(D.prototype,B,D.prototype.valueOf),f(D,"Symbol"),f(Math,"Math",true),f(a.JSON,"JSON",true);},function(e,t,n){var a=n(17)("meta"),r=n(11),o=n(5),i=n(7).f,s=0,c=Object.isExtensible||function(){return  true},l=!n(8)((function(){return c(Object.preventExtensions({}))})),u=function(e){i(e,a,{value:{i:"O"+ ++s,w:{}}});},f=e.exports={KEY:a,NEED:false,fastKey:function(e,t){if(!r(e))return "symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,a)){if(!c(e))return "F";if(!t)return "E";u(e);}return e[a].i},getWeak:function(e,t){if(!o(e,a)){if(!c(e))return  true;if(!t)return  false;u(e);}return e[a].w},onFreeze:function(e){return l&&f.NEED&&c(e)&&!o(e,a)&&u(e),e}};},function(e,t,n){var a=n(13),r=n(32),o=n(19);e.exports=function(e){var t=a(e),n=r.f;if(n)for(var i,s=n(e),c=o.f,l=0;s.length>l;)c.call(e,i=s[l++])&&t.push(i);return t};},function(e,t,n){var a=n(24);e.exports=Array.isArray||function(e){return "Array"==a(e)};},function(e,t,n){var a=n(9),r=n(41).f,o={}.toString,i="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[];e.exports.f=function(e){return i&&"[object Window]"==o.call(e)?function(e){try{return r(e)}catch(e){return i.slice()}}(e):r(a(e))};},function(e,t,n){var a=n(19),r=n(16),o=n(9),i=n(23),s=n(5),c=n(35),l=Object.getOwnPropertyDescriptor;t.f=n(4)?l:function(e,t){if(e=o(e),t=i(t,true),c)try{return l(e,t)}catch(e){}if(s(e,t))return r(!a.f.call(e,t),e[t])};},function(e,t){},function(e,t,n){n(31)("asyncIterator");},function(e,t,n){n(31)("observable");},function(e,t,n){t.__esModule=true;var a,r=n(77),o=(a=r)&&a.__esModule?a:{default:a};t.default=o.default||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e};},function(e,t,n){e.exports={default:n(78),__esModule:true};},function(e,t,n){n(79),e.exports=n(1).Object.assign;},function(e,t,n){var a=n(15);a(a.S+a.F,"Object",{assign:n(80)});},function(e,t,n){var a=n(4),r=n(13),o=n(32),i=n(19),s=n(18),c=n(40),l=Object.assign;e.exports=!l||n(8)((function(){var e={},t={},n=Symbol(),a="abcdefghijklmnopqrst";return e[n]=7,a.split("").forEach((function(e){t[e]=e;})),7!=l({},e)[n]||Object.keys(l({},t)).join("")!=a}))?function(e,t){for(var n=s(e),l=arguments.length,u=1,f=o.f,p=i.f;l>u;)for(var d,b=c(arguments[u++]),h=f?r(b).concat(f(b)):r(b),v=h.length,m=0;v>m;)d=h[m++],a&&!p.call(b,d)||(n[d]=b[d]);return n}:l;},function(e,t,n){t.__esModule=true;var a=o(n(82)),r=o(n(85));function o(e){return e&&e.__esModule?e:{default:e}}t.default=function(e,t){if(Array.isArray(e))return e;if((0, a.default)(Object(e)))return function(e,t){var n=[],a=true,o=false,i=void 0;try{for(var s,c=(0,r.default)(e);!(a=(s=c.next()).done)&&(n.push(s.value),!t||n.length!==t);a=!0);}catch(e){o=true,i=e;}finally{try{!a&&c.return&&c.return();}finally{if(o)throw i}}return n}(e,t);throw new TypeError("Invalid attempt to destructure non-iterable instance")};},function(e,t,n){e.exports={default:n(83),__esModule:true};},function(e,t,n){n(29),n(20),e.exports=n(84);},function(e,t,n){var a=n(42),r=n(2)("iterator"),o=n(12);e.exports=n(1).isIterable=function(e){var t=Object(e);return void 0!==t[r]||"@@iterator"in t||o.hasOwnProperty(a(t))};},function(e,t,n){e.exports={default:n(86),__esModule:true};},function(e,t,n){n(29),n(20),e.exports=n(87);},function(e,t,n){var a=n(10),r=n(88);e.exports=n(1).getIterator=function(e){var t=r(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return a(t.call(e))};},function(e,t,n){var a=n(42),r=n(2)("iterator"),o=n(12);e.exports=n(1).getIteratorMethod=function(e){if(null!=e)return e[r]||e["@@iterator"]||o[a(e)]};},function(e,t,n){e.exports={default:n(90),__esModule:true};},function(e,t,n){n(91),e.exports=n(1).Object.keys;},function(e,t,n){var a=n(18),r=n(13);n(92)("keys",(function(){return function(e){return r(a(e))}}));},function(e,t,n){var a=n(15),r=n(1),o=n(8);e.exports=function(e,t){var n=(r.Object||{})[e]||Object[e],i={};i[e]=t(n),a(a.S+a.F*o((function(){n(1);})),"Object",i);};},function(e,t,n){(function(t){var n=[["ary",128],["bind",1],["bindKey",2],["curry",8],["curryRight",16],["flip",512],["partial",32],["partialRight",64],["rearg",256]],a=/^\s+|\s+$/g,r=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,o=/\{\n\/\* \[wrapped with (.+)\] \*/,i=/,? & /,s=/^[-+]0x[0-9a-f]+$/i,c=/^0b[01]+$/i,l=/^\[object .+?Constructor\]$/,u=/^0o[0-7]+$/i,f=/^(?:0|[1-9]\d*)$/,p=parseInt,d="object"==typeof t&&t&&t.Object===Object&&t,b="object"==typeof self&&self&&self.Object===Object&&self,h=d||b||Function("return this")();function v(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function m(e,t){return !!(e?e.length:0)&&function(e,t,n){if(t!=t)return function(e,t,n,a){var r=e.length,o=n+(-1);for(;++o<r;)if(t(e[o],o,e))return o;return  -1}(e,y,n);var a=n-1,r=e.length;for(;++a<r;)if(e[a]===t)return a;return  -1}(e,t,0)>-1}function y(e){return e!=e}function g(e,t){for(var n=e.length,a=0;n--;)e[n]===t&&a++;return a}function E(e,t){for(var n=-1,a=e.length,r=0,o=[];++n<a;){var i=e[n];i!==t&&"__lodash_placeholder__"!==i||(e[n]="__lodash_placeholder__",o[r++]=n);}return o}var j,x,_,k=Function.prototype,O=Object.prototype,C=h["__core-js_shared__"],S=(j=/[^.]+$/.exec(C&&C.keys&&C.keys.IE_PROTO||""))?"Symbol(src)_1."+j:"",w=k.toString,A=O.hasOwnProperty,M=O.toString,P=RegExp("^"+w.call(A).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$"),F=Object.create,D=Math.max,I=Math.min,R=(x=H(Object,"defineProperty"),(_=H.name)&&_.length>2?x:void 0);function L(e){return X(e)?F(e):{}}function B(e){return !(!X(e)||function(e){return !!S&&S in e}(e))&&(function(e){var t=X(e)?M.call(e):"";return "[object Function]"==t||"[object GeneratorFunction]"==t}(e)||function(e){var t=false;if(null!=e&&"function"!=typeof e.toString)try{t=!!(e+"");}catch(e){}return t}(e)?P:l).test(function(e){if(null!=e){try{return w.call(e)}catch(e){}try{return e+""}catch(e){}}return ""}(e))}function N(e,t,n,a){for(var r=-1,o=e.length,i=n.length,s=-1,c=t.length,l=D(o-i,0),u=Array(c+l),f=!a;++s<c;)u[s]=t[s];for(;++r<i;)(f||r<o)&&(u[n[r]]=e[r]);for(;l--;)u[s++]=e[r++];return u}function z(e,t,n,a){for(var r=-1,o=e.length,i=-1,s=n.length,c=-1,l=t.length,u=D(o-s,0),f=Array(u+l),p=!a;++r<u;)f[r]=e[r];for(var d=r;++c<l;)f[d+c]=t[c];for(;++i<s;)(p||r<o)&&(f[d+n[i]]=e[r++]);return f}function T(e){return function(){var t=arguments;switch(t.length){case 0:return new e;case 1:return new e(t[0]);case 2:return new e(t[0],t[1]);case 3:return new e(t[0],t[1],t[2]);case 4:return new e(t[0],t[1],t[2],t[3]);case 5:return new e(t[0],t[1],t[2],t[3],t[4]);case 6:return new e(t[0],t[1],t[2],t[3],t[4],t[5]);case 7:return new e(t[0],t[1],t[2],t[3],t[4],t[5],t[6])}var n=L(e.prototype),a=e.apply(n,t);return X(a)?a:n}}function q(e,t,n,a,r,o,i,s,c,l){var u=128&t,f=1&t,p=2&t,d=24&t,b=512&t,v=p?void 0:T(e);return function m(){for(var y=arguments.length,j=Array(y),x=y;x--;)j[x]=arguments[x];if(d)var _=W(m),k=g(j,_);if(a&&(j=N(j,a,r,d)),o&&(j=z(j,o,i,d)),y-=k,d&&y<l){var O=E(j,_);return V(e,t,q,m.placeholder,n,j,O,s,c,l-y)}var C=f?n:this,S=p?C[e]:e;return y=j.length,s?j=Y(j,s):b&&y>1&&j.reverse(),u&&c<y&&(j.length=c),this&&this!==h&&this instanceof m&&(S=v||T(S)),S.apply(C,j)}}function V(e,t,n,a,r,o,i,s,c,l){var u=8&t;t|=u?32:64,4&(t&=~(u?64:32))||(t&=-4);var f=n(e,t,r,u?o:void 0,u?i:void 0,u?void 0:o,u?void 0:i,s,c,l);return f.placeholder=a,$(f,e,t)}function K(e,t,n,a,r,o,i,s){var c=2&t;if(!c&&"function"!=typeof e)throw new TypeError("Expected a function");var l=a?a.length:0;if(l||(t&=-97,a=r=void 0),i=void 0===i?i:D(te(i),0),s=void 0===s?s:te(s),l-=r?r.length:0,64&t){var u=a,f=r;a=r=void 0;}var p=[e,t,n,a,r,u,f,o,i,s];if(e=p[0],t=p[1],n=p[2],a=p[3],r=p[4],!(s=p[9]=null==p[9]?c?0:e.length:D(p[9]-l,0))&&24&t&&(t&=-25),t&&1!=t)d=8==t||16==t?function(e,t,n){var a=T(e);return function r(){for(var o=arguments.length,i=Array(o),s=o,c=W(r);s--;)i[s]=arguments[s];var l=o<3&&i[0]!==c&&i[o-1]!==c?[]:E(i,c);if((o-=l.length)<n)return V(e,t,q,r.placeholder,void 0,i,l,void 0,void 0,n-o);var u=this&&this!==h&&this instanceof r?a:e;return v(u,this,i)}}(e,t,s):32!=t&&33!=t||r.length?q.apply(void 0,p):function(e,t,n,a){var r=1&t,o=T(e);return function t(){for(var i=-1,s=arguments.length,c=-1,l=a.length,u=Array(l+s),f=this&&this!==h&&this instanceof t?o:e;++c<l;)u[c]=a[c];for(;s--;)u[c++]=arguments[++i];return v(f,r?n:this,u)}}(e,t,n,a);else var d=function(e,t,n){var a=1&t,r=T(e);return function t(){var o=this&&this!==h&&this instanceof t?r:e;return o.apply(a?n:this,arguments)}}(e,t,n);return $(d,e,t)}function W(e){return e.placeholder}function H(e,t){var n=function(e,t){return null==e?void 0:e[t]}(e,t);return B(n)?n:void 0}function U(e){var t=e.match(o);return t?t[1].split(i):[]}function G(e,t){var n=t.length,a=n-1;return t[a]=(n>1?"& ":"")+t[a],t=t.join(n>2?", ":" "),e.replace(r,"{\n/* [wrapped with "+t+"] */\n")}function J(e,t){return !!(t=null==t?9007199254740991:t)&&("number"==typeof e||f.test(e))&&e>-1&&e%1==0&&e<t}function Y(e,t){for(var n=e.length,a=I(t.length,n),r=function(e,t){var n=-1,a=e.length;for(t||(t=Array(a));++n<a;)t[n]=e[n];return t}(e);a--;){var o=t[a];e[a]=J(o,n)?r[o]:void 0;}return e}var $=R?function(e,t,n){var a,r=t+"";return R(e,"toString",{configurable:true,enumerable:false,value:(a=G(r,Q(U(r),n)),function(){return a})})}:function(e){return e};function Q(e,t){return function(e,t){for(var n=-1,a=e?e.length:0;++n<a&&false!==t(e[n],n,e););}(n,(function(n){var a="_."+n[0];t&n[1]&&!m(e,a)&&e.push(a);})),e.sort()}function Z(e,t,n){var a=K(e,8,void 0,void 0,void 0,void 0,void 0,t=n?void 0:t);return a.placeholder=Z.placeholder,a}function X(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function ee(e){return e?(e=function(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==M.call(e)}(e))return NaN;if(X(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=X(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(a,"");var n=c.test(e);return n||u.test(e)?p(e.slice(2),n?2:8):s.test(e)?NaN:+e}(e))===1/0||e===-1/0?17976931348623157e292*(e<0?-1:1):e==e?e:0:0===e?e:0}function te(e){var t=ee(e),n=t%1;return t==t?n?t-n:t:0}Z.placeholder={},e.exports=Z;}).call(this,n(43));},function(e,t,n){function a(e){return e&&e.__esModule?e.default:e}t.__esModule=true;var r=n(95);t.threezerotwofour=a(r);var o=n(96);t.apathy=a(o);var i=n(97);t.ashes=a(i);var s=n(98);t.atelierDune=a(s);var c=n(99);t.atelierForest=a(c);var l=n(100);t.atelierHeath=a(l);var u=n(101);t.atelierLakeside=a(u);var f=n(102);t.atelierSeaside=a(f);var p=n(103);t.bespin=a(p);var d=n(104);t.brewer=a(d);var b=n(105);t.bright=a(b);var h=n(106);t.chalk=a(h);var v=n(107);t.codeschool=a(v);var m=n(108);t.colors=a(m);var y=n(109);t.default=a(y);var g=n(110);t.eighties=a(g);var E=n(111);t.embers=a(E);var j=n(112);t.flat=a(j);var x=n(113);t.google=a(x);var _=n(114);t.grayscale=a(_);var k=n(115);t.greenscreen=a(k);var O=n(116);t.harmonic=a(O);var C=n(117);t.hopscotch=a(C);var S=n(118);t.isotope=a(S);var w=n(119);t.marrakesh=a(w);var A=n(120);t.mocha=a(A);var M=n(121);t.monokai=a(M);var P=n(122);t.ocean=a(P);var F=n(123);t.paraiso=a(F);var D=n(124);t.pop=a(D);var I=n(125);t.railscasts=a(I);var R=n(126);t.shapeshifter=a(R);var L=n(127);t.solarized=a(L);var B=n(128);t.summerfruit=a(B);var N=n(129);t.tomorrow=a(N);var z=n(130);t.tube=a(z);var T=n(131);t.twilight=a(T);},function(e,t,n){t.__esModule=true,t.default={scheme:"threezerotwofour",author:"jan t. sott (http://github.com/idleberg)",base00:"#090300",base01:"#3a3432",base02:"#4a4543",base03:"#5c5855",base04:"#807d7c",base05:"#a5a2a2",base06:"#d6d5d4",base07:"#f7f7f7",base08:"#db2d20",base09:"#e8bbd0",base0A:"#fded02",base0B:"#01a252",base0C:"#b5e4f4",base0D:"#01a0e4",base0E:"#a16a94",base0F:"#cdab53"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"apathy",author:"jannik siebert (https://github.com/janniks)",base00:"#031A16",base01:"#0B342D",base02:"#184E45",base03:"#2B685E",base04:"#5F9C92",base05:"#81B5AC",base06:"#A7CEC8",base07:"#D2E7E4",base08:"#3E9688",base09:"#3E7996",base0A:"#3E4C96",base0B:"#883E96",base0C:"#963E4C",base0D:"#96883E",base0E:"#4C963E",base0F:"#3E965B"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"ashes",author:"jannik siebert (https://github.com/janniks)",base00:"#1C2023",base01:"#393F45",base02:"#565E65",base03:"#747C84",base04:"#ADB3BA",base05:"#C7CCD1",base06:"#DFE2E5",base07:"#F3F4F5",base08:"#C7AE95",base09:"#C7C795",base0A:"#AEC795",base0B:"#95C7AE",base0C:"#95AEC7",base0D:"#AE95C7",base0E:"#C795AE",base0F:"#C79595"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"atelier dune",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)",base00:"#20201d",base01:"#292824",base02:"#6e6b5e",base03:"#7d7a68",base04:"#999580",base05:"#a6a28c",base06:"#e8e4cf",base07:"#fefbec",base08:"#d73737",base09:"#b65611",base0A:"#cfb017",base0B:"#60ac39",base0C:"#1fad83",base0D:"#6684e1",base0E:"#b854d4",base0F:"#d43552"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"atelier forest",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)",base00:"#1b1918",base01:"#2c2421",base02:"#68615e",base03:"#766e6b",base04:"#9c9491",base05:"#a8a19f",base06:"#e6e2e0",base07:"#f1efee",base08:"#f22c40",base09:"#df5320",base0A:"#d5911a",base0B:"#5ab738",base0C:"#00ad9c",base0D:"#407ee7",base0E:"#6666ea",base0F:"#c33ff3"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"atelier heath",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)",base00:"#1b181b",base01:"#292329",base02:"#695d69",base03:"#776977",base04:"#9e8f9e",base05:"#ab9bab",base06:"#d8cad8",base07:"#f7f3f7",base08:"#ca402b",base09:"#a65926",base0A:"#bb8a35",base0B:"#379a37",base0C:"#159393",base0D:"#516aec",base0E:"#7b59c0",base0F:"#cc33cc"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"atelier lakeside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)",base00:"#161b1d",base01:"#1f292e",base02:"#516d7b",base03:"#5a7b8c",base04:"#7195a8",base05:"#7ea2b4",base06:"#c1e4f6",base07:"#ebf8ff",base08:"#d22d72",base09:"#935c25",base0A:"#8a8a0f",base0B:"#568c3b",base0C:"#2d8f6f",base0D:"#257fad",base0E:"#5d5db1",base0F:"#b72dd2"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"atelier seaside",author:"bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)",base00:"#131513",base01:"#242924",base02:"#5e6e5e",base03:"#687d68",base04:"#809980",base05:"#8ca68c",base06:"#cfe8cf",base07:"#f0fff0",base08:"#e6193c",base09:"#87711d",base0A:"#c3c322",base0B:"#29a329",base0C:"#1999b3",base0D:"#3d62f5",base0E:"#ad2bee",base0F:"#e619c3"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"bespin",author:"jan t. sott",base00:"#28211c",base01:"#36312e",base02:"#5e5d5c",base03:"#666666",base04:"#797977",base05:"#8a8986",base06:"#9d9b97",base07:"#baae9e",base08:"#cf6a4c",base09:"#cf7d34",base0A:"#f9ee98",base0B:"#54be0d",base0C:"#afc4db",base0D:"#5ea6ea",base0E:"#9b859d",base0F:"#937121"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"brewer",author:"timothée poisot (http://github.com/tpoisot)",base00:"#0c0d0e",base01:"#2e2f30",base02:"#515253",base03:"#737475",base04:"#959697",base05:"#b7b8b9",base06:"#dadbdc",base07:"#fcfdfe",base08:"#e31a1c",base09:"#e6550d",base0A:"#dca060",base0B:"#31a354",base0C:"#80b1d3",base0D:"#3182bd",base0E:"#756bb1",base0F:"#b15928"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"bright",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#303030",base02:"#505050",base03:"#b0b0b0",base04:"#d0d0d0",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ffffff",base08:"#fb0120",base09:"#fc6d24",base0A:"#fda331",base0B:"#a1c659",base0C:"#76c7b7",base0D:"#6fb3d2",base0E:"#d381c3",base0F:"#be643c"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"chalk",author:"chris kempson (http://chriskempson.com)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#f5f5f5",base08:"#fb9fb1",base09:"#eda987",base0A:"#ddb26f",base0B:"#acc267",base0C:"#12cfc0",base0D:"#6fc2ef",base0E:"#e1a3ee",base0F:"#deaf8f"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"codeschool",author:"brettof86",base00:"#232c31",base01:"#1c3657",base02:"#2a343a",base03:"#3f4944",base04:"#84898c",base05:"#9ea7a6",base06:"#a7cfa3",base07:"#b5d8f6",base08:"#2a5491",base09:"#43820d",base0A:"#a03b1e",base0B:"#237986",base0C:"#b02f30",base0D:"#484d79",base0E:"#c59820",base0F:"#c98344"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"colors",author:"mrmrs (http://clrs.cc)",base00:"#111111",base01:"#333333",base02:"#555555",base03:"#777777",base04:"#999999",base05:"#bbbbbb",base06:"#dddddd",base07:"#ffffff",base08:"#ff4136",base09:"#ff851b",base0A:"#ffdc00",base0B:"#2ecc40",base0C:"#7fdbff",base0D:"#0074d9",base0E:"#b10dc9",base0F:"#85144b"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"default",author:"chris kempson (http://chriskempson.com)",base00:"#181818",base01:"#282828",base02:"#383838",base03:"#585858",base04:"#b8b8b8",base05:"#d8d8d8",base06:"#e8e8e8",base07:"#f8f8f8",base08:"#ab4642",base09:"#dc9656",base0A:"#f7ca88",base0B:"#a1b56c",base0C:"#86c1b9",base0D:"#7cafc2",base0E:"#ba8baf",base0F:"#a16946"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"eighties",author:"chris kempson (http://chriskempson.com)",base00:"#2d2d2d",base01:"#393939",base02:"#515151",base03:"#747369",base04:"#a09f93",base05:"#d3d0c8",base06:"#e8e6df",base07:"#f2f0ec",base08:"#f2777a",base09:"#f99157",base0A:"#ffcc66",base0B:"#99cc99",base0C:"#66cccc",base0D:"#6699cc",base0E:"#cc99cc",base0F:"#d27b53"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"embers",author:"jannik siebert (https://github.com/janniks)",base00:"#16130F",base01:"#2C2620",base02:"#433B32",base03:"#5A5047",base04:"#8A8075",base05:"#A39A90",base06:"#BEB6AE",base07:"#DBD6D1",base08:"#826D57",base09:"#828257",base0A:"#6D8257",base0B:"#57826D",base0C:"#576D82",base0D:"#6D5782",base0E:"#82576D",base0F:"#825757"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"flat",author:"chris kempson (http://chriskempson.com)",base00:"#2C3E50",base01:"#34495E",base02:"#7F8C8D",base03:"#95A5A6",base04:"#BDC3C7",base05:"#e0e0e0",base06:"#f5f5f5",base07:"#ECF0F1",base08:"#E74C3C",base09:"#E67E22",base0A:"#F1C40F",base0B:"#2ECC71",base0C:"#1ABC9C",base0D:"#3498DB",base0E:"#9B59B6",base0F:"#be643c"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"google",author:"seth wright (http://sethawright.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#CC342B",base09:"#F96A38",base0A:"#FBA922",base0B:"#198844",base0C:"#3971ED",base0D:"#3971ED",base0E:"#A36AC7",base0F:"#3971ED"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"grayscale",author:"alexandre gavioli (https://github.com/alexx2/)",base00:"#101010",base01:"#252525",base02:"#464646",base03:"#525252",base04:"#ababab",base05:"#b9b9b9",base06:"#e3e3e3",base07:"#f7f7f7",base08:"#7c7c7c",base09:"#999999",base0A:"#a0a0a0",base0B:"#8e8e8e",base0C:"#868686",base0D:"#686868",base0E:"#747474",base0F:"#5e5e5e"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"green screen",author:"chris kempson (http://chriskempson.com)",base00:"#001100",base01:"#003300",base02:"#005500",base03:"#007700",base04:"#009900",base05:"#00bb00",base06:"#00dd00",base07:"#00ff00",base08:"#007700",base09:"#009900",base0A:"#007700",base0B:"#00bb00",base0C:"#005500",base0D:"#009900",base0E:"#00bb00",base0F:"#005500"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"harmonic16",author:"jannik siebert (https://github.com/janniks)",base00:"#0b1c2c",base01:"#223b54",base02:"#405c79",base03:"#627e99",base04:"#aabcce",base05:"#cbd6e2",base06:"#e5ebf1",base07:"#f7f9fb",base08:"#bf8b56",base09:"#bfbf56",base0A:"#8bbf56",base0B:"#56bf8b",base0C:"#568bbf",base0D:"#8b56bf",base0E:"#bf568b",base0F:"#bf5656"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"hopscotch",author:"jan t. sott",base00:"#322931",base01:"#433b42",base02:"#5c545b",base03:"#797379",base04:"#989498",base05:"#b9b5b8",base06:"#d5d3d5",base07:"#ffffff",base08:"#dd464c",base09:"#fd8b19",base0A:"#fdcc59",base0B:"#8fc13e",base0C:"#149b93",base0D:"#1290bf",base0E:"#c85e7c",base0F:"#b33508"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"isotope",author:"jan t. sott",base00:"#000000",base01:"#404040",base02:"#606060",base03:"#808080",base04:"#c0c0c0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#ff0000",base09:"#ff9900",base0A:"#ff0099",base0B:"#33ff00",base0C:"#00ffff",base0D:"#0066ff",base0E:"#cc00ff",base0F:"#3300ff"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"marrakesh",author:"alexandre gavioli (http://github.com/alexx2/)",base00:"#201602",base01:"#302e00",base02:"#5f5b17",base03:"#6c6823",base04:"#86813b",base05:"#948e48",base06:"#ccc37a",base07:"#faf0a5",base08:"#c35359",base09:"#b36144",base0A:"#a88339",base0B:"#18974e",base0C:"#75a738",base0D:"#477ca1",base0E:"#8868b3",base0F:"#b3588e"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"mocha",author:"chris kempson (http://chriskempson.com)",base00:"#3B3228",base01:"#534636",base02:"#645240",base03:"#7e705a",base04:"#b8afad",base05:"#d0c8c6",base06:"#e9e1dd",base07:"#f5eeeb",base08:"#cb6077",base09:"#d28b71",base0A:"#f4bc87",base0B:"#beb55b",base0C:"#7bbda4",base0D:"#8ab3b5",base0E:"#a89bb9",base0F:"#bb9584"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"monokai",author:"wimer hazenberg (http://www.monokai.nl)",base00:"#272822",base01:"#383830",base02:"#49483e",base03:"#75715e",base04:"#a59f85",base05:"#f8f8f2",base06:"#f5f4f1",base07:"#f9f8f5",base08:"#f92672",base09:"#fd971f",base0A:"#f4bf75",base0B:"#a6e22e",base0C:"#a1efe4",base0D:"#66d9ef",base0E:"#ae81ff",base0F:"#cc6633"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"ocean",author:"chris kempson (http://chriskempson.com)",base00:"#2b303b",base01:"#343d46",base02:"#4f5b66",base03:"#65737e",base04:"#a7adba",base05:"#c0c5ce",base06:"#dfe1e8",base07:"#eff1f5",base08:"#bf616a",base09:"#d08770",base0A:"#ebcb8b",base0B:"#a3be8c",base0C:"#96b5b4",base0D:"#8fa1b3",base0E:"#b48ead",base0F:"#ab7967"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"paraiso",author:"jan t. sott",base00:"#2f1e2e",base01:"#41323f",base02:"#4f424c",base03:"#776e71",base04:"#8d8687",base05:"#a39e9b",base06:"#b9b6b0",base07:"#e7e9db",base08:"#ef6155",base09:"#f99b15",base0A:"#fec418",base0B:"#48b685",base0C:"#5bc4bf",base0D:"#06b6ef",base0E:"#815ba4",base0F:"#e96ba8"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"pop",author:"chris kempson (http://chriskempson.com)",base00:"#000000",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#b0b0b0",base05:"#d0d0d0",base06:"#e0e0e0",base07:"#ffffff",base08:"#eb008a",base09:"#f29333",base0A:"#f8ca12",base0B:"#37b349",base0C:"#00aabb",base0D:"#0e5a94",base0E:"#b31e8d",base0F:"#7a2d00"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"railscasts",author:"ryan bates (http://railscasts.com)",base00:"#2b2b2b",base01:"#272935",base02:"#3a4055",base03:"#5a647e",base04:"#d4cfc9",base05:"#e6e1dc",base06:"#f4f1ed",base07:"#f9f7f3",base08:"#da4939",base09:"#cc7833",base0A:"#ffc66d",base0B:"#a5c261",base0C:"#519f50",base0D:"#6d9cbe",base0E:"#b6b3eb",base0F:"#bc9458"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"shapeshifter",author:"tyler benziger (http://tybenz.com)",base00:"#000000",base01:"#040404",base02:"#102015",base03:"#343434",base04:"#555555",base05:"#ababab",base06:"#e0e0e0",base07:"#f9f9f9",base08:"#e92f2f",base09:"#e09448",base0A:"#dddd13",base0B:"#0ed839",base0C:"#23edda",base0D:"#3b48e3",base0E:"#f996e2",base0F:"#69542d"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"solarized",author:"ethan schoonover (http://ethanschoonover.com/solarized)",base00:"#002b36",base01:"#073642",base02:"#586e75",base03:"#657b83",base04:"#839496",base05:"#93a1a1",base06:"#eee8d5",base07:"#fdf6e3",base08:"#dc322f",base09:"#cb4b16",base0A:"#b58900",base0B:"#859900",base0C:"#2aa198",base0D:"#268bd2",base0E:"#6c71c4",base0F:"#d33682"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"summerfruit",author:"christopher corley (http://cscorley.github.io/)",base00:"#151515",base01:"#202020",base02:"#303030",base03:"#505050",base04:"#B0B0B0",base05:"#D0D0D0",base06:"#E0E0E0",base07:"#FFFFFF",base08:"#FF0086",base09:"#FD8900",base0A:"#ABA800",base0B:"#00C918",base0C:"#1faaaa",base0D:"#3777E6",base0E:"#AD00A1",base0F:"#cc6633"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"tomorrow",author:"chris kempson (http://chriskempson.com)",base00:"#1d1f21",base01:"#282a2e",base02:"#373b41",base03:"#969896",base04:"#b4b7b4",base05:"#c5c8c6",base06:"#e0e0e0",base07:"#ffffff",base08:"#cc6666",base09:"#de935f",base0A:"#f0c674",base0B:"#b5bd68",base0C:"#8abeb7",base0D:"#81a2be",base0E:"#b294bb",base0F:"#a3685a"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"london tube",author:"jan t. sott",base00:"#231f20",base01:"#1c3f95",base02:"#5a5758",base03:"#737171",base04:"#959ca1",base05:"#d9d8d8",base06:"#e7e7e8",base07:"#ffffff",base08:"#ee2e24",base09:"#f386a1",base0A:"#ffd204",base0B:"#00853e",base0C:"#85cebc",base0D:"#009ddc",base0E:"#98005d",base0F:"#b06110"},e.exports=t.default;},function(e,t,n){t.__esModule=true,t.default={scheme:"twilight",author:"david hart (http://hart-dev.com)",base00:"#1e1e1e",base01:"#323537",base02:"#464b50",base03:"#5f5a60",base04:"#838184",base05:"#a7a7a7",base06:"#c3c3c3",base07:"#ffffff",base08:"#cf6a4c",base09:"#cda869",base0A:"#f9ee98",base0B:"#8f9d6a",base0C:"#afc4db",base0D:"#7587a6",base0E:"#9b859d",base0F:"#9b703f"},e.exports=t.default;},function(e,t,n){var a=n(33);function r(e){var t=Math.round(a(e,0,255)).toString(16);return 1==t.length?"0"+t:t}e.exports=function(e){var t=4===e.length?r(255*e[3]):"";return "#"+r(e[0])+r(e[1])+r(e[2])+t};},function(e,t,n){var a=n(134),r=n(135),o=n(136),i=n(137);var s={"#":r,hsl:function(e){var t=a(e),n=i(t);return 4===t.length&&n.push(t[3]),n},rgb:o};function c(e){for(var t in s)if(0===e.indexOf(t))return s[t](e)}c.rgb=o,c.hsl=a,c.hex=r,e.exports=c;},function(e,t,n){var a=n(44),r=n(33);function o(e,t){switch(e=parseFloat(e),t){case 0:return r(e,0,360);case 1:case 2:return r(e,0,100);case 3:return r(e,0,1)}}e.exports=function(e){return a(e).map(o)};},function(e,t){e.exports=function(e){4!==e.length&&5!==e.length||(e=function(e){for(var t="#",n=1;n<e.length;n++){var a=e.charAt(n);t+=a+a;}return t}(e));var t=[parseInt(e.substring(1,3),16),parseInt(e.substring(3,5),16),parseInt(e.substring(5,7),16)];if(9===e.length){var n=parseFloat((parseInt(e.substring(7,9),16)/255).toFixed(2));t.push(n);}return t};},function(e,t,n){var a=n(44),r=n(33);function o(e,t){return t<3?-1!=e.indexOf("%")?Math.round(255*r(parseInt(e,10),0,100)/100):r(parseInt(e,10),0,255):r(parseFloat(e),0,1)}e.exports=function(e){return a(e).map(o)};},function(e,t){e.exports=function(e){var t,n,a,r,o,i=e[0]/360,s=e[1]/100,c=e[2]/100;if(0==s)return [o=255*c,o,o];t=2*c-(n=c<.5?c*(1+s):c+s-c*s),r=[0,0,0];for(var l=0;l<3;l++)(a=i+1/3*-(l-1))<0&&a++,a>1&&a--,o=6*a<1?t+6*(n-t)*a:2*a<1?n:3*a<2?t+(n-t)*(2/3-a)*6:t,r[l]=255*o;return r};},function(e,t,n){(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t,a="object"==typeof self&&self&&self.Object===Object&&self,r=n||a||Function("return this")();function o(e,t,n){switch(n.length){case 0:return e.call(t);case 1:return e.call(t,n[0]);case 2:return e.call(t,n[0],n[1]);case 3:return e.call(t,n[0],n[1],n[2])}return e.apply(t,n)}function i(e,t){for(var n=-1,a=t.length,r=e.length;++n<a;)e[r+n]=t[n];return e}var s=Object.prototype,c=s.hasOwnProperty,l=s.toString,u=r.Symbol,f=s.propertyIsEnumerable,p=u?u.isConcatSpreadable:void 0,d=Math.max;function b(e){return h(e)||function(e){return function(e){return function(e){return !!e&&"object"==typeof e}(e)&&function(e){return null!=e&&function(e){return "number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991}(e.length)&&!function(e){var t=function(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}(e)?l.call(e):"";return "[object Function]"==t||"[object GeneratorFunction]"==t}(e)}(e)}(e)&&c.call(e,"callee")&&(!f.call(e,"callee")||"[object Arguments]"==l.call(e))}(e)||!!(p&&e&&e[p])}var h=Array.isArray;var v,m,y,g=(m=function(e){var t=(e=function e(t,n,a,r,o){var s=-1,c=t.length;for(a||(a=b),o||(o=[]);++s<c;){var l=t[s];a(l)?i(o,l):(o[o.length]=l);}return o}(e)).length,n=t;for(v;n--;)if("function"!=typeof e[n])throw new TypeError("Expected a function");return function(){for(var n=0,a=t?e[n].apply(this,arguments):arguments[0];++n<t;)a=e[n].call(this,a);return a}},y=d(void 0===y?m.length-1:y,0),function(){for(var e=arguments,t=-1,n=d(e.length-y,0),a=Array(n);++t<n;)a[t]=e[y+t];t=-1;for(var r=Array(y+1);++t<y;)r[t]=e[t];return r[y]=a,o(m,this,r)});e.exports=g;}).call(this,n(43));},function(e,t,n){Object.defineProperty(t,"__esModule",{value:true}),t.yuv2rgb=function(e){var t,n,a,r=e[0],o=e[1],i=e[2];return t=1*r+0*o+1.13983*i,n=1*r+-0.39465*o+-0.5806*i,a=1*r+2.02311*o+0*i,t=Math.min(Math.max(0,t),1),n=Math.min(Math.max(0,n),1),a=Math.min(Math.max(0,a),1),[255*t,255*n,255*a]},t.rgb2yuv=function(e){var t=e[0]/255,n=e[1]/255,a=e[2]/255;return [.299*t+.587*n+.114*a,-0.14713*t+-0.28886*n+.436*a,.615*t+-0.51499*n+-0.10001*a]};},function(e,t,n){function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:true,configurable:true,writable:true}):e[t]=n,e}var r=n(141),o=function(){function e(){a(this,"_callbacks",void 0),a(this,"_isDispatching",void 0),a(this,"_isHandled",void 0),a(this,"_isPending",void 0),a(this,"_lastID",void 0),a(this,"_pendingPayload",void 0),this._callbacks={},this._isDispatching=false,this._isHandled={},this._isPending={},this._lastID=1;}var t=e.prototype;return t.register=function(e){var t="ID_"+this._lastID++;return this._callbacks[t]=e,t},t.unregister=function(e){this._callbacks[e]||r(false),delete this._callbacks[e];},t.waitFor=function(e){this._isDispatching||r(false);for(var t=0;t<e.length;t++){var n=e[t];this._isPending[n]?this._isHandled[n]||r(false):(this._callbacks[n]||r(false),this._invokeCallback(n));}},t.dispatch=function(e){this._isDispatching&&r(false),this._startDispatching(e);try{for(var t in this._callbacks)this._isPending[t]||this._invokeCallback(t);}finally{this._stopDispatching();}},t.isDispatching=function(){return this._isDispatching},t._invokeCallback=function(e){this._isPending[e]=true,this._callbacks[e](this._pendingPayload),this._isHandled[e]=true;},t._startDispatching=function(e){for(var t in this._callbacks)this._isPending[t]=false,this._isHandled[t]=false;this._pendingPayload=e,this._isDispatching=true;},t._stopDispatching=function(){delete this._pendingPayload,this._isDispatching=false;},e}();e.exports=o;},function(e,t,n){e.exports=function(e,t){for(var n=arguments.length,r=new Array(n>2?n-2:0),o=2;o<n;o++)r[o-2]=arguments[o];if(!e){var i;if(void 0===t)i=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var s=0;(i=new Error(t.replace(/%s/g,(function(){return String(r[s++])})))).name="Invariant Violation";}throw i.framesToPop=1,i}};},function(e,t,n){function a(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:true,configurable:true,writable:true}):e[t]=n,e}function r(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var a=Object.getOwnPropertySymbols(e);t&&(a=a.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),n.push.apply(n,a);}return n}function o(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?r(Object(n),true).forEach((function(t){a(e,t,n[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):r(Object(n)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t));}));}return e}function i(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function s(e,t){for(var n=0;n<t.length;n++){var a=t[n];a.enumerable=a.enumerable||false,a.configurable=true,"value"in a&&(a.writable=true),Object.defineProperty(e,a.key,a);}}function c(e,t,n){return t&&s(e.prototype,t),n&&s(e,n),e}function l(e,t){return (l=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function u(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}}),t&&l(e,t);}function f(e){return (f=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function p(e){return (p="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function d(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function b(e,t){return !t||"object"!==p(t)&&"function"!=typeof t?d(e):t}function h(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return  false;if(Reflect.construct.sham)return  false;if("function"==typeof Proxy)return  true;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return  false}}();return function(){var n,a=f(e);if(t){var r=f(this).constructor;n=Reflect.construct(a,arguments,r);}else n=a.apply(this,arguments);return b(this,n)}}n.r(t);var v=n(0),m=n.n(v);function y(){var e=this.constructor.getDerivedStateFromProps(this.props,this.state);null!=e&&this.setState(e);}function g(e){this.setState(function(t){var n=this.constructor.getDerivedStateFromProps(e,t);return null!=n?n:null}.bind(this));}function E(e,t){try{var n=this.props,a=this.state;this.props=e,this.state=t,this.__reactInternalSnapshotFlag=!0,this.__reactInternalSnapshot=this.getSnapshotBeforeUpdate(n,a);}finally{this.props=n,this.state=a;}}function j(e){var t=e.prototype;if(!t||!t.isReactComponent)throw new Error("Can only polyfill class components");if("function"!=typeof e.getDerivedStateFromProps&&"function"!=typeof t.getSnapshotBeforeUpdate)return e;var n=null,a=null,r=null;if("function"==typeof t.componentWillMount?n="componentWillMount":"function"==typeof t.UNSAFE_componentWillMount&&(n="UNSAFE_componentWillMount"),"function"==typeof t.componentWillReceiveProps?a="componentWillReceiveProps":"function"==typeof t.UNSAFE_componentWillReceiveProps&&(a="UNSAFE_componentWillReceiveProps"),"function"==typeof t.componentWillUpdate?r="componentWillUpdate":"function"==typeof t.UNSAFE_componentWillUpdate&&(r="UNSAFE_componentWillUpdate"),null!==n||null!==a||null!==r){var o=e.displayName||e.name,i="function"==typeof e.getDerivedStateFromProps?"getDerivedStateFromProps()":"getSnapshotBeforeUpdate()";throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n"+o+" uses "+i+" but also contains the following legacy lifecycles:"+(null!==n?"\n  "+n:"")+(null!==a?"\n  "+a:"")+(null!==r?"\n  "+r:"")+"\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://fb.me/react-async-component-lifecycle-hooks")}if("function"==typeof e.getDerivedStateFromProps&&(t.componentWillMount=y,t.componentWillReceiveProps=g),"function"==typeof t.getSnapshotBeforeUpdate){if("function"!=typeof t.componentDidUpdate)throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");t.componentWillUpdate=E;var s=t.componentDidUpdate;t.componentDidUpdate=function(e,t,n){var a=this.__reactInternalSnapshotFlag?this.__reactInternalSnapshot:n;s.call(this,e,t,a);};}return e}function x(e,t){if(null==e)return {};var n,a,r=function(e,t){if(null==e)return {};var n,a,r={},o=Object.keys(e);for(a=0;a<o.length;a++)n=o[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}(e,t);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);for(a=0;a<o.length;a++)n=o[a],t.indexOf(n)>=0||Object.prototype.propertyIsEnumerable.call(e,n)&&(r[n]=e[n]);}return r}function _(e){var t=function(e){return {}.toString.call(e).match(/\s([a-zA-Z]+)/)[1].toLowerCase()}(e);return "number"===t&&(t=isNaN(e)?"nan":(0|e)!=e?"float":"integer"),t}y.__suppressDeprecationWarning=true,g.__suppressDeprecationWarning=true,E.__suppressDeprecationWarning=true;var k={scheme:"rjv-default",author:"mac gainor",base00:"rgba(0, 0, 0, 0)",base01:"rgb(245, 245, 245)",base02:"rgb(235, 235, 235)",base03:"#93a1a1",base04:"rgba(0, 0, 0, 0.3)",base05:"#586e75",base06:"#073642",base07:"#002b36",base08:"#d33682",base09:"#cb4b16",base0A:"#dc322f",base0B:"#859900",base0C:"#6c71c4",base0D:"#586e75",base0E:"#2aa198",base0F:"#268bd2"},O={scheme:"rjv-grey",author:"mac gainor",base00:"rgba(1, 1, 1, 0)",base01:"rgba(1, 1, 1, 0.1)",base02:"rgba(0, 0, 0, 0.2)",base03:"rgba(1, 1, 1, 0.3)",base04:"rgba(0, 0, 0, 0.4)",base05:"rgba(1, 1, 1, 0.5)",base06:"rgba(1, 1, 1, 0.6)",base07:"rgba(1, 1, 1, 0.7)",base08:"rgba(1, 1, 1, 0.8)",base09:"rgba(1, 1, 1, 0.8)",base0A:"rgba(1, 1, 1, 0.8)",base0B:"rgba(1, 1, 1, 0.8)",base0C:"rgba(1, 1, 1, 0.8)",base0D:"rgba(1, 1, 1, 0.8)",base0E:"rgba(1, 1, 1, 0.8)",base0F:"rgba(1, 1, 1, 0.8)"},C={globalFontFamily:"monospace",globalCursor:"default",braceFontWeight:"bold",braceCursor:"pointer",ellipsisFontSize:"18px",ellipsisLineHeight:"10px",ellipsisCursor:"pointer",keyMargin:"0px 5px",keyLetterSpacing:"0.5px",keyFontStyle:"none",keyVerticalAlign:"top",keyOpacity:"0.85",keyOpacityHover:"1",keyValPaddingTop:"3px",keyValPaddingBottom:"3px",keyValPaddingRight:"5px",keyValBorderLeft:"1px solid",keyValBorderHover:"2px solid",pushedContentMarginLeft:"6px",variableValuePaddingRight:"6px",nullFontSize:"11px",nullFontWeight:"bold",nullPadding:"1px 2px",nullBorderRadius:"3px",nanFontSize:"11px",nanFontWeight:"bold",nanPadding:"1px 2px",nanBorderRadius:"3px",undefinedFontSize:"11px",undefinedPadding:"1px 2px",undefinedBorderRadius:"3px",dataTypeFontSize:"11px",dataTypeMarginRight:"4px",datatypeOpacity:"0.8",objectSizeBorderRadius:"3px",objectSizeFontStyle:"italic",objectSizeMargin:"0px 6px 0px 0px",clipboardCursor:"pointer",clipboardCheckMarginLeft:"-12px",metaDataPadding:"0px 0px 0px 10px",arrayGroupMetaPadding:"0px 0px 0px 4px",iconContainerWidth:"17px",tooltipPadding:"4px",editInputMinWidth:"130px",editInputBorderRadius:"2px",editInputPadding:"5px",editInputMarginRight:"4px",editInputFontFamily:"monospace",iconCursor:"pointer",iconFontSize:"15px",iconPaddingRight:"1px",dateValueMarginLeft:"2px",iconMarginRight:"3px",detectedRowPaddingTop:"3px",addKeyCoverBackground:"rgba(255, 255, 255, 0.3)",addKeyCoverPosition:"absolute",addKeyCoverPositionPx:"0px",addKeyModalWidth:"200px",addKeyModalMargin:"auto",addKeyModalPadding:"10px",addKeyModalRadius:"3px"},S=n(45),w=function(e){var t=function(e){return {backgroundColor:e.base00,ellipsisColor:e.base09,braceColor:e.base07,expandedIcon:e.base0D,collapsedIcon:e.base0E,keyColor:e.base07,arrayKeyColor:e.base0C,objectSize:e.base04,copyToClipboard:e.base0F,copyToClipboardCheck:e.base0D,objectBorder:e.base02,dataTypes:{boolean:e.base0E,date:e.base0D,float:e.base0B,function:e.base0D,integer:e.base0F,string:e.base09,nan:e.base08,null:e.base0A,undefined:e.base05,regexp:e.base0A,background:e.base02},editVariable:{editIcon:e.base0E,cancelIcon:e.base09,removeIcon:e.base09,addIcon:e.base0E,checkIcon:e.base0E,background:e.base01,color:e.base0A,border:e.base07},addKeyModal:{background:e.base05,border:e.base04,color:e.base0A,labelColor:e.base01},validationFailure:{background:e.base09,iconColor:e.base01,fontColor:e.base01}}}(e);return {"app-container":{fontFamily:C.globalFontFamily,cursor:C.globalCursor,backgroundColor:t.backgroundColor,position:"relative"},ellipsis:{display:"inline-block",color:t.ellipsisColor,fontSize:C.ellipsisFontSize,lineHeight:C.ellipsisLineHeight,cursor:C.ellipsisCursor},"brace-row":{display:"inline-block",cursor:"pointer"},brace:{display:"inline-block",cursor:C.braceCursor,fontWeight:C.braceFontWeight,color:t.braceColor},"expanded-icon":{color:t.expandedIcon},"collapsed-icon":{color:t.collapsedIcon},colon:{display:"inline-block",margin:C.keyMargin,color:t.keyColor,verticalAlign:"top"},objectKeyVal:function(e,n){return {style:o({paddingTop:C.keyValPaddingTop,paddingRight:C.keyValPaddingRight,paddingBottom:C.keyValPaddingBottom,borderLeft:C.keyValBorderLeft+" "+t.objectBorder,":hover":{paddingLeft:n.paddingLeft-1+"px",borderLeft:C.keyValBorderHover+" "+t.objectBorder}},n)}},"object-key-val-no-border":{padding:C.keyValPadding},"pushed-content":{marginLeft:C.pushedContentMarginLeft},variableValue:function(e,t){return {style:o({display:"inline-block",paddingRight:C.variableValuePaddingRight,position:"relative"},t)}},"object-name":{display:"inline-block",color:t.keyColor,letterSpacing:C.keyLetterSpacing,fontStyle:C.keyFontStyle,verticalAlign:C.keyVerticalAlign,opacity:C.keyOpacity,":hover":{opacity:C.keyOpacityHover}},"array-key":{display:"inline-block",color:t.arrayKeyColor,letterSpacing:C.keyLetterSpacing,fontStyle:C.keyFontStyle,verticalAlign:C.keyVerticalAlign,opacity:C.keyOpacity,":hover":{opacity:C.keyOpacityHover}},"object-size":{color:t.objectSize,borderRadius:C.objectSizeBorderRadius,fontStyle:C.objectSizeFontStyle,margin:C.objectSizeMargin,cursor:"default"},"data-type-label":{fontSize:C.dataTypeFontSize,marginRight:C.dataTypeMarginRight,opacity:C.datatypeOpacity},boolean:{display:"inline-block",color:t.dataTypes.boolean},date:{display:"inline-block",color:t.dataTypes.date},"date-value":{marginLeft:C.dateValueMarginLeft},float:{display:"inline-block",color:t.dataTypes.float},function:{display:"inline-block",color:t.dataTypes.function,cursor:"pointer",whiteSpace:"pre-line"},"function-value":{fontStyle:"italic"},integer:{display:"inline-block",color:t.dataTypes.integer},string:{display:"inline-block",color:t.dataTypes.string},nan:{display:"inline-block",color:t.dataTypes.nan,fontSize:C.nanFontSize,fontWeight:C.nanFontWeight,backgroundColor:t.dataTypes.background,padding:C.nanPadding,borderRadius:C.nanBorderRadius},null:{display:"inline-block",color:t.dataTypes.null,fontSize:C.nullFontSize,fontWeight:C.nullFontWeight,backgroundColor:t.dataTypes.background,padding:C.nullPadding,borderRadius:C.nullBorderRadius},undefined:{display:"inline-block",color:t.dataTypes.undefined,fontSize:C.undefinedFontSize,padding:C.undefinedPadding,borderRadius:C.undefinedBorderRadius,backgroundColor:t.dataTypes.background},regexp:{display:"inline-block",color:t.dataTypes.regexp},"copy-to-clipboard":{cursor:C.clipboardCursor},"copy-icon":{color:t.copyToClipboard,fontSize:C.iconFontSize,marginRight:C.iconMarginRight,verticalAlign:"top"},"copy-icon-copied":{color:t.copyToClipboardCheck,marginLeft:C.clipboardCheckMarginLeft},"array-group-meta-data":{display:"inline-block",padding:C.arrayGroupMetaPadding},"object-meta-data":{display:"inline-block",padding:C.metaDataPadding},"icon-container":{display:"inline-block",width:C.iconContainerWidth},tooltip:{padding:C.tooltipPadding},removeVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.removeIcon,cursor:C.iconCursor,fontSize:C.iconFontSize,marginRight:C.iconMarginRight},addVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.addIcon,cursor:C.iconCursor,fontSize:C.iconFontSize,marginRight:C.iconMarginRight},editVarIcon:{verticalAlign:"top",display:"inline-block",color:t.editVariable.editIcon,cursor:C.iconCursor,fontSize:C.iconFontSize,marginRight:C.iconMarginRight},"edit-icon-container":{display:"inline-block",verticalAlign:"top"},"check-icon":{display:"inline-block",cursor:C.iconCursor,color:t.editVariable.checkIcon,fontSize:C.iconFontSize,paddingRight:C.iconPaddingRight},"cancel-icon":{display:"inline-block",cursor:C.iconCursor,color:t.editVariable.cancelIcon,fontSize:C.iconFontSize,paddingRight:C.iconPaddingRight},"edit-input":{display:"inline-block",minWidth:C.editInputMinWidth,borderRadius:C.editInputBorderRadius,backgroundColor:t.editVariable.background,color:t.editVariable.color,padding:C.editInputPadding,marginRight:C.editInputMarginRight,fontFamily:C.editInputFontFamily},"detected-row":{paddingTop:C.detectedRowPaddingTop},"key-modal-request":{position:C.addKeyCoverPosition,top:C.addKeyCoverPositionPx,left:C.addKeyCoverPositionPx,right:C.addKeyCoverPositionPx,bottom:C.addKeyCoverPositionPx,backgroundColor:C.addKeyCoverBackground},"key-modal":{width:C.addKeyModalWidth,backgroundColor:t.addKeyModal.background,marginLeft:C.addKeyModalMargin,marginRight:C.addKeyModalMargin,padding:C.addKeyModalPadding,borderRadius:C.addKeyModalRadius,marginTop:"15px",position:"relative"},"key-modal-label":{color:t.addKeyModal.labelColor,marginLeft:"2px",marginBottom:"5px",fontSize:"11px"},"key-modal-input-container":{overflow:"hidden"},"key-modal-input":{width:"100%",padding:"3px 6px",fontFamily:"monospace",color:t.addKeyModal.color,border:"none",boxSizing:"border-box",borderRadius:"2px"},"key-modal-cancel":{backgroundColor:t.editVariable.removeIcon,position:"absolute",top:"0px",right:"0px",borderRadius:"0px 3px 0px 3px",cursor:"pointer"},"key-modal-cancel-icon":{color:t.addKeyModal.labelColor,fontSize:C.iconFontSize,transform:"rotate(45deg)"},"key-modal-submit":{color:t.editVariable.addIcon,fontSize:C.iconFontSize,position:"absolute",right:"2px",top:"3px",cursor:"pointer"},"function-ellipsis":{display:"inline-block",color:t.ellipsisColor,fontSize:C.ellipsisFontSize,lineHeight:C.ellipsisLineHeight,cursor:C.ellipsisCursor},"validation-failure":{float:"right",padding:"3px 6px",borderRadius:"2px",cursor:"pointer",color:t.validationFailure.fontColor,backgroundColor:t.validationFailure.background},"validation-failure-label":{marginRight:"6px"},"validation-failure-clear":{position:"relative",verticalAlign:"top",cursor:"pointer",color:t.validationFailure.iconColor,fontSize:C.iconFontSize,transform:"rotate(45deg)"}}};function A(e,t,n){return e||console.error("theme has not been set"),function(e){var t=k;return  false!==e&&"none"!==e||(t=O),Object(S.createStyling)(w,{defaultBase16:t})(e)}(e)(t,n)}var M=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=(e.rjvId,e.type_name),n=e.displayDataTypes,a=e.theme;return n?m.a.createElement("span",Object.assign({className:"data-type-label"},A(a,"data-type-label")),t):null}}]),n}(m.a.PureComponent),P=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props;return m.a.createElement("div",A(e.theme,"boolean"),m.a.createElement(M,Object.assign({type_name:"bool"},e)),e.value?"true":"false")}}]),n}(m.a.PureComponent),F=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props;return m.a.createElement("div",A(e.theme,"date"),m.a.createElement(M,Object.assign({type_name:"date"},e)),m.a.createElement("span",Object.assign({className:"date-value"},A(e.theme,"date-value")),e.value.toLocaleTimeString("en-us",{weekday:"short",year:"numeric",month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"})))}}]),n}(m.a.PureComponent),D=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props;return m.a.createElement("div",A(e.theme,"float"),m.a.createElement(M,Object.assign({type_name:"float"},e)),this.props.value)}}]),n}(m.a.PureComponent);function I(e,t){(null==t||t>e.length)&&(t=e.length);for(var n=0,a=new Array(t);n<t;n++)a[n]=e[n];return a}function R(e,t){if(e){if("string"==typeof e)return I(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return "Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(e):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?I(e,t):void 0}}function L(e,t){var n;if("undefined"==typeof Symbol||null==e[Symbol.iterator]){if(Array.isArray(e)||(n=R(e))||t){n&&(e=n);var a=0,r=function(){};return {s:r,n:function(){return a>=e.length?{done:true}:{done:false,value:e[a++]}},e:function(e){throw e},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,i=true,s=false;return {s:function(){n=e[Symbol.iterator]();},n:function(){var e=n.next();return i=e.done,e},e:function(e){s=true,o=e;},f:function(){try{i||null==n.return||n.return();}finally{if(s)throw o}}}}function B(e){return function(e){if(Array.isArray(e))return I(e)}(e)||function(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}(e)||R(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}var N=n(46),z=new(n(47).Dispatcher),T=new(function(e){u(n,e);var t=h(n);function n(){var e;i(this,n);for(var a=arguments.length,r=new Array(a),s=0;s<a;s++)r[s]=arguments[s];return (e=t.call.apply(t,[this].concat(r))).objects={},e.set=function(t,n,a,r){ void 0===e.objects[t]&&(e.objects[t]={}),void 0===e.objects[t][n]&&(e.objects[t][n]={}),e.objects[t][n][a]=r;},e.get=function(t,n,a,r){return void 0===e.objects[t]||void 0===e.objects[t][n]||null==e.objects[t][n][a]?r:e.objects[t][n][a]},e.handleAction=function(t){var n=t.rjvId,a=t.data;switch(t.name){case "RESET":e.emit("reset-"+n);break;case "VARIABLE_UPDATED":t.data.updated_src=e.updateSrc(n,a),e.set(n,"action","variable-update",o(o({},a),{},{type:"variable-edited"})),e.emit("variable-update-"+n);break;case "VARIABLE_REMOVED":t.data.updated_src=e.updateSrc(n,a),e.set(n,"action","variable-update",o(o({},a),{},{type:"variable-removed"})),e.emit("variable-update-"+n);break;case "VARIABLE_ADDED":t.data.updated_src=e.updateSrc(n,a),e.set(n,"action","variable-update",o(o({},a),{},{type:"variable-added"})),e.emit("variable-update-"+n);break;case "ADD_VARIABLE_KEY_REQUEST":e.set(n,"action","new-key-request",a),e.emit("add-key-request-"+n);}},e.updateSrc=function(t,n){var a=n.name,r=n.namespace,o=n.new_value,i=(n.existing_value,n.variable_removed);r.shift();var s,c=e.get(t,"global","src"),l=e.deepCopy(c,B(r)),u=l,f=L(r);try{for(f.s();!(s=f.n()).done;){u=u[s.value];}}catch(e){f.e(e);}finally{f.f();}return i?"array"==_(u)?u.splice(a,1):delete u[a]:null!==a?u[a]=o:l=o,e.set(t,"global","src",l),l},e.deepCopy=function(t,n){var a,r=_(t),i=n.shift();return "array"==r?a=B(t):"object"==r&&(a=o({},t)),void 0!==i&&(a[i]=e.deepCopy(t[i],n)),a},e}return n}(N.EventEmitter));z.register(T.handleAction.bind(T));var q=T,V=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).toggleCollapsed=function(){a.setState({collapsed:!a.state.collapsed},(function(){q.set(a.props.rjvId,a.props.namespace,"collapsed",a.state.collapsed);}));},a.getFunctionDisplay=function(e){var t=d(a).props;return e?m.a.createElement("span",null,a.props.value.toString().slice(9,-1).replace(/\{[\s\S]+/,""),m.a.createElement("span",{className:"function-collapsed",style:{fontWeight:"bold"}},m.a.createElement("span",null,"{"),m.a.createElement("span",A(t.theme,"ellipsis"),"..."),m.a.createElement("span",null,"}"))):a.props.value.toString().slice(9,-1)},a.state={collapsed:q.get(e.rjvId,e.namespace,"collapsed",true)},a}return c(n,[{key:"render",value:function(){var e=this.props,t=this.state.collapsed;return m.a.createElement("div",A(e.theme,"function"),m.a.createElement(M,Object.assign({type_name:"function"},e)),m.a.createElement("span",Object.assign({},A(e.theme,"function-value"),{className:"rjv-function-container",onClick:this.toggleCollapsed}),this.getFunctionDisplay(t)))}}]),n}(m.a.PureComponent),K=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){return m.a.createElement("div",A(this.props.theme,"nan"),"NaN")}}]),n}(m.a.PureComponent),W=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){return m.a.createElement("div",A(this.props.theme,"null"),"NULL")}}]),n}(m.a.PureComponent),H=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props;return m.a.createElement("div",A(e.theme,"integer"),m.a.createElement(M,Object.assign({type_name:"int"},e)),this.props.value)}}]),n}(m.a.PureComponent),U=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props;return m.a.createElement("div",A(e.theme,"regexp"),m.a.createElement(M,Object.assign({type_name:"regexp"},e)),this.props.value.toString())}}]),n}(m.a.PureComponent),G=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).toggleCollapsed=function(){a.setState({collapsed:!a.state.collapsed},(function(){q.set(a.props.rjvId,a.props.namespace,"collapsed",a.state.collapsed);}));},a.state={collapsed:q.get(e.rjvId,e.namespace,"collapsed",true)},a}return c(n,[{key:"render",value:function(){this.state.collapsed;var e=this.props,t=e.collapseStringsAfterLength,n=e.theme,a=e.value,r={style:{cursor:"default"}};return "integer"===_(t)&&a.length>t&&(r.style.cursor="pointer",this.state.collapsed&&(a=m.a.createElement("span",null,a.substring(0,t),m.a.createElement("span",A(n,"ellipsis")," ...")))),m.a.createElement("div",A(n,"string"),m.a.createElement(M,Object.assign({type_name:"string"},e)),m.a.createElement("span",Object.assign({className:"string-value"},r,{onClick:this.toggleCollapsed}),'"',a,'"'))}}]),n}(m.a.PureComponent),J=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){return m.a.createElement("div",A(this.props.theme,"undefined"),"undefined")}}]),n}(m.a.PureComponent);function Y(){return (Y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}var $=v.useLayoutEffect,Q=function(e){var t=Object(v.useRef)(e);return $((function(){t.current=e;})),t},Z=function(e,t){"function"!=typeof e?e.current=t:e(t);},X=function(e,t){var n=Object(v.useRef)();return Object(v.useCallback)((function(a){e.current=a,n.current&&Z(n.current,null),n.current=t,t&&Z(t,a);}),[t])},ee={"min-height":"0","max-height":"none",height:"0",visibility:"hidden",overflow:"hidden",position:"absolute","z-index":"-1000",top:"0",right:"0"},te=function(e){Object.keys(ee).forEach((function(t){e.style.setProperty(t,ee[t],"important");}));},ne=null;var ae=function(){},re=["borderBottomWidth","borderLeftWidth","borderRightWidth","borderTopWidth","boxSizing","fontFamily","fontSize","fontStyle","fontWeight","letterSpacing","lineHeight","paddingBottom","paddingLeft","paddingRight","paddingTop","tabSize","textIndent","textRendering","textTransform","width"],oe=!!document.documentElement.currentStyle,ie=function(e,t){var n=e.cacheMeasurements,a=e.maxRows,r=e.minRows,o=e.onChange,i=void 0===o?ae:o,s=e.onHeightChange,c=void 0===s?ae:s,l=function(e,t){if(null==e)return {};var n,a,r={},o=Object.keys(e);for(a=0;a<o.length;a++)n=o[a],t.indexOf(n)>=0||(r[n]=e[n]);return r}(e,["cacheMeasurements","maxRows","minRows","onChange","onHeightChange"]);var u,f=void 0!==l.value,p=Object(v.useRef)(null),d=X(p,t),b=Object(v.useRef)(0),h=Object(v.useRef)(),m=function(){var e=p.current,t=n&&h.current?h.current:function(e){var t=window.getComputedStyle(e);if(null===t)return null;var n,a=(n=t,re.reduce((function(e,t){return e[t]=n[t],e}),{})),r=a.boxSizing;return ""===r?null:(oe&&"border-box"===r&&(a.width=parseFloat(a.width)+parseFloat(a.borderRightWidth)+parseFloat(a.borderLeftWidth)+parseFloat(a.paddingRight)+parseFloat(a.paddingLeft)+"px"),{sizingStyle:a,paddingSize:parseFloat(a.paddingBottom)+parseFloat(a.paddingTop),borderSize:parseFloat(a.borderBottomWidth)+parseFloat(a.borderTopWidth)})}(e);if(t){h.current=t;var o=function(e,t,n,a){ void 0===n&&(n=1),void 0===a&&(a=1/0),ne||((ne=document.createElement("textarea")).setAttribute("tab-index","-1"),ne.setAttribute("aria-hidden","true"),te(ne)),null===ne.parentNode&&document.body.appendChild(ne);var r=e.paddingSize,o=e.borderSize,i=e.sizingStyle,s=i.boxSizing;Object.keys(i).forEach((function(e){var t=e;ne.style[t]=i[t];})),te(ne),ne.value=t;var c=function(e,t){var n=e.scrollHeight;return "border-box"===t.sizingStyle.boxSizing?n+t.borderSize:n-t.paddingSize}(ne,e);ne.value="x";var l=ne.scrollHeight-r,u=l*n;"border-box"===s&&(u=u+r+o),c=Math.max(u,c);var f=l*a;return "border-box"===s&&(f=f+r+o),[c=Math.min(f,c),l]}(t,e.value||e.placeholder||"x",r,a),i=o[0],s=o[1];b.current!==i&&(b.current=i,e.style.setProperty("height",i+"px","important"),c(i,{rowHeight:s}));}};return Object(v.useLayoutEffect)(m),u=Q(m),Object(v.useLayoutEffect)((function(){var e=function(e){u.current(e);};return window.addEventListener("resize",e),function(){window.removeEventListener("resize",e);}}),[]),Object(v.createElement)("textarea",Y({},l,{onChange:function(e){f||m(),i(e);},ref:d}))},se=Object(v.forwardRef)(ie);function ce(e){e=e.trim();try{if("["===(e=JSON.stringify(JSON.parse(e)))[0])return le("array",JSON.parse(e));if("{"===e[0])return le("object",JSON.parse(e));if(e.match(/\-?\d+\.\d+/)&&e.match(/\-?\d+\.\d+/)[0]===e)return le("float",parseFloat(e));if(e.match(/\-?\d+e-\d+/)&&e.match(/\-?\d+e-\d+/)[0]===e)return le("float",Number(e));if(e.match(/\-?\d+/)&&e.match(/\-?\d+/)[0]===e)return le("integer",parseInt(e));if(e.match(/\-?\d+e\+\d+/)&&e.match(/\-?\d+e\+\d+/)[0]===e)return le("integer",Number(e))}catch(e){}switch(e=e.toLowerCase()){case "undefined":return le("undefined",void 0);case "nan":return le("nan",NaN);case "null":return le("null",null);case "true":return le("boolean",true);case "false":return le("boolean",false);default:if(e=Date.parse(e))return le("date",new Date(e))}return le(false,null)}function le(e,t){return {type:e,value:t}}var ue=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M7,13H17V11H7"})))}}]),n}(m.a.PureComponent),fe=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 24 24",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("path",{d:"M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M13,7H11V11H7V13H11V17H13V13H17V11H13V7Z"})))}}]),n}(m.a.PureComponent),pe=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]),a=xe(t).style;return m.a.createElement("span",n,m.a.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},m.a.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),n}(m.a.PureComponent),de=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]),a=xe(t).style;return m.a.createElement("span",n,m.a.createElement("svg",{fill:a.color,width:a.height,height:a.width,style:a,viewBox:"0 0 1792 1792"},m.a.createElement("path",{d:"M1344 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zm128 448v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zm128-832v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"})))}}]),n}(m.a.PureComponent),be=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",{style:o(o({},xe(t).style),{},{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},m.a.createElement("path",{d:"M0 14l6-6-6-6z"})))}}]),n}(m.a.PureComponent),he=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",{style:o(o({},xe(t).style),{},{paddingLeft:"2px",verticalAlign:"top"}),viewBox:"0 0 15 15",fill:"currentColor"},m.a.createElement("path",{d:"M0 5l6 6 6-6z"})))}}]),n}(m.a.PureComponent),ve=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m30 35h-25v-22.5h25v7.5h2.5v-12.5c0-1.4-1.1-2.5-2.5-2.5h-7.5c0-2.8-2.2-5-5-5s-5 2.2-5 5h-7.5c-1.4 0-2.5 1.1-2.5 2.5v27.5c0 1.4 1.1 2.5 2.5 2.5h25c1.4 0 2.5-1.1 2.5-2.5v-5h-2.5v5z m-20-27.5h2.5s2.5-1.1 2.5-2.5 1.1-2.5 2.5-2.5 2.5 1.1 2.5 2.5 1.3 2.5 2.5 2.5h2.5s2.5 1.1 2.5 2.5h-20c0-1.5 1.1-2.5 2.5-2.5z m-2.5 20h5v-2.5h-5v2.5z m17.5-5v-5l-10 7.5 10 7.5v-5h12.5v-5h-12.5z m-17.5 10h7.5v-2.5h-7.5v2.5z m12.5-17.5h-12.5v2.5h12.5v-2.5z m-7.5 5h-5v2.5h5v-2.5z"}))))}}]),n}(m.a.PureComponent),me=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m28.6 25q0-0.5-0.4-1l-4-4 4-4q0.4-0.5 0.4-1 0-0.6-0.4-1.1l-2-2q-0.4-0.4-1-0.4-0.6 0-1 0.4l-4.1 4.1-4-4.1q-0.4-0.4-1-0.4-0.6 0-1 0.4l-2 2q-0.5 0.5-0.5 1.1 0 0.5 0.5 1l4 4-4 4q-0.5 0.5-0.5 1 0 0.7 0.5 1.1l2 2q0.4 0.4 1 0.4 0.6 0 1-0.4l4-4.1 4.1 4.1q0.4 0.4 1 0.4 0.6 0 1-0.4l2-2q0.4-0.4 0.4-1z m8.7-5q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),n}(m.a.PureComponent),ye=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-5.7v-5.7q0-0.6-0.4-1t-1-0.4h-2.9q-0.6 0-1 0.4t-0.4 1v5.7h-5.7q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h5.7v5.7q0 0.5 0.4 1t1 0.4h2.9q0.6 0 1-0.4t0.4-1v-5.7h5.7q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),n}(m.a.PureComponent),ge=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m31.6 21.6h-10v10h-3.2v-10h-10v-3.2h10v-10h3.2v10h10v3.2z"}))))}}]),n}(m.a.PureComponent),Ee=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m19.8 26.4l2.6-2.6-3.4-3.4-2.6 2.6v1.3h2.2v2.1h1.2z m9.8-16q-0.3-0.4-0.7 0l-7.8 7.8q-0.4 0.4 0 0.7t0.7 0l7.8-7.8q0.4-0.4 0-0.7z m1.8 13.2v4.3q0 2.6-1.9 4.5t-4.5 1.9h-18.6q-2.6 0-4.5-1.9t-1.9-4.5v-18.6q0-2.7 1.9-4.6t4.5-1.8h18.6q1.4 0 2.6 0.5 0.3 0.2 0.4 0.5 0.1 0.4-0.2 0.7l-1.1 1.1q-0.3 0.3-0.7 0.1-0.5-0.1-1-0.1h-18.6q-1.4 0-2.5 1.1t-1 2.5v18.6q0 1.4 1 2.5t2.5 1h18.6q1.5 0 2.5-1t1.1-2.5v-2.9q0-0.2 0.2-0.4l1.4-1.5q0.3-0.3 0.8-0.1t0.4 0.6z m-2.1-16.5l6.4 6.5-15 15h-6.4v-6.5z m9.9 3l-2.1 2-6.4-6.4 2.1-2q0.6-0.7 1.5-0.7t1.5 0.7l3.4 3.4q0.6 0.6 0.6 1.5t-0.6 1.5z"}))))}}]),n}(m.a.PureComponent),je=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.style,n=x(e,["style"]);return m.a.createElement("span",n,m.a.createElement("svg",Object.assign({},xe(t),{viewBox:"0 0 40 40",fill:"currentColor",preserveAspectRatio:"xMidYMid meet"}),m.a.createElement("g",null,m.a.createElement("path",{d:"m31.7 16.4q0-0.6-0.4-1l-2.1-2.1q-0.4-0.4-1-0.4t-1 0.4l-9.1 9.1-5-5q-0.5-0.4-1-0.4t-1 0.4l-2.1 2q-0.4 0.4-0.4 1 0 0.6 0.4 1l8.1 8.1q0.4 0.4 1 0.4 0.6 0 1-0.4l12.2-12.1q0.4-0.4 0.4-1z m5.6 3.6q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z"}))))}}]),n}(m.a.PureComponent);function xe(e){return e||(e={}),{style:o(o({verticalAlign:"middle"},e),{},{color:e.color?e.color:"#000000",height:"1em",width:"1em"})}}var _e=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).copiedTimer=null,a.handleCopy=function(){var e=document.createElement("textarea"),t=a.props,n=t.clickCallback,r=t.src,o=t.namespace;e.innerHTML=JSON.stringify(a.clipboardValue(r),null,"  "),document.body.appendChild(e),e.select(),document.execCommand("copy"),document.body.removeChild(e),a.copiedTimer=setTimeout((function(){a.setState({copied:false});}),5500),a.setState({copied:true},(function(){"function"==typeof n&&n({src:r,namespace:o,name:o[o.length-1]});}));},a.getClippyIcon=function(){var e=a.props.theme;return a.state.copied?m.a.createElement("span",null,m.a.createElement(ve,Object.assign({className:"copy-icon"},A(e,"copy-icon"))),m.a.createElement("span",A(e,"copy-icon-copied"),"✔")):m.a.createElement(ve,Object.assign({className:"copy-icon"},A(e,"copy-icon")))},a.clipboardValue=function(e){switch(_(e)){case "function":case "regexp":return e.toString();default:return e}},a.state={copied:false},a}return c(n,[{key:"componentWillUnmount",value:function(){this.copiedTimer&&(clearTimeout(this.copiedTimer),this.copiedTimer=null);}},{key:"render",value:function(){var e=this.props,t=(e.src,e.theme),n=e.hidden,a=e.rowHovered,r=A(t,"copy-to-clipboard").style,i="inline";return n&&(i="none"),m.a.createElement("span",{className:"copy-to-clipboard-container",title:"Copy to clipboard",style:{verticalAlign:"top",display:a?"inline-block":"none"}},m.a.createElement("span",{style:o(o({},r),{},{display:i}),onClick:this.handleCopy},this.getClippyIcon()))}}]),n}(m.a.PureComponent),ke=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).getEditIcon=function(){var e=a.props,t=e.variable,n=e.theme;return m.a.createElement("div",{className:"click-to-edit",style:{verticalAlign:"top",display:a.state.hovered?"inline-block":"none"}},m.a.createElement(Ee,Object.assign({className:"click-to-edit-icon"},A(n,"editVarIcon"),{onClick:function(){a.prepopInput(t);}})))},a.prepopInput=function(e){if(false!==a.props.onEdit){var t=function(e){var t;switch(_(e)){case "undefined":t="undefined";break;case "nan":t="NaN";break;case "string":t=e;break;case "date":case "function":case "regexp":t=e.toString();break;default:try{t=JSON.stringify(e,null,"  ");}catch(e){t="";}}return t}(e.value),n=ce(t);a.setState({editMode:true,editValue:t,parsedInput:{type:n.type,value:n.value}});}},a.getRemoveIcon=function(){var e=a.props,t=e.variable,n=e.namespace,r=e.theme,o=e.rjvId;return m.a.createElement("div",{className:"click-to-remove",style:{verticalAlign:"top",display:a.state.hovered?"inline-block":"none"}},m.a.createElement(me,Object.assign({className:"click-to-remove-icon"},A(r,"removeVarIcon"),{onClick:function(){z.dispatch({name:"VARIABLE_REMOVED",rjvId:o,data:{name:t.name,namespace:n,existing_value:t.value,variable_removed:true}});}})))},a.getValue=function(e,t){var n=!t&&e.type,r=d(a).props;switch(n){case  false:return a.getEditInput();case "string":return m.a.createElement(G,Object.assign({value:e.value},r));case "integer":return m.a.createElement(H,Object.assign({value:e.value},r));case "float":return m.a.createElement(D,Object.assign({value:e.value},r));case "boolean":return m.a.createElement(P,Object.assign({value:e.value},r));case "function":return m.a.createElement(V,Object.assign({value:e.value},r));case "null":return m.a.createElement(W,r);case "nan":return m.a.createElement(K,r);case "undefined":return m.a.createElement(J,r);case "date":return m.a.createElement(F,Object.assign({value:e.value},r));case "regexp":return m.a.createElement(U,Object.assign({value:e.value},r));default:return m.a.createElement("div",{className:"object-value"},JSON.stringify(e.value))}},a.getEditInput=function(){var e=a.props.theme,t=a.state.editValue;return m.a.createElement("div",null,m.a.createElement(se,Object.assign({type:"text",inputRef:function(e){return e&&e.focus()},value:t,className:"variable-editor",onChange:function(e){var t=e.target.value,n=ce(t);a.setState({editValue:t,parsedInput:{type:n.type,value:n.value}});},onKeyDown:function(e){switch(e.key){case "Escape":a.setState({editMode:false,editValue:""});break;case "Enter":(e.ctrlKey||e.metaKey)&&a.submitEdit(true);}e.stopPropagation();},placeholder:"update this value",minRows:2},A(e,"edit-input"))),m.a.createElement("div",A(e,"edit-icon-container"),m.a.createElement(me,Object.assign({className:"edit-cancel"},A(e,"cancel-icon"),{onClick:function(){a.setState({editMode:false,editValue:""});}})),m.a.createElement(je,Object.assign({className:"edit-check string-value"},A(e,"check-icon"),{onClick:function(){a.submitEdit();}})),m.a.createElement("div",null,a.showDetected())))},a.submitEdit=function(e){var t=a.props,n=t.variable,r=t.namespace,o=t.rjvId,i=a.state,s=i.editValue,c=i.parsedInput,l=s;e&&c.type&&(l=c.value),a.setState({editMode:false}),z.dispatch({name:"VARIABLE_UPDATED",rjvId:o,data:{name:n.name,namespace:r,existing_value:n.value,new_value:l,variable_removed:false}});},a.showDetected=function(){var e=a.props,t=e.theme,n=(e.variable,e.namespace,e.rjvId,a.state.parsedInput),r=(n.type,n.value,a.getDetectedInput());if(r)return m.a.createElement("div",null,m.a.createElement("div",A(t,"detected-row"),r,m.a.createElement(je,{className:"edit-check detected",style:o({verticalAlign:"top",paddingLeft:"3px"},A(t,"check-icon").style),onClick:function(){a.submitEdit(true);}})))},a.getDetectedInput=function(){var e=a.state.parsedInput,t=e.type,n=e.value,r=d(a).props,i=r.theme;if(false!==t)switch(t.toLowerCase()){case "object":return m.a.createElement("span",null,m.a.createElement("span",{style:o(o({},A(i,"brace").style),{},{cursor:"default"})},"{"),m.a.createElement("span",{style:o(o({},A(i,"ellipsis").style),{},{cursor:"default"})},"..."),m.a.createElement("span",{style:o(o({},A(i,"brace").style),{},{cursor:"default"})},"}"));case "array":return m.a.createElement("span",null,m.a.createElement("span",{style:o(o({},A(i,"brace").style),{},{cursor:"default"})},"["),m.a.createElement("span",{style:o(o({},A(i,"ellipsis").style),{},{cursor:"default"})},"..."),m.a.createElement("span",{style:o(o({},A(i,"brace").style),{},{cursor:"default"})},"]"));case "string":return m.a.createElement(G,Object.assign({value:n},r));case "integer":return m.a.createElement(H,Object.assign({value:n},r));case "float":return m.a.createElement(D,Object.assign({value:n},r));case "boolean":return m.a.createElement(P,Object.assign({value:n},r));case "function":return m.a.createElement(V,Object.assign({value:n},r));case "null":return m.a.createElement(W,r);case "nan":return m.a.createElement(K,r);case "undefined":return m.a.createElement(J,r);case "date":return m.a.createElement(F,Object.assign({value:new Date(n)},r))}},a.state={editMode:false,editValue:"",hovered:false,renameKey:false,parsedInput:{type:false,value:null}},a}return c(n,[{key:"render",value:function(){var e=this,t=this.props,n=t.variable,a=t.singleIndent,r=t.type,i=t.theme,s=t.namespace,c=t.indentWidth,l=t.enableClipboard,u=t.onEdit,f=t.onDelete,p=t.onSelect,d=t.displayArrayKey,b=t.quotesOnKeys,h=this.state.editMode;return m.a.createElement("div",Object.assign({},A(i,"objectKeyVal",{paddingLeft:c*a}),{onMouseEnter:function(){return e.setState(o(o({},e.state),{},{hovered:true}))},onMouseLeave:function(){return e.setState(o(o({},e.state),{},{hovered:false}))},className:"variable-row",key:n.name}),"array"==r?d?m.a.createElement("span",Object.assign({},A(i,"array-key"),{key:n.name+"_"+s}),n.name,m.a.createElement("div",A(i,"colon"),":")):null:m.a.createElement("span",null,m.a.createElement("span",Object.assign({},A(i,"object-name"),{className:"object-key",key:n.name+"_"+s}),!!b&&m.a.createElement("span",{style:{verticalAlign:"top"}},'"'),m.a.createElement("span",{style:{display:"inline-block"}},n.name),!!b&&m.a.createElement("span",{style:{verticalAlign:"top"}},'"')),m.a.createElement("span",A(i,"colon"),":")),m.a.createElement("div",Object.assign({className:"variable-value",onClick:false===p&&false===u?null:function(t){var a=B(s);(t.ctrlKey||t.metaKey)&&false!==u?e.prepopInput(n):false!==p&&(a.shift(),p(o(o({},n),{},{namespace:a})));}},A(i,"variableValue",{cursor:false===p?"default":"pointer"})),this.getValue(n,h)),l?m.a.createElement(_e,{rowHovered:this.state.hovered,hidden:h,src:n.value,clickCallback:l,theme:i,namespace:[].concat(B(s),[n.name])}):null,false!==u&&0==h?this.getEditIcon():null,false!==f&&0==h?this.getRemoveIcon():null)}}]),n}(m.a.PureComponent),Oe=function(e){u(n,e);var t=h(n);function n(){var e;i(this,n);for(var a=arguments.length,r=new Array(a),s=0;s<a;s++)r[s]=arguments[s];return (e=t.call.apply(t,[this].concat(r))).getObjectSize=function(){var t=e.props,n=t.size,a=t.theme;if(t.displayObjectSize)return m.a.createElement("span",Object.assign({className:"object-size"},A(a,"object-size")),n," item",1===n?"":"s")},e.getAddAttribute=function(t){var n=e.props,a=n.theme,r=n.namespace,i=n.name,s=n.src,c=n.rjvId,l=n.depth;return m.a.createElement("span",{className:"click-to-add",style:{verticalAlign:"top",display:t?"inline-block":"none"}},m.a.createElement(ye,Object.assign({className:"click-to-add-icon"},A(a,"addVarIcon"),{onClick:function(){var e={name:l>0?i:null,namespace:r.splice(0,r.length-1),existing_value:s,variable_removed:false,key_name:null};"object"===_(s)?z.dispatch({name:"ADD_VARIABLE_KEY_REQUEST",rjvId:c,data:e}):z.dispatch({name:"VARIABLE_ADDED",rjvId:c,data:o(o({},e),{},{new_value:[].concat(B(s),[null])})});}})))},e.getRemoveObject=function(t){var n=e.props,a=n.theme,r=(n.hover,n.namespace),o=n.name,i=n.src,s=n.rjvId;if(1!==r.length)return m.a.createElement("span",{className:"click-to-remove",style:{display:t?"inline-block":"none"}},m.a.createElement(me,Object.assign({className:"click-to-remove-icon"},A(a,"removeVarIcon"),{onClick:function(){z.dispatch({name:"VARIABLE_REMOVED",rjvId:s,data:{name:o,namespace:r.splice(0,r.length-1),existing_value:i,variable_removed:true}});}})))},e.render=function(){var t=e.props,n=t.theme,a=t.onDelete,r=t.onAdd,o=t.enableClipboard,i=t.src,s=t.namespace,c=t.rowHovered;return m.a.createElement("div",Object.assign({},A(n,"object-meta-data"),{className:"object-meta-data",onClick:function(e){e.stopPropagation();}}),e.getObjectSize(),o?m.a.createElement(_e,{rowHovered:c,clickCallback:o,src:i,theme:n,namespace:s}):null,false!==r?e.getAddAttribute(c):null,false!==a?e.getRemoveObject(c):null)},e}return n}(m.a.PureComponent);function Ce(e){var t=e.parent_type,n=e.namespace,a=e.quotesOnKeys,r=e.theme,o=e.jsvRoot,i=e.name,s=e.displayArrayKey,c=e.name?e.name:"";return !o||false!==i&&null!==i?"array"==t?s?m.a.createElement("span",Object.assign({},A(r,"array-key"),{key:n}),m.a.createElement("span",{className:"array-key"},c),m.a.createElement("span",A(r,"colon"),":")):m.a.createElement("span",null):m.a.createElement("span",Object.assign({},A(r,"object-name"),{key:n}),m.a.createElement("span",{className:"object-key"},a&&m.a.createElement("span",{style:{verticalAlign:"top"}},'"'),m.a.createElement("span",null,c),a&&m.a.createElement("span",{style:{verticalAlign:"top"}},'"')),m.a.createElement("span",A(r,"colon"),":")):m.a.createElement("span",null)}function Se(e){var t=e.theme;switch(e.iconStyle){case "triangle":return m.a.createElement(he,Object.assign({},A(t,"expanded-icon"),{className:"expanded-icon"}));case "square":return m.a.createElement(pe,Object.assign({},A(t,"expanded-icon"),{className:"expanded-icon"}));default:return m.a.createElement(ue,Object.assign({},A(t,"expanded-icon"),{className:"expanded-icon"}))}}function we(e){var t=e.theme;switch(e.iconStyle){case "triangle":return m.a.createElement(be,Object.assign({},A(t,"collapsed-icon"),{className:"collapsed-icon"}));case "square":return m.a.createElement(de,Object.assign({},A(t,"collapsed-icon"),{className:"collapsed-icon"}));default:return m.a.createElement(fe,Object.assign({},A(t,"collapsed-icon"),{className:"collapsed-icon"}))}}var Ae=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).toggleCollapsed=function(e){var t=[];for(var n in a.state.expanded)t.push(a.state.expanded[n]);t[e]=!t[e],a.setState({expanded:t});},a.state={expanded:[]},a}return c(n,[{key:"getExpandedIcon",value:function(e){var t=this.props,n=t.theme,a=t.iconStyle;return this.state.expanded[e]?m.a.createElement(Se,{theme:n,iconStyle:a}):m.a.createElement(we,{theme:n,iconStyle:a})}},{key:"render",value:function(){var e=this,t=this.props,n=t.src,a=t.groupArraysAfterLength,r=(t.depth,t.name),o=t.theme,i=t.jsvRoot,s=t.namespace,c=(t.parent_type,x(t,["src","groupArraysAfterLength","depth","name","theme","jsvRoot","namespace","parent_type"])),l=0,u=5*this.props.indentWidth;i||(l=5*this.props.indentWidth);var f=a,p=Math.ceil(n.length/f);return m.a.createElement("div",Object.assign({className:"object-key-val"},A(o,i?"jsv-root":"objectKeyVal",{paddingLeft:l})),m.a.createElement(Ce,this.props),m.a.createElement("span",null,m.a.createElement(Oe,Object.assign({size:n.length},this.props))),B(Array(p)).map((function(t,a){return m.a.createElement("div",Object.assign({key:a,className:"object-key-val array-group"},A(o,"objectKeyVal",{marginLeft:6,paddingLeft:u})),m.a.createElement("span",A(o,"brace-row"),m.a.createElement("div",Object.assign({className:"icon-container"},A(o,"icon-container"),{onClick:function(t){e.toggleCollapsed(a);}}),e.getExpandedIcon(a)),e.state.expanded[a]?m.a.createElement(Fe,Object.assign({key:r+a,depth:0,name:false,collapsed:false,groupArraysAfterLength:f,index_offset:a*f,src:n.slice(a*f,a*f+f),namespace:s,type:"array",parent_type:"array_group",theme:o},c)):m.a.createElement("span",Object.assign({},A(o,"brace"),{onClick:function(t){e.toggleCollapsed(a);},className:"array-group-brace"}),"[",m.a.createElement("div",Object.assign({},A(o,"array-group-meta-data"),{className:"array-group-meta-data"}),m.a.createElement("span",Object.assign({className:"object-size"},A(o,"object-size")),a*f," - ",a*f+f>n.length?n.length:a*f+f)),"]")))})))}}]),n}(m.a.PureComponent),Me=function(e){u(n,e);var t=h(n);function n(e){var a;i(this,n),(a=t.call(this,e)).toggleCollapsed=function(){a.setState({expanded:!a.state.expanded},(function(){q.set(a.props.rjvId,a.props.namespace,"expanded",a.state.expanded);}));},a.getObjectContent=function(e,t,n){return m.a.createElement("div",{className:"pushed-content object-container"},m.a.createElement("div",Object.assign({className:"object-content"},A(a.props.theme,"pushed-content")),a.renderObjectContents(t,n)))},a.getEllipsis=function(){return 0===a.state.size?null:m.a.createElement("div",Object.assign({},A(a.props.theme,"ellipsis"),{className:"node-ellipsis",onClick:a.toggleCollapsed}),"...")},a.getObjectMetaData=function(e){var t=a.props,n=(t.rjvId,t.theme,a.state),r=n.size,o=n.hovered;return m.a.createElement(Oe,Object.assign({rowHovered:o,size:r},a.props))},a.renderObjectContents=function(e,t){var n,r=a.props,o=r.depth,i=r.parent_type,s=r.index_offset,c=r.groupArraysAfterLength,l=r.namespace,u=a.state.object_type,f=[],p=Object.keys(e||{});return a.props.sortKeys&&"array"!==u&&(p=p.sort()),p.forEach((function(r){if(n=new Pe(r,e[r]),"array_group"===i&&s&&(n.name=parseInt(n.name)+s),e.hasOwnProperty(r))if("object"===n.type)f.push(m.a.createElement(Fe,Object.assign({key:n.name,depth:o+1,name:n.name,src:n.value,namespace:l.concat(n.name),parent_type:u},t)));else if("array"===n.type){var p=Fe;c&&n.value.length>c&&(p=Ae),f.push(m.a.createElement(p,Object.assign({key:n.name,depth:o+1,name:n.name,src:n.value,namespace:l.concat(n.name),type:"array",parent_type:u},t)));}else f.push(m.a.createElement(ke,Object.assign({key:n.name+"_"+l,variable:n,singleIndent:5,namespace:l,type:a.props.type},t)));})),f};var r=n.getState(e);return a.state=o(o({},r),{},{prevProps:{}}),a}return c(n,[{key:"getBraceStart",value:function(e,t){var n=this,a=this.props,r=a.src,o=a.theme,i=a.iconStyle;if("array_group"===a.parent_type)return m.a.createElement("span",null,m.a.createElement("span",A(o,"brace"),"array"===e?"[":"{"),t?this.getObjectMetaData(r):null);var s=t?Se:we;return m.a.createElement("span",null,m.a.createElement("span",Object.assign({onClick:function(e){n.toggleCollapsed();}},A(o,"brace-row")),m.a.createElement("div",Object.assign({className:"icon-container"},A(o,"icon-container")),m.a.createElement(s,{theme:o,iconStyle:i})),m.a.createElement(Ce,this.props),m.a.createElement("span",A(o,"brace"),"array"===e?"[":"{")),t?this.getObjectMetaData(r):null)}},{key:"render",value:function(){var e=this,t=this.props,n=t.depth,a=t.src,r=(t.namespace,t.name,t.type,t.parent_type),i=t.theme,s=t.jsvRoot,c=t.iconStyle,l=x(t,["depth","src","namespace","name","type","parent_type","theme","jsvRoot","iconStyle"]),u=this.state,f=u.object_type,p=u.expanded,d={};return s||"array_group"===r?"array_group"===r&&(d.borderLeft=0,d.display="inline"):d.paddingLeft=5*this.props.indentWidth,m.a.createElement("div",Object.assign({className:"object-key-val",onMouseEnter:function(){return e.setState(o(o({},e.state),{},{hovered:true}))},onMouseLeave:function(){return e.setState(o(o({},e.state),{},{hovered:false}))}},A(i,s?"jsv-root":"objectKeyVal",d)),this.getBraceStart(f,p),p?this.getObjectContent(n,a,o({theme:i,iconStyle:c},l)):this.getEllipsis(),m.a.createElement("span",{className:"brace-row"},m.a.createElement("span",{style:o(o({},A(i,"brace").style),{},{paddingLeft:p?"3px":"0px"})},"array"===f?"]":"}"),p?null:this.getObjectMetaData(a)))}}],[{key:"getDerivedStateFromProps",value:function(e,t){var a=t.prevProps;return e.src!==a.src||e.collapsed!==a.collapsed||e.name!==a.name||e.namespace!==a.namespace||e.rjvId!==a.rjvId?o(o({},n.getState(e)),{},{prevProps:e}):null}}]),n}(m.a.PureComponent);Me.getState=function(e){var t=Object.keys(e.src).length,n=(false===e.collapsed||true!==e.collapsed&&e.collapsed>e.depth)&&(!e.shouldCollapse||false===e.shouldCollapse({name:e.name,src:e.src,type:_(e.src),namespace:e.namespace}))&&0!==t;return {expanded:q.get(e.rjvId,e.namespace,"expanded",n),object_type:"array"===e.type?"array":"object",parent_type:"array"===e.type?"array":"object",size:t,hovered:false}};var Pe=function e(t,n){i(this,e),this.name=t,this.value=n,this.type=_(n);};j(Me);var Fe=Me,De=function(e){u(n,e);var t=h(n);function n(){var e;i(this,n);for(var a=arguments.length,r=new Array(a),o=0;o<a;o++)r[o]=arguments[o];return (e=t.call.apply(t,[this].concat(r))).render=function(){var t=d(e).props,n=[t.name],a=Fe;return Array.isArray(t.src)&&t.groupArraysAfterLength&&t.src.length>t.groupArraysAfterLength&&(a=Ae),m.a.createElement("div",{className:"pretty-json-container object-container"},m.a.createElement("div",{className:"object-content"},m.a.createElement(a,Object.assign({namespace:n,depth:0,jsvRoot:true},t))))},e}return n}(m.a.PureComponent),Ie=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).closeModal=function(){z.dispatch({rjvId:a.props.rjvId,name:"RESET"});},a.submit=function(){a.props.submit(a.state.input);},a.state={input:e.input?e.input:""},a}return c(n,[{key:"render",value:function(){var e=this,t=this.props,n=t.theme,a=t.rjvId,r=t.isValid,o=this.state.input,i=r(o);return m.a.createElement("div",Object.assign({className:"key-modal-request"},A(n,"key-modal-request"),{onClick:this.closeModal}),m.a.createElement("div",Object.assign({},A(n,"key-modal"),{onClick:function(e){e.stopPropagation();}}),m.a.createElement("div",A(n,"key-modal-label"),"Key Name:"),m.a.createElement("div",{style:{position:"relative"}},m.a.createElement("input",Object.assign({},A(n,"key-modal-input"),{className:"key-modal-input",ref:function(e){return e&&e.focus()},spellCheck:false,value:o,placeholder:"...",onChange:function(t){e.setState({input:t.target.value});},onKeyPress:function(t){i&&"Enter"===t.key?e.submit():"Escape"===t.key&&e.closeModal();}})),i?m.a.createElement(je,Object.assign({},A(n,"key-modal-submit"),{className:"key-modal-submit",onClick:function(t){return e.submit()}})):null),m.a.createElement("span",A(n,"key-modal-cancel"),m.a.createElement(ge,Object.assign({},A(n,"key-modal-cancel-icon"),{className:"key-modal-cancel",onClick:function(){z.dispatch({rjvId:a,name:"RESET"});}})))))}}]),n}(m.a.PureComponent),Re=function(e){u(n,e);var t=h(n);function n(){var e;i(this,n);for(var a=arguments.length,r=new Array(a),s=0;s<a;s++)r[s]=arguments[s];return (e=t.call.apply(t,[this].concat(r))).isValid=function(t){var n=e.props.rjvId,a=q.get(n,"action","new-key-request");return ""!=t&&-1===Object.keys(a.existing_value).indexOf(t)},e.submit=function(t){var n=e.props.rjvId,a=q.get(n,"action","new-key-request");a.new_value=o({},a.existing_value),a.new_value[t]=e.props.defaultValue,z.dispatch({name:"VARIABLE_ADDED",rjvId:n,data:a});},e}return c(n,[{key:"render",value:function(){var e=this.props,t=e.active,n=e.theme,a=e.rjvId;return t?m.a.createElement(Ie,{rjvId:a,theme:n,isValid:this.isValid,submit:this.submit}):null}}]),n}(m.a.PureComponent),Le=function(e){u(n,e);var t=h(n);function n(){return i(this,n),t.apply(this,arguments)}return c(n,[{key:"render",value:function(){var e=this.props,t=e.message,n=e.active,a=e.theme,r=e.rjvId;return n?m.a.createElement("div",Object.assign({className:"validation-failure"},A(a,"validation-failure"),{onClick:function(){z.dispatch({rjvId:r,name:"RESET"});}}),m.a.createElement("span",A(a,"validation-failure-label"),t),m.a.createElement(ge,A(a,"validation-failure-clear"))):null}}]),n}(m.a.PureComponent),Be=function(e){u(n,e);var t=h(n);function n(e){var a;return i(this,n),(a=t.call(this,e)).rjvId=Date.now().toString(),a.getListeners=function(){return {reset:a.resetState,"variable-update":a.updateSrc,"add-key-request":a.addKeyRequest}},a.updateSrc=function(){var e,t=q.get(a.rjvId,"action","variable-update"),n=t.name,r=t.namespace,o=t.new_value,i=t.existing_value,s=(t.variable_removed,t.updated_src),c=t.type,l=a.props,u=l.onEdit,f=l.onDelete,p=l.onAdd,d={existing_src:a.state.src,new_value:o,updated_src:s,name:n,namespace:r,existing_value:i};switch(c){case "variable-added":e=p(d);break;case "variable-edited":e=u(d);break;case "variable-removed":e=f(d);} false!==e?(q.set(a.rjvId,"global","src",s),a.setState({src:s})):a.setState({validationFailure:true});},a.addKeyRequest=function(){a.setState({addKeyRequest:true});},a.resetState=function(){a.setState({validationFailure:false,addKeyRequest:false});},a.state={addKeyRequest:false,editKeyRequest:false,validationFailure:false,src:n.defaultProps.src,name:n.defaultProps.name,theme:n.defaultProps.theme,validationMessage:n.defaultProps.validationMessage,prevSrc:n.defaultProps.src,prevName:n.defaultProps.name,prevTheme:n.defaultProps.theme},a}return c(n,[{key:"componentDidMount",value:function(){q.set(this.rjvId,"global","src",this.state.src);var e=this.getListeners();for(var t in e)q.on(t+"-"+this.rjvId,e[t]);this.setState({addKeyRequest:false,editKeyRequest:false});}},{key:"componentDidUpdate",value:function(e,t){ false!==t.addKeyRequest&&this.setState({addKeyRequest:false}),false!==t.editKeyRequest&&this.setState({editKeyRequest:false}),e.src!==this.state.src&&q.set(this.rjvId,"global","src",this.state.src);}},{key:"componentWillUnmount",value:function(){var e=this.getListeners();for(var t in e)q.removeListener(t+"-"+this.rjvId,e[t]);}},{key:"render",value:function(){var e=this.state,t=e.validationFailure,n=e.validationMessage,a=e.addKeyRequest,r=e.theme,i=e.src,s=e.name,c=this.props,l=c.style,u=c.defaultValue;return m.a.createElement("div",{className:"react-json-view",style:o(o({},A(r,"app-container").style),l)},m.a.createElement(Le,{message:n,active:t,theme:r,rjvId:this.rjvId}),m.a.createElement(De,Object.assign({},this.props,{src:i,name:s,theme:r,type:_(i),rjvId:this.rjvId})),m.a.createElement(Re,{active:a,theme:r,rjvId:this.rjvId,defaultValue:u}))}}],[{key:"getDerivedStateFromProps",value:function(e,t){if(e.src!==t.prevSrc||e.name!==t.prevName||e.theme!==t.prevTheme){var a={src:e.src,name:e.name,theme:e.theme,validationMessage:e.validationMessage,prevSrc:e.src,prevName:e.name,prevTheme:e.theme};return n.validateState(a)}return null}}]),n}(m.a.PureComponent);Be.defaultProps={src:{},name:"root",theme:"rjv-default",collapsed:false,collapseStringsAfterLength:false,shouldCollapse:false,sortKeys:false,quotesOnKeys:true,groupArraysAfterLength:100,indentWidth:4,enableClipboard:true,displayObjectSize:true,displayDataTypes:true,onEdit:false,onDelete:false,onAdd:false,onSelect:false,iconStyle:"triangle",style:{},validationMessage:"Validation Error",defaultValue:null,displayArrayKey:true},Be.validateState=function(e){var t={};return "object"!==_(e.theme)||function(e){var t=["base00","base01","base02","base03","base04","base05","base06","base07","base08","base09","base0A","base0B","base0C","base0D","base0E","base0F"];if("object"===_(e)){for(var n=0;n<t.length;n++)if(!(t[n]in e))return  false;return  true}return  false}(e.theme)||(console.error("react-json-view error:","theme prop must be a theme name or valid base-16 theme object.",'defaulting to "rjv-default" theme'),t.theme="rjv-default"),"object"!==_(e.src)&&"array"!==_(e.src)&&(console.error("react-json-view error:","src property must be a valid json object"),t.name="ERROR",t.src={message:"src property must be a valid json object"}),o(o({},e),t)},j(Be);t.default=Be;}])})); 
  	} (main$1));
  	return main$1.exports;
  }

  var mainExports = requireMain();
  var ReactJson = /*@__PURE__*/getDefaultExportFromCjs(mainExports);

  var _excluded$d = ["step"];
  function ownKeys$x(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$x(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$x(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$x(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var INPUT_COL_DEFS = [{
    key: 'key',
    displayName: 'Key',
    isSortable: false,
    defaultSort: 'none'
  }, {
    key: 'value',
    displayName: 'Value',
    isSortable: false,
    defaultSort: 'none',
    transform: function transform(data) {
      var isJson = uiCommon.objectUtils.isStringifiedJSON(data.value);
      var content = data.value;
      if (isJson) {
        content = /*#__PURE__*/React.createElement(ReactJson, {
          name: false,
          src: uiCommon.objectUtils.getValueForString(data.value),
          displayObjectSize: false,
          collapsed: 1,
          displayDataTypes: false,
          enableClipboard: false,
          theme: 'rjv-default'
        });
      }
      return content;
    }
  }];
  var OUTPUT_COL_DEFS = [{
    key: 'mappedKey',
    displayName: 'Key',
    isSortable: false,
    defaultSort: 'none'
  }, {
    key: 'mappedValue',
    displayName: 'Value',
    isSortable: false,
    defaultSort: 'none',
    transform: function transform(data) {
      var isJson = uiCommon.objectUtils.isStringifiedJSON(data.mappedValue);
      var content = data.mappedValue;
      if (isJson) {
        content = /*#__PURE__*/React.createElement(ReactJson, {
          name: false,
          src: uiCommon.objectUtils.getValueForString(data.mappedValue),
          displayObjectSize: false,
          collapsed: 1,
          displayDataTypes: false,
          enableClipboard: false,
          theme: 'rjv-default'
        });
      }
      return content;
    }
  }];
  var groupInputs = function groupInputs(inputs) {
    return uiCommon.objectUtils.groupBy(inputs, 'source');
  };
  var displayMatchedRule = function displayMatchedRule(rule) {
    if (!rule) {
      return false;
    }
    return rule.decisionRuleConditions.map(function (condition) {
      return /*#__PURE__*/React.createElement("code", {
        className: "rule-condition",
        key: condition.conditionId
      }, condition.condition);
    });
  };
  var displayInputs = function displayInputs(inputs) {
    var groups = groupInputs(inputs);
    return Object.entries(groups).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        values = _ref2[1];
      var table = /*#__PURE__*/React.createElement(uiComponents.DataGrid, {
        idField: "key",
        columnDefs: INPUT_COL_DEFS,
        items: values,
        selectable: false
      });
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: "input-table"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "io-heading"
      }, key), " ", table);
    });
  };
  var displayOutputs = function displayOutputs(outputs, ruleMap) {
    var items = outputs.map(function (output) {
      return _objectSpread$x(_objectSpread$x({}, output), {}, {
        id: "".concat(output.mappedKey, "-").concat(output.matchedDecisionRuleId)
      });
    });
    var matchedDecisions = uiCommon.objectUtils.groupBy(items, 'matchedDecisionRuleId');
    return Object.entries(matchedDecisions).map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        values = _ref4[1];
      var table = /*#__PURE__*/React.createElement("div", {
        className: "output-table",
        key: key
      }, /*#__PURE__*/React.createElement(uiComponents.DataGrid, {
        idField: "id",
        items: values,
        columnDefs: OUTPUT_COL_DEFS,
        selectable: false
      }));
      var rule = ruleMap.get(key);
      var matchedRules = displayMatchedRule(rule);
      return /*#__PURE__*/React.createElement("div", {
        key: key,
        className: "output-table"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "io-heading"
      }, key), matchedRules, table);
    });
  };
  var buildDecisionRuleMap = function buildDecisionRuleMap(decisionDTO) {
    var map = new Map();
    var decisionRules = decisionDTO.decisionRules;
    decisionRules.forEach(function (rule) {
      map.set(rule.ruleId, rule);
    });
    return map;
  };
  var DMNTable = function DMNTable(props) {
    var step = props.step,
      spreadable = _objectWithoutProperties(props, _excluded$d);
    var decisions = step.decisions;
    var _useState = React.useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      openState = _useState2[0],
      setOpen = _useState2[1];
    var handleToggleClick = function handleToggleClick(ev) {
      var _ev$target$dataset$ke, _ev$target;
      console.log(ev);
      ev.stopPropagation();
      //@ts-ignore
      var key = (_ev$target$dataset$ke = (_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : _ev$target.dataset.key) !== null && _ev$target$dataset$ke !== void 0 ? _ev$target$dataset$ke : '';
      var newOpenState = _objectSpread$x({}, openState);
      newOpenState[key] = !openState[key];
      setOpen(newOpenState);
    };
    var items = decisions.map(function (decision) {
      // the decision key is not a unique enough id
      // we need to include executionTime as well.
      var key = "".concat(decision.decisionDefinitionDto.decisionKey, "-").concat(decision.executionTime);
      var ruleMap = buildDecisionRuleMap(decision.decisionDefinitionDto);
      var hasState = {
        inputs: decision.decisionInputs.length > 0,
        outputs: decision.decisionOutputs.length > 0
      };
      var outputKey = "".concat(key, "-output");
      var inputsKey = "".concat(key, "-inputs");
      var classes = classnames({
        'has-io': hasState.inputs || hasState.outputs,
        'has-inputs': hasState.inputs,
        'has-outputs': hasState.outputs,
        'inputs-open': openState[inputsKey],
        'outputs-open': openState[outputKey]
      });
      var inputs = displayInputs(decision.decisionInputs);
      var outputs = displayOutputs(decision.decisionOutputs, ruleMap);
      return /*#__PURE__*/React.createElement("li", {
        key: decision.decisionDefinitionDto.decisionKey,
        className: classes
      }, decision.decisionDefinitionDto.decisionName, " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
        className: "io-toggles"
      }, "show:", /*#__PURE__*/React.createElement("label", {
        className: "io-label outputs-label",
        htmlFor: outputKey,
        onClick: handleToggleClick
      }, /*#__PURE__*/React.createElement("input", {
        id: outputKey,
        "data-key": outputKey,
        type: "checkbox"
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "inner-label"
      }, "outputs")), /*#__PURE__*/React.createElement("label", {
        className: "io-label inputs-label",
        htmlFor: inputsKey,
        onClick: handleToggleClick
      }, /*#__PURE__*/React.createElement("input", {
        id: inputsKey,
        "data-key": inputsKey,
        type: "checkbox"
      }), ' ', /*#__PURE__*/React.createElement("span", {
        className: "inner-label"
      }, "inputs"))), /*#__PURE__*/React.createElement("div", {
        className: "outputs-content"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "data-type"
      }, "Outputs"), /*#__PURE__*/React.createElement("ul", null, outputs)), /*#__PURE__*/React.createElement("div", {
        className: "inputs-content"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "data-type"
      }, "Inputs"), /*#__PURE__*/React.createElement("ul", null, inputs)));
    });
    var classes = classnames('dmn-table', {
      'no-items': items.length === 0
    });
    return /*#__PURE__*/React.createElement("div", _extends$1({}, spreadable, {
      className: classnames(classes)
    }), /*#__PURE__*/React.createElement("ul", null, items));
  };
  DMNTable.displayName = 'DMNTable';

  function ownKeys$w(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$w(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$w(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$w(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$r(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$r() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$r() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$r = function _isNativeReflectConstruct() { return !!t; })(); }
  var TimelineStatus = uiCommon.commonEnums.TimelineStatus;
  var noOp = function noOp() {};
  var getStatusIcon = function getStatusIcon(status) {
    if (status === TimelineStatus.STARTED) {
      return /*#__PURE__*/React.createElement(r, {
        iconName: e.Location,
        iconSize: "16",
        titleText: "Started Process"
      });
    } else if (status === TimelineStatus.COMPLETE) {
      return /*#__PURE__*/React.createElement(r, {
        iconName: e.Check_Circle,
        iconSize: "16",
        titleText: "Process Complete"
      });
    } else if (status === TimelineStatus.IN_PROGRESS) {
      return /*#__PURE__*/React.createElement(r, {
        iconName: e.Pending,
        iconSize: "16",
        titleText: "In Progress"
      });
    }
  };
  var idForEvent = function idForEvent(ev) {
    var _ev$target$dataset$id, _ev$target;
    //@ts-ignore
    return (_ev$target$dataset$id = (_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : _ev$target.dataset.id) !== null && _ev$target$dataset$id !== void 0 ? _ev$target$dataset$id : null;
  };
  var ProcessTimeline = /*#__PURE__*/function (_React$Component) {
    function ProcessTimeline(props) {
      var _this;
      _classCallCheck(this, ProcessTimeline);
      _this = _callSuper$r(this, ProcessTimeline, [props]);
      _defineProperty(_this, "accordionRef", void 0);
      _defineProperty(_this, "containerRef", void 0);
      _this.accordionRef = /*#__PURE__*/React.createRef();
      _this.containerRef = /*#__PURE__*/React.createRef();
      _this.handleClick = _this.handleClick.bind(_this);
      _this.state = {};
      return _this;
    }
    _inherits(ProcessTimeline, _React$Component);
    return _createClass(ProcessTimeline, [{
      key: "handleClick",
      value: function handleClick(ev) {
        ev.preventDefault();
        var itemId = idForEvent(ev);
        var accordionRef = this.accordionRef;
        if (itemId !== null && accordionRef.current !== null) {
          var _document$getElementB;
          document.querySelectorAll('.accordion-section.highlight').forEach(function (el) {
            el.classList.remove('highlight');
          });
          var el = (_document$getElementB = document.getElementById("stage-".concat(itemId))) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.closest('.accordion-section');
          if (el) {
            el.classList.add('highlight');
            this.props.clickObserver(itemId);
            setTimeout(function () {
              el.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
              });
            }, 100);
          }
        }
      }
    }, {
      key: "handleDoubleClick",
      value: function handleDoubleClick(ev) {
        var itemId = idForEvent(ev);
        var accordionRef = this.accordionRef;
        if (itemId !== null && accordionRef.current !== null) {
          var _accordionRef$current;
          (_accordionRef$current = accordionRef.current) === null || _accordionRef$current === void 0 || _accordionRef$current.toggle(itemId);
          if (!this.state[itemId]) {
            this.handleClick(ev);
          }
          var s = _objectSpread$w({}, this.state);
          s[itemId] = !s[itemId];
          this.setState(s);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _props$stifleSelectio;
        var props = _objectSpread$w({}, this.props);
        var stages = props.stages;
        var unselectableAccordion = (_props$stifleSelectio = props.stifleSelection) !== null && _props$stifleSelectio !== void 0 ? _props$stifleSelectio : false;
        var lastUpdatedDate = '';
        var lst = stages.map(function (stage, idx) {
          var _stage$steps, _stage$status, _stage$parent;
          var updateDate = stage.displayDate && typeof stage.displayDate === 'string' ? uiCommon.cmxDateTime.format(stage.displayDate, uiCommon.cmxDateTime.FORMATS.DATE) : 'N/A';
          var displayDate;
          if (idx === 0) {
            displayDate = updateDate;
          } else {
            displayDate = updateDate === lastUpdatedDate ? '' : updateDate;
          }
          lastUpdatedDate = updateDate;
          var timeFormat = idx === 0 ? uiCommon.cmxDateTime.FORMATS.TIME_WITH_ZONE : uiCommon.cmxDateTime.FORMATS.TIME;
          var updateTime = stage.displayDate && typeof stage.displayDate === 'string' ? uiCommon.cmxDateTime.format(stage.displayDate, timeFormat) : 'N/A';
          var peeked = (_stage$steps = stage.steps[stage.steps.length - 1]) !== null && _stage$steps !== void 0 ? _stage$steps : false;
          var statusClass = "status-".concat((_stage$status = stage.status) === null || _stage$status === void 0 ? void 0 : _stage$status.toLowerCase());
          var depthClass = "depth-".concat(stage.depth);
          var header = /*#__PURE__*/React.createElement("div", {
            id: "stage-".concat(stage.key),
            key: stage.key,
            className: "timeline-item ".concat(statusClass, " ").concat(depthClass)
          }, /*#__PURE__*/React.createElement("div", {
            className: "timeline-meta-col"
          }, /*#__PURE__*/React.createElement("div", {
            className: "timeline-status ".concat(statusClass)
          }, getStatusIcon("".concat(stage.status))), /*#__PURE__*/React.createElement("div", {
            className: "timeline-datetime"
          }, /*#__PURE__*/React.createElement("span", {
            className: "display-datetime"
          }, /*#__PURE__*/React.createElement("span", {
            className: "display-date"
          }, displayDate), /*#__PURE__*/React.createElement("span", {
            className: "display-time"
          }, updateTime)))), /*#__PURE__*/React.createElement("div", {
            className: "timeline-title timeline-description-col"
          }, /*#__PURE__*/React.createElement("span", {
            className: "stage-title"
          }, stage.title), /*#__PURE__*/React.createElement("span", {
            className: "stage-last-step"
          }, peeked && peeked.activity.activityDefinition.name), ' ', /*#__PURE__*/React.createElement("span", {
            className: "stage-parent"
          }, "Started by: ", (_stage$parent = stage.parent) === null || _stage$parent === void 0 ? void 0 : _stage$parent.title), /*#__PURE__*/React.createElement("span", {
            className: "debug-information"
          }, stage.key)));
          var steps = _toConsumableArray(stage.steps).reverse();
          var stepItems = steps.map(function (step) {
            var _step$activity$activi, _step$activity, _activityDefinition$n;
            var eventType = (_step$activity$activi = (_step$activity = step.activity) === null || _step$activity === void 0 || (_step$activity = _step$activity.activityDefinition) === null || _step$activity === void 0 ? void 0 : _step$activity.type) !== null && _step$activity$activi !== void 0 ? _step$activity$activi : 'DNE';
            if (eventType === 'startEvent' || eventType === 'conditionalStartEvent') {
              return false;
            }
            var activity = step.activity;
            var activityDefinition = activity.activityDefinition;
            var startDate = activity.createdDate;
            var updateDate = activity.lastEndTimestamp || activity.lastStartTimestamp;
            var updateDateMoment = startDate ? uiCommon.cmxDateTime.format(startDate, uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE) : 'N/A';

            // calculate total duration
            var duration = uiCommon.cmxDateTime.calculateDuration(startDate, updateDate);
            var seconds = duration.asSeconds() % 60;
            var durationInSeconds = Math.max(seconds, 0);
            var formattedNumber = parseFloat("".concat(durationInSeconds)).toFixed(2);
            var name = (_activityDefinition$n = activityDefinition === null || activityDefinition === void 0 ? void 0 : activityDefinition.name) !== null && _activityDefinition$n !== void 0 ? _activityDefinition$n : activityDefinition.activityId;
            var callsSub = activityDefinition.type === 'callActivity'; // && stepSet.has(activityDefinition.subprocessName as string);

            var displayName = callsSub ? /*#__PURE__*/React.createElement("a", {
              href: "#/",
              "data-id": activityDefinition.subprocessName
            }, /*#__PURE__*/React.createElement("span", {
              className: "step-name"
            }, name), "\u21E1", '  ', /*#__PURE__*/React.createElement("span", {
              className: "debug-information"
            }, activityDefinition.subprocessName)) : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
              className: "step-name"
            }, name), ' ', /*#__PURE__*/React.createElement("span", {
              className: "debug-information"
            }, activityDefinition.activityId));
            var hasRules = step.decisions.length > 0;
            var classes = classnames('timeline-step', {
              'has-rules': hasRules
            });
            return /*#__PURE__*/React.createElement("li", {
              key: activityDefinition.activityId,
              className: classes
            }, displayName, ' ', /*#__PURE__*/React.createElement("div", {
              className: "rules"
            }, /*#__PURE__*/React.createElement(DMNTable, {
              step: step
            })), /*#__PURE__*/React.createElement("span", {
              className: "duration-readout"
            }, formattedNumber, " seconds - ", updateDateMoment));
          });
          var body = /*#__PURE__*/React.createElement("div", {
            className: "timeline-body-item  timeline-description-col"
          }, /*#__PURE__*/React.createElement("div", {
            className: "timeline-meta-col"
          }), /*#__PURE__*/React.createElement("div", {
            className: "timeline-title timeline-ordered-list"
          }, /*#__PURE__*/React.createElement("ol", {
            reversed: true
          }, stepItems)));
          return {
            id: stage.key,
            data: stage,
            header: header,
            body: body
          };
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "process-timeline",
          ref: this.containerRef,
          id: "processTimeline",
          "data-testid": "process-timeline",
          onDoubleClick: this.handleDoubleClick,
          onClick: this.handleClick
        }, /*#__PURE__*/React.createElement(uiComponents.Accordion, {
          ref: this.accordionRef,
          selectable: !unselectableAccordion,
          items: lst
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(ProcessTimeline, "displayName", 'ProcessTimeline');
  _defineProperty(ProcessTimeline, "defaultProps", {
    stifleSelection: false,
    clickObserver: noOp,
    doubleClick: noOp
  });

  var theme = extendTheme(uiCommon.theme, theme$1, {
    useSystemColorMode: false,
    components: {
      Alert: {
        baseStyle: {
          container: {
            display: 'block !important',
            p: 0,
            m: 0,
            bg: 'transparent',
            border: 'none',
            borderRadius: 0,
            fontFamily: 'inherit',
            flexDirection: 'initial',
            alignItems: 'initial',
            justifyContent: 'initial',
            flexWrap: 'initial',
            gap: 0
          },
          title: {
            display: 'block !important',
            fontWeight: 'normal',
            fontSize: '14px',
            lineHeight: '1.2',
            mb: 1,
            p: 0,
            color: 'inherit',
            width: '100%'
          },
          description: {
            display: 'block !important',
            fontSize: '12px',
            lineHeight: '1.2',
            p: 0,
            m: 0,
            color: 'inherit',
            opacity: 0.85,
            width: '100%'
          },
          icon: {
            display: 'none'
          }
        },
        variants: {
          transparent: {
            container: {
              bg: 'transparent',
              border: 'none',
              p: 0,
              m: 0
            }
          }
        },
        defaultProps: {
          variant: 'transparent'
        }
      },
      CloseButton: {
        baseStyle: {
          _focus: {
            boxShadow: '0 0 0 3px rgba(66, 153, 225, 0.6)'
          }
        }
      }
    },
    styles: {
      global: {
        '.chakra-alert': {
          display: 'block !important',
          flexDirection: 'initial !important',
          alignItems: 'initial !important',
          justifyContent: 'initial !important',
          flexWrap: 'initial !important',
          gap: '0 !important'
        },
        '.chakra-alert__title': {
          display: 'block !important',
          float: 'none !important',
          clear: 'both !important'
        },
        '.chakra-alert__desc': {
          display: 'block !important',
          float: 'none !important',
          clear: 'both !important'
        },
        '.highlight-drawer .chakra-alert': {
          marginBottom: '8px !important'
        },
        '.highlight-drawer .chakra-alert__title': {
          fontSize: '14px !important',
          fontWeight: 'normal !important',
          marginBottom: '4px !important',
          color: 'inherit !important'
        },
        '.highlight-drawer .chakra-alert__desc': {
          fontSize: '12px !important',
          opacity: '0.85 !important',
          color: 'inherit !important'
        }
      }
    }
  });

  // most of these don't mean anything nowadays.
  // browsers stopped supporting them a while ago
  // really, the height and width are the meaningful ones.
  var popupWindowFeatures = ["menubar=yes", "resizable=yes", "scrollbars=yes", "status=yes", "height=".concat(window.screen.height - 200), "width=600"].join(',');
  var caseDocsWindowFeatures = ["menubar=yes", "resizable=yes", "scrollbars=yes", "status=yes", "height=".concat(window.screen.height - 200), "width=1024"].join(',');
  var caseDetailPopup = {
    url: "/json-view/",
    windowFeatures: popupWindowFeatures,
    windowTitle: 'json-viewer'
  };
  var bpmStepsPopup = {
    url: "/bpm-steps/",
    windowFeatures: popupWindowFeatures,
    windowTitle: 'bpm-steps'
  };
  var caseDocumentsPopup = {
    url: "/case-documents/",
    windowFeatures: caseDocsWindowFeatures,
    windowTitle: 'case-documents'
  };
  var launchAmplifyPopup = {
    url: "/accelerate/",
    windowFeatures: '',
    windowTitle: 'amplify'
  };
  var launchAmplifyCase = {
    url: "/cmx/worklist/",
    windowFeatures: '',
    windowTitle: 'amplify'
  };

  var NA = 'N/A';
  var propAccessor2 = function propAccessor2(detail, propertyActivations) {
    return function (propPath) {
      var altValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NA;
      var prop = uiCommon.objectUtils.get(detail, propPath, altValue);
      var activations = uiCommon.objectUtils.get(propertyActivations, propPath, []);
      var visible = activations.some(function (activation) {
        return activation.selectionState.visible;
      });
      if (!visible) {
        return prop !== null ? prop : altValue;
      }
      var highlighted = prop;
      activations.forEach(function (activation) {
        var active = activation.selectionState.active;
        var styleClasses = ["evidence", 'highlighted-text', {
          'evidence-categorical': true,
          'qa-evidence-categorical': true,
          'evidence-active': active,
          'qa-evidence-active': active
        }, "evidence-".concat(activation.meta.codeType), "evidence-".concat(activation.meta.provenance)];
        highlighted = /*#__PURE__*/React.createElement("span", {
          className: classnames(styleClasses)
        }, highlighted);
      });
      return highlighted;
    };
  };

  var AlertIcon = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='15' fill='none' viewBox='0 0 17 15'%3E%3Cmask id='prefix__a' fill='%23fff'%3E%3Cpath fill-rule='evenodd' d='M6.605 1.008c.776-1.344 2.717-1.344 3.493 0l6.331 10.967c.777 1.344-.194 3.025-1.746 3.025H2.02C.467 15-.503 13.32.273 11.975L6.605 1.008zm.486 4.286c0-.696.564-1.26 1.26-1.26.696 0 1.26.564 1.26 1.26V8.32c0 .696-.564 1.26-1.26 1.26-.696 0-1.26-.564-1.26-1.26V5.294zm1.26 7.311c.696 0 1.26-.564 1.26-1.26 0-.697-.564-1.261-1.26-1.261-.696 0-1.26.564-1.26 1.26 0 .697.564 1.261 1.26 1.261z' clip-rule='evenodd'/%3E%3C/mask%3E%3Cpath fill='%23BC5662' fill-rule='evenodd' d='M6.605 1.008c.776-1.344 2.717-1.344 3.493 0l6.331 10.967c.777 1.344-.194 3.025-1.746 3.025H2.02C.467 15-.503 13.32.273 11.975L6.605 1.008zm.486 4.286c0-.696.564-1.26 1.26-1.26.696 0 1.26.564 1.26 1.26V8.32c0 .696-.564 1.26-1.26 1.26-.696 0-1.26-.564-1.26-1.26V5.294zm1.26 7.311c.696 0 1.26-.564 1.26-1.26 0-.697-.564-1.261-1.26-1.261-.696 0-1.26.564-1.26 1.26 0 .697.564 1.261 1.26 1.261z' clip-rule='evenodd'/%3E%3Cpath fill='%23BC5662' d='M10.098 1.008l-.873.505.873-.505zm-3.493 0l.873.505-.873-.505zm9.824 10.967l.874-.504-.874.504zm-16.156 0l.874.504-.874-.504zM10.971.505c-1.164-2.018-4.075-2.018-5.24 0l1.747 1.008c.388-.673 1.358-.673 1.747 0L10.97.504zm6.332 10.966L10.97.504 9.225 1.513l6.331 10.966 1.747-1.008zm-2.62 4.537c2.329 0 3.784-2.52 2.62-4.537l-1.747 1.008c.388.672-.097 1.513-.873 1.513v2.016zm-12.663 0h12.663v-2.016H2.02v2.016zM-.6 11.471c-1.164 2.016.291 4.537 2.62 4.537v-2.016c-.776 0-1.262-.84-.873-1.513L-.6 11.471zM5.73.504L-.6 11.471l1.747 1.008L7.478 1.513 5.731.504zm2.62 2.521c-1.253 0-2.269 1.016-2.269 2.27H8.1c0-.14.113-.253.252-.253V3.025zm2.27 2.27c0-1.254-1.017-2.27-2.27-2.27v2.017c.14 0 .252.113.252.252h2.017zm0 3.024V5.294H8.602V8.32h2.017zm-2.27 2.27c1.253 0 2.27-1.017 2.27-2.27H8.602c0 .14-.113.252-.252.252v2.017zm-2.269-2.27c0 1.253 1.016 2.27 2.27 2.27V8.57c-.14 0-.253-.112-.253-.252H6.082zm0-3.025V8.32H8.1V5.294H6.082zm2.521 6.05c0 .14-.113.253-.252.253v2.016c1.253 0 2.27-1.015 2.27-2.268H8.602zm-.252-.252c.14 0 .252.113.252.252h2.017c0-1.252-1.016-2.268-2.269-2.268v2.016zm-.252.252c0-.139.113-.252.252-.252V9.076c-1.253 0-2.269 1.015-2.269 2.268H8.1zm.252.253c-.139 0-.252-.113-.252-.252H6.082c0 1.253 1.016 2.268 2.27 2.268v-2.016z' mask='url(%23prefix__a)'/%3E%3C/svg%3E";

  var DashboardActionBar = function DashboardActionBar(props) {
    var _actionsState$launchA, _actionsState$importA;
    var actionsState = props.actionsState,
      handleBackClick = props.handleBackClick,
      handleProcessIdChange = props.handleProcessIdChange,
      handleOpenJson = props.handleOpenJson,
      caseRuns = props.caseRuns,
      caseRun = props.caseRun;
    var showAmp = ((_actionsState$launchA = actionsState.launchAmplify) === null || _actionsState$launchA === void 0 ? void 0 : _actionsState$launchA.visible) || ((_actionsState$importA = actionsState.importAmplify) === null || _actionsState$importA === void 0 ? void 0 : _actionsState$importA.visible);
    return /*#__PURE__*/React.createElement(ChakraProvider, {
      theme: theme
    }, /*#__PURE__*/React.createElement("div", {
      className: "action-bar case-list"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nav-bar-columns"
    }, /*#__PURE__*/React.createElement("div", {
      className: "nav-bar-column nav-bar-left-column"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      size: "sm",
      onClick: handleBackClick,
      className: "qa-back-link",
      leftIcon: /*#__PURE__*/React.createElement(r, {
        iconName: e.Arrow_Left
      })
    }, "Back to Cases")), /*#__PURE__*/React.createElement("div", {
      className: "pro-serve-links nav-bar-middle-column no-loading"
    }, showAmp && /*#__PURE__*/React.createElement(ButtonGroup, {
      size: "sm",
      variant: "secondary",
      isAttached: true
    }, /*#__PURE__*/React.createElement(ButtonIcon, {
      isAttached: true,
      actionsState: actionsState.importAmplify,
      "data-href": "/import-amplify/",
      "data-target": "_blank",
      onClick: handleOpenJson,
      iconName: e.Export,
      label: "Export Case to Amplify",
      className: "upload-icon"
    }), /*#__PURE__*/React.createElement(ButtonIcon, {
      actionsState: actionsState.launchAmplify,
      "data-href": "/launch-amplify/",
      "data-target": "_blank",
      onClick: handleOpenJson,
      iconName: e.Launch,
      label: "Launch Amplify",
      className: "rocket-icon"
    })), /*#__PURE__*/React.createElement(ButtonGroup, {
      size: "sm",
      variant: "secondary",
      isAttached: true
    }, /*#__PURE__*/React.createElement(ButtonIcon, {
      isAttached: true,
      actionsState: actionsState.bpmSteps,
      "data-href": "/bpm-steps/",
      "data-target": "_blank",
      onClick: handleOpenJson,
      iconName: e.Footprints,
      label: "BPM Process",
      className: "shoe-prints-icon"
    }), /*#__PURE__*/React.createElement(ButtonIcon, {
      isAttached: true,
      actionsState: actionsState.jsonView,
      "data-href": "/json-view/",
      "data-target": "_blank",
      label: "Case JSON",
      iconName: e.Source,
      onClick: handleOpenJson,
      className: "code-icon"
    }), /*#__PURE__*/React.createElement(ButtonIcon, {
      actionsState: actionsState.caseDocuments,
      "data-href": "/case-documents/",
      "data-target": "_blank",
      label: "Documents",
      iconName: e.Notes_Stacked,
      onClick: handleOpenJson,
      className: "file-medical-icon"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "nav-bar-column nav-bar-right-column"
    }, /*#__PURE__*/React.createElement("div", {
      className: "no-loading"
    }, /*#__PURE__*/React.createElement("span", {
      className: "report-controls control-section"
    }, /*#__PURE__*/React.createElement("span", {
      className: "report-label"
    }, "Documentation ")), /*#__PURE__*/React.createElement("div", {
      className: "buttons btn-group"
    }, /*#__PURE__*/React.createElement(ProcessSelection, {
      caseRuns: caseRuns,
      activeId: caseRun.process_instance_id,
      onClick: handleProcessIdChange
    })))))));
  };
  DashboardActionBar.displayName = 'DashboardActionBar';

  var _excluded$c = ["svgIconName", "svgIconClass", "svgTitleText", "className", "header"];
  var IconHeader = function IconHeader(props) {
    var svgIconName = props.svgIconName,
      svgIconClass = props.svgIconClass,
      svgTitleText = props.svgTitleText,
      className = props.className,
      header = props.header,
      spreadable = _objectWithoutProperties(props, _excluded$c);
    var classes = classnames('icon-divider-title', className);
    return (
      /*#__PURE__*/
      //@ts-ignore
      React.createElement("div", _extends$1({}, spreadable, {
        className: "icon-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement(r, {
        iconName: svgIconName,
        iconSize: "20",
        iconClass: svgIconClass,
        titleText: svgTitleText
      }), /*#__PURE__*/React.createElement("h5", null, header)), /*#__PURE__*/React.createElement("div", {
        className: "divider"
      }))
    );
  };
  IconHeader.displayName = 'IconHeader';

  var onlyUnique = function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  };
  /**
   * DataTransformers take two objects.  A property accessor and the raw case run.
   * The raw case run is a fall back mechanism for array access which doesn't
   * currently have a method of highlighting.
   * @param propAccessor
   * @param rawCaseRun
   * @returns
   */
  var DataTransformers = function DataTransformers(propAccessor, rawCaseRun, activeContext) {
    return {
      friendly_date: function friendly_date(key) {
        var date_of_birth = rawCaseRun.date_of_birth;
        return date_of_birth && date_of_birth !== 'N/A' ? uiCommon.cmxDateTime.format(date_of_birth, uiCommon.cmxDateTime.FORMATS.BIRTH_DATE) : 'N/A';
      },
      dob_age_by_dos: function dob_age_by_dos(key) {
        var date_of_birth = rawCaseRun.date_of_birth,
          date_of_service = rawCaseRun.date_of_service;
        if (!date_of_birth || !date_of_service || date_of_birth === "N/A") {
          return /*#__PURE__*/React.createElement(Text, null, "N/A");
        }
        var duration = uiCommon.cmxDateTime.calculateDurationDateFns(date_of_birth, date_of_service);

        // Handle invalid or future DOB vs DOS
        if (!duration || new Date(date_of_birth) > new Date(date_of_service)) {
          return /*#__PURE__*/React.createElement(Text, null, "N/A");
        }
        var formattedDOB = uiCommon.cmxDateTime.format(date_of_birth, uiCommon.cmxDateTime.FORMATS.BIRTH_DATE);
        var ageDisplay = "";
        if (duration.years && duration.years > 0) {
          ageDisplay = "".concat(duration.years, "y");
        } else {
          ageDisplay = "".concat(duration.months || 0, "m ").concat(duration.days || 0, "d");
        }
        return /*#__PURE__*/React.createElement(Text, null, formattedDOB, " ", /*#__PURE__*/React.createElement(Tooltip, {
          label: "at date of service",
          placement: "top",
          hasArrow: true
        }, /*#__PURE__*/React.createElement(Text, {
          as: "span",
          cursor: "help",
          color: "gray.700"
        }, "(", ageDisplay, ")")));
      },
      date_of_service: function date_of_service(key) {
        var date = propAccessor(key);
        return date && typeof date === 'string' && date !== 'N/A' ? uiCommon.cmxDateTime.format(uiCommon.cmxDateTime.setTimeZoneForDate(rawCaseRun === null || rawCaseRun === void 0 ? void 0 : rawCaseRun.tenant_timezone, date), uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE) : 'N/A';
      },
      visit_number: function visit_number(key) {
        return propAccessor("".concat(key, ".number"));
      },
      primary_clinical_identifier: function primary_clinical_identifier(key) {
        return propAccessor("".concat(key, ".number"));
      },
      mrn: function mrn(key) {
        var numberProp = "".concat(key, ".number");
        var sourceProp = "".concat(key, ".issuer");
        return "".concat(propAccessor(numberProp), " (src: ").concat(propAccessor(sourceProp), ")");
      },
      numerical: function numerical(key) {
        return propAccessor("".concat(key, ".number"));
      },
      multi_place_of_service: function multi_place_of_service(key) {
        // to be unignored when caserun2 is implemented in omnibus.
        //@ts-ignore
        var invoices = (rawCaseRun === null || rawCaseRun === void 0 ? void 0 : rawCaseRun.invoices) || [];
        var place_of_service = invoices.map(function (invoice) {
          return invoice.place_of_service;
        });
        var uniq_pos = place_of_service.filter(function (pos) {
          return pos;
        }).filter(onlyUnique);
        return uniq_pos.length ? uniq_pos.join(', ') : rawCaseRun.place_of_service || 'N/A';
      },
      specimen_sources: function specimen_sources(key) {
        // @ts-ignore
        var specimen_sources = rawCaseRun.specimen_sources;
        if (!Array.isArray(specimen_sources)) {
          return specimen_sources;
        } else {
          var _specimen_sources = specimen_sources,
            _specimen_sources2 = _slicedToArray(_specimen_sources, 1),
            first = _specimen_sources2[0];
          if (first === undefined) {
            return 'N/A';
          }
          return first;
        }
      },
      identifier: function identifier(key) {
        var numberProp = "".concat(key, ".number");
        var sourceProp = "".concat(key, ".issuer");
        return "".concat(propAccessor(numberProp), " (src: ").concat(propAccessor(sourceProp), ")");
      },
      primary_provider: function primary_provider(property) {
        // Property is the role name
        var providers = propAccessor('providers');
        if (!Array.isArray(providers) || providers.length === 0 || !providers) {
          // Fall back to billing provider name if no providers array
          return propAccessor('billing_provider_name') || 'N/A';
        }
        var providersByRole = providers.filter(function (provider) {
          return provider.provider_role === property;
        });
        var providerNames = providersByRole.map(function (provider) {
          return provider.provider_name;
        });
        if (!providerNames.length) {
          // Fall back to billing provider name if no primary provider found
          return propAccessor('billing_provider_name') || 'N/A';
        }
        return providerNames.join(' | ');
      },
      providers_by_role: function providers_by_role(property) {
        // Property can be a role name or an array of role names as a string
        var providers = propAccessor('providers');
        if (!Array.isArray(providers) || providers.length === 0) {
          return 'N/A';
        }
        var roles = [];

        // Check if property is an array string like "['First Assistant', 'Physician Assistant']"
        if (property.startsWith('[') && property.endsWith(']')) {
          try {
            roles = JSON.parse(property.replace(/'/g, '"'));
          } catch (e) {
            roles = [property];
          }
        } else {
          roles = [property];
        }
        var providersByRole = providers.filter(function (provider) {
          return roles.includes(provider.provider_role);
        });
        var providerNames = providersByRole.map(function (provider) {
          return provider.provider_name;
        });
        if (!providerNames.length) {
          return 'N/A';
        }
        return providerNames.join(' | ');
      },
      service_line: function service_line(key) {
        var serviceLine = propAccessor(key);
        var mappedServiceLine = uiCommon.appServiceLines.isIPC(serviceLine) ? uiCommon.commonEnums.ServiceLines.BEDSIDE_PRO : serviceLine;
        if (activeContext) {
          var serviceLines = activeContext.serviceLines;
          var currentServiceLine = serviceLines.find(function (sl) {
            return sl.name === mappedServiceLine;
          });
          if (currentServiceLine) {
            return currentServiceLine.displayName || currentServiceLine.name;
          }
        }
        return uiCommon.appServiceLines.isIPC(serviceLine) ? uiCommon.commonEnums.ServiceLines.BEDSIDE_PRO : serviceLine;
      },
      age: function age(key) {
        var date_of_birth = rawCaseRun.date_of_birth;
        if (!date_of_birth || date_of_birth === 'N/A') {
          return 'N/A';
        }
        var birthDate = new Date(date_of_birth);
        var currentDate = new Date();
        var age = currentDate.getFullYear() - birthDate.getFullYear();
        var m = currentDate.getMonth() - birthDate.getMonth();
        if (m < 0 || m === 0 && currentDate.getDate() < birthDate.getDate()) {
          age--;
        }
        return age.toString();
      },
      patient_age_by_dos_dob: function patient_age_by_dos_dob(key) {
        var patientAge = rawCaseRun.patient_age;
        if (!patientAge) {
          var dob = rawCaseRun.date_of_birth;
          var dos = rawCaseRun.date_of_service;
          if (dob && dos) {
            var dobDate = new Date(dob);
            var dosDate = new Date(dos);
            var age = dosDate.getFullYear() - dobDate.getFullYear();
            var m = dosDate.getMonth() - dobDate.getMonth();
            if (m < 0 || m === 0 && dosDate.getDate() < dobDate.getDate()) {
              return age - 1;
            } else {
              return age;
            }
          }
        }
      },
      age_on_date_of_service: function age_on_date_of_service(key) {
        var date_of_birth = rawCaseRun.date_of_birth;
        var date_of_service = rawCaseRun.date_of_service;
        var duration = uiCommon.cmxDateTime.calculateDurationDateFns(date_of_birth, date_of_service);

        // conditional for bad data: negative time values occur when DOB is after DOS
        if (!duration || new Date(date_of_birth) > new Date(date_of_service)) {
          return 'N/A';
        }
        if (duration.years && duration.years > 0) {
          return "".concat(duration.years);
        }
        return "".concat(duration.months || 0, " months, ").concat(duration.days || 0, " days");
      }
    };
  };

  function _callSuper$q(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$q() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$q() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$q = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$v(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$v(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$v(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$v(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var getCoderNotesLookupParams$1 = uiCommon.AmplifyCore.coderNotesUtils.getCoderNotesLookupParams;
  var DataStyles$1 = {
    s: 'col-3 col-lg-4 col-md-4',
    ms: 'col-4 col-md-6',
    m: 'col-8',
    l: 'col-12'
  };
  function CellMaker$1(propAccessor, rawCaseRun, fieldEditorInfo, capability, showProviderInfo) {
    var dataTransformer = DataTransformers(propAccessor, rawCaseRun);
    return function (def) {
      var _def$additionalInfo;
      var cellClassName = DataStyles$1[def.dataSize];
      var value = def.transformer ? dataTransformer[def.transformer](def.property) : propAccessor(def.property, 'N/A');
      var additionalInfo = def === null || def === void 0 || (_def$additionalInfo = def.additionalInfo) === null || _def$additionalInfo === void 0 ? void 0 : _def$additionalInfo.reduce(function (acc, info) {
        var key = info === null || info === void 0 ? void 0 : info.label;
        var value = info.transformer ? dataTransformer[info.transformer](info.property) : propAccessor(info.property, 'N/A');

        // Ensure both key and value are strings
        acc[key] = value === null || value === void 0 ? void 0 : value.toString();
        return acc;
      }, {}); // Initialize an empty object with string key-value types

      var _handleUpdate = function _handleUpdate(updates) {
        var caserun_uid = rawCaseRun.caserun_uid,
          service_line = rawCaseRun.service_line;
        var _fieldEditorInfo$case = fieldEditorInfo.caseEdits[def.key],
          initialVal = _fieldEditorInfo$case.initialVal,
          mappedValues = _fieldEditorInfo$case.mappedValues;
        if (updates.hasOwnProperty('patient_type')) {
          var _fieldEditorInfo$case2, _mappedValues$find;
          var patientTypeValue = updates['patient_type'];
          var _mappedValues = ((_fieldEditorInfo$case2 = fieldEditorInfo.caseEdits['patient_class']) === null || _fieldEditorInfo$case2 === void 0 ? void 0 : _fieldEditorInfo$case2.mappedValues) || [];
          var _value = (_mappedValues$find = _mappedValues.find(function (item) {
            return item.label === patientTypeValue;
          })) === null || _mappedValues$find === void 0 ? void 0 : _mappedValues$find.value;
          if (_value !== undefined) {
            rawCaseRun['patient_class'] = _value;
            updates['patient_class'] = _value;
          }
        }
        fieldEditorInfo.updateCase({
          caseRunUid: caserun_uid,
          serviceLine: service_line == 'Inpatient Professional Coding' ? 'ipc' : service_line,
          caseUpdates: updates,
          initialVal: initialVal,
          mappedValues: mappedValues
        });
      };
      return /*#__PURE__*/React.createElement(InfoCell$1, {
        key: "".concat(def.key),
        className: cellClassName,
        cellKey: def.key,
        label: def.label,
        value: value,
        fieldType: def.fieldType,
        fieldEditorInfo: _objectSpread$v(_objectSpread$v({}, fieldEditorInfo), {}, {
          updateCase: function updateCase(updates) {
            return _handleUpdate(updates);
          }
        }),
        capability: capability,
        showProviderInfo: showProviderInfo,
        hasLink: def !== null && def !== void 0 && def.additionalInfo ? def === null || def === void 0 ? void 0 : def.hasLink : false,
        additionalInfo: additionalInfo
      });
    };
  }
  var CellPatientMaker$1 = function CellPatientMaker(propAccessor, rawCaseRun) {
    var dataTransformer = DataTransformers(propAccessor, rawCaseRun);
    return function (def) {
      var value = def.transformer ? dataTransformer[def.transformer](def.property) : propAccessor(def.property, 'N/A');
      return /*#__PURE__*/React.createElement("div", {
        key: def.key,
        className: "patient-cell"
      }, value, def.addHr ? /*#__PURE__*/React.createElement("div", {
        className: "vertical-divider"
      }) : null);
    };
  };
  var PatientEncounter = /*#__PURE__*/function (_React$Component) {
    function PatientEncounter(props) {
      var _this;
      _classCallCheck(this, PatientEncounter);
      _this = _callSuper$q(this, PatientEncounter, [props]);
      _this.handleToggleClick = _this.handleToggleClick.bind(_this);
      _this.handleCoderNotesClick = _this.handleCoderNotesClick.bind(_this);
      _this.handleCoderNotesKeyDown = _this.handleCoderNotesKeyDown.bind(_this);
      _this.state = {
        expandEncounter: true
      };
      return _this;
    }
    _inherits(PatientEncounter, _React$Component);
    return _createClass(PatientEncounter, [{
      key: "handleToggleClick",
      value: function handleToggleClick(ev) {
        ev.preventDefault();
        var expandEncounter = this.state.expandEncounter;
        var openClaims = this.props.openClaims;
        if (expandEncounter) {
          openClaims = [];
        } else {
          openClaims = [].concat(_toConsumableArray(openClaims), [{
            fieldIdentifier: 'showToggle',
            fieldName: 'showToggle'
          }]);
        }
        this.setState({
          expandEncounter: !expandEncounter
        });
        this.props.handleExpansion(!expandEncounter);
      }
    }, {
      key: "expandEncounter",
      value: function expandEncounter(_expandEncounter) {
        this.setState({
          expandEncounter: _expandEncounter
        });
        this.props.handleExpansion(_expandEncounter);
      }

      /**
       * Handles the click event on the "Coder Notes" section.
       * Prevents default behavior and triggers the coder notes info display.
       *
       * @param {React.MouseEvent<HTMLDivElement>} ev - The mouse event object.
       * @returns {void}
       */
    }, {
      key: "handleCoderNotesClick",
      value: function handleCoderNotesClick(ev) {
        var _activeItem$patient_i;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams$1(activeItem);
        ev.preventDefault();
        this.props.showCoderNotesInfo(_objectSpread$v(_objectSpread$v({}, lookupParams), {}, {
          patientMRN: activeItem === null || activeItem === void 0 || (_activeItem$patient_i = activeItem.patient_identifier) === null || _activeItem$patient_i === void 0 ? void 0 : _activeItem$patient_i.number,
          serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line
        }));
      }

      /**
       * Handles the keydown event on the "Coder Notes" section.
       * Triggers the coder notes info display when the Enter key is pressed.
       *
       * @param {React.KeyboardEvent<HTMLDivElement>} ev - The keyboard event object.
       * @returns {void}
       */
    }, {
      key: "handleCoderNotesKeyDown",
      value: function handleCoderNotesKeyDown(ev) {
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams$1(activeItem);
        if (ev.key === 'Enter') {
          var _activeItem$patient_i2;
          ev.preventDefault();
          this.props.showCoderNotesInfo(_objectSpread$v(_objectSpread$v({}, lookupParams), {}, {
            patientMRN: activeItem === null || activeItem === void 0 || (_activeItem$patient_i2 = activeItem.patient_identifier) === null || _activeItem$patient_i2 === void 0 ? void 0 : _activeItem$patient_i2.number,
            serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line
          }));
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _activations$property, _coderNotesCapability;
        var classnames$1 = ['patient-encounter'];
        var expandEncounter = this.state.expandEncounter;
        var _this$props = this.props,
          activations = _this$props.activations,
          activeItem = _this$props.activeItem,
          propertyConfig = _this$props.propertyConfig,
          fieldEditorInfo = _this$props.fieldEditorInfo,
          capability = _this$props.capability,
          coderNotesCapability = _this$props.coderNotesCapability,
          workItem = _this$props.workItem;
        var prop = propAccessor2(_objectSpread$v(_objectSpread$v({}, activeItem), workItem), (_activations$property = activations === null || activations === void 0 ? void 0 : activations.property) !== null && _activations$property !== void 0 ? _activations$property : {});
        var cellMaker = CellMaker$1(prop, activeItem, fieldEditorInfo, capability, this.props.showProviderInfo);
        var cellPatientMaker = CellPatientMaker$1(prop, activeItem);

        // all info less last item
        var patientConfig = propertyConfig.patient.slice(0, propertyConfig.patient.length - 1);
        // last item
        var patientLastItem = propertyConfig.patient.slice(-1);

        // add hr less the last one item
        patientConfig = patientConfig.map(function (patient, index) {
          return _objectSpread$v(_objectSpread$v({}, patient), {}, {
            addHr: index + 1 !== patientConfig.length
          });
        });
        var topRightCell = patientLastItem.map(cellMaker);
        var topCells = patientConfig.map(cellPatientMaker);
        var midCells = propertyConfig.summary.map(cellMaker);
        var bottomCells = propertyConfig.expanded.map(cellMaker);
        var chevronClassNames = ['chevron-link', 'qa-expand-encounter', {
          'chevron-link-opened': expandEncounter
        }, {
          'chevron-link-closed': !expandEncounter
        }];
        var expandEncounterClassNames = ['expanded-encounter', {
          'expanded-encounter-opened': expandEncounter
        }, {
          'expanded-encounter-closed': !expandEncounter
        }];
        var showComments = uiCommon.conditionalUtils.capabilityValue((_coderNotesCapability = coderNotesCapability === null || coderNotesCapability === void 0 ? void 0 : coderNotesCapability.on) !== null && _coderNotesCapability !== void 0 ? _coderNotesCapability : false);
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(classnames$1)
        }, /*#__PURE__*/React.createElement("div", {
          className: "patient-info-container",
          "data-testid": "patient-info-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "patient-top-info-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "top-patient-info"
        }, /*#__PURE__*/React.createElement("div", {
          className: "patient-info-primary sensitive-data columns"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12",
          "data-testid": "patient-info-name"
        }, prop('patient_name')), /*#__PURE__*/React.createElement("div", {
          className: "patient-info-secondary columns"
        }, topCells))), /*#__PURE__*/React.createElement("div", {
          className: "bottom-patient-info"
        }, /*#__PURE__*/React.createElement("div", {
          className: "columns"
        }, topRightCell)), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [showComments]
        }, /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onClick: this.handleCoderNotesClick,
          onKeyDown: this.handleCoderNotesKeyDown,
          className: "coder-comments-section"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconClass: "coder-comments",
          svgIconName: "BiomeComments",
          svgIconSize: "24"
        })))), propertyConfig.summary.length > 0 && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          className: "divider first-divider"
        }), /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "columns info-block"
        }, midCells))), /*#__PURE__*/React.createElement("div", {
          className: classnames(expandEncounterClassNames)
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "columns info-block"
        }, bottomCells)))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: propertyConfig.expanded.length > 0
        }, /*#__PURE__*/React.createElement("div", {
          className: "toggle-section",
          "data-dd-action-name": "~Toggle Section"
        }, /*#__PURE__*/React.createElement("span", {
          className: "show-toggle",
          onClick: this.handleToggleClick
        }, /*#__PURE__*/React.createElement(uiComponents.Chevron, {
          "data-dd-action-name": "~Toggle Section",
          onClick: this.handleToggleClick,
          className: classnames(chevronClassNames)
        })))));
      }
    }]);
  }(React.Component);
  _defineProperty(PatientEncounter, "displayName", 'PatientEncounter');
  _defineProperty(PatientEncounter, "defaultProps", {
    openClaims: [],
    showLoading: false,
    activations: {},
    handleExpansion: function handleExpansion(expanded) {},
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    showProviderInfo: function showProviderInfo(providerInfo) {},
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    workItem: {
      owner: '',
      assignee: '',
      aging_days: '',
      codable_days: ''
    }
  });

  var ChargeSessionCodeType$4 = uiCommon.commonEnums.ChargeSessionCodeType;
  var CODE_ORDER = new Map([[ChargeSessionCodeType$4.PROCEDURE.toUpperCase(), 0], [ChargeSessionCodeType$4.MODIFIER.toUpperCase(), 1], [ChargeSessionCodeType$4.DIAGNOSIS.toUpperCase(), 2]]);
  var getDroppableConfig = function getDroppableConfig(dropCandidate, dropTarget, position, allItems) {
    // check to see if they're the next in line.
    var candidateOrder = CODE_ORDER.get(dropCandidate.codeType.toUpperCase());
    var targetOrder = CODE_ORDER.get(dropTarget.codeType.toUpperCase());
    var targetDifference = Math.abs(candidateOrder - targetOrder);
    var permissibleDifference = 1;
    if (targetDifference > 1) {
      var hasMods = allItems.some(function (item) {
        return item.data.codeType === ChargeSessionCodeType$4.MODIFIER;
      });
      if (!hasMods) {
        permissibleDifference++;
      }
    }
    var rightAfter = position === 'after' && candidateOrder === targetOrder + permissibleDifference;
    var rightBefore = position === 'before' && candidateOrder === targetOrder - permissibleDifference;
    return {
      rightAfter: rightAfter,
      rightBefore: rightBefore
    };
  };
  var canDropOnto = function canDropOnto(dropCandidate, dropTarget, position, allItems) {
    // test to see if it's a search result
    if (uiCommon.cmxTypeguards.isSearchResult(dropCandidate)) {
      // if they're of the same code type, then can drop
      // NOTE codeType and provenance are being tested here
      // search results and codes don't respect the same
      // definitions, so we have to compare two separate props
      var sameType = dropCandidate.codeType === dropTarget.provenance;
      if (sameType) {
        return true;
      }
    } else {
      // not supporting moving between lists yet.
      var inList = allItems.find(function (item) {
        return item.data.code === dropCandidate.code;
      });
      if (!inList) {
        return false;
      }
      // if they're of the same code type, then can drop
      // dropping on self is prevented in the accordion
      var sameCodeType = dropCandidate.codeType === dropTarget.codeType;
      if (sameCodeType) {
        return true;
      }
    }
    // for search results and reordering
    var _getDroppableConfig = getDroppableConfig(dropCandidate, dropTarget, position, allItems),
      rightAfter = _getDroppableConfig.rightAfter,
      rightBefore = _getDroppableConfig.rightBefore;
    var targets = allItems.map(function (item) {
      return item.data;
    }).filter(function (item) {
      return item.codeType === dropTarget.codeType;
    });
    if (rightAfter) {
      return targets.findIndex(function (item) {
        return item.code === dropTarget.code;
      }) === targets.length - 1;
    } else if (rightBefore) {
      return targets[0].code === dropTarget.code;
    } else {
      return false;
    }
  };

  /**
   * Method that checks if an unit is valid
   * @param {string} inputUnit
   * @returns {boolean}
   */
  var isAValidUnits = function isAValidUnits(inputUnit) {
    if (/^-?\d+\.?\d*$/.test(inputUnit)) {
      if (Number(inputUnit) <= -1 || Number(inputUnit) >= 1) {
        return true;
      }
    }
    return false;
  };

  /**
   * Method that transform units a valid form
   * @param {number} inputUnit
   * @returns {number}
   */
  var parseUnits = function parseUnits(inputUnit) {
    if (inputUnit < 0) {
      inputUnit *= -1;
    }
    return Math.floor(inputUnit);
  };

  var CHARGE_TYPE_LABEL = {
    professional: 'PRO',
    technical: 'TECH',
    'pro-tech': 'PRO/TECH',
    SHARED_CODES: 'SHARED'
  };

  var getChildWindowParams$4 = uiCommon.caseUtils.getChildWindowParams;
  /**
   * Little component function for display error message list
   * @param errorMessages
   * @returns
   */
  var ErrorSubmission = function ErrorSubmission(props) {
    var _customClaimsRelatedP;
    var errorMessages = props.errorMessages,
      messageHeader = props.messageHeader,
      messageStyle = props.messageStyle,
      messageType = props.messageType,
      customClaimsRelatedProps = props.customClaimsRelatedProps;
    var caseHandler = function caseHandler(customClaim, index) {
      var childWindowParams = getChildWindowParams$4(customClaim === null || customClaim === void 0 ? void 0 : customClaim.case_uid, customClaim === null || customClaim === void 0 ? void 0 : customClaim.process_instance_guid, customClaim === null || customClaim === void 0 ? void 0 : customClaim.service_line, launchAmplifyCase, customClaim === null || customClaim === void 0 ? void 0 : customClaim.case_id);
      if (customClaimsRelatedProps && customClaimsRelatedProps.onOpenRelatedCase) {
        customClaimsRelatedProps.onOpenRelatedCase(childWindowParams);
      }
    };
    var getMessageDetails = function getMessageDetails(message) {
      var messages = {
        warning: {
          icon: e.Warning,
          text: 'Warning'
        },
        error: {
          icon: e.Error,
          text: 'Error'
        },
        info: {
          icon: e.Info,
          text: 'Info'
        }
      };
      return (messages === null || messages === void 0 ? void 0 : messages[message]) || {
        icon: e.Info,
        text: 'Info'
      };
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, (errorMessages === null || errorMessages === void 0 ? void 0 : errorMessages.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(messageStyle, " ").concat(messageType, " ").concat(customClaimsRelatedProps !== null && customClaimsRelatedProps !== void 0 && customClaimsRelatedProps.applyErrorTextStyle ? 'error-text' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "message-icon-container"
    }, /*#__PURE__*/React.createElement(r, {
      iconName: getMessageDetails(messageType).icon,
      iconClass: "message-icon",
      titleText: getMessageDetails(messageType).text
    })), /*#__PURE__*/React.createElement("div", {
      className: "message-container"
    }, messageHeader && /*#__PURE__*/React.createElement("h1", null, messageHeader), /*#__PURE__*/React.createElement("ul", {
      className: "error-submission"
    }, (customClaimsRelatedProps === null || customClaimsRelatedProps === void 0 || (_customClaimsRelatedP = customClaimsRelatedProps.cases) === null || _customClaimsRelatedP === void 0 ? void 0 : _customClaimsRelatedP.length) > 0 && /*#__PURE__*/React.createElement("li", null, "There are cross case CCI issues for these cases.", /*#__PURE__*/React.createElement("ul", null, customClaimsRelatedProps === null || customClaimsRelatedProps === void 0 ? void 0 : customClaimsRelatedProps.cases.map(function (customClaim, idx) {
      return /*#__PURE__*/React.createElement("li", {
        key: idx,
        className: "case-clickable",
        onClick: function onClick() {
          return caseHandler(customClaim);
        }
      }, customClaim === null || customClaim === void 0 ? void 0 : customClaim.case_id);
    }))), errorMessages.map(function (errorMessage, idx) {
      return /*#__PURE__*/React.createElement("li", {
        key: idx,
        className: customClaimsRelatedProps && !customClaimsRelatedProps.applyErrorTextStyle ? '' : 'error-text'
      }, errorMessage.message);
    }))))));
  };
  ErrorSubmission.displayName = 'ErrorSubmission';

  var TimeBasedCodePopover = function TimeBasedCodePopover(_ref) {
    var _codableTransaction$p, _codableTransaction$p2, _processInstance$age, _codableTransaction$p3, _codableTransaction$p4, _codableTransaction$p5, _processInstance$serv;
    var codableTransaction = _ref.codableTransaction,
      handleTimeBasedCodeAdd = _ref.handleTimeBasedCodeAdd,
      handleTimeBasedCodeUpdate = _ref.handleTimeBasedCodeUpdate,
      processInstance = _ref.processInstance,
      updatePopoverState = _ref.updatePopoverState;
      _ref.popoverState;
    var _useState = React.useState((codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p = codableTransaction.procedure) === null || _codableTransaction$p === void 0 ? void 0 : _codableTransaction$p.total_time) || ''),
      _useState2 = _slicedToArray(_useState, 2),
      time = _useState2[0],
      setTime = _useState2[1];
    var _useState3 = React.useState((codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.age) || (processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) && (processInstance === null || processInstance === void 0 || (_processInstance$age = processInstance.age) === null || _processInstance$age === void 0 ? void 0 : _processInstance$age.toString()) || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      age = _useState4[0],
      setAge = _useState4[1];
    var isNewValue = (codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p3 = codableTransaction.procedure) === null || _codableTransaction$p3 === void 0 ? void 0 : _codableTransaction$p3.total_time) === null;
    var hasAddOnCode = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p4 = codableTransaction.procedure) === null || _codableTransaction$p4 === void 0 ? void 0 : _codableTransaction$p4.add_on_code_available;
    var isTimePresent = (codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p5 = codableTransaction.procedure) === null || _codableTransaction$p5 === void 0 ? void 0 : _codableTransaction$p5.total_time) !== null;
    var handleActionButtonClick = function handleActionButtonClick(ev) {
      ev.stopPropagation();
      if (isNewValue) {
        handleTimeBasedCodeAdd(ev, time, age);
      } else {
        handleTimeBasedCodeUpdate(ev, time, age);
      }
      updatePopoverState(false);
    };
    var handleClose = function handleClose(ev) {
      var _codableTransaction$p6, _codableTransaction$p7, _processInstance$age2;
      // Close the popover and reset the clickTriggered state
      updatePopoverState(false);
      setTime((codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p6 = codableTransaction.procedure) === null || _codableTransaction$p6 === void 0 ? void 0 : _codableTransaction$p6.total_time) || '');
      setAge((codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p7 = codableTransaction.procedure) === null || _codableTransaction$p7 === void 0 ? void 0 : _codableTransaction$p7.age) || (processInstance === null || processInstance === void 0 ? void 0 : processInstance.age) && (processInstance === null || processInstance === void 0 || (_processInstance$age2 = processInstance.age) === null || _processInstance$age2 === void 0 ? void 0 : _processInstance$age2.toString()) || '');
      ev.stopPropagation();
    };
    var buttonText = '';
    if (hasAddOnCode) {
      buttonText = isTimePresent ? 'Regenerate' : 'Generate';
    } else {
      buttonText = 'Save';
    }
    return /*#__PURE__*/React.createElement("div", {
      className: classnames('time-based-code-popover', {
        magic: hasAddOnCode
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: "input-section"
    }, uiCommon.appServiceLines.isSurgery((_processInstance$serv = processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine) !== null && _processInstance$serv !== void 0 ? _processInstance$serv : 'NONE') && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "time-label"
    }, "Patient Age"), /*#__PURE__*/React.createElement("input", {
      name: 'age',
      type: "number",
      className: classnames('time-input', {
        magic: hasAddOnCode
      }),
      placeholder: "Enter patient age",
      value: age,
      onClick: function onClick(ev) {
        ev.stopPropagation();
      },
      onChange: function onChange(e) {
        return setAge(e.target.value);
      }
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", {
      className: "time-label"
    }, "Total Procedure Time"), /*#__PURE__*/React.createElement("input", {
      name: 'total-time',
      type: "number",
      className: classnames('time-input', {
        magic: hasAddOnCode
      }),
      placeholder: "Enter minutes",
      value: time,
      onClick: function onClick(ev) {
        ev.stopPropagation();
      },
      onChange: function onChange(e) {
        return setTime(e.target.value);
      }
    }))), /*#__PURE__*/React.createElement("div", {
      className: "button-section"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: handleClose,
      variant: "secondary"
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      onClick: handleActionButtonClick,
      disabled: !time.trim(),
      variant: "primary",
      className: classnames("magic-button", {
        disabled: !time.trim(),
        magic: hasAddOnCode
      }),
      leftIcon: hasAddOnCode && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeAutomation",
        svgIconSize: "20"
      })
    }, buttonText)));
  };

  var ChargeSessionCodeType$3 = uiCommon.commonEnums.ChargeSessionCodeType,
    CodeSearchType$2 = uiCommon.commonEnums.CodeSearchType;
  var MedicalCodesManager = function MedicalCodesManager(_ref) {
    var codeList = _ref.codeList,
      codeType = _ref.codeType,
      editMode = _ref.editMode,
      searchResults = _ref.searchResults,
      _ref$debounceTimeout = _ref.debounceTimeout,
      debounceTimeout = _ref$debounceTimeout === void 0 ? 200 : _ref$debounceTimeout,
      fieldDefinitions = _ref.fieldDefinitions,
      _ref$isSharedInvoice = _ref.isSharedInvoice,
      isSharedInvoice = _ref$isSharedInvoice === void 0 ? false : _ref$isSharedInvoice,
      searchResultsLookupKey = _ref.searchResultsLookupKey,
      suggestedCodes = _ref.suggestedCodes,
      transactionGuid = _ref.transactionGuid,
      handleCodeDelete = _ref.handleCodeDelete,
      onCodeSearch = _ref.onCodeSearch,
      onCodeSearchSelection = _ref.onCodeSearchSelection,
      handleCodeChecked = _ref.handleCodeChecked,
      codeDropHandler = _ref.codeDropHandler,
      onAddAllCodes = _ref.onAddAllCodes,
      onRemoveAllCodes = _ref.onRemoveAllCodes,
      codeEdits = _ref.codeEdits,
      _ref$autoFocus = _ref.autoFocus,
      autoFocus = _ref$autoFocus === void 0 ? false : _ref$autoFocus,
      changedCodes = _ref.changedCodes;
    // Refs for interacting with the Lookup component and the CodesManager container
    var lookupRef = /*#__PURE__*/React.createRef();
    var managerRef = React.useRef(null);
    var isProcedureCode = codeType === ChargeSessionCodeType$3.PROCEDURE;

    // State for controlling visibility of the search input
    var _useState = React.useState(uiCommon.objectUtils.isEmpty(codeList)),
      _useState2 = _slicedToArray(_useState, 2),
      isSearchVisible = _useState2[0],
      setIsSearchVisible = _useState2[1];

    // State to manage the list of codes (for reordering)
    var _useState3 = React.useState(codeList),
      _useState4 = _slicedToArray(_useState3, 2),
      codes = _useState4[0],
      setCodes = _useState4[1];
    var shouldShowSearch = function shouldShowSearch(codeList) {
      return editMode && (!isProcedureCode || uiCommon.objectUtils.isEmpty(codeList));
    };
    React.useEffect(function () {
      setCodes(codeList);
      setIsSearchVisible(shouldShowSearch(codeList));
    }, [codeList]);

    // Handler for clicking on the manager container (opens search if conditions are met)
    var handleManagerClick = function handleManagerClick() {
      if (shouldShowSearch(codeList)) {
        setIsSearchVisible(true);
        if (lookupRef.current) {
          lookupRef.current.focus(); // Set focus on the Lookup input
        }
      }
    };

    // Handler to reorder codes when dragged and dropped
    var handleCodeDrop = function handleCodeDrop(dragIndex, hoverIndex) {
      var updatedCodes = _toConsumableArray(codes);
      var _updatedCodes$splice = updatedCodes.splice(dragIndex, 1),
        _updatedCodes$splice2 = _slicedToArray(_updatedCodes$splice, 1),
        draggedCode = _updatedCodes$splice2[0];
      updatedCodes.splice(hoverIndex, 0, draggedCode);
      setCodes(updatedCodes);
      codeDropHandler(updatedCodes);
    };

    // Determine if the codes are draggable (based on edit mode and code type)
    var isDraggable = editMode && !isProcedureCode && codeList.length > 1;

    // Generate the view for the list of codes using CodeChip components
    var codesView = /*#__PURE__*/React.createElement(React.Fragment, null, codes.map(function (medicalCode, idx) {
      var isLedgerCodeChange = !!(changedCodes !== null && changedCodes !== void 0 && changedCodes.includes(medicalCode.code));
      return /*#__PURE__*/React.createElement(CodeFieldComponent, {
        key: "".concat(medicalCode.code, "-").concat(idx),
        chipProps: {
          code: medicalCode.code,
          codeType: medicalCode.codeType,
          editable: editMode,
          handleCodeDelete: handleCodeDelete,
          sequence: idx,
          onDrop: handleCodeDrop,
          isDraggable: isDraggable,
          active: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.active,
          shared: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.shared,
          isSharedInvoice: isSharedInvoice,
          handleCodeChecked: handleCodeChecked,
          description: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.description,
          evidence: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.evidence,
          codeEdits: codeEdits,
          codeProvenance: medicalCode === null || medicalCode === void 0 ? void 0 : medicalCode.codeProvenance,
          isLedgerCodeChange: isLedgerCodeChange
        }
      });
    }));

    // Filter field definitions based on the selected code type
    var fieldDefinition = fieldDefinitions.filter(function (def) {
      return def.label.toLowerCase() === codeType.toLowerCase();
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "codes-manager ".concat(codeType),
      ref: managerRef,
      onClick: handleManagerClick
    }, /*#__PURE__*/React.createElement("div", {
      className: "codes-manager-left"
    }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [(codes === null || codes === void 0 ? void 0 : codes.length) !== 0]
    }, /*#__PURE__*/React.createElement("div", {
      className: "code-list"
    }, codesView)), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: isSearchVisible
    }, /*#__PURE__*/React.createElement("div", {
      className: "code-search"
    }, /*#__PURE__*/React.createElement(SuggestedLookup, {
      ref: lookupRef,
      actionPrefix: "",
      placeholderText: uiCommon.objectUtils.isEmpty(codeList) ? "Add ".concat(codeType.toLowerCase()) : '',
      debounceTimeout: debounceTimeout,
      FieldDefinitions: fieldDefinition,
      shouldShowResults: uiComponents.shouldShowResults,
      autoFocus: autoFocus,
      onSearch: onCodeSearch,
      onSearchSelection: onCodeSearchSelection,
      handleCodeDelete: handleCodeDelete,
      searchResults: searchResults,
      disabled: !editMode,
      searchResultsLookupKey: searchResultsLookupKey,
      actionNameForDD: isSharedInvoice ? '~Focus code search (Shared)' : '~Focus code search (General)',
      suggestedCodes: suggestedCodes,
      allowCodeRemove: !isSharedInvoice && uiCommon.caseUtils.getCodeTypeShortName(codeType) !== CodeSearchType$2.CPT,
      transactionGuid: transactionGuid,
      onAddAllCodes: onAddAllCodes,
      onRemoveAllCodes: onRemoveAllCodes
    })))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: editMode && (!isProcedureCode || isProcedureCode && uiCommon.objectUtils.isEmpty(codeList))
    }, /*#__PURE__*/React.createElement("div", {
      className: "codes-manager-right"
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeChevronDownSVG20",
      svgIconSize: "16",
      svgIconClass: "select-chevron"
    }))));
  };

  var joinStrings = function joinStrings(str, separator) {
    if (typeof str === 'string') {
      return str;
    } else {
      return str.join(separator);
    }
  };

  /**
   * A utility function for building dispatchable functions.
   *
   * @param {Function} dispatch - The dispatch function provided by your Redux or state management library.
   * @returns {Function} A function that takes another function and dispatches its result.
   */
  var buildDispatchable = function buildDispatchable(dispatch) {
    /**
     * Executes a given function and dispatches its result.
     *
     * @param {Function} fn - The function to be executed and its result dispatched.
     * @returns {Promise<any>} A promise that resolves to the result of the dispatched action.
     */
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(fn) {
        var _t;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return dispatch(fn());
            case 1:
              return _context.abrupt("return", _context.sent);
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('Error performing action', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };

  /**
   * Extracts all ledger transactions from an invoice.
   * Since an invoice can contain multiple ledgers, this flattens them into a single list.
   */
  var getLedgerTransactionsFromInvoice = function getLedgerTransactionsFromInvoice(invoice) {
    var _invoice$case_invoice, _invoice$case_invoice2;
    return (_invoice$case_invoice = invoice === null || invoice === void 0 || (_invoice$case_invoice2 = invoice.case_invoice_ledgers) === null || _invoice$case_invoice2 === void 0 ? void 0 : _invoice$case_invoice2.flatMap(function (ledger) {
      var _ledger$case_ledger_t;
      return (_ledger$case_ledger_t = ledger.case_ledger_transactions) !== null && _ledger$case_ledger_t !== void 0 ? _ledger$case_ledger_t : [];
    })) !== null && _invoice$case_invoice !== void 0 ? _invoice$case_invoice : [];
  };

  /**
   * Finds the ledger transactions corresponding to the given transaction guid.
   */
  var getLedgerTransaction = function getLedgerTransaction(ledgerTransactions, transactionGuid) {
    if (!transactionGuid) {
      return undefined;
    }
    return ledgerTransactions.find(function (ledgerTxn) {
      var _ledgerTxn$transactio;
      return ((_ledgerTxn$transactio = ledgerTxn.transaction_guid) === null || _ledgerTxn$transactio === void 0 ? void 0 : _ledgerTxn$transactio.uuid) && ledgerTxn.transaction_guid.uuid === transactionGuid;
    });
  };
  /**
   * Determines if the transaction row should be highlighted.
   * A row highlight occurs when the transaction is newly introduced in the invoice.
   */
  var shouldHighlightTransaction = function shouldHighlightTransaction(txnLedger) {
    return (txnLedger === null || txnLedger === void 0 ? void 0 : txnLedger.change_type) === "INVOICE_CHARGE";
  };
  var getLedgerChangedCodes = function getLedgerChangedCodes(txnLedger) {
    var _txnLedger$change_jso, _txnLedger$change_jso2, _chargeCodes$cpt_code, _chargeCodes$cpt_code2, _chargeCodes$icd_code, _chargeCodes$icd_code2, _chargeCodes$icd_code3, _chargeCodes$icd_code4, _chargeCodes$modifier, _chargeCodes$modifier2, _chargeCodes$modifier3, _chargeCodes$modifier4;
    if (!txnLedger || txnLedger.change_type === "INVOICE_NO_CHANGE") {
      return {
        changedCptCodes: [],
        changedIcdCodes: [],
        changedModifiers: []
      };
    }
    var chargeCodes = (_txnLedger$change_jso = txnLedger === null || txnLedger === void 0 || (_txnLedger$change_jso2 = txnLedger.change_json) === null || _txnLedger$change_jso2 === void 0 ? void 0 : _txnLedger$change_jso2.charge_codes) !== null && _txnLedger$change_jso !== void 0 ? _txnLedger$change_jso : {};
    return {
      changedCptCodes: [(_chargeCodes$cpt_code = chargeCodes.cpt_codes) === null || _chargeCodes$cpt_code === void 0 ? void 0 : _chargeCodes$cpt_code.ADDENDUM, (_chargeCodes$cpt_code2 = chargeCodes.cpt_codes) === null || _chargeCodes$cpt_code2 === void 0 ? void 0 : _chargeCodes$cpt_code2.VOID].filter(Boolean),
      changedIcdCodes: [].concat(_toConsumableArray((_chargeCodes$icd_code = (_chargeCodes$icd_code2 = chargeCodes.icd_codes) === null || _chargeCodes$icd_code2 === void 0 ? void 0 : _chargeCodes$icd_code2.ADDENDUM) !== null && _chargeCodes$icd_code !== void 0 ? _chargeCodes$icd_code : []), _toConsumableArray((_chargeCodes$icd_code3 = (_chargeCodes$icd_code4 = chargeCodes.icd_codes) === null || _chargeCodes$icd_code4 === void 0 ? void 0 : _chargeCodes$icd_code4.VOID) !== null && _chargeCodes$icd_code3 !== void 0 ? _chargeCodes$icd_code3 : [])),
      changedModifiers: [].concat(_toConsumableArray((_chargeCodes$modifier = (_chargeCodes$modifier2 = chargeCodes.modifiers) === null || _chargeCodes$modifier2 === void 0 ? void 0 : _chargeCodes$modifier2.ADDENDUM) !== null && _chargeCodes$modifier !== void 0 ? _chargeCodes$modifier : []), _toConsumableArray((_chargeCodes$modifier3 = (_chargeCodes$modifier4 = chargeCodes.modifiers) === null || _chargeCodes$modifier4 === void 0 ? void 0 : _chargeCodes$modifier4.VOID) !== null && _chargeCodes$modifier3 !== void 0 ? _chargeCodes$modifier3 : []))
    };
  };
  var LEDGER_BANNER_CHANGE_TYPES = new Set(["INVOICE_CHARGE", "TRANSACTION_ADDENDUM", "TRANSACTION_VOID", "TRANSACTION_VOID_ADDENDUM"]);

  /**
   * Determines if the process instance contains any ledger updates
   * that should trigger the reference codes update banner.
   */

  var hasLedgerUpdates = function hasLedgerUpdates(processInstance) {
    var _processInstance$invo, _processInstance$invo2;
    return (_processInstance$invo = processInstance === null || processInstance === void 0 || (_processInstance$invo2 = processInstance.invoices) === null || _processInstance$invo2 === void 0 ? void 0 : _processInstance$invo2.some(function (inv) {
      var _inv$case_invoice_led;
      return inv === null || inv === void 0 || (_inv$case_invoice_led = inv.case_invoice_ledgers) === null || _inv$case_invoice_led === void 0 ? void 0 : _inv$case_invoice_led.some(function (ledger) {
        var _ledger$case_ledger_t2;
        return ledger === null || ledger === void 0 || (_ledger$case_ledger_t2 = ledger.case_ledger_transactions) === null || _ledger$case_ledger_t2 === void 0 ? void 0 : _ledger$case_ledger_t2.some(function (txn) {
          var _txn$transaction_guid;
          return LEDGER_BANNER_CHANGE_TYPES.has(txn.change_type) && !!((_txn$transaction_guid = txn.transaction_guid) !== null && _txn$transaction_guid !== void 0 && _txn$transaction_guid.uuid);
        });
      });
    })) !== null && _processInstance$invo !== void 0 ? _processInstance$invo : false;
  };

  var ChargeSessionCodeType$2 = uiCommon.commonEnums.ChargeSessionCodeType,
    CodeSearchType$1 = uiCommon.commonEnums.CodeSearchType;
  var EditorIssueLevel$2 = uiCommon.commonEnums.EditorIssueLevel;

  /**
   * React component that displays a Header
   * @param medicalCode
   * @param errors
   * @param handleCodeDelete
   * @param handleEnableTechPro
   * @param handleDisableTechPro
   * @param handleTransactionReorder
   * @returns
   */
  var TransactionHeader = function TransactionHeader(procedureCode, techTransaction, errors, invoice, codeEdits, handleUnitsChange, handleTransactionReorder, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, codeDropHandler, isTimeBasedCode, timeBasedCodePopup, onSearch, onSearchSelection, onAddAllCodes, onRemoveAllCodes, searchResults, codableTransaction, transaction, editable, suggestedCodes, autoFocus, transactionIndex) {
    var isFirstTnx = transactionIndex === 0;
    var isLastTnx = transactionIndex === (invoice === null || invoice === void 0 ? void 0 : invoice.transactions.length) - 1;
    var dianosisCodeList = [];
    var modifierCodeList = [];
    var fieldDefinitions = [];
    var unitsRef = /*#__PURE__*/React.createRef();
    var source = codableTransaction || transaction;
    if (source) {
      dianosisCodeList = source.codes.filter(function (item) {
        return item.codeType === ChargeSessionCodeType$2.DIAGNOSIS;
      });
      modifierCodeList = source.codes.filter(function (item) {
        return item.codeType === ChargeSessionCodeType$2.MODIFIER;
      });
      if (codableTransaction) {
        fieldDefinitions = codableTransaction.fieldDefinitions;
      }
    }
    // for shared-invoice display only diagnosis medical codes manager
    if ((invoice === null || invoice === void 0 ? void 0 : invoice.type) == uiCommon.commonEnums.InvoiceTypes.SHARED_CODES) {
      return /*#__PURE__*/React.createElement(MedicalCodesManager, {
        codeType: ChargeSessionCodeType$2.DIAGNOSIS,
        codeList: dianosisCodeList,
        searchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults[CodeSearchType$1.ICD],
        searchResultsLookupKey: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        debounceTimeout: 200,
        fieldDefinitions: fieldDefinitions,
        handleCodeDelete: handleCodeDelete,
        onCodeSearch: onSearch,
        onCodeSearchSelection: onSearchSelection,
        editMode: editable,
        handleCodeChecked: handleCodeChecked,
        isSharedInvoice: true,
        suggestedCodes: suggestedCodes,
        onAddAllCodes: onAddAllCodes,
        onRemoveAllCodes: onRemoveAllCodes,
        codeDropHandler: codeDropHandler
      });
    } else {
      var _procedureCode$shared, _codeEdits$procedureC;
      //@ts-ignore
      (_procedureCode$shared = procedureCode === null || procedureCode === void 0 ? void 0 : procedureCode.shared) !== null && _procedureCode$shared !== void 0 ? _procedureCode$shared : false;
      (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES;
      var allEdits = (_codeEdits$procedureC = codeEdits[procedureCode === null || procedureCode === void 0 ? void 0 : procedureCode.code]) !== null && _codeEdits$procedureC !== void 0 ? _codeEdits$procedureC : [];
      var vwErrors = allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel$2.ERROR;
      });
      var vwWarnings = allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel$2.WARNING;
      });
      var disablePro = !editable || techTransaction.hasProCode && !techTransaction.hasTechCode;
      var disableTech = !editable || techTransaction.hasTechCode && !techTransaction.hasProCode;
      var styleClasses = ["transaction-headerV2"];
      ['code-units-input', {
        'procedure-code-units-invalid': errors.some(function (error) {
          return error.message_key === 'procedure_code.units.invalid';
        })
      }];
      var proClassName = classnames([{
        'is-active': techTransaction.isProCodeActive,
        'is-inactive': !techTransaction.isProCodeActive
      }]);
      var techClassName = classnames([{
        'is-active': techTransaction.isTechCodeActive,
        'is-inactive': !techTransaction.isTechCodeActive
      }]);
      var techIndicatorClassName = classnames(['tech-code-cell', 'qa-tech-indicator', 'prevent-click', 'tech-indicator', 'indicator', 'indicator-pro-tech', {
        'tech-indicator-no-space': techTransaction.hasProCode && techTransaction.isTechCodeActive || techTransaction.hasTechCode && techTransaction.isProCodeActive,
        'indicator-pro-tech-active': techTransaction.isTechCodeActive,
        'indicator-pro-tech-inactive': !techTransaction.isTechCodeActive,
        'single-indicator-pro-tech': !techTransaction.hasProCode,
        'indicator-pro-tech-modifier': techTransaction.isModifier,
        'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
        'pro-tech-loading': techTransaction.isLoading
      }]);
      var proIndicatorClassName = classnames(['pro-code-cell', 'qa-pro-indicator', 'prevent-click', 'pro-indicator', 'indicator', 'indicator-pro-tech', {
        'indicator-pro-tech-active': techTransaction.isProCodeActive,
        'indicator-pro-tech-inactive': !techTransaction.isProCodeActive,
        'single-indicator-pro-tech': !techTransaction.hasTechCode,
        'indicator-pro-tech-modifier': techTransaction.isModifier,
        'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
        'pro-tech-loading': techTransaction.isLoading
      }]);
      var proCheck = classnames(['pro-tech-check', {
        'pro-tech-check-active': techTransaction.isProCodeActive,
        'pro-tech-check-inactive': !techTransaction.isProCodeActive
      }]);
      var techCheck = classnames(['pro-tech-check', {
        'pro-tech-check-active': techTransaction.isTechCodeActive,
        'pro-tech-check-inactive': !techTransaction.isTechCodeActive
      }]);
      var toggleProCode = function toggleProCode() {
        if (!techTransaction.isLoading) {
          techTransaction.isProCodeActive ? handleEnableTechPro(techTransaction.proContext) : handleDisableTechPro(techTransaction.proContext);
        }
      };
      var toggleTechCode = function toggleTechCode() {
        if (!techTransaction.isLoading) {
          techTransaction.isTechCodeActive ? handleEnableTechPro(techTransaction.techContext) : handleDisableTechPro(techTransaction.techContext);
        }
      };
      var handleUnitsUpdate = function handleUnitsUpdate(units) {
        var _unitsRef$current;
        var unitsDiv = (_unitsRef$current = unitsRef.current) === null || _unitsRef$current === void 0 ? void 0 : _unitsRef$current.querySelector('.unit-input');
        handleUnitsChange(units, unitsDiv);
      };
      var txnLedger = getLedgerTransaction(getLedgerTransactionsFromInvoice(invoice), codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid);
      var _getLedgerChangedCode = getLedgerChangedCodes(txnLedger),
        changedCptCodes = _getLedgerChangedCode.changedCptCodes,
        changedIcdCodes = _getLedgerChangedCode.changedIcdCodes,
        changedModifiers = _getLedgerChangedCode.changedModifiers;
      return /*#__PURE__*/React.createElement("div", _extends$1({}, procedureCode && {
        'data-code': procedureCode.code,
        'data-code-type': procedureCode.codeType
      }, {
        className: classnames(styleClasses)
      }), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
        on: editable && (invoice === null || invoice === void 0 ? void 0 : invoice.transactions.length) > 1 && invoice.transactions.every(function (txn) {
          return !txn.isTemporary;
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "transaction-code-gripper"
      }, /*#__PURE__*/React.createElement(Menu, {
        placement: "bottom-end"
      }, /*#__PURE__*/React.createElement(MenuButton$1, {
        as: Box,
        cursor: "pointer"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-gripper"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeGripperSVG20",
        svgIconSize: "20",
        svgIconClass: "gripper"
      }))), /*#__PURE__*/React.createElement(MenuList$1, {
        className: "transaction-reorder-menu"
      }, !isFirstTnx && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem$1, {
        onClick: function onClick() {
          return handleTransactionReorder(transactionIndex, 0);
        }
      }, "Move to Top"), /*#__PURE__*/React.createElement(MenuItem$1, {
        onClick: function onClick() {
          return handleTransactionReorder(transactionIndex, transactionIndex - 1);
        }
      }, "Move Up")), !isLastTnx && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem$1, {
        onClick: function onClick() {
          return handleTransactionReorder(transactionIndex, transactionIndex + 1);
        }
      }, "Move Down"), /*#__PURE__*/React.createElement(MenuItem$1, {
        onClick: function onClick() {
          return handleTransactionReorder(transactionIndex, (invoice === null || invoice === void 0 ? void 0 : invoice.transactions.length) - 1);
        }
      }, "Move to Bottom")))))), /*#__PURE__*/React.createElement("div", {
        className: "units-column",
        ref: unitsRef
      }, (procedureCode === null || procedureCode === void 0 ? void 0 : procedureCode.units) && /*#__PURE__*/React.createElement("span", {
        className: "code-units-populateable prevent-click"
      }, /*#__PURE__*/React.createElement(uiComponents.UnitInput, {
        minLimit: 1,
        value: procedureCode === null || procedureCode === void 0 ? void 0 : procedureCode.units,
        disabled: !editable || !(procedureCode !== null && procedureCode !== void 0 && procedureCode.editable),
        onChange: handleUnitsUpdate
      }))), /*#__PURE__*/React.createElement("div", {
        className: "procedure-code-section"
      }, /*#__PURE__*/React.createElement("div", {
        className: "procedure-code-column \n    ".concat(vwErrors ? 'vwError' : vwWarnings ? 'vwWarning' : '')
      }, /*#__PURE__*/React.createElement(MedicalCodesManager, {
        codeType: ChargeSessionCodeType$2.PROCEDURE,
        codeList: procedureCode ? [procedureCode] : [],
        searchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults[CodeSearchType$1.CPT],
        searchResultsLookupKey: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        debounceTimeout: 200,
        fieldDefinitions: fieldDefinitions,
        handleCodeDelete: handleCodeDelete,
        onCodeSearch: onSearch,
        onCodeSearchSelection: onSearchSelection,
        editMode: editable,
        suggestedCodes: suggestedCodes,
        transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        onAddAllCodes: onAddAllCodes,
        onRemoveAllCodes: onRemoveAllCodes,
        codeEdits: codeEdits,
        autoFocus: autoFocus,
        changedCodes: changedCptCodes
      })), /*#__PURE__*/React.createElement("div", {
        className: "code-actions-column"
      }, techTransaction.hasProCode && /*#__PURE__*/React.createElement("div", {
        className: classnames(proIndicatorClassName)
      }, /*#__PURE__*/React.createElement(Button, {
        "aria-label": "",
        variant: "clock",
        className: proClassName,
        onClick: toggleProCode,
        disabled: disablePro
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeCheckSVG20",
        svgIconSize: "12",
        svgIconClass: classnames(proCheck)
      }), /*#__PURE__*/React.createElement("p", {
        className: "pro-tech-label"
      }, "P"))), techTransaction.hasTechCode && /*#__PURE__*/React.createElement("div", {
        className: classnames(techIndicatorClassName)
      }, /*#__PURE__*/React.createElement(Button, {
        "aria-label": "",
        variant: "clock",
        className: techClassName,
        onClick: toggleTechCode,
        disabled: disableTech
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeCheckSVG20",
        svgIconSize: "12",
        svgIconClass: classnames(techCheck)
      }), /*#__PURE__*/React.createElement("p", {
        className: "pro-tech-label"
      }, "T"))), (procedureCode === null || procedureCode === void 0 ? void 0 : procedureCode.codeType) === 'procedure' && isTimeBasedCode() && /*#__PURE__*/React.createElement("div", {
        className: "time-code-cell"
      }, timeBasedCodePopup()))), /*#__PURE__*/React.createElement("div", {
        className: "modifier-codes-section"
      }, /*#__PURE__*/React.createElement(MedicalCodesManager, {
        codeType: ChargeSessionCodeType$2.MODIFIER,
        codeList: modifierCodeList,
        searchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults[CodeSearchType$1.MODIFIER],
        searchResultsLookupKey: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        debounceTimeout: 200,
        fieldDefinitions: fieldDefinitions,
        handleCodeDelete: handleCodeDelete,
        onCodeSearch: onSearch,
        onCodeSearchSelection: onSearchSelection,
        editMode: editable,
        suggestedCodes: suggestedCodes,
        codeDropHandler: codeDropHandler,
        transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        onAddAllCodes: onAddAllCodes,
        onRemoveAllCodes: onRemoveAllCodes,
        codeEdits: codeEdits,
        changedCodes: changedModifiers
      })), /*#__PURE__*/React.createElement("div", {
        className: "diagnosis-codes-section"
      }, /*#__PURE__*/React.createElement(MedicalCodesManager, {
        codeType: ChargeSessionCodeType$2.DIAGNOSIS,
        codeList: dianosisCodeList,
        searchResults: searchResults === null || searchResults === void 0 ? void 0 : searchResults[CodeSearchType$1.ICD],
        searchResultsLookupKey: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        debounceTimeout: 200,
        fieldDefinitions: fieldDefinitions,
        handleCodeDelete: handleCodeDelete,
        onCodeSearch: onSearch,
        onCodeSearchSelection: onSearchSelection,
        editMode: editable,
        handleCodeChecked: handleCodeChecked,
        codeDropHandler: codeDropHandler,
        suggestedCodes: suggestedCodes,
        transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        onAddAllCodes: onAddAllCodes,
        onRemoveAllCodes: onRemoveAllCodes,
        codeEdits: codeEdits,
        changedCodes: changedIcdCodes
      })));
    }
  };

  var draggedCodesManager$2 = uiCommon.dragManager.load('codes');
  /**
   * React component that displays a build body
   * @param codableTransaction
   * @param onDropHandler
   * @param onAccordionAction
   * @param items
   * @param onDelete
   * @param editable
   * @returns
   */
  var TransactionBuildBody = function TransactionBuildBody(codableTransaction, onDropHandler, onAccordionAction, items, onDelete, editable) {
    var _codableTransaction$p, _codableTransaction$p2;
    return /*#__PURE__*/React.createElement("div", {
      className: "transaction-bodyV2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "charge-details-header-section"
    }, /*#__PURE__*/React.createElement("h5", null, "Charge details"), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: editable
    }, /*#__PURE__*/React.createElement("div", {
      className: "charge-delete-section",
      onClick: function onClick(e) {
        return onDelete(e);
      }
    }, /*#__PURE__*/React.createElement(uiComponents.Icon, {
      svgIconName: "BiomeDelete",
      svgIconSize: "20",
      svgIconClass: "action-icon delete-icon"
    })))), /*#__PURE__*/React.createElement("div", null, items.length ? /*#__PURE__*/React.createElement(uiComponents.Accordion, {
      onAction: onAccordionAction,
      dragManager: draggedCodesManager$2,
      canDropOnto: canDropOnto,
      onDropHandler: onDropHandler,
      selectable: true,
      droppable: true,
      items: items,
      errors: (_codableTransaction$p = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.errorMessages) !== null && _codableTransaction$p !== void 0 ? _codableTransaction$p : []
    }) : editable ? /*#__PURE__*/React.createElement("div", {
      className: "empty-message editable"
    }, "Add codes in the above section.") : /*#__PURE__*/React.createElement("div", {
      className: "empty-message uneditable"
    }, "No codes selected")));
  };

  /**
   * Updated for new UI design (v2)
   * Changes made:
   * 1. Removed all code related to `ZippedCodeBlock`.
   * 2. Removed `tech` and `pro` code related to modifier codes.
   */


  /**
   * Method that builds an accordion element
   * @param handleUnitsChange
   * @param handleTransactionReorder
   * @param handleCodeDelete
   * @param handleEnableTechPro
   * @param handleDisableTechPro
   * @param onFeatureSelection
   * @param panelActivations
   * @param medicalCode
   * @param idx
   * @param errors
   * @returns
   */
  var transactionAccordianBuilderV2 = function transactionAccordianBuilderV2(handleUnitsChange, handleTransactionReorder, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup, onSearch, onSearchSelection, onAddAllCodes, onRemoveAllCodes, codeDropHandler, onDropHandler, onAccordionAction, onDelete, suggestedCodes, searchResults, invoice, codeEdits, editable, autoFocus, transactionIndex, codableTransaction, transaction) {
    var _invoice$isLoadingTec;
    var errors = arguments.length > 25 && arguments[25] !== undefined ? arguments[25] : [];
    var items = arguments.length > 26 ? arguments[26] : undefined;
    var styleClasses = '';
    var techTransaction = {
      proCode: null,
      techCode: null,
      hasProCode: false,
      hasTechCode: false,
      isProCodeActive: false,
      isTechCodeActive: false,
      proContext: null,
      techContext: null,
      isModifier: false,
      isLoading: false
    };
    techTransaction.isLoading = (_invoice$isLoadingTec = invoice === null || invoice === void 0 ? void 0 : invoice.isLoadingTechPro) !== null && _invoice$isLoadingTec !== void 0 ? _invoice$isLoadingTec : false;
    styleClasses = 'transaction-section';

    // removing procedures with provenance TECH
    if (codableTransaction !== null && codableTransaction !== void 0 && codableTransaction.hasOwnProperty('codes')) {
      codableTransaction.codes = codableTransaction.codes.filter(function (code) {
        return uiCommon.cmxTypeguards.isChargeSessionCode(code);
      }).filter(function (code) {
        return !(code.codeType === 'procedure' && code.provenance === 'TECH');
      });
    }

    // assign tech/pro code if it exists
    var procedureCode = [codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.codes, transaction === null || transaction === void 0 ? void 0 : transaction.codes].flatMap(function (codes) {
      return codes || [];
    }).find(function (code) {
      return uiCommon.cmxTypeguards.isChargeSessionCode(code) && code.codeType === 'procedure';
    });
    if (codableTransaction && procedureCode) {
      var _codableTransaction$m, _codableTransaction$m2, _codableTransaction$t, _codableTransaction$t2, _codableTransaction$m3, _codableTransaction$t3, _codableTransaction$m4, _codableTransaction$t4;
      techTransaction.isModifier = false;
      // add tech/pro for procedure
      techTransaction.proCode = (_codableTransaction$m = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m2 = codableTransaction.mapped_procedure) === null || _codableTransaction$m2 === void 0 ? void 0 : _codableTransaction$m2.procedure_code) !== null && _codableTransaction$m !== void 0 ? _codableTransaction$m : null;
      techTransaction.techCode = (_codableTransaction$t = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t2 = codableTransaction.technical_code) === null || _codableTransaction$t2 === void 0 ? void 0 : _codableTransaction$t2.code) !== null && _codableTransaction$t !== void 0 ? _codableTransaction$t : null;
      techTransaction.hasProCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$m3 = codableTransaction.mapped_procedure) !== null && _codableTransaction$m3 !== void 0 && _codableTransaction$m3.procedure_code);
      techTransaction.hasTechCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$t3 = codableTransaction.technical_code) !== null && _codableTransaction$t3 !== void 0 && _codableTransaction$t3.code);
      techTransaction.isProCodeActive = techTransaction.hasProCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m4 = codableTransaction.mapped_procedure) === null || _codableTransaction$m4 === void 0 ? void 0 : _codableTransaction$m4.active : false;
      techTransaction.isTechCodeActive = techTransaction.hasTechCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t4 = codableTransaction.technical_code) === null || _codableTransaction$t4 === void 0 ? void 0 : _codableTransaction$t4.active : false;
      techTransaction.proContext = {
        transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        mappedProcedure: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) || null
      };
      techTransaction.techContext = {
        transactionGuid: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid,
        technicalCode: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) || null
      };
    }
    return {
      className: classnames(styleClasses),
      header: TransactionHeader(procedureCode, techTransaction, errors, invoice, codeEdits, handleUnitsChange, handleTransactionReorder, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, codeDropHandler, isTimeBasedCode, timeBasedCodePopup, onSearch, onSearchSelection, onAddAllCodes, onRemoveAllCodes, searchResults, codableTransaction, transaction, editable, suggestedCodes, autoFocus, transactionIndex),
      id: 0,
      body: TransactionBuildBody(codableTransaction, onDropHandler, onAccordionAction, items, onDelete, editable)
    };
  };

  var EditorIssueLevel$1 = uiCommon.commonEnums.EditorIssueLevel;

  /**
   * React component that displays a Header
   * @param medicalCode
   * @param techTransaction
   * @param errors
   * @param invoice
   * @param codeEdits
   * @returns
   */
  var MedicalCodeAccordionHeader = function MedicalCodeAccordionHeader(medicalCode, techTransaction, errors, invoice, codeEdits) {
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
      var zippedCode = medicalCode;
      return /*#__PURE__*/React.createElement("div", {
        className: "medical-code-accordion-header icd-code transaction-shared-code-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "move-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-gripper prevent-click"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeGripperSVG20",
        svgIconSize: "20",
        svgIconClass: "gripper"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "codes-column"
      }, zippedCode.codes.map(function (medicalCode, idx) {
        var active = medicalCode.active;
        var classes = classnames(['chip', {
          'shared-code-on': active,
          'shared-code-off': !active
        }]);
        // change icon here... turned off for now.
        var iconName = active ? 'BiomeCheckSVG20' : 'BiomeMinusSVG20';
        return /*#__PURE__*/React.createElement("span", {
          key: medicalCode.code,
          className: "icd-code unclickable prevent-click",
          "data-dd-action-name": active === true ? '~Toggle code off' : '~Toggle code on'
        }, /*#__PURE__*/React.createElement("span", {
          className: "code-chip"
        }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", {
          className: classes
        }, active && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: iconName,
          svgIconSize: "20",
          svgIconClass: "shared-icon"
        }), /*#__PURE__*/React.createElement("span", {
          className: "code-text"
        }, medicalCode.code)))));
      })));
    } else if (uiCommon.cmxTypeguards.isChargeSessionCode(medicalCode)) {
      var _sessionCode$shared, _codeEdits$sessionCod, _sessionCode$evidence;
      var sessionCode = medicalCode;
      //@ts-ignore
      var shared = (_sessionCode$shared = sessionCode.shared) !== null && _sessionCode$shared !== void 0 ? _sessionCode$shared : false;
      var sharedInvoice = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES;
      var uneditableSharedCode = shared && !sharedInvoice;
      var allEdits = (_codeEdits$sessionCod = codeEdits[sessionCode.code]) !== null && _codeEdits$sessionCod !== void 0 ? _codeEdits$sessionCod : [];
      allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel$1.ERROR;
      });
      allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel$1.WARNING;
      });
      var styleClasses = ["medical-code-accordion-header", _defineProperty({
        'code-errors': errors.some(function (error) {
          return error.message_key === 'procedure_code.units.invalid' && sessionCode.codeType === 'procedure' || error.message_key !== 'procedure_code.units.invalid';
        }),
        unitable: sessionCode.unitable,
        editable: sessionCode.editable,
        'uneditable-shared-code': uneditableSharedCode
      }, 'transaction-shared-code', shared), "".concat(sessionCode.provenance.toLowerCase(), "-code")];
      var evidence = (_sessionCode$evidence = sessionCode.evidence) !== null && _sessionCode$evidence !== void 0 ? _sessionCode$evidence : [];
      var hasEvidence = evidence.length > 0;
      var isProcedureCode = sessionCode.codeType === 'procedure';
      var description = sessionCode.description || 'Retrieving description...';
      ['code-units-input', {
        'procedure-code-units-invalid': errors.some(function (error) {
          return error.message_key === 'procedure_code.units.invalid';
        })
      }];
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(sessionCode.code, "-").concat(sessionCode.codeType),
        "data-code": "".concat(sessionCode.code),
        "data-code-type": "".concat(sessionCode.codeType),
        className: classnames(styleClasses)
      }, /*#__PURE__*/React.createElement("div", {
        className: "units-column"
      }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
        on: !isProcedureCode
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-gripper prevent-click"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeGripperSVG20",
        svgIconSize: "20",
        svgIconClass: "gripper"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "codes-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-chip"
      }, /*#__PURE__*/React.createElement("span", {
        className: "chip"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-text"
      }, sessionCode.code)))), /*#__PURE__*/React.createElement("div", {
        title: description,
        className: "qa-description-column description-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ellipsify"
      }, description)), /*#__PURE__*/React.createElement("div", {
        className: "code-actions-column"
      }, hasEvidence && /*#__PURE__*/React.createElement("div", {
        className: "col-evidence code-indicator-cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator"
      }, "CMX"))));
    }
  };

  var FieldNames = {
    reason_for_visit: 'reason for visit',
    work_queue_name: 'work queue',
    procedure_type: 'procedure type',
    procedure_category: 'procedure category',
    exam_type: 'exam type',
    exam_description: 'exam description',
    body_region: 'body part',
    raw_body: 'documentation',
    body: 'documentation'
  };

  function _callSuper$p(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$p() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$p() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$p = function _isNativeReflectConstruct() { return !!t; })(); }
  var evidenceVerb = {
    partial: 'contains',
    complete: 'is',
    mapping: 'is'
  };
  var NoOpFeatureSelection = function NoOpFeatureSelection(feature) {};
  var CaseEvidenceTable2 = /*#__PURE__*/function (_React$Component) {
    function CaseEvidenceTable2(props) {
      var _this;
      _classCallCheck(this, CaseEvidenceTable2);
      _this = _callSuper$p(this, CaseEvidenceTable2, [props]);
      _this.handleClick = _this.handleClick.bind(_this);
      return _this;
    }
    _inherits(CaseEvidenceTable2, _React$Component);
    return _createClass(CaseEvidenceTable2, [{
      key: "handleClick",
      value: function handleClick(ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('span');
        var valuable = target.classList.contains('field-value') ? target : target.closest('.field-value');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('.case-evidence-item.case-evidence-linked');
        if (!valuable || !linkable) return;
        var item = linkable.attributes.getNamedItem('data-index');
        if (!item) return;
        var chargeSessionCode = this.props.chargeSessionCode;
        var currentIndex = parseInt(item.value);
        var evidence = chargeSessionCode.evidence[currentIndex];
        if (evidence) {
          var display = !linkable.classList.contains('case-evidence-active');
          var selectionState = {
            active: display,
            hover: false,
            visible: true
          };
          this.props.onFeatureSelection({
            chargeSessionCode: chargeSessionCode,
            evidence: [evidence],
            selectionState: selectionState
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          chargeSessionCode = _this$props.chargeSessionCode,
          panelActivations = _this$props.panelActivations,
          techTransaction = _this$props.techTransaction;
        var evidence = chargeSessionCode.evidence;
        var evidenceDisplay = evidence.map(function (evida, idx) {
          var _panelActivations$evi, _panelActivations$evi2, _evida$meta$content, _evida$meta;
          var isActive = (_panelActivations$evi = (_panelActivations$evi2 = panelActivations[evida.hash]) === null || _panelActivations$evi2 === void 0 ? void 0 : _panelActivations$evi2.active) !== null && _panelActivations$evi !== void 0 ? _panelActivations$evi : false;
          var styleClasses = ["case-evidence-item", {
            'case-evidence-linked': evida.linkable,
            'case-evidence-active': isActive,
            'sentence-highlight': evida.featureType === uiCommon.commonEnums.EvidenceType.PARTIAL,
            'categorical-highlight': evida.featureType === uiCommon.commonEnums.EvidenceType.COMPLETE
          }];
          var valueClasses = ["field-value", 'highlighted-text', 'sensitive-data'];
          var fieldName = FieldNames[evida.fieldName] || evida.fieldName;
          var verb = evidenceVerb[evida.featureType] || evida.featureType;
          var content = ((_evida$meta$content = (_evida$meta = evida.meta) === null || _evida$meta === void 0 ? void 0 : _evida$meta.content) !== null && _evida$meta$content !== void 0 ? _evida$meta$content : 'N/A').trim();
          if (evida.linkable) {
            content = /*#__PURE__*/React.createElement("a", {
              href: "".concat(evida.identifier)
            }, content);
          }
          return /*#__PURE__*/React.createElement("li", {
            className: classnames(styleClasses),
            key: idx,
            "data-index": idx
          }, "The ", /*#__PURE__*/React.createElement("span", {
            className: "field-name"
          }, fieldName), " ", verb, ' ', /*#__PURE__*/React.createElement("span", {
            className: classnames(valueClasses)
          }, content));
        });
        var codeType = chargeSessionCode.codeType.toLowerCase();
        var classes = ['case-evidence-table', 'case-evidence-table2', 'col-artifacts', "case-evidence-".concat(codeType)];
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(classes)
        }, (techTransaction.hasProCode || techTransaction.hasTechCode) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "BILLING DETAILS"), /*#__PURE__*/React.createElement("ul", {
          className: "case-evidence-list"
        }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
          className: "qa-empty-message empty-item-message tech-item"
        }, (techTransaction.isProCodeActive || techTransaction.isTechCodeActive) && /*#__PURE__*/React.createElement("div", {
          className: "case-evidence-item"
        }, "This ", codeType === 'procedure' ? 'charge' : 'modifier', ' ', "will be submitted", ' ', codeType === 'procedure' ? 'as' : 'with', ' ', /*#__PURE__*/React.createElement("b", null, techTransaction.isProCodeActive && techTransaction.proCode), techTransaction.isProCodeActive && techTransaction.isTechCodeActive && ' and ', /*#__PURE__*/React.createElement("b", null, techTransaction.isTechCodeActive && techTransaction.techCode)), !techTransaction.isProCodeActive && !techTransaction.isTechCodeActive && /*#__PURE__*/React.createElement("div", {
          className: "case-evidence-item"
        }, "The charge will not be submitted without a billing designation."))))), evidence.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "WHY WE SELECTED ", chargeSessionCode.code), /*#__PURE__*/React.createElement("ol", {
          onClick: this.handleClick,
          className: "case-evidence-list"
        }, evidenceDisplay)) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, "NO EVIDENCE AT THE MOMENT"), /*#__PURE__*/React.createElement("ul", {
          className: "case-evidence-list"
        }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
          className: "qa-empty-message empty-item-message no-evidence"
        }, "There is no displayable evidence at this time.")))));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseEvidenceTable2, "displayName", 'CaseEvidenceTable2');
  _defineProperty(CaseEvidenceTable2, "defaultProps", {
    onFeatureSelection: NoOpFeatureSelection,
    panelActivations: {},
    techTransaction: {}
  });

  /**
   * This component is part of the new UI design (v2).
   *
   * This component renders the body section of transaction-body items.
   * It displays the following details:
   * 1) Errors
   * 2) Billing Details
   * 3) Evidence
   *
   */

  /**
   * @param medicalCode
   * @param techTransaction
   * @param panelActivations
   * @param codeEdits
   * @param onFeatureSelection
   * @returns
   */
  var MedicalCodeAccordionBuildBody = function MedicalCodeAccordionBuildBody(medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection) {
    var styleClasses = ["code-header", "code-body", 'transaction-body'];
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } else {
      var sessionCode = medicalCode;
      var messages = codeEdits[sessionCode.code] ? formatEditGroup(codeEdits[sessionCode.code], 0) : false;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(styleClasses)
      }, /*#__PURE__*/React.createElement("div", {
        className: "case-evidence-container"
      }, messages && /*#__PURE__*/React.createElement("div", {
        className: "col-artifacts message-wrap"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-code"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-artifacts col-messages"
      }, messages)), /*#__PURE__*/React.createElement(CaseEvidenceTable2, {
        panelActivations: panelActivations,
        onFeatureSelection: onFeatureSelection,
        chargeSessionCode: sessionCode,
        techTransaction: techTransaction
      })));
    }
  };

  /**
   * This component is part of the new UI design (v2).
   * This component is responsible for creating transaction-body items.
   *
   * Each item is created using:
   * 1) medical-code-aAccordion-header for the header section.
   * 2) medical-code-accordion-body  for the body content.
   *
   * It manages the rendering and structure of these components within the transaction body.
   */

  var ChargeSessionCodeType$1 = uiCommon.commonEnums.ChargeSessionCodeType;
  var DRAGGABLE_CODES$1 = new Set([ChargeSessionCodeType$1.MODIFIER, ChargeSessionCodeType$1.DIAGNOSIS]);

  /**
   * Method that builds an accordion element
   * @param onFeatureSelection
   * @param panelActivations
   * @param codeEdits
   * @param medicalCode
   * @param idx
   * @param errors
   * @returns
   */
  var medicalCodeAccordianBuilder = function medicalCodeAccordianBuilder(onFeatureSelection, panelActivations, invoice, codeEdits, medicalCode, idx, codableTransaction) {
    var _invoice$isLoadingTec;
    var errors = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [];
    var styleClasses = '';
    var techTransaction = {
      proCode: null,
      techCode: null,
      hasProCode: false,
      hasTechCode: false,
      isProCodeActive: false,
      isTechCodeActive: false,
      proContext: null,
      techContext: null,
      isModifier: false,
      isLoading: false
    };
    techTransaction.isLoading = (_invoice$isLoadingTec = invoice === null || invoice === void 0 ? void 0 : invoice.isLoadingTechPro) !== null && _invoice$isLoadingTec !== void 0 ? _invoice$isLoadingTec : false;
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) ; else {
      var _codableTransaction$p;
      var sessionCode = medicalCode;
      styleClasses = "".concat(sessionCode.codeType, "-section");
      var modifierTransaction = (sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === 'modifier' ? codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.modifiers.find(function (codableTransacMod) {
        return codableTransacMod.modifier_code === sessionCode.code;
      }) : null;

      // assign tech/pro code if it exists
      if ((sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === uiCommon.commonEnums.CodeTypes.PROCEDURE && (codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p = codableTransaction.procedure) === null || _codableTransaction$p === void 0 ? void 0 : _codableTransaction$p.procedure_code) === (sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.code)) {
        var _codableTransaction$m, _codableTransaction$m2, _codableTransaction$t, _codableTransaction$t2, _codableTransaction$m3, _codableTransaction$t3, _codableTransaction$m4, _codableTransaction$t4;
        techTransaction.isModifier = false;
        // add tech/pro for procedure
        techTransaction.proCode = (_codableTransaction$m = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m2 = codableTransaction.mapped_procedure) === null || _codableTransaction$m2 === void 0 ? void 0 : _codableTransaction$m2.procedure_code) !== null && _codableTransaction$m !== void 0 ? _codableTransaction$m : null;
        techTransaction.techCode = (_codableTransaction$t = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t2 = codableTransaction.technical_code) === null || _codableTransaction$t2 === void 0 ? void 0 : _codableTransaction$t2.code) !== null && _codableTransaction$t !== void 0 ? _codableTransaction$t : null;
        techTransaction.hasProCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$m3 = codableTransaction.mapped_procedure) !== null && _codableTransaction$m3 !== void 0 && _codableTransaction$m3.procedure_code);
        techTransaction.hasTechCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$t3 = codableTransaction.technical_code) !== null && _codableTransaction$t3 !== void 0 && _codableTransaction$t3.code);
        techTransaction.isProCodeActive = techTransaction.hasProCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m4 = codableTransaction.mapped_procedure) === null || _codableTransaction$m4 === void 0 ? void 0 : _codableTransaction$m4.active : false;
        techTransaction.isTechCodeActive = techTransaction.hasTechCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t4 = codableTransaction.technical_code) === null || _codableTransaction$t4 === void 0 ? void 0 : _codableTransaction$t4.active : false;
        techTransaction.proContext = {
          transactionGuid: codableTransaction.guid,
          mappedProcedure: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) || null
        };
        techTransaction.techContext = {
          transactionGuid: codableTransaction.guid,
          technicalCode: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) || null
        };
      } else if ((sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === uiCommon.commonEnums.CodeTypes.MODIFIER) {
        // case for modifiers
        techTransaction.isModifier = true;
        if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === uiCommon.commonEnums.ModifierTypes.PRO) {
          var _ref, _codableTransaction$m5, _codableTransaction$m6, _codableTransaction$p2;
          techTransaction.proCode = (_ref = (_codableTransaction$m5 = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m6 = codableTransaction.mapped_procedure) === null || _codableTransaction$m6 === void 0 ? void 0 : _codableTransaction$m6.procedure_code) !== null && _codableTransaction$m5 !== void 0 ? _codableTransaction$m5 : codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.procedure_code) !== null && _ref !== void 0 ? _ref : '';
          techTransaction.hasProCode = true;
          techTransaction.isProCodeActive = true;
        } else if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === uiCommon.commonEnums.ModifierTypes.TECH) {
          var _codableTransaction$t5, _codableTransaction$t6;
          techTransaction.techCode = (_codableTransaction$t5 = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t6 = codableTransaction.technical_code) === null || _codableTransaction$t6 === void 0 ? void 0 : _codableTransaction$t6.code) !== null && _codableTransaction$t5 !== void 0 ? _codableTransaction$t5 : '';
          techTransaction.hasTechCode = true;
          techTransaction.isTechCodeActive = true;
        }
      }
    }
    return {
      className: classnames(styleClasses),
      header: MedicalCodeAccordionHeader(medicalCode, techTransaction, errors, invoice, codeEdits),
      data: medicalCode,
      selectable: !uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode),
      //@ts-ignore
      draggable: DRAGGABLE_CODES$1.has(medicalCode.codeType),
      id: "".concat(idx),
      body: MedicalCodeAccordionBuildBody(medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection),
      open: false
    };
  };

  var _excluded$b = ["chargeSession", "codableTransaction", "lineNumber", "editable", "invoice", "onCodeSearch", "handleCodeChange", "handleCodeSearchDrop", "handleCodeRemove", "canDropOnto", "searchResults", "codeSearchResultsV2", "onCodeSearchSelection", "onFeatureSelection", "onChargeSessionAction", "onEdit", "autoFocus", "panelActivations", "processInstance", "transaction", "debounceTimeout", "codeEdits", "suggestedCodes", "onTransactionSharedDiagnosisChange", "transactionIndex"];
  function ownKeys$u(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$u(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$u(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$u(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$o(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$o() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$o() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$o = function _isNativeReflectConstruct() { return !!t; })(); }
  var ChargeSessionCodeProvenance$1 = uiCommon.commonEnums.ChargeSessionCodeProvenance;
    uiCommon.commonEnums.CodeSearchType;
  var draggedCodesManager$1 = uiCommon.dragManager.load('codes');
  var sharedCodePredicate$1 = function sharedCodePredicate(code) {
    //@ts-ignore
    return code.shared === true;
  };
  var notSharedCodePredicate$1 = function notSharedCodePredicate(code) {
    //@ts-ignore
    return !(code.shared === true);
  };

  /**
   * Method that get data from codable object
   * @param element
   * @param codable
   * @returns
   */
  var getDataItem$1 = function getDataItem(element, codable) {
    var parent = element.closest('.transaction-headerV2');
    if (parent) {
      var codeId = parent.attributes.getNamedItem('data-code');
      var codeType = parent.attributes.getNamedItem('data-code-type');
      if (codeId && codeType) {
        var _codable$codes$find;
        return (_codable$codes$find = codable.codes.find(function (code) {
          if (!uiCommon.cmxTypeguards.isChargeSessionCode(code)) return false;
          var sessionCode = code;
          return "".concat(sessionCode.code) === "".concat(codeId.value) && sessionCode.codeType === "".concat(codeType.value);
        })) !== null && _codable$codes$find !== void 0 ? _codable$codes$find : null;
      }
    }
    return null;
  };

  /**
   * Method that get data from codable object
   * @param element
   * @param codable
   * @returns
   */
  var getChipDataItem = function getChipDataItem(element, codeInfo, codable) {
    var chipElement = !!element ? element === null || element === void 0 ? void 0 : element.closest('.medical-code-chip') : null;
    var canProceed = !!chipElement || !!codeInfo;
    if (canProceed) {
      var _chipElement$attribut, _chipElement$attribut2;
      var codeId = !!codeInfo ? codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code : chipElement === null || chipElement === void 0 || (_chipElement$attribut = chipElement.attributes) === null || _chipElement$attribut === void 0 || (_chipElement$attribut = _chipElement$attribut.getNamedItem('data-code')) === null || _chipElement$attribut === void 0 ? void 0 : _chipElement$attribut.value;
      var codeType = uiCommon.caseUtils.getCodeTypeFullname(!!codeInfo ? codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType : chipElement === null || chipElement === void 0 || (_chipElement$attribut2 = chipElement.attributes) === null || _chipElement$attribut2 === void 0 || (_chipElement$attribut2 = _chipElement$attribut2.getNamedItem('data-code-type')) === null || _chipElement$attribut2 === void 0 ? void 0 : _chipElement$attribut2.value);
      if (codeId && codeType) {
        var _codable$codes$find2;
        return (_codable$codes$find2 = codable.codes.find(function (code) {
          if (!uiCommon.cmxTypeguards.isChargeSessionCode(code)) return false;
          var sessionCode = code;
          return "".concat(sessionCode.code) === "".concat(codeId) && sessionCode.codeType === "".concat(codeType);
        })) !== null && _codable$codes$find2 !== void 0 ? _codable$codes$find2 : null;
      }
    }
    return null;
  };

  /**
   * Class React component for render a transaction
   */
  var TransactionV2 = /*#__PURE__*/function (_React$Component) {
    function TransactionV2(props) {
      var _this;
      _classCallCheck(this, TransactionV2);
      _this = _callSuper$o(this, TransactionV2, [props]);
      _defineProperty(_this, "lookupRef", void 0);
      _defineProperty(_this, "accordionPanelRef", /*#__PURE__*/React.createRef());
      _defineProperty(_this, "triggerRef", /*#__PURE__*/React.createRef());
      _defineProperty(_this, "observer", null);
      _defineProperty(_this, "currentUnit", void 0);
      _defineProperty(_this, "isTimeBasedCode", function () {
        var _this$props$codableTr;
        return (_this$props$codableTr = _this.props.codableTransaction) === null || _this$props$codableTr === void 0 || (_this$props$codableTr = _this$props$codableTr.procedure) === null || _this$props$codableTr === void 0 ? void 0 : _this$props$codableTr.time_based;
      });
      _defineProperty(_this, "handleTimeBasedCodeAdd", function (ev, time, age) {
        ev.preventDefault();
        ev.stopPropagation();
        var _this$props = _this.props,
          chargeSession = _this$props.chargeSession,
          codableTransaction = _this$props.codableTransaction;
        var element = ev.target;
        var dataItem = getDataItem$1(element, codableTransaction || chargeSession);
        var changeDetail = {
          codes: [dataItem],
          context: {
            chargeSession: _objectSpread$u({}, _this.props.chargeSession),
            transaction: _objectSpread$u({}, _this.props.codableTransaction),
            invoice: _objectSpread$u({}, _this.props.invoice),
            processInstance: _objectSpread$u({}, _this.props.processInstance)
          }
        };
        _this.props.handleTimeBasedCodeAdd(changeDetail, time, age);
        if (_this.lookupRef.current) {
          _this.lookupRef.current.focus();
        }
      });
      _defineProperty(_this, "handleTimeBasedCodeUpdate", function (ev, time, age) {
        ev.preventDefault();
        ev.stopPropagation();
        var _this$props2 = _this.props,
          chargeSession = _this$props2.chargeSession,
          codableTransaction = _this$props2.codableTransaction;
        var element = ev.target;
        var dataItem = getDataItem$1(element, codableTransaction || chargeSession);
        var changeDetail = {
          codes: [dataItem],
          context: {
            chargeSession: _objectSpread$u({}, _this.props.chargeSession),
            transaction: _objectSpread$u({}, _this.props.codableTransaction),
            invoice: _objectSpread$u({}, _this.props.invoice),
            processInstance: _objectSpread$u({}, _this.props.processInstance)
          }
        };
        _this.props.handleTimeBasedCodeUpdate(changeDetail, time, age);
        if (_this.lookupRef.current) {
          _this.lookupRef.current.focus();
        }
      });
      _defineProperty(_this, "isClockIconDisabled", function () {
        var _this$props$codableTr2, _invoice$transactions;
        var procedure = (_this$props$codableTr2 = _this.props.codableTransaction) === null || _this$props$codableTr2 === void 0 ? void 0 : _this$props$codableTr2.procedure;
        var invoice = _this.props.invoice;
        return procedure && (invoice === null || invoice === void 0 || (_invoice$transactions = invoice.transactions) === null || _invoice$transactions === void 0 ? void 0 : _invoice$transactions.some(function (transaction) {
          var _transaction$procedur;
          return (transaction === null || transaction === void 0 || (_transaction$procedur = transaction.procedure) === null || _transaction$procedur === void 0 ? void 0 : _transaction$procedur.add_on_code_id) === (procedure === null || procedure === void 0 ? void 0 : procedure.additionalProperties['id']);
        }));
      });
      //handle this manually so we can unmount it
      _defineProperty(_this, "handlePopoverClose", function (newState) {
        _this.setState({
          clickTriggered: newState
        });
      });
      _defineProperty(_this, "timeBasedCodePopup", function () {
        var _this$accordionPanelR, _this$props$codableTr3, _this$props$codableTr4, _this$props$codableTr5, _this$props$codableTr6;
        // Only allow the popover to be open if the trigger is in view
        var popoverState = _this.state.clickTriggered && _this.state.isTriggerInView;
        var handlePopoverOpen = function handlePopoverOpen(ev) {
          // Prevents the default behavior of the click event
          ev.stopPropagation();

          // Toggle the state when the user clicks to open the popover manually
          _this.setState({
            clickTriggered: !_this.state.clickTriggered
          });
        };
        return /*#__PURE__*/React.createElement(Popover, {
          isOpen: popoverState,
          placement: "bottom-end",
          variant: "time",
          trigger: "click",
          flip: true,
          preventOverflow: false,
          boundary: ((_this$accordionPanelR = _this.accordionPanelRef) === null || _this$accordionPanelR === void 0 ? void 0 : _this$accordionPanelR.current) || 'scrollParent'
        }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement(Button, {
          ref: _this.triggerRef,
          "aria-label": "",
          variant: "clock",
          disabled: !_this.props.editable || _this.isClockIconDisabled(),
          onClick: handlePopoverOpen
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeClock",
          svgIconSize: "20",
          svgIconClass: (_this$props$codableTr3 = _this.props.codableTransaction) !== null && _this$props$codableTr3 !== void 0 && (_this$props$codableTr3 = _this$props$codableTr3.procedure) !== null && _this$props$codableTr3 !== void 0 && _this$props$codableTr3.time_based && (_this$props$codableTr4 = _this.props.codableTransaction) !== null && _this$props$codableTr4 !== void 0 && (_this$props$codableTr4 = _this$props$codableTr4.procedure) !== null && _this$props$codableTr4 !== void 0 && _this$props$codableTr4.total_time ? 'grey-clock' : 'color-clock'
        }), ((_this$props$codableTr5 = _this.props.codableTransaction) === null || _this$props$codableTr5 === void 0 || (_this$props$codableTr5 = _this$props$codableTr5.procedure) === null || _this$props$codableTr5 === void 0 ? void 0 : _this$props$codableTr5.time_based) && ((_this$props$codableTr6 = _this.props.codableTransaction) === null || _this$props$codableTr6 === void 0 || (_this$props$codableTr6 = _this$props$codableTr6.procedure) === null || _this$props$codableTr6 === void 0 ? void 0 : _this$props$codableTr6.total_time) && /*#__PURE__*/React.createElement("div", {
          className: "total-time"
        }, _this.props.codableTransaction.procedure.total_time))), /*#__PURE__*/React.createElement(Portal, null, popoverState && /*#__PURE__*/React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement(PopoverArrow, null), /*#__PURE__*/React.createElement(PopoverBody, null, /*#__PURE__*/React.createElement(TimeBasedCodePopover, {
          codableTransaction: _this.props.codableTransaction,
          handleTimeBasedCodeAdd: _this.handleTimeBasedCodeAdd,
          handleTimeBasedCodeUpdate: _this.handleTimeBasedCodeUpdate,
          processInstance: _this.props.processInstance,
          popoverState: popoverState,
          updatePopoverState: _this.handlePopoverClose
        })))));
      });
      _defineProperty(_this, "toggleAccordion", function () {
        _this.setState(function (prevState) {
          return {
            isTransactionRowOpen: !prevState.isTransactionRowOpen
          };
        });
      });
      _this.handleUnitsChange = _this.handleUnitsChange.bind(_this);
      _this.handleTransactionReorder = _this.handleTransactionReorder.bind(_this);
      _this.handleCodeDelete = _this.handleCodeDelete.bind(_this);
      _this.handleCodesDelete = _this.handleCodesDelete.bind(_this);
      _this.onSearch = _this.onSearch.bind(_this);
      _this.onSearchSelection = _this.onSearchSelection.bind(_this);
      _this.onAddAllCodes = _this.onAddAllCodes.bind(_this);
      _this.onRemoveAllCodes = _this.onRemoveAllCodes.bind(_this);
      _this.onDropHandler = _this.onDropHandler.bind(_this);
      _this.onDragOver = _this.onDragOver.bind(_this);
      _this.onDrop = _this.onDrop.bind(_this);
      _this.onDragLeave = _this.onDragLeave.bind(_this);
      _this.onDelete = _this.onDelete.bind(_this);
      _this.onAccordionAction = _this.onAccordionAction.bind(_this);
      _this.handleCodeChecked = _this.handleCodeChecked.bind(_this);
      _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
      _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
      _this.isTimeBasedCode = _this.isTimeBasedCode.bind(_this);
      _this.timeBasedCodePopup = _this.timeBasedCodePopup.bind(_this);
      _this.codeDropHandler = _this.codeDropHandler.bind(_this);
      _this.lookupRef = /*#__PURE__*/React.createRef();
      _this.state = {
        dragHover: false,
        clickTriggered: false,
        //is the popover open
        hasTimeOpened: false,
        //has the popover been opened before in this session
        isTransactionRowOpen: false,
        isTriggerInView: true,
        //is the popover trigger in the scroll area
        isHidingWhileOutOfView: false //is the trigger out of view and the popover needs to be hidden
      };
      return _this;
    }

    /****/
    // Watch for the Popover trigger to go out of view and close it
    /****/
    _inherits(TransactionV2, _React$Component);
    return _createClass(TransactionV2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Create an intersection observer to watch the trigger
        this.setupIntersectionObserver();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        // Clean up the observer when component unmounts
        if (this.observer) {
          this.observer.disconnect();
        }
      }

      // Set up the intersection observer
    }, {
      key: "setupIntersectionObserver",
      value: function setupIntersectionObserver() {
        var _this$props$scrollCon,
          _this2 = this;
        // First, clean up any existing observer
        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }

        // Don't proceed if there's no scroll container
        if (!((_this$props$scrollCon = this.props.scrollContainerRef) !== null && _this$props$scrollCon !== void 0 && _this$props$scrollCon.current)) {
          // Schedule another attempt if the ref isn't ready
          setTimeout(function () {
            return _this2.setupIntersectionObserver();
          }, 100);
          return;
        }

        // Don't set up observer if trigger ref isn't available
        if (!this.triggerRef.current) {
          return; // We'll set it up when the ref becomes available
        }
        var options = {
          root: this.props.scrollContainerRef.current,
          rootMargin: '0px',
          threshold: 0.1
        };
        this.observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var isInView = entry.isIntersecting;
            _this2.setState({
              isTriggerInView: isInView
            });

            // If trigger scrolls out of view while popover is open, close it
            if (!isInView && _this2.state.clickTriggered) {
              _this2.setState({
                isHidingWhileOutOfView: true,
                clickTriggered: false
              });
            }

            // If trigger scrolls into view after it had been temp closed, open it again
            if (isInView && _this2.state.isHidingWhileOutOfView) {
              _this2.setState({
                isHidingWhileOutOfView: false,
                clickTriggered: true
              });
            }
          });
        }, options);

        // Start observing the trigger element
        this.observer.observe(this.triggerRef.current);
      }

      // Update the component after ref is attached
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState) {
        var _prevProps$codableTra,
          _this$props$codableTr7,
          _prevProps$scrollCont,
          _this$props$scrollCon2,
          _this3 = this;
        // Check if new procedure code was added
        var prevProcedure = (_prevProps$codableTra = prevProps.codableTransaction) === null || _prevProps$codableTra === void 0 ? void 0 : _prevProps$codableTra.procedure;
        var newProcedure = (_this$props$codableTr7 = this.props.codableTransaction) === null || _this$props$codableTr7 === void 0 ? void 0 : _this$props$codableTr7.procedure;
        var procedureCodeChanged = (prevProcedure === null || prevProcedure === void 0 ? void 0 : prevProcedure.procedure_code) !== (newProcedure === null || newProcedure === void 0 ? void 0 : newProcedure.procedure_code);

        // Check if accordion was just opened
        var accordionJustOpened = !prevState.isTransactionRowOpen && this.state.isTransactionRowOpen;
        var scrollContainerChanged = ((_prevProps$scrollCont = prevProps.scrollContainerRef) === null || _prevProps$scrollCont === void 0 ? void 0 : _prevProps$scrollCont.current) !== ((_this$props$scrollCon2 = this.props.scrollContainerRef) === null || _this$props$scrollCon2 === void 0 ? void 0 : _this$props$scrollCon2.current);

        // If procedure code changed, reset all popover-related states
        if (procedureCodeChanged) {
          this.setState({
            clickTriggered: false,
            hasTimeOpened: false,
            isTriggerInView: true,
            isHidingWhileOutOfView: false
          });
        }

        // This is commented out until we can control the auto open with a config
        // Handle auto-opening for time-based codes
        /* if (newProcedure && 
          !this.state.clickTriggered && 
          !this.state.hasTimeOpened &&
          newProcedure.time_based && 
          newProcedure.add_on_code_available && 
          !newProcedure.total_time) {
        
          // When we need to auto-open, give the DOM time to render first
          setTimeout(() => {
            this.setState({ 
              clickTriggered: true, 
              hasTimeOpened: true,
              isTriggerInView: true,
              isHidingWhileOutOfView: false
            }, () => {
              // After state is updated and component re-renders, set up the observer
              setTimeout(() => this.setupIntersectionObserver(), 50);
              });
            }, 100);
        }  */

        // Always ensure the observer is set up correctly after key changes
        if (accordionJustOpened || scrollContainerChanged || this.state.clickTriggered && !prevState.clickTriggered) {
          setTimeout(function () {
            return _this3.setupIntersectionObserver();
          }, 50);
        }
      }

      /**
       * Event for drag over
       * @param ev
       */
    }, {
      key: "onDragOver",
      value: function onDragOver(ev) {
        var data = draggedCodesManager$1.get();
        var searchResult = uiCommon.cmxTypeguards.isSearchResult(data);
        if (searchResult) {
          var _this$props3 = this.props,
            codableTransaction = _this$props3.codableTransaction,
            chargeSession = _this$props3.chargeSession;
          var hasCPT = (codableTransaction || chargeSession).codes.filter(uiCommon.cmxTypeguards.isChargeSessionCode).some(function (sessionCode) {
            return sessionCode.provenance.toUpperCase() === ChargeSessionCodeProvenance$1.CPT.toUpperCase();
          });
          var allowed = data.codeType.toUpperCase() === ChargeSessionCodeProvenance$1.CPT ? !hasCPT : true;
          if (allowed) {
            ev.dataTransfer.dropEffect = 'copy';
            ev.preventDefault();
            if (!this.state.dragHover) {
              this.setState({
                dragHover: true
              });
            }
          }
        }
      }

      /**
       * Event for drag leaves
       * @param ev
       */
    }, {
      key: "onDragLeave",
      value: function onDragLeave(ev) {
        if (this.state.dragHover) {
          this.setState({
            dragHover: false
          });
        }
        ev.dataTransfer.dropEffect = 'none';
      }

      /**
       * Event for drag drops
       * @param ev
       */
    }, {
      key: "onDrop",
      value: function onDrop(ev) {
        var searchResult = draggedCodesManager$1.parseEvent(ev);
        draggedCodesManager$1.clear();
        var codableTransaction = this.props.codableTransaction;
        if (codableTransaction) {
          var codes = codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).filter(function (sessionCode) {
            return sessionCode.codeType.toUpperCase() === searchResult.codeType.toUpperCase();
          });
          var result = _objectSpread$u(_objectSpread$u({}, searchResult), {}, {
            context: {
              invoice: _objectSpread$u({}, this.props.invoice),
              transaction: _objectSpread$u({}, this.props.codableTransaction),
              chargeSession: _objectSpread$u({}, this.props.chargeSession),
              processInstance: _objectSpread$u({}, this.props.processInstance)
            }
          });
          codes.push(result);
          this.props.onCodeSearchSelection(_objectSpread$u(_objectSpread$u({}, searchResult), {}, {
            context: {
              chargeSession: _objectSpread$u({}, this.props.chargeSession)
            }
          }));
          this.setState({
            dragHover: false
          });
          if (this.lookupRef.current) {
            this.lookupRef.current.reset();
            this.lookupRef.current.focus();
          }
        }
      }

      /**
       * Event for handle drag drop
       * @param ev
       */
    }, {
      key: "onDropHandler",
      value: function onDropHandler(dropAction) {
        var _this$props4 = this.props,
          chargeSession = _this$props4.chargeSession,
          codableTransaction = _this$props4.codableTransaction;
        var dropCandidate = dropAction.dropCandidate,
          dropTarget = dropAction.dropTarget;
        var sameCodeType = "".concat(dropCandidate.codeType).toUpperCase() === "".concat(dropTarget.codeType).toUpperCase();
        var matchCodes = function matchCodes(sessionCode) {
          var matchType = "".concat(sessionCode.codeType).toUpperCase() === "".concat(dropCandidate.codeType).toUpperCase();
          var matchProvenance = "".concat(sessionCode.provenance).toUpperCase() === "".concat(dropCandidate.codeType).toUpperCase();
          if (matchProvenance || matchType) {
            return sessionCode.code !== dropCandidate.code;
          }
          return false;
        };
        // remove the code from our code list
        var codes = (codableTransaction || chargeSession).codes.filter(matchCodes).filter(uiCommon.cmxTypeguards.isChargeSessionCode);
        var searchResult = uiCommon.cmxTypeguards.isSearchResult(dropCandidate);
        var dropCode = dropCandidate;
        if (searchResult) {
          dropCode = {
            code: dropCandidate.code,
            codeType: dropCandidate.codeType,
            description: dropCandidate.description
          };
          var targetPosition = codes.findIndex(function (sessionCode) {
            return sessionCode.code === dropTarget.code;
          });
          if (dropAction.position === 'after') {
            targetPosition++;
          }
          codes.splice(targetPosition, 0, dropCode);
          if (this.lookupRef.current) {
            this.lookupRef.current.reset();
            this.lookupRef.current.focus();
          }
        } else {
          // if the codes are of the same code type
          // then a drop is just a reordering of the same codes
          // if a drop is on a different code type, then we need
          // to do something different.
          if (sameCodeType) {
            var targetCode = dropTarget.code;
            if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropCode)) {
              var zippedDropCode = dropCode;
              var blockSet = new Set(zippedDropCode.codes.map(function (code) {
                return code.code;
              }));
              var filteredArray = _toConsumableArray(codes).filter(function (code) {
                return !blockSet.has(code.code);
              });
              var seekPosition = filteredArray.findIndex(function (sessionCode) {
                return sessionCode.code === dropTarget.code;
              });
              if (dropAction.position === 'after') {
                seekPosition++;
              }
              filteredArray.splice.apply(filteredArray, [seekPosition, 0].concat(_toConsumableArray(zippedDropCode.codes)));
              codes = filteredArray;

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (shared row moved)', {});
            } else {
              // if this is a shared code block then we need to rewind to the
              // front of the shared codes
              var codeIncrement = 1;
              if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropTarget)) {
                var zippedDropTarget = dropTarget;
                var _zippedDropTarget$cod = _slicedToArray(zippedDropTarget.codes, 1),
                  firstCode = _zippedDropTarget$cod[0];
                targetCode = firstCode.code;
                codeIncrement = zippedDropTarget.codes.length;
              }
              var _targetPosition = codes.findIndex(function (sessionCode) {
                return sessionCode.code === targetCode;
              });
              if (dropAction.position === 'after') {
                _targetPosition += codeIncrement;
              }
              codes.splice(_targetPosition, 0, dropCandidate);
            }

            // capturing the drag complete for Datadog Action
            // @ts-ignore
            window.DD_RUM.addAction('Drag (any code row moved)', {});
          } else {
            if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropCandidate)) {
              var zippedDropCandidate = dropCandidate;
              var _blockSet = new Set(zippedDropCandidate.codes.map(function (code) {
                return code.code;
              }));
              var _filteredArray = _toConsumableArray(codes).filter(function (code) {
                return !_blockSet.has(code.code);
              });
              var _seekPosition = _filteredArray.findIndex(function (sessionCode) {
                return sessionCode.code === dropTarget.code;
              });
              if (dropAction.position === 'after') {
                _seekPosition++;
              }
              _filteredArray.splice.apply(_filteredArray, [_seekPosition, 0].concat(_toConsumableArray(zippedDropCandidate.codes)));
              codes = _filteredArray;

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (shared row moved to top)', {});
            } else {
              // there is a defined visual order of codes
              // PROCEDURES, MODIFIERS, DX
              // if this changes, then the order will need to be updated
              var dropIndex = CODE_ORDER.get("".concat(dropCandidate.codeType));
              var dropTargetIndex = CODE_ORDER.get("".concat(dropTarget.codeType));
              if (dropIndex < dropTargetIndex) {
                codes.push(dropCandidate);
              } else {
                codes.unshift(dropCandidate);
              }

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (invoice code row move to top)', {});
            }
          }
        }
        var changeDetail = {
          codes: codes,
          context: {
            chargeSession: _objectSpread$u({}, this.props.chargeSession),
            invoice: _objectSpread$u({}, this.props.invoice),
            transaction: _objectSpread$u({}, this.props.codableTransaction),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          }
        };
        this.props.handleCodeSearchDrop(changeDetail);
        this.setState({
          dragHover: false
        });
      }
    }, {
      key: "codeDropHandler",
      value: function codeDropHandler(codes) {
        var changeDetail = {
          codes: codes,
          context: {
            chargeSession: _objectSpread$u({}, this.props.chargeSession),
            invoice: _objectSpread$u({}, this.props.invoice),
            transaction: _objectSpread$u({}, this.props.codableTransaction),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          }
        };
        this.props.handleCodeSearchDrop(changeDetail);
      }

      /**
       * Event launched when a search is performed
       * @param ev
       */
    }, {
      key: "onSearch",
      value: function onSearch(codeQuery) {
        this.props.onCodeSearch(_objectSpread$u(_objectSpread$u({}, codeQuery), {}, {
          context: {
            transaction: _objectSpread$u({}, this.props.codableTransaction),
            invoice: _objectSpread$u({}, this.props.invoice),
            chargeSession: _objectSpread$u({}, this.props.chargeSession),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          }
        }));
      }

      /**
       * Event launched when a search selection is pressed
       * @param ev
       */
    }, {
      key: "onSearchSelection",
      value: function onSearchSelection(searchResult) {
        var present = this.props.codableTransaction.codes.findIndex(function (code) {
          return code.code === searchResult.codeInfo.code;
        });
        var searchSelection = {
          codeInfo: searchResult.codeInfo,
          additionalCodes: (searchResult === null || searchResult === void 0 ? void 0 : searchResult.additionalCodes) || [],
          context: _objectSpread$u(_objectSpread$u({}, searchResult.context), {}, {
            defaultPrevented: present !== -1,
            invoice: _objectSpread$u({}, this.props.invoice),
            transaction: _objectSpread$u({}, this.props.codableTransaction),
            chargeSession: _objectSpread$u({}, this.props.chargeSession),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          })
        };
        this.props.onCodeSearchSelection(searchSelection);
      }
    }, {
      key: "onAddAllCodes",
      value: function onAddAllCodes(codes) {
        var _this4 = this;
        var filteredResults = codes.filter(function (result) {
          var present = _this4.props.codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).some(function (sessionCode) {
            return sessionCode.code === result.code && sessionCode.provenance === result.codeType;
          });

          // Keep the code if it is not existing code
          return !present;
        });
        var searchSelection = {
          codesInfo: filteredResults,
          context: {
            invoice: _objectSpread$u({}, this.props.invoice),
            transaction: _objectSpread$u({}, this.props.codableTransaction),
            chargeSession: _objectSpread$u({}, this.props.chargeSession),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          }
        };
        this.props.handleAddAllCodes(searchSelection);
      }
    }, {
      key: "onRemoveAllCodes",
      value: function onRemoveAllCodes(codes) {
        var _this5 = this;
        var _this$props5 = this.props,
          chargeSession = _this$props5.chargeSession,
          codableTransaction = _this$props5.codableTransaction;
        var codeList = [];
        var existingCodes = codes.filter(function (result) {
          var present = _this5.props.codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).some(function (sessionCode) {
            return sessionCode.code === result.code && sessionCode.provenance === result.codeType;
          });

          // Keep the code if it is existing code
          return present;
        });
        existingCodes.forEach(function (codeInfo) {
          var chipDataItem = getChipDataItem(null, codeInfo, codableTransaction || chargeSession);
          if (chipDataItem) {
            codeList.push(codeInfo);
          }
        });
        this.handleCodesDelete(codeList);
      }

      /**
       * Event launched when a code is deleted triggered with click on code chip x
       * @param ev
       */
    }, {
      key: "handleCodeDelete",
      value: function handleCodeDelete(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.editable) {
          var _this$props6 = this.props,
            chargeSession = _this$props6.chargeSession,
            codableTransaction = _this$props6.codableTransaction;
          var element = ev.target;
          var dataItem = getChipDataItem(element, null, codableTransaction || chargeSession);
          var changeDetail = {
            codes: [dataItem],
            context: {
              chargeSession: _objectSpread$u({}, this.props.chargeSession),
              transaction: _objectSpread$u({}, this.props.codableTransaction),
              invoice: _objectSpread$u({}, this.props.invoice),
              processInstance: _objectSpread$u({}, this.props.processInstance)
            }
          };
          this.props.handleCodeRemove(changeDetail);
          if (this.lookupRef.current) {
            this.lookupRef.current.focus();
          }
        }
      }

      /**
       * Event launched when a multiple code are deleted
       * @param ev
       */
    }, {
      key: "handleCodesDelete",
      value: function handleCodesDelete(codes) {
        if (this.props.editable) {
          var _codes$map;
          var _this$props7 = this.props,
            chargeSession = _this$props7.chargeSession,
            codableTransaction = _this$props7.codableTransaction;
          var dataItems = (_codes$map = codes === null || codes === void 0 ? void 0 : codes.map(function (codeInfo) {
            return getChipDataItem(null, codeInfo, codableTransaction || chargeSession);
          })) !== null && _codes$map !== void 0 ? _codes$map : [];
          var changeDetail = {
            codes: dataItems,
            context: {
              chargeSession: _objectSpread$u({}, this.props.chargeSession),
              transaction: _objectSpread$u({}, this.props.codableTransaction),
              invoice: _objectSpread$u({}, this.props.invoice),
              processInstance: _objectSpread$u({}, this.props.processInstance)
            }
          };
          if (dataItems) this.props.handleRemoveAllCodes(changeDetail);
          if (this.lookupRef.current) {
            this.lookupRef.current.focus();
          }
        }
      }

      /**
       * Event launched when a shared code is toggled.
       * @param ev
       */
    }, {
      key: "handleCodeChecked",
      value: function handleCodeChecked(ev) {
        ev.stopPropagation();
        var codableTransaction = this.props.codableTransaction;
        var action = ev.target.checked ? 'ADD' : 'REMOVE';
        var diagnoses = [];
        if (action === 'REMOVE') {
          diagnoses = [{
            diagnosis_code: ev.target.name,
            shared: true
          }];
        } else if (action === 'ADD') {
          var codes = this.props.codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).filter(function (code) {
            return code.codeType === 'diagnosis';
          });
          diagnoses = codes.map(function (code, idx) {
            return {
              diagnosis_code: code.code,
              sequence_number: idx + 1,
              //@ts-ignore
              shared: code.shared,
              //@ts-ignore
              active: code.code === ev.target.name ? true : code.active
            };
          });
        }
        var payload = {
          action: action,
          codeUpdate: {
            transactionGuid: codableTransaction.guid,
            processInstance: this.props.processInstance,
            serviceLine: this.props.processInstance.serviceLine,
            diagnoses: diagnoses
          }
        };
        this.props.onTransactionSharedDiagnosisChange(payload);
      }

      /**
       * Event launched when a units are changed
       * @param ev
       */
    }, {
      key: "handleUnitsChange",
      value: function handleUnitsChange(units, unitsElement) {
        if (this.props.editable) {
          var codableTransaction = this.props.codableTransaction;
          var element = unitsElement;
          var dataItem = getDataItem$1(element, codableTransaction);
          if (units && isAValidUnits(units.toString())) {
            this.currentUnit = parseUnits(parseInt(units.toString()));
            var code = _objectSpread$u(_objectSpread$u({}, dataItem), {}, {
              units: this.currentUnit
            });
            var changeDetail = {
              codes: [code],
              context: {
                chargeSession: _objectSpread$u({}, this.props.chargeSession),
                transaction: _objectSpread$u({}, this.props.codableTransaction),
                invoice: _objectSpread$u({}, this.props.invoice),
                processInstance: _objectSpread$u({}, this.props.processInstance)
              }
            };
            this.props.handleCodeChange(changeDetail);
          } else {
            this.currentUnit = dataItem !== null && dataItem !== void 0 && dataItem.units ? Number(dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) : null;
          }
        }
      }

      /**
       * Event launched when a transaction is re-ordered
       * @param ev
       */
    }, {
      key: "handleTransactionReorder",
      value: function handleTransactionReorder(transactionCurrentIndex, transactionDestinationIndex) {
        var _this$props$invoice;
        var transactions = (_this$props$invoice = this.props.invoice) === null || _this$props$invoice === void 0 ? void 0 : _this$props$invoice.transactions.slice();
        var movedTransaction = transactions[transactionCurrentIndex];
        transactions.splice(transactionCurrentIndex, 1);
        transactions.splice(transactionDestinationIndex, 0, movedTransaction);
        var reorderedTransactions = transactions.map(function (txn, index) {
          return {
            guid: txn.guid,
            sequence_number: index + 1
          };
        });
        var transactionReorderDetail = {
          transactions: reorderedTransactions,
          context: {
            invoice: _objectSpread$u({}, this.props.invoice),
            processInstance: _objectSpread$u({}, this.props.processInstance)
          }
        };
        this.props.handleTransactionOrderChange(transactionReorderDetail);
      }

      /**
       * Event launched when a transaction is deleted
       * @param event
       */
    }, {
      key: "onDelete",
      value: function onDelete(event) {
        event.preventDefault();
        this.props.onChargeSessionAction({
          action: 'DELETE_TRANSACTION',
          chargeSession: this.props.chargeSession,
          meta: {
            invoice: this.props.invoice,
            transaction: _objectSpread$u({}, this.props.codableTransaction)
          }
        });
      }

      /**
       * Event launched by the accordion
       * @param action
       * @param item
       */
    }, {
      key: "onAccordionAction",
      value: function onAccordionAction(action, item) {
        var chargeSessionCode = item.data;
        var opening = action === uiComponents.AccordionSectionAction.OPEN;
        var selection = {
          chargeSessionCode: chargeSessionCode,
          evidence: chargeSessionCode.evidence,
          selectionState: {
            active: false,
            hover: false,
            visible: opening
          }
        };
        this.props.onFeatureSelection(selection);
      }

      /**
       * Method used for enable a procedure with tech/pro charge
       * @param techTransactionCodable
       */
    }, {
      key: "handleEnableTechPro",
      value: function handleEnableTechPro(techTransactionCodable) {
        if (this.props.editable) {
          techTransactionCodable.invoice = this.props.invoice;
          this.props.handleEnableTechPro(techTransactionCodable);
        }
      }

      /**
       * Method used for disable a procedure with tech/pro charge
       * @param techTransactionCodable
       */
    }, {
      key: "handleDisableTechPro",
      value: function handleDisableTechPro(techTransactionCodable) {
        if (this.props.editable) {
          techTransactionCodable.invoice = this.props.invoice;
          this.props.handleDisableTechPro(techTransactionCodable);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _transaction$type, _codableTransaction$p, _codableTransaction$p2, _codableTransaction$p3;
        var _this$props8 = this.props;
          _this$props8.chargeSession;
          var codableTransaction = _this$props8.codableTransaction,
          lineNumber = _this$props8.lineNumber,
          editable = _this$props8.editable,
          invoice = _this$props8.invoice;
          _this$props8.onCodeSearch;
          _this$props8.handleCodeChange;
          _this$props8.handleCodeSearchDrop;
          _this$props8.handleCodeRemove;
          _this$props8.canDropOnto;
          _this$props8.searchResults;
          var codeSearchResultsV2 = _this$props8.codeSearchResultsV2;
          _this$props8.onCodeSearchSelection;
          var onFeatureSelection = _this$props8.onFeatureSelection;
          _this$props8.onChargeSessionAction;
          _this$props8.onEdit;
          var autoFocus = _this$props8.autoFocus,
          panelActivations = _this$props8.panelActivations;
          _this$props8.processInstance;
          var transaction = _this$props8.transaction;
          _this$props8.debounceTimeout;
          var codeEdits = _this$props8.codeEdits,
          suggestedCodes = _this$props8.suggestedCodes;
          _this$props8.onTransactionSharedDiagnosisChange;
          var transactionIndex = _this$props8.transactionIndex;
          _objectWithoutProperties(_this$props8, _excluded$b);
        var txnType = (_transaction$type = transaction === null || transaction === void 0 ? void 0 : transaction.type) !== null && _transaction$type !== void 0 ? _transaction$type : 'unknown txn type';
        var styleClasses = ['charge-session-informationV2', "charge-session-".concat(txnType.toLowerCase()), {
          'charge-session-editable': editable,
          'charge-session-uneditable': !editable,
          'charge-session-drop-zone': this.state.dragHover
        }];
        var boundTransactionAccordionBuilder = transactionAccordianBuilderV2.bind(null, this.handleUnitsChange, this.handleTransactionReorder, this.handleCodeDelete, this.handleCodeChecked, this.handleDisableTechPro, this.handleEnableTechPro, this.isTimeBasedCode, this.timeBasedCodePopup, this.onSearch, this.onSearchSelection, this.onAddAllCodes, this.onRemoveAllCodes, this.codeDropHandler, this.onDropHandler, this.onAccordionAction, this.onDelete, suggestedCodes, codeSearchResultsV2, invoice, codeEdits,
        // disable editable actions(i,e add diagnosis,modifiers) on a temporary transaction
        this.props.editable && !codableTransaction.isTemporary, autoFocus, transactionIndex);
        var boundMedicalCodeAccordionBuilder = medicalCodeAccordianBuilder.bind(null, onFeatureSelection, panelActivations, invoice, codeEdits);
        var assuranceErrorMessage = codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$p = codableTransaction.procedure) !== null && _codableTransaction$p !== void 0 && _codableTransaction$p.errorMessages ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.errorMessages : [];
        var sharedCodes = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES;
        var boundMedicalCodeAccordionBuilderHandler = function boundMedicalCodeAccordionBuilderHandler(code, index) {
          return boundMedicalCodeAccordionBuilder(code, index, codableTransaction, assuranceErrorMessage);
        };
        var boundTransactionAccordionBuilderHandler = function boundTransactionAccordionBuilderHandler(items) {
          return boundTransactionAccordionBuilder(codableTransaction, transaction, assuranceErrorMessage, items);
        };
        var transactionAccordionItem;
        var chargeMeta = false;
        var items = [];
        var highlightTransaction = false;
        if (codableTransaction) {
          var _codableTransaction$c;
          var codes = JSON.parse(JSON.stringify((_codableTransaction$c = codableTransaction.codes) !== null && _codableTransaction$c !== void 0 ? _codableTransaction$c : []));
          if (!sharedCodes) {
            var onlyShared = codes.filter(sharedCodePredicate$1);
            var firstIndex = codes.findIndex(sharedCodePredicate$1);
            codes.findIndex(notSharedCodePredicate$1, firstIndex);
            var preArray = codes.slice(0, firstIndex);
            var postArray = codes.slice(firstIndex + onlyShared.length);
            var zippedShareCodes = {
              codes: onlyShared,
              codeType: uiCommon.commonEnums.CodeType.DIAGNOSIS,
              zipped: true
            };
            codes = [].concat(_toConsumableArray(preArray), [zippedShareCodes], _toConsumableArray(postArray));
          }
          var filtered = codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code) || uiCommon.cmxTypeguards.isZippedCodeBlock(code) && code.codes.length;
          });
          items = filtered.map(boundMedicalCodeAccordionBuilderHandler);
          transactionAccordionItem = boundTransactionAccordionBuilderHandler(items);
          var txnLedger = getLedgerTransaction(getLedgerTransactionsFromInvoice(invoice), codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.guid);
          highlightTransaction = shouldHighlightTransaction(txnLedger);
        }
        // else if (chargeSession) {
        //   items = chargeSession.codes.map(boundAccordionBuilderHandler) as any[];

        //   // TODO: Determine code types
        //   chargeMeta = (
        //     <div className="charge-line">
        //       <span className="charge-index">Charge {lineNumber}:</span>
        //       <span className="charge-charge-type" style={{ display: 'none' }}>
        //         SOME CODE TYPE:
        //       </span>
        //       {editable ? (
        //         <span className="charge-delete-container">
        //           <a href="#/delete-session" onClick={this.onDelete}>
        //             remove
        //           </a>
        //         </span>
        //       ) : (
        //         false
        //       )}
        //     </div>
        //   );
        // }
        else if (transaction) {
          var diagnosis = [];
          var modifiers = [];
          // TODO:
          // const diagnosis = (invoice?.shared_codes.diagnoses ?? []).map(
          //   code => code.diagnosis_code
          // );
          // const modifiers = (invoice?.shared_codes.modifiers ?? []).map(
          //   code => code.modifier_code
          // );
          var dxString = diagnosis.length ? "diagnosis: ".concat(diagnosis.join(', ')) : '';
          var modString = modifiers.length ? "modifiers: ".concat(modifiers.join(', ')) : '';
          var conjunction = diagnosis.length && modifiers.length ? ' and ' : '';
          var alsoIncludes = "".concat(dxString, " ").concat(conjunction, " ").concat(modString);
          styleClasses.push({
            'show-also-includes': diagnosis.length || modifiers.length
          });
          var label = txnType in CHARGE_TYPE_LABEL ? CHARGE_TYPE_LABEL[txnType] : txnType;
          items = transaction.codes.map(boundMedicalCodeAccordionBuilderHandler);
          transactionAccordionItem = boundTransactionAccordionBuilderHandler(items);
          chargeMeta = /*#__PURE__*/React.createElement("div", {
            className: "transaction-meta transaction-".concat(txnType.toLowerCase())
          }, /*#__PURE__*/React.createElement("span", {
            className: "ordinal"
          }, lineNumber, ". "), label, ' ', /*#__PURE__*/React.createElement("span", {
            className: "also-includes"
          }, "Includes shared ", alsoIncludes));
        }
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(styleClasses, {
            "transaction-ledger-highlight": highlightTransaction
          }),
          key: transactionIndex
        }, chargeMeta, /*#__PURE__*/React.createElement("div", {
          className: "code-section"
        }, transactionAccordionItem ? /*#__PURE__*/React.createElement(Accordion, {
          allowToggle: true,
          className: "transaction-accordion-section ".concat(this.state.isTransactionRowOpen ? 'transaction-row-expanded' : '')
        }, /*#__PURE__*/React.createElement(AccordionItem, null, /*#__PURE__*/React.createElement("div", {
          className: "accordion-header-section"
        }, /*#__PURE__*/React.createElement("div", {
          className: 'accordion-header-content',
          onClick: function onClick(e) {
            return e.stopPropagation();
          } // Prevents toggling when clicking on text
        }, transactionAccordionItem.header), /*#__PURE__*/React.createElement(AccordionButton, {
          as: "div",
          className: "accordion-header-toggle",
          onClick: this.toggleAccordion
        }, /*#__PURE__*/React.createElement(AccordionIcon, null))), /*#__PURE__*/React.createElement(AccordionPanel, {
          className: "accordion-panel-section",
          ref: this.accordionPanelRef
        }, transactionAccordionItem.body))) : editable ? /*#__PURE__*/React.createElement("div", {
          className: "empty-message editable"
        }, "Add codes using the search box below.") : /*#__PURE__*/React.createElement("div", {
          className: "empty-message uneditable"
        }, "No codes selected")), /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.errorMessages,
          messageStyle: "txn-error-message",
          messageType: "error"
        }), /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p3 = codableTransaction.procedure) === null || _codableTransaction$p3 === void 0 ? void 0 : _codableTransaction$p3.errorMessages,
          messageStyle: "procedure-error-message",
          messageType: "error"
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(TransactionV2, "displayName", 'Transaction');
  _defineProperty(TransactionV2, "defaultProps", {
    autoFocus: false,
    searchResults: [],
    codeSearchResultsV2: {},
    editable: true,
    panelActivations: {},
    codeEdits: {},
    debounceTimeout: 200,
    suggestedCodes: {
      cpt: [],
      modifier: [],
      diagnosis: []
    },
    canDropOnto: canDropOnto,
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    handleCodeChange: function handleCodeChange(change) {},
    handleCodeRemove: function handleCodeRemove(change) {},
    handleCodeSearchDrop: function handleCodeSearchDrop(change) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    handleAddAllCodes: function handleAddAllCodes(searchSelection) {},
    handleRemoveAllCodes: function handleRemoveAllCodes(codeChange) {},
    onFeatureSelection: function onFeatureSelection(feature) {},
    onEdit: function onEdit(chargeSession) {},
    handleTimeBasedCodeAdd: function handleTimeBasedCodeAdd(change, time, age) {},
    handleTimeBasedCodeUpdate: function handleTimeBasedCodeUpdate(change, time, age) {},
    handleTransactionReorder: function handleTransactionReorder(transactionCurrentIndex, transactionDestinationIndex) {}
  });

  var EditorIssueLevel = uiCommon.commonEnums.EditorIssueLevel;
  var IconCell = function IconCell(_ref) {
    var iconName = _ref.iconName,
      iconClass = _ref.iconClass;
    return /*#__PURE__*/React.createElement("div", {
      className: "qa-scrubber-issues scrubber-issues col-evidence code-indicator-cell"
    }, /*#__PURE__*/React.createElement("span", {
      className: "indicator"
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "".concat(iconName),
      svgIconSize: "20",
      svgIconClass: "".concat(iconClass)
    })));
  };
  /**
   * React component that displays a Header
   * @param medicalCode
   * @param errors
   * @param handleKeyPress
   * @param handleBlurEvent
   * @param handleUnitsClick
   * @param handleCodeDelete
   * @param handleEnableTechPro
   * @param handleDisableTechPro
   * @returns
   */
  var Header = function Header(medicalCode, techTransaction, errors, invoice, codeEdits, handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup) {
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
      var zippedCode = medicalCode;
      return /*#__PURE__*/React.createElement("div", {
        className: "transaction-header icd-code transaction-shared-code-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "move-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-gripper prevent-click"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeGripperSVG20",
        svgIconSize: "20",
        svgIconClass: "gripper"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "codes-column"
      }, zippedCode.codes.map(function (medicalCode, idx) {
        var active = medicalCode.active;
        var classes = classnames(['chip', {
          'shared-code-on': active,
          'shared-code-off': !active
        }]);
        // change icon here... turned off for now.
        var iconName = active ? 'BiomeCheckSVG20' : 'BiomeMinusSVG20';
        return /*#__PURE__*/React.createElement("span", {
          key: medicalCode.code,
          className: "icd-code unclickable prevent-click",
          "data-dd-action-name": active === true ? '~Toggle code off' : '~Toggle code on'
        }, /*#__PURE__*/React.createElement("span", {
          className: "code-chip"
        }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", {
          className: classes
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          style: {
            display: 'none'
          },
          name: "".concat(medicalCode.code),
          onClick: handleCodeChecked,
          className: "txn-shared-checkbox",
          defaultChecked: active
        }), active && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: iconName,
          svgIconSize: "20",
          svgIconClass: "shared-icon"
        }), /*#__PURE__*/React.createElement("span", {
          className: "code-text"
        }, medicalCode.code)))));
      })));
    } else if (uiCommon.cmxTypeguards.isChargeSessionCode(medicalCode)) {
      var _sessionCode$shared, _codeEdits$sessionCod, _sessionCode$evidence;
      var sessionCode = medicalCode;
      //@ts-ignore
      var shared = (_sessionCode$shared = sessionCode.shared) !== null && _sessionCode$shared !== void 0 ? _sessionCode$shared : false;
      var sharedInvoice = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES;
      var uneditableSharedCode = shared && !sharedInvoice;
      var allEdits = (_codeEdits$sessionCod = codeEdits[sessionCode.code]) !== null && _codeEdits$sessionCod !== void 0 ? _codeEdits$sessionCod : [];
      var vwErrors = allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel.ERROR;
      });
      var vwWarnings = allEdits.some(function (edit) {
        return edit.level === EditorIssueLevel.WARNING;
      });
      var styleClasses = ["transaction-header", _defineProperty({
        'code-errors': errors.some(function (error) {
          return error.message_key === 'procedure_code.units.invalid' && sessionCode.codeType === 'procedure' || error.message_key !== 'procedure_code.units.invalid';
        }),
        unitable: sessionCode.unitable,
        editable: sessionCode.editable,
        'uneditable-shared-code': uneditableSharedCode
      }, 'transaction-shared-code', shared), "".concat(sessionCode.provenance.toLowerCase(), "-code")];
      var evidence = (_sessionCode$evidence = sessionCode.evidence) !== null && _sessionCode$evidence !== void 0 ? _sessionCode$evidence : [];
      var hasEvidence = evidence.length > 0;
      var description = sessionCode.description || 'Retrieving description...';
      var codeUnitsStyle = ['code-units-input', {
        'procedure-code-units-invalid': errors.some(function (error) {
          return error.message_key === 'procedure_code.units.invalid';
        })
      }];
      var showActionsColumn = vwErrors || vwWarnings || hasEvidence || techTransaction.hasTechCode || techTransaction.hasProCode;
      var proClassName = classnames(['pro-tech-box', {
        'is-active': techTransaction.isProCodeActive,
        'is-inactive': !techTransaction.isProCodeActive,
        'single-box': !techTransaction.hasTechCode,
        'left-box': techTransaction.hasTechCode
      }]);
      var techClassName = classnames(['pro-tech-box', {
        'is-active': techTransaction.isTechCodeActive,
        'is-inactive': !techTransaction.isTechCodeActive,
        'single-box': !techTransaction.hasProCode,
        'right-box': techTransaction.hasProCode
      }]);
      var techIndicatorClassName = classnames(['qa-tech-indicator', 'prevent-click', 'tech-indicator', 'indicator', 'indicator-pro-tech', {
        'tech-indicator-no-space': techTransaction.hasProCode && techTransaction.isTechCodeActive || techTransaction.hasTechCode && techTransaction.isProCodeActive,
        'indicator-pro-tech-active': techTransaction.isTechCodeActive,
        'indicator-pro-tech-inactive': !techTransaction.isTechCodeActive,
        'single-indicator-pro-tech': !techTransaction.hasProCode,
        'indicator-pro-tech-modifier': techTransaction.isModifier,
        'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
        'pro-tech-loading': techTransaction.isLoading
      }]);
      var proIndicatorClassName = classnames(['qa-pro-indicator', 'prevent-click', 'pro-indicator', 'indicator', 'indicator-pro-tech', {
        'indicator-pro-tech-active': techTransaction.isProCodeActive,
        'indicator-pro-tech-inactive': !techTransaction.isProCodeActive,
        'single-indicator-pro-tech': !techTransaction.hasTechCode,
        'indicator-pro-tech-modifier': techTransaction.isModifier,
        'indicator-pro-tech-no-modifier': !techTransaction.isModifier,
        'pro-tech-loading': techTransaction.isLoading
      }]);
      var proCheck = classnames(['pro-tech-check', {
        'pro-tech-check-active': techTransaction.isProCodeActive,
        'pro-tech-check-inactive': !techTransaction.isProCodeActive
      }]);
      var techCheck = classnames(['pro-tech-check', {
        'pro-tech-check-active': techTransaction.isTechCodeActive,
        'pro-tech-check-inactive': !techTransaction.isTechCodeActive
      }]);
      var toggleProCode = function toggleProCode() {
        if (!techTransaction.isLoading) {
          techTransaction.isProCodeActive ? handleEnableTechPro(techTransaction.proContext) : handleDisableTechPro(techTransaction.proContext);
        }
      };
      var toggleTechCode = function toggleTechCode() {
        if (!techTransaction.isLoading) {
          techTransaction.isTechCodeActive ? handleEnableTechPro(techTransaction.techContext) : handleDisableTechPro(techTransaction.techContext);
        }
      };
      return /*#__PURE__*/React.createElement("div", {
        key: "".concat(sessionCode.code, "-").concat(sessionCode.codeType),
        "data-code": "".concat(sessionCode.code),
        "data-code-type": "".concat(sessionCode.codeType),
        className: classnames(styleClasses)
      }, /*#__PURE__*/React.createElement("div", {
        className: "units-column"
      }, sessionCode.codeType !== 'procedure' ? /*#__PURE__*/React.createElement("span", {
        className: "code-gripper prevent-click"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeGripperSVG20",
        svgIconSize: "20",
        svgIconClass: "gripper"
      })) : /*#__PURE__*/React.createElement("span", {
        className: "code-units-populateable prevent-click"
      }, /*#__PURE__*/React.createElement("span", {
        className: "case-units-numeral"
      }, /*#__PURE__*/React.createElement("input", {
        onInput: handleKeyPress,
        onBlur: handleBlurEvent,
        onClick: handleUnitsClick,
        type: "text",
        disabled: !sessionCode.editable,
        className: classnames(codeUnitsStyle),
        value: sessionCode.units
      })))), /*#__PURE__*/React.createElement("div", {
        className: "codes-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-chip"
      }, /*#__PURE__*/React.createElement("span", {
        className: "chip"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-text"
      }, sessionCode.code)), !uneditableSharedCode && /*#__PURE__*/React.createElement("span", {
        onClick: handleCodeDelete,
        className: "code-action-icon code-delete-icon chip"
      }, /*#__PURE__*/React.createElement("span", {
        className: "code-action-icon-inner code-delete"
      }, /*#__PURE__*/React.createElement("a", {
        href: "#/delete-code",
        className: "code-delete-link"
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeCancelSVG20",
        svgIconSize: "12"
      })))))), /*#__PURE__*/React.createElement("div", {
        title: description,
        className: "qa-description-column description-column"
      }, /*#__PURE__*/React.createElement("span", {
        className: "ellipsify"
      }, description)), /*#__PURE__*/React.createElement(React.Fragment, null, sessionCode.codeType === 'procedure' && isTimeBasedCode() && timeBasedCodePopup()), showActionsColumn && /*#__PURE__*/React.createElement("div", {
        className: "code-actions-column"
      }, hasEvidence && /*#__PURE__*/React.createElement("div", {
        className: "col-evidence code-indicator-cell"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator"
      }, "CMX")), vwErrors && /*#__PURE__*/React.createElement(IconCell, {
        iconName: "BiomeVWErrorSVG20",
        iconClass: "qa-issue-error alert-error"
      }),
      /**
       * you can have errors and warnings at the same time.
       * due to the way react code is structured, i really don't like
       * nested ternary operators in jsx, hence the !vwErrors
       */
      !vwErrors && vwWarnings && /*#__PURE__*/React.createElement(IconCell, {
        iconName: "BiomeVWWarningSVG20",
        iconClass: "qa-issue-warning alert-warning"
      }), (techTransaction.hasTechCode || techTransaction.hasProCode) && /*#__PURE__*/React.createElement(React.Fragment, null, techTransaction.hasProCode && /*#__PURE__*/React.createElement("span", {
        className: classnames(proIndicatorClassName),
        onClick: toggleProCode
      }, /*#__PURE__*/React.createElement("div", {
        className: proClassName
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeCheckSVG20",
        svgIconSize: "12",
        svgIconClass: classnames(proCheck)
      }), /*#__PURE__*/React.createElement("p", {
        className: "pro-tech-label"
      }, "P"))), techTransaction.hasTechCode && /*#__PURE__*/React.createElement("span", {
        className: classnames(techIndicatorClassName),
        onClick: toggleTechCode
      }, /*#__PURE__*/React.createElement("div", {
        className: techClassName
      }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
        svgIconName: "BiomeCheckSVG20",
        svgIconSize: "12",
        svgIconClass: classnames(techCheck)
      }), /*#__PURE__*/React.createElement("p", {
        className: "pro-tech-label"
      }, "T"))))));
    }
  };

  /**
   * React component that displays a build body
   * @param medicalCode
   * @param panelActivations
   * @param onFeatureSelection
   * @returns
   */
  var BuildBody = function BuildBody(medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection) {
    var styleClasses = ["code-header", "code-body", 'transaction-body'];
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    } else {
      var sessionCode = medicalCode;
      var messages = codeEdits[sessionCode.code] ? formatEditGroup(codeEdits[sessionCode.code], 0) : false;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames(styleClasses)
      }, /*#__PURE__*/React.createElement("div", {
        className: "case-evidence-container"
      }, messages && /*#__PURE__*/React.createElement("div", {
        className: "col-artifacts message-wrap"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-code"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-artifacts col-messages"
      }, messages)), /*#__PURE__*/React.createElement(CaseEvidenceTable2, {
        panelActivations: panelActivations,
        onFeatureSelection: onFeatureSelection,
        chargeSessionCode: sessionCode,
        techTransaction: techTransaction
      })));
    }
  };

  var ChargeSessionCodeType = uiCommon.commonEnums.ChargeSessionCodeType;
  var DRAGGABLE_CODES = new Set([ChargeSessionCodeType.MODIFIER, ChargeSessionCodeType.DIAGNOSIS]);

  /**
   * Method that builds an accordion element
   * @param handleKeyPress
   * @param handleBlurEvent
   * @param handleUnitsClick
   * @param handleCodeDelete
   * @param handleEnableTechPro
   * @param handleDisableTechPro
   * @param onFeatureSelection
   * @param panelActivations
   * @param medicalCode
   * @param idx
   * @param errors
   * @returns
   */
  var transactionAccordianBuilder = function transactionAccordianBuilder(handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, onFeatureSelection, isTimeBasedCode, timeBasedCodePopup, panelActivations, invoice, codeEdits, medicalCode, idx, codableTransaction) {
    var _invoice$isLoadingTec;
    var errors = arguments.length > 16 && arguments[16] !== undefined ? arguments[16] : [];
    var styleClasses = '';
    var techTransaction = {
      proCode: null,
      techCode: null,
      hasProCode: false,
      hasTechCode: false,
      isProCodeActive: false,
      isTechCodeActive: false,
      proContext: null,
      techContext: null,
      isModifier: false,
      isLoading: false
    };
    techTransaction.isLoading = (_invoice$isLoadingTec = invoice === null || invoice === void 0 ? void 0 : invoice.isLoadingTechPro) !== null && _invoice$isLoadingTec !== void 0 ? _invoice$isLoadingTec : false;
    if (uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode)) ; else {
      var _codableTransaction$p;
      var sessionCode = medicalCode;
      styleClasses = "".concat(sessionCode.codeType, "-section");
      var modifierTransaction = (sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === 'modifier' ? codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.modifiers.find(function (codableTransacMod) {
        return codableTransacMod.modifier_code === sessionCode.code;
      }) : null;

      // assign tech/pro code if it exists
      if ((sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === uiCommon.commonEnums.CodeTypes.PROCEDURE && (codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p = codableTransaction.procedure) === null || _codableTransaction$p === void 0 ? void 0 : _codableTransaction$p.procedure_code) === (sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.code)) {
        var _codableTransaction$m, _codableTransaction$m2, _codableTransaction$t, _codableTransaction$t2, _codableTransaction$m3, _codableTransaction$t3, _codableTransaction$m4, _codableTransaction$t4;
        techTransaction.isModifier = false;
        // add tech/pro for procedure
        techTransaction.proCode = (_codableTransaction$m = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m2 = codableTransaction.mapped_procedure) === null || _codableTransaction$m2 === void 0 ? void 0 : _codableTransaction$m2.procedure_code) !== null && _codableTransaction$m !== void 0 ? _codableTransaction$m : null;
        techTransaction.techCode = (_codableTransaction$t = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t2 = codableTransaction.technical_code) === null || _codableTransaction$t2 === void 0 ? void 0 : _codableTransaction$t2.code) !== null && _codableTransaction$t !== void 0 ? _codableTransaction$t : null;
        techTransaction.hasProCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$m3 = codableTransaction.mapped_procedure) !== null && _codableTransaction$m3 !== void 0 && _codableTransaction$m3.procedure_code);
        techTransaction.hasTechCode = !!(codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$t3 = codableTransaction.technical_code) !== null && _codableTransaction$t3 !== void 0 && _codableTransaction$t3.code);
        techTransaction.isProCodeActive = techTransaction.hasProCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m4 = codableTransaction.mapped_procedure) === null || _codableTransaction$m4 === void 0 ? void 0 : _codableTransaction$m4.active : false;
        techTransaction.isTechCodeActive = techTransaction.hasTechCode ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t4 = codableTransaction.technical_code) === null || _codableTransaction$t4 === void 0 ? void 0 : _codableTransaction$t4.active : false;
        techTransaction.proContext = {
          transactionGuid: codableTransaction.guid,
          mappedProcedure: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.mapped_procedure) || null
        };
        techTransaction.techContext = {
          transactionGuid: codableTransaction.guid,
          technicalCode: (codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.technical_code) || null
        };
      } else if ((sessionCode === null || sessionCode === void 0 ? void 0 : sessionCode.codeType) === uiCommon.commonEnums.CodeTypes.MODIFIER) {
        // case for modifiers
        techTransaction.isModifier = true;
        if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === uiCommon.commonEnums.ModifierTypes.PRO) {
          var _ref, _codableTransaction$m5, _codableTransaction$m6, _codableTransaction$p2;
          techTransaction.proCode = (_ref = (_codableTransaction$m5 = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$m6 = codableTransaction.mapped_procedure) === null || _codableTransaction$m6 === void 0 ? void 0 : _codableTransaction$m6.procedure_code) !== null && _codableTransaction$m5 !== void 0 ? _codableTransaction$m5 : codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.procedure_code) !== null && _ref !== void 0 ? _ref : '';
          techTransaction.hasProCode = true;
          techTransaction.isProCodeActive = true;
        } else if ((modifierTransaction === null || modifierTransaction === void 0 ? void 0 : modifierTransaction.modifier_type) === uiCommon.commonEnums.ModifierTypes.TECH) {
          var _codableTransaction$t5, _codableTransaction$t6;
          techTransaction.techCode = (_codableTransaction$t5 = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$t6 = codableTransaction.technical_code) === null || _codableTransaction$t6 === void 0 ? void 0 : _codableTransaction$t6.code) !== null && _codableTransaction$t5 !== void 0 ? _codableTransaction$t5 : '';
          techTransaction.hasTechCode = true;
          techTransaction.isTechCodeActive = true;
        }
      }
    }
    return {
      className: classnames(styleClasses),
      header: Header(medicalCode, techTransaction, errors, invoice, codeEdits, handleKeyPress, handleBlurEvent, handleUnitsClick, handleCodeDelete, handleCodeChecked, handleEnableTechPro, handleDisableTechPro, isTimeBasedCode, timeBasedCodePopup),
      data: medicalCode,
      selectable: !uiCommon.cmxTypeguards.isZippedCodeBlock(medicalCode),
      //@ts-ignore
      draggable: DRAGGABLE_CODES.has(medicalCode.codeType),
      id: "".concat(idx),
      body: BuildBody(medicalCode, techTransaction, panelActivations, codeEdits, onFeatureSelection),
      open: false
    };
  };

  var _excluded$a = ["chargeSession", "codableTransaction", "lineNumber", "editable", "invoice", "onCodeSearch", "handleCodeChange", "handleCodeSearchDrop", "handleCodeRemove", "canDropOnto", "searchResults", "onCodeSearchSelection", "onFeatureSelection", "onChargeSessionAction", "onEdit", "autoFocus", "panelActivations", "processInstance", "transaction", "debounceTimeout", "codeEdits", "onTransactionSharedDiagnosisChange"];
  function ownKeys$t(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$t(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$t(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$t(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$n(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$n() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$n() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$n = function _isNativeReflectConstruct() { return !!t; })(); }
  var ChargeSessionCodeProvenance = uiCommon.commonEnums.ChargeSessionCodeProvenance;
  var draggedCodesManager = uiCommon.dragManager.load('codes');
  var sharedCodePredicate = function sharedCodePredicate(code) {
    //@ts-ignore
    return code.shared === true;
  };
  var notSharedCodePredicate = function notSharedCodePredicate(code) {
    //@ts-ignore
    return !(code.shared === true);
  };

  /**
   * Method that get data from codable object
   * @param element
   * @param codable
   * @returns
   */
  var getDataItem = function getDataItem(element, codable) {
    var parent = element.closest('.transaction-header');
    if (parent) {
      var codeId = parent.attributes.getNamedItem('data-code');
      var codeType = parent.attributes.getNamedItem('data-code-type');
      if (codeId && codeType) {
        var _codable$codes$find;
        return (_codable$codes$find = codable.codes.find(function (code) {
          if (!uiCommon.cmxTypeguards.isChargeSessionCode(code)) return false;
          var sessionCode = code;
          return "".concat(sessionCode.code) === "".concat(codeId.value) && sessionCode.codeType === "".concat(codeType.value);
        })) !== null && _codable$codes$find !== void 0 ? _codable$codes$find : null;
      }
    }
    return null;
  };

  /**
   * Class React component for render a transaction
   */
  var Transaction = /*#__PURE__*/function (_React$Component) {
    function Transaction(props) {
      var _this;
      _classCallCheck(this, Transaction);
      _this = _callSuper$n(this, Transaction, [props]);
      _defineProperty(_this, "lookupRef", void 0);
      _defineProperty(_this, "iconRef", void 0);
      _defineProperty(_this, "currentUnit", void 0);
      /**
       * Manage onBlur event for valid units
       * @param ev
       */
      _defineProperty(_this, "handleBlurEvent", function (ev) {
        ev.stopPropagation();
        if (_this.props.editable) {
          var element = ev.target;
          var codeUnitsInput = element === null || element === void 0 ? void 0 : element.closest('.code-units-input');
          if (codeUnitsInput && _this.currentUnit) {
            codeUnitsInput.value = _this.currentUnit.toString();
          }
        }
      });
      _defineProperty(_this, "isTimeBasedCode", function () {
        var _this$props$codableTr;
        return (_this$props$codableTr = _this.props.codableTransaction) === null || _this$props$codableTr === void 0 || (_this$props$codableTr = _this$props$codableTr.procedure) === null || _this$props$codableTr === void 0 ? void 0 : _this$props$codableTr.time_based;
      });
      _defineProperty(_this, "handleTimeBasedCodeAdd", function (ev, time, age) {
        ev.preventDefault();
        ev.stopPropagation();
        var _this$props = _this.props,
          chargeSession = _this$props.chargeSession,
          codableTransaction = _this$props.codableTransaction;
        var element = ev.target;
        var dataItem = getDataItem(element, codableTransaction || chargeSession);
        var changeDetail = {
          codes: [dataItem],
          context: {
            chargeSession: _objectSpread$t({}, _this.props.chargeSession),
            transaction: _objectSpread$t({}, _this.props.codableTransaction),
            invoice: _objectSpread$t({}, _this.props.invoice),
            processInstance: _objectSpread$t({}, _this.props.processInstance)
          }
        };
        _this.props.handleTimeBasedCodeAdd(changeDetail, time, age);
        if (_this.lookupRef.current) {
          _this.lookupRef.current.focus();
        }
      });
      _defineProperty(_this, "handleTimeBasedCodeUpdate", function (ev, time, age) {
        ev.preventDefault();
        ev.stopPropagation();
        var _this$props2 = _this.props,
          chargeSession = _this$props2.chargeSession,
          codableTransaction = _this$props2.codableTransaction;
        var element = ev.target;
        var dataItem = getDataItem(element, codableTransaction || chargeSession);
        var changeDetail = {
          codes: [dataItem],
          context: {
            chargeSession: _objectSpread$t({}, _this.props.chargeSession),
            transaction: _objectSpread$t({}, _this.props.codableTransaction),
            invoice: _objectSpread$t({}, _this.props.invoice),
            processInstance: _objectSpread$t({}, _this.props.processInstance)
          }
        };
        _this.props.handleTimeBasedCodeUpdate(changeDetail, time, age);
        if (_this.lookupRef.current) {
          _this.lookupRef.current.focus();
        }
      });
      _defineProperty(_this, "isClockIconDisabled", function () {
        var _this$props$codableTr2, _invoice$transactions;
        var procedure = (_this$props$codableTr2 = _this.props.codableTransaction) === null || _this$props$codableTr2 === void 0 ? void 0 : _this$props$codableTr2.procedure;
        var invoice = _this.props.invoice;
        return procedure && (invoice === null || invoice === void 0 || (_invoice$transactions = invoice.transactions) === null || _invoice$transactions === void 0 ? void 0 : _invoice$transactions.some(function (transaction) {
          var _transaction$procedur;
          return (transaction === null || transaction === void 0 || (_transaction$procedur = transaction.procedure) === null || _transaction$procedur === void 0 ? void 0 : _transaction$procedur.add_on_code_id) === (procedure === null || procedure === void 0 ? void 0 : procedure.additionalProperties['id']);
        }));
      });
      //handle this manually so we can unmount it
      _defineProperty(_this, "handlePopoverClose", function (newState) {
        _this.setState({
          clickTriggered: newState
        });
      });
      _defineProperty(_this, "timeBasedCodePopup", function () {
        var _this$props$codableTr3, _this$props$codableTr4, _this$props$codableTr5, _this$props$codableTr6, _this$props$codableTr7, _this$props$codableTr8;
        var popoverState = _this.state.clickTriggered;
        var handlePopoverOpen = function handlePopoverOpen(ev) {
          // Prevents the default behavior of the click event
          ev.stopPropagation();

          // Toggle the state when the user clicks to open the popover manually
          _this.setState({
            clickTriggered: !_this.state.clickTriggered
          });
        };
        return /*#__PURE__*/React.createElement(ChakraProvider, {
          theme: theme
        }, /*#__PURE__*/React.createElement("div", {
          className: (_this$props$codableTr3 = _this.props.codableTransaction) !== null && _this$props$codableTr3 !== void 0 && (_this$props$codableTr3 = _this$props$codableTr3.procedure) !== null && _this$props$codableTr3 !== void 0 && _this$props$codableTr3.time_based && (_this$props$codableTr4 = _this.props.codableTransaction) !== null && _this$props$codableTr4 !== void 0 && (_this$props$codableTr4 = _this$props$codableTr4.procedure) !== null && _this$props$codableTr4 !== void 0 && _this$props$codableTr4.total_time ? 'clock-time-section' : 'clock-section'
        }, /*#__PURE__*/React.createElement(Popover, {
          isOpen: popoverState,
          placement: "bottom-end",
          variant: "time"
        }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement(Button, {
          "data-testid": "time-based-code-open-btn",
          ref: _this.iconRef,
          "aria-label": "",
          size: "xs",
          variant: "clockv1",
          disabled: !_this.props.editable || _this.isClockIconDisabled(),
          onClick: handlePopoverOpen
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeClock",
          svgIconSize: "20",
          svgIconClass: (_this$props$codableTr5 = _this.props.codableTransaction) !== null && _this$props$codableTr5 !== void 0 && (_this$props$codableTr5 = _this$props$codableTr5.procedure) !== null && _this$props$codableTr5 !== void 0 && _this$props$codableTr5.time_based && (_this$props$codableTr6 = _this.props.codableTransaction) !== null && _this$props$codableTr6 !== void 0 && (_this$props$codableTr6 = _this$props$codableTr6.procedure) !== null && _this$props$codableTr6 !== void 0 && _this$props$codableTr6.total_time ? 'grey-clock' : 'color-clock'
        }), ((_this$props$codableTr7 = _this.props.codableTransaction) === null || _this$props$codableTr7 === void 0 || (_this$props$codableTr7 = _this$props$codableTr7.procedure) === null || _this$props$codableTr7 === void 0 ? void 0 : _this$props$codableTr7.time_based) && ((_this$props$codableTr8 = _this.props.codableTransaction) === null || _this$props$codableTr8 === void 0 || (_this$props$codableTr8 = _this$props$codableTr8.procedure) === null || _this$props$codableTr8 === void 0 ? void 0 : _this$props$codableTr8.total_time) && /*#__PURE__*/React.createElement("div", {
          className: "total-time"
        }, _this.props.codableTransaction.procedure.total_time))), /*#__PURE__*/React.createElement(Portal, null, popoverState && /*#__PURE__*/React.createElement(PopoverContent, null, /*#__PURE__*/React.createElement(PopoverBody, null, /*#__PURE__*/React.createElement(TimeBasedCodePopover, {
          codableTransaction: _this.props.codableTransaction,
          handleTimeBasedCodeAdd: _this.handleTimeBasedCodeAdd,
          handleTimeBasedCodeUpdate: _this.handleTimeBasedCodeUpdate,
          processInstance: _this.props.processInstance,
          popoverState: popoverState,
          updatePopoverState: _this.handlePopoverClose
        })))))));
      });
      _this.handleKeyPress = _this.handleKeyPress.bind(_this);
      _this.handleUnitsClick = _this.handleUnitsClick.bind(_this);
      _this.handleCodeDelete = _this.handleCodeDelete.bind(_this);
      _this.onSearch = _this.onSearch.bind(_this);
      _this.onSearchSelection = _this.onSearchSelection.bind(_this);
      _this.onDropHandler = _this.onDropHandler.bind(_this);
      _this.onDragOver = _this.onDragOver.bind(_this);
      _this.onDrop = _this.onDrop.bind(_this);
      _this.onDragLeave = _this.onDragLeave.bind(_this);
      _this.onDelete = _this.onDelete.bind(_this);
      _this.onAccordionAction = _this.onAccordionAction.bind(_this);
      _this.handleCodeChecked = _this.handleCodeChecked.bind(_this);
      _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
      _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
      _this.isTimeBasedCode = _this.isTimeBasedCode.bind(_this);
      _this.timeBasedCodePopup = _this.timeBasedCodePopup.bind(_this);
      _this.lookupRef = /*#__PURE__*/React.createRef();
      _this.iconRef = /*#__PURE__*/React.createRef();
      _this.state = {
        dragHover: false,
        clickTriggered: false
      };
      return _this;
    }

    // logic to show the timebased popover after page load
    _inherits(Transaction, _React$Component);
    return _createClass(Transaction, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$codableTra, _this$props$codableTr9;
        var prevProcedure = (_prevProps$codableTra = prevProps.codableTransaction) === null || _prevProps$codableTra === void 0 ? void 0 : _prevProps$codableTra.procedure;
        var newProcedure = (_this$props$codableTr9 = this.props.codableTransaction) === null || _this$props$codableTr9 === void 0 ? void 0 : _this$props$codableTr9.procedure;
        if ((prevProcedure === null || prevProcedure === void 0 ? void 0 : prevProcedure.procedure_code) !== (newProcedure === null || newProcedure === void 0 ? void 0 : newProcedure.procedure_code)) {
          this.setState({
            clickTriggered: false
          });
        }
        // This code opens the popover if the time code is required.
        // BSP customer asked for that to not be the default, but product wants it to be a configurable option.
        // Keeping this code so we can use it when we make it configurable.
        /* if (newProcedure) {
          if (
            newProcedure?.time_based &&
            newProcedure?.add_on_code_available &&
            !newProcedure.total_time &&
            !this.state.clickTriggered
          ) {
            this.iconRef.current.click();
            this.setState({ clickTriggered: true }); 
          }
        } */
      }

      /**
       * Event for drag over
       * @param ev
       */
    }, {
      key: "onDragOver",
      value: function onDragOver(ev) {
        var data = draggedCodesManager.get();
        var searchResult = uiCommon.cmxTypeguards.isSearchResult(data);
        if (searchResult) {
          var _this$props3 = this.props,
            codableTransaction = _this$props3.codableTransaction,
            chargeSession = _this$props3.chargeSession;
          var hasCPT = (codableTransaction || chargeSession).codes.filter(uiCommon.cmxTypeguards.isChargeSessionCode).some(function (sessionCode) {
            return sessionCode.provenance.toUpperCase() === ChargeSessionCodeProvenance.CPT.toUpperCase();
          });
          var allowed = data.codeType.toUpperCase() === ChargeSessionCodeProvenance.CPT ? !hasCPT : true;
          if (allowed) {
            ev.dataTransfer.dropEffect = 'copy';
            ev.preventDefault();
            if (!this.state.dragHover) {
              this.setState({
                dragHover: true
              });
            }
          }
        }
      }

      /**
       * Event for drag leaves
       * @param ev
       */
    }, {
      key: "onDragLeave",
      value: function onDragLeave(ev) {
        if (this.state.dragHover) {
          this.setState({
            dragHover: false
          });
        }
        ev.dataTransfer.dropEffect = 'none';
      }

      /**
       * Event for drag drops
       * @param ev
       */
    }, {
      key: "onDrop",
      value: function onDrop(ev) {
        var searchResult = draggedCodesManager.parseEvent(ev);
        draggedCodesManager.clear();
        var codableTransaction = this.props.codableTransaction;
        if (codableTransaction) {
          var codes = codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).filter(function (sessionCode) {
            return sessionCode.codeType.toUpperCase() === searchResult.codeType.toUpperCase();
          });
          var result = _objectSpread$t(_objectSpread$t({}, searchResult), {}, {
            context: {
              invoice: _objectSpread$t({}, this.props.invoice),
              transaction: _objectSpread$t({}, this.props.codableTransaction),
              chargeSession: _objectSpread$t({}, this.props.chargeSession),
              processInstance: _objectSpread$t({}, this.props.processInstance)
            }
          });
          codes.push(result);
          this.props.onCodeSearchSelection(_objectSpread$t(_objectSpread$t({}, searchResult), {}, {
            context: {
              chargeSession: _objectSpread$t({}, this.props.chargeSession)
            }
          }));
          this.setState({
            dragHover: false
          });
          if (this.lookupRef.current) {
            this.lookupRef.current.reset();
            this.lookupRef.current.focus();
          }
        }
      }

      /**
       * Event for handle drag drop
       * @param ev
       */
    }, {
      key: "onDropHandler",
      value: function onDropHandler(dropAction) {
        var _this$props4 = this.props,
          chargeSession = _this$props4.chargeSession,
          codableTransaction = _this$props4.codableTransaction;
        var dropCandidate = dropAction.dropCandidate,
          dropTarget = dropAction.dropTarget;
        var sameCodeType = "".concat(dropCandidate.codeType).toUpperCase() === "".concat(dropTarget.codeType).toUpperCase();
        var matchCodes = function matchCodes(sessionCode) {
          var matchType = "".concat(sessionCode.codeType).toUpperCase() === "".concat(dropCandidate.codeType).toUpperCase();
          var matchProvenance = "".concat(sessionCode.provenance).toUpperCase() === "".concat(dropCandidate.codeType).toUpperCase();
          if (matchProvenance || matchType) {
            return sessionCode.code !== dropCandidate.code;
          }
          return false;
        };
        // remove the code from our code list
        var codes = (codableTransaction || chargeSession).codes.filter(matchCodes).filter(uiCommon.cmxTypeguards.isChargeSessionCode);
        var searchResult = uiCommon.cmxTypeguards.isSearchResult(dropCandidate);
        var dropCode = dropCandidate;
        if (searchResult) {
          dropCode = {
            code: dropCandidate.code,
            codeType: dropCandidate.codeType,
            description: dropCandidate.description
          };
          var targetPosition = codes.findIndex(function (sessionCode) {
            return sessionCode.code === dropTarget.code;
          });
          if (dropAction.position === 'after') {
            targetPosition++;
          }
          codes.splice(targetPosition, 0, dropCode);
          if (this.lookupRef.current) {
            this.lookupRef.current.reset();
            this.lookupRef.current.focus();
          }
        } else {
          // if the codes are of the same code type
          // then a drop is just a reordering of the same codes
          // if a drop is on a different code type, then we need
          // to do something different.
          if (sameCodeType) {
            var targetCode = dropTarget.code;
            if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropCode)) {
              var zippedDropCode = dropCode;
              var blockSet = new Set(zippedDropCode.codes.map(function (code) {
                return code.code;
              }));
              var filteredArray = _toConsumableArray(codes).filter(function (code) {
                return !blockSet.has(code.code);
              });
              var seekPosition = filteredArray.findIndex(function (sessionCode) {
                return sessionCode.code === dropTarget.code;
              });
              if (dropAction.position === 'after') {
                seekPosition++;
              }
              filteredArray.splice.apply(filteredArray, [seekPosition, 0].concat(_toConsumableArray(zippedDropCode.codes)));
              codes = filteredArray;

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (shared row moved)', {});
            } else {
              // if this is a shared code block then we need to rewind to the
              // front of the shared codes
              var codeIncrement = 1;
              if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropTarget)) {
                var zippedDropTarget = dropTarget;
                var _zippedDropTarget$cod = _slicedToArray(zippedDropTarget.codes, 1),
                  firstCode = _zippedDropTarget$cod[0];
                targetCode = firstCode.code;
                codeIncrement = zippedDropTarget.codes.length;
              }
              var _targetPosition = codes.findIndex(function (sessionCode) {
                return sessionCode.code === targetCode;
              });
              if (dropAction.position === 'after') {
                _targetPosition += codeIncrement;
              }
              codes.splice(_targetPosition, 0, dropCandidate);
            }

            // capturing the drag complete for Datadog Action
            // @ts-ignore
            window.DD_RUM.addAction('Drag (any code row moved)', {});
          } else {
            if (uiCommon.cmxTypeguards.isZippedCodeBlock(dropCandidate)) {
              var zippedDropCandidate = dropCandidate;
              var _blockSet = new Set(zippedDropCandidate.codes.map(function (code) {
                return code.code;
              }));
              var _filteredArray = _toConsumableArray(codes).filter(function (code) {
                return !_blockSet.has(code.code);
              });
              var _seekPosition = _filteredArray.findIndex(function (sessionCode) {
                return sessionCode.code === dropTarget.code;
              });
              if (dropAction.position === 'after') {
                _seekPosition++;
              }
              _filteredArray.splice.apply(_filteredArray, [_seekPosition, 0].concat(_toConsumableArray(zippedDropCandidate.codes)));
              codes = _filteredArray;

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (shared row moved to top)', {});
            } else {
              // there is a defined visual order of codes
              // PROCEDURES, MODIFIERS, DX
              // if this changes, then the order will need to be updated
              var dropIndex = CODE_ORDER.get("".concat(dropCandidate.codeType));
              var dropTargetIndex = CODE_ORDER.get("".concat(dropTarget.codeType));
              if (dropIndex < dropTargetIndex) {
                codes.push(dropCandidate);
              } else {
                codes.unshift(dropCandidate);
              }

              // capturing the drag complete for Datadog Action
              // @ts-ignore
              window.DD_RUM.addAction('Drag (invoice code row move to top)', {});
            }
          }
        }
        var changeDetail = {
          codes: codes,
          context: {
            chargeSession: _objectSpread$t({}, this.props.chargeSession),
            invoice: _objectSpread$t({}, this.props.invoice),
            transaction: _objectSpread$t({}, this.props.codableTransaction),
            processInstance: _objectSpread$t({}, this.props.processInstance)
          }
        };
        this.props.handleCodeSearchDrop(changeDetail);
        this.setState({
          dragHover: false
        });
      }

      /**
       * Event launched when a search is performed
       * @param ev
       */
    }, {
      key: "onSearch",
      value: function onSearch(codeQuery) {
        this.props.onCodeSearch(_objectSpread$t(_objectSpread$t({}, codeQuery), {}, {
          context: {
            transaction: _objectSpread$t({}, this.props.codableTransaction),
            invoice: _objectSpread$t({}, this.props.invoice),
            chargeSession: _objectSpread$t({}, this.props.chargeSession),
            processInstance: _objectSpread$t({}, this.props.processInstance)
          }
        }));
      }

      /**
       * Event launched when a search selection is pressed
       * @param ev
       */
    }, {
      key: "onSearchSelection",
      value: function onSearchSelection(searchResult) {
        var present = this.props.codableTransaction.codes.findIndex(function (code) {
          return code.code === searchResult.codeInfo.code;
        });
        var searchSelection = {
          codeInfo: searchResult.codeInfo,
          context: {
            defaultPrevented: present !== -1,
            invoice: _objectSpread$t({}, this.props.invoice),
            transaction: _objectSpread$t({}, this.props.codableTransaction),
            chargeSession: _objectSpread$t({}, this.props.chargeSession),
            processInstance: _objectSpread$t({}, this.props.processInstance)
          }
        };
        this.props.onCodeSearchSelection(searchSelection);
      }

      /**
       * Event launched when units input is clicked
       * @param ev
       */
    }, {
      key: "handleUnitsClick",
      value: function handleUnitsClick(ev) {
        ev.stopPropagation();
        if (this.props.editable) {
          var element = ev.target;
          if (element instanceof HTMLInputElement && element.type === 'text') {
            element.select();
          }
        }
      }

      /**
       * Event launched when a code is deleted
       * @param ev
       */
    }, {
      key: "handleCodeDelete",
      value: function handleCodeDelete(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        if (this.props.editable) {
          var _this$props5 = this.props,
            chargeSession = _this$props5.chargeSession,
            codableTransaction = _this$props5.codableTransaction;
          var element = ev.target;
          var dataItem = getDataItem(element, codableTransaction || chargeSession);
          var changeDetail = {
            codes: [dataItem],
            context: {
              chargeSession: _objectSpread$t({}, this.props.chargeSession),
              transaction: _objectSpread$t({}, this.props.codableTransaction),
              invoice: _objectSpread$t({}, this.props.invoice),
              processInstance: _objectSpread$t({}, this.props.processInstance)
            }
          };
          this.props.handleCodeRemove(changeDetail);
          if (this.lookupRef.current) {
            this.lookupRef.current.focus();
          }
        }
      }

      /**
       * Event launched when a shared code is toggled.
       * @param ev
       */
    }, {
      key: "handleCodeChecked",
      value: function handleCodeChecked(ev) {
        ev.stopPropagation();
        var codableTransaction = this.props.codableTransaction;
        var action = ev.target.checked ? 'ADD' : 'REMOVE';
        var diagnoses = [];
        if (action === 'REMOVE') {
          diagnoses = [{
            diagnosis_code: ev.target.name,
            shared: true
          }];
        } else if (action === 'ADD') {
          var codes = this.props.codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).filter(function (code) {
            return code.codeType === 'diagnosis';
          });
          diagnoses = codes.map(function (code, idx) {
            return {
              diagnosis_code: code.code,
              sequence_number: idx + 1,
              //@ts-ignore
              shared: code.shared,
              //@ts-ignore
              active: code.code === ev.target.name ? true : code.active
            };
          });
        }
        var payload = {
          action: action,
          codeUpdate: {
            transactionGuid: codableTransaction.guid,
            processInstance: this.props.processInstance,
            serviceLine: this.props.processInstance.serviceLine,
            diagnoses: diagnoses
          }
        };
        this.props.onTransactionSharedDiagnosisChange(payload);
      }

      /**
       * Event launched when a key is pressed on input tag
       * @param ev
       */
    }, {
      key: "handleKeyPress",
      value: function handleKeyPress(ev) {
        ev.stopPropagation();
        if (this.props.editable) {
          var codableTransaction = this.props.codableTransaction;
          var element = ev.target;
          var codeUnitsInput = element === null || element === void 0 ? void 0 : element.closest('.code-units-input');
          var dataItem = getDataItem(element, codableTransaction);
          if (codeUnitsInput && isAValidUnits(codeUnitsInput.value)) {
            this.currentUnit = parseUnits(parseInt(codeUnitsInput.value));
            var code = _objectSpread$t(_objectSpread$t({}, dataItem), {}, {
              units: this.currentUnit
            });
            var changeDetail = {
              codes: [code],
              context: {
                chargeSession: _objectSpread$t({}, this.props.chargeSession),
                transaction: _objectSpread$t({}, this.props.codableTransaction),
                invoice: _objectSpread$t({}, this.props.invoice),
                processInstance: _objectSpread$t({}, this.props.processInstance)
              }
            };
            this.props.handleCodeChange(changeDetail);
          } else {
            this.currentUnit = dataItem !== null && dataItem !== void 0 && dataItem.units ? Number(dataItem === null || dataItem === void 0 ? void 0 : dataItem.units) : null;
          }
        }
      }
    }, {
      key: "onDelete",
      value:
      /**
       * Event launched when a transaction is deleted
       * @param event
       */
      function onDelete(event) {
        event.preventDefault();
        this.props.onChargeSessionAction({
          action: 'DELETE_TRANSACTION',
          chargeSession: this.props.chargeSession,
          meta: {
            invoice: this.props.invoice,
            transaction: _objectSpread$t({}, this.props.codableTransaction)
          }
        });
      }

      /**
       * Event launched by the accordion
       * @param action
       * @param item
       */
    }, {
      key: "onAccordionAction",
      value: function onAccordionAction(action, item) {
        var chargeSessionCode = item.data;
        var opening = action === uiComponents.AccordionSectionAction.OPEN;
        var selection = {
          chargeSessionCode: chargeSessionCode,
          evidence: chargeSessionCode.evidence,
          selectionState: {
            active: false,
            hover: false,
            visible: opening
          }
        };
        this.props.onFeatureSelection(selection);
      }

      /**
       * Method used for enable a procedure with tech/pro charge
       * @param techTransactionCodable
       */
    }, {
      key: "handleEnableTechPro",
      value: function handleEnableTechPro(techTransactionCodable) {
        if (this.props.editable) {
          techTransactionCodable.invoice = this.props.invoice;
          this.props.handleEnableTechPro(techTransactionCodable);
        }
      }

      /**
       * Method used for disable a procedure with tech/pro charge
       * @param techTransactionCodable
       */
    }, {
      key: "handleDisableTechPro",
      value: function handleDisableTechPro(techTransactionCodable) {
        if (this.props.editable) {
          techTransactionCodable.invoice = this.props.invoice;
          this.props.handleDisableTechPro(techTransactionCodable);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _transaction$type, _codableTransaction$p, _codableTransaction$p2, _codableTransaction$p3, _codableTransaction$p4, _codableTransaction$p5;
        var _this$props6 = this.props,
          chargeSession = _this$props6.chargeSession,
          codableTransaction = _this$props6.codableTransaction,
          lineNumber = _this$props6.lineNumber,
          editable = _this$props6.editable,
          invoice = _this$props6.invoice;
          _this$props6.onCodeSearch;
          _this$props6.handleCodeChange;
          _this$props6.handleCodeSearchDrop;
          _this$props6.handleCodeRemove;
          var canDropOnto = _this$props6.canDropOnto,
          searchResults = _this$props6.searchResults;
          _this$props6.onCodeSearchSelection;
          var onFeatureSelection = _this$props6.onFeatureSelection;
          _this$props6.onChargeSessionAction;
          _this$props6.onEdit;
          var autoFocus = _this$props6.autoFocus,
          panelActivations = _this$props6.panelActivations;
          _this$props6.processInstance;
          var transaction = _this$props6.transaction;
          _this$props6.debounceTimeout;
          var codeEdits = _this$props6.codeEdits;
          _this$props6.onTransactionSharedDiagnosisChange;
          _objectWithoutProperties(_this$props6, _excluded$a);
        var txnType = (_transaction$type = transaction === null || transaction === void 0 ? void 0 : transaction.type) !== null && _transaction$type !== void 0 ? _transaction$type : 'unknown txn type';
        var styleClasses = ['charge-session-information', "charge-session-".concat(txnType.toLowerCase()), {
          'charge-session-editable': editable,
          'charge-session-uneditable': !editable,
          'charge-session-drop-zone': this.state.dragHover
        }];
        var boundAccordionBuilder = transactionAccordianBuilder.bind(null, this.handleKeyPress, this.handleBlurEvent, this.handleUnitsClick, this.handleCodeDelete, this.handleCodeChecked, this.handleDisableTechPro, this.handleEnableTechPro, onFeatureSelection, this.isTimeBasedCode, this.timeBasedCodePopup, panelActivations, invoice, codeEdits);
        var assuranceErrorMessage = codableTransaction !== null && codableTransaction !== void 0 && (_codableTransaction$p = codableTransaction.procedure) !== null && _codableTransaction$p !== void 0 && _codableTransaction$p.errorMessages ? codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p2 = codableTransaction.procedure) === null || _codableTransaction$p2 === void 0 ? void 0 : _codableTransaction$p2.errorMessages : [];

        // removing procedures with provenance TECH
        if (codableTransaction !== null && codableTransaction !== void 0 && codableTransaction.hasOwnProperty('codes')) {
          codableTransaction.codes = codableTransaction.codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code);
          }).filter(function (code) {
            return !(code.codeType === 'procedure' && code.provenance === 'TECH');
          });
        }
        var sharedCodes = (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES;
        var boundAccordionBuilderHandler = function boundAccordionBuilderHandler(code, index) {
          return boundAccordionBuilder(code, index, codableTransaction, assuranceErrorMessage);
        };
        var items = [];
        var chargeMeta = false;
        if (codableTransaction) {
          var _codableTransaction$c;
          var codes = JSON.parse(JSON.stringify((_codableTransaction$c = codableTransaction.codes) !== null && _codableTransaction$c !== void 0 ? _codableTransaction$c : []));
          if (!sharedCodes) {
            var onlyShared = codes.filter(sharedCodePredicate);
            var firstIndex = codes.findIndex(sharedCodePredicate);
            codes.findIndex(notSharedCodePredicate, firstIndex);
            var preArray = codes.slice(0, firstIndex);
            var postArray = codes.slice(firstIndex + onlyShared.length);
            var zippedShareCodes = {
              codes: onlyShared,
              codeType: uiCommon.commonEnums.CodeType.DIAGNOSIS,
              zipped: true
            };
            codes = [].concat(_toConsumableArray(preArray), [zippedShareCodes], _toConsumableArray(postArray));
          }
          var filtered = codes.filter(function (code) {
            return uiCommon.cmxTypeguards.isChargeSessionCode(code) || uiCommon.cmxTypeguards.isZippedCodeBlock(code) && code.codes.length;
          });
          items = filtered.map(boundAccordionBuilderHandler);
          // TODO: Determine code types
          chargeMeta = (invoice === null || invoice === void 0 ? void 0 : invoice.type) !== uiCommon.commonEnums.InvoiceTypes.SHARED_CODES ? /*#__PURE__*/React.createElement("div", {
            className: "charge-line"
          }, /*#__PURE__*/React.createElement("span", {
            className: "charge-index"
          }, "Charge ", lineNumber, ":"), /*#__PURE__*/React.createElement("span", {
            className: "charge-charge-type",
            style: {
              display: 'none'
            }
          }, "SOME CODE TYPE:"), editable ? /*#__PURE__*/React.createElement("span", {
            className: "charge-delete-container"
          }, /*#__PURE__*/React.createElement("a", {
            href: "#/delete-session",
            onClick: this.onDelete
          }, "remove")) : false) : false;
        } else if (chargeSession) {
          items = chargeSession.codes.map(boundAccordionBuilderHandler);

          // TODO: Determine code types
          chargeMeta = /*#__PURE__*/React.createElement("div", {
            className: "charge-line"
          }, /*#__PURE__*/React.createElement("span", {
            className: "charge-index"
          }, "Charge ", lineNumber, ":"), /*#__PURE__*/React.createElement("span", {
            className: "charge-charge-type",
            style: {
              display: 'none'
            }
          }, "SOME CODE TYPE:"), editable ? /*#__PURE__*/React.createElement("span", {
            className: "charge-delete-container"
          }, /*#__PURE__*/React.createElement("a", {
            href: "#/delete-session",
            onClick: this.onDelete
          }, "remove")) : false);
        } else if (transaction) {
          var diagnosis = [];
          var modifiers = [];
          // TODO:
          // const diagnosis = (invoice?.shared_codes.diagnoses ?? []).map(
          //   code => code.diagnosis_code
          // );
          // const modifiers = (invoice?.shared_codes.modifiers ?? []).map(
          //   code => code.modifier_code
          // );
          var dxString = diagnosis.length ? "diagnosis: ".concat(diagnosis.join(', ')) : '';
          var modString = modifiers.length ? "modifiers: ".concat(modifiers.join(', ')) : '';
          var conjunction = diagnosis.length && modifiers.length ? ' and ' : '';
          var alsoIncludes = "".concat(dxString, " ").concat(conjunction, " ").concat(modString);
          styleClasses.push({
            'show-also-includes': diagnosis.length || modifiers.length
          });
          var label = txnType in CHARGE_TYPE_LABEL ? CHARGE_TYPE_LABEL[txnType] : txnType;
          items = transaction.codes.map(boundAccordionBuilderHandler);
          chargeMeta = /*#__PURE__*/React.createElement("div", {
            className: "transaction-meta transaction-".concat(txnType.toLowerCase())
          }, /*#__PURE__*/React.createElement("span", {
            className: "ordinal"
          }, lineNumber, ". "), label, ' ', /*#__PURE__*/React.createElement("span", {
            className: "also-includes"
          }, "Includes shared ", alsoIncludes));
          styleClasses.push({
            'charge-session-has-description': !!transaction.description
          });
        }
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(styleClasses)
        }, chargeMeta, /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: codableTransaction === null || codableTransaction === void 0 ? void 0 : codableTransaction.errorMessages,
          messageStyle: "txn-error-message",
          messageType: "error"
        }), /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p3 = codableTransaction.procedure) === null || _codableTransaction$p3 === void 0 ? void 0 : _codableTransaction$p3.errorMessages,
          messageStyle: "procedure-error-message",
          messageType: "error"
        }), items.length ? /*#__PURE__*/React.createElement(uiComponents.Accordion, {
          onAction: this.onAccordionAction,
          dragManager: draggedCodesManager,
          canDropOnto: canDropOnto,
          onDropHandler: this.onDropHandler,
          selectable: true,
          droppable: true,
          items: items,
          errors: (_codableTransaction$p4 = codableTransaction === null || codableTransaction === void 0 || (_codableTransaction$p5 = codableTransaction.procedure) === null || _codableTransaction$p5 === void 0 ? void 0 : _codableTransaction$p5.errorMessages) !== null && _codableTransaction$p4 !== void 0 ? _codableTransaction$p4 : []
        }) : editable ? /*#__PURE__*/React.createElement("div", {
          className: "empty-message editable"
        }, "Add codes using the search box below.") : /*#__PURE__*/React.createElement("div", {
          className: "empty-message uneditable"
        }, "No codes selected"), editable && codableTransaction && /*#__PURE__*/React.createElement(uiComponents.Lookup, {
          ref: this.lookupRef,
          actionPrefix: "",
          placeholderText: (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES ? 'Add shared diagnosis' : 'Search for code',
          debounceTimeout: this.props.debounceTimeout,
          FieldDefinitions: codableTransaction.fieldDefinitions,
          shouldShowResults: uiComponents.shouldShowResults,
          autoFocus: autoFocus,
          onSearch: this.onSearch,
          onSearchSelection: this.onSearchSelection,
          searchResults: searchResults,
          searchResultsLookupKey: codableTransaction.guid,
          actionNameForDD: (invoice === null || invoice === void 0 ? void 0 : invoice.type) === uiCommon.commonEnums.InvoiceTypes.SHARED_CODES ? '~Focus code search (Shared)' : '~Focus code search (General)'
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(Transaction, "displayName", 'Transaction');
  _defineProperty(Transaction, "defaultProps", {
    autoFocus: false,
    searchResults: [],
    editable: true,
    panelActivations: {},
    codeEdits: {},
    debounceTimeout: 200,
    canDropOnto: canDropOnto,
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    handleCodeChange: function handleCodeChange(change) {},
    handleCodeRemove: function handleCodeRemove(change) {},
    handleCodeSearchDrop: function handleCodeSearchDrop(change) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    onFeatureSelection: function onFeatureSelection(feature) {},
    onEdit: function onEdit(chargeSession) {},
    handleTimeBasedCodeAdd: function handleTimeBasedCodeAdd(change, time, age) {},
    handleTimeBasedCodeUpdate: function handleTimeBasedCodeUpdate(change, time, age) {}
  });

  var ArtifactTypes = {
    ASSEMBLED: 'From CodaMetrix (preliminary)',
    CODED: 'From CAC',
    MAPPED: 'From dictionary lookups (internal)',
    CLINICAL: 'From source (HL7)',
    CLAIM: 'From catalog file',
    PREDICTION: 'From machine learning prediction',
    PROCESSED: 'From CodaMetrix',
    SUBMITTED: 'Sent to billing',
    REMITTANCE: 'From a response to the payer',
    REFERRAL: 'From referral',
    MANUAL: 'From manual',
    CQA: 'From CodaMetrix QA'
  };
  var AmplifyInvoiceSourceHeader = {
    CLINICAL: 'From Source',
    MAPPED: 'From Rules',
    PREDICTION: 'From Prediction',
    PREDICTION_COMPONENT: 'From Prediction Component',
    ASSEMBLED: 'Assembled in Amplify'
  };
  var AmplifyCodeSourceHeader = {
    CLINICAL: 'Provider Submitted Set',
    MAPPED: 'Rule Set',
    PREDICTION: 'CMX Predicted Set',
    CODED: 'Coder Set',
    PROCESSED: 'Processed Set',
    SUBMITTED: 'Submitted Set'
  };
  var InvoiceTypes = {
    CLINICAL: 'CLINICAL',
    ASSEMBLED: 'ASSEMBLED'};

  function _callSuper$m(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$m() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$m() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$m = function _isNativeReflectConstruct() { return !!t; })(); }
  var Invoice = /*#__PURE__*/function (_React$Component) {
    function Invoice() {
      _classCallCheck(this, Invoice);
      return _callSuper$m(this, Invoice, arguments);
    }
    _inherits(Invoice, _React$Component);
    return _createClass(Invoice, [{
      key: "render",
      value: function render() {
        var _invoice$billing_area,
          _this = this;
        var _this$props = this.props,
          invoice = _this$props.simplifiedInvoice,
          panelActivations = _this$props.panelActivations,
          handleCodeChange = _this$props.handleCodeChange,
          handleCodeRemove = _this$props.handleCodeRemove,
          handleCodeSearchDrop = _this$props.handleCodeSearchDrop,
          onCodeSearch = _this$props.onCodeSearch,
          onCodeSearchSelection = _this$props.onCodeSearchSelection,
          onFeatureSelection = _this$props.onFeatureSelection,
          onChargeSessionAction = _this$props.onChargeSessionAction,
          editable = _this$props.editable;
        var transactions = invoice.transactions;
        var heading = pluralize('Procedure', transactions.length);
        var billingArea = (_invoice$billing_area = invoice.billing_area) !== null && _invoice$billing_area !== void 0 ? _invoice$billing_area : 'unspecified billing area';
        var billingProvider = invoice.billing_provider_name !== 'null' ? invoice.billing_provider_name : 'unspecified provider';
        var txnCount = 0;
        var txns = transactions.map(function (transaction, idx) {
          if (transaction.type !== 'SHARED_CODES') {
            txnCount += 1;
          }
          var TransactionComponent = _this.props.transactionV2 ? TransactionV2 : Transaction;
          var transactionProps = {
            onChargeSessionAction: onChargeSessionAction,
            panelActivations: panelActivations,
            handleCodeChange: handleCodeChange,
            handleCodeRemove: handleCodeRemove,
            handleCodeSearchDrop: handleCodeSearchDrop,
            onCodeSearch: onCodeSearch,
            onCodeSearchSelection: onCodeSearchSelection,
            onFeatureSelection: onFeatureSelection,
            lineNumber: txnCount,
            editable: editable,
            transaction: transaction
          };
          var tabContainerRef = /*#__PURE__*/React.createRef();

          //Only add scrollContainerRef if using TransactionV2
          var additionalProps = _this.props.transactionV2 ? {
            scrollContainerRef: tabContainerRef
          } : {};
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "invoice-here"
          }, /*#__PURE__*/React.createElement(TransactionComponent, _extends$1({}, additionalProps, transactionProps)));
        });
        var invoiceStyleClasses = ['invoice', "invoice-type-".concat(invoice.type).toLowerCase(), {
          'invoice-no-transactions': transactions.length === 0,
          'invoice-no-billing-area': !invoice.billing_area
        }];
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(invoiceStyleClasses)
        }, /*#__PURE__*/React.createElement("div", {
          className: "invoice-provenance"
        }, uiCommon.objectUtils.get(ArtifactTypes, invoice.type.toUpperCase(), invoice.type)), /*#__PURE__*/React.createElement("h4", {
          className: "invoice-heading"
        }, heading, " by ", billingProvider, /*#__PURE__*/React.createElement("span", {
          className: "billing-area"
        }, " at ", billingArea), "."), txns, /*#__PURE__*/React.createElement("div", {
          className: "no-charges empty-message"
        }, "No codes available."));
      }
    }]);
  }(React.Component);
  _defineProperty(Invoice, "displayName", 'Invoice');
  _defineProperty(Invoice, "defaultProps", {
    autoFocus: false,
    searchResults: [],
    editable: true,
    panelActivations: {},
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    handleCodeChange: function handleCodeChange(change) {},
    handleCodeRemove: function handleCodeRemove(change) {},
    handleCodeSearchDrop: function handleCodeSearchDrop(change) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    onFeatureSelection: function onFeatureSelection(feature) {}
  });

  function ownKeys$s(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$s(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$s(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$s(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_PROPS$6 = {
    documentMetadata: [],
    grouped: false,
    onSelect: function onSelect(docMetadata) {}
  };
  var DocCategories$1 = {
    DFT: 'DFTs',
    DFT_IN: 'Inbound DFTs',
    DFT_OUT: 'Outbound DFTs',
    NTE: 'Notes',
    NOTE: 'Notes',
    HL7: 'HL7 Messages',
    DFT_EHR: 'DFT EHRs'
  };
  var NotesSidebar = function NotesSidebar(passed) {
    var props = _objectSpread$s(_objectSpread$s({}, DEFAULT_PROPS$6), passed);
    var documentMetadata = props.documentMetadata,
      onSelect = props.onSelect,
      activeNote = props.activeNote;
      props.isIPC;
      props.capabilities;
      var grouped = props.grouped;

    //@ts-ignore
    var prepped = (documentMetadata || []).map(function (doc) {
      // Document categories are not named for end users.
      // Supplant with our own category names, shown above.
      // But if someone adds a document category we don't want to
      // blow up.
      if (doc.mimeType === 'text/html') {
        doc.documentCategory = 'HTML';
      }
      return _objectSpread$s(_objectSpread$s({}, doc), {}, {
        documentCategory: DocCategories$1[doc.documentCategory] || doc.documentCategory
      });
    });
    var preppedDocs;
    if (grouped) {
      var sortGroupedDocs = function sortGroupedDocs(a, b) {
        if (a === b) return 0;
        if (a === 'HL7 Messages' || a === 'Notes') return -1;
        if (b === 'HL7 Messages' || b === 'Notes') return 1;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      };
      preppedDocs = uiCommon.objectUtils.groupBy(prepped, 'documentCategory');
      Object.keys(preppedDocs).sort(sortGroupedDocs);
    } else {
      preppedDocs = prepped;
    }
    var buildDocList = function buildDocList(docs) {
      return docs.map(function (document, idx) {
        var _document$documentNam;
        var onClick = function onClick(event) {
          event.preventDefault();
          onSelect(document);
        };
        var isActive = (activeNote === null || activeNote === void 0 ? void 0 : activeNote.id) === document.id;
        var styleClasses = classnames([{
          'is-active': isActive
        }, 'sidebar-link']);
        return /*#__PURE__*/React.createElement("li", {
          key: document.documentGuid.uuid,
          className: styleClasses
        }, /*#__PURE__*/React.createElement("a", {
          href: "#/something",
          onClick: onClick
        }, /*#__PURE__*/React.createElement("span", {
          className: "document-name"
        }, (_document$documentNam = document.documentName) !== null && _document$documentNam !== void 0 ? _document$documentNam : 'Name N/A'), /*#__PURE__*/React.createElement("span", {
          className: "document-description"
        }, document.documentDescription), /*#__PURE__*/React.createElement("span", {
          className: "document-status"
        }, document.documentStatus)));
      });
    };
    var content;
    if (grouped) {
      content = Object.keys(preppedDocs).map(function (key) {
        var docs = preppedDocs[key];
        var items = buildDocList(preppedDocs[key]);
        return /*#__PURE__*/React.createElement("div", {
          key: key
        }, /*#__PURE__*/React.createElement("span", {
          className: "note-doc-category",
          style: {
            display: 'none'
          }
        }, docs[0].documentCategory), /*#__PURE__*/React.createElement("ul", {
          className: "note-sidebar-list"
        }, items));
      });
    } else {
      content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: "note-sidebar-list"
      }, buildDocList(preppedDocs)), ' ');
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "notes-sidebar"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sidebar-fixed"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sidebar-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "sidebar-inner"
    }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [(documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.length) > 1]
    }, /*#__PURE__*/React.createElement(React.Fragment, null, content)), props.children))));
  };

  var InvoiceMetaHeading = function InvoiceMetaHeading(_ref) {
    var meta = _ref.meta,
      onImportClick = _ref.onImportClick;
    if (meta.imported) {
      return /*#__PURE__*/React.createElement("div", {
        className: "import-divider qa-invoice-meta invoice-meta-container"
      }, /*#__PURE__*/React.createElement("h4", {
        className: "meta-heading-label"
      }, "Bundled codes", ' ', /*#__PURE__*/React.createElement(Tooltip, {
        label: "This case was billed under the following case.  The diagnosis may or may not apply directly."
      }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(r, {
        iconName: e.Info,
        iconSize: "16",
        iconClass: "icon-image",
        titleText: "Info"
      })))), /*#__PURE__*/React.createElement(InvoiceMeta, {
        meta: meta,
        onImportClick: onImportClick
      }));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "import-divider qa-invoice-meta invoice-meta-container"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "meta-heading-label"
    }, "Original codes", ' ', /*#__PURE__*/React.createElement(Tooltip, {
      label: "This case was billed as the case shown above.  The codes below are original to this case, but may or may not have been used in billing."
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(r, {
      iconName: e.Info,
      iconSize: "16",
      iconClass: "icon-image",
      titleText: "Info"
    })))));
  };
  var InvoiceMeta = function InvoiceMeta(_ref2) {
    var meta = _ref2.meta,
      onImportClick = _ref2.onImportClick;
    if (meta.imported) {
      return /*#__PURE__*/React.createElement("span", {
        className: "submitted-item-link-container"
      }, "Sent as", ' ', /*#__PURE__*/React.createElement("a", {
        className: "qa-related-group-item-link submitted-item-link",
        href: "/cmx/cases/".concat(meta.ownerCaseId),
        onClick: onImportClick,
        "data-case-id": "".concat(meta.ownerCaseId)
      }, /*#__PURE__*/React.createElement("div", {
        className: "view-case-link-inner sensitive-data"
      }, meta.description)));
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "invoice-meta-empty"
    });
  };

  function ownKeys$r(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$r(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$r(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$r(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$l(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$l() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$l() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$l = function _isNativeReflectConstruct() { return !!t; })(); }
  var completeSet$1 = uiCommon.cmxArtifacts.artifactSets.completeSet,
    isSingleSelection$1 = uiCommon.cmxArtifacts.isSingleSelection,
    getFeatureForSelection$1 = uiCommon.cmxArtifacts.getFeatureForSelection,
    isMultipleSelection$1 = uiCommon.cmxArtifacts.isMultipleSelection;
  var expandedProps$1 = new Set(['procedure_type', 'ordering_provider_name', 'ordering_provider_number.number', 'order_number.number', 'date_of_service', 'place_of_service', 'tenant_name', 'billing_provider_name', 'billing_provider_number.number', 'visit_number.number', 'case_id']);
  var expandedAmplifyProps$1 = new Set(['accession', 'exam_code', 'exam_description', 'reason_for_visit']);
  var getStatusTimestamp$1 = function getStatusTimestamp(caseRun, stages) {
    if (caseRun.case_completed_datetime) {
      return uiCommon.cmxDateTime.format(caseRun.case_completed_datetime, uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    if (stages.length) {
      var _stage$displayDate$ra;
      var stage = _toConsumableArray(stages).reverse().pop();
      return uiCommon.cmxDateTime.format((_stage$displayDate$ra = stage === null || stage === void 0 ? void 0 : stage.displayDate.raw) !== null && _stage$displayDate$ra !== void 0 ? _stage$displayDate$ra : new Date(), uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    return 'N/A';
  };
  var conditionalUtils$6 = uiCommon.AmplifyCore.conditionalUtils;
  var CaseDetail = /*#__PURE__*/function (_React$Component) {
    function CaseDetail(props) {
      var _this;
      _classCallCheck(this, CaseDetail);
      _this = _callSuper$l(this, CaseDetail, [props]);
      _defineProperty(_this, "_artifactRef", void 0);
      _defineProperty(_this, "_noteRef", void 0);
      _defineProperty(_this, "_patientRef", void 0);
      _defineProperty(_this, "noteRefs", {});
      _this._handleToggleClick = _this._handleToggleClick.bind(_this);
      _this._onFeatureSelection = _this._onFeatureSelection.bind(_this);
      _this._handleOpenJson = _this._handleOpenJson.bind(_this);
      _this._handleProcessIdChange = _this._handleProcessIdChange.bind(_this);
      _this._handleGroupedCaseClick = _this._handleGroupedCaseClick.bind(_this);
      _this._handlePatientExpansion = _this._handlePatientExpansion.bind(_this);
      _this.onFeatureActivation = _this.onFeatureActivation.bind(_this);
      var showAllArtifacts = completeSet$1.size === props.artifactSet.size;
      _this._artifactRef = /*#__PURE__*/React.createRef();
      _this._noteRef = /*#__PURE__*/React.createRef();
      _this._patientRef = /*#__PURE__*/React.createRef();
      _this.props.setActiveNote(_this.props.notes[0]);
      _this.state = {
        expandEncounter: false,
        openClaims: [],
        backHover: false,
        showAllArtifacts: showAllArtifacts
      };
      return _this;
    }
    _inherits(CaseDetail, _React$Component);
    return _createClass(CaseDetail, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$match;
        var _ref = (_this$props$match = this.props.match) !== null && _this$props$match !== void 0 ? _this$props$match : {},
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params;
        if (this.props.mode !== 'code-edit') {
          this.props.onNavigate(params.id, undefined, params.serviceLine, this.props.tenantId, this.props.hasAmplifyCaseRunV2Access);
        }
        return;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var _this2 = this;
        this.props.notes.forEach(function (note) {
          _this2.noteRefs[note.document_id] = /*#__PURE__*/React.createRef();
        });
      }
    }, {
      key: "_handleGroupedCaseClick",
      value: function _handleGroupedCaseClick(ev) {
        var _this$props$match2;
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item) return;
        var caseId = item.value;
        if (!caseId) return;
        // assume all grouped cases will be in the same service line
        var _ref2 = (_this$props$match2 = this.props.match) !== null && _this$props$match2 !== void 0 ? _this$props$match2 : {},
          _ref2$params = _ref2.params,
          params = _ref2$params === void 0 ? {} : _ref2$params;
        this.props.onNavigate(item.value, true, params.serviceLine, this.props.tenantId, this.props.hasAmplifyCaseRunV2Access);
      }
    }, {
      key: "_onFeatureSelection",
      value: function _onFeatureSelection(selection) {
        if (selection.display) {
          if (isMultipleSelection$1(selection)) {
            var _document$querySelect;
            var spanSelector = ".qa-".concat(selection.code.uuid);
            var targetElement = (_document$querySelect = document.querySelector(spanSelector)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('.accordion-section');
            if (targetElement) {
              var _this$_artifactRef;
              (_this$_artifactRef = this._artifactRef) === null || _this$_artifactRef === void 0 || (_this$_artifactRef = _this$_artifactRef.current) === null || _this$_artifactRef === void 0 || _this$_artifactRef.scrollToElement(targetElement);
            }
          } else if (isSingleSelection$1(selection)) {
            var feature = getFeatureForSelection$1(selection);
            var inExpanded = expandedProps$1.has(feature.field);
            this._patientRef.current.expandEncounter(inExpanded);
            if (inExpanded) {
              var state = _objectSpread$r(_objectSpread$r({}, this.state), {}, {
                expandEncounter: true
              });
              this.setState(state);
            } else if (feature.field === 'raw_body') {
              var _feature$spans = _slicedToArray(feature.spans, 1),
                selectedSpan = _feature$spans[0];
              var _spanSelector = ".span-".concat(selectedSpan.uuid);
              var _targetElement = document.querySelector(_spanSelector);
              if (_targetElement) {
                var _this$_noteRef;
                (_this$_noteRef = this._noteRef) === null || _this$_noteRef === void 0 || (_this$_noteRef = _this$_noteRef.current) === null || _this$_noteRef === void 0 || _this$_noteRef.scrollToElement(_targetElement);
              }
            }
          }
        }
        this.props.onFeatureSelection(selection);
      }
    }, {
      key: "onFeatureActivation",
      value: function onFeatureActivation(selection) {
        // only pop open the accordion for active selections
        if (!selection.selectionState.active && selection.evidence.length === 1) {
          var state = _objectSpread$r({}, this.state);
          var _selection$evidence = _slicedToArray(selection.evidence, 1),
            firstEvidence = _selection$evidence[0];
          var claimMatcher = function claimMatcher(claim) {
            return !(claim.fieldIdentifier === firstEvidence.fieldIdentifier && claim.fieldName === firstEvidence.fieldName);
          };
          state.openClaims = state.openClaims.filter(claimMatcher);
          state.expandEncounter = state.openClaims.length > 0;
          this.setState(state);
          this._patientRef.current.expandEncounter(state.expandEncounter);
        } else if (selection.selectionState.active) {
          var _selection$evidence2 = _slicedToArray(selection.evidence, 1),
            selectedSpan = _selection$evidence2[0];
          var fieldName = selectedSpan.fieldName;
          if (fieldName === 'body') {
            var spanSelector = ".span-".concat(selectedSpan.hash);
            var targetElement = document.querySelector(spanSelector);
            if (targetElement) {
              var _this$_noteRef2;
              (_this$_noteRef2 = this._noteRef) === null || _this$_noteRef2 === void 0 || (_this$_noteRef2 = _this$_noteRef2.current) === null || _this$_noteRef2 === void 0 || _this$_noteRef2.scrollToElement(targetElement);
            }
          } else {
            var inExpanded = new Set([].concat(_toConsumableArray(expandedProps$1), _toConsumableArray(this.props.mode !== 'dashboard' ? expandedAmplifyProps$1 : []))).has(fieldName);
            if (inExpanded) {
              var _state = _objectSpread$r(_objectSpread$r({}, this.state), {}, {
                expandEncounter: true
              });
              _state.openClaims = [].concat(_toConsumableArray(_state.openClaims), [{
                fieldIdentifier: selectedSpan.fieldIdentifier,
                fieldName: selectedSpan.fieldName
              }]);
              this.setState(_state);
              this._patientRef.current.expandEncounter(_state.expandEncounter);
            }
          }
        }
        this.props.onFeatureActivation(selection);
      }
    }, {
      key: "_handlePatientExpansion",
      value: function _handlePatientExpansion(isOpen) {
        this.setState(_objectSpread$r(_objectSpread$r({}, this.state), {}, {
          expandEncounter: isOpen
        }));
      }
    }, {
      key: "_handleToggleClick",
      value: function _handleToggleClick(event) {
        event.preventDefault();
        var showAllArtifacts = !this.state.showAllArtifacts;
        this.props.toggleArtifacts(showAllArtifacts);
        this.setState(_objectSpread$r(_objectSpread$r({}, this.state), {}, {
          showAllArtifacts: showAllArtifacts
        }));
      }
    }, {
      key: "_handleOpenJson",
      value: function _handleOpenJson(event) {
        var _event$currentTarget;
        event.preventDefault();
        var activeItem = this.props.activeItem;
        var serviceLineConfig = uiCommon.appServiceLines.determineServiceLineConfig({
          name: activeItem.service_line,
          caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
        });
        var caseId = serviceLineConfig.caseIdProp in activeItem ? activeItem[serviceLineConfig.caseIdProp] : activeItem.case_id;
        var isStandalone = this.props.activeItem.case_type === uiCommon.commonEnums.UIModesEnum.STANDALONE;
        var params = {
          caseId: caseId
        };
        var target = (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.closest('.icon-button');
        if (target && this.props.activeItem.case_id) {
          var _validTarget$dataset$, _this$props$match$par, _this$props$match3;
          var validTarget = target;
          var href = "".concat((_validTarget$dataset$ = validTarget === null || validTarget === void 0 ? void 0 : validTarget.dataset.href) !== null && _validTarget$dataset$ !== void 0 ? _validTarget$dataset$ : '');
          var base;
          params.processInstanceId = this.props.activeItem.process_instance_id;
          params.serviceLine = (_this$props$match$par = (_this$props$match3 = this.props.match) === null || _this$props$match3 === void 0 || (_this$props$match3 = _this$props$match3.params) === null || _this$props$match3 === void 0 ? void 0 : _this$props$match3.serviceLine) !== null && _this$props$match$par !== void 0 ? _this$props$match$par : '';
          if (href.indexOf('import-amplify') !== -1) {
            this.props.onCaseAction({
              action: 'import-amplify',
              caseRun: this.props.activeItem,
              caseOrganizationContext: this.props.caseOrganizationContext
            });
          } else if (href.indexOf('launch-amplify') !== -1 && isStandalone) {
            // STANDALONE case same window
            var _serviceLineConfig = uiCommon.appServiceLines.determineServiceLineConfig({
              name: this.props.activeItem.service_line,
              caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
            });
            var _caseId = _serviceLineConfig.caseIdProp in activeItem ? activeItem[_serviceLineConfig.caseIdProp] : activeItem.case_id;
            if (this.props.loadAllPatientDetailOptions) {
              this.props.loadAllPatientDetailOptions(this.props.tenantId, this.props.activeItem.facility);
            }
            this.props.openAmplifyCase({
              serviceLine: this.props.activeItem.service_line,
              caseId: _caseId,
              id: this.props.activeItem.process_instance_guid
            });
          } else {
            params.managed = true;
            if (href.indexOf('bpm-steps') !== -1) {
              base = bpmStepsPopup;
              params.processInstanceId = this.props.activeItem.process_instance_id;
            } else if (href.indexOf('json-view') !== -1) {
              base = caseDetailPopup;
            } else if (href.indexOf('launch-amplify') !== -1) {
              // PLAYGROUND case new window

              base = launchAmplifyPopup;
              params.launchpoint = 'Automate';
              params.processInstanceGuid = this.props.activeItem.process_instance_guid;
              params.processInstanceGuids = this.props.items.map(function (item) {
                return "".concat(item.case_id, ":").concat(item.process_instance_guid);
              }).join(',');
            } else if (href.indexOf('case-documents') != -1) {
              base = caseDocumentsPopup;
            }
            this.props.openChildWindow(_objectSpread$r(_objectSpread$r({}, base), {}, {
              params: params
            }));
          }
        }
      }
    }, {
      key: "_handleProcessIdChange",
      value: function _handleProcessIdChange(event) {
        event.preventDefault();
        var target = event.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-process-id');
        if (!item) return;
        var processId = parseInt(item.value);
        if (!processId) return;
        var caseRuns = Object.values(this.props.caseRuns).flat();
        var soughtRun = caseRuns.find(function (caseRun) {
          return caseRun.process_instance_id === processId;
        });
        if (!soughtRun) return;
        this.props.setActiveProcess({
          caseRun: soughtRun,
          serviceLine: this.props.serviceLine
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this,
          _this$props$match4,
          _dataItem$artifacts$l,
          _dataItem$artifacts,
          _this$props2,
          _this$props3;
        var _this$props = this.props,
          artifactLoadState = _this$props.artifactLoadState;
          _this$props.artifactSet;
          var activeItem = _this$props.activeItem;
          _this$props.codeEdits;
          var loadState = _this$props.loadState,
          notes = _this$props.notes,
          artifactList = _this$props.artifactList;
          _this$props.codeDescriptions;
          var formErrors = _this$props.formErrors,
          groupedCases = _this$props.groupedCases,
          caseRuns = _this$props.caseRuns,
          roles = _this$props.roles,
          stages = _this$props.stages,
          codeEditingPanel = _this$props.codeEditingPanel,
          propertyConfig = _this$props.propertyConfig,
          activations = _this$props.activations,
          simplifiedInvoices = _this$props.simplifiedInvoices,
          caseEdits = _this$props.caseEdits,
          organization = _this$props.organization,
          capability = _this$props.capability,
          mode = _this$props.mode;
          _this$props.htmlNotes;
          _this$props.noteUnavailableReason;
          var documentMetadata = _this$props.documentMetadata,
          updateValue = _this$props.updateValue,
          updateCase = _this$props.updateCase,
          setActiveNote = _this$props.setActiveNote;
          _this$props.processInstance;
          var activeNote = _this$props.activeNote,
          coderNotesCapability = _this$props.coderNotesCapability,
          workItem = _this$props.workItem;
        var onDocumentSelect = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(doc) {
            var noteRef, newActiveNote;
            return _regeneratorRuntime.wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  noteRef = _this3.noteRefs[doc.documentId];
                  requestAnimationFrame(function () {
                    var _noteRef$current;
                    return noteRef === null || noteRef === void 0 || (_noteRef$current = noteRef.current) === null || _noteRef$current === void 0 ? void 0 : _noteRef$current.scrollIntoView({
                      behavior: 'smooth'
                    });
                  });
                  newActiveNote = notes.find(function (note) {
                    return note.document_id === doc.documentId;
                  });
                  if (newActiveNote) {
                    setActiveNote(newActiveNote);
                  }
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function onDocumentSelect(_x) {
            return _ref3.apply(this, arguments);
          };
        }();
        var _this$state = this.state,
          expandEncounter = _this$state.expandEncounter;
          _this$state.openClaims;
          var actionBar = this.props.actionBar;
        // at the moment we only support a single case run
        var dataItem = activeItem;
        var _ref4 = (_this$props$match4 = this.props.match) !== null && _this$props$match4 !== void 0 ? _this$props$match4 : {},
          _ref4$params = _ref4.params,
          params = _ref4$params === void 0 ? {} : _ref4$params;
        var prop = propAccessor2(dataItem, activations.property);
        var noteStyle;
        var showLoading = loadState.loading || loadState.initial;
        if (showLoading) {
          noteStyle = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            numberItems: 30
          }));
        } else {
          noteStyle = /*#__PURE__*/React.createElement(Notes, {
            notes: notes,
            noteRefs: this.noteRefs
          });
        }
        var statusTimestamp = getStatusTimestamp$1(dataItem, stages);
        var loadingClasses = [{
          'loading-card': showLoading
        }];
        var rawArtifactLength = (_dataItem$artifacts$l = (_dataItem$artifacts = dataItem.artifacts) === null || _dataItem$artifacts === void 0 ? void 0 : _dataItem$artifacts.length) !== null && _dataItem$artifacts$l !== void 0 ? _dataItem$artifacts$l : 0;
        var displayedArtifactLength = artifactList.length;
        var userIsCoder = uiCommon.userUtils.isCoder(roles);
        var codeEditMode = this.props.mode === uiCommon.commonEnums.CaseDetailMode.EDIT;
        var multipleArtifacts = false;
        if (!userIsCoder) {
          if (simplifiedInvoices && simplifiedInvoices.length) {
            multipleArtifacts = simplifiedInvoices.length > 0;
          } else {
            multipleArtifacts = rawArtifactLength > displayedArtifactLength || rawArtifactLength > 0;
          }
        }
        var caseDetailClasses = ['case-detail', 'simple-layout', "case-".concat(this.props.mode, "-mode"), {
          'multiple-artifacts': multipleArtifacts,
          'encounter-expanded': expandEncounter,
          'case-detail-loading': showLoading
        }];
        var artifactListClasses = ['automation-container'].concat(loadingClasses);
        var artifactToggle = /*#__PURE__*/React.createElement("div", {
          className: "info-cell"
        }, "codes \xA0", /*#__PURE__*/React.createElement("span", {
          className: "artifact-toggle"
        }, userIsCoder ? /*#__PURE__*/React.createElement("span", null) : /*#__PURE__*/React.createElement("span", null, "(", /*#__PURE__*/React.createElement("a", {
          className: "qa-artifact-toggle",
          onClick: this._handleToggleClick,
          href: "#toggle-artifacts"
        }, this.state.showAllArtifacts ? "show summary" : "show all"), ")")));
        var preGoLive = uiCommon.caseUtils.isPreGoLive(activeItem);
        "".concat(prop('patient_identifier.issuer', 'SRC N/A'), ": ").concat(prop('patient_identifier.number'));
        "".concat(prop('primary_clinical_identifier.number'), " src: (").concat(prop('primary_clinical_identifier.issuer'), ")");
        var providerComments = Array.from(new Set(// get unique comments with a set
        (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.activeItem) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.invoices) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.find(function (invoice) {
          return invoice.type === uiCommon.commonEnums.CaseArtifactTypes.ASSEMBLED;
        }) // just the ASSEMBLED invoice
        ) === null || _this$props2 === void 0 ? void 0 : _this$props2.transactions.map(function (transaction) {
          var _transaction$custom_v;
          return transaction === null || transaction === void 0 || (_transaction$custom_v = transaction.custom_values) === null || _transaction$custom_v === void 0 ? void 0 : _transaction$custom_v.comment;
        }) // get comments for all transactions
        .filter(Boolean) // remove undefined/null comments
        ));
        if (this.props.mode === 'dashboard' && !actionBar) {
          actionBar = /*#__PURE__*/React.createElement(DashboardActionBar, {
            actionsState: this.props.actionsState,
            caseRun: this.props.activeItem,
            handleOpenJson: this._handleOpenJson,
            handleProcessIdChange: this._handleProcessIdChange,
            handleBackClick: this.props.handleBackClick,
            caseRuns: caseRuns
          });
        }
        var charges = Array.isArray(simplifiedInvoices) ? simplifiedInvoices.map(function (invoice, idx) {
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "invoice-item-group"
          }, invoice.meta ? /*#__PURE__*/React.createElement(InvoiceMetaHeading, {
            meta: invoice.meta,
            onImportClick: _this3._handleGroupedCaseClick
          }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Invoice, {
            panelActivations: activations.panel,
            onFeatureSelection: _this3.onFeatureActivation,
            simplifiedInvoice: invoice,
            editable: false
          }));
        }) : false;
        var shouldShowAddAttachDocsButton = conditionalUtils$6.capabilityValue(this === null || this === void 0 || (_this$props3 = this.props) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.capabilities) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.capabilities) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.attachDocs) === null || _this$props3 === void 0 ? void 0 : _this$props3.on) && this.props.UIView === uiCommon.commonEnums.UIViewEnum.AMPLIFY && this.props.UIMode === uiCommon.commonEnums.UIModesEnum.STANDALONE && uiCommon.appServiceLines.isIPC(activeItem.service_line);
        var docsNavSideBarEnabled = (documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.length) > 1 || shouldShowAddAttachDocsButton;
        return /*#__PURE__*/React.createElement(ChakraProvider, {
          theme: theme
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames(caseDetailClasses)
        }, actionBar, (formErrors === null || formErrors === void 0 ? void 0 : formErrors.status) === 'PAGE NOT FOUND' ? /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: 'Unable to load case (Case id# ' + params.id + ')',
          buttonText: 'Return',
          closable: false,
          icon: /*#__PURE__*/React.createElement("img", {
            src: AlertIcon,
            width: 30,
            height: 30
          }),
          onSubmit: this.props.handleBackClick,
          children: /*#__PURE__*/React.createElement("p", null, 'The case you are trying to view does not exist. Please check the information and try again.')
        }) : null, /*#__PURE__*/React.createElement("div", {
          className: "case-columns"
        }, /*#__PURE__*/React.createElement("div", {
          className: "column left-column"
        }, /*#__PURE__*/React.createElement(uiComponents.Card, {
          className: classnames(['encounter-container', {
            expanded: expandEncounter
          }].concat(loadingClasses))
        }, showLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 3
        }), /*#__PURE__*/React.createElement("br", null)) : /*#__PURE__*/React.createElement(PatientEncounter
        //@ts-ignore
        , {
          ref: this._patientRef,
          activations: activations,
          propertyConfig: propertyConfig,
          activeItem: activeItem,
          handleExpansion: this._handlePatientExpansion,
          showCoderNotesInfo: this.props.showCoderNotesInfo,
          showProviderInfo: this.props.showProviderInfo,
          fieldEditorInfo: {
            caseEdits: caseEdits,
            organization: organization,
            updateValue: updateValue,
            updateCase: updateCase
          },
          capability: _objectSpread$r(_objectSpread$r({}, capability), {}, {
            on:
            //@ts-ignore
            conditionalUtils$6.capabilityValue(capability.on) && mode === uiCommon.commonEnums.CaseDetailMode.EDIT
          }),
          coderNotesCapability: coderNotesCapability,
          workItem: workItem
        })), /*#__PURE__*/React.createElement(uiComponents.FlexCard
        //@ts-ignore
        , {
          ref: this._noteRef,
          unflexed: true,
          header: /*#__PURE__*/React.createElement(IconHeader, {
            svgIconName: e.Clipboard,
            svgIconClass: "card-header-icon",
            header: "documentation",
            svgTitleText: "Case Documents"
          }),
          className: classnames(['documentation-container'].concat(loadingClasses))
        }, /*#__PURE__*/React.createElement("div", {
          className: "provider-comments-section"
        }, providerComments.length > 0 && providerComments.map(function (comment, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "provider-comments",
            key: "provider-comment-".concat(index)
          }, /*#__PURE__*/React.createElement("div", {
            className: "provider-comments-icon"
          }, /*#__PURE__*/React.createElement(r, {
            iconName: e.Comments,
            titleText: "Provider Comments"
          })), /*#__PURE__*/React.createElement("p", {
            className: "provider-text"
          }, comment));
        })), /*#__PURE__*/React.createElement("div", {
          className: "doc-nav-wrap"
        }, /*#__PURE__*/React.createElement("div", {
          className: "doc-nav ".concat(docsNavSideBarEnabled ? 'doc-nav-enable' : 'doc-nav-disable')
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: docsNavSideBarEnabled,
          style: {
            width: '100%',
            height: '100%'
          }
        }, /*#__PURE__*/React.createElement(NotesSidebar, {
          onSelect: onDocumentSelect,
          activeNote: activeNote,
          documentMetadata: documentMetadata,
          isIPC: uiCommon.appServiceLines.isIPC(activeItem.service_line),
          capabilities: this.props.capabilities.capabilities
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: shouldShowAddAttachDocsButton
        }, /*#__PURE__*/React.createElement("div", {
          className: "doc-nav-attach"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            return _this3.props.showAttachDocsModal(activeItem);
          },
          className: "chakra-secondary-button"
        }, "Add")))))), /*#__PURE__*/React.createElement("div", {
          className: "documentation-section ".concat(docsNavSideBarEnabled && shouldShowAddAttachDocsButton && (documentMetadata === null || documentMetadata === void 0 ? void 0 : documentMetadata.length) <= 1 ? 'no-additional-notes' : '')
        }, /*#__PURE__*/React.createElement("div", {
          className: "doc-notes"
        }, noteStyle))))), /*#__PURE__*/React.createElement("div", {
          className: "column right-column"
        }, !codeEditMode && /*#__PURE__*/React.createElement("div", {
          className: "large-status-container"
        }, showLoading ? /*#__PURE__*/React.createElement(uiComponents.Card, {
          className: classnames(['status-loading'].concat(loadingClasses))
        }, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 2
        })) : /*#__PURE__*/React.createElement(CaseStatus, {
          onClick: this._handleGroupedCaseClick,
          billingGroupLoadState: this.props.billingGroupLoadState,
          groupedCases: groupedCases,
          caseRun: activeItem,
          timeStamp: statusTimestamp,
          isPreGoLive: preGoLive
        })), codeEditingPanel || /*#__PURE__*/React.createElement(uiComponents.FlexCard, {
          unflexed: true
          //@ts-ignore
          ,
          ref: this._artifactRef,
          header: artifactLoadState.initial ? /*#__PURE__*/React.createElement("span", null) : /*#__PURE__*/React.createElement(IconHeader, {
            svgIconName: e.Coding,
            svgIconClass: "card-header-icon",
            header: artifactToggle,
            svgTitleText: "Coding"
          }),
          className: classnames(artifactListClasses)
        }, /*#__PURE__*/React.createElement("div", {
          className: "case-status-codes"
        }, /*#__PURE__*/React.createElement("div", {
          className: "prediction-section"
        }, artifactLoadState.initial ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 2
        }) : (artifactList || []).length === 0 && !charges ? /*#__PURE__*/React.createElement("h4", {
          className: "content-vacant"
        }, ' ', userIsCoder || (activeItem.artifacts || []).length === 0 ? 'No codes available' : 'No codes displayed') : charges ? /*#__PURE__*/React.createElement(React.Fragment, null, charges) : /*#__PURE__*/React.createElement(React.Fragment, null))))))));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseDetail, "defaultProps", {
    onCaseAction: function onCaseAction(action) {},
    onFeatureActivation: function onFeatureActivation(selection) {},
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    items: [],
    mode: uiCommon.commonEnums.CaseDetailMode.DASHBOARD,
    actionsState: {},
    evidenceManager: new uiCommon.cmxArtifacts.EvidenceManager(),
    capability: {
      on: uiComponents.DEFAULT_UNAVAILABLE_CAPABILITY
    },
    coderNotesCapability: _objectSpread$r({}, uiCommon.AmplifyCore.conditionalUtils.disabledCapability),
    noteUnavailableReason: _objectSpread$r({}, uiCommon.AmplifyCore.conditionalUtils.disabledCapability),
    workItem: {
      owner: '',
      assignee: '',
      aging_days: '',
      codable_days: ''
    }
  });

  var _excluded$9 = ["additionalInfo", "capability", "cellKey", "fieldType", "hasLink", "label", "showProviderInfo", "value", "className", "fieldEditorInfo"];
  function ownKeys$q(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$q(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$q(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$q(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  uiCommon.AmplifyCore.conditionalUtils;
  var caseEdit = uiCommon.AmplifyCore.state.capabilities.capabilities.caseEdit;
  var BASE_FIELD = {
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    showProviderInfo: function showProviderInfo(providerInfo) {},
    updateValue: function updateValue(value) {},
    updateCase: function updateCase(idAndUpdates) {},
    loadPatientDetailOptions: function loadPatientDetailOptions(dictionaryInfo) {}
  };
  var UNEDITABLE_FIELD = _objectSpread$q(_objectSpread$q({}, BASE_FIELD), {}, {
    editEnabled: false
  });
  _objectSpread$q(_objectSpread$q({}, BASE_FIELD), {}, {
    editEnabled: true
  });
  var InfoCell = function InfoCell(_ref) {
    var _caseEdit$on$value;
    var additionalInfo = _ref.additionalInfo,
      capability = _ref.capability,
      cellKey = _ref.cellKey,
      fieldType = _ref.fieldType,
      hasLink = _ref.hasLink,
      label = _ref.label,
      showProviderInfo = _ref.showProviderInfo,
      value = _ref.value,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$fieldEditorInfo = _ref.fieldEditorInfo,
      fieldEditorInfo = _ref$fieldEditorInfo === void 0 ? _objectSpread$q({}, UNEDITABLE_FIELD) : _ref$fieldEditorInfo,
      spreadable = _objectWithoutProperties(_ref, _excluded$9);
    var props = _objectSpread$q({
      cellKey: cellKey,
      label: label,
      value: value,
      fieldType: fieldType,
      fieldEditorInfo: fieldEditorInfo,
      className: className,
      capability: capability,
      hasLink: hasLink,
      additionalInfo: additionalInfo,
      showProviderInfo: showProviderInfo
    }, spreadable);
    var classes = classnames("".concat(cellKey, "-cell"), 'info-cell', 'encounter-info', className);
    var additionalInfoHasNA = (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName) === 'N/A' || (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber) === 'N/A' || (additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode) === 'N/A';
    var showLink = hasLink ? value !== 'N/A' && !additionalInfoHasNA : false;
    var updateValue = fieldEditorInfo.updateValue,
      updateCase = fieldEditorInfo.updateCase;
    var isValidDate = function isValidDate(date) {
      if (fieldType === 'date') {
        var _cmxDateTime$parse;
        return fieldType === 'date' && date && (date === 'N/A' || ((_cmxDateTime$parse = uiCommon.cmxDateTime.parse(date)) === null || _cmxDateTime$parse === void 0 ? void 0 : _cmxDateTime$parse.successfullyParsed));
      } else {
        return false;
      }
    };
    var handleProviderClick = function handleProviderClick(ev) {
      ev.preventDefault();
      if (showLink) {
        showProviderInfo({
          providerName: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerName,
          providerNumber: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.providerNumber,
          tenantCode: additionalInfo === null || additionalInfo === void 0 ? void 0 : additionalInfo.tenantCode
        });
      }
    };
    var _handleChange = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
        var caseUpdate;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (fieldType === 'dictionary' || isValidDate(val === null || val === void 0 ? void 0 : val.toString())) {
                updateValue({
                  fieldKey: cellKey,
                  newValue: val
                });
                caseUpdate = {};
                caseUpdate[cellKey] = val;
                updateCase(caseUpdate);
              }
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function _handleChange(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var showFieldEditor = (fieldType === 'dictionary' || isValidDate(value === null || value === void 0 ? void 0 : value.toString())) && cellKey !== 'date_of_service' && (
    //@ts-ignore
    capability ? capability.on : (_caseEdit$on$value = caseEdit.on.value) !== null && _caseEdit$on$value !== void 0 ? _caseEdit$on$value : caseEdit.on);
    var hasAmplifyCaseRunV2Access = uiCommon.Utils.doesPathEndWithV2();
    var displayValue = typeof value === 'string' || /*#__PURE__*/React.isValidElement(value) ? value : JSON.stringify(value);
    var infoCellContent =
    /*#__PURE__*/
    //@ts-ignore
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends$1({}, spreadable, {
      className: classes,
      key: "".concat(cellKey, "-info-cell")
    }), /*#__PURE__*/React.createElement("span", {
      className: "encounter-field field-label"
    }, label), showFieldEditor ? hasAmplifyCaseRunV2Access ? /*#__PURE__*/React.createElement(FieldEditorv2, _extends$1({
      className: "field-data"
    }, props, {
      value: value,
      onChange: _handleChange,
      onSubmit: function onSubmit() {},
      fieldEditorInfo: fieldEditorInfo
    })) : /*#__PURE__*/React.createElement(FieldEditor, _extends$1({
      className: "field-data"
    }, props, {
      value: value,
      onChange: _handleChange,
      onSubmit: function onSubmit() {},
      fieldEditorInfo: fieldEditorInfo
    })) : /*#__PURE__*/React.createElement("span", {
      className: classnames('encounter-detail field-data sensitive-data', "".concat(cellKey, "-field"), {
        'cmx-link': showLink
      }),
      onClick: function onClick(ev) {
        return handleProviderClick(ev);
      }
    }, displayValue)));
    return infoCellContent;
  };
  InfoCell.displayName = 'InfoCell';

  function _callSuper$k(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$k() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$k() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$k = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$p(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$p(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$p(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$p(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var getCoderNotesLookupParams = uiCommon.AmplifyCore.coderNotesUtils.getCoderNotesLookupParams;
  var DataStyles = {
    s: 'col-3 col-lg-4 col-md-4',
    ms: 'col-4 col-md-6',
    m: 'col-8',
    l: 'col-12'
  };
  var CellMaker = function CellMaker(propAccessor, rawCaseRun, fieldEditorInfo, capability, showProviderInfo, activeContext) {
    var dataTransformer = DataTransformers(propAccessor, rawCaseRun, activeContext);
    return function (def) {
      var _def$additionalInfo;
      var cellClassName = DataStyles[def.dataSizeHorizontalView];
      var value = def.transformer ? dataTransformer[def.transformer](def.property) : propAccessor(def.property, 'N/A');
      var additionalInfo = def === null || def === void 0 || (_def$additionalInfo = def.additionalInfo) === null || _def$additionalInfo === void 0 ? void 0 : _def$additionalInfo.reduce(function (acc, info) {
        var key = info === null || info === void 0 ? void 0 : info.label;
        var value = info.transformer ? dataTransformer[info.transformer](info.property) : propAccessor(info.property, 'N/A');

        // Ensure both key and value are strings
        acc[key] = value === null || value === void 0 ? void 0 : value.toString();
        return acc;
      }, {}); // Initialize an empty object with string key-value types

      if ((value == 'N/A' || value == undefined) && def.defaultHide) {
        return null;
      }
      var _handleUpdate = function _handleUpdate(updates) {
        var caserun_uid = rawCaseRun.caserun_uid,
          service_line = rawCaseRun.service_line;
        var _fieldEditorInfo$case = fieldEditorInfo.caseEdits[def.key],
          initialVal = _fieldEditorInfo$case.initialVal,
          mappedValues = _fieldEditorInfo$case.mappedValues;
        if (updates.hasOwnProperty('patient_type')) {
          var _fieldEditorInfo$case2, _mappedValues$find;
          var patientTypeValue = updates['patient_type'];
          var _mappedValues = ((_fieldEditorInfo$case2 = fieldEditorInfo.caseEdits['patient_class']) === null || _fieldEditorInfo$case2 === void 0 ? void 0 : _fieldEditorInfo$case2.mappedValues) || [];
          var _value = (_mappedValues$find = _mappedValues.find(function (item) {
            return item.label === patientTypeValue;
          })) === null || _mappedValues$find === void 0 ? void 0 : _mappedValues$find.value;
          if (_value !== undefined) {
            rawCaseRun['patient_class'] = _value;
            updates['patient_class'] = _value;
          }
        }
        fieldEditorInfo.updateCase({
          caseRunUid: caserun_uid,
          serviceLine: service_line == 'Inpatient Professional Coding' ? 'ipc' : service_line,
          caseUpdates: updates,
          initialVal: initialVal,
          mappedValues: mappedValues
        });
      };
      return /*#__PURE__*/React.createElement(InfoCell, {
        key: "".concat(def.key),
        className: cellClassName,
        cellKey: def.key,
        label: def.label,
        value: value,
        fieldType: def.fieldType,
        fieldEditorInfo: _objectSpread$p(_objectSpread$p({}, fieldEditorInfo), {}, {
          updateCase: function updateCase(updates) {
            return _handleUpdate(updates);
          }
        }),
        capability: capability,
        showProviderInfo: showProviderInfo,
        hasLink: def !== null && def !== void 0 && def.additionalInfo ? def === null || def === void 0 ? void 0 : def.hasLink : false,
        additionalInfo: additionalInfo
      });
    };
  };
  var CellPatientMaker = function CellPatientMaker(propAccessor, rawCaseRun) {
    var dataTransformer = DataTransformers(propAccessor, rawCaseRun);
    return function (def) {
      var value = def.transformer ? dataTransformer[def.transformer](def.property) : propAccessor(def.property, 'N/A');
      return /*#__PURE__*/React.createElement("div", {
        key: def.key,
        className: "patient-cell"
      }, value, def.addHr ? /*#__PURE__*/React.createElement("div", {
        className: "vertical-divider"
      }) : null);
    };
  };
  var PatientEncounterv2 = /*#__PURE__*/function (_React$Component) {
    function PatientEncounterv2(props) {
      var _this;
      _classCallCheck(this, PatientEncounterv2);
      _this = _callSuper$k(this, PatientEncounterv2, [props]);
      _this.handleToggleClick = _this.handleToggleClick.bind(_this);
      _this.handleCoderNotesClick = _this.handleCoderNotesClick.bind(_this);
      _this.handleCoderNotesKeyDown = _this.handleCoderNotesKeyDown.bind(_this);
      _this.state = {
        expandEncounter: true
      };
      return _this;
    }
    _inherits(PatientEncounterv2, _React$Component);
    return _createClass(PatientEncounterv2, [{
      key: "handleToggleClick",
      value: function handleToggleClick(ev) {
        ev.preventDefault();
        var expandEncounter = this.state.expandEncounter;
        var openClaims = this.props.openClaims;
        if (expandEncounter) {
          openClaims = [];
        } else {
          openClaims = [].concat(_toConsumableArray(openClaims), [{
            fieldIdentifier: 'showToggle',
            fieldName: 'showToggle'
          }]);
        }
        this.setState({
          expandEncounter: !expandEncounter
        });
        this.props.handleExpansion(!expandEncounter);
      }
    }, {
      key: "expandEncounter",
      value: function expandEncounter(_expandEncounter) {
        this.setState({
          expandEncounter: _expandEncounter
        });
        this.props.handleExpansion(_expandEncounter);
      }

      /**
       * Handles the click event on the "Coder Notes" section.
       * Prevents default behavior and triggers the coder notes info display.
       *
       * @param {React.MouseEvent<HTMLDivElement>} ev - The mouse event object.
       * @returns {void}
       */
    }, {
      key: "handleCoderNotesClick",
      value: function handleCoderNotesClick(ev) {
        var _activeItem$patient_i;
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        ev.preventDefault();
        this.props.showCoderNotesInfo(_objectSpread$p(_objectSpread$p({}, lookupParams), {}, {
          patientMRN: activeItem === null || activeItem === void 0 || (_activeItem$patient_i = activeItem.patient_identifier) === null || _activeItem$patient_i === void 0 ? void 0 : _activeItem$patient_i.number,
          serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line
        }));
      }

      /**
       * Handles the keydown event on the "Coder Notes" section.
       * Triggers the coder notes info display when the Enter key is pressed.
       *
       * @param {React.KeyboardEvent<HTMLDivElement>} ev - The keyboard event object.
       * @returns {void}
       */
    }, {
      key: "handleCoderNotesKeyDown",
      value: function handleCoderNotesKeyDown(ev) {
        var activeItem = this.props.activeItem;
        var lookupParams = getCoderNotesLookupParams(activeItem);
        if (ev.key === 'Enter') {
          var _activeItem$patient_i2;
          ev.preventDefault();
          this.props.showCoderNotesInfo(_objectSpread$p(_objectSpread$p({}, lookupParams), {}, {
            patientMRN: activeItem === null || activeItem === void 0 || (_activeItem$patient_i2 = activeItem.patient_identifier) === null || _activeItem$patient_i2 === void 0 ? void 0 : _activeItem$patient_i2.number,
            serviceLine: activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line
          }));
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _activations$property, _coderNotesCapability;
        var classnames$1 = ['patient-encounterv2'];
        this.state.expandEncounter;
        var _this$props = this.props,
          activations = _this$props.activations,
          activeItem = _this$props.activeItem,
          propertyConfig = _this$props.propertyConfig,
          fieldEditorInfo = _this$props.fieldEditorInfo,
          capability = _this$props.capability,
          flagList = _this$props.flagList,
          coderNotesCapability = _this$props.coderNotesCapability,
          workItem = _this$props.workItem;
        var flagListSet = Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) {
          return flag === null || flag === void 0 ? void 0 : flag.flag;
        })));
        (_activations$property = activations === null || activations === void 0 ? void 0 : activations.property) !== null && _activations$property !== void 0 ? _activations$property : {};
        var prop = propAccessor2(_objectSpread$p(_objectSpread$p({}, activeItem), workItem), activations.property);
        var cellMaker = CellMaker(prop, activeItem, fieldEditorInfo, capability, this.props.showProviderInfo, this.props.activeContext);

        // all info less last item
        var patientConfig = propertyConfig.patient.slice(0, propertyConfig.patient.length - 1);
        // last item
        propertyConfig.patient.slice(-1);

        // add hr less the last one item
        patientConfig = patientConfig.map(function (patient, index) {
          return _objectSpread$p(_objectSpread$p({}, patient), {}, {
            addHr: index + 1 !== patientConfig.length
          });
        });
        var midCells = propertyConfig.summary.map(cellMaker);
        var showComments = uiCommon.conditionalUtils.capabilityValue((_coderNotesCapability = coderNotesCapability === null || coderNotesCapability === void 0 ? void 0 : coderNotesCapability.on) !== null && _coderNotesCapability !== void 0 ? _coderNotesCapability : false);
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(classnames$1)
        }, /*#__PURE__*/React.createElement("div", {
          className: "patient-info-container",
          "data-testid": "patient-info-container"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [(flagListSet === null || flagListSet === void 0 ? void 0 : flagListSet.length) > 0]
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex-section ".concat(uiCommon.caseUtils.getStatusReason(activeItem) ? 'zeroTopPadding' : '')
        }, flagListSet.map(function (flag, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: "flag-item-box",
            key: "flag-".concat(index)
          }, /*#__PURE__*/React.createElement("p", {
            className: "flag-item",
            title: flag
          }, flag));
        }))), propertyConfig.summary.length > 0 && /*#__PURE__*/React.createElement("div", {
          className: "info-block"
        }, midCells)), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [showComments]
        }, /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onClick: this.handleCoderNotesClick,
          onKeyDown: this.handleCoderNotesKeyDown,
          className: "coder-comments-section"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconClass: "coder-commentsv2",
          svgIconName: "BiomeComments",
          svgIconSize: "24"
        }))));
      }
    }]);
  }(React.Component);
  _defineProperty(PatientEncounterv2, "displayName", 'PatientEncounter');
  _defineProperty(PatientEncounterv2, "defaultProps", {
    openClaims: [],
    showLoading: false,
    activations: {},
    handleExpansion: function handleExpansion(expanded) {},
    showProviderInfo: function showProviderInfo(providerInfo) {},
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    flagList: [],
    workItem: {
      owner: '',
      assignee: '',
      aging_days: '',
      codable_days: ''
    }
  });

  function ownKeys$o(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$o(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$o(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$o(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_PROPS$5 = {
    documentMetadata: [],
    grouped: false,
    onSelect: function onSelect(docMetadata) {}
  };
  var DocCategories = {
    DFT: 'DFTs',
    DFT_IN: 'Inbound DFTs',
    DFT_OUT: 'Outbound DFTs',
    NTE: 'Notes',
    NOTE: 'Notes',
    HL7: 'HL7 Messages',
    DFT_EHR: 'DFT EHRs'
  };
  var NotesNavbarv2 = function NotesNavbarv2(passed) {
    var props = _objectSpread$o(_objectSpread$o({}, DEFAULT_PROPS$5), passed);
    var documentMetadata = props.documentMetadata,
      onSelect = props.onSelect,
      activeNote = props.activeNote;
      props.isIPC;
      props.capabilities;
      var grouped = props.grouped,
      showAddAttachDocsButton = props.showAddAttachDocsButton,
      showAttachDocsModal = props.showAttachDocsModal;
    var _useState = React.useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      currentIndex = _useState2[0],
      setCurrentIndex = _useState2[1];
    var documentsPerPage = 5; // Number of documents to show per page

    //@ts-ignore
    var prepped = (documentMetadata || []).map(function (doc) {
      if (doc.mimeType === 'text/html') {
        doc.documentCategory = 'HTML';
      }
      return _objectSpread$o(_objectSpread$o({}, doc), {}, {
        documentCategory: DocCategories[doc.documentCategory] || doc.documentCategory
      });
    });
    var preppedDocs;
    if (grouped) {
      var sortGroupedDocs = function sortGroupedDocs(a, b) {
        if (a === b) return 0;
        if (a === 'HL7 Messages' || a === 'Notes') return -1;
        if (b === 'HL7 Messages' || b === 'Notes') return 1;
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      };
      preppedDocs = uiCommon.objectUtils.groupBy(prepped, 'documentCategory');
      Object.keys(preppedDocs).sort(sortGroupedDocs);
    } else {
      preppedDocs = prepped;
    }
    var buildDocList = function buildDocList(docs) {
      return docs.map(function (document, idx) {
        var _document$documentNam;
        var onClick = function onClick(event) {
          event.preventDefault();
          onSelect(document);
        };
        var isActive = (activeNote === null || activeNote === void 0 ? void 0 : activeNote.id) === document.id;
        var styleClasses = classnames([{
          'is-active': isActive
        }, 'navbar-link']);
        return /*#__PURE__*/React.createElement("li", {
          key: document.documentGuid.uuid,
          className: styleClasses
        }, /*#__PURE__*/React.createElement("a", {
          href: "#/something",
          onClick: onClick,
          className: "document-list-item"
        }, /*#__PURE__*/React.createElement("span", {
          className: "document-name"
        }, (_document$documentNam = document.documentName) !== null && _document$documentNam !== void 0 ? _document$documentNam : 'Name N/A'), /*#__PURE__*/React.createElement("span", {
          className: "document-description"
        }, document.documentDescription), /*#__PURE__*/React.createElement("span", {
          className: "document-status"
        }, document.documentStatus)));
      });
    };
    var displayDocs = function displayDocs(docs) {
      var startIndex = currentIndex * documentsPerPage;
      var endIndex = startIndex + documentsPerPage;
      return docs.slice(startIndex, endIndex);
    };
    var handlePrevClick = function handlePrevClick() {
      setCurrentIndex(function (prev) {
        return Math.max(prev - 1, 0);
      });
    };
    var handleNextClick = function handleNextClick() {
      var maxIndex = Math.ceil(preppedDocs.length / documentsPerPage) - 1;
      setCurrentIndex(function (prev) {
        return Math.min(prev + 1, maxIndex);
      });
    };
    var content;
    if (grouped) {
      content = Object.keys(preppedDocs).map(function (key) {
        var docs = preppedDocs[key];
        var items = buildDocList(displayDocs(docs));
        return /*#__PURE__*/React.createElement("div", {
          key: key
        }, /*#__PURE__*/React.createElement("span", {
          className: "note-doc-category",
          style: {
            display: 'none'
          }
        }, docs[0].documentCategory), /*#__PURE__*/React.createElement("ul", {
          className: "note-navbar-list"
        }, items));
      });
    } else {
      var listClass = classnames('note-navbar-list', {
        'justify-flex-start': displayDocs(preppedDocs).length < documentsPerPage
      });
      content = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("ul", {
        className: listClass
      }, buildDocList(displayDocs(preppedDocs))));
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "notes-navbar"
    }, documentMetadata && documentMetadata.length > documentsPerPage && /*#__PURE__*/React.createElement("div", {
      className: "navigation"
    }, currentIndex > 0 && /*#__PURE__*/React.createElement("button", {
      className: "nav-left",
      onClick: handlePrevClick
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeLeftArrow",
      svgIconSize: "20"
    })), /*#__PURE__*/React.createElement("div", {
      className: "content-container"
    }, content), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: showAddAttachDocsButton
    }, /*#__PURE__*/React.createElement("button", {
      className: "add-button",
      onClick: showAttachDocsModal
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomePlusCircle",
      svgIconSize: "20"
    }), "Add")), currentIndex < Math.ceil(preppedDocs.length / documentsPerPage) - 1 && /*#__PURE__*/React.createElement("button", {
      className: "nav-right",
      onClick: handleNextClick
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeRightArrow",
      svgIconSize: "20"
    }))), !(documentMetadata && documentMetadata.length > documentsPerPage) && /*#__PURE__*/React.createElement("div", {
      className: "navigation"
    }, /*#__PURE__*/React.createElement("div", {
      className: "content-container"
    }, content), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      on: showAddAttachDocsButton
    }, /*#__PURE__*/React.createElement("button", {
      className: "add-button",
      onClick: props.showAttachDocsModal
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomePlusCircle",
      svgIconSize: "20"
    }), "Add"))), props.children);
  };

  function _callSuper$j(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$j() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$j() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$j = function _isNativeReflectConstruct() { return !!t; })(); }
  var HoldReasonType$3 = uiCommon.commonEnums.HoldReasonType;

  /**
   * State for the Case Hold component
   */

  var HoldReasonLabel = /*#__PURE__*/function (HoldReasonLabel) {
    HoldReasonLabel["HOLD"] = "Hold";
    HoldReasonLabel["HOLD_FOR_DOCUMENTATION_QUERY"] = "Hold for documentation query";
    HoldReasonLabel["HOLD_FOR_MANAGER_REVIEW"] = "Hold for manager review";
    HoldReasonLabel["OFF_HOLD"] = "Off hold";
    return HoldReasonLabel;
  }({});
  var CaseHold = /*#__PURE__*/function (_React$Component) {
    /**
     * Constructor method for class CaseHold
     * @param {Accelerate.CaseHoldProps} props - Props object passed to CaseHold component
     */
    function CaseHold(props) {
      var _this;
      _classCallCheck(this, CaseHold);
      _this = _callSuper$j(this, CaseHold, [props]);
      _this.state = {
        comment: '',
        holdReason: HoldReasonType$3.HOLD
      };
      _this.handleOptionChange = _this.handleOptionChange.bind(_this);
      _this.handleCommentChange = _this.handleCommentChange.bind(_this);
      _this.holdCase = _this.holdCase.bind(_this);
      _this.cancelHold = _this.cancelHold.bind(_this);
      return _this;
    }

    /**
     * Method to handle the change event for radio button options
     * @param {Object} event - Event object
     */
    _inherits(CaseHold, _React$Component);
    return _createClass(CaseHold, [{
      key: "handleOptionChange",
      value: function handleOptionChange(event) {
        this.setState({
          holdReason: event.target.id
        });
      }

      /**
       * Method to handle the change event for text area element
       * @param {Object} event - Event object
       */
    }, {
      key: "handleCommentChange",
      value: function handleCommentChange(event) {
        this.setState({
          comment: event.target.value
        });
      }

      /**
       * Method to hold the case
       */
    }, {
      key: "holdCase",
      value: function holdCase() {
        this.props.onHold(this.state.holdReason, this.state.comment);
      }

      /**
       * Method to cancel holding the case
       */
    }, {
      key: "cancelHold",
      value: function cancelHold() {
        this.props.onCancel();
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement("form", {
          className: "case-hold",
          onSubmit: function onSubmit(e) {
            return e.preventDefault();
          }
        }, /*#__PURE__*/React.createElement("p", {
          className: "case-hold-subtitle"
        }, "The case will be put on hold for 3 days."), /*#__PURE__*/React.createElement("div", {
          className: "case-hold-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "case-hold-radio-group"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: "holdReason",
          id: HoldReasonType$3.HOLD,
          className: "case-hold-radio-input",
          onChange: this.handleOptionChange,
          checked: this.state.holdReason === HoldReasonType$3.HOLD
        }), /*#__PURE__*/React.createElement("label", {
          className: "case-hold-label-radio case-hold-radio-label",
          htmlFor: HoldReasonType$3.HOLD
        }, /*#__PURE__*/React.createElement("span", {
          className: "case-hold-radio-button"
        }), HoldReasonLabel.HOLD)), /*#__PURE__*/React.createElement("div", {
          className: "case-hold-radio-group"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: "holdReason",
          id: HoldReasonType$3.HOLD_FOR_DOCUMENTATION_QUERY,
          className: "case-hold-radio-input",
          onChange: this.handleOptionChange,
          checked: this.state.holdReason === HoldReasonType$3.HOLD_FOR_DOCUMENTATION_QUERY
        }), /*#__PURE__*/React.createElement("label", {
          className: "case-hold-label-radio case-hold-radio-label",
          htmlFor: HoldReasonType$3.HOLD_FOR_DOCUMENTATION_QUERY
        }, /*#__PURE__*/React.createElement("span", {
          className: "case-hold-radio-button"
        }), HoldReasonLabel.HOLD_FOR_DOCUMENTATION_QUERY)), /*#__PURE__*/React.createElement("div", {
          className: "case-hold-radio-group"
        }, /*#__PURE__*/React.createElement("input", {
          type: "radio",
          name: "holdReason",
          id: HoldReasonType$3.HOLD_FOR_MANAGER_REVIEW,
          className: "case-hold-radio-input",
          onChange: this.handleOptionChange,
          checked: this.state.holdReason === HoldReasonType$3.HOLD_FOR_MANAGER_REVIEW
        }), /*#__PURE__*/React.createElement("label", {
          className: "case-hold-label-radio case-hold-radio-label",
          htmlFor: HoldReasonType$3.HOLD_FOR_MANAGER_REVIEW
        }, /*#__PURE__*/React.createElement("span", {
          className: "case-hold-radio-button"
        }), HoldReasonLabel.HOLD_FOR_MANAGER_REVIEW))), /*#__PURE__*/React.createElement("textarea", {
          className: "case-hold-comment form-input input",
          placeholder: "Enter comments (optional)",
          maxLength: 1024,
          onChange: this.handleCommentChange,
          rows: 4
        }), /*#__PURE__*/React.createElement("div", {
          className: "case-hold-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: this.cancelHold,
          className: "chakra-secondary-button"
        }, "Cancel"), /*#__PURE__*/React.createElement("button", {
          onClick: this.holdCase,
          className: classnames('chakra-primary-button')
        }, "Hold")));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseHold, "displayName", 'CaseHold');

  uiCommon.commonEnums.DocumentStatus;
    var HoldReasonType$2 = uiCommon.commonEnums.HoldReasonType;
  var UserActivityActionType = /*#__PURE__*/function (UserActivityActionType) {
    UserActivityActionType["UPDATE_CODE"] = "UPDATE_CODE";
    UserActivityActionType["REMOVE_CODE"] = "REMOVE_CODE";
    UserActivityActionType["ADD_CODE"] = "ADD_CODE";
    UserActivityActionType["SUBMIT_CODES"] = "SUBMIT_CODES";
    UserActivityActionType["CANCEL_CASE"] = "CANCEL_CASE";
    UserActivityActionType["ADD_INVOICE"] = "ADD_INVOICE";
    UserActivityActionType["UPDATE_INVOICE"] = "UPDATE_INVOICE";
    UserActivityActionType["DELETE_INVOICE"] = "DELETE_INVOICE";
    UserActivityActionType["ADD_TRANSACTION"] = "ADD_TRANSACTION";
    UserActivityActionType["DELETE_TRANSACTION"] = "DELETE_TRANSACTION";
    UserActivityActionType["UPDATE_CHARGEABLE"] = "UPDATE_CHARGEABLE";
    UserActivityActionType["ADD_DOCUMENT_IMPROVEMENT"] = "ADD_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["UPDATE_DOCUMENT_IMPROVEMENT"] = "UPDATE_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["DELETE_DOCUMENT_IMPROVEMENT"] = "DELETE_DOCUMENT_IMPROVEMENT";
    UserActivityActionType["ADD_PROVIDER"] = "ADD_PROVIDER";
    UserActivityActionType["UPDATE_PROVIDER"] = "UPDATE_PROVIDER";
    UserActivityActionType["DELETE_PROVIDER"] = "DELETE_PROVIDER";
    UserActivityActionType["HOLD_PROCESS_INSTANCE"] = "HOLD_PROCESS_INSTANCE";
    UserActivityActionType["UPDATE_FIELD"] = "UPDATE_FIELD";
    UserActivityActionType["SPLIT_CASE"] = "SPLIT_CASE";
    UserActivityActionType["MERGE_CASE"] = "MERGE_CASE";
    UserActivityActionType["CREATE_CASE"] = "CREATE_CASE";
    UserActivityActionType["MANUAL_ASSIGNMENT"] = "MANUAL_ASSIGNMENT";
    UserActivityActionType["REFRESH_CASE"] = "REFRESH_CASE";
    UserActivityActionType["DISMISS_LATE_CASE"] = "DISMISS_LATE_CASE";
    UserActivityActionType["COMMENT_ON_CASE"] = "COMMENT_ON_CASE";
    return UserActivityActionType;
  }({});
  var invoiceChangeRepr = function invoiceChangeRepr(activity) {
    if (!activity.updatedInvoiceFieldName) {
      return '';
    } else {
      return activity.updatedInvoiceFieldName
      // insert a space before all caps
      .replace(/([A-Z])/g, ' $1').toLowerCase();
    }
  };
  var ActivityCodeType = /*#__PURE__*/function (ActivityCodeType) {
    ActivityCodeType["PROCEDURE"] = "ProcedureCode";
    ActivityCodeType["DIAGNOSIS"] = "DiagnosisCode";
    ActivityCodeType["MODIFIER"] = "ModifierCode";
    return ActivityCodeType;
  }(ActivityCodeType || {});
  var codeRepr = function codeRepr(activity) {
    if (activity.codeType === ActivityCodeType.PROCEDURE) {
      return "procedure";
    } else if (activity.codeType === ActivityCodeType.DIAGNOSIS) {
      return "diagnosis";
    } else if (activity.codeType === ActivityCodeType.MODIFIER) {
      return "modifier";
    }
  };
  var userActivityFormatter = function userActivityFormatter(activity) {
    var inner;
    if (activity.actionType === UserActivityActionType.ADD_CODE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " added the ", /*#__PURE__*/React.createElement("b", null, activity.code), ' ', codeRepr(activity), ".");
    } else if (activity.actionType === UserActivityActionType.REMOVE_CODE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " removed the ", /*#__PURE__*/React.createElement("b", null, activity.code), ' ', codeRepr(activity), ".");
    } else if (activity.actionType === UserActivityActionType.UPDATE_CODE) {
      if (activity.codeType === ActivityCodeType.DIAGNOSIS || activity.codeType === ActivityCodeType.MODIFIER) {
        inner = /*#__PURE__*/React.createElement("span", {
          className: "activity-readout qa-updated-moved"
        }, activity.username, " updated the ", /*#__PURE__*/React.createElement("b", null, activity.code), ' ', codeRepr(activity), " to ", /*#__PURE__*/React.createElement("b", null, "a different order"), ".");
      } else {
        inner = /*#__PURE__*/React.createElement("span", {
          className: "activity-readout qa-changed-units"
        }, activity.username, " updated the ", /*#__PURE__*/React.createElement("b", null, activity.code), ' ', codeRepr(activity), " to ", /*#__PURE__*/React.createElement("b", null, activity.units, " units"), ".");
      }
    } else if (activity.actionType === UserActivityActionType.SUBMIT_CODES) {
      if (activity.withOverride) {
        inner = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          className: "activity-readout"
        }, activity.username, " submitted the charges with an override."), /*#__PURE__*/React.createElement("span", {
          className: "activity-message"
        }, activity.message));
      } else {
        inner = /*#__PURE__*/React.createElement("span", {
          className: "activity-readout"
        }, activity.username, " submitted the charges.");
      }
    } else if (activity.actionType === UserActivityActionType.REFRESH_CASE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " refreshed the case.");
    } else if (activity.actionType === UserActivityActionType.CANCEL_CASE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " cancelled the case.");
    } else if (activity.actionType === UserActivityActionType.ADD_INVOICE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " added an invoice.");
    } else if (activity.actionType === UserActivityActionType.DELETE_INVOICE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " removed an invoice.");
    } else if (activity.actionType === UserActivityActionType.UPDATE_INVOICE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " updated an invoice with", ' ', invoiceChangeRepr(activity), " to", ' ', /*#__PURE__*/React.createElement("b", null, activity.updatedInvoiceFieldValue, "."));
    } else if (activity.actionType === UserActivityActionType.ADD_TRANSACTION) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " added a charge.");
    } else if (activity.actionType === UserActivityActionType.DELETE_TRANSACTION) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " removed a charge.");
    } else if (activity.actionType === UserActivityActionType.UPDATE_CHARGEABLE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " made this case", ' ', "".concat(activity !== null && activity !== void 0 && activity.isChargeable ? 'chargeable' : 'non-chargeable'), ".");
    } else if (activity.actionType === UserActivityActionType.ADD_DOCUMENT_IMPROVEMENT) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " added ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), ' ', "improvement.");
    } else if (activity.actionType === UserActivityActionType.UPDATE_DOCUMENT_IMPROVEMENT) {
      var fieldName = activity === null || activity === void 0 ? void 0 : activity.updatedDocumentImprovementFieldName;
      var fieldValue = activity === null || activity === void 0 ? void 0 : activity.updatedDocumentImprovementFieldValue;
      var filedText = fieldName === 'charge_code' ? 'charge code' : 'potential charge code';
      var activityType = fieldValue ? ' added' : 'removed';
      var actionDetail = /*#__PURE__*/React.createElement(React.Fragment, null, activityType, " ", /*#__PURE__*/React.createElement("b", null, fieldValue), " ", filedText, ' ', fieldValue ? 'to' : 'from');
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " ", actionDetail, " ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), ' ', "improvement.");
    } else if (activity.actionType === UserActivityActionType.DELETE_DOCUMENT_IMPROVEMENT) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " deleted ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), ' ', "improvement.");
    } else if (activity.actionType === UserActivityActionType.ADD_PROVIDER) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " added provider", ' ', /*#__PURE__*/React.createElement("b", null, uiCommon.objectUtils.capitalize(activity.documentImprovementProviderName)), ' ', "to ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), " improvement.");
    } else if (activity.actionType === UserActivityActionType.DELETE_PROVIDER) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " removed provider", ' ', /*#__PURE__*/React.createElement("b", null, uiCommon.objectUtils.capitalize(activity.documentImprovementProviderName)), ' ', "from ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), " improvement.");
    } else if (activity.actionType === UserActivityActionType.UPDATE_PROVIDER) {
      var _activity$documentImp;
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " updated provider", ' ', /*#__PURE__*/React.createElement("b", null, uiCommon.objectUtils.capitalize(activity.documentImprovementProviderName)), ' ', "with status", ' ', /*#__PURE__*/React.createElement("b", null, uiCommon.objectUtils.capitalize((_activity$documentImp = activity.documentImprovementProviderQueryStatus) === null || _activity$documentImp === void 0 ? void 0 : _activity$documentImp.replace(/_/g, ' '))), ' ', "for ", /*#__PURE__*/React.createElement("b", null, activity.documentImprovement), " improvement.");
    } else if (activity.actionType === UserActivityActionType.HOLD_PROCESS_INSTANCE) {
      var hasComment = false;
      if (activity.message !== '' && activity.message !== null && activity.message !== undefined) {
        hasComment = true;
      }
      var holdDetail = "".concat(activity.username, " ").concat(activity.holdReason === HoldReasonType$2.OFF_HOLD ? 'took the case ' : 'has put the case on ');
      var holdReason = "".concat(activity.holdReason === HoldReasonType$2.OFF_HOLD ? 'off hold' : HoldReasonLabel[activity.holdReason]);
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, holdDetail, /*#__PURE__*/React.createElement("b", null, holdReason), hasComment && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), " and added comment ", /*#__PURE__*/React.createElement("b", null, activity.message)));
    } else if (activity.actionType === UserActivityActionType.UPDATE_FIELD) {
      var _activity$updatedFiel, _activity$updatedFiel2;
      var _fieldName = (_activity$updatedFiel = activity.updatedFieldName) === null || _activity$updatedFiel === void 0 ? void 0 : _activity$updatedFiel.toUpperCase().split('_').join(' ');
      var _fieldValue = (_activity$updatedFiel2 = activity.updatedFieldValue) === null || _activity$updatedFiel2 === void 0 ? void 0 : _activity$updatedFiel2.toUpperCase().split('_').join(' ');
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " updated the value of ", /*#__PURE__*/React.createElement("b", null, _fieldName, " "), "to ", /*#__PURE__*/React.createElement("b", null, _fieldValue), ".");
    } else if (activity.actionType === UserActivityActionType.SPLIT_CASE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " performed split.");
    } else if (activity.actionType === UserActivityActionType.MERGE_CASE) {
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " performed merge.");
    } else if (activity.actionType === UserActivityActionType.CREATE_CASE) {
      var _hasComment = !!activity.message;
      inner = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " created the case"), _hasComment && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("br", null), " and added comment ", /*#__PURE__*/React.createElement("b", null, activity.message, ".")));
    } else if (activity.actionType === UserActivityActionType.MANUAL_ASSIGNMENT) {
      inner = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " reasssigned the case to", ' ', activity.reassignedUsername, "."));
    } else if (activity.actionType === UserActivityActionType.DISMISS_LATE_CASE) {
      inner = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, activity.username, " dismissed the late case notification."));
    } else if (activity.actionType === UserActivityActionType.COMMENT_ON_CASE) {
      // Comment on a case is handled in UserActivityComments
      return;
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "activity-item"
    }, inner, /*#__PURE__*/React.createElement("span", {
      className: "activity-timestamp"
    }, activity.timestamp ? uiCommon.cmxDateTime.format(activity.timestamp, uiCommon.cmxDateTime.FORMATS.LONG_DATE_TIME) : 'N/A'));
  };

  var browserDetection = {};

  var isAndroid;
  var hasRequiredIsAndroid;

  function requireIsAndroid () {
  	if (hasRequiredIsAndroid) return isAndroid;
  	hasRequiredIsAndroid = 1;
  	isAndroid = function isAndroid(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return /Android/i.test(ua);
  	};
  	return isAndroid;
  }

  var isChromeOs;
  var hasRequiredIsChromeOs;

  function requireIsChromeOs () {
  	if (hasRequiredIsChromeOs) return isChromeOs;
  	hasRequiredIsChromeOs = 1;
  	isChromeOs = function isChromeOS(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return /CrOS/i.test(ua);
  	};
  	return isChromeOs;
  }

  var isEdge;
  var hasRequiredIsEdge;

  function requireIsEdge () {
  	if (hasRequiredIsEdge) return isEdge;
  	hasRequiredIsEdge = 1;
  	isEdge = function isEdge(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("Edge/") !== -1 || ua.indexOf("Edg/") !== -1;
  	};
  	return isEdge;
  }

  var isSamsung;
  var hasRequiredIsSamsung;

  function requireIsSamsung () {
  	if (hasRequiredIsSamsung) return isSamsung;
  	hasRequiredIsSamsung = 1;
  	isSamsung = function isSamsungBrowser(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return /SamsungBrowser/i.test(ua);
  	};
  	return isSamsung;
  }

  var isDuckduckgo;
  var hasRequiredIsDuckduckgo;

  function requireIsDuckduckgo () {
  	if (hasRequiredIsDuckduckgo) return isDuckduckgo;
  	hasRequiredIsDuckduckgo = 1;
  	isDuckduckgo = function isDuckDuckGo(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("DuckDuckGo/") !== -1;
  	};
  	return isDuckduckgo;
  }

  var isOpera;
  var hasRequiredIsOpera;

  function requireIsOpera () {
  	if (hasRequiredIsOpera) return isOpera;
  	hasRequiredIsOpera = 1;
  	isOpera = function isOpera(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return (ua.indexOf("OPR/") !== -1 ||
  	        ua.indexOf("Opera/") !== -1 ||
  	        ua.indexOf("OPT/") !== -1);
  	};
  	return isOpera;
  }

  var isSilk;
  var hasRequiredIsSilk;

  function requireIsSilk () {
  	if (hasRequiredIsSilk) return isSilk;
  	hasRequiredIsSilk = 1;
  	isSilk = function isSilk(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("Silk/") !== -1;
  	};
  	return isSilk;
  }

  var isChrome;
  var hasRequiredIsChrome;

  function requireIsChrome () {
  	if (hasRequiredIsChrome) return isChrome;
  	hasRequiredIsChrome = 1;
  	var isEdge = requireIsEdge();
  	var isSamsung = requireIsSamsung();
  	var isDuckDuckGo = requireIsDuckduckgo();
  	var isOpera = requireIsOpera();
  	var isSilk = requireIsSilk();
  	isChrome = function isChrome(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ((ua.indexOf("Chrome") !== -1 || ua.indexOf("CriOS") !== -1) &&
  	        !isEdge(ua) &&
  	        !isSamsung(ua) &&
  	        !isDuckDuckGo(ua) &&
  	        !isOpera(ua) &&
  	        !isSilk(ua));
  	};
  	return isChrome;
  }

  var isIe11;
  var hasRequiredIsIe11;

  function requireIsIe11 () {
  	if (hasRequiredIsIe11) return isIe11;
  	hasRequiredIsIe11 = 1;
  	isIe11 = function isIe11(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("Trident/7") !== -1;
  	};
  	return isIe11;
  }

  var isIe;
  var hasRequiredIsIe;

  function requireIsIe () {
  	if (hasRequiredIsIe) return isIe;
  	hasRequiredIsIe = 1;
  	var isIE11 = requireIsIe11();
  	isIe = function isIE(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("MSIE") !== -1 || isIE11(ua);
  	};
  	return isIe;
  }

  var isIe9;
  var hasRequiredIsIe9;

  function requireIsIe9 () {
  	if (hasRequiredIsIe9) return isIe9;
  	hasRequiredIsIe9 = 1;
  	isIe9 = function isIe9(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("MSIE 9") !== -1;
  	};
  	return isIe9;
  }

  var isIe10;
  var hasRequiredIsIe10;

  function requireIsIe10 () {
  	if (hasRequiredIsIe10) return isIe10;
  	hasRequiredIsIe10 = 1;
  	isIe10 = function isIe10(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("MSIE 10") !== -1;
  	};
  	return isIe10;
  }

  var isFirefox;
  var hasRequiredIsFirefox;

  function requireIsFirefox () {
  	if (hasRequiredIsFirefox) return isFirefox;
  	hasRequiredIsFirefox = 1;
  	isFirefox = function isFirefox(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return /Firefox/i.test(ua);
  	};
  	return isFirefox;
  }

  var isSafari;
  var hasRequiredIsSafari;

  function requireIsSafari () {
  	if (hasRequiredIsSafari) return isSafari;
  	hasRequiredIsSafari = 1;
  	isSafari = function isSafari(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return (/^Mozilla\/5\.0.*Safari\//.test(ua) &&
  	        !/(iPhone|iPad|iPod|Android|SM-)/i.test(ua) &&
  	        !/Chrome|CriOS|FxiOS|OPiOS|mercury/i.test(ua));
  	};
  	return isSafari;
  }

  var isIpados;
  var hasRequiredIsIpados;

  function requireIsIpados () {
  	if (hasRequiredIsIpados) return isIpados;
  	hasRequiredIsIpados = 1;
  	isIpados = function isIpadOS(ua, document) {
  	    ua = ua || window.navigator.userAgent;
  	    document = document || window.document;
  	    // "ontouchend" is used to determine if a browser is on an iPad, otherwise
  	    // user-agents for iPadOS behave/identify as a desktop browser
  	    return /Mac|iPad/i.test(ua) && "ontouchend" in document;
  	};
  	return isIpados;
  }

  var isIos;
  var hasRequiredIsIos;

  function requireIsIos () {
  	if (hasRequiredIsIos) return isIos;
  	hasRequiredIsIos = 1;
  	var isIpadOS = requireIsIpados();
  	isIos = function isIos(ua, checkIpadOS, document) {
  	    if (checkIpadOS === void 0) { checkIpadOS = true; }
  	    ua = ua || window.navigator.userAgent;
  	    var iOsTest = /iPhone|iPod|iPad/i.test(ua);
  	    return checkIpadOS ? iOsTest || isIpadOS(ua, document) : iOsTest;
  	};
  	return isIos;
  }

  var isIosFirefox;
  var hasRequiredIsIosFirefox;

  function requireIsIosFirefox () {
  	if (hasRequiredIsIosFirefox) return isIosFirefox;
  	hasRequiredIsIosFirefox = 1;
  	isIosFirefox = function isIosFirefox(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return /FxiOS/i.test(ua);
  	};
  	return isIosFirefox;
  }

  var isIosGoogleSearchApp;
  var hasRequiredIsIosGoogleSearchApp;

  function requireIsIosGoogleSearchApp () {
  	if (hasRequiredIsIosGoogleSearchApp) return isIosGoogleSearchApp;
  	hasRequiredIsIosGoogleSearchApp = 1;
  	var isIos = requireIsIos();
  	function isGoogleSearchApp(ua) {
  	    return /\bGSA\b/.test(ua);
  	}
  	isIosGoogleSearchApp = function isIosGoogleSearchApp(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return isIos(ua) && isGoogleSearchApp(ua);
  	};
  	return isIosGoogleSearchApp;
  }

  var isIosSafari;
  var hasRequiredIsIosSafari;

  function requireIsIosSafari () {
  	if (hasRequiredIsIosSafari) return isIosSafari;
  	hasRequiredIsIosSafari = 1;
  	var isIos = requireIsIos();
  	var isIosFirefox = requireIsIosFirefox();
  	var webkitRegexp = /webkit/i;
  	function isWebkit(ua) {
  	    return webkitRegexp.test(ua);
  	}
  	function isIosChrome(ua) {
  	    return ua.indexOf("CriOS") > -1;
  	}
  	function isFacebook(ua) {
  	    return ua.indexOf("FBAN") > -1;
  	}
  	isIosSafari = function isIosSafari(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return (isIos(ua) &&
  	        isWebkit(ua) &&
  	        !isIosChrome(ua) &&
  	        !isIosFirefox(ua) &&
  	        !isFacebook(ua));
  	};
  	return isIosSafari;
  }

  var isIosWebview;
  var hasRequiredIsIosWebview;

  function requireIsIosWebview () {
  	if (hasRequiredIsIosWebview) return isIosWebview;
  	hasRequiredIsIosWebview = 1;
  	var isIos = requireIsIos();
  	var isIosGoogleSearchApp = requireIsIosGoogleSearchApp();
  	isIosWebview = function isIosWebview(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    if (isIos(ua)) {
  	        // The Google Search iOS app is technically a webview and doesn't support popups.
  	        if (isIosGoogleSearchApp(ua)) {
  	            return true;
  	        }
  	        // Historically, a webview could be identified by the presence of AppleWebKit and _no_ presence of Safari after.
  	        return /.+AppleWebKit(?!.*Safari)/i.test(ua);
  	    }
  	    return false;
  	};
  	return isIosWebview;
  }

  var isIosUiwebview;
  var hasRequiredIsIosUiwebview;

  function requireIsIosUiwebview () {
  	if (hasRequiredIsIosUiwebview) return isIosUiwebview;
  	hasRequiredIsIosUiwebview = 1;
  	var isIosWebview = requireIsIosWebview();
  	isIosUiwebview = function isIosUIWebview(ua, statusBarVisible) {
  	    statusBarVisible =
  	        typeof statusBarVisible !== "undefined"
  	            ? statusBarVisible
  	            : window.statusbar.visible;
  	    return isIosWebview(ua) && !statusBarVisible;
  	};
  	return isIosUiwebview;
  }

  var isIosWkwebview;
  var hasRequiredIsIosWkwebview;

  function requireIsIosWkwebview () {
  	if (hasRequiredIsIosWkwebview) return isIosWkwebview;
  	hasRequiredIsIosWkwebview = 1;
  	var isIosWebview = requireIsIosWebview();
  	isIosWkwebview = function isIosWKWebview(ua, statusBarVisible) {
  	    statusBarVisible =
  	        typeof statusBarVisible !== "undefined"
  	            ? statusBarVisible
  	            : window.statusbar.visible;
  	    return isIosWebview(ua) && statusBarVisible;
  	};
  	return isIosWkwebview;
  }

  var isMobileFirefox;
  var hasRequiredIsMobileFirefox;

  function requireIsMobileFirefox () {
  	if (hasRequiredIsMobileFirefox) return isMobileFirefox;
  	hasRequiredIsMobileFirefox = 1;
  	var isIosFirefox = requireIsIosFirefox();
  	var isFirefox = requireIsFirefox();
  	isMobileFirefox = function isMobileFirefox(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return (isIosFirefox(ua) ||
  	        (/iPhone|iPod|iPad|Mobile|Tablet/i.test(ua) && isFirefox(ua)));
  	};
  	return isMobileFirefox;
  }

  var hasSoftwareKeyboard;
  var hasRequiredHasSoftwareKeyboard;

  function requireHasSoftwareKeyboard () {
  	if (hasRequiredHasSoftwareKeyboard) return hasSoftwareKeyboard;
  	hasRequiredHasSoftwareKeyboard = 1;
  	var isAndroid = requireIsAndroid();
  	var isChromeOS = requireIsChromeOs();
  	var isIos = requireIsIos();
  	hasSoftwareKeyboard = function hasSoftwareKeyboard() {
  	    return isAndroid() || isChromeOS() || isIos();
  	};
  	return hasSoftwareKeyboard;
  }

  var supportsPopups;
  var hasRequiredSupportsPopups;

  function requireSupportsPopups () {
  	if (hasRequiredSupportsPopups) return supportsPopups;
  	hasRequiredSupportsPopups = 1;
  	var MINIMUM_SUPPORTED_CHROME_IOS_VERSION = 48;
  	var isAndroid = requireIsAndroid();
  	var isIosFirefox = requireIsIosFirefox();
  	var isIosWebview = requireIsIosWebview();
  	var isChrome = requireIsChrome();
  	var isSamsungBrowser = requireIsSamsung();
  	var isDuckDuckGo = requireIsDuckduckgo();
  	function isUnsupportedIosChrome(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    var match = ua.match(/CriOS\/(\d+)\./);
  	    if (!match) {
  	        return false;
  	    }
  	    var version = parseInt(match[1], 10);
  	    return version < MINIMUM_SUPPORTED_CHROME_IOS_VERSION;
  	}
  	function isOperaMini(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return ua.indexOf("Opera Mini") > -1;
  	}
  	function isAndroidWebview(ua) {
  	    var androidWebviewRegExp = /Version\/[\d.]+/i;
  	    ua = ua || window.navigator.userAgent;
  	    if (isAndroid(ua)) {
  	        return (androidWebviewRegExp.test(ua) && !isOperaMini(ua) && !isDuckDuckGo(ua));
  	    }
  	    return false;
  	}
  	function isOldSamsungBrowserOrSamsungWebview(ua) {
  	    return !isChrome(ua) && !isSamsungBrowser(ua) && /samsung/i.test(ua);
  	}
  	supportsPopups = function supportsPopups(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    return !(isIosWebview(ua) ||
  	        isIosFirefox(ua) ||
  	        isAndroidWebview(ua) ||
  	        isOperaMini(ua) ||
  	        isUnsupportedIosChrome(ua) ||
  	        isOldSamsungBrowserOrSamsungWebview(ua));
  	};
  	return supportsPopups;
  }

  var supportsPaymentRequestApi;
  var hasRequiredSupportsPaymentRequestApi;

  function requireSupportsPaymentRequestApi () {
  	if (hasRequiredSupportsPaymentRequestApi) return supportsPaymentRequestApi;
  	hasRequiredSupportsPaymentRequestApi = 1;
  	var isChrome = requireIsChrome();
  	var MINIMUM_SUPPORTED_CHROME_VERSION = 61;
  	function isSupportedChromeVersion(ua) {
  	    var match = ua.match(/Chrome\/(\d+)\./);
  	    if (!match) {
  	        return false;
  	    }
  	    var version = parseInt(match[1], 10);
  	    return version >= MINIMUM_SUPPORTED_CHROME_VERSION;
  	}
  	supportsPaymentRequestApi = function supportsPaymentRequestApi(ua) {
  	    ua = ua || window.navigator.userAgent;
  	    if (!window.PaymentRequest) {
  	        return false;
  	    }
  	    if (!isChrome(ua)) {
  	        // if browser is not chrome based, but has Payment Request API
  	        // this means that it implemented the API after it was finalized
  	        return true;
  	    }
  	    // Chrome introduce the Payment Request API in some versions of
  	    // Android Chrome as early as Chrome v53, but it was not
  	    // finalized until v61
  	    return isSupportedChromeVersion(ua);
  	};
  	return supportsPaymentRequestApi;
  }

  var hasRequiredBrowserDetection;

  function requireBrowserDetection () {
  	if (hasRequiredBrowserDetection) return browserDetection;
  	hasRequiredBrowserDetection = 1;
  	Object.defineProperty(browserDetection, "__esModule", { value: true });
  	browserDetection.supportsPaymentRequestApi = browserDetection.supportsPopups = browserDetection.hasSoftwareKeyboard = browserDetection.isSilk = browserDetection.isSamsungBrowser = browserDetection.isOpera = browserDetection.isMobileFirefox = browserDetection.isIpadOS = browserDetection.isIosWKWebview = browserDetection.isIosWebview = browserDetection.isIosUIWebview = browserDetection.isIosSafari = browserDetection.isSafari = browserDetection.isIosGoogleSearchApp = browserDetection.isIosFirefox = browserDetection.isIos = browserDetection.isFirefox = browserDetection.isEdge = browserDetection.isIe11 = browserDetection.isIe10 = browserDetection.isIe9 = browserDetection.isIe = browserDetection.isDuckDuckGo = browserDetection.isChrome = browserDetection.isChromeOS = browserDetection.isAndroid = void 0;
  	var isAndroid = requireIsAndroid();
  	browserDetection.isAndroid = isAndroid;
  	var isChromeOS = requireIsChromeOs();
  	browserDetection.isChromeOS = isChromeOS;
  	var isChrome = requireIsChrome();
  	browserDetection.isChrome = isChrome;
  	var isDuckDuckGo = requireIsDuckduckgo();
  	browserDetection.isDuckDuckGo = isDuckDuckGo;
  	var isIe = requireIsIe();
  	browserDetection.isIe = isIe;
  	var isIe9 = requireIsIe9();
  	browserDetection.isIe9 = isIe9;
  	var isIe10 = requireIsIe10();
  	browserDetection.isIe10 = isIe10;
  	var isIe11 = requireIsIe11();
  	browserDetection.isIe11 = isIe11;
  	var isEdge = requireIsEdge();
  	browserDetection.isEdge = isEdge;
  	var isFirefox = requireIsFirefox();
  	browserDetection.isFirefox = isFirefox;
  	var isSafari = requireIsSafari();
  	browserDetection.isSafari = isSafari;
  	var isIos = requireIsIos();
  	browserDetection.isIos = isIos;
  	var isIosFirefox = requireIsIosFirefox();
  	browserDetection.isIosFirefox = isIosFirefox;
  	var isIosGoogleSearchApp = requireIsIosGoogleSearchApp();
  	browserDetection.isIosGoogleSearchApp = isIosGoogleSearchApp;
  	var isIosSafari = requireIsIosSafari();
  	browserDetection.isIosSafari = isIosSafari;
  	var isIosUIWebview = requireIsIosUiwebview();
  	browserDetection.isIosUIWebview = isIosUIWebview;
  	var isIosWebview = requireIsIosWebview();
  	browserDetection.isIosWebview = isIosWebview;
  	var isIosWKWebview = requireIsIosWkwebview();
  	browserDetection.isIosWKWebview = isIosWKWebview;
  	var isIpadOS = requireIsIpados();
  	browserDetection.isIpadOS = isIpadOS;
  	var isMobileFirefox = requireIsMobileFirefox();
  	browserDetection.isMobileFirefox = isMobileFirefox;
  	var isOpera = requireIsOpera();
  	browserDetection.isOpera = isOpera;
  	var isSamsungBrowser = requireIsSamsung();
  	browserDetection.isSamsungBrowser = isSamsungBrowser;
  	var isSilk = requireIsSilk();
  	browserDetection.isSilk = isSilk;
  	var hasSoftwareKeyboard = requireHasSoftwareKeyboard();
  	browserDetection.hasSoftwareKeyboard = hasSoftwareKeyboard;
  	var supportsPopups = requireSupportsPopups();
  	browserDetection.supportsPopups = supportsPopups;
  	var supportsPaymentRequestApi = requireSupportsPaymentRequestApi();
  	browserDetection.supportsPaymentRequestApi = supportsPaymentRequestApi;
  	return browserDetection;
  }

  var browserDetectionExports = requireBrowserDetection();

  uiCommon.commonEnums.DocumentStatus;
    uiCommon.commonEnums.HoldReasonType;
  var REVISION_TYPE_MAP = {
    ADD: 'Added',
    DEL: 'Deleted',
    MOD: 'Modified'
  };
  var SystemActivityActionType = /*#__PURE__*/function (SystemActivityActionType) {
    SystemActivityActionType["ASSIGN_PROFILE"] = "ASSIGN_PROFILE";
    SystemActivityActionType["CASE_VERSION_UPDATE"] = "CASE_VERSION_UPDATE";
    SystemActivityActionType["LATE_CASE_UPDATE"] = "LATE_CASE_UPDATE";
    return SystemActivityActionType;
  }({});
  var SystemActivityEntityType = /*#__PURE__*/function (SystemActivityEntityType) {
    SystemActivityEntityType["WORKITEM"] = "WORKITEM";
    SystemActivityEntityType["PROCESS_INSTANCE"] = "PROCESS_INSTANCE";
    return SystemActivityEntityType;
  }({});
  var systemActivityFormatter = function systemActivityFormatter(activity) {
    var inner;
    if (activity.action === SystemActivityActionType.ASSIGN_PROFILE && activity.targetEntityType === SystemActivityEntityType.WORKITEM) {
      var _activity$metadata;
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, "This case matched the ", activity === null || activity === void 0 || (_activity$metadata = activity.metadata) === null || _activity$metadata === void 0 ? void 0 : _activity$metadata.profileName, " queue for distribution.");
    } else if ((activity.action === SystemActivityActionType.CASE_VERSION_UPDATE || activity.action === SystemActivityActionType.LATE_CASE_UPDATE) && activity.targetEntityType === SystemActivityEntityType.PROCESS_INSTANCE) {
      var _activity$metadata2;
      inner = /*#__PURE__*/React.createElement("span", {
        className: "activity-readout"
      }, "The case version has been updated to ", activity === null || activity === void 0 || (_activity$metadata2 = activity.metadata) === null || _activity$metadata2 === void 0 ? void 0 : _activity$metadata2.caseVersion, ".");
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "activity-item"
    }, inner, /*#__PURE__*/React.createElement("span", {
      className: "activity-timestamp"
    }, activity.timestamp ? uiCommon.cmxDateTime.format(activity.timestamp, uiCommon.cmxDateTime.FORMATS.LONG_DATE_TIME) : 'N/A'));
  };
  var cqaActivityFormatter = function cqaActivityFormatter(item) {
    var _titles;
    var date = new Date(item.revInfo.datetime);
    var datetime = uiCommon.cmxDateTime.formatDateWithComma(date);
    var titles = [];
    if ('code' in item) {
      var cqaCode = item.code;
      titles = ["".concat(REVISION_TYPE_MAP[item.revisionType], " ").concat(cqaCode.entityType, " ").concat(cqaCode.code, " on charge ").concat(cqaCode.transaction.sequenceNumber)];
    }
    if ('codeAssessment' in item) {
      var _parentCode$transacti;
      var codeAssessment = item.codeAssessment;
      var parentCode = item.codeAssessment.parentCode;
      titles = ["".concat(REVISION_TYPE_MAP[item.revisionType], " assessment").concat(item.revisionType === 'MOD' ? ' to ' : ' ').concat(codeAssessment.assessment, " and role ").concat(codeAssessment.role).concat(item.revisionType === 'MOD' ? ' to ' : ' ').concat(parentCode ? "for ".concat(parentCode.entityType, " ").concat(parentCode.code, " on charge ").concat((_parentCode$transacti = parentCode.transaction) === null || _parentCode$transacti === void 0 ? void 0 : _parentCode$transacti.sequenceNumber) : 'n/a')];
    }
    return !((_titles = titles) !== null && _titles !== void 0 && _titles.length) ? false : titles.map(function (title, titleIdx) {
      return /*#__PURE__*/React.createElement("div", {
        key: titleIdx,
        style: {
          marginTop: '5px'
        }
      }, /*#__PURE__*/React.createElement("p", {
        className: "tile-title"
      }, title), /*#__PURE__*/React.createElement("span", {
        className: "cqa-activity-timestamp"
      }, datetime ? "".concat(datetime, ", ").concat(date.toLocaleTimeString()) : 'N/A', ' ', "| ".concat(item.revInfo.username)));
    });
  };

  var styles$1 = {
    lengthIndicator: {
      color: theme.colors.text['lowEmphasis']
    },
    textarea: {
      flexDirection: 'column',
      gap: theme.space[8],
      width: '100%'
    }
  };

  var _excluded$8 = ["leftIcon", "onChange", "placeholder", "readonly", "required", "rightIcon", "value", "className", "disabled", "maxLength", "size", "variant"];
  var TextareaSize = /*#__PURE__*/function (TextareaSize) {
    TextareaSize["XS"] = "xs";
    TextareaSize["SM"] = "sm";
    TextareaSize["MD"] = "md";
    TextareaSize["LG"] = "lg";
    return TextareaSize;
  }(TextareaSize || {});
  var TextareaVariant = /*#__PURE__*/function (TextareaVariant) {
    TextareaVariant["OUTLINE"] = "outline";
    TextareaVariant["FLUSHED"] = "flushed";
    TextareaVariant["FILLED"] = "filled";
    TextareaVariant["UNSTYLED"] = "unstyled";
    return TextareaVariant;
  }(TextareaVariant || {});
  var Textarea = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var _value$length;
    var leftIcon = _ref.leftIcon,
      _onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      readonly = _ref.readonly,
      required = _ref.required,
      rightIcon = _ref.rightIcon,
      value = _ref.value,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$maxLength = _ref.maxLength,
      maxLength = _ref$maxLength === void 0 ? 2048 : _ref$maxLength,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? TextareaSize.MD : _ref$size,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? TextareaVariant.OUTLINE : _ref$variant,
      props = _objectWithoutProperties(_ref, _excluded$8);
    var localRef = React.useRef(null);
    var _React$useState = React.useState((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      textLength = _React$useState2[0],
      setTextLength = _React$useState2[1];

    // Expose the local ref and reset function to parent
    React.useImperativeHandle(ref, function () {
      var element = localRef.current;
      element.resetTextLength = function () {
        return setTextLength(0);
      };
      return element; // return the real DOM node itself
    });
    React.useEffect(function () {
      if (localRef.current) {
        localRef.current.focus();
        localRef.current.selectionStart = localRef.current.value.length;
        localRef.current.selectionEnd = localRef.current.value.length;
      }
    }, []);
    return /*#__PURE__*/React.createElement(HStack, null, /*#__PURE__*/React.createElement("div", {
      className: "left-icon"
    }, leftIcon), /*#__PURE__*/React.createElement(Flex, {
      sx: styles$1.textarea
    }, /*#__PURE__*/React.createElement(Textarea$1, _extends$1({}, props, {
      size: size,
      isDisabled: disabled,
      isReadOnly: readonly,
      isRequired: required,
      variant: variant,
      className: className,
      placeholder: placeholder,
      value: value,
      maxLength: maxLength,
      ref: localRef,
      onChange: function onChange(e) {
        setTextLength(e.target.value.length);
        _onChange === null || _onChange === void 0 || _onChange(e);
      }
    })), /*#__PURE__*/React.createElement(Text, {
      sx: styles$1.lengthIndicator
    }, textLength, "/", maxLength)), /*#__PURE__*/React.createElement("div", {
      className: "right-icon"
    }, rightIcon));
  });
  Textarea.displayName = 'Textarea';

  var UserActivityComment = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var _gradeBenchState$invo;
    var onFilterChange = _ref.onFilterChange,
      editable = _ref.editable;
    var textareaRef = React.useRef(null);
    var dispatch = useDispatch();
    var codeBenchState = useSelector(function (state) {
      return state.codeBench;
    });
    var gradeBenchState = useSelector(function (state) {
      return state.gradeBenchPanel;
    });
    var uiState = useSelector(function (state) {
      return state.ui;
    });
    var isGradeBench = (codeBenchState === null || codeBenchState === void 0 ? void 0 : codeBenchState.benchMode) === uiCommon.commonEnums.BenchMode.GRADE;
    var processInstance = codeBenchState === null || codeBenchState === void 0 ? void 0 : codeBenchState.processInstance;
    var activeUser = uiState === null || uiState === void 0 ? void 0 : uiState.activeUser;
    var sdCaseId = gradeBenchState === null || gradeBenchState === void 0 || (_gradeBenchState$invo = gradeBenchState.invoices) === null || _gradeBenchState$invo === void 0 || (_gradeBenchState$invo = _gradeBenchState$invo[0]) === null || _gradeBenchState$invo === void 0 ? void 0 : _gradeBenchState$invo.sdCaseId;
    var userAvatar = React.useMemo(function () {
      if (!activeUser) return null;
      var initials = uiCommon.Utils.getAvatarInitials(activeUser.firstName, activeUser.lastName);
      return /*#__PURE__*/React.createElement(Avatar, {
        name: initials,
        bgColor: "#6B8D99",
        color: "#FFFFFF",
        size: "sm"
      });
    }, [activeUser]);
    var _React$useState = React.useState("all"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      selectedFilter = _React$useState2[0],
      setSelectedFilter = _React$useState2[1];
    var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasText = _React$useState4[0],
      setHasText = _React$useState4[1];
    var clearTextarea = function clearTextarea() {
      var _textareaRef$current$, _textareaRef$current;
      if (!textareaRef.current) return;
      textareaRef.current.value = "";
      try {
        textareaRef.current.dispatchEvent(new Event("input", {
          bubbles: true
        }));
      } catch (e) {
        console.warn("Input event dispatch failed:", e);
      }
      (_textareaRef$current$ = (_textareaRef$current = textareaRef.current).resetTextLength) === null || _textareaRef$current$ === void 0 || _textareaRef$current$.call(_textareaRef$current);
      setHasText(false);
    };
    var handleSaveClick = function handleSaveClick() {
      var _textareaRef$current2;
      var comment = (_textareaRef$current2 = textareaRef.current) === null || _textareaRef$current2 === void 0 ? void 0 : _textareaRef$current2.value.trim();
      if (!comment) return;
      if (isGradeBench) {
        // Use grade bench action
        dispatch(uiCommon.gradeBenchPanelActions.addUserActivityComment({
          sdCaseId: sdCaseId,
          comment: comment
        }));
      } else {
        // Use code bench action
        dispatch(uiCommon.codeBenchActions.addUserActivityComment({
          processInstance: processInstance,
          comment: comment
        }));
      }
      clearTextarea();
    };
    var handleCancelClick = function handleCancelClick() {
      clearTextarea();
    };
    var handleFilterClick = function handleFilterClick(filter) {
      setSelectedFilter(filter);
      onFilterChange === null || onFilterChange === void 0 || onFilterChange(filter);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "comment-send"
    }, /*#__PURE__*/React.createElement(Textarea, {
      ref: textareaRef,
      leftIcon: userAvatar,
      placeholder: "Add a comment",
      onChange: function onChange(e) {
        return setHasText(!!e.target.value.trim());
      },
      readonly: !editable
    }), /*#__PURE__*/React.createElement("div", {
      className: "comment-actions"
    }, /*#__PURE__*/React.createElement("button", {
      className: "chakra-secondary-button ".concat(!hasText ? "disabled" : ""),
      onClick: handleCancelClick
    }, "Cancel"), /*#__PURE__*/React.createElement("button", {
      className: "chakra-primary-button ".concat(!hasText ? "disabled" : ""),
      onClick: handleSaveClick
    }, "Save")), /*#__PURE__*/React.createElement("div", {
      className: "comment-filter"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return handleFilterClick("comments");
      },
      className: "chakra-secondary-button ".concat(selectedFilter === "comments" ? "active" : "")
    }, selectedFilter === "comments" && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeCheckSVG20",
      svgIconSize: "20",
      svgIconClass: "left-arrow"
    }), "Comments"), /*#__PURE__*/React.createElement("button", {
      onClick: function onClick() {
        return handleFilterClick("all");
      },
      className: "chakra-secondary-button ".concat(selectedFilter === "all" ? "active" : "")
    }, selectedFilter === "all" && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeCheckSVG20",
      svgIconSize: "20"
    }), "All")));
  });
  UserActivityComment.displayName = "UserActivityComment";

  var userActivityCommentFormatter = function userActivityCommentFormatter(activity) {
    var inner;
    inner = /*#__PURE__*/React.createElement("span", {
      className: "activity-readout"
    }, activity === null || activity === void 0 ? void 0 : activity.username, " ", /*#__PURE__*/React.createElement("span", null, "added comment ", /*#__PURE__*/React.createElement("b", null, activity.message)));
    return /*#__PURE__*/React.createElement("span", {
      className: "activity-item"
    }, inner, /*#__PURE__*/React.createElement("span", {
      className: "activity-timestamp"
    }, activity.timestamp ? uiCommon.cmxDateTime.format(activity.timestamp, uiCommon.cmxDateTime.FORMATS.LONG_DATE_TIME) : 'N/A'));
  };
  var cqaUserActivityFormatter = function cqaUserActivityFormatter(activity) {
    var date = new Date(activity.timestamp);
    uiCommon.cmxDateTime.formatDateWithComma(date);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        marginTop: '5px'
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "tile-title"
    }, activity === null || activity === void 0 ? void 0 : activity.coder_fullName, " ", /*#__PURE__*/React.createElement("span", null, "added comment ", /*#__PURE__*/React.createElement("b", null, activity.note_content))), /*#__PURE__*/React.createElement("span", {
      className: "cqa-activity-timestamp"
    }, activity.timestamp ? uiCommon.cmxDateTime.format(activity.timestamp, uiCommon.cmxDateTime.FORMATS.LONG_DATE_TIME) : 'N/A', ' ', "| ".concat(activity.coder_username)));
  };

  var ActivityType = /*#__PURE__*/function (ActivityType) {
    ActivityType["USER"] = "USER";
    ActivityType["SYSTEM"] = "SYSTEM";
    ActivityType["CQA"] = "CQA";
    ActivityType["USER_ACTIVITY_COMMENTS"] = "USER_ACTIVITY_COMMENTS";
    ActivityType["CQA_CODER_COMMENT"] = "CQA_CODER_COMMENT";
    return ActivityType;
  }(ActivityType || {});
  var Timeline = function Timeline(_ref) {
    var allItems = _ref.items,
      enableUserActivityComments = _ref.enableUserActivityComments,
      editable = _ref.editable;
    var _React$useState = React.useState("all"),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filter = _React$useState2[0],
      setFilter = _React$useState2[1];
    var filteredSourceItems = React.useMemo(function () {
      if (filter === "all") return allItems;
      return allItems.filter(function (item) {
        var type = item.activityType || item.type || "";
        return typeof type === "string" && (type === ActivityType.USER_ACTIVITY_COMMENTS || type === ActivityType.CQA_CODER_COMMENT);
      });
    }, [allItems, filter]);
    var raw = React.useMemo(function () {
      return uiCommon.activity.convertActivityToTimeline(filteredSourceItems, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ActivityType.USER, userActivityFormatter), ActivityType.SYSTEM, systemActivityFormatter), ActivityType.CQA, cqaActivityFormatter), ActivityType.USER_ACTIVITY_COMMENTS, userActivityCommentFormatter), ActivityType.CQA_CODER_COMMENT, cqaUserActivityFormatter));
    }, [filteredSourceItems]);
    if ((raw === null || raw === void 0 ? void 0 : raw.length) === 0 && !enableUserActivityComments) {
      return /*#__PURE__*/React.createElement("div", {
        className: "empty-message"
      }, "No activity.");
    }
    var items = raw.map(function (item, itemIdx) {
      var tiles = item.tiles.map(function (tile, idx) {
        var _tile$titles;
        var subTitle = tile.subtitle ? /*#__PURE__*/React.createElement("p", {
          className: "tile-subtitle"
        }, "On ", tile.subtitle, ":") : false;
        var titles = !((_tile$titles = tile.titles) !== null && _tile$titles !== void 0 && _tile$titles.length) ? false : tile.titles.map(function (title, titleIdx) {
          return /*#__PURE__*/React.createElement("p", {
            key: titleIdx,
            className: "tile-title"
          }, title);
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "tile",
          key: idx
        }, /*#__PURE__*/React.createElement("div", {
          className: "tile-content"
        }, subTitle, titles));
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "timeline-item",
        "data-testid": "timeline-item-".concat(itemIdx),
        key: itemIdx
      }, /*#__PURE__*/React.createElement("div", {
        className: "timeline-left"
      }, /*#__PURE__*/React.createElement("a", {
        className: "timeline-icon"
      })), /*#__PURE__*/React.createElement("div", {
        className: "timeline-content"
      }, tiles));
    });

    // Handle filter changes from Comment component
    var handleFilterChange = function handleFilterChange(selected) {
      setFilter(selected);
    };
    return /*#__PURE__*/React.createElement(React.Fragment, null, enableUserActivityComments && /*#__PURE__*/React.createElement(UserActivityComment, {
      onFilterChange: handleFilterChange,
      editable: editable
    }), /*#__PURE__*/React.createElement("div", {
      className: "cmx-timeline timeline"
    }, /*#__PURE__*/React.createElement("div", {
      className: "timeline-meta"
    }, browserDetectionExports.isIe11() ? 'All times listed in UTC' : 'All times listed are in your timezone'), items));
  };
  Timeline.displayName = 'Timeline';

  function CodeSources(_ref) {
    var diagnoses = _ref.diagnoses,
      modifiers = _ref.modifiers,
      procedures = _ref.procedures,
      title = _ref.title;
    return /*#__PURE__*/React.createElement("div", {
      className: "code-source"
    }, /*#__PURE__*/React.createElement("div", {
      className: "code-source-heading"
    }, /*#__PURE__*/React.createElement("span", {
      className: "code-source-heading-text"
    }, title)), /*#__PURE__*/React.createElement("div", {
      className: "code-sections"
    }, /*#__PURE__*/React.createElement("div", {
      className: "procedures-and-modifiers-section"
    }, procedures && procedures.map(function (procedureRowEntry) {
      var _procedureRowEntry$pr, _procedureRowEntry$te;
      return /*#__PURE__*/React.createElement("div", {
        className: "procedure-and-technical-code",
        key: "".concat((_procedureRowEntry$pr = procedureRowEntry.procedure) === null || _procedureRowEntry$pr === void 0 ? void 0 : _procedureRowEntry$pr.code, "-").concat((_procedureRowEntry$te = procedureRowEntry.technicalCode) === null || _procedureRowEntry$te === void 0 ? void 0 : _procedureRowEntry$te.code)
      }, procedureRowEntry.procedure && /*#__PURE__*/React.createElement("div", {
        className: "code-source-units"
      }, procedureRowEntry.procedure.units), procedureRowEntry.procedure && /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
        key: procedureRowEntry.procedure.code,
        code: procedureRowEntry.procedure.code,
        codeType: 'procedure',
        editable: false,
        sequence: null,
        handleCodeDelete: null,
        isDraggable: false,
        onDrop: null
      }), procedureRowEntry.technicalCode && procedureRowEntry.displayTechnicalCodeUnits && /*#__PURE__*/React.createElement("div", {
        className: "code-source-units"
      }, procedureRowEntry.technicalCode.units), procedureRowEntry.technicalCode && /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
        key: procedureRowEntry.technicalCode.code,
        code: procedureRowEntry.technicalCode.code,
        codeType: 'procedure',
        editable: false,
        sequence: null,
        handleCodeDelete: null,
        isDraggable: false,
        onDrop: null
      }));
    }), modifiers && modifiers.map(function (modifier) {
      return /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
        key: modifier.code,
        code: modifier.code,
        codeType: 'modifier',
        editable: false,
        sequence: null,
        handleCodeDelete: null,
        isDraggable: false,
        onDrop: null
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "diagnoses-section"
    }, diagnoses && diagnoses.map(function (diagnosis) {
      return /*#__PURE__*/React.createElement(uiComponents.MedicalCodeChip, {
        key: diagnosis.code,
        code: diagnosis.code,
        codeType: 'diagnosis',
        editable: false,
        sequence: null,
        handleCodeDelete: null,
        isDraggable: false,
        onDrop: null
      });
    }))));
  }

  function ownKeys$n(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$n(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$n(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$n(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var INVOICES_SORT_ORDER = {
    CLINICAL: 1,
    MAPPED: 2,
    PREDICTION: 3,
    PREDICTION_COMPONENT: 4,
    ASSEMBLED: 5,
    CODED: 6,
    PROCESSED: 7,
    SUBMITTED: 8
  };
  function buildInvoiceSourceHeader(invoiceType) {
    if (!invoiceType) {
      return '';
    }
    if (invoiceType in AmplifyInvoiceSourceHeader) {
      return AmplifyInvoiceSourceHeader[invoiceType];
    } else if (invoiceType in ArtifactTypes) {
      return ArtifactTypes[invoiceType];
    }
    return "From ".concat(invoiceType[0].toUpperCase() + invoiceType.slice(1).toLowerCase());
  }
  function buildCodeSourceHeader(invoiceType, sequenceNumber) {
    if (!invoiceType) {
      return '';
    }
    if (invoiceType === InvoiceTypes.ASSEMBLED) {
      return "Transaction ".concat(sequenceNumber);
    } else if (invoiceType in AmplifyCodeSourceHeader) {
      return AmplifyCodeSourceHeader[invoiceType];
    }
    return '';
  }
  function InvoiceSources(_ref) {
    var invoices = _ref.invoices;
    if (!invoices || invoices.length === 0) {
      return /*#__PURE__*/React.createElement("span", null, "No code sources available.");
    }
    // Normalize invoice types to uppercase for consistent sorting and header display
    var normalizedInvoices = invoices.map(function (inv) {
      var _inv$type;
      return _objectSpread$n(_objectSpread$n({}, inv), {}, {
        type: (_inv$type = inv.type) === null || _inv$type === void 0 ? void 0 : _inv$type.toUpperCase()
      });
    });
    var invoicesSorted = _toConsumableArray(normalizedInvoices).sort(function (inv1, inv2) {
      return INVOICES_SORT_ORDER[inv1.type] - INVOICES_SORT_ORDER[inv2.type];
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "invoice-sources-tab"
    }, invoicesSorted.map(function (invoice) {
      return /*#__PURE__*/React.createElement("div", {
        className: "invoice-source",
        key: invoice.id,
        id: invoice.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "invoice-type-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "invoice-type"
      }, buildInvoiceSourceHeader(invoice.type)), invoice.type === InvoiceTypes.CLINICAL && /*#__PURE__*/React.createElement("div", {
        className: "clinical-source-provider"
      }, invoice.performingProviderName)), invoice.transactions.map(function (transaction, index) {
        return /*#__PURE__*/React.createElement(CodeSources, {
          key: transaction.id,
          title: buildCodeSourceHeader(invoice.type, index + 1),
          diagnoses: transaction.diagnoses,
          modifiers: transaction.modifiers,
          procedures: transaction.procedures
        });
      }));
    }));
  }

  /**
   * Utility to transform various invoice types into invoice-sources component.
   */

  function invoiceAPInvoicesToInvoiceSources(invoices) {
    if (!invoices || invoices.length === 0) {
      return /*#__PURE__*/React.createElement("span", null, "No code sources available.");
    }
    var invoiceHasCodes = function invoiceHasCodes(invoice) {
      var _invoice$transactions;
      return (_invoice$transactions = invoice.transactions) === null || _invoice$transactions === void 0 ? void 0 : _invoice$transactions.some(function (transaction) {
        var _transaction$diagnose, _transaction$modifier;
        return ((_transaction$diagnose = transaction.diagnoses) === null || _transaction$diagnose === void 0 ? void 0 : _transaction$diagnose.length) > 0 || (transaction === null || transaction === void 0 ? void 0 : transaction.procedure) != null || ((_transaction$modifier = transaction.modifiers) === null || _transaction$modifier === void 0 ? void 0 : _transaction$modifier.length) > 0;
      });
    };

    // Type assertion to handle the union type properly
    var filteredInvoices = invoices.filter(function (invoice) {
      return invoiceHasCodes(invoice);
    });
    return /*#__PURE__*/React.createElement(InvoiceSources, {
      invoices: filteredInvoices.map(function (invoice) {
        var _invoice$transactions2;
        return {
          id: invoice.guid,
          type: invoice.type,
          performingProviderName: invoice.performing_provider_name,
          transactions: (_invoice$transactions2 = invoice.transactions) === null || _invoice$transactions2 === void 0 ? void 0 : _invoice$transactions2.map(function (transaction) {
            var _transaction$diagnose2, _transaction$modifier2;
            return {
              id: transaction.guid,
              diagnoses: (_transaction$diagnose2 = transaction.diagnoses) === null || _transaction$diagnose2 === void 0 ? void 0 : _transaction$diagnose2.map(function (diagnosis) {
                return {
                  code: diagnosis.diagnosis_code
                };
              }),
              modifiers: (_transaction$modifier2 = transaction.modifiers) === null || _transaction$modifier2 === void 0 ? void 0 : _transaction$modifier2.map(function (modifier) {
                return {
                  code: modifier.modifier_code
                };
              }),
              procedures: [
              // Amplify will contain 1 procedure
              {
                displayTechnicalCodeUnits: !transaction.procedure,
                procedure: transaction.procedure ? {
                  code: transaction.procedure.procedure_code,
                  units: transaction.procedure.units
                } : null,
                technicalCode: transaction.technical_code ? {
                  code: transaction.technical_code.code,
                  units: transaction.technical_code.units
                } : null
              }]
            };
          })
        };
      })
    });
  }

  function ownKeys$m(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$m(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$m(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$m(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$i(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$i() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$i() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$i = function _isNativeReflectConstruct() { return !!t; })(); }
  var CaseAccessState$1 = uiCommon.commonEnums.CaseAccessState;
  var completeSet = uiCommon.cmxArtifacts.artifactSets.completeSet,
    isSingleSelection = uiCommon.cmxArtifacts.isSingleSelection,
    getFeatureForSelection = uiCommon.cmxArtifacts.getFeatureForSelection,
    isMultipleSelection = uiCommon.cmxArtifacts.isMultipleSelection;
  var expandedProps = new Set(['procedure_type', 'ordering_provider_name', 'ordering_provider_number.number', 'order_number.number', 'date_of_service', 'place_of_service', 'tenant_name', 'billing_provider_name', 'billing_provider_number.number', 'visit_number.number', 'case_id']);
  var expandedAmplifyProps = new Set(['accession', 'exam_code', 'exam_description', 'reason_for_visit']);
  var getStatusTimestamp = function getStatusTimestamp(caseRun, stages) {
    if (caseRun.case_completed_datetime) {
      return uiCommon.cmxDateTime.format(caseRun.case_completed_datetime, uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    if (stages.length) {
      var _stage$displayDate$ra;
      var stage = _toConsumableArray(stages).reverse().pop();
      return uiCommon.cmxDateTime.format((_stage$displayDate$ra = stage === null || stage === void 0 ? void 0 : stage.displayDate.raw) !== null && _stage$displayDate$ra !== void 0 ? _stage$displayDate$ra : new Date(), uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE);
    }
    return 'N/A';
  };
  var isCaseAvailable$1 = function isCaseAvailable(caseAccessState) {
    return caseAccessState === CaseAccessState$1.NONE || caseAccessState === CaseAccessState$1.ACQUIRED;
  };
  var conditionalUtils$5 = uiCommon.AmplifyCore.conditionalUtils;
  var CaseDetailv2 = /*#__PURE__*/function (_React$Component) {
    function CaseDetailv2(props) {
      var _this;
      _classCallCheck(this, CaseDetailv2);
      _this = _callSuper$i(this, CaseDetailv2, [props]);
      _defineProperty(_this, "_artifactRef", void 0);
      _defineProperty(_this, "_noteRef", void 0);
      _defineProperty(_this, "_patientRef", void 0);
      _defineProperty(_this, "noteRefs", {});
      _this._handleToggleClick = _this._handleToggleClick.bind(_this);
      _this._onFeatureSelection = _this._onFeatureSelection.bind(_this);
      _this._handleOpenJson = _this._handleOpenJson.bind(_this);
      _this._handleProcessIdChange = _this._handleProcessIdChange.bind(_this);
      _this._handleGroupedCaseClick = _this._handleGroupedCaseClick.bind(_this);
      _this._handlePatientExpansion = _this._handlePatientExpansion.bind(_this);
      _this.onFeatureActivation = _this.onFeatureActivation.bind(_this);
      var showAllArtifacts = completeSet.size === props.artifactSet.size;
      _this._artifactRef = /*#__PURE__*/React.createRef();
      _this._noteRef = /*#__PURE__*/React.createRef();
      _this._patientRef = /*#__PURE__*/React.createRef();
      _this.props.setActiveNote(_this.props.notes[0]);
      _this.state = {
        expandEncounter: false,
        openClaims: [],
        backHover: false,
        showAllArtifacts: showAllArtifacts,
        expandDemographicsPanel: props.demographicsPanelVisibility === 'open' || props.demographicsPanelVisibility === undefined,
        demographicsLocation: props.demographicsPanelLocation || 'right'
      };
      return _this;
    }
    _inherits(CaseDetailv2, _React$Component);
    return _createClass(CaseDetailv2, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this$props$match;
        // CQA-UI: hide side nav bar
        this.props.hideSideNavBar();
        var _ref = (_this$props$match = this.props.match) !== null && _this$props$match !== void 0 ? _this$props$match : {},
          _ref$params = _ref.params,
          params = _ref$params === void 0 ? {} : _ref$params;
        if (this.props.mode !== 'code-edit') {
          this.props.onNavigate(params.id, true, params.serviceLine, this.props.tenantId, this.props.hasAmplifyCaseRunV2Access);
        }
        return;
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;
        this.props.notes.forEach(function (note) {
          _this2.noteRefs[note.document_id] = /*#__PURE__*/React.createRef();
        });

        // Update demographics expansion when preference changes
        if (prevProps.demographicsPanelVisibility !== this.props.demographicsPanelVisibility) {
          this.setState({
            expandDemographicsPanel: this.props.demographicsPanelVisibility === 'open'
          });
        }
      }
    }, {
      key: "_handleGroupedCaseClick",
      value: function _handleGroupedCaseClick(ev) {
        var _this$props$match2;
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item) return;
        var caseId = item.value;
        if (!caseId) return;
        // assume all grouped cases will be in the same service line
        var _ref2 = (_this$props$match2 = this.props.match) !== null && _this$props$match2 !== void 0 ? _this$props$match2 : {},
          _ref2$params = _ref2.params,
          params = _ref2$params === void 0 ? {} : _ref2$params;
        this.props.onNavigate(caseId, undefined, params.serviceLine, this.props.tenantId, this.props.hasAmplifyCaseRunV2Access);
      }
    }, {
      key: "_onFeatureSelection",
      value: function _onFeatureSelection(selection) {
        if (selection.display) {
          if (isMultipleSelection(selection)) {
            var _document$querySelect;
            var spanSelector = ".qa-".concat(selection.code.uuid);
            var targetElement = (_document$querySelect = document.querySelector(spanSelector)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.closest('.accordion-section');
            if (targetElement) {
              var _this$_artifactRef;
              (_this$_artifactRef = this._artifactRef) === null || _this$_artifactRef === void 0 || (_this$_artifactRef = _this$_artifactRef.current) === null || _this$_artifactRef === void 0 || _this$_artifactRef.scrollToElement(targetElement);
            }
          } else if (isSingleSelection(selection)) {
            var feature = getFeatureForSelection(selection);
            var inExpanded = expandedProps.has(feature.field);
            this._patientRef.current.expandEncounter(inExpanded);
            if (inExpanded) {
              var state = _objectSpread$m(_objectSpread$m({}, this.state), {}, {
                expandEncounter: true
              });
              this.setState(state);
            } else if (feature.field === 'raw_body') {
              var _feature$spans = _slicedToArray(feature.spans, 1),
                selectedSpan = _feature$spans[0];
              var _spanSelector = ".span-".concat(selectedSpan.uuid);
              var _targetElement = document.querySelector(_spanSelector);
              if (_targetElement) {
                var _this$_noteRef;
                (_this$_noteRef = this._noteRef) === null || _this$_noteRef === void 0 || (_this$_noteRef = _this$_noteRef.current) === null || _this$_noteRef === void 0 || _this$_noteRef.scrollToElement(_targetElement);
              }
            }
          }
        }
        this.props.onFeatureSelection(selection);
      }
    }, {
      key: "onFeatureActivation",
      value: function onFeatureActivation(selection) {
        // only pop open the accordion for active selections
        if (!selection.selectionState.active && selection.evidence.length === 1) {
          var state = _objectSpread$m({}, this.state);
          var _selection$evidence = _slicedToArray(selection.evidence, 1),
            firstEvidence = _selection$evidence[0];
          var claimMatcher = function claimMatcher(claim) {
            return !(claim.fieldIdentifier === firstEvidence.fieldIdentifier && claim.fieldName === firstEvidence.fieldName);
          };
          state.openClaims = state.openClaims.filter(claimMatcher);
          state.expandEncounter = state.openClaims.length > 0;
          this.setState(state);
          this._patientRef.current.expandEncounter(state.expandEncounter);
        } else if (selection.selectionState.active) {
          var _selection$evidence2 = _slicedToArray(selection.evidence, 1),
            selectedSpan = _selection$evidence2[0];
          var fieldName = selectedSpan.fieldName;
          if (fieldName === 'body') {
            var spanSelector = ".span-".concat(selectedSpan.hash);
            var targetElement = document.querySelector(spanSelector);
            if (targetElement) {
              var _this$_noteRef2;
              (_this$_noteRef2 = this._noteRef) === null || _this$_noteRef2 === void 0 || (_this$_noteRef2 = _this$_noteRef2.current) === null || _this$_noteRef2 === void 0 || _this$_noteRef2.scrollToElement(targetElement);
            }
          } else {
            var inExpanded = new Set([].concat(_toConsumableArray(expandedProps), _toConsumableArray(expandedAmplifyProps))).has(fieldName);
            if (inExpanded) {
              var _state = _objectSpread$m(_objectSpread$m({}, this.state), {}, {
                expandEncounter: true
              });
              _state.openClaims = [].concat(_toConsumableArray(_state.openClaims), [{
                fieldIdentifier: selectedSpan.fieldIdentifier,
                fieldName: selectedSpan.fieldName
              }]);
              this.setState(_state);
              this._patientRef.current.expandEncounter(_state.expandEncounter);
            }
          }
        }
        this.props.onFeatureActivation(selection);
      }
    }, {
      key: "_handlePatientExpansion",
      value: function _handlePatientExpansion(isOpen) {
        this.setState(_objectSpread$m(_objectSpread$m({}, this.state), {}, {
          expandEncounter: isOpen
        }));
      }
    }, {
      key: "_handleToggleClick",
      value: function _handleToggleClick(event) {
        event.preventDefault();
        var showAllArtifacts = !this.state.showAllArtifacts;
        this.props.toggleArtifacts(showAllArtifacts);
        this.setState(_objectSpread$m(_objectSpread$m({}, this.state), {}, {
          showAllArtifacts: showAllArtifacts
        }));
      }
    }, {
      key: "_handleOpenJson",
      value: function _handleOpenJson(event) {
        var _event$currentTarget;
        event.preventDefault();
        var activeItem = this.props.activeItem;
        var serviceLineConfig = uiCommon.appServiceLines.determineServiceLineConfig({
          name: activeItem.service_line,
          caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
        });
        var caseId = serviceLineConfig.caseIdProp in activeItem ? activeItem[serviceLineConfig.caseIdProp] : activeItem.case_id;
        var isStandalone = this.props.activeItem.case_type === uiCommon.commonEnums.UIModesEnum.STANDALONE;
        var params = {
          caseId: caseId
        };
        var target = (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.closest('.icon-button');
        if (target && this.props.activeItem.case_id) {
          var _validTarget$dataset$, _this$props$match$par, _this$props$match3;
          var validTarget = target;
          var href = "".concat((_validTarget$dataset$ = validTarget === null || validTarget === void 0 ? void 0 : validTarget.dataset.href) !== null && _validTarget$dataset$ !== void 0 ? _validTarget$dataset$ : '');
          var base;
          params.processInstanceId = this.props.activeItem.process_instance_id;
          params.serviceLine = (_this$props$match$par = (_this$props$match3 = this.props.match) === null || _this$props$match3 === void 0 || (_this$props$match3 = _this$props$match3.params) === null || _this$props$match3 === void 0 ? void 0 : _this$props$match3.serviceLine) !== null && _this$props$match$par !== void 0 ? _this$props$match$par : '';
          if (href.indexOf('import-amplify') !== -1) {
            this.props.onCaseAction({
              action: 'import-amplify',
              caseRun: this.props.activeItem,
              caseOrganizationContext: this.props.caseOrganizationContext
            });
          } else if (href.indexOf('launch-amplify') !== -1 && isStandalone) {
            // STANDALONE case same window
            var _serviceLineConfig = uiCommon.appServiceLines.determineServiceLineConfig({
              name: this.props.activeItem.service_line,
              caseIdentifier: "".concat(activeItem.case_uid || activeItem.case_id)
            });
            var _caseId = _serviceLineConfig.caseIdProp in activeItem ? activeItem[_serviceLineConfig.caseIdProp] : activeItem.case_id;
            if (this.props.loadAllPatientDetailOptions) {
              this.props.loadAllPatientDetailOptions(this.props.tenantId, this.props.activeItem.facility);
            }
            // CQA-UI: pass hasAmplifyCaseRunV2Access argument to openAmplifyCase
            this.props.openAmplifyCase({
              serviceLine: this.props.activeItem.service_line,
              caseId: _caseId,
              id: this.props.activeItem.process_instance_guid,
              hasAmplifyCaseRunV2Access: this.props.hasAmplifyCaseRunV2Access
            });
          } else {
            //Dashboard Icon Button Menu
            params.managed = true;
            if (href.indexOf('bpm-steps') !== -1) {
              base = bpmStepsPopup;
              params.processInstanceId = this.props.activeItem.process_instance_id;
            } else if (href.indexOf('json-view') !== -1) {
              base = caseDetailPopup;
            } else if (href.indexOf('launch-amplify') !== -1) {
              // PLAYGROUND case new window

              base = launchAmplifyPopup;
              params.launchpoint = 'Automate';
              params.processInstanceGuid = this.props.activeItem.process_instance_guid;
              params.processInstanceGuids = this.props.items.map(function (item) {
                return "".concat(item.case_id, ":").concat(item.process_instance_guid);
              }).join(',');
            } else if (href.indexOf('case-documents') != -1) {
              base = caseDocumentsPopup;
            }
            this.props.openChildWindow(_objectSpread$m(_objectSpread$m({}, base), {}, {
              params: params
            }));
          }
        }
      }
    }, {
      key: "_handleProcessIdChange",
      value: function _handleProcessIdChange(event) {
        event.preventDefault();
        var target = event.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-process-id');
        if (!item) return;
        var processId = parseInt(item.value);
        if (!processId) return;
        var caseRuns = Object.values(this.props.caseRuns).flat();
        var soughtRun = caseRuns.find(function (caseRun) {
          return caseRun.process_instance_id === processId;
        });
        if (!soughtRun) return;
        this.props.setActiveProcess({
          caseRun: soughtRun,
          serviceLine: this.props.serviceLine
        });
      }
    }, {
      key: "handleDemographicsPanelClick",
      value: function handleDemographicsPanelClick(ev) {
        ev.preventDefault();
        this.setState({
          expandDemographicsPanel: !this.state.expandDemographicsPanel
        });
      }
    }, {
      key: "handleDemographicsLocationClick",
      value: function handleDemographicsLocationClick(ev, location) {
        ev.preventDefault();
        this.setState({
          demographicsLocation: location,
          userChangedLocation: true
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this,
          _this$props$match4,
          _this$props$propertyC,
          _this$props$propertyC2,
          _dataItem$artifacts$l,
          _dataItem$artifacts,
          _this$props2,
          _this$props3,
          _this$props$capabilit,
          _this$props$capabilit2,
          _this$props$context;
        var _this$props = this.props,
          artifactLoadState = _this$props.artifactLoadState;
          _this$props.artifactSet;
          var activeItem = _this$props.activeItem;
          _this$props.codeEdits;
          var loadState = _this$props.loadState,
          notes = _this$props.notes,
          artifactList = _this$props.artifactList;
          _this$props.codeDescriptions;
          var formErrors = _this$props.formErrors,
          groupedCases = _this$props.groupedCases,
          caseRuns = _this$props.caseRuns,
          roles = _this$props.roles,
          stages = _this$props.stages,
          codeEditingPanel = _this$props.codeEditingPanel,
          propertyConfig = _this$props.propertyConfig,
          activations = _this$props.activations,
          simplifiedInvoices = _this$props.simplifiedInvoices,
          caseEdits = _this$props.caseEdits,
          organization = _this$props.organization,
          capability = _this$props.capability,
          mode = _this$props.mode;
          _this$props.htmlNotes;
          _this$props.noteUnavailableReason;
          var documentMetadata = _this$props.documentMetadata,
          updateValue = _this$props.updateValue,
          updateCase = _this$props.updateCase,
          setActiveNote = _this$props.setActiveNote;
          _this$props.processInstance;
          var activeNote = _this$props.activeNote,
          flagList = _this$props.flagList,
          coderNotesCapability = _this$props.coderNotesCapability,
          displayTopLeftPatientInfo = _this$props.displayTopLeftPatientInfo,
          workItem = _this$props.workItem,
          enableUserActivityComments = _this$props.enableUserActivityComments;
        var onVerticalMiniTabSelection = function onVerticalMiniTabSelection(selection) {
          _this3.props.setActiveVerticalMiniTab(selection.displayName);
        };
        var onDocumentSelect = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(doc) {
            var noteRef, newActiveNote;
            return _regeneratorRuntime.wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  noteRef = _this3.noteRefs[doc.documentId];
                  requestAnimationFrame(function () {
                    var _noteRef$current;
                    return noteRef === null || noteRef === void 0 || (_noteRef$current = noteRef.current) === null || _noteRef$current === void 0 ? void 0 : _noteRef$current.scrollIntoView({
                      behavior: 'smooth',
                      block: 'start',
                      // Sets vertical alignment
                      inline: 'nearest' //Sets horizontal alignment
                    });
                  });
                  newActiveNote = notes.find(function (note) {
                    return note.document_id === doc.documentId;
                  });
                  if (newActiveNote) {
                    setActiveNote(newActiveNote);
                  }
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return function onDocumentSelect(_x) {
            return _ref3.apply(this, arguments);
          };
        }();
        var _this$state = this.state,
          expandEncounter = _this$state.expandEncounter;
          _this$state.openClaims;
          var actionBar = this.props.actionBar;
        // at the moment we only support a single case run
        var dataItem = activeItem;
        var _ref4 = (_this$props$match4 = this.props.match) !== null && _this$props$match4 !== void 0 ? _this$props$match4 : {},
          _ref4$params = _ref4.params,
          params = _ref4$params === void 0 ? {} : _ref4$params;
        var prop = propAccessor2(dataItem, activations.property);
        var noteStyle;
        var showLoading = loadState.loading || loadState.initial;
        if (showLoading) {
          noteStyle = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            numberItems: 30
          }));
        } else {
          noteStyle = /*#__PURE__*/React.createElement(Notes, {
            notes: notes,
            noteRefs: this.noteRefs
          });
        }

        /** Start Patient details logic */
        var fieldEditorInfo = {
          caseEdits: caseEdits,
          organization: organization,
          updateValue: updateValue,
          updateCase: updateCase
        };
        var cellMaker = CellMaker(prop, this.props.activeItem, fieldEditorInfo, null);
        var cellPatientMaker = CellPatientMaker(prop, this.props.activeItem);

        // all info less last item
        var patientConfigDetails = (_this$props$propertyC = this.props.propertyConfig) === null || _this$props$propertyC === void 0 || (_this$props$propertyC = _this$props$propertyC.patient) === null || _this$props$propertyC === void 0 ? void 0 : _this$props$propertyC.slice(0, ((_this$props$propertyC2 = this.props.propertyConfig) === null || _this$props$propertyC2 === void 0 || (_this$props$propertyC2 = _this$props$propertyC2.patient) === null || _this$props$propertyC2 === void 0 ? void 0 : _this$props$propertyC2.length) - 1);
        var patientLastItem = this.props.propertyConfig.patient.slice(-1);

        // add hr less the last one item
        patientConfigDetails = patientConfigDetails.map(function (patient, index) {
          return _objectSpread$m(_objectSpread$m({}, patient), {}, {
            addHr: index + 1 !== patientConfigDetails.length
          });
        });
        var topCells = patientConfigDetails.map(cellPatientMaker);
        var topRightCell = patientLastItem.map(cellMaker);

        /** End Patient details logic */

        var statusTimestamp = getStatusTimestamp(dataItem, stages);
        var loadingClasses = [{
          'loading-card': showLoading
        }];
        var rawArtifactLength = (_dataItem$artifacts$l = (_dataItem$artifacts = dataItem.artifacts) === null || _dataItem$artifacts === void 0 ? void 0 : _dataItem$artifacts.length) !== null && _dataItem$artifacts$l !== void 0 ? _dataItem$artifacts$l : 0;
        var displayedArtifactLength = artifactList.length;
        var userIsCoder = uiCommon.userUtils.isCoder(roles);
        var codeEditMode = this.props.mode === uiCommon.commonEnums.CaseDetailMode.EDIT;
        var multipleArtifacts = false;
        if (!userIsCoder) {
          if (simplifiedInvoices && simplifiedInvoices.length) {
            multipleArtifacts = simplifiedInvoices.length > 0;
          } else {
            multipleArtifacts = rawArtifactLength > displayedArtifactLength || rawArtifactLength > 0;
          }
        }
        var caseDetailClasses = ['case-detailv2', 'simple-layout', "demographics-".concat(this.state.demographicsLocation), "case-".concat(this.props.mode, "-mode"), {
          'multiple-artifacts': multipleArtifacts,
          'encounter-expanded': expandEncounter,
          'case-detail-loading': showLoading,
          'demographics-open': this.state.expandDemographicsPanel,
          'demographics-closed': !this.state.expandDemographicsPanel
        }];

        //History of code automation
        var artifactListClasses = ['automation-container'].concat(loadingClasses);
        var artifactToggle = /*#__PURE__*/React.createElement("div", {
          className: "info-cell"
        }, "codes \xA0", /*#__PURE__*/React.createElement("span", {
          className: "artifact-toggle"
        }, userIsCoder ? /*#__PURE__*/React.createElement("span", null) : /*#__PURE__*/React.createElement("span", null, "(", /*#__PURE__*/React.createElement("a", {
          className: "qa-artifact-toggle",
          onClick: this._handleToggleClick,
          href: "#toggle-artifacts"
        }, this.state.showAllArtifacts ? "show summary" : "show all"), ")")));
        var preGoLive = uiCommon.caseUtils.isPreGoLive(activeItem);
        "".concat(prop('patient_identifier.issuer', 'SRC N/A'), ": ").concat(prop('patient_identifier.number'));
        "".concat(prop('primary_clinical_identifier.number'), " src: (").concat(prop('primary_clinical_identifier.issuer'), ")");
        var providerComments = Array.from(new Set(// get unique comments with a set
        (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.activeItem) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.invoices) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.find(function (invoice) {
          return invoice.type === uiCommon.commonEnums.CaseArtifactTypes.ASSEMBLED;
        }) // just the ASSEMBLED invoice
        ) === null || _this$props2 === void 0 ? void 0 : _this$props2.transactions.map(function (transaction) {
          var _transaction$custom_v;
          return transaction === null || transaction === void 0 || (_transaction$custom_v = transaction.custom_values) === null || _transaction$custom_v === void 0 ? void 0 : _transaction$custom_v.comment;
        }) // get comments for all transactions
        .filter(Boolean) // remove undefined/null comments
        ));
        if (this.props.mode === 'dashboard' && !actionBar) {
          actionBar = /*#__PURE__*/React.createElement(DashboardActionBar, {
            actionsState: this.props.actionsState,
            caseRun: this.props.activeItem,
            handleOpenJson: this._handleOpenJson,
            handleProcessIdChange: this._handleProcessIdChange,
            handleBackClick: this.props.handleBackClick,
            caseRuns: caseRuns
          });
        }
        var charges = Array.isArray(simplifiedInvoices) ? simplifiedInvoices.map(function (invoice, idx) {
          var _this3$props$capabili;
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "invoice-item-group"
          }, invoice.meta ? /*#__PURE__*/React.createElement(InvoiceMetaHeading, {
            meta: invoice.meta,
            onImportClick: _this3._handleGroupedCaseClick
          }) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(Invoice, {
            panelActivations: activations.panel,
            onFeatureSelection: _this3.onFeatureActivation,
            simplifiedInvoice: invoice,
            editable: false,
            transactionV2: conditionalUtils$5.capabilityValue((_this3$props$capabili = _this3.props.capabilities) === null || _this3$props$capabili === void 0 || (_this3$props$capabili = _this3$props$capabili.capabilities) === null || _this3$props$capabili === void 0 || (_this3$props$capabili = _this3$props$capabili.transactionV2) === null || _this3$props$capabili === void 0 ? void 0 : _this3$props$capabili.on)
          }));
        }) : false;
        var shouldShowAddAttachDocsButton = conditionalUtils$5.capabilityValue(this === null || this === void 0 || (_this$props3 = this.props) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.capabilities) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.capabilities) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.attachDocs) === null || _this$props3 === void 0 ? void 0 : _this$props3.on) && this.props.UIView === uiCommon.commonEnums.UIViewEnum.AMPLIFY && this.props.UIMode === uiCommon.commonEnums.UIModesEnum.STANDALONE && uiCommon.appServiceLines.isIPC(activeItem.service_line) && this.props.editable;
        var showImprovementsCapability = codeEditMode && conditionalUtils$5.capabilityValue((_this$props$capabilit = this.props.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.improvements) === null || _this$props$capabilit === void 0 ? void 0 : _this$props$capabilit.on);
        var tabsItems = [{
          id: 'Notes',
          displayName: 'Notes',
          active: this.props.activeVerticalMiniTab === uiCommon.commonEnums.MiniTabLabels.NOTES_LABEL,
          body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
            className: "provider-comments-section"
          }, providerComments.length > 0 && providerComments.map(function (comment, index) {
            return /*#__PURE__*/React.createElement("div", {
              className: "provider-comments",
              key: "provider-comment-".concat(index)
            }, /*#__PURE__*/React.createElement("div", {
              className: "provider-comments-icon"
            }, /*#__PURE__*/React.createElement(r, {
              iconName: e.Comments,
              titleText: "Provider Comments"
            })), /*#__PURE__*/React.createElement("p", {
              className: "provider-text"
            }, comment));
          })), /*#__PURE__*/React.createElement("div", {
            className: "doc-nav-wrap"
          }, /*#__PURE__*/React.createElement("div", {
            className: "doc-nav"
          }, /*#__PURE__*/React.createElement(NotesNavbarv2, {
            onSelect: onDocumentSelect,
            activeNote: activeNote,
            documentMetadata: documentMetadata,
            isIPC: uiCommon.appServiceLines.isIPC(activeItem.service_line),
            capabilities: this.props.capabilities.capabilities,
            showAddAttachDocsButton: shouldShowAddAttachDocsButton,
            showAttachDocsModal: function showAttachDocsModal() {
              return _this3.props.showAttachDocsModal(activeItem);
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: "documentation-section"
          }, noteStyle))),
          titleText: 'Notes',
          styleName: 'tab-teal'
        }, displayTopLeftPatientInfo && {
          id: 'relatedCases',
          displayName: uiCommon.commonEnums.MiniTabLabels.RELATED_LABEL,
          active: this.props.activeVerticalMiniTab === uiCommon.commonEnums.MiniTabLabels.RELATED_LABEL,
          body: this.props.relatedCasesView,
          titleText: uiCommon.commonEnums.MiniTabLabels.RELATED_DESCRIPTION,
          styleName: 'tab-green'
        }, showImprovementsCapability && {
          id: 'improvements',
          displayName: uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
          active: this.props.activeVerticalMiniTab === uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
          body: this.props.documentImprovementsPanel,
          titleText: uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION,
          styleName: 'tab-yellow'
        }, {
          id: 'activity',
          displayName: uiCommon.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
          active: this.props.activeVerticalMiniTab === uiCommon.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
          body: /*#__PURE__*/React.createElement(Timeline, {
            items: this.props.activity,
            enableUserActivityComments: enableUserActivityComments,
            editable: this.props.editable
          }),
          titleText: uiCommon.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION,
          styleName: 'tab-orange'
        }].filter(Boolean);
        if (conditionalUtils$5.capabilityValue((_this$props$capabilit2 = this.props.capabilities) === null || _this$props$capabilit2 === void 0 || (_this$props$capabilit2 = _this$props$capabilit2.capabilities) === null || _this$props$capabilit2 === void 0 || (_this$props$capabilit2 = _this$props$capabilit2.codeSourcesFeatures) === null || _this$props$capabilit2 === void 0 ? void 0 : _this$props$capabilit2.on) && mode === 'code-edit') {
          var _this$props4;
          tabsItems.push({
            id: 'Code Sources',
            displayName: uiCommon.commonEnums.MiniTabLabels.CODE_SOURCES,
            active: this.props.activeVerticalMiniTab === uiCommon.commonEnums.MiniTabLabels.CODE_SOURCES,
            body: invoiceAPInvoicesToInvoiceSources((_this$props4 = this.props) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.sourceInvoices) === null || _this$props4 === void 0 ? void 0 : _this$props4.sourceInvoices),
            titleText: uiCommon.commonEnums.MiniTabLabels.CODE_SOURCES_DESCRIPTION,
            styleName: 'tab-tropical-50'
          });
        }
        var toggleButton = /*#__PURE__*/React.createElement(Button, {
          className: "demographics-toggle-button",
          variant: 'toggle',
          onClick: function onClick(ev) {
            return _this3.handleDemographicsPanelClick(ev);
          },
          "data-dd-action-name": !this.state.expandDemographicsPanel ? '~Open Demographics V2' : '~Close Demographics V2'
        }, !this.state.expandDemographicsPanel ? /*#__PURE__*/React.createElement(r, {
          iconName: e.Chevron_Left,
          titleText: "Show Demographics"
        }) : /*#__PURE__*/React.createElement(r, {
          iconName: e.Chevron_Right,
          titleText: "Collapse Demographics"
        }));
        var placementToggle = /*#__PURE__*/React.createElement(React.Fragment, null, this.state.demographicsLocation == 'bottom' ? /*#__PURE__*/React.createElement(Button, {
          className: "location-toggle-button",
          variant: 'toggle',
          onClick: function onClick(ev) {
            return _this3.handleDemographicsLocationClick(ev, 'right');
          },
          "data-dd-action-name": '~Pin Demographics to Right'
        }, /*#__PURE__*/React.createElement(r, {
          iconName: e.Arrow_Right,
          titleText: "Pin to Right",
          iconSize: "12"
        })) : /*#__PURE__*/React.createElement(Button, {
          className: "location-toggle-button",
          variant: 'toggle',
          onClick: function onClick(ev) {
            return _this3.handleDemographicsLocationClick(ev, 'bottom');
          },
          "data-dd-action-name": '~Pin Demographics to Bottom'
        }, /*#__PURE__*/React.createElement(r, {
          iconName: e.Arrow_Right,
          titleText: "Pin to Bottom",
          iconSize: "12"
        })));
        var toggleButtonGroup = /*#__PURE__*/React.createElement(React.Fragment, null, this.state.demographicsLocation == 'bottom' ? /*#__PURE__*/React.createElement(HStack, {
          className: "location-toggle-button-group"
        }, toggleButton, placementToggle) : /*#__PURE__*/React.createElement(VStack, {
          className: "location-toggle-button-group"
        }, toggleButton, placementToggle));
        return /*#__PURE__*/React.createElement(ChakraProvider, {
          theme: theme
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames(caseDetailClasses)
        }, actionBar, (formErrors === null || formErrors === void 0 ? void 0 : formErrors.status) === 'PAGE NOT FOUND' ? /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: 'Unable to load case (Case id# ' + params.id + ')',
          buttonText: 'Return',
          closable: false,
          icon: /*#__PURE__*/React.createElement("img", {
            src: AlertIcon,
            width: 30,
            height: 30
          }),
          onSubmit: this.props.handleBackClick,
          children: /*#__PURE__*/React.createElement("p", null, 'The case you are trying to view does not exist. Please check the information and try again.')
        }) : null, /*#__PURE__*/React.createElement("div", {
          className: "left-column"
        }, displayTopLeftPatientInfo && /*#__PURE__*/React.createElement("div", {
          className: "patient-top-info-container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "patient-info-primary sensitive-data",
          "data-testid": "patient-info-name"
        }, prop('patient_name'), /*#__PURE__*/React.createElement("div", {
          className: "patient-info-secondary"
        }, topCells)), topRightCell, /*#__PURE__*/React.createElement("a", {
          href: '#/patient-info',
          className: "timeline-button-container",
          onClick: function onClick(ev) {
            ev.preventDefault();
            _this3.props.showPatientInfo(_this3.props.activeItem);
          }
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconClass: "patient-timeline",
          svgIconName: "BiomeCalender",
          svgIconSize: "24",
          svgTitleText: "Patient Timeline"
        }))), /*#__PURE__*/React.createElement(uiComponents.TabbedContainer, {
          items: tabsItems,
          onSelection: onVerticalMiniTabSelection
        })), /*#__PURE__*/React.createElement("div", {
          className: "middle-column"
        }, !codeEditMode && /*#__PURE__*/React.createElement("div", {
          className: "large-status-container"
        }, showLoading ? /*#__PURE__*/React.createElement(uiComponents.Card, {
          className: classnames(['status-loading'].concat(loadingClasses))
        }, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 2
        })) : /*#__PURE__*/React.createElement(CaseStatus, {
          onClick: this._handleGroupedCaseClick,
          billingGroupLoadState: this.props.billingGroupLoadState,
          groupedCases: groupedCases,
          caseRun: activeItem,
          timeStamp: statusTimestamp,
          isPreGoLive: preGoLive
        })), codeEditingPanel || /*#__PURE__*/React.createElement(uiComponents.FlexCard, {
          unflexed: true
          //@ts-ignore
          ,
          ref: this._artifactRef,
          header: artifactLoadState.initial ? /*#__PURE__*/React.createElement("span", null) : /*#__PURE__*/React.createElement(IconHeader, {
            svgIconName: e.Coding,
            svgIconClass: "card-header-icon",
            header: artifactToggle,
            svgTitleText: "Coding"
          }),
          className: classnames(artifactListClasses)
        }, /*#__PURE__*/React.createElement("div", {
          className: "case-status-codes"
        }, /*#__PURE__*/React.createElement("div", {
          className: "prediction-section"
        }, artifactLoadState.initial ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 2
        }) : (artifactList || []).length === 0 && !charges ? /*#__PURE__*/React.createElement("h4", {
          className: "content-vacant"
        }, ' ', userIsCoder || (activeItem.artifacts || []).length === 0 ? 'No codes available' : 'No codes displayed') : charges ? /*#__PURE__*/React.createElement(React.Fragment, null, charges) : /*#__PURE__*/React.createElement(React.Fragment, null))))), /*#__PURE__*/React.createElement("div", {
          className: "right-column"
        }, showLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 3
        }), /*#__PURE__*/React.createElement("br", null)) : /*#__PURE__*/React.createElement(React.Fragment, null, toggleButtonGroup, /*#__PURE__*/React.createElement(PatientEncounterv2
        //@ts-ignore
        , {
          ref: this._patientRef,
          activations: activations,
          propertyConfig: propertyConfig,
          activeItem: activeItem,
          handleExpansion: this._handlePatientExpansion,
          showCoderNotesInfo: this.props.showCoderNotesInfo,
          showProviderInfo: this.props.showProviderInfo,
          fieldEditorInfo: {
            caseEdits: caseEdits,
            organization: organization,
            updateValue: updateValue,
            updateCase: updateCase
          },
          capability: _objectSpread$m(_objectSpread$m({}, capability), {}, {
            on:
            //@ts-ignore
            conditionalUtils$5.capabilityValue(capability.on) && mode === uiCommon.commonEnums.CaseDetailMode.EDIT && isCaseAvailable$1(this.props.caseAccessState)
          }),
          coderNotesCapability: coderNotesCapability,
          flagList: flagList,
          workItem: workItem,
          activeContext: (_this$props$context = this.props.context) === null || _this$props$context === void 0 ? void 0 : _this$props$context.activeContext
        })))));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseDetailv2, "defaultProps", {
    onCaseAction: function onCaseAction(action) {},
    onFeatureActivation: function onFeatureActivation(selection) {},
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    items: [],
    mode: uiCommon.commonEnums.CaseDetailMode.DASHBOARD,
    actionsState: {},
    capability: {
      on: uiComponents.DEFAULT_UNAVAILABLE_CAPABILITY
    },
    coderNotesCapability: _objectSpread$m({}, uiCommon.AmplifyCore.conditionalUtils.disabledCapability),
    noteUnavailableReason: _objectSpread$m({}, uiCommon.AmplifyCore.conditionalUtils.disabledCapability),
    flagList: [],
    activeVerticalMiniTab: uiCommon.commonEnums.MiniTabLabels.NOTES_LABEL,
    setActiveVerticalMiniTab: function setActiveVerticalMiniTab(activeTabName) {},
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    displayTopLeftPatientInfo: true,
    editable: false,
    caseAccessState: CaseAccessState$1.NONE,
    enableUserActivityComments: false
  });

  var img$4 = new Image();
    img$4.src = "data:image/svg+xml,%3csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='hourglass-half' class='svg-inline--fa fa-hourglass-half fa-w-12 fa-3x ' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 384 512'%3e%3cpath fill='currentColor' d='M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z'%3e%3c/path%3e%3c/svg%3e";

  var img$3 = new Image();
    img$3.src = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3e%3cpath d='M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256zM99.5 144.8C77.15 176.1 64 214.5 64 256C64 362 149.1 448 256 448C297.5 448 335.9 434.9 367.2 412.5L99.5 144.8zM448 256C448 149.1 362 64 256 64C214.5 64 176.1 77.15 144.8 99.5L412.5 367.2C434.9 335.9 448 297.5 448 256V256z'/%3e%3c/svg%3e";

  var ProcessStatus = function ProcessStatus(props) {
    var benchEditable = props.benchEditable;
    if (benchEditable.waiting) {
      return /*#__PURE__*/React.createElement(uiComponents.Card, {
        className: "accelerate-process-status"
      }, /*#__PURE__*/React.createElement("div", {
        className: "pre-coding",
        "data-testid": "process-status-pre-coding"
      }, /*#__PURE__*/React.createElement("span", {
        className: "waiting-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$4
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-info"
      }, "Collecting information. Please check back again.")));
    } else if (benchEditable.submitted) {
      return /*#__PURE__*/React.createElement("div", {
        className: "accelerate-process-status"
      }, /*#__PURE__*/React.createElement("div", {
        className: "post-coding",
        "data-testid": "process-status-post-coding"
      }, /*#__PURE__*/React.createElement(r, {
        iconName: e.Check_Circle,
        iconClass: "status-icon",
        titleText: "Case is coded."
      }), /*#__PURE__*/React.createElement("div", {
        className: "status-text"
      }, "This case has been coded.")), ' ');
    } else if (benchEditable.cancelled) {
      return /*#__PURE__*/React.createElement("div", {
        className: "accelerate-process-status"
      }, /*#__PURE__*/React.createElement("div", {
        className: "post-coding",
        "data-testid": "process-status-post-coding"
      }, /*#__PURE__*/React.createElement("div", {
        className: "status-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: img$3,
        style: {
          width: '1rem',
          marginTop: '2px'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "status-text"
      }, "This case is cancelled and will not be sent to billing.")), ' ');
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: "empty-process-status",
        "data-testid": "process-status-empty"
      });
    }
  };

  function _callSuper$h(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$h() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$h() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$h = function _isNativeReflectConstruct() { return !!t; })(); }

  // Define a type for the props
  // Define the component
  var InvoiceMetadata = /*#__PURE__*/function (_Component) {
    function InvoiceMetadata() {
      _classCallCheck(this, InvoiceMetadata);
      return _callSuper$h(this, InvoiceMetadata, arguments);
    }
    _inherits(InvoiceMetadata, _Component);
    return _createClass(InvoiceMetadata, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
          dateOfService = _this$props.dateOfService,
          department = _this$props.department,
          performingName = _this$props.performingName,
          providerName = _this$props.providerName,
          referringName = _this$props.referringName,
          editable = _this$props.editable,
          codableInvoice = _this$props.codableInvoice,
          onInvoiceMetaEdit = _this$props.onInvoiceMetaEdit;
        return /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-cell-date"
        }, /*#__PURE__*/React.createElement("p", {
          className: "invoice-meta-date_of_service"
        }, dateOfService)), /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-cell-providers"
        }, department && /*#__PURE__*/React.createElement("p", {
          className: "invoice-meta-department_name"
        }, /*#__PURE__*/React.createElement("span", {
          className: "invoice-meta-label"
        }, "Department:"), ' ', department), performingName && /*#__PURE__*/React.createElement("p", {
          className: "invoice-meta-performing_name"
        }, /*#__PURE__*/React.createElement("span", {
          className: "invoice-meta-label"
        }, "Performed by:"), ' ', performingName), providerName && /*#__PURE__*/React.createElement("p", {
          className: "invoice-meta-provider_name"
        }, /*#__PURE__*/React.createElement("span", {
          className: "invoice-meta-label"
        }, "Billing provider:"), ' ', providerName), referringName && /*#__PURE__*/React.createElement("p", {
          className: "invoice-meta-referring_name"
        }, /*#__PURE__*/React.createElement("span", {
          className: "invoice-meta-label"
        }, "Referred by:"), ' ', referringName)), /*#__PURE__*/React.createElement("div", {
          className: "invoice-meta-cell-actions"
        }, editable && codableInvoice && /*#__PURE__*/React.createElement("span", {
          className: "invoice-edit"
        }, /*#__PURE__*/React.createElement("a", {
          href: "#/change-session",
          onClick: function onClick(e) {
            e.preventDefault();
            if (codableInvoice) {
              onInvoiceMetaEdit(codableInvoice);
            }
          }
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeEdit",
          svgIconSize: "16",
          svgTitleText: "Edit invoice",
          svgIconClass: "invoice-edit-icon"
        })))));
      }
    }]);
  }(React.Component);

  var _excluded$7 = ["searchResults", "counts", "editable", "benchEditable", "benchLoading", "onCodeSearch", "onCodeSearchSelection", "onCodeUpdate", "onCodeRemove", "onTimeBasedCodeAdd", "onTimeBasedCodeUpdate", "onCodeSearchDrop", "onFeatureSelection", "onInvoiceMetaEdit", "onChargeSessionAction", "onTransactionSharedDiagnosisChange", "panelActivations", "codableInvoices", "processInstance", "codeEdits", "showProcessStatus", "caseDetailProps", "handleEnableTechPro", "handleDisableTechPro", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "openChildWindow"];
  function _callSuper$g(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$g() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$g() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$g = function _isNativeReflectConstruct() { return !!t; })(); }
  var CodeBenchPanel = /*#__PURE__*/function (_React$Component) {
    function CodeBenchPanel(props) {
      var _this;
      _classCallCheck(this, CodeBenchPanel);
      _this = _callSuper$g(this, CodeBenchPanel, [props]);
      _this.state = {
        editState: {
          add: false
        }
      };
      return _this;
    }
    _inherits(CodeBenchPanel, _React$Component);
    return _createClass(CodeBenchPanel, [{
      key: "render",
      value: function render() {
        var _this2 = this,
          _processInstance$erro;
        var _this$props = this.props,
          searchResults = _this$props.searchResults;
          _this$props.counts;
          var editable = _this$props.editable,
          benchEditable = _this$props.benchEditable;
          _this$props.benchLoading;
          var onCodeSearch = _this$props.onCodeSearch,
          onCodeSearchSelection = _this$props.onCodeSearchSelection,
          onCodeUpdate = _this$props.onCodeUpdate,
          onCodeRemove = _this$props.onCodeRemove,
          onTimeBasedCodeAdd = _this$props.onTimeBasedCodeAdd,
          onTimeBasedCodeUpdate = _this$props.onTimeBasedCodeUpdate,
          onCodeSearchDrop = _this$props.onCodeSearchDrop,
          onFeatureSelection = _this$props.onFeatureSelection;
          _this$props.onInvoiceMetaEdit;
          var onChargeSessionAction = _this$props.onChargeSessionAction,
          onTransactionSharedDiagnosisChange = _this$props.onTransactionSharedDiagnosisChange,
          panelActivations = _this$props.panelActivations,
          codableInvoices = _this$props.codableInvoices,
          processInstance = _this$props.processInstance,
          codeEdits = _this$props.codeEdits,
          showProcessStatus = _this$props.showProcessStatus;
          _this$props.caseDetailProps;
          var handleEnableTechPro = _this$props.handleEnableTechPro,
          handleDisableTechPro = _this$props.handleDisableTechPro,
          customClaimsRelatedCases = _this$props.customClaimsRelatedCases,
          customClaimsRelatedCasesLoadState = _this$props.customClaimsRelatedCasesLoadState;
          _this$props.openChildWindow;
          var rest = _objectWithoutProperties(_this$props, _excluded$7);
        var styleClasses = ['code-bench-panel'];
        var counter = 0;
        var invoices = codableInvoices.map(function (codableInvoice, idx) {
          var _codableInvoice$billi, _codableInvoice$perfo, _codableInvoice$refer, _codableInvoice$fee_s, _codableInvoice$depar, _codableInvoice$depar2, _codableInvoice$type$, _codableInvoice$type;
          var providerName = (_codableInvoice$billi = codableInvoice.billing_provider_name) !== null && _codableInvoice$billi !== void 0 ? _codableInvoice$billi : '';
          var performingName = (_codableInvoice$perfo = codableInvoice.performing_provider_name) !== null && _codableInvoice$perfo !== void 0 ? _codableInvoice$perfo : '';
          var referringName = (_codableInvoice$refer = codableInvoice.referring_provider_name) !== null && _codableInvoice$refer !== void 0 ? _codableInvoice$refer : '';
          (_codableInvoice$fee_s = codableInvoice.fee_schedule) !== null && _codableInvoice$fee_s !== void 0 ? _codableInvoice$fee_s : 'None';
          var department = (_codableInvoice$depar = codableInvoice === null || codableInvoice === void 0 || (_codableInvoice$depar2 = codableInvoice.department) === null || _codableInvoice$depar2 === void 0 ? void 0 : _codableInvoice$depar2.name) !== null && _codableInvoice$depar !== void 0 ? _codableInvoice$depar : '';
          var dateOfService = codableInvoice.date_of_service ? uiCommon.cmxDateTime.format(codableInvoice.date_of_service, uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE) : 'Date not selected';
          var txns;
          txns = codableInvoice.transactions.map(function (txn) {
            var _searchResults$txn$gu;
            var rawResults = (_searchResults$txn$gu = searchResults[txn.guid]) !== null && _searchResults$txn$gu !== void 0 ? _searchResults$txn$gu : [];
            if (codableInvoice.type !== uiCommon.commonEnums.InvoiceTypes.SHARED_CODES) {
              counter++;
            }
            return /*#__PURE__*/React.createElement(Transaction, {
              key: "txn-".concat(txn.guid),
              codeEdits: codeEdits,
              onChargeSessionAction: onChargeSessionAction,
              panelActivations: panelActivations,
              invoice: codableInvoice,
              processInstance: processInstance
              // focus the user's cursor on the first charge to code.
              ,
              autoFocus: idx === 0,
              editable: editable,
              onFeatureSelection: onFeatureSelection,
              searchResults: rawResults,
              onCodeSearch: onCodeSearch,
              onCodeSearchSelection: onCodeSearchSelection,
              handleCodeChange: onCodeUpdate,
              handleCodeRemove: onCodeRemove,
              handleTimeBasedCodeAdd: onTimeBasedCodeAdd,
              handleTimeBasedCodeUpdate: onTimeBasedCodeUpdate,
              handleCodeSearchDrop: onCodeSearchDrop,
              onTransactionSharedDiagnosisChange: onTransactionSharedDiagnosisChange,
              lineNumber: counter,
              codableTransaction: txn,
              handleEnableTechPro: handleEnableTechPro,
              handleDisableTechPro: handleDisableTechPro
            });
          });
          var invoiceType = (_codableInvoice$type$ = codableInvoice === null || codableInvoice === void 0 || (_codableInvoice$type = codableInvoice.type) === null || _codableInvoice$type === void 0 ? void 0 : _codableInvoice$type.toLowerCase().replace(/\_/g, '-')) !== null && _codableInvoice$type$ !== void 0 ? _codableInvoice$type$ : 'unknown';
          var invoiceClasses = ['codable-invoice', 'qa-codable-invoice', "invoice-".concat(invoiceType)];
          uiCommon.appServiceLines.isIPC(processInstance === null || processInstance === void 0 ? void 0 : processInstance.serviceLine);
          return /*#__PURE__*/React.createElement("div", {
            className: classnames(invoiceClasses),
            key: "invoice-".concat(idx)
          }, /*#__PURE__*/React.createElement("div", {
            className: "invoice-meta"
          }, /*#__PURE__*/React.createElement("div", {
            className: "invoice-meta-line invoice-meta-provider"
          }, editable && /*#__PURE__*/React.createElement(ErrorSubmission, {
            errorMessages: codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.errorMessages,
            messageStyle: "inv-error-message",
            messageType: "error"
          }), /*#__PURE__*/React.createElement(InvoiceMetadata, {
            codableInvoice: codableInvoice,
            onInvoiceMetaEdit: _this2.props.onInvoiceMetaEdit,
            dateOfService: dateOfService,
            department: department,
            performingName: performingName,
            providerName: providerName,
            referringName: referringName,
            editable: editable
          }))), txns);
        });
        var noInvoices = /*#__PURE__*/React.createElement("div", {
          className: "no-transactions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "empty-message editable"
        }, "This case does not have any charges. Add a service date and providers with the charge button below, then add procedures to the set."));
        return /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
          className: classnames(styleClasses)
        }), showProcessStatus && /*#__PURE__*/React.createElement("div", {
          className: "status-section process-status-section"
        }, /*#__PURE__*/React.createElement(ProcessStatus, {
          benchEditable: benchEditable
        })), customClaimsRelatedCasesLoadState !== null && customClaimsRelatedCasesLoadState !== void 0 && customClaimsRelatedCasesLoadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 5
        }) : (processInstance === null || processInstance === void 0 || (_processInstance$erro = processInstance.errorMessages) === null || _processInstance$erro === void 0 ? void 0 : _processInstance$erro.length) > 0 && /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: processInstance.errorMessages,
          messageHeader: benchEditable.submitted ? 'We have found the following errors:' : 'We have found the following that reduce the coding quality of this case:',
          customClaimsRelatedProps: {
            cases: customClaimsRelatedCases,
            onOpenRelatedCase: this.props.openChildWindow,
            applyErrorTextStyle: !benchEditable.submitted
          },
          messageStyle: "case-error-message",
          messageType: benchEditable.submitted ? 'warning' : 'error'
        }), counter === 0 ? noInvoices : invoices);
      }
    }]);
  }(React.Component);
  _defineProperty(CodeBenchPanel, "displayName", 'CodeBenchPanel');
  _defineProperty(CodeBenchPanel, "defaultProps", {
    onCodeUpdate: function onCodeUpdate(changeDetail) {},
    onCodeRemove: function onCodeRemove(changeDetail) {},
    onTimeBasedCodeAdd: function onTimeBasedCodeAdd(changeDetail, time, age) {},
    onTimeBasedCodeUpdate: function onTimeBasedCodeUpdate(changeDetail, time, age) {},
    onCodeSearchDrop: function onCodeSearchDrop(changeDetail) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    onFeatureSelection: function onFeatureSelection(feature) {},
    onInvoiceMetaEdit: function onInvoiceMetaEdit(invoice) {},
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    handleEnableTechPro: function handleEnableTechPro(transactionCodeChange) {},
    handleDisableTechPro: function handleDisableTechPro(transactionCodeChange) {},
    codableInvoices: [],
    searchResults: {},
    editable: true,
    panelActivations: {},
    codeEdits: {},
    counts: {
      procedures: 0,
      diagnosis: 0,
      modifiers: 0
    }
  });

  var _excluded$6 = ["counts"];
  function ownKeys$l(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$l(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$l(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$l(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_PROPS$4 = {
    counts: {
      procedures: 0,
      diagnosis: 0,
      modifiers: 0
    }
  };
  var ChargeCounts = function ChargeCounts(props) {
    var appliedProps = _objectSpread$l(_objectSpread$l({}, DEFAULT_PROPS$4), props);
    var counts = appliedProps.counts,
      rest = _objectWithoutProperties(appliedProps, _excluded$6);
    var hasProcedures = counts.procedures > 0;
    var hasDX = counts.diagnosis > 0;
    var hasMods = counts.modifiers > 0;
    var styleClasses = ['charge-counts', {
      'has-procedures': hasProcedures,
      'has-dx': hasDX,
      'has-mods': hasMods
    }];
    var readout = [];
    if (hasProcedures) {
      readout.push("".concat(counts.procedures, " ").concat(pluralize('procedure', counts.procedures)));
    }
    if (hasDX) {
      var dxString = counts.diagnosis === 1 ? "".concat(counts.diagnosis, " diagnosis") : "".concat(counts.diagnosis, " diagnoses");
      readout.push(dxString);
    }
    if (hasMods) {
      var slug = readout.length === 2 ? 'and ' : '';
      readout.push("".concat(slug).concat(counts.modifiers, " ").concat(pluralize('modifier', counts.modifiers)));
    }
    var summary = '';
    if (readout.length === 0) {
      summary = 'No codes assigned';
    } else if (readout.length === 1) {
      summary = readout.join('');
    } else if (readout.length === 2) {
      summary = readout.join(' and ');
    } else {
      summary = readout.join(', ');
    }
    return /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
      className: classnames(styleClasses)
    }), summary);
  };
  ChargeCounts.displayName = 'ChargeCounts';

  var CancelledEula = function CancelledEula(props) {
    var onEulaCancel = props.onEulaCancel,
      modalProps = props.modalProps;
    var submitClick = function submitClick(e) {
      onEulaCancel(false);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: 'qa-cancelled-eula'
    }, /*#__PURE__*/React.createElement(uiComponents.Modal, _extends$1({
      title: 'You must accept the EULA to use the application',
      buttonText: 'Return',
      closable: false,
      onSubmit: submitClick,
      forceSubmitOptions: {
        isForced: true,
        time: 10,
        message: 'Returning to the login screen '
      }
    }, modalProps), /*#__PURE__*/React.createElement("p", null, "Please review the EULA and try again.")));
  };
  CancelledEula.displayName = 'CancelledEula';

  function ownKeys$k(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$k(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$k(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$k(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var AcceptableEula = function AcceptableEula(props) {
    var eula = props.eula,
      context = props.context,
      optionalEulaAcceptancePayload = props.optionalEulaAcceptancePayload,
      onEulaAccept = props.onEulaAccept,
      onEulaCancel = props.onEulaCancel;
    var acceptEulaClick = function acceptEulaClick() {
      var datedEula = _objectSpread$k(_objectSpread$k({}, eula), {}, {
        acceptedDate: uiCommon.cmxDateTime.format(new Date(), uiCommon.cmxDateTime.FORMATS.DATE_TIME_EULA)
      });
      onEulaAccept({
        eula: datedEula,
        context: context,
        optional: optionalEulaAcceptancePayload
      });
    };
    var footerChildren = /*#__PURE__*/React.createElement("div", {
      className: 'columns'
    }, /*#__PURE__*/React.createElement(uiComponents.RoundedButton, {
      className: 'btn btn-primary qa-submit-button column',
      onClick: function onClick() {
        acceptEulaClick();
      }
    }, ' ', "Accept"), /*#__PURE__*/React.createElement("div", {
      className: 'column col-1'
    }), /*#__PURE__*/React.createElement(uiComponents.RoundedButton, {
      className: 'btn btn-secondary qa-cancel-button column',
      onClick: function onClick() {
        onEulaCancel(true);
      }
    }, ' ', "Cancel"));
    return /*#__PURE__*/React.createElement("div", {
      className: 'qa-acceptable-eula acceptable-eula'
    }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
      footerChildren: footerChildren,
      closable: false,
      title: 'CodaMetrix End User License Agreement'
    }, /*#__PURE__*/React.createElement("div", null, eula.text)));
  };
  AcceptableEula.displayName = 'AcceptableEula';

  var defaultCancelEulaModalProps = {
    closable: false,
    forceSubmitOptions: {
      isForced: false,
      message: 'Returning to the login screen',
      time: 10
    },
    buttonText: ''
  };
  var Eula = function Eula(props) {
    var isCancelled = props.isCancelled,
      onEulaCancel = props.onEulaCancel;
    if (!isCancelled) {
      return /*#__PURE__*/React.createElement(AcceptableEula, props);
    } else {
      return /*#__PURE__*/React.createElement(CancelledEula, {
        onEulaCancel: onEulaCancel,
        modalProps: defaultCancelEulaModalProps
      });
    }
  };
  Eula.displayName = 'Eula';

  var img$2 = new Image();
    img$2.src = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto%3b background: rgb(255%2c 255%2c 255)%3b display: block%3b shape-rendering: auto%3b' width='34px' height='34px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3e%3cg transform='rotate(0 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-1.0299625468164795s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(30 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.9363295880149813s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(60 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.8426966292134832s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(90 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.7490636704119851s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(120 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.6554307116104869s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(150 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.5617977528089888s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(180 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.46816479400749067s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(210 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.37453183520599254s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(240 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.2808988764044944s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(270 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.18726591760299627s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(300 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.09363295880149813s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(330 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23fe718d'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='0s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3c!-- %5bldio%5d generated by https://loading.io/ --%3e%3c/svg%3e";

  var _excluded$5 = ["cancelled", "groupedCases", "isActive", "showLoading", "showProcessStatus", "suppressedLinks", "viewOnly"];
  var getBillingGroup = function getBillingGroup() {
    var showProcessStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var suppressedLinks = arguments.length > 1 ? arguments[1] : undefined;
    var caseRuns = arguments.length > 2 ? arguments[2] : undefined;
    if (!(caseRuns !== null && caseRuns !== void 0 && caseRuns.length)) {
      return false;
    }
    var suppressedSet = new Set(_toConsumableArray(suppressedLinks));
    var getMiniStatus = function getMiniStatus(caseRun, idx) {
      var _caseRun$exam_descrip;
      var statusDisplay = uiCommon.caseUtils.deriveStatus(caseRun);
      var description = (_caseRun$exam_descrip = caseRun.exam_description) !== null && _caseRun$exam_descrip !== void 0 ? _caseRun$exam_descrip : '';
      var clinicalId = "".concat(caseRun.primary_clinical_identifier.number, " (").concat(caseRun.primary_clinical_identifier.issuer, ")");
      var mainStatus = showProcessStatus ? statusDisplay.processStatus : statusDisplay.signifier;
      var styleClasses = ['related-group-item', 'qa-related-group-item', statusDisplay.styleClass];
      var inner = /*#__PURE__*/React.createElement("div", {
        className: "related-group-item-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "info-display"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle"
      }), mainStatus), /*#__PURE__*/React.createElement("div", {
        className: "descriptive-text ellipsify"
      }, description), /*#__PURE__*/React.createElement("div", {
        className: "clinical-id sensitive-data"
      }, "#", clinicalId));
      var itemClasses = 'qa-related-group-item-line related-group-item-line';
      return /*#__PURE__*/React.createElement("li", {
        className: classnames(styleClasses),
        key: "".concat(caseRun.process_instance_id, "-").concat(idx)
      }, suppressedSet.has(caseRun.case_id) ? /*#__PURE__*/React.createElement("span", {
        className: itemClasses
      }, inner) : /*#__PURE__*/React.createElement("a", {
        className: itemClasses,
        href: "/cmx/cases/".concat(caseRun.case_id),
        "data-case-id": "".concat(caseRun.case_id),
        title: "".concat(description, " - ").concat(caseRun.process_status)
      }, inner));
    };
    var relatedStatuses = caseRuns === null || caseRuns === void 0 ? void 0 : caseRuns.map(getMiniStatus);
    return /*#__PURE__*/React.createElement("div", {
      className: "relation-grouping"
    }, /*#__PURE__*/React.createElement("ul", {
      className: "related-group"
    }, relatedStatuses));
  };
  var BillingGroup = function BillingGroup(_ref) {
    var _groupedCases$caseRun;
    var _ref$cancelled = _ref.cancelled,
      cancelled = _ref$cancelled === void 0 ? false : _ref$cancelled,
      groupedCases = _ref.groupedCases;
      _ref.isActive;
      var _ref$showLoading = _ref.showLoading,
      showLoading = _ref$showLoading === void 0 ? false : _ref$showLoading,
      _ref$showProcessStatu = _ref.showProcessStatus,
      showProcessStatus = _ref$showProcessStatu === void 0 ? false : _ref$showProcessStatu,
      _ref$suppressedLinks = _ref.suppressedLinks,
      suppressedLinks = _ref$suppressedLinks === void 0 ? [] : _ref$suppressedLinks;
      _ref.viewOnly;
      var rest = _objectWithoutProperties(_ref, _excluded$5);
    var caseRuns = (_groupedCases$caseRun = groupedCases === null || groupedCases === void 0 ? void 0 : groupedCases.caseRuns) !== null && _groupedCases$caseRun !== void 0 ? _groupedCases$caseRun : [];
    var isStandalone = !(caseRuns !== null && caseRuns !== void 0 && caseRuns.length);
    var styleClasses = ['billing-group', {
      'bg-loaded': !showLoading,
      'bg-with-cases': !!(caseRuns !== null && caseRuns !== void 0 && caseRuns.length),
      'bg-empty': !showLoading && isStandalone,
      'bg-show-loading': showLoading,
      'case-cancelled': cancelled
    }];
    return /*#__PURE__*/React.createElement("div", _extends$1({
      className: classnames(styleClasses)
    }, rest), showLoading && /*#__PURE__*/React.createElement("span", {
      className: "loading-content"
    }, /*#__PURE__*/React.createElement("img", {
      src: img$2,
      alt: "in progress",
      className: "spinner"
    })), !(caseRuns !== null && caseRuns !== void 0 && caseRuns.length) && /*#__PURE__*/React.createElement("span", {
      className: "empty-content"
    }, "There are no other related cases at this time."), !!(caseRuns !== null && caseRuns !== void 0 && caseRuns.length) && /*#__PURE__*/React.createElement("div", {
      className: "billing-group-items"
    }, getBillingGroup(showProcessStatus, suppressedLinks, caseRuns)));
  };
  BillingGroup.displayName = 'BillingGroup';

  var img$1 = new Image();
    img$1.src = "data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M10 15.7089C10.3032 15.7089 10.5558 15.6038 10.7579 15.3936C10.96 15.1834 11.061 14.9263 11.061 14.6224C11.061 14.32 10.9559 14.0634 10.7458 13.8524C10.5348 13.6422 10.2777 13.5371 9.97456 13.5371C9.67142 13.5371 9.41879 13.6422 9.2167 13.8524C9.0146 14.0634 8.91355 14.32 8.91355 14.6224C8.91355 14.9263 9.01905 15.1834 9.23004 15.3936C9.44022 15.6038 9.69688 15.7089 10 15.7089ZM10.051 5.73053C10.5732 5.73053 10.9939 5.86553 11.3132 6.13553C11.6334 6.40472 11.7934 6.75839 11.7934 7.19654C11.7934 7.48271 11.7094 7.77736 11.5412 8.08051C11.3723 8.38365 11.1196 8.67831 10.7834 8.96448C10.2611 9.41879 9.88645 9.83148 9.65929 10.2025C9.43213 10.5728 9.31007 10.9515 9.29309 11.3387C9.27611 11.5238 9.33068 11.6839 9.45679 11.8189C9.5829 11.9539 9.75549 12.0214 9.97456 12.0214C10.1767 12.0214 10.3537 11.9579 10.5057 11.831C10.6568 11.7049 10.7494 11.5323 10.7834 11.3132C10.8335 11.0441 10.943 10.7874 11.112 10.5433C11.2801 10.2991 11.5493 9.99194 11.9195 9.6217C12.4587 9.11565 12.8209 8.6775 13.006 8.30726C13.1911 7.93702 13.2837 7.52434 13.2837 7.06922C13.2837 6.24385 12.9935 5.57896 12.4131 5.07452C11.8318 4.56847 11.0695 4.31545 10.1261 4.31545C9.50287 4.31545 8.93861 4.45045 8.43337 4.72045C7.92813 4.98964 7.4819 5.38535 7.09468 5.90757C6.99363 6.04257 6.96857 6.19414 7.0195 6.36228C7.06962 6.53043 7.17067 6.67351 7.32265 6.79154C7.47381 6.92654 7.66298 6.97302 7.89013 6.93098C8.1181 6.88895 8.30767 6.76688 8.45883 6.56478C8.66093 6.31176 8.88405 6.10966 9.12818 5.95849C9.37231 5.80652 9.6799 5.73053 10.051 5.73053ZM10 19.6C8.66942 19.6 7.42329 19.3474 6.26164 18.8422C5.09918 18.3369 4.08425 17.6546 3.21685 16.7953C2.34945 15.9368 1.66313 14.9223 1.15789 13.7517C0.652645 12.5812 0.400024 11.3306 0.400024 10C0.400024 8.66942 0.652645 7.41884 1.15789 6.2483C1.66313 5.07776 2.34945 4.06323 3.21685 3.20472C4.08425 2.34541 5.09918 1.66313 6.26164 1.15789C7.42329 0.652645 8.66942 0.400024 10 0.400024C11.3476 0.400024 12.6022 0.652645 13.7639 1.15789C14.9263 1.66313 15.9413 2.34541 16.8087 3.20472C17.6761 4.06323 18.3579 5.07776 18.8543 6.2483C19.3514 7.41884 19.6 8.66942 19.6 10C19.6 11.3306 19.3514 12.5812 18.8543 13.7517C18.3579 14.9223 17.6761 15.9368 16.8087 16.7953C15.9413 17.6546 14.9263 18.3369 13.7639 18.8422C12.6022 19.3474 11.3476 19.6 10 19.6ZM10 17.9824C12.2401 17.9824 14.1305 17.2036 15.6713 15.6458C17.212 14.088 17.9824 12.2061 17.9824 10C17.9824 7.79394 17.212 5.91201 15.6713 4.35425C14.1305 2.79649 12.2401 2.01761 10 2.01761C7.79394 2.01761 5.91201 2.79649 4.35425 4.35425C2.79649 5.91201 2.01761 7.79394 2.01761 10C2.01761 12.2061 2.79649 14.088 4.35425 15.6458C5.91201 17.2036 7.79394 17.9824 10 17.9824Z' fill='%23E5927D'/%3e%3c/svg%3e";

  function _callSuper$f(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$f() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$f() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$f = function _isNativeReflectConstruct() { return !!t; })(); }

  /**
   * State for the Case Exclusion component
   */
  var CaseExclusion = /*#__PURE__*/function (_React$Component) {
    /**
     * Constructor method for class CaseExclusion
     * @param {Accelerate.CaseExclusionProps} props
     */
    function CaseExclusion(props) {
      var _this;
      _classCallCheck(this, CaseExclusion);
      _this = _callSuper$f(this, CaseExclusion, [props]);
      _this.state = {
        comment: ''
      };
      _this.caseToggleExclusion = _this.caseToggleExclusion.bind(_this);
      _this.cancelExclusion = _this.cancelExclusion.bind(_this);
      _this.handleCommentChange = _this.handleCommentChange.bind(_this);
      return _this;
    }
    _inherits(CaseExclusion, _React$Component);
    return _createClass(CaseExclusion, [{
      key: "handleCommentChange",
      value:
      /**
       * Method to handle the change event for text area element
       * @param {Object} event - Event object
       */
      function handleCommentChange(event) {
        this.setState({
          comment: event.target.value
        });
      }

      /**
       * Method for case exclusion
       */
    }, {
      key: "caseToggleExclusion",
      value: function caseToggleExclusion() {
        this.props.onCaseExclusion(this.state.comment);
      }

      /**
       * Method for cancel the exclusion of a case
       */
    }, {
      key: "cancelExclusion",
      value: function cancelExclusion() {
        this.props.onCancel();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props, _this$props2;
        return /*#__PURE__*/React.createElement("form", {
          className: "case-exclusion",
          onSubmit: function onSubmit(e) {
            return e.preventDefault();
          }
        }, /*#__PURE__*/React.createElement("p", {
          className: "case-exclusion-subtitle"
        }, (_this$props = this.props) !== null && _this$props !== void 0 && _this$props.isChargeable ? 'This case will be considered non-chargeable, will be kept for reference, and charges are not submitted for billing. You can reverse this at any time.' : 'This case will be considered chargeable. You will be able to code and submit for billing. You can reverse this any time before the case is submitted.'), /*#__PURE__*/React.createElement("div", {
          className: "case-exclusion-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: this.cancelExclusion,
          className: "chakra-secondary-button"
        }, "No, Cancel"), /*#__PURE__*/React.createElement("button", {
          onClick: this.caseToggleExclusion,
          className: classnames('chakra-primary-button')
        }, (_this$props2 = this.props) !== null && _this$props2 !== void 0 && _this$props2.isChargeable ? 'Yes, exclude case' : 'Yes, include case')));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseExclusion, "displayName", 'CaseExclusion');
  _defineProperty(CaseExclusion, "defaultProps", {
    isChargeable: false,
    onStandaloneLaunch: function onStandaloneLaunch() {},
    onEmbeddedLaunch: function onEmbeddedLaunch() {}
  });

  function ownKeys$j(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$j(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$j(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$j(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$e(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$e() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$e() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$e = function _isNativeReflectConstruct() { return !!t; })(); }

  /**
   * State for the Case Comment component
   */

  var DEFAULT_PROPS$3 = {
    title: 'Add case comment',
    minLength: 5,
    maxLength: 1024,
    numberOfRows: 4,
    submitLabel: 'Comment',
    mandatoryComment: true,
    actionOnlyNoComment: false
  };
  var CaseComment = /*#__PURE__*/function (_React$Component) {
    /**
     * Constructor method for class CaseComment
     * @param {CMxCommonApp.CaseCommentProps} props - Props object passed to CaseComment component
     */
    function CaseComment(props) {
      var _this;
      _classCallCheck(this, CaseComment);
      _this = _callSuper$e(this, CaseComment, [props]);
      _this.state = {
        comment: '',
        validationMessage: ''
      };
      _this.handleCommentChange = _this.handleCommentChange.bind(_this);
      _this.submitComment = _this.submitComment.bind(_this);
      _this.cancelComment = _this.cancelComment.bind(_this);
      return _this;
    }
    /**
     * Method to handle the change event for text area element
     * @param {Object} event - Event object
     */
    _inherits(CaseComment, _React$Component);
    return _createClass(CaseComment, [{
      key: "handleCommentChange",
      value: function handleCommentChange(event) {
        this.setState({
          comment: event.target.value
        });
      }

      /**
       * Method to handle submit comment validation
       */
    }, {
      key: "handleValidation",
      value: function handleValidation() {
        var comment = this.state.comment;
        if (this.props.mandatoryComment && (!comment || comment.trim() === '')) {
          this.setState({
            validationMessage: 'Comment cannot be empty!'
          });
        } else if (comment.length < this.props.minLength) {
          this.setState({
            validationMessage: "Comment should have minimum ".concat(this.props.maxLength, " characters")
          });
        }
        return this.state.validationMessage ? false : true;
      }
      /**
       * Method to submit case comment
       */
    }, {
      key: "submitComment",
      value: function submitComment() {
        if (this.handleValidation()) {
          this.props.onSubmit(this.state.comment);
        }
      }

      /**
       * Method to cancel case comment
       */
    }, {
      key: "cancelComment",
      value: function cancelComment() {
        this.props.onCancel();
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state$comment;
        var props = _objectSpread$j(_objectSpread$j({}, DEFAULT_PROPS$3), this.props);
        var title = props.title,
          subtitle = props.subtitle,
          maxLength = props.maxLength,
          numberOfRows = props.numberOfRows,
          submitLabel = props.submitLabel,
          actionOnlyNoComment = props.actionOnlyNoComment;
        var validationMessage = this.state.validationMessage;
        var placeholder = (props.placeholder ? props.placeholder : 'Enter comments') + (props.mandatoryComment ? '' : ' (optional)');
        return /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: title,
          onClose: this.cancelComment
        }, /*#__PURE__*/React.createElement("form", {
          className: "case-comment",
          onSubmit: function onSubmit(e) {
            return e.preventDefault();
          }
        }, subtitle && /*#__PURE__*/React.createElement("p", {
          className: "case-comment-subtitle"
        }, subtitle), validationMessage && /*#__PURE__*/React.createElement("p", {
          className: "case-comment-validation"
        }, validationMessage), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!actionOnlyNoComment]
        }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
          className: "case-comment-textarea form-input input",
          placeholder: placeholder,
          maxLength: maxLength,
          onChange: this.handleCommentChange,
          rows: numberOfRows
        }), /*#__PURE__*/React.createElement("p", {
          className: "case-comment-length"
        }, (_this$state$comment = this.state.comment) === null || _this$state$comment === void 0 ? void 0 : _this$state$comment.length, "/", maxLength))), /*#__PURE__*/React.createElement("div", {
          className: "case-comment-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: this.cancelComment,
          className: "chakra-secondary-button"
        }, "Cancel"), /*#__PURE__*/React.createElement("button", {
          onClick: this.submitComment,
          className: classnames('chakra-primary-button')
        }, submitLabel))));
      }
    }]);
  }(React.Component);
  _defineProperty(CaseComment, "displayName", 'CaseComment');

  function _callSuper$d(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$d() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$d() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$d = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$i(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$i(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$i(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$i(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var conditionalUtils$4 = uiCommon.AmplifyCore.conditionalUtils,
    benchEditableCore$2 = uiCommon.AmplifyCore.benchEditable;
  var getChildWindowParams$3 = uiCommon.caseUtils.getChildWindowParams;
  var CapabilityAvailabilityReason$1 = uiCommon.commonEnums.CapabilityAvailabilityReason,
    HoldReasonType$1 = uiCommon.commonEnums.HoldReasonType,
    DocumentStatus$3 = uiCommon.commonEnums.DocumentStatus,
    CursorOperation$2 = uiCommon.commonEnums.CursorOperation,
    AccelerateProcessStatus$2 = uiCommon.commonEnums.AccelerateProcessStatus,
    CaseAlertType$1 = uiCommon.commonEnums.CaseAlertType;
  var DEFAULT_PROPS$2 = {
    processInstanceGuids: [],
    benchEditable: _objectSpread$i({}, uiCommon.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
    capabilities: _objectSpread$i({}, uiCommon.AmplifyCore.state.capabilities),
    caseVersions: []
  };
  var locatorFn$1 = function locatorFn(activeItem, item) {
    var _item$split = item.split(':'),
      _item$split2 = _slicedToArray(_item$split, 2),
      processInstanceGuid = _item$split2[1];
    return processInstanceGuid === activeItem.process_instance_guid;
  };
  var getCaseVersionDate$1 = function getCaseVersionDate(version) {
    var dateVersion = new Date(version.processInstanceCreatedDate);
    if (isNaN(dateVersion.valueOf())) {
      return version.processInstanceCreatedDate;
    } else {
      return dateVersion;
    }
  };
  var CodeBenchActionBar = /*#__PURE__*/function (_React$Component) {
    function CodeBenchActionBar(props) {
      var _this;
      _classCallCheck(this, CodeBenchActionBar);
      _this = _callSuper$d(this, CodeBenchActionBar, [props]);
      _defineProperty(_this, "getViewOnlyReason", function (capability, benchEditable) {
        var _this$props$capabilit;
        var displayMessage;
        var stringBundle = {};
        if (benchEditable.cancelled) {
          displayMessage = 'This case is cancelled.';
        } else if (benchEditable.submitted) {
          displayMessage = 'This case is submitted.';
        }
        displayMessage = (displayMessage !== null && displayMessage !== void 0 ? displayMessage : '') + 'If you need permissions to edit this case, see your administrator.';
        if (conditionalUtils$4.capabilityValue((_this$props$capabilit = _this.props.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.oldCaseLoadedAlert) === null || _this$props$capabilit === void 0 ? void 0 : _this$props$capabilit.on)) {
          displayMessage = 'You are viewing a non-codable version of this case';
        }
        stringBundle[CapabilityAvailabilityReason$1.CONFIGURATION] = displayMessage;
        var reasons = conditionalUtils$4.getStrings(capability.on, stringBundle);
        return joinStrings(reasons, '.');
      });
      return _this;
    }
    _inherits(CodeBenchActionBar, _React$Component);
    return _createClass(CodeBenchActionBar, [{
      key: "render",
      value: function render() {
        var _processStatusStyleCl, _improvements$improve, _caseVersions$findInd, _processInstance$guid3, _activeItem$child_cas;
        var props = _objectSpread$i(_objectSpread$i({}, DEFAULT_PROPS$2), this.props);
        var cases = props.cases,
          benchEditable = props.benchEditable,
          processInstanceGuids = props.processInstanceGuids,
          loadState = props.loadState,
          activeItem = props.activeItem,
          processInstance = props.processInstance,
          capabilities = props.capabilities,
          toggleHoldCaseModal = props.toggleHoldCaseModal,
          toggleExclusionCaseModal = props.toggleExclusionCaseModal,
          showLateCaseClearModal = props.showLateCaseClearModal,
          toggleSplitCaseModal = props.toggleSplitCaseModal,
          toggleChargeableCase = props.toggleChargeableCase,
          holdCase = props.holdCase,
          holdCaseStatus = props.holdCaseStatus,
          improvements = props.improvements,
          caseVersions = props.caseVersions,
          toggleSubmitOldCaseModal = props.toggleSubmitOldCaseModal,
          getCaseVersions = props.getCaseVersions,
          cursorAPIContext = props.cursorAPIContext,
          submitOldCaseModal = props.submitOldCaseModal,
          caseAccessTime = props.caseAccessTime;
        var hasMulti = (cases === null || cases === void 0 ? void 0 : cases.length) > 1;
        var hasMultipleProcessInstances = (processInstanceGuids === null || processInstanceGuids === void 0 ? void 0 : processInstanceGuids.length) > 1;
        var showLoading = loadState.loading || loadState.initial;
        var buttonCancel, buttonSubmit, processStatusDetail, processStatusStyleClass, processStatusTitle;
        var statusDisplay = uiCommon.caseUtils.deriveStatus(activeItem);
        function handleAction(buttonAction) {
          var loc = processInstanceGuids.findIndex(function (item) {
            return item === buttonAction.item;
          });
          if (processInstanceGuids[loc]) {
            props.handleTraversal(processInstanceGuids[loc]);
          }
        }
        function handleCancel(event) {
          event.preventDefault();
          props.onInvoicesCancel(processInstance);
        }
        function handleSubmit(_x) {
          return _handleSubmit.apply(this, arguments);
        }
        function _handleSubmit() {
          _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
            var vwComment,
              button,
              cursorAPIPayload,
              _args = arguments;
            return _regeneratorRuntime.wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  vwComment = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
                  event.preventDefault();
                  // Disable the submit button to prevent multiple clicks during the submission process
                  button = event.currentTarget;
                  button.disabled = true;
                  cursorAPIPayload = {
                    operation: CursorOperation$2.NEXT,
                    cursorAPIContext: cursorAPIContext
                  };
                  _context.prev = 1;
                  _context.next = 2;
                  return getCaseVersions(processInstance);
                case 2:
                  if (!isCodeableVersion) {
                    _context.next = 4;
                    break;
                  }
                  _context.next = 3;
                  return props.onInvoicesSubmisson({
                    processInstance: processInstance,
                    uiMode: props.UIMode,
                    vwComment: vwComment,
                    cursorAPIPayload: cursorAPIPayload,
                    submitWithOverrideButton: false,
                    caseAccessTime: caseAccessTime,
                    activeItem: activeItem
                  });
                case 3:
                  _context.next = 5;
                  break;
                case 4:
                  toggleSubmitOldCaseModal();
                case 5:
                  _context.prev = 5;
                  // Re-enable the submit button after the submission process is complete
                  button.disabled = false;
                  return _context.finish(5);
                case 6:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[1,, 5, 6]]);
          }));
          return _handleSubmit.apply(this, arguments);
        }
        function handleNextPrev(event, operation) {
          event.preventDefault();
          var cursorAPIPayload = {
            operation: operation,
            cursorAPIContext: cursorAPIContext
          };
          props.onCursorAction(cursorAPIPayload);
        }
        function handleOpenCase(processInstanceGuid, caseUid) {
          if (processInstanceGuid) {
            var childWindowParams = getChildWindowParams$3(caseUid !== null && caseUid !== void 0 ? caseUid : activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_uid, processInstanceGuid, activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line, launchAmplifyCase, activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id);
            props.openChildWindow(childWindowParams);
          }
        }
        if (processInstance) {
          var _this$props, _this$props2, _processStatusDetail;
          processStatusDetail = benchEditableCore$2.determineProcessStatus({
            isChargeable: processInstance.isChargeable,
            processInstanceStatus: processInstance.status,
            holdReason: holdCaseStatus === null || holdCaseStatus === void 0 ? void 0 : holdCaseStatus.hold_reason,
            holdComment: holdCaseStatus === null || holdCaseStatus === void 0 ? void 0 : holdCaseStatus.comment,
            qaStatus: processInstance.qaStatus,
            roles: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.roles,
            cancelled: processInstance.cancelled,
            benchEditable: benchEditable,
            userContext: (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.userContext
          }, true, activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_caserun_uid);
          processStatusStyleClass = benchEditableCore$2.fecthProcessStatusClasses(processStatusDetail, processInstance === null || processInstance === void 0 ? void 0 : processInstance.hold_reason);
          processStatusTitle = (_processStatusDetail = processStatusDetail) !== null && _processStatusDetail !== void 0 && _processStatusDetail.toLowerCase().includes('hold') ? holdCaseStatus === null || holdCaseStatus === void 0 ? void 0 : holdCaseStatus.comment : '';
        }
        var styleClasses = ['code-bench-action-bar', {
          'bench-pre-editable': benchEditable.waiting,
          'bench-loading': loadState.loading,
          'multiple-cases': hasMulti,
          'single-case': cases.length == 0
        }];
        if (benchEditable.editable) {
          buttonCancel = /*#__PURE__*/React.createElement("button", {
            onClick: handleCancel,
            className: "chakra-secondary-button qa-cancel-action-link action-bar-button"
          }, "Void");
          buttonSubmit = /*#__PURE__*/React.createElement("button", {
            onClick: handleSubmit,
            className: "chakra-primary-button submit-btn qa-submit-action-link action-bar-button"
          }, "Check & Submit");
        } else if (benchEditable.submitted) {
          buttonSubmit = /*#__PURE__*/React.createElement("button", {
            disabled: true,
            className: "chakra-primary-button submit-btn disabled action-bar-button"
          }, "Checked & Submitted");
        } else if (benchEditable.cancelled) {
          buttonCancel = /*#__PURE__*/React.createElement("button", {
            disabled: true,
            className: "chakra-secondary-button submit-btn disabled action-bar-button"
          }, "Voided");
        }
        var pageButtons = !hasMultipleProcessInstances ? false : /*#__PURE__*/React.createElement(uiComponents.PageButtons, {
          locatorFn: locatorFn$1,
          handleAction: handleAction,
          items: processInstanceGuids,
          activeItem: activeItem,
          key: "page-buttons"
        });
        var viewOnlyComponent = /*#__PURE__*/React.createElement("div", {
          className: "view-only-section"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: !capabilities.submitInProgress
        }, /*#__PURE__*/React.createElement("span", null, "View only Mode ")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: capabilities.submitInProgress
        }, /*#__PURE__*/React.createElement("span", null, "Submission in progress... ")), /*#__PURE__*/React.createElement("strong", {
          title: this.getViewOnlyReason(capabilities.capabilities.viewOnlyCase, benchEditable)
        }, /*#__PURE__*/React.createElement("img", {
          className: "help-icon-image",
          src: img$1
        })));
        var statusClasses = ['chip', props.className, 'standalone-status', 'description', statusDisplay.styleClass];
        var versionClasses = [processStatusDetail ? 'withProcessStatus' : 'withOutProcessStatus', processStatusStyleClass && _toConsumableArray((_processStatusStyleCl = processStatusStyleClass) === null || _processStatusStyleCl === void 0 ? void 0 : _processStatusStyleCl.filter(function (item) {
          return item !== 'process-status';
        }))];

        /**
         * 1. improvement with provider query required and
         *  a. with no provider is counted as open improvement.
         *  b. with atleast one open provider reason is counted as open improvement.
         * 2. improvement with provider query
         *  a. not required is not an open improvement.
         *  b. required and had no provider reason as open, is not an open improvement.
         */
        var improvementCount = improvements === null || improvements === void 0 || (_improvements$improve = improvements.improvements) === null || _improvements$improve === void 0 ? void 0 : _improvements$improve.filter(function (improvement) {
          var _improvement$provider, _improvement$provider2;
          return (improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) && ((improvement === null || improvement === void 0 || (_improvement$provider = improvement.providers) === null || _improvement$provider === void 0 ? void 0 : _improvement$provider.length) === 0 || (improvement === null || improvement === void 0 || (_improvement$provider2 = improvement.providers) === null || _improvement$provider2 === void 0 ? void 0 : _improvement$provider2.some(function (provider) {
            return (provider === null || provider === void 0 ? void 0 : provider.provider_query_status) === DocumentStatus$3.OPEN;
          })));
        }).length;
        var currentVersionPosition = (_caseVersions$findInd = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex(function (caseVersion) {
          var _processInstance$guid;
          return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 || (_processInstance$guid = processInstance.guid) === null || _processInstance$guid === void 0 ? void 0 : _processInstance$guid.uuid);
        })) !== null && _caseVersions$findInd !== void 0 ? _caseVersions$findInd : -1;
        var currentVersion = typeof currentVersionPosition === 'number' && currentVersionPosition !== -1 ? currentVersionPosition + 1 : null;
        var newestVersionObject = (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 ? caseVersions.slice().reverse().find(function (caseVersion) {
          var _caseVersion$processI;
          return ((_caseVersion$processI = caseVersion.processInstanceStatus) === null || _caseVersion$processI === void 0 ? void 0 : _caseVersion$processI.indexOf('REPLACED')) < 0;
        }) : null;
        var currentVersionObject = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.find(function (caseVersion) {
          var _processInstance$guid2;
          return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 || (_processInstance$guid2 = processInstance.guid) === null || _processInstance$guid2 === void 0 ? void 0 : _processInstance$guid2.uuid);
        });
        var previousVersions = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.filter(function (_, index) {
          return index < currentVersionPosition;
        });
        var previousSentCase = previousVersions === null || previousVersions === void 0 ? void 0 : previousVersions.find(function (previousVersion) {
          return previousVersion.processInstanceStatus === AccelerateProcessStatus$2.SUBMITTED || previousVersion.processInstanceStatus === AccelerateProcessStatus$2.CANCELLED || previousVersion.processInstanceStatus === AccelerateProcessStatus$2.SENT;
        });
        var isCodeableVersion = true;
        if (newestVersionObject !== null && newestVersionObject !== void 0 && newestVersionObject.processInstanceGuid && processInstance !== null && processInstance !== void 0 && (_processInstance$guid3 = processInstance.guid) !== null && _processInstance$guid3 !== void 0 && _processInstance$guid3.uuid) {
          var _processInstance$guid4;
          isCodeableVersion = (newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid) === (processInstance === null || processInstance === void 0 || (_processInstance$guid4 = processInstance.guid) === null || _processInstance$guid4 === void 0 ? void 0 : _processInstance$guid4.uuid) && (processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.NEW || processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.IN_PROGRESS || (processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus) === uiCommon.commonEnums.ProcessQAStatus.IN_QA && processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.SUBMITTED);
        }
        var PrefixTitle = function PrefixTitle() {
          var _capabilities$capabil;
          if (caseVersions.every(function (caseVersion) {
            return (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) !== AccelerateProcessStatus$2.SUBMITTED;
          }) && previousVersions.filter(function (caseVersion) {
            var _processInstance$guid5;
            return caseVersion.processInstanceGuid !== (processInstance === null || processInstance === void 0 || (_processInstance$guid5 = processInstance.guid) === null || _processInstance$guid5 === void 0 ? void 0 : _processInstance$guid5.uuid);
          }).some(function (caseVersion) {
            return (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) === AccelerateProcessStatus$2.IN_PROGRESS || (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) === AccelerateProcessStatus$2.NEW;
          }) && ((currentVersionObject === null || currentVersionObject === void 0 ? void 0 : currentVersionObject.processInstanceStatus) === AccelerateProcessStatus$2.NEW || (currentVersionObject === null || currentVersionObject === void 0 ? void 0 : currentVersionObject.processInstanceStatus) === AccelerateProcessStatus$2.IN_PROGRESS)) {
            return /*#__PURE__*/React.createElement("div", {
              className: "dot bg-new"
            });
          }
          if (capabilities !== null && capabilities !== void 0 && (_capabilities$capabil = capabilities.capabilities) !== null && _capabilities$capabil !== void 0 && (_capabilities$capabil = _capabilities$capabil.previousSentCaseAlert) !== null && _capabilities$capabil !== void 0 && _capabilities$capabil.on.value) {
            return /*#__PURE__*/React.createElement("div", {
              className: "dot bg-update"
            });
          }
          return null;
        };
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(styleClasses)
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [toggleSplitCaseModal]
        }, /*#__PURE__*/React.createElement(CaseComment, {
          title: "Are you sure you want to split the case?",
          subtitle: "This case will be considered non-chargeable, will be kept for reference, and charges are not submitted for billing.",
          submitLabel: "yes, split the case",
          mandatoryComment: false,
          actionOnlyNoComment: true,
          onCancel: props.hideSplitCaseModal,
          onSubmit: function onSubmit() {
            props.splitCase(processInstance);
          }
        })), toggleHoldCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "Reason for holding a case",
          onClose: props.hideHoldCaseModal
        }, /*#__PURE__*/React.createElement(CaseHold, {
          onHold: function onHold(holdReason, comment) {
            return holdCase({
              holdReason: holdReason,
              comment: comment,
              processInstance: processInstance
            });
          },
          onCancel: props.hideHoldCaseModal
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.toggleCaseComment, /*#__PURE__*/React.createElement(CaseComment, {
          title: "Remove hold",
          submitLabel: "Remove Hold",
          mandatoryComment: false,
          onCancel: props.hideCaseCommentModal,
          onSubmit: function onSubmit(comment) {
            return holdCase({
              holdReason: HoldReasonType$1.OFF_HOLD,
              comment: comment,
              coding_manager_id: holdCaseStatus === null || holdCaseStatus === void 0 ? void 0 : holdCaseStatus.coding_manager_id,
              processInstance: processInstance
            });
          }
        })), toggleExclusionCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "Are you sure you want to ".concat(processInstance !== null && processInstance !== void 0 && processInstance.isChargeable ? 'exclude' : 'include', " this case?"),
          onClose: props.hideExclusionCaseModal
        }, /*#__PURE__*/React.createElement(CaseExclusion, {
          isChargeable: processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable,
          onCaseExclusion: function onCaseExclusion() {
            return toggleChargeableCase({
              serviceLine: processInstance.serviceLine,
              processInstanceGuid: processInstance.guid.uuid,
              isChargeable: !(processInstance !== null && processInstance !== void 0 && processInstance.isChargeable)
            });
          },
          onCancel: props.hideExclusionCaseModal
        })), showLateCaseClearModal && /*#__PURE__*/React.createElement(CaseComment, {
          title: "Are you sure you want to clear this late update notification. It cannot be undone?",
          submitLabel: "yes, clear the notiifcation",
          mandatoryComment: false,
          actionOnlyNoComment: true,
          onCancel: function onCancel() {
            return props.toggleLateCaseUpdateClearModal(false);
          },
          onSubmit: function onSubmit() {
            props.clearLateCaseUpdateNotification(processInstance);
          }
        }), submitOldCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "More recent version found",
          onClose: toggleSubmitOldCaseModal
        }, /*#__PURE__*/React.createElement("p", {
          className: "submit-stale-case-warning"
        }, "This version is no longer the most recent codable version of this case. It is locked from future editing. Please make your edits on the new version."), /*#__PURE__*/React.createElement("div", {
          className: "case-exclusion-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: toggleSubmitOldCaseModal,
          className: "chakra-secondary-button"
        }, "Cancel, keep me here"), /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            return handleOpenCase(newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid);
          },
          className: classnames('chakra-primary-button')
        }, "Ok, take me to the new case"))), !loadState.loading && /*#__PURE__*/React.createElement("div", {
          className: "action-bar coding-view-v1"
        }, /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-columns"
        }, /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-column nav-bar-left-column align-left"
        }, /*#__PURE__*/React.createElement("div", {
          className: "cols"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: classnames(statusClasses)
        }, /*#__PURE__*/React.createElement(StatusDescription, {
          caseRun: activeItem,
          isPreGoLive: props.isPreGoLive,
          secondaryIndicatorVisibility: false
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!!(activeItem !== null && activeItem !== void 0 && activeItem.parent_case)]
        }, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement(MenuButton, {
          label: "Merged",
          className: "merged-case-menu-button"
        }, activeItem === null || activeItem === void 0 || (_activeItem$child_cas = activeItem.child_case_list) === null || _activeItem$child_cas === void 0 ? void 0 : _activeItem$child_cas.map(function (childCase, index) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: index,
            onSelect: function onSelect() {
              return handleOpenCase(childCase.caserun_uid, childCase.case_uid);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "child-case-menu-item"
          }, /*#__PURE__*/React.createElement("span", null, "Case #".concat(childCase.case_id)), /*#__PURE__*/React.createElement("div", {
            className: "menu-item-tags"
          }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [childCase.type === 'primary']
          }, /*#__PURE__*/React.createElement("span", {
            className: "merge-originating-case primary"
          }, "Primary")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [(processInstance === null || processInstance === void 0 ? void 0 : processInstance.status) !== AccelerateProcessStatus$2.REMOVED]
          }, /*#__PURE__*/React.createElement("span", {
            className: "merge-originating-case inactive"
          }, "Inactive")))));
        })))), /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "version-process"
        }, (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 && /*#__PURE__*/React.createElement(MenuButton, {
          label: currentVersion ? "Version ".concat(currentVersion) : '',
          disabled: caseVersions.length === 1,
          prefixTitle: /*#__PURE__*/React.createElement(PrefixTitle, null),
          className: classnames(versionClasses)
        }, caseVersions.map(function (caseVersion, caseVersionIndex) {
          var _processInstance$guid6;
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: caseVersionIndex,
            onSelect: function onSelect() {
              return handleOpenCase(caseVersion.processInstanceGuid);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "version-item"
          }, /*#__PURE__*/React.createElement("p", null, "Version ", caseVersionIndex + 1), caseVersion.processInstanceCreatedDate && /*#__PURE__*/React.createElement("p", null, "Filing date:", ' ', uiCommon.cmxDateTime.format(getCaseVersionDate$1(caseVersion), uiCommon.cmxDateTime.FORMATS.DATE_TIME_UI)), caseVersion.processInstanceGuid !== (processInstance === null || processInstance === void 0 || (_processInstance$guid6 = processInstance.guid) === null || _processInstance$guid6 === void 0 ? void 0 : _processInstance$guid6.uuid) && (caseVersion.processInstanceStatus === AccelerateProcessStatus$2.IN_PROGRESS || caseVersion.processInstanceStatus === AccelerateProcessStatus$2.NEW) && /*#__PURE__*/React.createElement("p", null, "Coding Started")));
        })), processStatusDetail && /*#__PURE__*/React.createElement("div", {
          className: "".concat(classnames(processStatusStyleClass), " process-col"),
          title: processStatusTitle
        }, processStatusDetail))), improvementCount !== 0 && /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("div", {
          className: "chip improvement-reasons-needed",
          title: "".concat(improvementCount, " improvement ").concat(pluralize('reason', improvementCount), " need to be resolved")
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeReports",
          svgIconSize: "12",
          svgTitleText: "".concat(improvementCount, " improvement ").concat(pluralize('reason', improvementCount), " need to be resolved")
        }), improvementCount)))), /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-column nav-bar-right-column charge-submission-column action-column action-bar-right-column"
        }, /*#__PURE__*/React.createElement("div", {
          className: "cols right-cols"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.pagination, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, pageButtons)), !showLoading && /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.servicedeskAction, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(ev) {
            return handleNextPrev(ev, CursorOperation$2.NEXT);
          },
          className: "chakra-secondary-button prev-next-button action-bar-button"
        }, "Next", /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeRightArrow",
          svgIconSize: "12"
        })))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.actionMenu, /*#__PURE__*/React.createElement(MenuButton, {
          label: "Actions"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, _extends$1({}, capabilities.capabilities.actionMenuCancelButton, {
          displayMode: "flex"
        }), /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: handleCancel
        }, "Void Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.holdCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showHoldCaseModal
        }, "Hold Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.removeHoldCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showCaseCommentModal
        }, "Remove Hold")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.createCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.navigateCreateCase(activeItem);
          }
        }, "Create Case from Encounter/HAR")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.toggleChargeableCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showExclusionCaseModal
        }, processInstance !== null && processInstance !== void 0 && processInstance.isChargeable ? 'Exclude Case' : 'Include Case')), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.mergeCapability, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.showMergeCasesModal({
              caseRun: activeItem,
              cursorAPIContext: cursorAPIContext
            });
          }
        }, "Merge Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.splitCapability, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.showSplitCaseModal();
          }
        }, "Split Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.lateCaseClearNotification, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.toggleLateCaseClearModal(true);
          }
        }, "Clear late update notification")))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.generalCancelButton, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, buttonCancel)), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.submitCase, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, buttonSubmit)), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.viewOnlyCase, /*#__PURE__*/React.createElement("div", {
          className: "col"
        }, viewOnlyComponent))))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.previousSentCaseAlert, /*#__PURE__*/React.createElement(CaseAlert, {
          alertType: CaseAlertType$1.ERROR
        }, "This is an update to a", ' ', /*#__PURE__*/React.createElement("a", {
          className: "anchor-chakra-link",
          onClick: function onClick() {
            return handleOpenCase(previousSentCase === null || previousSentCase === void 0 ? void 0 : previousSentCase.processInstanceGuid);
          }
        }, "previously submitted case"), ".")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.oldCaseLoadedAlert, /*#__PURE__*/React.createElement(CaseAlert, {
          alertType: CaseAlertType$1.WARNING
        }, "You are viewing a non-codable version of this case. View the", ' ', /*#__PURE__*/React.createElement("a", {
          className: "anchor-chakra-link",
          onClick: function onClick() {
            return handleOpenCase(newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid);
          }
        }, "codable version"))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          some: [!!(activeItem !== null && activeItem !== void 0 && activeItem.parent_process_instance_uid)]
        }, /*#__PURE__*/React.createElement(CaseAlert, {
          alertType: CaseAlertType$1.INFO,
          alertSize: "sm"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!!(activeItem !== null && activeItem !== void 0 && activeItem.parent_process_instance_uid)]
        }, /*#__PURE__*/React.createElement("span", null, "This case is no longer active. It has been merged into: case", /*#__PURE__*/React.createElement("a", {
          className: "anchor-chakra-link",
          onClick: function onClick() {
            return handleOpenCase(activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_process_instance_uid, activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_case_uid);
          }
        }, ' ', "#", activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_case_id)))))));
      }
    }]);
  }(React.Component);

  function ItemSelect(_ref) {
    var items = _ref.items,
      selectedItem = _ref.selectedItem,
      getItemLabel = _ref.getItemLabel,
      onItemSelect = _ref.onItemSelect,
      renderItem = _ref.renderItem,
      buttonLabel = _ref.buttonLabel,
      prefixTitle = _ref.prefixTitle,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$disableWhenSingl = _ref.disableWhenSingle,
      disableWhenSingle = _ref$disableWhenSingl === void 0 ? true : _ref$disableWhenSingl,
      _ref$isGrouped = _ref.isGrouped,
      isGrouped = _ref$isGrouped === void 0 ? false : _ref$isGrouped,
      isSelected = _ref.isSelected,
      secondaryLabel = _ref.secondaryLabel;
    if (!(items !== null && items !== void 0 && items.length)) {
      return null;
    }
    var renderMenuItems = function renderMenuItems(itemsToRender, groupLabel) {
      return itemsToRender.map(function (item, index) {
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: groupLabel ? "".concat(groupLabel, "-").concat(index) : index,
          onSelect: function onSelect() {
            return onItemSelect(item);
          },
          className: isSelected(selectedItem, item) ? 'selected' : ''
        }, renderItem(item, index));
      });
    };
    var renderGroups = function renderGroups(groups) {
      return groups.map(function (group, groupIndex) {
        return /*#__PURE__*/React.createElement("div", {
          key: "group-".concat(groupIndex),
          className: "menu-group"
        }, /*#__PURE__*/React.createElement("div", {
          className: "menu-group-title"
        }, group.label), renderMenuItems(group.items, group.label));
      });
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "item-select-container"
    }, /*#__PURE__*/React.createElement(MenuButton, {
      label: buttonLabel || (selectedItem ? getItemLabel(selectedItem) : ''),
      secondaryLabel: secondaryLabel,
      disabled: disabled || disableWhenSingle && items.length === 1,
      prefixTitle: prefixTitle,
      className: classnames('item-select-button', className)
    }, isGrouped ? renderGroups(items) : renderMenuItems(items)));
  }

  var CountdownTimer = function CountdownTimer(props) {
    var timeDurationLeft = props.timeDurationLeft,
      doClearInterval = props.doClearInterval;
    var _useState = React.useState(timeDurationLeft),
      _useState2 = _slicedToArray(_useState, 2),
      timeLeft = _useState2[0],
      setTimeLeft = _useState2[1];
    var _useState3 = React.useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      timerId = _useState4[0],
      setTimerId = _useState4[1];
    React.useEffect(function () {
      setTimeLeft(timeDurationLeft);
    }, [timeDurationLeft]);
    var countDownTimer = React.useCallback(function () {
      setTimeLeft(function (prevTime) {
        return prevTime ? prevTime - 1 : 0;
      });
    }, []);
    React.useEffect(function () {
      var interval = setInterval(countDownTimer, 1000);
      setTimerId(interval);
      return function () {
        return clearInterval(interval);
      };
    }, [countDownTimer]);
    React.useEffect(function () {
      if (timeLeft <= 0) {
        clearInterval(timerId);
        doClearInterval();
      }
    }, [timeLeft]);
    var formatTime = function formatTime(timeInSeconds) {
      var minutes = Math.floor(timeInSeconds / 60);
      var remainingSeconds = timeInSeconds % 60;
      return "".concat(minutes.toString().padStart(2, '0'), ":").concat(remainingSeconds.toString().padStart(2, '0'));
    };
    return /*#__PURE__*/React.createElement(Text, null, formatTime(timeLeft));
  };

  /**
   * Used for grading projects that do not leverage Rubric/Workflow Collectons which makes validation calls against the CQA Service. Cerca 2025. 
   * Determines if all CQA work items in the given grade bench panel state are evaluated. Uses the project configuration to determine which codes and assessment fields are required.
   *
   * @param {Accelerate.GradeBenchPanelState} gradeBenchPanelState - The state of the grade bench panel containing QA rules and invoices.
   * @returns {boolean} - Returns true if all work items are evaluated, otherwise false.
   */
  var isCQAWorkItemEvaluatedLegacy = function isCQAWorkItemEvaluatedLegacy(projectConfiguration, invoices) {
    if (!projectConfiguration || !invoices) {
      return true;
    }
    /**
     * Checks if a given code is evaluated based on the project configuration.
     *
     * @param {Accelerate.CQACode} code - The code to evaluate.
     * @returns {boolean} - Returns true if the code is evaluated, otherwise false.
     */
    var isCodeEvaluated = function isCodeEvaluated(code) {
      var _code$codeAssessment, _code$codeAssessment2;
      if (projectConfiguration.assessment && !((_code$codeAssessment = code.codeAssessment) !== null && _code$codeAssessment !== void 0 && _code$codeAssessment.assessment)) {
        return false;
      }
      if (projectConfiguration.role && !((_code$codeAssessment2 = code.codeAssessment) !== null && _code$codeAssessment2 !== void 0 && _code$codeAssessment2.role)) {
        return false;
      }
      return true;
    };

    /**
     * Checks if all codes in the given array are evaluated.
     *
     * @param {Accelerate.CQACode[]} codes - The array of codes to evaluate.
     * @returns {boolean} - Returns true if all codes are evaluated, otherwise false.
     */
    var checkIfCodesEvaluated = function checkIfCodesEvaluated(codes) {
      return codes.every(function (c) {
        return isCodeEvaluated(c);
      });
    };
    return invoices.every(function (invoice) {
      return invoice.transactions.every(function (transaction) {
        if (projectConfiguration['procedure'] && !checkIfCodesEvaluated(transaction.procedures)) {
          return false;
        }
        if (projectConfiguration['diagnosis'] && !checkIfCodesEvaluated(transaction.diagnoses)) {
          return false;
        }
        if (projectConfiguration['modifier'] && !checkIfCodesEvaluated(transaction.modifiers)) {
          return false;
        }
        return true;
      });
    });
  };

  function _callSuper$c(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$c() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$c() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$c = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$h(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$h(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$h(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$h(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var conditionalUtils$3 = uiCommon.AmplifyCore.conditionalUtils,
    benchEditableCore$1 = uiCommon.AmplifyCore.benchEditable;
  var getChildWindowParams$2 = uiCommon.caseUtils.getChildWindowParams;
  var CapabilityAvailabilityReason = uiCommon.commonEnums.CapabilityAvailabilityReason,
    HoldReasonType = uiCommon.commonEnums.HoldReasonType,
    DocumentStatus$2 = uiCommon.commonEnums.DocumentStatus,
    CursorOperation$1 = uiCommon.commonEnums.CursorOperation,
    AccelerateProcessStatus$1 = uiCommon.commonEnums.AccelerateProcessStatus,
    BenchMode = uiCommon.commonEnums.BenchMode;
    uiCommon.commonEnums.CaseAlertType;
    var CaseAccessState = uiCommon.commonEnums.CaseAccessState;

  // Add isCaseAvailable function
  var isCaseAvailable = function isCaseAvailable(caseAccessState) {
    return caseAccessState === CaseAccessState.NONE || caseAccessState === CaseAccessState.ACQUIRED;
  };
  var DEFAULT_PROPS$1 = {
    processInstanceGuids: [],
    benchEditable: _objectSpread$h({}, uiCommon.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
    capabilities: _objectSpread$h({}, uiCommon.AmplifyCore.state.capabilities),
    caseVersions: [],
    itemSelectorProps: undefined,
    submitButtonConfig: {
      enabled: true,
      text: '',
      tooltip: '',
      icon: '',
      classNames: []
    },
    nextVersionButtonConfig: {
      enabled: false,
      text: '',
      tooltip: '',
      icon: ''
    },
    caseAccessState: CaseAccessState.NONE
  };
  var locatorFn = function locatorFn(activeItem, item) {
    var _item$split = item.split(':'),
      _item$split2 = _slicedToArray(_item$split, 2),
      processInstanceGuid = _item$split2[1];
    return processInstanceGuid === activeItem.process_instance_guid;
  };
  var getCaseVersionDate = function getCaseVersionDate(version) {
    var dateVersion = new Date(version.processInstanceCreatedDate);
    if (isNaN(dateVersion.valueOf())) {
      return version.processInstanceCreatedDate;
    } else {
      return dateVersion;
    }
  };
  var CodeBenchActionBarv2Base = /*#__PURE__*/function (_React$Component) {
    function CodeBenchActionBarv2Base(props) {
      var _this;
      _classCallCheck(this, CodeBenchActionBarv2Base);
      _this = _callSuper$c(this, CodeBenchActionBarv2Base, [props]);
      _defineProperty(_this, "getViewOnlyReason", function (capability, benchEditable) {
        var _this$props$capabilit;
        var displayMessage;
        var stringBundle = {};
        if (benchEditable.cancelled) {
          displayMessage = 'This case is cancelled.';
        } else if (benchEditable.submitted) {
          displayMessage = 'This case is submitted.';
        }
        displayMessage = (displayMessage !== null && displayMessage !== void 0 ? displayMessage : '') + 'If you need permissions to edit this case, see your administrator.';
        if (conditionalUtils$3.capabilityValue((_this$props$capabilit = _this.props.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.capabilities) === null || _this$props$capabilit === void 0 || (_this$props$capabilit = _this$props$capabilit.oldCaseLoadedAlert) === null || _this$props$capabilit === void 0 ? void 0 : _this$props$capabilit.on)) {
          displayMessage = 'You are viewing an non-codable version of this case';
        }
        stringBundle[CapabilityAvailabilityReason.CONFIGURATION] = displayMessage;
        var reasons = conditionalUtils$3.getStrings(capability.on, stringBundle);
        return joinStrings(reasons, '.');
      });
      _defineProperty(_this, "doClearInterval", function () {
        _this.setState({
          disableCountDownTimer: true
        });
        setTimeout(function () {
          _this.props.refreshHoldSubmission(_this.props.activeItem);
        }, 1000);
      });
      _this.state = {
        disableCountDownTimer: false
      };
      _this.doClearInterval = _this.doClearInterval.bind(_this);
      return _this;
    }
    _inherits(CodeBenchActionBarv2Base, _React$Component);
    return _createClass(CodeBenchActionBarv2Base, [{
      key: "render",
      value: function render() {
        var _submitButtonConfig$c, _nextVersionButtonCon, _processStatusStyleCl, _improvements$improve, _caseVersions$findInd, _processInstance$guid3, _activeItem$child_cas, _capabilities$capabil2;
        var props = _objectSpread$h(_objectSpread$h({}, DEFAULT_PROPS$1), this.props);
        var cases = props.cases,
          benchEditable = props.benchEditable,
          processInstanceGuids = props.processInstanceGuids,
          loadState = props.loadState,
          activeItem = props.activeItem,
          processInstance = props.processInstance,
          capabilities = props.capabilities,
          toggleHoldCaseModal = props.toggleHoldCaseModal,
          toggleExclusionCaseModal = props.toggleExclusionCaseModal,
          showLateCaseClearModal = props.showLateCaseClearModal,
          toggleSplitCaseModal = props.toggleSplitCaseModal,
          toggleChargeableCase = props.toggleChargeableCase,
          holdCase = props.holdCase,
          holdCaseStatus = props.holdCaseStatus,
          improvements = props.improvements,
          caseVersions = props.caseVersions,
          toggleSubmitOldCaseModal = props.toggleSubmitOldCaseModal;
          props.getCaseVersions;
          var cursorAPIContext = props.cursorAPIContext,
          submitOldCaseModal = props.submitOldCaseModal;
          props.caseAccessTime;
          var benchMode = props.benchMode,
          handleSubmitCase = props.handleSubmitCase,
          submitButtonConfig = props.submitButtonConfig,
          onNextVersion = props.onNextVersion,
          nextVersionButtonConfig = props.nextVersionButtonConfig,
          caseAccessState = props.caseAccessState,
          workItem = props.workItem;
        var hasMulti = (cases === null || cases === void 0 ? void 0 : cases.length) > 1;
        var hasMultipleProcessInstances = (processInstanceGuids === null || processInstanceGuids === void 0 ? void 0 : processInstanceGuids.length) > 1;
        var showLoading = loadState.loading || loadState.initial;
        var isSubmitDisabled = benchMode === BenchMode.GRADE && (!submitButtonConfig.enabled || this.props.canSubmit === false);
        var submitButtonStyle = ['chakra-primary-button', 'submit-btn', 'qa-submit-action-link', 'action-bar-button', {
          disabled: isSubmitDisabled
        }].concat(_toConsumableArray((_submitButtonConfig$c = submitButtonConfig.classNames) !== null && _submitButtonConfig$c !== void 0 ? _submitButtonConfig$c : []));
        var nextVersionButtonStyle = ['chakra-secondary-button', 'prev-next-button', 'action-bar-button', {
          disabled: !nextVersionButtonConfig.enabled
        }].concat(_toConsumableArray((_nextVersionButtonCon = nextVersionButtonConfig.classNames) !== null && _nextVersionButtonCon !== void 0 ? _nextVersionButtonCon : []));
        var buttonCancel, buttonSubmit, processStatusDetail, processStatusStyleClass, processStatusTitle;
        var statusDisplay = uiCommon.caseUtils.deriveStatus(activeItem);
        function handleAction(buttonAction) {
          var loc = processInstanceGuids.findIndex(function (item) {
            return item === buttonAction.item;
          });
          if (processInstanceGuids[loc]) {
            props.handleTraversal(processInstanceGuids[loc]);
          }
        }
        function handleCancel(event) {
          event.preventDefault();
          props.onInvoicesCancel(processInstance);
        }
        function handleSubmit(_x) {
          return _handleSubmit.apply(this, arguments);
        } // CQA-UI: handleBack handler
        function _handleSubmit() {
          _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
            var vwComment,
              _args = arguments;
            return _regeneratorRuntime.wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  vwComment = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
                  event.preventDefault();
                  handleSubmitCase(event, vwComment, isCodeableVersion);
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          return _handleSubmit.apply(this, arguments);
        }
        function handleBack() {
          props.navigate("/cmx/".concat(props.backToWorklistPath));
          props.showSideNavBar();
        }
        function handleNextPrev(event, operation, hasAmplifyCaseRunV2Access) {
          event.preventDefault();
          var cursorAPIPayload = {
            operation: operation,
            cursorAPIContext: cursorAPIContext,
            hasAmplifyCaseRunV2Access: hasAmplifyCaseRunV2Access
          };
          props.onCursorAction(cursorAPIPayload);
        }
        function handleNextVersion(event, operation, hasAmplifyCaseRunV2Access) {
          event.preventDefault();
          var cursorAPIPayload = {
            operation: operation,
            cursorAPIContext: cursorAPIContext,
            hasAmplifyCaseRunV2Access: hasAmplifyCaseRunV2Access
          };
          onNextVersion(cursorAPIPayload);
        }
        function handleOpenCase(processInstanceGuid, caseUid) {
          if (processInstanceGuid) {
            var childWindowParams = getChildWindowParams$2(caseUid !== null && caseUid !== void 0 ? caseUid : activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_uid, processInstanceGuid, activeItem === null || activeItem === void 0 ? void 0 : activeItem.service_line, launchAmplifyCase, activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id);
            props.openChildWindow(childWindowParams);
          }
        }
        if (processInstance) {
          var _this$props, _this$props2, _processStatusDetail;
          processStatusDetail = benchEditableCore$1.determineProcessStatus({
            isChargeable: processInstance.isChargeable,
            processInstanceStatus: processInstance.status,
            holdReason: holdCaseStatus.hold_reason,
            holdComment: holdCaseStatus.comment,
            qaStatus: processInstance.qaStatus,
            roles: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.roles,
            cancelled: processInstance.cancelled,
            benchEditable: benchEditable,
            userContext: (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.userContext
          }, true, activeItem === null || activeItem === void 0 ? void 0 : activeItem.parent_caserun_uid);
          processStatusStyleClass = benchEditableCore$1.fecthProcessStatusClasses(processStatusDetail, holdCaseStatus.hold_reason);
          processStatusTitle = (_processStatusDetail = processStatusDetail) !== null && _processStatusDetail !== void 0 && _processStatusDetail.toLowerCase().includes('hold') ? holdCaseStatus.comment : '';
        }
        var styleClasses = ['code-bench-action-barv2', {
          'bench-pre-editable': benchEditable.waiting,
          'bench-loading': loadState.loading,
          'multiple-cases': hasMulti,
          'single-case': cases.length == 0
        }];
        if (benchEditable.editable) {
          buttonCancel = /*#__PURE__*/React.createElement("button", {
            onClick: handleCancel,
            className: "chakra-secondary-button qa-cancel-action-link action-bar-button"
          }, "Void");
          buttonSubmit = /*#__PURE__*/React.createElement("button", {
            onClick: handleSubmit,
            className: classnames(submitButtonStyle),
            disabled: isSubmitDisabled,
            title: submitButtonConfig.tooltip
          }, this.props.isValidating ? /*#__PURE__*/React.createElement(Spinner, {
            size: "xs",
            speed: "0.8s",
            mr: 2
          }) : submitButtonConfig.icon ? /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
            svgIconName: submitButtonConfig.icon,
            svgIconSize: "20"
          }) : null, benchMode == BenchMode.GRADE ? submitButtonConfig.text : !!(processInstance !== null && processInstance !== void 0 && processInstance.holdSubmission) && !(processInstance !== null && processInstance !== void 0 && processInstance.isCurrentInvoiceSubmitted) ? 'Check & Resubmit' : 'Check & Submit');
        } else if (benchEditable.submitted) {
          buttonSubmit = /*#__PURE__*/React.createElement("button", {
            disabled: true,
            className: "chakra-primary-button submit-btn disabled action-bar-button"
          }, benchMode == BenchMode.GRADE ? 'Submitted' : 'Checked & Submitted');
        } else if (benchEditable.cancelled) {
          buttonCancel = /*#__PURE__*/React.createElement("button", {
            disabled: true,
            className: "chakra-secondary-button submit-btn disabled action-bar-button"
          }, "Voided");
        }
        var pageButtons = !hasMultipleProcessInstances ? null : /*#__PURE__*/React.createElement(uiComponents.PageButtons, {
          locatorFn: locatorFn,
          handleAction: handleAction,
          items: processInstanceGuids,
          activeItem: activeItem,
          key: "page-buttons"
        });
        var viewOnlyComponent = /*#__PURE__*/React.createElement("div", {
          className: "view-only-section"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: !capabilities.submitInProgress
        }, /*#__PURE__*/React.createElement("span", null, "View only Mode")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: capabilities.submitInProgress
        }, /*#__PURE__*/React.createElement("span", null, "Submission in progress... ")), /*#__PURE__*/React.createElement("strong", {
          title: this.getViewOnlyReason(capabilities.capabilities.viewOnlyCase, benchEditable)
        }, /*#__PURE__*/React.createElement(r, {
          iconName: e.Info,
          iconClass: "help-icon",
          iconSize: "20"
        })));
        var statusClasses = ['chip', props.className, 'standalone-status', 'description', statusDisplay.styleClass];
        var versionClasses = [processStatusDetail ? 'withProcessStatus' : 'withOutProcessStatus', processStatusStyleClass && _toConsumableArray((_processStatusStyleCl = processStatusStyleClass) === null || _processStatusStyleCl === void 0 ? void 0 : _processStatusStyleCl.filter(function (item) {
          return item !== 'process-status';
        }))];

        /**
         * 1. improvement with provider query required and
         *  a. with no provider is counted as open improvement.
         *  b. with atleast one open provider reason is counted as open improvement.
         * 2. improvement with provider query
         *  a. not required is not an open improvement.
         *  b. required and had no provider reason as open, is not an open improvement.
         */
        var improvementCount = improvements === null || improvements === void 0 || (_improvements$improve = improvements.improvements) === null || _improvements$improve === void 0 ? void 0 : _improvements$improve.filter(function (improvement) {
          var _improvement$provider, _improvement$provider2;
          return (improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) && ((improvement === null || improvement === void 0 || (_improvement$provider = improvement.providers) === null || _improvement$provider === void 0 ? void 0 : _improvement$provider.length) === 0 || (improvement === null || improvement === void 0 || (_improvement$provider2 = improvement.providers) === null || _improvement$provider2 === void 0 ? void 0 : _improvement$provider2.some(function (provider) {
            return (provider === null || provider === void 0 ? void 0 : provider.provider_query_status) === DocumentStatus$2.OPEN;
          })));
        }).length;
        var currentVersionPosition = (_caseVersions$findInd = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex(function (caseVersion) {
          var _processInstance$guid;
          return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 || (_processInstance$guid = processInstance.guid) === null || _processInstance$guid === void 0 ? void 0 : _processInstance$guid.uuid);
        })) !== null && _caseVersions$findInd !== void 0 ? _caseVersions$findInd : -1;
        var currentVersion = typeof currentVersionPosition === 'number' && currentVersionPosition !== -1 ? currentVersionPosition + 1 : null;
        var newestVersionObject = (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 ? caseVersions.slice().reverse().find(function (caseVersion) {
          var _caseVersion$processI;
          return ((_caseVersion$processI = caseVersion.processInstanceStatus) === null || _caseVersion$processI === void 0 ? void 0 : _caseVersion$processI.indexOf('REPLACED')) < 0;
        }) : null;
        var currentVersionObject = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.find(function (caseVersion) {
          var _processInstance$guid2;
          return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 || (_processInstance$guid2 = processInstance.guid) === null || _processInstance$guid2 === void 0 ? void 0 : _processInstance$guid2.uuid);
        });
        var previousVersions = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.filter(function (_, index) {
          return index < currentVersionPosition;
        });
        var isCodeableVersion = true;
        if (newestVersionObject !== null && newestVersionObject !== void 0 && newestVersionObject.processInstanceGuid && processInstance !== null && processInstance !== void 0 && (_processInstance$guid3 = processInstance.guid) !== null && _processInstance$guid3 !== void 0 && _processInstance$guid3.uuid) {
          var _processInstance$guid4;
          isCodeableVersion = (newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid) === (processInstance === null || processInstance === void 0 || (_processInstance$guid4 = processInstance.guid) === null || _processInstance$guid4 === void 0 ? void 0 : _processInstance$guid4.uuid) && (processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.NEW || processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.IN_PROGRESS || ((processInstance === null || processInstance === void 0 ? void 0 : processInstance.qaStatus) === uiCommon.commonEnums.ProcessQAStatus.IN_QA || !!(processInstance !== null && processInstance !== void 0 && processInstance.holdSubmission)) && processInstance.status === uiCommon.commonEnums.AccelerateProcessStatus.SUBMITTED);
        }
        var PrefixTitle = function PrefixTitle() {
          var _capabilities$capabil;
          if (caseVersions.every(function (caseVersion) {
            return (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) !== AccelerateProcessStatus$1.SUBMITTED;
          }) && previousVersions.filter(function (caseVersion) {
            var _processInstance$guid5;
            return caseVersion.processInstanceGuid !== (processInstance === null || processInstance === void 0 || (_processInstance$guid5 = processInstance.guid) === null || _processInstance$guid5 === void 0 ? void 0 : _processInstance$guid5.uuid);
          }).some(function (caseVersion) {
            return (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) === AccelerateProcessStatus$1.IN_PROGRESS || (caseVersion === null || caseVersion === void 0 ? void 0 : caseVersion.processInstanceStatus) === AccelerateProcessStatus$1.NEW;
          }) && ((currentVersionObject === null || currentVersionObject === void 0 ? void 0 : currentVersionObject.processInstanceStatus) === AccelerateProcessStatus$1.NEW || (currentVersionObject === null || currentVersionObject === void 0 ? void 0 : currentVersionObject.processInstanceStatus) === AccelerateProcessStatus$1.IN_PROGRESS)) {
            return /*#__PURE__*/React.createElement("div", {
              className: "dot bg-new"
            });
          }

          //@ts-ignore
          if (capabilities !== null && capabilities !== void 0 && (_capabilities$capabil = capabilities.capabilities) !== null && _capabilities$capabil !== void 0 && (_capabilities$capabil = _capabilities$capabil.previousSentCaseAlert) !== null && _capabilities$capabil !== void 0 && _capabilities$capabil.on.value) {
            return /*#__PURE__*/React.createElement("div", {
              className: "dot bg-update"
            });
          }
          return null;
        };
        var timeDuration = uiCommon.cmxDateTime.calculateDurationDateFns(uiCommon.cmxDateTime.format(new Date(), uiCommon.cmxDateTime.FORMATS.DATE_TIME_WITH_ZONE), processInstance === null || processInstance === void 0 ? void 0 : processInstance.holdSubmissionDate);
        var timeDurationInSeconds = ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.hours) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.hours : 0) * 60 + ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.minutes) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.minutes : 0) * 60 + ((timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.seconds) > 0 ? timeDuration === null || timeDuration === void 0 ? void 0 : timeDuration.seconds : 0);
        var showHoldSubmissionTimer = (processInstance === null || processInstance === void 0 ? void 0 : processInstance.holdSubmission) && timeDurationInSeconds > 0;
        return /*#__PURE__*/React.createElement("div", {
          className: classnames(styleClasses)
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [toggleSplitCaseModal]
        }, /*#__PURE__*/React.createElement(CaseComment, {
          title: "Are you sure you want to split the case?",
          subtitle: "This case will be considered non-chargeable, will be kept for reference, and charges are not submitted for billing.",
          submitLabel: "yes, split the case",
          mandatoryComment: false,
          actionOnlyNoComment: true,
          onCancel: props.hideSplitCaseModal,
          onSubmit: function onSubmit() {
            props.splitCase(processInstance);
          }
        })), toggleHoldCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "Reason for holding a case",
          onClose: props.hideHoldCaseModal
        }, /*#__PURE__*/React.createElement(CaseHold, {
          onHold: function onHold(holdReason, comment) {
            return holdCase({
              holdReason: holdReason,
              comment: comment,
              processInstance: processInstance
            });
          },
          onCancel: props.hideHoldCaseModal
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.toggleCaseComment, /*#__PURE__*/React.createElement(CaseComment, {
          title: "Remove hold",
          submitLabel: "Remove Hold",
          mandatoryComment: false,
          onCancel: props.hideCaseCommentModal,
          onSubmit: function onSubmit(comment) {
            return holdCase({
              holdReason: HoldReasonType.OFF_HOLD,
              comment: comment,
              coding_manager_id: holdCaseStatus === null || holdCaseStatus === void 0 ? void 0 : holdCaseStatus.coding_manager_id,
              processInstance: processInstance
            });
          }
        })), toggleExclusionCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "Are you sure you want to ".concat(processInstance !== null && processInstance !== void 0 && processInstance.isChargeable ? 'exclude' : 'include', " this case?"),
          onClose: props.hideExclusionCaseModal
        }, /*#__PURE__*/React.createElement(CaseExclusion, {
          isChargeable: processInstance === null || processInstance === void 0 ? void 0 : processInstance.isChargeable,
          onCaseExclusion: function onCaseExclusion() {
            return toggleChargeableCase({
              serviceLine: processInstance.serviceLine,
              processInstanceGuid: processInstance.guid.uuid,
              isChargeable: !(processInstance !== null && processInstance !== void 0 && processInstance.isChargeable)
            });
          },
          onCancel: props.hideExclusionCaseModal
        })), showLateCaseClearModal && /*#__PURE__*/React.createElement(CaseComment, {
          title: "Are you sure you want to clear this late update notification. It cannot be undone?",
          submitLabel: "yes, clear the notiifcation",
          mandatoryComment: false,
          actionOnlyNoComment: true,
          onCancel: function onCancel() {
            return props.toggleLateCaseClearModal(false);
          },
          onSubmit: function onSubmit() {
            props.clearLateCaseNotification(processInstance);
          }
        }), submitOldCaseModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "More recent version found",
          onClose: toggleSubmitOldCaseModal
        }, /*#__PURE__*/React.createElement("p", {
          className: "submit-stale-case-warning"
        }, "This version is no longer the most recent codable version of this case. It is locked from future editing. Please make your edits on the new version."), /*#__PURE__*/React.createElement("div", {
          className: "case-exclusion-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: toggleSubmitOldCaseModal,
          className: "chakra-secondary-button"
        }, "Cancel, keep me here"), /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            return handleOpenCase(newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid);
          },
          className: classnames('chakra-primary-button')
        }, "Ok, take me to the new case"))), !loadState.loading && /*#__PURE__*/React.createElement("div", {
          className: "action-bar"
        }, /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-columns"
        }, /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-column nav-bar-left-column align-left"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: handleBack,
          className: "chakra-secondary-button back-to-worklist-button action-bar-button"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeLeftArrow",
          svgIconSize: "20",
          svgIconClass: "left-arrow"
        }), "Back to Worklist"), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.statusDescription, /*#__PURE__*/React.createElement("div", {
          className: classnames(statusClasses)
        }, /*#__PURE__*/React.createElement(StatusDescription, {
          caseRun: activeItem,
          isPreGoLive: props.isPreGoLive,
          secondaryIndicatorVisibility: false
        }))), this.props.itemSelectorProps && /*#__PURE__*/React.createElement(ItemSelect, this.props.itemSelectorProps), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!!(activeItem !== null && activeItem !== void 0 && activeItem.parent_case)]
        }, /*#__PURE__*/React.createElement(MenuButton, {
          label: "Merged",
          className: "merged-case-menu-button"
        }, activeItem === null || activeItem === void 0 || (_activeItem$child_cas = activeItem.child_case_list) === null || _activeItem$child_cas === void 0 ? void 0 : _activeItem$child_cas.map(function (childCase, index) {
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: index,
            onSelect: function onSelect() {
              return handleOpenCase(childCase.caserun_uid, childCase.case_uid);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "child-case-menu-item"
          }, /*#__PURE__*/React.createElement("span", null, "Case #".concat(childCase.case_id)), /*#__PURE__*/React.createElement("div", {
            className: "menu-item-tags"
          }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [childCase.type === 'primary']
          }, /*#__PURE__*/React.createElement("span", {
            className: "merge-originating-case primary"
          }, "Primary")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [(processInstance === null || processInstance === void 0 ? void 0 : processInstance.status) !== AccelerateProcessStatus$1.REMOVED]
          }, /*#__PURE__*/React.createElement("span", {
            className: "merge-originating-case inactive"
          }, "Inactive")))));
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.versionProcess, /*#__PURE__*/React.createElement("div", {
          className: "version-process"
        }, (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 && /*#__PURE__*/React.createElement(MenuButton, {
          label: currentVersion ? "Version ".concat(currentVersion) : '',
          disabled: caseVersions.length === 1,
          prefixTitle: /*#__PURE__*/React.createElement(PrefixTitle, null),
          className: classnames(versionClasses)
        }, caseVersions.map(function (caseVersion, caseVersionIndex) {
          var _processInstance$guid6;
          return /*#__PURE__*/React.createElement(MenuItem, {
            key: caseVersionIndex,
            onSelect: function onSelect() {
              return handleOpenCase(caseVersion.processInstanceGuid);
            }
          }, /*#__PURE__*/React.createElement("div", {
            className: "version-item"
          }, /*#__PURE__*/React.createElement("p", null, "Version ", caseVersionIndex + 1), caseVersion.processInstanceCreatedDate && /*#__PURE__*/React.createElement("p", null, "Filing date:", ' ', uiCommon.cmxDateTime.format(getCaseVersionDate(caseVersion), uiCommon.cmxDateTime.FORMATS.DATE_TIME_UI)), caseVersion.processInstanceGuid !== (processInstance === null || processInstance === void 0 || (_processInstance$guid6 = processInstance.guid) === null || _processInstance$guid6 === void 0 ? void 0 : _processInstance$guid6.uuid) && (caseVersion.processInstanceStatus === AccelerateProcessStatus$1.IN_PROGRESS || caseVersion.processInstanceStatus === AccelerateProcessStatus$1.NEW) && /*#__PURE__*/React.createElement("p", null, "Coding Started")));
        })), (!showHoldSubmissionTimer || this.state.disableCountDownTimer) && processStatusDetail && /*#__PURE__*/React.createElement("div", {
          className: "".concat(classnames(processStatusStyleClass), " process-col"),
          title: processStatusTitle
        }, processStatusDetail), showHoldSubmissionTimer && !this.state.disableCountDownTimer && /*#__PURE__*/React.createElement(Flex, {
          className: "".concat(classnames(processStatusStyleClass), " process-col")
        }, "Pending (", /*#__PURE__*/React.createElement(CountdownTimer, {
          timeDurationLeft: timeDurationInSeconds,
          doClearInterval: this.doClearInterval
        }), " \xA0 remaining)"))), improvementCount !== 0 && /*#__PURE__*/React.createElement("div", {
          className: "chip improvement-reasons-needed",
          title: "".concat(improvementCount, " improvement ").concat(pluralize('reason', improvementCount), " need to be resolved")
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeReports",
          svgIconSize: "12",
          svgTitleText: "".concat(improvementCount, " improvement ").concat(pluralize('reason', improvementCount), " need to be resolved")
        }), improvementCount), this.props.conflictingUser && /*#__PURE__*/React.createElement(Tooltip, {
          label: this.props.conflictingUser,
          placement: "right"
        }, /*#__PURE__*/React.createElement(Avatar, {
          name: this.props.conflictingUser,
          bgColor: "#948381",
          color: "#FFFFFF",
          size: "sm"
        }))), /*#__PURE__*/React.createElement("div", {
          className: "nav-bar-column nav-bar-right-column charge-submission-column action-column action-bar-right-column"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.pagination, pageButtons), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.actionBarSelectMultipleWorkitems, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(ev) {
            return handleNextVersion(ev, CursorOperation$1.NEXT, benchMode == BenchMode.GRADE ? false : true);
          },
          disabled: !nextVersionButtonConfig.enabled,
          className: classnames(nextVersionButtonStyle)
        }, nextVersionButtonConfig.text, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeRightArrow",
          svgIconSize: "20"
        }))), !showLoading && /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.servicedeskAction, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(ev) {
            return handleNextPrev(ev, CursorOperation$1.NEXT, benchMode == BenchMode.GRADE ? false : true);
          },
          className: "chakra-secondary-button prev-next-button action-bar-button"
        }, "Next", /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeRightArrow",
          svgIconSize: "20"
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [conditionalUtils$3.capabilityValue((_capabilities$capabil2 = capabilities.capabilities) === null || _capabilities$capabil2 === void 0 || (_capabilities$capabil2 = _capabilities$capabil2.actionMenu) === null || _capabilities$capabil2 === void 0 ? void 0 : _capabilities$capabil2.on), isCaseAvailable(caseAccessState)]
        }, /*#__PURE__*/React.createElement(MenuButton, {
          label: "Actions"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, _extends$1({}, capabilities.capabilities.actionMenuCancelButton, {
          displayMode: "flex"
        }), /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: handleCancel
        }, "Void Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.holdCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showHoldCaseModal
        }, "Hold Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.removeHoldCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showCaseCommentModal
        }, "Remove Hold")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.createCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.navigateCreateCase(activeItem);
          }
        }, "Create Case from Encounter/HAR")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.toggleChargeableCase, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: props.showExclusionCaseModal
        }, processInstance !== null && processInstance !== void 0 && processInstance.isChargeable ? 'Exclude Case' : 'Include Case')), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.mergeCapability, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.showMergeCasesModal({
              caseRun: activeItem,
              cursorAPIContext: cursorAPIContext
            });
          }
        }, "Merge Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.splitCapability, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.showSplitCaseModal();
          }
        }, "Split Case")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.lateCaseClearNotification, /*#__PURE__*/React.createElement(MenuItem, {
          onSelect: function onSelect() {
            return props.toggleLateCaseClearModal(true);
          }
        }, "Clear late update notification")))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.generalCancelButton, buttonCancel), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.submitCase, buttonSubmit), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.viewOnlyCase, viewOnlyComponent), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!!(workItem !== null && workItem !== void 0 && workItem.late_case_update) && !(workItem !== null && workItem !== void 0 && workItem.dismissed)]
        }, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick() {
            var _props$updateWorkItem;
            return (_props$updateWorkItem = props.updateWorkItemDismissed) === null || _props$updateWorkItem === void 0 ? void 0 : _props$updateWorkItem.call(props, (workItem === null || workItem === void 0 ? void 0 : workItem.work_item_case_id) || '', true);
          },
          className: "chakra-primary-button dismiss-late-notification-button action-bar-button",
          style: {
            backgroundColor: '#5ba37a',
            color: 'white !important'
          }
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "RadioEmpty20",
          svgIconSize: "20"
        }), "Clear late update notification")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!!(workItem !== null && workItem !== void 0 && workItem.late_case_update) && (workItem === null || workItem === void 0 ? void 0 : workItem.dismissed)]
        }, /*#__PURE__*/React.createElement("button", {
          className: "chakra-secondary-button dismiss-late-notification-button action-bar-button",
          onClick: function onClick() {
            var _props$updateWorkItem2;
            return (_props$updateWorkItem2 = props.updateWorkItemDismissed) === null || _props$updateWorkItem2 === void 0 ? void 0 : _props$updateWorkItem2.call(props, (workItem === null || workItem === void 0 ? void 0 : workItem.work_item_case_id) || '', false);
          },
          style: {
            borderColor: '#e5927d',
            color: '#e5927d'
          }
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeCheckSVG20",
          svgIconSize: "20",
          svgIconClass: "left-arrow"
        }), "Late update notification cleared"))))));
      }
    }]);
  }(React.Component);
  var CodeBenchActionBarv2 = function CodeBenchActionBarv2(props) {
    var _gradeBenchPanelState;
    var gradeBenchPanelState = useSelector(function (state) {
      return state.gradeBenchPanel;
    });
    var project_configuration = gradeBenchPanelState === null || gradeBenchPanelState === void 0 || (_gradeBenchPanelState = gradeBenchPanelState.qaRule) === null || _gradeBenchPanelState === void 0 || (_gradeBenchPanelState = _gradeBenchPanelState.data) === null || _gradeBenchPanelState === void 0 ? void 0 : _gradeBenchPanelState.project_configuration;
    var usesValidatedWorkflow = (project_configuration === null || project_configuration === void 0 ? void 0 : project_configuration.rubricVersionId) != null;
    var validationResult = gradeBenchPanelState === null || gradeBenchPanelState === void 0 ? void 0 : gradeBenchPanelState.validationResult;
    var invoices = gradeBenchPanelState === null || gradeBenchPanelState === void 0 ? void 0 : gradeBenchPanelState.invoices;

    // Default to can submit in case of future logical errors
    var canSubmit = true;
    if (usesValidatedWorkflow) {
      canSubmit = (validationResult === null || validationResult === void 0 ? void 0 : validationResult.isValid) === true;
    } else if (project_configuration && invoices) {
      canSubmit = isCQAWorkItemEvaluatedLegacy(project_configuration, invoices);
    }
    return /*#__PURE__*/React.createElement(CodeBenchActionBarv2Base, _extends$1({}, props, {
      canSubmit: canSubmit
    }));
  };

  var navigatePatient$1 = uiCommon.codeBenchActions.navigatePatient,
    navigateDetail$1 = uiCommon.codeBenchActions.navigateDetail,
    _showHoldCaseModal$1 = uiCommon.codeBenchActions.showHoldCaseModal,
    _hideHoldCaseModal$1 = uiCommon.codeBenchActions.hideHoldCaseModal,
    _showExclusionCaseModal$1 = uiCommon.codeBenchActions.showExclusionCaseModal,
    _hideExclusionCaseModal$1 = uiCommon.codeBenchActions.hideExclusionCaseModal,
    _toggleLateCaseClearModal$1 = uiCommon.codeBenchActions.toggleLateCaseClearModal,
    _clearLateCaseNotification$1 = uiCommon.codeBenchActions.clearLateCaseNotification,
    _showSplitCaseModal$1 = uiCommon.codeBenchActions.showSplitCaseModal,
    _hideSplitCaseModal$1 = uiCommon.codeBenchActions.hideSplitCaseModal,
    _navigate$1 = uiCommon.codeBenchActions.navigate,
    _toggleSubmitOldCaseModal$1 = uiCommon.codeBenchActions.toggleSubmitOldCaseModal,
    _getCaseVersions$1 = uiCommon.codeBenchActions.getCaseVersions,
    _showCaseCommentModal$1 = uiCommon.codeBenchActions.showCaseCommentModal,
    _hideCaseCommentModal$1 = uiCommon.codeBenchActions.hideCaseCommentModal,
    openWindow$1 = uiCommon.codeBenchActions.openWindow;
  var _showMergeCasesModal$1 = uiCommon.mergeCasesActions.showMergeCasesModal,
    _hideMergeCasesModal$1 = uiCommon.mergeCasesActions.hideMergeCasesModal,
    _splitCase$1 = uiCommon.mergeCasesActions.splitCase;
  var mapStateToCodeBenchActionBarProps = function mapStateToCodeBenchActionBarProps(state) {
    return {
      activeItem: state.codeBench.activeItem,
      loadState: state.codeBench.loadState,
      processInstanceGuids: state.ui.contextParams.processInstanceGuids || [],
      processInstance: state.codeBench.processInstance,
      cases: state.codeBench.cases,
      counts: state.codeBench.counts,
      benchEditable: state.codeBench.benchEditable,
      toggleHoldCaseModal: state.codeBench.toggleHoldCaseModal,
      toggleExclusionCaseModal: state.codeBench.toggleExclusionCaseModal,
      showLateCaseClearModal: state.codeBench.showLateCaseClearModal,
      toggleSplitCaseModal: state.codeBench.toggleSplitCaseModal,
      submitOldCaseModal: state.codeBench.submitOldCaseModal,
      holdCaseStatus: state.codeBench.holdCase,
      improvements: state.codeBench.improvements,
      userContext: state.codeBench.userContext,
      caseAccessTime: state.codeBench.caseAccessTime,
      benchMode: state.codeBench.benchMode
    };
  };
  var mapDispatchToCodeBenchActionBarProps = function mapDispatchToCodeBenchActionBarProps(dispatch) {
    return {
      openChildWindow: function openChildWindow(windowOpenArgs) {
        dispatch(openWindow$1(windowOpenArgs));
      },
      showPatientInfo: function showPatientInfo(caseRun) {
        dispatch(navigatePatient$1(caseRun));
      },
      handleTraversal: function handleTraversal(caseDescriptor) {
        dispatch(navigateDetail$1(caseDescriptor));
      },
      showHoldCaseModal: function showHoldCaseModal() {
        dispatch(_showHoldCaseModal$1());
      },
      hideHoldCaseModal: function hideHoldCaseModal() {
        dispatch(_hideHoldCaseModal$1());
      },
      showCaseCommentModal: function showCaseCommentModal() {
        dispatch(_showCaseCommentModal$1());
      },
      hideCaseCommentModal: function hideCaseCommentModal() {
        dispatch(_hideCaseCommentModal$1());
      },
      showMergeCasesModal: function showMergeCasesModal(mergeCaseModalProps) {
        dispatch(_showMergeCasesModal$1(mergeCaseModalProps));
      },
      hideMergeCasesModal: function hideMergeCasesModal() {
        dispatch(_hideMergeCasesModal$1());
      },
      showExclusionCaseModal: function showExclusionCaseModal() {
        dispatch(_showExclusionCaseModal$1());
      },
      hideExclusionCaseModal: function hideExclusionCaseModal() {
        dispatch(_hideExclusionCaseModal$1());
      },
      toggleLateCaseClearModal: function toggleLateCaseClearModal(toggle) {
        dispatch(_toggleLateCaseClearModal$1(toggle));
      },
      clearLateCaseNotification: function clearLateCaseNotification(processInstance) {
        dispatch(_clearLateCaseNotification$1(processInstance));
      },
      showSplitCaseModal: function showSplitCaseModal() {
        dispatch(_showSplitCaseModal$1());
      },
      hideSplitCaseModal: function hideSplitCaseModal() {
        dispatch(_hideSplitCaseModal$1());
      },
      navigate: function navigate(url) {
        dispatch(_navigate$1(url));
      },
      toggleSubmitOldCaseModal: function toggleSubmitOldCaseModal() {
        dispatch(_toggleSubmitOldCaseModal$1());
      },
      getCaseVersions: function () {
        var _getCaseVersions2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(processInstance) {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 1;
                return dispatch(_getCaseVersions$1(processInstance));
              case 1:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function getCaseVersions(_x) {
          return _getCaseVersions2.apply(this, arguments);
        }
        return getCaseVersions;
      }(),
      splitCase: function splitCase(processInstance) {
        dispatch(_splitCase$1(processInstance));
      }
    };
  };
  var CursorOperation = uiCommon.commonEnums.CursorOperation;
  function createSubmitCaseHandler(UIMode, onInvoicesSubmisson, processInstance, cursorAPIContext, caseAccessTime, activeItem, getCaseVersions, toggleSubmitOldCaseModal, hasAmplifyCaseRunV2Access, releaseCurrentCaseAccess) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
        var vwComment,
          isCodeableVersion,
          button,
          cursorAPIPayload,
          _args = arguments;
        return _regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              vwComment = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              isCodeableVersion = _args.length > 2 ? _args[2] : undefined;
              event.preventDefault();
              releaseCurrentCaseAccess();
              button = event.currentTarget;
              button.disabled = true;
              cursorAPIPayload = {
                operation: CursorOperation.NEXT,
                cursorAPIContext: cursorAPIContext,
                hasAmplifyCaseRunV2Access: hasAmplifyCaseRunV2Access
              };
              _context2.prev = 1;
              _context2.next = 2;
              return getCaseVersions(processInstance);
            case 2:
              if (!isCodeableVersion) {
                _context2.next = 4;
                break;
              }
              _context2.next = 3;
              return onInvoicesSubmisson({
                processInstance: processInstance,
                uiMode: UIMode,
                vwComment: vwComment,
                cursorAPIPayload: cursorAPIPayload,
                submitWithOverrideButton: false,
                caseAccessTime: caseAccessTime,
                activeItem: activeItem
              });
            case 3:
              _context2.next = 5;
              break;
            case 4:
              toggleSubmitOldCaseModal('');
            case 5:
              _context2.prev = 5;
              button.disabled = false;
              return _context2.finish(5);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[1,, 5, 6]]);
      }));
      return function (_x2) {
        return _ref.apply(this, arguments);
      };
    }();
  }
  function createSubmitCQAWorkItemHandler(cursorAPIContext, submitWorkItem, status, releaseCurrentCaseAccess) {
    return /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
        var button,
          cursorAPIPayload;
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              event.preventDefault();
              button = event.currentTarget;
              button.disabled = true;
              cursorAPIPayload = {
                operation: CursorOperation.NEXT,
                cursorAPIContext: cursorAPIContext
              };
              try {
                submitWorkItem(cursorAPIPayload, status, releaseCurrentCaseAccess);
              } finally {
                button.disabled = false;
              }
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }();
  }

  var img = new Image();
    img.src = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='utf-8'%3f%3e%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' style='margin: auto%3b background: rgb(255%2c 255%2c 255)%3b display: block%3b shape-rendering: auto%3b' width='34px' height='34px' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid'%3e%3cg transform='rotate(0 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-1.0299625468164795s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(30 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.9363295880149813s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(60 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.8426966292134832s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(90 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.7490636704119851s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(120 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.6554307116104869s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(150 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.5617977528089888s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(180 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.46816479400749067s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(210 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.37453183520599254s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(240 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.2808988764044944s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(270 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.18726591760299627s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(300 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='-0.09363295880149813s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3cg transform='rotate(330 50 50)'%3e %3crect x='46.5' y='8.5' rx='3.5' ry='4.37' width='7' height='19' fill='%23324ebd'%3e %3canimate attributeName='opacity' values='1%3b0' keyTimes='0%3b1' dur='1.1235955056179776s' begin='0s' repeatCount='indefinite'%3e%3c/animate%3e %3c/rect%3e%3c/g%3e%3c!-- %5bldio%5d generated by https://loading.io/ --%3e%3c/svg%3e";

  function _callSuper$b(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$b() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$b() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$b = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$g(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$g(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$g(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$g(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var invoiceUtils = uiCommon.AmplifyCore.invoiceUtils;
  var InvoiceEditorActions$1 = uiCommon.commonActions.InvoiceEditor;
  var RequiredField = uiCommon.commonEnums.RequiredField;
  var compareObjectProperties = invoiceUtils.compareObjectProperties,
    isFieldValid = invoiceUtils.isFieldValid;
  var FieldDefinitions$1 = [{
    label: 'Last Name',
    value: 'lastName',
    key: 'lastName'
  }, {
    label: 'ID',
    value: 'id',
    key: 'id',
    disabled: false
  }];
  var FieldIPCDefinitions = [{
    label: 'Name',
    value: 'name',
    key: 'name'
  }];
  var shouldShowResults$1 = function shouldShowResults(lookupState) {
    var _codeQuery$text;
    var active = lookupState.active,
      searching = lookupState.searching,
      codeQuery = lookupState.codeQuery;
    if (!active) {
      return false;
    }
    if (searching) {
      return true;
    }
    // one character names are displayable.
    // they may not be totally valid, but there are
    // instances in our database where they exist.
    // https://drive.google.com/file/d/1Eur55UvRKHmo2aYA7Q_lBx9EGSbU4kSH/view?usp=sharing
    return ((_codeQuery$text = codeQuery === null || codeQuery === void 0 ? void 0 : codeQuery.text) !== null && _codeQuery$text !== void 0 ? _codeQuery$text : '').length >= 1;
  };
  var resultFormatter$1 = function resultFormatter(activeIdx, provider, idx) {
    var identifier = provider.identifiers.find(function (id) {
      return id.primary;
    });
    var selectable = true;

    // We can't rely on there being an identifier from the API.
    // There may not be a primary, or there might not be an identifier
    // at all.  In the case of there being no identifier for the
    // provider, the result will be unselectable by the user.
    if (!identifier) {
      if (!provider.identifiers.length) {
        selectable = false;
        identifier = {
          idNumber: 'N/A',
          idTypeCode: 'N/A'
        };
      } else {
        // if we don't have a primary identifier, just choose a random
        // identifier at the moment.
        identifier = provider.identifiers[0];
      }
    }
    var styleClasses = ['search-result', {
      'search-result-submittable': activeIdx === idx,
      'result-unselectable': !selectable
    }];
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      "data-idx": idx,
      className: classnames(styleClasses),
      draggable: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-label search-label"
    }), /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, provider.displayName, /*#__PURE__*/React.createElement("div", {
      className: "id-display"
    }, "ID: ", identifier.idNumber, " (src: ", identifier.idTypeCode, ")")));
  };
  var resultFormatterDept = function resultFormatterDept(activeIdx, department, idx) {
    var styleClasses = ['search-result', {
      'search-result-submittable': activeIdx === idx
    }];
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      "data-idx": idx,
      className: classnames(styleClasses),
      draggable: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, department.description));
  };
  var resultFormatterV2 = function resultFormatterV2(activeIdx, provider, idx) {
    var _provider$specialties, _provider$specialties2, _Object$entries;
    var identifier = provider.identifiers.find(function (id) {
      return id === null || id === void 0 ? void 0 : id.primary;
    });
    var isProviderBillable = provider === null || provider === void 0 || (_provider$specialties = provider.specialties) === null || _provider$specialties === void 0 ? void 0 : _provider$specialties.some(function (specialty) {
      return specialty === null || specialty === void 0 ? void 0 : specialty.billable;
    });
    var selectable = isProviderBillable;

    // We can't rely on there being an identifier from the API.
    // There may not be a primary, or there might not be an identifier
    // at all.  In the case of there being no identifier for the
    // provider, the result will be unselectable by the user.
    if (!identifier) {
      if (!provider.identifiers.length) {
        selectable = false;
        identifier = {
          idNumber: 'N/A',
          idTypeCode: 'N/A'
        };
      } else {
        // if we don't have a primary identifier, just choose a random
        // identifier at the moment.
        identifier = provider === null || provider === void 0 ? void 0 : provider.identifiers[0];
      }
    }
    var isNotSectable = (provider === null || provider === void 0 ? void 0 : provider.isBillableSelectable) && !selectable || !(provider !== null && provider !== void 0 && provider.isSelectable);
    var styleClasses = ['search-result', 'ipc-provider-search', {
      'search-result-submittable': activeIdx === idx,
      'result-unselectable': isNotSectable
    }];
    var specialtiesByLoc = uiCommon.objectUtils.groupBy((_provider$specialties2 = provider === null || provider === void 0 ? void 0 : provider.specialties) !== null && _provider$specialties2 !== void 0 ? _provider$specialties2 : [], 'location');
    var specialtiesView = (_Object$entries = Object.entries(specialtiesByLoc)) === null || _Object$entries === void 0 ? void 0 : _Object$entries.map(function (_ref) {
      var _Object$entries2;
      var _ref2 = _slicedToArray(_ref, 2),
        location = _ref2[0],
        locationGroup = _ref2[1];
      var specialtiesByRole = uiCommon.objectUtils.groupBy(locationGroup !== null && locationGroup !== void 0 ? locationGroup : [], 'name');
      return (_Object$entries2 = Object.entries(specialtiesByRole)) === null || _Object$entries2 === void 0 ? void 0 : _Object$entries2.map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
          name = _ref4[0],
          specialties = _ref4[1];
        var isRoleBillable = specialties === null || specialties === void 0 ? void 0 : specialties.some(function (specialty) {
          return specialty === null || specialty === void 0 ? void 0 : specialty.billable;
        });
        var roleStyles = ['provider-specialties', {
          'billable-role': isRoleBillable,
          'non-billable-role': !isRoleBillable
        }];
        return /*#__PURE__*/React.createElement("div", {
          key: location
        }, location && location !== 'null' && /*#__PURE__*/React.createElement("div", {
          className: "provider-location"
        }, location), /*#__PURE__*/React.createElement("div", {
          className: classnames(roleStyles)
        }, /*#__PURE__*/React.createElement("div", {
          className: "provider-role"
        }, name), specialties === null || specialties === void 0 ? void 0 : specialties.map(function (specialty) {
          return /*#__PURE__*/React.createElement("div", {
            key: specialty === null || specialty === void 0 ? void 0 : specialty.specialty,
            className: "provider-specialty"
          }, /*#__PURE__*/React.createElement("div", {
            className: "specialty-name"
          }, specialty === null || specialty === void 0 ? void 0 : specialty.specialty), (specialty === null || specialty === void 0 ? void 0 : specialty.specialty_flag) && /*#__PURE__*/React.createElement("div", {
            className: "specialty-flag"
          }, specialty === null || specialty === void 0 ? void 0 : specialty.specialty_flag), (specialty === null || specialty === void 0 ? void 0 : specialty.billable) && /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
            svgTitleText: "Billable",
            svgIconName: "BiomeCoding",
            svgIconClass: "billing-icon",
            svgIconSize: "16"
          }));
        })));
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      "data-idx": idx,
      className: classnames(styleClasses),
      draggable: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, /*#__PURE__*/React.createElement("div", {
      className: "provider-header"
    }, /*#__PURE__*/React.createElement("span", {
      className: "encounter-bg"
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeEncounterCircle",
      svgIconClass: "encounter-icon",
      svgIconSize: "24"
    })), /*#__PURE__*/React.createElement("span", {
      className: "provider-name-section"
    }, /*#__PURE__*/React.createElement("span", {
      className: "provider-name"
    }, provider === null || provider === void 0 ? void 0 : provider.displayName, (provider === null || provider === void 0 ? void 0 : provider.degree) && ","), /*#__PURE__*/React.createElement("span", {
      className: "provider-degree"
    }, provider === null || provider === void 0 ? void 0 : provider.degree)), /*#__PURE__*/React.createElement("span", {
      className: "provider-id"
    }, "(", identifier.idNumber, ")"), /*#__PURE__*/React.createElement("span", {
      className: "provider-service-idtypecode"
    }, provider.idTypeCode)), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [isNotSectable]
    }, /*#__PURE__*/React.createElement("span", {
      className: "provider-specialties not-eligible"
    }, "Not Eligible")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [!isNotSectable]
    }, /*#__PURE__*/React.createElement(React.Fragment, null, specialtiesView))));
  };
  var getSelectionData$1 = function getSelectionData(row, selectElement, searchResults) {
    var item = row === null || row === void 0 ? void 0 : row.attributes.getNamedItem('data-idx');
    if (!item) return;
    return searchResults[item.value];
  };
  var DEFAULT_ARGS = {
    getSelectionData: getSelectionData$1,
    shouldShowResults: shouldShowResults$1,
    resultFormatter: resultFormatter$1,
    autoBlur: true,
    debounceTimeout: 500,
    minLength: 0,
    billingProviderSearchResults: [],
    referringProviderSearchResults: [],
    performingProviderSearchResults: [],
    FieldDefinitions: FieldDefinitions$1
  };
  var DEFAULT_ARGS_V2 = _objectSpread$g(_objectSpread$g({}, DEFAULT_ARGS), {}, {
    resultFormatter: resultFormatterV2,
    FieldDefinitions: FieldIPCDefinitions
  });
  var departmentSearch = function departmentSearch(department, departmentSearchText) {
    // allow show all when search text is just three numbers or lower
    if (departmentSearchText.length <= 3) {
      return true;
    }

    // if there is no description, search by code
    if (!department.description && department.code) {
      return department.code.toLowerCase().startsWith(departmentSearchText.toLowerCase()) || department.code.toLowerCase().includes(departmentSearchText.toLowerCase());
    }

    // by default search by description
    return department.description.toLowerCase().startsWith(departmentSearchText.toLowerCase()) || department.description.toLowerCase().includes(departmentSearchText.toLowerCase());
  };
  var InvoiceEditor = /*#__PURE__*/function (_React$Component) {
    function InvoiceEditor(props) {
      var _this;
      _classCallCheck(this, InvoiceEditor);
      _this = _callSuper$b(this, InvoiceEditor, [props]);
      _this.state = {
        requiredFieldsValid: {},
        departmentSearchText: ''
      };
      _this.handleProviderRemove = _this.handleProviderRemove.bind(_this);
      _this.handleProviderSearch = _this.handleProviderSearch.bind(_this);
      _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
      _this.handlePerformerRemove = _this.handlePerformerRemove.bind(_this);
      _this.handleReferringPerformerRemove = _this.handleReferringPerformerRemove.bind(_this);
      _this.handlePerformerSearch = _this.handlePerformerSearch.bind(_this);
      _this.handleReferrerSearch = _this.handleReferrerSearch.bind(_this);
      _this.onPerformDateChange = _this.onPerformDateChange.bind(_this);
      _this.departmentChange = _this.departmentChange.bind(_this);
      _this.departmentRemove = _this.departmentRemove.bind(_this);
      _this.feeScheduleChange = _this.feeScheduleChange.bind(_this);
      _this.handleDepartmentSearch = _this.handleDepartmentSearch.bind(_this);
      _this.handleFormValidation = _this.handleFormValidation.bind(_this);
      _this.resetRequiredFields = _this.resetRequiredFields.bind(_this);
      _this.handleCancel = _this.handleCancel.bind(_this);
      _this.checkRequiredFieldValid = _this.checkRequiredFieldValid.bind(_this);
      _this.handleOnPerformerAdditionAdd = _this.handleOnPerformerAdditionAdd.bind(_this);
      _this.handleOnReferrerPerformerAdditionAdd = _this.handleOnReferrerPerformerAdditionAdd.bind(_this);
      _this.handleOnProviderAdd = _this.handleOnProviderAdd.bind(_this);
      _this.state = {
        departmentSearchText: ''
      };
      return _this;
    }
    _inherits(InvoiceEditor, _React$Component);
    return _createClass(InvoiceEditor, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var _this$props;
        var comparePropsList = ['billing_area', 'department.code', 'billing_provider_number.number', 'performing_provider_number.number', 'referring_provider_number.number', 'date_of_service'];
        if (!compareObjectProperties(prevProps === null || prevProps === void 0 ? void 0 : prevProps.invoice, (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.invoice, comparePropsList)) {
          this.handleFormValidation();
        }
      }
    }, {
      key: "resetRequiredFields",
      value: function resetRequiredFields() {
        this.setState(_objectSpread$g(_objectSpread$g({}, this.state), {}, {
          requiredFieldsValid: {}
        }));
      }
    }, {
      key: "handleCancel",
      value: function handleCancel(ev) {
        ev.preventDefault();
        this.resetRequiredFields();
        this.props.onInvoiceCancel(ev);
      }
    }, {
      key: "checkRequiredFieldValid",
      value: function checkRequiredFieldValid(field) {
        var _this$state$requiredF, _this$state$requiredF2;
        return (_this$state$requiredF = (_this$state$requiredF2 = this.state.requiredFieldsValid) === null || _this$state$requiredF2 === void 0 ? void 0 : _this$state$requiredF2[field]) !== null && _this$state$requiredF !== void 0 ? _this$state$requiredF : true;
      }
    }, {
      key: "handleFormValidation",
      value: function handleFormValidation() {
        var _this$props$invoiceOp, _invoice$billing_prov, _invoice$referring_pr, _invoice$performing_p, _invoice$department;
        var requiredFields = (_this$props$invoiceOp = this.props.invoiceOptions) === null || _this$props$invoiceOp === void 0 ? void 0 : _this$props$invoiceOp.required_fields;
        var invoice = this.props.invoice;
        var isBillingProviderValid = isFieldValid(requiredFields, RequiredField.BILLING_PROVIDER, invoice === null || invoice === void 0 || (_invoice$billing_prov = invoice.billing_provider_number) === null || _invoice$billing_prov === void 0 ? void 0 : _invoice$billing_prov.number);
        var isReferringProviderValid = isFieldValid(requiredFields, RequiredField.REFERRING_PROVIDER, invoice === null || invoice === void 0 || (_invoice$referring_pr = invoice.referring_provider_number) === null || _invoice$referring_pr === void 0 ? void 0 : _invoice$referring_pr.number);
        var isPerformingProviderValid = isFieldValid(requiredFields, RequiredField.PERFORMING_PROVIDER, invoice === null || invoice === void 0 || (_invoice$performing_p = invoice.performing_provider_number) === null || _invoice$performing_p === void 0 ? void 0 : _invoice$performing_p.number);
        var isDepartmentValid = isFieldValid(requiredFields, RequiredField.DEPARTMENT, invoice === null || invoice === void 0 || (_invoice$department = invoice.department) === null || _invoice$department === void 0 ? void 0 : _invoice$department.code);
        var isBillingAreaValid = isFieldValid(requiredFields, RequiredField.BILLING_AREA, invoice === null || invoice === void 0 ? void 0 : invoice.fee_schedule);
        var isDateOfServiceValid = isFieldValid(requiredFields, RequiredField.DATE_OF_SERVICE, invoice === null || invoice === void 0 ? void 0 : invoice.date_of_service);
        var requiredFieldsValid = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RequiredField.BILLING_AREA, isBillingAreaValid), RequiredField.DEPARTMENT, isDepartmentValid), RequiredField.BILLING_PROVIDER, isBillingProviderValid), RequiredField.PERFORMING_PROVIDER, isPerformingProviderValid), RequiredField.REFERRING_PROVIDER, isReferringProviderValid), RequiredField.DATE_OF_SERVICE, isDateOfServiceValid);
        var isValid = Object.values(requiredFieldsValid).every(function (val) {
          return val;
        });
        this.setState(_objectSpread$g(_objectSpread$g({}, this.state), {}, {
          requiredFieldsValid: requiredFieldsValid,
          disableSubmit: !isValid
        }));
        return isValid;
      }
    }, {
      key: "handleFormSubmit",
      value: function handleFormSubmit(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var _this$props2 = this.props,
          invoice = _this$props2.invoice,
          processInstance = _this$props2.processInstance;
        this.resetRequiredFields();
        if (this.handleFormValidation()) {
          this.resetRequiredFields();
          if (this.props.displayMode === uiCommon.commonEnums.InvoiceEditorMode.EDITOR) {
            this.props.onInvoiceSave({
              invoice: invoice,
              processInstance: processInstance
            });
          } else if (this.props.displayMode === uiCommon.commonEnums.InvoiceEditorMode.ADDITION) {
            this.props.onInvoiceCreate({
              invoice: invoice,
              processInstance: processInstance
            });
          }
        }
      }
    }, {
      key: "handleProviderRemove",
      value: function handleProviderRemove(ev) {
        ev.preventDefault();
        this.props.onProviderRemove(this.props.invoice);
      }

      /**
       * method that handle when a search is done
       * @param codeQuery
       */
    }, {
      key: "handlePerformerSearch",
      value: function handlePerformerSearch(codeQuery) {
        var context = _objectSpread$g(_objectSpread$g({}, codeQuery.context), {}, {
          searchType: InvoiceEditorActions$1.PERFORMING_PROVIDER_RESULTS,
          processInstance: this.props.processInstance,
          providerType: uiCommon.commonEnums.ProviderType.PERFORMING_PROVIDER,
          invoice: this.props.invoice,
          shouldFilterActive: true,
          shouldGreyOutExternalProviders: true,
          providerRoleTypeConfig: this.props.providerRoleTypeConfig
        });
        this.props.onPerformerAdditionSearch(_objectSpread$g(_objectSpread$g({}, codeQuery), {}, {
          context: context
        }));
      }

      /**
       * method that handle when a search is done
       * @param codeQuery
       */
    }, {
      key: "handleDepartmentSearch",
      value: function handleDepartmentSearch(codeQuery) {
        this.setState({
          departmentSearchText: codeQuery.text
        });
      }
    }, {
      key: "handleReferrerSearch",
      value: function handleReferrerSearch(codeQuery) {
        var context = _objectSpread$g(_objectSpread$g({}, codeQuery.context), {}, {
          searchType: InvoiceEditorActions$1.PERFORMING_PROVIDER_RESULTS,
          processInstance: this.props.processInstance,
          providerType: uiCommon.commonEnums.ProviderType.REFERRING_PROVIDER,
          invoice: this.props.invoice,
          shouldFilterActive: true,
          shouldFilterOutExternalProviders: false
        });
        this.props.onPerformerAdditionSearch(_objectSpread$g(_objectSpread$g({}, codeQuery), {}, {
          context: context
        }));
      }
    }, {
      key: "handleProviderSearch",
      value: function handleProviderSearch(codeQuery) {
        var context = _objectSpread$g(_objectSpread$g({}, codeQuery.context), {}, {
          searchType: InvoiceEditorActions$1.BILLING_PROVIDER_RESULTS,
          processInstance: this.props.processInstance,
          providerType: uiCommon.commonEnums.ProviderType.BILLING_PROVIDER,
          shouldFilterActive: true,
          invoice: this.props.invoice,
          useProviderDirectoryLocations: this.props.useProviderDirectoryLocations
        });
        this.props.onProviderSearch(_objectSpread$g(_objectSpread$g({}, codeQuery), {}, {
          context: context
        }));
      }

      /**
       * method that handle when a performer wants to be removed
       * @param ev
       */
    }, {
      key: "handlePerformerRemove",
      value: function handlePerformerRemove(ev) {
        ev.preventDefault();
        this.props.onPerformerAdditionRemove(this.props.invoice);
      }

      /**
       * method that handle when a performer wants to be removed
       * @param ev
       */
    }, {
      key: "handleReferringPerformerRemove",
      value: function handleReferringPerformerRemove(ev) {
        ev.preventDefault();
        this.props.onReferringPerformerAdditionRemove(this.props.invoice);
      }

      /**
       * method that hanlde when a date has been changed
       * @param ev
       */
    }, {
      key: "onPerformDateChange",
      value: function onPerformDateChange(ev) {
        ev.preventDefault();
        this.props.onPerformDateChange(ev.target.value);
      }
    }, {
      key: "departmentChange",
      value: function departmentChange(departmentObj) {
        this.props.onDepartmentChange(departmentObj.codeInfo.code);
      }
    }, {
      key: "departmentRemove",
      value: function departmentRemove() {
        this.props.onRemoveDepartment();
      }
    }, {
      key: "feeScheduleChange",
      value: function feeScheduleChange(feeScheduleObj) {
        this.props.onFeeScheduleChange(feeScheduleObj.detail.value);
      }
    }, {
      key: "handleOnPerformerAdditionAdd",
      value: function handleOnPerformerAdditionAdd(payload) {
        var provider = _objectSpread$g(_objectSpread$g({}, payload.codeInfo), payload.context);
        this.props.onPerformerAdditionAdd(provider);
      }
    }, {
      key: "handleOnReferrerPerformerAdditionAdd",
      value: function handleOnReferrerPerformerAdditionAdd(payload) {
        var provider = _objectSpread$g(_objectSpread$g({}, payload.codeInfo), payload.context);
        this.props.onReferrerPerformerAdditionAdd(provider);
      }
    }, {
      key: "handleOnProviderAdd",
      value: function handleOnProviderAdd(payload) {
        var provider = _objectSpread$g(_objectSpread$g({}, payload.codeInfo), payload.context);
        this.props.onProviderAdd(provider);
      }
    }, {
      key: "render",
      value: function render() {
        var _invoiceOptions$summa,
          _appServiceLines$isIP,
          _this$props$processIn,
          _appServiceLines$isSu,
          _this$props$processIn2,
          _invoiceOptions$requi,
          _invoiceOptions$requi2,
          _invoiceOptions$requi3,
          _this2 = this,
          _invoiceOptions$requi4,
          _invoiceOptions$requi5,
          _invoiceOptions$requi6,
          _this$state$disableSu,
          _this$state,
          _this$state2;
        var _this$props3 = this.props,
          displayMode = _this$props3.displayMode,
          billingAreaOptions = _this$props3.billingAreaOptions,
          invoice = _this$props3.invoice,
          invoiceOptions = _this$props3.invoiceOptions;
        if (!displayMode) return /*#__PURE__*/React.createElement("span", {
          className: "charge-editor-form-empty"
        });
        var hasBillingProvider = invoice !== null && invoice !== void 0 && invoice.billing_provider_name ? true : false;
        var hasPerformer = invoice !== null && invoice !== void 0 && invoice.performing_provider_name ? true : false;
        var hasReferringPerformer = invoice !== null && invoice !== void 0 && invoice.referring_provider_name ? true : false;
        var feeSchedules = uiCommon.objectUtils.convertRecordToOptionList(invoiceOptions.summary.fee_schedules);
        var existingDepartments = new Set(invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$summa = invoiceOptions.summary) === null || _invoiceOptions$summa === void 0 || (_invoiceOptions$summa = _invoiceOptions$summa.existing_departments) === null || _invoiceOptions$summa === void 0 ? void 0 : _invoiceOptions$summa.map(function (obj) {
          return obj.code;
        }));
        var allDepartmentOptions = invoiceUtils.getPreparedDepartmentOptions(invoiceUtils.getAllDepartments(invoiceOptions), existingDepartments);
        var isIPCServiceLine = (_appServiceLines$isIP = uiCommon.appServiceLines.isIPC((_this$props$processIn = this.props.processInstance) === null || _this$props$processIn === void 0 ? void 0 : _this$props$processIn.serviceLine)) !== null && _appServiceLines$isIP !== void 0 ? _appServiceLines$isIP : false;
        var isSurgeryServiceLine = (_appServiceLines$isSu = uiCommon.appServiceLines.isSurgery((_this$props$processIn2 = this.props.processInstance) === null || _this$props$processIn2 === void 0 ? void 0 : _this$props$processIn2.serviceLine)) !== null && _appServiceLines$isSu !== void 0 ? _appServiceLines$isSu : false;
        var lookupArgs = isIPCServiceLine || isSurgeryServiceLine ? _objectSpread$g({}, DEFAULT_ARGS_V2) : _objectSpread$g({}, DEFAULT_ARGS);
        return /*#__PURE__*/React.createElement("div", {
          className: "charge-editor-form"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          onClose: this.handleCancel
        }, /*#__PURE__*/React.createElement("div", {
          className: "cmx-form cmx-block-form"
        }, /*#__PURE__*/React.createElement(uiComponents.Form, {
          formDefinition: {
            fieldGroups: [],
            fields: [],
            buttons: []
          }
        }, /*#__PURE__*/React.createElement("form", {
          className: "cmx-form-tag"
        }, /*#__PURE__*/React.createElement(uiComponents.FieldSetWrapper, {
          legend: "Billing Information"
        }, /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "datePerformingInfo",
          label: "Date",
          type: "date-performing-info",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi = invoiceOptions.required_fields) === null || _invoiceOptions$requi === void 0 ? void 0 : _invoiceOptions$requi.includes(RequiredField.DATE_OF_SERVICE)
        }, /*#__PURE__*/React.createElement("input", {
          type: "date",
          className: !(invoice !== null && invoice !== void 0 && invoice.date_of_service) ? 'input-invalid' : '',
          value: invoice === null || invoice === void 0 ? void 0 : invoice.date_of_service,
          onChange: this.onPerformDateChange
        }), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.checkRequiredFieldValid(RequiredField.DATE_OF_SERVICE)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The date of service")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.DATE_OF_SERVICE)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Date of service is required"))), /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "billingProvider",
          label: "Provider",
          type: "billing-provider",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi2 = invoiceOptions.required_fields) === null || _invoiceOptions$requi2 === void 0 ? void 0 : _invoiceOptions$requi2.includes(RequiredField.BILLING_PROVIDER)
        }, hasBillingProvider ? /*#__PURE__*/React.createElement("div", {
          className: "chip"
        }, invoice.billing_provider_name, /*#__PURE__*/React.createElement("button", {
          autoFocus: true,
          onClick: this.handleProviderRemove,
          className: "btn btn-clear btn-remover",
          "aria-label": "Remove provider"
        })) : /*#__PURE__*/React.createElement(uiComponents.Lookup, _extends$1({}, lookupArgs, {
          autoFocus: true,
          onSearchSelection: this.handleOnProviderAdd,
          onSearch: this.handleProviderSearch,
          searchResults: this.props.billingProviderSearchResults,
          actionPrefix: '',
          disabled: !(invoice !== null && invoice !== void 0 && invoice.date_of_service),
          autoSearch: true,
          placeholderText: isIPCServiceLine ? 'Search for a provider by name' : 'Search for a provider',
          debounceTimeout: 300
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.checkRequiredFieldValid(RequiredField.BILLING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The provider who is responsible for billing")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.BILLING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Billing provider is required"))), /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "departmentPerformingInfo",
          label: "Department",
          type: "department-performing-info",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi3 = invoiceOptions.required_fields) === null || _invoiceOptions$requi3 === void 0 ? void 0 : _invoiceOptions$requi3.includes(RequiredField.DEPARTMENT)
        }, /*#__PURE__*/React.createElement("div", {
          className: "department-select-box"
        }, this.props.invoice.department.code ? /*#__PURE__*/React.createElement("div", {
          className: "chip"
        }, this.props.invoice.department.name ? this.props.invoice.department.name : this.props.invoice.department.code, /*#__PURE__*/React.createElement("a", {
          href: "#/remove",
          onClick: this.departmentRemove,
          className: "btn btn-clear btn-remover",
          "aria-label": "Remove department",
          role: "button"
        })) : /*#__PURE__*/React.createElement(uiComponents.Lookup, _extends$1({}, lookupArgs, {
          minLength: 1,
          onSearchSelection: this.departmentChange,
          FieldDefinitions: [],
          resultFormatter: resultFormatterDept,
          onSearch: this.handleDepartmentSearch,
          searchResults: allDepartmentOptions.map(function (departmentOption) {
            return {
              code: departmentOption.value,
              codeType: departmentOption.value,
              description: departmentOption.label ? departmentOption.label : departmentOption.value,
              shortDescription: departmentOption.label ? departmentOption.label : departmentOption.value,
              tenantDefined: null,
              effectiveDate: ''
            };
          }).filter(function (department) {
            return departmentSearch(department, _this2.state.departmentSearchText);
          }),
          actionPrefix: '',
          autoSearch: true,
          placeholderText: 'Choose a department'
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.DEPARTMENT)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Department is required"))), feeSchedules.length > 1 && /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "feeSchedulePerformingInfo",
          label: "Bill Area",
          type: "feeSchedule-performing-info",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi4 = invoiceOptions.required_fields) === null || _invoiceOptions$requi4 === void 0 ? void 0 : _invoiceOptions$requi4.includes(RequiredField.BILLING_AREA)
        }, /*#__PURE__*/React.createElement("div", {
          className: "feeSchedule-select-box"
        }, /*#__PURE__*/React.createElement(uiComponents.SelectList, {
          placeholder: "Choose a Billing area",
          name: "feeSchedule",
          options: feeSchedules,
          value: this.props.invoice.fee_schedule,
          onChange: this.feeScheduleChange
        }), /*#__PURE__*/React.createElement("label", {
          className: "feeSchedule-select-label"
        }, /*#__PURE__*/React.createElement(uiComponents.Icon, {
          svgIconName: "BiomeChevronDownSVG20",
          svgIconSize: "16",
          svgIconClass: "select-checvron"
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.checkRequiredFieldValid(RequiredField.BILLING_AREA)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The billing area where the service was performed.")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.BILLING_AREA)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Billing area is required"))), /*#__PURE__*/React.createElement("div", {
          style: {
            display: 'none'
          }
        }, /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "billingArea",
          label: "Area",
          required: true
        }, /*#__PURE__*/React.createElement(uiComponents.SelectList, {
          name: "billingArea",
          options: billingAreaOptions,
          value: ""
        }), /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The billing area where the service was performed.")))), /*#__PURE__*/React.createElement(uiComponents.FieldSetWrapper, {
          legend: "Other Providers"
        }, /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "performingInformationProvider",
          label: "Performing",
          type: "performing-information-provider",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi5 = invoiceOptions.required_fields) === null || _invoiceOptions$requi5 === void 0 ? void 0 : _invoiceOptions$requi5.includes(RequiredField.PERFORMING_PROVIDER)
        }, hasPerformer ? /*#__PURE__*/React.createElement("div", {
          className: "chip"
        }, invoice.performing_provider_name, /*#__PURE__*/React.createElement("a", {
          href: "#/remove",
          onClick: this.handlePerformerRemove,
          className: "btn btn-clear btn-remover",
          "aria-label": "Remove provider",
          role: "button"
        })) : /*#__PURE__*/React.createElement(uiComponents.Lookup, _extends$1({}, lookupArgs, {
          onSearchSelection: this.handleOnPerformerAdditionAdd,
          onSearch: this.handlePerformerSearch,
          searchResults: this.props.performingProviderSearchResults,
          actionPrefix: '',
          autoSearch: true,
          placeholderText: isIPCServiceLine ? 'Search for a performer by name' : 'Search for a performer'
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.checkRequiredFieldValid(RequiredField.PERFORMING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The provider who performed the services.")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.PERFORMING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Performing provider is required"))), /*#__PURE__*/React.createElement(uiComponents.FieldWrapper, {
          key: "referringInformationProvider",
          label: "Referring",
          type: "performing-information-referring-provider",
          required: invoiceOptions === null || invoiceOptions === void 0 || (_invoiceOptions$requi6 = invoiceOptions.required_fields) === null || _invoiceOptions$requi6 === void 0 ? void 0 : _invoiceOptions$requi6.includes(RequiredField.REFERRING_PROVIDER)
        }, hasReferringPerformer ? /*#__PURE__*/React.createElement("div", {
          className: "chip"
        }, invoice.referring_provider_name, /*#__PURE__*/React.createElement("a", {
          href: "#/remove",
          onClick: this.handleReferringPerformerRemove,
          className: "btn btn-clear btn-remover",
          "aria-label": "Remove referring provider",
          role: "button"
        })) : /*#__PURE__*/React.createElement(uiComponents.Lookup, _extends$1({}, lookupArgs, {
          onSearchSelection: this.handleOnReferrerPerformerAdditionAdd,
          onSearch: this.handleReferrerSearch,
          searchResults: this.props.referringProviderSearchResults,
          actionPrefix: '',
          autoSearch: true,
          placeholderText: isIPCServiceLine ? 'Search for a referring provider by name' : 'Search for a referring provider'
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.checkRequiredFieldValid(RequiredField.REFERRING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "help-text help-text-select"
        }, "The provider who referred the service.")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [!this.checkRequiredFieldValid(RequiredField.REFERRING_PROVIDER)]
        }, /*#__PURE__*/React.createElement("span", {
          className: "error-text help-text help-text-select"
        }, "Referring provider is required")))), /*#__PURE__*/React.createElement("button", {
          key: "Save",
          type: "button",
          onClick: this.handleFormSubmit,
          disabled: (_this$state$disableSu = (_this$state = this.state) === null || _this$state === void 0 ? void 0 : _this$state.disableSubmit) !== null && _this$state$disableSu !== void 0 ? _this$state$disableSu : true,
          className: "chakra-primary-button submit-btn invoice-submit ".concat((_this$state2 = this.state) !== null && _this$state2 !== void 0 && _this$state2.disableSubmit ? 'disabled' : '')
        }, "Save")), /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onFocus: this.handleCancel,
          style: {
            width: 0,
            height: 0,
            overflow: 'hidden'
          }
        })))));
      }
    }]);
  }(React.Component);
  _defineProperty(InvoiceEditor, "defaultProps", {
    billingProviderSearchResults: [],
    referringProviderSearchResults: [],
    performingProviderSearchResults: [],
    billingAreaOptions: [],
    providerRoleTypeConfig: [],
    useProviderDirectoryLocations: {
      on: false
    },
    onInvoiceSave: function onInvoiceSave(savableInvoice) {},
    onProviderRemove: function onProviderRemove(invoice) {},
    onProviderAdd: function onProviderAdd(provider) {},
    onInvoiceCancel: function onInvoiceCancel() {},
    onInvoiceCreate: function onInvoiceCreate(savableInvoice) {},
    onPerformerAdditionRemove: function onPerformerAdditionRemove(invoice) {},
    onReferringPerformerAdditionRemove: function onReferringPerformerAdditionRemove(invoice) {},
    onPerformerAdditionAdd: function onPerformerAdditionAdd(provider) {},
    onReferrerPerformerAdditionAdd: function onReferrerPerformerAdditionAdd(provider) {},
    onPerformerAdditionSearch: function onPerformerAdditionSearch(query) {},
    onPerformDateChange: function onPerformDateChange(newDate) {}
  });

  function ownKeys$f(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$f(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$f(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$f(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$a(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$a() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$a() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$a = function _isNativeReflectConstruct() { return !!t; })(); }
  var reducers = uiCommon.AmplifyCore.reducers;
  var DocumentStatus$1 = uiCommon.commonEnums.DocumentStatus,
    FeedbackMeta = uiCommon.commonEnums.FeedbackMeta;
    uiCommon.commonEnums.ProviderType;
  var conditionalUtils$2 = uiCommon.AmplifyCore.conditionalUtils;
  var InvoiceEditorActions = uiCommon.commonActions.InvoiceEditor;
  var documentStatusOptions = [{
    value: DocumentStatus$1.OPEN,
    label: 'Open'
  }, {
    value: DocumentStatus$1.RESOLVED,
    label: 'Resolved'
  }, {
    value: DocumentStatus$1.INCOMPLETE,
    label: 'Incomplete'
  }, {
    value: DocumentStatus$1.NOT_CORRECTED,
    label: 'Not corrected'
  }];
  var ImprovementProviderSearch = /*#__PURE__*/function (_React$Component) {
    function ImprovementProviderSearch() {
      var _this;
      _classCallCheck(this, ImprovementProviderSearch);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _callSuper$a(this, ImprovementProviderSearch, [].concat(args));
      _defineProperty(_this, "handleProviderSearch", function (codeQuery) {
        var context = _objectSpread$f(_objectSpread$f({}, codeQuery.context), {}, {
          searchType: InvoiceEditorActions.PERFORMING_PROVIDER_RESULTS,
          processInstance: _this.props.processInstance,
          providerType: uiCommon.commonEnums.ProviderType.REFERRING_PROVIDER,
          shouldFilterActive: true,
          shouldFilterOutExternalProviders: true
        });
        _this.props.onProviderSearch(_objectSpread$f(_objectSpread$f({}, codeQuery), {}, {
          context: context
        }));
      });
      _defineProperty(_this, "handleProviderAdd", function (payload) {
        var _this$props$improveme;
        var provider = _objectSpread$f(_objectSpread$f({}, payload.codeInfo), payload.context);
        var providerIdentifier = reducers.getProviderInfo(provider);
        var proivderName = provider === null || provider === void 0 ? void 0 : provider.displayName;
        var providerQueryStatus = (_this$props$improveme = _this.props.improvement) !== null && _this$props$improveme !== void 0 && _this$props$improveme.provider_query ? DocumentStatus$1.OPEN : null;
        var isExistingProvider = _this.props.improvement.providers.some(function (pr) {
          return pr.provider_number === providerIdentifier.number;
        });
        if (isExistingProvider) {
          var feedback = {
            message: "Provider ".concat(proivderName, " already exists, Choose a different provider."),
            meta: FeedbackMeta.WARNING,
            dismissable: true
          };
          _this.props.showAmplifyFeedback(feedback);
        }
        if (providerIdentifier.number && !isExistingProvider) {
          var improvementRequest = {
            processInstance: _this.props.processInstance,
            documentImprovement: _this.props.improvement,
            improvementProvider: {
              provider_number: providerIdentifier.number,
              provider_name: proivderName,
              provider_query_status: providerQueryStatus,
              deleted: false
            }
          };
          _this.props.onProviderAdd(improvementRequest);
        }
      });
      return _this;
    }
    _inherits(ImprovementProviderSearch, _React$Component);
    return _createClass(ImprovementProviderSearch, [{
      key: "render",
      value: function render() {
        var _appServiceLines$isIP, _this$props$processIn, _appServiceLines$isSu, _this$props$processIn2;
        var _this$props = this.props,
          improvementsAction = _this$props.improvementsAction,
          providerSearchResults = _this$props.providerSearchResults;
        var isIPCServiceLine = (_appServiceLines$isIP = uiCommon.appServiceLines.isIPC((_this$props$processIn = this.props.processInstance) === null || _this$props$processIn === void 0 ? void 0 : _this$props$processIn.serviceLine)) !== null && _appServiceLines$isIP !== void 0 ? _appServiceLines$isIP : false;
        var isSurgeryServiceLine = (_appServiceLines$isSu = uiCommon.appServiceLines.isSurgery((_this$props$processIn2 = this.props.processInstance) === null || _this$props$processIn2 === void 0 ? void 0 : _this$props$processIn2.serviceLine)) !== null && _appServiceLines$isSu !== void 0 ? _appServiceLines$isSu : false;
        var lookupArgs = isIPCServiceLine || isSurgeryServiceLine ? _objectSpread$f({}, DEFAULT_ARGS_V2) : _objectSpread$f({}, DEFAULT_ARGS);
        return /*#__PURE__*/React.createElement("div", {
          className: "improvement-provider-search"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement(uiComponents.Lookup, _extends$1({}, lookupArgs, {
          autoFocus: true,
          showSearchButton: false,
          onSearchSelection: this.handleProviderAdd,
          onSearch: this.handleProviderSearch,
          searchResults: providerSearchResults,
          actionPrefix: '',
          autoSearch: true,
          placeholderText: 'Add provider'
        }))));
      }
    }]);
  }(React.Component);
  _defineProperty(ImprovementProviderSearch, "displayName", 'ImprovementProviderSearch');
  var ImprovementProvider = /*#__PURE__*/function (_React$Component2) {
    function ImprovementProvider(props) {
      var _this2;
      _classCallCheck(this, ImprovementProvider);
      _this2 = _callSuper$a(this, ImprovementProvider, [props]);
      _defineProperty(_this2, "handleProviderDelete", function (ev) {
        ev.preventDefault();
        var improvementRequest = {
          processInstance: _this2.props.processInstance,
          documentImprovement: _this2.props.improvement,
          improvementProvider: {
            provider_guid: _this2.props.provider.provider_guid
          }
        };
        _this2.props.onProviderRemove(improvementRequest);
      });
      _defineProperty(_this2, "handleProviderUpdate", function (statusObj) {
        var _this2$props$provider;
        _this2.setState({
          providerQueryStatus: statusObj.detail.value
        });
        var improvementRequest = {
          processInstance: _this2.props.processInstance,
          documentImprovement: _this2.props.improvement,
          improvementProvider: {
            provider_guid: (_this2$props$provider = _this2.props.provider) === null || _this2$props$provider === void 0 ? void 0 : _this2$props$provider.provider_guid,
            provider_query_status: statusObj.detail.value,
            deleted: false
          }
        };
        _this2.props.onProviderUpdate(improvementRequest);
      });
      _this2.state = {
        providerQueryStatus: _this2.props.provider.provider_query_status
      };
      _this2.handleProviderDelete = _this2.handleProviderDelete.bind(_this2);
      _this2.handleProviderUpdate = _this2.handleProviderUpdate.bind(_this2);
      return _this2;
    }
    _inherits(ImprovementProvider, _React$Component2);
    return _createClass(ImprovementProvider, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _prevProps$provider, _this$props2;
        if ((prevProps === null || prevProps === void 0 || (_prevProps$provider = prevProps.provider) === null || _prevProps$provider === void 0 ? void 0 : _prevProps$provider.provider_query_status) !== ((_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.provider) === null || _this$props2 === void 0 ? void 0 : _this$props2.provider_query_status)) {
          var _this$props$provider;
          this.setState({
            providerQueryStatus: (_this$props$provider = this.props.provider) === null || _this$props$provider === void 0 ? void 0 : _this$props$provider.provider_query_status
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state$providerQ;
        var _this$props3 = this.props,
          provider = _this$props3.provider,
          improvement = _this$props3.improvement,
          improvementsAction = _this$props3.improvementsAction;
        var documentStatusStyle = ['provider-status', this.state.providerQueryStatus && "provider-status-".concat((_this$state$providerQ = this.state.providerQueryStatus) === null || _this$state$providerQ === void 0 ? void 0 : _this$state$providerQ.toLowerCase())];
        var providerReasonView = conditionalUtils$2.capabilityValue(improvementsAction === null || improvementsAction === void 0 ? void 0 : improvementsAction.actionable) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.SelectList, {
          name: "provider-status-".concat(provider.provider_guid),
          options: documentStatusOptions,
          value: provider.provider_query_status,
          onChange: this.handleProviderUpdate
        }), /*#__PURE__*/React.createElement("label", {
          className: "provider-status-select-label"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeChevronDownSVG20",
          svgIconSize: "16",
          svgIconClass: "select-checvron"
        }))) : /*#__PURE__*/React.createElement("span", {
          className: "provider-reason-label"
        }, uiCommon.objectUtils.capitalize(provider.provider_query_status));
        return /*#__PURE__*/React.createElement("div", {
          className: "improvement-provider",
          key: provider.provider_guid
        }, /*#__PURE__*/React.createElement("div", {
          className: "provider-row-left"
        }, (improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) && /*#__PURE__*/React.createElement("div", {
          className: classnames(documentStatusStyle)
        }, providerReasonView), /*#__PURE__*/React.createElement("span", {
          className: "provider-name"
        }, provider.provider_name)), /*#__PURE__*/React.createElement("div", {
          className: "provider-row-right"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement("div", {
          className: "provider-remove",
          onClick: this.handleProviderDelete,
          "data-testid": "improvement-provider-remove"
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeCancelCircle",
          svgIconClass: "improvement-provider-remove",
          svgIconSize: "18"
        })))));
      }
    }]);
  }(React.Component);
  _defineProperty(ImprovementProvider, "displayName", 'ImprovementProvider');
  var ImprovementProviders = function ImprovementProviders(props) {
    var improvement = props.improvement,
      improvementsAction = props.improvementsAction,
      processInstance = props.processInstance,
      onProviderUpdate = props.onProviderUpdate,
      onProviderRemove = props.onProviderRemove;
    var providers = improvement.providers;
    var providersView = providers === null || providers === void 0 ? void 0 : providers.map(function (provider, idx) {
      return /*#__PURE__*/React.createElement(ImprovementProvider, {
        key: idx,
        provider: provider,
        processInstance: processInstance,
        improvement: improvement,
        improvementsAction: improvementsAction,
        onProviderUpdate: onProviderUpdate,
        onProviderRemove: onProviderRemove
      });
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "improvement-providers"
    }, providersView);
  };
  ImprovementProviders.displayName = 'ImprovementProviders';

  function ownKeys$e(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$e(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$e(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$e(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var ImprovementCharge = function ImprovementCharge(props) {
    var _improvement$charge_c, _improvement$potentia;
    var improvement = props.improvement,
      improvementsAction = props.improvementsAction,
      processInstance = props.processInstance,
      activeItem = props.activeItem,
      userContext = props.userContext,
      procedureSearchResults = props.procedureSearchResults,
      onCodeSearch = props.onCodeSearch,
      onImprovementUpdate = props.onImprovementUpdate,
      onSearchClear = props.onSearchClear;
    var handleChargeSearch = function handleChargeSearch(codeQuery) {
      var _codeQuery$text;
      var query = _objectSpread$e(_objectSpread$e({}, codeQuery), {}, {
        searchType: 'CPT',
        context: {
          activeItem: _objectSpread$e({}, activeItem),
          userContext: _objectSpread$e({}, userContext),
          processInstance: _objectSpread$e({}, processInstance),
          improvementGuid: improvement.document_improvement_guid
        }
      });
      if ((codeQuery === null || codeQuery === void 0 || (_codeQuery$text = codeQuery.text) === null || _codeQuery$text === void 0 ? void 0 : _codeQuery$text.length) >= 2) {
        onCodeSearch(_objectSpread$e({}, query));
      } else {
        onSearchClear(_objectSpread$e({}, query));
      }
    };
    var handleChargeUpdate = function handleChargeUpdate(isPotentialCharge, codeData) {
      var charge = isPotentialCharge ? 'potential_charge_code' : 'charge_code';
      var improvementRequest = {
        processInstance: processInstance,
        documentImprovement: _defineProperty({
          document_improvement_guid: improvement.document_improvement_guid
        }, charge, codeData)
      };
      onImprovementUpdate(improvementRequest);
    };
    var handleChargeSelection = function handleChargeSelection(searchResult) {
      var _searchResult$context;
      if (searchResult !== null && searchResult !== void 0 && (_searchResult$context = searchResult.context) !== null && _searchResult$context !== void 0 && _searchResult$context.defaultPrevented) {
        onSearchClear({
          context: searchResult.context
        });
      } else {
        var _searchResult$codeInf;
        handleChargeUpdate(false, searchResult === null || searchResult === void 0 || (_searchResult$codeInf = searchResult.codeInfo) === null || _searchResult$codeInf === void 0 ? void 0 : _searchResult$codeInf.code);
      }
    };
    var handlePotentialChargeSelection = function handlePotentialChargeSelection(searchResult) {
      var _searchResult$codeInf2;
      handleChargeUpdate(true, searchResult === null || searchResult === void 0 || (_searchResult$codeInf2 = searchResult.codeInfo) === null || _searchResult$codeInf2 === void 0 ? void 0 : _searchResult$codeInf2.code);
    };
    var handleChargeRemove = function handleChargeRemove(ev) {
      ev.preventDefault();
      handleChargeUpdate(false, null);
    };
    var handlePotentialChargeRemove = function handlePotentialChargeRemove(ev) {
      ev.preventDefault();
      handleChargeUpdate(true, null);
    };
    var lookupRef = /*#__PURE__*/React.createRef();
    var isViewOnly = !uiCommon.AmplifyCore.conditionalUtils.capabilityValue(improvementsAction === null || improvementsAction === void 0 ? void 0 : improvementsAction.on);

    /**
     * Do not show the charge row when the case is in view only and
     * both charge code and potential charge code are not present
     */
    var isViewOnlyWithNoCharge = isViewOnly && !(improvement !== null && improvement !== void 0 && improvement.charge_code) && !(improvement !== null && improvement !== void 0 && improvement.potential_charge_code);
    var existingCharge = !isViewOnlyWithNoCharge && /*#__PURE__*/React.createElement("div", {
      className: "procedure-code"
    }, /*#__PURE__*/React.createElement("div", {
      className: "charge-left"
    }, /*#__PURE__*/React.createElement("span", null, "Charge:"), /*#__PURE__*/React.createElement("span", {
      className: improvement !== null && improvement !== void 0 && improvement.charge_code ? 'procedure-label' : 'no-code'
    }, (_improvement$charge_c = improvement === null || improvement === void 0 ? void 0 : improvement.charge_code) !== null && _improvement$charge_c !== void 0 ? _improvement$charge_c : '-')), /*#__PURE__*/React.createElement("div", {
      className: "charge-right"
    }, /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement("div", {
      className: "charge-remove",
      onClick: handleChargeRemove
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeCancelCircle",
      svgIconClass: "improvement-provider-remove",
      svgIconSize: "18"
    })))));
    var existingPotentialCharge = !isViewOnlyWithNoCharge && /*#__PURE__*/React.createElement("div", {
      className: "potential-code"
    }, /*#__PURE__*/React.createElement("div", {
      className: "charge-left"
    }, /*#__PURE__*/React.createElement("span", null, "Potential Charge:"), /*#__PURE__*/React.createElement("span", {
      className: improvement !== null && improvement !== void 0 && improvement.potential_charge_code ? 'procedure-label' : 'no-code'
    }, (_improvement$potentia = improvement === null || improvement === void 0 ? void 0 : improvement.potential_charge_code) !== null && _improvement$potentia !== void 0 ? _improvement$potentia : '-')), /*#__PURE__*/React.createElement("div", {
      className: "charge-right"
    }, /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement("div", {
      className: "potential-charge-remove",
      onClick: handlePotentialChargeRemove
    }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeCancelCircle",
      svgIconClass: "improvement-provider-remove",
      svgIconSize: "18"
    })))));
    return /*#__PURE__*/React.createElement("div", {
      className: "charge-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "charge-row-left"
    }, improvement !== null && improvement !== void 0 && improvement.charge_code || isViewOnly ? existingCharge : /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement("div", {
      className: "procedure-code-add"
    }, /*#__PURE__*/React.createElement(uiComponents.Lookup, {
      ref: lookupRef,
      actionPrefix: "",
      placeholderText: "Add charge",
      shouldShowResults: uiComponents.shouldShowResults,
      onSearch: handleChargeSearch,
      onSearchSelection: handleChargeSelection,
      searchResults: procedureSearchResults,
      showSearchButton: false
    }), /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeChevronDownSVG20",
      svgIconSize: "20",
      svgIconClass: "select-checvron"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "charge-row-right"
    }, improvement !== null && improvement !== void 0 && improvement.potential_charge_code || isViewOnly ? existingPotentialCharge : /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement("div", {
      className: "potential-code-add"
    }, /*#__PURE__*/React.createElement(uiComponents.Lookup, {
      ref: lookupRef,
      actionPrefix: "",
      placeholderText: "Add potential charge",
      shouldShowResults: uiComponents.shouldShowResults,
      onSearch: handleChargeSearch,
      onSearchSelection: handlePotentialChargeSelection,
      searchResults: procedureSearchResults,
      showSearchButton: false
    }), /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeChevronDownSVG20",
      svgIconSize: "20",
      svgIconClass: "select-checvron"
    })))));
  };
  ImprovementCharge.displayName = 'ImprovementCharge';

  function ownKeys$d(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$d(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$d(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$d(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$9(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$9() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$9() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$9 = function _isNativeReflectConstruct() { return !!t; })(); }
  var DocumentStatus = uiCommon.commonEnums.DocumentStatus;
  var isOpenImprovement = function isOpenImprovement(improvement) {
    var _improvement$provider, _improvement$provider2, _improvement$provider3;
    var requiredImprovement = (_improvement$provider = improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) !== null && _improvement$provider !== void 0 ? _improvement$provider : false;
    var noProviderImprovement = requiredImprovement && (improvement === null || improvement === void 0 || (_improvement$provider2 = improvement.providers) === null || _improvement$provider2 === void 0 ? void 0 : _improvement$provider2.length) === 0;
    var openImprovement = requiredImprovement && (improvement === null || improvement === void 0 || (_improvement$provider3 = improvement.providers) === null || _improvement$provider3 === void 0 ? void 0 : _improvement$provider3.some(function (provider) {
      return (provider === null || provider === void 0 ? void 0 : provider.provider_query_status) === DocumentStatus.OPEN;
    }));
    return noProviderImprovement ? 'NO_PROVIDER' : openImprovement ? 'OPEN_REASON' : 'OTHERS';
  };
  // ---------------- utilities ----------------- //

  /**
   * Formatting for the auto-complete search
   * @param activeIdx
   * @param entity
   * @param idx
   * @returns
   */
  var resultFormatter = function resultFormatter(activeIdx, entity, idx) {
    var styleClasses = ['search-result', {
      'result-unselectable': true
    }];
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      "data-idx": idx,
      className: classnames(styleClasses),
      draggable: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-label search-label"
    }, entity['Error Code']), /*#__PURE__*/React.createElement("div", {
      className: "col-code-description"
    }, entity['Documentation Improvement Opportunity Description']));
  };

  /**
   * Retrieve item from the search results.  Used to pass to the onAdd handler.
   * @param row
   * @param selectElement
   * @param searchResults
   * @returns
   */
  var getSelectionData = function getSelectionData(row, selectElement, searchResults) {
    var item = row.attributes.getNamedItem('data-idx');
    if (!item) return;
    return searchResults[item.value];
  };
  var shouldShowResults = function shouldShowResults(lookupState) {
    var _codeQuery$text;
    var active = lookupState.active,
      searching = lookupState.searching,
      codeQuery = lookupState.codeQuery;
    if (!active) {
      return false;
    }
    if (searching) {
      return true;
    }
    // one character names are displayable.
    return ((_codeQuery$text = codeQuery === null || codeQuery === void 0 ? void 0 : codeQuery.text) !== null && _codeQuery$text !== void 0 ? _codeQuery$text : '').length >= 1;
  };

  // ---------------- React Components ----------------- //
  var ImprovementMenu = function ImprovementMenu(_ref) {
    var showAddProvider = _ref.showAddProvider,
      onAddProvider = _ref.onAddProvider,
      onDeleteImprovement = _ref.onDeleteImprovement;
    var icon = /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
      svgIconName: "BiomeVerticalMenu",
      svgIconClass: "improvement-menu-button",
      svgIconSize: "16"
    });
    return /*#__PURE__*/React.createElement(MenuButton, {
      icon: icon
    }, !showAddProvider && /*#__PURE__*/React.createElement(MenuItem, {
      onSelect: onAddProvider
    }, "Add provider"), /*#__PURE__*/React.createElement(MenuItem, {
      onSelect: onDeleteImprovement
    }, "Delete"));
  };
  var Improvement = /*#__PURE__*/function (_React$Component) {
    function Improvement(props) {
      var _this;
      _classCallCheck(this, Improvement);
      _this = _callSuper$9(this, Improvement, [props]);
      _defineProperty(_this, "providerQueryIcon", function (improvement) {
        return improvement.provider_query ? /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeVWErrorSVG20",
          svgIconClass: "improvement-required",
          svgTitleText: "Provider query is required"
        }) : /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeReports",
          svgIconClass: "improvement-not-required",
          svgTitleText: "Provider query is not required"
        });
      });
      _defineProperty(_this, "onImprovementDelete", function (ev) {
        ev.preventDefault();
        _this.props.onImprovementRemove(_this.props.improvement);
      });
      _defineProperty(_this, "onAddProvider", function (ev) {
        _this.setState({
          showAddProvider: !_this.state.showAddProvider
        });
      });
      _this.state = {
        showAddProvider: props.improvement.providers.length === 0
      };
      _this.onImprovementDelete = _this.onImprovementDelete.bind(_this);
      _this.onAddProvider = _this.onAddProvider.bind(_this);
      return _this;
    }
    _inherits(Improvement, _React$Component);
    return _createClass(Improvement, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.improvement.providers.length !== this.props.improvement.providers.length) {
          this.setState({
            showAddProvider: this.props.improvement.providers.length === 0
          });
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          some: [!this.props.showUnresolved, this.props.showUnresolved && isOpenImprovement(this.props.improvement) !== 'OTHERS']
        }, /*#__PURE__*/React.createElement("div", {
          className: "improvement qa-improvement",
          key: this.props.improvement.document_improvement_guid
        }, /*#__PURE__*/React.createElement("div", {
          className: "improvement-row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "improvement-no-actions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "improvement-icon"
        }, this.providerQueryIcon(this.props.improvement)), /*#__PURE__*/React.createElement("div", {
          className: "improvement-text"
        }, /*#__PURE__*/React.createElement("span", {
          className: "improvement-code"
        }, /*#__PURE__*/React.createElement("b", null, this.props.improvement.code, ":"), ' '), /*#__PURE__*/React.createElement("span", {
          className: "improvement-description"
        }, this.props.improvement.description))), /*#__PURE__*/React.createElement("div", {
          className: "improvement-actions"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, this.props.improvementsAction, /*#__PURE__*/React.createElement(ImprovementMenu, {
          showAddProvider: this.state.showAddProvider,
          onAddProvider: this.onAddProvider,
          onDeleteImprovement: this.onImprovementDelete
        })))), /*#__PURE__*/React.createElement("div", {
          className: "improvement-body"
        }, /*#__PURE__*/React.createElement("div", {
          className: "provider-rows"
        }, /*#__PURE__*/React.createElement(ImprovementProviders, {
          improvement: this.props.improvement,
          improvementsAction: this.props.improvementsAction,
          processInstance: this.props.processInstance,
          onProviderRemove: this.props.onProviderRemove,
          onProviderUpdate: this.props.onProviderUpdate
        })), /*#__PURE__*/React.createElement(uiComponents.Conditional, this.props.improvementsAction, this.state.showAddProvider && /*#__PURE__*/React.createElement("div", {
          className: "provider-search"
        }, /*#__PURE__*/React.createElement(ImprovementProviderSearch, {
          improvement: this.props.improvement,
          improvementsAction: this.props.improvementsAction,
          organization: this.props.organization,
          processInstance: this.props.processInstance,
          providerSearchResults: this.props.providerSearchResults,
          onProviderAdd: this.props.onProviderAdd,
          onProviderSearch: this.props.onProviderSearch,
          showAmplifyFeedback: this.props.showAmplifyFeedback
        }), /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeChevronDownSVG20",
          svgIconSize: "20",
          svgIconClass: "select-checvron"
        }))), /*#__PURE__*/React.createElement(ImprovementCharge, {
          improvement: this.props.improvement,
          improvementsAction: this.props.improvementsAction,
          processInstance: this.props.processInstance,
          procedureSearchResults: this.props.procedureSearchResults,
          activeItem: this.props.activeItem,
          userContext: this.props.userContext,
          onImprovementUpdate: this.props.onImprovementUpdate,
          onCodeSearch: this.props.onCodeSearch,
          onSearchClear: this.props.onSearchClear
        }))));
      }
    }]);
  }(React.Component);
  ImprovementMenu.displayName = 'ImprovementMenu';
  var Improvements = /*#__PURE__*/function (_React$Component2) {
    function Improvements(props) {
      var _props$showUnresolved;
      var _this2;
      _classCallCheck(this, Improvements);
      _this2 = _callSuper$9(this, Improvements, [props]);
      _this2.state = {
        showUnresolved: (_props$showUnresolved = props === null || props === void 0 ? void 0 : props.showUnresolved) !== null && _props$showUnresolved !== void 0 ? _props$showUnresolved : false
      };
      _this2.handleImprovementAdd = _this2.handleImprovementAdd.bind(_this2);
      _this2.handleImprovementRemove = _this2.handleImprovementRemove.bind(_this2);
      _this2.handleImprovementUpdate = _this2.handleImprovementUpdate.bind(_this2);
      _this2.toggleFilter = _this2.toggleFilter.bind(_this2);
      _this2.handleImprovementAdd = _this2.handleImprovementAdd.bind(_this2);
      return _this2;
    }
    _inherits(Improvements, _React$Component2);
    return _createClass(Improvements, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (prevProps.showUnresolved !== this.props.showUnresolved) {
          this.setState({
            showUnresolved: this.props.showUnresolved
          });
        }
      }
    }, {
      key: "handleImprovementAdd",
      value: function handleImprovementAdd(improvementDictionaryRow) {
        if (typeof improvementDictionaryRow !== 'undefined') {
          var improvementRequest = {
            processInstance: this.props.processInstance,
            improvementDictionaryRow: improvementDictionaryRow.codeInfo
          };
          this.props.onDocumentImprovementAdd(improvementRequest);
        }
      }
    }, {
      key: "handleImprovementUpdate",
      value: function handleImprovementUpdate(improvement) {
        var improvementRequest = {
          processInstance: this.props.processInstance,
          documentImprovement: improvement
        };
        this.props.onDocumentImprovementUpdate(improvementRequest);
      }
    }, {
      key: "handleImprovementRemove",
      value: function handleImprovementRemove(documentImprovement) {
        var improvementRequest = {
          processInstance: this.props.processInstance,
          documentImprovement: documentImprovement
        };
        this.props.onDocumentImprovementRemove(improvementRequest);
      }
    }, {
      key: "toggleFilter",
      value: function toggleFilter(event) {
        var _this$state;
        event.preventDefault();
        this.setState({
          showUnresolved: !((_this$state = this.state) !== null && _this$state !== void 0 && _this$state.showUnresolved)
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;
        var props = _objectSpread$d({}, this.props);
        var improvements = props.improvements,
          improvementsAction = props.improvementsAction,
          organization = props.organization,
          processInstance = props.processInstance;
        var documentImprovements = improvements === null || improvements === void 0 ? void 0 : improvements.improvements;
        var displayedImprovements;
        if (documentImprovements.length === 0) {
          displayedImprovements = /*#__PURE__*/React.createElement("div", {
            className: "empty-message"
          }, "No Document Improvements.");
        } else {
          displayedImprovements = documentImprovements === null || documentImprovements === void 0 ? void 0 : documentImprovements.map(function (improvement, idx) {
            return /*#__PURE__*/React.createElement(Improvement, {
              key: idx,
              improvement: improvement,
              improvementsAction: _this3.props.improvementsAction,
              organization: organization,
              processInstance: processInstance,
              providerSearchResults: improvements.providerSearchResults,
              procedureSearchResults: improvements.procedureSearchResults,
              onProviderSearch: _this3.props.onProviderSearch,
              onImprovementRemove: _this3.handleImprovementRemove,
              onSearchClear: _this3.props.onSearchClear,
              onProviderAdd: _this3.props.onProviderAdd,
              onProviderRemove: _this3.props.onProviderRemove,
              onProviderUpdate: _this3.props.onProviderUpdate,
              showAmplifyFeedback: _this3.props.showAmplifyFeedback,
              onImprovementUpdate: _this3.props.onDocumentImprovementUpdate,
              onCodeSearch: _this3.props.onCodeSearch,
              activeItem: _this3.props.activeItem,
              userContext: improvements.userContext,
              showUnresolved: _this3.state.showUnresolved
            });
          });
        }
        var filterLabel = "".concat(this.state.showUnresolved ? 'Showing unresolved' : 'Showing all');
        return /*#__PURE__*/React.createElement("div", {
          className: "improvements"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [documentImprovements.length > 0]
        }, /*#__PURE__*/React.createElement("div", {
          className: filterLabel.toLowerCase().replace(' ', '-'),
          onClick: this.toggleFilter
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [this.state.showUnresolved]
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomeCheckSVG20",
          svgIconClass: "unresolved-filter",
          svgIconSize: "16"
        })), filterLabel)), displayedImprovements, /*#__PURE__*/React.createElement(uiComponents.Conditional, improvementsAction, /*#__PURE__*/React.createElement(uiComponents.Lookup, {
          resultFormatter: resultFormatter,
          getSelectionData: getSelectionData,
          onSearch: this.props.onDocumentImprovementSearch
          //@ts-ignore
          ,
          onSearchSelection: this.handleImprovementAdd,
          searchResults: improvements.searchResults,
          placeholderText: 'Add reason for document improvement',
          minLength: 1,
          shouldShowResults: shouldShowResults
        })));
      }
    }]);
  }(React.Component);
  _defineProperty(Improvements, "displayName", 'Improvements');

  function ownKeys$c(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$c(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$c(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$c(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$8(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$8() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$8() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$8 = function _isNativeReflectConstruct() { return !!t; })(); }
  var FieldDefinitions = [{
    key: "remove_hold",
    helpText: 'Remove hold status on submit.'
  }];
  var VitalWareModal = /*#__PURE__*/function (_React$Component) {
    function VitalWareModal(props) {
      var _this;
      _classCallCheck(this, VitalWareModal);
      _this = _callSuper$8(this, VitalWareModal, [props]);
      _defineProperty(_this, "commentRef", void 0);
      _this.commentRef = /*#__PURE__*/React.createRef();
      _this.setCommentLength = _this.setCommentLength.bind(_this);
      _this.handleUnresolvedDocumentsClick = _this.handleUnresolvedDocumentsClick.bind(_this);
      _this.handleRemoveHoldChange = _this.handleRemoveHoldChange.bind(_this);
      _this.state = {
        commentLength: 0,
        removeHoldSelected: false
      };
      return _this;
    }
    _inherits(VitalWareModal, _React$Component);
    return _createClass(VitalWareModal, [{
      key: "setCommentLength",
      value: function setCommentLength(commentLength) {
        this.setState(_objectSpread$c(_objectSpread$c({}, this.state), {}, {
          commentLength: commentLength
        }));
      }
    }, {
      key: "handleUnresolvedDocumentsClick",
      value: function handleUnresolvedDocumentsClick(ev) {
        ev.preventDefault();
        this.props.onClose();
        this.props.setUnresolvedDocuments(true);
        this.props.setActiveMiniTab(uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL);
      }
    }, {
      key: "handleRemoveHoldChange",
      value: function handleRemoveHoldChange(event) {
        var _event$detail$value$c;
        event.preventDefault();
        var removeHoldValue = (_event$detail$value$c = event.detail.value.checkboxes) === null || _event$detail$value$c === void 0 ? void 0 : _event$detail$value$c.remove_hold;
        this.setState(_objectSpread$c(_objectSpread$c({}, this.state), {}, {
          removeHoldSelected: removeHoldValue
        }));
      }
    }, {
      key: "render",
      value: function render() {
        var _props$improvements,
          _props$improvements2,
          _props$vitalwareIssue,
          _props$vitalwareIssue2,
          _props$mergeSplitHist,
          _this2 = this;
        var props = this.props;
        var commentLength = this.state.commentLength;
        var unresolvedReasonsCount = (_props$improvements = props.improvements) === null || _props$improvements === void 0 ? void 0 : _props$improvements.filter(function (improvement) {
          var _improvement$provider, _improvement$provider2;
          return (improvement === null || improvement === void 0 ? void 0 : improvement.provider_query) && ((improvement === null || improvement === void 0 || (_improvement$provider = improvement.providers) === null || _improvement$provider === void 0 ? void 0 : _improvement$provider.length) === 0 || (improvement === null || improvement === void 0 || (_improvement$provider2 = improvement.providers) === null || _improvement$provider2 === void 0 ? void 0 : _improvement$provider2.some(function (provider) {
            return (provider === null || provider === void 0 ? void 0 : provider.provider_query_status) === uiCommon.commonEnums.DocumentStatus.OPEN;
          })));
        }).length;
        var getErrors = function getErrors(issues, code) {
          return issues && issues[code] && issues[code][uiCommon.commonEnums.EditorIssueLevel.ERROR] ? issues[code][uiCommon.commonEnums.EditorIssueLevel.ERROR] : [];
        };
        var someError = props.vitalwareIssues.some(function (issues) {
          return Object.keys(issues).some(function (code) {
            return getErrors(issues, code).length > 0;
          });
        });
        var overrideSubmitButtonClasses = classnames(['override-submit-button', 'chakra-primary-button', {
          disabled: someError && (commentLength || 0) === 0 || props.documentImprovementIssues.length > 0 && unresolvedReasonsCount !== 0 || props.holdIssues.length > 0 && !this.state.removeHoldSelected
        }]);
        return /*#__PURE__*/React.createElement("div", {
          className: "top-level-modal vw-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          closable: true,
          maximize: false,
          onClose: props.onClose,
          title: "Can you check these items before submission?"
        }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [props.mergeSplitHistoryIssues.length > 0]
        }, /*#__PURE__*/React.createElement("div", {
          className: "merge_split_history"
        }, /*#__PURE__*/React.createElement("p", {
          className: "vw-title"
        }, "Changes occurred while you are working"), /*#__PURE__*/React.createElement("p", {
          className: "vw-overline"
        }, "You should close this and refresh the case to be sure everything still looks as you expect. Otherwise, with a comment you may override these warnings."), /*#__PURE__*/React.createElement("div", {
          className: "vw-issues-box vw-mergesplit-issues-box"
        }, props.mergeSplitHistoryIssues.map(function (issues, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: "merge-history-issue-".concat(index, "]")
          }, /*#__PURE__*/React.createElement("li", {
            className: "merge-split-detail"
          }, " ", issues.message));
        })))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [props.documentImprovementIssues.length > 0]
        }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
          className: "vw-title mandatory-error"
        }, "Improvement requests must be resolved"), /*#__PURE__*/React.createElement("p", {
          className: "vw-subtitle"
        }, "Submission is prevented while requests are open. Please resolve the document requests before submitting again.", " ", /*#__PURE__*/React.createElement("span", {
          onClick: this.handleUnresolvedDocumentsClick,
          className: "cmx-link"
        }, "Manage open document improvement reasons.")), /*#__PURE__*/React.createElement("div", {
          className: "vw-issues-section vw-error-issues"
        }, (_props$improvements2 = props.improvements) === null || _props$improvements2 === void 0 ? void 0 : _props$improvements2.map(function (improvement, idx) {
          var isOpenReason = isOpenImprovement(improvement);
          var reasonText = isOpenReason === 'NO_PROVIDER' ? 'is missing provider.' : isOpenReason === 'OPEN_REASON' ? ' has an open status and must be closed to proceed.' : '';
          return /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            some: [isOpenReason === 'NO_PROVIDER', isOpenReason === 'OPEN_REASON']
          }, /*#__PURE__*/React.createElement("li", {
            className: "vw-issues-text"
          }, "".concat(improvement.code, " ").concat(reasonText)));
        })))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [props.holdIssues.length > 0]
        }, /*#__PURE__*/React.createElement("div", {
          className: "hold-issues"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "vw-title ".concat(this.state.removeHoldSelected ? '' : 'mandatory-error')
        }, "Case is in a hold status"), /*#__PURE__*/React.createElement("p", {
          className: "vw-subtitle"
        }, "Please confirm this case is ready for processing by removing the hold status."), /*#__PURE__*/React.createElement(uiComponents.CheckList, {
          FieldDefinitions: FieldDefinitions,
          value: {
            remove_hold: false
          },
          onChange: this.handleRemoveHoldChange
        }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          every: [((_props$vitalwareIssue = props.vitalwareIssues) === null || _props$vitalwareIssue === void 0 ? void 0 : _props$vitalwareIssue.length) > 0]
        }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
          className: "vw-title"
        }, "Warning: Claims Issues"), /*#__PURE__*/React.createElement("p", {
          className: "vw-subtitle"
        }, "Are you sure you want to submit the charges with the following claims issues?"), /*#__PURE__*/React.createElement("div", {
          className: "vw-issues-box"
        }, props.vitalwareIssues.map(function (issues, index) {
          return /*#__PURE__*/React.createElement("div", {
            key: "claims-issue-".concat(index, "]")
          }, Object.keys(issues).map(function (code, codeIdx) {
            return /*#__PURE__*/React.createElement("div", {
              key: "codeIdx"
            }, /*#__PURE__*/React.createElement("p", {
              className: "vw-code-title"
            }, code), /*#__PURE__*/React.createElement("ul", null, getErrors(issues, code) && getErrors(issues, code).length > 0 && /*#__PURE__*/React.createElement("div", {
              className: "vw-issues-section vw-error-issues"
            }, /*#__PURE__*/React.createElement("h3", {
              className: "vw-issues-title vw-issues-error"
            }, "ERRORS"), getErrors(issues, code).map(function (issue, issIndex) {
              return /*#__PURE__*/React.createElement("li", {
                className: "vw-issues-text",
                key: "claims-issue-errors-".concat(index, "-").concat(issIndex, "]")
              }, issue.message);
            })), issues[code][uiCommon.commonEnums.EditorIssueLevel.WARNING] && issues[code][uiCommon.commonEnums.EditorIssueLevel.WARNING].length > 0 && /*#__PURE__*/React.createElement("div", {
              className: "vw-issues-section vw-warning-issues"
            }, /*#__PURE__*/React.createElement("h3", {
              className: "vw-issues-title vw-issues-warning"
            }, "WARNINGS"), issues[code][uiCommon.commonEnums.EditorIssueLevel.WARNING].map(function (issue, issIndex) {
              return /*#__PURE__*/React.createElement("li", {
                className: "vw-issues-text",
                key: "claims-issue-warnings-".concat(index, "-").concat(issIndex, "]")
              }, issue.message);
            }))));
          }));
        })))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          some: [((_props$vitalwareIssue2 = props.vitalwareIssues) === null || _props$vitalwareIssue2 === void 0 ? void 0 : _props$vitalwareIssue2.length) > 0, ((_props$mergeSplitHist = props.mergeSplitHistoryIssues) === null || _props$mergeSplitHist === void 0 ? void 0 : _props$mergeSplitHist.length) > 0, props.documentImprovementIssues.length > 0, props.holdIssues.length > 0]
        }, /*#__PURE__*/React.createElement("div", {
          className: "override-controls"
        }, /*#__PURE__*/React.createElement("textarea", {
          ref: this.commentRef,
          maxLength: 1024,
          onChange: function onChange(event) {
            return _this2.setCommentLength(event.target.value.length);
          },
          rows: 5,
          placeholder: "Enter reason (".concat(someError ? 'required' : 'optional', ")"),
          className: "vw-comment form-input input"
        }), /*#__PURE__*/React.createElement("p", {
          className: "vw-comment-count"
        }, commentLength, "/1024"), /*#__PURE__*/React.createElement("div", {
          className: "vw-buttons-group"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: props.onClose,
          className: "chakra-secondary-button override-close-button"
        }, "No, I'll make changes"), /*#__PURE__*/React.createElement("button", {
          className: classnames(overrideSubmitButtonClasses),
          onClick: function onClick(event) {
            return props.onSubmit(event, _this2.commentRef.current.value, props.holdIssues.length > 0 ? _this2.state.removeHoldSelected : null);
          }
        }, "Override & Submit"))))));
      }
    }]);
  }(React.Component);

  var _excluded$4 = ["invoiceOptions", "handleAddCharge", "handleInvoiceAddition", "className"];
  function ownKeys$b(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$b(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$b(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$b(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$7(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$7() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$7() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$7 = function _isNativeReflectConstruct() { return !!t; })(); }

  // ---------------------- types  ---------------------- //

  // ---------------------- utilities  ---------------------- //
  // React.forwardRef is used to allow the parent component to attach a ref
  // to this functional component, so that the parent can access the underlying DOM node.

  var InvoiceChoice = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
    var invoice = _ref.invoice,
      handleAddCharge = _ref.handleAddCharge;
    return /*#__PURE__*/React.createElement("div", {
      ref: ref,
      onClick: function onClick() {
        return handleAddCharge(invoice);
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') {
          handleAddCharge(invoice);
        }
      },
      tabIndex: 0,
      className: classnames('qa-invoice-box invoice-box', {
        'invoice-removed': invoice.deleted
      })
    }, /*#__PURE__*/React.createElement("p", {
      className: "invoice-box-title"
    }, invoice.billing_provider_name, invoice.billing_location && " at ".concat(invoice.billing_location)), /*#__PURE__*/React.createElement("small", {
      className: "invoice-box-subtitle"
    }, invoice.date_of_service ? uiCommon.cmxDateTime.format(invoice.date_of_service, uiCommon.cmxDateTime.FORMATS.LONG_DATE) : 'Date not available', invoice.deleted && /*#__PURE__*/React.createElement("span", null, " - Previously removed charge")));
  });
  var ChargeSelector = /*#__PURE__*/function (_React$Component) {
    function ChargeSelector(props) {
      var _this;
      _classCallCheck(this, ChargeSelector);
      _this = _callSuper$7(this, ChargeSelector, [props]);
      _defineProperty(_this, "firstActiveRef", void 0);
      _this.handleOpenClick.bind(_this);
      // Create a ref to focus the first active invoice when the component mounts.
      // This ref is passed to the first <InvoiceChoice /> component.
      _this.firstActiveRef = /*#__PURE__*/React.createRef();
      _this.state = {
        open: false
      };
      return _this;
    }
    _inherits(ChargeSelector, _React$Component);
    return _createClass(ChargeSelector, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // On mount, if the ref is attached, focus the first active invoice.
        if (this.firstActiveRef.current) {
          var _this$firstActiveRef$;
          (_this$firstActiveRef$ = this.firstActiveRef.current) === null || _this$firstActiveRef$ === void 0 || _this$firstActiveRef$.focus();
        }
      }
    }, {
      key: "handleOpenClick",
      value: function handleOpenClick(event) {
        event.preventDefault();
        var state = _objectSpread$b({}, this.state);
        state.open = !state.open;
        this.setState(state);
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var _this$props = this.props,
          invoiceOptions = _this$props.invoiceOptions,
          handleAddCharge = _this$props.handleAddCharge,
          handleInvoiceAddition = _this$props.handleInvoiceAddition,
          className = _this$props.className;
          _objectWithoutProperties(_this$props, _excluded$4);
        var invoices = invoiceOptions.invoices;
        var styleClasses = classnames(['charge-selector', className]);
        var activeInvoices = invoices.filter(function (invoice) {
          return !invoice.deleted;
        });
        var inactiveInvoices = invoices.filter(function (invoice) {
          return invoice.deleted;
        });
        return /*#__PURE__*/React.createElement("div", {
          className: styleClasses
        }, activeInvoices.map(function (invoice, idx) {
          return (
            /*#__PURE__*/
            // Pass the `ref` only to the first <InvoiceChoice /> so it can be focused on mount.
            // Since InvoiceChoice is a functional component, we wrapped it in React.forwardRef.
            React.createElement(InvoiceChoice, {
              key: idx,
              invoice: invoice,
              handleAddCharge: handleAddCharge,
              ref: idx === 0 ? _this2.firstActiveRef : undefined
            })
          );
        }), /*#__PURE__*/React.createElement("div", {
          tabIndex: 0,
          onClick: function onClick() {
            return handleInvoiceAddition(invoices);
          },
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Enter') {
              handleInvoiceAddition(invoices);
            }
          },
          key: 'qa-invoice-new-invoice',
          className: "qa-invoice-box qa-new-invoice invoice-box"
        }, /*#__PURE__*/React.createElement("p", {
          className: "invoice-box-title"
        }, "A different provider or date of service.")), inactiveInvoices.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("a", {
          href: "#show",
          className: "qa-show-all",
          onClick: function onClick(e) {
            return _this2.handleOpenClick(e);
          }
        }, this.state.open ? 'Hide' : 'Show', ' ', "".concat(inactiveInvoices.length), " previous removed", ' ', pluralize('charge', inactiveInvoices.length), ".")), this.state.open && inactiveInvoices.map(function (invoice, idx) {
          return /*#__PURE__*/React.createElement(InvoiceChoice, {
            key: idx,
            invoice: invoice,
            handleAddCharge: handleAddCharge
          });
        })));
      }
    }]);
  }(React.Component);
  _defineProperty(ChargeSelector, "displayName", 'ChargeSelector');

  var prop = function prop(caseRun, propName) {
    var optDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'N/A';
    if (caseRun === null || caseRun === undefined) {
      return optDefault;
    }
    return uiCommon.objectUtils.get(caseRun, propName, optDefault) || optDefault;
  };

  /**
   * Function to format cell data with optional capitalization.
   * @function
   * @param {string} data - The input data to be formatted.
   * @param {boolean} shouldCapitalize - Flag indicating whether to capitalize the data.
   * @returns {React.ReactNode} - The formatted cell data.
   */
  var getCellData = function getCellData(data, shouldCapitalize, styleClasses) {
    var title;
    if (data === null || data === undefined) {
      return /*#__PURE__*/React.createElement(React.Fragment, null);
    }
    if (data && (data === null || data === void 0 ? void 0 : data.length) >= 10) {
      title = data;
    }
    if (title) {
      return /*#__PURE__*/React.createElement("span", {
        title: title,
        className: classnames(styleClasses)
      }, shouldCapitalize ? uiCommon.objectUtils.capitalize(data) : data);
    } else {
      return /*#__PURE__*/React.createElement("span", {
        className: classnames(styleClasses)
      }, shouldCapitalize ? uiCommon.objectUtils.capitalize(data) : data);
    }
  };
  var renderChip = function renderChip(key, type, code) {
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: "medical-code-chip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "chip ".concat(type)
    }, /*#__PURE__*/React.createElement("span", {
      className: "code-text"
    }, String(code))));
  };
  var getSubmittedInvoiceCodes = function getSubmittedInvoiceCodes(status, invoices) {
    if (status !== "Sent to Billing (CMX)" || !Array.isArray(invoices)) {
      return null;
    }
    var submittedInvoice = invoices.find(function (inv) {
      return inv.type === "SUBMITTED";
    });
    if (!submittedInvoice || !Array.isArray(submittedInvoice.transactions)) {
      return null;
    }
    var rows = submittedInvoice.transactions.map(function (txn, txnIndex) {
      var _txn$procedure, _txn$diagnoses, _txn$modifiers;
      var procedureChips = ((_txn$procedure = txn.procedure) === null || _txn$procedure === void 0 ? void 0 : _txn$procedure.procedure_code) != null ? [renderChip("proc-".concat(txnIndex), "procedure", txn.procedure.procedure_code)] : [];
      var diagnosisChips = ((_txn$diagnoses = txn.diagnoses) !== null && _txn$diagnoses !== void 0 ? _txn$diagnoses : []).filter(function (d) {
        return d.diagnosis_code != null;
      }).map(function (d, diagIndex) {
        return renderChip("diag-".concat(txnIndex, "-").concat(diagIndex), "diagnosis", d.diagnosis_code);
      });
      var modifierChips = ((_txn$modifiers = txn.modifiers) !== null && _txn$modifiers !== void 0 ? _txn$modifiers : []).filter(function (m) {
        return m.modifier_code != null;
      }).map(function (m, modIndex) {
        return renderChip("mod-".concat(txnIndex, "-").concat(modIndex), "modifier", m.modifier_code);
      });
      return /*#__PURE__*/React.createElement("div", {
        key: "txn-row-".concat(txnIndex),
        className: "codes-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "codes-section"
      }, procedureChips), /*#__PURE__*/React.createElement("div", {
        className: "codes-section"
      }, modifierChips), /*#__PURE__*/React.createElement("div", {
        className: "codes-section"
      }, diagnosisChips));
    });
    return rows.length > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "codes-grid"
    }, rows) : null;
  };

  var benchEditableCore = uiCommon.AmplifyCore.benchEditable;
  var CaseCard = function CaseCard(props) {
    var caseData = props.caseData,
      isCurrent = props.isCurrent,
      currentCaseTenantCode = props.currentCaseTenantCode;
      props.currentCaseTenantName;
      var onCaseClick = props.onCaseClick;
    var ProcessStatus = function ProcessStatus() {
      var _caseData$coding_stat;
      var styleClasses = benchEditableCore.fecthProcessStatusClasses(caseData === null || caseData === void 0 ? void 0 : caseData.processStatus, caseData === null || caseData === void 0 || (_caseData$coding_stat = caseData.coding_status) === null || _caseData$coding_stat === void 0 ? void 0 : _caseData$coding_stat.hold_status);
      var status = prop(caseData, 'processStatus');
      var celldata = getCellData(status, false);
      return /*#__PURE__*/React.createElement("span", {
        className: "head process-status-container"
      }, /*#__PURE__*/React.createElement("span", {
        className: classnames(styleClasses)
      }, celldata));
    };
    var SubmittedInvoiceCodes = function SubmittedInvoiceCodes() {
      var status = prop(caseData, 'processStatus');
      var invoices = prop(caseData, 'invoices');
      var celldata = getSubmittedInvoiceCodes(status, invoices);
      if (!celldata) return null;
      return celldata;
    };
    var DateOfService = function DateOfService() {
      var dateOfService = prop(caseData, 'date_of_service');
      return /*#__PURE__*/React.createElement("span", {
        className: "head date-of-service"
      }, dateOfService);
    };
    var PatientClass = function PatientClass() {
      var patientClass = prop(caseData, 'patient_class');
      return getCellData(patientClass, true, ['head', 'patient-class']);
    };
    var CaseId = function CaseId() {
      var case_id = "#".concat(prop(caseData, 'case_id', ''));
      return getCellData(case_id, true, ['case-id', 'cmx-link']);
    };
    var NoteSpecialty = function NoteSpecialty() {
      var noteSpecialtyDesignation = prop(caseData, 'note_specialty_designation');
      return getCellData(noteSpecialtyDesignation, true, ['note-specialty']);
    };
    var FinalSignProvider = function FinalSignProvider() {
      var providerName = prop(caseData, 'note_final_sign_provider_name');
      return /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(ev) {
          ev.preventDefault();
          props.showProviderInfo({
            providerName: caseData === null || caseData === void 0 ? void 0 : caseData.note_final_sign_provider_name,
            providerNumber: caseData === null || caseData === void 0 ? void 0 : caseData.note_final_sign_provider_number,
            tenantCode: currentCaseTenantCode
          });
        }
      }, getCellData(providerName, false, ['cmx-link', 'final-sign-provider']));
    };
    var AuthoringProvider = function AuthoringProvider() {
      var providerName = prop(caseData, 'primary_activity_provider_name');
      return /*#__PURE__*/React.createElement("span", {
        onClick: function onClick(ev) {
          ev.preventDefault();
          props.showProviderInfo({
            providerNumber: (caseData === null || caseData === void 0 ? void 0 : caseData.primary_activity_provider_number) || '',
            providerName: (caseData === null || caseData === void 0 ? void 0 : caseData.primary_activity_provider_name) || '',
            tenantCode: currentCaseTenantCode
          });
        }
      }, getCellData(providerName, false, ['cmx-link', 'authoring-provider']));
    };
    var TimeOfService = function TimeOfService() {
      var timeOfService = caseData !== null && caseData !== void 0 && caseData.datetime_of_service ? uiCommon.cmxDateTime.format(uiCommon.cmxDateTime.wrapTimezoneInBracket(caseData.datetime_of_service), uiCommon.cmxDateTime.FORMATS.TIME_WITHOUT_SECONDS) : '';
      return /*#__PURE__*/React.createElement("span", {
        className: "time-of-service"
      }, timeOfService);
    };
    var NoteDescription = function NoteDescription() {
      var _caseData$notes;
      return /*#__PURE__*/React.createElement("span", {
        className: "note-description"
      }, caseData === null || caseData === void 0 || (_caseData$notes = caseData.notes) === null || _caseData$notes === void 0 ? void 0 : _caseData$notes.map(function (note, idx) {
        return /*#__PURE__*/React.createElement("span", {
          key: idx
        }, note === null || note === void 0 ? void 0 : note.description);
      }));
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "case-card ".concat(isCurrent ? 'current-case' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/React.createElement(DateOfService, null), /*#__PURE__*/React.createElement(PatientClass, null), /*#__PURE__*/React.createElement("span", {
      className: "case-link head",
      onClick: function onClick() {
        return onCaseClick(caseData);
      }
    }, /*#__PURE__*/React.createElement(CaseId, null)), /*#__PURE__*/React.createElement(ProcessStatus, null)), /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-left"
    }, /*#__PURE__*/React.createElement(NoteSpecialty, null), /*#__PURE__*/React.createElement(NoteDescription, null), /*#__PURE__*/React.createElement(TimeOfService, null)), /*#__PURE__*/React.createElement("div", {
      className: "card-right"
    }, /*#__PURE__*/React.createElement("div", {
      className: "provider-detail"
    }, /*#__PURE__*/React.createElement("span", {
      className: "provider-type"
    }, "FINAL SIGNING PROVIDER"), /*#__PURE__*/React.createElement(FinalSignProvider, null)), /*#__PURE__*/React.createElement("div", {
      className: "provider-detail"
    }, /*#__PURE__*/React.createElement("span", {
      className: "provider-type"
    }, "AUTHORING PROVIDER"), /*#__PURE__*/React.createElement(AuthoringProvider, null)))), /*#__PURE__*/React.createElement(SubmittedInvoiceCodes, null));
  };
  CaseCard.displayName = 'CaseCard';

  function _callSuper$6(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$6() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$6() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$6 = function _isNativeReflectConstruct() { return !!t; })(); }
  var isEmpty$2 = uiCommon.objectUtils.isEmpty,
    cloneDeep = uiCommon.objectUtils.cloneDeep;
  var AutocompleteMultiSelect = /*#__PURE__*/function (_React$Component) {
    function AutocompleteMultiSelect(props) {
      var _this;
      _classCallCheck(this, AutocompleteMultiSelect);
      _this = _callSuper$6(this, AutocompleteMultiSelect, [props]);
      _this.handleSearchInputChange = _this.handleSearchInputChange.bind(_this);
      return _this;
    }
    _inherits(AutocompleteMultiSelect, _React$Component);
    return _createClass(AutocompleteMultiSelect, [{
      key: "handleSearchInputChange",
      value: function handleSearchInputChange(event) {
        this.props.handleSearchInputChange(event.target.value);
      }
    }, {
      key: "render",
      value: function render() {
        var _filterData$find, _currentFilterOptions;
        var searchQuery = this.props.searchQuery;
        var _this$props = this.props,
          currentFilter = _this$props.currentFilter,
          filterData = _this$props.filterData,
          filterSelection = _this$props.filterSelection,
          handleExcludeAndInclude = _this$props.handleExcludeAndInclude,
          handleCheckboxClick = _this$props.handleCheckboxClick;
        var currentFilterOptions = filterData === null || filterData === void 0 || (_filterData$find = filterData.find(function (_ref) {
          var type = _ref.type;
          return type === currentFilter;
        })) === null || _filterData$find === void 0 ? void 0 : _filterData$find.filterOptions;
        var defaults = filterSelection !== null && filterSelection !== void 0 && filterSelection[currentFilter] ? cloneDeep(filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection[currentFilter]) : {};
        if (!isEmpty$2(searchQuery) && (_currentFilterOptions = currentFilterOptions) !== null && _currentFilterOptions !== void 0 && _currentFilterOptions.length) {
          var _currentFilterOptions2, _currentFilterOptions3;
          currentFilterOptions = (_currentFilterOptions2 = currentFilterOptions) === null || _currentFilterOptions2 === void 0 ? void 0 : _currentFilterOptions2.filter(function (item) {
            var _item$key;
            return item === null || item === void 0 || (_item$key = item.key) === null || _item$key === void 0 ? void 0 : _item$key.toLowerCase().includes(searchQuery === null || searchQuery === void 0 ? void 0 : searchQuery.toLowerCase());
          });
          var searchMatchKeys = (_currentFilterOptions3 = currentFilterOptions) === null || _currentFilterOptions3 === void 0 ? void 0 : _currentFilterOptions3.map(function (obj) {
            return String(obj === null || obj === void 0 ? void 0 : obj.key);
          });
          defaults = Object.fromEntries(Object.entries(defaults).filter(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 1),
              key = _ref3[0];
            return searchMatchKeys.some(function (matchKey) {
              return matchKey.toLowerCase() === key.toLowerCase();
            });
          }));
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "filter-content multi-select-filter-content"
        }, /*#__PURE__*/React.createElement(Input, {
          placeholder: "Find event type...",
          className: "filter-search",
          value: searchQuery,
          onChange: this.handleSearchInputChange,
          mb: 4
        }), /*#__PURE__*/React.createElement("div", {
          className: "options-selection"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(e) {
            return handleExcludeAndInclude(true);
          },
          key: "options-selection-include"
        }, "Include all"), /*#__PURE__*/React.createElement("button", {
          onClick: function onClick(e) {
            return handleExcludeAndInclude(false);
          },
          key: "options-selection-exclude"
        }, "Exclude all")), /*#__PURE__*/React.createElement("div", {
          className: "check-list"
        }, currentFilterOptions.map(function (_ref4) {
          var key = _ref4.key,
            name = _ref4.name;
          return /*#__PURE__*/React.createElement("div", {
            className: "check-box-row",
            key: key
          }, /*#__PURE__*/React.createElement(Checkbox, {
            value: defaults[key],
            label: name,
            onChange: function onChange() {
              return handleCheckboxClick(key);
            }
          }));
        })));
      }
    }]);
  }(React.Component);

  var styles = function styles() {
    return {
      root: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row'
      },
      icon: {
        cursor: 'pointer',
        height: theme.space[32],
        width: theme.space[32]
      },
      monthIcon: {
        cursor: 'pointer',
        height: theme.space[32],
        width: theme.space[90]
      },
      header: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-between'
      },
      title: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        columnGap: theme.space[12]
      }
    };
  };

  var CommonDatePickerHeader = function CommonDatePickerHeader(props) {
    var _getMonthAndYear;
    var onMonthClick = props.onMonthClick,
      onMonthPickerYearClick = props.onMonthPickerYearClick,
      onYearClick = props.onYearClick,
      onRightArrowClick = props.onRightArrowClick,
      onLeftArrowClick = props.onLeftArrowClick,
      date = props.date,
      dayPicker = props.dayPicker,
      monthPicker = props.monthPicker,
      yearPicker = props.yearPicker,
      yearRange = props.yearRange,
      selectedYear = props.selectedYear;
    var classes = styles();
    var getMonthAndYear = React.useCallback(function () {
      var _date$toLocaleString$;
      return (_date$toLocaleString$ = date === null || date === void 0 ? void 0 : date.toLocaleString('en-US', {
        month: 'long',
        year: 'numeric'
      }).split(' ')) !== null && _date$toLocaleString$ !== void 0 ? _date$toLocaleString$ : null;
    }, [date]);
    var _ref2 = (_getMonthAndYear = getMonthAndYear()) !== null && _getMonthAndYear !== void 0 ? _getMonthAndYear : [],
      _ref3 = _slicedToArray(_ref2, 2),
      month = _ref3[0],
      year = _ref3[1];
    return /*#__PURE__*/React.createElement("div", {
      className: "common-header-date-picker"
    }, /*#__PURE__*/React.createElement(Box, {
      sx: classes.root
    }, /*#__PURE__*/React.createElement(Grid, {
      sx: classes.header
    }, /*#__PURE__*/React.createElement(Grid, {
      sx: classes.title
    }, dayPicker && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
      className: "react-datepicker__current-month",
      style: classes.monthIcon,
      onClick: onMonthClick
    }, month), /*#__PURE__*/React.createElement(Text, {
      className: "react-datepicker__current-month",
      style: classes.icon,
      onClick: onYearClick
    }, year)), yearPicker && /*#__PURE__*/React.createElement(Text, {
      className: "react-datepicker__current-month"
    }, yearRange), monthPicker && /*#__PURE__*/React.createElement(Text, {
      className: "react-datepicker__current-month",
      onClick: onMonthPickerYearClick,
      style: classes.icon
    }, selectedYear))), /*#__PURE__*/React.createElement("div", {
      className: "arrow-buttons"
    }, /*#__PURE__*/React.createElement(Box, {
      onClick: onLeftArrowClick
    }, /*#__PURE__*/React.createElement(r, {
      iconName: e.Chevron_Left,
      iconClass: "".concat(classes.icon),
      iconSize: "20"
    })), /*#__PURE__*/React.createElement(Box, {
      onClick: onRightArrowClick
    }, /*#__PURE__*/React.createElement(r, {
      iconName: e.Chevron_Right,
      iconSize: "20",
      iconClass: "".concat(classes.icon)
    })))));
  };
  CommonDatePickerHeader.displayName = 'CommonDatePickerHeader';

  var TEXT_CONSTANTS = {
    DAY: 'day',
    MONTH: 'month',
    YEAR: 'year'
  };

  /** returns the years range that is shown in the year picker*/
  var getYearRange = function getYearRange(date) {
    var dateYear = date.getFullYear();
    var rangeStart = dateYear;
    var count = 0;
    while (!Number.isInteger((dateYear - count) / 12)) {
      count++;
    }
    if (Number.isInteger(dateYear / 12)) {
      count = 12;
    }
    rangeStart = dateYear - count + 1;
    return "".concat(rangeStart, " - ").concat(rangeStart + 11);
  };
  var FORMATS = {
    DATE: 'yyyy-mm-dd'
  };
  var CommonDatePicker = function CommonDatePicker(props) {
    var onSelection = props.onSelection,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? 'Select Date' : _props$placeholder,
      startDate = props.startDate,
      endDate = props.endDate,
      _props$selectsRange = props.selectsRange,
      selectsRange = _props$selectsRange === void 0 ? true : _props$selectsRange;
    var _useState = React.useState(startDate),
      _useState2 = _slicedToArray(_useState, 2),
      _startDate = _useState2[0],
      setStartDate = _useState2[1];
    var _useState3 = React.useState(endDate),
      _useState4 = _slicedToArray(_useState3, 2),
      _endDate = _useState4[0],
      setEndDate = _useState4[1];
    var _useState5 = React.useState(TEXT_CONSTANTS.DAY),
      _useState6 = _slicedToArray(_useState5, 2),
      datePickerType = _useState6[0],
      setDatePickerType = _useState6[1];
    var _useState7 = React.useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      closeDatePicker = _useState8[0],
      setCloseDatePicker = _useState8[1];
    var _useState9 = React.useState(false),
      _useState0 = _slicedToArray(_useState9, 2),
      isDatePickerOpen = _useState0[0],
      setDatePickerOpen = _useState0[1];
    React.useEffect(function () {
      setStartDate(startDate);
      setEndDate(endDate);
    }, [startDate, endDate]);
    var onChange = function onChange(dates) {
      var start = null;
      var end = null;
      if (Array.isArray(dates)) {
        var _dates = _slicedToArray(dates, 2);
        start = _dates[0];
        end = _dates[1];
      } else {
        start = dates;
      }
      /** show months picker when year is selected,
       * show days picker when month is selected and
       *  set start and end dates when date is selected
       * */
      switch (datePickerType) {
        case TEXT_CONSTANTS.DAY:
          {
            setStartDate(start);
            setEndDate(end);
            onSelection && onSelection(start, end);
            break;
          }
        case TEXT_CONSTANTS.MONTH:
          {
            setDatePickerType(TEXT_CONSTANTS.DAY);

            /** Close the datepicker on select under the following conditions
             * Selecting a single date (or) the start and end dates in a range picker
             */
            if (!selectsRange && dates) {
              setCloseDatePicker(true);
            } else if (selectsRange && Array.isArray(dates)) {
              if (dates[0] && dates[1]) {
                setCloseDatePicker(true);
              }
            } else {
              setCloseDatePicker(false);
            }
            break;
          }
        case TEXT_CONSTANTS.YEAR:
          {
            setDatePickerType(TEXT_CONSTANTS.MONTH);
            break;
          }
        default:
          {
            console.warn("Unsupported datepicker change ".concat(datePickerType));
          }
      }
    };
    var onDayPickerMonthClick = function onDayPickerMonthClick() {
      closeDatePicker && setCloseDatePicker(false);
      setDatePickerType(TEXT_CONSTANTS.MONTH);
    };
    var onHeaderYearClick = function onHeaderYearClick() {
      closeDatePicker && setCloseDatePicker(false);
      setDatePickerType(TEXT_CONSTANTS.YEAR);
    };
    var handleCalendarClose = function handleCalendarClose() {
      isDatePickerOpen && setDatePickerOpen(false);
      setDatePickerType(TEXT_CONSTANTS.DAY);
    };
    return /*#__PURE__*/React.createElement(DatePicker, _extends$1({
      inline: true,
      calendarClassName: "common-date-picker",
      placeholderText: placeholder,
      selected: _startDate,
      startDate: _startDate,
      endDate: _endDate,
      onChange: onChange
    }, selectsRange && {
      selectsRange: true
    }, {
      shouldCloseOnSelect: closeDatePicker,
      dateFormat: FORMATS.DATE,
      onCalendarClose: handleCalendarClose,
      showYearPicker: TEXT_CONSTANTS.YEAR === datePickerType,
      showMonthYearPicker: TEXT_CONSTANTS.MONTH === datePickerType,
      showFourColumnMonthYearPicker: true,
      renderCustomHeader: function renderCustomHeader(_ref) {
        var date = _ref.date,
          decreaseMonth = _ref.decreaseMonth,
          increaseMonth = _ref.increaseMonth,
          decreaseYear = _ref.decreaseYear,
          increaseYear = _ref.increaseYear;
        return /*#__PURE__*/React.createElement("div", null, datePickerType === TEXT_CONSTANTS.DAY && /*#__PURE__*/React.createElement(CommonDatePickerHeader, {
          onLeftArrowClick: decreaseMonth,
          onRightArrowClick: increaseMonth,
          date: date,
          onMonthClick: onDayPickerMonthClick,
          onYearClick: onHeaderYearClick,
          dayPicker: true
        }), datePickerType === TEXT_CONSTANTS.YEAR && /*#__PURE__*/React.createElement(CommonDatePickerHeader, {
          onLeftArrowClick: decreaseYear,
          onRightArrowClick: increaseYear,
          yearRange: getYearRange(date),
          yearPicker: true
        }), datePickerType === TEXT_CONSTANTS.MONTH && /*#__PURE__*/React.createElement(CommonDatePickerHeader, {
          onLeftArrowClick: decreaseYear,
          onRightArrowClick: increaseYear,
          selectedYear: date.getFullYear().toString(),
          onMonthPickerYearClick: onHeaderYearClick,
          monthPicker: true
        }));
      }
    }));
  };
  CommonDatePicker.displayName = 'CommonDatePicker';

  function _callSuper$5(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$5() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$5() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$5 = function _isNativeReflectConstruct() { return !!t; })(); }
  var DateFilter = /*#__PURE__*/function (_React$Component) {
    function DateFilter(props) {
      var _this;
      _classCallCheck(this, DateFilter);
      _this = _callSuper$5(this, DateFilter, [props]);
      _this.handlePresetChange = _this.handlePresetChange.bind(_this);
      _this.handleDateClear = _this.handleDateClear.bind(_this);
      return _this;
    }
    _inherits(DateFilter, _React$Component);
    return _createClass(DateFilter, [{
      key: "handlePresetChange",
      value: function handlePresetChange(presetType) {
        var today = new Date();
        var startDate, endDate;
        if (presetType.durationType) {
          switch (presetType.durationType) {
            case "days":
              startDate = subDays(today, presetType.duration);
              endDate = today;
              break;
            case "years":
              startDate = subYears(today, presetType.duration);
              endDate = today;
              break;
          }
        } else {
          startDate = presetType.startDate;
          endDate = presetType.endDate;
        }
        this.props.handleDateChange(startDate, endDate, presetType);
      }
    }, {
      key: "handleDateClear",
      value: function handleDateClear() {
        var _filterData$dateFilte, _filterData$dateFilte2;
        var filterData = this.props.filterData;
        var startDate = filterData === null || filterData === void 0 || (_filterData$dateFilte = filterData.dateFilterOptions) === null || _filterData$dateFilte === void 0 ? void 0 : _filterData$dateFilte.startDate;
        var endDate = filterData === null || filterData === void 0 || (_filterData$dateFilte2 = filterData.dateFilterOptions) === null || _filterData$dateFilte2 === void 0 ? void 0 : _filterData$dateFilte2.endDate;
        this.props.handleDateChange(startDate, endDate);
      }
    }, {
      key: "render",
      value: function render() {
        var _filterData$dateFilte3,
          _this2 = this;
        var _this$props = this.props,
          filterData = _this$props.filterData,
          filterSelection = _this$props.filterSelection;
        var startDate = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection.startDate;
        var endDate = filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection.endDate;
        var _ref = (_filterData$dateFilte3 = filterData === null || filterData === void 0 ? void 0 : filterData.dateFilterOptions) !== null && _filterData$dateFilte3 !== void 0 ? _filterData$dateFilte3 : {},
          datePresets = _ref.datePresets;
        return /*#__PURE__*/React.createElement("div", {
          className: "filter-content date-filter-content"
        }, datePresets && /*#__PURE__*/React.createElement("div", {
          className: "filter-presets"
        }, datePresets.map(function (datePreset) {
          return /*#__PURE__*/React.createElement("button", {
            key: datePreset.key,
            onClick: function onClick() {
              return _this2.handlePresetChange(datePreset);
            },
            className: "chakra-secondary-button date-duration-btn"
          }, datePreset.name);
        }), /*#__PURE__*/React.createElement("button", {
          key: "actions-reset",
          onClick: this.handleDateClear,
          className: "chakra-secondary-button clear-btn"
        }, "Clear")), /*#__PURE__*/React.createElement("div", {
          className: "filter-date"
        }, /*#__PURE__*/React.createElement(CommonDatePicker, {
          startDate: startDate,
          endDate: endDate,
          label: '',
          showRange: true,
          onSelection: function onSelection(startDate, endDate) {
            if (startDate && endDate) {
              _this2.props.handleDateChange(startDate, endDate);
            }
            if (!startDate && !endDate) {
              _this2.handleDateClear();
            }
          },
          selectsRange: true
        })));
      }
    }]);
  }(React.Component);

  function ownKeys$a(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$a(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$a(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$a(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$4(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$4() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$4() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$4 = function _isNativeReflectConstruct() { return !!t; })(); }
  var isEqual$1 = uiCommon.objectUtils.isEqual,
    isEmpty$1 = uiCommon.objectUtils.isEmpty;
    uiCommon.objectUtils.cloneDeep;
  var CommonFilter = /*#__PURE__*/function (_React$Component) {
    function CommonFilter(props) {
      var _this;
      _classCallCheck(this, CommonFilter);
      _this = _callSuper$4(this, CommonFilter, [props]);
      _this.state = {
        isOpen: false,
        currentFilter: '',
        searchQuery: '',
        filterSelection: {},
        modifiedFilterData: [],
        defaultFilterSelection: {}
      };
      _this.toggleFilter = _this.toggleFilter.bind(_this);
      _this.handleFilterChange = _this.handleFilterChange.bind(_this);
      _this.handleSearchInputChange = _this.handleSearchInputChange.bind(_this);
      _this.handleExcludeAndInclude = _this.handleExcludeAndInclude.bind(_this);
      _this.handleApply = _this.handleApply.bind(_this);
      _this.handleCancel = _this.handleCancel.bind(_this);
      _this.handleReset = _this.handleReset.bind(_this);
      _this.filterBody = _this.filterBody.bind(_this);
      _this.footerChildren = _this.footerChildren.bind(_this);
      _this.handleCheckboxClick = _this.handleCheckboxClick.bind(_this);
      _this.resetOptionsState = _this.resetOptionsState.bind(_this);
      _this.handleDateChange = _this.handleDateChange.bind(_this);
      return _this;
    }
    _inherits(CommonFilter, _React$Component);
    return _createClass(CommonFilter, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.resetOptionsState();
      }
    }, {
      key: "resetOptionsState",
      value: function resetOptionsState(clearFilter) {
        var _sortedData;
        var _this$props = this.props,
          filterData = _this$props.filterData,
          relatedCasesFilterSelection = _this$props.relatedCasesFilterSelection;
        var defaultFilterSelection = {};
        var filterSelection = {};
        var sortedData = [];
        var today = new Date();
        if (filterData !== null && filterData !== void 0 && filterData.length) {
          filterData === null || filterData === void 0 || filterData.forEach(function (filter) {
            if (filter.viewType !== 'date_range_with_preset') {
              var _filter$filterOptions;
              var defaults = {};
              filter === null || filter === void 0 || (_filter$filterOptions = filter.filterOptions) === null || _filter$filterOptions === void 0 || _filter$filterOptions.forEach(function (item) {
                defaults[item === null || item === void 0 ? void 0 : item.key] = (item === null || item === void 0 ? void 0 : item.defaultSelection) === 'INCLUDE';
              });
              defaultFilterSelection[filter.type] = defaults;
            } else {
              var dateDefaults = {};
              if (filter !== null && filter !== void 0 && filter.dateFilterOptions) {
                var _filter$dateFilterOpt, _filter$dateFilterOpt2, _filter$dateFilterOpt3, _filter$dateFilterOpt4;
                dateDefaults.startDate = filter !== null && filter !== void 0 && (_filter$dateFilterOpt = filter.dateFilterOptions) !== null && _filter$dateFilterOpt !== void 0 && _filter$dateFilterOpt.startDate ? filter === null || filter === void 0 || (_filter$dateFilterOpt2 = filter.dateFilterOptions) === null || _filter$dateFilterOpt2 === void 0 ? void 0 : _filter$dateFilterOpt2.startDate : today;
                dateDefaults.endDate = filter !== null && filter !== void 0 && (_filter$dateFilterOpt3 = filter.dateFilterOptions) !== null && _filter$dateFilterOpt3 !== void 0 && _filter$dateFilterOpt3.endDate ? filter === null || filter === void 0 || (_filter$dateFilterOpt4 = filter.dateFilterOptions) === null || _filter$dateFilterOpt4 === void 0 ? void 0 : _filter$dateFilterOpt4.endDate : today;
                defaultFilterSelection[filter.type] = dateDefaults;
              }
            }
          });
          if (isEmpty$1(relatedCasesFilterSelection) || clearFilter) {
            filterSelection = defaultFilterSelection;
          } else {
            filterSelection = relatedCasesFilterSelection;
          }
          sortedData = filterData.sort(function (a, b) {
            return (a === null || a === void 0 ? void 0 : a.displayOrder) - (b === null || b === void 0 ? void 0 : b.displayOrder);
          });
        }
        this.setState({
          defaultFilterSelection: defaultFilterSelection,
          filterSelection: filterSelection,
          modifiedFilterData: sortedData,
          currentFilter: (_sortedData = sortedData) !== null && _sortedData !== void 0 && _sortedData.length ? sortedData[0].type : '',
          presetTypeSelected: {}
        });
      }
    }, {
      key: "handleFilterChange",
      value: function handleFilterChange(type) {
        this.setState({
          currentFilter: type,
          searchQuery: ''
        });
      }
    }, {
      key: "handleSearchInputChange",
      value: function handleSearchInputChange(searchQuery) {
        this.setState({
          searchQuery: searchQuery
        });
      }
    }, {
      key: "handleReset",
      value: function handleReset() {
        this.resetOptionsState(true);
      }
    }, {
      key: "handleCancel",
      value: function handleCancel() {
        this.toggleFilter();
      }
    }, {
      key: "handleApply",
      value: function handleApply() {
        this.props.onApply(this.state.filterSelection);
        this.toggleFilter();
      }
    }, {
      key: "handleExcludeAndInclude",
      value: function handleExcludeAndInclude(isInclude) {
        var _this$state = this.state,
          currentFilter = _this$state.currentFilter,
          filterSelection = _this$state.filterSelection,
          modifiedFilterData = _this$state.modifiedFilterData;
        var selection = isInclude;
        var defaults = {};
        var currentFilterData = modifiedFilterData.find(function (_ref) {
          var type = _ref.type;
          return type === currentFilter;
        });
        if (currentFilterData) {
          currentFilterData === null || currentFilterData === void 0 || currentFilterData.filterOptions.forEach(function (item) {
            defaults[item === null || item === void 0 ? void 0 : item.key] = selection;
          });
        }
        var newFilterSelection = _objectSpread$a(_objectSpread$a({}, filterSelection), {}, _defineProperty({}, currentFilter, defaults));
        this.setState({
          filterSelection: newFilterSelection
        });
      }
    }, {
      key: "handleCheckboxClick",
      value: function handleCheckboxClick(optionKey) {
        var _this$state2 = this.state,
          currentFilter = _this$state2.currentFilter,
          filterSelection = _this$state2.filterSelection,
          modifiedFilterData = _this$state2.modifiedFilterData;
        var currentFilterData = modifiedFilterData.find(function (_ref2) {
          var type = _ref2.type;
          return type === currentFilter;
        });
        var defaults = {};
        currentFilterData === null || currentFilterData === void 0 || currentFilterData.filterOptions.forEach(function (item) {
          var checkboxValue = filterSelection[currentFilter][item === null || item === void 0 ? void 0 : item.key];
          if ((item === null || item === void 0 ? void 0 : item.key) === optionKey) {
            checkboxValue = checkboxValue ? !checkboxValue : true;
          }
          defaults[item === null || item === void 0 ? void 0 : item.key] = checkboxValue;
        });
        var newfilterSelection = _objectSpread$a(_objectSpread$a({}, filterSelection), {}, _defineProperty({}, currentFilter, defaults));
        this.setState({
          filterSelection: newfilterSelection
        });
      }
    }, {
      key: "toggleFilter",
      value: function toggleFilter() {
        this.setState({
          isOpen: !this.state.isOpen
        });
      }
    }, {
      key: "handleDateChange",
      value: function handleDateChange(startDate, endDate, presetTypeSelected) {
        var _this$state3 = this.state,
          filterSelection = _this$state3.filterSelection,
          currentFilter = _this$state3.currentFilter;
        var newfilterSelection = _objectSpread$a(_objectSpread$a({}, filterSelection), {}, _defineProperty({}, currentFilter, _objectSpread$a(_objectSpread$a({}, filterSelection[currentFilter]), {}, {
          startDate: startDate,
          endDate: endDate
        })));
        this.setState({
          filterSelection: newfilterSelection,
          presetTypeSelected: presetTypeSelected
        });
      }
    }, {
      key: "footerChildren",
      value: function footerChildren() {
        return /*#__PURE__*/React.createElement("div", {
          className: "actions"
        }, /*#__PURE__*/React.createElement("button", {
          key: "actions-reset",
          onClick: this.handleReset,
          className: "chakra-secondary-button reset-btn"
        }, "Reset"), /*#__PURE__*/React.createElement("button", {
          key: "actions-cancel",
          onClick: this.handleCancel,
          className: "chakra-secondary-button cancel-btn"
        }, "Cancel"), /*#__PURE__*/React.createElement("button", {
          key: "actions-apply",
          onClick: this.handleApply,
          className: "chakra-primary-button submit-btn"
        }, "Apply"));
      }
    }, {
      key: "filterBody",
      value: function filterBody() {
        var _this$state4 = this.state,
          searchQuery = _this$state4.searchQuery,
          filterSelection = _this$state4.filterSelection,
          currentFilter = _this$state4.currentFilter,
          modifiedFilterData = _this$state4.modifiedFilterData,
          defaultFilterSelection = _this$state4.defaultFilterSelection;
        var currentFilterObj = modifiedFilterData === null || modifiedFilterData === void 0 ? void 0 : modifiedFilterData.find(function (_ref3) {
          var type = _ref3.type;
          return type === currentFilter;
        });
        var filterBody;
        switch (currentFilterObj === null || currentFilterObj === void 0 ? void 0 : currentFilterObj.viewType) {
          case 'date_range_with_preset':
            filterBody = /*#__PURE__*/React.createElement(DateFilter, {
              currentFilter: currentFilter,
              filterData: currentFilterObj,
              handleDateChange: this.handleDateChange,
              filterSelection: filterSelection === null || filterSelection === void 0 ? void 0 : filterSelection[currentFilter],
              defaultFilterSelection: defaultFilterSelection
            });
            break;
          default:
            filterBody = /*#__PURE__*/React.createElement(AutocompleteMultiSelect, {
              currentFilter: currentFilter,
              filterSelection: filterSelection,
              filterData: modifiedFilterData,
              defaultFilterSelection: defaultFilterSelection,
              handleExcludeAndInclude: this.handleExcludeAndInclude,
              handleCheckboxClick: this.handleCheckboxClick,
              searchQuery: searchQuery,
              handleSearchInputChange: this.handleSearchInputChange
            });
        }
        return filterBody;
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;
        var relatedCasesFilterSelection = this.props.relatedCasesFilterSelection;
        var _this$state5 = this.state,
          currentFilter = _this$state5.currentFilter,
          modifiedFilterData = _this$state5.modifiedFilterData,
          isOpen = _this$state5.isOpen,
          defaultFilterSelection = _this$state5.defaultFilterSelection,
          presetTypeSelected = _this$state5.presetTypeSelected,
          filterSelection = _this$state5.filterSelection;
        var filterButtonDateContent;
        var currentFilterObj = modifiedFilterData === null || modifiedFilterData === void 0 ? void 0 : modifiedFilterData.find(function (_ref4) {
          var type = _ref4.type;
          return type === currentFilter;
        });
        var isDefaultFilterStateChanged = !isEmpty$1(relatedCasesFilterSelection) && !isEqual$1(defaultFilterSelection, relatedCasesFilterSelection);
        if (isEmpty$1(presetTypeSelected)) {
          var dateFilterCofig = filterSelection['date_range'];
          var starteDateToShow = dateFilterCofig !== null && dateFilterCofig !== void 0 && dateFilterCofig.startDate ? uiCommon.cmxDateTime.format(dateFilterCofig.startDate.toString(), uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE) : '';
          var endDateToshow = dateFilterCofig !== null && dateFilterCofig !== void 0 && dateFilterCofig.endDate ? uiCommon.cmxDateTime.format(dateFilterCofig.endDate.toString(), uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE) : '';
          filterButtonDateContent = starteDateToShow == endDateToshow ? starteDateToShow : "".concat(starteDateToShow, " - ").concat(endDateToshow);
        } else {
          filterButtonDateContent = presetTypeSelected.name;
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "common-filter"
        }, /*#__PURE__*/React.createElement(Popover, {
          isOpen: isOpen,
          onOpen: this.toggleFilter,
          onClose: this.toggleFilter
        }, /*#__PURE__*/React.createElement(PopoverTrigger, null, /*#__PURE__*/React.createElement("button", {
          className: "chakra-secondary-button cancel-btn"
        }, filterButtonDateContent && /*#__PURE__*/React.createElement("span", null, " ", filterButtonDateContent, " |"), /*#__PURE__*/React.createElement(r, {
          iconName: e.Filter,
          iconSize: "16",
          titleText: "Filter"
        }), !isDefaultFilterStateChanged ? 'Default Filter' : 'Custom Filter')), /*#__PURE__*/React.createElement(Portal, null, !!modifiedFilterData.length && /*#__PURE__*/React.createElement(PopoverContent, {
          className: "common-filter-popOver-content ".concat(currentFilterObj.viewType === 'date_range_with_preset' ? 'lg' : 'md'),
          "data-testid": "common-filter-popOver-content"
        }, /*#__PURE__*/React.createElement(PopoverArrow, null), /*#__PURE__*/React.createElement(PopoverBody, {
          className: "common-filter-popOver-body"
        }, /*#__PURE__*/React.createElement("div", {
          className: "common-filter-body ".concat(currentFilterObj.viewType === 'date_range_with_preset' ? 'lg' : 'md')
        }, /*#__PURE__*/React.createElement("div", {
          className: "filter-selector"
        }, modifiedFilterData.map(function (_ref5) {
          var type = _ref5.type,
            label = _ref5.label;
          return /*#__PURE__*/React.createElement("div", {
            key: type,
            className: "filter-selector-item ".concat(type === currentFilter ? 'selected' : 'unSelected'),
            onClick: function onClick(e) {
              return _this2.handleFilterChange(type);
            }
          }, /*#__PURE__*/React.createElement("span", null, label), /*#__PURE__*/React.createElement("span", {
            className: "filter-selector-icon"
          }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
            svgIconName: "BiomeChevronRight",
            svgIconSize: "20",
            svgIconClass: "chevron-right"
          })));
        })), this.filterBody())), /*#__PURE__*/React.createElement(PopoverFooter, {
          className: "common-filter-popOver-footer"
        }, this.footerChildren())))));
      }
    }]);
  }(React.Component);

  var _excluded$3 = ["relatedCases", "showLoading", "activeItem", "onOpenRelatedCase", "showProviderInfo", "filterData", "relatedCasesFilterSelection", "onRelatedCasesFilterApply", "relatedCasesFilterCapability"];
  function ownKeys$9(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$9(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$9(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$9(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var isEqual = uiCommon.objectUtils.isEqual,
    isEmpty = uiCommon.objectUtils.isEmpty;
  var getChildWindowParams$1 = uiCommon.caseUtils.getChildWindowParams;
  var RelatedCases = function RelatedCases(_ref) {
    var _relatedCasesFilterCa;
    var _ref$relatedCases = _ref.relatedCases,
      relatedCases = _ref$relatedCases === void 0 ? [] : _ref$relatedCases,
      _ref$showLoading = _ref.showLoading,
      showLoading = _ref$showLoading === void 0 ? false : _ref$showLoading,
      activeItem = _ref.activeItem,
      onOpenRelatedCase = _ref.onOpenRelatedCase,
      showProviderInfo = _ref.showProviderInfo,
      _ref$filterData = _ref.filterData,
      filterData = _ref$filterData === void 0 ? [] : _ref$filterData,
      relatedCasesFilterSelection = _ref.relatedCasesFilterSelection,
      onRelatedCasesFilterApply = _ref.onRelatedCasesFilterApply,
      relatedCasesFilterCapability = _ref.relatedCasesFilterCapability,
      rest = _objectWithoutProperties(_ref, _excluded$3);
    var styleClasses = ['related-cases', {
      'bg-loaded': !showLoading,
      'bg-with-cases': !!(relatedCases !== null && relatedCases !== void 0 && relatedCases.length),
      'bg-empty': !showLoading,
      'bg-show-loading': showLoading
    }];
    var handleRowSelection = function handleRowSelection(relatedCase) {
      if (!!relatedCase) {
        var childWindowParams = getChildWindowParams$1(relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.case_uid, relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.process_instance_guid, relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.service_line, launchAmplifyCase, relatedCase === null || relatedCase === void 0 ? void 0 : relatedCase.case_id);
        onOpenRelatedCase(childWindowParams);
      }
    };

    // Preparing the case list to identify the current case run
    var relatedCaseList = relatedCases.map(function (caseRun) {
      var row = {
        isCurrent: caseRun.case_id === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.case_id) && caseRun.process_instance_guid === (activeItem === null || activeItem === void 0 ? void 0 : activeItem.process_instance_guid),
        id: caseRun.case_id + '-' + caseRun.process_instance_guid,
        caseRun: _objectSpread$9(_objectSpread$9({}, caseRun), {}, {
          date_of_service: uiCommon.cmxDateTime.format(caseRun.date_of_service, uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE)
        })
      };
      return row;
    });
    var showRelatedCasesFilter = uiCommon.conditionalUtils.capabilityValue((_relatedCasesFilterCa = relatedCasesFilterCapability === null || relatedCasesFilterCapability === void 0 ? void 0 : relatedCasesFilterCapability.on) !== null && _relatedCasesFilterCa !== void 0 ? _relatedCasesFilterCa : false);
    var defaultFilterSelection = {};
    filterData && (filterData === null || filterData === void 0 ? void 0 : filterData.forEach(function (filter) {
      var _filter$filterOptions;
      var defaults = {};
      filter === null || filter === void 0 || (_filter$filterOptions = filter.filterOptions) === null || _filter$filterOptions === void 0 || _filter$filterOptions.forEach(function (item) {
        defaults[item === null || item === void 0 ? void 0 : item.key] = (item === null || item === void 0 ? void 0 : item.defaultSelection) === 'INCLUDE';
      });
      defaultFilterSelection[filter.type] = defaults;
    }));
    var isDefaultFilterStateChanged = !isEmpty(relatedCasesFilterSelection) && !isEqual(defaultFilterSelection, relatedCasesFilterSelection);
    return /*#__PURE__*/React.createElement("div", _extends$1({
      className: classnames(styleClasses)
    }, rest), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [!!(filterData !== null && filterData !== void 0 && filterData.length), showRelatedCasesFilter]
    }, /*#__PURE__*/React.createElement(CommonFilter, {
      filterData: filterData,
      relatedCasesFilterSelection: relatedCasesFilterSelection,
      onApply: onRelatedCasesFilterApply
    })), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [!showLoading, !(relatedCaseList !== null && relatedCaseList !== void 0 && relatedCaseList.length)]
    }, /*#__PURE__*/React.createElement("span", {
      className: "empty-content"
    }, isDefaultFilterStateChanged ? 'With the current filters applied, there are no results display.' : 'With the default filters applied, there are no results to display.')), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [showLoading]
    }, /*#__PURE__*/React.createElement("div", {
      className: "loading-container",
      "data-testid": "related-cases-loading"
    }, /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
      key: "loading-slugs",
      numberItems: 3
    }))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
      every: [!showLoading, !!(relatedCaseList !== null && relatedCaseList !== void 0 && relatedCaseList.length)],
      displayMode: "flex"
    }, /*#__PURE__*/React.createElement("div", {
      className: "related-table"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grid-container"
    }, relatedCaseList === null || relatedCaseList === void 0 ? void 0 : relatedCaseList.map(function (relatedCase, idx) {
      return /*#__PURE__*/React.createElement(CaseCard, {
        key: idx,
        caseData: relatedCase.caseRun,
        isCurrent: relatedCase.isCurrent,
        onCaseClick: handleRowSelection,
        showProviderInfo: showProviderInfo,
        currentCaseTenantCode: activeItem === null || activeItem === void 0 ? void 0 : activeItem.facility,
        currentCaseTenantName: activeItem === null || activeItem === void 0 ? void 0 : activeItem.tenant_name
      });
    })))));
  };
  RelatedCases.displayName = 'RelatedCases';

  function ownKeys$8(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$8(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$8(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$8(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var StandalonePageableList = function StandalonePageableList(_ref) {
    var children = _ref.children,
      sortablePageable = _ref.sortablePageable,
      theme = _ref.theme,
      _ref$list = _ref.list,
      list = _ref$list === void 0 ? function (options) {} : _ref$list;
    var pageable = sortablePageable.pageableDefinition;
    var onPaginationClick = function onPaginationClick(action) {
      var pageable = sortablePageable.pageableDefinition,
        sortableOptions = sortablePageable.sortableOptions,
        filterableOptions = sortablePageable.filterableOptions;
      var retAction = {
        pageableDefinition: _objectSpread$8(_objectSpread$8({}, pageable), {}, {
          pageable: _objectSpread$8(_objectSpread$8({}, pageable.pageable), {}, {
            pageNumber: action.index,
            pageSize: action.size
          })
        }),
        sortableOptions: sortableOptions,
        filterableOptions: filterableOptions
      };
      list(retAction);
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "standalone-pageable"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pageable-list"
    }, children), /*#__PURE__*/React.createElement("div", {
      className: "pagination-controls"
    }, /*#__PURE__*/React.createElement(uiComponents.Pagination, {
      pageable: pageable,
      onSelect: onPaginationClick,
      theme: theme
    })));
  };
  StandalonePageableList.displayName = 'StandalonePageableList';

  var _excluded$2 = ["nonCodeBench", "chargeSessions", "counts", "searchResults", "benchEditable", "processInstance", "activations", "groupedCases", "modalURL", "hostCaseId", "onChargeSessionAction", "activity", "prompt", "confirm", "showSubmittedFeedback", "showLoadingSubmission", "showLoadingCancelation", "showSizeExpWarning", "showCanceledFeedback", "submittedFeedbackTimer", "showvitalwareIssuesModal", "toggleHoldCaseModal", "toggleExclusionCaseModal", "showLateCaseClearModal", "toggleSplitCaseModal", "vitalwareIssues", "mergeSplitHistoryIssues", "documentImprovementIssues", "holdIssues", "hidevitalwareIssuesModal", "displayAddCharge", "showAddChargeError", "showAddChargeLoading", "loadState", "codableInvoices", "feedback", "showFeedBack", "UIMode", "epicToken", "codeEdits", "invoiceOptions", "caseEdits", "showHoldCaseModal", "hideHoldCaseModal", "showExclusionCaseModal", "hideExclusionCaseModal", "toggleChargeableCase", "toggleLateCaseClearModal", "clearLateCaseNotification", "holdCase", "improvements", "capabilities", "updateValue", "updateCase", "relatedCases", "relatedCasesPageable", "flagList", "htmlNotes", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "workItem"];
  function ownKeys$7(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$7(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$7(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$7(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$3(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$3() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$3() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$3 = function _isNativeReflectConstruct() { return !!t; })(); }
  var conditionalUtils$1 = uiCommon.AmplifyCore.conditionalUtils;
  var CodeBench = /*#__PURE__*/function (_React$Component) {
    function CodeBench(props) {
      var _this;
      _classCallCheck(this, CodeBench);
      _this = _callSuper$3(this, CodeBench, [props]);
      _defineProperty(_this, "caseDetailRef", void 0);
      _defineProperty(_this, "iframeRef", void 0);
      _defineProperty(_this, "onRelatedCasesFilterApply", function (filters) {
        var _this$props$activeIte, _this$props$activeIte2;
        _this.props.updateRelatedCasesFilterSelection(filters);
        _this.props.getCasesWithEncounter({
          encounterId: (_this$props$activeIte = _this.props.activeItem) === null || _this$props$activeIte === void 0 || (_this$props$activeIte = _this$props$activeIte.encounter_identifier) === null || _this$props$activeIte === void 0 ? void 0 : _this$props$activeIte.number,
          sortablePageable: _objectSpread$7({}, uiCommon.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
          serviceLine: (_this$props$activeIte2 = _this.props.activeItem) === null || _this$props$activeIte2 === void 0 ? void 0 : _this$props$activeIte2.service_line,
          filterSelection: filters
        });
      });
      _this.onCodeUpdate = _this.onCodeUpdate.bind(_this);
      _this.onCodeRemove = _this.onCodeRemove.bind(_this);
      _this.onTimeBasedCodeAdd = _this.onTimeBasedCodeAdd.bind(_this);
      _this.onTimeBasedCodeUpdate = _this.onTimeBasedCodeUpdate.bind(_this);
      _this.onCodeSearchDrop = _this.onCodeSearchDrop.bind(_this);
      _this.onCodeSearch = _this.onCodeSearch.bind(_this);
      _this.onCodeSearchSelection = _this.onCodeSearchSelection.bind(_this);
      _this.onFeatureSelection = _this.onFeatureSelection.bind(_this);
      _this.handleGroupedCaseClick = _this.handleGroupedCaseClick.bind(_this);
      _this.handleModalClose = _this.handleModalClose.bind(_this);
      _this.handleInvoiceEdit = _this.handleInvoiceEdit.bind(_this);
      _this.handlePromptDismiss = _this.handlePromptDismiss.bind(_this);
      _this.handleMetaAction = _this.handleMetaAction.bind(_this);
      _this.handleCancel = _this.handleCancel.bind(_this);
      _this.handleSubmit = _this.handleSubmit.bind(_this);
      _this.onModalAddChargeOpen = _this.onModalAddChargeOpen.bind(_this);
      _this.onModalAddChargeClose = _this.onModalAddChargeClose.bind(_this);
      _this.handleAddCharge = _this.handleAddCharge.bind(_this);
      _this.handleTimer = _this.handleTimer.bind(_this);
      _this.handleInvoiceAddition = _this.handleInvoiceAddition.bind(_this);
      _this.handleTransactionSharedDiagnosisChange = _this.handleTransactionSharedDiagnosisChange.bind(_this);
      _this.handleDeleteSizeExpWarning = _this.handleDeleteSizeExpWarning.bind(_this);
      _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
      _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
      _this.caseDetailRef = /*#__PURE__*/React.createRef();
      _this.iframeRef = /*#__PURE__*/React.createRef();
      var codeUpdateDebounced = _this.onCodeUpdate.bind(_this);
      _this.onCodeUpdate = uiCommon.objectUtils.debounce(codeUpdateDebounced, 500);
      _this.handleHARCaseList = _this.handleHARCaseList.bind(_this);
      _this.onMiniTabSelection = _this.onMiniTabSelection.bind(_this);
      return _this;
    }
    _inherits(CodeBench, _React$Component);
    return _createClass(CodeBench, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var _prevProps$match, _this$props$match;
        if (!this.props.loadAlwaysFromURL) return;
        if (((_prevProps$match = prevProps.match) === null || _prevProps$match === void 0 ? void 0 : _prevProps$match.url) !== ((_this$props$match = this.props.match) === null || _this$props$match === void 0 ? void 0 : _this$props$match.url)) {
          var _this$props$capabilit, _this$props, _this$props$match2, _this$props$match3;
          this.props.match.params.getCaserunWithRefresh = conditionalUtils$1.capabilityValue((_this$props$capabilit = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.capabilities) === null || _this$props === void 0 || (_this$props = _this$props.capabilities) === null || _this$props === void 0 || (_this$props = _this$props.getCaseRunWithRefresh) === null || _this$props === void 0 ? void 0 : _this$props.on) !== null && _this$props$capabilit !== void 0 ? _this$props$capabilit : false);
          this.props.onLoadFromURLMatch(this.props.match);
          var case_uid = (_this$props$match2 = this.props.match) === null || _this$props$match2 === void 0 || (_this$props$match2 = _this$props$match2.params) === null || _this$props$match2 === void 0 ? void 0 : _this$props$match2.caseId;
          var caserun_uid = (_this$props$match3 = this.props.match) === null || _this$props$match3 === void 0 || (_this$props$match3 = _this$props$match3.params) === null || _this$props$match3 === void 0 ? void 0 : _this$props$match3.id;
          this.props.loadWorkItemDetails(case_uid, caserun_uid);
          // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
          this.props.loadServicedeskContext(this.props.cursorAPIContext);
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.loadRoles(this.props.roles);
        var hasActiveItem = !uiCommon.objectUtils.isEmpty(this.props.activeItem);
        var case_uid = '',
          caserun_uid = '';
        if (this.props.loadAlwaysFromURL || !hasActiveItem) {
          var _this$props$capabilit2, _this$props2, _this$props$match4, _this$props$match5;
          this.props.match.params.getCaserunWithRefresh = conditionalUtils$1.capabilityValue((_this$props$capabilit2 = (_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.capabilities) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.capabilities) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.getCaseRunWithRefresh) === null || _this$props2 === void 0 ? void 0 : _this$props2.on) !== null && _this$props$capabilit2 !== void 0 ? _this$props$capabilit2 : false);
          this.props.onLoadFromURLMatch(this.props.match);
          case_uid = (_this$props$match4 = this.props.match) === null || _this$props$match4 === void 0 || (_this$props$match4 = _this$props$match4.params) === null || _this$props$match4 === void 0 ? void 0 : _this$props$match4.caseId;
          caserun_uid = (_this$props$match5 = this.props.match) === null || _this$props$match5 === void 0 || (_this$props$match5 = _this$props$match5.params) === null || _this$props$match5 === void 0 ? void 0 : _this$props$match5.id;
        } else {
          this.props.onLoad(this.props.activeItem);
          case_uid = this.props.activeItem.case_uid;
          caserun_uid = this.props.activeItem.caserun_uid;
        }
        this.props.loadWorkItemDetails(case_uid, caserun_uid);

        // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
        this.props.loadServicedeskContext(this.props.cursorAPIContext);
      }
    }, {
      key: "handleCancel",
      value: function handleCancel(event) {
        event.preventDefault();
        this.props.onInvoicesCancel(this.props.processInstance);
      }
    }, {
      key: "handleSubmit",
      value: function handleSubmit(event) {
        var vwComment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var submitWithOverrideButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var remove_hold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        event.preventDefault();
        var cursorAPIPayload = {
          operation: uiCommon.commonEnums.CursorOperation.NEXT,
          cursorAPIContext: this.props.cursorAPIContext
        };
        this.props.onInvoicesSubmisson({
          processInstance: this.props.processInstance,
          uiMode: this.props.UIMode,
          vwComment: vwComment,
          submitWithOverrideButton: submitWithOverrideButton,
          cursorAPIPayload: cursorAPIPayload,
          activeItem: this.props.activeItem,
          removeHold: remove_hold
        });
      }
    }, {
      key: "handlePreviousClick",
      value: function handlePreviousClick(event) {
        event.preventDefault();
        var _this$props3 = this.props,
          processInstanceGuids = _this$props3.processInstanceGuids,
          activeItem = _this$props3.activeItem;
        var loc = processInstanceGuids.findIndex(function (item) {
          return item === activeItem.process_instance_guid;
        });
        this.props.handleTraversal(processInstanceGuids[loc - 1]);
      }
    }, {
      key: "handleModalClose",
      value: function handleModalClose(ev) {
        ev.preventDefault();
        this.props.onPopUpClose();
      }
    }, {
      key: "handlePromptDismiss",
      value: function handlePromptDismiss(ev) {
        ev.preventDefault();
        this.props.onPrompt('REFRESH_TOKEN');
      }
    }, {
      key: "handleConfirm",
      value: function handleConfirm(actionItem) {
        this.props.onPopUpClose();
      }
    }, {
      key: "handleConfirmDismiss",
      value: function handleConfirmDismiss(actionItem) {
        this.props.onPopUpClose();
      }
    }, {
      key: "handleInvoiceEdit",
      value: function handleInvoiceEdit(invoice) {
        this.props.onInvoiceEdit(invoice, this.props.processInstance);
      }
    }, {
      key: "handleInvoiceAddition",
      value: function handleInvoiceAddition(invoices) {
        this.props.onInvoiceAddition(invoices && invoices.length > 0 ? invoices[0] : null, this.props.processInstance);
      }
    }, {
      key: "handleMetaAction",
      value: function handleMetaAction(transactionAction) {
        var invoice = this.props.codableInvoices.find(function (invoice) {
          return invoice.guid === transactionAction.meta.invoice.guid;
        });
        this.props.onChargeSessionAction(_objectSpread$7(_objectSpread$7({}, transactionAction), {}, {
          meta: _objectSpread$7(_objectSpread$7({}, transactionAction.meta), {}, {
            invoice: invoice,
            processInstance: this.props.processInstance
          })
        }));
      }
    }, {
      key: "handleGroupedCaseClick",
      value: function handleGroupedCaseClick(ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item) return;
        var caseId = item.value;
        if (!caseId) return;
        var hostCaseId = this.props.hostCaseId ? this.props.hostCaseId : this.props.activeItem.case_id;
        var replace = hostCaseId !== this.props.activeItem.case_id;
        this.props.onPopUpNavigate({
          caseId: item.value,
          replace: replace,
          serviceLine: this.props.activeItem.service_line,
          hostCaseId: hostCaseId
        });
      }
    }, {
      key: "onFeatureSelection",
      value: function onFeatureSelection(selection) {
        this.props.onFeatureActivation(selection);
        this.caseDetailRef.current.onFeatureActivation(selection);
      }
      // The CodeQuery, SearchResult, and CodeChange all rely on a common
      // property called context.  This is what will allow business
      // logic upstream to have standard patterns for figuring out what to do
      // with various actions.
    }, {
      key: "onCodeSearch",
      value: function onCodeSearch(commonCodeQuery) {
        var context = _objectSpread$7(_objectSpread$7({}, commonCodeQuery.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          userContext: _objectSpread$7({}, this.props.userContext)
        });
        var codeQuery = _objectSpread$7(_objectSpread$7({}, commonCodeQuery), {}, {
          context: context
        });
        var isMod = codeQuery.searchType === uiCommon.commonEnums.CodeType.MODIFIER;
        if (isMod) {
          codeQuery.text = "".concat(codeQuery.text).toUpperCase();
        }
        //
        if (codeQuery.text.length > 2 || codeQuery.text.length === 2 && isMod) {
          this.props.onCodeSearch(codeQuery);
        } else {
          this.props.onSearchClear(codeQuery, commonCodeQuery.searchResultsLookupKey);
        }
      }
    }, {
      key: "onCodeSearchSelection",
      value: function onCodeSearchSelection(commonSearchResult) {
        var _commonSearchResult$c, _commonSearchResult$c2;
        if (uiCommon.objectUtils.isEmpty(commonSearchResult)) {
          return;
        }
        var defaultPrevented = (_commonSearchResult$c = (_commonSearchResult$c2 = commonSearchResult.context) === null || _commonSearchResult$c2 === void 0 ? void 0 : _commonSearchResult$c2.defaultPrevented) !== null && _commonSearchResult$c !== void 0 ? _commonSearchResult$c : false;
        if (defaultPrevented) {
          this.props.onSearchClear({
            context: _objectSpread$7(_objectSpread$7({}, commonSearchResult.context), {}, {
              activeItem: this.props.activeItem
            })
          });
        } else {
          var context = _objectSpread$7(_objectSpread$7({}, commonSearchResult.context), {}, {
            activeItem: _objectSpread$7({}, this.props.activeItem),
            invoices: _toConsumableArray(this.props.codableInvoices)
          });
          var searchResult = {
            codeInfo: commonSearchResult.codeInfo,
            context: context
          };
          this.props.onCodeSearchSelection(searchResult);
        }
      }
    }, {
      key: "onCodeUpdate",
      value: function onCodeUpdate(commonChangeDetail) {
        var context = _objectSpread$7(_objectSpread$7({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$7(_objectSpread$7({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeUpdate(changeDetail);
      }
    }, {
      key: "onCodeRemove",
      value: function onCodeRemove(commonChangeDetail) {
        var context = _objectSpread$7(_objectSpread$7({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$7(_objectSpread$7({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeRemove(changeDetail);
      }
    }, {
      key: "onTimeBasedCodeAdd",
      value: function onTimeBasedCodeAdd(commonChangeDetail, time, age) {
        var context = _objectSpread$7(_objectSpread$7({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var codeChange = _objectSpread$7(_objectSpread$7({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onTimeBasedCodeAdd(codeChange, time, age);
      }
    }, {
      key: "onTimeBasedCodeUpdate",
      value: function onTimeBasedCodeUpdate(commonChangeDetail, time, age) {
        var context = _objectSpread$7(_objectSpread$7({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var codeChange = _objectSpread$7(_objectSpread$7({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onTimeBasedCodeUpdate(codeChange, time, age);
      }
    }, {
      key: "onCodeSearchDrop",
      value: function onCodeSearchDrop(commonChangeDetail) {
        var context = _objectSpread$7(_objectSpread$7({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$7({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$7(_objectSpread$7({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeSearchDrop(changeDetail);
      }
    }, {
      key: "handleTransactionSharedDiagnosisChange",
      value: function handleTransactionSharedDiagnosisChange(changeDetail) {
        this.props.onTransactionSharedDiagnosisChange(changeDetail);
      }
    }, {
      key: "handleHARCaseList",
      value: function handleHARCaseList(options) {
        var _this$props$activeIte3, _this$props$activeIte4;
        this.props.getCasesWithEncounter({
          encounterId: (_this$props$activeIte3 = this.props.activeItem) === null || _this$props$activeIte3 === void 0 || (_this$props$activeIte3 = _this$props$activeIte3.encounter_identifier) === null || _this$props$activeIte3 === void 0 ? void 0 : _this$props$activeIte3.number,
          sortablePageable: options,
          serviceLine: (_this$props$activeIte4 = this.props.activeItem) === null || _this$props$activeIte4 === void 0 ? void 0 : _this$props$activeIte4.service_line,
          filterSelection: this.props.relatedCasesFilterSelection
        });
      }

      /**
       * Event that happen when click add charge button
       * @returns {void}
       */
    }, {
      key: "onModalAddChargeOpen",
      value: function onModalAddChargeOpen() {
        this.props.onModalAddChargeOpen();
      }

      /**
       * Event that happen when moda of add charge button is closed
       * @returns {void}
       */
    }, {
      key: "onModalAddChargeClose",
      value: function onModalAddChargeClose(e) {
        this.props.onModalAddChargeClose(e);
      }

      /**
       * Event launched when invoice is clicked
       */
    }, {
      key: "handleAddCharge",
      value: function handleAddCharge(invoice) {
        if (invoice.deleted) {
          this.handleInvoiceAddition([invoice]);
        } else {
          this.props.handleAddCharge({
            invoiceGuid: invoice.guid,
            processInstanceId: this.props.processInstance.guid.uuid,
            activeItem: this.props.activeItem
          });
        }
      }

      /**
       * Method that is called for decrement timer
       */
    }, {
      key: "handleTimer",
      value: function handleTimer() {
        this.props.handleTimer();
      }

      /**
       * Method that is called when user wants to close the modal for size experience warning
       */
    }, {
      key: "handleDeleteSizeExpWarning",
      value: function handleDeleteSizeExpWarning() {
        this.props.deleteSizeExpWarning();
      }

      /**
       * Method used for enable a procedure with tech/pro charge
       * @param context
       */
    }, {
      key: "handleEnableTechPro",
      value: function handleEnableTechPro(techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleEnableTechPro(techCodableTransaction);
      }

      /**
       * Method used for disable a procedure with tech/pro charge
       * @param context
       */
    }, {
      key: "handleDisableTechPro",
      value: function handleDisableTechPro(techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleDisableTechPro(techCodableTransaction);
      }
    }, {
      key: "onMiniTabSelection",
      value: function onMiniTabSelection(selection) {
        this.props.setActiveMiniTab(selection.displayName);
      }
    }, {
      key: "render",
      value: function render() {
        var _invoiceOptions$invoi,
          _this2 = this,
          _this$props$improveme;
        var _this$props4 = this.props;
          _this$props4.nonCodeBench;
          _this$props4.chargeSessions;
          var counts = _this$props4.counts,
          searchResults = _this$props4.searchResults,
          benchEditable = _this$props4.benchEditable,
          processInstance = _this$props4.processInstance,
          activations = _this$props4.activations,
          groupedCases = _this$props4.groupedCases,
          modalURL = _this$props4.modalURL,
          hostCaseId = _this$props4.hostCaseId;
          _this$props4.onChargeSessionAction;
          var activity = _this$props4.activity,
          prompt = _this$props4.prompt,
          confirm = _this$props4.confirm,
          showSubmittedFeedback = _this$props4.showSubmittedFeedback,
          showLoadingSubmission = _this$props4.showLoadingSubmission,
          showLoadingCancelation = _this$props4.showLoadingCancelation,
          showSizeExpWarning = _this$props4.showSizeExpWarning,
          showCanceledFeedback = _this$props4.showCanceledFeedback,
          submittedFeedbackTimer = _this$props4.submittedFeedbackTimer,
          showvitalwareIssuesModal = _this$props4.showvitalwareIssuesModal;
          _this$props4.toggleHoldCaseModal;
          _this$props4.toggleExclusionCaseModal;
          _this$props4.showLateCaseClearModal;
          _this$props4.toggleSplitCaseModal;
          var vitalwareIssues = _this$props4.vitalwareIssues,
          mergeSplitHistoryIssues = _this$props4.mergeSplitHistoryIssues,
          documentImprovementIssues = _this$props4.documentImprovementIssues,
          holdIssues = _this$props4.holdIssues;
          _this$props4.hidevitalwareIssuesModal;
          var displayAddCharge = _this$props4.displayAddCharge,
          showAddChargeError = _this$props4.showAddChargeError,
          showAddChargeLoading = _this$props4.showAddChargeLoading,
          loadState = _this$props4.loadState,
          codableInvoices = _this$props4.codableInvoices,
          feedback = _this$props4.feedback,
          showFeedBack = _this$props4.showFeedBack,
          UIMode = _this$props4.UIMode,
          epicToken = _this$props4.epicToken,
          codeEdits = _this$props4.codeEdits,
          invoiceOptions = _this$props4.invoiceOptions,
          caseEdits = _this$props4.caseEdits;
          _this$props4.showHoldCaseModal;
          _this$props4.hideHoldCaseModal;
          _this$props4.showExclusionCaseModal;
          _this$props4.hideExclusionCaseModal;
          _this$props4.toggleChargeableCase;
          _this$props4.toggleLateCaseClearModal;
          _this$props4.clearLateCaseNotification;
          _this$props4.holdCase;
          _this$props4.improvements;
          var capabilities = _this$props4.capabilities,
          updateValue = _this$props4.updateValue,
          updateCase = _this$props4.updateCase,
          relatedCases = _this$props4.relatedCases,
          relatedCasesPageable = _this$props4.relatedCasesPageable,
          flagList = _this$props4.flagList;
          _this$props4.htmlNotes;
          _this$props4.customClaimsRelatedCases;
          _this$props4.customClaimsRelatedCasesLoadState;
          var workItem = _this$props4.workItem,
          caseDetailProps = _objectWithoutProperties(_this$props4, _excluded$2);
        var flagListSet = Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) {
          return flag === null || flag === void 0 ? void 0 : flag.flag;
        })));
        var actionBar = /*#__PURE__*/React.createElement(CodeBenchActionBar, this.props);
        var codeEditingPanel;
        var relatedCasesView;
        var isActive = !uiCommon.caseUtils.isFinishedCase(caseDetailProps.activeItem);
        if (showSubmittedFeedback || showCanceledFeedback) {
          if (submittedFeedbackTimer) {
            window.parent.postMessage({
              action: 'Epic.Clinical.Informatics.Web.CloseActivity',
              token: epicToken
            }, '*');
          } else {
            this.handleTimer();
          }
        }
        var showProcessStatus = !benchEditable.editable;
        var showModal = modalURL !== null && modalURL.path;
        var modalURI = showModal ? modalURL.path + modalURL.queryString : '';
        var benchLoading = loadState.loading;
        (_invoiceOptions$invoi = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : invoiceOptions.invoices) !== null && _invoiceOptions$invoi !== void 0 ? _invoiceOptions$invoi : [];
        var styles = classnames(['code-bench', {
          'bench-pre-editable': benchEditable.waiting,
          'bench-cancelled': benchEditable.cancelled,
          'bench-loading': benchLoading
        }]);
        if (benchEditable.waiting) {
          codeEditingPanel = /*#__PURE__*/React.createElement(ProcessStatus, {
            benchEditable: benchEditable
          });
        } else {
          var noCodableInvoices = codableInvoices === null || codableInvoices.length === 0;
          var innerBench = noCodableInvoices && codableInvoices === null || loadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            key: "loading-slugs",
            numberItems: 3
          }) : [noCodableInvoices ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "no-charges empty-message"
          }, "No charges found.")) : /*#__PURE__*/React.createElement(CodeBenchPanel, {
            key: "code-bench-panel",
            panelActivations: activations.panel,
            onChargeSessionAction: this.handleMetaAction,
            onFeatureSelection: this.onFeatureSelection,
            editable: benchEditable.editable,
            benchEditable: benchEditable,
            caseDetailProps: caseDetailProps,
            searchResults: searchResults,
            benchLoading: benchLoading,
            codeEdits: codeEdits,
            onInvoiceMetaEdit: this.handleInvoiceEdit,
            onCodeSearchSelection: this.onCodeSearchSelection,
            onCodeSearch: this.onCodeSearch,
            onCodeUpdate: this.onCodeUpdate,
            onCodeRemove: this.onCodeRemove,
            onTimeBasedCodeAdd: this.onTimeBasedCodeAdd,
            onTimeBasedCodeUpdate: this.onTimeBasedCodeUpdate,
            onCodeSearchDrop: this.onCodeSearchDrop,
            onTransactionSharedDiagnosisChange: this.handleTransactionSharedDiagnosisChange,
            counts: counts,
            processInstance: processInstance,
            codableInvoices: codableInvoices,
            showProcessStatus: showProcessStatus,
            handleEnableTechPro: this.handleEnableTechPro,
            handleDisableTechPro: this.handleDisableTechPro,
            customClaimsRelatedCases: this.props.customClaimsRelatedCases,
            customClaimsRelatedCasesLoadState: this.props.customClaimsRelatedCasesLoadState,
            openChildWindow: this.props.openChildWindow
          }), /*#__PURE__*/React.createElement("div", null, benchEditable.editable && /*#__PURE__*/React.createElement("div", {
            key: "add-charge-button",
            className: "add-charge-div",
            onClick: this.onModalAddChargeOpen
          }, /*#__PURE__*/React.createElement(r, {
            iconName: e.Plus,
            titleText: "Add Charge",
            iconSize: "16",
            iconClass: "plus-icon"
          }), /*#__PURE__*/React.createElement("a", {
            className: "add-charge-btn"
          }, "Add Charge"))), /*#__PURE__*/React.createElement("div", {
            key: "charge-totals",
            className: "summary-section"
          }, /*#__PURE__*/React.createElement("h5", null, "Summary"), /*#__PURE__*/React.createElement(ChargeCounts, {
            counts: counts
          }))];
          var improvementsCapability = conditionalUtils$1.capabilityValue(capabilities.capabilities.improvements.on);
          if (uiCommon.AmplifyCore.isIPCServiceline(this.props.activeItem.service_line)) {
            relatedCasesView = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
              className: "patient-info-link",
              href: '#/patient-info',
              onClick: function onClick(ev) {
                ev.preventDefault();
                _this2.props.showPatientInfo(_this2.props.activeItem);
              }
            }, "View more patient info"), /*#__PURE__*/React.createElement(StandalonePageableList, {
              list: this.handleHARCaseList,
              sortablePageable: relatedCasesPageable,
              theme: 'cmx-theme'
            }, /*#__PURE__*/React.createElement(RelatedCases, {
              relatedCases: relatedCases,
              showLoading: benchLoading || caseDetailProps.relatedCasesLoadState.loading,
              activeItem: this.props.activeItem,
              onOpenRelatedCase: this.props.openChildWindow,
              showProviderInfo: this.props.showProviderInfo,
              filterData: this.props.filterData,
              relatedCasesFilterSelection: this.props.relatedCasesFilterSelection,
              onRelatedCasesFilterApply: this.onRelatedCasesFilterApply,
              relatedCasesFilterCapability: capabilities.capabilities.relatedCasesFilter
            })));
          } else {
            relatedCasesView = /*#__PURE__*/React.createElement(React.Fragment, null, benchLoading || caseDetailProps.billingGroupLoadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
              key: "loading-slugs",
              numberItems: 1
            }) : /*#__PURE__*/React.createElement("div", {
              className: "status-section",
              onClick: this.handleGroupedCaseClick
            }, /*#__PURE__*/React.createElement(BillingGroup, {
              suppressedLinks: [hostCaseId],
              showProcessStatus: true,
              isActive: isActive,
              cancelled: benchEditable.cancelled,
              groupedCases: groupedCases,
              showLoading: caseDetailProps.billingGroupLoadState.loading,
              viewOnly: !benchEditable.editable
            })));
          }
          var miniTabsItems = [{
            id: 'charges',
            displayName: uiCommon.commonEnums.MiniTabLabels.CHARGES_LABEL,
            active: this.props.activeMiniTab === uiCommon.commonEnums.MiniTabLabels.CHARGES_LABEL,
            body: innerBench,
            icon: /*#__PURE__*/React.createElement(r, {
              iconName: e.Coding,
              iconSize: "18",
              iconClass: "tab-icon",
              titleText: uiCommon.commonEnums.MiniTabLabels.CHARGES_DESCRIPTION
            }),
            titleText: uiCommon.commonEnums.MiniTabLabels.CHARGES_DESCRIPTION
          }, {
            id: 'relatedCases',
            displayName: uiCommon.commonEnums.MiniTabLabels.RELATED_LABEL,
            active: this.props.activeMiniTab === uiCommon.commonEnums.MiniTabLabels.RELATED_LABEL,
            body: relatedCasesView,
            icon: /*#__PURE__*/React.createElement(r, {
              iconName: e.Related,
              iconSize: "18",
              iconClass: "tab-icon",
              titleText: uiCommon.commonEnums.MiniTabLabels.RELATED_DESCRIPTION
            }),
            titleText: uiCommon.commonEnums.MiniTabLabels.RELATED_DESCRIPTION
          }, {
            id: 'activity',
            displayName: uiCommon.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
            active: this.props.activeMiniTab === uiCommon.commonEnums.MiniTabLabels.ACTIVITY_LABEL,
            body: /*#__PURE__*/React.createElement(Timeline, {
              items: activity
            }),
            icon: /*#__PURE__*/React.createElement(r, {
              iconName: e.History,
              iconSize: "18",
              iconClass: "tab-icon",
              titleText: uiCommon.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION
            }),
            titleText: uiCommon.commonEnums.MiniTabLabels.ACTIVITY_DESCRIPTION
          }, improvementsCapability && {
            id: 'improvements',
            displayName: uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
            active: this.props.activeMiniTab === uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_LABEL,
            body: /*#__PURE__*/React.createElement(Improvements, _extends$1({}, this.props, {
              improvementsAction: capabilities.capabilities.improvementsAction,
              showUnresolved: this.props.showUnresolvedDocuments
            })),
            icon: /*#__PURE__*/React.createElement(r, {
              iconName: e.Reports,
              iconSize: "18",
              iconClass: "tab-icon",
              titleText: uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION
            }),
            titleText: uiCommon.commonEnums.MiniTabLabels.IMPROVEMENTS_DESCRIPTION
          }].filter(Boolean);
          codeEditingPanel = [/*#__PURE__*/React.createElement(uiComponents.Card, {
            key: "charge-sessions",
            className: "cmx-card-panel"
          }, /*#__PURE__*/React.createElement("div", {
            className: "status-area"
          }, benchLoading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            key: "loading-slugs",
            numberItems: 1
          }) : /*#__PURE__*/React.createElement("div", {
            className: "status-section case-status-section"
          }, /*#__PURE__*/React.createElement(StatusDescription, {
            secondaryPrefix: "Review Required",
            includeBox: true,
            caseRun: caseDetailProps.activeItem
          }), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [(flagListSet === null || flagListSet === void 0 ? void 0 : flagListSet.length) > 0]
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex-section ".concat(uiCommon.caseUtils.getStatusReason(caseDetailProps.activeItem) ? 'zeroTopPadding' : '')
          }, flagListSet.map(function (flag, index) {
            return /*#__PURE__*/React.createElement("div", {
              className: "flag-item-box",
              key: "flag-".concat(index)
            }, /*#__PURE__*/React.createElement("p", {
              className: "flag-item",
              title: flag
            }, flag));
          }))))), /*#__PURE__*/React.createElement("div", {
            className: "charge-sessions"
          }, /*#__PURE__*/React.createElement(uiComponents.MiniTabs, {
            items: miniTabsItems,
            onSelection: this.onMiniTabSelection
          }))), /*#__PURE__*/React.createElement(React.Fragment, null, UIMode === uiCommon.commonEnums.UIModesEnum.EPIC_EMBEDDED ? /*#__PURE__*/React.createElement("div", {
            className: "debug-box"
          }, /*#__PURE__*/React.createElement("a", {
            className: "debug-link",
            href: "/debug"
          }, "Debug")) : '')];
        }
        return /*#__PURE__*/React.createElement("div", {
          className: styles
        }, prompt && /*#__PURE__*/React.createElement("div", {
          className: "top-level-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: prompt.text,
          closable: false,
          onSubmit: this.handlePromptDismiss,
          buttonText: "Yes",
          maximize: false
        }, /*#__PURE__*/React.createElement("p", null, "Click ", /*#__PURE__*/React.createElement("b", null, "Yes"), " below to stay logged in."))), /*#__PURE__*/React.createElement(Confirm, _extends$1({
          onConfirm: this.props.handleConfirm,
          onDismiss: this.props.handleConfirmDismiss
        }, confirm)), showModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          onClose: this.handleModalClose,
          maximize: true
        }, /*#__PURE__*/React.createElement("iframe", {
          ref: this.iframeRef,
          src: modalURI,
          className: "popup-frame"
        })), (showSubmittedFeedback || showCanceledFeedback) && /*#__PURE__*/React.createElement("div", {
          className: "qa-submitted-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: {
            message: "Successfully ".concat(showSubmittedFeedback ? 'submitted' : 'canceled'),
            id: new Date().getTime(),
            dismissable: true
          },
          showingTime: 3000,
          dismissFeedback: this.props.hideSubmittedFeedback,
          showFeedback: showSubmittedFeedback || showCanceledFeedback
        })), (showLoadingSubmission || showLoadingCancelation) && /*#__PURE__*/React.createElement("div", {
          className: "qa-submitted-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: {
            message: "".concat(showLoadingSubmission ? 'Submitting...' : 'Canceling...'),
            id: new Date().getTime(),
            dismissable: false,
            meta: {
              level: uiCommon.commonEnums.FeedbackMeta.WARNING
            }
          },
          showFeedback: showLoadingSubmission || showLoadingCancelation
        })), displayAddCharge && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          onClose: this.onModalAddChargeClose,
          title: showAddChargeLoading ? 'Adding charge' : 'Add a charge for:'
        }, /*#__PURE__*/React.createElement("div", {
          className: "qa-add-charge-modal"
        }, !showAddChargeLoading ? /*#__PURE__*/React.createElement(ChargeSelector, {
          handleAddCharge: this.handleAddCharge,
          handleInvoiceAddition: this.handleInvoiceAddition,
          invoiceOptions: invoiceOptions
        }) : /*#__PURE__*/React.createElement("div", {
          className: "spinner-box"
        }, /*#__PURE__*/React.createElement("img", {
          src: img,
          alt: "in progress",
          className: "spinner"
        })), /*#__PURE__*/React.createElement("div", {
          className: "charge-error-box"
        }, showAddChargeError ? /*#__PURE__*/React.createElement("small", {
          className: "charge-error-text"
        }, "Error adding a new charge") : ''))), /*#__PURE__*/React.createElement(CaseDetail, _extends$1({
          ref: this.caseDetailRef,
          mode: "code-edit",
          codeEdits: codeEdits,
          codeEditingPanel: codeEditingPanel,
          groupedCases: groupedCases
        }, caseDetailProps, {
          loadState: loadState,
          activations: activations,
          actionBar: actionBar,
          updateValue: updateValue,
          updateCase: updateCase,
          showAttachDocsModal: this.props.showAttachDocsModal,
          capability: capabilities.capabilities.caseEdit,
          coderNotesCapability: capabilities.capabilities.coderNotes,
          capabilities: capabilities,
          processInstance: this.props.processInstance,
          caseEdits: caseEdits,
          noteUnavailableReason: capabilities.capabilities.noteUnavailableReason,
          UIMode: this.props.UIMode,
          showCoderNotesInfo: this.props.showCoderNotesInfo,
          workItem: workItem
        })), /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: feedback,
          dismissFeedback: this.props.hideFeedback,
          showFeedback: showFeedBack,
          showingTime: 5000
        }), showSizeExpWarning && /*#__PURE__*/React.createElement("div", {
          className: "top-level-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: 'Help us improve your experience',
          closable: true,
          onClose: this.handleDeleteSizeExpWarning,
          onSubmit: this.handleDeleteSizeExpWarning,
          buttonText: "Dismiss",
          maximize: false
        }, /*#__PURE__*/React.createElement("p", null, "Consider adjusting the width of your browser to a wider setting for a better view of CMX Amplify."))), showvitalwareIssuesModal && /*#__PURE__*/React.createElement(VitalWareModal, {
          onClose: this.props.hidevitalwareIssuesModal,
          onSubmit: function onSubmit(event, comment, remove_hold) {
            return _this2.handleSubmit(event, comment, true, remove_hold);
          },
          vitalwareIssues: vitalwareIssues,
          mergeSplitHistoryIssues: mergeSplitHistoryIssues,
          documentImprovementIssues: documentImprovementIssues,
          holdIssues: holdIssues,
          holdCaseStatus: capabilities.holdCaseStatus,
          improvements: (_this$props$improveme = this.props.improvements) === null || _this$props$improveme === void 0 ? void 0 : _this$props$improveme.improvements,
          setActiveMiniTab: this.props.setActiveMiniTab,
          setUnresolvedDocuments: this.props.setUnresolvedDocuments
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(CodeBench, "defaultProps", {
    benchEditable: _objectSpread$7({}, uiCommon.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
    improvements: _objectSpread$7({}, uiCommon.AmplifyCore.state.improvements),
    capabilities: _objectSpread$7({}, uiCommon.AmplifyCore.state.capabilities),
    relatedCasesLoadState: _objectSpread$7({}, uiCommon.loadStates.LOAD_STATES.done),
    relatedCasesPageable: _objectSpread$7({}, uiCommon.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
    processInstanceGuids: [],
    hostCaseId: null,
    loadAlwaysFromURL: false,
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    confirm: {
      display: false,
      title: ''
    },
    activity: [],
    noteTypes: [],
    workItem: {
      assignee: '',
      owner: '',
      aging_days: '',
      codable_days: ''
    },
    onLoad: function onLoad(caseRun) {},
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    onReload: function onReload(params) {},
    onSearchClear: function onSearchClear(codeQuery) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    handleAddAllCodes: function handleAddAllCodes(searchSelection) {},
    handleRemoveAllCodes: function handleRemoveAllCodes(codeChange) {},
    onChargeSessionMetaEdit: function onChargeSessionMetaEdit(chargeSession) {},
    onCodeUpdate: function onCodeUpdate(changeDetail) {},
    onCodeRemove: function onCodeRemove(changeDetail) {},
    onTimeBasedCodeAdd: function onTimeBasedCodeAdd(time, age) {},
    onTimeBasedCodeUpdate: function onTimeBasedCodeUpdate(time, age) {},
    onCodeSearchDrop: function onCodeSearchDrop(changeDetail) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    onPrompt: function onPrompt(action) {},
    onPopUpClose: function onPopUpClose() {},
    onFeatureActivation: function onFeatureActivation(selection) {},
    onNavigate: function onNavigate(caseId, replace, serviceLine) {},
    hidevitalwareIssuesModal: function hidevitalwareIssuesModal() {},
    onImprovementAdd: function onImprovementAdd(documentImprovement) {},
    onImprovementUpdate: function onImprovementUpdate(documentImprovement) {},
    onImprovementRemove: function onImprovementRemove(documentImprovement) {},
    onProviderAdd: function onProviderAdd(documentImprovement) {},
    onProviderRemove: function onProviderRemove(documentImprovement) {},
    onProviderUpdate: function onProviderUpdate(documentImprovement) {},
    onDocumentImprovementSearch: function onDocumentImprovementSearch(codeQuery) {},
    showAmplifyFeedback: function showAmplifyFeedback(feedback) {},
    onProviderSearch: function onProviderSearch(query) {},
    updateValue: function updateValue(val) {},
    updateCase: function updateCase(idAndUpdates) {},
    loadRoles: function loadRoles(roles) {},
    getFlagItems: function getFlagItems(activeItem) {},
    setActiveMiniTab: function setActiveMiniTab(activeTabName) {},
    setUnresolvedDocuments: function setUnresolvedDocuments(value) {},
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    searchResults: {},
    codeSearchResultsV2: {},
    displayAddCharge: false,
    showAddChargeError: false,
    showLoadingSubmission: false,
    showLoadingCancelation: false,
    showSizeExpWarning: false,
    showFeedBack: false,
    showSubmittedFeedback: false,
    showCanceledFeedback: false,
    submittedFeedbackTimer: false,
    showvitalwareIssuesModal: false,
    toggleHoldCaseModal: false,
    toggleExclusionCaseModal: false,
    showLateCaseClearModal: false,
    toggleSplitCaseModal: false,
    showCoderNotesModal: false,
    submitOldCaseModal: false,
    vitalwareIssues: [],
    mergeSplitHistoryIssues: [],
    caseAccessTime: '',
    activeMiniTab: uiCommon.commonEnums.MiniTabLabels.CHARGES_LABEL,
    showUnresolvedDocuments: false,
    relatedCaseFilterOptions: {},
    updateRelatedCasesFilterSelection: function updateRelatedCasesFilterSelection(options) {}
  });

  function ownKeys$6(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$6(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$6(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$6(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var FieldType = uiCommon.commonEnums.FieldType;
  var DateOfService = {
    key: 'date_of_service',
    path: ['date_of_service'],
    displayName: null,
    classNames: [['invoice-meta-text-heading']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text,
    datetimeFormat: uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE,
    fallbackValue: 'Date not selected'
  };
  var DepartmentField = {
    key: 'department',
    path: ['department', 'name'],
    displayName: 'Department',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
  };
  var PeformingNameField = {
    key: 'performing_provider_name',
    path: ['performing_provider_name'],
    appendValuePath: ['performing_provider_number', 'number'],
    displayName: 'Performed By',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
  };
  var ProviderNameField = {
    key: 'billing_provider_name',
    path: ['billing_provider_name'],
    appendValuePath: ['billing_provider_number', 'number'],
    displayName: 'Billing provider',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
  };
  var ReferredByField = {
    key: 'referred_by',
    path: ['referring_provider_name'],
    appendValuePath: ['referring_provider_number', 'number'],
    displayName: 'Referred By',
    classNames: [['invoice-meta-text-body']],
    readonly: true,
    width: '1fr',
    fieldType: FieldType.Text
  };

  // These are the current form fields for the invoice metadata form in both the grade bench and code bench panel
  // If these fields need to change dynamicaly then InvoiceMetadataFormFields can be added to the redux state rather than statically defined here
  var InvoiceMetadataFormFields = [DateOfService, DepartmentField, PeformingNameField, ProviderNameField, ReferredByField];
  var InvoiceMetadataFormFieldsCQA = [_objectSpread$6(_objectSpread$6({}, DateOfService), {}, {
    path: ['dateOfService']
  }), _objectSpread$6({}, DepartmentField), _objectSpread$6(_objectSpread$6({}, PeformingNameField), {}, {
    path: ['performingProviderName']
  }), _objectSpread$6(_objectSpread$6({}, ProviderNameField), {}, {
    path: ['billingProviderName']
  }), _objectSpread$6(_objectSpread$6({}, ReferredByField), {}, {
    path: ['referringProviderName']
  })];

  var _excluded$1 = ["searchResults", "counts", "editable", "benchEditable", "benchLoading", "onCodeSearch", "onCodeSearchSelection", "handleAddAllCodes", "handleRemoveAllCodes", "onCodeUpdate", "onCodeRemove", "onTimeBasedCodeAdd", "onTimeBasedCodeUpdate", "onCodeSearchDrop", "onFeatureSelection", "onInvoiceMetaEdit", "onChargeSessionAction", "onTransactionSharedDiagnosisChange", "panelActivations", "codableInvoices", "processInstance", "codeEdits", "showProcessStatus", "caseDetailProps", "handleEnableTechPro", "handleDisableTechPro", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "openChildWindow"];
  function ownKeys$5(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$5(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$5(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$5(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  function _callSuper$2(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$2() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$2() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$2 = function _isNativeReflectConstruct() { return !!t; })(); }
  var CodeSearchType = uiCommon.commonEnums.CodeSearchType;
  var DEFAULT_SUGGESTED_CODES = uiCommon.AmplifyCore.state.DEFAULT_SUGGESTED_CODES;
  var CodeBenchPanelv2 = /*#__PURE__*/function (_React$Component) {
    function CodeBenchPanelv2(props) {
      var _this;
      _classCallCheck(this, CodeBenchPanelv2);
      _this = _callSuper$2(this, CodeBenchPanelv2, [props]);
      _defineProperty(_this, "tabContainerRef", /*#__PURE__*/React.createRef());
      /**
       * Event that happen when Enter key is pressed on  add Invoice link
       * @returns {void}
       */
      _defineProperty(_this, "handleKeyDown", function (ev) {
        if (ev.key === 'Enter') {
          ev.preventDefault();
          _this.props.handleInvoiceAddition();
        }
      });
      _defineProperty(_this, "createItemsForTabContainer", function () {
        var _this$props = _this.props,
          codableInvoices = _this$props.codableInvoices,
          searchResults = _this$props.searchResults,
          codeSearchResultsV2 = _this$props.codeSearchResultsV2,
          codeEdits = _this$props.codeEdits,
          onChargeSessionAction = _this$props.onChargeSessionAction,
          panelActivations = _this$props.panelActivations,
          processInstance = _this$props.processInstance,
          editable = _this$props.editable,
          suggestedCodes = _this$props.suggestedCodes,
          onFeatureSelection = _this$props.onFeatureSelection,
          onCodeSearch = _this$props.onCodeSearch,
          onCodeSearchSelection = _this$props.onCodeSearchSelection,
          handleAddAllCodes = _this$props.handleAddAllCodes,
          handleRemoveAllCodes = _this$props.handleRemoveAllCodes,
          onCodeUpdate = _this$props.onCodeUpdate,
          onCodeRemove = _this$props.onCodeRemove,
          onTimeBasedCodeAdd = _this$props.onTimeBasedCodeAdd,
          onTimeBasedCodeUpdate = _this$props.onTimeBasedCodeUpdate,
          onCodeSearchDrop = _this$props.onCodeSearchDrop,
          onTransactionSharedDiagnosisChange = _this$props.onTransactionSharedDiagnosisChange,
          handleEnableTechPro = _this$props.handleEnableTechPro,
          handleDisableTechPro = _this$props.handleDisableTechPro,
          onInvoiceMetaEdit = _this$props.onInvoiceMetaEdit;
          _this$props.onInvoiceRemove;
          var onTransactionOrderChange = _this$props.onTransactionOrderChange;
        var counter = 0; // Initialize counter

        var handleInvoiceRemove = function handleInvoiceRemove(invoiceGuid) {
          _this.props.onInvoiceRemove({
            processInstance: processInstance,
            invoiceGuid: invoiceGuid
          });
        };
        var isEmptyCPTCodeTransaction = function isEmptyCPTCodeTransaction(transaction) {
          var hasProcedureCode = transaction.codes.some(function (code) {
            return 'codeType' in code && code.codeType === 'procedure';
          });
          return !hasProcedureCode;
        };
        var firstEmptyCPTTransactionFound = false; // Tracks if an empty transaction has been found
        var items = codableInvoices.map(function (codableInvoice, idx) {
          var _codableInvoice$billi, _codableInvoice$perfo, _codableInvoice$refer, _codableInvoice$fee_s, _codableInvoice$depar, _codableInvoice$depar2, _codableInvoice$type$, _codableInvoice$type, _codeSearchResultsV2$2, _codeSearchResultsV2$3;
          var providerName = (_codableInvoice$billi = codableInvoice.billing_provider_name) !== null && _codableInvoice$billi !== void 0 ? _codableInvoice$billi : '';
          (_codableInvoice$perfo = codableInvoice.performing_provider_name) !== null && _codableInvoice$perfo !== void 0 ? _codableInvoice$perfo : '';
          (_codableInvoice$refer = codableInvoice.referring_provider_name) !== null && _codableInvoice$refer !== void 0 ? _codableInvoice$refer : '';
          (_codableInvoice$fee_s = codableInvoice.fee_schedule) !== null && _codableInvoice$fee_s !== void 0 ? _codableInvoice$fee_s : 'None';
          (_codableInvoice$depar = codableInvoice === null || codableInvoice === void 0 || (_codableInvoice$depar2 = codableInvoice.department) === null || _codableInvoice$depar2 === void 0 ? void 0 : _codableInvoice$depar2.name) !== null && _codableInvoice$depar !== void 0 ? _codableInvoice$depar : '';
          var dateOfService = codableInvoice.date_of_service ? uiCommon.cmxDateTime.format(codableInvoice.date_of_service, uiCommon.cmxDateTime.FORMATS.DATE_OF_SERVICE) : 'Date not selected';

          /**
           * Event triggered when a search selection is pressed to create a transaction and add code
           * @param ev
           */
          var createTransactionAndAddCode = function createTransactionAndAddCode(searchResult) {
            var searchSelection = _objectSpread$5(_objectSpread$5({}, searchResult), {}, {
              context: {
                invoice: _objectSpread$5({}, codableInvoice),
                processInstance: _objectSpread$5({}, _this.props.processInstance)
              }
            });
            _this.props.createTransactionAndAddCode(searchSelection);
          };
          var txns = codableInvoice.transactions.map(function (txn, txnIdx) {
            var _searchResults$txn$gu, _codeSearchResultsV2$;
            var rawResults = (_searchResults$txn$gu = searchResults[txn.guid]) !== null && _searchResults$txn$gu !== void 0 ? _searchResults$txn$gu : [];
            var rawResultsV2 = (_codeSearchResultsV2$ = codeSearchResultsV2[txn.guid]) !== null && _codeSearchResultsV2$ !== void 0 ? _codeSearchResultsV2$ : {};
            if (codableInvoice.type !== uiCommon.commonEnums.InvoiceTypes.SHARED_CODES) {
              counter++;
            }
            var shouldAutoFocus = false;
            // to find first transaction with no CPT code.
            if (codableInvoice.type !== 'SHARED_CODES' && isEmptyCPTCodeTransaction(txn) && !firstEmptyCPTTransactionFound) {
              firstEmptyCPTTransactionFound = true;
              shouldAutoFocus = true;
            }
            var TransactionComponent = _this.props.transactionV2 ? TransactionV2 : Transaction;
            var transactionProps = {
              key: "txn-".concat(txn.guid),
              codeEdits: codeEdits,
              onChargeSessionAction: onChargeSessionAction,
              panelActivations: panelActivations,
              invoice: codableInvoice,
              processInstance: processInstance,
              autoFocus: shouldAutoFocus,
              editable: editable,
              onFeatureSelection: onFeatureSelection,
              searchResults: rawResults,
              codeSearchResultsV2: rawResultsV2,
              onCodeSearch: onCodeSearch,
              onCodeSearchSelection: onCodeSearchSelection,
              handleAddAllCodes: handleAddAllCodes,
              handleRemoveAllCodes: handleRemoveAllCodes,
              createTransactionAndAddCode: createTransactionAndAddCode,
              handleCodeChange: onCodeUpdate,
              handleCodeRemove: onCodeRemove,
              handleTransactionOrderChange: onTransactionOrderChange,
              handleTimeBasedCodeAdd: onTimeBasedCodeAdd,
              handleTimeBasedCodeUpdate: onTimeBasedCodeUpdate,
              handleCodeSearchDrop: onCodeSearchDrop,
              onTransactionSharedDiagnosisChange: onTransactionSharedDiagnosisChange,
              lineNumber: counter,
              codableTransaction: txn,
              suggestedCodes: suggestedCodes,
              handleEnableTechPro: handleEnableTechPro,
              handleDisableTechPro: handleDisableTechPro,
              scrollContainerRef: _this.tabContainerRef,
              transactionIndex: txnIdx
            };
            return /*#__PURE__*/React.createElement(TransactionComponent, transactionProps);
          });

          /**
           * Event launched when a search is performed
           * @param ev
           */
          var onSearch = function onSearch(codeQuery) {
            _this.props.onCodeSearch(_objectSpread$5(_objectSpread$5({}, codeQuery), {}, {
              context: {
                invoice: _objectSpread$5({}, codableInvoice),
                processInstance: _objectSpread$5({}, _this.props.processInstance)
              }
            }));
          };
          var invoiceType = (_codableInvoice$type$ = codableInvoice === null || codableInvoice === void 0 || (_codableInvoice$type = codableInvoice.type) === null || _codableInvoice$type === void 0 ? void 0 : _codableInvoice$type.toLowerCase().replace(/_/g, '-')) !== null && _codableInvoice$type$ !== void 0 ? _codableInvoice$type$ : 'unknown';
          var additionalInvoiceCardClasses = ['codable-invoice', 'qa-codable-invoice', "invoice-".concat(invoiceType)];
          //`invoice-${invoiceType}`
          var invoiceBody = /*#__PURE__*/React.createElement(InvoiceCard, {
            additionalClasses: additionalInvoiceCardClasses,
            key: "invoice-".concat(idx)
          }, /*#__PURE__*/React.createElement("div", {
            className: "invoice-meta"
          }, /*#__PURE__*/React.createElement("div", {
            className: "invoice-meta-line invoice-meta-provider"
          }, editable && /*#__PURE__*/React.createElement(ErrorSubmission, {
            errorMessages: codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.errorMessages,
            messageStyle: "inv-error-message",
            messageType: "error"
          }), /*#__PURE__*/React.createElement(InvoiceMetadatav2, {
            invoice: codableInvoice,
            onInvoiceMetaEdit: onInvoiceMetaEdit,
            fields: InvoiceMetadataFormFields,
            editable: editable,
            onInvoiceRemove: handleInvoiceRemove
          }))), txns, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [editable, !invoiceType.includes('shared')],
            displayMode: "flex"
          }, /*#__PURE__*/React.createElement("div", {
            className: "add-transaction-with-code-section"
          }, /*#__PURE__*/React.createElement(SuggestedLookup, {
            actionPrefix: "",
            placeholderText: "Add procedure code",
            debounceTimeout: 200,
            FieldDefinitions: uiComponents.FieldDefinitions.filter(function (def) {
              return def.label.toLowerCase() === 'procedure';
            }),
            shouldShowResults: uiComponents.shouldShowResults,
            autoFocus: false,
            onSearch: onSearch,
            onSearchSelection: createTransactionAndAddCode,
            searchResults: (_codeSearchResultsV2$2 = codeSearchResultsV2 === null || codeSearchResultsV2 === void 0 || (_codeSearchResultsV2$3 = codeSearchResultsV2[codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.guid]) === null || _codeSearchResultsV2$3 === void 0 ? void 0 : _codeSearchResultsV2$3[CodeSearchType.CPT]) !== null && _codeSearchResultsV2$2 !== void 0 ? _codeSearchResultsV2$2 : [],
            searchResultsLookupKey: codableInvoice === null || codableInvoice === void 0 ? void 0 : codableInvoice.guid,
            showSearchButton: false,
            actionNameForDD: "~Focus code search (General)",
            suggestedCodes: suggestedCodes,
            allowCodeRemove: false
          }), /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
            svgIconName: "BiomeChevronDownSVG20",
            svgIconSize: "16",
            svgIconClass: "select-chevron"
          }))));
          return {
            headerText: dateOfService,
            subheaderText: providerName,
            body: invoiceBody
          };
        });
        return {
          items: items,
          counter: counter
        };
      });
      _this.state = {
        editState: {
          add: false
        }
      };
      return _this;
    }
    _inherits(CodeBenchPanelv2, _React$Component);
    return _createClass(CodeBenchPanelv2, [{
      key: "parseDate",
      value: function parseDate(dateString) {
        var _dateString$split$map = dateString.split('/').map(Number),
          _dateString$split$map2 = _slicedToArray(_dateString$split$map, 3),
          month = _dateString$split$map2[0],
          day = _dateString$split$map2[1],
          year = _dateString$split$map2[2];
        return new Date(year, month - 1, day);
      }
    }, {
      key: "sortItems",
      value: function sortItems(itemsToSort) {
        var _this2 = this;
        return itemsToSort.sort(function (a, b) {
          var dateA = _this2.parseDate(a.headerText);
          var dateB = _this2.parseDate(b.headerText);

          // Compare the dates
          if (dateA < dateB) return -1;
          if (dateA > dateB) return 1;

          // Compare the provider names
          var providerA = a.subheaderText.toLowerCase();
          var providerB = b.subheaderText.toLowerCase();
          if (providerA < providerB) return -1;
          if (providerA > providerB) return 1;
          return 0;
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _processInstance$erro;
        var _this$props2 = this.props;
          _this$props2.searchResults;
          _this$props2.counts;
          var editable = _this$props2.editable,
          benchEditable = _this$props2.benchEditable;
          _this$props2.benchLoading;
          _this$props2.onCodeSearch;
          _this$props2.onCodeSearchSelection;
          _this$props2.handleAddAllCodes;
          _this$props2.handleRemoveAllCodes;
          _this$props2.onCodeUpdate;
          _this$props2.onCodeRemove;
          _this$props2.onTimeBasedCodeAdd;
          _this$props2.onTimeBasedCodeUpdate;
          _this$props2.onCodeSearchDrop;
          _this$props2.onFeatureSelection;
          _this$props2.onInvoiceMetaEdit;
          _this$props2.onChargeSessionAction;
          _this$props2.onTransactionSharedDiagnosisChange;
          _this$props2.panelActivations;
          var codableInvoices = _this$props2.codableInvoices,
          processInstance = _this$props2.processInstance;
          _this$props2.codeEdits;
          var showProcessStatus = _this$props2.showProcessStatus;
          _this$props2.caseDetailProps;
          _this$props2.handleEnableTechPro;
          _this$props2.handleDisableTechPro;
          var customClaimsRelatedCases = _this$props2.customClaimsRelatedCases,
          customClaimsRelatedCasesLoadState = _this$props2.customClaimsRelatedCasesLoadState;
          _this$props2.openChildWindow;
          var rest = _objectWithoutProperties(_this$props2, _excluded$1);
        var styleClasses = ['code-bench-panelv2'];
        var _this$createItemsForT = this.createItemsForTabContainer(),
          items = _this$createItemsForT.items,
          counter = _this$createItemsForT.counter;
        var noInvoices = /*#__PURE__*/React.createElement("div", {
          className: "no-transactions"
        }, /*#__PURE__*/React.createElement("div", {
          className: "empty-message editable"
        }, "This case does not have any charges. Add a service date and providers with the charge button below, then add procedures to the set."), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
          on: editable
        }, /*#__PURE__*/React.createElement("div", {
          className: "add-element-div",
          tabIndex: 0,
          onKeyDown: this.handleKeyDown,
          onClick: this.props.handleInvoiceAddition
        }, /*#__PURE__*/React.createElement(uiComponents.CMXIcon, {
          svgIconName: "BiomePlusCircle",
          svgIconSize: "20"
        }), /*#__PURE__*/React.createElement("a", {
          className: "add-element-button"
        }, "Add invoice"))));
        return /*#__PURE__*/React.createElement("div", _extends$1({}, rest, {
          className: classnames(styleClasses)
        }), showProcessStatus && /*#__PURE__*/React.createElement("div", {
          className: "status-section process-status-section"
        }, /*#__PURE__*/React.createElement(ProcessStatus, {
          benchEditable: benchEditable
        })), customClaimsRelatedCasesLoadState !== null && customClaimsRelatedCasesLoadState !== void 0 && customClaimsRelatedCasesLoadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
          numberItems: 5
        }) : (processInstance === null || processInstance === void 0 || (_processInstance$erro = processInstance.errorMessages) === null || _processInstance$erro === void 0 ? void 0 : _processInstance$erro.length) > 0 && /*#__PURE__*/React.createElement(ErrorSubmission, {
          errorMessages: processInstance.errorMessages,
          messageHeader: benchEditable.submitted ? 'We have found the following errors:' : 'We have found the following that reduce the coding quality of this case:',
          customClaimsRelatedProps: {
            cases: customClaimsRelatedCases,
            onOpenRelatedCase: this.props.openChildWindow,
            applyErrorTextStyle: !benchEditable.submitted
          },
          messageStyle: "case-error-message",
          messageType: benchEditable.submitted ? 'warning' : 'error'
        }), counter === 0 ? noInvoices : items.length > 1 ? /*#__PURE__*/React.createElement(uiComponents.InteractiveTabContainer, _extends$1({
          key: codableInvoices.length,
          items: this.sortItems(items.slice(1)),
          alwaysFirstElement: items[0].body
        }, editable && {
          action: {
            label: 'Add',
            onAction: this.props.handleInvoiceAddition
          }
        }, {
          footerElement: this.props.summarySection,
          scrollContainerRef: this.tabContainerRef
        })) : /*#__PURE__*/React.createElement(uiComponents.InteractiveTabContainer, {
          key: codableInvoices.length,
          items: items
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(CodeBenchPanelv2, "displayName", 'CodeBenchPanel');
  _defineProperty(CodeBenchPanelv2, "defaultProps", {
    onCodeUpdate: function onCodeUpdate(changeDetail) {},
    onCodeRemove: function onCodeRemove(changeDetail) {},
    onTimeBasedCodeAdd: function onTimeBasedCodeAdd(changeDetail, time, age) {},
    onTimeBasedCodeUpdate: function onTimeBasedCodeUpdate(changeDetail, time, age) {},
    onCodeSearchDrop: function onCodeSearchDrop(changeDetail) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    handleAddAllCodes: function handleAddAllCodes(searchSelection) {},
    handleRemoveAllCodes: function handleRemoveAllCodes(codeChange) {},
    createTransactionAndAddCode: function createTransactionAndAddCode(searchSelection) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    onFeatureSelection: function onFeatureSelection(feature) {},
    onInvoiceMetaEdit: function onInvoiceMetaEdit(invoice) {},
    onInvoiceRemove: function onInvoiceRemove(invoiceDeleteParams) {},
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    handleEnableTechPro: function handleEnableTechPro(transactionCodeChange) {},
    handleDisableTechPro: function handleDisableTechPro(transactionCodeChange) {},
    codableInvoices: [],
    searchResults: {},
    codeSearchResultsV2: {},
    editable: true,
    panelActivations: {},
    codeEdits: {},
    counts: {
      procedures: 0,
      diagnosis: 0,
      modifiers: 0
    },
    suggestedCodes: _objectSpread$5({}, DEFAULT_SUGGESTED_CODES)
  });

  function PurposeAndGuideline(_ref) {
    var guideline = _ref.guideline,
      purpose = _ref.purpose;
    return /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "purpose-rows-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-box purpose-guideline-top-row"
    }, "Purpose for Assessment"), /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-box purpose-guideline-top-row"
    }, "Guidelines")), /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-box"
    }, purpose), /*#__PURE__*/React.createElement("div", {
      className: "purpose-guideline-box"
    }, guideline))));
  }

  var renderWorkItemLabel = function renderWorkItemLabel(workitem) {
    var _workitem$data;
    return (_workitem$data = workitem.data) === null || _workitem$data === void 0 ? void 0 : _workitem$data.assignee;
  };
  var renderWorkitemInItemSelector = function renderWorkitemInItemSelector(workitem) {
    var _workitem$data2;
    return /*#__PURE__*/React.createElement("div", null, (_workitem$data2 = workitem.data) === null || _workitem$data2 === void 0 ? void 0 : _workitem$data2.assignee);
  };
  var WorkItemStatus = /*#__PURE__*/function (WorkItemStatus) {
    WorkItemStatus["IN_CQA"] = "IN PROGRESS";
    WorkItemStatus["CQA_COMPLETE"] = "COMPLETE";
    WorkItemStatus["CQA_APPROVED"] = "APPROVED";
    return WorkItemStatus;
  }(WorkItemStatus || {});
  var GroupWorkitemsByStatus = function GroupWorkitemsByStatus(workitems) {
    // Create new groups array with empty items arrays each time
    var groups = [{
      label: WorkItemStatus.IN_CQA,
      items: []
    }, {
      label: WorkItemStatus.CQA_COMPLETE,
      items: []
    }, {
      label: WorkItemStatus.CQA_APPROVED,
      items: []
    }];
    workitems.forEach(function (workitem) {
      var qaStatus = workitem.data.qa_status;
      var group = groups.find(function (group) {
        return group.label === WorkItemStatus[qaStatus];
      });
      if (group) {
        group.items.push(workitem);
      }
    });
    return groups;
  };
  var isWorkitemSelected = function isWorkitemSelected(selectedWorkitem, currentWorkitem) {
    var _selectedWorkitem$dat, _currentWorkitem$data;
    return (selectedWorkitem === null || selectedWorkitem === void 0 || (_selectedWorkitem$dat = selectedWorkitem.data) === null || _selectedWorkitem$dat === void 0 ? void 0 : _selectedWorkitem$dat.case_id) === ((_currentWorkitem$data = currentWorkitem.data) === null || _currentWorkitem$data === void 0 ? void 0 : _currentWorkitem$data.case_id);
  };
  var getSelectedWorkitemFromInvoice = function getSelectedWorkitemFromInvoice(cursorAPIContext, workitems) {
    var selectedWorkitemIndex = workitems.findIndex(function (workitem) {
      return workitem.data.case_id === cursorAPIContext.workitemId;
    });
    return [workitems[selectedWorkitemIndex], selectedWorkitemIndex];
  };

  var _excluded = ["nonCodeBench", "chargeSessions", "counts", "searchResults", "codeSearchResultsV2", "benchEditable", "processInstance", "activations", "groupedCases", "modalURL", "hostCaseId", "onChargeSessionAction", "activity", "prompt", "confirm", "showSubmittedFeedback", "showLoadingSubmission", "showLoadingCancelation", "showSizeExpWarning", "showCanceledFeedback", "submittedFeedbackTimer", "showvitalwareIssuesModal", "toggleHoldCaseModal", "toggleExclusionCaseModal", "showLateCaseClearModal", "toggleSplitCaseModal", "vitalwareIssues", "mergeSplitHistoryIssues", "documentImprovementIssues", "holdIssues", "hidevitalwareIssuesModal", "displayAddCharge", "showAddChargeError", "showAddChargeLoading", "loadState", "codableInvoices", "feedback", "showFeedBack", "UIMode", "epicToken", "codeEdits", "invoiceOptions", "caseEdits", "showHoldCaseModal", "hideHoldCaseModal", "showExclusionCaseModal", "hideExclusionCaseModal", "toggleLateCaseClearModal", "clearLateCaseNotification", "toggleChargeableCase", "holdCase", "improvements", "capabilities", "updateValue", "updateCase", "relatedCases", "relatedCasesPageable", "flagList", "htmlNotes", "customClaimsRelatedCases", "customClaimsRelatedCasesLoadState", "organization", "benchMode", "caseVersions", "gradeableInvoices", "fieldDefinitions", "riskCategories", "cqaCodeAssessmentRiskDictionaries", "onGradeUpdate", "onGradeRemove", "onCodeEvent", "onCreateCQATransaction", "onDeleteCQATransaction", "workItem", "suggestedCodes", "associatedWorkitems", "loadAssociatedWorkItem"];
  function _callSuper$1(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct$1() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct$1() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() { return !!t; })(); }
  function ownKeys$4(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$4(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$4(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$4(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var CaseAlertType = uiCommon.commonEnums.CaseAlertType,
    AccelerateProcessStatus = uiCommon.commonEnums.AccelerateProcessStatus;
  var getChildWindowParams = uiCommon.caseUtils.getChildWindowParams;
  var conditionalUtils = uiCommon.AmplifyCore.conditionalUtils;
  /**
   * Place to update, transform, or modify property config.
   *
   * This function can help to separate the the React view from the React state before
   * sharing the object with PatientEncounterv2
   *
   * @param UpdatePropertyConfig
   * @returns An updated PatientInformationConfiguration
   */
  function updatePropertyConfig(_ref) {
    var serviceLine = _ref.serviceLine,
      benchMode = _ref.benchMode,
      propertyConfig = _ref.propertyConfig;
    var _serviceLine = serviceLine ? serviceLine.toLocaleLowerCase() : '';

    // For cqa workflow, serviceLine comes from activeItem which is set in code-bench.reducer.ts when loadCQAItemFromURL.
    // This service line is specifically based on the cqa-service workitem. Product requirement is to display
    // exam_description in CQA grading screen only for radiology.
    if (benchMode === uiCommon.commonEnums.BenchMode.GRADE) {
      return _objectSpread$4(_objectSpread$4({}, propertyConfig), {}, {
        summary: propertyConfig.summary.filter(function (summary) {
          if (summary.key === 'exam_description' && !['radiology'].includes(_serviceLine)) {
            return false;
          }
          return true;
        })
      });
    }
    return _objectSpread$4({}, propertyConfig);
  }
  var CodeBenchv2 = /*#__PURE__*/function (_React$Component) {
    function CodeBenchv2(props) {
      var _this;
      _classCallCheck(this, CodeBenchv2);
      _this = _callSuper$1(this, CodeBenchv2, [props]);
      _defineProperty(_this, "caseDetailRef", void 0);
      _defineProperty(_this, "iframeRef", void 0);
      _defineProperty(_this, "timerId", null);
      _defineProperty(_this, "timerStarted", false);
      _defineProperty(_this, "handleBeforeUnload", function () {
        _this.cleanupCaseAccess();
      });
      _defineProperty(_this, "cleanupCaseAccess", function () {
        var hasActiveItem = !uiCommon.objectUtils.isEmpty(_this.props.activeItem);
        var case_uid = '';
        if (_this.props.loadAlwaysFromURL || !hasActiveItem) {
          var _this$props$match$par, _this$props$match, _this$props$match2;
          case_uid = (_this$props$match$par = (_this$props$match = _this.props.match) === null || _this$props$match === void 0 || (_this$props$match = _this$props$match.params) === null || _this$props$match === void 0 ? void 0 : _this$props$match.caseId) !== null && _this$props$match$par !== void 0 ? _this$props$match$par : (_this$props$match2 = _this.props.match) === null || _this$props$match2 === void 0 || (_this$props$match2 = _this$props$match2.params) === null || _this$props$match2 === void 0 ? void 0 : _this$props$match2.id;
        } else {
          case_uid = _this.props.activeItem.case_uid;
        }
        if (_this.timerStarted) {
          _this.props.releaseCaseAccess(case_uid);
        }
        _this.clearTimer();
        _this.props.resetCaseAccess(_this.props.processInstance);
      });
      _defineProperty(_this, "startTimer", function (caseUid) {
        // avoid duplicate timers
        _this.clearTimer();
        _this.timerId = setInterval(function () {
          _this.props.refreshCaseAccessTimer(caseUid);
        }, 300000);
      });
      /**
       * Helper function to release current case access, clear timer, and reset case access state
       */
      _defineProperty(_this, "releaseCurrentCaseAccess", function () {
        // reset state
        _this.setState({
          showCaseConflictModal: false,
          conflictingUser: ''
        });
        if (_this.timerStarted && (_this.props.processInstance || _this.props.benchMode === uiCommon.commonEnums.BenchMode.GRADE)) {
          var _this$props$activeIte, _this$props$activeIte2, _this$props$match3;
          var case_uid = (_this$props$activeIte = (_this$props$activeIte2 = _this.props.activeItem) === null || _this$props$activeIte2 === void 0 ? void 0 : _this$props$activeIte2.case_uid) !== null && _this$props$activeIte !== void 0 ? _this$props$activeIte : (_this$props$match3 = _this.props.match) === null || _this$props$match3 === void 0 || (_this$props$match3 = _this$props$match3.params) === null || _this$props$match3 === void 0 ? void 0 : _this$props$match3.id;
          if (case_uid) {
            _this.props.releaseCaseAccess(case_uid);
            _this.clearTimer();
            _this.props.resetCaseAccess(_this.props.processInstance);
          }
        }
      });
      /**
       * Event that happen when Enter key is pressed on  add charge button
       * @returns {void}
       */
      _defineProperty(_this, "handleKeyDown", function (ev) {
        if (ev.key === 'Enter') {
          ev.preventDefault();
          _this.onModalAddChargeOpen();
        }
      });
      _defineProperty(_this, "onRelatedCasesFilterApply", function (filters) {
        var _this$props$activeIte3, _this$props$activeIte4;
        _this.props.updateRelatedCasesFilterSelection(filters);
        _this.props.getCasesWithEncounter({
          encounterId: (_this$props$activeIte3 = _this.props.activeItem) === null || _this$props$activeIte3 === void 0 || (_this$props$activeIte3 = _this$props$activeIte3.encounter_identifier) === null || _this$props$activeIte3 === void 0 ? void 0 : _this$props$activeIte3.number,
          sortablePageable: _objectSpread$4({}, uiCommon.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
          serviceLine: (_this$props$activeIte4 = _this.props.activeItem) === null || _this$props$activeIte4 === void 0 ? void 0 : _this$props$activeIte4.service_line,
          filterSelection: filters
        });
      });
      _this.onCodeUpdate = _this.onCodeUpdate.bind(_this);
      _this.onCodeRemove = _this.onCodeRemove.bind(_this);
      _this.onTransactionOrderChange = _this.onTransactionOrderChange.bind(_this);
      _this.onTimeBasedCodeAdd = _this.onTimeBasedCodeAdd.bind(_this);
      _this.onTimeBasedCodeUpdate = _this.onTimeBasedCodeUpdate.bind(_this);
      _this.onCodeSearchDrop = _this.onCodeSearchDrop.bind(_this);
      _this.onCodeSearch = _this.onCodeSearch.bind(_this);
      _this.onCodeSearchSelection = _this.onCodeSearchSelection.bind(_this);
      _this.onAddAllCodes = _this.onAddAllCodes.bind(_this);
      _this.onRemoveAllCodes = _this.onRemoveAllCodes.bind(_this);
      _this.createTransactionAndAddCode = _this.createTransactionAndAddCode.bind(_this);
      _this.onFeatureSelection = _this.onFeatureSelection.bind(_this);
      _this.handleGroupedCaseClick = _this.handleGroupedCaseClick.bind(_this);
      _this.handleModalClose = _this.handleModalClose.bind(_this);
      _this.handleInvoiceEdit = _this.handleInvoiceEdit.bind(_this);
      _this.handlePromptDismiss = _this.handlePromptDismiss.bind(_this);
      _this.handleMetaAction = _this.handleMetaAction.bind(_this);
      _this.handleCancel = _this.handleCancel.bind(_this);
      _this.handleSubmit = _this.handleSubmit.bind(_this);
      _this.onModalAddChargeOpen = _this.onModalAddChargeOpen.bind(_this);
      _this.onModalAddChargeClose = _this.onModalAddChargeClose.bind(_this);
      _this.handleAddCharge = _this.handleAddCharge.bind(_this);
      _this.handleTimer = _this.handleTimer.bind(_this);
      _this.handleInvoiceAddition = _this.handleInvoiceAddition.bind(_this);
      _this.handleTransactionSharedDiagnosisChange = _this.handleTransactionSharedDiagnosisChange.bind(_this);
      _this.handleDeleteSizeExpWarning = _this.handleDeleteSizeExpWarning.bind(_this);
      _this.handleEnableTechPro = _this.handleEnableTechPro.bind(_this);
      _this.handleDisableTechPro = _this.handleDisableTechPro.bind(_this);
      _this.caseDetailRef = /*#__PURE__*/React.createRef();
      _this.iframeRef = /*#__PURE__*/React.createRef();
      var codeUpdateDebounced = _this.onCodeUpdate.bind(_this);
      _this.onCodeUpdate = uiCommon.objectUtils.debounce(codeUpdateDebounced, 500);
      _this.handleHARCaseList = _this.handleHARCaseList.bind(_this);
      _this.state = {
        showCaseConflictModal: false,
        conflictingUser: ''
      };
      return _this;
    }
    _inherits(CodeBenchv2, _React$Component);
    return _createClass(CodeBenchv2, [{
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps, prevState, snapshot) {
        var _this$props$match$par2,
          _this$props$match4,
          _this$props$match5,
          _this$props$benchEdit,
          _prevProps$benchEdita,
          _this2 = this,
          _prevProps$benchEdita2,
          _this$props$benchEdit2,
          _prevProps$match,
          _this$props$match6;
        if (!this.props.loadAlwaysFromURL) return;
        // --- ACQUIRE CASE ACCESS ---
        var case_uid = (_this$props$match$par2 = (_this$props$match4 = this.props.match) === null || _this$props$match4 === void 0 || (_this$props$match4 = _this$props$match4.params) === null || _this$props$match4 === void 0 ? void 0 : _this$props$match4.caseId) !== null && _this$props$match$par2 !== void 0 ? _this$props$match$par2 : (_this$props$match5 = this.props.match) === null || _this$props$match5 === void 0 || (_this$props$match5 = _this$props$match5.params) === null || _this$props$match5 === void 0 ? void 0 : _this$props$match5.id;
        var becameEditable = ((_this$props$benchEdit = this.props.benchEditable) === null || _this$props$benchEdit === void 0 ? void 0 : _this$props$benchEdit.editable) && !((_prevProps$benchEdita = prevProps.benchEditable) !== null && _prevProps$benchEdita !== void 0 && _prevProps$benchEdita.editable);
        if (becameEditable && !this.timerStarted) {
          this.props.acquireCaseAccess({
            case_uid: case_uid,
            processInstance: this.props.processInstance,
            callback: function callback(result) {
              if (result !== null && result !== void 0 && result.conflict) {
                var fullName = result !== null && result !== void 0 && result.openedByName ? "".concat(result.openedByName) : 'N/A';
                _this2.setState({
                  showCaseConflictModal: true,
                  conflictingUser: fullName
                });
                return;
              }
              if (result !== null && result !== void 0 && result.success) {
                _this2.startTimer(case_uid);
                _this2.timerStarted = true;
              }
            }
          });
        }
        // --- RELEASE CASE ACCESS ---
        var becameNonEditable = ((_prevProps$benchEdita2 = prevProps.benchEditable) === null || _prevProps$benchEdita2 === void 0 ? void 0 : _prevProps$benchEdita2.editable) && !((_this$props$benchEdit2 = this.props.benchEditable) !== null && _this$props$benchEdit2 !== void 0 && _this$props$benchEdit2.editable);
        if (becameNonEditable && this.timerStarted) {
          this.props.releaseCaseAccess(case_uid);
          this.clearTimer();
          this.props.resetCaseAccess(this.props.processInstance);
        }
        if (((_prevProps$match = prevProps.match) === null || _prevProps$match === void 0 ? void 0 : _prevProps$match.url) !== ((_this$props$match6 = this.props.match) === null || _this$props$match6 === void 0 ? void 0 : _this$props$match6.url)) {
          var _this$props$capabilit, _this$props, _this$props$match7, _this$props$match8;
          this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_this$props$capabilit = (_this$props = this.props) === null || _this$props === void 0 || (_this$props = _this$props.capabilities) === null || _this$props === void 0 || (_this$props = _this$props.capabilities) === null || _this$props === void 0 || (_this$props = _this$props.getCaseRunWithRefresh) === null || _this$props === void 0 ? void 0 : _this$props.on) !== null && _this$props$capabilit !== void 0 ? _this$props$capabilit : false);
          this.props.onLoadFromURLMatch(this.props.match);
          var _case_uid = (_this$props$match7 = this.props.match) === null || _this$props$match7 === void 0 || (_this$props$match7 = _this$props$match7.params) === null || _this$props$match7 === void 0 ? void 0 : _this$props$match7.caseId;
          var caserun_uid = (_this$props$match8 = this.props.match) === null || _this$props$match8 === void 0 || (_this$props$match8 = _this$props$match8.params) === null || _this$props$match8 === void 0 ? void 0 : _this$props$match8.id;
          this.props.loadWorkItemDetails(_case_uid, caserun_uid);
          // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
          this.props.loadServicedeskContext(this.props.cursorAPIContext);
          if (this.props.benchMode == uiCommon.commonEnums.BenchMode.GRADE) {
            this.props.fetchGradePanelConfigurations();
            if (this.props.cursorAPIContext.qaCollectionUuid) {
              this.props.fetchQaRule({
                qaCollectionUuid: this.props.cursorAPIContext.qaCollectionUuid,
                level: 3,
                service: this.props.cursorAPIContext.launchConfigServiceLine
              });
            }
            this.props.fetchWorkerInfoForUser(this.props.userContext);
          }
        }
        if (this.props.benchMode == uiCommon.commonEnums.BenchMode.GRADE) {
          if (prevProps.gradeableInvoices !== this.props.gradeableInvoices) {
            this.props.fetchGraderWorkItemActivity(this.props.match.params.id);
          }
        }
        if (prevProps.userContext !== this.props.userContext) {
          var _this$props2, _this$props3, _this$props$userConte;
          var serviceLine = uiCommon.appServiceLines.isIPC((_this$props2 = this.props) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.match) === null || _this$props2 === void 0 || (_this$props2 = _this$props2.params) === null || _this$props2 === void 0 ? void 0 : _this$props2.serviceLine) ? 'Inpatient Professional Coding' : (_this$props3 = this.props) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.match) === null || _this$props3 === void 0 || (_this$props3 = _this$props3.params) === null || _this$props3 === void 0 ? void 0 : _this$props3.serviceLine;
          this.props.fetchCoderConfig({
            section: uiCommon.commonEnums.ConfigurationSection.CODER_CONFIG,
            serviceLine: serviceLine,
            //@ts-ignore TODO: active tenantId appears to be mapped to userContext
            tenantId: (_this$props$userConte = this.props.userContext) === null || _this$props$userConte === void 0 ? void 0 : _this$props$userConte.tenantId
          });
        }
      }
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.props.loadRoles(this.props.roles);
        var hasActiveItem = !uiCommon.objectUtils.isEmpty(this.props.activeItem);
        var case_uid = '',
          caserun_uid = '';
        if (this.props.loadAlwaysFromURL || !hasActiveItem) {
          var _this$props$capabilit2, _this$props4, _this$props$match9, _this$props$match0;
          this.props.match.params.getCaserunWithRefresh = conditionalUtils.capabilityValue((_this$props$capabilit2 = (_this$props4 = this.props) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.capabilities) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.capabilities) === null || _this$props4 === void 0 || (_this$props4 = _this$props4.getCaseRunWithRefresh) === null || _this$props4 === void 0 ? void 0 : _this$props4.on) !== null && _this$props$capabilit2 !== void 0 ? _this$props$capabilit2 : false);
          this.props.onLoadFromURLMatch(this.props.match);
          case_uid = (_this$props$match9 = this.props.match) === null || _this$props$match9 === void 0 || (_this$props$match9 = _this$props$match9.params) === null || _this$props$match9 === void 0 ? void 0 : _this$props$match9.caseId;
          caserun_uid = (_this$props$match0 = this.props.match) === null || _this$props$match0 === void 0 || (_this$props$match0 = _this$props$match0.params) === null || _this$props$match0 === void 0 ? void 0 : _this$props$match0.id;
        } else {
          this.props.onLoad(this.props.activeItem);
          case_uid = this.props.activeItem.case_uid;
          caserun_uid = this.props.activeItem.caserun_uid;
        }
        this.props.loadWorkItemDetails(case_uid, caserun_uid);

        // Loads cursorAPIContext from connected props(from dashboard-ui) to capabilities state(shared-views)
        this.props.loadServicedeskContext(this.props.cursorAPIContext);
        if (this.props.benchMode == uiCommon.commonEnums.BenchMode.GRADE) {
          this.props.fetchGradePanelConfigurations();
          if (this.props.cursorAPIContext.qaCollectionUuid) {
            this.props.fetchQaRule({
              qaCollectionUuid: this.props.cursorAPIContext.qaCollectionUuid,
              level: 3,
              service: this.props.cursorAPIContext.launchConfigServiceLine
            });
          }
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload);
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        this.cleanupCaseAccess();
      }
    }, {
      key: "clearTimer",
      value: function clearTimer() {
        if (this.timerId) {
          clearInterval(this.timerId);
          this.timerId = null;
          this.timerStarted = false;
        }
      }
    }, {
      key: "handleCancel",
      value: function handleCancel(event) {
        event.preventDefault();
        this.props.onInvoicesCancel(this.props.processInstance);
      }
    }, {
      key: "handleSubmit",
      value: function handleSubmit(event) {
        var _this$props$capabilit3, _this$props$capabilit4;
        var vwComment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var submitWithOverrideButton = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var remove_hold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        event.preventDefault();
        var cursorAPIPayload = {
          operation: uiCommon.commonEnums.CursorOperation.NEXT,
          cursorAPIContext: this.props.cursorAPIContext,
          hasAmplifyCaseRunV2Access: conditionalUtils.capabilityValue((_this$props$capabilit3 = (_this$props$capabilit4 = this.props.capabilities.capabilities.amplifyCaseRunV2) === null || _this$props$capabilit4 === void 0 ? void 0 : _this$props$capabilit4.on) !== null && _this$props$capabilit3 !== void 0 ? _this$props$capabilit3 : false)
        };
        this.props.onInvoicesSubmisson({
          processInstance: this.props.processInstance,
          uiMode: this.props.UIMode,
          vwComment: vwComment,
          submitWithOverrideButton: submitWithOverrideButton,
          cursorAPIPayload: cursorAPIPayload,
          activeItem: this.props.activeItem,
          removeHold: remove_hold
        });
      }
    }, {
      key: "handlePreviousClick",
      value: function handlePreviousClick(event) {
        event.preventDefault();
        var _this$props5 = this.props,
          processInstanceGuids = _this$props5.processInstanceGuids,
          activeItem = _this$props5.activeItem;
        var loc = processInstanceGuids.findIndex(function (item) {
          return item === activeItem.process_instance_guid;
        });
        this.props.handleTraversal(processInstanceGuids[loc - 1]);
      }
    }, {
      key: "handleModalClose",
      value: function handleModalClose(ev) {
        ev.preventDefault();
        this.props.onPopUpClose();
      }
    }, {
      key: "handlePromptDismiss",
      value: function handlePromptDismiss(ev) {
        ev.preventDefault();
        this.props.onPrompt('REFRESH_TOKEN');
      }
    }, {
      key: "handleConfirm",
      value: function handleConfirm(actionItem) {
        this.props.onPopUpClose();
      }
    }, {
      key: "handleConfirmDismiss",
      value: function handleConfirmDismiss(actionItem) {
        this.props.onPopUpClose();
      }
    }, {
      key: "handleInvoiceEdit",
      value: function handleInvoiceEdit(invoice) {
        this.props.onInvoiceEdit(invoice, this.props.processInstance);
      }
    }, {
      key: "handleInvoiceAddition",
      value: function handleInvoiceAddition(invoices) {
        this.props.onInvoiceAddition(invoices && invoices.length > 0 ? invoices[0] : null, this.props.processInstance);
      }
    }, {
      key: "handleMetaAction",
      value: function handleMetaAction(transactionAction) {
        var invoice = this.props.codableInvoices.find(function (invoice) {
          return invoice.guid === transactionAction.meta.invoice.guid;
        });
        this.props.onChargeSessionAction(_objectSpread$4(_objectSpread$4({}, transactionAction), {}, {
          meta: _objectSpread$4(_objectSpread$4({}, transactionAction.meta), {}, {
            invoice: invoice,
            processInstance: this.props.processInstance
          })
        }));
      }
    }, {
      key: "handleGroupedCaseClick",
      value: function handleGroupedCaseClick(ev) {
        ev.preventDefault();
        var target = ev.target || document.createElement('div');
        var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
        if (!linkable) return;
        var item = linkable.attributes.getNamedItem('data-case-id');
        if (!item) return;
        var caseId = item.value;
        if (!caseId) return;
        var hostCaseId = this.props.hostCaseId ? this.props.hostCaseId : this.props.activeItem.case_id;
        var replace = hostCaseId !== this.props.activeItem.case_id;
        this.props.onPopUpNavigate({
          caseId: item.value,
          replace: replace,
          serviceLine: this.props.activeItem.service_line,
          hostCaseId: hostCaseId
        });
      }
    }, {
      key: "onFeatureSelection",
      value: function onFeatureSelection(selection) {
        this.props.onFeatureActivation(selection);
        this.caseDetailRef.current.onFeatureActivation(selection);
      }
      // The CodeQuery, SearchResult, and CodeChange all rely on a common
      // property called context.  This is what will allow business
      // logic upstream to have standard patterns for figuring out what to do
      // with various actions.
    }, {
      key: "onCodeSearch",
      value: function onCodeSearch(commonCodeQuery) {
        var context = _objectSpread$4(_objectSpread$4({}, commonCodeQuery.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          userContext: _objectSpread$4({}, this.props.userContext)
        });
        var codeQuery = _objectSpread$4(_objectSpread$4({}, commonCodeQuery), {}, {
          context: context
        });
        var isMod = codeQuery.searchType === uiCommon.commonEnums.CodeType.MODIFIER;
        if (isMod) {
          codeQuery.text = "".concat(codeQuery.text).toUpperCase();
        }
        //
        if (codeQuery.text.length > 2 || codeQuery.text.length === 2 && isMod) {
          this.props.onCodeSearch(codeQuery);
        }
      }
    }, {
      key: "onCodeSearchSelection",
      value: function onCodeSearchSelection(commonSearchResult) {
        var _commonSearchResult$c, _commonSearchResult$c2;
        if (uiCommon.objectUtils.isEmpty(commonSearchResult)) {
          return;
        }
        var defaultPrevented = (_commonSearchResult$c = (_commonSearchResult$c2 = commonSearchResult.context) === null || _commonSearchResult$c2 === void 0 ? void 0 : _commonSearchResult$c2.defaultPrevented) !== null && _commonSearchResult$c !== void 0 ? _commonSearchResult$c : false;
        if (defaultPrevented) {
          this.props.onSearchClear({
            context: _objectSpread$4(_objectSpread$4({}, commonSearchResult.context), {}, {
              activeItem: this.props.activeItem
            })
          });
        } else {
          var context = _objectSpread$4(_objectSpread$4({}, commonSearchResult.context), {}, {
            activeItem: _objectSpread$4({}, this.props.activeItem),
            invoices: _toConsumableArray(this.props.codableInvoices)
          });
          var searchResult = {
            codeInfo: commonSearchResult.codeInfo,
            additionalCodes: commonSearchResult.additionalCodes,
            context: context
          };
          this.props.onCodeSearchSelection(searchResult);
        }
      }
    }, {
      key: "onAddAllCodes",
      value: function onAddAllCodes(commonSearchResult) {
        var _commonSearchResult$c3, _commonSearchResult$c4;
        if (uiCommon.objectUtils.isEmpty(commonSearchResult === null || commonSearchResult === void 0 ? void 0 : commonSearchResult.codesInfo)) {
          return;
        }
        var defaultPrevented = (_commonSearchResult$c3 = (_commonSearchResult$c4 = commonSearchResult.context) === null || _commonSearchResult$c4 === void 0 ? void 0 : _commonSearchResult$c4.defaultPrevented) !== null && _commonSearchResult$c3 !== void 0 ? _commonSearchResult$c3 : false;
        if (defaultPrevented) {
          this.props.onSearchClear({
            context: _objectSpread$4(_objectSpread$4({}, commonSearchResult.context), {}, {
              activeItem: this.props.activeItem
            })
          });
        } else {
          var context = _objectSpread$4(_objectSpread$4({}, commonSearchResult.context), {}, {
            activeItem: _objectSpread$4({}, this.props.activeItem),
            invoices: _toConsumableArray(this.props.codableInvoices)
          });
          var searchResult = {
            codesInfo: commonSearchResult.codesInfo,
            context: context
          };
          this.props.handleAddAllCodes(searchResult);
        }
      }
    }, {
      key: "createTransactionAndAddCode",
      value: function createTransactionAndAddCode(commonSearchResult) {
        if (uiCommon.objectUtils.isEmpty(commonSearchResult)) {
          return;
        }
        var context = _objectSpread$4(_objectSpread$4({}, commonSearchResult.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var searchResult = {
          codeInfo: commonSearchResult.codeInfo,
          additionalCodes: commonSearchResult.additionalCodes,
          context: context
        };
        this.props.createTransactionAndAddCode(searchResult);
      }
    }, {
      key: "onCodeUpdate",
      value: function onCodeUpdate(commonChangeDetail) {
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeUpdate(changeDetail);
      }
    }, {
      key: "onCodeRemove",
      value: function onCodeRemove(commonChangeDetail) {
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeRemove(changeDetail);
      }
    }, {
      key: "onRemoveAllCodes",
      value: function onRemoveAllCodes(commonChangeDetail) {
        if (uiCommon.objectUtils.isEmpty(commonChangeDetail === null || commonChangeDetail === void 0 ? void 0 : commonChangeDetail.codes)) {
          return;
        }
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.handleRemoveAllCodes(changeDetail);
      }
    }, {
      key: "onTimeBasedCodeAdd",
      value: function onTimeBasedCodeAdd(commonChangeDetail, time, age) {
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var codeChange = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onTimeBasedCodeAdd(codeChange, time, age);
      }
    }, {
      key: "onTimeBasedCodeUpdate",
      value: function onTimeBasedCodeUpdate(commonChangeDetail, time, age) {
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var codeChange = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onTimeBasedCodeUpdate(codeChange, time, age);
      }
    }, {
      key: "onTransactionOrderChange",
      value: function onTransactionOrderChange(transactionReorderDetail) {
        this.props.onTransactionOrderChange(transactionReorderDetail);
      }
    }, {
      key: "onCodeSearchDrop",
      value: function onCodeSearchDrop(commonChangeDetail) {
        var context = _objectSpread$4(_objectSpread$4({}, commonChangeDetail.context), {}, {
          activeItem: _objectSpread$4({}, this.props.activeItem),
          invoices: _toConsumableArray(this.props.codableInvoices)
        });
        var changeDetail = _objectSpread$4(_objectSpread$4({}, commonChangeDetail), {}, {
          context: context
        });
        this.props.onCodeSearchDrop(changeDetail);
      }
    }, {
      key: "handleTransactionSharedDiagnosisChange",
      value: function handleTransactionSharedDiagnosisChange(changeDetail) {
        this.props.onTransactionSharedDiagnosisChange(changeDetail);
      }
    }, {
      key: "handleHARCaseList",
      value: function handleHARCaseList(options) {
        var _this$props$activeIte5, _this$props$activeIte6;
        this.props.getCasesWithEncounter({
          encounterId: (_this$props$activeIte5 = this.props.activeItem) === null || _this$props$activeIte5 === void 0 || (_this$props$activeIte5 = _this$props$activeIte5.encounter_identifier) === null || _this$props$activeIte5 === void 0 ? void 0 : _this$props$activeIte5.number,
          sortablePageable: options,
          serviceLine: (_this$props$activeIte6 = this.props.activeItem) === null || _this$props$activeIte6 === void 0 ? void 0 : _this$props$activeIte6.service_line,
          filterSelection: this.props.relatedCasesFilterSelection
        });
      }

      /**
       * Event that happen when click add charge button
       * @returns {void}
       */
    }, {
      key: "onModalAddChargeOpen",
      value: function onModalAddChargeOpen() {
        this.props.onModalAddChargeOpen();
      }
    }, {
      key: "onModalAddChargeClose",
      value:
      /**
       * Event that happen when moda of add charge button is closed
       * @returns {void}
       */
      function onModalAddChargeClose(e) {
        this.props.onModalAddChargeClose(e);
      }

      /**
       * Event launched when invoice is clicked
       */
    }, {
      key: "handleAddCharge",
      value: function handleAddCharge(invoice) {
        if (invoice.deleted) {
          this.handleInvoiceAddition([invoice]);
        } else {
          this.props.handleAddCharge({
            invoiceGuid: invoice.guid,
            processInstanceId: this.props.processInstance.guid.uuid,
            activeItem: this.props.activeItem
          });
        }
      }

      /**
       * Method that is called for decrement timer
       */
    }, {
      key: "handleTimer",
      value: function handleTimer() {
        this.props.handleTimer();
      }

      /**
       * Method that is called when user wants to close the modal for size experience warning
       */
    }, {
      key: "handleDeleteSizeExpWarning",
      value: function handleDeleteSizeExpWarning() {
        this.props.deleteSizeExpWarning();
      }

      /**
       * Method used for enable a procedure with tech/pro charge
       * @param context
       */
    }, {
      key: "handleEnableTechPro",
      value: function handleEnableTechPro(techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleEnableTechPro(techCodableTransaction);
      }

      /**
       * Method used for disable a procedure with tech/pro charge
       * @param context
       */
    }, {
      key: "handleDisableTechPro",
      value: function handleDisableTechPro(techCodableTransaction) {
        techCodableTransaction.processInstance = this.props.processInstance;
        this.props.handleDisableTechPro(techCodableTransaction);
      }
    }, {
      key: "render",
      value: function render() {
        var _caseVersions$findInd,
          _this$props$capabilit5,
          _this3 = this,
          _selectedWorkitem$dat,
          _selectedWorkitem$dat2,
          _invoiceOptions$invoi,
          _this$props$improveme;
        var _this$props6 = this.props;
          _this$props6.nonCodeBench;
          _this$props6.chargeSessions;
          var counts = _this$props6.counts,
          searchResults = _this$props6.searchResults,
          codeSearchResultsV2 = _this$props6.codeSearchResultsV2,
          benchEditable = _this$props6.benchEditable,
          processInstance = _this$props6.processInstance,
          activations = _this$props6.activations,
          groupedCases = _this$props6.groupedCases,
          modalURL = _this$props6.modalURL,
          hostCaseId = _this$props6.hostCaseId;
          _this$props6.onChargeSessionAction;
          var activity = _this$props6.activity,
          prompt = _this$props6.prompt,
          confirm = _this$props6.confirm,
          showSubmittedFeedback = _this$props6.showSubmittedFeedback,
          showLoadingSubmission = _this$props6.showLoadingSubmission,
          showLoadingCancelation = _this$props6.showLoadingCancelation,
          showSizeExpWarning = _this$props6.showSizeExpWarning,
          showCanceledFeedback = _this$props6.showCanceledFeedback,
          submittedFeedbackTimer = _this$props6.submittedFeedbackTimer,
          showvitalwareIssuesModal = _this$props6.showvitalwareIssuesModal;
          _this$props6.toggleHoldCaseModal;
          _this$props6.toggleExclusionCaseModal;
          _this$props6.showLateCaseClearModal;
          _this$props6.toggleSplitCaseModal;
          var vitalwareIssues = _this$props6.vitalwareIssues,
          mergeSplitHistoryIssues = _this$props6.mergeSplitHistoryIssues,
          documentImprovementIssues = _this$props6.documentImprovementIssues,
          holdIssues = _this$props6.holdIssues;
          _this$props6.hidevitalwareIssuesModal;
          var displayAddCharge = _this$props6.displayAddCharge,
          showAddChargeError = _this$props6.showAddChargeError,
          showAddChargeLoading = _this$props6.showAddChargeLoading,
          loadState = _this$props6.loadState,
          codableInvoices = _this$props6.codableInvoices,
          feedback = _this$props6.feedback,
          showFeedBack = _this$props6.showFeedBack,
          UIMode = _this$props6.UIMode,
          epicToken = _this$props6.epicToken,
          codeEdits = _this$props6.codeEdits,
          invoiceOptions = _this$props6.invoiceOptions,
          caseEdits = _this$props6.caseEdits;
          _this$props6.showHoldCaseModal;
          _this$props6.hideHoldCaseModal;
          _this$props6.showExclusionCaseModal;
          _this$props6.hideExclusionCaseModal;
          _this$props6.toggleLateCaseClearModal;
          _this$props6.clearLateCaseNotification;
          _this$props6.toggleChargeableCase;
          _this$props6.holdCase;
          _this$props6.improvements;
          var capabilities = _this$props6.capabilities,
          updateValue = _this$props6.updateValue,
          updateCase = _this$props6.updateCase,
          relatedCases = _this$props6.relatedCases,
          relatedCasesPageable = _this$props6.relatedCasesPageable,
          flagList = _this$props6.flagList;
          _this$props6.htmlNotes;
          _this$props6.customClaimsRelatedCases;
          _this$props6.customClaimsRelatedCasesLoadState;
          _this$props6.organization;
          var benchMode = _this$props6.benchMode,
          caseVersions = _this$props6.caseVersions,
          gradeableInvoices = _this$props6.gradeableInvoices,
          fieldDefinitions = _this$props6.fieldDefinitions,
          riskCategories = _this$props6.riskCategories,
          cqaCodeAssessmentRiskDictionaries = _this$props6.cqaCodeAssessmentRiskDictionaries,
          onGradeUpdate = _this$props6.onGradeUpdate,
          onGradeRemove = _this$props6.onGradeRemove,
          onCodeEvent = _this$props6.onCodeEvent,
          onCreateCQATransaction = _this$props6.onCreateCQATransaction,
          onDeleteCQATransaction = _this$props6.onDeleteCQATransaction,
          workItem = _this$props6.workItem,
          suggestedCodes = _this$props6.suggestedCodes,
          associatedWorkitems = _this$props6.associatedWorkitems,
          loadAssociatedWorkItem = _this$props6.loadAssociatedWorkItem,
          caseDetailProps = _objectWithoutProperties(_this$props6, _excluded);
        function handleOpenCase(processInstanceGuid, caseUid) {
          if (processInstanceGuid) {
            var _caseDetailProps$acti, _caseDetailProps$acti2, _caseDetailProps$acti3;
            var childWindowParams = getChildWindowParams(caseUid !== null && caseUid !== void 0 ? caseUid : (_caseDetailProps$acti = caseDetailProps.activeItem) === null || _caseDetailProps$acti === void 0 ? void 0 : _caseDetailProps$acti.case_uid, processInstanceGuid, (_caseDetailProps$acti2 = caseDetailProps.activeItem) === null || _caseDetailProps$acti2 === void 0 ? void 0 : _caseDetailProps$acti2.service_line, launchAmplifyCase, (_caseDetailProps$acti3 = caseDetailProps.activeItem) === null || _caseDetailProps$acti3 === void 0 ? void 0 : _caseDetailProps$acti3.case_id);
            caseDetailProps.openChildWindow(childWindowParams);
          }
        }
        var currentVersionPosition = (_caseVersions$findInd = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.findIndex(function (caseVersion) {
          var _processInstance$guid;
          return caseVersion.processInstanceGuid === (processInstance === null || processInstance === void 0 || (_processInstance$guid = processInstance.guid) === null || _processInstance$guid === void 0 ? void 0 : _processInstance$guid.uuid);
        })) !== null && _caseVersions$findInd !== void 0 ? _caseVersions$findInd : -1;
        var previousVersions = caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.filter(function (_, index) {
          return index < currentVersionPosition;
        });
        var previousSentCase = previousVersions === null || previousVersions === void 0 ? void 0 : previousVersions.find(function (previousVersion) {
          return previousVersion.processInstanceStatus === AccelerateProcessStatus.SUBMITTED || previousVersion.processInstanceStatus === AccelerateProcessStatus.CANCELLED || previousVersion.processInstanceStatus === AccelerateProcessStatus.SENT;
        });
        var newestVersionObject = (caseVersions === null || caseVersions === void 0 ? void 0 : caseVersions.length) > 0 ? caseVersions.slice().reverse().find(function (caseVersion) {
          var _caseVersion$processI;
          return ((_caseVersion$processI = caseVersion.processInstanceStatus) === null || _caseVersion$processI === void 0 ? void 0 : _caseVersion$processI.indexOf('REPLACED')) < 0;
        }) : null;
        Array.from(new Set(flagList === null || flagList === void 0 ? void 0 : flagList.map(function (flag) {
          return flag === null || flag === void 0 ? void 0 : flag.flag;
        })));
        var submitHandler = null;
        if (benchMode == uiCommon.commonEnums.BenchMode.GRADE) {
          var updatedStatus = 'CQA_COMPLETE';
          if (gradeableInvoices.length > 0 && gradeableInvoices[0].status == 'CQA_COMPLETE') {
            updatedStatus = 'CQA_APPROVED';
          }
          submitHandler = createSubmitCQAWorkItemHandler(this.props.cursorAPIContext, this.props.submitCQAWorkitem, updatedStatus, this.releaseCurrentCaseAccess);
        } else {
          var _capabilities$capabil, _capabilities$capabil2;
          submitHandler = createSubmitCaseHandler(UIMode, this.props.onInvoicesSubmisson, this.props.processInstance, this.props.cursorAPIContext, this.props.caseAccessTime, this.props.activeItem, this.props.getCaseVersions, this.props.toggleSubmitOldCaseModal, conditionalUtils.capabilityValue((_capabilities$capabil = (_capabilities$capabil2 = capabilities.capabilities.amplifyCaseRunV2) === null || _capabilities$capabil2 === void 0 ? void 0 : _capabilities$capabil2.on) !== null && _capabilities$capabil !== void 0 ? _capabilities$capabil : false), this.releaseCurrentCaseAccess);
        }
        var actionBarSelectMultipleWorkitems = conditionalUtils.capabilityValue((_this$props$capabilit5 = this.props.capabilities) === null || _this$props$capabilit5 === void 0 || (_this$props$capabilit5 = _this$props$capabilit5.capabilities) === null || _this$props$capabilit5 === void 0 || (_this$props$capabilit5 = _this$props$capabilit5.actionBarSelectMultipleWorkitems) === null || _this$props$capabilit5 === void 0 ? void 0 : _this$props$capabilit5.on);
        var onCursorActionHandler = this.props.onCursorAction;
        if (benchMode == uiCommon.commonEnums.BenchMode.GRADE && actionBarSelectMultipleWorkitems) {
          onCursorActionHandler = function onCursorActionHandler(cursorAPIPayload) {
            if (associatedWorkitems && associatedWorkitems.length > 0) {
              var workitemId = associatedWorkitems[associatedWorkitems.length - 1].data.case_id;
              cursorAPIPayload.cursorAPIContext.workitemId = workitemId;
              _this3.props.onCursorAction(cursorAPIPayload);
            }
          };
        } else {
          // Wrap the original onCursorAction to release case access before navigation
          onCursorActionHandler = function onCursorActionHandler(cursorAPIPayload) {
            // Release current case access before navigating to next case
            _this3.releaseCurrentCaseAccess();

            // Call the original onCursorAction
            _this3.props.onCursorAction(cursorAPIPayload);
          };
        }
        var _getSelectedWorkitemF = getSelectedWorkitemFromInvoice(this.props.cursorAPIContext, associatedWorkitems),
          _getSelectedWorkitemF2 = _slicedToArray(_getSelectedWorkitemF, 2),
          selectedWorkitem = _getSelectedWorkitemF2[0],
          selectedWorkitemIndex = _getSelectedWorkitemF2[1];
        var groupedWorkitems = GroupWorkitemsByStatus(associatedWorkitems);
        var workitemSelectorProps = {
          items: groupedWorkitems,
          selectedItem: selectedWorkitem,
          getItemLabel: function getItemLabel(item) {
            return renderWorkItemLabel(item);
          },
          onItemSelect: function onItemSelect(item) {
            return loadAssociatedWorkItem(_this3.props.cursorAPIContext, item);
          },
          renderItem: function renderItem(item) {
            return renderWorkitemInItemSelector(item);
          },
          buttonLabel: selectedWorkitem !== null && selectedWorkitem !== void 0 && (_selectedWorkitem$dat = selectedWorkitem.data) !== null && _selectedWorkitem$dat !== void 0 && _selectedWorkitem$dat.assignee ? "".concat(selectedWorkitem === null || selectedWorkitem === void 0 || (_selectedWorkitem$dat2 = selectedWorkitem.data) === null || _selectedWorkitem$dat2 === void 0 ? void 0 : _selectedWorkitem$dat2.assignee) : 'Select Workitem',
          prefixTitle: '',
          className: 'action-bar-item-selector',
          disabled: false,
          disableWhenSingle: false,
          isSelected: isWorkitemSelected,
          secondaryLabel: "".concat(selectedWorkitemIndex + 1, " of ").concat(associatedWorkitems.length),
          isGrouped: true
        };
        var actionBar =
        /*#__PURE__*/
        //@ts-ignore
        React.createElement(CodeBenchActionBarv2, _extends$1({}, this.props, {
          handleSubmitCase: submitHandler,
          itemSelectorProps: actionBarSelectMultipleWorkitems && associatedWorkitems.length > 0 ? workitemSelectorProps : undefined,
          onCursorAction: onCursorActionHandler,
          onNextVersion: this.props.onCursorAction,
          conflictingUser: this.state.conflictingUser,
          caseAccessState: this.props.caseAccessState
        }));
        var codeEditingPanel;
        var relatedCasesView;
        var isActive = !uiCommon.caseUtils.isFinishedCase(caseDetailProps.activeItem);
        if (showSubmittedFeedback || showCanceledFeedback) {
          if (submittedFeedbackTimer) {
            window.parent.postMessage({
              action: 'Epic.Clinical.Informatics.Web.CloseActivity',
              token: epicToken
            }, '*');
          } else {
            this.handleTimer();
          }
        }
        var showProcessStatus = !benchEditable.editable;
        var showModal = modalURL !== null && modalURL.path;
        var modalURI = showModal ? modalURL.path + modalURL.queryString : '';
        var benchLoading = loadState.loading;
        var invoices = (_invoiceOptions$invoi = invoiceOptions === null || invoiceOptions === void 0 ? void 0 : invoiceOptions.invoices) !== null && _invoiceOptions$invoi !== void 0 ? _invoiceOptions$invoi : [];
        var hasStatusReason = uiCommon.caseUtils.getStatusReason(caseDetailProps.activeItem);
        var styles = classnames(['code-benchv2', {
          'bench-pre-editable': benchEditable.waiting,
          'bench-cancelled': benchEditable.cancelled,
          'bench-loading': benchLoading
        }]);
        if (benchEditable.waiting) {
          codeEditingPanel = /*#__PURE__*/React.createElement(ProcessStatus, {
            benchEditable: benchEditable
          });
        } else {
          var _capabilities$capabil3, _this$props$resolverV, _this$props$processIn, _this$props$activeIte7, _this$props$activeIte8, _this$props$activeIte9;
          var noCodableInvoices = codableInvoices === null || codableInvoices.length === 0;
          var noGradeableInvoice = gradeableInvoices == null || gradeableInvoices.length === 0;
          var noCharges = noCodableInvoices && noGradeableInvoice;
          var summarySection = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            key: "charge-totals",
            className: "summary-section"
          }, /*#__PURE__*/React.createElement("h5", null, "Summary"), /*#__PURE__*/React.createElement(ChargeCounts, {
            counts: counts
          })));
          var panel = benchMode == uiCommon.commonEnums.BenchMode.CODE ? /*#__PURE__*/React.createElement(CodeBenchPanelv2, {
            key: "code-bench-panel",
            panelActivations: activations.panel,
            onChargeSessionAction: this.handleMetaAction,
            onFeatureSelection: this.onFeatureSelection,
            editable: benchEditable.editable,
            benchEditable: benchEditable,
            caseDetailProps: caseDetailProps,
            searchResults: searchResults,
            codeSearchResultsV2: codeSearchResultsV2,
            benchLoading: benchLoading,
            codeEdits: codeEdits,
            onInvoiceMetaEdit: this.handleInvoiceEdit,
            onCodeSearchSelection: this.onCodeSearchSelection,
            handleAddAllCodes: this.onAddAllCodes,
            handleRemoveAllCodes: this.onRemoveAllCodes,
            createTransactionAndAddCode: this.createTransactionAndAddCode,
            onCodeSearch: this.onCodeSearch,
            onCodeUpdate: this.onCodeUpdate,
            onCodeRemove: this.onCodeRemove,
            onTimeBasedCodeAdd: this.onTimeBasedCodeAdd,
            onTimeBasedCodeUpdate: this.onTimeBasedCodeUpdate,
            onCodeSearchDrop: this.onCodeSearchDrop,
            onTransactionSharedDiagnosisChange: this.handleTransactionSharedDiagnosisChange,
            counts: counts,
            processInstance: processInstance,
            codableInvoices: codableInvoices,
            showProcessStatus: showProcessStatus,
            handleEnableTechPro: this.handleEnableTechPro,
            handleDisableTechPro: this.handleDisableTechPro,
            customClaimsRelatedCases: this.props.customClaimsRelatedCases,
            customClaimsRelatedCasesLoadState: this.props.customClaimsRelatedCasesLoadState,
            openChildWindow: this.props.openChildWindow,
            handleInvoiceAddition: function handleInvoiceAddition() {
              return _this3.handleInvoiceAddition(invoices);
            },
            onInvoiceRemove: this.props.onInvoiceRemove,
            summarySection: summarySection,
            transactionV2: conditionalUtils.capabilityValue((_capabilities$capabil3 = capabilities.capabilities.transactionV2) === null || _capabilities$capabil3 === void 0 ? void 0 : _capabilities$capabil3.on),
            suggestedCodes: suggestedCodes,
            onTransactionOrderChange: this.onTransactionOrderChange
          }) : /*#__PURE__*/React.createElement(GradeBenchPanelGeneralized, {
            key: "grade-bench-panel",
            invoiceMetadataFields: InvoiceMetadataFormFieldsCQA,
            cptFields: fieldDefinitions.cptFields,
            icdFields: fieldDefinitions.icdFields,
            modifierFields: fieldDefinitions.modifierFields,
            gradeableInvoices: gradeableInvoices,
            onCodeUpdate: onGradeUpdate,
            onCodeRemove: onGradeRemove,
            onCodeEvent: onCodeEvent,
            codeSearch: {
              onCodeSearch: this.onCodeSearch,
              //Code search selection and drop are disabled for now, until gradebench gets its own codeUpdate actions
              onCodeSearchSelection: this.onCodeSearchSelection,
              onCodeSearchDrop: function onCodeSearchDrop() {},
              searchResults: searchResults
            },
            onCreateCQATransaction: onCreateCQATransaction,
            onDeleteCQATransaction: onDeleteCQATransaction,
            projectConfiguration: this.props.qaRuleCollection.project_configuration,
            riskCategories: riskCategories,
            cqaCodeAssessmentRiskDictionaries: cqaCodeAssessmentRiskDictionaries,
            gradingErrors: this.props.gradingErrors,
            resolverValidationErrors: (_this$props$resolverV = this.props.resolverValidationErrors) !== null && _this$props$resolverV !== void 0 ? _this$props$resolverV : null,
            editable: benchEditable === null || benchEditable === void 0 ? void 0 : benchEditable.editable
          });
          var innerBench = noCodableInvoices && codableInvoices === null || loadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            key: "loading-slugs",
            numberItems: 3
          }) : [noCharges ? /*#__PURE__*/React.createElement("div", {
            className: "no-charges empty-message"
          }, "No charges found.") : panel];
          if (uiCommon.AmplifyCore.isIPCServiceline(this.props.activeItem.service_line)) {
            relatedCasesView = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StandalonePageableList, {
              list: this.handleHARCaseList,
              sortablePageable: relatedCasesPageable,
              theme: 'cmx-theme'
            }, /*#__PURE__*/React.createElement(RelatedCases, {
              relatedCases: relatedCases,
              showLoading: benchLoading || caseDetailProps.relatedCasesLoadState.loading,
              activeItem: this.props.activeItem,
              onOpenRelatedCase: this.props.openChildWindow,
              showProviderInfo: this.props.showProviderInfo,
              filterData: this.props.filterData,
              relatedCasesFilterSelection: this.props.relatedCasesFilterSelection,
              onRelatedCasesFilterApply: this.onRelatedCasesFilterApply,
              relatedCasesFilterCapability: capabilities.capabilities.relatedCasesFilter
            })));
          } else {
            relatedCasesView = /*#__PURE__*/React.createElement(React.Fragment, null, benchLoading || caseDetailProps.billingGroupLoadState.loading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
              key: "loading-slugs",
              numberItems: 1
            }) : /*#__PURE__*/React.createElement("div", {
              className: "status-section",
              onClick: this.handleGroupedCaseClick
            }, /*#__PURE__*/React.createElement(BillingGroup, {
              suppressedLinks: [hostCaseId],
              showProcessStatus: true,
              isActive: isActive,
              cancelled: benchEditable.cancelled,
              groupedCases: groupedCases,
              showLoading: caseDetailProps.billingGroupLoadState.loading,
              viewOnly: !benchEditable.editable
            })));
          }
          codeEditingPanel = [/*#__PURE__*/React.createElement(React.Fragment, null, benchMode == uiCommon.commonEnums.BenchMode.GRADE ? /*#__PURE__*/React.createElement(PurposeAndGuideline, {
            purpose: this.props.qaRuleCollection.sampleReason,
            guideline: this.props.qaRuleCollection.guideline
          }) : /*#__PURE__*/React.createElement("div", {
            className: "status-area conditional-view ".concat(!hasStatusReason ? 'default-display-none-on-false' : '')
          }, /*#__PURE__*/React.createElement("div", {
            className: "status-section case-status-section"
          }, benchLoading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            key: "loading-slugs",
            numberItems: 1
          }) : /*#__PURE__*/React.createElement(StatusDescription, {
            secondaryPrefix: "Review Required",
            includeBox: true,
            caseRun: caseDetailProps.activeItem
          }))), benchLoading ? /*#__PURE__*/React.createElement(uiComponents.LoadingSlugs, {
            key: "loading-slugs",
            numberItems: 2
          }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [!!((_this$props$processIn = this.props.processInstance) !== null && _this$props$processIn !== void 0 && _this$props$processIn.areCodesCopied)]
          }, /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: CaseAlertType.INFO
          }, "This case has been updated with a new version since submission from your coder. We haven\u2019t changed any of their work; however, you may want to review the case and see if changes are required because of the updated information.")), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [hasLedgerUpdates(this.props.processInstance)]
          }, /*#__PURE__*/React.createElement("div", {
            className: "reference-update-banner"
          }, /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: CaseAlertType.WARNING
          }, /*#__PURE__*/React.createElement("div", {
            className: "reference-update-alert"
          }, /*#__PURE__*/React.createElement("div", {
            className: "reference-update-alert-header"
          }, /*#__PURE__*/React.createElement("strong", null, "New information available!")), /*#__PURE__*/React.createElement("div", null, "Reference codes for this case have changed. We suggest double checking the codes in the Codes Source tab to see if you need to make changes because of an updated source set or prediction set."))))), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.previousSentCaseAlert, /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: CaseAlertType.ERROR
          }, "This is an update to a", ' ', /*#__PURE__*/React.createElement("a", {
            className: "anchor-chakra-link",
            onClick: function onClick() {
              return handleOpenCase(previousSentCase === null || previousSentCase === void 0 ? void 0 : previousSentCase.processInstanceGuid);
            }
          }, "previously submitted case"), ".")), /*#__PURE__*/React.createElement(uiComponents.Conditional, capabilities.capabilities.oldCaseLoadedAlert, /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: CaseAlertType.WARNING
          }, "You are viewing a non-codable version of this case. View the", ' ', /*#__PURE__*/React.createElement("a", {
            className: "anchor-chakra-link",
            onClick: function onClick() {
              return handleOpenCase(newestVersionObject === null || newestVersionObject === void 0 ? void 0 : newestVersionObject.processInstanceGuid);
            }
          }, "codable version"))), /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            some: [!!((_this$props$activeIte7 = this.props.activeItem) !== null && _this$props$activeIte7 !== void 0 && _this$props$activeIte7.parent_process_instance_uid)]
          }, /*#__PURE__*/React.createElement(CaseAlert, {
            alertType: CaseAlertType.INFO,
            alertSize: "sm"
          }, /*#__PURE__*/React.createElement(uiComponents.Conditional, {
            every: [!!((_this$props$activeIte8 = this.props.activeItem) !== null && _this$props$activeIte8 !== void 0 && _this$props$activeIte8.parent_process_instance_uid)]
          }, /*#__PURE__*/React.createElement("span", null, "This case is no longer active. It has been merged into: case", /*#__PURE__*/React.createElement("a", {
            className: "anchor-chakra-link",
            onClick: function onClick() {
              var _this3$props$activeIt, _this3$props$activeIt2;
              return handleOpenCase((_this3$props$activeIt = _this3.props.activeItem) === null || _this3$props$activeIt === void 0 ? void 0 : _this3$props$activeIt.parent_process_instance_uid, (_this3$props$activeIt2 = _this3.props.activeItem) === null || _this3$props$activeIt2 === void 0 ? void 0 : _this3$props$activeIt2.parent_case_uid);
            }
          }, ' ', "#", (_this$props$activeIte9 = this.props.activeItem) === null || _this$props$activeIte9 === void 0 ? void 0 : _this$props$activeIte9.parent_case_id)))))), /*#__PURE__*/React.createElement("div", {
            className: "charge-sessions"
          }, innerBench), UIMode === uiCommon.commonEnums.UIModesEnum.EPIC_EMBEDDED ? /*#__PURE__*/React.createElement("div", {
            className: "debug-box"
          }, /*#__PURE__*/React.createElement("a", {
            className: "debug-link",
            href: "/debug"
          }, "Debug")) : '')];
        }
        var _updatedPropertyConfig = updatePropertyConfig({
          benchMode: benchMode,
          serviceLine: this.props.activeItem.service_line,
          propertyConfig: this.props.propertyConfig
        });
        return /*#__PURE__*/React.createElement("div", {
          className: styles
        }, prompt && /*#__PURE__*/React.createElement("div", {
          className: "top-level-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: prompt.text,
          closable: false,
          onSubmit: this.handlePromptDismiss,
          buttonText: "Yes",
          maximize: false
        }, /*#__PURE__*/React.createElement("p", null, "Click ", /*#__PURE__*/React.createElement("b", null, "Yes"), " below to stay logged in."))), /*#__PURE__*/React.createElement(Confirm, _extends$1({
          onConfirm: this.props.handleConfirm,
          onDismiss: this.props.handleConfirmDismiss
        }, confirm)), this.state.showCaseConflictModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "This case is currently open by ".concat(this.state.conflictingUser),
          buttonText: "I understand",
          closable: false,
          icon: /*#__PURE__*/React.createElement("img", {
            src: AlertIcon,
            width: 30,
            height: 30
          }),
          onSubmit: function onSubmit() {
            return _this3.setState({
              showCaseConflictModal: false
            });
          }
        }, /*#__PURE__*/React.createElement("p", null, "Another user is editing this case at the moment. If you make edits, it could interfere with their work.")), showModal && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          onClose: this.handleModalClose,
          maximize: true
        }, /*#__PURE__*/React.createElement("iframe", {
          ref: this.iframeRef,
          src: modalURI,
          className: "popup-frame"
        })), (showSubmittedFeedback || showCanceledFeedback) && /*#__PURE__*/React.createElement("div", {
          className: "qa-submitted-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: {
            message: "Successfully ".concat(showSubmittedFeedback ? 'submitted' : 'canceled'),
            id: new Date().getTime(),
            dismissable: true
          },
          showingTime: 3000,
          dismissFeedback: this.props.hideSubmittedFeedback,
          showFeedback: showSubmittedFeedback || showCanceledFeedback
        })), (showLoadingSubmission || showLoadingCancelation) && /*#__PURE__*/React.createElement("div", {
          className: "qa-submitted-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: {
            message: "".concat(showLoadingSubmission ? 'Submitting...' : 'Canceling...'),
            id: new Date().getTime(),
            dismissable: false,
            meta: {
              level: uiCommon.commonEnums.FeedbackMeta.WARNING
            }
          },
          showFeedback: showLoadingSubmission || showLoadingCancelation
        })), displayAddCharge && /*#__PURE__*/React.createElement(uiComponents.Modal, {
          onClose: this.onModalAddChargeClose,
          title: showAddChargeLoading ? 'Adding charge' : 'Add a charge for:'
        }, /*#__PURE__*/React.createElement("div", {
          className: "qa-add-charge-modal"
        }, !showAddChargeLoading ? /*#__PURE__*/React.createElement(ChargeSelector, {
          handleAddCharge: this.handleAddCharge,
          handleInvoiceAddition: this.handleInvoiceAddition,
          invoiceOptions: invoiceOptions
        }) : /*#__PURE__*/React.createElement("div", {
          className: "spinner-box"
        }, /*#__PURE__*/React.createElement("img", {
          src: img,
          alt: "in progress",
          className: "spinner"
        })), /*#__PURE__*/React.createElement("div", {
          className: "charge-error-box"
        }, showAddChargeError ? /*#__PURE__*/React.createElement("small", {
          className: "charge-error-text"
        }, "Error adding a new charge") : ''))), /*#__PURE__*/React.createElement(CaseDetailv2, _extends$1({
          ref: this.caseDetailRef,
          mode: "code-edit",
          codeEdits: codeEdits,
          codeEditingPanel: codeEditingPanel,
          groupedCases: groupedCases
        }, _objectSpread$4(_objectSpread$4({}, caseDetailProps), {}, {
          propertyConfig: benchMode === uiCommon.commonEnums.BenchMode.GRADE ? _updatedPropertyConfig : caseDetailProps.propertyConfig,
          demographicsPanelLocation: caseDetailProps.demographicsPanelLocation,
          demographicsPanelVisibility: caseDetailProps.demographicsPanelVisibility
        }), {
          loadState: loadState,
          activations: activations,
          actionBar: actionBar,
          updateValue: updateValue,
          updateCase: updateCase,
          showAttachDocsModal: this.props.showAttachDocsModal,
          capability: capabilities.capabilities.caseEdit,
          coderNotesCapability: capabilities.capabilities.coderNotes,
          capabilities: capabilities,
          processInstance: this.props.processInstance,
          caseEdits: caseEdits,
          noteUnavailableReason: capabilities.capabilities.noteUnavailableReason,
          caseAccessState: this.props.caseAccessState,
          UIMode: this.props.UIMode,
          flagList: flagList,
          relatedCasesView: relatedCasesView,
          activity: activity,
          documentImprovementsPanel: /*#__PURE__*/React.createElement(Improvements, _extends$1({}, this.props, {
            improvementsAction: capabilities.capabilities.improvementsAction,
            showUnresolved: this.props.showUnresolvedDocuments
          })),
          showCoderNotesInfo: this.props.showCoderNotesInfo,
          workItem: workItem,
          displayTopLeftPatientInfo: !(this.props.benchMode == uiCommon.commonEnums.BenchMode.GRADE),
          editable: benchEditable.editable,
          enableUserActivityComments: true
        })), /*#__PURE__*/React.createElement(uiComponents.UniversalFeedback, {
          feedback: feedback,
          dismissFeedback: this.props.hideFeedback,
          showFeedback: showFeedBack,
          showingTime: 5000
        }), showSizeExpWarning && /*#__PURE__*/React.createElement("div", {
          className: "top-level-modal"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: 'Help us improve your experience',
          closable: true,
          onClose: this.handleDeleteSizeExpWarning,
          onSubmit: this.handleDeleteSizeExpWarning,
          buttonText: "Dismiss",
          maximize: false
        }, /*#__PURE__*/React.createElement("p", null, "Consider adjusting the width of your browser to a wider setting for a better view of CMX Amplify."))), showvitalwareIssuesModal && /*#__PURE__*/React.createElement(VitalWareModal, {
          onClose: this.props.hidevitalwareIssuesModal,
          onSubmit: function onSubmit(event, comment, remove_hold) {
            return _this3.handleSubmit(event, comment, true, remove_hold);
          },
          vitalwareIssues: vitalwareIssues,
          mergeSplitHistoryIssues: mergeSplitHistoryIssues,
          documentImprovementIssues: documentImprovementIssues,
          holdIssues: holdIssues,
          holdCaseStatus: capabilities.holdCaseStatus,
          improvements: (_this$props$improveme = this.props.improvements) === null || _this$props$improveme === void 0 ? void 0 : _this$props$improveme.improvements,
          setActiveMiniTab: this.props.setActiveVerticalMiniTab,
          setUnresolvedDocuments: this.props.setUnresolvedDocuments
        }));
      }
    }]);
  }(React.Component);
  _defineProperty(CodeBenchv2, "defaultProps", {
    suggestedCodes: {
      cpt: [],
      modifier: [],
      diagnosis: []
    },
    benchEditable: _objectSpread$4({}, uiCommon.AmplifyCore.state.DEFAULT_BENCH_EDITABLE),
    improvements: _objectSpread$4({}, uiCommon.AmplifyCore.state.improvements),
    capabilities: _objectSpread$4({}, uiCommon.AmplifyCore.state.capabilities),
    relatedCasesLoadState: _objectSpread$4({}, uiCommon.loadStates.LOAD_STATES.done),
    relatedCasesPageable: _objectSpread$4({}, uiCommon.AmplifyCore.paginationUtils.relatedCasesSortablePageable),
    processInstanceGuids: [],
    hostCaseId: null,
    loadAlwaysFromURL: false,
    propertyConfig: {
      patient: [],
      summary: [],
      expanded: []
    },
    confirm: {
      display: false,
      title: ''
    },
    activity: [],
    noteTypes: [],
    workItem: {
      assignee: '',
      owner: '',
      aging_days: '',
      codable_days: ''
    },
    onLoad: function onLoad(caseRun) {},
    onChargeSessionAction: function onChargeSessionAction(transactionAction) {},
    onReload: function onReload(params) {},
    onSearchClear: function onSearchClear(codeQuery) {},
    onCodeSearch: function onCodeSearch(codeQuery) {},
    onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {},
    handleAddAllCodes: function handleAddAllCodes(searchSelection) {},
    handleRemoveAllCodes: function handleRemoveAllCodes(codeChange) {},
    createTransactionAndAddCode: function createTransactionAndAddCode(searchSelection) {},
    onChargeSessionMetaEdit: function onChargeSessionMetaEdit(chargeSession) {},
    onCodeUpdate: function onCodeUpdate(changeDetail) {},
    onCodeRemove: function onCodeRemove(changeDetail) {},
    onTransactionOrderChange: function onTransactionOrderChange(transactionReorderDetail) {},
    onTimeBasedCodeAdd: function onTimeBasedCodeAdd(time, age) {},
    onTimeBasedCodeUpdate: function onTimeBasedCodeUpdate(time, age) {},
    onCodeSearchDrop: function onCodeSearchDrop(changeDetail) {},
    onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {},
    onPrompt: function onPrompt(action) {},
    onPopUpClose: function onPopUpClose() {},
    onFeatureActivation: function onFeatureActivation(selection) {},
    onNavigate: function onNavigate(caseId, replace, serviceLine) {},
    hidevitalwareIssuesModal: function hidevitalwareIssuesModal() {},
    onImprovementAdd: function onImprovementAdd(documentImprovement) {},
    onImprovementUpdate: function onImprovementUpdate(documentImprovement) {},
    onImprovementRemove: function onImprovementRemove(documentImprovement) {},
    onProviderAdd: function onProviderAdd(documentImprovement) {},
    onProviderRemove: function onProviderRemove(documentImprovement) {},
    onProviderUpdate: function onProviderUpdate(documentImprovement) {},
    onDocumentImprovementSearch: function onDocumentImprovementSearch(codeQuery) {},
    showAmplifyFeedback: function showAmplifyFeedback(feedback) {},
    onProviderSearch: function onProviderSearch(query) {},
    updateValue: function updateValue(val) {},
    updateCase: function updateCase(idAndUpdates) {},
    loadRoles: function loadRoles(roles) {},
    getFlagItems: function getFlagItems(activeItem) {},
    setActiveMiniTab: function setActiveMiniTab(activeTabName) {},
    setActiveVerticalMiniTab: function setActiveVerticalMiniTab(activeTabName) {},
    setUnresolvedDocuments: function setUnresolvedDocuments(value) {},
    showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {},
    onInvoiceRemove: function onInvoiceRemove(invoiceDeleteParams) {},
    searchResults: {},
    codeSearchResultsV2: {},
    displayAddCharge: false,
    showAddChargeError: false,
    showLoadingSubmission: false,
    showLoadingCancelation: false,
    showSizeExpWarning: false,
    showFeedBack: false,
    showSubmittedFeedback: false,
    showCanceledFeedback: false,
    submittedFeedbackTimer: false,
    showvitalwareIssuesModal: false,
    toggleHoldCaseModal: false,
    toggleExclusionCaseModal: false,
    showLateCaseClearModal: false,
    toggleSplitCaseModal: false,
    submitOldCaseModal: false,
    vitalwareIssues: [],
    mergeSplitHistoryIssues: [],
    caseAccessTime: '',
    activeMiniTab: uiCommon.commonEnums.MiniTabLabels.CHARGES_LABEL,
    activeVerticalMiniTab: uiCommon.commonEnums.MiniTabLabels.NOTES_LABEL,
    showUnresolvedDocuments: false,
    gradeableInvoices: [],
    qaRuleCollection: {
      sampleReason: '',
      guideline: ''
    },
    associatedWorkitems: []
  });

  function ownKeys$3(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$3(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$3(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$3(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _AmplifyCore$actions$1 = uiCommon.AmplifyCore.actions,
    getInvoiceOptions = _AmplifyCore$actions$1.getInvoiceOptions,
    removeTransaction = _AmplifyCore$actions$1.removeTransaction,
    providerSearch$1 = _AmplifyCore$actions$1.providerSearch;
  var addImprovement = uiCommon.improvementActions.addImprovement,
    removeImprovement = uiCommon.improvementActions.removeImprovement,
    improvementSearch = uiCommon.improvementActions.improvementSearch,
    updateImprovement = uiCommon.improvementActions.updateImprovement,
    addImprovementProvider = uiCommon.improvementActions.addImprovementProvider,
    updateImprovementProvider = uiCommon.improvementActions.updateImprovementProvider,
    removeImprovementProvider = uiCommon.improvementActions.removeImprovementProvider;
  var dismissConfirm = uiCommon.uiActions.dismissConfirm,
    _handleConfirm = uiCommon.uiActions.handleConfirm,
    showConfirm = uiCommon.uiActions.showConfirm,
    _hideFeedback = uiCommon.uiActions.hideFeedback,
    amplifyFeedback = uiCommon.uiActions.amplifyFeedback;
  var loadCaseFromId = uiCommon.launchPageActions.loadCaseFromId,
    loadFromURLMatch = uiCommon.launchPageActions.loadFromURLMatch;
  var cancelInvoicesPopup = uiCommon.codeBenchActions.cancelInvoicesPopup,
    clearSearchResults = uiCommon.codeBenchActions.clearSearchResults,
    codeAdd = uiCommon.codeBenchActions.codeAdd,
    codesAdd = uiCommon.codeBenchActions.codesAdd,
    _createTransactionAndAddCode = uiCommon.codeBenchActions.createTransactionAndAddCode,
    codeRemove = uiCommon.codeBenchActions.codeRemove,
    codesRemove = uiCommon.codeBenchActions.codesRemove,
    timeBasedCodeAdd = uiCommon.codeBenchActions.timeBasedCodeAdd,
    timeBasedCodeUpdate = uiCommon.codeBenchActions.timeBasedCodeUpdate,
    transactionOrderChange = uiCommon.codeBenchActions.transactionOrderChange,
    codeSearch = uiCommon.codeBenchActions.codeSearch,
    codeSearchDrop = uiCommon.codeBenchActions.codeSearchDrop,
    codeUpdate = uiCommon.codeBenchActions.codeUpdate,
    featureSelection = uiCommon.codeBenchActions.featureSelection,
    fetchProcessInstance = uiCommon.codeBenchActions.fetchProcessInstance,
    navigateDetail = uiCommon.codeBenchActions.navigateDetail,
    popupClose = uiCommon.codeBenchActions.popupClose,
    popupNavigate = uiCommon.codeBenchActions.popupNavigate,
    promptClose = uiCommon.codeBenchActions.promptClose,
    selectInvoiceToEdit = uiCommon.codeBenchActions.selectInvoiceToEdit,
    selectInvoiceToAdd = uiCommon.codeBenchActions.selectInvoiceToAdd,
    submitInvoice = uiCommon.codeBenchActions.submitInvoice,
    openAddChargeModal = uiCommon.codeBenchActions.openAddChargeModal,
    closeAddChargeModal = uiCommon.codeBenchActions.closeAddChargeModal,
    addTransaction = uiCommon.codeBenchActions.addTransaction,
    submittedFeedbackTimer = uiCommon.codeBenchActions.submittedFeedbackTimer,
    _deleteSizeExpWarning = uiCommon.codeBenchActions.deleteSizeExpWarning,
    _hideSubmittedFeedback = uiCommon.codeBenchActions.hideSubmittedFeedback,
    txnSharedCodeAction = uiCommon.codeBenchActions.txnSharedCodeAction,
    enableTechPro = uiCommon.codeBenchActions.enableTechPro,
    disableTechPro = uiCommon.codeBenchActions.disableTechPro,
    _hidevitalwareIssuesModal = uiCommon.codeBenchActions.hidevitalwareIssuesModal,
    _showHoldCaseModal = uiCommon.codeBenchActions.showHoldCaseModal,
    _hideHoldCaseModal = uiCommon.codeBenchActions.hideHoldCaseModal,
    _showCaseCommentModal = uiCommon.codeBenchActions.showCaseCommentModal,
    _hideCaseCommentModal = uiCommon.codeBenchActions.hideCaseCommentModal,
    _showExclusionCaseModal = uiCommon.codeBenchActions.showExclusionCaseModal,
    _hideExclusionCaseModal = uiCommon.codeBenchActions.hideExclusionCaseModal,
    _toggleLateCaseClearModal = uiCommon.codeBenchActions.toggleLateCaseClearModal,
    _clearLateCaseNotification = uiCommon.codeBenchActions.clearLateCaseNotification,
    _showSplitCaseModal = uiCommon.codeBenchActions.showSplitCaseModal,
    _hideSplitCaseModal = uiCommon.codeBenchActions.hideSplitCaseModal,
    _navigate = uiCommon.codeBenchActions.navigate,
    _toggleChargeableCase = uiCommon.codeBenchActions.toggleChargeableCase,
    navigatePatient = uiCommon.codeBenchActions.navigatePatient,
    navigateProvider = uiCommon.codeBenchActions.navigateProvider,
    _holdCase = uiCommon.codeBenchActions.holdCase,
    _toggleSubmitOldCaseModal = uiCommon.codeBenchActions.toggleSubmitOldCaseModal,
    _getCaseVersions = uiCommon.codeBenchActions.getCaseVersions,
    openWindow = uiCommon.codeBenchActions.openWindow,
    loadCursorAPIContext = uiCommon.codeBenchActions.loadCursorAPIContext,
    _loadRoles = uiCommon.codeBenchActions.loadRoles,
    _getFlagItems = uiCommon.codeBenchActions.getFlagItems,
    _getCasesWithEncounter = uiCommon.codeBenchActions.getCasesWithEncounter,
    _setActiveNote = uiCommon.codeBenchActions.setActiveNote,
    _setActiveMiniTab = uiCommon.codeBenchActions.setActiveMiniTab,
    _setActiveVerticalMiniTab = uiCommon.codeBenchActions.setActiveVerticalMiniTab,
    _setUnresolvedDocuments = uiCommon.codeBenchActions.setUnresolvedDocuments,
    navigateCoderNotes = uiCommon.codeBenchActions.navigateCoderNotes,
    removeInvoice = uiCommon.codeBenchActions.removeInvoice,
    _updateRelatedCasesFilterSelection = uiCommon.codeBenchActions.updateRelatedCasesFilterSelection,
    _acquireCaseAccess = uiCommon.codeBenchActions.acquireCaseAccess,
    _refreshCaseAccessTimer = uiCommon.codeBenchActions.refreshCaseAccessTimer,
    _resetCaseAccess = uiCommon.codeBenchActions.resetCaseAccess,
    _releaseCaseAccess = uiCommon.codeBenchActions.releaseCaseAccess,
    updateProcessInstance = uiCommon.codeBenchActions.updateProcessInstance,
    _refreshHoldSubmission = uiCommon.codeBenchActions.refreshHoldSubmission;
  var _navigateCreateCase = uiCommon.createCaseActions.navigateCreateCase;
  var _showMergeCasesModal = uiCommon.mergeCasesActions.showMergeCasesModal,
    _hideMergeCasesModal = uiCommon.mergeCasesActions.hideMergeCasesModal,
    _fetchMergeableCases = uiCommon.mergeCasesActions.fetchMergeableCases,
    _splitCase = uiCommon.mergeCasesActions.splitCase;
  var _showAttachDocsModal = uiCommon.attachDocsActions.showAttachDocsModal;
  var _caseEditsActions$cas = uiCommon.caseEditsActions.caseEditsActions,
    _updateValue = _caseEditsActions$cas.updateValue,
    _updateCase = _caseEditsActions$cas.updateCase,
    _loadAllPatientDetailOptions = _caseEditsActions$cas.loadAllPatientDetailOptions;
  ({
    ampUI: _objectSpread$3({}, uiCommon.AmplifyCore.state.ampUI),
    invoiceMetadata: _objectSpread$3({}, uiCommon.AmplifyCore.state.invoiceMetadata),
    codeBench: _objectSpread$3({}, uiCommon.AmplifyCore.state.codeBenchState),
    launch: _objectSpread$3({}, uiCommon.AmplifyCore.state.launch),
    eula: _objectSpread$3({}, uiCommon.AmplifyState),
    capabilities: _objectSpread$3({}, uiCommon.AmplifyCore.state.capabilities),
    improvements: _objectSpread$3({}, uiCommon.AmplifyCore.state.improvements)
  });
  // state : AmplifyDefaultState
  var mapStateToCodeBenchProps = function mapStateToCodeBenchProps(state) {
    var _state$router, _state$caseEdits, _state$cases$htmlNote, _state$cases, _state$codeBench, _state$cases$roles, _state$cases2, _state$cases3, _state$codeBench2, _state$codeBench3, _state$codeBench4, _state$codeBench5;
    var location_state = state === null || state === void 0 || (_state$router = state.router) === null || _state$router === void 0 || (_state$router = _state$router.location) === null || _state$router === void 0 ? void 0 : _state$router.state;
    var cursorAPIContext = location_state ? _objectSpread$3({}, location_state) : _objectSpread$3({}, uiCommon.AmplifyCore.state.capabilities.cursorAPIContext);
    return _objectSpread$3(_objectSpread$3(_objectSpread$3({}, state.codeBench), state.ampUI), {}, {
      capabilities: state.capabilities,
      improvements: state.improvements,
      caseEdits: (_state$caseEdits = state.caseEdits) === null || _state$caseEdits === void 0 ? void 0 : _state$caseEdits.caseEdits,
      cursorAPIContext: cursorAPIContext,
      htmlNotes: (_state$cases$htmlNote = state === null || state === void 0 || (_state$cases = state.cases) === null || _state$cases === void 0 ? void 0 : _state$cases.htmlNotes) !== null && _state$cases$htmlNote !== void 0 ? _state$cases$htmlNote : state === null || state === void 0 || (_state$codeBench = state.codeBench) === null || _state$codeBench === void 0 ? void 0 : _state$codeBench.htmlNotes,
      roles: (_state$cases$roles = state === null || state === void 0 || (_state$cases2 = state.cases) === null || _state$cases2 === void 0 ? void 0 : _state$cases2.roles) !== null && _state$cases$roles !== void 0 ? _state$cases$roles : [],
      caseRun: state === null || state === void 0 || (_state$cases3 = state.cases) === null || _state$cases3 === void 0 ? void 0 : _state$cases3.activeItem,
      caseAccessTime: state === null || state === void 0 || (_state$codeBench2 = state.codeBench) === null || _state$codeBench2 === void 0 ? void 0 : _state$codeBench2.caseAccessTime,
      customClaimsRelatedCases: state === null || state === void 0 || (_state$codeBench3 = state.codeBench) === null || _state$codeBench3 === void 0 ? void 0 : _state$codeBench3.customClaimsRelatedCases,
      customClaimsRelatedCasesLoadState: state === null || state === void 0 || (_state$codeBench4 = state.codeBench) === null || _state$codeBench4 === void 0 ? void 0 : _state$codeBench4.customClaimsRelatedCasesLoadState,
      backToWorklistPath: state.ui.backToWorklistPath,
      propertyConfig: state === null || state === void 0 || (_state$codeBench5 = state.codeBench) === null || _state$codeBench5 === void 0 ? void 0 : _state$codeBench5.propertyConfig
    });
  };
  var mapDispatchToCodeBenchProps = function mapDispatchToCodeBenchProps(dispatch) {
    var runDispatchable = buildDispatchable(dispatch);
    return {
      updateRelatedCasesFilterSelection: function updateRelatedCasesFilterSelection(options) {
        dispatch(_updateRelatedCasesFilterSelection(options));
      },
      setUnresolvedDocuments: function setUnresolvedDocuments(value) {
        dispatch(_setUnresolvedDocuments(value));
      },
      setActiveMiniTab: function setActiveMiniTab(activeTabName) {
        dispatch(_setActiveMiniTab(activeTabName));
      },
      setActiveVerticalMiniTab: function setActiveVerticalMiniTab(activeVerticalTabName) {
        dispatch(_setActiveVerticalMiniTab(activeVerticalTabName));
      },
      onProviderSearch: function onProviderSearch(query) {
        dispatch(providerSearch$1(query));
      },
      handleConfirm: function () {
        var _handleConfirm2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(actionItem) {
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(actionItem.action === 'DELETE_TRANSACTION')) {
                  _context.next = 1;
                  break;
                }
                _context.next = 1;
                return dispatch(removeTransaction(actionItem));
              case 1:
                dispatch(_handleConfirm(actionItem));
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function handleConfirm(_x) {
          return _handleConfirm2.apply(this, arguments);
        }
        return handleConfirm;
      }(),
      handleConfirmDismiss: function handleConfirmDismiss(actionItem) {
        dispatch(dismissConfirm(actionItem));
      },
      onLoadFromURLMatch: function onLoadFromURLMatch(params) {
        runDispatchable(function () {
          return loadFromURLMatch(params);
        });
      },
      loadWorkItemDetails: function loadWorkItemDetails(case_uid, caserun_uid) {},
      acquireCaseAccess: function acquireCaseAccess(_ref) {
        var case_uid = _ref.case_uid,
          processInstance = _ref.processInstance,
          callback = _ref.callback;
        dispatch(_acquireCaseAccess({
          case_uid: case_uid,
          processInstance: processInstance,
          callback: callback
        }));
      },
      refreshCaseAccessTimer: function refreshCaseAccessTimer(case_uid) {
        dispatch(_refreshCaseAccessTimer(case_uid));
      },
      resetCaseAccess: function resetCaseAccess(processInstance) {
        dispatch(_resetCaseAccess(processInstance));
      },
      releaseCaseAccess: function releaseCaseAccess(case_uid) {
        dispatch(_releaseCaseAccess(case_uid));
      },
      onSearchClear: function onSearchClear(codeQuery, searchResultsLookupKey) {
        var _codeQuery$context$ch, _codeQuery$context;
        var searchId = (_codeQuery$context$ch = (_codeQuery$context = codeQuery.context) === null || _codeQuery$context === void 0 || (_codeQuery$context = _codeQuery$context.chargeSession) === null || _codeQuery$context === void 0 ? void 0 : _codeQuery$context.transactionId) !== null && _codeQuery$context$ch !== void 0 ? _codeQuery$context$ch : '';
        dispatch(clearSearchResults(searchId));
        if (searchResultsLookupKey) {
          dispatch(clearSearchResults(searchResultsLookupKey));
        }
      },
      onFeatureActivation: function onFeatureActivation(selection) {
        dispatch(featureSelection(selection));
      },
      onCodeSearch: function onCodeSearch(codeQuery) {
        dispatch(codeSearch(codeQuery));
      },
      onChargeSessionAction: function onChargeSessionAction(transactionAction) {
        dispatch(showConfirm(transactionAction));
        //;
      },
      onCodeSearchSelection: function onCodeSearchSelection(searchSelection) {
        // codes are added through search selection
        dispatch(codeAdd(searchSelection));
      },
      handleAddAllCodes: function handleAddAllCodes(searchSelection) {
        dispatch(codesAdd(searchSelection));
      },
      handleRemoveAllCodes: function handleRemoveAllCodes(codeChange) {
        dispatch(codesRemove(codeChange));
      },
      createTransactionAndAddCode: function createTransactionAndAddCode(searchSelection) {
        dispatch(_createTransactionAndAddCode(searchSelection));
      },
      onPopUpNavigate: function onPopUpNavigate(caseNavigate) {
        if (caseNavigate.replace) {
          dispatch(loadCaseFromId({
            caseId: caseNavigate.caseId
          }));
        } else {
          sessionStorage.setItem('channel', uiCommon.authenticationChannel.name);
          dispatch(popupNavigate(caseNavigate));
        }
      },
      onCodeUpdate: function onCodeUpdate(changeDetail) {
        dispatch(codeUpdate(changeDetail));
      },
      onCodeRemove: function onCodeRemove(changeDetail) {
        dispatch(codeRemove(changeDetail));
      },
      onTimeBasedCodeAdd: function onTimeBasedCodeAdd(codeChange, time, age) {
        dispatch(timeBasedCodeAdd({
          codeChange: codeChange,
          time: time,
          age: age
        }));
      },
      onTimeBasedCodeUpdate: function onTimeBasedCodeUpdate(codeChange, time, age) {
        dispatch(timeBasedCodeUpdate({
          codeChange: codeChange,
          time: time,
          age: age
        }));
      },
      onTransactionOrderChange: function onTransactionOrderChange(transactionReorderDetail) {
        dispatch(transactionOrderChange(transactionReorderDetail));
      },
      onCodeSearchDrop: function onCodeSearchDrop(changeDetail) {
        dispatch(codeSearchDrop(changeDetail));
      },
      onModalAddChargeOpen: function onModalAddChargeOpen() {
        dispatch(openAddChargeModal());
      },
      onModalAddChargeClose: function onModalAddChargeClose(e) {
        e.preventDefault();
        dispatch(closeAddChargeModal());
      },
      handleAddCharge: function handleAddCharge(newInvoice) {
        dispatch(addTransaction(newInvoice));
      },
      handleTimer: function handleTimer() {
        setTimeout(function () {
          dispatch(submittedFeedbackTimer());
        }, 700);
      },
      onInvoiceEdit: function () {
        var _onInvoiceEdit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(invoice, processInstance) {
          return _regeneratorRuntime.wrap(function (_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 1;
                return dispatch(getInvoiceOptions(processInstance));
              case 1:
                dispatch(selectInvoiceToEdit(invoice));
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function onInvoiceEdit(_x2, _x3) {
          return _onInvoiceEdit.apply(this, arguments);
        }
        return onInvoiceEdit;
      }(),
      onInvoiceAddition: function () {
        var _onInvoiceAddition = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(invoice, processInstance) {
          return _regeneratorRuntime.wrap(function (_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 1;
                return dispatch(getInvoiceOptions(processInstance));
              case 1:
                dispatch(selectInvoiceToAdd(invoice));
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function onInvoiceAddition(_x4, _x5) {
          return _onInvoiceAddition.apply(this, arguments);
        }
        return onInvoiceAddition;
      }(),
      onInvoiceRemove: function onInvoiceRemove(invoiceDeleteParams) {
        dispatch(removeInvoice(invoiceDeleteParams));
      },
      onLoad: function onLoad(caseRun) {
        dispatch(fetchProcessInstance(caseRun));
      },
      onPrompt: function onPrompt(action) {
        dispatch(promptClose());
      },
      onPopUpClose: function onPopUpClose() {
        dispatch(popupClose());
      },
      showPatientInfo: function showPatientInfo(caseRun) {
        dispatch(navigatePatient(caseRun));
      },
      showProviderInfo: function showProviderInfo(providerInfo) {
        dispatch(navigateProvider(providerInfo));
      },
      showCoderNotesInfo: function showCoderNotesInfo(coderNotesParams) {
        dispatch(navigateCoderNotes(coderNotesParams));
      },
      handleTraversal: function handleTraversal(caseDescriptor) {
        dispatch(navigateDetail(caseDescriptor));
      },
      onInvoicesCancel: function onInvoicesCancel(processInstance) {
        dispatch(cancelInvoicesPopup(processInstance));
      },
      onInvoicesSubmisson: function () {
        var _onInvoicesSubmisson = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(submission) {
          return _regeneratorRuntime.wrap(function (_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 1;
                return dispatch(submitInvoice(submission));
              case 1:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        function onInvoicesSubmisson(_x6) {
          return _onInvoicesSubmisson.apply(this, arguments);
        }
        return onInvoicesSubmisson;
      }(),
      onTransactionSharedDiagnosisChange: function onTransactionSharedDiagnosisChange(changeDetail) {
        dispatch(txnSharedCodeAction(changeDetail));
      },
      // Inactive methods at the moment.  They're required bc of the amount that
      // we're leveraging the case detail.
      onCaseAction: function onCaseAction(action) {},
      onFeatureSelection: function onFeatureSelection(selection) {},
      openChildWindow: function openChildWindow(windowOpenArgs) {
        dispatch(openWindow(windowOpenArgs));
      },
      openAmplifyCase: function openAmplifyCase(amplifyLaunchConfig) {
        dispatch(_navigate("/cmx/worklist/".concat(amplifyLaunchConfig.serviceLine, "/case/").concat(amplifyLaunchConfig.caseId, "/case-run/").concat(amplifyLaunchConfig.id, "/")));
      },
      toggleArtifacts: function toggleArtifacts(showAll) {},
      showList: function showList(serviceLine, refreshList) {},
      onNavigate: function onNavigate(caseId, replace) {},
      setActiveProcess: function setActiveProcess(activeProcess) {},
      hideFeedback: function hideFeedback() {
        dispatch(_hideFeedback());
      },
      deleteSizeExpWarning: function deleteSizeExpWarning() {
        dispatch(_deleteSizeExpWarning());
      },
      hideSubmittedFeedback: function hideSubmittedFeedback() {
        dispatch(_hideSubmittedFeedback());
      },
      handleEnableTechPro: function handleEnableTechPro(transactionCodeChange) {
        dispatch(enableTechPro(transactionCodeChange));
      },
      handleDisableTechPro: function handleDisableTechPro(transactionCodeChange) {
        dispatch(disableTechPro(transactionCodeChange));
      },
      hidevitalwareIssuesModal: function hidevitalwareIssuesModal() {
        dispatch(_hidevitalwareIssuesModal());
      },
      showHoldCaseModal: function showHoldCaseModal() {
        dispatch(_showHoldCaseModal());
      },
      hideHoldCaseModal: function hideHoldCaseModal() {
        dispatch(_hideHoldCaseModal());
      },
      showCaseCommentModal: function showCaseCommentModal() {
        dispatch(_showCaseCommentModal());
      },
      hideCaseCommentModal: function hideCaseCommentModal() {
        dispatch(_hideCaseCommentModal());
      },
      showExclusionCaseModal: function showExclusionCaseModal() {
        dispatch(_showExclusionCaseModal());
      },
      hideExclusionCaseModal: function hideExclusionCaseModal() {
        dispatch(_hideExclusionCaseModal());
      },
      toggleLateCaseClearModal: function toggleLateCaseClearModal(toggle) {
        dispatch(_toggleLateCaseClearModal(toggle));
      },
      clearLateCaseNotification: function clearLateCaseNotification(processInstance) {
        dispatch(_clearLateCaseNotification(processInstance));
      },
      showSplitCaseModal: function showSplitCaseModal() {
        dispatch(_showSplitCaseModal());
      },
      hideSplitCaseModal: function hideSplitCaseModal() {
        dispatch(_hideSplitCaseModal());
      },
      splitCase: function splitCase(processInstance) {
        dispatch(_splitCase(processInstance));
      },
      toggleChargeableCase: function toggleChargeableCase(toggleChargeableCaseObject) {
        dispatch(_toggleChargeableCase(toggleChargeableCaseObject));
      },
      holdCase: function holdCase(holdCaseObject) {
        dispatch(_holdCase(holdCaseObject));
      },
      onDocumentImprovementAdd: function onDocumentImprovementAdd(improvementRequest) {
        dispatch(addImprovement(improvementRequest));
      },
      onDocumentImprovementRemove: function onDocumentImprovementRemove(improvementRequest) {
        dispatch(removeImprovement(improvementRequest));
      },
      onDocumentImprovementSearch: function onDocumentImprovementSearch(codeQuery) {
        dispatch(improvementSearch(codeQuery));
      },
      onDocumentImprovementUpdate: function onDocumentImprovementUpdate(documentImprovement) {
        dispatch(updateImprovement(documentImprovement));
      },
      onProviderAdd: function onProviderAdd(improvementRequest) {
        dispatch(addImprovementProvider(improvementRequest));
      },
      onProviderUpdate: function onProviderUpdate(improvementRequest) {
        dispatch(updateImprovementProvider(improvementRequest));
      },
      onProviderRemove: function onProviderRemove(documentImprovement) {
        dispatch(removeImprovementProvider(documentImprovement));
      },
      showAmplifyFeedback: function showAmplifyFeedback(feedback) {
        dispatch(amplifyFeedback(feedback));
      },
      updateValue: function updateValue(updatedFieldAndValue) {
        dispatch(_updateValue(updatedFieldAndValue));
      },
      updateCase: function updateCase(updatesAndInfo) {
        dispatch(_updateCase(updatesAndInfo));
      },
      navigate: function navigate(url) {
        dispatch(_navigate(url));
      },
      toggleSubmitOldCaseModal: function toggleSubmitOldCaseModal() {
        dispatch(_toggleSubmitOldCaseModal());
      },
      getCaseVersions: function () {
        var _getCaseVersions2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(processInstance) {
          return _regeneratorRuntime.wrap(function (_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 1;
                return dispatch(_getCaseVersions(processInstance));
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        function getCaseVersions(_x7) {
          return _getCaseVersions2.apply(this, arguments);
        }
        return getCaseVersions;
      }(),
      onCursorAction: function onCursorAction(cursorAPIPayload) {},
      loadServicedeskContext: function loadServicedeskContext(cursorAPIContext) {
        dispatch(loadCursorAPIContext(cursorAPIContext));
      },
      loadRoles: function loadRoles(roles) {
        dispatch(_loadRoles(roles));
      },
      loadAllPatientDetailOptions: function loadAllPatientDetailOptions(tenantId, facility) {
        dispatch(_loadAllPatientDetailOptions({
          activeTenantId: tenantId,
          facility: facility
        }));
      },
      getFlagItems: function getFlagItems(activeItem) {
        dispatch(_getFlagItems(activeItem));
      },
      getCasesWithEncounter: function getCasesWithEncounter(harListPayload) {
        dispatch(_getCasesWithEncounter(harListPayload));
      },
      showMergeCasesModal: function showMergeCasesModal(mergeCaseModalProps) {
        dispatch(_showMergeCasesModal(mergeCaseModalProps));
      },
      navigateCreateCase: function navigateCreateCase(caseRun) {
        dispatch(_navigateCreateCase(caseRun));
      },
      showAttachDocsModal: function showAttachDocsModal(caseRun) {
        dispatch(_showAttachDocsModal(caseRun));
      },
      hideMergeCasesModal: function hideMergeCasesModal() {
        dispatch(_hideMergeCasesModal());
      },
      fetchMergeableCases: function fetchMergeableCases(mergeableCasesParams) {
        dispatch(_fetchMergeableCases(mergeableCasesParams));
      },
      setActiveNote: function setActiveNote(activeNote) {
        dispatch(_setActiveNote(activeNote));
      },
      hideSideNavBar: function hideSideNavBar() {
        dispatch(uiCommon.codeBenchActions.hideSideNavBar());
      },
      showSideNavBar: function showSideNavBar() {
        dispatch(uiCommon.codeBenchActions.showSideNavBar());
      },
      onCreateCQATransaction: function onCreateCQATransaction() {
        dispatch(uiCommon.gradeBenchPanelActions.createCQATransaction);
      },
      onDeleteCQATransaction: function onDeleteCQATransaction() {
        dispatch(uiCommon.gradeBenchPanelActions.deleteCQATransaction);
      },
      fetchCoderConfig: function fetchCoderConfig(args) {
        dispatch(uiCommon.coderConfig.getCoderConfig(args));
      },
      refreshHoldSubmission: function refreshHoldSubmission(caseRun) {
        setTimeout(function () {
          dispatch(updateProcessInstance({
            serviceLine: caseRun.service_line,
            guid: caseRun.process_instance_guid
          }));
          dispatch(_refreshHoldSubmission());
        }, 3000);
      }
    };
  };

  function ownKeys$2(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$2(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$2(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$2(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var DEFAULT_PROPS = {
    cases: [],
    chooseCase: function chooseCase(caseDetail) {}
  };
  var CLINICAL_ID_TYPES = {
    ACCESSION_NUMBER: 'Accession'
  };
  var CaseChooser = function CaseChooser(passed) {
    var props = _objectSpread$2(_objectSpread$2({}, DEFAULT_PROPS), passed);
    var chooseCase = props.chooseCase,
      launchParams = props.launchParams;
    var handleItemClick = React.useCallback(function (event) {
      event.preventDefault();
      var target = event.target || document.createElement('div');
      var linkable = target === null || target === void 0 ? void 0 : target.closest('a');
      if (!linkable) return;
      var item = linkable.attributes.getNamedItem('data-process-instance-id');
      if (!item) return;
      var processInstanceId = parseInt(item.value);
      if (processInstanceId === undefined) return;
      var caseRun = cases.find(function (caseRun) {
        return caseRun.process_instance_id === processInstanceId;
      });
      if (caseRun) {
        chooseCase(caseRun);
      }
    }, [chooseCase]);
    var cases = passed.cases;
    var hasCases = cases.length > 0;
    var displayedCases = cases.map(function (caseRun, idx) {
      var clinicalId = caseRun.primary_clinical_identifier;
      return /*#__PURE__*/React.createElement("a", {
        key: idx,
        "data-process-instance-id": caseRun.process_instance_id,
        className: 'case-chooser-item qa-case-chooser-item',
        onClick: handleItemClick
      }, /*#__PURE__*/React.createElement("div", {
        className: "chase-chooser-description"
      }, caseRun.reason_for_visit), /*#__PURE__*/React.createElement("div", {
        className: "case-chooser-meta"
      }, /*#__PURE__*/React.createElement("div", {
        className: "case-chooser-key"
      }, CLINICAL_ID_TYPES[clinicalId.type] || clinicalId.type, ":"), /*#__PURE__*/React.createElement("div", {
        className: "case-chooser-value"
      }, "#", clinicalId.number, " (", clinicalId.issuer, ")", ' ')));
    });
    var classNames = classnames(["case-chooser", {
      'case-chooser-empty': !hasCases,
      'case-chooser-populated': hasCases
    }]);
    var dateOfService = launchParams.serviceDate || 'N/A';
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classNames)
    }, /*#__PURE__*/React.createElement("div", {
      className: "empty-message"
    }, "No cases were found"), /*#__PURE__*/React.createElement("div", {
      className: "case-display-container"
    }, /*#__PURE__*/React.createElement("h4", null, "Select Charge Session"), /*#__PURE__*/React.createElement("p", null, "Multiple results were found for ", /*#__PURE__*/React.createElement("b", null, dateOfService), ". Please select the relevant item below."), /*#__PURE__*/React.createElement("div", null, displayedCases)));
  };

  var selectCase = uiCommon.launchPageActions.selectCase;
  var mapStateToCaseChooserProps = function mapStateToCaseChooserProps(state) {
    return {
      cases: state.codeBench.cases,
      launchParams: state.launch.launchParams
    };
  };
  var mapDispatchToCaseChooserProps = function mapDispatchToCaseChooserProps(dispatch) {
    return {
      chooseCase: function chooseCase(caseRun) {
        dispatch(selectCase(caseRun));
      }
    };
  };

  function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var _AmplifyCore$actions = uiCommon.AmplifyCore.actions,
    removeAdditionPerformer = _AmplifyCore$actions.removeAdditionPerformer,
    removeAdditionReferringPerformer = _AmplifyCore$actions.removeAdditionReferringPerformer,
    chooseAdditionPerformer = _AmplifyCore$actions.chooseAdditionPerformer,
    chooseAdditionReferringPerformer = _AmplifyCore$actions.chooseAdditionReferringPerformer,
    changePerformDate = _AmplifyCore$actions.changePerformDate,
    createInvoice = _AmplifyCore$actions.createInvoice;
    _AmplifyCore$actions.addProvider;
    var cancelChargeEdit = _AmplifyCore$actions.cancelChargeEdit,
    chooseProvider = _AmplifyCore$actions.chooseProvider,
    providerSearch = _AmplifyCore$actions.providerSearch,
    removeProvider = _AmplifyCore$actions.removeProvider,
    saveInvoice = _AmplifyCore$actions.saveInvoice,
    departmentChange = _AmplifyCore$actions.departmentChange,
    feeScheduleChange = _AmplifyCore$actions.feeScheduleChange;
  var mapStateToInvoiceEditorProps = function mapStateToInvoiceEditorProps(state) {
    var _state$codeBench$prov, _state$codeBench, _state$capabilities;
    return _objectSpread$1(_objectSpread$1({}, state.invoiceMetadata), {}, {
      providerRoleTypeConfig: (_state$codeBench$prov = state === null || state === void 0 || (_state$codeBench = state.codeBench) === null || _state$codeBench === void 0 ? void 0 : _state$codeBench.providerRoleTypeConfig) !== null && _state$codeBench$prov !== void 0 ? _state$codeBench$prov : [],
      useProviderDirectoryLocations: state === null || state === void 0 || (_state$capabilities = state.capabilities) === null || _state$capabilities === void 0 || (_state$capabilities = _state$capabilities.capabilities) === null || _state$capabilities === void 0 ? void 0 : _state$capabilities.useProviderDirectoryLocations
    });
  };
  var mapDispatchToInvoiceEditorProps = function mapDispatchToInvoiceEditorProps(dispatch) {
    return {
      onProviderSearch: function onProviderSearch(query) {
        dispatch(providerSearch(query));
      },
      onProviderRemove: function onProviderRemove() {
        dispatch(removeProvider());
      },
      onProviderAdd: function onProviderAdd(provider) {
        dispatch(chooseProvider(provider));
      },
      onInvoiceSave: function onInvoiceSave(savableInvoice) {
        dispatch(saveInvoice(savableInvoice));
      },
      onPerformerAdditionSearch: function onPerformerAdditionSearch(query) {
        dispatch(providerSearch(query));
      },
      onPerformerAdditionRemove: function onPerformerAdditionRemove() {
        dispatch(removeAdditionPerformer());
      },
      onReferringPerformerAdditionRemove: function onReferringPerformerAdditionRemove() {
        dispatch(removeAdditionReferringPerformer());
      },
      onPerformerAdditionAdd: function onPerformerAdditionAdd(provider) {
        dispatch(chooseAdditionPerformer(provider));
      },
      onReferrerPerformerAdditionAdd: function onReferrerPerformerAdditionAdd(provider) {
        dispatch(chooseAdditionReferringPerformer(provider));
      },
      onPerformDateChange: function onPerformDateChange(newDate) {
        dispatch(changePerformDate(newDate));
      },
      onInvoiceCreate: function () {
        var _onInvoiceCreate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(createbleInvoice) {
          var _t;
          return _regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 1;
                return dispatch(createInvoice(createbleInvoice));
              case 1:
                _context.next = 3;
                break;
              case 2:
                _context.prev = 2;
                _t = _context["catch"](0);
                console.error('Error from createInvoice action:', _t);
              case 3:
              case "end":
                return _context.stop();
            }
          }, _callee, null, [[0, 2]]);
        }));
        function onInvoiceCreate(_x) {
          return _onInvoiceCreate.apply(this, arguments);
        }
        return onInvoiceCreate;
      }(),
      onInvoiceCancel: function onInvoiceCancel(e) {
        e.preventDefault();
        dispatch(cancelChargeEdit());
      },
      onDepartmentChange: function onDepartmentChange(department) {
        dispatch(departmentChange(department));
      },
      onRemoveDepartment: function onRemoveDepartment() {
        dispatch(departmentChange(null));
      },
      onFeeScheduleChange: function onFeeScheduleChange(feeSchedule) {
        dispatch(feeScheduleChange(feeSchedule));
      }
    };
  };

  function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
  function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
  var CaseCancellation = /*#__PURE__*/function (_React$Component) {
    function CaseCancellation(props) {
      var _this;
      _classCallCheck(this, CaseCancellation);
      _this = _callSuper(this, CaseCancellation, [props]);
      _this.handleCancelDismiss = _this.handleCancelDismiss.bind(_this);
      _this.handleCaseCancel = _this.handleCaseCancel.bind(_this);
      return _this;
    }
    _inherits(CaseCancellation, _React$Component);
    return _createClass(CaseCancellation, [{
      key: "handleCancelDismiss",
      value: function handleCancelDismiss(event) {
        event.preventDefault();
        this.props.onCaseCancelDismiss(event);
      }
    }, {
      key: "handleCaseCancel",
      value: function handleCaseCancel(event) {
        event.preventDefault();
        var cursorAPIPayload = {
          operation: uiCommon.commonEnums.CursorOperation.NEXT,
          cursorAPIContext: this.props.cursorAPIContext,
          hasAmplifyCaseRunV2Access: uiCommon.Utils.doesPathEndWithV2()
        };
        this.props.onCaseCancel({
          processInstance: this.props.processInstance,
          uiMode: this.props.UIMode,
          cursorAPIPayload: cursorAPIPayload
        });
      }
    }, {
      key: "render",
      value: function render() {
        var displayCancellation = this.props.displayCancellation;
        if (!displayCancellation) return /*#__PURE__*/React.createElement("span", {
          className: "case-cancellation-empty"
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "case-cancellation-form"
        }, /*#__PURE__*/React.createElement(uiComponents.Modal, {
          title: "Void this case?",
          onClose: this.handleCancelDismiss
        }, /*#__PURE__*/React.createElement("div", {
          className: "cols"
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12"
        }, /*#__PURE__*/React.createElement("p", {
          className: "void-subtitle"
        }, "Voided cases are not submitted for reimbursement, and will no longer be editable.")), /*#__PURE__*/React.createElement("div", {
          className: "col-12 cancel-buttons-col"
        }, /*#__PURE__*/React.createElement("button", {
          onClick: this.handleCaseCancel,
          className: "chakra-primary-button qa-rounded-button"
        }, "Yes, Void"), /*#__PURE__*/React.createElement("button", {
          onClick: this.handleCancelDismiss,
          className: "chakra-secondary-button cancel-link qa-cancel-link"
        }, "No, Cancel")))));
      }
    }]);
  }(React.Component);

  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
  var cancelInvoicesConfirm = uiCommon.codeBenchActions.cancelInvoicesConfirm,
    cancelInvoicesDismiss = uiCommon.codeBenchActions.cancelInvoicesDismiss;
  var mapStateToCaseCancellationProps = function mapStateToCaseCancellationProps(state) {
    return _objectSpread(_objectSpread(_objectSpread({}, state.codeBench), state.ampUI), {}, {
      cursorAPIContext: _objectSpread({}, state.capabilities.cursorAPIContext)
    });
  };
  var mapDispatchToCaseCancellationProps = function mapDispatchToCaseCancellationProps(dispatch) {
    return {
      onCaseCancelDismiss: function onCaseCancelDismiss(ev) {
        dispatch(cancelInvoicesDismiss());
      },
      onCaseCancel: function onCaseCancel(submission) {
        dispatch(cancelInvoicesConfirm(submission));
      }
    };
  };

  exports.BillingGroup = BillingGroup;
  exports.ButtonIcon = ButtonIcon;
  exports.CaseCancellation = CaseCancellation;
  exports.CaseChooser = CaseChooser;
  exports.CaseDetail = CaseDetail;
  exports.CaseDetailv2 = CaseDetailv2;
  exports.CaseEvidenceTable = CaseEvidenceTable;
  exports.CaseStatus = CaseStatus;
  exports.ChargeCounts = ChargeCounts;
  exports.ChargeSelector = ChargeSelector;
  exports.CodeBench = CodeBench;
  exports.CodeBenchActionBar = CodeBenchActionBar;
  exports.CodeBenchActionBarv2 = CodeBenchActionBarv2;
  exports.CodeBenchPanel = CodeBenchPanel;
  exports.CodeBenchv2 = CodeBenchv2;
  exports.Confirm = Confirm;
  exports.DEFAULT_ARGS = DEFAULT_ARGS;
  exports.DEFAULT_ARGS_V2 = DEFAULT_ARGS_V2;
  exports.EDITABLE_FIELD = EDITABLE_FIELD;
  exports.EmptyNote = EmptyNote;
  exports.Eula = Eula;
  exports.FieldDefinitions = FieldDefinitions$1;
  exports.FieldIPCDefinitions = FieldIPCDefinitions;
  exports.HighlightedContent = HighlightedContent;
  exports.Improvements = Improvements;
  exports.InfoCell = InfoCell$1;
  exports.InvoiceEditor = InvoiceEditor;
  exports.MenuButton = MenuButton;
  exports.MenuItem = MenuItem;
  exports.NA = NA$1;
  exports.Notes = Notes;
  exports.PatientEncounter = PatientEncounter;
  exports.ProcessSelection = ProcessSelection;
  exports.ProcessStatus = ProcessStatus;
  exports.ProcessTimeline = ProcessTimeline;
  exports.ResultType = ResultType;
  exports.StatusDescription = StatusDescription;
  exports.SuggestedLookup = SuggestedLookup;
  exports.Timeline = Timeline;
  exports.UNEDITABLE_FIELD = UNEDITABLE_FIELD$1;
  exports.bpmStepsPopup = bpmStepsPopup;
  exports.caseDetailPopup = caseDetailPopup;
  exports.caseDocumentsPopup = caseDocumentsPopup;
  exports.codeTypeToEntityType = codeTypeToEntityType$1;
  exports.createSubmitCQAWorkItemHandler = createSubmitCQAWorkItemHandler;
  exports.createSubmitCaseHandler = createSubmitCaseHandler;
  exports.findAnswerForQuestion = findAnswerForQuestion;
  exports.getCellData = getCellData;
  exports.getQuestionIdsToClear = getQuestionIdsToClear;
  exports.getSubmittedInvoiceCodes = getSubmittedInvoiceCodes;
  exports.getUnhighlightedText = getUnhighlightedText;
  exports.getWorkflowForCodeType = getWorkflowForCodeType;
  exports.isOpenImprovement = isOpenImprovement;
  exports.launchAmplifyCase = launchAmplifyCase;
  exports.launchAmplifyPopup = launchAmplifyPopup;
  exports.mapDispatchToCaseCancellationProps = mapDispatchToCaseCancellationProps;
  exports.mapDispatchToCaseChooserProps = mapDispatchToCaseChooserProps;
  exports.mapDispatchToCodeBenchActionBarProps = mapDispatchToCodeBenchActionBarProps;
  exports.mapDispatchToCodeBenchProps = mapDispatchToCodeBenchProps;
  exports.mapDispatchToInvoiceEditorProps = mapDispatchToInvoiceEditorProps;
  exports.mapStateToCaseCancellationProps = mapStateToCaseCancellationProps;
  exports.mapStateToCaseChooserProps = mapStateToCaseChooserProps;
  exports.mapStateToCodeBenchActionBarProps = mapStateToCodeBenchActionBarProps;
  exports.mapStateToCodeBenchProps = mapStateToCodeBenchProps;
  exports.mapStateToInvoiceEditorProps = mapStateToInvoiceEditorProps;
  exports.prop = prop;
  exports.propAccessor = propAccessor;
  exports.resultFormatterV2 = resultFormatterV2;

}));
//# sourceMappingURL=index.js.map
